// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28187.8214285714, 190.9642857143, 239.6785714286%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%233ac47d%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23d92550%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23d92550%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2875.6, 82.8, 194.4%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./utils/images/logo-inverse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./utils/images/logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./images/icon__caret.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./images/icon__calendar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./images/icon__filter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./images/icon__search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./components/icons/linearicons/Linearicons-Free.eot?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./components/icons/linearicons/Linearicons-Free.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./components/icons/linearicons/Linearicons-Free.woff2?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./components/icons/linearicons/Linearicons-Free.woff?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./components/icons/linearicons/Linearicons-Free.ttf?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./components/icons/linearicons/Linearicons-Free.svg?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___, { hash: "?#iefixw118d" });
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "#Linearicons-Free" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "?#iefixd7yf1v" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___, { hash: "#Pe-icon-7-stroke" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.border-primary {
  border-color: #545cd8;
}

.border-secondary {
  border-color: #6c757d;
}

.border-success {
  border-color: #3ac47d;
}

.border-info {
  border-color: #30b1ff;
}

.border-warning {
  border-color: #f7b924;
}

.border-danger {
  border-color: #d92550;
}

.border-light {
  border-color: #eeeeee;
}

.border-dark {
  border-color: #343a40;
}

.border-focus {
  border-color: #444054;
}

.border-alternate {
  border-color: #83588a;
}

:root {
  --bs-blue: #86c6fb;
  --bs-indigo: #444054;
  --bs-purple: #83588a;
  --bs-pink: #f65ca2;
  --bs-red: #d92550;
  --bs-orange: #fd7e14;
  --bs-yellow: #f7b924;
  --bs-green: #3ac47d;
  --bs-teal: #16E0BD;
  --bs-cyan: #30b1ff;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-primary: #545cd8;
  --bs-secondary: #6c757d;
  --bs-success: #3ac47d;
  --bs-info: #30b1ff;
  --bs-warning: #f7b924;
  --bs-danger: #d92550;
  --bs-light: #eeeeee;
  --bs-dark: #343a40;
  --bs-focus: #444054;
  --bs-alternate: #83588a;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 1px;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 400;
  line-height: 1.2;
}

h1, .h1 {
  font-size: calc(1.345rem + 1.14vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.2rem;
  }
}

h2, .h2 {
  font-size: calc(1.301rem + 0.612vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.76rem;
  }
}

h3, .h3 {
  font-size: calc(1.279rem + 0.348vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.54rem;
  }
}

h4, .h4 {
  font-size: calc(1.257rem + 0.084vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.32rem;
  }
}

h5, .h5 {
  font-size: 1.1rem;
}

h6, .h6 {
  font-size: 0.88rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #545cd8;
  text-decoration: underline;
}
a:hover {
  color: rgb(67.2, 73.6, 172.8);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr /* rtl:ignore */;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: #f65ca2;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::-webkit-file-upload-button {
  font: inherit;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.1rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #6c757d;
}

.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 0.75rem;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: 0.75rem;
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-bg: transparent;
  --bs-table-accent-bg: rgba(0, 0, 0, 0.03);
  --bs-table-striped-color: #495057;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #495057;
  --bs-table-active-bg: #e0f3ff;
  --bs-table-hover-color: #495057;
  --bs-table-hover-bg: #e0f3ff;
  width: 100%;
  margin-bottom: 1rem;
  color: #495057;
  vertical-align: top;
  border-color: #e9ecef;
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: rgb(220.8, 222.4, 247.2);
  --bs-table-striped-bg: rgb(209.76, 211.28, 234.84);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(198.72, 200.16, 222.48);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(204.24, 205.72, 228.66);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(198.72, 200.16, 222.48);
}

.table-secondary {
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(203.04, 204.66, 206.1);
}

.table-success {
  --bs-table-bg: rgb(215.6, 243.2, 229);
  --bs-table-striped-bg: rgb(204.82, 231.04, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(194.04, 218.88, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(199.43, 224.96, 211.825);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(194.04, 218.88, 206.1);
}

.table-info {
  --bs-table-bg: rgb(213.6, 239.4, 255);
  --bs-table-striped-bg: rgb(202.92, 227.43, 242.25);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(192.24, 215.46, 229.5);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(197.58, 221.445, 235.875);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(192.24, 215.46, 229.5);
}

.table-warning {
  --bs-table-bg: rgb(253.4, 241, 211.2);
  --bs-table-striped-bg: rgb(240.73, 228.95, 200.64);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(228.06, 216.9, 190.08);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(234.395, 222.925, 195.36);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(228.06, 216.9, 190.08);
}

.table-danger {
  --bs-table-bg: rgb(247.4, 211.4, 220);
  --bs-table-striped-bg: rgb(235.03, 200.83, 209);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(222.66, 190.26, 198);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(228.845, 195.545, 203.5);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(222.66, 190.26, 198);
}

.table-light {
  --bs-table-bg: #eeeeee;
  --bs-table-striped-bg: rgb(226.1, 226.1, 226.1);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(214.2, 214.2, 214.2);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(220.15, 220.15, 220.15);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(214.2, 214.2, 214.2);
}

.table-dark {
  --bs-table-bg: #343a40;
  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);
  --bs-table-hover-color: #fff;
  color: #fff;
  border-color: rgb(72.3, 77.7, 83.1);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.1rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.968rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
          appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  background-color: rgb(239.3, 248.9225806452, 255);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  background-color: rgb(239.3, 248.9225806452, 255);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: rgb(227.335, 236.4764516129, 242.25);
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(227.335, 236.4764516129, 242.25);
}
.form-control::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  background-color: rgb(239.3, 248.9225806452, 255);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: rgb(227.335, 236.4764516129, 242.25);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + (0.5rem + 2px));
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.2rem;
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + (1rem + 2px));
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + (0.75rem + 2px));
}
textarea.form-control-sm {
  min-height: calc(1.5em + (0.5rem + 2px));
}
textarea.form-control-lg {
  min-height: calc(1.5em + (1rem + 2px));
}

.form-control-color {
  max-width: 3rem;
  height: auto;
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #e9ecef;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.968rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.1rem;
}

.form-check {
  display: block;
  min-height: 1.32rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-check-input:checked {
  background-color: #545cd8;
  border-color: #545cd8;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #545cd8;
  border-color: #545cd8;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(203.7, 206.1, 243.3);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(203.7, 206.1, 243.3);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: rgb(239.3, 248.9225806452, 255);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #3ac47d;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.968rem;
  color: #000;
  background-color: rgba(58, 196, 125, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #3ac47d;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #3ac47d;
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #3ac47d;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #3ac47d;
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #3ac47d;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #3ac47d;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #3ac47d;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 1;
}
.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #d92550;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.968rem;
  color: #fff;
  background-color: rgba(217, 37, 80, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #d92550;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #d92550;
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #d92550;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #d92550;
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #d92550;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #d92550;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #d92550;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 2;
}
.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  border-radius: 0.25rem;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #495057;
}
.btn-check:focus + .btn, .btn:focus {
  outline: 0;
  box-shadow: none;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-primary {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
}
.btn-check:focus + .btn-primary, .btn-primary:focus {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(67.2, 73.6, 172.8);
  border-color: #3f45a2;
}
.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-primary:disabled, .btn-primary.disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
}
.btn-check:focus + .btn-secondary, .btn-secondary:focus {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(86.4, 93.6, 100);
  border-color: rgb(81, 87.75, 93.75);
}
.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-success {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:hover {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:focus + .btn-success, .btn-success:focus {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {
  color: #000;
  background-color: rgb(97.4, 207.8, 151);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-success:disabled, .btn-success.disabled {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}

.btn-info {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:hover {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:focus + .btn-info, .btn-info:focus {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {
  color: #000;
  background-color: rgb(89.4, 192.6, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-info:disabled, .btn-info.disabled {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}

.btn-warning {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:hover {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:focus + .btn-warning, .btn-warning:focus {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {
  color: #000;
  background-color: rgb(248.6, 199, 79.8);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-warning:disabled, .btn-warning.disabled {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}

.btn-danger {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
}
.btn-check:focus + .btn-danger, .btn-danger:focus {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(173.6, 29.6, 64);
  border-color: rgb(162.75, 27.75, 60);
}
.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-danger:disabled, .btn-danger.disabled {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}

.btn-light {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:hover {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:focus + .btn-light, .btn-light:focus {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {
  color: #000;
  background-color: rgb(241.4, 241.4, 241.4);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-light:disabled, .btn-light.disabled {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
}
.btn-check:focus + .btn-dark, .btn-dark:focus {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(41.6, 46.4, 51.2);
  border-color: rgb(39, 43.5, 48);
}
.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark:disabled, .btn-dark.disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-focus {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:hover {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
}
.btn-check:focus + .btn-focus, .btn-focus:focus {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {
  color: #fff;
  background-color: rgb(54.4, 51.2, 67.2);
  border-color: #33303f;
}
.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-focus:disabled, .btn-focus.disabled {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}

.btn-alternate {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:hover {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
}
.btn-check:focus + .btn-alternate, .btn-alternate:focus {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {
  color: #fff;
  background-color: rgb(104.8, 70.4, 110.4);
  border-color: rgb(98.25, 66, 103.5);
}
.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-alternate:disabled, .btn-alternate.disabled {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}

.btn-outline-primary {
  color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #545cd8;
  background-color: transparent;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #6c757d;
  background-color: transparent;
}

.btn-outline-success {
  color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:hover {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #3ac47d;
  background-color: transparent;
}

.btn-outline-info {
  color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:hover {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #30b1ff;
  background-color: transparent;
}

.btn-outline-warning {
  color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:hover {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #f7b924;
  background-color: transparent;
}

.btn-outline-danger {
  color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #d92550;
  background-color: transparent;
}

.btn-outline-light {
  color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:hover {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light:disabled, .btn-outline-light.disabled {
  color: #eeeeee;
  background-color: transparent;
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #343a40;
  background-color: transparent;
}

.btn-outline-focus {
  color: #444054;
  border-color: #444054;
}
.btn-outline-focus:hover {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus:disabled, .btn-outline-focus.disabled {
  color: #444054;
  background-color: transparent;
}

.btn-outline-alternate {
  color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:hover {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {
  color: #83588a;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: #545cd8;
  text-decoration: underline;
}
.btn-link:hover {
  color: rgb(67.2, 73.6, 172.8);
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.4rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(29.7, 33.3, 36.9);
  background-color: #e0f3ff;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #545cd8;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.65rem 1rem;
  margin-bottom: 0;
  font-size: 0.968rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.4rem 1rem;
  color: #212529;
}

.dropdown-menu-dark {
  color: #dee2e6;
  background-color: #343a40;
  border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item {
  color: #dee2e6;
}
.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
}
.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {
  color: #fff;
  background-color: #545cd8;
}
.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {
  color: #adb5bd;
}
.dropdown-menu-dark .dropdown-divider {
  border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item-text {
  color: #dee2e6;
}
.dropdown-menu-dark .dropdown-header {
  color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #545cd8;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: rgb(67.2, 73.6, 172.8);
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: none;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
  isolation: isolate;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #545cd8;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: 0.335rem;
  padding-bottom: 0.335rem;
  margin-right: 1rem;
  font-size: 1.1rem;
  text-decoration: none;
  white-space: nowrap;
}
.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.1rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.55);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.55);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-subtitle {
  margin-top: -0.25rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1rem;
}

.card-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.5rem 1rem;
  background-color: #fff;
  border-top: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
  margin-left: -0.5rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-group > .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s, border-radius 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: rgb(75.6, 82.8, 194.4);
  background-color: rgb(237.9, 238.7, 251.1);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}
.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  transform: rotate(-180deg);
}
.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: none;
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  background-color: #fff;
}
.accordion-item:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.accordion-body {
  padding: 1rem 1.25rem;
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0;
  margin-bottom: 1rem;
  list-style: none;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/" /* rtl: var(--bs-breadcrumb-divider, "/") */;
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #545cd8;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: rgb(67.2, 73.6, 172.8);
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  color: rgb(67.2, 73.6, 172.8);
  background-color: #e9ecef;
  outline: 0;
  box-shadow: none;
}

.page-item:not(:first-child) .page-link, .pagination .page-number:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link, .pagination .active.page-number .page-link {
  z-index: 3;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.page-item.disabled .page-link, .pagination .disabled.page-number .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.1rem;
}
.pagination-lg .page-item:first-child .page-link, .pagination-lg .pagination .page-number:first-child .page-link, .pagination .pagination-lg .page-number:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link, .pagination-lg .pagination .page-number:last-child .page-link, .pagination .pagination-lg .page-number:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
}
.pagination-sm .page-item:first-child .page-link, .pagination-sm .pagination .page-number:first-child .page-link, .pagination .pagination-sm .page-number:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link, .pagination-sm .pagination .page-number:last-child .page-link, .pagination .pagination-sm .page-number:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 1rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  color: rgb(50.4, 55.2, 129.6);
  background-color: rgb(220.8, 222.4, 247.2);
  border-color: rgb(203.7, 206.1, 243.3);
}
.alert-primary .alert-link {
  color: rgb(40.32, 44.16, 103.68);
}

.alert-secondary {
  color: rgb(64.8, 70.2, 75);
  background-color: rgb(225.6, 227.4, 229);
  border-color: rgb(210.9, 213.6, 216);
}
.alert-secondary .alert-link {
  color: rgb(51.84, 56.16, 60);
}

.alert-success {
  color: rgb(34.8, 117.6, 75);
  background-color: rgb(215.6, 243.2, 229);
  border-color: rgb(195.9, 237.3, 216);
}
.alert-success .alert-link {
  color: rgb(27.84, 94.08, 60);
}

.alert-info {
  color: rgb(28.8, 106.2, 153);
  background-color: rgb(213.6, 239.4, 255);
  border-color: rgb(192.9, 231.6, 255);
}
.alert-info .alert-link {
  color: rgb(23.04, 84.96, 122.4);
}

.alert-warning {
  color: rgb(98.8, 74, 14.4);
  background-color: rgb(253.4, 241, 211.2);
  border-color: rgb(252.6, 234, 189.3);
}
.alert-warning .alert-link {
  color: rgb(79.04, 59.2, 11.52);
}

.alert-danger {
  color: rgb(130.2, 22.2, 48);
  background-color: rgb(247.4, 211.4, 220);
  border-color: rgb(243.6, 189.6, 202.5);
}
.alert-danger .alert-link {
  color: rgb(104.16, 17.76, 38.4);
}

.alert-light {
  color: rgb(95.2, 95.2, 95.2);
  background-color: rgb(251.6, 251.6, 251.6);
  border-color: rgb(249.9, 249.9, 249.9);
}
.alert-light .alert-link {
  color: rgb(76.16, 76.16, 76.16);
}

.alert-dark {
  color: rgb(31.2, 34.8, 38.4);
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(194.1, 195.9, 197.7);
}
.alert-dark .alert-link {
  color: rgb(24.96, 27.84, 30.72);
}

.alert-focus {
  color: rgb(40.8, 38.4, 50.4);
  background-color: rgb(217.6, 216.8, 220.8);
  border-color: rgb(198.9, 197.7, 203.7);
}
.alert-focus .alert-link {
  color: rgb(32.64, 30.72, 40.32);
}

.alert-alternate {
  color: rgb(78.6, 52.8, 82.8);
  background-color: rgb(230.2, 221.6, 231.6);
  border-color: rgb(217.8, 204.9, 219.9);
}
.alert-alternate .alert-link {
  color: rgb(62.88, 42.24, 66.24);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.66rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #545cd8;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #495057;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.5rem 1rem;
  color: #212529;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid rgba(84, 92, 216, 0.08);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(50.4, 55.2, 129.6);
  background-color: rgb(220.8, 222.4, 247.2);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(50.4, 55.2, 129.6);
  background-color: rgb(198.72, 200.16, 222.48);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(50.4, 55.2, 129.6);
  border-color: rgb(50.4, 55.2, 129.6);
}

.list-group-item-secondary {
  color: rgb(64.8, 70.2, 75);
  background-color: rgb(225.6, 227.4, 229);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(64.8, 70.2, 75);
  background-color: rgb(203.04, 204.66, 206.1);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(64.8, 70.2, 75);
  border-color: rgb(64.8, 70.2, 75);
}

.list-group-item-success {
  color: rgb(34.8, 117.6, 75);
  background-color: rgb(215.6, 243.2, 229);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(34.8, 117.6, 75);
  background-color: rgb(194.04, 218.88, 206.1);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(34.8, 117.6, 75);
  border-color: rgb(34.8, 117.6, 75);
}

.list-group-item-info {
  color: rgb(28.8, 106.2, 153);
  background-color: rgb(213.6, 239.4, 255);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(28.8, 106.2, 153);
  background-color: rgb(192.24, 215.46, 229.5);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(28.8, 106.2, 153);
  border-color: rgb(28.8, 106.2, 153);
}

.list-group-item-warning {
  color: rgb(98.8, 74, 14.4);
  background-color: rgb(253.4, 241, 211.2);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(98.8, 74, 14.4);
  background-color: rgb(228.06, 216.9, 190.08);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(98.8, 74, 14.4);
  border-color: rgb(98.8, 74, 14.4);
}

.list-group-item-danger {
  color: rgb(130.2, 22.2, 48);
  background-color: rgb(247.4, 211.4, 220);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(130.2, 22.2, 48);
  background-color: rgb(222.66, 190.26, 198);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(130.2, 22.2, 48);
  border-color: rgb(130.2, 22.2, 48);
}

.list-group-item-light {
  color: rgb(95.2, 95.2, 95.2);
  background-color: rgb(251.6, 251.6, 251.6);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(95.2, 95.2, 95.2);
  background-color: rgb(226.44, 226.44, 226.44);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(95.2, 95.2, 95.2);
  border-color: rgb(95.2, 95.2, 95.2);
}

.list-group-item-dark {
  color: rgb(31.2, 34.8, 38.4);
  background-color: rgb(214.4, 215.6, 216.8);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(31.2, 34.8, 38.4);
  background-color: rgb(192.96, 194.04, 195.12);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(31.2, 34.8, 38.4);
  border-color: rgb(31.2, 34.8, 38.4);
}

.list-group-item-focus {
  color: rgb(40.8, 38.4, 50.4);
  background-color: rgb(217.6, 216.8, 220.8);
}
.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {
  color: rgb(40.8, 38.4, 50.4);
  background-color: rgb(195.84, 195.12, 198.72);
}
.list-group-item-focus.list-group-item-action.active {
  color: #fff;
  background-color: rgb(40.8, 38.4, 50.4);
  border-color: rgb(40.8, 38.4, 50.4);
}

.list-group-item-alternate {
  color: rgb(78.6, 52.8, 82.8);
  background-color: rgb(230.2, 221.6, 231.6);
}
.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {
  color: rgb(78.6, 52.8, 82.8);
  background-color: rgb(207.18, 199.44, 208.44);
}
.list-group-item-alternate.list-group-item-action.active {
  color: #fff;
  background-color: rgb(78.6, 52.8, 82.8);
  border-color: rgb(78.6, 52.8, 82.8);
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  width: 350px;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.toast:not(.showing):not(.show) {
  opacity: 0;
}
.toast.hide {
  display: none;
}

.toast-container {
  width: -webkit-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.toast-header .btn-close {
  margin-right: -0.375rem;
  margin-left: 0.75rem;
}

.toast-body {
  padding: 0.75rem;
  word-wrap: break-word;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}
.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.968rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0 /* rtl:ignore */;
  z-index: 1070;
  display: block;
  max-width: 320px;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.968rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
  border-radius: 0.3rem;
}
.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.88rem;
  background-color: #fff;
  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 1rem 1rem;
  color: #495057;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  visibility: hidden;
  background-color: #fff;
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.offcanvas-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: 1rem 1rem;
  overflow-y: auto;
}

.offcanvas-start {
  top: 0;
  left: 0;
  width: 400px;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateX(-100%);
}

.offcanvas-end {
  top: 0;
  right: 0;
  width: 400px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
}

.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateY(-100%);
}

.offcanvas-bottom {
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateY(100%);
}

.offcanvas.show {
  transform: none;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-primary {
  color: #545cd8;
}
.link-primary:hover, .link-primary:focus {
  color: rgb(67.2, 73.6, 172.8);
}

.link-secondary {
  color: #6c757d;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgb(86.4, 93.6, 100);
}

.link-success {
  color: #3ac47d;
}
.link-success:hover, .link-success:focus {
  color: rgb(97.4, 207.8, 151);
}

.link-info {
  color: #30b1ff;
}
.link-info:hover, .link-info:focus {
  color: rgb(89.4, 192.6, 255);
}

.link-warning {
  color: #f7b924;
}
.link-warning:hover, .link-warning:focus {
  color: rgb(248.6, 199, 79.8);
}

.link-danger {
  color: #d92550;
}
.link-danger:hover, .link-danger:focus {
  color: rgb(173.6, 29.6, 64);
}

.link-light {
  color: #eeeeee;
}
.link-light:hover, .link-light:focus {
  color: rgb(241.4, 241.4, 241.4);
}

.link-dark {
  color: #343a40;
}
.link-dark:hover, .link-dark:focus {
  color: rgb(41.6, 46.4, 51.2);
}

.link-focus {
  color: #444054;
}
.link-focus:hover, .link-focus:focus {
  color: rgb(54.4, 51.2, 67.2);
}

.link-alternate {
  color: #83588a;
}
.link-alternate:hover, .link-alternate:focus {
  color: rgb(104.8, 70.4, 110.4);
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dee2e6 !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dee2e6 !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #545cd8 !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #3ac47d !important;
}

.border-info {
  border-color: #30b1ff !important;
}

.border-warning {
  border-color: #f7b924 !important;
}

.border-danger {
  border-color: #d92550 !important;
}

.border-light {
  border-color: #eeeeee !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-focus {
  border-color: #444054 !important;
}

.border-alternate {
  border-color: #83588a !important;
}

.border-white {
  border-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.345rem + 1.14vw) !important;
}

.fs-2 {
  font-size: calc(1.301rem + 0.612vw) !important;
}

.fs-3 {
  font-size: calc(1.279rem + 0.348vw) !important;
}

.fs-4 {
  font-size: calc(1.257rem + 0.084vw) !important;
}

.fs-5 {
  font-size: 1.1rem !important;
}

.fs-6 {
  font-size: 0.88rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  color: #545cd8 !important;
}

.text-secondary {
  color: #6c757d !important;
}

.text-success {
  color: #3ac47d !important;
}

.text-info {
  color: #30b1ff !important;
}

.text-warning {
  color: #f7b924 !important;
}

.text-danger {
  color: #d92550 !important;
}

.text-light {
  color: #eeeeee !important;
}

.text-dark {
  color: #343a40 !important;
}

.text-focus {
  color: #444054 !important;
}

.text-alternate {
  color: #83588a !important;
}

.text-white {
  color: #fff !important;
}

.text-body {
  color: #495057 !important;
}

.text-muted, .dispute .chatbot .chat p, .dispute .chatbot__body .date {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  color: inherit !important;
}

.bg-primary {
  background-color: #545cd8 !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

.bg-success {
  background-color: #3ac47d !important;
}

.bg-info {
  background-color: #30b1ff !important;
}

.bg-warning {
  background-color: #f7b924 !important;
}

.bg-danger {
  background-color: #d92550 !important;
}

.bg-light {
  background-color: #eeeeee !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

.bg-focus {
  background-color: #444054 !important;
}

.bg-alternate {
  background-color: #83588a !important;
}

.bg-body {
  background-color: #fff !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.2rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-end {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-start {
  border-bottom-left-radius: 0.25rem !important;
  border-top-left-radius: 0.25rem !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.2rem !important;
  }
  .fs-2 {
    font-size: 1.76rem !important;
  }
  .fs-3 {
    font-size: 1.54rem !important;
  }
  .fs-4 {
    font-size: 1.32rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
a,
button,
.btn {
  outline: none !important;
}

.app-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

.SidebarAnimation-appear {
  transform: translateX(-30px);
  opacity: 0;
}
.SidebarAnimation-appear.SidebarAnimation-appear-active {
  opacity: 1;
  transform: translateX(0);
  transition: all 0.4s linear;
}

.HeaderAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.HeaderAnimation-appear.HeaderAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.MainAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.MainAnimation-appear.MainAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.app-header {
  height: 60px;
  display: flex;
  align-items: center;
  align-content: center;
  position: relative;
  z-index: 10;
  transition: all 0.2s;
}
.app-header.header-shadow {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.app-header .app-header__content {
  display: flex;
  align-items: center;
  align-content: center;
  flex: 1 1;
  padding: 0 1.5rem;
  height: 60px;
}
.app-header .app-header__content .app-header-left {
  display: flex;
  align-items: center;
}
.app-header .app-header__content .app-header-right {
  align-items: center;
  display: flex;
  margin-left: auto;
}
.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {
  white-space: nowrap;
}
.app-header .header-user-info > .widget-subheading {
  font-size: 0.8rem;
}

.app-header__logo {
  padding: 0 1.5rem;
  height: 60px;
  width: 280px;
  display: flex;
  align-items: center;
  transition: width 0.2s;
}
.app-header__logo .logo-src {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.app-header__menu,
.app-header__mobile-menu {
  display: none;
  padding: 0 1.5rem;
  height: 60px;
  align-items: center;
}

.fixed-header .app-header {
  position: fixed;
  width: 100%;
  top: 0;
}
.fixed-header .app-header .app-header__logo {
  visibility: visible;
}
.fixed-header .app-main {
  padding-top: 60px;
}
.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}

.header-dots {
  margin-left: auto;
  display: flex;
}
.header-dots > .dropdown {
  display: flex;
  align-content: center;
}
.header-dots .icon-wrapper-alt {
  margin: 0;
  height: 44px;
  width: 44px;
  text-align: center;
  overflow: visible;
}
.header-dots .icon-wrapper-alt .language-icon {
  border-radius: 30px;
  position: relative;
  z-index: 4;
  width: 28px;
  height: 28px;
  overflow: hidden;
  margin: 0 auto;
}
.header-dots .icon-wrapper-alt .language-icon img {
  position: relative;
  top: 50%;
  left: 50%;
  margin: -22px 0 0 -20px;
}
.header-dots .icon-wrapper-alt .icon-wrapper-bg {
  opacity: 0.1;
  transition: opacity 0.2s;
  border-radius: 40px;
}
.header-dots .icon-wrapper-alt svg {
  margin: 0 auto;
}
@-moz-document url-prefix() {
  .header-dots .icon-wrapper-alt svg {
    width: 50%;
  }
}
.header-dots .icon-wrapper-alt i {
  font-size: 1.3rem;
}
.header-dots .icon-wrapper-alt:hover {
  cursor: pointer;
}
.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {
  opacity: 0.2;
}
.header-dots .icon-wrapper-alt .badge-dot {
  top: 1px;
  right: 1px;
  border: 0;
}

.header-megamenu.nav > li > .nav-link {
  color: #6c757d;
  padding-left: 0.6666666667rem;
  padding-right: 0.6666666667rem;
}
.header-megamenu.nav > li > .nav-link .rounded-pill {
  padding: 5px 7px;
}
.header-megamenu.nav > li > .nav-link:hover {
  color: #343a40;
}
.header-megamenu.nav > li > .nav-link svg {
  margin-top: 1px;
}

.header-btn-lg {
  padding: 0 0 0 1.5rem;
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
  /*&::before {
    position: absolute;
    left: -1px;
    top: 50%;
    background: \$border-color;
    width: 1px;
    height: 30px;
    margin-top: -15px;
    content: '';
  }*/
}
.header-btn-lg .hamburger-inner,
.header-btn-lg .hamburger-inner::before,
.header-btn-lg .hamburger-inner::after {
  background: #6c757d;
}

.app-header.header-text-light .app-header-left > .nav > li > .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(255, 255, 255);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {
  fill: rgba(255, 255, 255, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(255, 255, 255, 0.95);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.15) !important;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.app-header.header-text-light .search-wrapper.active .input-holder {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-input {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .header-btn-lg::before {
  background: rgba(255, 255, 255, 0.2);
}
.app-header.header-text-light .header-btn-lg .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger-inner::before,
.app-header.header-text-light .header-btn-lg .hamburger-inner::after,
.app-header.header-text-light .header__pane .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger-inner::before,
.app-header.header-text-light .header__pane .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper .close::before,
.app-header.header-text-light .search-wrapper .close::after,
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {
  background: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {
  background: rgba(255, 255, 255, 0.9);
}

.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(0, 0, 0);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {
  fill: rgba(0, 0, 0, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(0, 0, 0, 0.95);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.15) !important;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .header-btn-lg::before {
  background: rgba(0, 0, 0, 0.2);
}
.app-header.header-text-dark .header-btn-lg .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,
.app-header.header-text-dark .header__pane .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger-inner::before,
.app-header.header-text-dark .header__pane .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .close::before,
.app-header.header-text-dark .search-wrapper .close::after,
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {
  background: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.app-sidebar {
  width: 280px;
  display: flex;
  z-index: 11;
  overflow: hidden;
  min-width: 280px;
  position: relative;
  flex: 0 0 280px;
  margin-top: -60px;
  padding-top: 60px;
  transition: all 0.2s;
}
.app-sidebar .app-sidebar__inner {
  padding: 2px 1.5rem 1.5rem;
}
.app-sidebar .scrollbar-container {
  z-index: 15;
  width: 100%;
}
.app-sidebar .app-sidebar-bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0.05;
  background-size: cover;
  z-index: 10;
}
.app-sidebar .app-header__logo {
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  z-index: 11;
}
.app-sidebar.sidebar-shadow {
  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);
}

.app-sidebar__heading {
  text-transform: uppercase;
  font-size: 0.8rem;
  margin: 0.75rem 0;
  font-weight: bold;
  color: #545cd8;
  white-space: nowrap;
  position: relative;
}

.sidebar-mobile-overlay {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #333;
  opacity: 0.6;
  left: 0;
  top: 0;
  z-index: 12;
}

.vertical-nav-menu {
  position: relative;
}
.vertical-nav-menu::after {
  content: " ";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.vertical-nav-menu .metismenu-container,
.vertical-nav-menu .metismenu-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.vertical-nav-menu .metismenu-container {
  list-style: none;
}
.vertical-nav-menu .metismenu-container:before {
  opacity: 0;
  transition: opacity 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-link {
  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;
  display: block;
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 1.5rem 0 45px;
  position: relative;
  border-radius: 0.25rem;
  color: #343a40;
  white-space: nowrap;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover {
  background: #e0f3ff;
  text-decoration: none;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {
  opacity: 0.6;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {
  opacity: 1;
}
.vertical-nav-menu .metismenu-container .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {
  font-weight: bold;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon,
.vertical-nav-menu .metismenu-container i.metismenu-icon {
  text-align: center;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
  font-size: 1.5rem;
  opacity: 0.3;
  transition: color 300ms;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon {
  transition: transform 300ms;
  left: auto;
  right: 0;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {
  transform: rotate(-180deg);
}
.vertical-nav-menu .metismenu-container .metismenu-container {
  transition: padding 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {
  content: "";
  height: 100%;
  opacity: 1;
  width: 3px;
  background: #e0f3ff;
  position: absolute;
  left: 20px;
  top: 0;
  border-radius: 15px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  line-height: 2.3em;
  color: #6c757d;
  margin: 0 0 3px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {
  color: #545cd8;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {
  display: none;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {
  height: 0;
  overflow: hidden;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 1em;
}

.app-sidebar.sidebar-text-light {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-light .app-sidebar__heading {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .app-sidebar__heading::before {
  background: rgba(255, 255, 255, 0.2) !important;
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {
  color: rgb(255, 255, 255);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-light .ps__thumb-y {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {
  background: rgba(255, 255, 255, 0.2);
}
.app-sidebar.sidebar-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8);
}

.app-sidebar.sidebar-text-dark {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {
  background: rgba(0, 0, 0, 0.5) !important;
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-dark .ps__thumb-y {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {
  background: rgba(0, 0, 0, 0.2);
}
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8);
}

.fixed-sidebar .app-sidebar {
  position: fixed;
  height: 100vh;
}
.fixed-sidebar .app-main .app-main__outer {
  z-index: 9;
  padding-left: 280px;
}
.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {
  display: none;
}
.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  display: flex;
}
.fixed-sidebar:not(.fixed-header) .app-header {
  margin-left: 280px;
}
.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {
  margin-left: 80px;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  width: 80px;
  padding: 0;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {
  margin-right: auto;
}

.closed-sidebar .app-sidebar {
  transition: all 0.3s ease;
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px;
  z-index: 13;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {
  text-indent: -999em;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e0f3ff;
  text-indent: 1px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {
  text-indent: -99rem;
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  left: 50%;
  margin-left: -17px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {
  visibility: hidden;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 0;
}
.closed-sidebar .app-sidebar:hover {
  flex: 0 0 280px !important;
  width: 280px !important;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {
  text-indent: 0;
  text-indent: initial;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {
  display: none;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {
  text-indent: 0;
  text-indent: initial;
  padding: 0 1.5rem 0 45px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  text-indent: initial;
  left: 5px;
  margin-left: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {
  visibility: visible;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 1em;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {
  position: static;
  height: auto;
  overflow: visible !important;
  overflow: initial !important;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {
  position: absolute;
  height: 100%;
  overflow: hidden !important;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {
  width: 80px;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {
  display: none;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {
  margin-right: auto;
}
.closed-sidebar.fixed-sidebar .app-main__outer {
  padding-left: 80px;
}
.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {
  width: auto;
  display: flex;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {
  display: flex;
  width: 80px;
  padding: 0 1.5rem !important;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {
  display: block !important;
  margin: 0 auto;
  width: 21px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {
  width: 280px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {
  width: 97px;
  margin: 0;
}
.closed-sidebar.closed-sidebar-mobile .app-header {
  margin-left: 0 !important;
}
.closed-sidebar.fixed-footer .app-footer__inner {
  margin-left: 0 !important;
}

.app-main {
  z-index: 8;
  position: relative;
  display: flex;
}
.app-main .app-main__outer {
  flex: 1 1;
  flex-direction: column;
  display: flex;
  z-index: 12;
  width: 1px;
}
.app-main .app-main__inner {
  padding: 1.5rem 1.5rem 0;
  flex: 1 1;
}
.app-main .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 1.5rem;
}
.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {
  margin-top: -0.5rem;
}

.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 1rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {
  border: 0;
  background: transparent;
  position: relative;
  z-index: 7;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {
  margin-top: -13px;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {
  margin-top: 0.5rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {
  color: #fff;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.1rem;
  z-index: 5;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.app-theme-white.app-container {
  background: #eaedef;
}
.app-theme-white .app-sidebar {
  background: #ffffff;
}
.app-theme-white .app-footer .app-footer__inner,
.app-theme-white .app-header {
  background: #fafbfc;
}
.app-theme-white.fixed-header .app-header__logo {
  background: rgba(250, 251, 252, 0.1);
}

.app-theme-gray.app-container {
  background: #ffffff;
}
.app-theme-gray .app-sidebar {
  background: #ffffff;
  border-right: #dee2e6 solid 1px;
}
.app-theme-gray .app-page-title {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .app-footer,
.app-theme-gray .app-header {
  background: #f8f9fa;
}
.app-theme-gray .app-footer {
  border-top: #dee2e6 solid 1px;
}
.app-theme-gray .app-header .app-header__logo {
  border-right: rgba(0, 0, 0, 0.1) solid 1px;
}
.app-theme-gray.fixed-header .app-header__logo {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .card {
  border-width: 1px;
}
.app-theme-gray .main-card {
  box-shadow: 0 0 0 0 transparent !important;
}
.app-theme-gray .main-card > .card-body > .card-title {
  text-transform: none;
  font-size: 1.1rem;
  font-weight: normal;
  border-bottom: #dee2e6 solid 1px;
  position: relative;
  padding: 0 0 1.5rem;
  margin: 0 0 1.5rem;
}
.app-theme-gray .main-card > .card-body > .card-title::before {
  position: absolute;
  width: 40px;
  background: #545cd8;
  border-radius: 30px;
  height: 5px;
  left: 0;
  bottom: -2px;
  content: "";
}
.app-theme-gray .app-inner-layout__sidebar {
  border-left: 0 !important;
}

@media (min-width: 760px) {
  .trade_icon {
    position: absolute;
    top: 60%;
    left: 45%; /* Move to the center horizontally */
    transform: translateX(-50%); /* Center the element based on its width */
  }
}
.carousel .thumbs-wrapper {
  margin: 0 !important;
}

.carousel .thumbs {
  padding: 0 !important;
}

.carousel .thumb.selected,
.carousel .thumb:hover {
  border: none !important;
}

.app-footer {
  height: 60px;
}
.app-footer .app-footer__inner {
  padding: 0 1.5rem 0 0.75rem;
  height: 60px;
  transition: all 0.2s;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-left {
  display: flex;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-right {
  margin-left: auto;
  display: flex;
}

.footer-dots {
  display: flex;
  align-items: center;
  align-content: center;
}
.footer-dots .dots-separator {
  height: 40px;
  margin: 0 0.6rem;
  width: 1px;
  background: #e9ecef;
}

.dot-btn-wrapper {
  padding: 0.5rem;
  position: relative;
  display: flex;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.dot-btn-wrapper .badge-abs {
  right: 50%;
}
.dot-btn-wrapper .badge-abs.badge-dot-sm {
  top: -2px;
  margin-right: -3px;
}
.dot-btn-wrapper .dot-btn-icon {
  font-size: 1.8rem;
}
.dot-btn-wrapper:hover {
  text-decoration: none;
  opacity: 1;
}

.fixed-footer .app-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 7;
}
.fixed-footer .app-footer .app-footer__inner {
  margin-left: 280px;
  box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.04), 0.3rem -0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02);
}
.fixed-footer .app-main .app-main__outer {
  padding-bottom: 60px;
}
.fixed-footer.closed-sidebar .app-footer .app-footer__inner {
  margin-left: 80px !important;
}

.app-page-title {
  padding: 1.5rem;
  margin: -1.5rem -1.5rem 1.5rem;
  position: relative;
}
.app-page-title .page-title-wrapper {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.app-page-title .page-title-heading,
.app-page-title .page-title-subheading {
  margin: 0;
  padding: 0;
}
.app-page-title .page-title-heading {
  font-size: 1.1rem;
  font-weight: 400;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-page-title .page-title-subheading {
  padding: 3px 0 0;
  font-size: 0.88rem;
  opacity: 0.6;
}
.app-page-title .page-title-subheading .breadcrumb {
  padding: 0;
  margin: 3px 0 0;
  background: transparent;
}
.app-page-title .page-title-actions {
  margin-left: auto;
}
.app-page-title .page-title-actions .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-page-title .page-title-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  padding: 0.8333333333rem;
  margin: 0 1.5rem 0 0;
  background: #fff;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  border-radius: 0.25rem;
  width: 60px;
  height: 60px;
}
.app-page-title .page-title-icon i {
  margin: auto;
}
.app-page-title .page-title-icon.rounded-circle {
  margin: 0 1rem 0 0;
}
.app-page-title + .RRT__container {
  margin-top: -1.1538461538rem;
}
.app-page-title + .rc-tabs {
  max-width: calc(100vw - 322px);
  margin: -1.5rem -0.75rem 1.95rem;
}
@media only screen and (max-width: 812px) and (min-width: 360px) {
  .app-page-title + .rc-tabs {
    max-width: calc(100vw - 0px);
    margin: -1.5rem -0.75rem 1.95rem;
  }
}
.app-page-title.app-page-title-simple {
  margin: 0;
  background: none !important;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}
.app-page-title .page-title-right {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 15px;
}
.app-page-title .page-title-right span {
  white-space: nowrap;
  color: #212121;
}

.page-title-icon-rounded .page-title-icon {
  border-radius: 50px;
}

.closed-sidebar .rc-tabs {
  max-width: calc(100vw - 140px);
}

@media only screen and (max-width: 812px) and (min-width: 360px) {
  .closed-sidebar .rc-tabs {
    max-width: calc(100vw - 0px);
  }
}
.body-tabs.body-tabs-layout {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding: 0 1.5rem;
  border-top: 0;
  border-bottom: #dee2e6 solid 1px;
}

.search-wrapper {
  position: relative;
  margin-right: 0.6666666667rem;
}
.search-wrapper .input-holder {
  height: 42px;
  width: 42px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease-in-out;
}
.search-wrapper .input-holder .search-input {
  width: 100%;
  padding: 0 70px 0 20px;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  box-sizing: border-box;
  border: none;
  outline: none;
  transform: translate(0, 60px);
  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.3s;
  font-size: 0.88rem;
}
.search-wrapper .input-holder .search-icon {
  width: 42px;
  height: 42px;
  border: none;
  padding: 0;
  outline: none;
  position: relative;
  z-index: 2;
  float: right;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 30px;
}
.search-wrapper .input-holder .search-icon span {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  transform: rotate(45deg);
  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);
}
.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {
  position: absolute;
  content: "";
}
.search-wrapper .input-holder .search-icon span::before {
  width: 4px;
  height: 11px;
  left: 9px;
  top: 13px;
  border-radius: 2px;
  background: #545cd8;
}
.search-wrapper .input-holder .search-icon span::after {
  width: 14px;
  height: 14px;
  left: 4px;
  top: 0;
  border-radius: 16px;
  border: 2px solid #545cd8;
}
.search-wrapper .btn-close {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  cursor: pointer;
  opacity: 0 !important;
  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);
  transition-delay: 0.1s;
}
.search-wrapper .btn-close::before, .search-wrapper .btn-close::after {
  position: absolute;
  background: #545cd8;
  border-radius: 2px;
}
.search-wrapper .btn-close::before {
  width: 2px;
  height: 20px;
  left: 9px;
  top: 0;
}
.search-wrapper .btn-close::after {
  width: 20px;
  height: 2px;
  left: 0;
  top: 9px;
}
.search-wrapper.active {
  width: 330px;
}
.search-wrapper.active .input-holder {
  width: 290px;
  border-radius: 50px;
  background: rgba(0, 0, 0, 0.05);
  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);
}
.search-wrapper.active .input-holder .search-input {
  opacity: 1;
  transform: translate(0, 11px);
}
.search-wrapper.active .input-holder .search-icon {
  width: 42px;
  height: 42px;
  margin: 0;
  border-radius: 30px;
}
.search-wrapper.active .input-holder .search-icon span {
  transform: rotate(-45deg);
}
.search-wrapper.active .btn-close {
  left: 300px;
  opacity: 0.6 !important;
  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.5s;
}
.search-wrapper.active .btn-close:hover {
  opacity: 1 !important;
}
.search-wrapper.active + .header-megamenu {
  opacity: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.bg-gray {
  background: #f9f9f9 !important;
}
.bg-table--green {
  background: #229e60 !important;
}
.bg-table--red {
  background: #cd3a3d !important;
}

.text-success {
  color: #0e9451 !important;
}
.text-primary {
  color: #535bd6 !important;
}
.text-base {
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  color: inherit;
}
.text-muted, .dispute .chatbot .chat p, .dispute .chatbot__body .date {
  color: #767676 !important;
}
.text-table--green {
  color: #229e60 !important;
}
.text-table--red {
  color: #cd3a3d !important;
}

.weight-400 {
  font-weight: 400 !important;
}
.weight-500 {
  font-weight: 500 !important;
}
.weight-600 {
  font-weight: 600 !important;
}
.weight-700 {
  font-weight: 700 !important;
}

.alert {
  border-radius: 0.25rem;
  padding: 0.25rem 0.625rem;
  border-style: solid;
  border-width: 1px;
  text-transform: uppercase;
  font-size: 11px;
  line-height: 13px;
  font-weight: 700;
  color: inherit;
  margin: 0;
}
.alert-orange {
  background: #ffefc9;
  border-color: #f7b924;
  color: #f7b924;
}
.alert-red {
  background: #ffe2e7;
  border-color: #fd1a41;
  color: #fd1a41;
}
.alert-green {
  background: rgba(34, 158, 96, 0.0509803922);
  border-color: #229e60;
  color: #229e60;
}

@media (min-width: 768px) {
  .h-md-100p {
    height: 100% !important;
  }
}

.p-3\\.5 {
  padding: 20px !important;
}

.ps-\\.5 {
  padding-left: 0px !important;
}

.pe-\\.5 {
  padding-right: 20px !important;
}

.pt-\\.5 {
  padding-top: 20px !important;
}

.pb-\\.5 {
  padding-bottom: 20px !important;
}

.m-3\\.5 {
  margin: 20px !important;
}

.ms-3\\.5 {
  margin-left: 0px !important;
}

.me-3\\.5 {
  margin-right: 20px !important;
}

.mt-3\\.5 {
  margin-top: 20px !important;
}

.mb-3\\.5 {
  margin-bottom: 20px !important;
}

@media (min-width: 768px) {
  .w-md-auto {
    width: auto !important;
  }
}

.badge {
  white-space: normal;
}

.app-title {
  margin-bottom: 1.5rem;
}
@media (max-width: 767.98px) {
  .app-title {
    margin-bottom: 0.75rem;
  }
}
.app-title .avatar {
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  border-radius: 0.25rem;
  background: #ffffff;
  margin-right: 0.625rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-title .avatar i {
  font-size: 2rem;
}
.app-title span:not(.avatar) {
  font-size: 0.813rem;
  line-height: 0.938rem;
  font-weight: 400;
  color: #767676;
}
.app-title [type=date] {
  background: #ffffff;
  border-color: #535bd6;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #212121;
  padding: 0.5rem 0.875rem;
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}), url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: 12px 7px, 16px;
  background-position: right 0.875rem center, 0.875rem center;
  background-repeat: no-repeat;
  border-color: #535bd6;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #212121;
  padding: 0.5rem 0.875rem;
  padding-right: calc(1.75rem + 12px);
  padding-left: calc(1.75rem + 16px);
  border-radius: 0.25rem !important;
  width: auto;
}
.app-title [type=date]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
.app-title .btn-outline-primary {
  background: #ffffff;
  font-weight: 600;
}

.dashboard-card {
  padding: 1.25rem;
  background: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
}
.dashboard-card > header {
  min-height: auto;
  padding: 0;
}
.dashboard-card.card {
  padding: 0;
}

.card {
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05) !important;
  border-radius: 0.25rem !important;
}

body {
  font-family: "Inter", serif;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  color: #212121;
}

h1, .h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  font-family: "Inter", serif;
  font-weight: 600;
}

h3, .h3 {
  font-size: 19px;
  line-height: 25px;
  font-weight: 500;
  color: #212121;
}

h5, .h5 {
  font-size: 15px;
  line-height: 21px;
  font-weight: 500;
  color: #212121;
}

h6, .h6 {
  font-size: 13px;
  line-height: 19px;
  font-weight: 500;
  color: #212121;
}

.rdt_Wrapper {
  border: solid 1px #e6e6e6;
  border-radius: 6px !important;
}
.rdt_Wrapper .rdt_TableHead {
  background: #f6f6f6;
  font-size: 13px;
  line-height: 15px;
  font-weight: 400;
  color: #535bd6;
}
.rdt_Wrapper .rdt_TableHeadRow {
  background: none;
  min-height: auto;
  border-bottom-color: #e6e6e6;
}
.rdt_Wrapper .rdt_TableCol {
  padding: 10px 20px;
}
.rdt_Wrapper .rdt_TableCol_Sortable:hover, .rdt_Wrapper .rdt_TableCol_Sortable:focus {
  opacity: 1;
}
.rdt_Wrapper .rdt_TableCol_Sortable:hover *, .rdt_Wrapper .rdt_TableCol_Sortable:focus * {
  opacity: 1;
}
.rdt_Wrapper .rdt_TableRow {
  min-height: auto;
  font-size: 13px;
  line-height: 15px;
  font-weight: 400;
  color: #212121;
}
.rdt_Wrapper .rdt_TableCell {
  padding: 10px 20px;
}
.rdt_Pagination {
  border: none !important;
  border-radius: 0 0 0.25rem 0.25rem !important;
  background: none !important;
  min-height: auto !important;
}
.rdt_SubHeader {
  width: 100%;
  margin-bottom: 1rem;
}
@media (min-width: 1200px) {
  .rdt_SubHeader {
    display: flex;
    align-items: center;
  }
}
.rdt_SubHeader .btn {
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #ffffff;
  padding: 0.5rem 0.875rem;
  border-radius: 0.25rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rdt_SubHeader .btn-gray {
  background: #eaedef;
  border-color: #eaedef;
  color: #212121;
}
.rdt_SubHeader .btn-gray:hover, .rdt_SubHeader .btn-gray:active {
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.rdt_SubHeader .btn-icon {
  position: relative;
  padding-right: 3rem;
}
.rdt_SubHeader .btn-icon .icon {
  position: absolute;
  top: -1px;
  bottom: -1px;
  right: 0;
  border-radius: 0 0.25rem 0.25rem 0 !important;
  width: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #535bd6;
}
.rdt_SubHeader .btn-icon .icon img {
  height: 18px;
  width: auto;
}
.rdt_SubHeader .btn-sort:after {
  content: "";
  background-size: 100%;
  margin-left: 0.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 0 0;
  width: 12px;
  height: 7px;
}
.rdt_SubHeader .btn-filter:before {
  content: "";
  background-size: 100%;
  margin-right: 0.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat 0 0;
  width: 16px;
  height: 14px;
}
.rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker {
  background: #ffffff;
  border-color: #535bd6;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #212121;
  padding: 0.5rem 0.875rem;
  border-radius: 0.25rem !important;
}
.rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker::placeholder {
  color: #212121;
  opacity: 1;
}
.rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker:hover {
  border-color: #535bd6;
}
@media (max-width: 767.98px) {
  .rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker {
    width: 100%;
  }
}
.rdt_SubHeader .form-control {
  background: #ffffff;
  border-color: #535bd6;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #212121;
  padding: 0.5rem 0.875rem;
  border-radius: 0.25rem !important;
}
.rdt_SubHeader .form-control::placeholder {
  color: #212121;
  opacity: 1;
}
.rdt_SubHeader .form-control:focus {
  z-index: 1 !important;
}
.rdt_SubHeader .form-search {
  background: #ffffff url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat 0.875rem center;
  padding-left: 44px;
}
.rdt_SubHeader .form-search-reset {
  position: absolute;
  right: 0.875rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.rdt_SubHeader .form-select {
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: right 0.875rem center;
  background-size: 12px 7px;
  border-color: #535bd6;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #212121;
  padding: 0.5rem 0.875rem;
  padding-right: calc(1.75rem + 12px);
  border-radius: 0.25rem !important;
  width: auto;
}
.rdt_SubHeader .form-select-period {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}), url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: 12px 7px, 16px;
  background-position: right 0.875rem center, 0.875rem center;
  padding-left: calc(1.75rem + 16px);
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.75rem 2.25rem;
}

@media (min-width: 768px) {
  .button-group {
    display: flex;
    align-items: center;
  }
  .button-group .btn + .btn {
    margin-left: 1rem;
  }
}
@media (max-width: 767.98px) {
  .button-group .btn {
    width: 100%;
  }
  .button-group .btn + .btn {
    margin-top: 0.5rem;
  }
}

.form-control {
  border-color: #e6e6e6;
  color: #212121;
  outline: none !important;
  box-shadow: none !important;
}
.form-control::placeholder {
  opacity: 1;
  color: #767676;
}
.form-control:disabled, .form-control[readonly] {
  background: #f6f6f6;
}
.form-select {
  border-color: #e6e6e6;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  color: #767676;
}
.form-select-wrapper {
  position: relative;
}
.form-select-wrapper:after {
  content: "";
  width: 12px;
  height: 7px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 0 0;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.form-select-wrapper .form-select {
  -webkit-appearance: none;
  appearance: none;
  background-image: none;
}
.form-select.lrg {
  padding-top: 10px;
  padding-bottom: 10px;
}
.form-textarea {
  height: 100px;
  overflow: auto;
  resize: none;
}

.dropdown .dropdown-toggle:after {
  margin-left: 0.5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 0 0;
  background-size: 100%;
  width: 12px;
  height: 7px;
  opacity: 1;
  position: static;
  border: none;
}
.dropdown .dropdown-toggle:hover {
  color: inherit;
}
.dropdown .dropdown-menu {
  min-width: 10rem;
  background: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  margin: 0;
  padding: 0.5rem 0;
}
.dropdown .dropdown-menu:before, .dropdown .dropdown-menu:after {
  display: none;
}
.dropdown .dropdown-menu .dropdown-item {
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  color: #212121;
}
.dropdown.show > .dropdown-toggle {
  box-shadow: none !important;
}
.dropdown.show > .dropdown-toggle.btn-gray {
  background: #e6e6e6;
  border-color: #e6e6e6;
  color: #212121;
}

.admin-box h2, .admin-box .h2 {
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 0;
}
.admin-box p {
  color: #212121;
}
.admin-box .btn {
  border-radius: 5px;
}
.admin-box .coinbox-value {
  font-size: 32px;
  color: #535bd6;
  line-height: 40px;
  font-weight: 700;
  margin-bottom: 10px;
}
.admin-box .coinbox p {
  color: #767676;
  margin-bottom: 0;
}
.admin-box .wallet-box {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.admin-box .wallet-box-top {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.admin-box .wallet-box-top .btn-box {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.admin-box .wallet-box-mid {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
}
.admin-box .wallet-box-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #767676;
  padding-top: 15px;
}
.admin-box .wallet-box-bottom div {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.admin-box .wallet-box-bottom div p {
  font-size: 15px;
  margin-bottom: 0;
}
.admin-box .wallet-box-bottom div p:first-child {
  color: #767676;
}
.admin-box .summery-box {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.admin-box .summery-box-list {
  width: 100%;
  display: grid;
  grid: 100px/auto auto auto auto;
  grid-gap: 20px;
}
.admin-box .summery-box-card {
  padding: 20px;
  border-radius: 10px;
}
.admin-box .summery-box-card h2, .admin-box .summery-box-card .h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
.admin-box .summery-box-card p {
  margin-bottom: 0;
}
.admin-box .summery-box-card.blue-md {
  background-color: #f3f4ff;
}
.admin-box .summery-box-card.blue-md h2, .admin-box .summery-box-card.blue-md .h2 {
  color: #535bd6;
}
.admin-box .summery-box-card.blue-vi {
  background-color: #e7f5ff;
}
.admin-box .summery-box-card.blue-vi h2, .admin-box .summery-box-card.blue-vi .h2 {
  color: #1188dd;
}
.admin-box .summery-box-card.green {
  background-color: #e8faf2;
}
.admin-box .summery-box-card.green h2, .admin-box .summery-box-card.green .h2 {
  color: #0e9451;
}
.admin-box .summery-box-card.orange {
  background-color: #fffce8;
}
.admin-box .summery-box-card.orange h2, .admin-box .summery-box-card.orange .h2 {
  color: #f7b924;
}
.admin-box .summery-box-card.red {
  background-color: #fff1f1;
}
.admin-box .summery-box-card.red h2, .admin-box .summery-box-card.red .h2 {
  color: #d8092e;
}
.admin-box .summery-box-card.gray {
  background-color: #f5f5f5;
}
.admin-box .summery-box-card.gray h2, .admin-box .summery-box-card.gray .h2 {
  color: #212121;
}
.admin-box .summery-box-card.pink {
  background-color: #fff0fb;
}
.admin-box .summery-box-card.pink h2, .admin-box .summery-box-card.pink .h2 {
  color: #d423a5;
}
.admin-box .summery-box-card.violet {
  background-color: #f3f4ff;
}
.admin-box .summery-box-card.violet h2, .admin-box .summery-box-card.violet .h2 {
  color: #9953d6;
}
.admin-box .table-box {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.admin-box .table-box-top {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}
.admin-box .table-box-topleft {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.admin-box .table-box-topright {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.admin-box .table-box .saleamt {
  background-color: #eeefff;
  padding: 8px 15px;
  border-radius: 5px;
}
.admin-box .table-box .saleamt p {
  margin-bottom: 0;
  color: #535bd6;
  font-size: 13px;
  font-weight: 600;
}
.admin-box .table-box .filtericon {
  background-color: #535bd6;
  color: #fff;
  border-radius: 5px;
  padding: 5px;
}
.admin-box .table-box .datainfo {
  width: 100%;
  display: grid;
  grid: 20px/auto auto auto auto;
  grid-gap: 10px;
}
.admin-box .table-box .datainfo-list {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
}
.admin-box .table-box .datainfo-list span {
  width: 8px;
  height: 8px;
  border-radius: 100%;
}
.admin-box .table-box .datainfo-list.tt span {
  background-color: #535bd6;
}
.admin-box .table-box .datainfo-list.ctu span {
  background-color: #1188dd;
}
.admin-box .table-box .datainfo-list.ts span {
  background-color: #0e9451;
}
.admin-box .table-box .datainfo-list.trd span {
  background-color: #f7b924;
}
.admin-box .table-box .datainfo-list.bpa span {
  background-color: #d8092e;
}
.admin-box .table-box .datainfo-list.te span {
  background-color: #212121;
}
.admin-box .table-box .datainfo-list.tr span {
  background-color: #d423a5;
}
.admin-box .table-box .datainfo-list.tri span {
  background-color: #9953d6;
}
.admin-box .table-box .datainfo p {
  margin-bottom: 0;
  font-size: 13px;
  line-height: 14px;
}
.admin-box .table-box-bottom {
  width: 100%;
}
.admin-box .table-box-bottom .table {
  margin-bottom: 0;
}
.admin-box .table-box-bottom .table thead tr {
  background-color: #f6f6f6;
}
.admin-box .table-box-bottom .table thead tr th {
  color: #535bd6;
  font-weight: 500 !important;
  border-bottom: 1px solid #e6e6e6;
  padding: 10px;
}
.admin-box .table-box-bottom .table tbody tr td {
  padding: 0 10px;
}
.admin-box .table-box-bottom .table tbody tr:last-child td {
  border-bottom: 0px;
}
.admin-box .tableinner {
  overflow: hidden;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
}

.paypal {
  /* Rectangle 118 */
  width: 124.92px;
  height: 62px;
  background: #FAEACC;
  border-radius: 8px;
}

.dispute {
  color: #212121;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  color: #212121;
}
.dispute__body {
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  border-radius: 0.25rem;
  background: #ffffff;
}
.dispute__body hr {
  color: #000000;
  background-color: #000000;
  opacity: 0.05;
  margin: 1.5rem 0;
}
.dispute__info {
  overflow: hidden;
  color: #212121;
}
.dispute__info.buy-sell, .dispute__info.trade .bg-gray {
  background: rgba(228, 230, 232, 0.2);
}
.dispute__info.trade > .row > [class*=col-]:last-of-type {
  border-left: solid 1px rgba(228, 230, 232, 0.4);
}
.dispute__info.trade .block {
  border: solid 1px rgba(228, 230, 232, 0.4);
  border-radius: 6px;
}
.dispute__info span {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: inherit;
  color: #767676;
  margin-bottom: 0.25rem;
  display: block;
}
@media (min-width: 768px) {
  .dispute__info .col-custom-5 {
    width: 50%;
  }
}
@media (min-width: 992px) {
  .dispute__info .col-custom-5 {
    width: 33.3333333333%;
  }
}
@media (min-width: 1200px) {
  .dispute__info .col-custom-5 {
    width: 20%;
  }
}
.dispute__info .alert {
  border-color: #de9d00;
  font-size: 10px;
  line-height: 14px;
  font-weight: 700;
  color: #de9d00;
  padding: 3px 6px;
  margin: 0;
  text-transform: uppercase;
}
.dispute__info .timeline > div {
  position: relative;
  padding-left: 0.75rem;
  margin-bottom: 1.5rem;
}
@media (max-width: 767.98px) {
  .dispute__info .timeline > div:last-child {
    margin: 0;
  }
}
.dispute__info .timeline > div:last-child::before {
  display: none;
}
.dispute__info .timeline > div::before, .dispute__info .timeline > div:after {
  content: "";
  position: absolute;
  top: 0;
}
.dispute__info .timeline > div:before {
  width: 1px;
  height: calc(100% + 1.5rem);
  background: rgba(83, 91, 214, 0.4);
  left: 0;
}
.dispute__info .timeline > div:after {
  border: solid 1px #535bd6;
  background: #ffffff;
  width: calc(0.5rem + 1px);
  height: calc(0.5rem + 1px);
  border-radius: 50%;
  left: -0.25rem;
}
.dispute__info .timeline > div.completed:after {
  background: #535bd6;
}
.dispute .form-select {
  min-width: 16vw;
}
.dispute .buyer-seller-card {
  border-radius: 6px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: inherit;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dispute .buyer-seller-card .counter input {
  flex-grow: 1;
  padding: 0 0.25rem;
  background: none;
  border: none;
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  font-weight: 600;
  color: inherit;
  max-width: 2.5rem;
}
.dispute .buyer-seller-card .counter .btn {
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 0.25rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.2);
}
.dispute .buyer-seller-card .counter .btn:hover {
  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.6);
}
.dispute .buyer-seller-card .refund-buyer .block {
  position: relative;
}
.dispute .buyer-seller-card .refund-buyer .block:not(:first-child) {
  margin-top: 10px;
}
.dispute .buyer-seller-card .refund-buyer .block .option {
  background: #ffffff;
  border-radius: 6px;
  border: solid 1px #ffffff;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.2);
  transition: all 0.5s ease-in;
}
.dispute .buyer-seller-card .refund-buyer .block:hover .option {
  border-color: #535bd6;
}
.dispute .buyer-seller-card .refund-buyer .block [type=radio] {
  position: absolute;
  inset: 0;
  width: auto;
  height: auto;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}
.dispute .buyer-seller-card .refund-buyer .block [type=radio]:checked ~ .option {
  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.6);
  border-color: #535bd6;
  background-color: #535bd6;
  color: white;
}
.dispute .buyer-seller-card .refund-buyer .block .input {
  position: relative;
  z-index: 2;
}
.dispute .buyer-seller-card .refund-buyer .block .input input {
  padding-right: 52px;
}
.dispute .buyer-seller-card .refund-buyer .block .input:after {
  content: "EUR";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  text-transform: uppercase;
  color: #767676;
}
.dispute .buyer-seller-card .refund-buyer .no-block {
  position: relative;
}
.dispute .buyer-seller-card .refund-buyer .no-block:not(:first-child) {
  margin-top: 10px;
}
.dispute .buyer-seller-card .refund-buyer .no-block .option {
  background: #ffffff;
  border-radius: 6px;
  border: solid 1px #ffffff;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.2);
  transition: all 0.5s ease-in;
}
.dispute .buyer-seller-card .refund-buyer .no-block [type=radio] {
  position: absolute;
  inset: 0;
  width: auto;
  height: auto;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}
.dispute .buyer-seller-card .refund-buyer .no-block .input {
  position: relative;
  z-index: 2;
}
.dispute .buyer-seller-card .refund-buyer .no-block .input input {
  padding-right: 52px;
}
.dispute .buyer-seller-card .refund-buyer .no-block .input:after {
  content: "EUR";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  text-transform: uppercase;
  color: #767676;
}
.dispute .buyer-seller-card .footer {
  border: solid 1px rgba(230, 230, 230, 0.5);
  background: #ffffff;
  padding: 0.75rem 1.25rem 1rem;
  border-radius: 0 0 6px 6px;
  margin-top: auto;
}
.dispute .attachments {
  height: 4rem;
  width: 5.5rem;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}
.dispute .attachments:after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(33, 33, 33, 0.7);
}
.dispute .attachments img {
  width: 100%;
  height: 100%;
}
.dispute .attachments > span {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: #ffffff;
  position: absolute;
  inset: 0;
  z-index: 1;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dispute .past-comments {
  border: solid 1px #e6e6e6;
  border-radius: 6px;
  padding: 1rem;
}
.dispute .past-comments .blocks {
  overflow-x: hidden;
  overflow-y: auto;
  height: 25rem;
}
.dispute .past-comments .blocks::-webkit-scrollbar {
  width: 0.25rem;
}
.dispute .past-comments .blocks::-webkit-scrollbar-track {
  box-shadow: none;
  border-radius: 0;
  background: none;
}
.dispute .past-comments .blocks::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  border-radius: 10px;
}
.dispute .past-comments .blocks .block {
  background: rgba(234, 237, 239, 0.7);
  border-radius: 8px;
  padding: 10px 14px;
}
.dispute .past-comments .blocks .block:not(:first-child) {
  margin-top: 0.5rem;
}
.dispute .past-comments .blocks .block p {
  color: #767676;
  margin-bottom: 0.5rem;
}
.dispute .past-comments .blocks .block > span {
  display: block;
  font-size: 11px;
  line-height: 15px;
  font-weight: 400;
  color: #535bd6;
  text-align: right;
}
.dispute .past-comments .blocks .block2 {
  background: rgba(17, 136, 221, 0.7);
  border-radius: 8px;
  padding: 10px 14px;
}
.dispute .past-comments .blocks .block2:not(:first-child) {
  margin-top: 0.5rem;
}
.dispute .past-comments .blocks .block2 p {
  color: #212121;
  margin-bottom: 0.5rem;
}
.dispute .past-comments .blocks .block2 > span {
  display: block;
  font-size: 11px;
  line-height: 15px;
  font-weight: 400;
  color: #535bd6;
  text-align: right;
}
.dispute .chatbot {
  border: solid 1px #e6e6e6;
  border-radius: 6px;
}
.dispute .chatbot__header {
  border-bottom: solid 1px #e6e6e6;
  border-radius: 6px 6px 0 0;
  padding: 0.75rem 0.875rem;
  background: #f5f6fd;
}
.dispute .chatbot__body {
  padding: 0.75rem 1rem 1rem;
  padding-right: 0;
}
.dispute .chatbot__body .date {
  display: block;
  text-align: center;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  color: inherit;
  margin-bottom: 0.75rem;
}
.dispute .chatbot__footer {
  border-top: solid 1px #e6e6e6;
  border-radius: 0 0 6px 6px;
  padding: 0.75rem 0.75rem 0.625rem;
  display: flex;
  align-items: center;
}
.dispute .chatbot__footer input {
  flex-grow: 1;
  padding: 0;
  margin: 0;
  margin-right: 1rem;
  height: 34px;
  line-height: 34px;
  color: #212121;
  background: none;
  border: none;
  box-shadow: none;
  outline: none;
  width: calc(100% - 50px);
}
.dispute .chatbot__footer input::placeholder {
  color: #767676;
  opacity: 1;
}
.dispute .chatbot__footer button {
  flex-shrink: 0;
  background: #e7f5ff;
  border: none;
  box-shadow: none;
  outline: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.dispute .chatbot__footer button:hover {
  background: rgb(205.5, 234.375, 255);
}
.dispute .chatbot .chats {
  height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  justify-content: flex-end;
}
.dispute .chatbot .chats .inner {
  display: flex;
  flex-direction: column;
  padding-right: 1rem;
}
.dispute .chatbot .chats::-webkit-scrollbar {
  width: 0.25rem;
}
.dispute .chatbot .chats::-webkit-scrollbar-track {
  box-shadow: none;
  border-radius: 0;
  background: none;
}
.dispute .chatbot .chats::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  border-radius: 10px;
}
.dispute .chatbot .chat {
  max-width: 75%;
}
.dispute .chatbot .chat:not(:first-child) {
  margin-top: 0.75rem;
}
.dispute .chatbot .chat.user {
  display: flex;
  align-items: flex-start;
  max-width: calc(75% + 30px);
  margin: 5px 0px;
}
.dispute .chatbot .chat.user .avatar {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 30px;
  font-weight: 500;
  color: rgba(33, 33, 33, 0.5);
  margin-right: 6px;
  background: #eaedef;
  flex-shrink: 0;
  text-align: center;
  overflow: hidden;
  padding: 0 0.25rem;
}
.dispute .chatbot .chat.user > div {
  flex-grow: 1;
  border: solid 1px rgba(234, 237, 239, 0.7);
  background: rgba(234, 237, 239, 0.7);
  border-radius: 0.5rem;
  padding: 10px 14px;
  border-radius: 0.5rem;
}
.dispute .chatbot .chat.self {
  border: solid 1px rgba(0, 0, 0, 0.14);
  background: #ffffff;
  align-self: flex-end;
  padding: 10px 14px;
  border-radius: 0.5rem;
  margin: 5px 0px;
}
.dispute .chatbot .chat p {
  margin-bottom: 3px;
}
.dispute .chatbot .chat .time {
  display: block;
  font-size: 11px;
  line-height: 15px;
  font-weight: 400;
  color: #535bd6;
  text-align: right;
}
.dispute .chatbot .user + .user,
.dispute .chatbot .self + .self {
  margin-top: 0.375rem;
  margin: 5px 0px;
}
.dispute .tooltip--custom {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + 1rem);
  min-width: 15rem;
  max-width: calc(100vw - 2rem);
  background: #ffffff;
  border: solid 1px #535bd6;
  border-radius: 0.25rem;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.07));
  padding: 0.375rem 0.5rem;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #212121;
  text-align: center;
  z-index: 1;
}
.dispute .tooltip--custom::before, .dispute .tooltip--custom:after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
}
.dispute .tooltip--custom::before {
  bottom: -0.75rem;
  border-left: 0.75rem solid transparent;
  border-right: 0.75rem solid transparent;
  border-top: 0.75rem solid #535bd6;
}
.dispute .tooltip--custom::after {
  bottom: -0.625rem;
  border-left: 0.625rem solid transparent;
  border-right: 0.625rem solid transparent;
  border-top: 0.625rem solid #ffffff;
  z-index: 1;
}
.dispute .tooltip--custom p {
  margin: 0;
}
.dispute .tooltip--custom p > strong {
  color: #535bd6;
  font-weight: 600;
}
.dispute .tooltip--custom.warning {
  border-color: #ffd1d1;
}
.dispute .tooltip--custom.warning::before {
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: #ffd1d1;
}
.dispute .tooltip--custom.warning::after {
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: #ffffff;
}
.dispute .tooltip--custom.warning p > strong {
  color: #d35d5f;
}

/* Base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.voucher-generator {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #333;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Header styles */
.header {
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  font-size: 1.25rem;
  font-weight: 600;
  margin-right: 24px;
}

.nav-menu {
  display: none;
}

.nav-link {
  color: #666;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 8px 12px;
  margin: 0 8px;
  position: relative;
}

.nav-link:hover {
  color: #333;
}

.nav-link.active {
  color: #2563eb;
  border-bottom: 2px solid #2563eb;
}

.header-right {
  display: flex;
  align-items: center;
}

.notification-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  margin-right: 12px;
}

.avatar-container {
  position: relative;
}

.avatar-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e5e5e5;
}

/* Main content styles */
.main-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.page-subtitle {
  color: #666;
}

.export-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  margin-top: 12px;
}

.export-btn:hover {
  background-color: #f5f5f5;
}

.icon {
  width: 16px;
  height: 16px;
}

/* Stats cards */
.stats-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  gap: 16px;
  margin-bottom: 24px;
}

.card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.card-title {
  font-size: 1.125rem;
  font-weight: 500;
}

.card-content {
  padding: 16px;
}

.card-content.no-padding {
  padding: 0;
}

.stat-value {
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.total-vouchers {
  color: #2563eb;
}

.active-vouchers {
  color: #10b981;
}

.redeemed-value {
  color: #8b5cf6;
}

.stat-label {
  font-size: 0.875rem;
  color: #666;
}

/* Main grid layout */
.main-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  gap: 24px;
}

/* Form styles */
.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 8px;
}

.form-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: #f9fafb;
  font-size: 0.875rem;
}

.form-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

.form-hint {
  font-size: 0.75rem;
  color: #666;
  margin-top: 4px;
}

.generate-btn {
  width: 100%;
  padding: 10px;
  background-color: #2563eb;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.generate-btn:hover {
  background-color: #1d4ed8;
}

.generate-btn:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}

/* Tabs */
.tabs {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 16px;
}

.tab-button {
  padding: 12px 16px;
  background: none;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.tab-button.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}

/* Table styles */
.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e5e5e5;
}

.table th {
  background-color: #f9fafb;
  font-size: 0.75rem;
  font-weight: 600;
  color: #4b5563;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.table tr:last-child td {
  border-bottom: none;
}

.monospace {
  font-family: "Courier New", Courier, monospace;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.badge-active {
  background-color: #d1fae5;
  color: #065f46;
}

.badge-redeemed {
  background-color: #dbeafe;
  color: #1e40af;
}

.badge-expired {
  background-color: #f3f4f6;
  color: #4b5563;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.empty-icon {
  width: 48px;
  height: 48px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.empty-title {
  font-size: 1.125rem;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
}

.empty-description {
  font-size: 0.875rem;
  color: #6b7280;
  max-width: 20rem;
  margin: 0 auto;
}

/* Action buttons */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 16px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  color: #333;
  cursor: pointer;
}

.action-btn:hover {
  background-color: #f5f5f5;
}

/* Loading spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* Toast notification */
.toast-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.toast {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 16px;
  min-width: 300px;
  max-width: 400px;
  animation: slideIn 0.3s ease-out forwards;
}

.toast-header {
  font-weight: 600;
  margin-bottom: 4px;
}

.toast-body {
  font-size: 0.875rem;
  color: #6b7280;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
/* Responsive styles */
@media (min-width: 768px) {
  .nav-menu {
    display: flex;
  }
  .stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .main-grid {
    grid-template-columns: 1fr 2fr;
  }
  .export-btn {
    margin-top: 0;
  }
}
.listContainer {
  max-width: 1800px;
  min-width: 1600px;
  margin: 0 auto;
  padding: 20px;
}

.listHeader {
  margin-bottom: 30px;
}

.listHeader h1, .listHeader .h1 {
  font-size: 24px;
  color: #333;
  margin: 0 0 10px 0;
}

.listHeader p {
  color: #666;
  margin: 0;
}

.controlsContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 15px;
}

.searchContainer {
  flex: 1 1;
  min-width: 300px;
}

.searchInput {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.filtersContainer {
  display: flex;
  gap: 15px;
}

.filterGroup {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filterGroup label {
  font-size: 14px;
  color: #555;
}

.filterGroup select {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.tableContainer {
  overflow-x: auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.usersTable {
  width: 100%;
  border-collapse: collapse;
}

.usersTable th,
.usersTable td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.usersTable th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.sortableHeader {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.sortableHeader:hover {
  background-color: #f1f3f5;
}

.sortIcon {
  display: inline-block;
  margin-left: 5px;
}

.userRow {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.userRow:hover {
  background-color: #f8f9fa;
}

.statusBadge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  min-width: 80px;
}

.pending {
  background-color: #fff3cd;
  color: #856404;
}

.approved {
  background-color: #d4edda;
  color: #155724;
}

.rejected {
  background-color: #f8d7da;
  color: #721c24;
}

.typeLabel {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.individualType {
  background-color: #e2f0fd;
  color: #0c63e4;
}

.businessType {
  background-color: #e6e6fa;
  color: #6f42c1;
}

.viewButton {
  background-color: #2c6ecf;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.viewButton:hover {
  background-color: #1e5bb0;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 15px;
}

.paginationButton {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.paginationButton:hover:not(:disabled) {
  background-color: #e9ecef;
}

.paginationButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pageInfo {
  font-size: 14px;
  color: #666;
}

.resultsInfo {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.noResults {
  text-align: center;
  padding: 30px;
  color: #666;
}

/* Responsive styles */
@media (max-width: 768px) {
  .controlsContainer {
    flex-direction: column;
  }
  .searchContainer {
    min-width: 100%;
  }
  .filtersContainer {
    width: 100%;
    justify-content: space-between;
  }
  .usersTable th:nth-child(3),
  .usersTable td:nth-child(3) {
    display: none;
  }
}
@media (max-width: 576px) {
  .usersTable th:nth-child(4),
  .usersTable td:nth-child(4) {
    display: none;
  }
}
.reviewPanel {
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.panelHeader {
  background-color: #f8f9fa;
  padding: 20px 30px;
  border-bottom: 1px solid #e9ecef;
  position: relative;
}

.headerActions {
  margin-bottom: 15px;
}

.backButton {
  background: none;
  border: none;
  color: #2c6ecf;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  display: flex;
  align-items: center;
}

.backButton:hover {
  text-decoration: underline;
}

.panelHeader h1, .panelHeader .h1 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.submissionMeta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}

.submissionId {
  font-weight: 600;
}

.submissionStatus {
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 600;
}

.submissionStatus.pending {
  background-color: #fff3cd;
  color: #856404;
}

.submissionStatus.approved {
  background-color: #d4edda;
  color: #155724;
}

.submissionStatus.rejected {
  background-color: #f8d7da;
  color: #721c24;
}

.reviewContent {
  padding: 30px;
}

.infoSection {
  margin-bottom: 30px;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
}

.infoSection h2, .infoSection .h2 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}

.infoGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 20px;
  gap: 20px;
}

.infoItem {
  margin-bottom: 15px;
}

.infoItem label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.infoItem div {
  font-size: 16px;
  color: #333;
  padding: 8px 0;
  overflow-wrap: break-word;
}

.documentsSection {
  margin-bottom: 30px;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
}

.documentsSection h2, .documentsSection .h2 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}

.documentsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
  gap: 20px;
}

.documentItem {
  cursor: pointer;
  transition: transform 0.2s ease;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.documentItem:hover {
  transform: translateY(-5px);
}

.documentThumbnail {
  height: 150px;
  overflow: hidden;
  background-color: #eee;
}

.documentThumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.documentLabel {
  padding: 10px;
  text-align: center;
  font-size: 14px;
  background-color: #fff;
  border-top: 1px solid #eee;
}

.verificationSection {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
}

.verificationSection h2, .verificationSection .h2 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}

.notesTextarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
  resize: vertical;
}

.actionButtons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.approveButton,
.rejectButton,
.confirmRejectButton,
.cancelButton {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.approveButton {
  background-color: #28a745;
  color: white;
}

.approveButton:hover {
  background-color: #218838;
}

.rejectButton {
  background-color: #dc3545;
  color: white;
}

.rejectButton:hover {
  background-color: #c82333;
}

.confirmRejectButton {
  background-color: #dc3545;
  color: white;
}

.confirmRejectButton:hover {
  background-color: #c82333;
}

.cancelButton {
  background-color: #6c757d;
  color: white;
}

.cancelButton:hover {
  background-color: #5a6268;
}

.statusMessage {
  padding: 15px;
  border-radius: 4px;
  font-weight: 500;
  text-align: center;
}

.approvedMessage {
  background-color: #d4edda;
  color: #155724;
  padding: 10px;
  border-radius: 4px;
}

.rejectedMessage {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
}

.documentViewer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.documentViewerContent {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.documentViewerHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.documentViewerHeader h3, .documentViewerHeader .h3 {
  margin: 0;
  font-size: 18px;
}

.closeButton {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.documentViewerImage {
  padding: 20px;
  overflow: auto;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.documentViewerImage img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.rejectionModal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.rejectionModalContent {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  padding: 25px;
}

.rejectionModalContent h3, .rejectionModalContent .h3 {
  margin-top: 0;
  color: #333;
}

.rejectionTextarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 15px 0;
  font-size: 14px;
  resize: vertical;
}

.rejectionModalButtons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 18px;
  color: #666;
}

/* Responsive styles */
@media (max-width: 768px) {
  .panelHeader {
    padding: 15px 20px;
  }
  .reviewContent {
    padding: 20px;
  }
  .infoGrid {
    grid-template-columns: 1fr;
  }
  .documentsGrid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
  .actionButtons {
    flex-direction: column;
  }
  .approveButton,
  .rejectButton {
    width: 100%;
  }
}
/* Admin Panel Styles */
.admin-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.admin-header h1, .admin-header .h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.admin-header p {
  font-size: 14px;
  color: #666;
  margin: 4px 0 0 0;
}

/* Stats Cards */
.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 16px;
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background-color: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-card h2, .stat-card .h2 {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 4px;
}

.stat-description {
  font-size: 14px;
  color: #666;
}

/* Content Container */
.content-container {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  grid-gap: 24px;
  gap: 24px;
}

/* Tabs */
.tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 16px;
}

.tabs button {
  padding: 12px 16px;
  background: none;
  border: none;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  position: relative;
}

.tabs button.tab-active {
  color: #4f46e5;
  font-weight: 500;
}

.tabs button.tab-active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #4f46e5;
}

/* Bug List */
.bug-list-container,
.bug-detail-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.bug-list {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db #f3f4f6;
}

.bug-list::-webkit-scrollbar {
  width: 8px;
}

.bug-list::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 4px;
}

.bug-list::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}

.bug-list-item {
  padding: 16px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.bug-list-item:hover {
  background-color: #f9f9f9;
}

.bug-list-item.selected {
  background-color: #f0f7ff;
  border-left: 3px solid #4f46e5;
}

.bug-list-item-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.bug-type {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.bug-severity {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.bug-severity.critical {
  background-color: #fee2e2;
  color: #b91c1c;
}

.bug-severity.high {
  background-color: #ffedd5;
  color: #c2410c;
}

.bug-severity.medium {
  background-color: #fef3c7;
  color: #92400e;
}

.bug-severity.low {
  background-color: #ecfdf5;
  color: #047857;
}

.bug-details-preview {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
}

.bug-list-item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.bug-reporter {
  display: flex;
  flex-direction: column;
}

.username {
  font-weight: 500;
  color: #333;
}

.email {
  color: #666;
}

.bug-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
}

.attachment-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Bug List Empty State */
.empty-bug-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #666;
  text-align: center;
}

.empty-bug-list svg {
  color: #ccc;
  margin-bottom: 16px;
}

.empty-bug-list h3, .empty-bug-list .h3 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 8px 0;
}

.empty-bug-list p {
  font-size: 14px;
  margin: 0;
}

/* Bug Detail */
.bug-detail {
  padding: 24px;
}

.bug-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.bug-detail-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bug-detail-title h2, .bug-detail-title .h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.status-badge {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.status-badge.open {
  background-color: #fee2e2;
  color: #b91c1c;
}

.status-badge.resolved {
  background-color: #ecfdf5;
  color: #047857;
}

.bug-actions {
  display: flex;
  gap: 8px;
}

.status-select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.action-button {
  background-color: #4f46e5;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.action-button:hover {
  background-color: #4338ca;
}

.bug-detail-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.bug-detail-section {
  border-bottom: 1px solid #eee;
  padding-bottom: 24px;
}

.bug-detail-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.bug-detail-section h3, .bug-detail-section .h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #333;
}

.detail-row {
  display: flex;
  margin-bottom: 8px;
}

.detail-label {
  width: 120px;
  font-weight: 500;
  color: #666;
  font-size: 14px;
}

.detail-value {
  font-size: 14px;
  color: #333;
}

.severity-indicator {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.severity-indicator.critical {
  background-color: #ef4444;
}

.severity-indicator.high {
  background-color: #f59e0b;
}

.severity-indicator.medium {
  background-color: #f59e0b;
}

.severity-indicator.low {
  background-color: #10b981;
}

.detail-text {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.attachments-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 16px;
  gap: 16px;
}

.attachment-item {
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.attachment-preview {
  height: 150px;
  overflow: hidden;
}

.attachment-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.attachment-info {
  padding: 8px;
}

.attachment-name {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 4px;
  word-break: break-all;
}

.download-link {
  font-size: 12px;
  color: #4f46e5;
  text-decoration: none;
}

.download-link:hover {
  text-decoration: underline;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #666;
  text-align: center;
  height: 100%;
}

.empty-state svg {
  color: #ccc;
  margin-bottom: 16px;
}

.empty-state h3, .empty-state .h3 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 8px 0;
}

.empty-state p {
  font-size: 14px;
  margin: 0;
}

/* Status Colors */
.bug-list-item.open {
  border-left: 3px solid #ef4444;
}

.bug-list-item.resolved {
  border-left: 3px solid #10b981;
}

/* Scrollbar Styles */
[role=dialog] > div {
  scrollbar-width: thin;
  scrollbar-color: #4b5563 #1f2937;
}

[role=dialog] > div::-webkit-scrollbar {
  width: 8px;
}

[role=dialog] > div::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

[role=dialog] > div::-webkit-scrollbar-thumb {
  background-color: #4b5563;
  border-radius: 4px;
}

/* Responsive */
@media (max-width: 768px) {
  .content-container {
    grid-template-columns: 1fr;
  }
  .bug-list {
    max-height: 300px;
  }
}
/* Responsive adjustments */
@media (max-height: 700px) {
  .stats-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .stat-card {
    padding: 12px;
  }
  .stat-value {
    font-size: 28px;
  }
  .content-container {
    gap: 16px;
  }
}
@media (max-height: 600px) {
  .admin-container {
    padding: 16px;
  }
  .admin-header {
    margin-bottom: 16px;
  }
  .stats-container {
    margin-bottom: 16px;
  }
}
.opacity-01 {
  opacity: 0.01 !important;
}

.opacity-02 {
  opacity: 0.02 !important;
}

.opacity-03 {
  opacity: 0.03 !important;
}

.opacity-04 {
  opacity: 0.04 !important;
}

.opacity-05 {
  opacity: 0.05 !important;
}

.opacity-06 {
  opacity: 0.06 !important;
}

.opacity-07 {
  opacity: 0.07 !important;
}

.opacity-08 {
  opacity: 0.08 !important;
}

.opacity-09 {
  opacity: 0.09 !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.filter-grayscale-5 {
  filter: grayscale(5%) !important;
}

.filter-grayscale-10 {
  filter: grayscale(10%) !important;
}

.filter-grayscale-20 {
  filter: grayscale(20%) !important;
}

.filter-grayscale-30 {
  filter: grayscale(30%) !important;
}

.filter-grayscale-40 {
  filter: grayscale(40%) !important;
}

.filter-grayscale-50 {
  filter: grayscale(50%) !important;
}

.filter-grayscale-80 {
  filter: grayscale(80%) !important;
}

.filter-grayscale-100 {
  filter: grayscale(100%) !important;
}

.br-tl {
  border-top-left-radius: 0.25rem !important;
}

.br-tr {
  border-top-right-radius: 0.25rem !important;
}

.br-bl {
  border-bottom-left-radius: 0.25rem !important;
}

.br-br {
  border-bottom-right-radius: 0.25rem !important;
}

.b-radius-0 {
  border-radius: 0 !important;
}

.rm-border {
  border-width: 0 !important;
}

.br-a {
  border-radius: 0.25rem;
}

.margin-h-center {
  margin-left: auto !important;
  margin-right: auto !important;
}

.center-svg {
  margin: 0 auto;
}
.center-svg svg {
  margin: 0 auto;
}

.apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-donut {
  display: flex;
  align-items: center;
  align-content: center;
}

.alert-dismissible .close {
  top: 0;
  right: 5px;
  padding: 5px;
}

.icon-gradient {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.font-size-xlg {
  font-size: 1.3rem !important;
}

.font-size-md {
  font-size: 0.9rem !important;
}

.font-size-lg {
  font-size: 1.1rem !important;
}

.no-shadow {
  box-shadow: 0 0 0 transparent !important;
}

.h-100 {
  height: 100vh !important;
}

.he-auto {
  height: auto !important;
}

.he-100 {
  height: 100%;
}

.h-sm {
  height: 150px;
}

.text-nowrap {
  white-space: nowrap;
}

.fsize-1 {
  font-size: 0.95rem !important;
}

.fsize-2 {
  font-size: 1.3rem !important;
}

.fsize-3 {
  font-size: 1.6rem !important;
}

.fsize-4 {
  font-size: 2rem !important;
}

.z-index-6 {
  z-index: 6;
}

.line-height-1 {
  line-height: 1;
}

.center-elem {
  display: flex;
  align-items: center;
  align-content: center;
}

.flex2 {
  flex: 2 1;
}

.divider {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  overflow: hidden;
  background: #e9ecef;
}

.list-group-item:hover {
  z-index: auto;
  z-index: initial;
}

.no-results {
  padding: 1.5rem;
  text-align: center;
}
.no-results .results-title {
  color: #495057;
  font-size: 1.1rem;
}
.no-results .results-subtitle {
  color: #adb5bd;
  font-size: 1.1rem;
}

.bg-animation {
  animation: bg-pan-left 8s both;
}
@keyframes bg-pan-left {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.w-100 {
  width: 100%;
}

.mb--2 {
  margin-bottom: -1.5rem;
}

.mbg-3 {
  margin-bottom: 1.5rem;
}

.loader-container {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
  text-align: center;
  line-height: 1.6rem;
}
.loader-container .loader-container-inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 1.5rem;
}
.loader-container small, .loader-container .small {
  margin: 10px 0 0;
  display: block;
  color: #6c757d;
  font-weight: normal;
}
.loader-container h3, .loader-container .h3 {
  text-align: center;
  display: block;
}

.btn-info, .btn-success {
  color: #fff !important;
}

.bg-warning {
  color: #212529;
}

.list-group-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.btn-link, a {
  text-decoration: none !important;
}

.bg-light {
  color: #212529;
}

.table {
  --bs-table-accent-bg: none;
}

.form-check-input-custom {
  width: 1rem;
  height: 1rem;
}

.bg-warm-flame {
  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;
}

.bg-night-fade {
  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;
}

.bg-sunny-morning {
  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;
}

.bg-tempting-azure {
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;
}

.bg-amy-crisp {
  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;
}

.bg-heavy-rain {
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;
}

.bg-mean-fruit {
  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;
}

.bg-malibu-beach {
  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;
}

.bg-deep-blue {
  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;
}

.bg-ripe-malin {
  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;
}

.bg-arielle-smile {
  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;
}

.bg-plum-plate {
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.bg-happy-fisher {
  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;
}

.bg-happy-itmeo {
  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;
}

.bg-mixed-hopes {
  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;
}

.bg-strong-bliss {
  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;
}

.bg-grow-early {
  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;
}

.bg-love-kiss {
  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;
}

.bg-premium-dark {
  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;
}

.bg-happy-green {
  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;
}

.bg-vicious-stance {
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;
}

.bg-midnight-bloom {
  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;
}

.bg-night-sky {
  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;
}

.bg-slick-carbon {
  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;
  background-blend-mode: multiply;
}

.bg-royal {
  background-image: linear-gradient(to right, #141e30, #243b55) !important;
}

.bg-asteroid {
  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;
}

.bg-transparent {
  background: transparent !important;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT
Copyright (c) 2015 Daniel Eden
*/
body {
  -webkit-backface-visibility: hidden;
}

.animated, .TabsAnimation-appear {
  animation-duration: calc(1s);
  animation-fill-mode: both;
}
.animated.infinite, .infinite.TabsAnimation-appear {
  animation-iteration-count: infinite;
}
.animated.hinge, .hinge.TabsAnimation-appear {
  animation-duration: calc(1s * 2);
}
.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInUp, .TabsAnimation-appear {
  animation-name: fadeInUp;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes lightSpeedIn {
  0% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: translateX(-20%) skewX(30deg);
    opacity: 1;
  }
  80% {
    transform: translateX(0%) skewX(-15deg);
    opacity: 1;
  }
  100% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
}
.lightSpeedIn {
  animation-name: lightSpeedIn;
  animation-timing-function: ease-out;
}
@keyframes lightSpeedOut {
  0% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
  100% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
}
.lightSpeedOut {
  animation-name: lightSpeedOut;
  animation-timing-function: ease-in;
}

.dropdown-menu.show {
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.popover.show {
  display: block;
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.dropdown-menu[data-placement^=top].show {
  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  bottom: auto !important;
  top: auto !important;
}

@keyframes fade-in2 {
  0% {
    margin-top: -50px;
    visibility: hidden;
    opacity: 0;
  }
  100% {
    margin-top: 0px;
    visibility: visible;
    opacity: 1;
  }
}
.form-control {
  transition: all 0.2s;
}

.btn-outline-2x {
  border-width: 2px;
}

.btn-group .btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn-group .btn-outline-2x + .btn-outline-2x {
  margin-left: -2px;
}
.btn-group .btn-square {
  border-radius: 0;
}

.btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn.btn-pill.btn-wide, .btn.btn-pill {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-dashed {
  border-style: dashed;
}

.btn-icon {
  vertical-align: bottom;
}
.btn-icon.btn-icon-right .btn-icon-wrapper {
  margin-left: 0.5rem;
  margin-right: 0;
}
.btn-icon .btn-icon-wrapper {
  margin-right: 0.5rem;
  margin-left: 0;
  margin-top: 0;
  font-size: 17px;
  vertical-align: middle;
  transition: color 0.1s;
  display: inline-block;
}
.btn-icon.btn-link {
  text-decoration: none;
}
.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}

.btn-icon-only .btn-icon-wrapper {
  margin-left: 0;
  margin-right: 0;
}

.btn-hover-shine {
  position: relative;
}
.btn-hover-shine:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  transition: none;
}
.btn-hover-shine:hover:after {
  width: 120%;
  background-color: rgba(255, 255, 255, 0);
  transition: all 0.4s ease-in-out;
}
.btn-hover-shine.btn-pill::after {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-icon-vertical {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.btn-icon-vertical .btn-icon-wrapper {
  display: block;
  font-size: 200%;
  margin: 5px 0;
  opacity: 0.6;
}
.btn-icon-vertical.btn-link {
  text-decoration: none;
}
.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}
.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {
  opacity: 1;
}
.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {
  margin: 0.2rem 0 5px;
}
.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {
  transition: all 0.2s !important;
}
.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {
  transform: scale(1.3);
}
.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {
  color: #fff !important;
}

.btn-icon-lg {
  font-size: 2.2rem !important;
}

.btn-transition {
  color: #6c757d;
  border-color: #e9ecef;
  background-color: none;
}
.btn-transition.btn-outline-link {
  border-color: transparent;
  background-color: transparent;
}
.btn-transition.btn-outline-link:hover {
  color: #545cd8;
  background: #f8f9fa;
}
.btn-transition.disabled, .btn-transition:disabled {
  color: #6c757d;
  border-color: #e9ecef;
}
.btn-transition:hover .btn-icon-wrapper {
  transition: none;
}

.btn-transition-alt:hover .icon-gradient {
  -webkit-background-clip: initial;
  -webkit-text-fill-color: initial;
  background-clip: border-box;
  background-clip: initial;
  text-fill-color: initial;
  background: none !important;
  color: #fff;
}

.btn-square {
  border-radius: 0 !important;
}

.active-btn {
  border: 1px solid rgb(212, 212, 212);
  border-radius: 1rem;
  padding: 1em;
  background-color: rgb(241, 241, 241);
  box-shadow: 1px solid black;
}

.inactive-btn {
  border: 1px solid rgb(212, 212, 212);
  border-radius: 1rem;
  padding: 1em;
  background-color: inherit;
  box-shadow: 1px solid black;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner {
  width: 20px;
  height: 20px;
  background-color: none;
  animation: spin 1s linear infinite;
}

.btn.btn-wide {
  padding: 0.375rem 1.5rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
}

.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {
  padding: 0.5rem 2rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}

.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {
  padding: 0.25rem 1rem;
  font-size: 0.8rem;
  border-radius: 0.2rem;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 1px;
}

.btn-gradient-primary {
  background-image: linear-gradient(140deg, rgb(41.5071428571, 50.0214285714, 181.9928571429) -30%, #545cd8 90%);
  background-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));
}
.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(38.6657142857, 46.5971428571, 169.5342857143) 0%, rgb(71.5414285714, 80.1242857143, 213.1585714286) 100%);
  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));
  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);
}
.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {
  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143)) !important;
  border-color: rgb(36.7714285714, 44.3142857143, 161.2285714286) !important;
}
.btn-gradient-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-gradient-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-gradient-secondary {
  background-image: linear-gradient(140deg, rgb(72.5407725322, 78.5858369099, 83.9592274678) -30%, #6c757d 90%);
  background-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);
  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);
  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));
}
.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(65.4489270386, 70.9030042918, 75.7510729614) 0%, rgb(100.9081545064, 109.317167382, 116.7918454936) 100%);
  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));
  border-color: rgb(48.9012875536, 52.9763948498, 56.5987124464);
}
.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {
  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464)) !important;
  border-color: rgb(60.7210300429, 65.7811158798, 70.2789699571) !important;
}
.btn-gradient-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-gradient-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-gradient-success {
  background-image: linear-gradient(140deg, rgb(40.531496063, 136.968503937, 87.3523622047) -30%, #3ac47d 90%);
  background-color: rgb(40.531496063, 136.968503937, 87.3523622047);
  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);
  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));
}
.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(37.0377952756, 125.1622047244, 79.8228346457) 0%, rgb(54.5062992126, 184.1937007874, 117.4704724409) 100%);
  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));
  border-color: rgb(28.8858267717, 97.6141732283, 62.2539370079);
}
.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {
  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079)) !important;
  border-color: rgb(34.7086614173, 117.2913385827, 74.8031496063) !important;
}
.btn-gradient-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-gradient-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-gradient-info {
  background-image: linear-gradient(140deg, rgb(0, 141.152173913, 226.5) -30%, #30b1ff 90%);
  background-color: rgb(0, 141.152173913, 226.5);
  border-color: rgb(0, 141.152173913, 226.5);
  color: color-yiq(rgb(0, 109.3695652174, 175.5));
}
.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(0, 131.6173913043, 211.2) 0%, rgb(32.7, 171.2347826087, 255) 100%);
  color: color-yiq(rgb(0, 109.3695652174, 175.5));
  border-color: rgb(0, 109.3695652174, 175.5);
}
.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {
  color: color-yiq(rgb(0, 109.3695652174, 175.5)) !important;
  border-color: rgb(0, 125.2608695652, 201) !important;
}
.btn-gradient-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-gradient-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-gradient-warning {
  background-image: linear-gradient(140deg, rgb(199.2224669604, 142.8215859031, 7.2775330396) -30%, #f7b924 90%);
  background-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);
  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);
  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));
}
.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(184.4616740088, 132.2396475771, 6.7383259912) 0%, rgb(246.4607929515, 180.281938326, 21.2392070485) 100%);
  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));
  border-color: rgb(150.0198237885, 107.5484581498, 5.4801762115);
}
.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {
  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115)) !important;
  border-color: rgb(174.6211453744, 125.1850220264, 6.3788546256) !important;
}
.btn-gradient-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-gradient-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-gradient-danger {
  background-image: linear-gradient(140deg, rgb(151.6437007874, 25.8562992126, 55.905511811) -30%, #d92550 90%);
  background-color: rgb(151.6437007874, 25.8562992126, 55.905511811);
  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);
  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));
}
.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(138.5724409449, 23.6275590551, 51.0866141732) 0%, rgb(203.9287401575, 34.7712598425, 75.1811023622) 100%);
  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));
  border-color: rgb(108.0728346457, 18.4271653543, 39.842519685);
}
.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {
  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685)) !important;
  border-color: rgb(129.8582677165, 22.1417322835, 47.874015748) !important;
}
.btn-gradient-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-gradient-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-gradient-focus {
  background-image: linear-gradient(140deg, rgb(32.8513513514, 30.9189189189, 40.5810810811) -30%, #444054 90%);
  background-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);
  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);
  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));
}
.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(25.8216216216, 24.3027027027, 31.8972972973) 0%, rgb(60.9702702703, 57.3837837838, 75.3162162162) 100%);
  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));
  border-color: rgb(9.4189189189, 8.8648648649, 11.6351351351);
}
.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {
  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351)) !important;
  border-color: rgb(21.1351351351, 19.8918918919, 26.1081081081) !important;
}
.btn-gradient-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-gradient-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-gradient-alternate {
  background-image: linear-gradient(140deg, rgb(86.657079646, 58.2123893805, 91.2876106195) -30%, #83588a 90%);
  background-color: rgb(86.657079646, 58.2123893805, 91.2876106195);
  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);
  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));
}
.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(77.7884955752, 52.2548672566, 81.9451327434) 0%, rgb(122.1314159292, 82.0424778761, 128.6575221239) 100%);
  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));
  border-color: rgb(57.0951327434, 38.3539823009, 60.1460176991);
}
.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {
  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991)) !important;
  border-color: rgb(71.8761061947, 48.2831858407, 75.7168141593) !important;
}
.btn-gradient-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-gradient-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-gradient-light {
  background-image: linear-gradient(140deg, rgb(199.75, 199.75, 199.75) -30%, #eeeeee 90%);
  background-color: rgb(199.75, 199.75, 199.75);
  border-color: rgb(199.75, 199.75, 199.75);
  color: color-yiq(rgb(174.25, 174.25, 174.25));
}
.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(192.1, 192.1, 192.1) 0%, rgb(230.35, 230.35, 230.35) 100%);
  color: color-yiq(rgb(174.25, 174.25, 174.25));
  border-color: rgb(174.25, 174.25, 174.25);
}
.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {
  color: color-yiq(rgb(174.25, 174.25, 174.25)) !important;
  border-color: #bbbbbb !important;
}
.btn-gradient-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-gradient-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-gradient-dark {
  background-image: linear-gradient(140deg, rgb(17.7068965517, 19.75, 21.7931034483) -30%, #343a40 90%);
  background-color: rgb(17.7068965517, 19.75, 21.7931034483);
  border-color: rgb(17.7068965517, 19.75, 21.7931034483);
  color: color-yiq(black);
}
.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(10.8482758621, 12.1, 13.3517241379) 0%, rgb(45.1413793103, 50.35, 55.5586206897) 100%);
  color: color-yiq(black);
  border-color: black;
}
.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {
  color: color-yiq(black) !important;
  border-color: rgb(6.275862069, 7, 7.724137931) !important;
}
.btn-gradient-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-gradient-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-shadow.active {
  box-shadow: 0 0 0 0 transparent !important;
}

.btn-primary {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
}
.btn-check:focus + .btn-primary, .btn-primary:focus {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(67.2, 73.6, 172.8);
  border-color: #3f45a2;
}
.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-primary:disabled, .btn-primary.disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
}
.btn-check:focus + .btn-secondary, .btn-secondary:focus {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(86.4, 93.6, 100);
  border-color: rgb(81, 87.75, 93.75);
}
.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-success {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:hover {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:focus + .btn-success, .btn-success:focus {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {
  color: #000;
  background-color: rgb(97.4, 207.8, 151);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-success:disabled, .btn-success.disabled {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-info {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:hover {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:focus + .btn-info, .btn-info:focus {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {
  color: #000;
  background-color: rgb(89.4, 192.6, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-info:disabled, .btn-info.disabled {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-warning {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:hover {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:focus + .btn-warning, .btn-warning:focus {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {
  color: #000;
  background-color: rgb(248.6, 199, 79.8);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-warning:disabled, .btn-warning.disabled {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-danger {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
}
.btn-check:focus + .btn-danger, .btn-danger:focus {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(173.6, 29.6, 64);
  border-color: rgb(162.75, 27.75, 60);
}
.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-danger:disabled, .btn-danger.disabled {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-light {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:hover {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:focus + .btn-light, .btn-light:focus {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {
  color: #000;
  background-color: rgb(241.4, 241.4, 241.4);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-light:disabled, .btn-light.disabled {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
}
.btn-check:focus + .btn-dark, .btn-dark:focus {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(41.6, 46.4, 51.2);
  border-color: rgb(39, 43.5, 48);
}
.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark:disabled, .btn-dark.disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-focus {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:hover {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
}
.btn-check:focus + .btn-focus, .btn-focus:focus {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {
  color: #fff;
  background-color: rgb(54.4, 51.2, 67.2);
  border-color: #33303f;
}
.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-focus:disabled, .btn-focus.disabled {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-alternate {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:hover {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
}
.btn-check:focus + .btn-alternate, .btn-alternate:focus {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {
  color: #fff;
  background-color: rgb(104.8, 70.4, 110.4);
  border-color: rgb(98.25, 66, 103.5);
}
.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-alternate:disabled, .btn-alternate.disabled {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-shadow-primary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}

.btn-shadow-secondary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}

.btn-shadow-success:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}

.btn-shadow-info:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}

.btn-shadow-warning:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}

.btn-shadow-danger:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}

.btn-shadow-light:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}

.btn-shadow-dark:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}

.btn-shadow-focus:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}

.btn-shadow-alternate:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}

.btn-outline-primary {
  color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #545cd8;
  background-color: transparent;
}
.btn-outline-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}
.btn-outline-primary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}
.btn-outline-secondary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);
}

.btn-outline-success {
  color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:hover {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #3ac47d;
  background-color: transparent;
}
.btn-outline-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}
.btn-outline-success.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);
}

.btn-outline-info {
  color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:hover {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #30b1ff;
  background-color: transparent;
}
.btn-outline-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}
.btn-outline-info.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);
}

.btn-outline-warning {
  color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:hover {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #f7b924;
  background-color: transparent;
}
.btn-outline-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}
.btn-outline-warning.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);
}

.btn-outline-danger {
  color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #d92550;
  background-color: transparent;
}
.btn-outline-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}
.btn-outline-danger.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);
}

.btn-outline-light {
  color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:hover {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light:disabled, .btn-outline-light.disabled {
  color: #eeeeee;
  background-color: transparent;
}
.btn-outline-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}
.btn-outline-light.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}
.btn-outline-dark.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);
}

.btn-outline-focus {
  color: #444054;
  border-color: #444054;
}
.btn-outline-focus:hover {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus:disabled, .btn-outline-focus.disabled {
  color: #444054;
  background-color: transparent;
}
.btn-outline-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}
.btn-outline-focus.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);
}

.btn-outline-alternate {
  color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:hover {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {
  color: #83588a;
  background-color: transparent;
}
.btn-outline-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}
.btn-outline-alternate.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);
}

.btn {
  position: relative;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn-light {
  border-color: rgb(219.5, 219.5, 219.5);
}

.btn-outline-light {
  color: #8f8f8f;
}

.dropdown-menu {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  font-size: 0.88rem;
  margin: 0.125rem;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
}
.dropdown-menu .dropdown-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #545cd8;
  font-weight: bold;
}
.dropdown-menu .dropdown-item {
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  z-index: 6;
  position: relative;
}
.dropdown-menu .dropdown-item .dropdown-icon {
  font-size: 1rem;
  margin-right: 0.325rem;
  width: 30px;
  text-align: center;
  opacity: 0.3;
  margin-left: -10px;
}
.dropdown-menu .dropdown-item:hover .dropdown-icon {
  opacity: 0.7;
}
.dropdown-menu.dropdown-menu-shadow {
  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.dropdown-menu-rounded {
  border-radius: 10px;
  padding: 0.65rem;
}
.dropdown-menu-rounded .dropdown-item {
  border-radius: 30px;
}
.dropdown-menu-rounded .dropdown-divider {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
}
.dropdown-menu-rounded .dropdown-menu-header {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu-rounded .menu-header-image,
.dropdown-menu-rounded .dropdown-menu-header-inner {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.dropdown-menu-hover-link .dropdown-item:hover {
  background: none;
  color: #545cd8;
}

.dropdown-menu-hover-primary .dropdown-item:hover {
  background: #545cd8;
  color: #fff;
}

.dropdown-menu.dropdown-menu-lg {
  min-width: 22rem;
}
.dropdown-menu.dropdown-menu-xl {
  min-width: 25rem;
}

.dropdown-menu .dropdown-menu-header,
.dropdown-menu .menu-header-image,
.dropdown-menu .dropdown-menu-header-inner {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.dropdown-menu-header {
  color: #fff;
  margin-top: -0.65rem;
  margin-bottom: 0.65rem;
  position: relative;
  z-index: 6;
}
.dropdown-menu-header .dropdown-menu-header-inner {
  margin: -1px -1px 0;
  padding: 1.5rem 0.5rem;
  position: relative;
}
.dropdown-menu-header .menu-header-image {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 8;
  opacity: 0.25;
  filter: grayscale(80%);
  background-size: cover;
}
.dropdown-menu-header .menu-header-content {
  text-align: center;
  position: relative;
  z-index: 10;
}
.dropdown-menu-header .menu-header-content.text-start {
  padding-left: 0.5rem;
}
.dropdown-menu-header .menu-header-content.btn-pane-right {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
}
.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
  margin: 0 0 0 auto;
}
.dropdown-menu-header .menu-header-content .menu-header-btn-pane {
  margin-top: 10px;
  margin-bottom: 3px;
}
.dropdown-menu-header + .grid-menu {
  margin-top: -0.65rem;
}

.menu-header-title {
  font-weight: 500;
  font-size: 1.1rem;
  margin: 0;
}

.menu-header-subtitle {
  font-size: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: var(--bs-font-sans-serif);
  margin: 5px 0 0;
  opacity: 0.8;
}

.dropdown-menu .grid-menu {
  margin-bottom: -0.65rem;
  padding: 1px;
}
.dropdown-menu .grid-menu [class*=col-] {
  padding: 0.65rem;
}
.dropdown-menu .grid-menu-xl {
  margin-bottom: -0.4814814815rem;
}
.dropdown-menu .grid-menu-xl [class*=col-] {
  padding: 0;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
  margin-left: 5px;
}

.dropdown-toggle-split::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 2px;
}

.dropdown-menu::before, .dropdown-menu::after {
  position: absolute;
  width: 14px;
  height: 14px;
  left: 5px;
  top: -5px;
  transform: rotate(45deg);
  border-radius: 4px;
  content: "";
  display: block;
  z-index: 5;
}
.dropdown-menu::before {
  background: #fff;
  z-index: 5;
}
.dropdown-menu::after {
  top: -6px;
  background: rgba(0, 0, 0, 0.15);
  z-index: 4;
}
.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {
  top: auto;
  bottom: -5px;
}
.dropdown-menu[data-placement=top-start]::after {
  bottom: -6px;
}
.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {
  left: auto;
  right: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=left-start]::after {
  top: 5px;
  right: -6px;
}
.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {
  right: auto;
  left: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=right-start]::after {
  top: 5px;
  left: -6px;
}
.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {
  left: auto;
  right: 6px;
}
.dropdown-menu.dropdown-menu-right::after {
  right: 6px;
}
.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {
  display: none;
}

.dropdown-mega-menu {
  width: 56rem;
  padding: 1rem;
}
.dropdown-mega-menu .nav-item.nav-item-header {
  text-transform: none;
  font-size: 0.88rem;
  padding-top: 0;
  font-weight: normal;
}
.dropdown-mega-menu .grid-menu {
  margin-bottom: 0;
}

.dropdown-mega-menu-sm {
  width: 40rem;
}

body .dropdown-menu.dropdown-menu-inline {
  border: 0;
  position: static !important;
  box-shadow: 0 0 0 transparent;
  background: transparent;
  border-radius: 0;
  display: inline-block;
  float: none;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  transform: translateY(0) !important;
}
body .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {
  display: none;
}

.nav-item .nav-link {
  font-weight: normal;
}

.nav-link {
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}
.nav-link .nav-link-icon {
  color: #545cd8;
  font-size: 1rem;
  width: 30px;
  text-align: center;
  opacity: 0.45;
  margin-left: -10px;
}
.nav-link:hover {
  color: #495057;
}
.nav-link:hover .nav-link-icon {
  opacity: 0.9;
  color: #545cd8;
}
.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {
  opacity: 0.3;
}

.nav-item.nav-item-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #6c757d;
  font-weight: bold;
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-btn {
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-divider {
  margin: 0.5rem 0;
  height: 1px;
  overflow: hidden;
  background: #dee2e6;
}

.nav .badge {
  margin-left: 8px;
}

.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {
  color: #fff;
}
.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {
  color: #fff;
  opacity: 0.8;
}
.nav-pills .nav-link:hover {
  color: #495057 !important;
}

.grid-menu [class*=col-] {
  border-right: #dee2e6 solid 0;
  border-bottom: #dee2e6 solid 1px;
}
.grid-menu [class*=col-]:hover {
  z-index: 5;
}
.grid-menu [class*=col-]:nth-last-child(-n+2) {
  border-bottom-width: 0;
}
.grid-menu [class*=col-]:nth-child(1n) {
  border-right-width: 1px;
}
.grid-menu [class*=col-]:nth-child(2n) {
  border-right-width: 0;
}
.grid-menu [class*=col-]:nth-last-child(-n+1) {
  border-bottom-width: 0;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {
  border-bottom-width: 0;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {
  border-right-width: 1px;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {
  border-right-width: 0;
}
.grid-menu .btn {
  display: block;
  border: 0;
  min-width: 100%;
}

.badge {
  font-weight: bold;
  text-transform: uppercase;
  padding: 5px 10px;
  min-width: 19px;
}

.badge-light {
  background: #fff;
}

.badge-dot {
  text-indent: -999em;
  padding: 0;
  width: 8px;
  height: 8px;
  border: transparent solid 1px;
  border-radius: 30px;
  min-width: 2px;
}

.badge-dot-lg {
  width: 10px;
  height: 10px;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}
.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.badge-dot-sm {
  width: 6px;
  height: 6px;
}

.btn .badge {
  margin-left: 8px;
}
.btn .badge-dot {
  position: absolute;
  border: #fff solid 2px;
  top: -5px;
  right: -5px;
  width: 11px;
  height: 11px;
}
.btn .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
}
.btn .badge-dot.badge-dot-sm {
  width: 8px;
  height: 8px;
  border-width: 1px;
}
.btn .badge-dot-inside {
  top: 10px;
  right: 10px;
}

.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {
  top: 1px;
  right: 4px;
}
.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {
  top: 0px;
  right: 2px;
}
.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {
  top: -3px;
  right: -2px;
}
.btn-sm .rounded-pill, .btn-group-sm > .btn .rounded-pill {
  position: absolute;
  top: -4px;
  right: -4px;
}

.badge-abs {
  position: absolute;
  right: -3px;
  top: -3px;
}

.avatar-icon-wrapper {
  display: inline-block;
  margin-right: 0.1rem;
  position: relative;
}
.avatar-icon-wrapper .badge {
  position: absolute;
  right: -2px;
  top: -2px;
}
.avatar-icon-wrapper .badge:empty {
  display: block;
}
.avatar-icon-wrapper .badge.badge-bottom {
  top: auto;
  right: -2px;
  bottom: -2px;
}
.avatar-icon-wrapper .badge-dot {
  width: 10px;
  height: 10px;
  border: #fff solid 2px;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
  border: #fff solid 2px;
  top: 0;
  right: 0;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {
  top: auto;
  right: 0;
  bottom: 0;
}

.avatar-icon-add .avatar-icon {
  background: #e0f3ff;
  border: rgb(146.2928571429, 151.3785714286, 230.2071428571) dashed 1px;
  color: #545cd8;
  text-align: center;
  opacity: 0.6;
}
.avatar-icon-add .avatar-icon i {
  font-style: normal;
  vertical-align: middle;
  font-size: 1.32rem;
  display: block;
  height: 100%;
}
.avatar-icon-add:hover {
  cursor: pointer;
}
.avatar-icon-add:hover .avatar-icon {
  opacity: 1;
}

a.avatar-icon-wrapper:hover .avatar-icon {
  opacity: 0.8;
}

.avatar-icon {
  display: block;
  width: 44px;
  height: 44px;
  transition: all 0.2s;
  opacity: 1;
  border-radius: 50px;
}
.avatar-icon.rounded {
  border-radius: 0.39rem !important;
}

.avatar-icon-xl .avatar-icon {
  width: 64px;
  height: 64px;
}
.avatar-icon-xl.avatar-icon-add i {
  font-size: 1.76rem;
}

.avatar-icon-lg .avatar-icon {
  width: 54px;
  height: 54px;
}
.avatar-icon-lg.avatar-icon-add i {
  font-size: 1.54rem;
}

.avatar-icon-sm .avatar-icon {
  width: 34px;
  height: 34px;
}
.avatar-icon-sm.avatar-icon-add i {
  font-size: 1.1rem;
}

.avatar-icon-xs .avatar-icon {
  width: 26px;
  height: 26px;
  transition: transform 0.2s;
}
.avatar-icon-xs.avatar-icon-add i {
  line-height: 26px;
  font-size: 0.88rem;
}
.avatar-icon-xs:hover .avatar-icon {
  transform: scale(2);
}

.avatar-icon {
  border: #fff solid 3px;
  overflow: hidden;
}
.avatar-icon img {
  width: 100%;
  height: 100%;
}

.avatar-wrapper-overlap .avatar-icon-wrapper {
  z-index: 5;
  margin-left: -18px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper:hover {
  z-index: 7;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {
  margin-left: -30px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {
  margin-left: -24px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {
  margin-left: -14px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {
  margin-left: -10px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {
  margin-left: 0 !important;
}
.badge-pulse {
  -webkit-animation: pulse 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  position: relative;
}
.badge-pulse::before, .badge-pulse::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-animation-iteration-count: infinite;
}
.badge-pulse::after {
  -webkit-animation-delay: 0.33s;
  -webkit-animation-duration: 2.2s;
}

.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  border-width: 0;
  transition: all 0.2s;
}
.card > .dropdown-menu-header {
  margin: 0;
}
.card > .dropdown-menu-header .dropdown-menu-header-inner {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header, .card.text-white .card-footer,
.card.text-white .card-header {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header {
  color: rgba(0, 0, 0, 0.9);
}
.card .card-footer {
  display: flex;
  align-items: center;
}

.btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
}

.btn-actions-pane-left {
  margin-right: auto;
}

.actions-icon-btn .btn-icon-only {
  padding-left: 0;
  padding-right: 0;
  color: #495057;
}
.actions-icon-btn .btn-icon-only .btn-icon-wrapper {
  font-size: 1.3rem;
  width: 30px;
  text-align: center;
}
.actions-icon-btn .btn-icon-only:hover {
  color: #545cd8;
}

.card-header,
.card-title {
  text-transform: uppercase;
  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.7);
  font-weight: bold;
  font-size: 0.88rem;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0.5rem;
  height: 3.5rem;
}
.card-header.no-border {
  border: 0;
  padding: 0;
  height: auto;
}
.card-header .menu-header-subtitle {
  display: block;
}
.card-header.card-header-tab .nav {
  width: auto;
  margin-left: auto;
}
.card-header.card-header-tab .card-header-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.card-header .header-icon {
  font-size: 1.65rem;
  margin-right: 0.5rem;
}
.card-header > .nav {
  margin-left: -0.5rem;
  height: 100%;
  width: 100%;
}
.card-header > .nav .nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}
.card-header > .nav .nav-link {
  text-transform: none;
  width: 100%;
  display: block;
  color: #495057;
}
.card-header > .nav .nav-link::before {
  content: "";
  border-radius: 15px;
  background: #545cd8;
  transition: all 0.2s;
  height: 4px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -2px;
  opacity: 0;
}
.card-header > .nav .nav-link:hover {
  color: #545cd8;
}
.card-header > .nav .nav-link.active {
  color: #545cd8;
}
.card-header > .nav .nav-link.active::before {
  opacity: 1;
}
.card-header.card-header-tab-animation .nav .nav-link::before {
  transform: scale(0);
  opacity: 1;
  width: 90%;
  left: 5%;
}
.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {
  transform: scale(1);
}

.card-border {
  box-shadow: 0 0 0 transparent;
  border-width: 1px;
}

.card-hover-shadow:hover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.card-hover-shadow-2x:hover {
  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.card-subtitle {
  margin-bottom: 1rem;
  font-size: 0.968rem;
  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.55);
}

.card-shadow-primary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);
}

.card-shadow-secondary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);
}

.card-shadow-success {
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);
}

.card-shadow-info {
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);
}

.card-shadow-warning {
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);
}

.card-shadow-danger {
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);
}

.card-shadow-light {
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);
}

.card-shadow-dark {
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);
}

.card-shadow-focus {
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);
}

.card-shadow-alternate {
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);
}

.card-header-lg {
  padding: 2rem 2rem;
  height: auto;
}

.sticky-active-class .sticky-inner-wrapper > div {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.nav-pills,
.nav-tabs {
  margin-bottom: 1rem;
}

.nav-link {
  font-weight: bold;
}
.nav-link:hover {
  cursor: pointer;
}

.nav-tabs .nav-link:hover {
  color: #545cd8 !important;
}
.nav-tabs .nav-link.active {
  color: #545cd8;
}

.nav-pills .nav-link:hover {
  color: #545cd8 !important;
}
.nav-pills .nav-link.active {
  background: #545cd8;
}
.nav-pills .nav-link.active:hover {
  color: #fff !important;
}

.RRT__container {
  position: relative;
}

.RRT__tabs {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.RRT__accordion {
  flex-direction: column;
}

.RRT__tab {
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  padding: 0.5rem 1rem;
  transition: all 0.2s;
}
.RRT__tab:hover {
  color: #545cd8;
}
.RRT__tab:focus {
  outline: 0;
}

.RRT__tab--selected {
  color: #545cd8;
}

.RRT__tab--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.RRT__tab:focus {
  z-index: 2;
}

.RRT__tab--selected .RRT__removable {
  position: relative;
}

.RRT__tab--selected .RRT__removable-text {
  margin-right: 10px;
}

.RRT__tab--selected .RRT__removable-icon {
  position: absolute;
  font-size: 18px;
  right: 0.5em;
  top: 0.2em;
}

.body-tabs.body-tabs-layout.body-tabs-big {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0 auto;
  padding: 10px;
  border-radius: 50px;
  border: #e9ecef solid 1px;
  z-index: 7;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
  margin: 0;
  font-size: 1rem;
  font-weight: 300;
  padding: 0;
  height: 50px;
  line-height: 50px;
  flex: 1 1;
  text-align: center;
  position: relative;
  color: #545cd8;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {
  color: #212529;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {
  height: 70px !important;
  top: -70px !important;
  margin: 0 auto -3.4rem;
  position: relative;
  padding: 0 10px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {
  position: absolute;
  content: "";
  background: #fff;
  width: 100%;
  height: 100%;
  left: 0;
  top: -11px;
  border-radius: 50px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 50px !important;
  margin-top: 10px;
  border-radius: 50px;
  box-shadow: 0 0 0 transparent;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {
  margin-top: -1rem;
}

.RRT__panel {
  margin-top: 1rem;
}

.RRT__showmore {
  border-radius: 0.25rem;
  background: #545cd8;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  font-weight: bold;
  width: 36px;
  text-align: center;
  height: 36px;
  display: block;
  margin-left: 15px;
  position: absolute;
  right: 1.5rem;
  top: 50%;
  margin-top: -18px;
  font-size: 1.4rem;
}
.RRT__showmore:focus {
  outline: none;
}

.RRT__showmore-label {
  position: relative;
  z-index: 1;
  color: #fff;
  width: 36px;
  text-align: center;
  height: 36px;
  line-height: 24px;
}

.RRT__showmore--selected {
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.RRT__showmore-list {
  position: absolute;
  right: -1px;
  top: 100%;
  display: none;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.RRT__showmore-list .RRT__tab {
  display: block;
  width: 100%;
  padding: 0.4rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  margin: 0;
}
.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {
  color: rgb(29.7, 33.3, 36.9) !important;
  text-decoration: none;
  background: #e0f3ff;
}

.RRT__showmore-list--opened {
  display: block;
}
.RRT__showmore-list--opened .RRT__tab--selected {
  color: #545cd8;
}

.RRT__inkbar-wrapper {
  width: 100%;
}

.RRT__inkbar {
  position: relative;
  bottom: 0;
  height: 3px;
  margin-top: -3px;
  background-color: #545cd8;
  border-radius: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
  z-index: 2;
}

.card-tabs .card-header {
  padding: 0 1.25rem;
}
.card-tabs .card-header.RRT__tabs {
  cursor: pointer;
  font-weight: normal;
}
.card-tabs .card-header.RRT__tabs .RRT__tab {
  text-transform: none;
  line-height: 1.3;
}
.card-tabs .RRT__inkbar-wrapper {
  width: calc(100% - 1.5rem) !important;
  margin-left: 1.25rem;
}
.card-tabs .RRT__panel {
  padding: 1rem;
  margin: 0;
}
.card-tabs.text-white .RRT__tab {
  color: rgba(255, 255, 255, 0.6);
}
.card-tabs.text-white .RRT__tab:hover {
  color: #fff;
}
.card-tabs.text-white .RRT__tab--selected {
  color: #fff;
}
.card-tabs.text-white .RRT__inkbar {
  background: rgb(250.1142857143, 250.3428571429, 253.8857142857);
}

.card-tabs-animated .RRT__container > .RRT__tabs {
  background: transparent;
  position: relative;
  z-index: 7;
}
.card-tabs-animated .RRT__container > .RRT__tabs.card-header {
  border-bottom: 0;
  height: auto;
  padding: 1.5rem 1.5rem 0.5rem;
}
.card-tabs-animated .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.5rem;
  z-index: 5;
}
.card-tabs-animated .RRT__tab {
  padding: 0.5rem 1.2rem;
}
.card-tabs-animated .RRT__tab--selected {
  color: #fff;
}
.card-tabs-animated .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.card-tabs-animated-inner .RRT__tabs {
  padding: 0 5%;
}
.card-tabs-animated-inner .RRT__inkbar-wrapper {
  left: 5%;
  width: 90%;
  height: 36px;
  top: 14px;
}
.card-tabs-animated-inner .RRT__inkbar {
  height: 36px;
}

.body-tabs {
  border-bottom: #dee2e6 solid 2px;
}
.body-tabs > .RRT__tab {
  padding: 1rem 1.25rem;
  font-weight: normal;
  font-size: 0.88rem;
}
.body-tabs.body-tabs-alt > .RRT__tab {
  padding: 1.3636363636rem 0.5rem;
  font-weight: normal;
  font-size: 0.86rem;
  width: 33%;
  text-align: center;
}
.body-tabs.body-tabs-alt .RRT__inkbar {
  height: 2px;
  margin-top: -2px;
}

.popover .RRT__panel,
.dropdown-menu .RRT__panel {
  margin: 0;
  padding: 0;
  position: relative;
}
.popover .RRT__panel::after, .popover .RRT__panel::before,
.dropdown-menu .RRT__panel::after,
.dropdown-menu .RRT__panel::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 20px;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00ffffff", GradientType=0);
}
.popover .RRT__panel::after,
.dropdown-menu .RRT__panel::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#ffffff", GradientType=0);
}

.tabs-lg-alternate.card-header {
  padding: 0;
  height: auto;
}
.tabs-lg-alternate.card-header .widget-number {
  font-size: 1.76rem;
  font-weight: 300;
}
.tabs-lg-alternate.card-header .tab-subheading {
  padding: 5px 0 0;
  opacity: 0.6;
  transition: all 0.2s;
}
.tabs-lg-alternate.card-header > .nav {
  margin: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link {
  padding: 1.5rem 0;
  border-right: #e9ecef solid 1px;
  background: #f8f9fa;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-link::before {
  background: #fff;
  border-radius: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {
  border-right: 0;
}

.accordion-wrapper {
  border-radius: 0.25rem;
  border: #e9ecef solid 1px;
}
.accordion-wrapper > .card {
  box-shadow: 0 0 0 0 transparent;
}
.accordion-wrapper > .card > .card-header {
  padding: 1rem;
  height: auto;
}
.accordion-wrapper > .card > .card-header .btn:active,
.accordion-wrapper > .card > .card-header .btn:focus,
.accordion-wrapper > .card > .card-header .btn:hover {
  text-decoration: none;
}
.accordion-wrapper > .card > .card-header .form-heading p {
  margin: 0;
}
.accordion-wrapper > .card .collapse {
  border-bottom: transparent solid 1px;
}
.accordion-wrapper > .card .collapse.show {
  border-bottom-color: #e9ecef;
}

.modal-header,
.modal-footer {
  background: #f8f9fa;
}

.modal-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.modal-dialog {
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.25rem;
}

/**
 * Dots
 */
@keyframes scale {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }
  80% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-pulse > div:nth-child(0) {
  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(1) {
  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(2) {
  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(3) {
  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-pulse-sync {
  33% {
    transform: translateY(10px);
  }
  66% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.ball-pulse-sync > div:nth-child(0) {
  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(1) {
  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(2) {
  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(3) {
  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;
}
.ball-pulse-sync > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-scale {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  height: 60px;
  width: 60px;
  animation: ball-scale 1s 0s ease-in-out infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ball-rotate {
  position: relative;
}
.ball-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: relative;
}
.ball-rotate > div:first-child {
  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;
}
.ball-rotate > div:before, .ball-rotate > div:after {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  content: "";
  position: absolute;
  opacity: 0.8;
}
.ball-rotate > div:before {
  top: 0px;
  left: -28px;
}
.ball-rotate > div:after {
  top: 0px;
  left: 25px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  height: 25px;
  width: 25px;
  background: transparent !important;
  display: inline-block;
  animation: rotate 0.75s 0s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
@keyframes scale {
  30% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.ball-clip-rotate-pulse {
  position: relative;
  transform: translateY(-15px);
}
.ball-clip-rotate-pulse > div {
  animation-fill-mode: both;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 100%;
}
.ball-clip-rotate-pulse > div:first-child {
  background: #545cd8;
  height: 16px;
  width: 16px;
  top: 7px;
  left: -7px;
  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}
.ball-clip-rotate-pulse > div:last-child {
  position: absolute;
  border: 2px solid #545cd8;
  width: 30px;
  height: 30px;
  left: -16px;
  top: -2px;
  background: transparent;
  border: 2px solid;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
  animation-duration: 1s;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate-multiple {
  position: relative;
}
.ball-clip-rotate-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  left: -20px;
  top: -20px;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  border-top-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  animation: rotate 1s 0s ease-in-out infinite;
}
.ball-clip-rotate-multiple > div:last-child {
  display: inline-block;
  top: -10px;
  left: -10px;
  width: 15px;
  height: 15px;
  animation-duration: 0.5s;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation-direction: reverse;
}

@keyframes ball-scale-ripple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple > div {
  animation-fill-mode: both;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-scale-ripple-multiple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple-multiple {
  position: relative;
  transform: translateY(-25px);
}
.ball-scale-ripple-multiple > div:nth-child(0) {
  animation-delay: -0.8s;
}
.ball-scale-ripple-multiple > div:nth-child(1) {
  animation-delay: -0.6s;
}
.ball-scale-ripple-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-ripple-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-ripple-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  top: -2px;
  left: -26px;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-beat {
  50% {
    opacity: 0.2;
    transform: scale(0.75);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: ball-beat 0.7s 0s infinite linear;
}
.ball-beat > div:nth-child(2n-1) {
  animation-delay: -0.35s !important;
}

@keyframes ball-scale-multiple {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale-multiple {
  position: relative;
  transform: translateY(-30px);
}
.ball-scale-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-multiple > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  left: -30px;
  top: 0px;
  opacity: 0;
  margin: 0;
  width: 60px;
  height: 60px;
  animation: ball-scale-multiple 1s 0s linear infinite;
}

@keyframes ball-triangle-path-1 {
  33% {
    transform: translate(25px, -50px);
  }
  66% {
    transform: translate(50px, 0px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-2 {
  33% {
    transform: translate(25px, 50px);
  }
  66% {
    transform: translate(-25px, 50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-3 {
  33% {
    transform: translate(-50px, 0px);
  }
  66% {
    transform: translate(-25px, -50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.ball-triangle-path {
  position: relative;
  transform: translate(-29.9940011998px, -37.5093773443px);
}
.ball-triangle-path > div:nth-child(1) {
  animation-name: ball-triangle-path-1;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(2) {
  animation-name: ball-triangle-path-2;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(3) {
  animation-name: ball-triangle-path-3;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div {
  animation-fill-mode: both;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid #545cd8;
}
.ball-triangle-path > div:nth-of-type(1) {
  top: 50px;
}
.ball-triangle-path > div:nth-of-type(2) {
  left: 25px;
}
.ball-triangle-path > div:nth-of-type(3) {
  top: 50px;
  left: 50px;
}

@keyframes ball-pulse-rise-even {
  0% {
    transform: scale(1.1);
  }
  25% {
    transform: translateY(-30px);
  }
  50% {
    transform: scale(0.4);
  }
  75% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(1);
  }
}
@keyframes ball-pulse-rise-odd {
  0% {
    transform: scale(0.4);
  }
  25% {
    transform: translateY(30px);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: translateY(-30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(0.75);
  }
}
.ball-pulse-rise > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);
  animation-iteration-count: infinite;
  animation-delay: 0;
}
.ball-pulse-rise > div:nth-child(2n) {
  animation-name: ball-pulse-rise-even;
}
.ball-pulse-rise > div:nth-child(2n-1) {
  animation-name: ball-pulse-rise-odd;
}

@keyframes ball-grid-beat {
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.ball-grid-beat {
  width: 57px;
}
.ball-grid-beat > div:nth-child(1) {
  animation-delay: 0.53s;
  animation-duration: 0.66s;
}
.ball-grid-beat > div:nth-child(2) {
  animation-delay: 0.69s;
  animation-duration: 0.91s;
}
.ball-grid-beat > div:nth-child(3) {
  animation-delay: 0.51s;
  animation-duration: 1.56s;
}
.ball-grid-beat > div:nth-child(4) {
  animation-delay: 0.01s;
  animation-duration: 0.64s;
}
.ball-grid-beat > div:nth-child(5) {
  animation-delay: 0.59s;
  animation-duration: 1.54s;
}
.ball-grid-beat > div:nth-child(6) {
  animation-delay: 0.41s;
  animation-duration: 0.65s;
}
.ball-grid-beat > div:nth-child(7) {
  animation-delay: 0.32s;
  animation-duration: 1.25s;
}
.ball-grid-beat > div:nth-child(8) {
  animation-delay: -0.15s;
  animation-duration: 1.37s;
}
.ball-grid-beat > div:nth-child(9) {
  animation-delay: 0.55s;
  animation-duration: 1.56s;
}
.ball-grid-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-beat;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-grid-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-grid-pulse {
  width: 57px;
}
.ball-grid-pulse > div:nth-child(1) {
  animation-delay: -0.03s;
  animation-duration: 1.31s;
}
.ball-grid-pulse > div:nth-child(2) {
  animation-delay: 0.66s;
  animation-duration: 0.93s;
}
.ball-grid-pulse > div:nth-child(3) {
  animation-delay: 0.64s;
  animation-duration: 1.56s;
}
.ball-grid-pulse > div:nth-child(4) {
  animation-delay: 0.45s;
  animation-duration: 0.81s;
}
.ball-grid-pulse > div:nth-child(5) {
  animation-delay: 0.57s;
  animation-duration: 1.55s;
}
.ball-grid-pulse > div:nth-child(6) {
  animation-delay: 0.24s;
  animation-duration: 1.47s;
}
.ball-grid-pulse > div:nth-child(7) {
  animation-delay: -0.14s;
  animation-duration: 1.25s;
}
.ball-grid-pulse > div:nth-child(8) {
  animation-delay: 0.54s;
  animation-duration: 0.84s;
}
.ball-grid-pulse > div:nth-child(9) {
  animation-delay: 0.43s;
  animation-duration: 1.11s;
}
.ball-grid-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-pulse;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-spin-fade-loader {
  50% {
    opacity: 0.3;
    transform: scale(0.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -10px;
}
.ball-spin-fade-loader > div:nth-child(1) {
  top: 25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.96s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(2) {
  top: 17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.84s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 25px;
  animation: ball-spin-fade-loader 1s -0.72s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(4) {
  top: -17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.6s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(5) {
  top: -25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.48s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(6) {
  top: -17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.36s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -25px;
  animation: ball-spin-fade-loader 1s -0.24s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(8) {
  top: 17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.12s infinite linear;
}
.ball-spin-fade-loader > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
}

@keyframes ball-spin-loader {
  75% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}
.ball-spin-loader {
  position: relative;
}
.ball-spin-loader > span:nth-child(1) {
  top: 45px;
  left: 0;
  animation: ball-spin-loader 2s 0.9s infinite linear;
}
.ball-spin-loader > span:nth-child(2) {
  top: 30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 1.8s infinite linear;
}
.ball-spin-loader > span:nth-child(3) {
  top: 0;
  left: 45px;
  animation: ball-spin-loader 2s 2.7s infinite linear;
}
.ball-spin-loader > span:nth-child(4) {
  top: -30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 3.6s infinite linear;
}
.ball-spin-loader > span:nth-child(5) {
  top: -45px;
  left: 0;
  animation: ball-spin-loader 2s 4.5s infinite linear;
}
.ball-spin-loader > span:nth-child(6) {
  top: -30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 5.4s infinite linear;
}
.ball-spin-loader > span:nth-child(7) {
  top: 0;
  left: -45px;
  animation: ball-spin-loader 2s 6.3s infinite linear;
}
.ball-spin-loader > span:nth-child(8) {
  top: 30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 7.2s infinite linear;
}
.ball-spin-loader > div {
  animation-fill-mode: both;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: green;
}

@keyframes ball-zig {
  33% {
    transform: translate(-15px, -30px);
  }
  66% {
    transform: translate(15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag {
  33% {
    transform: translate(15px, 30px);
  }
  66% {
    transform: translate(-15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag > div:first-child {
  animation: ball-zig 0.7s 0s infinite linear;
}
.ball-zig-zag > div:last-child {
  animation: ball-zag 0.7s 0s infinite linear;
}

@keyframes ball-zig-deflect {
  17% {
    transform: translate(-15px, -30px);
  }
  34% {
    transform: translate(15px, -30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(15px, -30px);
  }
  84% {
    transform: translate(-15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag-deflect {
  17% {
    transform: translate(15px, 30px);
  }
  34% {
    transform: translate(-15px, 30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(-15px, 30px);
  }
  84% {
    transform: translate(15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag-deflect {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag-deflect > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag-deflect > div:first-child {
  animation: ball-zig-deflect 1.5s 0s infinite linear;
}
.ball-zig-zag-deflect > div:last-child {
  animation: ball-zag-deflect 1.5s 0s infinite linear;
}

/**
 * Lines
 */
@keyframes line-scale {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale > div:nth-child(1) {
  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(2) {
  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(3) {
  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(4) {
  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(5) {
  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes line-scale-party {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
.line-scale-party > div:nth-child(1) {
  animation-delay: 0.48s;
  animation-duration: 0.38s;
}
.line-scale-party > div:nth-child(2) {
  animation-delay: -0.06s;
  animation-duration: 0.78s;
}
.line-scale-party > div:nth-child(3) {
  animation-delay: 0.43s;
  animation-duration: 0.58s;
}
.line-scale-party > div:nth-child(4) {
  animation-delay: 0.12s;
  animation-duration: 1.01s;
}
.line-scale-party > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-name: line-scale-party;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes line-scale-pulse-out {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);
}
.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {
  animation-delay: -0.4s !important;
}
.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {
  animation-delay: -0.2s !important;
}

@keyframes line-scale-pulse-out-rapid {
  0% {
    transform: scaley(1);
  }
  80% {
    transform: scaley(0.3);
  }
  90% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out-rapid > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  vertical-align: middle;
  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);
}
.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {
  animation-delay: -0.25s !important;
}
.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {
  animation-delay: 0s !important;
}

@keyframes line-spin-fade-loader {
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
.line-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -4px;
}
.line-spin-fade-loader > div:nth-child(1) {
  top: 20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(2) {
  top: 13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(4) {
  top: -13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(5) {
  top: -20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(6) {
  top: -13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(8) {
  top: 13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;
}
.line-spin-fade-loader > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  width: 5px;
  height: 15px;
}

/**
 * Misc
 */
@keyframes triangle-skew-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.triangle-skew-spin > div {
  animation-fill-mode: both;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #545cd8;
  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes square-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.square-spin > div {
  animation-fill-mode: both;
  width: 50px;
  height: 50px;
  background: #545cd8;
  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes rotate_pacman_half_up {
  0% {
    transform: rotate(270deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
@keyframes rotate_pacman_half_down {
  0% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}
@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    transform: translate(-100px, -6.25px);
  }
}
.pacman {
  position: relative;
}
.pacman > div:nth-child(2) {
  animation: pacman-balls 1s -0.99s infinite linear;
}
.pacman > div:nth-child(3) {
  animation: pacman-balls 1s -0.66s infinite linear;
}
.pacman > div:nth-child(4) {
  animation: pacman-balls 1s -0.33s infinite linear;
}
.pacman > div:nth-child(5) {
  animation: pacman-balls 1s 0s infinite linear;
}
.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_up 0.5s 0s infinite;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_down 0.5s 0s infinite;
  margin-top: -50px;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  transform: translate(0, -6.25px);
  top: 25px;
  left: 70px;
}

@keyframes cube-transition {
  25% {
    transform: translateX(50px) scale(0.5) rotate(-90deg);
  }
  50% {
    transform: translate(50px, 50px) rotate(-180deg);
  }
  75% {
    transform: translateY(50px) scale(0.5) rotate(-270deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.cube-transition {
  position: relative;
  transform: translate(-25px, -25px);
}
.cube-transition > div {
  animation-fill-mode: both;
  width: 10px;
  height: 10px;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: #545cd8;
  animation: cube-transition 1.6s 0s infinite ease-in-out;
}
.cube-transition > div:last-child {
  animation-delay: -0.8s;
}

@keyframes spin-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.semi-circle-spin {
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
}
.semi-circle-spin > div {
  position: absolute;
  border-width: 0px;
  border-radius: 100%;
  animation: spin-rotate 0.6s 0s infinite linear;
  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);
  width: 100%;
  height: 100%;
}

.progress .progress-bar:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.progress.progress-bar-sm {
  height: 0.5rem;
}
.progress.progress-bar-xs {
  height: 0.3rem;
}
.progress.progress-bar-rounded {
  border-radius: 30px;
}

.progress-bar-animated-alt.progress-bar,
.progress-bar-animated-alt .progress-bar {
  position: relative;
}
.progress-bar-animated-alt.progress-bar::after,
.progress-bar-animated-alt .progress-bar::after {
  content: "";
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  animation: progress-active 2s ease infinite;
}

@keyframes progress-active {
  0% {
    opacity: 0.4;
    width: 0;
  }
  100% {
    opacity: 0;
    width: 100%;
  }
}
.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}
.vertical-timeline::after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.25rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}
.vertical-timeline-element:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element:last-child {
  margin-bottom: 0;
}

.vertical-timeline-element-content {
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}
.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element-content .timeline-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
}
.vertical-timeline-element-content p {
  color: #6c757d;
  margin: 0 0 0.5rem;
}
.vertical-timeline-element-content .vertical-timeline-element-date {
  display: block;
  position: absolute;
  left: -90px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619047619rem;
  white-space: nowrap;
}

.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}
.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.vertical-timeline-element--no-children .vertical-timeline-element-content {
  background: 0 0;
  box-shadow: none;
}
.vertical-timeline-element--no-children .vertical-timeline-element-content::before {
  display: none;
}

.vertical-without-time::before {
  left: 11px;
}
.vertical-without-time .vertical-timeline-element-content {
  margin-left: 36px;
}
.vertical-without-time .vertical-timeline-element-icon {
  left: 4px;
}

.vertical-time-icons {
  padding: 2rem 0 0;
}
.vertical-time-icons::before {
  content: "";
  position: absolute;
  top: 0;
  left: 14px;
  height: 100%;
  width: 6px;
  background: #e9ecef;
  border-radius: 0.25rem;
}
.vertical-time-icons .vertical-timeline-element {
  margin-bottom: 1rem;
}
.vertical-time-icons .vertical-timeline-element-content {
  margin-left: 50px;
}
.vertical-time-icons .vertical-timeline-element-icon {
  width: 34px;
  height: 34px;
  left: 0;
  top: -7px;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {
  width: 34px;
  height: 34px;
  background: #fff;
  border-radius: 50px;
  border-width: 2px;
  border-style: solid;
  box-shadow: 0 0 0 5px #fff;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {
  display: block;
  font-size: 1.1rem;
  margin: 0 auto;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {
  margin: 0 auto;
}

.vertical-time-simple {
  padding: 0.5rem 0;
}
.vertical-time-simple .vertical-timeline-element {
  margin: 0 0 0.5rem;
}
.vertical-time-simple .timeline-title {
  font-weight: normal;
  font-size: 0.9166666667rem;
  padding: 0;
}
.vertical-time-simple .vertical-timeline-element-icon {
  height: 14px;
  width: 14px;
  background: #e9ecef;
  position: absolute;
  left: 6px;
  top: 2px;
  display: block;
  border-radius: 20px;
}
.vertical-time-simple .vertical-timeline-element-icon::after {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.vertical-time-simple .timeline-title {
  text-transform: none;
}

.dot-primary .vertical-timeline-element-icon {
  background: #545cd8;
}

.dot-secondary .vertical-timeline-element-icon {
  background: #6c757d;
}

.dot-success .vertical-timeline-element-icon {
  background: #3ac47d;
}

.dot-info .vertical-timeline-element-icon {
  background: #30b1ff;
}

.dot-warning .vertical-timeline-element-icon {
  background: #f7b924;
}

.dot-danger .vertical-timeline-element-icon {
  background: #d92550;
}

.dot-light .vertical-timeline-element-icon {
  background: #eeeeee;
}

.dot-dark .vertical-timeline-element-icon {
  background: #343a40;
}

.dot-focus .vertical-timeline-element-icon {
  background: #444054;
}

.dot-alternate .vertical-timeline-element-icon {
  background: #83588a;
}

.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}
@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
  visibility: visible;
  animation: cd-bounce-2 0.6s;
}

@media only screen and (min-width: 1170px) {
  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@media only screen and (max-width: 1169px) {
  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
    visibility: visible;
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  60% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  60% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
.todo-list-wrapper .todo-indicator {
  position: absolute;
  width: 4px;
  height: 60%;
  border-radius: 0.3rem;
  left: 0.5rem;
  top: 20%;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.todo-list-wrapper .list-group-item:hover .todo-indicator {
  opacity: 0.9;
}
.todo-list-wrapper .custom-control,
.todo-list-wrapper input[checkbox] {
  margin-left: 0.5rem;
}

.list-group-flush + .card-footer {
  border-top: 0;
}

.rm-list-borders .list-group-item {
  border: 0;
  padding: 0.6666666667rem 0;
}

.rm-list-borders-scroll .list-group-item {
  border: 0;
  padding-right: 1.5rem;
}

.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.input-group > div:not([class]) {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > div:not([class]) .react-datepicker__input-container .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .input-group-prepend + div {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

legend {
  font-size: 0.88rem;
  font-weight: bold;
}

.form-heading {
  font-size: 1.1rem;
  margin: 0;
  color: #545cd8;
}
.form-heading p {
  color: #6c757d;
  padding: 0.3rem 0 0;
  font-size: 0.88rem;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.pagination li a {
  position: relative;
  display: block;
  padding: 0.375rem 0.75rem;
  margin-left: -1px;
  color: #545cd8;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.pagination li a:hover {
  z-index: 2;
  color: rgb(67.2, 73.6, 172.8);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.pagination li a:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
}
.pagination li a:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.pagination li:first-child a {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.pagination li:last-child a {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.pagination li.active a {
  z-index: 1;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.pagination li.active a:hover {
  color: #fff;
}
.pagination li.disabled a {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-rounded li a {
  border-radius: 50px !important;
  margin: 0 0.3rem;
}

.chat-box-wrapper {
  display: flex;
  clear: both;
  padding: 0.75rem;
}
.chat-box-wrapper + .chat-box-wrapper {
  padding-top: 0;
}
.chat-box-wrapper .chat-box {
  box-shadow: 0 0 0 transparent;
  position: relative;
  opacity: 1;
  background: #e0f3ff;
  border: 0;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  border-top-left-radius: 0.25rem;
  flex: 1 1;
  display: flex;
  max-width: 50%;
  min-width: 100%;
  text-align: left;
}
.chat-box-wrapper .chat-box + small, .chat-box-wrapper .chat-box + .small {
  text-align: left;
  padding: 0.5rem 0 0;
  margin-left: 1.5rem;
  display: block;
}
.chat-box-wrapper.chat-box-wrapper-right {
  text-align: right;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box {
  border-radius: 30px;
  border-top-left-radius: 30px;
  border-top-right-radius: 0.25rem;
  margin-left: auto;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box + small, .chat-box-wrapper.chat-box-wrapper-right .chat-box + .small {
  text-align: right;
  margin-right: 1.5rem;
  margin-left: 0;
}

.forms-wizard {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: 100%;
  display: table;
  table-layout: fixed;
  border-radius: 0.25rem;
}
.forms-wizard li {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 1rem 0;
  color: #adb5bd;
  position: relative;
}
.forms-wizard li::after, .forms-wizard li::before {
  position: absolute;
  height: 4px;
  top: 50%;
  margin-top: -1rem;
  width: 50%;
  content: "";
  background: #dee2e6;
  z-index: 5;
  transition: all 0.2s;
}
.forms-wizard li::after {
  left: 50%;
}
.forms-wizard li::before {
  left: 0;
}
.forms-wizard li:first-child::before {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.forms-wizard li:last-child::after {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.forms-wizard li em {
  font-style: normal;
  font-size: 1.32rem;
  background: #ced4da;
  color: #fff;
  text-align: center;
  padding: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50px;
  display: block;
  margin: 0 auto 0.5rem;
  position: relative;
  z-index: 7;
  transition: all 0.2s;
}
.forms-wizard li.form-wizard-step-doing {
  color: #495057;
}
.forms-wizard li.form-wizard-step-doing em {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-doing::before {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-done em {
  font-family: "Linearicons-Free";
  background: #3ac47d;
  overflow: hidden;
}
.forms-wizard li.form-wizard-step-done em::before {
  width: 42px;
  height: 42px;
  font-size: 1.2rem;
  line-height: 40px;
  text-align: center;
  display: block;
}
.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {
  background: #3ac47d;
}
.forms-wizard li:hover {
  color: #6c757d;
}

.forms-wizard-alt .forms-wizard li {
  font-size: 0.88rem;
}
.forms-wizard-alt .forms-wizard li em {
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-indent: -999rem;
  border: #fff solid 2px;
  margin: -7px auto 0;
}

.forms-wizard-vertical .forms-wizard {
  display: block;
  width: 30%;
  float: left;
  padding: 0 1.5rem 1.5rem 0;
}
.forms-wizard-vertical .forms-wizard li {
  text-align: left;
  display: flex;
  align-items: center;
  align-content: flex-start;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.3rem;
  transition: all 0.2s;
}
.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
  display: none;
}
.forms-wizard-vertical .forms-wizard li em {
  margin: 0 0.75rem 0 0;
}
.forms-wizard-vertical .forms-wizard li:hover {
  background: #e9ecef;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
  background: #545cd8;
  color: #fff;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
  background: rgba(255, 255, 255, 0.2);
}
.forms-wizard-vertical .form-wizard-content {
  width: 70%;
  overflow: auto;
}

@media screen and (min-width: 360px) and (max-width: 812px) {
  .forms-wizard-vertical .forms-wizard {
    display: block;
    width: 50%;
    float: left;
    padding: 0 1.5rem 1.5rem 0;
  }
  .forms-wizard-vertical .forms-wizard li {
    text-align: left;
    display: flex;
    align-items: center;
    align-content: flex-start;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border-radius: 0.3rem;
    transition: all 0.2s;
  }
  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
    display: none;
  }
  .forms-wizard-vertical .forms-wizard li em {
    margin: 0 0.75rem 0 0;
  }
  .forms-wizard-vertical .forms-wizard li:hover {
    background: #e9ecef;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
    background: #545cd8;
    color: #fff;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
    background: rgba(255, 255, 255, 0.2);
  }
  .forms-wizard-vertical .form-wizard-content {
    width: 50%;
    overflow: auto;
  }
}
.icon-wrapper {
  display: flex;
  align-content: center;
  align-items: center;
}

.widget-chart {
  text-align: center;
  padding: 1rem;
  position: relative;
}
.widget-chart .progress-sub-label {
  opacity: 0.8;
  padding: 5px 0 0;
}
.widget-chart .progress-circle-wrapper {
  min-width: 68px;
  margin-right: 1rem;
}
.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {
  font-size: 0.8rem;
}
.widget-chart .widget-chart-content {
  position: relative;
  z-index: 5;
}
.widget-chart .widget-chart-content-lg {
  padding: 2rem 0 1rem 2rem;
}
.widget-chart .widget-chart-content-lg .widget-numbers {
  margin-bottom: 0;
}
.widget-chart .widget-chart-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.25;
  z-index: 6;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  overflow: hidden;
}
.widget-chart .widget-numbers {
  font-weight: bold;
  font-size: 2.5rem;
  display: block;
  line-height: 1;
  margin: 1rem auto;
}
.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {
  margin-top: -0.5rem;
}
.widget-chart .widget-subheading {
  margin: -0.5rem 0 0;
  display: block;
  opacity: 0.6;
}
.widget-chart .widget-subheading:first-child {
  margin-top: 0;
}
.widget-chart .widget-subheading + .widget-numbers {
  margin-top: 0.5rem;
}
.widget-chart .widget-description {
  margin: 1rem 0 0;
}
.widget-chart.widget-chart-hover {
  transition: all 0.2s;
}
.widget-chart.widget-chart-hover:hover {
  z-index: 15;
  transform: scale(1.15);
  box-shadow: 0 0.46875rem 4.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.9375rem 2.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.25rem 1.3125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06), 0 0.125rem 1.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06);
  cursor: pointer;
  background: #fff;
}
.widget-chart .widget-chart-actions {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 12;
}
.widget-chart .widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}
.widget-chart .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  margin: 0 -1px -1px;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {
  border-bottom-left-radius: 0.25rem;
}
.widget-chart .widget-chart-flex {
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 1rem;
}
.widget-chart .widget-chart-flex:last-child {
  margin-bottom: 0;
}
.widget-chart .widget-chart-flex .widget-subheading {
  margin: 0;
}
.widget-chart .widget-chart-flex .widget-description {
  margin-top: 0;
}
.widget-chart.text-start {
  flex-direction: row;
  align-items: center;
}
.widget-chart.text-start .icon-wrapper {
  min-width: 54px;
  margin: 0 1rem 0 0;
}
.widget-chart.text-start .widget-numbers {
  margin-left: 0;
}
.widget-chart.text-start .widget-chart-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  flex: 1 1;
  position: relative;
}
.widget-chart.text-start .widget-chart-content > .widget-numbers:first-child {
  margin-top: 0;
}
.widget-chart.text-start .widget-chart-content .widget-description {
  align-self: flex-start;
}
.widget-chart.text-start .widget-chart-wrapper {
  height: 35%;
}
.widget-chart.widget-chart-left {
  padding-bottom: 15%;
}
.widget-chart .chart-wrapper-relative {
  position: relative;
  opacity: 1;
  margin-top: 1rem;
}

.widget-chart-actions {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 12;
}
.widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}

.widget-chart:hover .widget-chart-actions .btn-link,
.widget-content:hover .widget-chart-actions .btn-link {
  opacity: 1;
}

.grid-menu .widget-chart.widget-chart-hover:hover {
  background: #fff;
  border-radius: 0.25rem;
}

.icon-wrapper {
  width: 54px;
  height: 54px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.icon-wrapper[class*=border-] {
  border-width: 1px;
  border-style: solid;
}
.icon-wrapper .icon-wrapper-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 3;
  opacity: 0.2;
}
.icon-wrapper .icon-wrapper-bg.bg-light {
  opacity: 0.08;
}
.icon-wrapper i {
  margin: 0 auto;
  font-size: 1.7rem;
  position: relative;
  z-index: 5;
}
.icon-wrapper i:before {
  margin-top: -3px;
}
.icon-wrapper .progress-circle-wrapper {
  width: 100%;
  margin-right: 0;
}

.widget-chart2 .widget-chart-flex {
  display: flex;
  align-items: baseline;
  align-content: center;
  margin-bottom: 0;
}
.widget-chart2 .widget-chart-flex .widget-subtitle {
  margin-left: auto;
}
.widget-chart2 .widget-chart-flex .widget-numbers {
  font-weight: normal;
}
.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {
  margin-bottom: 0;
}
.widget-chart2 .widget-chat-wrapper-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  max-width: 100%;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {
  height: 70px;
  opacity: 0.8;
  position: relative;
  margin: 1rem auto -0.5rem;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {
  height: 130px;
}

.card-btm-border {
  border-bottom: transparent solid 4px;
}

.progress-box {
  text-align: center;
}
.progress-box h4, .progress-box .h4 {
  font-size: 0.88rem;
  font-weight: bold;
  opacity: 0.6;
  text-transform: uppercase;
  padding-bottom: 0.3333333333rem;
}
.progress-box svg {
  margin: 0 auto;
}

.svg-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}
.svg-bg svg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.widget-numbers-sm {
  font-size: 1.5rem;
}

.widget-content {
  padding: 1rem;
  flex-direction: row;
  align-items: center;
}
.widget-content .widget-content-wrapper {
  display: flex;
  flex: 1 1;
  position: relative;
  align-items: center;
}
.widget-content .widget-content-left .widget-heading {
  opacity: 0.8;
  font-weight: bold;
}
.widget-content .widget-content-left .widget-subheading {
  opacity: 0.5;
}
.widget-content .widget-content-right {
  margin-left: auto;
}
.widget-content .widget-numbers {
  font-weight: bold;
  font-size: 1.8rem;
  display: block;
}
.widget-content .widget-content-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.widget-content .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-content .widget-progress-wrapper .progress-sub-label {
  margin-top: 0.3333333333rem;
  opacity: 0.5;
  display: flex;
  align-content: center;
  align-items: center;
}
.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {
  margin-left: auto;
}
.widget-content .widget-content-right.widget-content-actions {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}
.widget-content:hover .widget-content-right.widget-content-actions {
  visibility: visible;
  opacity: 1;
}

.profile-block {
  position: relative;
  overflow: hidden;
}
.profile-block .profile-blur {
  width: 100%;
  height: 100%;
  filter: blur(5px);
  transform: scale(1.8);
  position: absolute;
  left: -25%;
  top: -25%;
}
.profile-block .profile-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  left: 0;
  top: 0;
}
.profile-block .dropdown-menu-header .menu-header-content {
  padding: 3rem;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {
  margin: 0.75rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {
  color: #fff;
  padding: 0;
  width: 44px;
  height: 44px;
  line-height: 37px;
  font-size: 1.1rem;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.app-logo {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.app-logo-inverse {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.app-login-box .app-logo {
  margin-bottom: 3rem;
}
.app-login-box h4, .app-login-box .h4 {
  margin-bottom: 1.5rem;
  font-weight: normal;
}
.app-login-box h4 div, .app-login-box .h4 div {
  opacity: 0.6;
}
.app-login-box h4 span, .app-login-box .h4 span {
  font-size: 1.1rem;
}

.chat-container {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin: 0 auto;
  padding: 10px;
  height: 50vh;
  overflow-y: scroll;
  font-family: "Helvetica Neue", Arial, sans-serif;
}

.message-wrapper {
  display: flex;
  flex-direction: column;
}

.chat-message {
  display: flex;
  margin: 10px;
  padding: 10px;
  max-width: 50%;
  width: 100%;
  position: relative;
}

.left {
  justify-content: flex-start;
  align-self: flex-start;
}

.right {
  justify-content: flex-end;
  align-self: flex-end;
}

.chat-bubble {
  padding: 10px;
  border-radius: 15px;
  position: relative;
  background-color: white;
  width: 100%;
}

.left .chat-bubble {
  background-color: #f1f0f0;
}

.right .chat-bubble {
  background-color: #593196;
  margin-left: auto;
}

.chat-user-info {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.chat-profile-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.chat-user-name {
  font-weight: bold;
  color: #333;
}

.chat-message-content {
  margin-top: 5px;
}

.chat-message-content p {
  margin: 0;
  padding: 5px;
  font-size: 16px;
  word-wrap: break-word;
}

.chat-message-content small, .chat-message-content .small {
  display: block;
  text-align: right;
  font-size: 12px;
  color: gray;
}

.left .chat-bubble::before {
  content: "";
  position: absolute;
  top: 0;
  left: -8px;
  width: 20px;
  height: 20px;
  background-color: #f1f0f0;
  border-bottom-right-radius: 15px;
  transform: rotate(90deg);
}

.right .chat-bubble::before {
  content: "";
  position: absolute;
  top: 0;
  right: -8px;
  width: 20px;
  height: 20px;
  background-color: #593196;
  border-bottom-left-radius: 15px;
  transform: rotate(-90deg);
}

.chat-container::-webkit-scrollbar {
  width: 6px;
}

.chat-container::-webkit-scrollbar-thumb {
  background-color: #b0b0b0;
  border-radius: 3px;
}

.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {
  width: auto;
  float: none;
}
.app-inner-layout .app-inner-layout__header {
  width: 100%;
  padding: 1.5rem;
  text-align: left;
  border-bottom: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__header .app-page-title {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-inner-layout .app-inner-layout__header-boxed {
  padding: 1.5rem;
}
.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {
  border-radius: 0.3rem;
}
.app-inner-layout .app-inner-layout__wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {
  flex: 1 1;
  display: flex;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  border: 0;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
  padding: 0.75rem 1.5rem;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {
  display: flex;
  align-items: center;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {
  padding: 1.5rem;
  border-top: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {
  width: 270px;
  list-style: none;
  text-align: left;
  order: -1;
  flex: 0 0 270px;
  display: flex;
  margin: 0;
  position: relative;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {
  white-space: normal;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  background: #f8f9fa;
  border: 0;
  border-right: #e9ecef solid 1px;
  border-left: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {
  background: #f8f9fa;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {
  width: 60px;
}
.app-inner-layout .app-inner-layout__footer {
  width: 100%;
  height: 50px;
}

.app-wrapper-footer .app-footer {
  border-top: #e9ecef solid 1px;
}
.app-wrapper-footer .app-footer .app-footer__inner {
  border-left: #e9ecef solid 1px;
}

.chat-layout.app-inner-layout .app-inner-layout__sidebar {
  width: 360px;
  flex: 0 0 360px;
}
.chat-layout .app-inner-layout__top-pane h4, .chat-layout .app-inner-layout__top-pane .h4 {
  font-size: 1.1rem;
}
.chat-layout .app-inner-layout__top-pane h4 div, .chat-layout .app-inner-layout__top-pane .h4 div {
  font-size: 0.88rem;
}
.chat-layout .chat-box-wrapper {
  padding: 1.5rem;
}

@media (max-width: 991.98px) {
  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {
    white-space: normal;
  }
}
.mobile-app-menu-btn {
  display: none;
  margin: 3px 1.5rem 0 0;
}

@media (max-width: 767.98px) {
  .app-inner-layout__sidebar {
    display: none !important;
  }
  .mobile-app-menu-btn {
    display: block;
  }
  .open-mobile-menu .app-inner-layout__sidebar {
    display: block !important;
  }
}
/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none !important;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0;
  /* please don't change 'position' */
  position: absolute;
  z-index: 7;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
  border-radius: 50px;
  z-index: 7;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus {
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.12);
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.12);
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.scrollbar-container {
  position: relative;
  height: 100%;
}

.scroll-area {
  overflow-x: hidden;
  height: 400px;
}

.scroll-area-xs {
  height: 150px;
  overflow-x: hidden;
}

.scroll-area-sm {
  height: 200px;
  overflow-x: hidden;
}

.scroll-area-md {
  height: 300px;
  overflow-x: hidden;
}

.scroll-area-lg {
  height: 400px;
  overflow-x: hidden;
}

.scroll-area-x {
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
}

.shadow-overflow {
  position: relative;
}
.shadow-overflow::after, .shadow-overflow::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 1.5rem;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00ffffff", GradientType=0);
}
.shadow-overflow::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#ffffff", GradientType=0);
}

.rc-tabs {
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.rc-tabs-bar,
.rc-tabs-nav-container {
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  outline: none;
  zoom: 1;
  transition: padding 0.45s;
}

.rc-tabs-ink-bar {
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.rc-tabs-ink-bar-animated {
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
}

.rc-tabs-tab-prev,
.rc-tabs-tab-next {
  -webkit-user-select: none;
  user-select: none;
  z-index: 1;
  line-height: 36px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  position: absolute;
}

.rc-tabs-tab-prev-icon,
.rc-tabs-tab-next-icon {
  position: relative;
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  line-height: inherit;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  font-smoothing: antialiased;
  text-stroke-width: 0;
  font-family: sans-serif;
}

.rc-tabs-tab-prev-icon:before,
.rc-tabs-tab-next-icon:before {
  display: block;
}

.rc-tabs-tab-btn-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-nav-wrap {
  overflow: hidden;
}

.rc-tabs-nav {
  box-sizing: border-box;
  padding-left: 0;
  position: relative;
  margin: 0;
  float: left;
  list-style: none;
  display: inline-block;
  transform-origin: 0 0;
}
.rc-tabs-nav > div:first-child {
  z-index: 5;
  position: relative;
}

.rc-tabs-nav-animated {
  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);
}

.rc-tabs-nav:before,
.rc-tabs-nav:after {
  display: table;
  content: " ";
}

.rc-tabs-nav:after {
  clear: both;
}

.rc-tabs-tab {
  box-sizing: border-box;
  position: relative;
  display: block;
  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  padding: 8px 20px;
  cursor: pointer;
}

.rc-tabs-tab:hover {
  color: #545cd8;
}

.rc-tabs-tab-active,
.rc-tabs-tab-active:hover {
  color: #fff;
  cursor: default;
  transform: translateZ(0);
}

.rc-tabs-tab-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-tab-disabled:hover {
  color: #495057;
}

.rc-tabs-content {
  zoom: 1;
}

.rc-tabs-content .rc-tabs-tabpane {
  overflow: hidden;
}

.rc-tabs-content-animated {
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  display: flex;
  will-change: transform;
}

.rc-tabs-content-animated .rc-tabs-tabpane {
  flex-shrink: 0;
}

.no-flexbox .rc-tabs-content {
  transform: none !important;
  overflow: hidden;
}

.no-csstransitions .rc-tabs-tabpane-inactive,
.no-flexbox .rc-tabs-tabpane-inactive,
.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {
  display: none;
}

.rc-tabs-bottom .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-content {
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-container-scrolling {
  padding-left: 35px;
  padding-right: 35px;
}

.rc-tabs-top .rc-tabs-nav-scroll {
  width: 99999px;
}

.rc-tabs-top .rc-tabs-nav-swipe {
  position: relative;
  left: 0;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {
  display: flex;
  flex: 1 1;
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {
  display: flex;
  flex-shrink: 0;
  margin-right: 0;
  padding: 8px 0;
  justify-content: center;
}

.rc-tabs-top .rc-tabs-nav-wrap {
  width: 100%;
  padding: 1.5rem 0.75rem;
}

.rc-tabs-top .rc-tabs-content-animated {
  flex-direction: row;
}

.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {
  width: 100%;
}

.rc-tabs-top .rc-tabs-tab-next {
  right: 2px;
}

.rc-tabs-top .rc-tabs-tab-next-icon:before {
  content: ">";
}

.rc-tabs-top .rc-tabs-tab-prev {
  left: 0;
}

.rc-tabs-top .rc-tabs-tab-prev-icon:before {
  content: "<";
}

.rc-tabs-top .rc-tabs-tab-prev,
.rc-tabs-top .rc-tabs-tab-next {
  margin-right: -2px;
  width: 0;
  height: 0;
  top: 0;
  text-align: center;
  opacity: 0;
  transition: width 0.3s, height 0.3s, opacity 0.3s;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 35px;
  height: 100%;
}

.rc-tabs-top .rc-tabs-ink-bar {
  height: 35px;
  bottom: 0;
  left: 0;
  background: #545cd8;
}

.rc-tabs-top .rc-tabs-tab {
  float: left;
  height: 100%;
  line-height: 1.3;
  margin-right: 0.75rem;
}

.rc-tabs-top .rc-tabs-tabpane-inactive {
  height: 0;
  overflow: visible;
}

/*!
 * Ladda
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2018 Hakim El Hattab, http://hakim.se
 */
/*************************************
 * CONFIG
 */
/*************************************
 * MIXINS
 */
/*************************************
 * Opacity animation for spin.js
 */
@keyframes ladda-spinner-line-fade {
  0%, 100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
/*************************************
 * BUTTON BASE
 */
.ladda-button {
  position: relative;
}

/* Spinner animation */
.ladda-button .ladda-spinner {
  position: absolute;
  z-index: 2;
  display: inline-block;
  width: 32px;
  top: 50%;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
}

/* Button label */
.ladda-button .ladda-label {
  position: relative;
  z-index: 3;
}

[class*=btn-outline-] .ladda-spinner div div div {
  background: #000 !important;
}
[class*=btn-outline-].ladda-button .ladda-label {
  transition: none !important;
}

/* Progress bar */
.ladda-button .ladda-progress {
  position: absolute;
  width: 0;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  display: none;
  transition: 0.1s linear all !important;
}

.ladda-button[data-loading] .ladda-progress {
  display: block;
}

/*************************************
 * EASING
 */
.ladda-button,
.ladda-button .ladda-spinner,
.ladda-button .ladda-label {
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
}

.ladda-button[data-style=zoom-in],
.ladda-button[data-style=zoom-in] .ladda-spinner,
.ladda-button[data-style=zoom-in] .ladda-label,
.ladda-button[data-style=zoom-out],
.ladda-button[data-style=zoom-out] .ladda-spinner,
.ladda-button[data-style=zoom-out] .ladda-label {
  transition: 0.3s ease all !important;
}

/*************************************
 * EXPAND RIGHT
 */
.ladda-button[data-style=expand-right] .ladda-spinner {
  right: -6px;
}
.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {
  right: -12px;
}
.ladda-button[data-style=expand-right][data-loading] {
  padding-right: 56px;
}
.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {
  padding-right: 40px;
}

/*************************************
 * EXPAND LEFT
 */
.ladda-button[data-style=expand-left] .ladda-spinner {
  left: 26px;
}
.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {
  left: 4px;
}
.ladda-button[data-style=expand-left][data-loading] {
  padding-left: 56px;
}
.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {
  padding-left: 40px;
}

/*************************************
 * EXPAND UP
 */
.ladda-button[data-style=expand-up] {
  overflow: hidden;
}
.ladda-button[data-style=expand-up] .ladda-spinner {
  top: -32px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-up][data-loading] {
  padding-top: 54px;
}
.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {
  opacity: 1;
  top: 26px;
  margin-top: 0;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {
  padding-top: 32px;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {
  top: 4px;
}

/*************************************
 * EXPAND DOWN
 */
.ladda-button[data-style=expand-down] {
  overflow: hidden;
}
.ladda-button[data-style=expand-down] .ladda-spinner {
  top: 52px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {
  top: 40px;
}
.ladda-button[data-style=expand-down][data-loading] {
  padding-bottom: 54px;
}
.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {
  padding-bottom: 32px;
}

/*************************************
 * SLIDE LEFT
 */
.ladda-button[data-style=slide-left] {
  overflow: hidden;
}
.ladda-button[data-style=slide-left] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-left] .ladda-spinner {
  left: 100%;
  margin-left: 0;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-label {
  opacity: 0;
  left: -100%;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE RIGHT
 */
.ladda-button[data-style=slide-right] {
  overflow: hidden;
}
.ladda-button[data-style=slide-right] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-right] .ladda-spinner {
  right: 100%;
  margin-left: 0;
  left: 16px;
}
[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {
  right: auto;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-label {
  opacity: 0;
  left: 100%;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE UP
 */
.ladda-button[data-style=slide-up] {
  overflow: hidden;
}
.ladda-button[data-style=slide-up] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-up] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: 1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-label {
  opacity: 0;
  top: -1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * SLIDE DOWN
 */
.ladda-button[data-style=slide-down] {
  overflow: hidden;
}
.ladda-button[data-style=slide-down] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-down] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: -2em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-label {
  opacity: 0;
  top: 1em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * ZOOM-OUT
 */
.ladda-button[data-style=zoom-out] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-out] .ladda-spinner {
  left: 50%;
  margin-left: 32px;
  transform: scale(2.5);
}

.ladda-button[data-style=zoom-out] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(0.5);
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * ZOOM-IN
 */
.ladda-button[data-style=zoom-in] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-in] .ladda-spinner {
  left: 50%;
  margin-left: -16px;
  transform: scale(0.2);
}

.ladda-button[data-style=zoom-in] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(2.2);
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * CONTRACT
 */
.ladda-button[data-style=contract] {
  overflow: hidden;
  width: 100px;
}

.ladda-button[data-style=contract] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract][data-loading] {
  border-radius: 50%;
  width: 52px;
}

.ladda-button[data-style=contract][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract][data-loading] .ladda-spinner {
  opacity: 1;
}

/*************************************
 * OVERLAY
 */
.ladda-button[data-style=contract-overlay] {
  overflow: hidden;
  width: 100px;
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);
}

.ladda-button[data-style=contract-overlay] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] {
  border-radius: 50%;
  width: 52px;
  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {
  opacity: 1;
}

[dir=rtl] .ladda-spinner > div {
  left: 25% !important;
}

/*!
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0px 0px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger.is-active:hover {
  opacity: 0.7;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #545cd8;
}

.hamburger-box {
  width: 24px;
  height: 14px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -1px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #545cd8;
  border-radius: 10px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -6px;
}
.hamburger-inner::after {
  bottom: -6px;
}

/*
 * Elastic
 */
.hamburger--elastic .hamburger-inner {
  top: 1px;
  transition-duration: 0.275s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic .hamburger-inner::before {
  top: 6px;
  transition: opacity 0.125s 0.275s ease;
}
.hamburger--elastic .hamburger-inner::after {
  top: 12px;
  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic.is-active .hamburger-inner {
  transform: translate3d(0, 6px, 0) rotate(135deg);
  transition-delay: 0.075s;
}
.hamburger--elastic.is-active .hamburger-inner::before {
  transition-delay: 0s;
  opacity: 0;
}
.hamburger--elastic.is-active .hamburger-inner::after {
  transform: translate3d(0, -12px, 0) rotate(-270deg);
  transition-delay: 0.075s;
}

.drawer-content-wrapper {
  background: #fff;
  position: relative;
  padding: 1.5rem;
}
.drawer-content-wrapper .drawer-heading {
  font-size: 0.968rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
}
.drawer-content-wrapper .drawer-heading:first-child {
  border-top: 0;
}
.drawer-content-wrapper .drawer-section {
  padding: 1.5rem;
}
.drawer-content-wrapper > .app-sidebar__heading:first-child {
  margin-top: 0;
}

.drawer-nav-btn {
  border-radius: 30px;
  background: #fff;
  position: fixed;
  right: 0.75rem;
  top: 0.75rem;
  padding: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  z-index: 20;
}
.drawer-nav-btn .hamburger {
  margin-top: 4px;
}

.sa-icon {
  width: 80px;
  height: 80px;
  border: 4px solid #dee2e6;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}
.sa-icon.sa-error {
  border-color: #d92550;
}
.sa-icon.sa-error .sa-x-mark {
  position: relative;
  display: block;
}
.sa-icon.sa-error .sa-line {
  position: absolute;
  height: 5px;
  width: 47px;
  background-color: #d92550;
  display: block;
  top: 37px;
  border-radius: 2px;
}
.sa-icon.sa-error .sa-line.sa-left {
  transform: rotate(45deg);
  left: 17px;
}
.sa-icon.sa-error .sa-line.sa-right {
  transform: rotate(-45deg);
  right: 16px;
}
.sa-icon.sa-warning {
  border-color: #f7b924;
}
.sa-icon.sa-warning .sa-body {
  position: absolute;
  width: 5px;
  height: 47px;
  left: 50%;
  top: 10px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #f7b924;
}
.sa-icon.sa-warning .sa-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  bottom: 10px;
  background-color: #f7b924;
}
.sa-icon.sa-info {
  border-color: #30b1ff;
}
.sa-icon.sa-info::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #30b1ff;
}
.sa-icon.sa-info::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  top: 19px;
  background-color: #30b1ff;
}
.sa-icon.sa-success {
  border-color: #3ac47d;
}
.sa-icon.sa-success::before, .sa-icon.sa-success::after {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  transform: rotate(45deg);
}
.sa-icon.sa-success::before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}
.sa-icon.sa-success::after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}
.sa-icon.sa-success .sa-placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(165, 220, 134, 0.2);
  border-radius: 40px;
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}
.sa-icon.sa-success .sa-fix {
  width: 5px;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}
.sa-icon.sa-success .sa-line {
  height: 5px;
  background-color: #3ac47d;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}
.sa-icon.sa-success .sa-line.sa-tip {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}
.sa-icon.sa-success .sa-line.sa-long {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}
.sa-icon.sa-custom {
  background-size: contain;
  border-radius: 0;
  border: none;
  background-position: center center;
  background-repeat: no-repeat;
}
@keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
.animateSuccessTip {
  animation: animateSuccessTip 0.75s;
}

.animateSuccessLong {
  animation: animateSuccessLong 0.75s;
}

.sa-icon.sa-success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}

/* Success icon */
.sweet-alert .sa-icon.sa-success {
  border-color: transparent \\9 ;
}

.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {
  -ms-transform: rotate(45deg) \\9 ;
}

.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {
  -ms-transform: rotate(-45deg) \\9 ;
}

.Toastify__toast-container {
  z-index: 9999;
  position: fixed;
  padding: 0;
  width: 320px;
  box-sizing: border-box;
  color: #fff;
}
.Toastify__toast-container--top-left {
  top: 1rem;
  left: 1rem;
}
.Toastify__toast-container--top-center {
  top: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--top-right {
  top: 1rem;
  right: 1rem;
}
.Toastify__toast-container--bottom-left {
  bottom: 1rem;
  left: 1rem;
}
.Toastify__toast-container--bottom-center {
  bottom: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--bottom-right {
  bottom: 1rem;
  right: 1rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: 0;
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: auto;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: 54px;
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  display: flex;
  justify-content: space-between;
  max-height: 800px;
  overflow: hidden;
  font-family: sans-serif;
  cursor: pointer;
  direction: ltr;
}
.Toastify__toast--rtl {
  direction: rtl;
}
.Toastify__toast--default {
  background: #fff;
  color: #495057;
  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);
}
.Toastify__toast--info {
  background: #30b1ff;
  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);
}
.Toastify__toast--success {
  background: #3ac47d;
  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);
}
.Toastify__toast--warning {
  background: #f7b924;
  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);
}
.Toastify__toast--error {
  background: #d92550;
  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);
}
.Toastify__toast-body {
  margin: auto 0;
  padding: 0 0 0.4rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast {
    margin-bottom: 0;
  }
}
.Toastify__close-button {
  color: #fff;
  font-size: 14px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  position: absolute;
  top: 5px;
  right: 9px;
}
.Toastify__close-button--default {
  color: #000;
  opacity: 0.3;
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    width: 96%;
  }
  100% {
    width: 0;
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 9%;
  left: 2%;
  width: 0;
  height: 5px;
  z-index: 9999;
  animation: Toastify__trackProgress linear 1;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 0.25rem;
}
.Toastify__progress-bar--rtl {
  right: 0;
  left: auto;
  left: initial;
}
.Toastify__progress-bar--default {
  background: #545cd8;
}
@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}
.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}
.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}
.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}
.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}
.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}
.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}
.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}
.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

/* -- container -- */
.rodal,
.rodal-mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.rodal {
  position: fixed;
}

/* -- mask -- */
.rodal-mask {
  position: absolute;
  background-color: #000;
  opacity: 0.5;
}

/* -- dialog -- */
.rodal-dialog {
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 101;
  background: #fff;
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.25rem;
  height: auto !important;
}

.rodal-dialog:focus {
  outline: none;
}

/* -- close button -- */
.rodal-close {
  position: absolute;
  cursor: pointer;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
}

.rodal-close:before,
.rodal-close:after {
  position: absolute;
  content: "";
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #adb5bd;
  border-radius: 100%;
  transition: background 0.2s;
}

.rodal-close:before {
  transform: rotate(45deg);
}

.rodal-close:after {
  transform: rotate(-45deg);
}

.rodal-close:hover:before,
.rodal-close:hover:after {
  background: #343a40;
}

/* -- fade -- */
@keyframes rodal-fade-enter {
  from {
    opacity: 0;
  }
}
.rodal-fade-enter {
  animation: rodal-fade-enter both ease-in;
}

@keyframes rodal-fade-leave {
  to {
    opacity: 0;
  }
}
.rodal-fade-leave {
  animation: rodal-fade-leave both ease-out;
}

@keyframes rodal-zoom-enter {
  from {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-enter {
  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-zoom-leave {
  to {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-leave {
  animation: rodal-zoom-leave both;
}

@keyframes rodal-slideDown-enter {
  from {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-enter {
  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideDown-leave {
  to {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-leave {
  animation: rodal-slideDown-leave both;
}

/* -- slideLeft -- */
@keyframes rodal-slideLeft-enter {
  from {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-enter {
  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideLeft-leave {
  to {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-leave {
  animation: rodal-slideLeft-leave both;
}

/* -- slideRight -- */
@keyframes rodal-slideRight-enter {
  from {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-enter {
  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideRight-leave {
  to {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-leave {
  animation: rodal-slideRight-leave both;
}

/* -- slideUp -- */
@keyframes rodal-slideUp-enter {
  from {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-enter {
  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideUp-leave {
  to {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-leave {
  animation: rodal-slideUp-leave both;
}

/* -- flip -- */
@keyframes rodal-flip-enter {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);
  }
  70% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px);
  }
}
.rodal-flip-enter {
  animation: rodal-flip-enter both ease-in;
  -webkit-backface-visibility: visible !important;
          backface-visibility: visible !important;
}

@keyframes rodal-flip-leave {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);
  }
}
.rodal-flip-leave {
  animation: rodal-flip-leave both;
  -webkit-backface-visibility: visible !important;
          backface-visibility: visible !important;
}

/* -- rotate -- */
@keyframes rodal-rotate-enter {
  from {
    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-enter {
  animation: rodal-rotate-enter both;
  transform-origin: center;
}

@keyframes rodal-rotate-leave {
  to {
    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-leave {
  animation: rodal-rotate-leave both;
  transform-origin: center;
}

/* -- door -- */
@keyframes rodal-door-enter {
  from {
    transform: scale3d(0, 1, 1);
  }
}
.rodal-door-enter {
  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-door-leave {
  60% {
    transform: scale3d(0.01, 1, 1);
  }
  to {
    transform: scale3d(0, 1, 0.1);
  }
}
.rodal-door-leave {
  animation: rodal-door-leave both;
}

.react-sweet-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.react-sweet-progress-symbol {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 35px;
  height: 20px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 200;
}

.react-sweet-progress-symbol-absolute {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  align-items: center;
  justify-content: center;
  transform: translate3d(-50%, -50%, 0);
}

.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {
  padding: 0;
  width: 100%;
}

.react-sweet-progress-circle-outer {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.react-sweet-progress-line {
  width: 100%;
  border-radius: 100px;
  background-color: #efefef;
  vertical-align: middle;
}

.react-sweet-progress-line-inner {
  position: relative;
  min-height: 10px;
  border-radius: 100px;
  transition: width 0.3s ease;
}

.react-sweet-progress-line-inner-status-active:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  background: #fff;
  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;
  content: "";
  opacity: 0;
}

@keyframes active-anim {
  0% {
    width: 0;
    opacity: 0.1;
  }
  20% {
    width: 0;
    opacity: 0.5;
  }
  to {
    width: 100%;
    opacity: 0;
  }
}
.react-sweet-progress-circle path {
  stroke-linecap: round;
}

/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.slick-slider-sm .slick-slider {
  max-width: 450px;
}
.slick-slider-sm .slick-slider .slick-prev {
  left: -20px;
}
.slick-slider-sm .slick-slider .slick-next {
  right: -20px;
}

.slick-slider-md .slick-slider {
  max-width: 650px;
  margin: 0 auto;
}

.slick-slider-hover .slick-arrow {
  opacity: 0;
  background: #545cd8;
  color: #fff !important;
}
.slick-slider-hover .slick-prev {
  left: -30px;
}
.slick-slider-hover .slick-next {
  right: -30px;
}
.slick-slider-hover:hover .slick-arrow {
  opacity: 1;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 40px;
  width: 40px;
  cursor: pointer;
  color: #6c757d;
  top: 50%;
  transform: translate(0, -80%);
  padding: 0;
  border: none;
  outline: none;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  transition: all 0.2s;
  font-family: "Pe-icon-7-stroke";
  border-radius: 50px;
  background: #fff;
  z-index: 6;
  overflow: hidden;
}
.slick-prev::before,
.slick-next::before {
  font-size: 35px;
  height: 40px;
  line-height: 40px;
  width: 40px;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  color: #545cd8;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}

.slick-prev {
  left: 0;
}
.slick-prev:before {
  content: "\\e686";
}

.slick-next {
  right: 0;
}
.slick-next:before {
  content: "\\e684";
}

/* Dots */
.slick-dots {
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0.75rem 0 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  padding: 0;
  margin: 0 5px;
  cursor: pointer;
  transform: scale(0.8);
  transition: all 0.2s;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 14px;
  width: 14px;
  background: #545cd8;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  color: transparent;
}
.slick-dots li button::before {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.slick-dots li.slick-active {
  transform: scale(1.2);
}

.slick-center {
  transform: scale(1.1);
}

.slick-slider .slide-img-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  opacity: 0.4;
  z-index: 10;
}
.slick-slider .slider-content {
  position: relative;
  z-index: 15;
  text-align: center;
  margin: 0 6rem;
}
.slick-slider .slider-content h3, .slick-slider .slider-content .h3 {
  font-size: 1.54rem;
  font-weight: normal;
  margin-bottom: 1.5rem;
}
.slick-slider .slider-content p {
  font-size: 0.88rem;
  opacity: 0.7;
}

.slider-light .slick-dots {
  position: absolute;
  bottom: 10px;
}
.slider-light .slick-dots li button {
  background: rgba(255, 255, 255, 0.25);
}
.slider-light .slick-prev,
.slider-light .slick-next {
  background: transparent;
  color: #fff;
  box-shadow: 0 0 0 0 transparent;
}
.slider-light .slick-prev:hover,
.slider-light .slick-next:hover {
  background: rgba(255, 255, 255, 0.15);
}
.slider-light .slick-next {
  right: 15px;
}
.slider-light .slick-prev {
  left: 15px;
}
.slider-light .slider-content {
  color: #fff;
}

.loading-indicator {
  text-align: center;
}

.loading-bullet {
  display: inline-block;
  opacity: 0;
  font-size: 2em;
  color: #02a17c;
}

.block-ui {
  position: relative;
  min-height: 3em;
}

.block-ui-container {
  position: absolute;
  z-index: 1010;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  min-height: 2em;
  cursor: wait;
  overflow: hidden;
}

.block-ui-container:focus {
  outline: none;
}

.block-ui-overlay {
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  background-color: white;
}

.block-ui-message-container {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  right: 0;
  text-align: center;
  transform: translateY(-50%);
  z-index: 10001;
}

.block-ui-message {
  color: #333;
  background: none;
  z-index: 1011;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-overlay-dark .block-ui-overlay {
  background: rgb(0, 0, 0);
}

.popover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.popover .grid-menu {
  margin-bottom: -1rem;
  padding: 1px;
}
.popover .grid-menu [class*=col-] {
  padding: 1rem;
}
.popover .grid-menu + .nav .nav-item-btn {
  margin-bottom: 1rem;
}
.popover .grid-menu-xl {
  margin-bottom: -0.7407407407rem;
}
.popover .grid-menu-xl [class*=col-] {
  padding: 0;
}
.popover .popover-inner .dropdown-menu-header {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
  margin-top: -1px;
  margin-left: -1px;
  margin-right: -1px;
}

.rm-max-width > .popover {
  max-width: none;
  max-width: initial;
}

.rm-pointers > .popover .arrow {
  display: none !important;
}

.popover-primary {
  background-color: #545cd8 !important;
}

.popover-secondary {
  background-color: #6c757d !important;
}

.popover-success {
  background-color: #3ac47d !important;
}

.popover-info {
  background-color: #30b1ff !important;
}

.popover-warning {
  background-color: #f7b924 !important;
}

.popover-danger {
  background-color: #d92550 !important;
}

.popover-light {
  background-color: #eeeeee !important;
}

.popover-dark {
  background-color: #343a40 !important;
}

.popover-focus {
  background-color: #444054 !important;
}

.popover-alternate {
  background-color: #83588a !important;
}

.popover-custom .popover-body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.popover-custom .popover-body .dropdown-menu-header {
  margin-top: 0;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
}
.popover-custom .popover-body .dropdown-menu-header .menu-header-content {
  padding: 0 1.5rem;
}
.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {
  color: rgba(0, 0, 0, 0.8);
}
.popover-custom.popover-custom-lg {
  min-width: 22rem;
}
.popover-custom.popover-custom-xl {
  min-width: 25rem;
}
.popover-custom.popover-custom-sm {
  min-width: 15rem;
}

.popover-bg {
  border: 0;
}
.popover-bg .arrow {
  display: none;
}
.popover-bg .popover-header {
  background: rgba(255, 255, 255, 0.1);
  border-bottom: 0;
  color: rgb(255, 255, 255);
}
.popover-bg .popover-header::before {
  display: none;
}
.popover-bg .popover-body {
  color: rgba(255, 255, 255, 0.7);
}
.popover-bg.text-dark .popover-header {
  color: rgba(0, 0, 0, 0.8);
}
.popover-bg.text-dark .popover-body {
  color: rgba(0, 0, 0, 0.7);
}

.tooltip-light > .tooltip .tooltip-inner {
  background: #fff;
  color: #343a40;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  border: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125) solid 1px;
}
.tooltip-light > .tooltip .arrow {
  display: none;
}

.scrollable-block {
  margin-bottom: 50px;
  overflow: hidden;
  position: relative;
}
.scrollable-block .sticky {
  z-index: 2;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1;
  min-height: 580px;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full, .rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: rgb(178.5, 178.5, 178.5);
}

.rbc-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  flex: 1 0;
  flex-basis: auto !important;
}
.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  z-index: 4;
}

.rbc-today {
  background-color: #e0f3ff;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  width: 100%;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #fff;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: #545cd8;
  border: 1px solid #545cd8;
  padding: 0.375rem 1rem;
  border-radius: 0.25rem;
  line-height: normal;
  white-space: nowrap;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 0.88rem;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);
}
.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgb(39.6128571429, 47.7385714286, 173.6871428571);
  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);
}
.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);
}
.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-event {
  cursor: pointer;
  padding: 0.125rem;
  background-color: #545cd8;
  border-radius: 0.25rem;
  color: #fff;
}
.rbc-event.rbc-selected {
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  height: 100%;
}
.rbc-month-view .rbc-header {
  border-bottom: 1px solid #e9ecef;
}
.rbc-month-view .rbc-header + .rbc-header {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #e9ecef;
}

.rbc-date-cell {
  padding-right: 5px;
  text-align: right;
  flex: 1 1;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-off-range-bg {
  background: #f8f9fa;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}
.rbc-agenda-view table {
  width: 100%;
  border: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table tbody > tr > td + td {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr + tr {
  border-top: 1px solid #e9ecef;
}
.rbc-agenda-view table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #e9ecef;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-event {
  border: 1px solid rgb(46.2428571429, 55.7285714286, 202.7571428571);
  display: flex;
  max-height: 100%;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid white;
}

.rbc-time-slot {
  flex: 1 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-day-slot .rbc-event {
  position: absolute;
  z-index: 2;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.5);
  color: #white;
  font-size: 75%;
  padding: 3px;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #e9ecef;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}
.rbc-time-view .rbc-allday-cell {
  width: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row > * + * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header > .rbc-row > * + * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #e9ecef;
}
.rbc-time-header .rbc-gutter-cell {
  flex: none;
}
.rbc-time-header > .rbc-gutter-cell + * {
  width: 100%;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #e9ecef;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 1;
  left: 0;
  height: 1px;
  background-color: #3ac47d;
  pointer-events: none;
}
.rbc-current-time-indicator::before {
  display: block;
  position: absolute;
  left: -3px;
  top: -3px;
  content: " ";
  background-color: #3ac47d;
  border-radius: 50%;
  width: 8px;
  height: 8px;
}
.rbc-rtl .rbc-current-time-indicator::before {
  left: 0;
  right: -3px;
}

.handle-bar {
  background: transparent !important;
  border-radius: 30px;
}
.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {
  background-color: #e9ecef !important;
}
.handle-bar.resize-not-allowed:hover {
  background-color: #e9ecef;
}
.handle-bar .handle-bar_drag {
  border-color: #545cd8 !important;
}

/**
 * Extra class applied to VirtualScroll through className prop
 */
.rst__virtualScrollOverride {
  overflow: auto !important;
}

.ReactVirtualized__Grid__innerScrollContainer {
  overflow: visible !important;
}

.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {
  direction: rtl;
}

.ReactVirtualized__Grid {
  outline: none;
}

.rst__node {
  min-width: 100%;
  white-space: nowrap;
  position: relative;
  text-align: left;
}

.rst__node.rst__rtl {
  text-align: right;
}

.rst__nodeContent {
  position: absolute;
  top: 0;
  bottom: 0;
}

/* ==========================================================================
   Scaffold

    Line-overlaid blocks used for showing the tree structure
   ========================================================================== */
.rst__lineBlock,
.rst__absoluteLineBlock {
  height: 100%;
  position: relative;
  display: inline-block;
}

.rst__absoluteLineBlock {
  position: absolute;
  top: 0;
}

.rst__lineHalfHorizontalRight::before,
.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  position: absolute;
  content: "";
  background-color: black;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |     |
 * +-----+
 */
.rst__lineHalfHorizontalRight::before {
  height: 1px;
  top: 50%;
  right: 0;
  width: 50%;
}

.rst__rtl.rst__lineHalfHorizontalRight::before {
  left: 0;
  right: auto;
  right: initial;
}

.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  width: 1px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__lineFullVertical::after,
.rst__rtl.rst__lineHalfVerticalTop::after,
.rst__rtl.rst__lineHalfVerticalBottom::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__lineHalfVerticalTop::after {
  height: 50%;
}

.rst__lineHalfVerticalBottom::after {
  top: auto;
  bottom: 0;
  height: 50%;
}

/* Highlight line for pointing to dragged row destination
   ========================================================================== */
.rst__highlightLineVertical {
  z-index: 3;
}

.rst__highlightLineVertical::before {
  position: absolute;
  content: "";
  background-color: #545cd8;
  width: 8px;
  margin-left: -4px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__highlightLineVertical::before {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  left: auto;
  left: initial;
  right: 50%;
}

@keyframes arrow-pulse {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  30% {
    transform: translate(0, 300%);
    opacity: 1;
  }
  70% {
    transform: translate(0, 700%);
    opacity: 1;
  }
  100% {
    transform: translate(0, 1000%);
    opacity: 0;
  }
}
.rst__highlightLineVertical::after {
  content: "";
  position: absolute;
  height: 0;
  margin-left: -4px;
  left: 50%;
  top: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid white;
  animation: arrow-pulse 1s infinite linear both;
}

.rst__rtl.rst__highlightLineVertical::after {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  right: 50%;
  left: auto;
  left: initial;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |  |  |
 * +--+--+
 */
.rst__highlightTopLeftCorner::before {
  z-index: 3;
  content: "";
  position: absolute;
  border-top: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(50% + 4px);
  top: 50%;
  margin-top: -4px;
  right: 0;
  width: calc(50% + 4px);
}

.rst__rtl.rst__highlightTopLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 0;
  right: auto;
  right: initial;
}

/**
 * +--+--+
 * |  |  |
 * |  |  |
 * |  +->|
 * +-----+
 */
.rst__highlightBottomLeftCorner {
  z-index: 3;
}

.rst__highlightBottomLeftCorner::before {
  content: "";
  position: absolute;
  border-bottom: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(100% + 4px);
  top: 0;
  right: 12px;
  width: calc(50% - 8px);
}

.rst__rtl.rst__highlightBottomLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 12px;
  right: auto;
  right: initial;
}

.rst__highlightBottomLeftCorner::after {
  content: "";
  position: absolute;
  height: 0;
  right: 0;
  top: 100%;
  margin-top: -12px;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid #545cd8;
}

.rst__rtl.rst__highlightBottomLeftCorner::after {
  left: 0;
  right: auto;
  right: initial;
  border-right: 12px solid #545cd8;
  border-left: none;
}

.rst__rowWrapper {
  padding: 10px 10px 10px 0;
  height: 100%;
  box-sizing: border-box;
}

.rst__rtl.rst__rowWrapper {
  padding: 10px 0 10px 10px;
}

.rst__row {
  height: 100%;
  white-space: nowrap;
  display: flex;
}

.rst__row > * {
  box-sizing: border-box;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__rowLandingPad,
.rst__rowCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__rowLandingPad > *,
.rst__rowCancelPad > * {
  opacity: 0 !important;
}

.rst__rowLandingPad::before,
.rst__rowCancelPad::before {
  background-color: lightblue;
  border: 1px dashed #fff;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__rowCancelPad::before {
  background-color: #e6a8ad;
}

/**
 * Nodes matching the search conditions are highlighted
 */
.rst__rowSearchMatch {
  outline: solid 3px #0080ff;
}

/**
 * The node that matches the search conditions and is currently focused
 */
.rst__rowSearchFocus {
  outline: solid 3px #fc6421;
}

.rst__rowContents,
.rst__rowLabel,
.rst__rowToolbar,
.rst__moveHandle,
.rst__toolbarButton {
  display: inline-block;
  vertical-align: middle;
}

.rst__rowContents {
  position: relative;
  height: 100%;
  border: solid #dee2e6 1px;
  border-left: none;
  padding: 0 5px 0 10px;
  border-radius: 2px;
  min-width: 230px;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

.rst__rtl.rst__rowContents {
  border-right: none;
  border-left: solid #dee2e6 1px;
  padding: 0 10px 0 5px;
}

.rst__rowContentsDragDisabled {
  border-left: solid #dee2e6 1px;
}

.rst__rtl.rst__rowContentsDragDisabled {
  border-right: solid #dee2e6 1px;
  border-left: solid #dee2e6 1px;
}

.rst__rowLabel {
  flex: 0 1 auto;
  padding-right: 20px;
}

.rst__rtl.rst__rowLabel {
  padding-left: 20px;
  padding-right: inherit;
}

.rst__rowToolbar {
  flex: 0 1 auto;
  display: flex;
}

.rst__moveHandle,
.rst__loadingHandle {
  height: 100%;
  width: 44px;
  background: #e9ecef url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center;
  border: solid #aaa 1px;
  cursor: move;
  border-radius: 1px;
  z-index: 1;
}

.rst__loadingHandle {
  cursor: default;
  background: #e9ecef;
}

@keyframes pointFade {
  0%, 19.999%, 100% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
}
.rst__loadingCircle {
  width: 80%;
  height: 80%;
  margin: 10%;
  position: relative;
}

.rst__loadingCirclePoint {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.rst__rtl.rst__loadingCirclePoint {
  right: 0;
  left: auto;
  left: initial;
}

.rst__loadingCirclePoint::before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 11%;
  height: 30%;
  background-color: #fff;
  border-radius: 30%;
  animation: pointFade 800ms infinite ease-in-out both;
}

.rst__loadingCirclePoint:nth-of-type(1) {
  transform: rotate(0deg);
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(1)::before,
.rst__loadingCirclePoint:nth-of-type(7)::before {
  animation-delay: -800ms;
}

.rst__loadingCirclePoint:nth-of-type(2) {
  transform: rotate(30deg);
}

.rst__loadingCirclePoint:nth-of-type(8) {
  transform: rotate(210deg);
}

.rst__loadingCirclePoint:nth-of-type(2)::before,
.rst__loadingCirclePoint:nth-of-type(8)::before {
  animation-delay: -666ms;
}

.rst__loadingCirclePoint:nth-of-type(3) {
  transform: rotate(60deg);
}

.rst__loadingCirclePoint:nth-of-type(9) {
  transform: rotate(240deg);
}

.rst__loadingCirclePoint:nth-of-type(3)::before,
.rst__loadingCirclePoint:nth-of-type(9)::before {
  animation-delay: -533ms;
}

.rst__loadingCirclePoint:nth-of-type(4) {
  transform: rotate(90deg);
}

.rst__loadingCirclePoint:nth-of-type(10) {
  transform: rotate(270deg);
}

.rst__loadingCirclePoint:nth-of-type(4)::before,
.rst__loadingCirclePoint:nth-of-type(10)::before {
  animation-delay: -400ms;
}

.rst__loadingCirclePoint:nth-of-type(5) {
  transform: rotate(120deg);
}

.rst__loadingCirclePoint:nth-of-type(11) {
  transform: rotate(300deg);
}

.rst__loadingCirclePoint:nth-of-type(5)::before,
.rst__loadingCirclePoint:nth-of-type(11)::before {
  animation-delay: -266ms;
}

.rst__loadingCirclePoint:nth-of-type(6) {
  transform: rotate(150deg);
}

.rst__loadingCirclePoint:nth-of-type(12) {
  transform: rotate(330deg);
}

.rst__loadingCirclePoint:nth-of-type(6)::before,
.rst__loadingCirclePoint:nth-of-type(12)::before {
  animation-delay: -133ms;
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(13) {
  transform: rotate(360deg);
}

.rst__loadingCirclePoint:nth-of-type(7)::before,
.rst__loadingCirclePoint:nth-of-type(13)::before {
  animation-delay: 0ms;
}

.rst__rowTitle {
  font-weight: bold;
}

.rst__rowTitleWithSubtitle {
  font-size: 85%;
  display: block;
  height: 0.8rem;
}

.rst__rowSubtitle {
  font-size: 70%;
  line-height: 1;
}

.rst__collapseButton,
.rst__expandButton {
  -webkit-appearance: none;
          appearance: none;
  border: none;
  position: absolute;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #000;
  width: 16px;
  height: 16px;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.rst__rtl.rst__collapseButton,
.rst__rtl.rst__expandButton {
  transform: translate(50%, -50%);
}

.rst__collapseButton:focus,
.rst__expandButton:focus {
  outline: none;
  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;
}

.rst__collapseButton:hover:not(:active),
.rst__expandButton:hover:not(:active) {
  background-size: 24px;
  height: 20px;
  width: 20px;
}

.rst__collapseButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_23___}) no-repeat center;
}

.rst__expandButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat center;
}

/**
 * Line for under a node with children
 */
.rst__lineChildren {
  height: 100%;
  display: inline-block;
  position: absolute;
}

.rst__lineChildren::after {
  content: "";
  position: absolute;
  background-color: black;
  width: 1px;
  left: 50%;
  bottom: 0;
  height: 10px;
}

.rst__rtl.rst__lineChildren::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__placeholder {
  position: relative;
  height: 68px;
  max-width: 300px;
  padding: 10px;
}

.rst__placeholder,
.rst__placeholder > * {
  box-sizing: border-box;
}

.rst__placeholder::before {
  border: 3px dashed #e9ecef;
  content: "";
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  z-index: -1;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__placeholderLandingPad,
.rst__placeholderCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__placeholderLandingPad *,
.rst__placeholderCancelPad * {
  opacity: 0 !important;
}

.rst__placeholderLandingPad::before,
.rst__placeholderCancelPad::before {
  background-color: lightblue;
  border-color: white;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__placeholderCancelPad::before {
  background-color: #e6a8ad;
}

/* Collection default theme */
/* Grid default theme */
/* Table default theme */
.ReactVirtualized__Table__headerRow {
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__headerTruncatedText {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ReactVirtualized__Table__headerColumn,
.ReactVirtualized__Table__rowColumn {
  margin-right: 10px;
  min-width: 0px;
}

.ReactVirtualized__Table__rowColumn {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReactVirtualized__Table__headerColumn:first-of-type,
.ReactVirtualized__Table__rowColumn:first-of-type {
  margin-left: 10px;
}

.ReactVirtualized__Table__sortableHeaderColumn {
  cursor: pointer;
}

.ReactVirtualized__Table__sortableHeaderIconContainer {
  display: flex;
  align-items: center;
}

.ReactVirtualized__Table__sortableHeaderIcon {
  flex: 0 0 24px;
  height: 1em;
  width: 1em;
  fill: currentColor;
}

/* List default theme */
.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}
.ReactTable .-pagination input,
.ReactTable .-pagination select,
.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  display: block;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.5em + (0.5rem + 2px));
  padding: 0.25rem 0.5rem;
  border-radius: 0.2rem;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.ReactTable .-pagination input::-ms-expand,
.ReactTable .-pagination select::-ms-expand,
.ReactTable .rt-thead.-filters input::-ms-expand,
.ReactTable .rt-thead.-filters select::-ms-expand {
  background-color: transparent;
  border: 0;
}
.ReactTable .-pagination input::placeholder,
.ReactTable .-pagination select::placeholder,
.ReactTable .rt-thead.-filters input::placeholder,
.ReactTable .rt-thead.-filters select::placeholder {
  color: #6c757d;
  opacity: 1;
}
.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],
.ReactTable .-pagination select:disabled,
.ReactTable .-pagination select[readonly],
.ReactTable .rt-thead.-filters input:disabled,
.ReactTable .rt-thead.-filters input[readonly],
.ReactTable .rt-thead.-filters select:disabled,
.ReactTable .rt-thead.-filters select[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
          user-select: none;
}
.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-headerGroups .rt-th,
.ReactTable .rt-thead.-headerGroups .rt-td {
  padding: 0.3rem;
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:hover,
.ReactTable .rt-thead.-headerGroups .rt-td:hover {
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:empty,
.ReactTable .rt-thead.-headerGroups .rt-td:empty {
  padding: 0;
}
.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}
.ReactTable .rt-thead.-filters .rt-th {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-filters.-header {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-thead .rt-tr {
  text-align: center;
}
.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  padding: 0.55rem;
  line-height: normal;
  position: relative;
  font-weight: bold;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  color: #545cd8;
}
.ReactTable .rt-thead .rt-th:hover,
.ReactTable .rt-thead .rt-td:hover {
  color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
}
.ReactTable .rt-thead .rt-th.-sort-asc,
.ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-sort-desc,
.ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}
.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}
.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}
.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}
.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}
.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}
.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px #e9ecef;
}
.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}
.ReactTable .rt-tbody .rt-td {
  border-right: 1px solid #e9ecef;
  align-items: center;
  align-content: center;
  display: flex;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true] {
  width: 100%;
  border: 1px solid transparent;
  background: #fff !important;
  border-radius: 0.2rem;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {
  padding: 3px 5px;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: none;
}
.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
  text-overflow: clip;
}
.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}
.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  text-overflow: ellipsis;
  padding: 0.55rem;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
}
.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}
.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  color: transparent;
  margin: 0 10px 0 0;
}
.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}
.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}
.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}
.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}
.ReactTable.-fixed .-header {
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-fixed .pagination-bottom {
  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: #e0f3ff;
}
.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
          appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.25rem;
  padding: 6px;
  font-size: 1em;
  color: #545cd8;
  background: #f8f9fa;
  transition: all 0.2s ease;
  cursor: pointer;
  outline: none;
  font-weight: bold;
}
.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: default;
}
.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: #545cd8;
  color: #fff;
}
.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}
.ReactTable .-pagination .-center {
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ReactTable .-pagination .-totalPages {
  padding-left: 5px;
  font-weight: bold;
}
.ReactTable .-pagination .-pageInfo {
  display: inherit;
  margin: 3px 0 3px 10px;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
}
.ReactTable .-pagination .-pageJump {
  display: inline-block;
  margin: 0 5px;
}
.ReactTable .-pagination .-pageJump input {
  width: 70px;
  text-align: center;
}
.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}
.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: #545cd8;
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}
.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}
.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.table thead th,
.table td {
  vertical-align: middle;
}

.table th .filter {
  margin-top: 0.375rem;
  height: auto;
  padding: 0.3rem 0.5rem;
}

.caret-4-asc,
.caret-4-desc {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  margin-left: 0.375rem;
}

.table .sortable:hover .caret-4-asc,
.table .sortable:hover .caret-4-desc {
  color: #545cd8;
}

.table-lg th,
.table-lg td {
  padding: 1.1rem 0.825rem;
}

@font-face {
  font-family: "Linearicons-Free";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=lnr-],
[class*=" lnr-"] {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.lnr-home:before {
  content: "\\e800";
}

.lnr-apartment:before {
  content: "\\e801";
}

.lnr-pencil:before {
  content: "\\e802";
}

.lnr-magic-wand:before {
  content: "\\e803";
}

.lnr-drop:before {
  content: "\\e804";
}

.lnr-lighter:before {
  content: "\\e805";
}

.lnr-poop:before {
  content: "\\e806";
}

.lnr-sun:before {
  content: "\\e807";
}

.lnr-moon:before {
  content: "\\e808";
}

.lnr-cloud:before {
  content: "\\e809";
}

.lnr-cloud-upload:before {
  content: "\\e80a";
}

.lnr-cloud-download:before {
  content: "\\e80b";
}

.lnr-cloud-sync:before {
  content: "\\e80c";
}

.lnr-cloud-check:before {
  content: "\\e80d";
}

.lnr-database:before {
  content: "\\e80e";
}

.lnr-lock:before {
  content: "\\e80f";
}

.lnr-cog:before {
  content: "\\e810";
}

.lnr-trash:before {
  content: "\\e811";
}

.lnr-dice:before {
  content: "\\e812";
}

.lnr-heart:before {
  content: "\\e813";
}

.lnr-star:before {
  content: "\\e814";
}

.lnr-star-half:before {
  content: "\\e815";
}

.lnr-star-empty:before {
  content: "\\e816";
}

.lnr-flag:before {
  content: "\\e817";
}

.lnr-envelope:before {
  content: "\\e818";
}

.lnr-paperclip:before {
  content: "\\e819";
}

.lnr-inbox:before {
  content: "\\e81a";
}

.lnr-eye:before {
  content: "\\e81b";
}

.lnr-printer:before {
  content: "\\e81c";
}

.lnr-file-empty:before {
  content: "\\e81d";
}

.lnr-file-add:before {
  content: "\\e81e";
}

.lnr-enter:before {
  content: "\\e81f";
}

.lnr-exit:before {
  content: "\\e820";
}

.lnr-graduation-hat:before {
  content: "\\e821";
}

.lnr-license:before {
  content: "\\e822";
}

.lnr-music-note:before {
  content: "\\e823";
}

.lnr-film-play:before {
  content: "\\e824";
}

.lnr-camera-video:before {
  content: "\\e825";
}

.lnr-camera:before {
  content: "\\e826";
}

.lnr-picture:before {
  content: "\\e827";
}

.lnr-book:before {
  content: "\\e828";
}

.lnr-bookmark:before {
  content: "\\e829";
}

.lnr-user:before {
  content: "\\e82a";
}

.lnr-users:before {
  content: "\\e82b";
}

.lnr-shirt:before {
  content: "\\e82c";
}

.lnr-store:before {
  content: "\\e82d";
}

.lnr-cart:before {
  content: "\\e82e";
}

.lnr-tag:before {
  content: "\\e82f";
}

.lnr-phone-handset:before {
  content: "\\e830";
}

.lnr-phone:before {
  content: "\\e831";
}

.lnr-pushpin:before {
  content: "\\e832";
}

.lnr-map-marker:before {
  content: "\\e833";
}

.lnr-map:before {
  content: "\\e834";
}

.lnr-location:before {
  content: "\\e835";
}

.lnr-calendar-full:before {
  content: "\\e836";
}

.lnr-keyboard:before {
  content: "\\e837";
}

.lnr-spell-check:before {
  content: "\\e838";
}

.lnr-screen:before {
  content: "\\e839";
}

.lnr-smartphone:before {
  content: "\\e83a";
}

.lnr-tablet:before {
  content: "\\e83b";
}

.lnr-laptop:before {
  content: "\\e83c";
}

.lnr-laptop-phone:before {
  content: "\\e83d";
}

.lnr-power-switch:before {
  content: "\\e83e";
}

.lnr-bubble:before {
  content: "\\e83f";
}

.lnr-heart-pulse:before {
  content: "\\e840";
}

.lnr-construction:before {
  content: "\\e841";
}

.lnr-pie-chart:before {
  content: "\\e842";
}

.lnr-chart-bars:before {
  content: "\\e843";
}

.lnr-gift:before {
  content: "\\e844";
}

.lnr-diamond:before {
  content: "\\e845";
}

.lnr-linearicons:before {
  content: "\\e846";
}

.lnr-dinner:before {
  content: "\\e847";
}

.lnr-coffee-cup:before {
  content: "\\e848";
}

.lnr-leaf:before {
  content: "\\e849";
}

.lnr-paw:before {
  content: "\\e84a";
}

.lnr-rocket:before {
  content: "\\e84b";
}

.lnr-briefcase:before {
  content: "\\e84c";
}

.lnr-bus:before {
  content: "\\e84d";
}

.lnr-car:before {
  content: "\\e84e";
}

.lnr-train:before {
  content: "\\e84f";
}

.lnr-bicycle:before {
  content: "\\e850";
}

.lnr-wheelchair:before {
  content: "\\e851";
}

.lnr-select:before {
  content: "\\e852";
}

.lnr-earth:before {
  content: "\\e853";
}

.lnr-smile:before {
  content: "\\e854";
}

.lnr-sad:before {
  content: "\\e855";
}

.lnr-neutral:before {
  content: "\\e856";
}

.lnr-mustache:before {
  content: "\\e857";
}

.lnr-alarm:before {
  content: "\\e858";
}

.lnr-bullhorn:before {
  content: "\\e859";
}

.lnr-volume-high:before {
  content: "\\e85a";
}

.lnr-volume-medium:before {
  content: "\\e85b";
}

.lnr-volume-low:before {
  content: "\\e85c";
}

.lnr-volume:before {
  content: "\\e85d";
}

.lnr-mic:before {
  content: "\\e85e";
}

.lnr-hourglass:before {
  content: "\\e85f";
}

.lnr-undo:before {
  content: "\\e860";
}

.lnr-redo:before {
  content: "\\e861";
}

.lnr-sync:before {
  content: "\\e862";
}

.lnr-history:before {
  content: "\\e863";
}

.lnr-clock:before {
  content: "\\e864";
}

.lnr-download:before {
  content: "\\e865";
}

.lnr-upload:before {
  content: "\\e866";
}

.lnr-enter-down:before {
  content: "\\e867";
}

.lnr-exit-up:before {
  content: "\\e868";
}

.lnr-bug:before {
  content: "\\e869";
}

.lnr-code:before {
  content: "\\e86a";
}

.lnr-link:before {
  content: "\\e86b";
}

.lnr-unlink:before {
  content: "\\e86c";
}

.lnr-thumbs-up:before {
  content: "\\e86d";
}

.lnr-thumbs-down:before {
  content: "\\e86e";
}

.lnr-magnifier:before {
  content: "\\e86f";
}

.lnr-cross:before {
  content: "\\e870";
}

.lnr-menu:before {
  content: "\\e871";
}

.lnr-list:before {
  content: "\\e872";
}

.lnr-chevron-up:before, .caret-4-asc:before {
  content: "\\e873";
}

.lnr-chevron-down:before, .caret-4-desc:before {
  content: "\\e874";
}

.lnr-chevron-left:before {
  content: "\\e875";
}

.lnr-chevron-right:before {
  content: "\\e876";
}

.lnr-arrow-up:before {
  content: "\\e877";
}

.lnr-arrow-down:before {
  content: "\\e878";
}

.lnr-arrow-left:before {
  content: "\\e879";
}

.lnr-arrow-right:before {
  content: "\\e87a";
}

.lnr-move:before {
  content: "\\e87b";
}

.lnr-warning:before {
  content: "\\e87c";
}

.lnr-question-circle:before {
  content: "\\e87d";
}

.lnr-menu-circle:before {
  content: "\\e87e";
}

.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {
  content: "\\e87f";
}

.lnr-cross-circle:before {
  content: "\\e880";
}

.lnr-plus-circle:before {
  content: "\\e881";
}

.lnr-circle-minus:before {
  content: "\\e882";
}

.lnr-arrow-up-circle:before {
  content: "\\e883";
}

.lnr-arrow-down-circle:before {
  content: "\\e884";
}

.lnr-arrow-left-circle:before {
  content: "\\e885";
}

.lnr-arrow-right-circle:before {
  content: "\\e886";
}

.lnr-chevron-up-circle:before {
  content: "\\e887";
}

.lnr-chevron-down-circle:before {
  content: "\\e888";
}

.lnr-chevron-left-circle:before {
  content: "\\e889";
}

.lnr-chevron-right-circle:before {
  content: "\\e88a";
}

.lnr-crop:before {
  content: "\\e88b";
}

.lnr-frame-expand:before {
  content: "\\e88c";
}

.lnr-frame-contract:before {
  content: "\\e88d";
}

.lnr-layers:before {
  content: "\\e88e";
}

.lnr-funnel:before {
  content: "\\e88f";
}

.lnr-text-format:before {
  content: "\\e890";
}

.lnr-text-format-remove:before {
  content: "\\e891";
}

.lnr-text-size:before {
  content: "\\e892";
}

.lnr-bold:before {
  content: "\\e893";
}

.lnr-italic:before {
  content: "\\e894";
}

.lnr-underline:before {
  content: "\\e895";
}

.lnr-strikethrough:before {
  content: "\\e896";
}

.lnr-highlight:before {
  content: "\\e897";
}

.lnr-text-align-left:before {
  content: "\\e898";
}

.lnr-text-align-center:before {
  content: "\\e899";
}

.lnr-text-align-right:before {
  content: "\\e89a";
}

.lnr-text-align-justify:before {
  content: "\\e89b";
}

.lnr-line-spacing:before {
  content: "\\e89c";
}

.lnr-indent-increase:before {
  content: "\\e89d";
}

.lnr-indent-decrease:before {
  content: "\\e89e";
}

.lnr-pilcrow:before {
  content: "\\e89f";
}

.lnr-direction-ltr:before {
  content: "\\e8a0";
}

.lnr-direction-rtl:before {
  content: "\\e8a1";
}

.lnr-page-break:before {
  content: "\\e8a2";
}

.lnr-sort-alpha-asc:before {
  content: "\\e8a3";
}

.lnr-sort-amount-asc:before {
  content: "\\e8a4";
}

.lnr-hand:before {
  content: "\\e8a5";
}

.lnr-pointer-up:before {
  content: "\\e8a6";
}

.lnr-pointer-right:before {
  content: "\\e8a7";
}

.lnr-pointer-down:before {
  content: "\\e8a8";
}

.lnr-pointer-left:before {
  content: "\\e8a9";
}

/*
*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set
*/
@font-face {
  font-family: "Pe-icon-7-stroke";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=pe-7s-], [class*=" pe-7s-"] {
  display: inline-block;
  font-family: "Pe-icon-7-stroke";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* HELPER CLASS
 * -------------------------- */
/* FA based classes */
/*! Modified from font-awesome helper CSS classes - PIXEDEN
 *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (CSS: MIT License)
 */
/* makes the font 33% larger relative to the icon container */
.pe-lg {
  font-size: 1.1704rem;
  line-height: 0.75em;
  vertical-align: -15%;
}

.pe-2x {
  font-size: 1.76rem;
}

.pe-3x {
  font-size: 2.64rem;
}

.pe-4x {
  font-size: 3.52rem;
}

.pe-5x {
  font-size: 4.4rem;
}

.pe-fw {
  width: 1.2857142857em;
  text-align: center;
}

.pe-ul {
  padding-left: 0;
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.pe-ul > li {
  position: relative;
}

.pe-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  top: 0.1428571429em;
  text-align: center;
}
.pe-li.pe-lg {
  left: -1.8571428571em;
}

.pe-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eeeeee;
  border-radius: 0.1em;
}

.pull-right {
  float: right;
}

.pe.pull-left {
  float: left;
  margin-right: 0.3em;
  margin-left: 0.3em;
}

.pe-spin {
  animation: spin 2s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.pe-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.pe-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.pe-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.pe-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);
  transform: scale(-1, 1);
}

.pe-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);
  transform: scale(1, -1);
}

.pe-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.pe-stack-1x,
.pe-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.pe-stack-1x {
  line-height: inherit;
}

.pe-stack-2x {
  font-size: 2em;
}

.pe-inverse {
  color: #ffffff;
}

/* Custom classes / mods - PIXEDEN */
.pe-va {
  vertical-align: middle;
}

.pe-border {
  border: solid 0.08em #eaeaea;
}

.pe-7s-album:before {
  content: "\\e6aa";
}

.pe-7s-arc:before {
  content: "\\e6ab";
}

.pe-7s-back-2:before {
  content: "\\e6ac";
}

.pe-7s-bandaid:before {
  content: "\\e6ad";
}

.pe-7s-car:before {
  content: "\\e6ae";
}

.pe-7s-diamond:before {
  content: "\\e6af";
}

.pe-7s-door-lock:before {
  content: "\\e6b0";
}

.pe-7s-eyedropper:before {
  content: "\\e6b1";
}

.pe-7s-female:before {
  content: "\\e6b2";
}

.pe-7s-gym:before {
  content: "\\e6b3";
}

.pe-7s-hammer:before {
  content: "\\e6b4";
}

.pe-7s-headphones:before {
  content: "\\e6b5";
}

.pe-7s-helm:before {
  content: "\\e6b6";
}

.pe-7s-hourglass:before {
  content: "\\e6b7";
}

.pe-7s-leaf:before {
  content: "\\e6b8";
}

.pe-7s-magic-wand:before {
  content: "\\e6b9";
}

.pe-7s-male:before {
  content: "\\e6ba";
}

.pe-7s-map-2:before {
  content: "\\e6bb";
}

.pe-7s-next-2:before {
  content: "\\e6bc";
}

.pe-7s-paint-bucket:before {
  content: "\\e6bd";
}

.pe-7s-pendrive:before {
  content: "\\e6be";
}

.pe-7s-photo:before {
  content: "\\e6bf";
}

.pe-7s-piggy:before {
  content: "\\e6c0";
}

.pe-7s-plugin:before {
  content: "\\e6c1";
}

.pe-7s-refresh-2:before {
  content: "\\e6c2";
}

.pe-7s-rocket:before {
  content: "\\e6c3";
}

.pe-7s-settings:before {
  content: "\\e6c4";
}

.pe-7s-shield:before {
  content: "\\e6c5";
}

.pe-7s-smile:before {
  content: "\\e6c6";
}

.pe-7s-usb:before {
  content: "\\e6c7";
}

.pe-7s-vector:before {
  content: "\\e6c8";
}

.pe-7s-wine:before {
  content: "\\e6c9";
}

.pe-7s-cloud-upload:before {
  content: "\\e68a";
}

.pe-7s-cash:before {
  content: "\\e68c";
}

.pe-7s-close:before {
  content: "\\e680";
}

.pe-7s-bluetooth:before {
  content: "\\e68d";
}

.pe-7s-cloud-download:before {
  content: "\\e68b";
}

.pe-7s-way:before {
  content: "\\e68e";
}

.pe-7s-close-circle:before {
  content: "\\e681";
}

.pe-7s-id:before {
  content: "\\e68f";
}

.pe-7s-angle-up:before {
  content: "\\e682";
}

.pe-7s-wristwatch:before {
  content: "\\e690";
}

.pe-7s-angle-up-circle:before {
  content: "\\e683";
}

.pe-7s-world:before {
  content: "\\e691";
}

.pe-7s-angle-right:before {
  content: "\\e684";
}

.pe-7s-volume:before {
  content: "\\e692";
}

.pe-7s-angle-right-circle:before {
  content: "\\e685";
}

.pe-7s-users:before {
  content: "\\e693";
}

.pe-7s-angle-left:before {
  content: "\\e686";
}

.pe-7s-user-female:before {
  content: "\\e694";
}

.pe-7s-angle-left-circle:before {
  content: "\\e687";
}

.pe-7s-up-arrow:before {
  content: "\\e695";
}

.pe-7s-angle-down:before {
  content: "\\e688";
}

.pe-7s-switch:before {
  content: "\\e696";
}

.pe-7s-angle-down-circle:before {
  content: "\\e689";
}

.pe-7s-scissors:before {
  content: "\\e697";
}

.pe-7s-wallet:before {
  content: "\\e600";
}

.pe-7s-safe:before {
  content: "\\e698";
}

.pe-7s-volume2:before {
  content: "\\e601";
}

.pe-7s-volume1:before {
  content: "\\e602";
}

.pe-7s-voicemail:before {
  content: "\\e603";
}

.pe-7s-video:before {
  content: "\\e604";
}

.pe-7s-user:before {
  content: "\\e605";
}

.pe-7s-upload:before {
  content: "\\e606";
}

.pe-7s-unlock:before {
  content: "\\e607";
}

.pe-7s-umbrella:before {
  content: "\\e608";
}

.pe-7s-trash:before {
  content: "\\e609";
}

.pe-7s-tools:before {
  content: "\\e60a";
}

.pe-7s-timer:before {
  content: "\\e60b";
}

.pe-7s-ticket:before {
  content: "\\e60c";
}

.pe-7s-target:before {
  content: "\\e60d";
}

.pe-7s-sun:before {
  content: "\\e60e";
}

.pe-7s-study:before {
  content: "\\e60f";
}

.pe-7s-stopwatch:before {
  content: "\\e610";
}

.pe-7s-star:before {
  content: "\\e611";
}

.pe-7s-speaker:before {
  content: "\\e612";
}

.pe-7s-signal:before {
  content: "\\e613";
}

.pe-7s-shuffle:before {
  content: "\\e614";
}

.pe-7s-shopbag:before {
  content: "\\e615";
}

.pe-7s-share:before {
  content: "\\e616";
}

.pe-7s-server:before {
  content: "\\e617";
}

.pe-7s-search:before {
  content: "\\e618";
}

.pe-7s-film:before {
  content: "\\e6a5";
}

.pe-7s-science:before {
  content: "\\e619";
}

.pe-7s-disk:before {
  content: "\\e6a6";
}

.pe-7s-ribbon:before {
  content: "\\e61a";
}

.pe-7s-repeat:before {
  content: "\\e61b";
}

.pe-7s-refresh:before {
  content: "\\e61c";
}

.pe-7s-add-user:before {
  content: "\\e6a9";
}

.pe-7s-refresh-cloud:before {
  content: "\\e61d";
}

.pe-7s-paperclip:before {
  content: "\\e69c";
}

.pe-7s-radio:before {
  content: "\\e61e";
}

.pe-7s-note2:before {
  content: "\\e69d";
}

.pe-7s-print:before {
  content: "\\e61f";
}

.pe-7s-network:before {
  content: "\\e69e";
}

.pe-7s-prev:before {
  content: "\\e620";
}

.pe-7s-mute:before {
  content: "\\e69f";
}

.pe-7s-power:before {
  content: "\\e621";
}

.pe-7s-medal:before {
  content: "\\e6a0";
}

.pe-7s-portfolio:before {
  content: "\\e622";
}

.pe-7s-like2:before {
  content: "\\e6a1";
}

.pe-7s-plus:before {
  content: "\\e623";
}

.pe-7s-left-arrow:before {
  content: "\\e6a2";
}

.pe-7s-play:before {
  content: "\\e624";
}

.pe-7s-key:before {
  content: "\\e6a3";
}

.pe-7s-plane:before {
  content: "\\e625";
}

.pe-7s-joy:before {
  content: "\\e6a4";
}

.pe-7s-photo-gallery:before {
  content: "\\e626";
}

.pe-7s-pin:before {
  content: "\\e69b";
}

.pe-7s-phone:before {
  content: "\\e627";
}

.pe-7s-plug:before {
  content: "\\e69a";
}

.pe-7s-pen:before {
  content: "\\e628";
}

.pe-7s-right-arrow:before {
  content: "\\e699";
}

.pe-7s-paper-plane:before {
  content: "\\e629";
}

.pe-7s-delete-user:before {
  content: "\\e6a7";
}

.pe-7s-paint:before {
  content: "\\e62a";
}

.pe-7s-bottom-arrow:before {
  content: "\\e6a8";
}

.pe-7s-notebook:before {
  content: "\\e62b";
}

.pe-7s-note:before {
  content: "\\e62c";
}

.pe-7s-next:before {
  content: "\\e62d";
}

.pe-7s-news-paper:before {
  content: "\\e62e";
}

.pe-7s-musiclist:before {
  content: "\\e62f";
}

.pe-7s-music:before {
  content: "\\e630";
}

.pe-7s-mouse:before {
  content: "\\e631";
}

.pe-7s-more:before {
  content: "\\e632";
}

.pe-7s-moon:before {
  content: "\\e633";
}

.pe-7s-monitor:before {
  content: "\\e634";
}

.pe-7s-micro:before {
  content: "\\e635";
}

.pe-7s-menu:before {
  content: "\\e636";
}

.pe-7s-map:before {
  content: "\\e637";
}

.pe-7s-map-marker:before {
  content: "\\e638";
}

.pe-7s-mail:before {
  content: "\\e639";
}

.pe-7s-mail-open:before {
  content: "\\e63a";
}

.pe-7s-mail-open-file:before {
  content: "\\e63b";
}

.pe-7s-magnet:before {
  content: "\\e63c";
}

.pe-7s-loop:before {
  content: "\\e63d";
}

.pe-7s-look:before {
  content: "\\e63e";
}

.pe-7s-lock:before {
  content: "\\e63f";
}

.pe-7s-lintern:before {
  content: "\\e640";
}

.pe-7s-link:before {
  content: "\\e641";
}

.pe-7s-like:before {
  content: "\\e642";
}

.pe-7s-light:before {
  content: "\\e643";
}

.pe-7s-less:before {
  content: "\\e644";
}

.pe-7s-keypad:before {
  content: "\\e645";
}

.pe-7s-junk:before {
  content: "\\e646";
}

.pe-7s-info:before {
  content: "\\e647";
}

.pe-7s-home:before {
  content: "\\e648";
}

.pe-7s-help2:before {
  content: "\\e649";
}

.pe-7s-help1:before {
  content: "\\e64a";
}

.pe-7s-graph3:before {
  content: "\\e64b";
}

.pe-7s-graph2:before {
  content: "\\e64c";
}

.pe-7s-graph1:before {
  content: "\\e64d";
}

.pe-7s-graph:before {
  content: "\\e64e";
}

.pe-7s-global:before {
  content: "\\e64f";
}

.pe-7s-gleam:before {
  content: "\\e650";
}

.pe-7s-glasses:before {
  content: "\\e651";
}

.pe-7s-gift:before {
  content: "\\e652";
}

.pe-7s-folder:before {
  content: "\\e653";
}

.pe-7s-flag:before {
  content: "\\e654";
}

.pe-7s-filter:before {
  content: "\\e655";
}

.pe-7s-file:before {
  content: "\\e656";
}

.pe-7s-expand1:before {
  content: "\\e657";
}

.pe-7s-exapnd2:before {
  content: "\\e658";
}

.pe-7s-edit:before {
  content: "\\e659";
}

.pe-7s-drop:before {
  content: "\\e65a";
}

.pe-7s-drawer:before {
  content: "\\e65b";
}

.pe-7s-download:before {
  content: "\\e65c";
}

.pe-7s-display2:before {
  content: "\\e65d";
}

.pe-7s-display1:before {
  content: "\\e65e";
}

.pe-7s-diskette:before {
  content: "\\e65f";
}

.pe-7s-date:before {
  content: "\\e660";
}

.pe-7s-cup:before {
  content: "\\e661";
}

.pe-7s-culture:before {
  content: "\\e662";
}

.pe-7s-crop:before {
  content: "\\e663";
}

.pe-7s-credit:before {
  content: "\\e664";
}

.pe-7s-copy-file:before {
  content: "\\e665";
}

.pe-7s-config:before {
  content: "\\e666";
}

.pe-7s-compass:before {
  content: "\\e667";
}

.pe-7s-comment:before {
  content: "\\e668";
}

.pe-7s-coffee:before {
  content: "\\e669";
}

.pe-7s-cloud:before {
  content: "\\e66a";
}

.pe-7s-clock:before {
  content: "\\e66b";
}

.pe-7s-check:before {
  content: "\\e66c";
}

.pe-7s-chat:before {
  content: "\\e66d";
}

.pe-7s-cart:before {
  content: "\\e66e";
}

.pe-7s-camera:before {
  content: "\\e66f";
}

.pe-7s-call:before {
  content: "\\e670";
}

.pe-7s-calculator:before {
  content: "\\e671";
}

.pe-7s-browser:before {
  content: "\\e672";
}

.pe-7s-box2:before {
  content: "\\e673";
}

.pe-7s-box1:before {
  content: "\\e674";
}

.pe-7s-bookmarks:before {
  content: "\\e675";
}

.pe-7s-bicycle:before {
  content: "\\e676";
}

.pe-7s-bell:before {
  content: "\\e677";
}

.pe-7s-battery:before {
  content: "\\e678";
}

.pe-7s-ball:before {
  content: "\\e679";
}

.pe-7s-back:before {
  content: "\\e67a";
}

.pe-7s-attention:before {
  content: "\\e67b";
}

.pe-7s-anchor:before {
  content: "\\e67c";
}

.pe-7s-albums:before {
  content: "\\e67d";
}

.pe-7s-alarm:before {
  content: "\\e67e";
}

.pe-7s-airplay:before {
  content: "\\e67f";
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -6px;
  position: absolute;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  box-sizing: content-box;
  position: absolute;
  border: 6px solid transparent;
  height: 0;
  width: 1px;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  content: "";
  z-index: -1;
  border-width: 6px;
  left: -6px;
  border-bottom-color: #dee2e6;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -6px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #fff;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #dee2e6;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -6px;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-bottom: none;
  border-top-color: #fff;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #dee2e6;
}

.react-datepicker-wrapper {
  display: block;
  z-index: 10;
}

.react-datepicker {
  background-color: #fff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  display: inline-block;
  position: relative;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time {
  border-radius: 0.3rem;
}
.react-datepicker--time-only .react-datepicker__time-box {
  border-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 102;
}
.react-datepicker-popper[data-placement^=bottom] {
  margin-top: 8px;
}
.react-datepicker-popper[data-placement^=top] {
  margin-bottom: 8px;
}
.react-datepicker-popper[data-placement^=right] {
  margin-left: 6px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  margin-right: 6px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  padding-top: 10px;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header {
  margin-top: 0;
  color: #343a40;
  font-weight: bold;
  font-size: 0.968rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 2rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 15px;
  padding: 0;
  border: 0.35rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: #ced4da;
}
.react-datepicker__navigation--previous:hover {
  border-right-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}
.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: #ced4da;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 80px;
}
.react-datepicker__navigation--next:hover {
  border-left-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ced4da;
}
.react-datepicker__navigation--years-previous:hover {
  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ced4da;
}
.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__month {
  margin: 0.5rem;
  text-align: center;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #dee2e6;
  width: 120px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -122px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 120px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: calc(195px + 2rem / 2);
  overflow-y: scroll;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  padding: 5px 10px;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #e0f3ff;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: theme-color("primary");
  color: #fff;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: theme-color("primary");
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ced4da;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ced4da;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.25rem;
  background-color: #fff;
}

.react-datepicker__day-names {
  background: #f8f9fa;
  border-top: #dee2e6 solid 1px;
  margin-top: 10px;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #495057;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day {
  cursor: pointer;
  border-radius: 0.25rem;
}
.react-datepicker__day:hover {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted {
  border-radius: 0.25rem;
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--highlighted:hover {
  background-color: rgb(63.2357142857, 72.2071428571, 211.2642857143);
}
.react-datepicker__day--highlighted-custom-1 {
  color: #f7b924;
}
.react-datepicker__day--highlighted-custom-2 {
  color: #444054;
}
.react-datepicker__day--selected {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--selected:hover {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {
  background-color: #e0f3ff;
  color: rgb(29.7, 33.3, 36.9);
}
.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {
  background-color: #e0f3ff;
  color: rgb(29.7, 33.3, 36.9);
}
.react-datepicker__day--keyboard-selected {
  border-radius: 0.25rem;
  background-color: rgb(96.811023622, 208.188976378, 150.8858267717);
  color: #fff;
}
.react-datepicker__day--keyboard-selected:hover {
  background-color: rgb(52.1771653543, 176.3228346457, 112.4507874016);
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
  background-color: #e0f3ff;
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--disabled {
  cursor: default;
  color: #ced4da;
}
.react-datepicker__day--disabled:hover {
  background-color: transparent;
  color: #ced4da;
}

.react-datepicker__day--selecting-range-start,
.react-datepicker__day--selecting-range-end {
  background-color: #3ac47d !important;
  color: #fff !important;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #ced4da;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.35rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #fff;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ced4da;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  vertical-align: middle;
  position: absolute;
  height: 16px;
  width: 16px;
  top: 25%;
  right: 7px;
}
.react-datepicker__close-icon::after {
  background-color: theme-color("primary");
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "×";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 0px;
  text-align: center;
}

.react-datepicker__today-button {
  background: #fff;
  border-top: 1px solid #dee2e6;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1040;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.584rem;
}
.react-datepicker__portal .react-datepicker__navigation {
  border: 0.63rem solid transparent;
  margin-top: 3px;
}
.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
}
.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}
.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
}
.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}

.rangeButtonSelectedStyle {
  background: #545cd8 !important;
}

.rangebuttonstyle {
  outline: none !important;
  color: #545cd8 !important;
}

.rc-slider-tooltip {
  z-index: 555;
}

.rc-tooltip.rc-tooltip-zoom-enter,
.rc-tooltip.rc-tooltip-zoom-leave {
  display: block;
}

.rc-tooltip-zoom-enter,
.rc-tooltip-zoom-appear {
  opacity: 0;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation-play-state: paused;
}

.rc-tooltip-zoom-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
  animation-play-state: paused;
}

.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,
.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {
  animation-name: rcToolTipZoomIn;
  animation-play-state: running;
}

.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {
  animation-name: rcToolTipZoomOut;
  animation-play-state: running;
}

@keyframes rcToolTipZoomIn {
  0% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
  100% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
}
@keyframes rcToolTipZoomOut {
  0% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
}
.rc-tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  visibility: visible;
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.9;
}

.rc-tooltip-hidden {
  display: none;
}

.rc-tooltip-placement-top,
.rc-tooltip-placement-topLeft,
.rc-tooltip-placement-topRight {
  padding: 5px 0 9px 0;
}

.rc-tooltip-placement-right,
.rc-tooltip-placement-rightTop,
.rc-tooltip-placement-rightBottom {
  padding: 0 5px 0 9px;
}

.rc-tooltip-placement-bottom,
.rc-tooltip-placement-bottomLeft,
.rc-tooltip-placement-bottomRight {
  padding: 9px 0 5px 0;
}

.rc-tooltip-placement-left,
.rc-tooltip-placement-leftTop,
.rc-tooltip-placement-leftBottom {
  padding: 0 9px 0 5px;
}

.rc-tooltip-inner {
  padding: 12px 14px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  background-color: #343a40;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
  min-height: 34px;
  font-weight: bold;
}

.rc-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-tooltip-placement-top .rc-tooltip-arrow,
.rc-tooltip-placement-topLeft .rc-tooltip-arrow,
.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  bottom: 4px;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #343a40;
}

.rc-tooltip-placement-top .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-topLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-tooltip-placement-right .rc-tooltip-arrow,
.rc-tooltip-placement-rightTop .rc-tooltip-arrow,
.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  left: 4px;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #343a40;
}

.rc-tooltip-placement-right .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-rightTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-left .rc-tooltip-arrow,
.rc-tooltip-placement-leftTop .rc-tooltip-arrow,
.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  right: 4px;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #343a40;
}

.rc-tooltip-placement-left .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-leftTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow,
.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,
.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  top: 4px;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #343a40;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-slider {
  position: relative;
  height: 20px;
  padding: 8px 0 0;
  width: 100%;
  border-radius: 0.25rem;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-rail {
  position: absolute;
  width: 100%;
  background-color: #e9ecef;
  height: 4px;
  border-radius: 0.25rem;
}

.rc-slider-track {
  position: absolute;
  left: 0;
  height: 4px;
  border-radius: 0.25rem;
  background-color: #545cd8;
}

.rc-slider-handle {
  position: absolute;
  margin-left: -8px;
  margin-top: -6px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  cursor: grab;
  border-radius: 50%;
  border: solid 2px #545cd8;
  background-color: #fff;
  touch-action: pan-x;
  transition: box-shadow 200ms;
}
.rc-slider-handle:focus {
  outline: none;
}
.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {
  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-handle:active {
  cursor: grabbing;
}

.rc-slider-mark {
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  font-size: 12px;
}

.rc-slider-mark-text {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  color: #6c757d;
}

.rc-slider-mark-text-active {
  color: #343a40;
}

.rc-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
}

.rc-slider-dot {
  position: absolute;
  bottom: -2px;
  margin-left: -4px;
  width: 8px;
  height: 8px;
  border: 2px solid #dee2e6;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;
}

.rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-disabled {
  background-color: #e9ecef;
}

.rc-slider-disabled .rc-slider-track {
  background-color: #ced4da;
}

.rc-slider-disabled .rc-slider-handle,
.rc-slider-disabled .rc-slider-dot {
  border-color: #ced4da;
  box-shadow: none;
  background-color: #fff;
  cursor: not-allowed;
}

.rc-slider-disabled .rc-slider-mark-text,
.rc-slider-disabled .rc-slider-dot {
  cursor: not-allowed !important;
}

.rc-slider-vertical {
  width: 14px;
  height: 100%;
  padding: 0 5px;
}

.rc-slider-vertical .rc-slider-rail {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-track {
  left: 5px;
  bottom: 0;
  width: 4px;
}

.rc-slider-vertical .rc-slider-handle {
  margin-left: -6px;
  margin-bottom: -7px;
  touch-action: pan-y;
}

.rc-slider-vertical .rc-slider-mark {
  top: 0;
  left: 18px;
  height: 100%;
}

.rc-slider-vertical .rc-slider-step {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-dot {
  left: 2px;
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:first-child {
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:last-child {
  margin-bottom: -4px;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
  animation-name: rcSliderTooltipZoomDownIn;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
  animation-name: rcSliderTooltipZoomDownOut;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  transform: scale(0, 0);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.rc-slider-tooltip-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes rcSliderTooltipZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
  100% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
}
@keyframes rcSliderTooltipZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
}
.rc-slider-tooltip {
  position: absolute;
  left: -9999px;
  top: -9999px;
  visibility: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-tooltip-hidden {
  display: none;
}

.rc-slider-tooltip-placement-top {
  padding: 4px 0 8px 0;
}

.rc-slider-tooltip-inner {
  padding: 0 8px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  font-weight: bold;
}

.rc-slider-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
  bottom: 4px;
  left: 50%;
  margin-left: -4px;
  border-width: 4px 4px 0;
  border-top-color: #212529;
}

.rc-slider-primary .rc-slider-track {
  background-color: #545cd8;
}
.rc-slider-primary .rc-slider-handle {
  border-color: #545cd8;
  background-color: #fff;
}
.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {
  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-primary .rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-secondary .rc-slider-track {
  background-color: #6c757d;
}
.rc-slider-secondary .rc-slider-handle {
  border-color: #6c757d;
  background-color: #fff;
}
.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {
  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);
}
.rc-slider-secondary .rc-slider-dot-active {
  border-color: #6c757d;
}

.rc-slider-success .rc-slider-track {
  background-color: #3ac47d;
}
.rc-slider-success .rc-slider-handle {
  border-color: #3ac47d;
  background-color: #fff;
}
.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {
  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);
}
.rc-slider-success .rc-slider-dot-active {
  border-color: #3ac47d;
}

.rc-slider-info .rc-slider-track {
  background-color: #30b1ff;
}
.rc-slider-info .rc-slider-handle {
  border-color: #30b1ff;
  background-color: #fff;
}
.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {
  border-color: rgb(0, 141.152173913, 226.5);
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);
}
.rc-slider-info .rc-slider-dot-active {
  border-color: #30b1ff;
}

.rc-slider-warning .rc-slider-track {
  background-color: #f7b924;
}
.rc-slider-warning .rc-slider-handle {
  border-color: #f7b924;
  background-color: #fff;
}
.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {
  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);
}
.rc-slider-warning .rc-slider-dot-active {
  border-color: #f7b924;
}

.rc-slider-danger .rc-slider-track {
  background-color: #d92550;
}
.rc-slider-danger .rc-slider-handle {
  border-color: #d92550;
  background-color: #fff;
}
.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {
  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);
}
.rc-slider-danger .rc-slider-dot-active {
  border-color: #d92550;
}

.rc-slider-light .rc-slider-track {
  background-color: #eeeeee;
}
.rc-slider-light .rc-slider-handle {
  border-color: #eeeeee;
  background-color: #fff;
}
.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {
  border-color: rgb(199.75, 199.75, 199.75);
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);
}
.rc-slider-light .rc-slider-dot-active {
  border-color: #eeeeee;
}

.rc-slider-dark .rc-slider-track {
  background-color: #343a40;
}
.rc-slider-dark .rc-slider-handle {
  border-color: #343a40;
  background-color: #fff;
}
.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {
  border-color: rgb(17.7068965517, 19.75, 21.7931034483);
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);
}
.rc-slider-dark .rc-slider-dot-active {
  border-color: #343a40;
}

.rc-slider-focus .rc-slider-track {
  background-color: #444054;
}
.rc-slider-focus .rc-slider-handle {
  border-color: #444054;
  background-color: #fff;
}
.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {
  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);
}
.rc-slider-focus .rc-slider-dot-active {
  border-color: #444054;
}

.rc-slider-alternate .rc-slider-track {
  background-color: #83588a;
}
.rc-slider-alternate .rc-slider-handle {
  border-color: #83588a;
  background-color: #fff;
}
.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {
  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);
}
.rc-slider-alternate .rc-slider-dot-active {
  border-color: #83588a;
}

.rc-slider-line .rc-slider-handle {
  border-radius: 0;
  border-width: 0 3px 0 0;
  margin-left: -8px;
  width: 10px;
  background-color: transparent;
  box-shadow: 0 0 0 transparent !important;
}

.rc-slider-square .rc-slider-handle {
  border-radius: 3px;
  border-widtH: 1px;
}
.rc-slider-square .rc-slider-handle:before {
  position: absolute;
  height: 8px;
  width: 4px;
  border: #adb5bd solid 1px;
  border-width: 0 1px;
  display: block;
  content: "";
  top: 50%;
  left: 50%;
  margin: -4px -2px;
}

.rc-slider-lg.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-lg .rc-slider-rail {
  height: 4px;
}
.rc-slider-lg .rc-slider-track {
  height: 4px;
}
.rc-slider-lg .rc-slider-handle {
  margin-left: -10px;
  margin-top: -8px;
  width: 20px;
  height: 20px;
}
.rc-slider-lg.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-lg.rc-slider-square .rc-slider-handle:before {
  height: 10px;
  width: 6px;
  margin: -5px -3px;
}

.rc-slider-sm.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-sm .rc-slider-rail {
  height: 4px;
}
.rc-slider-sm .rc-slider-track {
  height: 4px;
}
.rc-slider-sm .rc-slider-handle {
  margin-left: -6px;
  margin-top: -4px;
  width: 12px;
  height: 12px;
}
.rc-slider-sm.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-sm.rc-slider-square .rc-slider-handle:before {
  height: 6px;
  margin: -3px 0 0 -1px;
  border: 0;
  width: 2px;
  background: #adb5bd;
}

.rdw-option-wrapper {
  border: 1px solid #F1F1F1;
  padding: 5px;
  min-width: 25px;
  height: 20px;
  border-radius: 2px;
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-option-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-option-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-dropdown-wrapper {
  height: 30px;
  background: white;
  cursor: pointer;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  margin: 0 3px;
  text-transform: capitalize;
  background: white;
}

.rdw-dropdown-wrapper:focus {
  outline: none;
}

.rdw-dropdown-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdown-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-dropdown-carettoopen {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-top: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-carettoclose {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-bottom: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-selectedtext {
  display: flex;
  position: relative;
  height: 100%;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdown-optionwrapper {
  z-index: 100;
  position: relative;
  border: 1px solid #F1F1F1;
  width: 98%;
  background: white;
  border-radius: 2px;
  margin: 0;
  padding: 0;
  max-height: 250px;
  overflow-y: scroll;
}

.rdw-dropdown-optionwrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdownoption-default {
  min-height: 25px;
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdownoption-highlighted {
  background: #F1F1F1;
}

.rdw-dropdownoption-active {
  background: #f5f5f5;
}

.rdw-dropdownoption-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-inline-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-inline-dropdown {
  width: 50px;
}

.rdw-inline-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-block-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-block-dropdown {
  width: 110px;
}

.rdw-fontsize-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontsize-dropdown {
  min-width: 40px;
}

.rdw-fontsize-option {
  display: flex;
  justify-content: center;
}

.rdw-fontfamily-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontfamily-dropdown {
  width: 115px;
}

.rdw-fontfamily-placeholder {
  white-space: nowrap;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rdw-fontfamily-optionwrapper {
  width: 140px;
}

.rdw-list-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-list-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-list-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-text-align-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-text-align-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-text-align-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-right-aligned-block {
  text-align: right;
}

.rdw-left-aligned-block {
  text-align: left !important;
}

.rdw-center-aligned-block {
  text-align: center !important;
}

.rdw-justify-aligned-block {
  text-align: justify !important;
}

.rdw-right-aligned-block > div {
  display: inline-block;
}

.rdw-left-aligned-block > div {
  display: inline-block;
}

.rdw-center-aligned-block > div {
  display: inline-block;
}

.rdw-justify-aligned-block > div {
  display: inline-block;
}

.rdw-colorpicker-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-colorpicker-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 175px;
  height: 175px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-colorpicker-modal-header {
  display: flex;
  padding-bottom: 5px;
}

.rdw-colorpicker-modal-style-label {
  font-size: 15px;
  width: 50%;
  text-align: center;
  cursor: pointer;
  padding: 0 10px 5px;
}

.rdw-colorpicker-modal-style-label-active {
  border-bottom: 2px solid #0a66b7;
}

.rdw-colorpicker-modal-options {
  margin: 5px auto;
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  overflow: scroll;
}

.rdw-colorpicker-cube {
  width: 22px;
  height: 22px;
  border: 1px solid #F1F1F1;
}

.rdw-colorpicker-option {
  margin: 3px;
  padding: 0;
  min-height: 20px;
  border: none;
  width: 22px;
  height: 22px;
  min-width: 22px;
  box-shadow: 1px 2px 1px #BFBDBD inset;
}

.rdw-colorpicker-option:hover {
  box-shadow: 1px 2px 1px #BFBDBD;
}

.rdw-colorpicker-option:active {
  box-shadow: -1px -2px 1px #BFBDBD;
}

.rdw-colorpicker-option-active {
  box-shadow: 0px 0px 2px 2px #BFBDBD;
}

.rdw-link-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-link-dropdown {
  width: 50px;
}

.rdw-link-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-link-dropdownPlaceholder {
  margin-left: 8px;
}

.rdw-link-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 205px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-link-modal-label {
  font-size: 15px;
}

.rdw-link-modal-input {
  margin-top: 5px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  height: 25px;
  margin-bottom: 15px;
  padding: 0 5px;
}

.rdw-link-modal-input:focus {
  outline: none;
}

.rdw-link-modal-buttonsection {
  margin: 0 auto;
}

.rdw-link-modal-target-option {
  margin-bottom: 20px;
}

.rdw-link-modal-target-option > span {
  margin-left: 5px;
}

.rdw-link-modal-btn {
  margin-left: 10px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-link-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-link-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-link-modal-btn:focus {
  outline: none !important;
}

.rdw-link-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-link-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-embedded-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-embedded-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  justify-content: space-between;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-embedded-modal-header {
  font-size: 15px;
  display: flex;
}

.rdw-embedded-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-embedded-modal-header-label {
  width: 95px;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-embedded-modal-link-section {
  display: flex;
  flex-direction: column;
}

.rdw-embedded-modal-link-input {
  width: 88%;
  height: 35px;
  margin: 10px 0;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-embedded-modal-link-input-wrapper {
  display: flex;
  align-items: center;
}

.rdw-embedded-modal-link-input:focus {
  outline: none;
}

.rdw-embedded-modal-btn-section {
  display: flex;
  justify-content: center;
}

.rdw-embedded-modal-btn {
  margin: 0 3px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-embedded-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-embedded-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-embedded-modal-btn:focus {
  outline: none !important;
}

.rdw-embedded-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-embedded-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-embedded-modal-size-input {
  width: 80%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-embedded-modal-size-input:focus {
  outline: none;
}

.rdw-emoji-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-emoji-modal {
  overflow: auto;
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-wrap: wrap;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-emoji-icon {
  margin: 2.5px;
  height: 24px;
  width: 24px;
  cursor: pointer;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdw-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.rdw-spinner > div {
  width: 12px;
  height: 12px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.rdw-spinner .rdw-bounce1 {
  animation-delay: -0.32s;
}

.rdw-spinner .rdw-bounce2 {
  animation-delay: -0.16s;
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.rdw-image-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-image-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-image-modal-header {
  font-size: 15px;
  margin: 10px 0;
  display: flex;
}

.rdw-image-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-image-modal-header-label {
  width: 80px;
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
}

.rdw-image-modal-header-label-highlighted {
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-image-modal-upload-option {
  width: 100%;
  color: gray;
  cursor: pointer;
  display: flex;
  border: none;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  outline: 2px dashed gray;
  outline-offset: -10px;
  margin: 10px 0;
  padding: 9px 0;
}

.rdw-image-modal-upload-option-highlighted {
  outline: 2px dashed #0a66b7;
}

.rdw-image-modal-upload-option-label {
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

.rdw-image-modal-upload-option-label span {
  padding: 0 20px;
}

.rdw-image-modal-upload-option-image-preview {
  max-width: 100%;
  max-height: 200px;
}

.rdw-image-modal-upload-option-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.rdw-image-modal-url-section {
  display: flex;
  align-items: center;
}

.rdw-image-modal-url-input {
  width: 90%;
  height: 35px;
  margin: 15px 0 12px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-image-modal-btn-section {
  margin: 10px auto 0;
}

.rdw-image-modal-url-input:focus {
  outline: none;
}

.rdw-image-modal-btn {
  margin: 0 5px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-image-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-image-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-image-modal-btn:focus {
  outline: none !important;
}

.rdw-image-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-image-modal-spinner {
  position: absolute;
  top: -3px;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.rdw-image-modal-alt-input {
  width: 70%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
  margin-left: 5px;
}

.rdw-image-modal-alt-input:focus {
  outline: none;
}

.rdw-image-modal-alt-lbl {
  font-size: 12px;
}

.rdw-image-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-image-modal-size-input {
  width: 40%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-image-modal-size-input:focus {
  outline: none;
}

.rdw-image-mandatory-sign {
  color: red;
  margin-left: 3px;
  margin-right: 3px;
}

.rdw-remove-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-history-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-history-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-link-decorator-wrapper {
  position: relative;
}

.rdw-link-decorator-icon {
  position: absolute;
  left: 40%;
  top: 0;
  cursor: pointer;
  background-color: white;
}

.rdw-mention-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-suggestion-wrapper {
  position: relative;
}

.rdw-suggestion-dropdown {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid #F1F1F1;
  min-width: 100px;
  max-height: 150px;
  overflow: auto;
  background: white;
  z-index: 100;
}

.rdw-suggestion-option {
  padding: 7px 5px;
  border-bottom: 1px solid #f1f1f1;
}

.rdw-suggestion-option-active {
  background-color: #F1F1F1;
}

.rdw-hashtag-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-image-alignment-options-popup {
  position: absolute;
  background: white;
  display: flex;
  padding: 5px 2px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  width: 105px;
  cursor: pointer;
  z-index: 100;
}

.rdw-alignment-option-left {
  justify-content: flex-start;
}

.rdw-image-alignment-option {
  height: 15px;
  width: 15px;
  min-width: 15px;
}

.rdw-image-alignment {
  position: relative;
}

.rdw-image-imagewrapper {
  position: relative;
}

.rdw-image-center {
  display: flex;
  justify-content: center;
}

.rdw-image-left {
  display: flex;
}

.rdw-image-right {
  display: flex;
  justify-content: flex-end;
}

.rdw-image-alignment-options-popup-right {
  right: 0;
}

.rdw-editor-main {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.rdw-editor-toolbar {
  padding: 6px 5px 0;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  display: flex;
  justify-content: flex-start;
  background: white;
  flex-wrap: wrap;
  font-size: 15px;
  margin-bottom: 5px;
  -webkit-user-select: none;
          user-select: none;
}

.public-DraftStyleDefault-block {
  margin: 1em 0;
}

.rdw-editor-wrapper:focus {
  outline: none;
}

.rdw-editor-wrapper {
  box-sizing: content-box;
}

.rdw-editor-main blockquote {
  border-left: 5px solid #f1f1f1;
  padding-left: 5px;
}

.rdw-editor-main pre {
  background: #f1f1f1;
  border-radius: 3px;
  padding: 1px 10px;
} /**
* Draft v0.9.1
*
* Copyright (c) 2013-present, Facebook, Inc.
* All rights reserved.
*
* This source code is licensed under the BSD-style license found in the
* LICENSE file in the root directory of this source tree. An additional grant
* of patent rights can be found in the PATENTS file in the same directory.
*/
.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {
  height: inherit;
  text-align: left;
  text-align: initial;
}

.public-DraftEditor-content[contenteditable=true] {
  -webkit-user-modify: read-write-plaintext-only;
}

.DraftEditor-root {
  position: relative;
}

.DraftEditor-editorContainer {
  background-color: rgba(255, 255, 255, 0);
  border-left: 0.1px solid transparent;
  position: relative;
  z-index: 1;
}

.public-DraftEditor-block {
  position: relative;
}

.DraftEditor-alignLeft .public-DraftStyleDefault-block {
  text-align: left;
}

.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {
  left: 0;
  text-align: left;
}

.DraftEditor-alignCenter .public-DraftStyleDefault-block {
  text-align: center;
}

.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.DraftEditor-alignRight .public-DraftStyleDefault-block {
  text-align: right;
}

.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {
  right: 0;
  text-align: right;
}

.public-DraftEditorPlaceholder-root {
  color: #9197a3;
  position: absolute;
  z-index: 0;
}

.public-DraftEditorPlaceholder-hasFocus {
  color: #bdc1c9;
}

.DraftEditorPlaceholder-hidden {
  display: none;
}

.public-DraftStyleDefault-block {
  position: relative;
  white-space: pre-wrap;
}

.public-DraftStyleDefault-ltr {
  direction: ltr;
  text-align: left;
}

.public-DraftStyleDefault-rtl {
  direction: rtl;
  text-align: right;
}

.public-DraftStyleDefault-listLTR {
  direction: ltr;
}

.public-DraftStyleDefault-listRTL {
  direction: rtl;
}

.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {
  margin: 16px 0;
  padding: 0;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
  margin-left: 1.5em;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {
  margin-right: 1.5em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {
  margin-left: 3em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {
  margin-right: 3em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {
  margin-left: 4.5em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {
  margin-right: 4.5em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {
  margin-left: 6em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {
  margin-right: 6em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {
  margin-left: 7.5em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {
  margin-right: 7.5em;
}

.public-DraftStyleDefault-unorderedListItem {
  list-style-type: square;
  position: relative;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {
  list-style-type: disc;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {
  list-style-type: circle;
}

.public-DraftStyleDefault-orderedListItem {
  list-style-type: none;
  position: relative;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {
  left: -36px;
  position: absolute;
  text-align: right;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {
  position: absolute;
  right: -36px;
  text-align: left;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem:before {
  content: counter(ol0) ". ";
  counter-increment: ol0;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {
  content: counter(ol1) ". ";
  counter-increment: ol1;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {
  content: counter(ol2) ". ";
  counter-increment: ol2;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {
  content: counter(ol3) ". ";
  counter-increment: ol3;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {
  content: counter(ol4) ". ";
  counter-increment: ol4;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {
  counter-reset: ol0;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {
  counter-reset: ol1;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {
  counter-reset: ol2;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {
  counter-reset: ol3;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {
  counter-reset: ol4;
}

.demo-editor {
  height: 275px !important;
  border: 1px solid #F1F1F1 !important;
  padding: 5px !important;
  border-radius: 2px !important;
}

.has-switch {
  border-radius: 30px;
  cursor: pointer;
  display: inline-block;
  line-height: 1.72222;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 60px;
  -webkit-user-select: none;
          user-select: none;
}

.has-switch.deactivate {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.has-switch.deactivate label,
.has-switch.deactivate span {
  cursor: default !important;
}

.has-switch > div {
  position: relative;
  top: 0;
  width: 100px;
}

.has-switch > div.switch-animate {
  transition: left 0.25s ease-out;
}

.has-switch > div.switch-off {
  left: -35px;
}

.has-switch > div.switch-on {
  left: 0;
}

.has-switch > div label {
  background-color: #FFFFFF;
  background: rgb(255, 255, 255);
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);
  background-size: 150% 150%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.has-switch input[type=checkbox] {
  display: none;
}

.has-switch span {
  cursor: pointer;
  float: left;
  font-size: 11px;
  font-weight: 400;
  height: 24px;
  line-height: 15px;
  margin: 0;
  padding-bottom: 6px;
  padding-top: 5px;
  position: relative;
  text-align: center;
  text-indent: -10px;
  width: 50%;
  z-index: 1;
  transition: 0.25s ease-out;
}

.has-switch span.switch-left {
  background-color: #545cd8;
  border-left: 1px solid rgba(0, 0, 0, 0);
  border-radius: 30px 0 0 30px;
  color: #FFFFFF;
}

.has-switch .switch-off span.switch-left {
  background-color: #ced4da !important;
}

.has-switch span.switch-right {
  border-radius: 0 30px 30px 0;
  background-color: #545cd8;
  color: #ffffff;
  text-indent: 1px;
}

.has-switch .switch-off span.switch-right {
  background-color: #ced4da !important;
}

.has-switch label {
  border-radius: 12px;
  float: left;
  height: 22px;
  margin: 1px -13px;
  padding: 0;
  position: relative;
  vertical-align: middle;
  width: 22px;
  z-index: 10;
  transition: 0.25s ease-out;
}

.has-switch .switch-on .fa-check:before {
  margin-left: 10px;
}

.has-switch:hover .switch-on label {
  margin: 1px -17px;
  width: 26px;
}

.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 26px;
}

.has-switch-sm.has-switch span {
  height: 18px;
  line-height: 18px;
  padding: 0;
}
.has-switch-sm.has-switch label {
  height: 16px;
  width: 16px;
  margin: 1px -8px;
}
.has-switch-sm.has-switch .switch-off label {
  margin: 1px -13px;
}
.has-switch-sm.has-switch:hover .switch-on label {
  margin: 1px -11px;
  width: 20px;
}
.has-switch-sm.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 20px;
}

.dropzone-wrapper {
  width: 100%;
  border: #ced4da dashed 2px;
  border-radius: 0.3rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  height: 230px;
  transition: all 0.2s;
}
.dropzone-wrapper:hover {
  border-color: #545cd8;
}
.dropzone-wrapper > div {
  width: 100%;
  height: 100%;
  outline: none !important;
  display: flex;
  align-items: center;
}
.dropzone-wrapper.dropzone-wrapper-lg {
  height: 300px;
}
.dropzone-wrapper.dropzone-wrapper-sm {
  height: 150px;
}
.dropzone-wrapper input {
  width: 100%;
  height: 100%;
}
.dropzone-wrapper .dropzone-content {
  margin: 0 auto;
  color: #6c757d;
}
.dropzone-wrapper[aria-disabled=true] {
  border-color: #dee2e6;
}
.dropzone-wrapper[aria-disabled=true] .dropzone-content {
  color: #ced4da;
}

.rbt {
  outline: none;
}
.rbt-menu {
  margin-bottom: 2px;
}
.rbt-menu > li a {
  overflow: hidden;
  text-overflow: ellipsis;
}
.rbt-menu > li a:focus {
  outline: none;
}
.rbt-menu-pagination-option {
  text-align: center;
}
.rbt .rbt-input-main::-ms-clear {
  display: none;
}
.rbt-input-multi {
  cursor: text;
  overflow: hidden;
  position: relative;
}
.rbt-input-multi.form-control[disabled] {
  background-color: #e9ecef;
  opacity: 1;
}
.rbt-input-multi input::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.rbt-input-multi input:-ms-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi input::-webkit-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi .rbt-input-wrapper {
  margin-top: 2px;
  overflow: hidden;
}
.rbt-input-multi .rbt-input-main {
  height: auto;
}
.rbt-input-multi .rbt-input-hint-container {
  display: inline-block;
}
.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {
  height: auto;
}
.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {
  height: auto;
}
.rbt-close {
  z-index: 1;
}
.rbt-close-lg {
  font-size: 24px;
}
.rbt-token {
  background-color: #e0f3ff;
  border: 0;
  border-radius: 0.25rem;
  color: #545cd8;
  display: inline-block;
  line-height: 1em;
  margin: 0 3px 3px 0;
  padding: 4px 7px;
  position: relative;
}
.rbt-token-disabled {
  background-color: #f8f9fa;
  color: #adb5bd;
  pointer-events: none;
}
.rbt-token-removeable {
  cursor: pointer;
  padding-right: 21px;
}
.rbt-token-active {
  background-color: #545cd8;
  color: #fff;
  outline: none;
  text-decoration: none;
}
.rbt-token .rbt-token-remove-button {
  bottom: 0;
  color: #495057;
  font-size: inherit;
  font-weight: normal;
  opacity: 1;
  outline: none;
  padding: 3px 7px;
  position: absolute;
  right: 0;
  text-shadow: none;
  top: -1px;
}
.rbt-loader {
  animation: loader-animation 600ms infinite linear;
  border: 1px solid #e0f3ff;
  border-radius: 50%;
  border-top-color: rgb(173, 223.2580645161, 255);
  display: block;
  height: 16px;
  width: 16px;
}
.rbt-loader-lg {
  height: 20px;
  width: 20px;
}
.rbt-aux {
  display: flex;
  align-items: center;
  bottom: 0;
  justify-content: center;
  pointer-events: none; /* Don't block clicks on the input */
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
}
.rbt-aux-lg {
  width: 46px;
}
.rbt-aux .rbt-close {
  margin-top: -1px;
  pointer-events: auto; /* Override pointer-events: none; above */
  background-color: transparent;
  border: none;
}
.has-aux .rbt-input {
  padding-right: 34px;
}
.rbt-highlight-text {
  background-color: inherit;
  color: inherit;
  font-weight: bold;
  padding: 0;
}

/* Input Groups */
.input-group > .rbt {
  flex: 1 1;
}
.input-group > .rbt .rbt-input-hint-container {
  display: flex;
}
.input-group > .rbt .rbt-input-hint {
  z-index: 5;
}
.input-group > .rbt .rbt-aux {
  z-index: 5;
}
.input-group > .rbt:not(:first-child) .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .rbt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

@keyframes loader-animation {
  to {
    transform: rotate(1turn);
  }
}
.input-group > .rbt .rbt-input-hint-container {
  flex: 1 1;
  height: 100%;
}

.rbt-token-remove-button {
  background-color: transparent;
  border: none;
}

/* for debugging */
@keyframes react-widgets-autofill-start {
  from {
    /**/
  }
  to {
    /**/
  }
}
@keyframes react-widgets-autofill-cancel {
  from {
    /**/
  }
  to {
    /**/
  }
}
.rw-btn {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-clip: padding-box;
  cursor: pointer;
}

.rw-btn:focus {
  outline: none;
}

.rw-btn:disabled, fieldset[disabled] .rw-btn, .rw-state-disabled .rw-btn, .rw-state-readonly .rw-btn {
  cursor: inherit;
}

fieldset[disabled] .rw-btn {
  pointer-events: none;
}

.rw-picker-caret,
.rw-picker-btn {
  color: #212529;
}

.rw-picker-btn:hover {
  background-color: #e9ecef;
}

.rw-picker-btn:active {
  background-color: #dee2e6;
}

.rw-picker-btn:disabled, fieldset[disabled] .rw-picker-btn {
  background-color: #e9ecef;
}

.rw-input-addon, .rw-input-addon.rw-picker-btn {
  border-left: #ced4da 1px solid;
}

[dir=rtl] .rw-input-addon, [dir=rtl] .rw-input-addon.rw-picker-btn {
  border-right: #ced4da 1px solid;
  border-left: none;
}

.rw-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.rw-widget {
  border: none;
  color: #212529;
  font-size: 1em;
  font-family: inherit;
  outline: none;
  position: relative;
}

.rw-widget, .rw-widget *, .rw-widget:after, .rw-widget:before, .rw-widget *:after, .rw-widget *:before {
  box-sizing: border-box;
}

.rw-state-readonly,
.rw-state-disabled,
fieldset[disabled] .rw-widget {
  cursor: not-allowed;
}

.rw-widget-picker {
  display: grid;
  overflow: hidden;
  min-height: calc(1.5em + (0.75rem + 2px));
  background-color: #fff;
  border: #ced4da 1px solid;
  border-radius: 0.25rem;
  outline: none;
  grid-template: 1fr/1fr 1.9em;
  width: 100%;
}

.rw-widget-picker.rw-hide-caret {
  grid-template-columns: 1fr;
}

.rw-state-focus .rw-widget-picker {
  color: #495057;
  background-color: #fff;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-state-focus .rw-widget-picker.rw-widget-input {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);
}

.rw-input {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  padding: 0 0.75rem;
}

.rw-input:disabled {
  opacity: 1;
}

.rw-input[type=text]::-ms-clear {
  display: none;
}

.rw-input:disabled, .rw-input:read-only {
  cursor: inherit;
}

.rw-widget-input {
  color: #495057;
  background-color: #fff;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  background-clip: padding-box;
  width: inherit;
}

.rw-widget-input.rw-state-disabled, .rw-state-disabled .rw-widget-input, fieldset[disabled] .rw-widget-input {
  background-color: #e9ecef;
}

.rw-placeholder,
.rw-input::placeholder {
  color: #6c757d;
}

.rw-state-disabled .rw-placeholder,
.rw-state-disabled .rw-input::placeholder {
  color: #999;
}

.rw-detect-autofill {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
}

.rw-detect-autofill:disabled {
  opacity: 1;
}

.rw-detect-autofill:-webkit-autofill {
  animation-name: react-widgets-autofill-start;
  animation-duration: 0.01ms;
}

.rw-detect-autofill:not(:-webkit-autofill) {
  animation-name: react-widgets-autofill-cancel;
  animation-duration: 0.01ms;
}

.rw-webkit-autofill .rw-widget-container,
.rw-input:-webkit-autofill {
  background-color: rgb(232, 240, 254) !important;
  background-image: none !important;
  color: rgb(0, 0, 0) !important;
}

.rw-list {
  font-size: 1em;
  overflow-x: visible;
  overflow-y: auto;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.rw-list:focus {
  outline: none;
}

.rw-list-option, .rw-list-option-create {
  -webkit-user-select: none;
          user-select: none;
  color: #212529;
  cursor: pointer;
  border: 1px solid transparent;
  background-clip: padding-box;
}

.rw-list-option:hover, .rw-list-option-create:hover, [data-intent=keyboard] .rw-list-option.rw-state-focus:not(.rw-state-selected), [data-intent=keyboard] .rw-state-focus.rw-list-option-create:not(.rw-state-selected) {
  background-color: #e9ecef;
  border-color: #e9ecef;
}

.rw-list-option.rw-state-selected, .rw-state-selected.rw-list-option-create {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.rw-list-option.rw-state-disabled, .rw-state-disabled.rw-list-option-create {
  cursor: not-allowed;
  background-color: transparent;
  border-color: transparent;
  color: #dee2e6;
}

.rw-list-empty,
.rw-list-option,
.rw-list-option-create,
.rw-list-optgroup {
  padding: 0.25em 1.5em;
  outline: none;
}

.rw-list-empty {
  text-align: center;
  color: #ced4da;
}

.rw-list-optgroup {
  font-weight: bold;
  padding-top: 7px;
}

.rw-list-option-create {
  display: block;
  font-size: 1em;
  padding: 0.25em 1.5em;
}

.rw-listbox {
  border-radius: 4px;
  background-color: #fff;
  border: #ccc 1px solid;
}

.rw-listbox.rw-state-focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-listbox.rw-state-disabled > *, fieldset[disabled] .rw-listbox > * {
  pointer-events: none;
}

.rw-listbox.rw-state-readonly > * {
  cursor: inherit;
}

.rw-popup-container {
  position: absolute;
  z-index: 1005;
  top: 100%;
  left: -1em;
  right: -1em;
  padding: 0 1em;
}

.rw-popup-container.rw-dropup {
  top: auto;
  bottom: 100%;
}

.rw-state-focus .rw-popup-container {
  z-index: 1006;
}

.rw-slide-transition {
  margin-bottom: 1em;
}

.rw-dropup > .rw-slide-transition {
  margin-bottom: 0;
  margin-top: 1em;
}

.rw-popup {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 2px;
  border-radius: 4px;
  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);
  border: #ccc 1px solid;
  background-clip: padding-box;
  background: #fff;
}

.rw-popup .rw-list {
  max-height: 250px;
}

.rw-dropup .rw-popup {
  margin-top: 0;
  margin-bottom: 2px;
  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);
}

.rw-slide-transition {
  transition: transform 130ms, opacity 100ms;
}

.rw-slide-transition-entering {
  overflow: hidden;
}

.rw-slide-transition-entering .rw-slide-transition {
  transform: translateY(0);
  opacity: 1;
  transition-timing-function: ease-out;
}

.rw-slide-transition-exiting .rw-slide-transition {
  transition-timing-function: ease-in;
}

.rw-slide-transition-exiting,
.rw-slide-transition-exited {
  overflow: hidden;
}

.rw-slide-transition-exiting .rw-slide-transition,
.rw-slide-transition-exited .rw-slide-transition {
  opacity: 0;
  transform: translateY(-10%);
}

.rw-slide-transition-exiting.rw-dropup .rw-slide-transition,
.rw-slide-transition-exited.rw-dropup .rw-slide-transition {
  opacity: 0;
  transform: translateY(10%);
}

.rw-slide-transition-exited {
  display: none;
}

.rw-dropdown-list {
  width: 100%;
}

.rw-dropdownlist-search {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
}

.rw-dropdownlist-search:disabled {
  opacity: 1;
}

.rw-dropdown-list-input {
  padding: 0 0.75rem;
  align-self: center;
  display: grid;
  min-width: 0;
  grid-template: 1fr/1fr;
}

.rw-dropdown-list-input > * {
  grid-area: 1/1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

[dir=rtl] .rw-dropdown-list-input {
  padding-right: 0.75rem;
  padding-left: 0;
}

.rw-combobox-input {
  background-color: transparent;
  z-index: 1;
}

.rw-multiselect-input {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  height: calc(calc(1.5em + (0.75rem + 2px)) - 1px * 2);
  padding: 0 0.75rem;
  max-width: 100%;
}

.rw-multiselect-input:disabled {
  opacity: 1;
}

.rw-multiselect-input:disabled, .rw-multiselect-input:read-only {
  cursor: inherit;
}

.rw-multiselect-taglist {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
  outline: none;
  cursor: text;
}

.rw-state-disabled .rw-multiselect-taglist {
  cursor: inherit;
}

.rw-multiselect-tag {
  display: inline-flex;
  margin-left: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);
  margin-top: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);
  min-height: calc(calc(1.5em + (0.75rem + 2px)) * 0.77);
  border-radius: 3px;
  background-color: #dee2e6;
  border: 1px solid #dee2e6;
  cursor: default;
  max-width: 100%;
  align-items: center;
  overflow: hidden;
}

.rw-multiselect-tag:focus {
  outline: none;
}

[dir=rtl] .rw-multiselect-tag {
  margin-left: 0;
  margin-right: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);
  padding: 0 0.35em 0 0.35em;
}

.rw-multiselect-tag.rw-state-focus {
  z-index: 1;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-multiselect-tag.rw-state-disabled, fieldset[disabled] .rw-multiselect-tag {
  opacity: 0.65;
}

.rw-multiselect-tag-label {
  padding: 0 0.35em 0 0.35em;
}

.rw-multiselect-tag-btn {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  cursor: pointer;
  align-self: stretch;
  padding: 0 0.35em;
}

.rw-multiselect-tag-btn:focus {
  outline: none;
}

.rw-multiselect-tag-btn:disabled {
  cursor: inherit;
}

.rw-calendar-popup {
  right: auto;
  min-width: 0;
  width: 22em;
}

.rw-calendar {
  overflow: hidden;
}

.rw-calendar-contained {
  border-radius: 4px;
  background-color: #fff;
  border: #ccc 1px solid;
}

.rw-calendar-now {
  font-weight: bold;
}

.rw-calendar-header {
  display: flex;
  padding: 0.8em;
}

.rw-cell,
.rw-calendar-btn {
  background-clip: padding-box;
}

.rw-cell:focus,
.rw-calendar-btn:focus {
  z-index: 1;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  transition: box-shadow 0.15s ease-in-out;
}

[data-intent=mouse] .rw-cell:focus,
[data-intent=mouse] .rw-calendar-btn:focus {
  z-index: auto;
  box-shadow: none;
}

.rw-cell:disabled, .rw-cell.rw-state-disabled,
.rw-calendar-btn:disabled,
.rw-calendar-btn.rw-state-disabled {
  pointer-events: none;
  opacity: 0.35;
}

.rw-calendar-btn {
  line-height: 2em;
  border-radius: 4px;
}

.rw-calendar-btn:hover {
  background-color: #e9ecef;
}

.rw-calendar-btn:active {
  background-color: #dee2e6;
}

.rw-calendar-btn-left,
.rw-calendar-btn-today,
.rw-calendar-btn-right,
.rw-calendar-btn-view {
  padding: 0.3em 0.6em;
}

[dir=rtl] .rw-calendar-btn-left,
[dir=rtl] .rw-calendar-btn-right {
  transform: scale(-1, 1);
}

.rw-calendar-btn-view {
  font-weight: bold;
}

.rw-calendar-btn-view > :last-child {
  margin: 0 0.5em;
}

.rw-calendar-btn-view + * {
  margin-left: auto;
}

[dir=rtl] .rw-calendar-btn-view + * {
  margin-left: 0;
  margin-right: auto;
}

.rw-calendar-grid {
  display: table;
  outline: none;
  height: 14em;
  padding: 3px;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  background-color: #fff;
}

.rw-calendar-head {
  display: table-header-group;
}

.rw-calendar-body {
  display: table-row-group;
}

.rw-calendar-row {
  display: table-row;
}

.rw-head-cell {
  display: table-cell;
  text-align: center;
  border-bottom: 1px solid #ced4da;
  padding: 0.25em;
}

.rw-cell {
  display: table-cell;
  color: #212529;
  vertical-align: middle;
  border-radius: 4px;
  cursor: pointer;
  line-height: normal;
  text-align: center;
  border: 1px solid transparent;
  padding: 0.25em;
  outline: none;
}

.rw-cell:hover {
  background-color: #e9ecef;
}

.rw-cell:active {
  background-color: #dee2e6;
}

.rw-cell.rw-state-selected {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.rw-calendar-month .rw-cell {
  text-align: center;
}

.rw-cell-off-range {
  color: #ced4da;
}

.rw-calendar-transition-group {
  position: relative;
  overflow: hidden;
}

.rw-calendar-transition {
  width: 100%;
  overflow: hidden;
  transition: transform 0.2s ease-in-out 0ms;
  transform: translate(0, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition {
    transform: translate3d(0, 0, 0);
  }
}
.rw-calendar-transition-next {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.rw-calendar-transition-top .rw-calendar-transition-next {
  transform: translate(0, -100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-top .rw-calendar-transition-next {
    transform: translate3d(0, -100%, 0);
  }
}
.rw-calendar-transition-bottom .rw-calendar-transition-next {
  transform: translate(0, 100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-bottom .rw-calendar-transition-next {
    transform: translate3d(0, 100%, 0);
  }
}
.rw-calendar-transition-right .rw-calendar-transition-next {
  transform: translate(-100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-right .rw-calendar-transition-next {
    transform: translate3d(-100%, 0, 0);
  }
}
.rw-calendar-transition-left .rw-calendar-transition-next {
  transform: translate(100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-left .rw-calendar-transition-next {
    transform: translate3d(100%, 0, 0);
  }
}
.rw-calendar-transition-next.rw-calendar-transition-active {
  transform: translate(0, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-next.rw-calendar-transition-active {
    transform: translate3d(0, 0, 0);
  }
}
.rw-calendar-transition-prev {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
  left: 0;
  top: 0;
}

.rw-calendar-transition-top .rw-calendar-transition-prev {
  transform: translate(0, 100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-top .rw-calendar-transition-prev {
    transform: translate3d(0, 100%, 0);
  }
}
.rw-calendar-transition-bottom .rw-calendar-transition-prev {
  transform: translate(0, -100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-bottom .rw-calendar-transition-prev {
    transform: translate3d(0, -100%, 0);
  }
}
.rw-calendar-transition-right .rw-calendar-transition-prev {
  transform: translate(100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-right .rw-calendar-transition-prev {
    transform: translate3d(100%, 0, 0);
  }
}
.rw-calendar-transition-left .rw-calendar-transition-prev {
  transform: translate(-100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-left .rw-calendar-transition-prev {
    transform: translate3d(-100%, 0, 0);
  }
}
.rw-popup {
  display: flex;
  flex-direction: column;
}

.rw-popup > .rw-time-input {
  align-self: center;
  margin: 1em 0;
}

.rw-time-input {
  display: inline-flex;
  min-height: calc(1.5em + (0.75rem + 2px));
  align-items: center;
  background-color: #fff;
  border: #ced4da 1px solid;
  border-radius: 0.25rem;
  outline: none;
  cursor: text;
}

.rw-time-part-input {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  padding: 0 0.5em;
}

.rw-time-part-input:disabled {
  opacity: 1;
}

.rw-time-part-input, .rw-time-part-input::placeholder {
  text-align: center;
}

.rw-time-part-meridiem {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  padding: 0 0.5em;
  text-transform: lowercase;
  font-feature-settings: "smcp";
  font-variant: small-caps;
}

.rw-time-part-meridiem :focus {
  outline: none;
}

.rw-time-input-clear {
  padding: 0 0.4em;
  outline: none;
  opacity: 0;
  margin-left: auto;
}

[dir=rtl] .rw-time-input-clear {
  margin-left: revert;
  margin-right: auto;
}

.rw-time-input:hover .rw-time-input-clear.rw-show, .rw-time-input.rw-state-focus .rw-time-input-clear.rw-show {
  opacity: 1;
}

.rw-number-picker-spinners {
  display: flex;
  flex-direction: column;
}

.rw-number-picker-spinners .rw-btn {
  flex: 1 1;
}

.ui-theme-settings {
  position: fixed;
  z-index: 155;
  right: -30px;
  top: 0;
  height: 100vh;
  transform: translate(500px);
  transition: all 0.2s;
  box-shadow: -0.46875rem 0 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.9375rem 0 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.25rem 0 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), -0.125rem 0 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.ui-theme-settings .btn-open-options {
  border-radius: 50px;
  position: absolute;
  left: -114px;
  bottom: 80px;
  padding: 0;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
  display: block;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  margin-top: -27px;
}
.ui-theme-settings .btn-open-options svg {
  top: 50%;
  left: 50%;
  position: absolute;
  margin: -0.5em 0 0 -0.5em;
}
.ui-theme-settings .theme-settings__inner {
  background: #fff;
  width: 500px;
  height: 100vh;
  padding: 0;
}
.ui-theme-settings.settings-open {
  transform: translate(0);
  right: 0;
}
.ui-theme-settings .theme-settings-swatches {
  text-align: center;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img {
  width: 72px;
  height: auto;
  border-radius: 3px;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {
  width: 100%;
}
.ui-theme-settings .themeoptions-heading {
  font-size: 1.1rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
  display: flex;
  align-items: center;
  align-content: center;
}
.ui-theme-settings .themeoptions-heading:first-child {
  border-top: 0;
}
.ui-theme-settings .list-group-item h5, .ui-theme-settings .list-group-item .h5 {
  color: #545cd8;
  font-size: 0.968rem;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
}

.swatch-holder {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 5px 5px 0;
  transition: all 0.2s;
  opacity: 0.7;
  display: inline-block;
  border-radius: 30px;
}
.swatch-holder.active {
  border: #fff solid 2px;
  box-shadow: 0 0 0 5px #545cd8;
  opacity: 1;
}
.swatch-holder:hover {
  opacity: 1;
}

.swatch-holder-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.font-icon-wrapper {
  text-align: center;
  border: #e9ecef solid 1px;
  border-radius: 0.25rem;
  margin: 0 0 10px;
  padding: 5px;
}
.font-icon-wrapper.font-icon-lg {
  float: left;
  padding: 10px;
  text-align: center;
  margin-right: 15px;
  min-width: 64px;
}
.font-icon-wrapper.font-icon-lg i {
  font-size: 2.2rem;
}
.font-icon-wrapper:hover {
  background: #f8f9fa;
  color: #545cd8;
}
.font-icon-wrapper:hover p {
  color: #6c757d;
}
.font-icon-wrapper i {
  font-size: 1.65rem;
}
.font-icon-wrapper p {
  color: #adb5bd;
  font-size: 0.8066666667rem;
  margin: 5px 0 0;
}

.btn-icon-vertical {
  min-width: 100px;
}

.card.mb-3 {
  margin-bottom: 1.5rem !important;
}

.demo-image-bg {
  height: 350px;
  margin-bottom: 1.5rem;
}

.loader-wrapper {
  width: 150px;
  height: 100px;
  float: left;
}

.slider-item {
  background: #dee2e6;
  border-radius: 0.25rem;
  color: #6c757d;
  font-size: 36px;
  padding: 0;
  position: relative;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 1.5rem;
  transition: all 0.2s;
}

.slick-center .slider-item {
  background: #adb5bd;
  color: #495057;
}

.after-img {
  max-width: 100%;
}

@media only screen and (max-width: 1320px) {
  .header-user-info {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .app-main {
    display: block;
  }
  .dropdown-menu::before, .dropdown-menu::after {
    display: none;
  }
  .app-sidebar {
    flex: 0 0 280px !important;
    width: 280px !important;
    transform: translateX(-280px);
  }
  .app-sidebar .app-header__logo {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar {
    transform: translateX(0);
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {
    text-indent: 0;
    text-indent: initial;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {
    text-indent: 0;
    text-indent: initial;
    padding: 0 1.5rem 0 45px;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {
    text-indent: 0;
    text-indent: initial;
    left: 5px;
    margin-left: 0;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {
    visibility: visible;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {
    padding: 0.5em 0 0 2rem;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
    height: 2.3em;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
    padding-left: 1em;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo {
    width: auto !important;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {
    width: 97px !important;
    margin-left: auto;
    margin-right: 0;
  }
  .sidebar-mobile-open .fixed-sidebar .app-sidebar {
    height: 100%;
  }
  .sidebar-mobile-open .sidebar-mobile-overlay {
    display: block;
  }
  .app-main .app-main__outer {
    padding-left: 0 !important;
    width: auto;
  }
  .app-header {
    justify-content: space-between;
  }
  .app-header .app-header__logo {
    display: none;
    order: 2;
    background: transparent !important;
    border: 0 !important;
  }
  .app-header .app-header__content {
    visibility: hidden;
    opacity: 0;
    box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
    position: absolute;
    left: 5%;
    width: 90%;
    top: 0;
    transition: all 0.2s;
    background: #fff;
    border-radius: 50px;
    padding: 0 10px;
    overflow: hidden;
  }
  .app-header .app-header__content .header-btn-lg {
    margin-left: 0.5rem;
    padding: 0 0.5rem;
  }
  .app-header .app-header__content .header-btn-lg .hamburger-box {
    margin-top: 5px;
  }
  .app-header .app-header__content .header-btn-lg + .header-btn-lg {
    display: none;
  }
  .app-header .app-header__content .app-header-left .nav {
    display: none;
  }
  .app-header .app-header__content.header-mobile-open {
    visibility: visible;
    opacity: 1;
    top: 80px;
  }
  .app-header .app-header__mobile-menu {
    display: flex;
    order: 1;
  }
  .app-header .app-header__menu {
    display: flex;
    order: 3;
  }
  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.1);
  }
  .app-header.header-text-light .header-mobile-open {
    background: #343a40;
  }
  .popover,
  .dropdown-menu {
    position: fixed !important;
    z-index: 50;
    left: 5% !important;
    top: 50% !important;
    width: 90% !important;
    transform: translateY(-50%) !important;
    min-width: 10px !important;
  }
  .popover .btn-icon-vertical .btn-icon-wrapper,
  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {
    display: none;
  }
  .popover {
    max-width: none;
    max-width: initial;
  }
  .popover .arrow {
    display: none !important;
  }
  .app-page-title {
    text-align: center;
  }
  .app-page-title .page-title-heading,
  .app-page-title .page-title-wrapper {
    margin: 0 auto;
    display: block;
  }
  .app-page-title .page-title-actions {
    margin: 0.75rem auto 0;
  }
  .app-page-title .page-title-actions .breadcrumb-item,
  .app-page-title .page-title-actions .breadcrumb,
  .app-page-title .page-title-subheading .breadcrumb-item,
  .app-page-title .page-title-subheading .breadcrumb {
    display: inline-block;
  }
  .app-footer .app-footer__inner .app-footer-right {
    display: none;
  }
  .app-footer .app-footer__inner .app-footer-left {
    width: 100%;
  }
  .app-footer .app-footer__inner .app-footer-left .footer-dots {
    margin: 0 auto;
  }
  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {
    margin-left: 0 !important;
  }
  .widget-content .widget-numbers {
    font-size: 1.6rem;
    line-height: 1;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big {
    display: block !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
    display: inline-block !important;
    padding: 0 1.5rem !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {
    margin-top: -20px;
  }
  .ReactTable .-pagination .-center {
    display: none;
  }
  .ReactTable .-pagination .-previous {
    padding-right: 3px;
  }
  .bg-transparent.list-group-item {
    border-color: transparent;
  }
  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {
    font-size: 1.5rem;
  }
  .page-title-head {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .app-page-title .page-title-icon,
  .ui-theme-settings {
    display: none;
  }
  .card-header.responsive-center {
    display: block;
    text-align: center;
    height: auto;
    padding: 1.5rem;
  }
  .card-header.responsive-center .nav,
  .card-header.responsive-center .btn-actions-pane-right {
    margin: 0.75rem 0 0;
  }
  .card-header.responsive-center .nav .d-inline-block.ml-2,
  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {
    width: 100% !important;
    text-align: left;
    margin: 0 !important;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
}
@media (min-width: 992px) {
  .slick-slider-sm .slick-slider {
    max-width: 850px !important;
  }
}
@media (max-width: 991.98px) {
  .-hide-paging .-pagination .-center {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .app-main .app-main__inner {
    padding: 15px 15px 0;
  }
  .mbg-3,
  body .card.mb-3 {
    margin-bottom: 0.75rem !important;
  }
  .app-page-title {
    padding: 0.75rem;
    margin: -0.75rem -0.75rem 1.5rem;
  }
  .body-tabs.body-tabs-layout {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
    padding: 0 0.75rem;
  }
  .app-main .app-main__inner > .RRT__container > .RRT__panel {
    margin-top: 0.75rem;
  }
  .popover,
  .dropdown-menu {
    width: 80%;
    left: 10%;
  }
  body .card-header {
    height: auto;
    display: block;
    padding: 0.75rem 1.5rem;
    text-align: center;
  }
  body .card-header .btn-actions-pane-right {
    padding: 0.75rem 0 0;
  }
  body .card-header .actions-icon-btn {
    padding: 0;
  }
  .card-header.card-header-tab .card-header-title {
    display: inline-flex !important;
    line-height: 1;
  }
  .card-header.card-header-tab > .nav {
    margin: 0.75rem 0 -0.75rem;
    display: table !important;
    width: 100%;
  }
  .card-header.card-header-tab > .nav .nav-item {
    display: table-cell;
  }
  .header-icon {
    display: none;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
  .slick-slider-sm .slick-slider .slick-prev {
    left: 0.75rem;
  }
  .slick-slider-sm .slick-slider .slick-next {
    right: 0.75rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/base.scss","webpack://./src/assets/themes/default/_variables.scss","webpack://./src/assets/components/bootstrap5/_root.scss","webpack://./src/assets/components/bootstrap5/_reboot.scss","webpack://./src/assets/components/bootstrap5/_variables.scss","webpack://./src/assets/components/bootstrap5/vendor/_rfs.scss","webpack://./src/assets/components/bootstrap5/mixins/_border-radius.scss","webpack://./src/assets/components/bootstrap5/_type.scss","webpack://./src/assets/components/bootstrap5/mixins/_lists.scss","webpack://./src/assets/components/bootstrap5/_images.scss","webpack://./src/assets/components/bootstrap5/mixins/_image.scss","webpack://./src/assets/components/bootstrap5/_containers.scss","webpack://./src/assets/components/bootstrap5/mixins/_container.scss","webpack://./src/assets/components/bootstrap5/mixins/_breakpoints.scss","webpack://./src/assets/components/bootstrap5/_grid.scss","webpack://./src/assets/components/bootstrap5/mixins/_grid.scss","webpack://./src/assets/components/bootstrap5/_tables.scss","webpack://./src/assets/components/bootstrap5/mixins/_table-variants.scss","webpack://./src/assets/components/bootstrap5/forms/_labels.scss","webpack://./src/assets/components/bootstrap5/forms/_form-text.scss","webpack://./src/assets/components/bootstrap5/forms/_form-control.scss","webpack://./src/assets/components/bootstrap5/mixins/_transition.scss","webpack://./src/assets/components/bootstrap5/mixins/_gradients.scss","webpack://./src/assets/components/bootstrap5/forms/_form-select.scss","webpack://./src/assets/components/bootstrap5/forms/_form-check.scss","webpack://./src/assets/components/bootstrap5/forms/_form-range.scss","webpack://./src/assets/components/bootstrap5/forms/_floating-labels.scss","webpack://./src/assets/components/bootstrap5/forms/_input-group.scss","webpack://./src/assets/components/bootstrap5/mixins/_forms.scss","webpack://./src/assets/components/bootstrap5/_buttons.scss","webpack://./src/assets/components/bootstrap5/mixins/_buttons.scss","webpack://./src/assets/components/bootstrap5/_transitions.scss","webpack://./src/assets/components/bootstrap5/_dropdown.scss","webpack://./src/assets/components/bootstrap5/mixins/_caret.scss","webpack://./src/assets/components/bootstrap5/_button-group.scss","webpack://./src/assets/components/bootstrap5/_nav.scss","webpack://./src/assets/components/bootstrap5/_navbar.scss","webpack://./src/assets/components/bootstrap5/_card.scss","webpack://./src/assets/components/bootstrap5/_accordion.scss","webpack://./src/assets/components/bootstrap5/_breadcrumb.scss","webpack://./src/assets/components/bootstrap5/_pagination.scss","webpack://./src/assets/components/bootstrap5/mixins/_pagination.scss","webpack://./src/assets/components/bootstrap5/_badge.scss","webpack://./src/assets/components/bootstrap5/_alert.scss","webpack://./src/assets/components/bootstrap5/mixins/_alert.scss","webpack://./src/assets/components/bootstrap5/_progress.scss","webpack://./src/assets/components/bootstrap5/_list-group.scss","webpack://./src/assets/components/bootstrap5/mixins/_list-group.scss","webpack://./src/assets/components/bootstrap5/_close.scss","webpack://./src/assets/components/bootstrap5/_toasts.scss","webpack://./src/assets/components/bootstrap5/_modal.scss","webpack://./src/assets/components/bootstrap5/_tooltip.scss","webpack://./src/assets/components/bootstrap5/mixins/_reset-text.scss","webpack://./src/assets/components/bootstrap5/_popover.scss","webpack://./src/assets/components/bootstrap5/_carousel.scss","webpack://./src/assets/components/bootstrap5/mixins/_clearfix.scss","webpack://./src/assets/components/bootstrap5/_spinners.scss","webpack://./src/assets/components/bootstrap5/_offcanvas.scss","webpack://./src/assets/components/bootstrap5/_jumbotron.scss","webpack://./src/assets/components/bootstrap5/helpers/_colored-links.scss","webpack://./src/assets/components/bootstrap5/helpers/_ratio.scss","webpack://./src/assets/components/bootstrap5/helpers/_position.scss","webpack://./src/assets/components/bootstrap5/helpers/_visually-hidden.scss","webpack://./src/assets/components/bootstrap5/mixins/_visually-hidden.scss","webpack://./src/assets/components/bootstrap5/helpers/_stretched-link.scss","webpack://./src/assets/components/bootstrap5/helpers/_text-truncation.scss","webpack://./src/assets/components/bootstrap5/mixins/_text-truncate.scss","webpack://./src/assets/components/bootstrap5/mixins/_utilities.scss","webpack://./src/assets/components/bootstrap5/utilities/_api.scss","webpack://./src/assets/layout/generic/_generic-base.scss","webpack://./src/assets/layout/generic/_animations.scss","webpack://./src/assets/layout/header/_header-base.scss","webpack://./src/assets/layout/_layout-variables.scss","webpack://./src/assets/layout/header/modifiers/_fixed-header.scss","webpack://./src/assets/layout/header/modifiers/_header-dots.scss","webpack://./src/assets/layout/header/modifiers/_header-megamenu.scss","webpack://./src/assets/layout/header/modifiers/_header-buttons.scss","webpack://./src/assets/layout/header/themes/_header-light.scss","webpack://./src/assets/layout/header/themes/_header-dark.scss","webpack://./src/assets/layout/sidebar/_sidebar-base.scss","webpack://./src/assets/layout/sidebar/modifiers/_navmenu-vertical.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-light.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-dark.scss","webpack://./src/assets/layout/sidebar/modifiers/_fixed-sidebar.scss","webpack://./src/assets/layout/sidebar/modifiers/_closed-sidebar.scss","webpack://./src/assets/layout/main/_main-base.scss","webpack://./src/assets/layout/main/themes/_main-white.scss","webpack://./src/assets/layout/main/themes/_main-gray.scss","webpack://./src/assets/layout/footer/_footer-base.scss","webpack://./src/assets/layout/footer/_fixed-footer.scss","webpack://./src/assets/layout/elements/page-title/_page-title-base.scss","webpack://./src/assets/layout/elements/search-box/_search-box.scss","webpack://./src/assets/sass/base/_reset.scss","webpack://./src/assets/sass/base/_global.scss","webpack://./src/assets/sass/utilities/_mixin.scss","webpack://./src/assets/sass/utilities/_variables.scss","webpack://./src/assets/sass/base/_typography.scss","webpack://./src/assets/sass/components/_table.scss","webpack://./src/assets/sass/components/_button.scss","webpack://./src/assets/sass/components/_form.scss","webpack://./src/assets/sass/components/_dropdown.scss","webpack://./src/assets/sass/pages/home/_home.scss","webpack://./src/assets/sass/pages/dispute/_dispute.scss","webpack://./src/assets/sass/pages/Voucher/_voucher.scss","webpack://./src/assets/sass/pages/kyc/_kyc.scss","webpack://./src/assets/sass/pages/kyc/_reviewKyc.scss","webpack://./src/assets/sass/pages/bugs/_bugs.scss","webpack://./src/assets/utils/helpers/_opacity.scss","webpack://./src/assets/utils/helpers/_grayscale.scss","webpack://./src/assets/utils/_helpers.scss","webpack://./src/assets/utils/_backgrounds.scss","webpack://./node_modules/animate-sass/helpers/_base.scss","webpack://./node_modules/animate-sass/helpers/_mixins.scss","webpack://./node_modules/animate-sass/helpers/_settings.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeIn.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInDown.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInUp.scss","webpack://./node_modules/animate-sass/animations/fade-exit/_fadeOut.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedIn.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedOut.scss","webpack://./src/assets/utils/_comps-animations.scss","webpack://./src/assets/elements/_buttons.scss","webpack://./src/assets/elements/_dropdown.scss","webpack://./src/assets/elements/_navs.scss","webpack://./src/assets/elements/_badges.scss","webpack://./src/assets/elements/_cards.scss","webpack://./src/assets/elements/_tabs.scss","webpack://./src/assets/elements/_accordions.scss","webpack://./src/assets/elements/_modals.scss","webpack://./src/assets/elements/_loaders.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse.scss","webpack://./node_modules/loaders.css/src/_mixins.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-sync.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale.scss","webpack://./node_modules/loaders.css/src/animations/ball-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-triangle-trace.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-rise.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag-deflect.scss","webpack://./node_modules/loaders.css/src/animations/line-scale.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-random.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid.scss","webpack://./node_modules/loaders.css/src/animations/line-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/triangle-skew-spin.scss","webpack://./node_modules/loaders.css/src/animations/square-spin.scss","webpack://./node_modules/loaders.css/src/animations/pacman.scss","webpack://./node_modules/loaders.css/src/animations/cube-transition.scss","webpack://./node_modules/loaders.css/src/animations/semi-circle-spin.scss","webpack://./src/assets/elements/_progressbar.scss","webpack://./src/assets/elements/_timeline.scss","webpack://./src/assets/elements/listgroup.scss","webpack://./src/assets/elements/_forms.scss","webpack://./src/assets/elements/_pagination.scss","webpack://./src/assets/elements/_chat.scss","webpack://./src/assets/elements/_forms-wizard.scss","webpack://./src/assets/widgets/chart-boxes/_chart-boxes.scss","webpack://./src/assets/widgets/content-boxes/_content-boxes.scss","webpack://./src/assets/widgets/profile-boxes/_profile-boxes.scss","webpack://./src/assets/pages/_userpages.scss","webpack://./src/assets/applications/_applications-base.scss","webpack://./src/assets/applications/_chat.scss","webpack://./src/assets/applications/_responsive.scss","webpack://./src/assets/components/perfect-scrollbar/_perfect-scrollbar.scss","webpack://./src/assets/components/rc-tabs/_rc-tabs.scss","webpack://./src/assets/components/loading-buttons/_loading-buttons.scss","webpack://./src/assets/components/hamburgers/hamburgers.scss","webpack://./src/assets/components/hamburgers/_base.scss","webpack://./src/assets/components/hamburgers/types/_elastic.scss","webpack://./src/assets/components/drawer/_drawer.scss","webpack://./src/assets/components/notifications/_sweetalerts.scss","webpack://./src/assets/components/notifications/toastify/_toastContainer.scss","webpack://./src/assets/components/notifications/toastify/_variables.scss","webpack://./src/assets/components/notifications/toastify/_toast.scss","webpack://./src/assets/components/notifications/toastify/_closeButton.scss","webpack://./src/assets/components/notifications/toastify/_progressBar.scss","webpack://./src/assets/components/notifications/toastify/animations/_bounce.scss","webpack://./src/assets/components/notifications/toastify/animations/_zoom.scss","webpack://./src/assets/components/notifications/toastify/animations/_flip.scss","webpack://./src/assets/components/notifications/toastify/animations/_slide.scss","webpack://./src/assets/components/modals/_rodal.scss","webpack://./src/assets/components/progress-bar/_progress-bar.scss","webpack://./src/assets/components/slick-carousel/slick/_slick.scss","webpack://./src/assets/components/slick-carousel/slick/_slick-theme.scss","webpack://./src/assets/components/block-loading/_block-loading.scss","webpack://./src/assets/components/popovers-tooltips/_popovers-tooltips.scss","webpack://./src/assets/components/sticky-elements/_sticky-elements.scss","webpack://./src/assets/components/calendar/scss/_reset.scss","webpack://./src/assets/components/calendar/_calendar.scss","webpack://./src/assets/components/calendar/scss/_variables.scss","webpack://./src/assets/components/calendar/scss/_toolbar.scss","webpack://./src/assets/components/calendar/scss/_event.scss","webpack://./src/assets/components/calendar/scss/_month.scss","webpack://./src/assets/components/calendar/scss/_agenda.scss","webpack://./src/assets/components/calendar/scss/_time-column.scss","webpack://./src/assets/components/calendar/scss/_time-grid.scss","webpack://./src/assets/components/splitters/_splitters.scss","webpack://./src/assets/components/tree-view/_tree-view.scss","webpack://./src/assets/components/tables/_tables.scss","webpack://./src/assets/components/icons/_linearicons.scss","webpack://./node_modules/pe7-icon/dist/scss/pe-icon-7-stroke.scss","webpack://./node_modules/pe7-icon/dist/scss/_path.scss","webpack://./node_modules/pe7-icon/dist/scss/_core.scss","webpack://./node_modules/pe7-icon/dist/scss/_helper.scss","webpack://./node_modules/pe7-icon/dist/scss/_icons.scss","webpack://./node_modules/pe7-icon/dist/scss/_variables.scss","webpack://./src/assets/components/forms/datepicker/_mixins.scss","webpack://./src/assets/components/forms/datepicker/_variables.scss","webpack://./src/assets/components/forms/datepicker/_datepicker.scss","webpack://./src/assets/components/forms/rangeslider/_tooltip.scss","webpack://./src/assets/components/forms/rangeslider/_rangeslider.scss","webpack://./src/assets/components/forms/wysiwyg/_wysiwyg.scss","webpack://./src/assets/components/forms/toggle-switch/_switch.scss","webpack://./src/assets/components/forms/dropzone/_dropzone.scss","webpack://./src/assets/components/forms/typeahead/_typeahead.scss","webpack://./src/assets/components/forms/typeahead/_mixins.scss","webpack://./node_modules/react-widgets/scss/widget.scss","webpack://./node_modules/react-widgets/scss/mixins.scss","webpack://./node_modules/react-widgets/scss/variables.scss","webpack://./node_modules/react-widgets/scss/list.scss","webpack://./node_modules/react-widgets/scss/listbox.scss","webpack://./node_modules/react-widgets/scss/popup.scss","webpack://./node_modules/react-widgets/scss/dropdown-list.scss","webpack://./node_modules/react-widgets/scss/combobox.scss","webpack://./node_modules/react-widgets/scss/multiselect.scss","webpack://./node_modules/react-widgets/scss/calendar.scss","webpack://./node_modules/react-widgets/scss/date-picker.scss","webpack://./node_modules/react-widgets/scss/time-input.scss","webpack://./node_modules/react-widgets/scss/number-picker.scss","webpack://./src/assets/demo-ui/elements/_theme-options.scss","webpack://./src/assets/demo-ui/_demo.scss","webpack://./src/assets/layout/responsive/_responsive-base.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgLd;EACE,qBA5FW;ADjFf;;AC4KE;EACE,qBA5FW;AD7Ef;;ACwKE;EACE,qBA5FW;ADzEf;;ACoKE;EACE,qBA5FW;ADrEf;;ACgKE;EACE,qBA5FW;ADjEf;;AC4JE;EACE,qBA5FW;AD7Df;;ACwJE;EACE,qBA5FW;ADzDf;;ACoJE;EACE,qBA5FW;ADrDf;;ACgJE;EACE,qBA5FW;ADjDf;;AC4IE;EACE,qBA5FW;AD7Cf;;AExCA;EAGI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAKF,qNAAA;EACA,yGAAA;EACA,yFAAA;AFuDF;;AGtDA;;;EAGE,sBAAA;AHyDF;;AG5CI;EAJJ;IAKM,uBAAA;EHgDJ;AACF;;AGpCA;EACE,SAAA;EACA,4MCsX4B;EDtX5B,sCCsX4B;EChIxB,kBALI;EF/OR,gBCgY4B;ED/X5B,gBCqY4B;EDpY5B,cF5BS;EE8BT,sBFzCQ;EE0CR,8BAAA;EACA,6CAAA;AHsCF;;AG7BA;EACE,cAAA;EACA,cCqb4B;EDpb5B,8BAAA;EACA,SAAA;EACA,aCob4B;AJpZ9B;;AG7BA;EACE,WC+R4B;AJ/P9B;;AGtBA;EACE,aAAA;EACA,qBC0X4B;EDvX5B,gBFCqB;EEArB,gBC0X4B;AJnW9B;;AGnBA;EE4MQ,kCAAA;ALrLR;AKmBI;EF1CJ;IEmNQ,iBAAA;ELxLN;AACF;;AGvBA;EEuMQ,mCAAA;AL5KR;AKUI;EFrCJ;IE8MQ,kBAAA;EL/KN;AACF;;AG3BA;EEkMQ,mCAAA;ALnKR;AKCI;EFhCJ;IEyMQ,kBAAA;ELtKN;AACF;;AG/BA;EE6LQ,mCAAA;AL1JR;AKRI;EF3BJ;IEoMQ,kBAAA;EL7JN;AACF;;AGnCA;EEoLM,iBALI;ALxIV;;AGlCA;EE+KM,kBALI;ALpIV;;AG3BA;EACE,aAAA;EACA,mBCyK0B;AJ3I5B;;AGnBA;;EAEE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AHsBF;;AGhBA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHmBF;;AGbA;;EAEE,kBAAA;AHgBF;;AGbA;;;EAGE,aAAA;EACA,mBAAA;AHgBF;;AGbA;;;;EAIE,gBAAA;AHgBF;;AGbA;EACE,gBC6P4B;AJ7O9B;;AGXA;EACE,qBAAA;EACA,cAAA;AHcF;;AGRA;EACE,gBAAA;AHWF;;AGHA;;EAEE,mBCsO4B;AJhO9B;;AGEA;EEgFM,kBALI;ALzEV;;AGKA;EACE,cCkS4B;EDjS5B,yBCyS4B;AJ3S9B;;AGWA;;EAEE,kBAAA;EE4DI,iBALI;EFrDR,cAAA;EACA,wBAAA;AHRF;;AGWA;EAAM,eAAA;AHPN;;AGQA;EAAM,WAAA;AHJN;;AGSA;EACE,cFxMM;EEyMN,0BCyCwC;AJ/C1C;AGQE;EACE,6BCwCsC;AJ9C1C;;AGiBE;EAEE,cAAA;EACA,qBAAA;AHfJ;;AGsBA;;;;EAIE,iGCmJ4B;EDnJ5B,qCCmJ4B;ECjIxB,cALI;EFXR,+BAAA;EACA,2BAAA;AHnBF;;AG0BA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EEII,kBALI;ALrBV;AG2BE;EEDI,kBALI;EFQN,cAAA;EACA,kBAAA;AHzBJ;;AG6BA;EERM,kBALI;EFeR,cF7PK;EE8PL,qBAAA;AH1BF;AG6BE;EACE,cAAA;AH3BJ;;AG+BA;EACE,sBAAA;EEpBI,kBALI;EF2BR,WF3SM;EE4SN,yBFnSS;EKNP,qBAAA;AN8QJ;AG8BE;EACE,UAAA;EE3BE,cALI;EFkCN,gBCgH0B;AJ5I9B;;AGqCA;EACE,gBAAA;AHlCF;;AGwCA;;EAEE,sBAAA;AHrCF;;AG6CA;EACE,oBAAA;EACA,yBAAA;AH1CF;;AG6CA;EACE,mBC8K4B;ED7K5B,sBC6K4B;ED5K5B,cF9US;EE+UT,gBAAA;AH1CF;;AGiDA;EAEE,mBAAA;EACA,gCAAA;AH/CF;;AGkDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AH/CF;;AGuDA;EACE,qBAAA;AHpDF;;AG0DA;EAEE,gBAAA;AHxDF;;AGgEA;EACE,UAAA;AH7DF;;AGkEA;;;;;EAKE,SAAA;EACA,oBAAA;EE1HI,kBALI;EFiIR,oBAAA;AH/DF;;AGmEA;;EAEE,oBAAA;AHhEF;;AGqEA;EACE,eAAA;AHlEF;;AGqEA;EAGE,iBAAA;AHpEF;AGuEE;EACE,UAAA;AHrEJ;;AG4EA;EACE,aAAA;AHzEF;;AGiFA;;;;EAIE,0BAAA;AH9EF;AGiFI;;;;EACE,eAAA;AH5EN;;AGmFA;EACE,UAAA;EACA,kBAAA;AHhFF;;AGqFA;EACE,gBAAA;AHlFF;;AG4FA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AHzFF;;AGiGA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCG4B;EClNtB,iCAAA;EFkNN,oBAAA;AH/FF;AKrRI;EF6WJ;IEpMQ,iBAAA;ELgHN;AACF;AG4FE;EACE,WAAA;AH1FJ;;AGiGA;;;;;;;EAOE,UAAA;AH9FF;;AGiGA;EACE,YAAA;AH9FF;;AGuGA;EACE,oBAAA;EACA,6BAAA;AHpGF;;AG4GA;;;;;;;CAAA;AAWA;EACE,wBAAA;AH5GF;;AGiHA;EACE,UAAA;AH9GF;;AGoHA;EACE,aAAA;AHjHF;;AGgHA;EACE,aAAA;AHjHF;;AGuHA;EACE,aAAA;EACA,0BAAA;AHpHF;;AGyHA;EACE,qBAAA;AHtHF;;AG2HA;EACE,SAAA;AHxHF;;AG+HA;EACE,kBAAA;EACA,eAAA;AH5HF;;AGoIA;EACE,wBAAA;AHjIF;;AGyIA;EACE,wBAAA;AHtIF;;AOzcA;EFyQM,iBALI;EElQR,gBHyc4B;AJG9B;;AOvcE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJ6B9B;AKzWI;EEpGF;IF6QM,eAAA;ELoMN;AACF;;AOldE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJwC9B;AKpXI;EEpGF;IF6QM,iBAAA;EL+MN;AACF;;AO7dE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJmD9B;AK/XI;EEpGF;IF6QM,eAAA;EL0NN;AACF;;AOxeE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJ8D9B;AK1YI;EEpGF;IF6QM,iBAAA;ELqON;AACF;;AOnfE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJyE9B;AKrZI;EEpGF;IF6QM,eAAA;ELgPN;AACF;;AO9fE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJoF9B;AKhaI;EEpGF;IF6QM,iBAAA;EL2PN;AACF;;AOnfA;ECrDE,eAAA;EACA,gBAAA;AR4iBF;;AOnfA;EC1DE,eAAA;EACA,gBAAA;ARijBF;;AOrfA;EACE,qBAAA;APwfF;AOtfE;EACE,oBHgc0B;AJwD9B;;AO9eA;EFsNM,kBALI;EE/MR,yBAAA;APifF;;AO7eA;EACE,mBHmKO;EC4CH,iBALI;ALuSV;AO9eE;EACE,gBAAA;APgfJ;;AO5eA;EACE,iBAAA;EACA,mBHyJO;EC4CH,kBALI;EE9LR,cN5ES;AD2jBX;AO7eE;EACE,aAAA;AP+eJ;;AS7kBA;ECIE,eAAA;EAGA,YAAA;AV2kBF;;AS5kBA;EACE,gBL2yCkC;EK1yClC,sBRHQ;EQIR,yBAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AVolBF;;AStkBA;EAEE,qBAAA;ATwkBF;;ASrkBA;EACE,qBAAA;EACA,cAAA;ATwkBF;;ASrkBA;EJ+PM,kBALI;EIxPR,cRlBS;AD0lBX;;AW1mBE;;;;;;;ECHA,WAAA;EACA,sBAAA;EAAA,0CAAA;EACA,qBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,iBAAA;AZunBF;;Aa/jBI;EF5CE;IACE,gBPoTe;EJ2TrB;AACF;AarkBI;EF5CE;IACE,gBPoTe;EJgUrB;AACF;Aa1kBI;EF5CE;IACE,gBPoTe;EJqUrB;AACF;Aa/kBI;EF5CE;IACE,iBPoTe;EJ0UrB;AACF;AaplBI;EF5CE;IACE,iBPoTe;EJ+UrB;AACF;AcnpBE;ECAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AfspBF;AczpBI;ECYF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AfgpBF;;AejmBM;EACE,SAAA;AfomBR;;AejmBM;EApCJ,cAAA;EACA,WAAA;AfyoBF;;Ae3nBE;EACE,cAAA;EACA,WAAA;Af8nBJ;;AehoBE;EACE,cAAA;EACA,UAAA;AfmoBJ;;AeroBE;EACE,cAAA;EACA,qBAAA;AfwoBJ;;Ae1oBE;EACE,cAAA;EACA,UAAA;Af6oBJ;;Ae/oBE;EACE,cAAA;EACA,UAAA;AfkpBJ;;AeppBE;EACE,cAAA;EACA,qBAAA;AfupBJ;;AajpBI;EESE;IACE,SAAA;Ef4oBN;EezoBI;IApCJ,cAAA;IACA,WAAA;EfgrBA;EelqBA;IACE,cAAA;IACA,WAAA;EfoqBF;EetqBA;IACE,cAAA;IACA,UAAA;EfwqBF;Ee1qBA;IACE,cAAA;IACA,qBAAA;Ef4qBF;Ee9qBA;IACE,cAAA;IACA,UAAA;EfgrBF;EelrBA;IACE,cAAA;IACA,UAAA;EforBF;EetrBA;IACE,cAAA;IACA,qBAAA;EfwrBF;AACF;AanrBI;EESE;IACE,SAAA;Ef6qBN;Ee1qBI;IApCJ,cAAA;IACA,WAAA;EfitBA;EensBA;IACE,cAAA;IACA,WAAA;EfqsBF;EevsBA;IACE,cAAA;IACA,UAAA;EfysBF;Ee3sBA;IACE,cAAA;IACA,qBAAA;Ef6sBF;Ee/sBA;IACE,cAAA;IACA,UAAA;EfitBF;EentBA;IACE,cAAA;IACA,UAAA;EfqtBF;EevtBA;IACE,cAAA;IACA,qBAAA;EfytBF;AACF;AaptBI;EESE;IACE,SAAA;Ef8sBN;Ee3sBI;IApCJ,cAAA;IACA,WAAA;EfkvBA;EepuBA;IACE,cAAA;IACA,WAAA;EfsuBF;EexuBA;IACE,cAAA;IACA,UAAA;Ef0uBF;Ee5uBA;IACE,cAAA;IACA,qBAAA;Ef8uBF;EehvBA;IACE,cAAA;IACA,UAAA;EfkvBF;EepvBA;IACE,cAAA;IACA,UAAA;EfsvBF;EexvBA;IACE,cAAA;IACA,qBAAA;Ef0vBF;AACF;AarvBI;EESE;IACE,SAAA;Ef+uBN;Ee5uBI;IApCJ,cAAA;IACA,WAAA;EfmxBA;EerwBA;IACE,cAAA;IACA,WAAA;EfuwBF;EezwBA;IACE,cAAA;IACA,UAAA;Ef2wBF;Ee7wBA;IACE,cAAA;IACA,qBAAA;Ef+wBF;EejxBA;IACE,cAAA;IACA,UAAA;EfmxBF;EerxBA;IACE,cAAA;IACA,UAAA;EfuxBF;EezxBA;IACE,cAAA;IACA,qBAAA;Ef2xBF;AACF;AatxBI;EESE;IACE,SAAA;EfgxBN;Ee7wBI;IApCJ,cAAA;IACA,WAAA;EfozBA;EetyBA;IACE,cAAA;IACA,WAAA;EfwyBF;Ee1yBA;IACE,cAAA;IACA,UAAA;Ef4yBF;Ee9yBA;IACE,cAAA;IACA,qBAAA;EfgzBF;EelzBA;IACE,cAAA;IACA,UAAA;EfozBF;EetzBA;IACE,cAAA;IACA,UAAA;EfwzBF;Ee1zBA;IACE,cAAA;IACA,qBAAA;Ef4zBF;AACF;AexxBM;EAtDJ,cAAA;EACA,WAAA;Afi1BF;;AetxBU;EAtEN,cAAA;EACA,kBAAA;Afg2BJ;;Ae3xBU;EAtEN,cAAA;EACA,mBAAA;Afq2BJ;;AehyBU;EAtEN,cAAA;EACA,UAAA;Af02BJ;;AeryBU;EAtEN,cAAA;EACA,mBAAA;Af+2BJ;;Ae1yBU;EAtEN,cAAA;EACA,mBAAA;Afo3BJ;;Ae/yBU;EAtEN,cAAA;EACA,UAAA;Afy3BJ;;AepzBU;EAtEN,cAAA;EACA,mBAAA;Af83BJ;;AezzBU;EAtEN,cAAA;EACA,mBAAA;Afm4BJ;;Ae9zBU;EAtEN,cAAA;EACA,UAAA;Afw4BJ;;Aen0BU;EAtEN,cAAA;EACA,mBAAA;Af64BJ;;Aex0BU;EAtEN,cAAA;EACA,mBAAA;Afk5BJ;;Ae70BU;EAtEN,cAAA;EACA,WAAA;Afu5BJ;;Ae10BY;EA9DV,wBAAA;Af44BF;;Ae90BY;EA9DV,yBAAA;Afg5BF;;Ael1BY;EA9DV,gBAAA;Afo5BF;;Aet1BY;EA9DV,yBAAA;Afw5BF;;Ae11BY;EA9DV,yBAAA;Af45BF;;Ae91BY;EA9DV,gBAAA;Afg6BF;;Ael2BY;EA9DV,yBAAA;Afo6BF;;Aet2BY;EA9DV,yBAAA;Afw6BF;;Ae12BY;EA9DV,gBAAA;Af46BF;;Ae92BY;EA9DV,yBAAA;Afg7BF;;Ael3BY;EA9DV,yBAAA;Afo7BF;;Ae32BQ;;EAEE,gBAAA;Af82BV;;Ae32BQ;;EAEE,gBAAA;Af82BV;;Aer3BQ;;EAEE,sBAAA;Afw3BV;;Aer3BQ;;EAEE,sBAAA;Afw3BV;;Ae/3BQ;;EAEE,qBAAA;Afk4BV;;Ae/3BQ;;EAEE,qBAAA;Afk4BV;;Aez4BQ;;EAEE,mBAAA;Af44BV;;Aez4BQ;;EAEE,mBAAA;Af44BV;;Aen5BQ;;EAEE,qBAAA;Afs5BV;;Aen5BQ;;EAEE,qBAAA;Afs5BV;;Ae75BQ;;EAEE,mBAAA;Afg6BV;;Ae75BQ;;EAEE,mBAAA;Afg6BV;;Aa/9BI;EE+BE;IAtDJ,cAAA;IACA,WAAA;Ef2/BA;Eeh8BQ;IAtEN,cAAA;IACA,kBAAA;EfygCF;Eep8BQ;IAtEN,cAAA;IACA,mBAAA;Ef6gCF;Eex8BQ;IAtEN,cAAA;IACA,UAAA;EfihCF;Ee58BQ;IAtEN,cAAA;IACA,mBAAA;EfqhCF;Eeh9BQ;IAtEN,cAAA;IACA,mBAAA;EfyhCF;Eep9BQ;IAtEN,cAAA;IACA,UAAA;Ef6hCF;Eex9BQ;IAtEN,cAAA;IACA,mBAAA;EfiiCF;Ee59BQ;IAtEN,cAAA;IACA,mBAAA;EfqiCF;Eeh+BQ;IAtEN,cAAA;IACA,UAAA;EfyiCF;Eep+BQ;IAtEN,cAAA;IACA,mBAAA;Ef6iCF;Eex+BQ;IAtEN,cAAA;IACA,mBAAA;EfijCF;Ee5+BQ;IAtEN,cAAA;IACA,WAAA;EfqjCF;Eex+BU;IA9DV,cAAA;EfyiCA;Ee3+BU;IA9DV,wBAAA;Ef4iCA;Ee9+BU;IA9DV,yBAAA;Ef+iCA;Eej/BU;IA9DV,gBAAA;EfkjCA;Eep/BU;IA9DV,yBAAA;EfqjCA;Eev/BU;IA9DV,yBAAA;EfwjCA;Ee1/BU;IA9DV,gBAAA;Ef2jCA;Ee7/BU;IA9DV,yBAAA;Ef8jCA;EehgCU;IA9DV,yBAAA;EfikCA;EengCU;IA9DV,gBAAA;EfokCA;EetgCU;IA9DV,yBAAA;EfukCA;EezgCU;IA9DV,yBAAA;Ef0kCA;EejgCM;;IAEE,gBAAA;EfmgCR;EehgCM;;IAEE,gBAAA;EfkgCR;EezgCM;;IAEE,sBAAA;Ef2gCR;EexgCM;;IAEE,sBAAA;Ef0gCR;EejhCM;;IAEE,qBAAA;EfmhCR;EehhCM;;IAEE,qBAAA;EfkhCR;EezhCM;;IAEE,mBAAA;Ef2hCR;EexhCM;;IAEE,mBAAA;Ef0hCR;EejiCM;;IAEE,qBAAA;EfmiCR;EehiCM;;IAEE,qBAAA;EfkiCR;EeziCM;;IAEE,mBAAA;Ef2iCR;EexiCM;;IAEE,mBAAA;Ef0iCR;AACF;Aa1mCI;EE+BE;IAtDJ,cAAA;IACA,WAAA;EfqoCA;Ee1kCQ;IAtEN,cAAA;IACA,kBAAA;EfmpCF;Ee9kCQ;IAtEN,cAAA;IACA,mBAAA;EfupCF;EellCQ;IAtEN,cAAA;IACA,UAAA;Ef2pCF;EetlCQ;IAtEN,cAAA;IACA,mBAAA;Ef+pCF;Ee1lCQ;IAtEN,cAAA;IACA,mBAAA;EfmqCF;Ee9lCQ;IAtEN,cAAA;IACA,UAAA;EfuqCF;EelmCQ;IAtEN,cAAA;IACA,mBAAA;Ef2qCF;EetmCQ;IAtEN,cAAA;IACA,mBAAA;Ef+qCF;Ee1mCQ;IAtEN,cAAA;IACA,UAAA;EfmrCF;Ee9mCQ;IAtEN,cAAA;IACA,mBAAA;EfurCF;EelnCQ;IAtEN,cAAA;IACA,mBAAA;Ef2rCF;EetnCQ;IAtEN,cAAA;IACA,WAAA;Ef+rCF;EelnCU;IA9DV,cAAA;EfmrCA;EernCU;IA9DV,wBAAA;EfsrCA;EexnCU;IA9DV,yBAAA;EfyrCA;Ee3nCU;IA9DV,gBAAA;Ef4rCA;Ee9nCU;IA9DV,yBAAA;Ef+rCA;EejoCU;IA9DV,yBAAA;EfksCA;EepoCU;IA9DV,gBAAA;EfqsCA;EevoCU;IA9DV,yBAAA;EfwsCA;Ee1oCU;IA9DV,yBAAA;Ef2sCA;Ee7oCU;IA9DV,gBAAA;Ef8sCA;EehpCU;IA9DV,yBAAA;EfitCA;EenpCU;IA9DV,yBAAA;EfotCA;Ee3oCM;;IAEE,gBAAA;Ef6oCR;Ee1oCM;;IAEE,gBAAA;Ef4oCR;EenpCM;;IAEE,sBAAA;EfqpCR;EelpCM;;IAEE,sBAAA;EfopCR;Ee3pCM;;IAEE,qBAAA;Ef6pCR;Ee1pCM;;IAEE,qBAAA;Ef4pCR;EenqCM;;IAEE,mBAAA;EfqqCR;EelqCM;;IAEE,mBAAA;EfoqCR;Ee3qCM;;IAEE,qBAAA;Ef6qCR;Ee1qCM;;IAEE,qBAAA;Ef4qCR;EenrCM;;IAEE,mBAAA;EfqrCR;EelrCM;;IAEE,mBAAA;EforCR;AACF;AapvCI;EE+BE;IAtDJ,cAAA;IACA,WAAA;Ef+wCA;EeptCQ;IAtEN,cAAA;IACA,kBAAA;Ef6xCF;EextCQ;IAtEN,cAAA;IACA,mBAAA;EfiyCF;Ee5tCQ;IAtEN,cAAA;IACA,UAAA;EfqyCF;EehuCQ;IAtEN,cAAA;IACA,mBAAA;EfyyCF;EepuCQ;IAtEN,cAAA;IACA,mBAAA;Ef6yCF;EexuCQ;IAtEN,cAAA;IACA,UAAA;EfizCF;Ee5uCQ;IAtEN,cAAA;IACA,mBAAA;EfqzCF;EehvCQ;IAtEN,cAAA;IACA,mBAAA;EfyzCF;EepvCQ;IAtEN,cAAA;IACA,UAAA;Ef6zCF;EexvCQ;IAtEN,cAAA;IACA,mBAAA;Efi0CF;Ee5vCQ;IAtEN,cAAA;IACA,mBAAA;Efq0CF;EehwCQ;IAtEN,cAAA;IACA,WAAA;Efy0CF;Ee5vCU;IA9DV,cAAA;Ef6zCA;Ee/vCU;IA9DV,wBAAA;Efg0CA;EelwCU;IA9DV,yBAAA;Efm0CA;EerwCU;IA9DV,gBAAA;Efs0CA;EexwCU;IA9DV,yBAAA;Efy0CA;Ee3wCU;IA9DV,yBAAA;Ef40CA;Ee9wCU;IA9DV,gBAAA;Ef+0CA;EejxCU;IA9DV,yBAAA;Efk1CA;EepxCU;IA9DV,yBAAA;Efq1CA;EevxCU;IA9DV,gBAAA;Efw1CA;Ee1xCU;IA9DV,yBAAA;Ef21CA;Ee7xCU;IA9DV,yBAAA;Ef81CA;EerxCM;;IAEE,gBAAA;EfuxCR;EepxCM;;IAEE,gBAAA;EfsxCR;Ee7xCM;;IAEE,sBAAA;Ef+xCR;Ee5xCM;;IAEE,sBAAA;Ef8xCR;EeryCM;;IAEE,qBAAA;EfuyCR;EepyCM;;IAEE,qBAAA;EfsyCR;Ee7yCM;;IAEE,mBAAA;Ef+yCR;Ee5yCM;;IAEE,mBAAA;Ef8yCR;EerzCM;;IAEE,qBAAA;EfuzCR;EepzCM;;IAEE,qBAAA;EfszCR;Ee7zCM;;IAEE,mBAAA;Ef+zCR;Ee5zCM;;IAEE,mBAAA;Ef8zCR;AACF;Aa93CI;EE+BE;IAtDJ,cAAA;IACA,WAAA;Efy5CA;Ee91CQ;IAtEN,cAAA;IACA,kBAAA;Efu6CF;Eel2CQ;IAtEN,cAAA;IACA,mBAAA;Ef26CF;Eet2CQ;IAtEN,cAAA;IACA,UAAA;Ef+6CF;Ee12CQ;IAtEN,cAAA;IACA,mBAAA;Efm7CF;Ee92CQ;IAtEN,cAAA;IACA,mBAAA;Efu7CF;Eel3CQ;IAtEN,cAAA;IACA,UAAA;Ef27CF;Eet3CQ;IAtEN,cAAA;IACA,mBAAA;Ef+7CF;Ee13CQ;IAtEN,cAAA;IACA,mBAAA;Efm8CF;Ee93CQ;IAtEN,cAAA;IACA,UAAA;Efu8CF;Eel4CQ;IAtEN,cAAA;IACA,mBAAA;Ef28CF;Eet4CQ;IAtEN,cAAA;IACA,mBAAA;Ef+8CF;Ee14CQ;IAtEN,cAAA;IACA,WAAA;Efm9CF;Eet4CU;IA9DV,cAAA;Efu8CA;Eez4CU;IA9DV,wBAAA;Ef08CA;Ee54CU;IA9DV,yBAAA;Ef68CA;Ee/4CU;IA9DV,gBAAA;Efg9CA;Eel5CU;IA9DV,yBAAA;Efm9CA;Eer5CU;IA9DV,yBAAA;Efs9CA;Eex5CU;IA9DV,gBAAA;Efy9CA;Ee35CU;IA9DV,yBAAA;Ef49CA;Ee95CU;IA9DV,yBAAA;Ef+9CA;Eej6CU;IA9DV,gBAAA;Efk+CA;Eep6CU;IA9DV,yBAAA;Efq+CA;Eev6CU;IA9DV,yBAAA;Efw+CA;Ee/5CM;;IAEE,gBAAA;Efi6CR;Ee95CM;;IAEE,gBAAA;Efg6CR;Eev6CM;;IAEE,sBAAA;Efy6CR;Eet6CM;;IAEE,sBAAA;Efw6CR;Ee/6CM;;IAEE,qBAAA;Efi7CR;Ee96CM;;IAEE,qBAAA;Efg7CR;Eev7CM;;IAEE,mBAAA;Efy7CR;Eet7CM;;IAEE,mBAAA;Efw7CR;Ee/7CM;;IAEE,qBAAA;Efi8CR;Ee97CM;;IAEE,qBAAA;Efg8CR;Eev8CM;;IAEE,mBAAA;Efy8CR;Eet8CM;;IAEE,mBAAA;Efw8CR;AACF;AaxgDI;EE+BE;IAtDJ,cAAA;IACA,WAAA;EfmiDA;Eex+CQ;IAtEN,cAAA;IACA,kBAAA;EfijDF;Ee5+CQ;IAtEN,cAAA;IACA,mBAAA;EfqjDF;Eeh/CQ;IAtEN,cAAA;IACA,UAAA;EfyjDF;Eep/CQ;IAtEN,cAAA;IACA,mBAAA;Ef6jDF;Eex/CQ;IAtEN,cAAA;IACA,mBAAA;EfikDF;Ee5/CQ;IAtEN,cAAA;IACA,UAAA;EfqkDF;EehgDQ;IAtEN,cAAA;IACA,mBAAA;EfykDF;EepgDQ;IAtEN,cAAA;IACA,mBAAA;Ef6kDF;EexgDQ;IAtEN,cAAA;IACA,UAAA;EfilDF;Ee5gDQ;IAtEN,cAAA;IACA,mBAAA;EfqlDF;EehhDQ;IAtEN,cAAA;IACA,mBAAA;EfylDF;EephDQ;IAtEN,cAAA;IACA,WAAA;Ef6lDF;EehhDU;IA9DV,cAAA;EfilDA;EenhDU;IA9DV,wBAAA;EfolDA;EethDU;IA9DV,yBAAA;EfulDA;EezhDU;IA9DV,gBAAA;Ef0lDA;Ee5hDU;IA9DV,yBAAA;Ef6lDA;Ee/hDU;IA9DV,yBAAA;EfgmDA;EeliDU;IA9DV,gBAAA;EfmmDA;EeriDU;IA9DV,yBAAA;EfsmDA;EexiDU;IA9DV,yBAAA;EfymDA;Ee3iDU;IA9DV,gBAAA;Ef4mDA;Ee9iDU;IA9DV,yBAAA;Ef+mDA;EejjDU;IA9DV,yBAAA;EfknDA;EeziDM;;IAEE,gBAAA;Ef2iDR;EexiDM;;IAEE,gBAAA;Ef0iDR;EejjDM;;IAEE,sBAAA;EfmjDR;EehjDM;;IAEE,sBAAA;EfkjDR;EezjDM;;IAEE,qBAAA;Ef2jDR;EexjDM;;IAEE,qBAAA;Ef0jDR;EejkDM;;IAEE,mBAAA;EfmkDR;EehkDM;;IAEE,mBAAA;EfkkDR;EezkDM;;IAEE,qBAAA;Ef2kDR;EexkDM;;IAEE,qBAAA;Ef0kDR;EejlDM;;IAEE,mBAAA;EfmlDR;EehlDM;;IAEE,mBAAA;EfklDR;AACF;AgB7sDA;EACE,0BAAA;EACA,yCAAA;EACA,iCAAA;EACA,0CAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBZ0OO;EYzOP,cfOS;EeNT,mBZogB4B;EYngB5B,qBAAA;AhB8sDF;AgBvsDE;EACE,sBAAA;EACA,oCAAA;EACA,wBZ4U0B;EY3U1B,wDAAA;AhBysDJ;AgBtsDE;EACE,uBAAA;AhBwsDJ;AgBrsDE;EACE,sBAAA;AhBusDJ;AgBnsDE;EACE,iCZqgB0B;AJgsC9B;;AgB5rDA;EACE,iBAAA;AhB+rDF;;AgBrrDE;EACE,wBAAA;AhBwrDJ;;AgBzqDE;EACE,mBAAA;AhB4qDJ;AgBzqDI;EACE,mBAAA;AhB2qDN;;AgBpqDE;EACE,sBAAA;AhBuqDJ;;AgB9pDE;EACE,gDAAA;EACA,oCAAA;AhBiqDJ;;AgBzpDA;EACE,+CAAA;EACA,mCAAA;AhB4pDF;;AgBppDE;EACE,8CAAA;EACA,kCAAA;AhBupDJ;;AiB/wDE;EAME,uCAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,yCAAA;AjB4wDJ;;AiB3xDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjBwxDJ;;AiBvyDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjBoyDJ;;AiBnzDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjBgzDJ;;AiB/zDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjB4zDJ;;AiB30DE;EAME,qCAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,sCAAA;AjBw0DJ;;AiBv1DE;EAME,sBAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,sCAAA;AjBo1DJ;;AiBn2DE;EAME,sBAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,mCAAA;AjBg2DJ;;AgBhuDI;EACE,gBAAA;EACA,iCAAA;AhBmuDN;;Aa1yDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhByuDJ;AACF;AajzDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhB+uDJ;AACF;AavzDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhBqvDJ;AACF;Aa7zDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhB2vDJ;AACF;Aan0DI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhBiwDJ;AACF;AkBj5DA;EACE,qBd0pBsC;AJyvCxC;;AkB14DA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EboRI,kBALI;Ea3QR,gBdka4B;AJy+C9B;;AkBv4DA;EACE,+BAAA;EACA,kCAAA;Eb0QI,iBALI;ALsoDV;;AkBv4DA;EACE,gCAAA;EACA,mCAAA;EboQI,mBALI;AL4oDV;;AmBx6DA;EACE,mBfkpBsC;EClXlC,kBALI;EcvRR,clBaS;AD45DX;;AoB96DA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;Ef8RI,kBALI;EetRR,gBhBua4B;EgBta5B,gBhB4a4B;EgB3a5B,cnBWS;EmBVT,sBnBGM;EmBFN,4BAAA;EACA,yBAAA;EACA,wBAAA;UAAA,gBAAA;EdGE,sBAAA;EeHE,wEDMJ;ApB46DF;AqB96DM;EDhBN;ICiBQ,gBAAA;ErBi7DN;AACF;AoB/6DE;EACE,gBAAA;ApBi7DJ;AoB/6DI;EACE,eAAA;ApBi7DN;AoB56DE;EACE,cnBXO;EmBYP,sBnBnBI;EmBoBJ,iEnBsHuB;EmBrHvB,UAAA;EAKE,iDhByiB0B;AJi4ChC;AoBn6DE;EAEE,aAAA;ApBo6DJ;AoBh6DE;EACE,cnBlCO;EmBoCP,UAAA;ApBi6DJ;AoBz5DE;EAEE,yBnBlDO;EmBqDP,UAAA;ApBw5DJ;AoBp5DE;EACE,yBAAA;EACA,0BAAA;EACA,2BhB4f0B;UgB5f1B,0BhB4f0B;EgB3f1B,cnBxDO;EqBnBT,iDrByHqB;EmB5CnB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBmR0B;EgBlR1B,gBAAA;ECtEE,6FDuEF;ECvEE,qFDuEF;ApBs5DJ;AoBl6DE;EACE,yBAAA;EACA,0BAAA;EACA,2BhB4f0B;UgB5f1B,0BhB4f0B;EgB3f1B,cnBxDO;EqBnBT,iDrByHqB;EmB5CnB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBmR0B;EgBlR1B,gBAAA;ECtEE,qFDuEF;ApBs5DJ;AqBz9DM;EDuDJ;ICtDM,wBAAA;IAAA,gBAAA;ErB49DN;EoBt6DA;ICtDM,gBAAA;ErB49DN;AACF;AoBx5DE;EACE,sDhB6vB8B;AJ6pClC;AoB35DE;EACE,sDhB6vB8B;AJ6pClC;AoBv5DE;EACE,yBAAA;EACA,0BAAA;EACA,2BhBye0B;UgBze1B,0BhBye0B;EgBxe1B,cnB3EO;EqBnBT,iDrByHqB;EmBzBnB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBgQ0B;EgB/P1B,gBAAA;ECzFE,6FD0FF;EC1FE,qFD0FF;ApBy5DJ;AqB/+DM;ED0EJ;ICzEM,wBAAA;IAAA,gBAAA;ErBk/DN;AACF;AoB35DE;EACE,sDhB0uB8B;AJmrClC;;AoBp5DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBhB2T4B;EgB1T5B,cnBtGS;EmBuGT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApBu5DF;AoBr5DE;EAEE,gBAAA;EACA,eAAA;ApBs5DJ;;AoB34DA;EACE,wChBkkBsC;EgBjkBtC,uBAAA;EfmJI,mBALI;EC7QN,qBAAA;AN+gEJ;AoB54DE;EACE,uBAAA;EACA,wBAAA;EACA,0BhB6b0B;UgB7b1B,yBhB6b0B;AJi9C9B;AoBj5DE;EACE,uBAAA;EACA,wBAAA;EACA,0BhB6b0B;UgB7b1B,yBhB6b0B;AJi9C9B;AoB34DE;EACE,uBAAA;EACA,wBAAA;EACA,0BhBub0B;UgBvb1B,yBhBub0B;AJs9C9B;;AoBz4DA;EACE,sChBgjBsC;EgB/iBtC,oBAAA;EfgII,iBALI;EC7QN,qBAAA;ANgiEJ;AoB14DE;EACE,oBAAA;EACA,qBAAA;EACA,wBhB8a0B;UgB9a1B,uBhB8a0B;AJ89C9B;AoB/4DE;EACE,oBAAA;EACA,qBAAA;EACA,wBhB8a0B;UgB9a1B,uBhB8a0B;AJ89C9B;AoBz4DE;EACE,oBAAA;EACA,qBAAA;EACA,wBhBwa0B;UgBxa1B,uBhBwa0B;AJm+C9B;;AoBn4DE;EACE,yChBuhBoC;AJ+2CxC;AoBn4DE;EACE,wChBohBoC;AJi3CxC;AoBl4DE;EACE,sChBihBoC;AJm3CxC;;AoB/3DA;EACE,eAAA;EACA,YAAA;EACA,iBhB8X4B;AJogD9B;AoBh4DE;EACE,eAAA;ApBk4DJ;AoB/3DE;EACE,aAAA;Ed/LA,sBAAA;ANikEJ;AoB93DE;EACE,aAAA;EdpMA,sBAAA;ANqkEJ;;AuBnlEA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EAEA,uCAAA;ElB2RI,kBALI;EkBnRR,gBnBoa4B;EmBna5B,gBnBya4B;EmBxa5B,ctBQS;EsBPT,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCnBgxBkC;EmB/wBlC,0BnBgxBkC;EmB/wBlC,yBAAA;EjBFE,sBAAA;EeHE,wEEQJ;EACA,wBAAA;UAAA,gBAAA;AvBmlEF;AqBxlEM;EEfN;IFgBQ,gBAAA;ErB2lEN;AACF;AuBtlEE;EACE,iEtB8HuB;EsB7HvB,UAAA;EAKE,iDnBixB4B;AJm0ClC;AuBhlEE;EAEE,sBnBkiB0B;EmBjiB1B,sBAAA;AvBilEJ;AuB9kEE;EAEE,yBtB5BO;AD2mEX;AuB1kEE;EACE,kBAAA;EACA,0BAAA;AvB4kEJ;;AuBxkEA;EACE,oBnB2hB4B;EmB1hB5B,uBnB0hB4B;EmBzhB5B,oBnB0hB4B;ECjTxB,mBALI;ALw2DV;;AuBxkEA;EACE,mBnBwhB4B;EmBvhB5B,sBnBuhB4B;EmBthB5B,kBnBuhB4B;ECrTxB,iBALI;AL+2DV;;AwB3oEA;EACE,cAAA;EACA,mBpBqtBwC;EoBptBxC,mBpBqtBwC;EoBptBxC,uBpBqtBwC;AJy7C1C;AwB5oEE;EACE,WAAA;EACA,mBAAA;AxB8oEJ;;AwB1oEA;EACE,UpBysBwC;EoBxsBxC,WpBwsBwC;EoBvsBxC,kBAAA;EACA,mBAAA;EACA,sBvBLM;EuBMN,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCpB4sBwC;EoB3sBxC,wBAAA;UAAA,gBAAA;EACA,iCAAA;UAAA,yBAAA;AxB6oEF;AwB1oEE;ElBXE,qBAAA;ANwpEJ;AwBzoEE;EAEE,kBpBmsBsC;AJu8C1C;AwBvoEE;EACE,uBpB0rBsC;AJ+8C1C;AwBtoEE;EACE,iEvB8GuB;EuB7GvB,UAAA;EACA,iDpBqiB4B;AJmmDhC;AwBroEE;EACE,yBvBJI;EuBKJ,qBvBLI;AD4oER;AwBroEI;EAII,yDAAA;AxBooER;AwBhoEI;EAII,yDAAA;AxB+nER;AwB1nEE;EACE,yBvBzBI;EuB0BJ,qBvB1BI;EuB+BF,yDAAA;AxBwnEN;AwBpnEE;EACE,oBAAA;EACA,YAAA;EACA,YpBkqBuC;AJo9C3C;AwB/mEI;EACE,YpB0pBqC;AJu9C3C;;AwBnmEA;EACE,mBpBqpBgC;AJi9ClC;AwBpmEE;EACE,UpBipB8B;EoBhpB9B,mBAAA;EACA,yDAAA;EACA,gCAAA;ElB9FA,kBAAA;EeHE,iDGmGF;AxBsmEJ;AqBrsEM;EGyFJ;IHxFM,gBAAA;ErBwsEN;AACF;AwBzmEI;EACE,yDAAA;AxB2mEN;AwBxmEI;EACE,iCpBgpB4B;EoB3oB1B,yDAAA;AxBsmER;;AwBhmEA;EACE,qBAAA;EACA,kBpBmnBgC;AJg/ClC;;AwBhmEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AxBmmEF;AwB/lEI;EACE,oBAAA;EACA,YAAA;EACA,apBuewB;AJ0nD9B;;AyB/uEA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;UAAA,gBAAA;AzBkvEF;AyBhvEE;EACE,UAAA;AzBkvEJ;AyB9uEI;EAA0B,iErB4zBa;AJq7C3C;AyBhvEI;EAA0B,iErB2zBa;AJw7C3C;AyBhvEE;EACE,SAAA;AzBkvEJ;AyB/uEE;EACE,WrB6yBuC;EqB5yBvC,YrB4yBuC;EqB3yBvC,oBAAA;EHzBF,yBrB0CM;EwBfJ,SrB4yBuC;EExzBvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;EACA,wBAAA;UAAA,gBAAA;AzBgvEJ;AqB/vEM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ErBkwEN;AACF;AyBnvEI;EHjCF,0ClB40ByC;AJ28C3C;AyBjvEE;EACE,WrBsxB8B;EqBrxB9B,crBsxB8B;EqBrxB9B,kBAAA;EACA,erBqxB8B;EqBpxB9B,yBxB5BO;EwB6BP,yBAAA;EnB7BA,mBAAA;ANixEJ;AyB/uEE;EACE,WrBkxBuC;EqBjxBvC,YrBixBuC;EkBp0BzC,yBrB0CM;EwBWJ,SrBkxBuC;EExzBvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;EACA,gBAAA;AzBgvEJ;AqBzxEM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ErB4xEN;AACF;AyBnvEI;EH3DF,0ClB40ByC;AJq+C3C;AyBjvEE;EACE,WrB4vB8B;EqB3vB9B,crB4vB8B;EqB3vB9B,kBAAA;EACA,erB2vB8B;EqB1vB9B,yBxBtDO;EwBuDP,yBAAA;EnBvDA,mBAAA;AN2yEJ;AyB/uEE;EACE,oBAAA;AzBivEJ;AyB/uEI;EACE,yBxB9DK;AD+yEX;AyB9uEI;EACE,yBxBlEK;ADkzEX;;A0Bv0EA;EACE,kBAAA;A1B00EF;A0Bx0EE;;EAEE,0BtBu1B8B;EsBt1B9B,iBtBu1B8B;AJm/ClC;A0Bv0EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELDE,gEKEF;A1By0EJ;AqBv0EM;EKXJ;ILYM,gBAAA;ErB00EN;AACF;A0B10EE;EACE,qBAAA;A1B40EJ;A0B10EI;EACE,kBAAA;A1B40EN;A0Bz0EI;EAEE,qBtBi0B4B;EsBh0B5B,wBtBi0B4B;AJygDlC;A0Bv0EI;EACE,qBtB4zB4B;EsB3zB5B,wBtB4zB4B;AJ6gDlC;A0Br0EE;EACE,qBtBszB8B;EsBrzB9B,wBtBszB8B;AJihDlC;A0Bj0EI;;;EACE,atBgzB4B;EsB/yB5B,8DtBgzB4B;AJqhDlC;A0Bh0EI;EACE,atByyB4B;EsBxyB5B,8DtByyB4B;AJyhDlC;;A2Bx3EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A3B23EF;A2Bz3EE;;EAEE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A3B23EJ;A2Bv3EE;;EAEE,UAAA;A3By3EJ;A2Bn3EE;EACE,kBAAA;EACA,UAAA;A3Bq3EJ;A2Bn3EI;EACE,UAAA;A3Bq3EN;;A2B12EA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EtBsPI,kBALI;EsB/OR,gBvBgY4B;EuB/X5B,gBvBqY4B;EuBpY5B,c1B5BS;E0B6BT,kBAAA;EACA,mBAAA;EACA,iD1BuEqB;E0BtErB,yBAAA;ErBpCE,sBAAA;ANk5EJ;;A2Bp2EA;;;;EAIE,oBAAA;EtBgOI,iBALI;EC7QN,qBAAA;AN25EJ;;A2Bp2EA;;;;EAIE,uBAAA;EtBuNI,mBALI;EC7QN,qBAAA;ANo6EJ;;A2Bp2EA;;EAEE,mBAAA;A3Bu2EF;;A2B11EI;;ErB/DA,0BAAA;EACA,6BAAA;AN85EJ;A2Bz1EI;;ErBtEA,0BAAA;EACA,6BAAA;ANm6EJ;A2Bn1EE;EACE,iBAAA;ErBpEA,yBAAA;EACA,4BAAA;AN05EJ;;A4Bn7EE;EACE,aAAA;EACA,WAAA;EACA,mBxB2nBoC;EClXlC,kBALI;EuBjQN,cxBw1BqB;AJ6lDzB;;A4Bl7EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvB4PE,mBALI;EuBpPN,WAvBc;EAwBd,yCAvBiB;EtBHjB,sBAAA;AN+8EJ;;A4Bh7EI;;;;EAEE,cAAA;A5Bq7EN;;A4Bn+EI;EAoDE,qBxB6zBmB;EwB1zBjB,oCxBipBgC;EwBhpBhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5Bi7ER;A4B96EM;EACE,qBxBkzBiB;EwBjzBjB,kDA/Ca;A5B+9ErB;;A4Bh/EI;EAyEI,oCxB+nBgC;EwB9nBhC,kFAAA;A5B26ER;;A4Br/EI;EAiFE,qBxBgyBmB;AJwoDzB;A4Br6EQ;EAEE,uBxB4sB8B;EwB3sB9B,kGAAA;EACA,+DAAA;EACA,2EAAA;A5Bs6EV;A4Bl6EM;EACE,qBxBmxBiB;EwBlxBjB,kDA9Ea;A5Bk/ErB;;A4BngFI;EAsGE,qBxB2wBmB;AJspDzB;A4B/5EM;EACE,yBxBwwBiB;AJypDzB;A4B95EM;EACE,kDA5Fa;A5B4/ErB;A4B75EM;EACE,cxBgwBiB;AJ+pDzB;;A4B15EI;EACE,kBAAA;A5B65EN;;A4BphFI;;;EA+HI,UAAA;A5B25ER;A4Bv5EM;;;EACE,UAAA;A5B25ER;;A4B5gFE;EACE,aAAA;EACA,WAAA;EACA,mBxB2nBoC;EClXlC,kBALI;EuBjQN,cxBw1BqB;AJsrDzB;;A4B3gFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvB4PE,mBALI;EuBpPN,WAvBc;EAwBd,wCAvBiB;EtBHjB,sBAAA;ANwiFJ;;A4BzgFI;;;;EAEE,cAAA;A5B8gFN;;A4B5jFI;EAoDE,qBxB6zBmB;EwB1zBjB,oCxBipBgC;EwBhpBhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5B0gFR;A4BvgFM;EACE,qBxBkzBiB;EwBjzBjB,iDA/Ca;A5BwjFrB;;A4BzkFI;EAyEI,oCxB+nBgC;EwB9nBhC,kFAAA;A5BogFR;;A4B9kFI;EAiFE,qBxBgyBmB;AJiuDzB;A4B9/EQ;EAEE,uBxB4sB8B;EwB3sB9B,kGAAA;EACA,+DAAA;EACA,2EAAA;A5B+/EV;A4B3/EM;EACE,qBxBmxBiB;EwBlxBjB,iDA9Ea;A5B2kFrB;;A4B5lFI;EAsGE,qBxB2wBmB;AJ+uDzB;A4Bx/EM;EACE,yBxBwwBiB;AJkvDzB;A4Bv/EM;EACE,iDA5Fa;A5BqlFrB;A4Bt/EM;EACE,cxBgwBiB;AJwvDzB;;A4Bn/EI;EACE,kBAAA;A5Bs/EN;;A4B7mFI;;;EAiII,UAAA;A5Bk/ER;A4Bh/EM;;;EACE,UAAA;A5Bo/ER;;A6B1nFA;EACE,qBAAA;EAEA,gBzB0a4B;EyBza5B,gBzB+a4B;EyB9a5B,c5BcS;E4BbT,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EC8GA,yBAAA;EzBsKI,kBALI;EC7QN,sBAAA;EeHE,qFQGJ;A7B6nFF;AqB5nFM;EQhBN;IRiBQ,gBAAA;ErB+nFN;AACF;A6BhoFE;EACE,c5BCO;ADioFX;A6B9nFE;EAEE,UAAA;EACA,gB5BqEmB;AD0jFvB;A6BjnFE;EAGE,oBAAA;EACA,azB4kB0B;AJqiE9B;;A6BrmFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADilFf;A8B7oFE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,oCAjBa;A9BgqFjB;A8B5oFE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,oCAxBa;EA6BX,qDAAA;A9ByoFN;A8BroFE;EAKE,WAlCa;EAmCb,wCArCkB;EAwClB,qBAvCc;A9BwqFlB;A8B/nFI;EAKI,qDAAA;A9B6nFR;A8BxnFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADymFf;;A6BnoFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD+mFf;A8B3qFE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,kCAjBa;A9B8rFjB;A8B1qFE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,kCAxBa;EA6BX,mDAAA;A9BuqFN;A8BnqFE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,mCAvCc;A9BssFlB;A8B7pFI;EAKI,mDAAA;A9B2pFR;A8BtpFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADuoFf;;A6BjqFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD6oFf;A8BzsFE;EACE,WAdY;ERRd,2CQMmB;EAkBjB,mCAjBa;A9B4tFjB;A8BxsFE;EAEE,WArBY;ERRd,2CQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9BqsFN;A8BjsFE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BouFlB;A8B3rFI;EAKI,kDAAA;A9ByrFR;A8BprFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADqqFf;;A6B/rFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD2qFf;A8BvuFE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,mCAjBa;A9B0vFjB;A8BtuFE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BmuFN;A8B/tFE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BkwFlB;A8BztFI;EAKI,mDAAA;A9ButFR;A8BltFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADmsFf;;A6B7tFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADysFf;A8BrwFE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,mCAjBa;A9BwxFjB;A8BpwFE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BiwFN;A8B7vFE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BgyFlB;A8BvvFI;EAKI,mDAAA;A9BqvFR;A8BhvFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADiuFf;;A6B3vFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADuuFf;A8BnyFE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,kCAjBa;A9BszFjB;A8BlyFE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,kCAxBa;EA6BX,kDAAA;A9B+xFN;A8B3xFE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,oCAvCc;A9B8zFlB;A8BrxFI;EAKI,kDAAA;A9BmxFR;A8B9wFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD+vFf;;A6BzxFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADqwFf;A8Bj0FE;EACE,WAdY;ERRd,6CQMmB;EAkBjB,sCAjBa;A9Bo1FjB;A8Bh0FE;EAEE,WArBY;ERRd,6CQMmB;EAyBjB,sCAxBa;EA6BX,kDAAA;A9B6zFN;A8BzzFE;EAKE,WAlCa;EAmCb,0CArCkB;EAwClB,sCAvCc;A9B41FlB;A8BnzFI;EAKI,kDAAA;A9BizFR;A8B5yFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD6xFf;;A6BvzFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADmyFf;A8B/1FE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9Bk3FjB;A8B91FE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9B21FN;A8Bv1FE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,+BAvCc;A9B03FlB;A8Bj1FI;EAKI,kDAAA;A9B+0FR;A8B10FE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD2zFf;;A6Br1FE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADi0Ff;A8B73FE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9Bg5FjB;A8B53FE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9By3FN;A8Br3FE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,qBAvCc;A9Bw5FlB;A8B/2FI;EAKI,mDAAA;A9B62FR;A8Bx2FE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADy1Ff;;A6Bn3FE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD+1Ff;A8B35FE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,qCAjBa;A9B86FjB;A8B15FE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,qCAxBa;EA6BX,oDAAA;A9Bu5FN;A8Bn5FE;EAKE,WAlCa;EAmCb,yCArCkB;EAwClB,mCAvCc;A9Bs7FlB;A8B74FI;EAKI,oDAAA;A9B24FR;A8Bt4FE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADu3Ff;;A6B34FE;ECmBA,c7BCa;E6BAb,qBAAA;A9B43FF;A8B13FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADi4Ff;A8Bz3FE;EAEE,0CAAA;A9B03FJ;A8Bv3FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADy4Ff;A8Bn3FI;EAKI,0CAAA;A9Bi3FR;A8B52FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B62FJ;;A6Bp6FE;ECmBA,c7BCa;E6BAb,qBAAA;A9Bq5FF;A8Bn5FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD05Ff;A8Bl5FE;EAEE,4CAAA;A9Bm5FJ;A8Bh5FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADk6Ff;A8B54FI;EAKI,4CAAA;A9B04FR;A8Br4FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bs4FJ;;A6B77FE;ECmBA,c7BCa;E6BAb,qBAAA;A9B86FF;A8B56FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADm7Ff;A8B36FE;EAEE,2CAAA;A9B46FJ;A8Bz6FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD27Ff;A8Br6FI;EAKI,2CAAA;A9Bm6FR;A8B95FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B+5FJ;;A6Bt9FE;ECmBA,c7BCa;E6BAb,qBAAA;A9Bu8FF;A8Br8FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD48Ff;A8Bp8FE;EAEE,2CAAA;A9Bq8FJ;A8Bl8FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADo9Ff;A8B97FI;EAKI,2CAAA;A9B47FR;A8Bv7FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bw7FJ;;A6B/+FE;ECmBA,c7BCa;E6BAb,qBAAA;A9Bg+FF;A8B99FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADq+Ff;A8B79FE;EAEE,2CAAA;A9B89FJ;A8B39FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD6+Ff;A8Bv9FI;EAKI,2CAAA;A9Bq9FR;A8Bh9FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bi9FJ;;A6BxgGE;ECmBA,c7BCa;E6BAb,qBAAA;A9By/FF;A8Bv/FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD8/Ff;A8Bt/FE;EAEE,0CAAA;A9Bu/FJ;A8Bp/FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADsgGf;A8Bh/FI;EAKI,0CAAA;A9B8+FR;A8Bz+FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B0+FJ;;A6BjiGE;ECmBA,c7BCa;E6BAb,qBAAA;A9BkhGF;A8BhhGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADuhGf;A8B/gGE;EAEE,4CAAA;A9BghGJ;A8B7gGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD+hGf;A8BzgGI;EAKI,4CAAA;A9BugGR;A8BlgGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BmgGJ;;A6B1jGE;ECmBA,c7BCa;E6BAb,qBAAA;A9B2iGF;A8BziGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADgjGf;A8BxiGE;EAEE,yCAAA;A9ByiGJ;A8BtiGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADwjGf;A8BliGI;EAKI,yCAAA;A9BgiGR;A8B3hGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B4hGJ;;A6BnlGE;ECmBA,c7BCa;E6BAb,qBAAA;A9BokGF;A8BlkGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADykGf;A8BjkGE;EAEE,yCAAA;A9BkkGJ;A8B/jGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADilGf;A8B3jGI;EAKI,yCAAA;A9ByjGR;A8BpjGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BqjGJ;;A6B5mGE;ECmBA,c7BCa;E6BAb,qBAAA;A9B6lGF;A8B3lGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADkmGf;A8B1lGE;EAEE,2CAAA;A9B2lGJ;A8BxlGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD0mGf;A8BplGI;EAKI,2CAAA;A9BklGR;A8B7kGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B8kGJ;;A6BznGA;EACE,gBzBmW4B;EyBlW5B,c5BjCM;E4BkCN,0BzBgNwC;AJ46F1C;A6B1nGE;EACE,6BzB+MsC;AJ66F1C;A6BpnGE;EAEE,c5BvEO;AD4rGX;;A6B1mGA;ECuBE,oBAAA;EzBsKI,iBALI;EC7QN,qBAAA;ANqsGJ;;A6B5mGA;ECmBE,uBAAA;EzBsKI,mBALI;EC7QN,qBAAA;AN2sGJ;;A+B9tGA;EVgBM,gCUfJ;A/BiuGF;AqB9sGM;EUpBN;IVqBQ,gBAAA;ErBitGN;AACF;A+BpuGE;EACE,UAAA;A/BsuGJ;;A+BhuGE;EACE,aAAA;A/BmuGJ;;A+B/tGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;A/BkuGF;AqBhuGM;EULN;IVMQ,gBAAA;ErBmuGN;AACF;;AgCxvGA;;;;EAIE,kBAAA;AhC2vGF;;AgCxvGA;EACE,mBAAA;AhC2vGF;AiCtuGI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AjCywGF;AiCptGI;EACE,cAAA;AjCstGN;;AgCjwGA;EACE,kBAAA;EACA,a5Bu3BkC;E4Bt3BlC,aAAA;EACA,gB/BuFmB;E+BtFnB,kBAAA;EACA,SAAA;E3B+QI,kBALI;E2BxQR,c/BDS;E+BET,gBAAA;EACA,gBAAA;EACA,sB/BXM;E+BYN,4BAAA;EACA,qCAAA;E1BVE,sBAAA;AN+wGJ;AgCjwGE;EACE,SAAA;EACA,OAAA;EACA,oB5B+7BgC;AJo0EpC;;AgCvvGI;EACE,oBAAA;AhC0vGN;AgCxvGM;EACE,WAAA;EACA,OAAA;AhC0vGR;;AgCtvGI;EACE,kBAAA;AhCyvGN;AgCvvGM;EACE,QAAA;EACA,UAAA;AhCyvGR;;AaxvGI;EmBfA;IACE,oBAAA;EhC2wGJ;EgCzwGI;IACE,WAAA;IACA,OAAA;EhC2wGN;EgCvwGE;IACE,kBAAA;EhCywGJ;EgCvwGI;IACE,QAAA;IACA,UAAA;EhCywGN;AACF;AazwGI;EmBfA;IACE,oBAAA;EhC2xGJ;EgCzxGI;IACE,WAAA;IACA,OAAA;EhC2xGN;EgCvxGE;IACE,kBAAA;EhCyxGJ;EgCvxGI;IACE,QAAA;IACA,UAAA;EhCyxGN;AACF;AazxGI;EmBfA;IACE,oBAAA;EhC2yGJ;EgCzyGI;IACE,WAAA;IACA,OAAA;EhC2yGN;EgCvyGE;IACE,kBAAA;EhCyyGJ;EgCvyGI;IACE,QAAA;IACA,UAAA;EhCyyGN;AACF;AazyGI;EmBfA;IACE,oBAAA;EhC2zGJ;EgCzzGI;IACE,WAAA;IACA,OAAA;EhC2zGN;EgCvzGE;IACE,kBAAA;EhCyzGJ;EgCvzGI;IACE,QAAA;IACA,UAAA;EhCyzGN;AACF;AazzGI;EmBfA;IACE,oBAAA;EhC20GJ;EgCz0GI;IACE,WAAA;IACA,OAAA;EhC20GN;EgCv0GE;IACE,kBAAA;EhCy0GJ;EgCv0GI;IACE,QAAA;IACA,UAAA;EhCy0GN;AACF;AgCh0GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uB5Bu5BgC;AJ26EpC;AiCh3GI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AjC44GF;AiC91GI;EACE,cAAA;AjCg2GN;;AgCt0GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qB5By4BgC;AJg8EpC;AiCr4GI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AjC05GF;AiCn3GI;EACE,cAAA;AjCq3GN;AgCj1GI;EACE,iBAAA;AhCm1GN;;AgC70GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sB5Bw3BgC;AJw9EpC;AiC75GI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;AjC+5GN;AiCp5GM;EACE,aAAA;AjCs5GR;AiCn5GM;EACE,qBAAA;EACA,qB7BqVsB;E6BpVtB,uB7BmVsB;E6BlVtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;AjCo7GF;AiCn5GI;EACE,cAAA;AjCq5GN;AgCh2GI;EACE,iBAAA;AhCk2GN;;AgC31GA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AhC81GF;;AgCx1GA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gB5B0S4B;E4BzS5B,c/B/GS;E+BgHT,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AhC21GF;AgC70GE;EAEE,4B5Bm1BgC;EkB5+BlC,yBrBwGuB;ADg4GzB;AgC10GE;EAEE,W/BpJI;E+BqJJ,qBAAA;EVjKF,yBrB0CM;ADm8GR;AgCx0GE;EAEE,c/BtJO;E+BuJP,oBAAA;EACA,6BAAA;AhCy0GJ;;AgCn0GA;EACE,cAAA;AhCs0GF;;AgCl0GA;EACE,cAAA;EACA,qB5Bk0BkC;E4Bj0BlC,gBAAA;E3B0GI,mBALI;E2BnGR,c/BvKS;E+BwKT,mBAAA;AhCq0GF;;AgCj0GA;EACE,cAAA;EACA,oBAAA;EACA,c/B5KS;ADg/GX;;AgCh0GA;EACE,c/BvLS;E+BwLT,yB/BnLS;E+BoLT,iC5B2xBkC;AJwiFpC;AgCh0GE;EACE,c/B7LO;AD+/GX;AgCh0GI;EAEE,W/BpME;EqBZN,2ClBmgCkC;AJ+gFpC;AgC9zGI;EAEE,W/B1ME;EqBZN,yBrB0CM;AD4+GR;AgC5zGI;EAEE,c/B3MK;ADwgHX;AgCzzGE;EACE,iC5BkwBgC;AJyjFpC;AgCxzGE;EACE,c/BtNO;ADghHX;AgCvzGE;EACE,c/BxNO;ADihHX;;AkCriHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AlCwiHF;AkCtiHE;;EACE,kBAAA;EACA,cAAA;AlCyiHJ;AkCpiHE;;;;;;;;;;;;EAME,UAAA;AlC4iHJ;;AkCviHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AlC0iHF;AkCxiHE;EACE,WAAA;AlC0iHJ;;AkCpiHE;;EAEE,iBAAA;AlCuiHJ;AkCniHE;;E5BRE,0BAAA;EACA,6BAAA;AN+iHJ;AkC/hHE;;;E5BHE,yBAAA;EACA,4BAAA;ANuiHJ;;AkClhHA;EACE,wBAAA;EACA,uBAAA;AlCqhHF;AkCnhHE;EAGE,cAAA;AlCmhHJ;AkChhHE;EACE,eAAA;AlCkhHJ;;AkC9gHA;EACE,uBAAA;EACA,sBAAA;AlCihHF;;AkC9gHA;EACE,sBAAA;EACA,qBAAA;AlCihHF;;AkC7/GA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AlCggHF;AkC9/GE;;EAEE,WAAA;AlCggHJ;AkC7/GE;;EAEE,gBAAA;AlC+/GJ;AkC3/GE;;E5BvFE,6BAAA;EACA,4BAAA;ANslHJ;AkC3/GE;;E5B1GE,yBAAA;EACA,0BAAA;ANymHJ;;AmCjoHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCooHF;;AmCjoHA;EACE,cAAA;EACA,oBAAA;EAGA,clC4BM;EkC3BN,qBAAA;EdHI,uGcIJ;AnCkoHF;AqBloHM;EcPN;IdQQ,gBAAA;ErBqoHN;AACF;AmCroHE;EAEE,6B/B0QsC;AJ43G1C;AmCjoHE;EACE,clCRO;EkCSP,oBAAA;EACA,eAAA;AnCmoHJ;;AmC3nHA;EACE,gCAAA;AnC8nHF;AmC5nHE;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;E7BlBA,+BAAA;EACA,gCAAA;ANipHJ;AmC7nHI;EAEE,qC/Bg3B8B;E+B92B9B,kBAAA;AnC6nHN;AmC1nHI;EACE,clCnCK;EkCoCL,6BAAA;EACA,yBAAA;AnC4nHN;AmCxnHE;;EAEE,clC1CO;EkC2CP,sBlCtDM;EkCuDN,kC/Bm2BgC;AJuxFpC;AmCvnHE;EAEE,gBAAA;E7B5CA,yBAAA;EACA,0BAAA;ANqqHJ;;AmC9mHE;EACE,gBAAA;EACA,SAAA;E7BnEA,sBAAA;ANqrHJ;AmC9mHE;;EAEE,WlC5EI;EqBZN,yBrB0CM;AD+pHR;;AmCtmHE;;EAEE,cAAA;EACA,kBAAA;AnCymHJ;;AmCpmHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AnCumHJ;;AmCjmHE;;EACE,WAAA;AnCqmHJ;;AmC3lHE;EACE,aAAA;AnC8lHJ;AmC5lHE;EACE,cAAA;AnC8lHJ;;AoCttHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBhC25BkC;EgCz5BlC,sBhCy5BkC;AJ+zFpC;AoCjtHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ApCytHJ;AoCrsHA;EACE,qBhCk4BkC;EgCj4BlC,wBhCi4BkC;EgCh4BlC,kBhCi4BkC;ECtpB9B,iBALI;E+BpOR,qBAAA;EACA,mBAAA;ApCusHF;AoC1rHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC4rHF;AoC1rHE;EACE,gBAAA;EACA,eAAA;ApC4rHJ;AoCzrHE;EACE,gBAAA;ApC2rHJ;;AoClrHA;EACE,mBhCszBkC;EgCrzBlC,sBhCqzBkC;AJg4FpC;;AoCzqHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ApC0qHF;;AoCtqHA;EACE,wBAAA;E/B6KI,iBALI;E+BtKR,cAAA;EACA,6BAAA;EACA,6BAAA;E9BzGE,sBAAA;EeHE,wCe8GJ;ApCyqHF;AqBnxHM;EemGN;IflGQ,gBAAA;ErBsxHN;AACF;AoC5qHE;EACE,qBAAA;ApC8qHJ;AoC3qHE;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;ApC6qHJ;;AoCvqHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ApC0qHF;;AoCvqHA;EACE,gBAAA;EAAA,yCAAA;EACA,gBAAA;ApC0qHF;;AapwHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpCiqHN;EoC/pHM;IACE,mBAAA;EpCiqHR;EoC/pHQ;IACE,kBAAA;EpCiqHV;EoC9pHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJ+5FlC;EoC5pHM;IACE,iBAAA;EpC8pHR;EoC3pHM;IACE,wBAAA;IACA,gBAAA;EpC6pHR;EoC1pHM;IACE,aAAA;EpC4pHR;AACF;Aa/xHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpC2rHN;EoCzrHM;IACE,mBAAA;EpC2rHR;EoCzrHQ;IACE,kBAAA;EpC2rHV;EoCxrHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJy7FlC;EoCtrHM;IACE,iBAAA;EpCwrHR;EoCrrHM;IACE,wBAAA;IACA,gBAAA;EpCurHR;EoCprHM;IACE,aAAA;EpCsrHR;AACF;AazzHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpCqtHN;EoCntHM;IACE,mBAAA;EpCqtHR;EoCntHQ;IACE,kBAAA;EpCqtHV;EoCltHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJm9FlC;EoChtHM;IACE,iBAAA;EpCktHR;EoC/sHM;IACE,wBAAA;IACA,gBAAA;EpCitHR;EoC9sHM;IACE,aAAA;EpCgtHR;AACF;Aan1HI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpC+uHN;EoC7uHM;IACE,mBAAA;EpC+uHR;EoC7uHQ;IACE,kBAAA;EpC+uHV;EoC5uHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJ6+FlC;EoC1uHM;IACE,iBAAA;EpC4uHR;EoCzuHM;IACE,wBAAA;IACA,gBAAA;EpC2uHR;EoCxuHM;IACE,aAAA;EpC0uHR;AACF;Aa72HI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpCywHN;EoCvwHM;IACE,mBAAA;EpCywHR;EoCvwHQ;IACE,kBAAA;EpCywHV;EoCtwHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJugGlC;EoCpwHM;IACE,iBAAA;EpCswHR;EoCnwHM;IACE,wBAAA;IACA,gBAAA;EpCqwHR;EoClwHM;IACE,aAAA;EpCowHR;AACF;AoCjyHI;EAEI,iBAAA;EACA,2BAAA;ApCkyHR;AoChyHQ;EACE,mBAAA;ApCkyHV;AoChyHU;EACE,kBAAA;ApCkyHZ;AoC/xHU;EACE,qBhCkwBwB;EgCjwBxB,oBhCiwBwB;AJgiGpC;AoC7xHQ;EACE,iBAAA;ApC+xHV;AoC5xHQ;EACE,wBAAA;EACA,gBAAA;ApC8xHV;AoC3xHQ;EACE,aAAA;ApC6xHV;;AoC9wHE;EACE,yBhC8vBgC;AJmhGpC;AoC/wHI;EAEE,yBhC0vB8B;AJshGpC;AoC3wHI;EACE,0BhCkvB8B;AJ2hGpC;AoC3wHM;EAEE,yBhC+uB4B;AJ6hGpC;AoCzwHM;EACE,yBhC6uB4B;AJ8hGpC;AoCvwHI;;EAEE,yBhCsuB8B;AJmiGpC;AoCrwHE;EACE,0BhC+tBgC;EgC9tBhC,gChCmuBgC;AJoiGpC;AoCpwHE;EACE,yDAAA;ApCswHJ;AoCnwHE;EACE,0BhCstBgC;AJ+iGpC;AoCnwHI;;;EAGE,yBhCmtB8B;AJkjGpC;;AoC9vHE;EACE,WnCpPI;ADq/HR;AoC/vHI;EAEE,WnCxPE;ADw/HR;AoC3vHI;EACE,gChCwrB8B;AJqkGpC;AoC3vHM;EAEE,gChCqrB4B;AJukGpC;AoCzvHM;EACE,gChCmrB4B;AJwkGpC;AoCvvHI;;EAEE,WnC5QE;ADqgIR;AoCrvHE;EACE,gChCqqBgC;EgCpqBhC,sChCyqBgC;AJ8kGpC;AoCpvHE;EACE,0DAAA;ApCsvHJ;AoCnvHE;EACE,gChC4pBgC;AJylGpC;AoCpvHI;;;EAGE,WnC9RE;ADohIR;;AqChiIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBpCKM;EoCJN,2BAAA;EACA,2EAAA;E/BME,sBAAA;AN6hIJ;AqChiIE;EACE,eAAA;EACA,cAAA;ArCkiIJ;AqC/hIE;EACE,mBAAA;EACA,sBAAA;ArCiiIJ;AqC/hII;EACE,mBAAA;E/BEF,2CAAA;EACA,4CAAA;ANgiIJ;AqC/hII;EACE,sBAAA;E/BWF,+CAAA;EACA,8CAAA;ANuhIJ;AqC5hIE;;EAEE,aAAA;ArC8hIJ;;AqC1hIA;EAGE,cAAA;EACA,kBAAA;ArC2hIF;;AqCvhIA;EACE,qBjCwgCkC;AJkhGpC;;AqCvhIA;EACE,oBAAA;EACA,gBAAA;ArC0hIF;;AqCvhIA;EACE,gBAAA;ArC0hIF;;AqCthIE;EACE,qBAAA;ArCyhIJ;AqCthIE;EACE,iBjCkLK;AJs2HT;;AqChhIA;EACE,oBAAA;EACA,gBAAA;EAEA,sBpCnEM;EoCoEN,kFAAA;ArCkhIF;AqChhIE;E/BnEE,0DAAA;ANslIJ;;AqC9gIA;EACE,oBAAA;EAEA,sBpC9EM;EoC+EN,+EAAA;ArCghIF;AqC9gIE;E/B9EE,0DAAA;AN+lIJ;;AqCvgIA;EACE,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;ArC0gIF;;AqChgIA;EACE,qBAAA;EACA,oBAAA;ArCmgIF;;AqC//HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,ajCoHO;EEtOL,kCAAA;ANqnIJ;;AqC//HA;;;EAGE,WAAA;ArCkgIF;;AqC//HA;;E/BnHI,2CAAA;EACA,4CAAA;ANunIJ;;AqChgIA;;E/B1GI,+CAAA;EACA,8CAAA;AN+mIJ;;AqCz/HE;EACE,sBjCw6BgC;AJolGpC;Aa/lII;EwB+FJ;IAQI,aAAA;IACA,mBAAA;ErC4/HF;EqCz/HE;IAEE,SAAA;IACA,gBAAA;ErC0/HJ;EqCx/HI;IACE,cAAA;IACA,cAAA;ErC0/HN;EqCr/HM;I/BnJJ,0BAAA;IACA,6BAAA;EN2oIF;EqCt/HQ;;IAGE,0BAAA;ErCu/HV;EqCr/HQ;;IAGE,6BAAA;ErCs/HV;EqCl/HM;I/BpJJ,yBAAA;IACA,4BAAA;ENyoIF;EqCn/HQ;;IAGE,yBAAA;ErCo/HV;EqCl/HQ;;IAGE,4BAAA;ErCm/HV;AACF;;AsChsIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EjC4RI,kBALI;EiCrRR,crCYS;EqCXT,gBAAA;EACA,sBrCDQ;EqCER,SAAA;EhCKE,gBAAA;EgCHF,qBAAA;EjBAI,+GiBCJ;AtCmsIF;AqBhsIM;EiBhBN;IjBiBQ,gBAAA;ErBmsIN;AACF;AsCtsIE;EACE,6BlC8kCsC;EkC7kCtC,0ClC4kCsC;EkC3kCtC,+CAAA;AtCwsIJ;AsCtsII;EACE,0DAAA;EACA,0BlCilCoC;AJunG1C;AsCnsIE;EACE,cAAA;EACA,clCskCsC;EkCrkCtC,elCqkCsC;EkCpkCtC,iBAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBlCgkCsC;EiBvlCpC,sCiBwBF;AtCqsIJ;AqBztIM;EiBWJ;IjBVM,gBAAA;ErB4tIN;AACF;AsCvsIE;EACE,UAAA;AtCysIJ;AsCtsIE;EACE,UAAA;EACA,iErCyGuB;EqCxGvB,UAAA;EACA,gBrC+CmB;ADypIvB;;AsCpsIA;EACE,gBAAA;AtCusIF;;AsCpsIA;EACE,sBrChDQ;ADuvIV;AsCpsIE;EhCnCE,+BAAA;EACA,gCAAA;AN0uIJ;AsCrsII;EhCtCA,2CAAA;EACA,4CAAA;AN8uIJ;AsCpsIE;EACE,aAAA;AtCssIJ;AsClsIE;EhClCE,mCAAA;EACA,kCAAA;ANuuIJ;AsClsIM;EhCtCF,+CAAA;EACA,8CAAA;AN2uIJ;AsCjsII;EhC3CA,mCAAA;EACA,kCAAA;AN+uIJ;;AsC/rIA;EACE,qBAAA;AtCksIF;;AsCzrIE;EACE,eAAA;AtC4rIJ;AsCzrIE;EACE,eAAA;EACA,cAAA;EhCxFA,gBAAA;ANoxIJ;AsCzrII;EAAgB,aAAA;AtC4rIpB;AsC3rII;EAAe,gBAAA;AtC8rInB;AsC5rII;EhC9FA,gBAAA;AN6xIJ;;AuChzIA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBnC60CkC;EmC30ClC,gBAAA;AvCkzIF;;AuC3yIE;EACE,oBnCk0CgC;AJ4+FpC;AuC5yII;EACE,WAAA;EACA,qBnC8zC8B;EmC7zC9B,ctCGK;EsCFL,yDAAA;EAAA,uFAAA;AvC8yIN;AuC1yIE;EACE,ctCHO;AD+yIX;;AwCr0IA;EACE,aAAA;EhCGA,eAAA;EACA,gBAAA;ARs0IF;;AwCt0IA;EACE,kBAAA;EACA,cAAA;EACA,cvCsCM;EuCrCN,qBAAA;EACA,sBvCMM;EuCLN,yBAAA;EnBKI,qImBJJ;AxCy0IF;AqBj0IM;EmBfN;InBgBQ,gBAAA;ErBo0IN;AACF;AwC50IE;EACE,UAAA;EACA,6BpCkRsC;EoChRtC,yBAAA;EACA,qBAAA;AxC60IJ;AwC10IE;EACE,UAAA;EACA,6BpC0QsC;EoCzQtC,yBvCPO;EuCQP,UpCygCgC;EoCxgChC,gBvCyE0B;ADmwI9B;;AwCv0IE;EACE,iBpC4/BgC;AJ80GpC;AwCv0IE;EACE,UAAA;EACA,WvCtBI;EqBZN,yBrB0CM;EuCNJ,qBvCMI;ADm0IR;AwCt0IE;EACE,cvCtBO;EuCuBP,oBAAA;EACA,sBvC9BI;EuC+BJ,qBvC5BO;ADo2IX;;AyCn3IE;EACE,yBAAA;AzCs3IJ;;AyC/2IQ;EnCqCJ,+BAAA;EACA,kCAAA;AN80IJ;AyC92IQ;EnCiBJ,gCAAA;EACA,mCAAA;ANg2IJ;;AyCh4IE;EACE,uBAAA;EpCgSE,iBALI;ALymIV;AyC73IQ;EnCqCJ,8BAAA;EACA,iCAAA;AN21IJ;AyC33IQ;EnCiBJ,+BAAA;EACA,kCAAA;AN62IJ;;AyC74IE;EACE,uBAAA;EpCgSE,mBALI;ALsnIV;AyC14IQ;EnCqCJ,8BAAA;EACA,iCAAA;ANw2IJ;AyCx4IQ;EnCiBJ,+BAAA;EACA,kCAAA;AN03IJ;;A0Cz5IA;EACE,qBAAA;EACA,sBAAA;ErC8RI,iBALI;EqCvRR,gBtCya4B;EsCxa5B,cAAA;EACA,WzCKM;EyCJN,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCKE,sBAAA;ANw5IJ;A0Cx5IE;EACE,aAAA;A1C05IJ;;A0Cr5IA;EACE,kBAAA;EACA,SAAA;A1Cw5IF;;A2C/6IA;EACE,kBAAA;EACA,kBAAA;EACA,mBvCuvC8B;EuCtvC9B,6BAAA;ErCWE,sBAAA;ANw6IJ;;A2C96IA;EAEE,cAAA;A3Cg7IF;;A2C56IA;EACE,gBvC8Z4B;AJihI9B;;A2Cv6IA;EACE,mBvCwuC8B;AJksGhC;A2Cv6IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A3Cy6IJ;;A2C15IE;EClDA,6BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Cq6IjB;A4C98IE;EACE,gCAAA;A5Cg9IJ;;A2Cn6IE;EClDA,0BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,oCD2Ce;A3C86IjB;A4Cv9IE;EACE,4BAAA;A5Cy9IJ;;A2C56IE;EClDA,2BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,oCD2Ce;A3Cu7IjB;A4Ch+IE;EACE,4BAAA;A5Ck+IJ;;A2Cr7IE;EClDA,4BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,oCD2Ce;A3Cg8IjB;A4Cz+IE;EACE,+BAAA;A5C2+IJ;;A2C97IE;EClDA,0BDgDgB;ErB9ChB,wCqB0CmB;EC1CnB,oCD2Ce;A3Cy8IjB;A4Cl/IE;EACE,8BAAA;A5Co/IJ;;A2Cv8IE;EClDA,2BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,sCD2Ce;A3Ck9IjB;A4C3/IE;EACE,+BAAA;A5C6/IJ;;A2Ch9IE;EClDA,4BDgDgB;ErB9ChB,0CqB0CmB;EC1CnB,sCD2Ce;A3C29IjB;A4CpgJE;EACE,+BAAA;A5CsgJJ;;A2Cz9IE;EClDA,4BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Co+IjB;A4C7gJE;EACE,+BAAA;A5C+gJJ;;A2Cl+IE;EClDA,4BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3C6+IjB;A4CthJE;EACE,+BAAA;A5CwhJJ;;A2C3+IE;EClDA,4BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Cs/IjB;A4C/hJE;EACE,+BAAA;A5CiiJJ;;A6CpiJE;EACE;IAAK,2BzCuwC2B;EJiyGlC;AACF;A6CpiJA;EACE,aAAA;EACA,YzCgwCkC;EyC/vClC,gBAAA;ExCwRI,kBALI;EwCjRR,yB5CGS;EKCP,sBAAA;ANmiJJ;;A6CliJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,W5CTM;E4CUN,kBAAA;EACA,mBAAA;EACA,yB5CkBM;EoB9BF,2BwBaJ;A7CqiJF;AqB9iJM;EwBAN;IxBCQ,gBAAA;ErBijJN;AACF;;A6CviJA;EvBYE,qMAAA;EuBVA,0BAAA;A7C0iJF;;A6CtiJE;EACE,kDAAA;A7CyiJJ;A6CtiJM;EAJJ;IAKM,eAAA;E7CyiJN;AACF;;A8CjlJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCSE,sBAAA;AN0kJJ;;A8C/kJA;EACE,qBAAA;EACA,sBAAA;A9CklJF;A8ChlJE;EAEE,oCAAA;EACA,0BAAA;A9CilJJ;;A8CvkJA;EACE,WAAA;EACA,c7CVS;E6CWT,mBAAA;A9C0kJF;A8CvkJE;EAEE,UAAA;EACA,c7CjBO;E6CkBP,qBAAA;EACA,yB7CzBO;ADimJX;A8CrkJE;EACE,c7CvBO;E6CwBP,yB7C7BO;ADomJX;;A8C9jJA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,c7CnCS;E6CoCT,qBAAA;EACA,sB7C9CM;E6C+CN,yCAAA;A9CikJF;A8C/jJE;ExCrCE,+BAAA;EACA,gCAAA;ANumJJ;A8C/jJE;ExC3BE,mCAAA;EACA,kCAAA;AN6lJJ;A8C/jJE;EAEE,c7CrDO;E6CsDP,oBAAA;EACA,sB7C7DI;AD6nJR;A8C5jJE;EACE,UAAA;EACA,W7CnEI;E6CoEJ,yB7CtCI;E6CuCJ,qB7CvCI;ADqmJR;A8C3jJE;EACE,mBAAA;A9C6jJJ;A8C3jJI;EACE,gBAAA;EACA,qB1C2QwB;AJkzI9B;;A8C/iJI;EACE,mBAAA;A9CkjJN;A8C/iJQ;ExCrCJ,kCAAA;EAZA,0BAAA;ANomJJ;A8C9iJQ;ExCtDJ,gCAAA;EAYA,4BAAA;AN4lJJ;A8C7iJQ;EACE,aAAA;A9C+iJV;A8C5iJQ;EACE,qB1C0OoB;E0CzOpB,oBAAA;A9C8iJV;A8C5iJU;EACE,iBAAA;EACA,sB1CqOkB;AJy0I9B;;AalnJI;EiC4CA;IACE,mBAAA;E9C0kJJ;E8CvkJM;IxCrCJ,kCAAA;IAZA,0BAAA;EN4nJF;E8CtkJM;IxCtDJ,gCAAA;IAYA,4BAAA;ENonJF;E8CrkJM;IACE,aAAA;E9CukJR;E8CpkJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CskJR;E8CpkJQ;IACE,iBAAA;IACA,sB1CqOkB;EJi2I5B;AACF;Aa3oJI;EiC4CA;IACE,mBAAA;E9CkmJJ;E8C/lJM;IxCrCJ,kCAAA;IAZA,0BAAA;ENopJF;E8C9lJM;IxCtDJ,gCAAA;IAYA,4BAAA;EN4oJF;E8C7lJM;IACE,aAAA;E9C+lJR;E8C5lJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9C8lJR;E8C5lJQ;IACE,iBAAA;IACA,sB1CqOkB;EJy3I5B;AACF;AanqJI;EiC4CA;IACE,mBAAA;E9C0nJJ;E8CvnJM;IxCrCJ,kCAAA;IAZA,0BAAA;EN4qJF;E8CtnJM;IxCtDJ,gCAAA;IAYA,4BAAA;ENoqJF;E8CrnJM;IACE,aAAA;E9CunJR;E8CpnJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CsnJR;E8CpnJQ;IACE,iBAAA;IACA,sB1CqOkB;EJi5I5B;AACF;Aa3rJI;EiC4CA;IACE,mBAAA;E9CkpJJ;E8C/oJM;IxCrCJ,kCAAA;IAZA,0BAAA;ENosJF;E8C9oJM;IxCtDJ,gCAAA;IAYA,4BAAA;EN4rJF;E8C7oJM;IACE,aAAA;E9C+oJR;E8C5oJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9C8oJR;E8C5oJQ;IACE,iBAAA;IACA,sB1CqOkB;EJy6I5B;AACF;AantJI;EiC4CA;IACE,mBAAA;E9C0qJJ;E8CvqJM;IxCrCJ,kCAAA;IAZA,0BAAA;EN4tJF;E8CtqJM;IxCtDJ,gCAAA;IAYA,4BAAA;ENotJF;E8CrqJM;IACE,aAAA;E9CuqJR;E8CpqJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CsqJR;E8CpqJQ;IACE,iBAAA;IACA,sB1CqOkB;EJi8I5B;AACF;A8CzpJA;ExC9HI,gBAAA;AN0xJJ;A8CzpJE;EACE,qBAAA;A9C2pJJ;A8CzpJI;EACE,sBAAA;A9C2pJN;;A+C/yJE;EACE,6BDiKyB;EChKzB,0CD+JsB;A9CmpJ1B;A+C/yJM;EAEE,6BD2JqB;EC1JrB,6CAAA;A/CgzJR;A+C7yJM;EACE,WAAA;EACA,wCDqJqB;ECpJrB,oCDoJqB;A9C2pJ7B;;A+C7zJE;EACE,0BDiKyB;EChKzB,wCD+JsB;A9CiqJ1B;A+C7zJM;EAEE,0BD2JqB;EC1JrB,4CAAA;A/C8zJR;A+C3zJM;EACE,WAAA;EACA,qCDqJqB;ECpJrB,iCDoJqB;A9CyqJ7B;;A+C30JE;EACE,2BDiKyB;EChKzB,wCD+JsB;A9C+qJ1B;A+C30JM;EAEE,2BD2JqB;EC1JrB,4CAAA;A/C40JR;A+Cz0JM;EACE,WAAA;EACA,sCDqJqB;ECpJrB,kCDoJqB;A9CurJ7B;;A+Cz1JE;EACE,4BDiKyB;EChKzB,wCD+JsB;A9C6rJ1B;A+Cz1JM;EAEE,4BD2JqB;EC1JrB,4CAAA;A/C01JR;A+Cv1JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9CqsJ7B;;A+Cv2JE;EACE,0BDmK2B;EClK3B,wCD+JsB;A9C2sJ1B;A+Cv2JM;EAEE,0BD6JuB;EC5JvB,4CAAA;A/Cw2JR;A+Cr2JM;EACE,WAAA;EACA,qCDuJuB;ECtJvB,iCDsJuB;A9CitJ/B;;A+Cr3JE;EACE,2BDiKyB;EChKzB,wCD+JsB;A9CytJ1B;A+Cr3JM;EAEE,2BD2JqB;EC1JrB,0CAAA;A/Cs3JR;A+Cn3JM;EACE,WAAA;EACA,sCDqJqB;ECpJrB,kCDoJqB;A9CiuJ7B;;A+Cn4JE;EACE,4BDmK2B;EClK3B,0CD+JsB;A9CuuJ1B;A+Cn4JM;EAEE,4BD6JuB;EC5JvB,6CAAA;A/Co4JR;A+Cj4JM;EACE,WAAA;EACA,uCDuJuB;ECtJvB,mCDsJuB;A9C6uJ/B;;A+Cj5JE;EACE,4BDiKyB;EChKzB,0CD+JsB;A9CqvJ1B;A+Cj5JM;EAEE,4BD2JqB;EC1JrB,6CAAA;A/Ck5JR;A+C/4JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9C6vJ7B;;A+C/5JE;EACE,4BDiKyB;EChKzB,0CD+JsB;A9CmwJ1B;A+C/5JM;EAEE,4BD2JqB;EC1JrB,6CAAA;A/Cg6JR;A+C75JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9C2wJ7B;;A+C76JE;EACE,4BDiKyB;EChKzB,0CD+JsB;A9CixJ1B;A+C76JM;EAEE,4BD2JqB;EC1JrB,6CAAA;A/C86JR;A+C36JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9CyxJ7B;;AgD17JA;EACE,uBAAA;EACA,U5C04C2B;E4Cz4C3B,W5Cy4C2B;E4Cx4C3B,sBAAA;EACA,W/CgBM;E+CfN,0FAAA;EACA,SAAA;E1COE,sBAAA;E0CLF,Y5C04C2B;AJmjH7B;AgD17JE;EACE,W/CQI;E+CPJ,qBAAA;EACA,a5Cq4CyB;AJujH7B;AgDz7JE;EACE,UAAA;EACA,iD5C0jB4B;E4CzjB5B,U5Cg4CyB;AJ2jH7B;AgDx7JE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a5C03CyB;AJ+jH7B;;AgDr7JA;EACE,kD5Cs3C2B;AJkkH7B;;AiD99JA;EACE,Y7C6qCkC;E6C5qClC,eAAA;E5CmSI,mBALI;E4C3RR,oBAAA;EACA,2C7C6qCkC;E6C5qClC,4BAAA;EACA,oCAAA;EACA,6C7CmX4B;EEzW1B,sBAAA;ANu9JJ;AiD99JE;EACE,UAAA;AjDg+JJ;AiD79JE;EACE,aAAA;AjD+9JJ;;AiD39JA;EACE,0BAAA;EAAA,kBAAA;EACA,eAAA;EACA,oBAAA;AjD89JF;AiD59JE;EACE,sB7CqUkB;AJypJtB;;AiD19JA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,chDbS;EgDcT,2C7CupCkC;E6CtpClC,4BAAA;EACA,4CAAA;E3CVE,2CAAA;EACA,4CAAA;ANw+JJ;AiD59JE;EACE,uBAAA;EACA,oB7CooCgC;AJ01HpC;;AiD19JA;EACE,gB7C+nCkC;E6C9nClC,qBAAA;AjD69JF;;AkDvgKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9Cm4BkC;E8Cl4BlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlDwgKF;;AkDjgKA;EACE,kBAAA;EACA,WAAA;EACA,c9CsrCkC;E8CprClC,oBAAA;AlDmgKF;AkDhgKE;E7BlBI,mC6BmBF;EACA,8B9C4sCgC;AJszHpC;AqBlhKM;E6BcJ;I7BbM,gBAAA;ErBqhKN;AACF;AkDrgKE;EACE,e9C0sCgC;AJ6zHpC;AkDngKE;EACE,sB9CusCgC;AJ8zHpC;;AkDjgKA;EACE,yBAAA;AlDogKF;AkDlgKE;EACE,gBAAA;EACA,gBAAA;AlDogKJ;AkDjgKE;EACE,gBAAA;AlDmgKJ;;AkD//JA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AlDkgKF;;AkD9/JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sBjD5DM;EiD6DN,4BAAA;EACA,oCAAA;E5C3DE,qBAAA;E4C+DF,UAAA;AlD6/JF;;AkDz/JA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9CkzBkC;E8CjzBlC,YAAA;EACA,aAAA;EACA,sBjDnEM;AD+jKR;AkDz/JE;EAAS,UAAA;AlD4/JX;AkD3/JE;EAAS,Y9CioCyB;AJ63HpC;;AkDz/JA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,kB9C8nCkC;E8C7nClC,gCAAA;E5ChFE,0CAAA;EACA,2CAAA;AN6kKJ;AkD3/JE;EACE,sBAAA;EACA,oCAAA;AlD6/JJ;;AkDx/JA;EACE,gBAAA;EACA,gB9C+T4B;AJ4rJ9B;;AkDt/JA;EACE,kBAAA;EAGA,cAAA;EACA,a9CuHO;AJg4JT;;AkDn/JA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;E5CnGE,8CAAA;EACA,6CAAA;AN0lKJ;AkDl/JE;EACE,eAAA;AlDo/JJ;;AazkKI;EqC4FF;IACE,gB9CglCgC;I8C/kChC,oBAAA;ElDi/JF;EkD9+JA;IACE,2BAAA;ElDg/JF;EkD7+JA;IACE,+BAAA;ElD++JF;EkDx+JA;IAAY,gB9C+jCsB;EJ46HlC;AACF;AazlKI;EqCiHF;;IAEE,gB9C2jCgC;EJg7HlC;AACF;Aa/lKI;EqCwHF;IAAY,iB9CujCsB;EJo7HlC;AACF;AkDn+JI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDq+JN;AkDn+JM;EACE,YAAA;EACA,SAAA;E5CrLJ,gBAAA;AN2pKJ;AkDl+JM;E5CzLF,gBAAA;AN8pKJ;AkDj+JM;EACE,gBAAA;AlDm+JR;AkDh+JM;E5CjMF,gBAAA;ANoqKJ;;Aa3mKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD2/JJ;EkDz/JI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENirKF;EkDx/JI;I5CzLF,gBAAA;ENorKF;EkDv/JI;IACE,gBAAA;ElDy/JN;EkDt/JI;I5CjMF,gBAAA;EN0rKF;AACF;AaloKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDihKJ;EkD/gKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENusKF;EkD9gKI;I5CzLF,gBAAA;EN0sKF;EkD7gKI;IACE,gBAAA;ElD+gKN;EkD5gKI;I5CjMF,gBAAA;ENgtKF;AACF;AaxpKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDuiKJ;EkDriKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;EN6tKF;EkDpiKI;I5CzLF,gBAAA;ENguKF;EkDniKI;IACE,gBAAA;ElDqiKN;EkDliKI;I5CjMF,gBAAA;ENsuKF;AACF;Aa9qKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD6jKJ;EkD3jKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENmvKF;EkD1jKI;I5CzLF,gBAAA;ENsvKF;EkDzjKI;IACE,gBAAA;ElD2jKN;EkDxjKI;I5CjMF,gBAAA;EN4vKF;AACF;AapsKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDmlKJ;EkDjlKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENywKF;EkDhlKI;I5CzLF,gBAAA;EN4wKF;EkD/kKI;IACE,gBAAA;ElDilKN;EkD9kKI;I5CjMF,gBAAA;ENkxKF;AACF;AmDryKA;EACE,kBAAA;EACA,a/C64BkC;E+C54BlC,cAAA;EACA,S/CunCkC;EgD3nClC,4MhDoa4B;EgDpa5B,sChDoa4B;EgDla5B,kBAAA;EACA,gBhD6a4B;EgD5a5B,gBhDkb4B;EgDjb5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CsRI,mBALI;E8CrRR,qBAAA;EACA,UAAA;AnDizKF;AmD/yKE;EAAS,Y/C2mCyB;AJusIpC;AmDhzKE;EACE,kBAAA;EACA,cAAA;EACA,a/C2mCgC;E+C1mChC,c/C2mCgC;AJusIpC;AmDhzKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDkzKN;;AmD7yKA;EACE,iBAAA;AnDgzKF;AmD9yKE;EACE,SAAA;AnDgzKJ;AmD9yKI;EACE,SAAA;EACA,6BAAA;EACA,sBlDdE;AD8zKR;;AmD3yKA;EACE,iBAAA;AnD8yKF;AmD5yKE;EACE,OAAA;EACA,a/C6kCgC;E+C5kChC,c/C2kCgC;AJmuIpC;AmD5yKI;EACE,WAAA;EACA,oCAAA;EACA,wBlD9BE;AD40KR;;AmDzyKA;EACE,iBAAA;AnD4yKF;AmD1yKE;EACE,MAAA;AnD4yKJ;AmD1yKI;EACE,YAAA;EACA,6BAAA;EACA,yBlD5CE;ADw1KR;;AmDvyKA;EACE,iBAAA;AnD0yKF;AmDxyKE;EACE,QAAA;EACA,a/C+iCgC;E+C9iChC,c/C6iCgC;AJ6vIpC;AmDxyKI;EACE,UAAA;EACA,oCAAA;EACA,uBlD5DE;ADs2KR;;AmDrxKA;EACE,gB/CygCkC;E+CxgClC,uBAAA;EACA,WlD9FM;EkD+FN,kBAAA;EACA,sBlDtFM;EKPJ,sBAAA;ANs3KJ;;AqDz4KA;EACE,kBAAA;EACA,MAAA;EACA,wBAAA;EACA,ajD24BkC;EiD14BlC,cAAA;EACA,gBpDsIkB;EmD3IlB,4MhDoa4B;EgDpa5B,sChDoa4B;EgDla5B,kBAAA;EACA,gBhD6a4B;EgD5a5B,gBhDkb4B;EgDjb5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CsRI,mBALI;EgDpRR,qBAAA;EACA,sBpDGM;EoDFN,4BAAA;EACA,2EAAA;E/CIE,qBAAA;ANm5KJ;AqDn5KE;EACE,kBAAA;EACA,cAAA;EACA,WjD6oCgC;EiD5oChC,cjD6oCgC;AJwwIpC;AqDn5KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDo5KN;;AqD94KE;EACE,2BAAA;ArDi5KJ;AqD/4KI;EACE,SAAA;EACA,6BAAA;EACA,2EjD4nC8B;AJqxIpC;AqD94KI;EACE,WjDyTwB;EiDxTxB,6BAAA;EACA,sBpDjCE;ADi7KR;;AqD14KE;EACE,yBAAA;EACA,ajD2mCgC;EiD1mChC,YjDymCgC;AJoyIpC;AqD34KI;EACE,OAAA;EACA,oCAAA;EACA,6EjDwmC8B;AJqyIpC;AqD14KI;EACE,SjDqSwB;EiDpSxB,oCAAA;EACA,wBpDrDE;ADi8KR;;AqDt4KE;EACE,wBAAA;ArDy4KJ;AqDv4KI;EACE,MAAA;EACA,oCAAA;EACA,8EjDslC8B;AJmzIpC;AqDt4KI;EACE,QjDmRwB;EiDlRxB,oCAAA;EACA,yBpDvEE;AD+8KR;AqDn4KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WjDkkCgC;EiDjkChC,oBAAA;EACA,WAAA;EACA,6BAAA;ArDq4KJ;;AqDh4KE;EACE,0BAAA;EACA,ajDyjCgC;EiDxjChC,YjDujCgC;AJ40IpC;AqDj4KI;EACE,QAAA;EACA,oCAAA;EACA,4EjDsjC8B;AJ60IpC;AqDh4KI;EACE,UjDmPwB;EiDlPxB,oCAAA;EACA,uBpDvGE;ADy+KR;;AqD72KA;EACE,oBAAA;EACA,gBAAA;EhDuJI,kBALI;EgD/IR,sBpDjIM;EoDkIN,kFAAA;E/CtHE,0CAAA;EACA,2CAAA;ANs+KJ;AqD92KE;EACE,aAAA;ArDg3KJ;;AqD52KA;EACE,kBAAA;EACA,cpDrIS;ADo/KX;;AsD9/KA;EACE,kBAAA;AtDigLF;;AsD9/KA;EACE,mBAAA;AtDigLF;;AsD9/KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDigLF;AuDvhLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDyhLJ;;AsDlgLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EjClBI,sCiCmBJ;AtDqgLF;AqBphLM;EiCQN;IjCPQ,gBAAA;ErBuhLN;AACF;;AsDvgLA;;;EAGE,cAAA;AtD0gLF;;AsDvgLA,qBAAA;AACA;;EAEE,2BAAA;AtD0gLF;;AsDvgLA;;EAEE,4BAAA;AtD0gLF;;AsDvgLA,mBAAA;AAQE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDmgLJ;AsDhgLE;;;EAGE,UAAA;EACA,UAAA;AtDkgLJ;AsD//KE;;EAEE,UAAA;EACA,UAAA;EjC/DE,2BiCgEF;AtDigLJ;AqB7jLM;EiCwDJ;;IjCvDM,gBAAA;ErBikLN;AACF;;AsD9/KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlD2vCmC;EkD1vCnC,UAAA;EACA,WrDrFM;EqDsFN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlDsvCmC;EiB/0C/B,8BiC0FJ;AtDggLF;AqBtlLM;EiCqEN;;IjCpEQ,gBAAA;ErB0lLN;AACF;AsDngLE;;;EAEE,WrD/FI;EqDgGJ,qBAAA;EACA,UAAA;EACA,YlD8uCiC;AJwxIrC;;AsDngLA;EACE,OAAA;AtDsgLF;;AsDngLA;EACE,QAAA;AtDsgLF;;AsDjgLA;;EAEE,qBAAA;EACA,WlD+uCmC;EkD9uCnC,YlD8uCmC;EkD7uCnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtDogLF;;AsDjgLA;;;;;;;GAAA;AAQA;EACE,0DAAA;AtDogLF;;AsDlgLA;EACE,0DAAA;AtDqgLF;;AsD7/KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlDurCmC;EkDtrCnC,mBAAA;EACA,gBlDqrCmC;EkDprCnC,gBAAA;AtD+/KF;AsD7/KE;EACE,uBAAA;EACA,cAAA;EACA,WlDorCiC;EkDnrCjC,WlDorCiC;EkDnrCjC,UAAA;EACA,iBlDorCiC;EkDnrCjC,gBlDmrCiC;EkDlrCjC,mBAAA;EACA,eAAA;EACA,sBrDtKI;EqDuKJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlD2qCiC;EiBv1C/B,6BiC6KF;AtD8/KJ;AqBvqLM;EiCwJJ;IjCvJM,gBAAA;ErB0qLN;AACF;AsDhgLE;EACE,UlDwqCiC;AJ01IrC;;AsDz/KA;EACE,kBAAA;EACA,UAAA;EACA,elDkqCmC;EkDjqCnC,SAAA;EACA,oBlD+pCmC;EkD9pCnC,uBlD8pCmC;EkD7pCnC,WrDjMM;EqDkMN,kBAAA;AtD4/KF;;AsDt/KE;;EAEE,gClDiqCiC;AJw1IrC;AsDt/KE;EACE,sBrDpMI;AD4rLR;AsDr/KE;EACE,WrDxMI;AD+rLR;;AwDptLA;EACE;IAAK,0CAAA;ExDwtLL;AACF;AwDrtLA;EACE,qBAAA;EACA,WpDs3CwB;EoDr3CxB,YpDq3CwB;EoDp3CxB,wBpDs3CwB;EoDr3CxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AxDstLF;;AwDntLA;EACE,WpDi3CwB;EoDh3CxB,YpDg3CwB;EoD/2CxB,mBpDi3CwB;AJq2I1B;;AwD9sLA;EACE;IACE,mBAAA;ExDitLF;EwD/sLA;IACE,UAAA;IACA,eAAA;ExDitLF;AACF;AwD7sLA;EACE,qBAAA;EACA,WpDo1CwB;EoDn1CxB,YpDm1CwB;EoDl1CxB,wBpDo1CwB;EoDn1CxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AxD8sLF;;AwD3sLA;EACE,WpD+0CwB;EoD90CxB,YpD80CwB;AJg4I1B;;AwD1sLE;EACE;;IAEE,wBAAA;ExD6sLJ;AACF;AyD/wLA;EACE,eAAA;EACA,SAAA;EACA,arD04BkC;EqDz4BlC,aAAA;EACA,sBAAA;EACA,eAAA;EAEA,kBAAA;EACA,sBxDOM;EwDNN,4BAAA;EACA,UAAA;EpCKI,sCoCHJ;AzD+wLF;AqBxwLM;EoCpBN;IpCqBQ,gBAAA;ErB2wLN;AACF;;AyDjxLA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AzDoxLF;AyDlxLE;EACE,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AzDoxLJ;;AyDhxLA;EACE,gBAAA;EACA,gBrDuZ4B;AJ43K9B;;AyDhxLA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AzDmxLF;;AyDhxLA;EACE,MAAA;EACA,OAAA;EACA,YrDy3CkC;EqDx3ClC,0CAAA;EACA,4BAAA;AzDmxLF;;AyDhxLA;EACE,MAAA;EACA,QAAA;EACA,YrDi3CkC;EqDh3ClC,yCAAA;EACA,2BAAA;AzDmxLF;;AyDhxLA;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,YrDy2CkC;EqDx2ClC,gBAAA;EACA,2CAAA;EACA,4BAAA;AzDmxLF;;AyDhxLA;EACE,QAAA;EACA,OAAA;EACA,YrDg2CkC;EqD/1ClC,gBAAA;EACA,wCAAA;EACA,2BAAA;AzDmxLF;;AyDhxLA;EACE,eAAA;AzDmxLF;;A0D51LA;EACE,kBAAA;EACA,mBALkC;EAMlC,yBzDWS;EKCP,qBAAA;ANo1LJ;AaxyLI;E6C3DJ;IAOI,kBAAA;E1Dg2LF;AACF;;A0D71LA;EACE,gBAAA;EACA,eAAA;EpDEE,gBAAA;AN+1LJ;;AuDh3LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDm3LJ;;A2Dv3LE;EACE,c1DmFW;ADuyLf;A2Dv3LM;EAEE,6BAAA;A3Dw3LR;;A2D93LE;EACE,c1DmFW;AD8yLf;A2D93LM;EAEE,2BAAA;A3D+3LR;;A2Dr4LE;EACE,c1DmFW;ADqzLf;A2Dr4LM;EAEE,4BAAA;A3Ds4LR;;A2D54LE;EACE,c1DmFW;AD4zLf;A2D54LM;EAEE,4BAAA;A3D64LR;;A2Dn5LE;EACE,c1DmFW;ADm0Lf;A2Dn5LM;EAEE,4BAAA;A3Do5LR;;A2D15LE;EACE,c1DmFW;AD00Lf;A2D15LM;EAEE,2BAAA;A3D25LR;;A2Dj6LE;EACE,c1DmFW;ADi1Lf;A2Dj6LM;EAEE,+BAAA;A3Dk6LR;;A2Dx6LE;EACE,c1DmFW;ADw1Lf;A2Dx6LM;EAEE,4BAAA;A3Dy6LR;;A2D/6LE;EACE,c1DmFW;AD+1Lf;A2D/6LM;EAEE,4BAAA;A3Dg7LR;;A2Dt7LE;EACE,c1DmFW;ADs2Lf;A2Dt7LM;EAEE,8BAAA;A3Du7LR;;A4D57LA;EACE,kBAAA;EACA,WAAA;A5D+7LF;A4D77LE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A5D+7LJ;A4D57LE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A5D87LJ;;A4Dz7LE;EACE,uBAAA;A5D47LJ;;A4D77LE;EACE,sBAAA;A5Dg8LJ;;A4Dj8LE;EACE,yBAAA;A5Do8LJ;;A4Dr8LE;EACE,iCAAA;A5Dw8LJ;;A6D79LA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,azDo4BkC;AJ4lKpC;;A6D79LA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,azD43BkC;AJomKpC;;A6Dx9LI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,azDg3B8B;AJ2mKpC;;Aat7LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJknKlC;AACF;Aa97LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJynKlC;AACF;Aar8LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJgoKlC;AACF;Aa58LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJuoKlC;AACF;Aan9LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJ8oKlC;AACF;A8DrhMA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;A/DqhMF;;AgEhiME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U5D2RsC;E4D1RtC,WAAA;AhEmiMJ;;AiE3iMA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AlE+iMF;;AmEpgMM;EAEI,mCAAA;AnEsgMV;;AmExgMM;EAEI,8BAAA;AnE0gMV;;AmE5gMM;EAEI,iCAAA;AnE8gMV;;AmEhhMM;EAEI,iCAAA;AnEkhMV;;AmEphMM;EAEI,sCAAA;AnEshMV;;AmExhMM;EAEI,mCAAA;AnE0hMV;;AmE5hMM;EAEI,sBAAA;AnE8hMV;;AmEhiMM;EAEI,uBAAA;AnEkiMV;;AmEpiMM;EAEI,sBAAA;AnEsiMV;;AmExiMM;EAEI,yBAAA;AnE0iMV;;AmE5iMM;EAEI,2BAAA;AnE8iMV;;AmEhjMM;EAEI,4BAAA;AnEkjMV;;AmEpjMM;EAEI,2BAAA;AnEsjMV;;AmExjMM;EAEI,0BAAA;AnE0jMV;;AmE5jMM;EAEI,gCAAA;AnE8jMV;;AmEhkMM;EAEI,yBAAA;AnEkkMV;;AmEpkMM;EAEI,wBAAA;AnEskMV;;AmExkMM;EAEI,yBAAA;AnE0kMV;;AmE5kMM;EAEI,6BAAA;AnE8kMV;;AmEhlMM;EAEI,8BAAA;AnEklMV;;AmEplMM;EAEI,wBAAA;AnEslMV;;AmExlMM;EAEI,+BAAA;AnE0lMV;;AmE5lMM;EAEI,wBAAA;AnE8lMV;;AmEhmMM;EAEI,wDAAA;AnEkmMV;;AmEpmMM;EAEI,8DAAA;AnEsmMV;;AmExmMM;EAEI,uDAAA;AnE0mMV;;AmE5mMM;EAEI,2BAAA;AnE8mMV;;AmEhnMM;EAEI,2BAAA;AnEknMV;;AmEpnMM;EAEI,6BAAA;AnEsnMV;;AmExnMM;EAEI,6BAAA;AnE0nMV;;AmE5nMM;EAEI,0BAAA;AnE8nMV;;AmEhoMM;EAEI,mCAAA;EAAA,2BAAA;AnEkoMV;;AmEpoMM;EAEI,iBAAA;AnEsoMV;;AmExoMM;EAEI,mBAAA;AnE0oMV;;AmE5oMM;EAEI,oBAAA;AnE8oMV;;AmEhpMM;EAEI,oBAAA;AnEkpMV;;AmEppMM;EAEI,sBAAA;AnEspMV;;AmExpMM;EAEI,uBAAA;AnE0pMV;;AmE5pMM;EAEI,kBAAA;AnE8pMV;;AmEhqMM;EAEI,oBAAA;AnEkqMV;;AmEpqMM;EAEI,qBAAA;AnEsqMV;;AmExqMM;EAEI,mBAAA;AnE0qMV;;AmE5qMM;EAEI,qBAAA;AnE8qMV;;AmEhrMM;EAEI,sBAAA;AnEkrMV;;AmEprMM;EAEI,2CAAA;AnEsrMV;;AmExrMM;EAEI,sCAAA;AnE0rMV;;AmE5rMM;EAEI,sCAAA;AnE8rMV;;AmEhsMM;EAEI,oCAAA;AnEksMV;;AmEpsMM;EAEI,oBAAA;AnEssMV;;AmExsMM;EAEI,wCAAA;AnE0sMV;;AmE5sMM;EAEI,wBAAA;AnE8sMV;;AmEhtMM;EAEI,0CAAA;AnEktMV;;AmEptMM;EAEI,0BAAA;AnEstMV;;AmExtMM;EAEI,2CAAA;AnE0tMV;;AmE5tMM;EAEI,2BAAA;AnE8tMV;;AmEhuMM;EAEI,yCAAA;AnEkuMV;;AmEpuMM;EAEI,yBAAA;AnEsuMV;;AmExuMM;EAEI,gCAAA;AnE0uMV;;AmE5uMM;EAEI,gCAAA;AnE8uMV;;AmEhvMM;EAEI,gCAAA;AnEkvMV;;AmEpvMM;EAEI,gCAAA;AnEsvMV;;AmExvMM;EAEI,gCAAA;AnE0vMV;;AmE5vMM;EAEI,gCAAA;AnE8vMV;;AmEhwMM;EAEI,gCAAA;AnEkwMV;;AmEpwMM;EAEI,gCAAA;AnEswMV;;AmExwMM;EAEI,gCAAA;AnE0wMV;;AmE5wMM;EAEI,gCAAA;AnE8wMV;;AmEhxMM;EAEI,6BAAA;AnEkxMV;;AmEpxMM;EAEI,4BAAA;AnEsxMV;;AmExxMM;EAEI,4BAAA;AnE0xMV;;AmE5xMM;EAEI,4BAAA;AnE8xMV;;AmEhyMM;EAEI,4BAAA;AnEkyMV;;AmEpyMM;EAEI,4BAAA;AnEsyMV;;AmExyMM;EAEI,qBAAA;AnE0yMV;;AmE5yMM;EAEI,qBAAA;AnE8yMV;;AmEhzMM;EAEI,qBAAA;AnEkzMV;;AmEpzMM;EAEI,sBAAA;AnEszMV;;AmExzMM;EAEI,sBAAA;AnE0zMV;;AmE5zMM;EAEI,0BAAA;AnE8zMV;;AmEh0MM;EAEI,uBAAA;AnEk0MV;;AmEp0MM;EAEI,2BAAA;AnEs0MV;;AmEx0MM;EAEI,sBAAA;AnE00MV;;AmE50MM;EAEI,sBAAA;AnE80MV;;AmEh1MM;EAEI,sBAAA;AnEk1MV;;AmEp1MM;EAEI,uBAAA;AnEs1MV;;AmEx1MM;EAEI,uBAAA;AnE01MV;;AmE51MM;EAEI,2BAAA;AnE81MV;;AmEh2MM;EAEI,wBAAA;AnEk2MV;;AmEp2MM;EAEI,4BAAA;AnEs2MV;;AmEx2MM;EAEI,yBAAA;AnE02MV;;AmE52MM;EAEI,8BAAA;AnE82MV;;AmEh3MM;EAEI,iCAAA;AnEk3MV;;AmEp3MM;EAEI,sCAAA;AnEs3MV;;AmEx3MM;EAEI,yCAAA;AnE03MV;;AmE53MM;EAEI,uBAAA;AnE83MV;;AmEh4MM;EAEI,uBAAA;AnEk4MV;;AmEp4MM;EAEI,yBAAA;AnEs4MV;;AmEx4MM;EAEI,yBAAA;AnE04MV;;AmE54MM;EAEI,0BAAA;AnE84MV;;AmEh5MM;EAEI,4BAAA;AnEk5MV;;AmEp5MM;EAEI,kCAAA;AnEs5MV;;AmEx5MM;EAEI,iBAAA;AnE05MV;;AmE55MM;EAEI,uBAAA;AnE85MV;;AmEh6MM;EAEI,sBAAA;AnEk6MV;;AmEp6MM;EAEI,oBAAA;AnEs6MV;;AmEx6MM;EAEI,sBAAA;AnE06MV;;AmE56MM;EAEI,oBAAA;AnE86MV;;AmEh7MM;EAEI,sCAAA;AnEk7MV;;AmEp7MM;EAEI,oCAAA;AnEs7MV;;AmEx7MM;EAEI,kCAAA;AnE07MV;;AmE57MM;EAEI,yCAAA;AnE87MV;;AmEh8MM;EAEI,wCAAA;AnEk8MV;;AmEp8MM;EAEI,wCAAA;AnEs8MV;;AmEx8MM;EAEI,kCAAA;AnE08MV;;AmE58MM;EAEI,gCAAA;AnE88MV;;AmEh9MM;EAEI,8BAAA;AnEk9MV;;AmEp9MM;EAEI,gCAAA;AnEs9MV;;AmEx9MM;EAEI,+BAAA;AnE09MV;;AmE59MM;EAEI,oCAAA;AnE89MV;;AmEh+MM;EAEI,kCAAA;AnEk+MV;;AmEp+MM;EAEI,gCAAA;AnEs+MV;;AmEx+MM;EAEI,uCAAA;AnE0+MV;;AmE5+MM;EAEI,sCAAA;AnE8+MV;;AmEh/MM;EAEI,iCAAA;AnEk/MV;;AmEp/MM;EAEI,2BAAA;AnEs/MV;;AmEx/MM;EAEI,iCAAA;AnE0/MV;;AmE5/MM;EAEI,+BAAA;AnE8/MV;;AmEhgNM;EAEI,6BAAA;AnEkgNV;;AmEpgNM;EAEI,+BAAA;AnEsgNV;;AmExgNM;EAEI,8BAAA;AnE0gNV;;AmE5gNM;EAEI,oBAAA;AnE8gNV;;AmEhhNM;EAEI,mBAAA;AnEkhNV;;AmEphNM;EAEI,mBAAA;AnEshNV;;AmExhNM;EAEI,mBAAA;AnE0hNV;;AmE5hNM;EAEI,mBAAA;AnE8hNV;;AmEhiNM;EAEI,mBAAA;AnEkiNV;;AmEpiNM;EAEI,mBAAA;AnEsiNV;;AmExiNM;EAEI,mBAAA;AnE0iNV;;AmE5iNM;EAEI,oBAAA;AnE8iNV;;AmEhjNM;EAEI,0BAAA;AnEkjNV;;AmEpjNM;EAEI,yBAAA;AnEsjNV;;AmExjNM;EAEI,uBAAA;AnE0jNV;;AmE5jNM;EAEI,yBAAA;AnE8jNV;;AmEhkNM;EAEI,uBAAA;AnEkkNV;;AmEpkNM;EAEI,uBAAA;AnEskNV;;AmExkNM;EAEI,0BAAA;EAAA,yBAAA;AnE2kNV;;AmE7kNM;EAEI,gCAAA;EAAA,+BAAA;AnEglNV;;AmEllNM;EAEI,+BAAA;EAAA,8BAAA;AnEqlNV;;AmEvlNM;EAEI,6BAAA;EAAA,4BAAA;AnE0lNV;;AmE5lNM;EAEI,+BAAA;EAAA,8BAAA;AnE+lNV;;AmEjmNM;EAEI,6BAAA;EAAA,4BAAA;AnEomNV;;AmEtmNM;EAEI,6BAAA;EAAA,4BAAA;AnEymNV;;AmE3mNM;EAEI,wBAAA;EAAA,2BAAA;AnE8mNV;;AmEhnNM;EAEI,8BAAA;EAAA,iCAAA;AnEmnNV;;AmErnNM;EAEI,6BAAA;EAAA,gCAAA;AnEwnNV;;AmE1nNM;EAEI,2BAAA;EAAA,8BAAA;AnE6nNV;;AmE/nNM;EAEI,6BAAA;EAAA,gCAAA;AnEkoNV;;AmEpoNM;EAEI,2BAAA;EAAA,8BAAA;AnEuoNV;;AmEzoNM;EAEI,2BAAA;EAAA,8BAAA;AnE4oNV;;AmE9oNM;EAEI,wBAAA;AnEgpNV;;AmElpNM;EAEI,8BAAA;AnEopNV;;AmEtpNM;EAEI,6BAAA;AnEwpNV;;AmE1pNM;EAEI,2BAAA;AnE4pNV;;AmE9pNM;EAEI,6BAAA;AnEgqNV;;AmElqNM;EAEI,2BAAA;AnEoqNV;;AmEtqNM;EAEI,2BAAA;AnEwqNV;;AmE1qNM;EAEI,0BAAA;AnE4qNV;;AmE9qNM;EAEI,gCAAA;AnEgrNV;;AmElrNM;EAEI,+BAAA;AnEorNV;;AmEtrNM;EAEI,6BAAA;AnEwrNV;;AmE1rNM;EAEI,+BAAA;AnE4rNV;;AmE9rNM;EAEI,6BAAA;AnEgsNV;;AmElsNM;EAEI,6BAAA;AnEosNV;;AmEtsNM;EAEI,2BAAA;AnEwsNV;;AmE1sNM;EAEI,iCAAA;AnE4sNV;;AmE9sNM;EAEI,gCAAA;AnEgtNV;;AmEltNM;EAEI,8BAAA;AnEotNV;;AmEttNM;EAEI,gCAAA;AnEwtNV;;AmE1tNM;EAEI,8BAAA;AnE4tNV;;AmE9tNM;EAEI,8BAAA;AnEguNV;;AmEluNM;EAEI,yBAAA;AnEouNV;;AmEtuNM;EAEI,+BAAA;AnEwuNV;;AmE1uNM;EAEI,8BAAA;AnE4uNV;;AmE9uNM;EAEI,4BAAA;AnEgvNV;;AmElvNM;EAEI,8BAAA;AnEovNV;;AmEtvNM;EAEI,4BAAA;AnEwvNV;;AmE1vNM;EAEI,4BAAA;AnE4vNV;;AmE9vNM;EAEI,qBAAA;AnEgwNV;;AmElwNM;EAEI,2BAAA;AnEowNV;;AmEtwNM;EAEI,0BAAA;AnEwwNV;;AmE1wNM;EAEI,wBAAA;AnE4wNV;;AmE9wNM;EAEI,0BAAA;AnEgxNV;;AmElxNM;EAEI,wBAAA;AnEoxNV;;AmEtxNM;EAEI,2BAAA;EAAA,0BAAA;AnEyxNV;;AmE3xNM;EAEI,iCAAA;EAAA,gCAAA;AnE8xNV;;AmEhyNM;EAEI,gCAAA;EAAA,+BAAA;AnEmyNV;;AmEryNM;EAEI,8BAAA;EAAA,6BAAA;AnEwyNV;;AmE1yNM;EAEI,gCAAA;EAAA,+BAAA;AnE6yNV;;AmE/yNM;EAEI,8BAAA;EAAA,6BAAA;AnEkzNV;;AmEpzNM;EAEI,yBAAA;EAAA,4BAAA;AnEuzNV;;AmEzzNM;EAEI,+BAAA;EAAA,kCAAA;AnE4zNV;;AmE9zNM;EAEI,8BAAA;EAAA,iCAAA;AnEi0NV;;AmEn0NM;EAEI,4BAAA;EAAA,+BAAA;AnEs0NV;;AmEx0NM;EAEI,8BAAA;EAAA,iCAAA;AnE20NV;;AmE70NM;EAEI,4BAAA;EAAA,+BAAA;AnEg1NV;;AmEl1NM;EAEI,yBAAA;AnEo1NV;;AmEt1NM;EAEI,+BAAA;AnEw1NV;;AmE11NM;EAEI,8BAAA;AnE41NV;;AmE91NM;EAEI,4BAAA;AnEg2NV;;AmEl2NM;EAEI,8BAAA;AnEo2NV;;AmEt2NM;EAEI,4BAAA;AnEw2NV;;AmE12NM;EAEI,2BAAA;AnE42NV;;AmE92NM;EAEI,iCAAA;AnEg3NV;;AmEl3NM;EAEI,gCAAA;AnEo3NV;;AmEt3NM;EAEI,8BAAA;AnEw3NV;;AmE13NM;EAEI,gCAAA;AnE43NV;;AmE93NM;EAEI,8BAAA;AnEg4NV;;AmEl4NM;EAEI,4BAAA;AnEo4NV;;AmEt4NM;EAEI,kCAAA;AnEw4NV;;AmE14NM;EAEI,iCAAA;AnE44NV;;AmE94NM;EAEI,+BAAA;AnEg5NV;;AmEl5NM;EAEI,iCAAA;AnEo5NV;;AmEt5NM;EAEI,+BAAA;AnEw5NV;;AmE15NM;EAEI,0BAAA;AnE45NV;;AmE95NM;EAEI,gCAAA;AnEg6NV;;AmEl6NM;EAEI,+BAAA;AnEo6NV;;AmEt6NM;EAEI,6BAAA;AnEw6NV;;AmE16NM;EAEI,+BAAA;AnE46NV;;AmE96NM;EAEI,6BAAA;AnEg7NV;;AmEl7NM;EAEI,4GAAA;EAAA,gDAAA;AnEo7NV;;AmEt7NM;EAEI,6CAAA;AnEw7NV;;AmE17NM;EAEI,8CAAA;AnE47NV;;AmE97NM;EAEI,8CAAA;AnEg8NV;;AmEl8NM;EAEI,8CAAA;AnEo8NV;;AmEt8NM;EAEI,4BAAA;AnEw8NV;;AmE18NM;EAEI,6BAAA;AnE48NV;;AmE98NM;EAEI,6BAAA;AnEg9NV;;AmEl9NM;EAEI,6BAAA;AnEo9NV;;AmEt9NM;EAEI,2BAAA;AnEw9NV;;AmE19NM;EAEI,+BAAA;AnE49NV;;AmE99NM;EAEI,2BAAA;AnEg+NV;;AmEl+NM;EAEI,2BAAA;AnEo+NV;;AmEt+NM;EAEI,8BAAA;AnEw+NV;;AmE1+NM;EAEI,yBAAA;AnE4+NV;;AmE9+NM;EAEI,4BAAA;AnEg/NV;;AmEl/NM;EAEI,2BAAA;AnEo/NV;;AmEt/NM;EAEI,yBAAA;AnEw/NV;;AmE1/NM;EAEI,2BAAA;AnE4/NV;;AmE9/NM;EAEI,4BAAA;AnEggOV;;AmElgOM;EAEI,6BAAA;AnEogOV;;AmEtgOM;EAEI,gCAAA;AnEwgOV;;AmE1gOM;EAEI,qCAAA;AnE4gOV;;AmE9gOM;EAEI,wCAAA;AnEghOV;;AmElhOM;EAEI,oCAAA;AnEohOV;;AmEthOM;EAEI,oCAAA;AnEwhOV;;AmE1hOM;EAEI,qCAAA;AnE4hOV;;AmE9hOM;EAEI,8BAAA;AnEgiOV;;AmEliOM;EAEI,8BAAA;AnEoiOV;;AmExiOQ,qBAAA;AAEF;EAEI,gCAAA;EAAA,iCAAA;AnE0iOV;;AmE9hOQ,mBAAA;AAdF;EAEI,yBAAA;AnE+iOV;;AmEjjOM;EAEI,yBAAA;AnEmjOV;;AmErjOM;EAEI,yBAAA;AnEujOV;;AmEzjOM;EAEI,yBAAA;AnE2jOV;;AmE7jOM;EAEI,yBAAA;AnE+jOV;;AmEjkOM;EAEI,yBAAA;AnEmkOV;;AmErkOM;EAEI,yBAAA;AnEukOV;;AmEzkOM;EAEI,yBAAA;AnE2kOV;;AmE7kOM;EAEI,yBAAA;AnE+kOV;;AmEjlOM;EAEI,yBAAA;AnEmlOV;;AmErlOM;EAEI,sBAAA;AnEulOV;;AmEzlOM;EAEI,yBAAA;AnE2lOV;;AmE7lOM;EAEI,yBAAA;AnE+lOV;;AmEjmOM;EAEI,oCAAA;AnEmmOV;;AmErmOM;EAEI,0CAAA;AnEumOV;;AmEzmOM;EAEI,yBAAA;AnE2mOV;;AmE7mOM;EAEI,oCAAA;AnE+mOV;;AmEjnOM;EAEI,oCAAA;AnEmnOV;;AmErnOM;EAEI,oCAAA;AnEunOV;;AmEznOM;EAEI,oCAAA;AnE2nOV;;AmE7nOM;EAEI,oCAAA;AnE+nOV;;AmEjoOM;EAEI,oCAAA;AnEmoOV;;AmEroOM;EAEI,oCAAA;AnEuoOV;;AmEzoOM;EAEI,oCAAA;AnE2oOV;;AmE7oOM;EAEI,oCAAA;AnE+oOV;;AmEjpOM;EAEI,oCAAA;AnEmpOV;;AmErpOM;EAEI,iCAAA;AnEupOV;;AmEzpOM;EAEI,iCAAA;AnE2pOV;;AmE7pOM;EAEI,wCAAA;AnE+pOV;;AmEjqOM;EAEI,uGAAA;EAAA,+CAAA;AnEmqOV;;AmErqOM;EAEI,mCAAA;UAAA,2BAAA;AnEuqOV;;AmEzqOM;EAEI,oCAAA;UAAA,4BAAA;AnE2qOV;;AmE7qOM;EAEI,oCAAA;UAAA,4BAAA;AnE+qOV;;AmEjrOM;EAEI,+BAAA;AnEmrOV;;AmErrOM;EAEI,+BAAA;AnEurOV;;AmEzrOM;EAEI,iCAAA;AnE2rOV;;AmE7rOM;EAEI,2BAAA;AnE+rOV;;AmEjsOM;EAEI,gCAAA;AnEmsOV;;AmErsOM;EAEI,iCAAA;AnEusOV;;AmEzsOM;EAEI,gCAAA;AnE2sOV;;AmE7sOM;EAEI,6BAAA;AnE+sOV;;AmEjtOM;EAEI,+BAAA;AnEmtOV;;AmErtOM;EAEI,0CAAA;EAAA,2CAAA;AnEwtOV;;AmE1tOM;EAEI,2CAAA;EAAA,8CAAA;AnE6tOV;;AmE/tOM;EAEI,8CAAA;EAAA,6CAAA;AnEkuOV;;AmEpuOM;EAEI,6CAAA;EAAA,0CAAA;AnEuuOV;;AmEzuOM;EAEI,8BAAA;AnE2uOV;;AmE7uOM;EAEI,6BAAA;AnE+uOV;;AanuOI;EsDdE;IAEI,sBAAA;EnEovOR;EmEtvOI;IAEI,uBAAA;EnEuvOR;EmEzvOI;IAEI,sBAAA;EnE0vOR;EmE5vOI;IAEI,0BAAA;EnE6vOR;EmE/vOI;IAEI,gCAAA;EnEgwOR;EmElwOI;IAEI,yBAAA;EnEmwOR;EmErwOI;IAEI,wBAAA;EnEswOR;EmExwOI;IAEI,yBAAA;EnEywOR;EmE3wOI;IAEI,6BAAA;EnE4wOR;EmE9wOI;IAEI,8BAAA;EnE+wOR;EmEjxOI;IAEI,wBAAA;EnEkxOR;EmEpxOI;IAEI,+BAAA;EnEqxOR;EmEvxOI;IAEI,wBAAA;EnEwxOR;EmE1xOI;IAEI,yBAAA;EnE2xOR;EmE7xOI;IAEI,8BAAA;EnE8xOR;EmEhyOI;IAEI,iCAAA;EnEiyOR;EmEnyOI;IAEI,sCAAA;EnEoyOR;EmEtyOI;IAEI,yCAAA;EnEuyOR;EmEzyOI;IAEI,uBAAA;EnE0yOR;EmE5yOI;IAEI,uBAAA;EnE6yOR;EmE/yOI;IAEI,yBAAA;EnEgzOR;EmElzOI;IAEI,yBAAA;EnEmzOR;EmErzOI;IAEI,0BAAA;EnEszOR;EmExzOI;IAEI,4BAAA;EnEyzOR;EmE3zOI;IAEI,kCAAA;EnE4zOR;EmE9zOI;IAEI,iBAAA;EnE+zOR;EmEj0OI;IAEI,uBAAA;EnEk0OR;EmEp0OI;IAEI,sBAAA;EnEq0OR;EmEv0OI;IAEI,oBAAA;EnEw0OR;EmE10OI;IAEI,sBAAA;EnE20OR;EmE70OI;IAEI,oBAAA;EnE80OR;EmEh1OI;IAEI,sCAAA;EnEi1OR;EmEn1OI;IAEI,oCAAA;EnEo1OR;EmEt1OI;IAEI,kCAAA;EnEu1OR;EmEz1OI;IAEI,yCAAA;EnE01OR;EmE51OI;IAEI,wCAAA;EnE61OR;EmE/1OI;IAEI,wCAAA;EnEg2OR;EmEl2OI;IAEI,kCAAA;EnEm2OR;EmEr2OI;IAEI,gCAAA;EnEs2OR;EmEx2OI;IAEI,8BAAA;EnEy2OR;EmE32OI;IAEI,gCAAA;EnE42OR;EmE92OI;IAEI,+BAAA;EnE+2OR;EmEj3OI;IAEI,oCAAA;EnEk3OR;EmEp3OI;IAEI,kCAAA;EnEq3OR;EmEv3OI;IAEI,gCAAA;EnEw3OR;EmE13OI;IAEI,uCAAA;EnE23OR;EmE73OI;IAEI,sCAAA;EnE83OR;EmEh4OI;IAEI,iCAAA;EnEi4OR;EmEn4OI;IAEI,2BAAA;EnEo4OR;EmEt4OI;IAEI,iCAAA;EnEu4OR;EmEz4OI;IAEI,+BAAA;EnE04OR;EmE54OI;IAEI,6BAAA;EnE64OR;EmE/4OI;IAEI,+BAAA;EnEg5OR;EmEl5OI;IAEI,8BAAA;EnEm5OR;EmEr5OI;IAEI,oBAAA;EnEs5OR;EmEx5OI;IAEI,mBAAA;EnEy5OR;EmE35OI;IAEI,mBAAA;EnE45OR;EmE95OI;IAEI,mBAAA;EnE+5OR;EmEj6OI;IAEI,mBAAA;EnEk6OR;EmEp6OI;IAEI,mBAAA;EnEq6OR;EmEv6OI;IAEI,mBAAA;EnEw6OR;EmE16OI;IAEI,mBAAA;EnE26OR;EmE76OI;IAEI,oBAAA;EnE86OR;EmEh7OI;IAEI,0BAAA;EnEi7OR;EmEn7OI;IAEI,yBAAA;EnEo7OR;EmEt7OI;IAEI,uBAAA;EnEu7OR;EmEz7OI;IAEI,yBAAA;EnE07OR;EmE57OI;IAEI,uBAAA;EnE67OR;EmE/7OI;IAEI,uBAAA;EnEg8OR;EmEl8OI;IAEI,0BAAA;IAAA,yBAAA;EnEo8OR;EmEt8OI;IAEI,gCAAA;IAAA,+BAAA;EnEw8OR;EmE18OI;IAEI,+BAAA;IAAA,8BAAA;EnE48OR;EmE98OI;IAEI,6BAAA;IAAA,4BAAA;EnEg9OR;EmEl9OI;IAEI,+BAAA;IAAA,8BAAA;EnEo9OR;EmEt9OI;IAEI,6BAAA;IAAA,4BAAA;EnEw9OR;EmE19OI;IAEI,6BAAA;IAAA,4BAAA;EnE49OR;EmE99OI;IAEI,wBAAA;IAAA,2BAAA;EnEg+OR;EmEl+OI;IAEI,8BAAA;IAAA,iCAAA;EnEo+OR;EmEt+OI;IAEI,6BAAA;IAAA,gCAAA;EnEw+OR;EmE1+OI;IAEI,2BAAA;IAAA,8BAAA;EnE4+OR;EmE9+OI;IAEI,6BAAA;IAAA,gCAAA;EnEg/OR;EmEl/OI;IAEI,2BAAA;IAAA,8BAAA;EnEo/OR;EmEt/OI;IAEI,2BAAA;IAAA,8BAAA;EnEw/OR;EmE1/OI;IAEI,wBAAA;EnE2/OR;EmE7/OI;IAEI,8BAAA;EnE8/OR;EmEhgPI;IAEI,6BAAA;EnEigPR;EmEngPI;IAEI,2BAAA;EnEogPR;EmEtgPI;IAEI,6BAAA;EnEugPR;EmEzgPI;IAEI,2BAAA;EnE0gPR;EmE5gPI;IAEI,2BAAA;EnE6gPR;EmE/gPI;IAEI,0BAAA;EnEghPR;EmElhPI;IAEI,gCAAA;EnEmhPR;EmErhPI;IAEI,+BAAA;EnEshPR;EmExhPI;IAEI,6BAAA;EnEyhPR;EmE3hPI;IAEI,+BAAA;EnE4hPR;EmE9hPI;IAEI,6BAAA;EnE+hPR;EmEjiPI;IAEI,6BAAA;EnEkiPR;EmEpiPI;IAEI,2BAAA;EnEqiPR;EmEviPI;IAEI,iCAAA;EnEwiPR;EmE1iPI;IAEI,gCAAA;EnE2iPR;EmE7iPI;IAEI,8BAAA;EnE8iPR;EmEhjPI;IAEI,gCAAA;EnEijPR;EmEnjPI;IAEI,8BAAA;EnEojPR;EmEtjPI;IAEI,8BAAA;EnEujPR;EmEzjPI;IAEI,yBAAA;EnE0jPR;EmE5jPI;IAEI,+BAAA;EnE6jPR;EmE/jPI;IAEI,8BAAA;EnEgkPR;EmElkPI;IAEI,4BAAA;EnEmkPR;EmErkPI;IAEI,8BAAA;EnEskPR;EmExkPI;IAEI,4BAAA;EnEykPR;EmE3kPI;IAEI,4BAAA;EnE4kPR;EmE9kPI;IAEI,qBAAA;EnE+kPR;EmEjlPI;IAEI,2BAAA;EnEklPR;EmEplPI;IAEI,0BAAA;EnEqlPR;EmEvlPI;IAEI,wBAAA;EnEwlPR;EmE1lPI;IAEI,0BAAA;EnE2lPR;EmE7lPI;IAEI,wBAAA;EnE8lPR;EmEhmPI;IAEI,2BAAA;IAAA,0BAAA;EnEkmPR;EmEpmPI;IAEI,iCAAA;IAAA,gCAAA;EnEsmPR;EmExmPI;IAEI,gCAAA;IAAA,+BAAA;EnE0mPR;EmE5mPI;IAEI,8BAAA;IAAA,6BAAA;EnE8mPR;EmEhnPI;IAEI,gCAAA;IAAA,+BAAA;EnEknPR;EmEpnPI;IAEI,8BAAA;IAAA,6BAAA;EnEsnPR;EmExnPI;IAEI,yBAAA;IAAA,4BAAA;EnE0nPR;EmE5nPI;IAEI,+BAAA;IAAA,kCAAA;EnE8nPR;EmEhoPI;IAEI,8BAAA;IAAA,iCAAA;EnEkoPR;EmEpoPI;IAEI,4BAAA;IAAA,+BAAA;EnEsoPR;EmExoPI;IAEI,8BAAA;IAAA,iCAAA;EnE0oPR;EmE5oPI;IAEI,4BAAA;IAAA,+BAAA;EnE8oPR;EmEhpPI;IAEI,yBAAA;EnEipPR;EmEnpPI;IAEI,+BAAA;EnEopPR;EmEtpPI;IAEI,8BAAA;EnEupPR;EmEzpPI;IAEI,4BAAA;EnE0pPR;EmE5pPI;IAEI,8BAAA;EnE6pPR;EmE/pPI;IAEI,4BAAA;EnEgqPR;EmElqPI;IAEI,2BAAA;EnEmqPR;EmErqPI;IAEI,iCAAA;EnEsqPR;EmExqPI;IAEI,gCAAA;EnEyqPR;EmE3qPI;IAEI,8BAAA;EnE4qPR;EmE9qPI;IAEI,gCAAA;EnE+qPR;EmEjrPI;IAEI,8BAAA;EnEkrPR;EmEprPI;IAEI,4BAAA;EnEqrPR;EmEvrPI;IAEI,kCAAA;EnEwrPR;EmE1rPI;IAEI,iCAAA;EnE2rPR;EmE7rPI;IAEI,+BAAA;EnE8rPR;EmEhsPI;IAEI,iCAAA;EnEisPR;EmEnsPI;IAEI,+BAAA;EnEosPR;EmEtsPI;IAEI,0BAAA;EnEusPR;EmEzsPI;IAEI,gCAAA;EnE0sPR;EmE5sPI;IAEI,+BAAA;EnE6sPR;EmE/sPI;IAEI,6BAAA;EnEgtPR;EmEltPI;IAEI,+BAAA;EnEmtPR;EmErtPI;IAEI,6BAAA;EnEstPR;EmExtPI;IAEI,2BAAA;EnEytPR;EmE3tPI;IAEI,4BAAA;EnE4tPR;EmE9tPI;IAEI,6BAAA;EnE+tPR;AACF;AaptPI;EsDdE;IAEI,sBAAA;EnEouPR;EmEtuPI;IAEI,uBAAA;EnEuuPR;EmEzuPI;IAEI,sBAAA;EnE0uPR;EmE5uPI;IAEI,0BAAA;EnE6uPR;EmE/uPI;IAEI,gCAAA;EnEgvPR;EmElvPI;IAEI,yBAAA;EnEmvPR;EmErvPI;IAEI,wBAAA;EnEsvPR;EmExvPI;IAEI,yBAAA;EnEyvPR;EmE3vPI;IAEI,6BAAA;EnE4vPR;EmE9vPI;IAEI,8BAAA;EnE+vPR;EmEjwPI;IAEI,wBAAA;EnEkwPR;EmEpwPI;IAEI,+BAAA;EnEqwPR;EmEvwPI;IAEI,wBAAA;EnEwwPR;EmE1wPI;IAEI,yBAAA;EnE2wPR;EmE7wPI;IAEI,8BAAA;EnE8wPR;EmEhxPI;IAEI,iCAAA;EnEixPR;EmEnxPI;IAEI,sCAAA;EnEoxPR;EmEtxPI;IAEI,yCAAA;EnEuxPR;EmEzxPI;IAEI,uBAAA;EnE0xPR;EmE5xPI;IAEI,uBAAA;EnE6xPR;EmE/xPI;IAEI,yBAAA;EnEgyPR;EmElyPI;IAEI,yBAAA;EnEmyPR;EmEryPI;IAEI,0BAAA;EnEsyPR;EmExyPI;IAEI,4BAAA;EnEyyPR;EmE3yPI;IAEI,kCAAA;EnE4yPR;EmE9yPI;IAEI,iBAAA;EnE+yPR;EmEjzPI;IAEI,uBAAA;EnEkzPR;EmEpzPI;IAEI,sBAAA;EnEqzPR;EmEvzPI;IAEI,oBAAA;EnEwzPR;EmE1zPI;IAEI,sBAAA;EnE2zPR;EmE7zPI;IAEI,oBAAA;EnE8zPR;EmEh0PI;IAEI,sCAAA;EnEi0PR;EmEn0PI;IAEI,oCAAA;EnEo0PR;EmEt0PI;IAEI,kCAAA;EnEu0PR;EmEz0PI;IAEI,yCAAA;EnE00PR;EmE50PI;IAEI,wCAAA;EnE60PR;EmE/0PI;IAEI,wCAAA;EnEg1PR;EmEl1PI;IAEI,kCAAA;EnEm1PR;EmEr1PI;IAEI,gCAAA;EnEs1PR;EmEx1PI;IAEI,8BAAA;EnEy1PR;EmE31PI;IAEI,gCAAA;EnE41PR;EmE91PI;IAEI,+BAAA;EnE+1PR;EmEj2PI;IAEI,oCAAA;EnEk2PR;EmEp2PI;IAEI,kCAAA;EnEq2PR;EmEv2PI;IAEI,gCAAA;EnEw2PR;EmE12PI;IAEI,uCAAA;EnE22PR;EmE72PI;IAEI,sCAAA;EnE82PR;EmEh3PI;IAEI,iCAAA;EnEi3PR;EmEn3PI;IAEI,2BAAA;EnEo3PR;EmEt3PI;IAEI,iCAAA;EnEu3PR;EmEz3PI;IAEI,+BAAA;EnE03PR;EmE53PI;IAEI,6BAAA;EnE63PR;EmE/3PI;IAEI,+BAAA;EnEg4PR;EmEl4PI;IAEI,8BAAA;EnEm4PR;EmEr4PI;IAEI,oBAAA;EnEs4PR;EmEx4PI;IAEI,mBAAA;EnEy4PR;EmE34PI;IAEI,mBAAA;EnE44PR;EmE94PI;IAEI,mBAAA;EnE+4PR;EmEj5PI;IAEI,mBAAA;EnEk5PR;EmEp5PI;IAEI,mBAAA;EnEq5PR;EmEv5PI;IAEI,mBAAA;EnEw5PR;EmE15PI;IAEI,mBAAA;EnE25PR;EmE75PI;IAEI,oBAAA;EnE85PR;EmEh6PI;IAEI,0BAAA;EnEi6PR;EmEn6PI;IAEI,yBAAA;EnEo6PR;EmEt6PI;IAEI,uBAAA;EnEu6PR;EmEz6PI;IAEI,yBAAA;EnE06PR;EmE56PI;IAEI,uBAAA;EnE66PR;EmE/6PI;IAEI,uBAAA;EnEg7PR;EmEl7PI;IAEI,0BAAA;IAAA,yBAAA;EnEo7PR;EmEt7PI;IAEI,gCAAA;IAAA,+BAAA;EnEw7PR;EmE17PI;IAEI,+BAAA;IAAA,8BAAA;EnE47PR;EmE97PI;IAEI,6BAAA;IAAA,4BAAA;EnEg8PR;EmEl8PI;IAEI,+BAAA;IAAA,8BAAA;EnEo8PR;EmEt8PI;IAEI,6BAAA;IAAA,4BAAA;EnEw8PR;EmE18PI;IAEI,6BAAA;IAAA,4BAAA;EnE48PR;EmE98PI;IAEI,wBAAA;IAAA,2BAAA;EnEg9PR;EmEl9PI;IAEI,8BAAA;IAAA,iCAAA;EnEo9PR;EmEt9PI;IAEI,6BAAA;IAAA,gCAAA;EnEw9PR;EmE19PI;IAEI,2BAAA;IAAA,8BAAA;EnE49PR;EmE99PI;IAEI,6BAAA;IAAA,gCAAA;EnEg+PR;EmEl+PI;IAEI,2BAAA;IAAA,8BAAA;EnEo+PR;EmEt+PI;IAEI,2BAAA;IAAA,8BAAA;EnEw+PR;EmE1+PI;IAEI,wBAAA;EnE2+PR;EmE7+PI;IAEI,8BAAA;EnE8+PR;EmEh/PI;IAEI,6BAAA;EnEi/PR;EmEn/PI;IAEI,2BAAA;EnEo/PR;EmEt/PI;IAEI,6BAAA;EnEu/PR;EmEz/PI;IAEI,2BAAA;EnE0/PR;EmE5/PI;IAEI,2BAAA;EnE6/PR;EmE//PI;IAEI,0BAAA;EnEggQR;EmElgQI;IAEI,gCAAA;EnEmgQR;EmErgQI;IAEI,+BAAA;EnEsgQR;EmExgQI;IAEI,6BAAA;EnEygQR;EmE3gQI;IAEI,+BAAA;EnE4gQR;EmE9gQI;IAEI,6BAAA;EnE+gQR;EmEjhQI;IAEI,6BAAA;EnEkhQR;EmEphQI;IAEI,2BAAA;EnEqhQR;EmEvhQI;IAEI,iCAAA;EnEwhQR;EmE1hQI;IAEI,gCAAA;EnE2hQR;EmE7hQI;IAEI,8BAAA;EnE8hQR;EmEhiQI;IAEI,gCAAA;EnEiiQR;EmEniQI;IAEI,8BAAA;EnEoiQR;EmEtiQI;IAEI,8BAAA;EnEuiQR;EmEziQI;IAEI,yBAAA;EnE0iQR;EmE5iQI;IAEI,+BAAA;EnE6iQR;EmE/iQI;IAEI,8BAAA;EnEgjQR;EmEljQI;IAEI,4BAAA;EnEmjQR;EmErjQI;IAEI,8BAAA;EnEsjQR;EmExjQI;IAEI,4BAAA;EnEyjQR;EmE3jQI;IAEI,4BAAA;EnE4jQR;EmE9jQI;IAEI,qBAAA;EnE+jQR;EmEjkQI;IAEI,2BAAA;EnEkkQR;EmEpkQI;IAEI,0BAAA;EnEqkQR;EmEvkQI;IAEI,wBAAA;EnEwkQR;EmE1kQI;IAEI,0BAAA;EnE2kQR;EmE7kQI;IAEI,wBAAA;EnE8kQR;EmEhlQI;IAEI,2BAAA;IAAA,0BAAA;EnEklQR;EmEplQI;IAEI,iCAAA;IAAA,gCAAA;EnEslQR;EmExlQI;IAEI,gCAAA;IAAA,+BAAA;EnE0lQR;EmE5lQI;IAEI,8BAAA;IAAA,6BAAA;EnE8lQR;EmEhmQI;IAEI,gCAAA;IAAA,+BAAA;EnEkmQR;EmEpmQI;IAEI,8BAAA;IAAA,6BAAA;EnEsmQR;EmExmQI;IAEI,yBAAA;IAAA,4BAAA;EnE0mQR;EmE5mQI;IAEI,+BAAA;IAAA,kCAAA;EnE8mQR;EmEhnQI;IAEI,8BAAA;IAAA,iCAAA;EnEknQR;EmEpnQI;IAEI,4BAAA;IAAA,+BAAA;EnEsnQR;EmExnQI;IAEI,8BAAA;IAAA,iCAAA;EnE0nQR;EmE5nQI;IAEI,4BAAA;IAAA,+BAAA;EnE8nQR;EmEhoQI;IAEI,yBAAA;EnEioQR;EmEnoQI;IAEI,+BAAA;EnEooQR;EmEtoQI;IAEI,8BAAA;EnEuoQR;EmEzoQI;IAEI,4BAAA;EnE0oQR;EmE5oQI;IAEI,8BAAA;EnE6oQR;EmE/oQI;IAEI,4BAAA;EnEgpQR;EmElpQI;IAEI,2BAAA;EnEmpQR;EmErpQI;IAEI,iCAAA;EnEspQR;EmExpQI;IAEI,gCAAA;EnEypQR;EmE3pQI;IAEI,8BAAA;EnE4pQR;EmE9pQI;IAEI,gCAAA;EnE+pQR;EmEjqQI;IAEI,8BAAA;EnEkqQR;EmEpqQI;IAEI,4BAAA;EnEqqQR;EmEvqQI;IAEI,kCAAA;EnEwqQR;EmE1qQI;IAEI,iCAAA;EnE2qQR;EmE7qQI;IAEI,+BAAA;EnE8qQR;EmEhrQI;IAEI,iCAAA;EnEirQR;EmEnrQI;IAEI,+BAAA;EnEorQR;EmEtrQI;IAEI,0BAAA;EnEurQR;EmEzrQI;IAEI,gCAAA;EnE0rQR;EmE5rQI;IAEI,+BAAA;EnE6rQR;EmE/rQI;IAEI,6BAAA;EnEgsQR;EmElsQI;IAEI,+BAAA;EnEmsQR;EmErsQI;IAEI,6BAAA;EnEssQR;EmExsQI;IAEI,2BAAA;EnEysQR;EmE3sQI;IAEI,4BAAA;EnE4sQR;EmE9sQI;IAEI,6BAAA;EnE+sQR;AACF;AapsQI;EsDdE;IAEI,sBAAA;EnEotQR;EmEttQI;IAEI,uBAAA;EnEutQR;EmEztQI;IAEI,sBAAA;EnE0tQR;EmE5tQI;IAEI,0BAAA;EnE6tQR;EmE/tQI;IAEI,gCAAA;EnEguQR;EmEluQI;IAEI,yBAAA;EnEmuQR;EmEruQI;IAEI,wBAAA;EnEsuQR;EmExuQI;IAEI,yBAAA;EnEyuQR;EmE3uQI;IAEI,6BAAA;EnE4uQR;EmE9uQI;IAEI,8BAAA;EnE+uQR;EmEjvQI;IAEI,wBAAA;EnEkvQR;EmEpvQI;IAEI,+BAAA;EnEqvQR;EmEvvQI;IAEI,wBAAA;EnEwvQR;EmE1vQI;IAEI,yBAAA;EnE2vQR;EmE7vQI;IAEI,8BAAA;EnE8vQR;EmEhwQI;IAEI,iCAAA;EnEiwQR;EmEnwQI;IAEI,sCAAA;EnEowQR;EmEtwQI;IAEI,yCAAA;EnEuwQR;EmEzwQI;IAEI,uBAAA;EnE0wQR;EmE5wQI;IAEI,uBAAA;EnE6wQR;EmE/wQI;IAEI,yBAAA;EnEgxQR;EmElxQI;IAEI,yBAAA;EnEmxQR;EmErxQI;IAEI,0BAAA;EnEsxQR;EmExxQI;IAEI,4BAAA;EnEyxQR;EmE3xQI;IAEI,kCAAA;EnE4xQR;EmE9xQI;IAEI,iBAAA;EnE+xQR;EmEjyQI;IAEI,uBAAA;EnEkyQR;EmEpyQI;IAEI,sBAAA;EnEqyQR;EmEvyQI;IAEI,oBAAA;EnEwyQR;EmE1yQI;IAEI,sBAAA;EnE2yQR;EmE7yQI;IAEI,oBAAA;EnE8yQR;EmEhzQI;IAEI,sCAAA;EnEizQR;EmEnzQI;IAEI,oCAAA;EnEozQR;EmEtzQI;IAEI,kCAAA;EnEuzQR;EmEzzQI;IAEI,yCAAA;EnE0zQR;EmE5zQI;IAEI,wCAAA;EnE6zQR;EmE/zQI;IAEI,wCAAA;EnEg0QR;EmEl0QI;IAEI,kCAAA;EnEm0QR;EmEr0QI;IAEI,gCAAA;EnEs0QR;EmEx0QI;IAEI,8BAAA;EnEy0QR;EmE30QI;IAEI,gCAAA;EnE40QR;EmE90QI;IAEI,+BAAA;EnE+0QR;EmEj1QI;IAEI,oCAAA;EnEk1QR;EmEp1QI;IAEI,kCAAA;EnEq1QR;EmEv1QI;IAEI,gCAAA;EnEw1QR;EmE11QI;IAEI,uCAAA;EnE21QR;EmE71QI;IAEI,sCAAA;EnE81QR;EmEh2QI;IAEI,iCAAA;EnEi2QR;EmEn2QI;IAEI,2BAAA;EnEo2QR;EmEt2QI;IAEI,iCAAA;EnEu2QR;EmEz2QI;IAEI,+BAAA;EnE02QR;EmE52QI;IAEI,6BAAA;EnE62QR;EmE/2QI;IAEI,+BAAA;EnEg3QR;EmEl3QI;IAEI,8BAAA;EnEm3QR;EmEr3QI;IAEI,oBAAA;EnEs3QR;EmEx3QI;IAEI,mBAAA;EnEy3QR;EmE33QI;IAEI,mBAAA;EnE43QR;EmE93QI;IAEI,mBAAA;EnE+3QR;EmEj4QI;IAEI,mBAAA;EnEk4QR;EmEp4QI;IAEI,mBAAA;EnEq4QR;EmEv4QI;IAEI,mBAAA;EnEw4QR;EmE14QI;IAEI,mBAAA;EnE24QR;EmE74QI;IAEI,oBAAA;EnE84QR;EmEh5QI;IAEI,0BAAA;EnEi5QR;EmEn5QI;IAEI,yBAAA;EnEo5QR;EmEt5QI;IAEI,uBAAA;EnEu5QR;EmEz5QI;IAEI,yBAAA;EnE05QR;EmE55QI;IAEI,uBAAA;EnE65QR;EmE/5QI;IAEI,uBAAA;EnEg6QR;EmEl6QI;IAEI,0BAAA;IAAA,yBAAA;EnEo6QR;EmEt6QI;IAEI,gCAAA;IAAA,+BAAA;EnEw6QR;EmE16QI;IAEI,+BAAA;IAAA,8BAAA;EnE46QR;EmE96QI;IAEI,6BAAA;IAAA,4BAAA;EnEg7QR;EmEl7QI;IAEI,+BAAA;IAAA,8BAAA;EnEo7QR;EmEt7QI;IAEI,6BAAA;IAAA,4BAAA;EnEw7QR;EmE17QI;IAEI,6BAAA;IAAA,4BAAA;EnE47QR;EmE97QI;IAEI,wBAAA;IAAA,2BAAA;EnEg8QR;EmEl8QI;IAEI,8BAAA;IAAA,iCAAA;EnEo8QR;EmEt8QI;IAEI,6BAAA;IAAA,gCAAA;EnEw8QR;EmE18QI;IAEI,2BAAA;IAAA,8BAAA;EnE48QR;EmE98QI;IAEI,6BAAA;IAAA,gCAAA;EnEg9QR;EmEl9QI;IAEI,2BAAA;IAAA,8BAAA;EnEo9QR;EmEt9QI;IAEI,2BAAA;IAAA,8BAAA;EnEw9QR;EmE19QI;IAEI,wBAAA;EnE29QR;EmE79QI;IAEI,8BAAA;EnE89QR;EmEh+QI;IAEI,6BAAA;EnEi+QR;EmEn+QI;IAEI,2BAAA;EnEo+QR;EmEt+QI;IAEI,6BAAA;EnEu+QR;EmEz+QI;IAEI,2BAAA;EnE0+QR;EmE5+QI;IAEI,2BAAA;EnE6+QR;EmE/+QI;IAEI,0BAAA;EnEg/QR;EmEl/QI;IAEI,gCAAA;EnEm/QR;EmEr/QI;IAEI,+BAAA;EnEs/QR;EmEx/QI;IAEI,6BAAA;EnEy/QR;EmE3/QI;IAEI,+BAAA;EnE4/QR;EmE9/QI;IAEI,6BAAA;EnE+/QR;EmEjgRI;IAEI,6BAAA;EnEkgRR;EmEpgRI;IAEI,2BAAA;EnEqgRR;EmEvgRI;IAEI,iCAAA;EnEwgRR;EmE1gRI;IAEI,gCAAA;EnE2gRR;EmE7gRI;IAEI,8BAAA;EnE8gRR;EmEhhRI;IAEI,gCAAA;EnEihRR;EmEnhRI;IAEI,8BAAA;EnEohRR;EmEthRI;IAEI,8BAAA;EnEuhRR;EmEzhRI;IAEI,yBAAA;EnE0hRR;EmE5hRI;IAEI,+BAAA;EnE6hRR;EmE/hRI;IAEI,8BAAA;EnEgiRR;EmEliRI;IAEI,4BAAA;EnEmiRR;EmEriRI;IAEI,8BAAA;EnEsiRR;EmExiRI;IAEI,4BAAA;EnEyiRR;EmE3iRI;IAEI,4BAAA;EnE4iRR;EmE9iRI;IAEI,qBAAA;EnE+iRR;EmEjjRI;IAEI,2BAAA;EnEkjRR;EmEpjRI;IAEI,0BAAA;EnEqjRR;EmEvjRI;IAEI,wBAAA;EnEwjRR;EmE1jRI;IAEI,0BAAA;EnE2jRR;EmE7jRI;IAEI,wBAAA;EnE8jRR;EmEhkRI;IAEI,2BAAA;IAAA,0BAAA;EnEkkRR;EmEpkRI;IAEI,iCAAA;IAAA,gCAAA;EnEskRR;EmExkRI;IAEI,gCAAA;IAAA,+BAAA;EnE0kRR;EmE5kRI;IAEI,8BAAA;IAAA,6BAAA;EnE8kRR;EmEhlRI;IAEI,gCAAA;IAAA,+BAAA;EnEklRR;EmEplRI;IAEI,8BAAA;IAAA,6BAAA;EnEslRR;EmExlRI;IAEI,yBAAA;IAAA,4BAAA;EnE0lRR;EmE5lRI;IAEI,+BAAA;IAAA,kCAAA;EnE8lRR;EmEhmRI;IAEI,8BAAA;IAAA,iCAAA;EnEkmRR;EmEpmRI;IAEI,4BAAA;IAAA,+BAAA;EnEsmRR;EmExmRI;IAEI,8BAAA;IAAA,iCAAA;EnE0mRR;EmE5mRI;IAEI,4BAAA;IAAA,+BAAA;EnE8mRR;EmEhnRI;IAEI,yBAAA;EnEinRR;EmEnnRI;IAEI,+BAAA;EnEonRR;EmEtnRI;IAEI,8BAAA;EnEunRR;EmEznRI;IAEI,4BAAA;EnE0nRR;EmE5nRI;IAEI,8BAAA;EnE6nRR;EmE/nRI;IAEI,4BAAA;EnEgoRR;EmEloRI;IAEI,2BAAA;EnEmoRR;EmEroRI;IAEI,iCAAA;EnEsoRR;EmExoRI;IAEI,gCAAA;EnEyoRR;EmE3oRI;IAEI,8BAAA;EnE4oRR;EmE9oRI;IAEI,gCAAA;EnE+oRR;EmEjpRI;IAEI,8BAAA;EnEkpRR;EmEppRI;IAEI,4BAAA;EnEqpRR;EmEvpRI;IAEI,kCAAA;EnEwpRR;EmE1pRI;IAEI,iCAAA;EnE2pRR;EmE7pRI;IAEI,+BAAA;EnE8pRR;EmEhqRI;IAEI,iCAAA;EnEiqRR;EmEnqRI;IAEI,+BAAA;EnEoqRR;EmEtqRI;IAEI,0BAAA;EnEuqRR;EmEzqRI;IAEI,gCAAA;EnE0qRR;EmE5qRI;IAEI,+BAAA;EnE6qRR;EmE/qRI;IAEI,6BAAA;EnEgrRR;EmElrRI;IAEI,+BAAA;EnEmrRR;EmErrRI;IAEI,6BAAA;EnEsrRR;EmExrRI;IAEI,2BAAA;EnEyrRR;EmE3rRI;IAEI,4BAAA;EnE4rRR;EmE9rRI;IAEI,6BAAA;EnE+rRR;AACF;AaprRI;EsDdE;IAEI,sBAAA;EnEosRR;EmEtsRI;IAEI,uBAAA;EnEusRR;EmEzsRI;IAEI,sBAAA;EnE0sRR;EmE5sRI;IAEI,0BAAA;EnE6sRR;EmE/sRI;IAEI,gCAAA;EnEgtRR;EmEltRI;IAEI,yBAAA;EnEmtRR;EmErtRI;IAEI,wBAAA;EnEstRR;EmExtRI;IAEI,yBAAA;EnEytRR;EmE3tRI;IAEI,6BAAA;EnE4tRR;EmE9tRI;IAEI,8BAAA;EnE+tRR;EmEjuRI;IAEI,wBAAA;EnEkuRR;EmEpuRI;IAEI,+BAAA;EnEquRR;EmEvuRI;IAEI,wBAAA;EnEwuRR;EmE1uRI;IAEI,yBAAA;EnE2uRR;EmE7uRI;IAEI,8BAAA;EnE8uRR;EmEhvRI;IAEI,iCAAA;EnEivRR;EmEnvRI;IAEI,sCAAA;EnEovRR;EmEtvRI;IAEI,yCAAA;EnEuvRR;EmEzvRI;IAEI,uBAAA;EnE0vRR;EmE5vRI;IAEI,uBAAA;EnE6vRR;EmE/vRI;IAEI,yBAAA;EnEgwRR;EmElwRI;IAEI,yBAAA;EnEmwRR;EmErwRI;IAEI,0BAAA;EnEswRR;EmExwRI;IAEI,4BAAA;EnEywRR;EmE3wRI;IAEI,kCAAA;EnE4wRR;EmE9wRI;IAEI,iBAAA;EnE+wRR;EmEjxRI;IAEI,uBAAA;EnEkxRR;EmEpxRI;IAEI,sBAAA;EnEqxRR;EmEvxRI;IAEI,oBAAA;EnEwxRR;EmE1xRI;IAEI,sBAAA;EnE2xRR;EmE7xRI;IAEI,oBAAA;EnE8xRR;EmEhyRI;IAEI,sCAAA;EnEiyRR;EmEnyRI;IAEI,oCAAA;EnEoyRR;EmEtyRI;IAEI,kCAAA;EnEuyRR;EmEzyRI;IAEI,yCAAA;EnE0yRR;EmE5yRI;IAEI,wCAAA;EnE6yRR;EmE/yRI;IAEI,wCAAA;EnEgzRR;EmElzRI;IAEI,kCAAA;EnEmzRR;EmErzRI;IAEI,gCAAA;EnEszRR;EmExzRI;IAEI,8BAAA;EnEyzRR;EmE3zRI;IAEI,gCAAA;EnE4zRR;EmE9zRI;IAEI,+BAAA;EnE+zRR;EmEj0RI;IAEI,oCAAA;EnEk0RR;EmEp0RI;IAEI,kCAAA;EnEq0RR;EmEv0RI;IAEI,gCAAA;EnEw0RR;EmE10RI;IAEI,uCAAA;EnE20RR;EmE70RI;IAEI,sCAAA;EnE80RR;EmEh1RI;IAEI,iCAAA;EnEi1RR;EmEn1RI;IAEI,2BAAA;EnEo1RR;EmEt1RI;IAEI,iCAAA;EnEu1RR;EmEz1RI;IAEI,+BAAA;EnE01RR;EmE51RI;IAEI,6BAAA;EnE61RR;EmE/1RI;IAEI,+BAAA;EnEg2RR;EmEl2RI;IAEI,8BAAA;EnEm2RR;EmEr2RI;IAEI,oBAAA;EnEs2RR;EmEx2RI;IAEI,mBAAA;EnEy2RR;EmE32RI;IAEI,mBAAA;EnE42RR;EmE92RI;IAEI,mBAAA;EnE+2RR;EmEj3RI;IAEI,mBAAA;EnEk3RR;EmEp3RI;IAEI,mBAAA;EnEq3RR;EmEv3RI;IAEI,mBAAA;EnEw3RR;EmE13RI;IAEI,mBAAA;EnE23RR;EmE73RI;IAEI,oBAAA;EnE83RR;EmEh4RI;IAEI,0BAAA;EnEi4RR;EmEn4RI;IAEI,yBAAA;EnEo4RR;EmEt4RI;IAEI,uBAAA;EnEu4RR;EmEz4RI;IAEI,yBAAA;EnE04RR;EmE54RI;IAEI,uBAAA;EnE64RR;EmE/4RI;IAEI,uBAAA;EnEg5RR;EmEl5RI;IAEI,0BAAA;IAAA,yBAAA;EnEo5RR;EmEt5RI;IAEI,gCAAA;IAAA,+BAAA;EnEw5RR;EmE15RI;IAEI,+BAAA;IAAA,8BAAA;EnE45RR;EmE95RI;IAEI,6BAAA;IAAA,4BAAA;EnEg6RR;EmEl6RI;IAEI,+BAAA;IAAA,8BAAA;EnEo6RR;EmEt6RI;IAEI,6BAAA;IAAA,4BAAA;EnEw6RR;EmE16RI;IAEI,6BAAA;IAAA,4BAAA;EnE46RR;EmE96RI;IAEI,wBAAA;IAAA,2BAAA;EnEg7RR;EmEl7RI;IAEI,8BAAA;IAAA,iCAAA;EnEo7RR;EmEt7RI;IAEI,6BAAA;IAAA,gCAAA;EnEw7RR;EmE17RI;IAEI,2BAAA;IAAA,8BAAA;EnE47RR;EmE97RI;IAEI,6BAAA;IAAA,gCAAA;EnEg8RR;EmEl8RI;IAEI,2BAAA;IAAA,8BAAA;EnEo8RR;EmEt8RI;IAEI,2BAAA;IAAA,8BAAA;EnEw8RR;EmE18RI;IAEI,wBAAA;EnE28RR;EmE78RI;IAEI,8BAAA;EnE88RR;EmEh9RI;IAEI,6BAAA;EnEi9RR;EmEn9RI;IAEI,2BAAA;EnEo9RR;EmEt9RI;IAEI,6BAAA;EnEu9RR;EmEz9RI;IAEI,2BAAA;EnE09RR;EmE59RI;IAEI,2BAAA;EnE69RR;EmE/9RI;IAEI,0BAAA;EnEg+RR;EmEl+RI;IAEI,gCAAA;EnEm+RR;EmEr+RI;IAEI,+BAAA;EnEs+RR;EmEx+RI;IAEI,6BAAA;EnEy+RR;EmE3+RI;IAEI,+BAAA;EnE4+RR;EmE9+RI;IAEI,6BAAA;EnE++RR;EmEj/RI;IAEI,6BAAA;EnEk/RR;EmEp/RI;IAEI,2BAAA;EnEq/RR;EmEv/RI;IAEI,iCAAA;EnEw/RR;EmE1/RI;IAEI,gCAAA;EnE2/RR;EmE7/RI;IAEI,8BAAA;EnE8/RR;EmEhgSI;IAEI,gCAAA;EnEigSR;EmEngSI;IAEI,8BAAA;EnEogSR;EmEtgSI;IAEI,8BAAA;EnEugSR;EmEzgSI;IAEI,yBAAA;EnE0gSR;EmE5gSI;IAEI,+BAAA;EnE6gSR;EmE/gSI;IAEI,8BAAA;EnEghSR;EmElhSI;IAEI,4BAAA;EnEmhSR;EmErhSI;IAEI,8BAAA;EnEshSR;EmExhSI;IAEI,4BAAA;EnEyhSR;EmE3hSI;IAEI,4BAAA;EnE4hSR;EmE9hSI;IAEI,qBAAA;EnE+hSR;EmEjiSI;IAEI,2BAAA;EnEkiSR;EmEpiSI;IAEI,0BAAA;EnEqiSR;EmEviSI;IAEI,wBAAA;EnEwiSR;EmE1iSI;IAEI,0BAAA;EnE2iSR;EmE7iSI;IAEI,wBAAA;EnE8iSR;EmEhjSI;IAEI,2BAAA;IAAA,0BAAA;EnEkjSR;EmEpjSI;IAEI,iCAAA;IAAA,gCAAA;EnEsjSR;EmExjSI;IAEI,gCAAA;IAAA,+BAAA;EnE0jSR;EmE5jSI;IAEI,8BAAA;IAAA,6BAAA;EnE8jSR;EmEhkSI;IAEI,gCAAA;IAAA,+BAAA;EnEkkSR;EmEpkSI;IAEI,8BAAA;IAAA,6BAAA;EnEskSR;EmExkSI;IAEI,yBAAA;IAAA,4BAAA;EnE0kSR;EmE5kSI;IAEI,+BAAA;IAAA,kCAAA;EnE8kSR;EmEhlSI;IAEI,8BAAA;IAAA,iCAAA;EnEklSR;EmEplSI;IAEI,4BAAA;IAAA,+BAAA;EnEslSR;EmExlSI;IAEI,8BAAA;IAAA,iCAAA;EnE0lSR;EmE5lSI;IAEI,4BAAA;IAAA,+BAAA;EnE8lSR;EmEhmSI;IAEI,yBAAA;EnEimSR;EmEnmSI;IAEI,+BAAA;EnEomSR;EmEtmSI;IAEI,8BAAA;EnEumSR;EmEzmSI;IAEI,4BAAA;EnE0mSR;EmE5mSI;IAEI,8BAAA;EnE6mSR;EmE/mSI;IAEI,4BAAA;EnEgnSR;EmElnSI;IAEI,2BAAA;EnEmnSR;EmErnSI;IAEI,iCAAA;EnEsnSR;EmExnSI;IAEI,gCAAA;EnEynSR;EmE3nSI;IAEI,8BAAA;EnE4nSR;EmE9nSI;IAEI,gCAAA;EnE+nSR;EmEjoSI;IAEI,8BAAA;EnEkoSR;EmEpoSI;IAEI,4BAAA;EnEqoSR;EmEvoSI;IAEI,kCAAA;EnEwoSR;EmE1oSI;IAEI,iCAAA;EnE2oSR;EmE7oSI;IAEI,+BAAA;EnE8oSR;EmEhpSI;IAEI,iCAAA;EnEipSR;EmEnpSI;IAEI,+BAAA;EnEopSR;EmEtpSI;IAEI,0BAAA;EnEupSR;EmEzpSI;IAEI,gCAAA;EnE0pSR;EmE5pSI;IAEI,+BAAA;EnE6pSR;EmE/pSI;IAEI,6BAAA;EnEgqSR;EmElqSI;IAEI,+BAAA;EnEmqSR;EmErqSI;IAEI,6BAAA;EnEsqSR;EmExqSI;IAEI,2BAAA;EnEyqSR;EmE3qSI;IAEI,4BAAA;EnE4qSR;EmE9qSI;IAEI,6BAAA;EnE+qSR;AACF;AapqSI;EsDdE;IAEI,sBAAA;EnEorSR;EmEtrSI;IAEI,uBAAA;EnEurSR;EmEzrSI;IAEI,sBAAA;EnE0rSR;EmE5rSI;IAEI,0BAAA;EnE6rSR;EmE/rSI;IAEI,gCAAA;EnEgsSR;EmElsSI;IAEI,yBAAA;EnEmsSR;EmErsSI;IAEI,wBAAA;EnEssSR;EmExsSI;IAEI,yBAAA;EnEysSR;EmE3sSI;IAEI,6BAAA;EnE4sSR;EmE9sSI;IAEI,8BAAA;EnE+sSR;EmEjtSI;IAEI,wBAAA;EnEktSR;EmEptSI;IAEI,+BAAA;EnEqtSR;EmEvtSI;IAEI,wBAAA;EnEwtSR;EmE1tSI;IAEI,yBAAA;EnE2tSR;EmE7tSI;IAEI,8BAAA;EnE8tSR;EmEhuSI;IAEI,iCAAA;EnEiuSR;EmEnuSI;IAEI,sCAAA;EnEouSR;EmEtuSI;IAEI,yCAAA;EnEuuSR;EmEzuSI;IAEI,uBAAA;EnE0uSR;EmE5uSI;IAEI,uBAAA;EnE6uSR;EmE/uSI;IAEI,yBAAA;EnEgvSR;EmElvSI;IAEI,yBAAA;EnEmvSR;EmErvSI;IAEI,0BAAA;EnEsvSR;EmExvSI;IAEI,4BAAA;EnEyvSR;EmE3vSI;IAEI,kCAAA;EnE4vSR;EmE9vSI;IAEI,iBAAA;EnE+vSR;EmEjwSI;IAEI,uBAAA;EnEkwSR;EmEpwSI;IAEI,sBAAA;EnEqwSR;EmEvwSI;IAEI,oBAAA;EnEwwSR;EmE1wSI;IAEI,sBAAA;EnE2wSR;EmE7wSI;IAEI,oBAAA;EnE8wSR;EmEhxSI;IAEI,sCAAA;EnEixSR;EmEnxSI;IAEI,oCAAA;EnEoxSR;EmEtxSI;IAEI,kCAAA;EnEuxSR;EmEzxSI;IAEI,yCAAA;EnE0xSR;EmE5xSI;IAEI,wCAAA;EnE6xSR;EmE/xSI;IAEI,wCAAA;EnEgySR;EmElySI;IAEI,kCAAA;EnEmySR;EmErySI;IAEI,gCAAA;EnEsySR;EmExySI;IAEI,8BAAA;EnEyySR;EmE3ySI;IAEI,gCAAA;EnE4ySR;EmE9ySI;IAEI,+BAAA;EnE+ySR;EmEjzSI;IAEI,oCAAA;EnEkzSR;EmEpzSI;IAEI,kCAAA;EnEqzSR;EmEvzSI;IAEI,gCAAA;EnEwzSR;EmE1zSI;IAEI,uCAAA;EnE2zSR;EmE7zSI;IAEI,sCAAA;EnE8zSR;EmEh0SI;IAEI,iCAAA;EnEi0SR;EmEn0SI;IAEI,2BAAA;EnEo0SR;EmEt0SI;IAEI,iCAAA;EnEu0SR;EmEz0SI;IAEI,+BAAA;EnE00SR;EmE50SI;IAEI,6BAAA;EnE60SR;EmE/0SI;IAEI,+BAAA;EnEg1SR;EmEl1SI;IAEI,8BAAA;EnEm1SR;EmEr1SI;IAEI,oBAAA;EnEs1SR;EmEx1SI;IAEI,mBAAA;EnEy1SR;EmE31SI;IAEI,mBAAA;EnE41SR;EmE91SI;IAEI,mBAAA;EnE+1SR;EmEj2SI;IAEI,mBAAA;EnEk2SR;EmEp2SI;IAEI,mBAAA;EnEq2SR;EmEv2SI;IAEI,mBAAA;EnEw2SR;EmE12SI;IAEI,mBAAA;EnE22SR;EmE72SI;IAEI,oBAAA;EnE82SR;EmEh3SI;IAEI,0BAAA;EnEi3SR;EmEn3SI;IAEI,yBAAA;EnEo3SR;EmEt3SI;IAEI,uBAAA;EnEu3SR;EmEz3SI;IAEI,yBAAA;EnE03SR;EmE53SI;IAEI,uBAAA;EnE63SR;EmE/3SI;IAEI,uBAAA;EnEg4SR;EmEl4SI;IAEI,0BAAA;IAAA,yBAAA;EnEo4SR;EmEt4SI;IAEI,gCAAA;IAAA,+BAAA;EnEw4SR;EmE14SI;IAEI,+BAAA;IAAA,8BAAA;EnE44SR;EmE94SI;IAEI,6BAAA;IAAA,4BAAA;EnEg5SR;EmEl5SI;IAEI,+BAAA;IAAA,8BAAA;EnEo5SR;EmEt5SI;IAEI,6BAAA;IAAA,4BAAA;EnEw5SR;EmE15SI;IAEI,6BAAA;IAAA,4BAAA;EnE45SR;EmE95SI;IAEI,wBAAA;IAAA,2BAAA;EnEg6SR;EmEl6SI;IAEI,8BAAA;IAAA,iCAAA;EnEo6SR;EmEt6SI;IAEI,6BAAA;IAAA,gCAAA;EnEw6SR;EmE16SI;IAEI,2BAAA;IAAA,8BAAA;EnE46SR;EmE96SI;IAEI,6BAAA;IAAA,gCAAA;EnEg7SR;EmEl7SI;IAEI,2BAAA;IAAA,8BAAA;EnEo7SR;EmEt7SI;IAEI,2BAAA;IAAA,8BAAA;EnEw7SR;EmE17SI;IAEI,wBAAA;EnE27SR;EmE77SI;IAEI,8BAAA;EnE87SR;EmEh8SI;IAEI,6BAAA;EnEi8SR;EmEn8SI;IAEI,2BAAA;EnEo8SR;EmEt8SI;IAEI,6BAAA;EnEu8SR;EmEz8SI;IAEI,2BAAA;EnE08SR;EmE58SI;IAEI,2BAAA;EnE68SR;EmE/8SI;IAEI,0BAAA;EnEg9SR;EmEl9SI;IAEI,gCAAA;EnEm9SR;EmEr9SI;IAEI,+BAAA;EnEs9SR;EmEx9SI;IAEI,6BAAA;EnEy9SR;EmE39SI;IAEI,+BAAA;EnE49SR;EmE99SI;IAEI,6BAAA;EnE+9SR;EmEj+SI;IAEI,6BAAA;EnEk+SR;EmEp+SI;IAEI,2BAAA;EnEq+SR;EmEv+SI;IAEI,iCAAA;EnEw+SR;EmE1+SI;IAEI,gCAAA;EnE2+SR;EmE7+SI;IAEI,8BAAA;EnE8+SR;EmEh/SI;IAEI,gCAAA;EnEi/SR;EmEn/SI;IAEI,8BAAA;EnEo/SR;EmEt/SI;IAEI,8BAAA;EnEu/SR;EmEz/SI;IAEI,yBAAA;EnE0/SR;EmE5/SI;IAEI,+BAAA;EnE6/SR;EmE//SI;IAEI,8BAAA;EnEggTR;EmElgTI;IAEI,4BAAA;EnEmgTR;EmErgTI;IAEI,8BAAA;EnEsgTR;EmExgTI;IAEI,4BAAA;EnEygTR;EmE3gTI;IAEI,4BAAA;EnE4gTR;EmE9gTI;IAEI,qBAAA;EnE+gTR;EmEjhTI;IAEI,2BAAA;EnEkhTR;EmEphTI;IAEI,0BAAA;EnEqhTR;EmEvhTI;IAEI,wBAAA;EnEwhTR;EmE1hTI;IAEI,0BAAA;EnE2hTR;EmE7hTI;IAEI,wBAAA;EnE8hTR;EmEhiTI;IAEI,2BAAA;IAAA,0BAAA;EnEkiTR;EmEpiTI;IAEI,iCAAA;IAAA,gCAAA;EnEsiTR;EmExiTI;IAEI,gCAAA;IAAA,+BAAA;EnE0iTR;EmE5iTI;IAEI,8BAAA;IAAA,6BAAA;EnE8iTR;EmEhjTI;IAEI,gCAAA;IAAA,+BAAA;EnEkjTR;EmEpjTI;IAEI,8BAAA;IAAA,6BAAA;EnEsjTR;EmExjTI;IAEI,yBAAA;IAAA,4BAAA;EnE0jTR;EmE5jTI;IAEI,+BAAA;IAAA,kCAAA;EnE8jTR;EmEhkTI;IAEI,8BAAA;IAAA,iCAAA;EnEkkTR;EmEpkTI;IAEI,4BAAA;IAAA,+BAAA;EnEskTR;EmExkTI;IAEI,8BAAA;IAAA,iCAAA;EnE0kTR;EmE5kTI;IAEI,4BAAA;IAAA,+BAAA;EnE8kTR;EmEhlTI;IAEI,yBAAA;EnEilTR;EmEnlTI;IAEI,+BAAA;EnEolTR;EmEtlTI;IAEI,8BAAA;EnEulTR;EmEzlTI;IAEI,4BAAA;EnE0lTR;EmE5lTI;IAEI,8BAAA;EnE6lTR;EmE/lTI;IAEI,4BAAA;EnEgmTR;EmElmTI;IAEI,2BAAA;EnEmmTR;EmErmTI;IAEI,iCAAA;EnEsmTR;EmExmTI;IAEI,gCAAA;EnEymTR;EmE3mTI;IAEI,8BAAA;EnE4mTR;EmE9mTI;IAEI,gCAAA;EnE+mTR;EmEjnTI;IAEI,8BAAA;EnEknTR;EmEpnTI;IAEI,4BAAA;EnEqnTR;EmEvnTI;IAEI,kCAAA;EnEwnTR;EmE1nTI;IAEI,iCAAA;EnE2nTR;EmE7nTI;IAEI,+BAAA;EnE8nTR;EmEhoTI;IAEI,iCAAA;EnEioTR;EmEnoTI;IAEI,+BAAA;EnEooTR;EmEtoTI;IAEI,0BAAA;EnEuoTR;EmEzoTI;IAEI,gCAAA;EnE0oTR;EmE5oTI;IAEI,+BAAA;EnE6oTR;EmE/oTI;IAEI,6BAAA;EnEgpTR;EmElpTI;IAEI,+BAAA;EnEmpTR;EmErpTI;IAEI,6BAAA;EnEspTR;EmExpTI;IAEI,2BAAA;EnEypTR;EmE3pTI;IAEI,4BAAA;EnE4pTR;EmE9pTI;IAEI,6BAAA;EnE+pTR;AACF;AoEhsTA;ED8BM;IAEI,4BAAA;EnEoqTR;EmEtqTI;IAEI,6BAAA;EnEuqTR;EmEzqTI;IAEI,6BAAA;EnE0qTR;EmE5qTI;IAEI,6BAAA;EnE6qTR;AACF;AoE3rTA;EDWM;IAEI,0BAAA;EnEkrTR;EmEprTI;IAEI,gCAAA;EnEqrTR;EmEvrTI;IAEI,yBAAA;EnEwrTR;EmE1rTI;IAEI,wBAAA;EnE2rTR;EmE7rTI;IAEI,yBAAA;EnE8rTR;EmEhsTI;IAEI,6BAAA;EnEisTR;EmEnsTI;IAEI,8BAAA;EnEosTR;EmEtsTI;IAEI,wBAAA;EnEusTR;EmEzsTI;IAEI,+BAAA;EnE0sTR;EmE5sTI;IAEI,wBAAA;EnE6sTR;AACF;AqE/vTA;;;EAGE,wBAAA;ArEiwTF;;AqE9vTA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;ArEiwTF;;AsE3wTA;EACE,4BAAA;EACA,UAAA;AtE8wTF;AsE5wTE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;AtE8wTJ;;AsEjwTA;EACE,4BAAA;EACA,UAAA;AtEowTF;AsElwTE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;AtEowTJ;;AsE9vTA;EACE,4BAAA;EACA,UAAA;AtEiwTF;AsE/vTE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;AtEiwTJ;;AuEzyTA;EACE,YCWkB;EDVlB,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;AvE4yTF;AuE1yTE;EACE,kUtEoGiB;ADwsTrB;AuEzyTE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,YCPgB;AxEkzTpB;AuEzyTI;EACE,aAAA;EACA,mBAAA;AvE2yTN;AuExyTI;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;AvE0yTN;AuEryTI;EAEE,mBAAA;AvEsyTN;AuEnyTI;EACE,iBtEoDS;ADivTf;;AuEhyTA;EACE,iBAAA;EACA,YCnCkB;EDoClB,YC1CkB;ED2ClB,aAAA;EACA,mBAAA;EACA,sBAAA;AvEmyTF;AuEjyTE;EACE,YC7CU;ED8CV,WC7CS;ED8CT,oDAAA;AvEmyTJ;;AuE/xTA;;EAEE,aAAA;EACA,iBAAA;EACA,YCpDkB;EDqDlB,mBAAA;AvEkyTF;;AyEl2TE;EACE,eAAA;EACA,WAAA;EACA,MAAA;AzEq2TJ;AyEn2TI;EACE,mBAAA;AzEq2TN;AyEj2TE;EACE,iBAAA;AzEm2TJ;AyE91TM;EACE,kBAAA;AzEg2TR;;A0El3TA;EACE,iBAAA;EACA,aAAA;A1Eq3TF;A0En3TE;EACE,aAAA;EACA,qBAAA;A1Eq3TJ;A0El3TE;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;A1Eo3TJ;A0El3TI;EpECA,mBAAA;EoECE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;A1Eo3TN;A0El3TM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;A1Eo3TR;A0E/2TI;EACE,YAAA;EACA,wBAAA;EpEnBF,mBAAA;ANq4TJ;A0E92TI;EACE,cAAA;A1Eg3TN;A0E72TI;EACE;IACE,UAAA;E1E+2TN;AACF;A0E52TI;EACE,iBAAA;A1E82TN;A0E32TI;EACE,eAAA;A1E62TN;A0E32TM;EACE,YAAA;A1E62TR;A0Ez2TI;EACE,QAAA;EACA,UAAA;EACA,SAAA;A1E22TN;;A2Ex6TI;EACE,c1EeK;E0EdL,6BAAA;EACA,8BAAA;A3E26TN;A2Ez6TM;EACE,gBAAA;A3E26TR;A2Ex6TM;EACE,c1EQG;ADk6TX;A2Ev6TM;EACE,eAAA;A3Ey6TR;;A4E17TA;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA;;;;;;;;;IAAA;A5Eq8TF;A4E17TE;;;EAGE,mB3EFO;AD87TX;;A6Eh9TI;EACE,+BAAA;A7Em9TN;A6Ej9TM;EACE,+BAAA;A7Em9TR;A6Eh9TM;EACE,yBAAA;A7Ek9TR;A6E38TQ;EACE,8BAAA;EACA,oBAAA;A7E68TV;A6E18TQ;EACE,+CAAA;EACA,oBAAA;EACA,UAAA;A7E48TV;A6Ex8TU;EACE,+BAAA;A7E08TZ;A6Ev8TU;EACE,gDAAA;A7Ey8TZ;A6Er8TQ;EACE,yBAAA;A7Eu8TV;A6Ej8TQ;;;EAGE,+BAAA;A7Em8TV;A6E/7TU;EACE,2FAAA;A7Ei8TZ;A6Ez7TQ;EACE,8BAAA;A7E27TV;A6Ev7TU;EAKE,0CAAA;A7Eq7TZ;A6E/6TQ;EACE,oCAAA;A7Ei7TV;A6E/6TU;EACE,+BAAA;A7Ei7TZ;A6E96TU;EACE,oCAAA;A7Eg7TZ;A6Ez6TM;EACE,oCAAA;A7E26TR;A6Er6TM;;;;;;;;EAIE,qDAAA;A7E26TR;A6Ev6TI;EACE,sCAAA;A7Ey6TN;A6Et6TI;;;EAGE,oCAAA;A7Ew6TN;A6Ep6TM;EACE,oDAAA;A7Es6TR;A6Ej6TM;;;EAGE,oCAAA;A7Em6TR;;A8EhiUI;EACE,yBAAA;A9EmiUN;A8EjiUM;EACE,yBAAA;A9EmiUR;A8EhiUM;EACE,mBAAA;A9EkiUR;A8E3hUQ;EACE,wBAAA;EACA,oBAAA;A9E6hUV;A8E1hUQ;EACE,yCAAA;EACA,oBAAA;EACA,UAAA;A9E4hUV;A8ExhUU;EACE,yBAAA;A9E0hUZ;A8EvhUU;EACE,0CAAA;A9EyhUZ;A8ErhUQ;EACE,yBAAA;A9EuhUV;A8EjhUQ;;;EAGE,yBAAA;A9EmhUV;A8E5gUQ;EACE,8BAAA;A9E8gUV;A8EzgUQ;EACE,8BAAA;A9E2gUV;A8EzgUU;EACE,yBAAA;A9E2gUZ;A8ExgUU;EACE,8BAAA;A9E0gUZ;A8EngUM;EACE,8BAAA;A9EqgUR;A8E//TM;;;;;;;;EAIE,+CAAA;A9EqgUR;A8EjgUI;EACE,gCAAA;A9EmgUN;A8EhgUI;;;EAGE,8BAAA;A9EkgUN;A8E9/TM;EACE,oDAAA;A9EggUR;;A+ErmUA;EACE,YPGkB;EOFlB,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBPDkB;EOElB,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBPCkB;EOAlB,oBAAA;A/EwmUF;A+EtmUE;EACE,0BAAA;A/EwmUJ;A+ErmUE;EACE,WAAA;EACA,WAAA;A/EumUJ;A+EpmUE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;A/EsmUJ;A+EnmUE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;A/EqmUJ;A+ElmUE;EACE,0CAAA;A/EomUJ;;A+EhmUA;EACE,yBAAA;EACA,iB9E2Ca;E8E1Cb,iBAAA;EACA,iBAAA;EACA,c9ERM;E8ESN,mBAAA;EACA,kBAAA;A/EmmUF;;A+EhmUA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;A/EmmUF;;AgFrqUA;EACE,kBAAA;AhFwqUF;AgFtqUE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AhFwqUJ;AgFrqUE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;AhFuqUJ;AgFrqUE;EACE,gBAAA;AhFuqUJ;AgFrqUI;EACE,UAAA;EACA,yBAAA;AhFuqUN;AgFpqUI;EACE,6EAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;E1EhBF,sBAAA;E0EkBE,c/EbK;E+EcL,mBAAA;AhFsqUN;AgFpqUM;EACE,mB/EmEiB;E+ElEjB,qBAAA;AhFsqUR;AgFnqUQ;EACE,YAAA;AhFqqUV;AgFlqUQ;EACE,UAAA;AhFoqUV;AgFhqUM;EACE,c/ETA;E+EUA,mB/EoDiB;AD8mUzB;AgF/pUM;EAEE,iBAAA;AhFgqUR;AgF5pUI;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AhF8pUN;AgF3pUI;EACE,2BAAA;EACA,UAAA;EACA,QAAA;AhF6pUN;AgF3pUM;EACE,0BAAA;AhF6pUR;AgFzpUI;EACE,yBAAA;AhF2pUN;AgFzpUM;EACE,uBAAA;AhF2pUR;AgFzpUQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,mB/EOe;E+ENf,kBAAA;EACA,UAAA;EACA,MAAA;E1ErFN,mBAAA;ANivUJ;AgFxpUQ;EACE,aAAA;EACA,kBAAA;EACA,c/EzFC;E+E0FD,eAAA;AhF0pUV;AgFxpUU;EACE,c/ErEJ;AD+tUR;AgFvpUU;EACE,aAAA;AhFypUZ;AgFtpUU;EACE,c/E7EJ;E+E8EI,mB/EhBa;ADwqUzB;AgFnpUM;EACE,SAAA;EACA,gBAAA;AhFqpUR;AgFlpUM;EACE,iBAAA;AhFopUR;;AiFxxUE;EACE,0BAAA;AjF2xUJ;AiFzxUI;EACE,+BAAA;AjF2xUN;AiFzxUM;EACE,+CAAA;AjF2xUR;AiFrxUQ;EACE,+BAAA;AjFuxUV;AiFrxUU;EACE,yBAAA;EACA,oCAAA;AjFuxUZ;AiFpxUU;EACE,oCAAA;AjFsxUZ;AiFhxUY;EACE,+BAAA;AjFkxUd;AiFhxUc;EACE,oCAAA;EACA,+BAAA;AjFkxUhB;AiF/wUc;EACE,yBAAA;AjFixUhB;AiF5wUY;EACE,oCAAA;AjF8wUd;AiFzwUQ;;EAEE,YAAA;AjF2wUV;AiFtwUI;EACE,oCAAA;AjFwwUN;AiFpwUM;EACE,oCAAA;AjFswUR;AiFjwUM;EACE,oDAAA;AjFmwUR;AiFhwUM;;;EAGE,0CAAA;AjFkwUR;;AkF30UE;EACE,0BAAA;AlF80UJ;AkF50UI;EACE,yBAAA;AlF80UN;AkF50UM;EACE,yCAAA;AlF80UR;AkFx0UQ;EACE,yBAAA;AlF00UV;AkFx0UU;EACE,mBAAA;EACA,8BAAA;AlF00UZ;AkFv0UU;EACE,8BAAA;AlFy0UZ;AkFn0UY;EACE,yBAAA;AlFq0Ud;AkFn0Uc;EACE,8BAAA;AlFq0UhB;AkFj0UY;EACE,8BAAA;AlFm0Ud;AkF/zUU;;EAEE,YAAA;AlFi0UZ;AkF3zUI;EACE,8BAAA;AlF6zUN;AkFzzUM;EACE,8BAAA;AlF2zUR;AkFrzUM;;;EAGE,oCAAA;AlFuzUR;;AmFv3UE;EACE,eAAA;EACA,aAAA;AnF03UJ;AmFr3UI;EACE,UAAA;EACA,mBXJc;AxE23UpB;AmFh3UM;EACE,aAAA;AnFk3UR;AmF32UM;EACE,aAAA;AnF62UR;AmFz2UI;EAEE,kBX1Bc;AxEo4UpB;AmFx2UM;EACE,aAAA;AnF02UR;AmF91UM;EACE,iBXzCsB;AxEy4U9B;AmF31UQ;EACE,WX/CoB;EWgDpB,UAAA;AnF61UV;AmF31UU;EACE,aAAA;AnF61UZ;AmF11UU;EACE,kBAAA;AnF41UZ;;AoFv5UE;EACE,yBAAA;EACA,WZE0B;EYD1B,eZC0B;EYA1B,cAAA;EACA,WAAA;ApF05UJ;AoFt5UM;EACE,mBAAA;ApFw5UR;AoFt5UQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBnFoFe;EmFnFf,gBAAA;ApFw5UV;AoFp5UM;EACE,mBAAA;EACA,UAAA;ApFs5UR;AoFn5UM;EACE,cAAA;EACA,SAAA;EACA,kBAAA;ApFq5UR;AoFl5UM;EACE,kBAAA;ApFo5UR;AoFh5UQ;EACE,UAAA;ApFk5UV;AoFh5UU;EACE,SAAA;ApFk5UZ;AoF54UI;EACE,0BAAA;EACA,uBAAA;ApF84UN;AoF14UQ;EACE,cAAA;EAAA,oBAAA;ApF44UV;AoF34UU;EACE,aAAA;ApF64UZ;AoFz4UQ;EACE,cAAA;EAAA,oBAAA;EACA,wBAAA;ApF24UV;AoFx4UQ;EACE,cAAA;EAAA,oBAAA;EACA,SAAA;EACA,cAAA;ApF04UV;AoFv4UQ;EACE,mBAAA;ApFy4UV;AoFr4UU;EACE,uBAAA;ApFu4UZ;AoFr4UY;EACE,aAAA;ApFu4Ud;AoFl4UY;EACE,iBAAA;ApFo4Ud;AoFx3UM;EACE,gBAAA;EACA,YAAA;EACA,4BAAA;EAAA,4BAAA;ApF03UR;AoFt3UQ;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;ApFw3UV;AoFh3UM;EACE,WZpHsB;AxEs+U9B;AoFh3UQ;EACE,aAAA;ApFk3UV;AoF/2UQ;EACE,kBAAA;ApFi3UV;AoFz2UI;EACE,kBZpIwB;AxE++U9B;AoFr2UM;EACE,kBAAA;ApFu2UR;AoF/1UM;;EACE,WAAA;EACA,aAAA;ApFk2UR;AoFh2UQ;;EACE,aAAA;ApFm2UV;AoF71UM;EACE,aAAA;EACA,WZhKsB;EYiKtB,4BAAA;ApF+1UR;AoF71UQ;EACE,yBAAA;EACA,cAAA;EACA,WAAA;ApF+1UV;AoF51UQ;EACE,aAAA;ApF81UV;AoFz1UQ;EACE,YZjLU;AxE4gVpB;AoFz1UU;EACE,WZhLC;EYiLD,SAAA;ApF21UZ;AoFp1UI;EACE,yBAAA;ApFs1UN;AoFj1UI;EACE,yBAAA;ApFm1UN;;AqF1hVA;EACE,UAAA;EACA,kBAAA;EACA,aAAA;ArF6hVF;AqF3hVE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;ArF6hVJ;AqF1hVE;EACE,wBAAA;EACA,SAAA;ArF4hVJ;AqFzhVM;EACE,kBjFkUsB;AJytU9B;AqFvhVQ;EACE,mBAAA;ArFyhVV;;AqF7gVM;EACE,gBAAA;ArFghVR;AqF7gVM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;ArF+gVR;AqF7gVQ;EACE,iBAAA;ArF+gVV;AqF5gVQ;EACE,kBjFg2B0B;AJ8qTpC;AqF3gVQ;EACE,WpF3CF;ADwjVR;AqF1gVQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;ArF4gVV;AqF1gVU;EACE,YAAA;EACA,aAAA;E/ElDR,sBAAA;E+EoDQ,iIAAA;ArF4gVZ;;AsFvkVE;EACE,mBATe;AtFmlVnB;AsFvkVE;EACE,mBAZa;AtFqlVjB;AsFlkVE;;EAEE,mBApBY;AtFwlVhB;AsFhkVI;EACE,oCAAA;AtFkkVN;;AuFplVE;EACE,mBAVe;AvFimVnB;AuFplVE;EACE,mBAba;EAcb,+BAAA;AvFslVJ;AuFnlVE;EACE,+BAAA;AvFqlVJ;AuFllVE;;EAEE,mBAtBY;AvF0mVhB;AuFjlVE;EACE,6BAAA;AvFmlVJ;AuF/kVI;EACE,0CAAA;AvFilVN;AuF5kVI;EACE,+BApCe;AvFknVrB;AuF1kVE;EACE,iBAAA;AvF4kVJ;AuFzkVE;EACE,0CAAA;AvF2kVJ;AuFvkVM;EACE,oBAAA;EACA,iBtFkCO;EsFjCP,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AvFykVR;AuFvkVQ;EACE,kBAAA;EACA,WAAA;EACA,mBtFtBF;EK3BJ,mBAAA;EiFmDM,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AvFykVV;AuFnkVE;EACE,yBAAA;AvFqkVJ;;AqF7jVA;EACE;IACE,kBAAA;IACA,QAAA;IACA,SAAA,EAAA,oCAAA;IACA,2BAAA,EAAA,0CAAA;ErFgkVF;AACF;AqF7jVA;EACE,oBAAA;ArF+jVF;;AqF7jVA;EACE,qBAAA;ArFgkVF;;AqF7jVA;;EAEE,uBAAA;ArFgkVF;;AwFtqVA;EACE,YhBSkB;AxEgqVpB;AwFvqVE;EACE,2BAAA;EACA,YhBKgB;EgBJhB,oBAAA;EAEA,aAAA;EACA,qBAAA;EACA,mBAAA;AxFwqVJ;AwFtqVI;EACE,aAAA;EACA,mBAAA;AxFwqVN;AwFrqVI;EACE,iBAAA;EACA,aAAA;AxFuqVN;;AwFhqVA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AxFmqVF;AwFjqVE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mBvFrBO;ADwrVX;;AwF/pVA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;AxFkqVF;AwFhqVE;EACE,UAAA;AxFkqVJ;AwFhqVI;EACE,SAAA;EACA,kBAAA;AxFkqVN;AwF9pVE;EACE,iBAAA;AxFgqVJ;AwF7pVE;EACE,qBAAA;EACA,UAAA;AxF+pVJ;;AyF7tVE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AzFguVJ;AyF9tVI;EACE,kBjBHc;EiBId,0VAAA;AzFguVN;AyFxtVE;EACE,oBjBPgB;AxEiuVpB;AyFrtVM;EACE,4BAAA;AzFutVR;;A0F9uVA;EACE,etFoV4B;EsFnV5B,8BAAA;EACA,kBAAA;A1FivVF;A0F/uVE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A1FivVJ;A0F9uVE;;EAEE,SAAA;EACA,UAAA;A1FgvVJ;A0F7uVE;EACE,iBtFua0B;EsFta1B,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;A1F+uVJ;A0F5uVE;EACE,gBAAA;EACA,kBzF0Da;EyFzDb,YAAA;A1F8uVJ;A0F5uVI;EACE,UAAA;EACA,eAAA;EACA,uBAAA;A1F8uVN;A0F1uVE;EACE,iBAAA;A1F4uVJ;A0F1uVI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;A1F4uVN;A0FxuVE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBzF7CI;EyF8CJ,kUzFkDiB;EK7FjB,sBAAA;EoF6CA,WAAA;EACA,YAAA;A1F0uVJ;A0FxuVI;EACE,YAAA;A1F0uVN;A0FvuVI;EACE,kBAAA;A1FyuVN;A0FruVE;EACE,4BAAA;A1FuuVJ;A0FpuVE;EAEE,8BAAA;EACA,gCAAA;A1FquVJ;A0FluVE;EACE;IAEE,4BAAA;IACA,gCAAA;E1FmuVJ;AACF;A0F/tVE;EACE,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A1FiuVJ;A0F9tVE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;A1FguVJ;A0F9tVI;EACE,mBAAA;EACA,cAAA;A1FguVN;;A0F1tVE;EpFlGE,mBAAA;ANg0VJ;;A0FztVA;EACE,8BAAA;A1F4tVF;;A0F1tVA;EACE;IACE,4BAAA;E1F6tVF;AACF;A0FvtVE;EACE,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;A1FytVJ;;A2F91VA;EACE,kBAAA;EACA,6BAAA;A3Fi2VF;A2F/1VE;EACE,YAPkB;EAQlB,WARkB;EASlB,gBAAA;EACA,kBAAA;EACA,gCAAA;A3Fi2VJ;A2F/1VI;EACE,WAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,wDAAA;EACA,sBAAA;EACA,kB1F4DW;ADqyVjB;A2F91VI;EACE,WA/BgB;EAgChB,YAhCgB;EAiChB,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,+BAAA;ErF1BF,mBAAA;AN23VJ;A2F91VM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yDAAA;A3Fg2VR;A2F91VQ;EAEE,kBAAA;EACA,WAAA;A3F+1VV;A2F51VQ;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mB1FvBF;ADq3VR;A2F31VQ;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,mBAAA;EACA,yBAAA;A3F61VV;A2Fv1VE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EAEA,4DAAA;EACA,sBAAA;A3Fw1VJ;A2Ft1VI;EAEE,kBAAA;EACA,mB1FvDE;E0FwDF,kBAAA;A3Fu1VN;A2Fp1VI;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;A3Fs1VN;A2Fn1VI;EACE,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;A3Fq1VN;A2Fj1VE;EACE,YAAA;A3Fm1VJ;A2Fj1VI;EACE,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,wDAAA;A3Fm1VN;A2Fj1VM;EACE,UAAA;EACA,6BAAA;A3Fm1VR;A2Fh1VM;EACE,WAnIc;EAoId,YApIc;EAqId,SAAA;EACA,mBAAA;A3Fk1VR;A2Fh1VQ;EACE,yBAAA;A3Fk1VV;A2F70VI;EACE,WAAA;EACA,uBAAA;EAEA,wDAAA;EACA,sBAAA;A3F80VN;A2F50VM;EACE,qBAAA;A3F80VR;A2F10VI;EACE,UAAA;A3F40VN;;A4Fv+VA;;EAEE,wBAAA;EACA,SAAA;A5F0+VF;;A4Fv+VA;EACE,0BAAA;A5F0+VF;;A6Fh/VE;EACE,8BAAA;A7Fm/VJ;A6F/+VI;EACE,8BAAA;A7Fi/VN;A6F9+VI;EACE,8BAAA;A7Fg/VN;;A6F1+VE;EACE,yBAAA;A7F6+VJ;A6F1+VE;EACE,yBAAA;A7F4+VJ;A6Fz+VE;ECxBA,eDyBgB;ECxBhB,iBDwBsB;ECvBtB,gBAH2C;EAI3C,cAJwD;A9FwgW1D;A6F3+VE;EACE,yBAAA;A7F6+VJ;A6Fz+VI;EACE,yBAAA;A7F2+VN;A6Fx+VI;EACE,yBAAA;A7F0+VN;;A6Fp+VE;EACE,2BAAA;A7Fu+VJ;A6Fp+VE;EACE,2BAAA;A7Fs+VJ;A6Fn+VE;EACE,2BAAA;A7Fq+VJ;A6Fl+VE;EACE,2BAAA;A7Fo+VJ;;A6Fh+VA;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EClEA,eDmEc;EClEd,iBDkEoB;ECjEpB,gBDiE0B;EChE1B,cAJwD;EDqExD,SAAA;A7Fs+VF;A6Fp+VE;EACE,mBEzBiB;EF0BjB,qBE3BW;EF4BX,cE5BW;A/FkgWf;A6Fn+VE;EACE,mBE5Bc;EF6Bd,qBE9BQ;EF+BR,cE/BQ;A/FogWZ;A6Fl+VE;EACE,2CE/BgB;EFgChB,qBEjCU;EFkCV,cElCU;A/FsgWd;;Aa//VI;EgFiCA;IACE,uBAAA;E7Fk+VJ;AACF;;A6F99VA;EACE,wBAAA;A7Fi+VF;;A6F99VA;EACE,4BAAA;A7Fi+VF;;A6F99VA;EACE,8BAAA;A7Fi+VF;;A6F99VA;EACE,4BAAA;A7Fi+VF;;A6F99VA;EACE,+BAAA;A7Fi+VF;;A6F99VA;EACE,uBAAA;A7Fi+VF;;A6F99VA;EACE,2BAAA;A7Fi+VF;;A6F99VA;EACE,6BAAA;A7Fi+VF;;A6F99VA;EACE,2BAAA;A7Fi+VF;;A6F99VA;EACE,8BAAA;A7Fi+VF;;Aa7iWI;EgFiFA;IACE,sBAAA;E7Fg+VJ;AACF;;A6F59VA;EACE,mBAAA;A7F+9VF;;A6F19VA;EACE,qBAAA;A7F69VF;Aa9iWI;EgFoFA;IACE,sBAAA;E7F69VJ;AACF;A6F19VE;EACE,WAAA;EACA,YAAA;EACA,gDAAA;EACA,sBAAA;EACA,mBErIU;EFsIV,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A7F49VJ;A6F19VI;EACE,eAAA;A7F49VN;A6Fv9VI;ECjLF,mBDkLkB;ECjLlB,qBDiL4B;EChL5B,gBDgLsC;EC/KtC,cCQc;A/FmoWhB;A6Fx9VE;EACE,mBEvJU;EFwJV,qBExLY;EDAd,eDyLgB;ECxLhB,iBDwLsB;ECvLtB,gBDuL4B;ECtL5B,cCSU;EF8KR,wBAAA;EACA,yBE3JU;EF4JV,oGAAA;EAEA,+BAAA;EACA,2DAAA;EACA,4BAAA;EACA,qBEjMY;EDAd,eDkMgB;ECjMhB,iBDiMsB;EChMtB,gBDgM4B;EC/L5B,cCSU;EFuLR,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,WAAA;A7F+9VJ;A6F79VI;EACE,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;A7F+9VN;A6F19VI;EACE,mBEzLQ;EF0LR,gBAAA;A7F49VN;;A6Fv9VA;EACE,gBAAA;EACA,mBEjMY;EFkMZ,sBAAA;EACA,gDAAA;A7F09VF;A6Fx9VE;EACE,gBAAA;EACA,UAAA;A7F09VJ;A6Fv9VE;EACE,UAAA;A7Fy9VJ;;A6Fr9VA;EACE,2DAAA;EACA,iCAAA;A7Fw9VF;;AgG1sWA;EACE,2BAAA;EFAA,eECc;EFAd,iBAAA;EACA,gBED0B;EFE1B,cCSU;A/FqsWZ;;AgG7sWA;;;;;;;;;;;EAME,2BAAA;EACA,gBAAA;AhGqtWF;;AgGltWA;EFdE,eEec;EFdd,iBEcoB;EFbpB,gBEa0B;EFZ1B,cCSU;A/F2tWZ;;AgGrtWA;EFlBE,eEmBc;EFlBd,iBEkBoB;EFjBpB,gBEiB0B;EFhB1B,cCSU;A/FkuWZ;;AgGxtWA;EFtBE,eEuBc;EFtBd,iBEsBoB;EFrBpB,gBEqB0B;EFpB1B,cCSU;A/FyuWZ;;AiGrvWE;EACE,yBAAA;EACA,6BAAA;AjGwvWJ;AiGrvWM;EACE,mBFiCO;EDvCb,eGOoB;EHNpB,iBGM0B;EHL1B,gBGKgC;EHJhC,cCqCkB;A/FytWpB;AiGvvWM;EACE,gBAAA;EACA,gBAAA;EACA,4BFyBO;A/FguWf;AiGtvWM;EACE,kBAAA;AjGwvWR;AiGrvWU;EAEE,UAAA;AjGsvWZ;AiGpvWY;EACE,UAAA;AjGsvWd;AiGhvWM;EACE,gBAAA;EHhCN,eGiCoB;EHhCpB,iBGgC0B;EH/B1B,gBG+BgC;EH9BhC,cCsCgB;A/F6uWlB;AiGlvWM;EACE,kBAAA;AjGovWR;AiG/uWE;EACE,uBAAA;EACA,6CAAA;EACA,2BAAA;EACA,2BAAA;AjGivWJ;AiG9uWE;EACE,WAAA;EACA,mBAAA;AjGgvWJ;AazuWI;EoFJE;IACE,aAAA;IACA,mBAAA;EjGgvWN;AACF;AiG7uWI;EH5DF,eG6DkB;EH5DlB,iBG4DwB;EH3DxB,gBG2D8B;EH1D9B,cC6BY;EE8BR,wBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjGkvWN;AiGhvWM;EACE,mBF5DY;EE6DZ,qBF7DY;EE8DZ,cF3DI;A/F6yWZ;AiGhvWQ;EAEE,mBFrCK;EEsCL,qBFtCK;A/FuxWf;AiG7uWM;EACE,kBAAA;EACA,mBAAA;AjG+uWR;AiG7uWQ;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EAEA,6CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBF/FM;A/F60WhB;AiG5uWU;EACE,YAAA;EACA,WAAA;AjG8uWZ;AiGxuWQ;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,kEAAA;EACA,WAAA;EACA,WAAA;AjG0uWV;AiGruWQ;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,kEAAA;EACA,WAAA;EACA,YAAA;AjGuuWV;AiGhuWQ;EACE,mBFlGI;EEmGJ,qBFnIM;EDAd,eGoIsB;EHnItB,iBGmI4B;EHlI5B,gBGkIkC;EHjIlC,cCSU;EEyHF,wBAAA;EACA,iCAAA;AjGquWV;AiGnuWU;EACE,cF7HA;EE8HA,UAAA;AjGquWZ;AiGluWU;EACE,qBF9II;A/Fk3WhB;Aa3yWI;EoF2EQ;IACE,WAAA;EjGmuWZ;AACF;AiGvtWM;EACE,mBFjIM;EEkIN,qBFlKQ;EDAd,eGmKoB;EHlKpB,iBGkK0B;EHjK1B,gBGiKgC;EHhKhC,cCSU;EEwJJ,wBAAA;EACA,iCAAA;AjG4tWR;AiG1tWQ;EACE,cF5JE;EE6JF,UAAA;AjG4tWV;AiGztWQ;EACE,qBAAA;AjG2tWV;AiGvtWM;EACE,sFAAA;EAEA,kBAAA;AjGwtWR;AiGttWQ;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AjGwtWV;AiGptWM;EACE,yBFhKM;EEiKN,0DAAA;EACA,0CAAA;EACA,yBAAA;EACA,qBFpMQ;EDAd,eGqMoB;EHpMpB,iBGoM0B;EHnM1B,gBGmMgC;EHlMhC,cCSU;EE0LJ,wBAAA;EACA,mCAAA;EACA,iCAAA;EACA,WAAA;AjGytWR;AiGvtWQ;EACE,oGAAA;EAEA,+BAAA;EACA,2DAAA;EACA,kCAAA;AjGwtWV;;AkGx6WE;EACE,wBAAA;AlG26WJ;;Aal3WI;EqFnDA;IACE,aAAA;IACA,mBAAA;ElGy6WJ;EkGt6WM;IACE,iBAAA;ElGw6WR;AACF;Aa/2WI;EqFnDE;IACE,WAAA;ElGq6WN;EkGp6WM;IACE,kBAAA;ElGs6WR;AACF;;AmG97WE;EACE,qBJea;EIdb,cJUQ;EITR,wBAAA;EACA,2BAAA;AnGi8WJ;AmG/7WI;EACE,UAAA;EACA,cJGU;A/F87WhB;AmG97WI;EAEE,mBJEO;A/F67Wb;AmG37WE;EACE,qBJFa;EDhBf,eKmBgB;ELlBhB,iBKkBsB;ELjBtB,gBKiB4B;ELhB5B,cCQc;A/Fw8WhB;AmG97WI;EACE,kBAAA;AnGg8WN;AmG97WM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kEAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AnGg8WR;AmG77WM;EACE,wBAAA;EACA,gBAAA;EACA,sBAAA;AnG+7WR;AmG37WI;EACE,iBAAA;EACA,oBAAA;AnG67WN;AmGz7WE;EACE,aAAA;EACA,cAAA;EACA,YAAA;AnG27WJ;;AoG1+WM;EACE,mBAAA;EACA,kEAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;ApG6+WR;AoG1+WM;EACE,cAAA;ApG4+WR;AoGz+WI;EACE,gBAAA;EACA,mBLWQ;EKVR,sBAAA;EACA,gDAAA;EACA,SAAA;EACA,iBAAA;ApG2+WN;AoGz+WM;EAEE,aAAA;ApG0+WR;AoGt+WQ;ENjCN,eMkCsB;ENjCtB,iBMiC4B;ENhC5B,gBMgCkC;EN/BlC,cCSU;A/FigXZ;AoGp+WI;EACE,2BAAA;ApGs+WN;AoGp+WM;EACE,mBLPO;EKQP,qBLRO;EKSP,cLnCI;A/FygXZ;;AqGzhXE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;ArG4hXJ;AqGzhXE;EACE,cNSQ;A/FkhXZ;AqGxhXE;EACE,kBAAA;ArG0hXJ;AqGthXI;EACE,eAAA;EACA,cNbU;EMcV,iBAAA;EACA,gBAAA;EACA,mBAAA;ArGwhXN;AqGrhXI;EACE,cNTU;EMUV,gBAAA;ArGuhXN;AqGnhXE;EACE,WAAA;EACA,sBpGhBI;EoGiBJ,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,wCAAA;ArGqhXJ;AqGnhXI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ArGqhXN;AqGnhXM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;ArGqhXR;AqG9gXI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;ArGghXN;AqG7gXI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;ArG+gXN;AqG7gXM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;ArG+gXR;AqG7gXQ;EACE,eAAA;EACA,gBAAA;ArG+gXV;AqG7gXU;EACE,cN1EI;A/FylXhB;AqGxgXE;EACE,WAAA;EACA,sBpGnFI;EoGoFJ,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,wCAAA;ArG0gXJ;AqGxgXI;EACE,WAAA;EACA,aAAA;EACA,+BAAA;EACA,cAAA;ArG0gXN;AqGvgXI;EACE,aAAA;EACA,mBAAA;ArGygXN;AqGvgXM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;ArGygXR;AqGtgXM;EACE,gBAAA;ArGwgXR;AqGrgXM;EACE,yBN5HK;A/FmoXb;AqGtgXQ;EACE,cN/HM;A/FuoXhB;AqGrgXM;EACE,yBN9HS;A/FqoXjB;AqGtgXQ;EACE,cNjIG;A/FyoXb;AqGrgXM;EACE,yBNnHM;A/F0nXd;AqGtgXQ;EACE,cNtHG;A/F8nXb;AqGrgXM;EACE,yBNjHO;A/FwnXf;AqGtgXQ;EACE,cNpHK;A/F4nXf;AqGpgXM;EACE,yBNnII;A/FyoXZ;AqGrgXQ;EACE,cNtIG;A/F6oXb;AqGpgXM;EACE,yBN/IK;A/FqpXb;AqGrgXQ;EACE,cNlJE;A/FypXZ;AqGpgXM;EACE,yBNvIK;A/F6oXb;AqGrgXQ;EACE,cN5II;A/FmpXd;AqGngXM;EACE,yBNxKK;A/F6qXb;AqGpgXQ;EACE,cN5KQ;A/FkrXlB;AqGhgXE;EACE,WAAA;EACA,sBpGxKI;EoGyKJ,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,wCAAA;ArGkgXJ;AqGhgXI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;ArGkgXN;AqG//WI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;ArGigXN;AqG9/WI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;ArGggXN;AqG1/WI;EACE,yBNnNa;EMoNb,iBAAA;EACA,kBAAA;ArG4/WN;AqG3/WM;EACE,gBAAA;EACA,cN9NQ;EM+NR,eAAA;EACA,gBAAA;ArG6/WR;AqGz/WI;EACE,yBNrOU;EMsOV,WpG3NE;EoG4NF,kBAAA;EACA,YAAA;ArG2/WN;AqGx/WI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;ArG0/WN;AqGx/WM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;ArG0/WR;AqGx/WQ;EACE,UAAA;EACA,WAAA;EACA,mBAAA;ArG0/WV;AqGt/WU;EACE,yBNhQI;A/FwvXhB;AqGp/WU;EACE,yBNjQC;A/FuvXb;AqGl/WU;EACE,yBNrPC;A/FyuXb;AqG/+WU;EACE,yBNnPG;A/FouXf;AqG7+WU;EACE,yBNnQC;A/FkvXb;AqG3+WU;EACE,yBN9QA;A/F2vXZ;AqGz+WU;EACE,yBNvQE;A/FkvXd;AqGv+WU;EACE,yBNrSM;A/F8wXlB;AqGp+WM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ArGs+WR;AqGl+WI;EACE,WAAA;ArGo+WN;AqGl+WM;EACE,gBAAA;ArGo+WR;AqGj+WU;EACE,yBNzSC;A/F4wXb;AqGj+WY;EACE,cN3TE;EM4TF,2BAAA;EACA,gCAAA;EACA,aAAA;ArGm+Wd;AqG59WY;EACE,eAAA;ArG89Wd;AqGz9Wc;EACE,kBAAA;ArG29WhB;AqGl9WE;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;ArGo9WJ;;AqGj9WA;EACE,kBAAA;EACF,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ArGo9WA;;AsGhzXE;EACE,cPOQ;EDZV,eQMgB;ERLhB,iBQKsB;ERJtB,gBQI4B;ERH5B,cCSU;A/FgzXZ;AsGlzXI;EACE,gDAAA;EACA,sBAAA;EACA,mBPmBQ;A/FiyXd;AsGlzXM;EACE,cPiBM;EOhBN,yBPgBM;EOfN,aAAA;EACA,gBAAA;AtGozXR;AsGhzXI;EACE,gBAAA;EACA,cPbM;A/F+zXZ;AsGhzXM;EAEE,oCAAA;AtGizXR;AsG5yXU;EACE,+CAAA;AtG8yXZ;AsG1yXQ;EACE,0CAAA;EACA,kBAAA;AtG4yXV;AsGxyXM;ER7CJ,eQ8CoB;ER7CpB,iBQ6C0B;ER5C1B,gBAH2C;EAI3C,cAJwD;EQgDlD,cPpCQ;EOqCR,sBAAA;EACA,cAAA;AtG6yXR;AapyXI;EyFJM;IACE,UAAA;EtG2yXV;AACF;AazyXI;EyFCM;IACE,qBAAA;EtG2yXV;AACF;Aa9yXI;EyFMM;IACE,UAAA;EtG2yXV;AACF;AsGvyXM;EACE,qBPpCa;EDnCnB,eQwEoB;ERvEpB,iBQuE0B;ERtE1B,gBQsEgC;ERrEhC,cCgCmB;EOsCb,gBAAA;EACA,SAAA;EACA,yBAAA;AtG4yXR;AsGxyXQ;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;AtG0yXV;AarzXI;EyFeU;IACE,SAAA;EtGyyXd;AACF;AsGvyXY;EACE,aAAA;AtGyyXd;AsGryXU;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;AtGsyXZ;AsGnyXU;EACE,UAAA;EACA,2BAAA;EACA,kCAAA;EACA,OAAA;AtGqyXZ;AsGlyXU;EACE,yBAAA;EACA,mBP/EE;EOgFF,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AtGoyXZ;AsGhyXY;EACE,mBPxHE;A/F05XhB;AsGzxXI;EACE,eAAA;AtG2xXN;AsGxxXI;EACE,kBAAA;ERtIJ,eQuIkB;ERtIlB,iBQsIwB;ERrIxB,gBAH2C;EAI3C,cAJwD;EQyIpD,YAAA;EACA,aAAA;EACA,sBAAA;AtG6xXN;AsG1xXQ;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;ERlJR,eQmJsB;ERlJtB,iBQkJ4B;ERjJ5B,gBQiJkC;ERhJlC,cAJwD;EQqJhD,iBAAA;AtG+xXV;AsG5xXQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,mBP7HI;EO8HJ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sDAhKC;AtG87XX;AsG5xXU;EACE,sDAlKK;AtGg8XjB;AsGxxXQ;EACE,kBAAA;AtG0xXV;AsGxxXU;EACE,gBAAA;AtG0xXZ;AsGvxXU;EACE,mBPlJE;EOmJF,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sDArLD;EAsLC,4BAAA;AtGyxXZ;AsGrxXY;EACE,qBP5LE;A/Fm9XhB;AsGnxXU;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AtGqxXZ;AsGlxXU;EACE,sDAzMK;EA0ML,qBP5MI;EO6MJ,yBP7MI;EO8MJ,YAAA;AtGoxXZ;AsGjxXU;EACE,kBAAA;EACA,UAAA;AtGmxXZ;AsGjxXY;EACE,mBAAA;AtGmxXd;AsGhxXY;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;EACA,cPrNE;A/Fu+XhB;AsG9wXQ;EACE,kBAAA;AtGgxXV;AsG9wXU;EACE,gBAAA;AtGgxXZ;AsG7wXU;EACE,mBP5ME;EO6MF,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sDA/OD;EAgPC,4BAAA;AtG+wXZ;AsGtwXU;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AtGwwXZ;AsGhwXU;EACE,kBAAA;EACA,UAAA;AtGkwXZ;AsGhwXY;EACE,mBAAA;AtGkwXd;AsG/vXY;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,yBAAA;EACA,cP7QE;A/F8gYhB;AsG3vXM;EACE,0CAAA;EACA,mBPhQM;EOiQN,6BAAA;EACA,0BAAA;EACA,gBAAA;AtG6vXR;AsGzvXI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AtG2vXN;AsGzvXM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;AtG2vXR;AsGxvXM;EACE,WAAA;EACA,YAAA;AtG0vXR;AsGvvXM;ER1TJ,eQ2ToB;ER1TpB,iBQ0T0B;ERzT1B,gBQyTgC;ERxThC,cC6BY;EO4RN,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AtG4vXR;AsGxvXI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AtG0vXN;AsGxvXM;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;AtG0vXR;AsGxvXQ;EACE,cAAA;AtG0vXV;AsGvvXQ;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AtGyvXV;AsGtvXQ;EACE,mBP3UO;EO4UP,mBAAA;AtGwvXV;AsGrvXQ;EACE,oCAAA;EACA,kBAAA;EACA,kBAAA;AtGuvXV;AsGrvXU;EACE,kBAAA;AtGuvXZ;AsGpvXU;EACE,cP9VI;EO+VJ,qBAAA;AtGsvXZ;AsGnvXU;EACE,cAAA;ER9WV,eQ+WwB;ER9WxB,iBQ8W8B;ER7W9B,gBQ6WoC;ER5WpC,cCHc;EOgXJ,iBAAA;AtGwvXZ;AsGrvXQ;EACE,mCAAA;EACA,kBAAA;EACA,kBAAA;AtGuvXV;AsGrvXU;EACE,kBAAA;AtGuvXZ;AsGpvXU;EACE,cPjXA;EOkXA,qBAAA;AtGsvXZ;AsGnvXU;EACE,cAAA;ERlYV,eQmYwB;ERlYxB,iBQkY8B;ERjY9B,gBQiYoC;ERhYpC,cCHc;EOoYJ,iBAAA;AtGwvXZ;AsGhvXI;EACE,yBAAA;EACA,kBAAA;AtGkvXN;AsGhvXM;EACE,gCAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBP7YU;A/F+nYlB;AsG/uXM;EACE,0BAAA;EACA,gBAAA;AtGivXR;AsG/uXQ;EACE,cAAA;EACA,kBAAA;ER7ZR,eQ8ZsB;ER7ZtB,iBQ6Z4B;ER5Z5B,gBAH2C;EAI3C,cAJwD;EQiahD,sBAAA;AtGmvXV;AsG/uXM;EACE,6BAAA;EACA,0BAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;AtGivXR;AsG/uXQ;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,cPtaE;EOuaF,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;AtGivXV;AsG/uXU;EACE,cP/aI;EOgbJ,UAAA;AtGivXZ;AsG7uXQ;EACE,cAAA;EACA,mBP5bO;EO6bP,YAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AtG+uXV;AsG7uXU;EACE,oCAAA;AtG+uXZ;AsG1uXM;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AtG4uXR;AsG1uXQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AtG4uXV;AsGzuXQ;EACE,cAAA;AtG2uXV;AsGxuXQ;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AtG0uXV;AsGvuXQ;EACE,mBP1dO;EO2dP,mBAAA;AtGyuXV;AsGruXM;EACE,cAAA;AtGuuXR;AsGruXQ;EACE,mBAAA;AtGuuXV;AsGpuXQ;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;AtGsuXV;AsGpuXU;EACE,YAAA;EACA,WAAA;EACA,kBAAA;ER/fV,eQggBwB;ER/fxB,iBQ+f8B;ER9f9B,gBQ8foC;ER7fpC,4BQ6fyC;EAC/B,iBAAA;EACA,mBPzfQ;EO0fR,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AtGyuXZ;AsGtuXU;EACE,YAAA;EACA,0CAAA;EACA,oCAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AtGwuXZ;AsGpuXQ;EACE,qCAAA;EACA,mBPrfI;EOsfJ,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AtGsuXV;AsGnuXQ;EACE,kBAAA;AtGquXV;AsGjuXQ;EACE,cAAA;ERliBR,eQmiBsB;ERliBtB,iBQkiB4B;ERjiB5B,gBQiiBkC;ERhiBlC,cCHc;EOoiBN,iBAAA;AtGsuXV;AsGluXM;;EAEE,oBAAA;EACA,eAAA;AtGouXR;AsG9tXI;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBPxhBQ;EOyhBR,yBAAA;EACA,sBAAA;EACA,mDAAA;EACA,wBAAA;ER5jBJ,eQ6jBkB;ER5jBlB,iBQ4jBwB;ER3jBxB,gBQ2jB8B;ER1jB9B,cCSU;EOkjBN,kBAAA;EACA,UAAA;AtGmuXN;AsGjuXM;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;AtGkuXR;AsG/tXM;EACE,gBAAA;EACA,sCAAA;EACA,uCAAA;EACA,iCAAA;AtGiuXR;AsG9tXM;EACE,iBAAA;EACA,uCAAA;EACA,wCAAA;EACA,kCAAA;EACA,UAAA;AtGguXR;AsG7tXM;EACE,SAAA;AtG+tXR;AsG7tXQ;EACE,cP9lBM;EO+lBN,gBAAA;AtG+tXV;AsG3tXM;EACE,qBP3kBK;A/FwyYb;AsG3tXQ;EACE,8BAAA;EACA,+BAAA;EACA,yBPhlBG;A/F6yYb;AsG1tXQ;EACE,8BAAA;EACA,+BAAA;EACA,yBP/kBI;A/F2yYd;AsGxtXU;EACE,cP1lBA;A/FozYZ;;AuGn1YA,gBAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;AvGs1YJ;;AuGn1YE;EACE,wIAAA;EAEA,WAAA;EACA,yBAAA;EACA,iBAAA;AvGq1YJ;;AuGl1YE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AvGq1YJ;;AuGl1YE,kBAAA;AACA;EACE,sBAAA;EACA,gCAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;AvGq1YJ;;AuGl1YE;EACE,cAAA;EACA,gCAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,kBAAA;AvGq1YJ;;AuGl1YE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AvGq1YJ;;AuGl1YE,wBAAA;AACA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AvGq1YJ;;AuGl1YE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,YAAA;AvGq1YJ;;AuGl1YE,gBAAA;AACA;EACE,aAAA;EACA,0BAAA;EACA,cAAA;EAAA,SAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,gCAAA;AvGq1YJ;;AuGl1YE;EACE,mBAAA;EACA,gBAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;AvGq1YJ;;AuGl1YE;EACE,UAAA;AvGq1YJ;;AuGl1YE;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,cAAA;AvGq1YJ;;AuGl1YE;EACE,cAAA;AvGq1YJ;;AuGl1YE;EACE,cAAA;AvGq1YJ;;AuGl1YE;EACE,mBAAA;EACA,WAAA;AvGq1YJ;;AuGl1YE,qBAAA;AACA;EACE,aAAA;EACA,0BAAA;EACA,cAAA;EAAA,SAAA;AvGq1YJ;;AuGl1YE,gBAAA;AACA;EACE,mBAAA;AvGq1YJ;;AuGl1YE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AvGq1YJ;;AuGl1YE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE,SAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;AvGq1YJ;;AuGl1YE;EACE,cAAA;EACA,4BAAA;AvGq1YJ;;AuGl1YE,iBAAA;AACA;EACE,gBAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,yBAAA;AvGq1YJ;;AuGl1YE;;EAEE,kBAAA;EACA,gBAAA;EACA,gCAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AvGq1YJ;;AuGl1YE;EACE,mBAAA;AvGq1YJ;;AuGl1YE;EACE,8CAAA;AvGq1YJ;;AuGl1YE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;EACA,cAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;EACA,cAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;EACA,cAAA;AvGq1YJ;;AuGl1YE,gBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AvGq1YJ;;AuGl1YE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AvGq1YJ;;AuGl1YE,mBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;AvGq1YJ;;AuGl1YE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AvGq1YJ;;AuGl1YE;EACE,yBAAA;AvGq1YJ;;AuGl1YE,oBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AvGq1YJ;;AuGl1YE;EACE;IACE,yBAAA;EvGq1YJ;AACF;AuGl1YE,uBAAA;AACA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AvGo1YJ;;AuGj1YE;EACE,sBAAA;EACA,kBAAA;EACA,iFAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AvGo1YJ;;AuGj1YE;EACE,gBAAA;EACA,kBAAA;AvGo1YJ;;AuGj1YE;EACE,mBAAA;EACA,cAAA;AvGo1YJ;;AuGj1YE;EACE;IACE,2BAAA;IACA,UAAA;EvGo1YJ;EuGl1YE;IACE,wBAAA;IACA,UAAA;EvGo1YJ;AACF;AuGj1YE,sBAAA;AACA;EACE;IACE,aAAA;EvGm1YJ;EuGh1YE;IACE,qCAAA;EvGk1YJ;EuG/0YE;IACE,8BAAA;EvGi1YJ;EuG90YE;IACE,aAAA;EvGg1YJ;AACF;AwG5zZE;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AxG8zZN;;AwG3zZI;EACE,mBAAA;AxG8zZN;;AwG3zZI;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AxG8zZN;;AwG3zZI;EACE,WAAA;EACA,SAAA;AxG8zZN;;AwG3zZI;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AxG8zZN;;AwG3zZI;EACE,SAAA;EACA,gBAAA;AxG8zZN;;AwG3zZI;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AxG8zZN;;AwG3zZI;EACE,aAAA;EACA,SAAA;AxG8zZN;;AwG3zZI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AxG8zZN;;AwG3zZI;EACE,eAAA;EACA,WAAA;AxG8zZN;;AwG3zZI;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AxG8zZN;;AwG3zZI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;AxG8zZN;;AwG3zZI;EACE,WAAA;EACA,yBAAA;AxG8zZN;;AwG3zZI;;EAEE,kBAAA;EACA,gBAAA;EACA,6BAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;AxG8zZN;;AwG3zZI;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;AxG8zZN;;AwG3zZI;EACE,qBAAA;EACA,gBAAA;AxG8zZN;;AwG3zZI;EACE,eAAA;EACA,sCAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;AxG8zZN;;AwG3zZI;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,cAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,cAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,cAAA;AxG8zZN;;AwG3zZI;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,cAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,cAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;AxG8zZN;;AwG3zZI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AxG8zZN;;AwG3zZI;EACE,yBAAA;AxG8zZN;;AwG3zZI;EACE,YAAA;EACA,mBAAA;AxG8zZN;;AwG3zZI;EACE,eAAA;EACA,WAAA;AxG8zZN;;AwG3zZI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AxG8zZN;;AwG3zZI;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AxG8zZN;;AwG3zZI,sBAAA;AACA;EACE;IACE,sBAAA;ExG8zZN;EwG3zZI;IACE,eAAA;ExG6zZN;EwG1zZI;IACE,WAAA;IACA,8BAAA;ExG4zZN;EwGzzZI;;IAEE,aAAA;ExG2zZN;AACF;AwGxzZI;EACE;;IAEE,aAAA;ExG0zZN;AACF;AyGhjaA;EACI,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AzGkjaJ;;AyG/iaE;EACE,mBAAA;AzGkjaJ;;AyG/iaE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AzGkjaJ;;AyG/iaE;EACE,0BAAA;AzGkjaJ;;AyG/iaE;EACE,SAAA;EACA,eAAA;EACA,WAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AzGkjaJ;;AyG/iaE;EACE,gBAAA;AzGkjaJ;;AyG/iaE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,cAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,cAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,cAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;AzGkjaJ;;AyG/iaE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;AzGkjaJ;;AyG/iaE;EACE,mBAAA;AzGkjaJ;;AyG/iaE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AzGkjaJ;;AyG/iaE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;AzGkjaJ;;AyG/iaE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;AzGkjaJ;;AyG/iaE;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AzGkjaJ;;AyG/iaE;EACE,2BAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;AzGkjaJ;;AyG/iaE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;AzGkjaJ;;AyG/iaE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AzGkjaJ;;AyG/iaE;;;;EAIE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,YAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,YAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,YAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,YAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AzGkjaJ;;AyG/iaE;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;AzGkjaJ;;AyG/iaE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AzGkjaJ;;AyG/iaE;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AzGkjaJ;;AyG/iaE;EACE,SAAA;EACA,eAAA;AzGkjaJ;;AyG/iaE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzGkjaJ;;AyG/iaE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AzGkjaJ;;AyG/iaE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AzGkjaJ;;AyG/iaE;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,WAAA;AzGkjaJ;;AyG/iaE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AzGkjaJ;;AyG/iaE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AzGkjaJ;;AyG/iaE,sBAAA;AACA;EACE;IACE,kBAAA;EzGkjaJ;EyG/iaE;IACE,aAAA;EzGijaJ;EyG9iaE;IACE,0BAAA;EzGgjaJ;EyG7iaE;IACE,4DAAA;EzG+iaJ;EyG5iaE;IACE,sBAAA;EzG8iaJ;EyG3iaE;;IAEE,WAAA;EzG6iaJ;AACF;A0G18aA,uBAAA;AACA;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,wIAAA;A1G48aJ;;A0Gx8aE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,WAAA;EACA,iBAAA;A1G28aJ;;A0Gx8aE,gBAAA;AACA;EACE,aAAA;EACA,2DAAA;EACA,cAAA;EAAA,SAAA;EACA,mBAAA;A1G28aJ;;A0Gx8aE;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE,sBAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,cAAA;EAAA,SAAA;A1G28aJ;;A0Gx8aE,SAAA;AACA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;A1G28aJ;;A0Gx8aE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,cAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;A1G28aJ;;A0Gx8aE,aAAA;AACA;;EAEE,uBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;A1G28aJ;;A0Gx8aE;EACE,UAAA;A1G28aJ;;A0Gx8aE;EACE,mBAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,6BAAA;EACA,eAAA;EACA,iCAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,8BAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,cAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,cAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,cAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,cAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,sBAAA;A1G28aJ;;A0Gx8aE;EACE,gBAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE;EACE,WAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;A1G28aJ;;A0Gx8aE,yBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,WAAA;EACA,mBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,SAAA;A1G28aJ;;A0Gx8aE,eAAA;AACA;EACE,aAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,cAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,cAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,QAAA;A1G28aJ;;A0Gx8aE;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;A1G28aJ;;A0Gx8aE;EACE,6BAAA;EACA,oBAAA;A1G28aJ;;A0Gx8aE;EACE,mBAAA;EACA,iBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;A1G28aJ;;A0Gx8aE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,aAAA;EACA,gBAAA;A1G28aJ;;A0Gx8aE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;A1G28aJ;;A0Gx8aE;EACE,YAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,cAAA;EACA,qBAAA;A1G28aJ;;A0Gx8aE;EACE,0BAAA;A1G28aJ;;A0Gx8aE,gBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;A1G28aJ;;A0Gx8aE;EACE,WAAA;EACA,mBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;A1G28aJ;;A0Gx8aE;EACE,eAAA;EACA,SAAA;A1G28aJ;;A0Gx8aE,kBAAA;AACA;EACE,8BAAA;A1G28aJ;;A0Gx8aE;EACE,8BAAA;A1G28aJ;;A0Gx8aE,qBAAA;AACA;EACE,qBAAA;EACA,gCAAA;A1G28aJ;;A0Gx8aE;EACE,UAAA;A1G28aJ;;A0Gx8aE;EACE,mBAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE;EACE,yBAAA;EACA,kBAAA;A1G28aJ;;A0Gx8aE,eAAA;AACA;EACE;IACE,0BAAA;E1G28aJ;E0Gx8aE;IACE,iBAAA;E1G08aJ;AACF;A0Gv8aE,2BAAA;AACA;EACE;IACE,qCAAA;IACA,SAAA;E1Gy8aJ;E0Gt8aE;IACE,aAAA;E1Gw8aJ;E0Gr8aE;IACE,eAAA;E1Gu8aJ;E0Gp8aE;IACE,SAAA;E1Gs8aJ;AACF;A0Gn8aE;EACE;IACE,aAAA;E1Gq8aJ;E0Gl8aE;IACE,mBAAA;E1Go8aJ;E0Gj8aE;IACE,mBAAA;E1Gm8aJ;AACF;A2Gz9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,wBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,uBAAA;A3G29bF;;A2Gx9bA;EACE,qBAAA;A3G29bF;;A4GzicA;EACE,gCAAA;A5G4icF;;A4GzicA;EACE,iCAAA;A5G4icF;;A4GzicA;EACE,iCAAA;A5G4icF;;A4GzicA;EACE,iCAAA;A5G4icF;;A4GzicA;EACE,iCAAA;A5G4icF;;A4GzicA;EACE,iCAAA;A5G4icF;;A4GzicA;EACE,iCAAA;A5G4icF;;A4GzicA;EACE,kCAAA;A5G4icF;;A6GrkcA;EACE,0CAAA;A7GwkcF;;A6GrkcA;EACE,2CAAA;A7GwkcF;;A6GrkcA;EACE,6CAAA;A7GwkcF;;A6GrkcA;EACE,8CAAA;A7GwkcF;;A6GrkcA;EACE,2BAAA;A7GwkcF;;A6GrkcA;EACE,0BAAA;A7GwkcF;;A6GrkcA;EvGXI,sBAAA;ANolcJ;;A6GnkcA;EACE,4BAAA;EACA,6BAAA;A7GskcF;;A6GnkcA;EACE,cAAA;A7GskcF;A6GpkcE;EACE,cAAA;A7GskcJ;;A6GlkcA;EACE,cAAA;A7GqkcF;;A6GlkcA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;A7GqkcF;;A6GjkcE;EACE,MAAA;EACA,UAAA;EACA,YAAA;A7GokcJ;;A6G9jcA;EACE,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,4BAAA;A7GikcF;;A6G5jcA;EACE,4BAAA;A7G+jcF;;A6G5jcA;EACE,4BAAA;A7G+jcF;;A6G5jcA;EACE,4BAAA;A7G+jcF;;A6G1jcA;EACE,wCAAA;A7G6jcF;;A6GxjcA;EACE,wBAAA;A7G2jcF;;A6GxjcA;EACE,uBAAA;A7G2jcF;;A6GxjcA;EACE,YAAA;A7G2jcF;;A6GxjcA;EACE,aAAA;A7G2jcF;;A6GxjcA;EACE,mBAAA;A7G2jcF;;A6GtjcA;EACE,6BAAA;A7GyjcF;;A6GtjcA;EACE,4BAAA;A7GyjcF;;A6GtjcA;EACE,4BAAA;A7GyjcF;;A6GtjcA;EACE,0BAAA;A7GyjcF;;A6GtjcA;EACE,UAAA;A7GyjcF;;A6GtjcA;EACE,cAAA;A7GyjcF;;A6GpjcA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;A7GujcF;;A6GpjcA;EACE,SAAA;A7GujcF;;A6GljcA;EACE,gBzG0FO;EyGzFP,mBzGyFO;EyGxFP,WAAA;EACA,gBAAA;EACA,mB5GjJS;ADsscX;;A6GljcA;EACE,aAAA;EAAA,gBAAA;A7GqjcF;;A6GhjcA;EACE,eAAA;EACA,kBAAA;A7GmjcF;A6GjjcE;EACE,c5G1JO;E4G2JP,iBzG6Q0B;AJsyb9B;A6GhjcE;EACE,c5GjKO;E4GkKP,iB5G3FW;AD6ocf;;A6G5icA;EACE,8BAAA;A7G+icF;A6GnicA;EACE;IACE,6BAAA;E7G8icF;E6G5icA;IACE,2BAAA;E7G8icF;AACF;A6GzicA;EACE,WAAA;A7G2icF;;A6GxicA;EACE,sBAAA;A7G2icF;;A6GticA;EACE,qBzGyH4B;AJg7b9B;;A6GpicA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A7GuicF;A6GricE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;A7GuicJ;A6GpicE;EACE,gBAAA;EACA,cAAA;EACA,c5GlOO;E4GmOP,mBAAA;A7GsicJ;A6GnicE;EACE,kBAAA;EACA,cAAA;A7GqicJ;;A6GjicA;EACE,sBAAA;A7GoicF;;A6GjicA;EACE,cAAA;A7GoicF;;A6GjicA;EACE,sCAAA;A7GoicF;;A6GjicA;EACE,gCAAA;A7GoicF;;A6GjicA;EACE,cAAA;A7GoicF;;A6GhicA;EACE,0BAAA;A7GmicF;;A6GhicA;EACE,WAAA;EACA,YAAA;A7GmicF;;A8G9zcA;EACE,0FAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,gFAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,2GAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,0GAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,yEAAA;A9Gi0cF;;A8G9zcA;EACE,6EAAA;A9Gi0cF;;A8G9zcA;EACE,8EAAA;A9Gi0cF;;A8G9zcA;EACE,0FAAA;A9Gi0cF;;A8G9zcA;EACE,8KAAA;EACA,+BAAA;A9Gi0cF;;A8G9zcA;EACE,wEAAA;A9Gi0cF;;A8G9zcA;EACE,iFAAA;A9Gi0cF;;A8G9zcA;EACE,kCAAA;A9Gi0cF;;A+G56cA;;;;CAAA;AAMA;EACC,mCAAA;A/G86cD;;A+G36cA;ECII,4BAAA;EAAA,yBAAA;AhH86cJ;A+G96cC;EACE,mCENuB;AjHs7c1B;A+G76cC;ECJG,gCAAA;AhHq7cJ;A+G76cC;ECRG,mCAAA;AhHy7cJ;A+G56cC;ECbG,mCAAA;AhH67cJ;AgHx6cI;EEjCF;IAAI,UAAA;ElHs9cJ;EkHr9cA;IAAM,UAAA;ElHw9cN;AACF;AkHt9cC;EFQG,sBAAA;AhHk9cJ;AmHn9cC;EACC;IACC,UAAA;IACA,4BAAA;EnHg+cD;EmH79cA;IACC,UAAA;IACA,wBAAA;EnH+9cD;AACF;AmH59cC;EHXG,0BAAA;AhH2+cJ;AoH5+cC;EACC;IACC,UAAA;IACA,2BAAA;EpHy/cD;EoHt/cA;IACC,UAAA;IACA,wBAAA;EpHw/cD;AACF;AoHr/cC;EJXG,wBAAA;AhHogdJ;AgH/+cI;EKjCF;IAAI,UAAA;ErH6hdJ;EqH5hdA;IAAM,UAAA;ErH+hdN;AACF;AqH7hdC;ELQG,uBAAA;AhHyhdJ;AsH/hdC;EACC;IAAK,yCAAA;IAAmD,UAAA;EtHsjdxD;EsHrjdA;IAAM,wCAAA;IAAkD,UAAA;EtHyjdxD;EsHxjdA;IAAM,uCAAA;IAAqD,UAAA;EtH4jd3D;EsH3jdA;IAAO,qCAAA;IAAuC,UAAA;EtH+jd9C;AACF;AsH7jdC;ENDG,4BAAA;EAAA,mCAAA;AhHokdJ;AuH5kdC;EACC;IAAK,qCAAA;IAAuC,UAAA;EvH2ld5C;EuH1ldA;IAAO,yCAAA;IAAmD,UAAA;EvH8ld1D;AACF;AuH5ldC;EPGG,6BAAA;EAAA,kCAAA;AhH+ldJ;;AwHpmdE;EACE,iEAAA;AxHumdJ;;AwHlmdE;EACE,cAAA;EACA,iEAAA;AxHqmdJ;;AwHhmdE;EACE,iEAAA;EACA,uBAAA;EACA,oBAAA;AxHmmdJ;;AwH/ldA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,UAAA;ExHkmdF;EwHhmdA;IACE,eAAA;IACA,mBAAA;IACA,UAAA;ExHkmdF;AACF;AwH/ldA;EACE,oBAAA;AxHimdF;;AyHtodA;EACE,iBAAA;AzHyodF;;AyHrodE;EACE,iBAAA;EACA,gBAAA;AzHwodJ;AyHrodE;EACE,iBAAA;AzHuodJ;AyHpodE;EnHFE,gBAAA;ANyodJ;;AyHlodA;EACE,iBAAA;EACA,gBAAA;AzHqodF;AyHjodE;EnHiBE,4BAAA;EACA,+BAAA;EAfA,6BAAA;EACA,gCAAA;ANmodJ;;AyH7ndA;EACE,oBAAA;AzHgodF;;AyH3ndA;EACE,sBAAA;AzH8ndF;AyH3ndI;EACE,mBAAA;EACA,eAAA;AzH6ndN;AyHzndE;EACE,oBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;AzH2ndJ;AyHxndE;EACE,qBAAA;AzH0ndJ;AyHtndI;EACE,eAAA;AzHwndN;AyHnndI;EACE,eAAA;AzHqndN;;AyH/mdE;EACE,cAAA;EACA,eAAA;AzHkndJ;;AyH5mdA;EACE,kBAAA;AzH+mdF;AyH7mdE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,0CAAA;EAGA,gBAAA;AzH+mdJ;AyH5mdE;EACE,WAAA;EACA,wCAAA;EACA,gCAAA;AzH8mdJ;AyH1mdI;EnHpEA,4BAAA;EACA,+BAAA;EAfA,6BAAA;EACA,gCAAA;ANisdJ;;AyHvmdA;EACE,iBAAA;EACA,oBAAA;AzH0mdF;AyHxmdE;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AzH0mdJ;AyHvmdE;EACE,qBAAA;AzHymdJ;AyHrmdI;EACE,eAAA;AzHumdN;AyHlmdI;EACE,eAAA;AzHomdN;AyH7ldI;EACE,UAAA;AzH+ldN;AyH1ldI;EACE,oBAAA;AzH4ldN;AyHvldI;EACE,+BAAA;AzHyldN;AyHrldM;EACE,qBAAA;AzHuldR;AyHhldQ;EACE,sBAAA;AzHkldV;;AyH3kdA;EACE,4BAAA;AzH8kdF;;AyHzkdA;EACE,cxH9KS;EwH+KT,qBxHnLS;EwHoLT,sBAAA;AzH4kdF;AyH1kdE;EACE,yBAAA;EACA,6BAAA;AzH4kdJ;AyH1kdI;EACE,cxH/JE;EwHgKF,mBxH7LK;ADywdX;AyHxkdE;EAEE,cxH9LO;EwH+LP,qBxHnMO;AD4wdX;AyHrkdI;EACE,gBAAA;AzHukdN;;AyHhkdI;EACE,gCAAA;EACA,gCAAA;EACA,2BAAA;EAAA,wBAAA;EACA,wBAAA;EACA,2BAAA;EACA,WxHvNE;AD0xdR;;AyH5jdA;EnH3NI,2BAAA;AN2xdJ;;AyH7jdA;EACE,oCAAA;EACE,mBAAA;EACA,YAAA;EACA,oCAAA;EACA,2BAAA;AzHgkdJ;;AyH9jdA;EACE,oCAAA;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,2BAAA;AzHikdJ;;AyH7jdA;EACE;IACE,uBAAA;EzHgkdF;EyH9jdA;IACE,yBAAA;EzHgkdF;AACF;AyH7jdA;EACE,WAAA;EACA,YAAA;EAIA,sBAAA;EACA,kCAAA;AzH4jdF;;AyHxjdE;E3FtJA,wBAAA;EzBsKI,iBALI;EC7QN,sBAAA;ANg0dJ;;AyHxjdE;E3F5JA,oBAAA;EzBsKI,iBALI;EC7QN,qBAAA;ANs0dJ;;AyHxjdE;E3FlKA,qBAAA;EzBsKI,iBALI;EC7QN,qBAAA;AN40dJ;;AyHtjdE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;AzHyjdJ;;AyHnjdI;EACE,MAAA;AzHsjdN;;AyHjjdA;EACE,+CAAA;AzHojdF;;AyH38cE;EA5BA,8GAAA;EACA,mEAuBQ;EAtBR,+DAsBQ;EArBR,mEAAA;AzH2+cF;AyHz+cE;EAGE,uJAAA;EACA,mEAAA;EACA,+DAAA;AzHy+cJ;AyHt+cE;EAIE,8EAAA;EACA,0EAAA;AzHq+cJ;AyHx9cI;EACE,mGAAA;AzH09cN;AyHx9cM;EACE,mGAAA;AzH09cR;;AyHj+cE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,kEAAA;AzHigdF;AyH//cE;EAGE,uJAAA;EACA,kEAAA;EACA,8DAAA;AzH+/cJ;AyH5/cE;EAIE,6EAAA;EACA,yEAAA;AzH2/cJ;AyH9+cI;EACE,uGAAA;AzHg/cN;AyH9+cM;EACE,uGAAA;AzHg/cR;;AyHv/cE;EA5BA,4GAAA;EACA,iEAuBQ;EAtBR,6DAsBQ;EArBR,kEAAA;AzHuhdF;AyHrhdE;EAGE,wJAAA;EACA,kEAAA;EACA,8DAAA;AzHqhdJ;AyHlhdE;EAIE,6EAAA;EACA,0EAAA;AzHihdJ;AyHpgdI;EACE,qGAAA;AzHsgdN;AyHpgdM;EACE,qGAAA;AzHsgdR;;AyH7gdE;EA5BA,yFAAA;EACA,8CAuBQ;EAtBR,0CAsBQ;EArBR,+CAAA;AzH6idF;AyH3idE;EAGE,gHAAA;EACA,+CAAA;EACA,2CAAA;AzH2idJ;AyHxidE;EAIE,0DAAA;EACA,oDAAA;AzHuidJ;AyH1hdI;EACE,qGAAA;AzH4hdN;AyH1hdM;EACE,qGAAA;AzH4hdR;;AyHnidE;EA5BA,8GAAA;EACA,mEAuBQ;EAtBR,+DAsBQ;EArBR,mEAAA;AzHmkdF;AyHjkdE;EAGE,uJAAA;EACA,mEAAA;EACA,+DAAA;AzHikdJ;AyH9jdE;EAIE,8EAAA;EACA,0EAAA;AzH6jdJ;AyHhjdI;EACE,qGAAA;AzHkjdN;AyHhjdM;EACE,qGAAA;AzHkjdR;;AyHzjdE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,kEAAA;AzHyldF;AyHvldE;EAGE,uJAAA;EACA,kEAAA;EACA,8DAAA;AzHuldJ;AyHpldE;EAIE,6EAAA;EACA,yEAAA;AzHmldJ;AyHtkdI;EACE,mGAAA;AzHwkdN;AyHtkdM;EACE,mGAAA;AzHwkdR;;AyH/kdE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,gEAAA;AzH+mdF;AyH7mdE;EAGE,qJAAA;EACA,gEAAA;EACA,4DAAA;AzH6mdJ;AyH1mdE;EAIE,2EAAA;EACA,yEAAA;AzHymdJ;AyH5ldI;EACE,iGAAA;AzH8ldN;AyH5ldM;EACE,iGAAA;AzH8ldR;;AyHrmdE;EA5BA,4GAAA;EACA,iEAuBQ;EAtBR,6DAsBQ;EArBR,kEAAA;AzHqodF;AyHnodE;EAGE,uJAAA;EACA,kEAAA;EACA,8DAAA;AzHmodJ;AyHhodE;EAIE,6EAAA;EACA,yEAAA;AzH+ndJ;AyHlndI;EACE,qGAAA;AzHondN;AyHlndM;EACE,qGAAA;AzHondR;;AyH3ndE;EA5BA,wFAAA;EACA,6CAuBQ;EAtBR,yCAsBQ;EArBR,6CAAA;AzH2pdF;AyHzpdE;EAGE,wGAAA;EACA,6CAAA;EACA,yCAAA;AzHypdJ;AyHtpdE;EAIE,wDAAA;EACA,gCAAA;AzHqpdJ;AyHxodI;EACE,uGAAA;AzH0odN;AyHxodM;EACE,uGAAA;AzH0odR;;AyHjpdE;EA5BA,qGAAA;EACA,0DAuBQ;EAtBR,sDAsBQ;EArBR,uBAAA;AzHirdF;AyH/qdE;EAGE,oIAAA;EACA,uBAAA;EACA,mBAAA;AzH+qdJ;AyH5qdE;EAIE,kCAAA;EACA,yDAAA;AzH2qdJ;AyH9pdI;EACE,iGAAA;AzHgqdN;AyH9pdM;EACE,iGAAA;AzHgqdR;;AyHzpdE;EACE,0CAAA;AzH4pdJ;;AyHhpdE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD8/df;A8B1jeE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,oCAjBa;A9B6kejB;A8BzjeE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,oCAxBa;EA6BX,qDAAA;A9BsjeN;A8BljeE;EAKE,WAlCa;EAmCb,wCArCkB;EAwClB,qBAvCc;A9BqlelB;A8B5ieI;EAKI,qDAAA;A9B0ieR;A8BrieE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADshef;AyH3qdI;EACE,mGAAA;AzH6qdN;AyH3qdM;EACE,mGAAA;AzH6qdR;;AyHprdE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADkief;A8B9leE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,kCAjBa;A9BinejB;A8B7leE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,kCAxBa;EA6BX,mDAAA;A9B0leN;A8BtleE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,mCAvCc;A9BynelB;A8BhleI;EAKI,mDAAA;A9B8keR;A8BzkeE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD0jef;AyH/sdI;EACE,uGAAA;AzHitdN;AyH/sdM;EACE,uGAAA;AzHitdR;;AyHxtdE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADskef;A8BloeE;EACE,WAdY;ERRd,2CQMmB;EAkBjB,mCAjBa;A9BqpejB;A8BjoeE;EAEE,WArBY;ERRd,2CQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9B8neN;A8B1neE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9B6pelB;A8BpneI;EAKI,kDAAA;A9BkneR;A8B7meE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD8lef;AyHnvdI;EACE,qGAAA;AzHqvdN;AyHnvdM;EACE,qGAAA;AzHqvdR;;AyH5vdE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD0mef;A8BtqeE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,mCAjBa;A9ByrejB;A8BrqeE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BkqeN;A8B9peE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BiselB;A8BxpeI;EAKI,mDAAA;A9BspeR;A8BjpeE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADkoef;AyHvxdI;EACE,qGAAA;AzHyxdN;AyHvxdM;EACE,qGAAA;AzHyxdR;;AyHhydE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD8oef;A8B1seE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,mCAjBa;A9B6tejB;A8BzseE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BsseN;A8BlseE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BquelB;A8B5reI;EAKI,mDAAA;A9B0reR;A8BrreE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADsqef;AyH3zdI;EACE,qGAAA;AzH6zdN;AyH3zdM;EACE,qGAAA;AzH6zdR;;AyHp0dE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADkref;A8B9ueE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,kCAjBa;A9BiwejB;A8B7ueE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,kCAxBa;EA6BX,kDAAA;A9B0ueN;A8BtueE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,oCAvCc;A9BywelB;A8BhueI;EAKI,kDAAA;A9B8teR;A8BzteE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD0sef;AyH/1dI;EACE,mGAAA;AzHi2dN;AyH/1dM;EACE,mGAAA;AzHi2dR;;AyHx2dE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADstef;A8BlxeE;EACE,WAdY;ERRd,6CQMmB;EAkBjB,sCAjBa;A9BqyejB;A8BjxeE;EAEE,WArBY;ERRd,6CQMmB;EAyBjB,sCAxBa;EA6BX,kDAAA;A9B8weN;A8B1weE;EAKE,WAlCa;EAmCb,0CArCkB;EAwClB,sCAvCc;A9B6yelB;A8BpweI;EAKI,kDAAA;A9BkweR;A8B7veE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD8uef;AyHn4dI;EACE,uGAAA;AzHq4dN;AyHn4dM;EACE,uGAAA;AzHq4dR;;AyH54dE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD0vef;A8BtzeE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9By0ejB;A8BrzeE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9BkzeN;A8B9yeE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,+BAvCc;A9Bi1elB;A8BxyeI;EAKI,kDAAA;A9BsyeR;A8BjyeE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADkxef;AyHv6dI;EACE,iGAAA;AzHy6dN;AyHv6dM;EACE,iGAAA;AzHy6dR;;AyHh7dE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD8xef;A8B11eE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9B62ejB;A8Bz1eE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9Bs1eN;A8Bl1eE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,qBAvCc;A9Bq3elB;A8B50eI;EAKI,mDAAA;A9B00eR;A8Br0eE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADszef;AyH38dI;EACE,iGAAA;AzH68dN;AyH38dM;EACE,iGAAA;AzH68dR;;AyHp9dE;E3FzaA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADk0ef;A8B93eE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,qCAjBa;A9Bi5ejB;A8B73eE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,qCAxBa;EA6BX,oDAAA;A9B03eN;A8Bt3eE;EAKE,WAlCa;EAmCb,yCArCkB;EAwClB,mCAvCc;A9By5elB;A8Bh3eI;EAKI,oDAAA;A9B82eR;A8Bz2eE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD01ef;AyH/+dI;EACE,qGAAA;AzHi/dN;AyH/+dM;EACE,qGAAA;AzHi/dR;;AyHz+dI;EACE,mGAAA;AzH4+dN;;AyH7+dI;EACE,uGAAA;AzHg/dN;;AyHj/dI;EACE,qGAAA;AzHo/dN;;AyHr/dI;EACE,qGAAA;AzHw/dN;;AyHz/dI;EACE,qGAAA;AzH4/dN;;AyH7/dI;EACE,mGAAA;AzHggeN;;AyHjgeI;EACE,uGAAA;AzHogeN;;AyHrgeI;EACE,iGAAA;AzHwgeN;;AyHzgeI;EACE,iGAAA;AzH4geN;;AyH7geI;EACE,qGAAA;AzHgheN;;AyH1geE;E3F/XA,c7BCa;E6BAb,qBAAA;A9B64eF;A8B34eE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADk5ef;A8B14eE;EAEE,0CAAA;A9B24eJ;A8Bx4eE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD05ef;A8Bp4eI;EAKI,0CAAA;A9Bk4eR;A8B73eE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B83eJ;AyHhieI;EACE,mGAAA;AzHkieN;AyHhieM;EAIE,mGAAA;AzH+heR;AyH5heM;EACE,oDAAA;AzH8heR;;AyH5ieE;E3F/XA,c7BCa;E6BAb,qBAAA;A9B+6eF;A8B76eE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADo7ef;A8B56eE;EAEE,4CAAA;A9B66eJ;A8B16eE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD47ef;A8Bt6eI;EAKI,4CAAA;A9Bo6eR;A8B/5eE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bg6eJ;AyHlkeI;EACE,uGAAA;AzHokeN;AyHlkeM;EAIE,uGAAA;AzHikeR;AyH9jeM;EACE,sDAAA;AzHgkeR;;AyH9keE;E3F/XA,c7BCa;E6BAb,qBAAA;A9Bi9eF;A8B/8eE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADs9ef;A8B98eE;EAEE,2CAAA;A9B+8eJ;A8B58eE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD89ef;A8Bx8eI;EAKI,2CAAA;A9Bs8eR;A8Bj8eE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bk8eJ;AyHpmeI;EACE,qGAAA;AzHsmeN;AyHpmeM;EAIE,qGAAA;AzHmmeR;AyHhmeM;EACE,qDAAA;AzHkmeR;;AyHhneE;E3F/XA,c7BCa;E6BAb,qBAAA;A9Bm/eF;A8Bj/eE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADw/ef;A8Bh/eE;EAEE,2CAAA;A9Bi/eJ;A8B9+eE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADggff;A8B1+eI;EAKI,2CAAA;A9Bw+eR;A8Bn+eE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bo+eJ;AyHtoeI;EACE,qGAAA;AzHwoeN;AyHtoeM;EAIE,qGAAA;AzHqoeR;AyHloeM;EACE,qDAAA;AzHooeR;;AyHlpeE;E3F/XA,c7BCa;E6BAb,qBAAA;A9BqhfF;A8BnhfE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD0hff;A8BlhfE;EAEE,2CAAA;A9BmhfJ;A8BhhfE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADkiff;A8B5gfI;EAKI,2CAAA;A9B0gfR;A8BrgfE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BsgfJ;AyHxqeI;EACE,qGAAA;AzH0qeN;AyHxqeM;EAIE,qGAAA;AzHuqeR;AyHpqeM;EACE,qDAAA;AzHsqeR;;AyHpreE;E3F/XA,c7BCa;E6BAb,qBAAA;A9BujfF;A8BrjfE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD4jff;A8BpjfE;EAEE,0CAAA;A9BqjfJ;A8BljfE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADokff;A8B9ifI;EAKI,0CAAA;A9B4ifR;A8BvifE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BwifJ;AyH1seI;EACE,mGAAA;AzH4seN;AyH1seM;EAIE,mGAAA;AzHyseR;AyHtseM;EACE,oDAAA;AzHwseR;;AyHtteE;E3F/XA,c7BCa;E6BAb,qBAAA;A9BylfF;A8BvlfE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD8lff;A8BtlfE;EAEE,4CAAA;A9BulfJ;A8BplfE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADsmff;A8BhlfI;EAKI,4CAAA;A9B8kfR;A8BzkfE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B0kfJ;AyH5ueI;EACE,uGAAA;AzH8ueN;AyH5ueM;EAIE,uGAAA;AzH2ueR;AyHxueM;EACE,sDAAA;AzH0ueR;;AyHxveE;E3F/XA,c7BCa;E6BAb,qBAAA;A9B2nfF;A8BznfE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADgoff;A8BxnfE;EAEE,yCAAA;A9BynfJ;A8BtnfE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADwoff;A8BlnfI;EAKI,yCAAA;A9BgnfR;A8B3mfE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B4mfJ;AyH9weI;EACE,iGAAA;AzHgxeN;AyH9weM;EAIE,iGAAA;AzH6weR;AyH1weM;EACE,mDAAA;AzH4weR;;AyH1xeE;E3F/XA,c7BCa;E6BAb,qBAAA;A9B6pfF;A8B3pfE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADkqff;A8B1pfE;EAEE,yCAAA;A9B2pfJ;A8BxpfE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD0qff;A8BppfI;EAKI,yCAAA;A9BkpfR;A8B7ofE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B8ofJ;AyHhzeI;EACE,iGAAA;AzHkzeN;AyHhzeM;EAIE,iGAAA;AzH+yeR;AyH5yeM;EACE,mDAAA;AzH8yeR;;AyH5zeE;E3F/XA,c7BCa;E6BAb,qBAAA;A9B+rfF;A8B7rfE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADosff;A8B5rfE;EAEE,2CAAA;A9B6rfJ;A8B1rfE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD4sff;A8BtrfI;EAKI,2CAAA;A9BorfR;A8B/qfE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BgrfJ;AyHl1eI;EACE,qGAAA;AzHo1eN;AyHl1eM;EAIE,qGAAA;AzHi1eR;AyH90eM;EACE,qDAAA;AzHg1eR;;AyH10eA;EACE,kBAAA;EpGxdI,qFoGydJ;AzH60eF;AqBlyfM;EoGmdN;IpGldQ,gBAAA;ErBqyfN;AACF;;AyH/0eA;EACE,sCAAA;AzHk1eF;;AyH/0eA;EACE,cAAA;AzHk1eF;;A0H/zfA;EACE,kUAAA;EAIA,kBzHkFe;EyHhFf,gBtHw9BkC;AJs2dpC;A0H5zfE;EACE,mBAAA;A1H8zfJ;A0H3zfE;EACE,yBAAA;EACA,0BAAA;EACA,czH0BI;EyHzBJ,iBAAA;A1H6zfJ;A0H1zfE;EACE,kBzHkEa;EyHjEb,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;A1H4zfJ;A0H1zfI;EACE,eAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A1H4zfN;A0HxzfM;EACE,YAAA;A1H0zfR;A0HrzfE;EACE,kUAAA;A1HuzfJ;;A0HhzfA;EpHtCI,mBAAA;EoHwCF,gBzHmDmB;ADgwfrB;A0HjzfE;EpH1CE,mBAAA;AN81fJ;A0HhzfE;EACE,qBAAA;EACA,sBAAA;A1HkzfJ;A0H/yfE;EACE,qBAAA;EACA,sBAAA;EpH5CA,4BAAA;EACA,6BAAA;AN81fJ;A0H/yfE;;EpHhDE,4BAAA;EACA,6BAAA;ANm2fJ;;A0H5yfI;EACE,gBAAA;EACA,czHxCE;ADu1fR;;A0HxyfI;EACE,mBzHhDE;EyHiDF,WzH/EE;AD03fR;;A0HryfE;EACE,gBAAA;A1HwyfJ;A0HryfE;EACE,gBAAA;A1HuyfJ;;A0HhyfE;;;EpHrFE,+BAAA;EACA,gCAAA;AN23fJ;;A0HhyfA;EACE,WzHzGM;EyH0GN,oBAAA;EACA,sBzHbmB;EyHcnB,kBAAA;EACA,UAAA;A1HmyfF;A0HjyfE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;A1HmyfJ;A0HhyfE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;A1HkyfJ;A0H/xfE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;A1HiyfJ;A0H/xfI;EACE,oBAAA;A1HiyfN;A0H9xfI;EACE,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;A1HgyfN;A0H9xfM;EACE,kBAAA;A1HgyfR;A0H5xfI;EACE,gBAAA;EACA,kBAAA;A1H8xfN;A0H1xfE;EACE,oBAAA;A1H4xfJ;;A0HxxfA;EACE,gBAAA;EACA,iBtH2Q4B;EsH1Q5B,SAAA;A1H2xfF;;A0HxxfA;EACE,0MtH4O4B;EsH5O5B,oCtH4O4B;EsH3O5B,eAAA;EACA,YAAA;A1H2xfF;;A0HvxfE;EACE,uBAAA;EACA,YAAA;A1H0xfJ;A0HxxfI;EACE,gBzHtFe;ADg3frB;A0HtxfE;EACE,+BAAA;A1HwxfJ;A0HtxfI;EACE,UAAA;A1HwxfN;;A0HhxfE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;A1HmxfJ;;A0H9wfE;EACE,cAAA;A1HixfJ;;A0H3wfI;EACE,MAAA;A1H8wfN;;A0HzwfA;EACE,+CAAA;A1H4wfF;;A0HrwfE;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;A1HuwfJ;A0HpwfE;EACE,gBzHjPI;EyHkPJ,UAAA;A1HswfJ;A0HnwfE;EACE,SAAA;EACA,+BtHguBgC;EsH/tBhC,UAAA;A1HqwfJ;A0HjwfI;EAEE,SAAA;EACA,YAAA;A1HkwfN;A0H/vfI;EACE,YAAA;A1HiwfN;A0H5vfI;EAEE,UAAA;EACA,WAAA;EACA,QAAA;A1H6vfN;A0H1vfI;EACE,QAAA;EACA,WAAA;A1H4vfN;A0HvvfI;EAEE,WAAA;EACA,UAAA;EACA,QAAA;A1HwvfN;A0HrvfI;EACE,QAAA;EACA,UAAA;A1HuvfN;A0HlvfI;EAEE,UAAA;EACA,UAAA;A1HmvfN;A0HhvfI;EACE,UAAA;A1HkvfN;A0H7ufI;EAEE,aAAA;A1H8ufN;;A0HvufA;EACE,YAAA;EACA,atHlFO;AJ4zfT;A0HxufE;EACE,oBAAA;EACA,kBzHpPa;EyHqPb,cAAA;EACA,mBAAA;A1H0ufJ;A0HvufE;EACE,gBAAA;A1HyufJ;;A0HrufA;EACE,YAAA;A1HwufF;;A0HnufA;EACE,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EpHhVE,gBAAA;EoHkVF,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mCAAA;A1HsufF;A0HpufE;EAEE,aAAA;A1HqufJ;;A2H9kgBE;EACE,mBAAA;A3HilgBJ;;A2H7kgBA;EACE,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;A3HglgBF;A2H9kgBE;EACE,c1H6BI;E0H5BJ,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;A3HglgBJ;A2H7kgBE;EACE,c1HHO;ADklgBX;A2H7kgBI;EACE,YAAA;EACA,c1HgBE;AD+jgBR;A2HzkgBI;EACE,YAAA;A3H2kgBN;;A2HrkgBE;EACE,yBAAA;EACA,0BAAA;EACA,c1HxBO;E0HyBP,iBAAA;EACA,oBAAA;A3HwkgBJ;A2HrkgBE;EACE,oBAAA;A3HukgBJ;A2HpkgBE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mB1HxCO;AD8mgBX;;A2HjkgBE;EACE,gBAAA;A3HokgBJ;;A2H7jgBI;EAEE,W1H1DE;ADyngBR;A2H7jgBM;EACE,W1H7DA;E0H8DA,YAAA;A3H+jgBR;A2H3jgBI;EACE,yBAAA;A3H6jgBN;;A2HpjgBE;EACE,6BAAA;EACA,gCAAA;A3HujgBJ;A2HrjgBI;EACE,UAAA;A3HujgBN;A2HjjgBI;EACE,sBAAA;A3HmjgBN;A2HhjgBI;EACE,uBAAA;A3HkjgBN;A2H/igBI;EACE,qBAAA;A3HijgBN;A2H7igBE;EACE,sBAAA;A3H+igBJ;A2HxigBM;EACE,sBAAA;A3H0igBR;A2HvigBM;EACE,uBAAA;A3HyigBR;A2HtigBM;EACE,qBAAA;A3HwigBR;A2HnigBE;EACE,cAAA;EACA,SAAA;EACA,eAAA;A3HqigBJ;;A4H1qgBA;EACE,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;A5H6qgBF;;A4H1qgBA;EACE,gBAAA;A5H6qgBF;;A4H1qgBA;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EtHLE,mBAAA;EsHOF,cAAA;A5H6qgBF;;A4H1qgBA;EACE,WAAA;EACA,YAAA;A5H6qgBF;;A4H1qgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A5H6qgBF;A4H3qgBE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EtHvBA,sBAAA;EsHyBA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,gB3HhCI;AD6sgBR;;A4HzqgBA;EACE,UAAA;EACA,WAAA;A5H4qgBF;;A4HxqgBE;EACE,gBAAA;A5H2qgBJ;A4HxqgBE;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;A5H0qgBJ;A4HxqgBI;EACE,WAAA;EACA,YAAA;A5H0qgBN;A4HvqgBI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;A5HyqgBN;A4HrqgBE;EACE,SAAA;EACA,WAAA;A5HuqgBJ;;A4HlqgBE;EACE,QAAA;EACA,UAAA;A5HqqgBJ;A4HlqgBE;EACE,QAAA;EACA,UAAA;A5HoqgBJ;A4HjqgBE;EACE,SAAA;EACA,WAAA;A5HmqgBJ;A4HhqgBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;A5HkqgBJ;;A4H9pgBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A5HiqgBF;;A4H5pgBA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;A5H+pgBF;A4H7pgBE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A5H+pgBJ;A4H7pgBI;EACE,cAAA;A5H+pgBN;A4H5pgBI;EACE,SAAA;EACA,WAAA;EACA,YAAA;A5H8pgBN;A4H1pgBE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;A5H4pgBJ;A4H1pgBI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,MAAA;EACA,QAAA;A5H4pgBN;A4H1pgBM;EACE,SAAA;EACA,QAAA;EACA,SAAA;A5H4pgBR;;A4HppgBE;EACE,mB3HxDqB;E2HyDrB,sEAAA;EACA,c3HxHI;E2HyHJ,kBAAA;EACA,YAAA;A5HupgBJ;A4HrpgBI;EACE,kBAAA;EACA,sBAAA;EACA,kBxHiRwB;EwHhRxB,cAAA;EACA,YAAA;A5HupgBN;A4HnpgBE;EACE,eAAA;A5HqpgBJ;A4HnpgBI;EACE,UAAA;A5HqpgBN;;A4H7ogBI;EACE,YAAA;A5HgpgBN;;A4H3ogBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;EtHvLE,mBAAA;ANs0gBJ;A4H5ogBE;EtH1LE,iCAAA;ANy0gBJ;;A4HzogBE;EACE,WAAA;EACA,YAAA;A5H4ogBJ;A4HxogBI;EACE,kBxHkOwB;AJw6f9B;;A4HpogBE;EACE,WAAA;EACA,YAAA;A5HuogBJ;A4HnogBI;EACE,kBxHsNwB;AJ+6f9B;;A4H/ngBE;EACE,WAAA;EACA,YAAA;A5HkogBJ;A4H9ngBI;EACE,iB3HxJS;ADwxgBf;;A4H1ngBE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;A5H6ngBJ;A4HzngBI;EACE,iBAAA;EACA,kB3HxKW;ADmygBjB;A4HtngBI;EACE,mBAAA;A5HwngBN;;A4HnngBA;EACE,sBAAA;EACA,gBAAA;A5HsngBF;A4HpngBE;EACE,WAAA;EACA,YAAA;A5HsngBJ;;A4HjngBE;EACE,UAAA;EACA,kBAAA;A5HongBJ;A4HlngBI;EACE,UAAA;A5HongBN;A4HjngBI;EACE,kBAAA;A5HmngBN;A4HjngBI;EACE,kBAAA;A5HmngBN;A4HjngBI;EACE,kBAAA;A5HmngBN;A4HjngBI;EACE,kBAAA;A5HmngBN;A4HhngBI;EAEE,yBAAA;A5HingBN;A4HllgBA;EACE,oCAAA;EACA,2CAAA;EACA,kBAAA;A5H2mgBF;A4HzmgBE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,gEAAA;EACA,2CAAA;A5HwmgBJ;A4HrmgBE;EACE,8BAAA;EACA,gCAAA;A5HumgBJ;;A6Hz8gBA;EACE,kU5H2GmB;E4H1GnB,eAAA;EACA,oBAAA;A7H48gBF;A6H18gBE;EACE,SAAA;A7H48gBJ;A6H18gBI;EvHgBA,+BAAA;EACA,gCAAA;AN67gBJ;A6Hv8gBI;;;EAEE,oCAAA;EACA,+BAAA;A7H08gBN;A6Hr8gBI;;EAEE,yBAAA;A7Hu8gBN;A6Hn8gBE;EACE,aAAA;EACA,mBAAA;A7Hq8gBJ;;A6Hj8gBA;EACE,iBAAA;EACA,mBAAA;A7Ho8gBF;;A6Hj8gBA;EACE,kBAAA;A7Ho8gBF;;A6Hh8gBE;EACE,eAAA;EACA,gBAAA;EAQA,c5HpCO;ADg+gBX;A6Hl8gBI;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;A7Ho8gBN;A6H/7gBI;EACE,c5HhBE;ADi9gBR;;A6H57gBA;;EAEE,yBAAA;EACA,6DAAA;EACA,iBAAA;EACA,kB5HmBe;AD46gBjB;;A6H57gBA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;A7H+7gBF;A6H77gBE;EACE,SAAA;EACA,UAAA;EACA,YAAA;A7H+7gBJ;A6H57gBE;EACE,cAAA;A7H87gBJ;A6H17gBI;EACE,WAAA;EACA,iBAAA;A7H47gBN;A6Hz7gBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;A7H27gBN;A6Hv7gBE;EACE,kBAAA;EACA,oBAAA;A7Hy7gBJ;A6Ht7gBE;EACE,oBAAA;EACA,YAAA;EACA,WAAA;A7Hw7gBJ;A6Ht7gBI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;A7Hw7gBN;A6Hr7gBI;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,c5HzGK;ADgihBX;A6Hr7gBM;EACE,WAAA;EvHhHJ,mBAAA;EuHkHI,mB5HvFA;E4HwFA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;A7Hu7gBR;A6Hp7gBM;EACE,c5HlGA;ADwhhBR;A6Hn7gBM;EACE,c5HtGA;AD2hhBR;A6Hn7gBQ;EACE,UAAA;A7Hq7gBV;A6H76gBM;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;A7H+6gBR;A6H16gBQ;EACE,mBAAA;A7H46gBV;;A6Hr6gBA;EACE,6BAAA;EACA,iBAAA;A7Hw6gBF;;A6Hp6gBE;EACE,kUAAA;A7Hu6gBJ;;A6H/5gBE;EACE,kUAAA;A7Hk6gBJ;;A6H35gBA;EACE,mBzHiDO;EyHhDP,mB5H5Ga;E4H6Gb,8DAAA;A7H85gBF;;A6H15gBE;EACE,sMAAA;A7H65gBJ;;A6H95gBE;EACE,8MAAA;A7Hi6gBJ;;A6Hl6gBE;EACE,0MAAA;A7Hq6gBJ;;A6Ht6gBE;EACE,0MAAA;A7Hy6gBJ;;A6H16gBE;EACE,0MAAA;A7H66gBJ;;A6H96gBE;EACE,sMAAA;A7Hi7gBJ;;A6Hl7gBE;EACE,8MAAA;A7Hq7gBJ;;A6Ht7gBE;EACE,kMAAA;A7Hy7gBJ;;A6H17gBE;EACE,kMAAA;A7H67gBJ;;A6H97gBE;EACE,0MAAA;A7Hi8gBJ;;A6Hx7gBA;EACE,kBAAA;EACA,YAAA;A7H27gBF;;A6Ht7gBI;EACE,kU5HhHe;ADyihBrB;;A8HrphBA;;EAEE,mB1HmPO;AJq6gBT;;A8HrphBA;EACE,iBAAA;A9HwphBF;A8HtphBE;EACE,eAAA;A9HwphBJ;;A8HjphBI;EACE,yBAAA;A9HophBN;A8HjphBI;EACE,c7HqBE;AD8nhBR;;A8H3ohBI;EACE,yBAAA;A9H8ohBN;A8H3ohBI;EACE,mB7HQE;ADqohBR;A8H3ohBM;EACE,sBAAA;A9H6ohBR;;A8HrohBA;EACE,kBAAA;A9HwohBF;;A8HrohBA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;A9HwohBF;;A8HrohBA;EACE,sBAAA;A9HwohBF;;A8HrohBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;A9HwohBF;A8HtohBE;EACE,c7HzBI;ADiqhBR;A8HrohBE;EACE,UAAA;A9HuohBJ;;A8HnohBA;EACE,c7HlCM;ADwqhBR;;A8HnohBA;EACE,YAAA;EACA,mBAAA;A9HsohBF;;A8HnohBA;EACE,UAAA;A9HsohBF;;A8HnohBA;EACE,kBAAA;A9HsohBF;;A8HnohBA;EACE,kBAAA;A9HsohBF;;A8HnohBA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;A9HsohBF;;A8HhohBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EAEA,cAAA;EACA,aAAA;ExHjGA,mBAAA;EwHmGA,yBAAA;EACA,UAAA;A9HkohBJ;A8HhohBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,c7HrFE;ADuthBR;A8HhohBM;EACE,c7H7GG;AD+uhBX;A8H/nhBM;EACE,W7H1HA;AD2vhBR;A8H/nhBQ;EACE,W7H7HF;AD8vhBR;A8H5nhBI;EACE,uBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,eAAA;A9H6nhBN;A8H3nhBM;EACE,kBAAA;EACA,WAAA;EACA,gB7H7IA;E6H8IA,WAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;ExH9IJ,mBAAA;AN4whBJ;A8H1nhBM;EACE,uBAAA;EACA,gBAAA;ExHpJJ,mBAAA;EwHsJI,6BAAA;A9H4nhBR;A8HznhBM;EACE,iBAAA;A9H2nhBR;;A8HnnhBA;EACE,gB1HmEO;AJmjhBT;;A8H9mhBA;ExH3KI,sBAAA;EwH6KF,mB7HlJM;E6HmJN,eAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,a1H8I4B;E0H7I5B,QAAA;EACA,iBAAA;EACA,iBAAA;A9HinhBF;A8H/mhBE;EACE,aAAA;A9HinhBJ;;A8H5mhBA;EACE,kBAAA;EACA,UAAA;EACA,W7HzMM;E6H0MN,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;A9H+mhBF;;A8H5mhBA;EACE,iIAAA;A9H+mhBF;;A8H1mhBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gB7HhImB;E6HiInB,kBAAA;EACA,oBAAA;EACA,kB7HnJe;E6HoJf,c7HxNS;E6HyNT,gBAAA;EACA,gBAAA;EACA,sB7HlOM;E6HmON,4BAAA;EACA,qCAAA;ExHjOE,sBAAA;EwHmOF,kU7HtImB;ADmvhBrB;A8H3mhBE;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gB1HoL0B;E0HnL1B,c7HrOO;E6HsOP,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;A9H6mhBJ;A8H3mhBI;EAEE,uCAAA;EACA,qBAAA;EACA,mB7H7JmB;ADywhBzB;;A8HvmhBA;EACE,cAAA;A9H0mhBF;A8HxmhBE;EACE,c7HpOI;AD80hBR;;A8HpmhBA;EACE,WAAA;A9HumhBF;;A8HpmhBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,yB7HnPM;EK3BJ,mBAAA;EwHgRF,yDAAA;EACA,UAAA;A9HumhBF;;A8HnmhBE;EACE,kBAAA;A9HsmhBJ;A8HpmhBI;EACE,eAAA;EACA,mBAAA;A9HsmhBN;A8HpmhBM;EACE,oBAAA;EACA,gBAAA;A9HsmhBR;A8HjmhBE;EACE,qCAAA;EACA,oBAAA;A9HmmhBJ;A8HhmhBE;EACE,a1HnEK;E0HoEL,SAAA;A9HkmhBJ;A8H7lhBI;EACE,+BAAA;A9H+lhBN;A8H7lhBM;EACE,W7HtTA;ADq5hBR;A8H3lhBI;EACE,W7H3TE;ADw5hBR;A8H1lhBI;EACE,+DAAA;A9H4lhBN;;A8HtlhBE;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;A9HylhBJ;A8HvlhBI;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;A9HylhBN;A8HrlhBE;EACE,kBAAA;EACA,WtD7Vc;EsD8Vd,UAAA;A9HulhBJ;A8HplhBE;EACE,sBAAA;A9HslhBJ;A8HnlhBE;EACE,W7H5VI;ADi7hBR;A8HllhBE;EACE,YAAA;EACA,aAAA;ExH9VA,sBAAA;EwHgWA,iIAAA;A9HolhBJ;;A8H7khBE;EACE,aAAA;A9HglhBJ;A8H7khBE;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;A9H+khBJ;A8H5khBE;EACE,YAAA;A9H8khBJ;;A8H1khBA;EACE,gCAAA;A9H6khBF;A8H3khBE;EACE,qBAAA;EACA,mBAAA;EACA,kB7HrTa;ADk4hBjB;A8HzkhBI;EACE,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A9H2khBN;A8HxkhBI;EACE,WAAA;EACA,gBAAA;A9H0khBN;;A8HnkhBE;;EACE,SAAA;EACA,UAAA;EACA,kBAAA;A9HukhBJ;A8HrkhBI;;;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;A9HwkhBN;A8HrkhBI;;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;A9HukhBN;;A8H/jhBE;EACE,UAAA;EACA,YAAA;A9HkkhBJ;A8HhkhBI;EACE,kB1HdwB;E0HexB,gBAAA;A9HkkhBN;A8H/jhBI;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;A9HikhBN;A8H9jhBI;EACE,SAAA;A9HgkhBN;A8H9jhBM;EACE,iBAAA;EACA,+BAAA;EACA,mB7HzcG;ADygiBX;A8H9jhBQ;EACE,gB7H7cF;AD6giBR;A8H/jhBU;EACE,W7HrcJ;E6HscI,YAAA;A9HikhBZ;A8H7jhBQ;EACE,gB7HrdF;E6HsdE,gBAAA;A9H+jhBV;A8H5jhBQ;EACE,gB7H1dF;ADwhiBR;A8H5jhBU;EACE,W7HndJ;E6HodI,YAAA;A9H8jhBZ;A8HxjhBQ;EACE,eAAA;A9H0jhBV;;A+H7iiBA;EzHiBI,sBAAA;EyHfF,yBAAA;A/HgjiBF;A+H9iiBE;EACE,+BAAA;A/HgjiBJ;A+H9iiBI;EACE,aAAA;EACA,YAAA;A/HgjiBN;A+H9iiBM;;;EAGE,qBAAA;A/HgjiBR;A+H5iiBQ;EACE,SAAA;A/H8iiBV;A+HziiBI;EACE,oCAAA;A/H2iiBN;A+HziiBM;EACE,4B9HZG;ADujiBX;;AgIvkiBA;;EAEE,mB/HaS;AD6jiBX;;AgIvkiBA;E1HmCI,mCAAA;EACA,kCAAA;ANwiiBJ;;AgIxkiBA;EACE,4L/H6GsB;EKtGpB,sBAAA;ANqkiBJ;;AiItjiBA;;EAAA;AC9BA;EACE;IACE,mBAAA;IACA,UAAA;ElI0liBF;EkIxliBA;IACE,qBAAA;IACA,YAAA;ElI0liBF;EkIxliBA;IACE,mBAAA;IACA,UAAA;ElI0liBF;AACF;AkIpliBI;EACE,0EAAA;AlIsliBN;AkIvliBI;EACE,0EAAA;AlIyliBN;AkI1liBI;EACE,0EAAA;AlI4liBN;AkI7liBI;EACE,sEAAA;AlI+liBN;AkIvliBE;EC9BA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;ED8BE,qBAAA;AlI4liBJ;;AoIzniBA;EACE;IACE,2BAAA;EpI4niBF;EoI1niBA;IACE,4BAAA;EpI4niBF;EoI1niBA;IACE,wBAAA;EpI4niBF;AACF;AoIvniBI;EACE,2DAAA;ApIyniBN;AoI1niBI;EACE,2DAAA;ApI4niBN;AoI7niBI;EACE,2DAAA;ApI+niBN;AoIhoiBI;EACE,uDAAA;ApIkoiBN;AoI1niBE;ED5BA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EC4BE,qBAAA;ApI+niBJ;;AqI7piBA;EACE;IACE,mBAAA;ErIgqiBF;EqI9piBA;IACE,mBAAA;IACA,UAAA;ErIgqiBF;AACF;AqI3piBE;EFdA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EEcE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gDAAA;ArIgqiBJ;;AsInriBA;EACE;IACE,uBAAA;EtIsriBF;EsIpriBA;IACE,yBAAA;EtIsriBF;EsIpriBA;IACE,yBAAA;EtIsriBF;AACF;AsInriBA;EACE,kBAAA;AtIqriBF;AsInriBE;EHjBA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EGiBE,kBAAA;AtIwriBJ;AsItriBI;EACE,qEAAA;AtIwriBN;AsIrriBI;EH3BF,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EK6BH,WAAA;EACA,kBAAA;EACA,YAAA;AtI0riBN;AsIvriBI;EACE,QAAA;EACA,WAAA;AtIyriBN;AsItriBI;EACE,QAAA;EACA,UAAA;AtIwriBN;;AuIhuiBA;EACE;IACE,gCAAA;EvImuiBF;EuIjuiBA;IACE,oCAAA;EvImuiBF;EuIjuiBA;IACC,kCAAA;EvImuiBD;AACF;AuI9tiBE;EJhBA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EIgBE,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;AvImuiBJ;;AwI3viBA;EACE;IACE,gCAAA;ExI8viBF;EwI5viBA;IACE,oCAAA;ExI8viBF;EwI5viBA;IACC,kCAAA;ExI8viBD;AACF;AwI3viBA;EACE;IACE,qBAAA;ExI6viBF;EwI3viBA;IACE,mBAAA;ExI6viBF;AACF;AwI1viBA;EACE,kBAAA;EACA,4BAAA;AxI4viBF;AwI1viBE;ELvBA,yBAAA;EK0BE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AxI2viBJ;AwIzviBI;EACE,mBvISE;EuIRF,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,mEAAA;AxI2viBN;AwIxviBI;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,qDAAA;EACA,oEAAA;EACA,sBAAA;AxI0viBN;;AyI/yiBA;EACE;IACE,gCAAA;EzIkziBF;EyIhziBA;IACE,oCAAA;EzIkziBF;EyIhziBA;IACC,kCAAA;EzIkziBD;AACF;AyI/yiBA;EACE,kBAAA;AzIiziBF;AyI/yiBE;ENbA,yBAAA;EMgBE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;AzIgziBJ;AyI9yiBI;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,qDAAA;EACA,4BAAA;AzIgziBN;;A0Ir1iBA;EACE;IACE,qBAAA;IACA,UAAA;E1Iw1iBF;E0It1iBA;IACE,mBAAA;IACA,YAAA;E1Iw1iBF;E0It1iBA;IACE,UAAA;E1Iw1iBF;AACF;A0In1iBE;EPdA,yBAAA;EOiBE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,+EAAA;A1Io1iBJ;;A2Ix2iBA;EACE;IACE,qBAAA;IACA,UAAA;E3I22iBF;E2Iz2iBA;IACE,mBAAA;IACA,YAAA;E3I22iBF;E2Iz2iBA;IACE,UAAA;E3I22iBF;AACF;A2Ih2iBA;EAGE,kBAAA;EACA,4BAAA;A3Ig2iBF;A2I12iBI;EACE,sBAAA;A3I42iBN;A2I72iBI;EACE,sBAAA;A3I+2iBN;A2Ih3iBI;EACE,sBAAA;A3Ik3iBN;A2In3iBI;EACE,sBAAA;A3Iq3iBN;A2I12iBE;ER7BA,yBAAA;EQgCE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WApCG;EAqCH,YArCG;EAsCH,mBAAA;EACA,yBAAA;EACA,2FAAA;A3I22iBJ;;A4Ip5iBA;EACE;IACE,YAAA;IACA,sBAAA;E5Iu5iBF;E4Ir5iBA;IACE,UAAA;IACA,mBAAA;E5Iu5iBF;AACF;A4Il5iBE;ETfA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;ESeE,qBAAA;EACA,4CAAA;A5Iu5iBJ;A4Ir5iBI;EACE,kCAAA;A5Iu5iBN;;A6Iz6iBA;EACE;IACE,mBAAA;IACA,UAAA;E7I46iBF;E6I16iBA;IACE,UAAA;E7I46iBF;E6I16iBA;IACE,mBAAA;IACA,UAAA;E7I46iBF;AACF;A6Ij6iBA;EAGE,kBAAA;EACA,4BAAA;A7Ii6iBF;A6I36iBI;EACE,sBAAA;A7I66iBN;A6I96iBI;EACE,sBAAA;A7Ig7iBN;A6Ir6iBE;EVjCA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EUiCE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAvCG;EAwCH,YAxCG;EAyCH,oDAAA;A7I06iBJ;;A8Il9iBA;EACE;IACE,iCAAA;E9Iq9iBF;E8In9iBA;IACE,+BAAA;E9Iq9iBF;E8In9iBA;IACE,8BAAA;E9Iq9iBF;AACF;A8Il9iBA;EACE;IACE,gCAAA;E9Io9iBF;E8Il9iBA;IACE,iCAAA;E9Io9iBF;E8Il9iBA;IACE,8BAAA;E9Io9iBF;AACF;A8Ij9iBA;EACE;IACE,gCAAA;E9Im9iBF;E8Ij9iBA;IACE,kCAAA;E9Im9iBF;E8Ij9iBA;IACE,8BAAA;E9Im9iBF;AACF;A8Il8iBA;EACE,kBAAA;EAEA,wDAAA;A9Im8iBF;A8Ih9iBI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;A9Ik9iBN;A8Iv9iBI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;A9Iy9iBN;A8I99iBI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;A9Ig+iBN;A8It9iBE;EXvDA,yBAAA;EW0DE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;A9Iu9iBJ;A8Ir9iBI;EACE,SAnEG;A9I0hjBT;A8Ip9iBI;EACE,UAAA;A9Is9iBN;A8In9iBI;EACE,SA3EG;EA4EH,UA5EG;A9IiijBT;;A+I/hjBA;EACE;IACE,qBAAA;E/IkijBF;E+IhijBA;IACE,4BAAA;E/IkijBF;E+IhijBA;IACE,qBAAA;E/IkijBF;E+IhijBA;IACE,2BAAA;E/IkijBF;E+IhijBA;IACE,wBAAA;IACA,mBAAA;E/IkijBF;AACF;A+I/hjBA;EACE;IACE,qBAAA;E/IiijBF;E+I/hjBA;IACE,2BAAA;E/IiijBF;E+I/hjBA;IACE,qBAAA;E/IiijBF;E+I/hjBA;IACE,4BAAA;E/IiijBF;E+I/hjBA;IACE,wBAAA;IACA,sBAAA;E/IiijBF;AACF;A+I5hjBE;EZ5CA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EY4CE,qBAAA;EACA,sBAAA;EACA,6DAAA;EACA,mCAAA;EACA,kBAAA;A/IiijBJ;A+I/hjBI;EACE,oCAAA;A/IiijBN;A+I9hjBI;EACE,mCAAA;A/IgijBN;;AgJzljBA;EACE;IACE,YAAA;EhJ4ljBF;EgJ1ljBA;IACE,UAAA;EhJ4ljBF;AACF;AgJ/kjBA;EAEE,WAAA;AhJgljBF;AgJ1ljBI;EACE,sBAAA;EACA,yBAAA;AhJ4ljBN;AgJ9ljBI;EACE,sBAAA;EACA,yBAAA;AhJgmjBN;AgJlmjBI;EACE,sBAAA;EACA,yBAAA;AhJomjBN;AgJtmjBI;EACE,sBAAA;EACA,yBAAA;AhJwmjBN;AgJ1mjBI;EACE,sBAAA;EACA,yBAAA;AhJ4mjBN;AgJ9mjBI;EACE,sBAAA;EACA,yBAAA;AhJgnjBN;AgJlnjBI;EACE,sBAAA;EACA,yBAAA;AhJonjBN;AgJtnjBI;EACE,uBAAA;EACA,yBAAA;AhJwnjBN;AgJ1njBI;EACE,sBAAA;EACA,yBAAA;AhJ4njBN;AgJlnjBE;EbzBA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EayBE,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,mCAAA;EACA,kBAAA;AhJunjBJ;;AiJtpjBA;EACE;IACE,mBAAA;EjJypjBF;EiJvpjBA;IACE,qBAAA;IACA,YAAA;EjJypjBF;EiJvpjBA;IACE,mBAAA;IACA,UAAA;EjJypjBF;AACF;AiJ5ojBA;EAEE,WAAA;AjJ6ojBF;AiJvpjBI;EACE,uBAAA;EACA,yBAAA;AjJypjBN;AiJ3pjBI;EACE,sBAAA;EACA,yBAAA;AjJ6pjBN;AiJ/pjBI;EACE,sBAAA;EACA,yBAAA;AjJiqjBN;AiJnqjBI;EACE,sBAAA;EACA,yBAAA;AjJqqjBN;AiJvqjBI;EACE,sBAAA;EACA,yBAAA;AjJyqjBN;AiJ3qjBI;EACE,sBAAA;EACA,yBAAA;AjJ6qjBN;AiJ/qjBI;EACE,uBAAA;EACA,yBAAA;AjJirjBN;AiJnrjBI;EACE,sBAAA;EACA,yBAAA;AjJqrjBN;AiJvrjBI;EACE,sBAAA;EACA,yBAAA;AjJyrjBN;AiJ/qjBE;Ed9BA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;Ec8BE,qBAAA;EACA,WAAA;EACA,+BAAA;EACA,mCAAA;EACA,kBAAA;AjJorjBJ;;AkJrtjBA;EACE;IACE,YAAA;IACA,qBAAA;ElJwtjBF;EkJttjBA;IACE,UAAA;IACA,mBAAA;ElJwtjBF;AACF;AkJhrjBA;EAGE,kBAAA;EACA,UAAA;EACA,WAAA;AlJgrjBF;AkJxtjBI;EAKI,SApBC;EAqBD,OAAA;EAwBF,0DAAA;AlJ+rjBN;AkJ7tjBI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,0DAAA;AlJosjBN;AkJlujBI;EAWI,MAAA;EACA,UA3BC;EA6CH,0DAAA;AlJysjBN;AkJvujBI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,yDAAA;AlJ8sjBN;AkJ5ujBI;EAiBI,UAAA;EACA,OAAA;EAYF,0DAAA;AlJmtjBN;AkJjvjBI;EAoBI,qBAAA;EACA,sBAAA;EASF,0DAAA;AlJwtjBN;AkJtvjBI;EAuBI,MAAA;EACA,WAAA;EAMF,0DAAA;AlJ6tjBN;AkJ3vjBI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,0DAAA;AlJkujBN;AkJttjBE;Ef5DA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;Ee4DE,kBAAA;AlJ2tjBJ;;AmJvxjBA;EACE;IACE,YAAA;EnJ0xjBF;EmJxxjBA;IACE,UAAA;EnJ0xjBF;AACF;AmJlvjBA;EAEE,kBAAA;AnJmvjBF;AmJxxjBI;EAKI,SAlBC;EAmBD,OAAA;EAwBF,mDAAA;AnJ+vjBN;AmJ7xjBI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,mDAAA;AnJowjBN;AmJlyjBI;EAWI,MAAA;EACA,UAzBC;EA2CH,mDAAA;AnJywjBN;AmJvyjBI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,mDAAA;AnJ8wjBN;AmJ5yjBI;EAiBI,UAAA;EACA,OAAA;EAYF,mDAAA;AnJmxjBN;AmJjzjBI;EAoBI,qBAAA;EACA,sBAAA;EASF,mDAAA;AnJwxjBN;AmJtzjBI;EAuBI,MAAA;EACA,WAAA;EAMF,mDAAA;AnJ6xjBN;AmJ3zjBI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,mDAAA;AnJkyjBN;AmJzxjBE;EhBlDA,yBAAA;EgBqDE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AnJ0xjBJ;;AoJn1jBA;EACE;IACE,kCAAA;EpJs1jBF;EoJp1jBA;IACE,iCAAA;EpJs1jBF;EoJp1jBA;IACE,0BAAA;EpJs1jBF;AACF;AoJn1jBA;EACE;IACE,gCAAA;EpJq1jBF;EoJn1jBA;IACE,iCAAA;EpJq1jBF;EoJn1jBA;IACE,0BAAA;EpJq1jBF;AACF;AoJl1jBA;EACE,kBAAA;EACA,kCAAA;ApJo1jBF;AoJl1jBE;EjBhCA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EiBgCE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;ApJu1jBJ;AoJr1jBI;EACE,2CAAA;ApJu1jBN;AoJp1jBI;EACE,2CAAA;ApJs1jBN;;AqJh4jBA;EACE;IACE,kCAAA;ErJm4jBF;EqJj4jBA;IACE,iCAAA;ErJm4jBF;EqJj4jBA;IACE,0BAAA;ErJm4jBF;EqJj4jBA;IACE,iCAAA;ErJm4jBF;EqJj4jBA;IACE,kCAAA;ErJm4jBF;EqJj4jBA;IACE,0BAAA;ErJm4jBF;AACF;AqJh4jBA;EACE;IACE,gCAAA;ErJk4jBF;EqJh4jBA;IACE,iCAAA;ErJk4jBF;EqJh4jBA;IACE,0BAAA;ErJk4jBF;EqJh4jBA;IACE,iCAAA;ErJk4jBF;EqJh4jBA;IACE,gCAAA;ErJk4jBF;EqJh4jBA;IACE,0BAAA;ErJk4jBF;AACF;AqJ/3jBA;EACE,kBAAA;EACA,kCAAA;ArJi4jBF;AqJ/3jBE;ElBlDA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EkBkDE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;ArJo4jBJ;AqJl4jBI;EACE,mDAAA;ArJo4jBN;AqJj4jBI;EACE,mDAAA;ArJm4jBN;;AiI34jBA;;EAAA;AqBrDA;EACE;IACE,oBAAA;EtJs8jBF;EsJp8jBA;IACE,sBAAA;EtJs8jBF;EsJp8jBA;IACE,oBAAA;EtJs8jBF;AACF;AsJj8jBI;EACE,2EAAA;AtJm8jBN;AsJp8jBI;EACE,2EAAA;AtJs8jBN;AsJv8jBI;EACE,2EAAA;AtJy8jBN;AsJ18jBI;EACE,2EAAA;AtJ48jBN;AsJ78jBI;EACE,wEAAA;AtJ+8jBN;AsJv8jBE;EnB1BA,yBlI6CM;EkI1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EmB0BE,qBAAA;AtJ48jBJ;;AuJx+jBA;EACE;IACE,mBAAA;EvJ2+jBF;EuJz+jBA;IAEE,qBAAA;EvJ0+jBF;EuJx+jBA;IACE,mBAAA;EvJ0+jBF;AACF;AuJr+jBI;EACE,sBAAA;EACA,yBAAA;AvJu+jBN;AuJz+jBI;EACE,uBAAA;EACA,yBAAA;AvJ2+jBN;AuJ7+jBI;EACE,sBAAA;EACA,yBAAA;AvJ++jBN;AuJj/jBI;EACE,sBAAA;EACA,yBAAA;AvJm/jBN;AuJ3+jBE;EpB3BA,yBlI6CM;EkI1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EoB2BE,qBAAA;EACA,gCAAA;EACA,mCAAA;EACA,kBAAA;AvJg/jBJ;;AwJ/gkBA;EACE;IACE,oBAAA;ExJkhkBF;EwJhhkBA;IACE,sBAAA;ExJkhkBF;EwJhhkBA;IACE,oBAAA;ExJkhkBF;AACF;AwJ7gkBE;ErBjBA,yBlI6CM;EkI1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EqBiBE,qBAAA;EACA,wFAAA;AxJkhkBJ;AwJhhkBI;EACE,iCAAA;AxJkhkBN;AwJ/gkBI;EACE,iCAAA;AxJihkBN;;AyJ5ikBA;EACE;IACE,oBAAA;EzJ+ikBF;EyJ7ikBA;IACE,sBAAA;EzJ+ikBF;EyJ7ikBA;IACE,oBAAA;EzJ+ikBF;AACF;AyJ1ikBE;EtBhBA,yBlI6CM;EkI1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EsBgBE,qBAAA;EACA,sBAAA;EACA,8FAAA;AzJ+ikBJ;AyJ7ikBI;EACE,kCAAA;AzJ+ikBN;AyJ5ikBI;EACE,8BAAA;AzJ8ikBN;;A0JtkkBA;EACE;IACE,YAAA;E1JykkBF;E0JvkkBA;IACE,UAAA;E1JykkBF;AACF;A0J3hkBA;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;A1J4hkBF;A0JzkkBI;EAKI,SAlBC;EAmBD,OAAA;EA8BF,iEAAA;A1J0ikBN;A0J9kkBI;EAQI,oBANQ;EAOR,qBAPQ;EAQR,yBAAA;EA0BF,iEAAA;A1JgjkBN;A0JplkBI;EAYI,MAAA;EACA,UA1BC;EA2BD,wBAAA;EAsBF,gEAAA;A1JsjkBN;A0J1lkBI;EAgBI,qBAAA;EACA,qBAfQ;EAgBR,wBAAA;EAkBF,iEAAA;A1J4jkBN;A0JhmkBI;EAoBI,UAAA;EACA,OAAA;EAeF,iEAAA;A1JikkBN;A0JrmkBI;EAuBI,qBAAA;EACA,sBAAA;EACA,yBAAA;EAWF,iEAAA;A1JukkBN;A0J3mkBI;EA2BI,MAAA;EACA,WAAA;EACA,wBAAA;EAOF,iEAAA;A1J6kkBN;A0JjnkBI;EA+BI,oBA7BQ;EA8BR,sBAAA;EACA,wBAAA;EAGF,6DAAA;A1JmlkBN;A0JxkkBE;EvB/DA,yBlI6CM;EkI1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EuB+DE,kBAAA;EACA,UAAA;EACA,YAAA;A1J6kkBJ;;AiIjlkBA;;EAAA;A0B7DA;EACE;IACE,wDAAA;E3JopkBF;E2JlpkBA;IACE,6DAAA;E3JopkBF;E2JlpkBA;IACE,wDAAA;E3JopkBF;E2JlpkBA;IACE,mDAAA;E3JopkBF;AACF;A2J/okBE;ExBjBA,yBAAA;EwBoBE,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gFAAA;A3JgpkBJ;;A4J3qkBA;EACE;IACE,wDAAA;E5J8qkBF;E4J5qkBA;IACE,6DAAA;E5J8qkBF;E4J5qkBA;IACE,wDAAA;E5J8qkBF;E4J5qkBA;IACE,mDAAA;E5J8qkBF;AACF;A4JzqkBE;EzBfA,yBAAA;EyBkBE,WAAA;EACA,YAAA;EACA,mB3JqBI;E2JpBJ,yEAAA;A5J0qkBJ;;A6J9rkBA;EACI;IACK,yBAAA;E7JiskBP;E6J/rkBE;IACK,yBAAA;E7JiskBP;E6J/rkBE;IACK,yBAAA;E7JiskBP;AACF;A6J9rkBA;EACI;IACK,wBAAA;E7JgskBP;E6J9rkBE;IACK,uBAAA;E7JgskBP;E6J9rkBE;IACK,wBAAA;E7JgskBP;AACF;A6JnrkBA;EACE;IACE,YAAA;E7JqrkBF;E6JnrkBA;IACE,qCAAA;E7JqrkBF;AACF;A6J1qkBA;EAGE,kBAAA;A7J0qkBF;A6JnrkBI;EACE,iDAAA;A7JqrkBN;A6JtrkBI;EACE,iDAAA;A7JwrkBN;A6JzrkBI;EACE,iDAAA;A7J2rkBN;A6J5rkBI;EACE,6CAAA;A7J8rkBN;A6JprkBE;EA/BE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EA4DH,iDAAA;EACA,kBAAA;EACA,WAAA;A7J4rkBJ;A6JzrkBE;EAtCE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EAmEH,mDAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;A7JiskBJ;A6J9rkBE;;;;E1B5EA,yBlI6CM;EkInCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;E4BiFL,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;A7JkskBJ;;A8JrxkBA;EACE;IACE,qDAAA;E9JwxkBF;E8JtxkBA;IACE,gDAAA;E9JwxkBF;E8JtxkBA;IACE,sDAAA;E9JwxkBF;E8JtxkBA;IACE,0BAAA;E9JwxkBF;AACF;A8JrxkBA;EACE,kBAAA;EACA,kCAAA;A9JuxkBF;A8JrxkBE;E3BpBA,yBAAA;E2BuBE,WAxBG;EAyBH,YAzBG;EA0BH,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yB7JaI;E6JZJ,uDAAA;A9JsxkBJ;A8JpxkBI;EACE,sBAAA;A9JsxkBN;;A+JrzkBA;EACE;IACE,uBAAA;E/JwzkBF;E+JtzkBA;IACE,yBAAA;E/JwzkBF;E+JtzkBA;IACE,yBAAA;E/JwzkBF;AACF;A+JrzkBA;EACE,kBAAA;EACA,WAjBK;EAkBL,YAlBK;EAmBL,gBAAA;A/JuzkBF;A+JrzkBE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6FAAA;EACA,WAAA;EACA,YAAA;A/JuzkBJ;;AgKj1kBI;E1J8BA,gCAAA;EACA,mCAAA;ANuzkBJ;AgKj1kBE;EACE,cAAA;AhKm1kBJ;AgKh1kBE;EACE,cAAA;AhKk1kBJ;AgK/0kBE;E1JCE,mBAAA;ANi1kBJ;;AgK30kBE;;EAEE,kBAAA;AhK80kBJ;AgK50kBI;;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gB/JrBE;E+JsBF,2CAAA;AhK+0kBN;;AgK10kBA;EACE;IACE,YAAA;IACA,QAAA;EhK60kBF;EgK30kBA;IACE,UAAA;IACA,WAAA;EhK60kBF;AACF;AiK93kBA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;AjKg4kBF;AiK93kBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AjKg4kBJ;AiK73kBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBhKFO;EKCP,sBAAA;ANi4kBJ;;AiK33kBA;EACE,kBAAA;EACA,gBAAA;AjK83kBF;AiK53kBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AjK83kBJ;AiK33kBE;EACE,gBAAA;AjK63kBJ;;AiKz3kBA;EACE,kBAAA;EACA,iBAAA;EACA,iBhKmDa;ADy0kBf;AiK13kBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AjK43kBJ;AiKz3kBE;EACE,iBhK0CW;EgKzCX,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AjK23kBJ;AiKx3kBE;EACE,chKtCO;EgKuCP,kBAAA;AjK03kBJ;AiKv3kBE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,mBAAA;EACA,iBAAA;EACA,chKlDO;EgKmDP,0BAAA;EACA,mBAAA;AjKy3kBJ;;AiKr3kBA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AjKw3kBF;AiKt3kBE;EACE,0BAAA;AjKw3kBJ;;AiKp3kBA;EACE,eAAA;EACA,gBAAA;AjKu3kBF;AiKr3kBE;EACE,aAAA;AjKu3kBJ;;AiKl3kBE;EACE,UAAA;AjKq3kBJ;AiKl3kBE;EACE,iBAAA;AjKo3kBJ;AiKj3kBE;EACE,SAAA;AjKm3kBJ;;AiK/2kBA;EACE,iBAAA;AjKk3kBF;AiKh3kBE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBhKtGO;EKCP,sBAAA;ANw9kBJ;AiK/2kBE;EACE,mB7J4HK;AJqvkBT;AiK92kBE;EACE,iBAAA;AjKg3kBJ;AiK72kBE;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;AjK+2kBJ;AiK72kBI;EACE,WAAA;EACA,YAAA;EACA,gBhK7HE;EKGJ,mBAAA;E2J4HE,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AjK+2kBN;AiK72kBM;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AjK+2kBR;AiK52kBM;EACE,cAAA;AjK82kBR;;AiKt2kBA;EACE,iBAAA;AjKy2kBF;AiKv2kBE;EACE,kBAAA;AjKy2kBJ;AiKt2kBE;EACE,mBAAA;EACA,0BAAA;EACA,UAAA;AjKw2kBJ;AiKr2kBE;EACE,YAAA;EACA,WAAA;EACA,mBhKpKO;EgKqKP,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;E3JvKA,mBAAA;AN+glBJ;AiKr2kBI;EACE,WAAA;EACA,kBAAA;EACA,gBhKhLE;EgKiLF,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;E3JnLF,mBAAA;AN2hlBJ;AiKn2kBE;EACE,oBAAA;AjKq2kBJ;;AiK/1kBI;EACE,mBhK9HS;ADg+kBf;;AiKn2kBI;EACE,mBhK9HS;ADo+kBf;;AiKv2kBI;EACE,mBhK9HS;ADw+kBf;;AiK32kBI;EACE,mBhK9HS;AD4+kBf;;AiK/2kBI;EACE,mBhK9HS;ADg/kBf;;AiKn3kBI;EACE,mBhK9HS;ADo/kBf;;AiKv3kBI;EACE,mBhK9HS;ADw/kBf;;AiK33kBI;EACE,mBhK9HS;AD4/kBf;;AiK/3kBI;EACE,mBhK9HS;ADgglBf;;AiKn4kBI;EACE,mBhK9HS;ADoglBf;;AiK13kBA;EACE,kBAAA;AjK63kBF;;AiK13kBA;EACE,mBAAA;EACA,2BAAA;AjK63kBF;AiKx1kBA;EACE;IACE,UAAA;IAKA,qBAAA;EjKq3kBF;EiKl3kBA;IACE,UAAA;IAKA,qBAAA;EjKo3kBF;EiKj3kBA;IAKE,mBAAA;EjKm3kBF;AACF;AiK/2kBA;EACE,kBAAA;AjKi3kBF;;AiK92kBA;EACE,mBAAA;EAGA,2BAAA;AjKi3kBF;;AiK92kBA;EACE;IAGE,mCAAA;EjKi3kBF;AACF;AiK72kBA;EACE;IACE,mBAAA;IAGA,mCAAA;EjK+2kBF;AACF;AiKz0kBA;EACE;IACE,UAAA;IAKA,6BAAA;EjKq2kBF;EiKl2kBA;IACE,UAAA;IAKA,2BAAA;EjKo2kBF;EiKj2kBA;IAKE,wBAAA;EjKm2kBF;AACF;AiK7zkBA;EACE;IACE,UAAA;IAKA,4BAAA;EjKy1kBF;EiKt1kBA;IACE,UAAA;IAKA,4BAAA;EjKw1kBF;EiKr1kBA;IAKE,wBAAA;EjKu1kBF;AACF;AkKjxlBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;E5JWA,qBAAA;E4JTA,YAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;AlKmxlBJ;AkK9wlBM;EACE,YAAA;AlKgxlBR;AkK3wlBE;;EAEE,mBAAA;AlK6wlBJ;;AkKzwlBA;EACE,aAAA;AlK4wlBF;;AkKxwlBE;EACE,SAAA;EACA,0BAAA;AlK2wlBJ;;AkKtwlBE;EACE,SAAA;EACA,qBAAA;AlKywlBJ;;AmK/ylBM;E7J2CF,yBAAA;EACA,4BAAA;EAfA,2CAAA;EACA,8CAAA;ANwxlBJ;AmK/ylBE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;AnKizlBJ;AmK9ylBM;E7JgBF,0BAAA;EACA,6BAAA;ANiylBJ;;AmKxylBI;EACE,kBAAA;EACA,cAAA;EACA,SAAA;AnK2ylBN;AmKvylBE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;AnKyylBJ;AmKvylBI;E7JQA,yBAAA;EACA,4BAAA;ANkylBJ;;AmKnylBA;EACE,kBlKyCe;EkKxCf,iBAAA;AnKsylBF;;AmKjylBA;EACE,iBlKmCa;EkKlCb,SAAA;EACA,clKbM;ADizlBR;AmKlylBE;EACE,clKxCO;EkKyCP,mBAAA;EACA,kBlK2Ba;ADywlBjB;;AmKhylBA;EACE,wBAAA;EACA,qBAAA;AnKmylBF;;AoK/1lBI;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EAEA,cnK8BE;EmK7BF,sBnKDE;EmKEF,yBAAA;ApKi2lBN;AoK/1lBM;EACE,UAAA;EACA,6BhK4QkC;EgK3QlC,qBAAA;EACA,yBnKNG;EmKOH,qBnKNG;ADu2lBX;AoK91lBM;EACE,UAAA;EACA,UhKqgC4B;EgKpgC5B,gBnKqEsB;AD2xlB9B;AoK51lBM;EACE,eAAA;ApK81lBR;AoKz1lBM;EACE,cAAA;E9JOJ,+BAAA;EACA,kCAAA;ANq1lBJ;AoKx1lBM;E9JZF,gCAAA;EACA,mCAAA;ANu2lBJ;AoKv1lBI;EACE,UAAA;EACA,WnKtCE;EmKuCF,yBnKTE;EmKUF,qBnKVE;ADm2lBR;AoKv1lBM;EACE,WnK3CA;ADo4lBR;AoKr1lBI;EACE,cnK1CK;EmK2CL,oBAAA;EAEA,YAAA;EACA,sBnKpDE;EmKqDF,qBnKlDK;ADw4lBX;;AoK90lBE;E9J1DE,8BAAA;E8J4DA,gBAAA;ApKi1lBJ;;AqK55lBA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;ArK+5lBF;AqK75lBE;EACE,cAAA;ArK+5lBJ;AqK55lBE;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,mBpK2FqB;EoK1FrB,SAAA;EACA,uBAAA;E/JAA,mBAAA;E+JEA,+BjKgW0B;EiK/V1B,SAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ArK85lBJ;AqK55lBI;EACE,gBAAA;EACA,mBAAA;EACA,mB7FzBY;E6F0BZ,cAAA;ArK85lBN;AqK15lBE;EACE,iBAAA;ArK45lBJ;AqK15lBI;E/JpBA,mBAAA;E+JsBE,4BAAA;EACA,gCjK2UwB;EiK1UxB,iBAAA;ArK45lBN;AqK15lBM;EACE,iBAAA;EACA,oB7FzCU;E6F0CV,cAAA;ArK45lBR;;AsKx8lBA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EhKSE,sBAAA;ANm8lBJ;AsKz8lBE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,crKCO;EqKAP,kBAAA;AtK28lBJ;AsKz8lBI;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mBrKZK;EqKaL,UAAA;EACA,oBAAA;AtK08lBN;AsKv8lBI;EACE,SAAA;AtKy8lBN;AsKt8lBI;EACE,OAAA;AtKw8lBN;AsKp8lBM;EhKIF,4BAAA;EACA,+BAAA;ANm8lBJ;AsKl8lBM;EhKhBF,6BAAA;EACA,gCAAA;ANq9lBJ;AsKj8lBI;EACE,kBAAA;EACA,kBlKoYwB;EkKnYxB,mBrKvCK;EqKwCL,WrK5CE;EqK6CF,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EhK9CF,mBAAA;EgKgDE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AtKm8lBN;AsKh8lBI;EACE,crKpDK;ADs/lBX;AsKj8lBM;EACE,mBrK/BA;ADk+lBR;AsKh8lBM;EACE,mBrKnCA;ADq+lBR;AsK77lBM;EACE,+BAAA;EAEA,mBrKnCA;EqKoCA,gBAAA;AtK87lBR;AsK77lBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AtK+7lBV;AsK37lBM;EAEE,mBrKjDA;AD6+lBR;AsKx7lBI;EACE,crKtFK;ADghmBX;;AsKh7lBI;EACE,kBrK5BW;AD+8lBjB;AsKj7lBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;AtKm7lBR;;AsK36lBE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;AtK86lBJ;AsK56lBI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EhKhIF,qBAAA;EgKkIE,oBAAA;AtK86lBN;AsK56lBM;EAEE,aAAA;AtK66lBR;AsK16lBM;EACE,qBAAA;AtK46lBR;AsKz6lBM;EACE,mBrK/IG;AD0jmBX;AsKx6lBM;EACE,mBrKvHA;EqKwHA,WrKtJA;ADgkmBR;AsKx6lBQ;EACE,oCAAA;AtK06lBV;AsKp6lBE;EACE,UAAA;EACA,cAAA;AtKs6lBJ;;AsKn6lBA;EAEI;IACE,cAAA;IACA,UAAA;IACA,WAAA;IACA,0BAAA;EtKq6lBJ;EsKn6lBI;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,gBAAA;IACA,qBAAA;IhK/KJ,qBAAA;IgKiLI,oBAAA;EtKq6lBN;EsKn6lBM;IAEE,aAAA;EtKo6lBR;EsKj6lBM;IACE,qBAAA;EtKm6lBR;EsKh6lBM;IACE,mBrK9LC;EDgmmBT;EsK/5lBM;IACE,mBrKtKF;IqKuKE,WrKrMF;EDsmmBN;EsK/5lBQ;IACE,oCAAA;EtKi6lBV;EsK35lBE;IACE,UAAA;IACA,cAAA;EtK65lBJ;AACF;AuKtnmBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AvKwnmBF;;AuKrnmBA;EACE,kBAAA;EACA,anKyOO;EmKxOP,kBAAA;AvKwnmBF;AuKtnmBE;EACE,YAAA;EACA,gBAAA;AvKwnmBJ;AuKrnmBE;EACE,eAAA;EACA,kBnK+NK;AJw5lBT;AuKrnmBI;EACE,iBtKiES;ADsjmBf;AuKnnmBE;EACE,kBAAA;EACA,UAAA;AvKqnmBJ;AuKlnmBE;EACE,yBAAA;AvKonmBJ;AuKlnmBI;EACE,gBAAA;AvKonmBN;AuKhnmBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EjKVA,mCAAA;EACA,kCAAA;EiKWA,gBAAA;AvKmnmBJ;AuKhnmBE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AvKknmBJ;AuKhnmBI;EAGE,mBAAA;AvKgnmBN;AuK5mmBE;EACE,mBAAA;EACA,cAAA;EACA,YAAA;AvK8mmBJ;AuK5mmBI;EACE,aAAA;AvK8mmBN;AuK3mmBI;EACE,kBAAA;AvK6mmBN;AuKzmmBE;EACE,gBAAA;AvK2mmBJ;AuKxmmBE;EACE,oBAAA;AvK0mmBJ;AuKxmmBI;EACE,WAAA;EACA,sBAAA;EACA,iUAAA;EAIA,eAAA;EACA,gBtKpFE;AD2rmBR;AuKnmmBE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AvKqmmBJ;AuKnmmBI;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AvKqmmBN;AuKjmmBE;EACE,gBnKkIK;AJi+lBT;AuKjmmBI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AvKmmmBN;AuKjmmBM;EACE,mBAAA;AvKmmmBR;AuKhmmBM;EjKvGF,yBAAA;EACA,0BAAA;EAaA,mCAAA;EACA,kCAAA;AN8rmBJ;AuKlmmBQ;EACE,kCnK6OoB;AJu3lB9B;AuK7lmBE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBnKsGK;AJy/lBT;AuK7lmBI;EACE,gBAAA;AvK+lmBN;AuK5lmBI;EACE,SAAA;AvK8lmBN;AuK3lmBI;EACE,aAAA;AvK6lmBN;AuKzlmBE;EACE,mBAAA;EACA,mBAAA;AvK2lmBJ;AuKzlmBI;EACE,eAAA;EACA,kBAAA;AvK2lmBN;AuKxlmBI;EACE,cAAA;AvK0lmBN;AuKvlmBI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AvKylmBN;AuKvlmBM;EACE,aAAA;AvKylmBR;AuKtlmBM;EACE,sBAAA;AvKwlmBR;AuKplmBI;EACE,WAAA;AvKslmBN;AuKllmBE;EACE,mBAAA;AvKolmBJ;AuKjlmBE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AvKmlmBJ;;AuK/kmBA;EACE,kBAAA;EACA,WnKwCO;EmKvCP,SnKuCO;EmKtCP,WAAA;AvKklmBF;AuKhlmBE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AvKklmBJ;;AuK1kmBM;;EACE,UAAA;AvK8kmBR;;AuKrkmBM;EACE,gBtK5NA;EKGJ,sBAAA;ANkymBJ;;AuKjkmBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBAAA;EACA,gBAAA;AvKmkmBF;AuKjkmBE;EACE,iBAAA;EACA,mBAAA;AvKmkmBJ;AuKhkmBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AvKkkmBJ;AuKhkmBI;EACE,aAAA;AvKkkmBN;AuK7jmBE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AvK+jmBJ;AuK7jmBI;EACE,gBAAA;AvK+jmBN;AuK3jmBE;EACE,WAAA;EACA,eAAA;AvK6jmBJ;;AuKxjmBE;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AvK2jmBJ;AuKrjmBI;EACE,iBAAA;AvKujmBN;AuKpjmBI;EACE,mBAAA;AvKsjmBN;AuKljmBM;EACE,gBAAA;AvKojmBR;AuK/imBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AvKijmBJ;AuK/imBI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AvKijmBN;AuK9imBI;EACE,aAAA;AvKgjmBN;;AuKzimBA;EACE,oCAAA;AvK4imBF;;AuKvimBA;EACE,kBAAA;AvK0imBF;AuKximBE;EACE,kBtK7Pa;EsK8Pb,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;AvK0imBJ;AuKvimBE;EACE,cAAA;AvKyimBJ;;AuKrimBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AvKwimBF;AuKtimBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AvKwimBJ;;AuKpimBA;EACE,iBAAA;AvKuimBF;;AwKn5mBA;EACE,apKgPO;EoK/OP,mBAAA;EACA,mBAAA;AxKs5mBF;AwKp5mBE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AxKs5mBJ;AwKj5mBI;EACE,YAAA;EACA,iBAAA;AxKm5mBN;AwKh5mBI;EACE,YAAA;AxKk5mBN;AwK94mBE;EACE,iBAAA;AxKg5mBJ;AwK74mBE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AxK+4mBJ;AwK54mBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AxK84mBJ;AwK34mBE;EACE,gBpKwMK;AJqsmBT;AwK34mBI;EACE,2BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AxK64mBN;AwKv4mBM;EACE,iBAAA;AxKy4mBR;AwKn4mBI;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;AxKq4mBN;AwK/3mBM;EACE,mBAAA;EACA,UAAA;AxKi4mBR;;AyK78mBA;EACE,kBAAA;EACA,gBAAA;AzKg9mBF;AyK98mBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AzKg9mBJ;AyK78mBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;AzK+8mBJ;AyK18mBI;EACE,ajGzBa;AxEq+mBnB;AyK18mBM;EACE,mBAAA;AzK48mBR;AyKz8mBM;EACE,kBAAA;AzK28mBR;AyKv8mBI;EACE,kBAAA;AzKy8mBN;AyKv8mBM;EACE,WxK7BA;EwK8BA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBxK0CO;AD+5mBf;AyKv8mBQ;EACE,oCAAA;AzKy8mBV;;A0K5/mBA;EACE,YlGQY;EkGPZ,WlGQW;EkGPX,oDAAA;A1K+/mBF;;A0K5/mBA;EACE,YlGEY;EkGDZ,WlGEW;EkGDX,oDAAA;A1K+/mBF;;A0K3/mBE;EACE,mBlGXe;AxEygnBnB;A0K3/mBE;EACE,qBlGdc;EkGed,mBAAA;A1K6/mBJ;A0K3/mBI;EACE,YAAA;A1K6/mBN;A0K1/mBI;EACE,iBzKgES;AD47mBf;;A0Kx/mBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;A1K2/mBF;;A0Kx/mBA;EACE,aAAA;EACA,sBAAA;A1K2/mBF;;A0Kx/mBA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;A1K2/mBF;;A0Kx/mBA;EACE,2BAAA;EACA,sBAAA;A1K2/mBF;;A0Kx/mBA;EACE,yBAAA;EACA,oBAAA;A1K2/mBF;;A0Kx/mBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;A1K2/mBF;;A0Kx/mBA;EACE,yBAAA;A1K2/mBF;;A0Kx/mBA;EACE,yBAAA;EACA,iBAAA;A1K2/mBF;;A0Kx/mBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A1K2/mBF;;A0Kx/mBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A1K2/mBF;;A0Kx/mBA;EACE,iBAAA;EACA,WAAA;A1K2/mBF;;A0Kx/mBA;EACE,eAAA;A1K2/mBF;;A0Kx/mBA;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;A1K2/mBF;;A0Kx/mBA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;A1K2/mBF;;A0Kx/mBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,wBAAA;A1K2/mBF;;A0Kx/mBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;EACA,yBAAA;A1K2/mBF;;A0Kx/mBA;EACE,UAAA;A1K2/mBF;;A0Kx/mBA;EACE,yBAAA;EACA,kBAAA;A1K2/mBF;;A2KnonBM;EACE,WAAA;EACA,WAAA;A3KsonBR;A2KjonBE;EACE,WAAA;EACA,enGjBc;EmGkBd,gBAAA;EAQA,gCAAA;A3K4nnBJ;A2KlonBI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;A3KoonBN;A2K9nnBE;EACE,enG9Bc;AxE8pnBlB;A2K9nnBI;ErKnBA,qBAAA;ANopnBJ;A2K5nnBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;A3K8nnBJ;A2K5nnBI;EACE,SAAA;EACA,aAAA;A3K8nnBN;A2K5nnBM;EACE,+BAAA;EACA,gBAAA;EACA,SAAA;A3K8nnBR;A2K3nnBM;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A3K6nnBR;A2K1nnBM;EACE,aAAA;EACA,mBAAA;A3K4nnBR;A2KznnBM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;A3K2nnBR;A2KxnnBM;EACE,enGzEU;EmG0EV,6BAAA;A3K0nnBR;A2KtnnBI;EACE,YAjF8B;EAkF9B,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;A3KwnnBN;A2KtnnBM;EACE,mBAAA;A3KwnnBR;A2KrnnBM;EACE,+BAAA;EACA,gBAAA;EACA,mB1KpFG;E0KqFH,SAAA;EACA,+BAAA;EACA,8BAAA;A3KunnBR;A2KpnnBM;;EAEE,mB1K5FG;ADktnBX;A2KlnnBI;EACE,WA7G8B;A3KiunBpC;A2KhnnBE;EACE,WAAA;EACA,YAlHgC;A3KounBpC;;A2K7mnBE;EACE,6BAAA;A3KgnnBJ;A2K9mnBI;EACE,8BAAA;A3KgnnBN;;A4K5unBI;EACE,YAL0B;EAM1B,eAAA;A5K+unBN;A4K3unBE;EACE,iBxKmb0B;AJ0zmB9B;A4K3unBI;EACE,kB3K4EW;ADiqnBjB;A4KzunBE;EACE,epGdc;AxEyvnBlB;;AanrnBI;E+JhDI;IACE,mBAAA;E5KuunBR;AACF;A2KznnBA;EACE,aAAA;EACA,sBAAA;A3K2nnBF;;Aa7rnBI;EgKzEF;IACE,wBAAA;E7K0wnBF;E6KvwnBA;IACE,cAAA;E7KywnBF;E6KpwnBE;IACE,yBAAA;E7KswnBJ;AACF;A8KrxnBA;;EAAA;AAGA;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;A9KuxnBF;;A8KpxnBA;;EAAA;AAGA;EACE,wBAAA;EACA,UAAA;EACA,6DAAA;EACA,YAAA;EACA,mDAAA;EACA,SAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;A9KuxnBF;;A8KpxnBA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;ExKbE,mBAAA;EwKeF,UAAA;A9KuxnBF;;A8KpxnBA;;EAEE,cAAA;EACA,6BAAA;A9KuxnBF;;A8KpxnBA;;;;;;EAME,YAAA;A9KuxnBF;;A8KpxnBA;;;;EAIE,oCAAA;EACA,YAAA;A9KuxnBF;;A8KpxnBA;;EAAA;AAGA;EACE,oCAAA;EACA,kBAAA;EACA,iEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;A9KuxnBF;;A8KpxnBA;EACE,oCAAA;EACA,kBAAA;EACA,gEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;A9KuxnBF;;A8KpxnBA;;EAEE,qCAAA;EACA,YAAA;A9KuxnBF;;A8KpxnBA;;EAEE,qCAAA;EACA,WAAA;A9KuxnBF;;A8KpxnBA,gBAAA;AACA;EACE;IACE,yBAAA;E9KuxnBF;AACF;A8KpxnBA;EACE;IACE,yBAAA;E9KsxnBF;AACF;A8KnxnBA;EACE,kBAAA;EACA,YAAA;A9KqxnBF;;A8KhxnBA;EACE,kBAAA;EACA,aAAA;A9KmxnBF;;A8KhxnBA;EACE,aAAA;EACA,kBAAA;A9KmxnBF;;A8KhxnBA;EACE,aAAA;EACA,kBAAA;A9KmxnBF;;A8KhxnBA;EACE,aAAA;EACA,kBAAA;A9KmxnBF;;A8KhxnBA;EACE,aAAA;EACA,kBAAA;A9KmxnBF;;A8KhxnBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;A9KmxnBF;;A8KhxnBA;EACE,kBAAA;A9KmxnBF;A8KjxnBE;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,ctGvJc;EsGwJd,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;A9KkxnBJ;A8K/wnBE;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;A9KgxnBJ;;A+Kv7nBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;A/K07nBF;;A+Kv7nBA;;EAEE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,yBAAA;A/K07nBF;;A+Kv7nBA;EACE,aAAA;EzKJE,sBAAA;EyKMF,iIACQ;A/Ky7nBV;;A+Kp7nBA;EACE,yDAAA;A/Ku7nBF;;A+Kp7nBA;;EAEE,yBAAA;EAGA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;A/Ku7nBF;;A+Kp7nBA;;EAEE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,uBAAA;A/Ku7nBF;;A+Kp7nBA;;EAEE,cAAA;A/Ku7nBF;;A+Kp7nBA;EACE,eAAA;EACA,c9KjDS;ADw+nBX;;A+Kp7nBA;EACE,gBAAA;A/Ku7nBF;;A+Kp7nBA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;A/Ku7nBF;A+Kr7nBE;EACE,UAAA;EACA,kBAAA;A/Ku7nBJ;;A+Kn7nBA;EACE,yDAAA;A/Ks7nBF;;A+Kn7nBA;;EAEE,cAAA;EACA,YAAA;A/Ks7nBF;;A+Kn7nBA;EACE,WAAA;A/Ks7nBF;;A+Kn7nBA;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,qDAAA;EACA,iBAAA;EACA,eAAA;A/Ks7nBF;;A+Kn7nBA;EACE,c9KzEM;AD+/nBR;;A+Kn7nBA;;EAEE,W9K5GM;E8K6GN,eAAA;EACA,wBAAA;A/Ks7nBF;;A+Kn7nBA;EACE,eAAA;EACA,c9K5GS;ADkioBX;;A+Kn7nBA;EACE,c9KhHS;ADsioBX;;A+Kn7nBA;EACE,OAAA;A/Ks7nBF;;A+Kn7nBA;EACE,gBAAA;A/Ks7nBF;;A+Kn7nBA;EACE,0JAAA;EAEA,aAAA;EACA,sBAAA;A/Ks7nBF;;A+Kn7nBA;EAEE,cAAA;A/Ks7nBF;;A+Kn7nBA;EACE,0BAAA;EACA,gBAAA;A/Ks7nBF;;A+Kn7nBA;;;EAGE,aAAA;A/Ks7nBF;;A+Kn7nBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;A/Ks7nBF;;A+Kl7nBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;A/Kq7nBF;;A+Kl7nBA;EACE,WAAA;A/Kq7nBF;;A+Kl7nBA;EACE,kBAAA;EACA,mBAAA;A/Kq7nBF;;A+Kl7nBA;EACE,cAAA;A/Kq7nBF;;A+Kl7nBA;EACE,kBAAA;EACA,OAAA;A/Kq7nBF;;A+Kl7nBA;EAEE,aAAA;EAEA,SAAA;EACA,WAAA;A/Kq7nBF;;A+Kl7nBA;EAEE,aAAA;EAEA,cAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;A/Kq7nBF;;A+Kl7nBA;EACE,WAAA;EACA,uBAAA;A/Kq7nBF;;A+Kl7nBA;EAEE,mBAAA;A/Kq7nBF;;A+Kl7nBA;EACE,WAAA;A/Kq7nBF;;A+Kl7nBA;EACE,UAAA;A/Kq7nBF;;A+Kl7nBA;EACE,YAAA;A/Kq7nBF;;A+Kl7nBA;EACE,OAAA;A/Kq7nBF;;A+Kl7nBA;EACE,YAAA;A/Kq7nBF;;A+Kl7nBA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,iDAAA;A/Kq7nBF;;A+Kl7nBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;A/Kq7nBF;;A+Kl7nBA;EACE,YAAA;EACA,SAAA;EACA,OAAA;EACA,mB9KhOM;ADqpoBR;;A+Kl7nBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;A/Kq7nBF;;A+Kl7nBA;EACE,SAAA;EACA,iBAAA;A/Kq7nBF;;AgL/soBA;;;;;;EAAA;AASA;;EAAA;AASA;;EAAA;AAYA;;EAAA;AAIA;EACE;IACE,aAAA,EAAA,oBAAA;EhLgsoBF;EgL9roBA;IACE,UAAA;EhLgsoBF;AACF;AgL5roBA;;EAAA;AAIA;EACE,kBAAA;AhL6roBF;;AgLzroBA,sBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,WA3CY;EA4CZ,QAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AhL4roBF;;AgLzroBA,iBAAA;AACA;EACE,kBAAA;EACA,UAAA;AhL4roBF;;AgLxroBE;EACE,2BAAA;AhL2roBJ;AgLxroBE;EACE,2BAAA;AhL0roBJ;;AgLtroBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,8BAAA;EACA,aAAA;EAlEA,sCAAA;AhL4voBF;;AgLtroBA;EACE,cAAA;AhLyroBF;;AgLrroBA;;EAAA;AAIA;;;EA/EE,uEAAA;AhLywoBF;;AgLproBA;;;;;;EArFE,oCAAA;AhLkxoBF;;AgLnroBA;;EAAA;AAKE;EACE,WAAA;AhLoroBJ;AgLjroBE;EAEE,YAAA;AhLkroBJ;AgL/qoBE;EACE,mBAAA;AhLiroBJ;AgL/qoBI;EACE,UAAA;AhLiroBN;AgL9qoBI;EAEE,mBAAA;AhL+qoBN;;AgLzqoBA;;EAAA;AAKE;EACE,UAAA;AhL0qoBJ;AgLvqoBE;EAEE,SAAA;AhLwqoBJ;AgLrqoBE;EACE,kBAAA;AhLuqoBJ;AgLrqoBI;EACE,UAAA;AhLuqoBN;AgLpqoBI;EAEE,kBAAA;AhLqqoBN;;AgL/poBA;;EAAA;AAIA;EACE,gBAAA;AhLiqoBF;AgL/poBE;EACE,UAAA;EACA,SAAA;EACA,cAAA;AhLiqoBJ;AgL9poBE;EACE,iBAAA;AhLgqoBJ;AgL9poBI;EACE,UAAA;EACA,SAAA;EACA,aAAA;AhLgqoBN;AgL7poBI;EAEE,iBAAA;AhL8poBN;AgL5poBM;EACE,QAAA;AhL8poBR;;AgLvpoBA;;EAAA;AAIA;EACE,gBAAA;AhLypoBF;AgLvpoBE;EACE,SAAA;EACA,SAAA;EACA,cAAA;AhLypoBJ;AgLtpoBE;EAEE,SAAA;AhLupoBJ;AgLppoBE;EACE,oBAAA;AhLspoBJ;AgLppoBI;EACE,UAAA;AhLspoBN;AgLnpoBI;EAEE,oBAAA;AhLopoBN;;AgL9ooBA;;EAAA;AAGA;EACE,gBAAA;AhLipoBF;AgL/ooBE;EACE,kBAAA;AhLipoBJ;AgL/ooBE;EACE,UAAA;EACA,cAAA;AhLipoBJ;AgL7ooBI;EACE,UAAA;EACA,WAAA;AhL+ooBN;AgL7ooBI;EACE,UAAA;EACA,SAAA;AhL+ooBN;;AgLzooBA;;EAAA;AAGA;EACE,gBAAA;AhL4ooBF;AgL1ooBE;EACE,kBAAA;AhL4ooBJ;AgL1ooBE;EACE,WAAA;EACA,cAAA;EACA,UAAA;AhL4ooBJ;AgL1ooBI;EACE,WAAA;AhL4ooBN;AgLvooBI;EACE,UAAA;EACA,UAAA;AhLyooBN;AgLvooBI;EACE,UAAA;EACA,SAAA;AhLyooBN;;AgLnooBA;;EAAA;AAGA;EACE,gBAAA;AhLsooBF;AgLpooBE;EACE,kBAAA;AhLsooBJ;AgLpooBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AhLsooBJ;AgLlooBI;EACE,UAAA;EACA,SAAA;AhLoooBN;AgLlooBI;EACE,UAAA;EACA,aAAA;AhLoooBN;;AgL9noBA;;EAAA;AAGA;EACE,gBAAA;AhLiooBF;AgL/noBE;EACE,kBAAA;AhLiooBJ;AgL/noBE;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AhLiooBJ;AgL7noBI;EACE,UAAA;EACA,QAAA;AhL+noBN;AgL7noBI;EACE,UAAA;EACA,aAAA;AhL+noBN;;AgLznoBA;;EAAA;AAIA;EACE,gBAAA;AhL2noBF;;AgLznoBA;EACE,SAAA;EACA,iBAhWY;EAYZ,qBAsVoB;AhL2noBtB;;AgLznoBA;EACE,kBAAA;EACA,qBAAA;AhL4noBF;;AgLznoBA;EACE,UAAA;EA9VA,qBAgWoB;AhL2noBtB;;AgLznoBA;EACE,UAAA;EACA,cAAA;EApWA,eAsWoB;AhL2noBtB;;AgLvnoBA;;EAAA;AAIA;EACE,gBAAA;AhLynoBF;;AgLvnoBA;EACE,SAAA;EACA,kBAAA;EAnXA,qBAqXoB;AhLynoBtB;;AgLvnoBA;EACE,kBAAA;EACA,qBAAA;AhL0noBF;;AgLvnoBA;EACE,UAAA;EA7XA,qBA+XoB;AhLynoBtB;;AgLvnoBA;EACE,UAAA;EACA,cAAA;EAnYA,eAqYoB;AhLynoBtB;;AgLrnoBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;AhLunoBF;;AgLrnoBA;EACE,SAAA;EACA,cAAA;AhLwnoBF;;AgLrnoBA;EACE,kBAAA;EACA,WAAA;AhLwnoBF;;AgLtnoBA;EACE,UAAA;AhLynoBF;;AgLvnoBA;EACE,UAAA;AhL0noBF;;AgLrnoBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;EAEA,+CAAA;AhLsnoBF;;AgLpnoBA;EACE,SAAA;EACA,cAAA;AhLunoBF;;AgLpnoBA;EACE,kBAAA;EACA,WAAA;EAEA,+CAAA;EACA,iDAAA;AhLsnoBF;;AgLpnoBA;EACE,UAAA;AhLunoBF;;AgLrnoBA;EACE,UAAA;AhLwnoBF;;AgLpnoBA;EACE,oBAAA;AhLunoBF;;AiLnlpBA;;;;;;EAAA;ACGA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAGA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AlLulpBF;AkLrlpBE;EAKI,YDT2B;AjL4lpBjC;AkL9kpBI;EAKI,YDnByB;AjL+lpBjC;AkLxkpBI;;;EAGE,yBjLEE;ADwkpBR;;AkLrkpBA;EACE,WDrC+B;ECsC/B,YAAA;EACA,qBAAA;EACA,kBAAA;AlLwkpBF;;AkLrkpBA;EACE,cAAA;EACA,QAAA;EACA,gBAAA;AlLwkpBF;AkLtkpBE;EAGE,WDnD6B;ECoD7B,WDnD6B;ECoD7B,yBjLpBI;EiLqBJ,mBDlD6B;ECmD7B,kBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;AlLskpBJ;AkLnkpBE;EAEE,WAAA;EACA,cAAA;AlLokpBJ;AkLjkpBE;EACE,SAAA;AlLmkpBJ;AkLhkpBE;EACE,YAAA;AlLkkpBJ;;AmLpppBE;;EAAA;AAIE;EACE,QAAA;EACA,2BAAA;EACA,kEAAA;AnLsppBN;AmLpppBM;EACE,QAAA;EACA,sCAAA;AnLsppBR;AmLnppBM;EACE,SAAA;EACA,mEAAA;AnLqppBR;AmLhppBM;EAGE,gDAAA;EACA,wBAAA;AnLgppBR;AmL9opBQ;EACE,oBAAA;EACA,UAAA;AnLgppBV;AmL7opBQ;EACE,mDAAA;EACA,wBAAA;AnL+opBV;;AoLhrpBA;EACE,gBnLWM;EmLVN,kBAAA;EACA,e5GDgB;AxEorpBlB;AoLjrpBE;EACE,mBnLmFW;EmLlFX,cnLYO;EmLXP,SAAA;EACA,mBnLIO;EmLHP,uBAAA;EACA,gCAAA;EACA,6BAAA;ApLmrpBJ;AoLjrpBI;EACE,aAAA;ApLmrpBN;AoL/qpBE;EACE,e5GlBc;AxEmspBlB;AoL9qpBE;EACE,aAAA;ApLgrpBJ;;AoL5qpBA;E9KbI,mBAAA;E8KeF,gBnLlBM;EmLmBN,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mDhLsV4B;EgLrV5B,WAAA;ApL+qpBF;AoL7qpBE;EACE,eAAA;ApL+qpBJ;;AqLx9oBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;ArL29oBF;AqLz9oBE;EACE,qBpL3NE;ADsrpBN;AqLz9oBI;EACE,kBAAA;EACA,cAAA;ArL29oBN;AqLx9oBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBpLtOA;EoLuOA,cAAA;EACA,SAAA;EACA,kBAAA;ArL09oBN;AqLx9oBM;EAEE,wBAAA;EACA,UAAA;ArL09oBR;AqLv9oBM;EAEE,yBAAA;EACA,WAAA;ArLy9oBR;AqLp9oBE;EACE,qBpLxPK;AD8spBT;AqLp9oBI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EAEA,kBAAA;EACA,iBAAA;EACA,yBpLnQG;ADytpBT;AqLn9oBI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,yBpL/QG;ADoupBT;AqLj9oBE;EACE,qBpLjRG;ADoupBP;AqLj9oBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBpL5RC;AD+upBP;AqLh9oBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yBpLvSC;ADyvpBP;AqL98oBE;EACE,qBpL9SI;AD8vpBR;AqL98oBI;EAEE,WAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBpL9VE;EoLgWF,wBAAA;ArL+8oBN;AqL58oBI;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;EAEA,yBAAA;EAEA,2BAAA;ArL88oBN;AqL38oBI;EAEE,8BAAA;EACA,UAAA;EACA,UAAA;EAEA,yBAAA;EAEA,wBAAA;ArL68oBN;AqL18oBI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;ArL48oBN;AqLz8oBI;EACE,UAAA;EACA,YAAA;EACA,sBpL1YE;EoL2YF,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,yBAAA;ArL28oBN;AqLx8oBI;EACE,WAAA;EACA,yBpL/WE;EoLgXF,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;ArL08oBN;AqLx8oBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,wBAAA;ArL08oBR;AqLv8oBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,yBAAA;ArLy8oBR;AqLp8oBE;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;ArLs8oBJ;AqL7uoBA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;ErL2woBF;EqLzwoBA;IACE,QAAA;IACA,SAAA;IACA,SAAA;ErL2woBF;EqLzwoBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;ErL2woBF;EqLzwoBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;ErL2woBF;EqLzwoBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;ErL2woBF;AACF;AqLjvoBA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;ErLywoBF;EqLvwoBA;IACE,QAAA;IACA,WAAA;IACA,SAAA;ErLywoBF;EqLvwoBA;IACE,WAAA;IACA,QAAA;IACA,SAAA;ErLywoBF;EqLvwoBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;ErLywoBF;AACF;AqLhuoBA;EAEE,kCAAA;ArLkuoBF;;AqL/toBA;EAEE,mCAAA;ArLkuoBF;;AqL/toBA;EAEE,0CAAA;ArLkuoBF;;AqLzjoBA,iBAAA;AACA;EACE,6BAAA;ArL4joBF;;AqLxjoBA;EACE,gCAAA;ArL2joBF;;AqLvjoBA;EACE,iCAAA;ArL0joBF;;AsLpgqBA;EACI,aCcS;EDbT,eAAA;EACA,UAAA;EACA,YCLa;EDMb,sBAAA;EACA,WrLQI;AD+/pBR;AsLtgqBI;EACI,SlL+OC;EkL9OD,UlL8OC;AJ0xpBT;AsLtgqBI;EACI,SlL2OC;EkL1OD,SAAA;EACA,mBAAA;AtLwgqBR;AsLtgqBI;EACI,SlLsOC;EkLrOD,WlLqOC;AJmypBT;AsLtgqBI;EACI,YlLkOC;EkLjOD,UlLiOC;AJuypBT;AsLtgqBI;EACI,YlL8NC;EkL7ND,SAAA;EACA,mBAAA;AtLwgqBR;AsLtgqBI;EACI,YlLyNC;EkLxND,WlLwNC;AJgzpBT;;AsLpgqBA;EACI;IACI,YAAA;IACA,UAAA;IACA,OAAA;IACA,SAAA;EtLugqBN;EsLtgqBM;IAGI,MAAA;EtLsgqBV;EsLpgqBM;IAGI,SAAA;EtLogqBV;EsLlgqBM;IACE,QAAA;IACA,UAAA;IAAA,aAAA;EtLogqBR;AACF;AwL1jqBA;EACI,kBAAA;EACA,gBDDkB;ECElB,sBAAA;EACA,mBAAA;EACA,apLkPK;EEtOL,sBAAA;EkLVA,kUvLuGiB;EuLtGjB,aAAA;EACA,8BAAA;EACA,iBDRkB;ECSlB,gBAAA;EACA,uBDEa;ECDb,eAAA;EACA,cAAA;AxL4jqBJ;AwL3jqBI;EACI,cAAA;AxL6jqBR;AwL3jqBI;EACI,gBDdW;ECeX,cvLCG;EAmJT,sMAAA;AD06pBF;AwL3jqBI;EACI,mBvL8BD;EAkHL,0MAAA;AD86pBF;AwL3jqBI;EACI,mBvLwBA;EAoHN,0MAAA;ADk7pBF;AwL3jqBI;EACI,mBvLmBC;EAqHP,0MAAA;ADs7pBF;AwL3jqBI;EACI,mBvLaF;EAuHJ,sMAAA;AD07pBF;AwL3jqBI;EACI,cAAA;EACA,mBAAA;AxL6jqBR;;AwLzjqBA;EACE;IACE,gBAAA;ExL4jqBF;AACF;AyL9mqBA;EACE,WxLeM;EwLdN,eAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AzLgnqBF;AyL/mqBE;EACE,WAAA;EACA,YAAA;AzLinqBJ;AyL9mqBE;EAEE,UAAA;AzL+mqBJ;;A0LnoqBA;EACE;IACE,UAAA;E1LsoqBF;E0LpoqBA;IACE,QAAA;E1LsoqBF;AACF;A0LnoqBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,aHEW;EGDX,2CAAA;EACA,0CAAA;EpLEE,sBAAA;ANooqBJ;A0LnoqBE;EACE,QAAA;EACA,UAAA;EAAA,aAAA;A1LqoqBJ;A0LnoqBE;EACE,mBzLqBI;ADgnqBR;A2L1pqBA;EACI;IAJA,8DAAA;E3LiqqBF;E2LtpqBE;IACI,UAAA;IACA,oCAAA;E3LwpqBN;E2LtpqBE;IACI,UAAA;IACA,mCAAA;E3LwpqBN;E2LtpqBE;IACI,kCAAA;E3LwpqBN;E2LtpqBE;IACI,kCAAA;E3LwpqBN;E2LtpqBE;IACI,eAAA;E3LwpqBN;AACF;A2LrpqBA;EACI;IACI,UAAA;IACA,mCAAA;E3LupqBN;E2LrpqBE;IACI,UAAA;IACA,oCAAA;E3LupqBN;AACF;A2LppqBA;EACI;IA1CA,8DAAA;E3LisqBF;E2LhpqBE;IACI,UAAA;IACA,qCAAA;E3LkpqBN;E2LhpqBE;IACI,UAAA;IACA,kCAAA;E3LkpqBN;E2LhpqBE;IACI,mCAAA;E3LkpqBN;E2LhpqBE;IACI,iCAAA;E3LkpqBN;E2LhpqBE;IACI,eAAA;E3LkpqBN;AACF;A2L/oqBA;EACI;IACI,UAAA;IACA,kCAAA;E3LipqBN;E2L/oqBE;IACI,UAAA;IACA,qCAAA;E3LipqBN;AACF;A2L9oqBA;EACI;IAhFA,8DAAA;E3LiuqBF;E2L1oqBE;IACI,UAAA;IACA,oCAAA;E3L4oqBN;E2L1oqBE;IACI,UAAA;IACA,mCAAA;E3L4oqBN;E2L1oqBE;IACI,kCAAA;E3L4oqBN;E2L1oqBE;IACI,kCAAA;E3L4oqBN;E2L1oqBE;IACI,+BAAA;E3L4oqBN;AACF;A2LzoqBA;EACI;IACI,mCAAA;E3L2oqBN;E2LzoqBE;IAEI,UAAA;IACA,kCAAA;E3L0oqBN;E2LxoqBE;IACI,UAAA;IACA,qCAAA;E3L0oqBN;AACF;A2LvoqBA;EACI;IA1HA,8DAAA;E3LowqBF;E2LnoqBE;IACI,UAAA;IACA,qCAAA;E3LqoqBN;E2LnoqBE;IACI,UAAA;IACA,kCAAA;E3LqoqBN;E2LnoqBE;IACI,mCAAA;E3LqoqBN;E2LnoqBE;IACI,iCAAA;E3LqoqBN;E2LnoqBE;IACI,eAAA;E3LqoqBN;AACF;A2LloqBA;EACI;IACI,kCAAA;E3LooqBN;E2LloqBE;IAEI,UAAA;IACA,mCAAA;E3LmoqBN;E2LjoqBE;IACI,UAAA;IACA,oCAAA;E3LmoqBN;AACF;A2L/nqBI;EAEI,sCAAA;A3LgoqBR;A2L9nqBI;EAEI,uCAAA;A3L+nqBR;A2L7nqBI;EACI,sCAAA;A3L+nqBR;A2L7nqBI;EACI,oCAAA;A3L+nqBR;;A2L1nqBI;EAEI,uCAAA;A3L4nqBR;A2L1nqBI;EAEI,wCAAA;A3L2nqBR;A2LznqBI;EACI,qCAAA;A3L2nqBR;A2LznqBI;EACI,uCAAA;A3L2nqBR;;A4L7zqBA;EACI;IACI,UAAA;IACA,iCAAA;E5Lg0qBN;E4L9zqBE;IACI,UAAA;E5Lg0qBN;AACF;A4L7zqBA;EACI;IACI,UAAA;E5L+zqBN;E4L7zqBE;IACI,UAAA;IACA,iCAAA;E5L+zqBN;E4L7zqBE;IACI,UAAA;E5L+zqBN;AACF;A4L5zqBA;EACI,gCAAA;A5L8zqBJ;;A4L3zqBA;EACI,iCAAA;A5L8zqBJ;;A6L11qBA;EACI;IACI,sDAAA;IACA,kCAAA;IACA,UAAA;E7L61qBN;E6L31qBE;IACI,uDAAA;IACA,kCAAA;E7L61qBN;E6L31qBE;IACI,sDAAA;IACA,UAAA;E7L61qBN;E6L31qBE;IACI,sDAAA;E7L61qBN;E6L31qBE;IACI,6BAAA;E7L61qBN;AACF;A6L11qBA;EACI;IACI,6BAAA;E7L41qBN;E6L11qBE;IACI,uDAAA;IACA,UAAA;E7L41qBN;E6L11qBE;IACI,sDAAA;IACA,UAAA;E7L41qBN;AACF;A6Lz1qBA;EACI,gCAAA;A7L21qBJ;;A6Lx1qBA;EACI,iCAAA;A7L21qBJ;;A8Lh4qBA;EACI;IACI,kCAAA;IACA,mBAAA;E9Lm4qBN;E8Lj4qBE;IARA,+BAAA;E9L44qBF;AACF;A8Lh4qBA;EACI;IACI,mCAAA;IACA,mBAAA;E9Lk4qBN;E8Lh4qBE;IAlBA,+BAAA;E9Lq5qBF;AACF;A8L/3qBA;EACI;IACI,kCAAA;IACA,mBAAA;E9Li4qBN;E8L/3qBE;IA5BA,+BAAA;E9L85qBF;AACF;A8L93qBA;EACI;IACI,mCAAA;IACA,mBAAA;E9Lg4qBN;E8L93qBE;IAtCA,+BAAA;E9Lu6qBF;AACF;A8L73qBA;EACI;IA5CA,+BAAA;E9L46qBF;E8L73qBE;IACI,kBAAA;IACA,kCAAA;E9L+3qBN;AACF;A8L53qBA;EACI;IAtDA,+BAAA;E9Lq7qBF;E8L53qBE;IACI,kBAAA;IACA,mCAAA;E9L83qBN;AACF;A8L33qBA;EACI;IAhEA,+BAAA;E9L87qBF;E8L33qBE;IACI,kBAAA;IACA,mCAAA;E9L63qBN;AACF;A8L13qBA;EACI;IA1EA,+BAAA;E9Lu8qBF;E8L13qBE;IACI,kBAAA;IACA,oCAAA;E9L43qBN;AACF;A8Lx3qBI;EAEI,qCAAA;A9Ly3qBR;A8Lv3qBI;EAEI,sCAAA;A9Lw3qBR;A8Lt3qBI;EACI,qCAAA;A9Lw3qBR;A8Lt3qBI;EACI,mCAAA;A9Lw3qBR;;A8Ln3qBI;EAEI,sCAAA;A9Lq3qBR;A8Ln3qBI;EAEI,uCAAA;A9Lo3qBR;A8Ll3qBI;EACI,oCAAA;A9Lo3qBR;A8Ll3qBI;EACI,sCAAA;A9Lo3qBR;;A+Lt+qBA,oBAAA;AACA;;EAEE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A/Ly+qBF;;A+Lt+qBA;EACE,eAAA;A/Ly+qBF;;A+Lt+qBA,eAAA;AACA;EACE,kBAAA;EACA,sB9LSM;E8LRN,Y3LgtCkC;AJyxoBpC;;A+Lt+qBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,gB9LbM;E8LcN,4L9L2FsB;EKtGpB,sBAAA;EyLaF,uBAAA;A/Ly+qBF;;A+Lt+qBA;EACE,aAAA;A/Ly+qBF;;A+Lt+qBA,uBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;A/Ly+qBF;;A+Lt+qBA;;EAEE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,mB9LrCS;E8LsCT,mBAAA;EACA,2BAAA;A/Ly+qBF;;A+Lt+qBA;EACE,wBAAA;A/Ly+qBF;;A+Lt+qBA;EACE,yBAAA;A/Ly+qBF;;A+Lt+qBA;;EAEE,mB9LjDS;AD0hrBX;;A+Lt+qBA,eAAA;AAEA;EACE;IACE,UAAA;E/Lw+qBF;AACF;A+Lr+qBA;EACE,wCAAA;A/Lu+qBF;;A+Lp+qBA;EACE;IACE,UAAA;E/Lu+qBF;AACF;A+Lp+qBA;EACE,yCAAA;A/Ls+qBF;;A+Ln+qBA;EACE;IACE,iCAAA;E/Ls+qBF;AACF;A+Ln+qBA;EACE,6DAAA;A/Lq+qBF;;A+Ll+qBA;EACE;IACE,iCAAA;E/Lq+qBF;AACF;A+Ll+qBA;EACE,gCAAA;A/Lo+qBF;;A+Lj+qBA;EACE;IACE,oCAAA;E/Lo+qBF;AACF;A+Lj+qBA;EACE,kEAAA;A/Lm+qBF;;A+Lh+qBA;EACE;IACE,oCAAA;E/Lm+qBF;AACF;A+Lh+qBA;EACE,qCAAA;A/Lk+qBF;;A+L/9qBA,oBAAA;AAEA;EACE;IACE,oCAAA;E/Li+qBF;AACF;A+L99qBA;EACE,kEAAA;A/Lg+qBF;;A+L79qBA;EACE;IACE,oCAAA;E/Lg+qBF;AACF;A+L79qBA;EACE,qCAAA;A/L+9qBF;;A+L59qBA,qBAAA;AAEA;EACE;IACE,mCAAA;E/L89qBF;AACF;A+L39qBA;EACE,mEAAA;A/L69qBF;;A+L19qBA;EACE;IACE,mCAAA;E/L69qBF;AACF;A+L19qBA;EACE,sCAAA;A/L49qBF;;A+Lz9qBA,kBAAA;AAEA;EACE;IACE,mCAAA;E/L29qBF;AACF;A+Lx9qBA;EACE,gEAAA;A/L09qBF;;A+Lv9qBA;EACE;IACE,mCAAA;E/L09qBF;AACF;A+Lv9qBA;EACE,mCAAA;A/Ly9qBF;;A+Lt9qBA,eAAA;AAEA;EACE;IACE,sDAAA;E/Lw9qBF;E+Lt9qBA;IACE,uDAAA;E/Lw9qBF;E+Lt9qBA;IACE,6BAAA;E/Lw9qBF;AACF;A+Lr9qBA;EACE,wCAAA;EACA,+CAAA;UAAA,uCAAA;A/Lu9qBF;;A+Lp9qBA;EACE;IACE,6BAAA;E/Lu9qBF;E+Lr9qBA;IACE,uDAAA;E/Lu9qBF;E+Lr9qBA;IACE,sDAAA;E/Lu9qBF;AACF;A+Lp9qBA;EACE,gCAAA;EACA,+CAAA;UAAA,uCAAA;A/Ls9qBF;;A+Ln9qBA,iBAAA;AAEA;EACE;IACE,4DAAA;E/Lq9qBF;AACF;A+Ll9qBA;EACE,kCAAA;EACA,wBAAA;A/Lo9qBF;;A+Lj9qBA;EACE;IACE,2DAAA;E/Lo9qBF;AACF;A+Lj9qBA;EACE,kCAAA;EACA,wBAAA;A/Lm9qBF;;A+Lh9qBA,eAAA;AAEA;EACE;IACE,2BAAA;E/Lk9qBF;AACF;A+L/8qBA;EACE,6DAAA;A/Li9qBF;;A+L98qBA;EACE;IACE,8BAAA;E/Li9qBF;E+L/8qBA;IACE,6BAAA;E/Li9qBF;AACF;A+L98qBA;EACE,gCAAA;A/Lg9qBF;;AgM9urBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AhMivrBF;;AgM9urBA;EACE,aAAA;EACA,mBAAA;EAEA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AhMivrBF;;AgM9urBA;EAEE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,qCAAA;AhMivrBF;;AgM9urBA;EACE,UAAA;EACA,WAAA;AhMivrBF;;AgM9urBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AhMivrBF;;AgM9urBA;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AhMivrBF;;AgM9urBA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;AhMivrBF;;AgM9urBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,gEAAA;EACA,WAAA;EACA,UAAA;AhMivrBF;;AgM9urBA;EACE;IACE,QAAA;IACA,YAAA;EhMivrBF;EgM/urBA;IACE,QAAA;IACA,YAAA;EhMivrBF;EgM/urBA;IACE,WAAA;IACA,UAAA;EhMivrBF;AACF;AgM9urBA;EACE,qBAAA;AhMgvrBF;;AiMt0rBA,WAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AjMw0rBF;;AiMp0rBE;EACE,gBAAA;AjMu0rBJ;AiMr0rBI;EACE,WAAA;AjMu0rBN;AiMp0rBI;EACE,YAAA;AjMs0rBN;;AiMh0rBE;EACE,gBAAA;EACA,cAAA;AjMm0rBJ;;AiM9zrBE;EACE,UAAA;EACA,mBhMEI;EgMDJ,sBAAA;AjMi0rBJ;AiM9zrBE;EACE,WAAA;AjMg0rBJ;AiM5zrBE;EACE,YAAA;AjM8zrBJ;AiMzzrBI;EACE,UAAA;AjM2zrBN;;AiMtzrBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AjMyzrBF;AiMvzrBE;EACE,aAAA;AjMyzrBJ;AiMtzrBE;EACE,eAAA;EACA,YAAA;AjMwzrBJ;;AiMpzrBA;;EAME,+BAAA;AjMuzrBF;;AiMpzrBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AjMuzrBF;AiMrzrBE;EAEE,WAAA;EACA,cAAA;AjMszrBJ;AiMnzrBE;EACE,WAAA;AjMqzrBJ;AiMlzrBE;EACE,kBAAA;AjMozrBJ;;AiMhzrBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EAWA,aAAA;AjMyyrBF;AiMnzrBE;EACE,YAAA;AjMqzrBJ;AiMnzrBE;EACE,cAAA;AjMqzrBJ;AiMnzrBE;EACE,aAAA;AjMqzrBJ;AiMhzrBE;EACE,oBAAA;AjMkzrBJ;AiM/yrBE;EACE,cAAA;AjMizrBJ;AiM9yrBE;EACE,kBAAA;AjMgzrBJ;AiM7yrBE;EACE,cAAA;EACA,YAAA;EACA,6BAAA;AjM+yrBJ;;AiM3yrBA;EACE,aAAA;AjM8yrBF;;AkMr7rBA,WAAA;AAEA;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cjMFS;EiMGT,QAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kUjMkFmB;EiMjFnB,oBAAA;EACA,+BAAA;E5LbE,mBAAA;E4LeF,gBjMlBM;EiMmBN,UAAA;EACA,gBAAA;AlMu7rBF;AkMr7rBE;;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AlMw7rBJ;AkMr7rBE;;;EACE,aAAA;EACA,4C9L+U0B;E8L9U1B,cjMFI;AD27rBR;AkMt7rBE;;EACE,aAvCuB;AlMg+rB3B;;AkMr7rBA;EACE,OAAA;AlMw7rBF;AkMv7rBE;EACE,gBAlDmB;AlM2+rBvB;;AkMp7rBA;EACE,QAAA;AlMu7rBF;AkMt7rBE;EACE,gBA3DmB;AlMm/rBvB;;AkMp7rBA,SAAA;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AlMs7rBF;AkMr7rBE;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AlMu7rBJ;AkMr7rBI;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBjMjDE;EiMkDF,eAAA;EACA,kBAAA;E5L9EF,mBAAA;E4LgFE,kBAAA;AlMu7rBN;AkMr7rBM;EACE,WAAA;EACA,kBAAA;EACA,gBjMxFA;EiMyFA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;E5L3FJ,mBAAA;ANmhsBJ;AkMn7rBI;EACE,qBAAA;AlMq7rBN;;AkMh7rBA;EACE,qBAAA;AlMm7rBF;;AkM/6rBE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AlMk7rBJ;AkM/6rBE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AlMi7rBJ;AkM/6rBI;EACE,kB9L6SwB;E8L5SxB,mBAAA;EACA,qB1H/IM;AxEgksBZ;AkM96rBI;EACE,kBjM3DW;EiM4DX,YAAA;AlMg7rBN;;AkMx6rBE;EACE,kBAAA;EACA,YAAA;AlM26rBJ;AkMz6rBI;EACE,qCAAA;AlM26rBN;AkMv6rBE;;EAEE,uBAAA;EACA,WjM3JI;EiM4JJ,+BAAA;AlMy6rBJ;AkMv6rBI;;EACE,qCAAA;AlM06rBN;AkMt6rBE;EACE,WAAA;AlMw6rBJ;AkMr6rBE;EACE,UAAA;AlMu6rBJ;AkMp6rBE;EACE,WjM5KI;ADklsBR;;AmMlmsBA;EACE,kBAAA;AnMqmsBF;;AmMlmsBA;EACE,qBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;AnMqmsBF;;AmMlmsBA;EACE,kBAAA;EACA,eAAA;AnMqmsBF;;AmMlmsBA;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AnMqmsBF;;AmMlmsBA;EACE,aAAA;AnMqmsBF;;AmMlmsBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;AnMqmsBF;;AmMlmsBA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;AnMqmsBF;;AmMlmsBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AnMomsBF;;AmMhmsBE;EACE,wBAAA;AnMmmsBJ;;AoM7psBA;EACE,kUnMyGmB;ADujsBrB;AoM9psBE;EACE,oBAAA;EACA,YAAA;ApMgqsBJ;AoM9psBI;EACE,ahM2OG;AJq7rBT;AoM5psBM;EACE,mBhMsOC;AJw7rBT;AoMzpsBE;EACE,+BAAA;ApM2psBJ;AoMzpsBI;EACE,UAAA;ApM2psBN;AoMtpsBI;E9LLA,8BAAA;EACA,+BAAA;E8LME,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApMypsBN;;AoMnpsBE;EACE,eAAA;EAAA,kBAAA;ApMspsBJ;;AoMhpsBI;EACE,wBAAA;ApMmpsBN;;AoM7osBE;EACE,oCAAA;ApMgpsBJ;;AoMjpsBE;EACE,oCAAA;ApMopsBJ;;AoMrpsBE;EACE,oCAAA;ApMwpsBJ;;AoMzpsBE;EACE,oCAAA;ApM4psBJ;;AoM7psBE;EACE,oCAAA;ApMgqsBJ;;AoMjqsBE;EACE,oCAAA;ApMoqsBJ;;AoMrqsBE;EACE,oCAAA;ApMwqsBJ;;AoMzqsBE;EACE,oCAAA;ApM4qsBJ;;AoM7qsBE;EACE,oCAAA;ApMgrsBJ;;AoMjrsBE;EACE,oCAAA;ApMorsBJ;;AoM3qsBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ApM8qsBJ;AoM5qsBI;EACE,aAAA;E9L9CF,8BAAA;EACA,+BAAA;E8L+CE,gBAAA;ApM+qsBN;AoM7qsBM;EACE,iBAAA;ApM+qsBR;AoM5qsBM;EACE,yBAAA;ApM8qsBR;AoMzqsBE;EACE,gBAAA;ApM2qsBJ;AoMxqsBE;EACE,gBAAA;ApM0qsBJ;AoMvqsBE;EACE,gBAAA;ApMyqsBJ;;AoMrqsBA;EACE,SAAA;ApMwqsBF;AoMtqsBE;EACE,aAAA;ApMwqsBJ;AoMrqsBE;EACE,oCAAA;EACA,gBAAA;EACA,yBAAA;ApMuqsBJ;AoMrqsBI;EACE,aAAA;ApMuqsBN;AoMnqsBE;EACE,+BAAA;ApMqqsBJ;AoMjqsBI;EACE,yBAAA;ApMmqsBN;AoMhqsBI;EACE,yBAAA;ApMkqsBN;;AoMzpsBI;EACE,gBnM1HE;EmM2HF,cnMnHK;EmMoHL,kUnM5Be;EmM6Bf,2EAAA;ApM4psBN;AoMzpsBI;EACE,aAAA;ApM2psBN;;AqM1ysBA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;ArM6ysBF;AqM5ysBE;EACE,UAAA;ArM8ysBJ;;AsMrzsBA;EACE,cAAA;EACA,aAAA;EACA,SAAA;AtMwzsBF;;AsMrzsBA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;AtMwzsBF;;AsMrzsBA;EACE,mBAAA;AtMwzsBF;;AsMrzsBA;EACE,SAAA;EACA,UAAA;AtMwzsBF;;AuMv0sBA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACE,SAAA;EACA,iBAAA;AvM00sBJ;;AuMv0sBA;;;EAGE,mBAAA;AvM00sBF;;AuMv0sBA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AvM00sBF;;AuMv0sBA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AvM00sBF;;AuMv0sBA;EACE,cAAA;AvM00sBF;;AuMv0sBA;EACE,+BCtCmB;AxMg3sBrB;;AuMv0sBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AvM00sBF;AuMv0sBI;EACE,cAAA;EACA,qBAAA;AvMy0sBN;;AuMp0sBA;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AvMu0sBF;;AuMp0sBA;EACE,yBtMoCuB;ADmysBzB;;AyMx4sBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AzM24sBF;AyMz4sBE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AzM24sBJ;AyMx4sBE;EACE,WxMJI;EwMKJ,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBxMqBI;EwMpBJ,yBAAA;EACA,sBAAA;EACA,sBrMyV0B;EqMxV1B,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;AzM04sBJ;AyMx4sBI;EAEE,sBAAA;EACA,gDAAA;EACA,mEAnCc;EAoCd,+DAnCU;AzM46sBhB;AyMv4sBM;EAEE,WxM5BA;EwM6BA,mEAAA;EACA,+DAAA;AzMw4sBR;AyMp4sBI;EACE,WxMnCE;EwMoCF,mEAhDc;EAiDd,+DAhDU;AzMs7sBhB;AyMn4sBI;EACE,WxMzCE;EwM0CF,mEAtDc;EAuDd,+DAtDU;AzM27sBhB;;AyMh4sBA;EACE,qBAAA;EACA,mBAAA;AzMm4sBF;AyMj4sBE;EACE,0BAAA;EACA,6BAAA;AzMm4sBJ;AyMh4sBE;EACE,yBAAA;EACA,4BAAA;AzMk4sBJ;AyM/3sBE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AzMi4sBJ;AyM93sBE;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;AzMg4sBJ;AyM73sBE;EACE,gBAAA;AzM+3sBJ;AyM53sBE;EACE,iBAAA;AzM83sBJ;AyM33sBE;EACE,cAAA;EACA,kBAAA;AzM63sBJ;AyM13sBE;EAEE,iBAAA;AzM23sBJ;;A0Ml+sBA;EACE,eAAA;EACA,iBtM+9BkC;EsM99BlC,yBzMyCM;EyMxCN,sBtM+W4B;EsM9W5B,WzMSM;AD49sBR;A0Mn+sBE;EACE,mEAAA;A1Mq+sBJ;;A0Mj+sBA;EAEE,cAAA;A1Mm+sBF;;A0Mh+sBA;EACE,kDAAA;A1Mm+sBF;;A0Mh+sBA;EACE,yBAAA;EACA,4BAAA;A1Mm+sBF;;A0Mj+sBA;EACE,0BAAA;EACA,6BAAA;A1Mo+sBF;;A0Mh+sBA;EACE,yBAAA;EACA,0BAAA;A1Mm+sBF;;A0Mj+sBA;EACE,4BAAA;EACA,6BAAA;A1Mo+sBF;;A2MxgtBA;EACE,aAAA;EACA,mBAAA;A3M2gtBF;;A2MxgtBA;EACE,sBAAA;A3M2gtBF;A2MpgtBA;EACE,oCHHwB;AxMygtB1B;;A2MlgtBA;EAEE,0CAAA;EACA,UHFa;EGGb,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;A3MogtBF;;A2MjgtBA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,YAAA;A3MmgtBF;A2MjgtBE;EACE,gCAAA;A3MmgtBJ;A2MhgtBE;EACE,8BAAA;A3MkgtBJ;A2M//sBE;EACE,oBAAA;EACA,+BAAA;A3MigtBJ;;A2M7/sBA;EACE,aAAA;EACA,mBAAA;A3MggtBF;;A2M7/sBA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EAEA,YAAA;A3M+/sBF;A2M7/sBE;EACE,6BAAA;A3M+/sBJ;;A2M3/sBA;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;A3M8/sBF;A2M5/sBE;EACE,iBAAA;A3M8/sBJ;A2M1/sBI;EACE,cAAA;EACA,qBAAA;A3M4/sBN;;A2Mv/sBA;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;A3My/sBF;;A2Mt/sBA;EACA,SAAA;A3My/sBA;A2Mx/sBE;EACE,8BAAA;A3M0/sBJ;A2Mv/sBE;EACE,oBAAA;EACA,+BAAA;A3My/sBJ;;A2Mr/sBA;EACI,mB1MjGO;ADyltBX;;A2Mr/sBA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;A3Mw/sBF;A2Mt/sBE;EACE,eAAA;A3Mw/sBJ;;A2Mp/sBA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;A3Mu/sBF;;A4M3ntBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;A5M8ntBF;A4M5ntBE;EACE,WAAA;EACA,yBAAA;A5M8ntBJ;A4M5ntBI;EACE,iBAAA;EACA,mBAAA;A5M8ntBN;A4M1ntBI;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;A5M4ntBN;A4MzntBI;EACE,8BAAA;A5M2ntBN;A4MvntBM;EACE,oBAAA;EACA,+BAAA;A5MyntBR;A4MrntBI;EACE,6BAAA;A5MuntBN;A4MpntBI;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;A5MsntBN;A4MpntBM;EACE,iBAAA;A5MsntBR;;A4MhntBA;EACE,yBAAA;A5MmntBF;A4MjntBE;EACE,aAAA;A5MmntBJ;A4MjntBE;EACE,aAAA;A5MmntBJ;;A4M/mtBA;;EAEE,mBAAA;A5MkntBF;;A4M7mtBA;EACE,WAAA;A5MgntBF;;A6MlrtBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;A7MqrtBF;A6MnrtBE;EACE,SAAA;A7MqrtBJ;;A6MhrtBA;EACE,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;A7MmrtBF;;A6MhrtBA;;EAEE,UAAA;A7MmrtBF;;A6MhrtBA;EACE,cAAA;A7MmrtBF;;A6MhrtBA;EACE,kBAAA;A7MmrtBF;A6MjrtBE;EACE,mEAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;A7MmrtBJ;A6MhrtBE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;A7MkrtBJ;A6M/qtBE;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;A7MirtBJ;A6M9qtBE;EACE,2BAAA;A7MgrtBJ;;A6M5qtBA;EACE,SAAA;A7M+qtBF;A6M7qtBE;EACE,iBAAA;A7M+qtBJ;;A6M3qtBA;EACE,kBAAA;A7M8qtBF;;A6M3qtBA;EACE,kBAAA;EACA,UAAA;A7M8qtBF;;A8MvvtBA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,oCNMwB;EMLxB,aNIqB;EMHrB,cAAA;EACA,YAAA;A9M0vtBF;;A8MvvtBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;A9M0vtBF;A8MxvtBE;EACE,mBAAA;A9M0vtBJ;A8MvvtBE;EACE,WAAA;EACA,kBAAA;A9MyvtBJ;A8MtvtBE;EACE,kBAAA;EACA,UAAA;A9MwvtBJ;A8MrvtBE;EACE,gBAAA;A9MuvtBJ;;A8MlvtBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;A9MqvtBF;A8MnvtBE;EACE,+BAAA;A9MqvtBJ;A8MlvtBE;EACE,qBAAA;EACA,8BAAA;A9MovtBJ;A8MjvtBE;EACE,8BAAA;A9MmvtBJ;A8MhvtBE;EACE,oBAAA;EACA,+BAAA;A9MkvtBJ;A8M/utBE;EACE,gCAAA;A9MivtBJ;A8M9utBE;EACE,UAAA;A9MgvtBJ;A8M7utBE;EACE,WAAA;A9M+utBJ;;A8M3utBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;A9M8utBF;A8M5utBE;EACE,UAAA;A9M8utBJ;A8M3utBE;EACE,8BAAA;A9M6utBJ;A8M1utBE;EACE,oBAAA;EACA,+BAAA;A9M4utBJ;A8MzutBE;EACE,WAAA;EACA,yBAAA;UAAA,iBAAA;A9M2utBJ;;A8MvutBA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EAEA,yB7MzDM;E6M0DN,oBAAA;A9MyutBF;A8MvutBE;EACE,cAAA;EAEA,kBAAA;EACA,UAAA;EACA,SAAA;EAEA,YAAA;EACA,yB7MpEI;E6MsEJ,kBAAA;EACA,UAAA;EACA,WAAA;A9MsutBJ;A8MnutBE;EACE,OAAA;EACA,WAAA;A9MqutBJ;;A+Mt2tBA;EACE,kCAAA;EzMgBE,mBAAA;AN01tBJ;A+Mv2tBE;EAGE,oCAAA;A/Mu2tBJ;A+Mp2tBE;EACE,yB9MKO;ADi2tBX;A+Mn2tBE;EACE,gCAAA;A/Mq2tBJ;;AgNt3tBA;;EAAA;AAGA;EACE,yBAAA;AhNy3tBF;;AgNt3tBA;EACE,4BAAA;AhNy3tBF;;AgNt3tBA;EACE,cAAA;AhNy3tBF;;AgNt3tBA;EACE,aAAA;AhNy3tBF;;AgNt3tBA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AhNy3tBF;;AgNt3tBA;EACE,iBAAA;AhNy3tBF;;AgNt3tBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;AhNy3tBF;;AgNt3tBA;;;;+EAAA;AAKA;;EAEE,YAAA;EACA,kBAAA;EACA,qBAAA;AhNy3tBF;;AgNt3tBA;EACE,kBAAA;EACA,MAAA;AhNy3tBF;;AgNt3tBA;;;;EAIE,kBAAA;EACA,WAAA;EACA,uBAAA;AhNy3tBF;;AgNt3tBA;;;;;;EAAA;AAOA;EACE,WAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AhNy3tBF;;AgNt3tBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;AhNy3tBF;;AgNt3tBA;;;EAGE,UAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AhNy3tBF;;AgNt3tBA;;;EAGE,UAAA;EACA,UAAA;EAAA,aAAA;AhNy3tBF;;AgNt3tBA;EACE,WAAA;AhNy3tBF;;AgNt3tBA;EACE,SAAA;EACA,SAAA;EACA,WAAA;AhNy3tBF;;AgNt3tBA;+EAAA;AAEA;EACE,UAAA;AhNy3tBF;;AgNv3tBA;EACE,kBAAA;EACA,WAAA;EACA,yB/MrEM;E+MsEN,UAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AhN03tBF;;AgNv3tBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EAAA,aAAA;EACA,UAAA;AhN03tBF;;AgNv3tBA;EACE;IACE,0BAAA;IACA,UAAA;EhN03tBF;EgNx3tBA;IACE,6BAAA;IACA,UAAA;EhN03tBF;EgNx3tBA;IACE,6BAAA;IACA,UAAA;EhN03tBF;EgNx3tBA;IACE,8BAAA;IACA,UAAA;EhN03tBF;AACF;AgNx3tBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;EACA,8CAAA;AhN03tBF;;AgNv3tBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EAAA,aAAA;AhN03tBF;;AgNv3tBA;;;;;;EAAA;AAOA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;AhN03tBF;;AgNv3tBA;EACE,+BAAA;EACA,iBAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;AhN03tBF;;AgNv3tBA;;;;;;EAAA;AAOA;EACE,UAAA;AhN03tBF;;AgNx3tBA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AhN23tBF;;AgNx3tBA;EACE,+BAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EAAA,cAAA;AhN23tBF;;AgNx3tBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;AhN23tBF;;AgNx3tBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;EACA,gCAAA;EACA,iBAAA;AhN23tBF;;AgNx3tBA;EACE,yBAAA;EACA,YAAA;EACA,sBAAA;AhN23tBF;;AgNx3tBA;EACE,yBAAA;AhN23tBF;;AgNx3tBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AhN23tBF;;AgNz3tBA;EACE,sBAAA;AhN43tBF;;AgNz3tBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AhN43tBF;;AgN13tBA;;EAEE,qBAAA;AhN63tBF;;AgN33tBA;;EAEE,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AhN83tBF;;AgN33tBA;;EAAA;AAGA;EACE,yBAAA;AhN83tBF;;AgN33tBA;;EAAA;AAGA;EACE,0BAAA;AhN83tBF;;AgN33tBA;;EAAA;AAGA;EACE,0BAAA;AhN83tBF;;AgN33tBA;;;;;EAKE,qBAAA;EACA,sBAAA;AhN83tBF;;AgN33tBA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AhN83tBF;;AgN33tBA;EACE,kBAAA;EACA,8BAAA;EACA,qBAAA;AhN83tBF;;AgN33tBA;EACE,8BAAA;AhN83tBF;;AgN33tBA;EACE,+BAAA;EACA,8BAAA;AhN83tBF;;AgN33tBA;EACE,cAAA;EACA,mBAAA;AhN83tBF;;AgN53tBA;EACE,kBAAA;EACA,sBAAA;AhN+3tBF;;AgN53tBA;EACE,cAAA;EACA,aAAA;AhN+3tBF;;AgN53tBA;;EAEE,YAAA;EACA,WAAA;EACA,6EAAA;EAGA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AhN63tBF;;AgN13tBA;EACE,eAAA;EACA,mB/MxWS;ADquuBX;;AgN13tBA;EACE;IAGE,UAAA;EhN23tBF;EgNz3tBA;IACE,UAAA;EhN23tBF;AACF;AgNx3tBA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AhN03tBF;;AgNv3tBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AhN03tBF;;AgNv3tBA;EACE,QAAA;EACA,UAAA;EAAA,aAAA;AhN03tBF;;AgNv3tBA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sB/MlZM;E+MmZN,kBAAA;EACA,oDAAA;AhN03tBF;;AgNx3tBA;EACE,uBAAA;AhN23tBF;;AgNz3tBA;EACE,yBAAA;AhN43tBF;;AgN13tBA;;EAEE,uBAAA;AhN63tBF;;AgN33tBA;EACE,wBAAA;AhN83tBF;;AgN53tBA;EACE,yBAAA;AhN+3tBF;;AgN73tBA;;EAEE,uBAAA;AhNg4tBF;;AgN93tBA;EACE,wBAAA;AhNi4tBF;;AgN/3tBA;EACE,yBAAA;AhNk4tBF;;AgNh4tBA;;EAEE,uBAAA;AhNm4tBF;;AgNj4tBA;EACE,wBAAA;AhNo4tBF;;AgNl4tBA;EACE,yBAAA;AhNq4tBF;;AgNn4tBA;;EAEE,uBAAA;AhNs4tBF;;AgNp4tBA;EACE,yBAAA;AhNu4tBF;;AgNr4tBA;EACE,yBAAA;AhNw4tBF;;AgNt4tBA;;EAEE,uBAAA;AhNy4tBF;;AgNv4tBA;EACE,yBAAA;AhN04tBF;;AgNx4tBA;EACE,yBAAA;AhN24tBF;;AgNz4tBA;;EAEE,uBAAA;AhN44tBF;;AgN14tBA;EACE,yBAAA;AhN64tBF;;AgN34tBA;EACE,yBAAA;AhN84tBF;;AgN54tBA;;EAEE,oBAAA;AhN+4tBF;;AgN54tBA;EACE,iBAAA;AhN+4tBF;;AgN54tBA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AhN+4tBF;;AgN54tBA;EACE,cAAA;EACA,cAAA;AhN+4tBF;;AgN54tBA;;EAEE,wBAAA;UAAA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;AhN+4tBF;;AgN74tBA;;EAEE,+BAAA;AhNg5tBF;;AgN94tBA;;EAEE,aAAA;EACA,+CAAA;AhNi5tBF;;AgN/4tBA;;EAEE,qBAAA;EACA,YAAA;EACA,WAAA;AhNk5tBF;;AgN/4tBA;EACE,0EAAA;AhNk5tBF;;AgN74tBA;EACE,0EAAA;AhNg5tBF;;AgN34tBA;;EAAA;AAGA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;AhN84tBF;;AgN54tBA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AhN+4tBF;;AgN54tBA;EACE,UAAA;EACA,UAAA;EAAA,aAAA;AhN+4tBF;;AgN54tBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AhN+4tBF;;AgN74tBA;;EAEE,sBAAA;AhNg5tBF;;AgN94tBA;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AhNi5tBF;;AgN94tBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AhNi5tBF;;AgN/4tBA;;EAEE,qBAAA;AhNk5tBF;;AgNh5tBA;;EAEE,2BAAA;EACA,mBAAA;AhNm5tBF;;AgNh5tBA;;EAAA;AAGA;EACE,yBAAA;AhNm5tBF;;AgNh5tBA,6BAAA;AAQA,uBAAA;AAQA,wBAAA;AAQA;EACE,gBAAA;EACA,yBAAA;EAGA,aAAA;EAIA,mBAAA;EAGA,mBAAA;AhN83tBF;;AgN53tBA;EAGE,aAAA;EAIA,mBAAA;EAGA,mBAAA;AhN+3tBF;;AgN53tBA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AhN+3tBF;;AgN53tBA;;EAEE,kBAAA;EACA,cAAA;AhN+3tBF;;AgN73tBA;EACE,uBAAA;EACA,mBAAA;AhNg4tBF;;AgN73tBA;;EAEE,iBAAA;AhNg4tBF;;AgN93tBA;EACE,eAAA;AhNi4tBF;;AgN93tBA;EAGE,aAAA;EAGA,mBAAA;AhNi4tBF;;AgN/3tBA;EAGE,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AhNk4tBF;;AgN/3tBA,uBAAA;ACxsBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AjN2kvBF;AiNzkvBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AjN2kvBJ;AiNxkvBE;;;;EAIE,cAAA;EACA,WAAA;EACA,chNDO;EgNEP,sBhNTI;EgNUJ,4BAAA;EACA,yBAAA;EAEA,oC7MsrBoC;E6MrrBpC,uBAAA;E3MXA,qBAAA;E2MgBE,sB7MkVwB;E4K9V5B,mFAAA;AhLmlvBF;AiN/jvBI;;;;EACE,6BAAA;EACA,SAAA;AjNokvBN;AiN9jvBI;;;;EACE,chN9BK;EgN+BL,UAAA;AjNmkvBN;AiNhkvBI;;;;;;;EAEE,yBhNxCK;EgNyCL,UAAA;AjNukvBN;AiNnkvBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;AjNqkvBJ;AiNnkvBI;EACE,+BAAA;EACA,gCAAA;AjNqkvBN;AiNnkvBM;;EAEE,ehN6DgB;EgN5DhB,chNtDG;AD2nvBX;AiNnkvBQ;;EACE,chNzDC;AD+nvBX;AiNnkvBQ;;EACE,UAAA;AjNskvBV;AiNjkvBI;EACE,gCAAA;EACA,mBhNzEK;AD4ovBX;AiNjkvBM;EACE,+BAAA;AjNmkvBR;AiNhkvBM;EACE,4CAAA;AjNkkvBR;AiN9jvBI;EACE,kBAAA;AjNgkvBN;AiN7jvBI;;EAEE,gBhN4Be;EgN3Bf,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mEAAA;EACA,qCAAA;EACA,chNrEE;ADoovBR;AiN7jvBM;;EACE,wDAAA;AjNgkvBR;AiN5jvBI;;EAEE,mCAAA;AjN8jvBN;AiN3jvBI;;EAEE,oCAAA;AjN6jvBN;AiN1jvBI;;EAEE,eAAA;AjN4jvBN;AiNzjvBI;;EAEE,eAAA;AjN2jvBN;AiNxjvBI;EACE,iBAAA;AjN0jvBN;AiNvjvBI;EACE,gBAAA;AjNyjvBN;AiNtjvBI;EACE,gBAAA;EACA,uBAAA;AjNwjvBN;AiNrjvBI;EACE,2BAAA;AjNujvBN;AiNpjvBI;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AjNsjvBN;AiNnjvBI;EACE,oCAAA;EACA,uBhN7JE;EgN8JF,iBAAA;EACA,gBAAA;AjNqjvBN;AiNljvBI;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AjNojvBN;AiNhjvBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AjNkjvBJ;AiNhjvBI;EACE,gCAAA;AjNkjvBN;AiN/ivBI;EACE,gBAAA;AjNijvBN;AiN9ivBI;EACE,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AjNgjvBN;AiN9ivBM;EACE,WAAA;EACA,6BAAA;EACA,2BAAA;E3M9LJ,qBAAA;AN+uvBJ;AiN9ivBQ;EACE,gBAAA;EACA,iEhN5DiB;EgN6DjB,aAAA;AjNgjvBV;AiN3ivBI;EACE,eAAA;AjN6ivBN;AiN1ivBI;EACE,eAAA;EACA,mBAAA;AjN4ivBN;AiNxivBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AjN0ivBJ;AiNvivBE;EACE,cAAA;EACA,oBAAA;AjNyivBJ;AiNtivBE;;EAEE,SAAA;EACA,uBAAA;EACA,gBhN/GiB;EgNiHjB,qBAAA;EACA,uDAAA;AjNuivBJ;AiNrivBI;;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AjNwivBN;AiNpivBE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AjNsivBJ;AiNrivBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;AjNuivBN;AiNrivBI;EACE,0CAAA;AjNuivBN;AiNnivBE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AjNqivBJ;AiNlivBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AjNoivBJ;AiNlivBI;EACE,+BAAA;AjNoivBN;AiNnivBM;EACE,eAAA;AjNqivBR;AiNhivBE;EACE,+BAAA;AjNkivBJ;AiN9hvBI;EACE,2CAAA;AjNgivBN;AiN7hvBI;EACE,4CAAA;AjN+hvBN;AiN3hvBE;EACE,mBhNxNqB;ADqvvBzB;AiN1hvBE;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;AjN4hvBJ;AiN1hvBI;EACE,wBAAA;UAAA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,sB7M+BwB;E6M9BxB,YAAA;EACA,cAAA;EACA,chN3SE;EgN4SF,mBhNzUK;EgN0UL,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AjN4hvBN;AiNzhvBI;EACE,YAAA;EACA,eAAA;AjN2hvBN;AiNxhvBI;EACE,mBhNzTE;EgN0TF,WhNxVE;ADk3vBR;AiNvhvBI;;EAEE,SAAA;EACA,kBAAA;AjNyhvBN;AiNthvBI;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AjNwhvBN;AiNrhvBI;EACE,iBAAA;EACA,iBAAA;AjNuhvBN;AiNphvBI;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AjNshvBN;AiNnhvBI;EACE,qBAAA;EACA,aAAA;AjNqhvBN;AiNlhvBI;EACE,WAAA;EACA,kBAAA;AjNohvBN;AiNjhvBI;EACE,gBAAA;AjNmhvBN;AiN/gvBE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AjNihvBJ;AiN9gvBE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AjNghvBJ;AiN7gvBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,chN7YI;EgN8YJ,2BAAA;EACA,yDAAA;AjN+gvBJ;AiN5gvBE;EACE,UAAA;EACA,UAAA;EACA,mBAAA;AjN8gvBJ;AiN3gvBE;EACE,0BAAA;AjN6gvBJ;AiN1gvBE;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AjN4gvBJ;;AiNxgvBA;;EAEE,sBAAA;AjN2gvBF;;AiNvgvBE;EACE,oBAAA;EACA,YAAA;EACA,sBAAA;AjN0gvBJ;;AiNtgvBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AjNygvBF;;AiNrgvBE;;EAEE,chNhcI;ADw8vBR;;AiNz/uBE;;EAEE,wBAAA;AjN4/uBJ;;AkNv/vBA;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;AlNs/vBF;AkNn/vBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AlNo/vBF;;AkNj/vBA;EACE,gBAAA;AlNo/vBF;;AkNl/vBA;EACE,gBAAA;AlNq/vBF;;AkNn/vBA;EACE,gBAAA;AlNs/vBF;;AkNp/vBA;EACE,gBAAA;AlNu/vBF;;AkNr/vBA;EACE,gBAAA;AlNw/vBF;;AkNt/vBA;EACE,gBAAA;AlNy/vBF;;AkNv/vBA;EACE,gBAAA;AlN0/vBF;;AkNx/vBA;EACE,gBAAA;AlN2/vBF;;AkNz/vBA;EACE,gBAAA;AlN4/vBF;;AkN1/vBA;EACE,gBAAA;AlN6/vBF;;AkN3/vBA;EACE,gBAAA;AlN8/vBF;;AkN5/vBA;EACE,gBAAA;AlN+/vBF;;AkN7/vBA;EACE,gBAAA;AlNggwBF;;AkN9/vBA;EACE,gBAAA;AlNigwBF;;AkN//vBA;EACE,gBAAA;AlNkgwBF;;AkNhgwBA;EACE,gBAAA;AlNmgwBF;;AkNjgwBA;EACE,gBAAA;AlNogwBF;;AkNlgwBA;EACE,gBAAA;AlNqgwBF;;AkNngwBA;EACE,gBAAA;AlNsgwBF;;AkNpgwBA;EACE,gBAAA;AlNugwBF;;AkNrgwBA;EACE,gBAAA;AlNwgwBF;;AkNtgwBA;EACE,gBAAA;AlNygwBF;;AkNvgwBA;EACE,gBAAA;AlN0gwBF;;AkNxgwBA;EACE,gBAAA;AlN2gwBF;;AkNzgwBA;EACE,gBAAA;AlN4gwBF;;AkN1gwBA;EACE,gBAAA;AlN6gwBF;;AkN3gwBA;EACE,gBAAA;AlN8gwBF;;AkN5gwBA;EACE,gBAAA;AlN+gwBF;;AkN7gwBA;EACE,gBAAA;AlNghwBF;;AkN9gwBA;EACE,gBAAA;AlNihwBF;;AkN/gwBA;EACE,gBAAA;AlNkhwBF;;AkNhhwBA;EACE,gBAAA;AlNmhwBF;;AkNjhwBA;EACE,gBAAA;AlNohwBF;;AkNlhwBA;EACE,gBAAA;AlNqhwBF;;AkNnhwBA;EACE,gBAAA;AlNshwBF;;AkNphwBA;EACE,gBAAA;AlNuhwBF;;AkNrhwBA;EACE,gBAAA;AlNwhwBF;;AkNthwBA;EACE,gBAAA;AlNyhwBF;;AkNvhwBA;EACE,gBAAA;AlN0hwBF;;AkNxhwBA;EACE,gBAAA;AlN2hwBF;;AkNzhwBA;EACE,gBAAA;AlN4hwBF;;AkN1hwBA;EACE,gBAAA;AlN6hwBF;;AkN3hwBA;EACE,gBAAA;AlN8hwBF;;AkN5hwBA;EACE,gBAAA;AlN+hwBF;;AkN7hwBA;EACE,gBAAA;AlNgiwBF;;AkN9hwBA;EACE,gBAAA;AlNiiwBF;;AkN/hwBA;EACE,gBAAA;AlNkiwBF;;AkNhiwBA;EACE,gBAAA;AlNmiwBF;;AkNjiwBA;EACE,gBAAA;AlNoiwBF;;AkNliwBA;EACE,gBAAA;AlNqiwBF;;AkNniwBA;EACE,gBAAA;AlNsiwBF;;AkNpiwBA;EACE,gBAAA;AlNuiwBF;;AkNriwBA;EACE,gBAAA;AlNwiwBF;;AkNtiwBA;EACE,gBAAA;AlNyiwBF;;AkNviwBA;EACE,gBAAA;AlN0iwBF;;AkNxiwBA;EACE,gBAAA;AlN2iwBF;;AkNziwBA;EACE,gBAAA;AlN4iwBF;;AkN1iwBA;EACE,gBAAA;AlN6iwBF;;AkN3iwBA;EACE,gBAAA;AlN8iwBF;;AkN5iwBA;EACE,gBAAA;AlN+iwBF;;AkN7iwBA;EACE,gBAAA;AlNgjwBF;;AkN9iwBA;EACE,gBAAA;AlNijwBF;;AkN/iwBA;EACE,gBAAA;AlNkjwBF;;AkNhjwBA;EACE,gBAAA;AlNmjwBF;;AkNjjwBA;EACE,gBAAA;AlNojwBF;;AkNljwBA;EACE,gBAAA;AlNqjwBF;;AkNnjwBA;EACE,gBAAA;AlNsjwBF;;AkNpjwBA;EACE,gBAAA;AlNujwBF;;AkNrjwBA;EACE,gBAAA;AlNwjwBF;;AkNtjwBA;EACE,gBAAA;AlNyjwBF;;AkNvjwBA;EACE,gBAAA;AlN0jwBF;;AkNxjwBA;EACE,gBAAA;AlN2jwBF;;AkNzjwBA;EACE,gBAAA;AlN4jwBF;;AkN1jwBA;EACE,gBAAA;AlN6jwBF;;AkN3jwBA;EACE,gBAAA;AlN8jwBF;;AkN5jwBA;EACE,gBAAA;AlN+jwBF;;AkN7jwBA;EACE,gBAAA;AlNgkwBF;;AkN9jwBA;EACE,gBAAA;AlNikwBF;;AkN/jwBA;EACE,gBAAA;AlNkkwBF;;AkNhkwBA;EACE,gBAAA;AlNmkwBF;;AkNjkwBA;EACE,gBAAA;AlNokwBF;;AkNlkwBA;EACE,gBAAA;AlNqkwBF;;AkNnkwBA;EACE,gBAAA;AlNskwBF;;AkNpkwBA;EACE,gBAAA;AlNukwBF;;AkNrkwBA;EACE,gBAAA;AlNwkwBF;;AkNtkwBA;EACE,gBAAA;AlNykwBF;;AkNvkwBA;EACE,gBAAA;AlN0kwBF;;AkNxkwBA;EACE,gBAAA;AlN2kwBF;;AkNzkwBA;EACE,gBAAA;AlN4kwBF;;AkN1kwBA;EACE,gBAAA;AlN6kwBF;;AkN3kwBA;EACE,gBAAA;AlN8kwBF;;AkN5kwBA;EACE,gBAAA;AlN+kwBF;;AkN7kwBA;EACE,gBAAA;AlNglwBF;;AkN9kwBA;EACE,gBAAA;AlNilwBF;;AkN/kwBA;EACE,gBAAA;AlNklwBF;;AkNhlwBA;EACE,gBAAA;AlNmlwBF;;AkNjlwBA;EACE,gBAAA;AlNolwBF;;AkNllwBA;EACE,gBAAA;AlNqlwBF;;AkNnlwBA;EACE,gBAAA;AlNslwBF;;AkNplwBA;EACE,gBAAA;AlNulwBF;;AkNrlwBA;EACE,gBAAA;AlNwlwBF;;AkNtlwBA;EACE,gBAAA;AlNylwBF;;AkNvlwBA;EACE,gBAAA;AlN0lwBF;;AkNxlwBA;EACE,gBAAA;AlN2lwBF;;AkNzlwBA;EACE,gBAAA;AlN4lwBF;;AkN1lwBA;EACE,gBAAA;AlN6lwBF;;AkN3lwBA;EACE,gBAAA;AlN8lwBF;;AkN5lwBA;EACE,gBAAA;AlN+lwBF;;AkN7lwBA;EACE,gBAAA;AlNgmwBF;;AkN9lwBA;EACE,gBAAA;AlNimwBF;;AkN/lwBA;EACE,gBAAA;AlNkmwBF;;AkNhmwBA;EACE,gBAAA;AlNmmwBF;;AkNjmwBA;EACE,gBAAA;AlNomwBF;;AkNlmwBA;EACE,gBAAA;AlNqmwBF;;AkNnmwBA;EACE,gBAAA;AlNsmwBF;;AkNpmwBA;EACE,gBAAA;AlNumwBF;;AkNrmwBA;EACE,gBAAA;AlNwmwBF;;AkNtmwBA;EACE,gBAAA;AlNymwBF;;AkNvmwBA;EACE,gBAAA;AlN0mwBF;;AkNxmwBA;EACE,gBAAA;AlN2mwBF;;AkNzmwBA;EACE,gBAAA;AlN4mwBF;;AkN1mwBA;EACE,gBAAA;AlN6mwBF;;AkN3mwBA;EACE,gBAAA;AlN8mwBF;;AkN5mwBA;EACE,gBAAA;AlN+mwBF;;AkN7mwBA;EACE,gBAAA;AlNgnwBF;;AkN9mwBA;EACE,gBAAA;AlNinwBF;;AkN/mwBA;EACE,gBAAA;AlNknwBF;;AkNhnwBA;EACE,gBAAA;AlNmnwBF;;AkNjnwBA;EACE,gBAAA;AlNonwBF;;AkNlnwBA;EACE,gBAAA;AlNqnwBF;;AkNnnwBA;EACE,gBAAA;AlNsnwBF;;AkNpnwBA;EACE,gBAAA;AlNunwBF;;AkNrnwBA;EACE,gBAAA;AlNwnwBF;;AkNtnwBA;EACE,gBAAA;AlNynwBF;;AkNvnwBA;EACE,gBAAA;AlN0nwBF;;AkNxnwBA;EACE,gBAAA;AlN2nwBF;;AkNznwBA;EACE,gBAAA;AlN4nwBF;;AkN1nwBA;EACE,gBAAA;AlN6nwBF;;AkN3nwBA;EACE,gBAAA;AlN8nwBF;;AkN5nwBA;EACE,gBAAA;AlN+nwBF;;AkN7nwBA;EACE,gBAAA;AlNgowBF;;AkN9nwBA;EACE,gBAAA;AlNiowBF;;AkN/nwBA;EACE,gBAAA;AlNkowBF;;AkNhowBA;EACE,gBAAA;AlNmowBF;;AkNjowBA;EACE,gBAAA;AlNoowBF;;AkNlowBA;EACE,gBAAA;AlNqowBF;;AkNnowBA;EACE,gBAAA;AlNsowBF;;AkNpowBA;EACE,gBAAA;AlNuowBF;;AkNrowBA;EACE,gBAAA;AlNwowBF;;AkNtowBA;EACE,gBAAA;AlNyowBF;;AkNvowBA;EACE,gBAAA;AlN0owBF;;AkNxowBA;EACE,gBAAA;AlN2owBF;;AkNzowBA;EACE,gBAAA;AlN4owBF;;AkN1owBA;EACE,gBAAA;AlN6owBF;;AkN3owBA;EACE,gBAAA;AlN8owBF;;AkN5owBA;EACE,gBAAA;AlN+owBF;;AkN7owBA;EACE,gBAAA;AlNgpwBF;;AkN9owBA;EACE,gBAAA;AlNipwBF;;AkN/owBA;EACE,gBAAA;AlNkpwBF;;AkNhpwBA;EACE,gBAAA;AlNmpwBF;;AkNjpwBA;EACE,gBAAA;AlNopwBF;;AkNlpwBA;EACE,gBAAA;AlNqpwBF;;AkNnpwBA;EACE,gBAAA;AlNspwBF;;AkNppwBA;EACE,gBAAA;AlNupwBF;;AkNrpwBA;EACE,gBAAA;AlNwpwBF;;AkNtpwBA;EACE,gBAAA;AlNypwBF;;AkNvpwBA;EACE,gBAAA;AlN0pwBF;;AkNxpwBA;EACE,gBAAA;AlN2pwBF;;AkNzpwBA;EACE,gBAAA;AlN4pwBF;;AkN1pwBA;EACE,gBAAA;AlN6pwBF;;AmNxrxBA;;CAAA;ACAA;EACC,+BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;ApN2rxBD;AqNnsxBA;EACC,qBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;ArNosxBD;;AsN/sxBA;+BAAA;AAGA,qBAAA;AAEA;;;EAAA;AAKA,6DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;AtN+sxBF;;AsN5sxBA;EACE,kBAAA;AtN+sxBF;;AsN5sxBA;EACE,kBAAA;AtN+sxBF;;AsN5sxBA;EACE,kBAAA;AtN+sxBF;;AsN5sxBA;EACE,iBAAA;AtN+sxBF;;AsN5sxBA;EACE,qBAAA;EACA,kBAAA;AtN+sxBF;;AsN5sxBA;EACE,eAAA;EACA,2BAAA;EACA,qBAAA;AtN+sxBF;AsN7sxBE;EACE,kBAAA;AtN+sxBJ;;AsN3sxBA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AtN8sxBF;AsN5sxBE;EACE,qBAAA;AtN8sxBJ;;AsN1sxBA;EACE,4BAAA;EACA,4BAAA;EACA,oBAAA;AtN6sxBF;;AsN1sxBA;EACE,YAAA;AtN6sxBF;;AsNzsxBE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;AtN4sxBJ;;AsNxsxBA;EACE,kCAAA;AtN2sxBF;;AsNxsxBA;EACE;IACE,uBAAA;EtN2sxBF;EsNzsxBA;IACE,yBAAA;EtN2sxBF;AACF;AsNxsxBA;EACE,gEAAA;EACA,wBAAA;AtN0sxBF;;AsNvsxBA;EACE,gEAAA;EACA,yBAAA;AtN0sxBF;;AsNvsxBA;EACE,gEAAA;EACA,yBAAA;AtN0sxBF;;AsNvsxBA;EACE,0EAAA;EACA,uBAAA;AtN0sxBF;;AsNvsxBA;EACE,0EAAA;EACA,uBAAA;AtN0sxBF;;AsNvsxBA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AtN0sxBF;;AsNvsxBA;;EAEE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AtN0sxBF;;AsNvsxBA;EACE,oBAAA;AtN0sxBF;;AsNvsxBA;EACE,cAAA;AtN0sxBF;;AsNvsxBA;EACE,cAAA;AtN0sxBF;;AsNvsxBA,oCAAA;AACA;EACE,sBAAA;AtN0sxBF;;AsNvsxBA;EACE,4BAAA;AtN0sxBF;;AuNl2xBA;EACE,gBCGe;AxNk2xBjB;;AuNl2xBA;EACE,gBAAA;AvNq2xBF;;AuNn2xBA;EACE,gBCFgB;AxNw2xBlB;;AuNp2xBA;EACE,gBCJiB;AxN22xBnB;;AuNr2xBA;EACE,gBCNa;AxN82xBf;;AuNt2xBA;EACE,gBCRiB;AxNi3xBnB;;AuNv2xBA;EACE,gBCVmB;AxNo3xBrB;;AuNx2xBA;EACE,gBCZoB;AxNu3xBtB;;AuNz2xBA;EACE,gBCdgB;AxN03xBlB;;AuN12xBA;EACE,gBChBa;AxN63xBf;;AuN32xBA;EACE,gBClBgB;AxNg4xBlB;;AuN52xBA;EACE,gBCpBoB;AxNm4xBtB;;AuN72xBA;EACE,gBCtBc;AxNs4xBhB;;AuN92xBA;EACE,gBCxBmB;AxNy4xBrB;;AuN/2xBA;EACE,gBC1Bc;AxN44xBhB;;AuNh3xBA;EACE,gBC5BoB;AxN+4xBtB;;AuNj3xBA;EACE,gBC9Bc;AxNk5xBhB;;AuNl3xBA;EACE,gBChCe;AxNq5xBjB;;AuNn3xBA;EACE,gBClCgB;AxNw5xBlB;;AuNp3xBA;EACE,gBCpCsB;AxN25xBxB;;AuNr3xBA;EACE,gBCtCkB;AxN85xBpB;;AuNt3xBA;EACE,gBCxCe;AxNi6xBjB;;AuNv3xBA;EACE,gBC1Ce;AxNo6xBjB;;AuNx3xBA;EACE,gBC5CgB;AxNu6xBlB;;AuNz3xBA;EACE,gBC9CmB;AxN06xBrB;;AuN13xBA;EACE,gBChDgB;AxN66xBlB;;AuN33xBA;EACE,gBClDkB;AxNg7xBpB;;AuN53xBA;EACE,gBCpDgB;AxNm7xBlB;;AuN73xBA;EACE,gBCtDe;AxNs7xBjB;;AuN93xBA;EACE,gBCxDa;AxNy7xBf;;AuN/3xBA;EACE,gBC1DgB;AxN47xBlB;;AuNh4xBA;EACE,gBC5Dc;AxN+7xBhB;;AuNj4xBA;EACE,gBC9DsB;AxNk8xBxB;;AuNl4xBA;EACE,gBChEc;AxNq8xBhB;;AuNn4xBA;EACE,gBClEe;AxNw8xBjB;;AuNp4xBA;EACE,gBCpEmB;AxN28xBrB;;AuNr4xBA;EACE,gBCtEwB;AxN88xB1B;;AuNt4xBA;EACE,gBCxEa;AxNi9xBf;;AuNv4xBA;EACE,gBC1EsB;AxNo9xBxB;;AuNx4xBA;EACE,gBC5EY;AxNu9xBd;;AuNz4xBA;EACE,gBC9EkB;AxN09xBpB;;AuN14xBA;EACE,gBChFoB;AxN69xBtB;;AuN34xBA;EACE,gBClFyB;AxNg+xB3B;;AuN54xBA;EACE,gBCpFe;AxNm+xBjB;;AuN74xBA;EACE,gBCtFqB;AxNs+xBvB;;AuN94xBA;EACE,gBCxFgB;AxNy+xBlB;;AuN/4xBA;EACE,gBC1F4B;AxN4+xB9B;;AuNh5xBA;EACE,gBC5Fe;AxN++xBjB;;AuNj5xBA;EACE,gBC9FoB;AxNk/xBtB;;AuNl5xBA;EACE,gBChGqB;AxNq/xBvB;;AuNn5xBA;EACE,gBClG2B;AxNw/xB7B;;AuNp5xBA;EACE,gBCpGkB;AxN2/xBpB;;AuNr5xBA;EACE,gBCtGoB;AxN8/xBtB;;AuNt5xBA;EACE,gBCxGgB;AxNigyBlB;;AuNv5xBA;EACE,gBC1G2B;AxNogyB7B;;AuNx5xBA;EACE,gBC5GkB;AxNugyBpB;;AuNz5xBA;EACE,gBC9GgB;AxN0gyBlB;;AuN15xBA;EACE,gBChHc;AxN6gyBhB;;AuN35xBA;EACE,gBClHiB;AxNghyBnB;;AuN55xBA;EACE,gBCpHiB;AxNmhyBnB;;AuN75xBA;EACE,gBCtHmB;AxNshyBrB;;AuN95xBA;EACE,gBCxHe;AxNyhyBjB;;AuN/5xBA;EACE,gBC1Hc;AxN4hyBhB;;AuNh6xBA;EACE,gBC5HgB;AxN+hyBlB;;AuNj6xBA;EACE,gBC9HgB;AxNkiyBlB;;AuNl6xBA;EACE,gBChIkB;AxNqiyBpB;;AuNn6xBA;EACE,gBClIe;AxNwiyBjB;;AuNp6xBA;EACE,gBCpIe;AxN2iyBjB;;AuNr6xBA;EACE,gBCtIe;AxN8iyBjB;;AuNt6xBA;EACE,gBCxIgB;AxNijyBlB;;AuNv6xBA;EACE,gBC1IgB;AxNojyBlB;;AuNx6xBA;EACE,gBC5Ia;AxNujyBf;;AuNz6xBA;EACE,gBC9Ie;AxN0jyBjB;;AuN16xBA;EACE,gBChJmB;AxN6jyBrB;;AuN36xBA;EACE,gBClJc;AxNgkyBhB;;AuN56xBA;EACE,gBCpJiB;AxNmkyBnB;;AuN76xBA;EACE,gBCtJgB;AxNskyBlB;;AuN96xBA;EACE,gBCxJiB;AxNykyBnB;;AuN/6xBA;EACE,gBC1JiB;AxN4kyBnB;;AuNh7xBA;EACE,gBC5Je;AxN+kyBjB;;AuNj7xBA;EACE,gBC9JgB;AxNklyBlB;;AuNl7xBA;EACE,gBChKgB;AxNqlyBlB;;AuNn7xBA;EACE,gBClKc;AxNwlyBhB;;AuNp7xBA;EACE,gBCpKiB;AxN2lyBnB;;AuNr7xBA;EACE,gBCtKc;AxN8lyBhB;;AuNt7xBA;EACE,gBCxKgB;AxNimyBlB;;AuNv7xBA;EACE,gBC1KgB;AxNomyBlB;;AuNx7xBA;EACE,gBC5KiB;AxNumyBnB;;AuNz7xBA;EACE,gBC9KkB;AxN0myBpB;;AuN17xBA;EACE,gBChLuB;AxN6myBzB;;AuN37xBA;EACE,gBClLmB;AxNgnyBrB;;AuN57xBA;EACE,gBCpLe;AxNmnyBjB;;AuN77xBA;EACE,gBCtLe;AxNsnyBjB;;AuN97xBA;EACE,gBCxLe;AxNynyBjB;;AuN/7xBA;EACE,gBC1LiB;AxN4nyBnB;;AuNh8xBA;EACE,gBC5Lc;AxN+nyBhB;;AuNj8xBA;EACE,gBC9Lc;AxNkoyBhB;;AuNl8xBA;EACE,gBChMe;AxNqoyBjB;;AuNn8xBA;EACE,gBClMe;AxNwoyBjB;;AuNp8xBA;EACE,gBCpMmB;AxN2oyBrB;;AuNr8xBA;EACE,gBCtMe;AxN8oyBjB;;AuNt8xBA;EACE,gBCxMc;AxNipyBhB;;AuNv8xBA;EACE,gBC1MoB;AxNopyBtB;;AuNx8xBA;EACE,gBC5Mc;AxNupyBhB;;AuNz8xBA;EACE,gBC9Ma;AxN0pyBf;;AuN18xBA;EACE,gBChNe;AxN6pyBjB;;AuN38xBA;EACE,gBClNa;AxNgqyBf;;AuN58xBA;EACE,gBCpNuB;AxNmqyBzB;;AuN78xBA;EACE,gBCtNa;AxNsqyBf;;AuN98xBA;EACE,gBCxNe;AxNyqyBjB;;AuN/8xBA;EACE,gBC1Nc;AxN4qyBhB;;AuNh9xBA;EACE,gBC5Na;AxN+qyBf;;AuNj9xBA;EACE,gBC9NqB;AxNkryBvB;;AuNl9xBA;EACE,gBChOqB;AxNqryBvB;;AuNn9xBA;EACE,gBClOqB;AxNwryBvB;;AuNp9xBA;EACE,gBCpOe;AxN2ryBjB;;AuNr9xBA;EACE,gBCtOsB;AxN8ryBxB;;AuNt9xBA;EACE,gBCxOkB;AxNisyBpB;;AuNv9xBA;EACE,gBC1Oc;AxNosyBhB;;AuNx9xBA;EACE,gBC5Oc;AxNusyBhB;;AuNz9xBA;EACE,gBC9OoB;AxN0syBtB;;AuN19xBA;EACE,gBChPmB;AxN6syBrB;;AuN39xBA;EACE,gBClPe;AxNgtyBjB;;AuN59xBA;EACE,gBCpPe;AxNmtyBjB;;AuN79xBA;EACE,gBCtPc;AxNstyBhB;;AuN99xBA;EACE,gBCxPc;AxNytyBhB;;AuN/9xBA;EACE,gBC1PiB;AxN4tyBnB;;AuNh+xBA;EACE,gBC5Pe;AxN+tyBjB;;AuNj+xBA;EACE,gBC9Pc;AxNkuyBhB;;AuNl+xBA;EACE,gBChQa;AxNquyBf;;AuNn+xBA;EACE,gBClQoB;AxNwuyBtB;;AuNp+xBA;EACE,gBCpQc;AxN2uyBhB;;AuNr+xBA;EACE,gBCtQmB;AxN8uyBrB;;AuNt+xBA;EACE,gBCxQwB;AxNivyB1B;;AuNv+xBA;EACE,gBC1QgB;AxNovyBlB;;AuNx+xBA;EACE,gBC5Qc;AxNuvyBhB;;AuNz+xBA;EACE,gBC9Qc;AxN0vyBhB;;AuN1+xBA;EACE,gBChRc;AxN6vyBhB;;AuN3+xBA;EACE,gBClRiB;AxNgwyBnB;;AuN5+xBA;EACE,gBCpRc;AxNmwyBhB;;AuN7+xBA;EACE,gBCtRc;AxNswyBhB;;AuN9+xBA;EACE,gBCxRe;AxNywyBjB;;AuN/+xBA;EACE,gBC1Rc;AxN4wyBhB;;AuNh/xBA;EACE,gBC5RgB;AxN+wyBlB;;AuNj/xBA;EACE,gBC9Rc;AxNkxyBhB;;AuNl/xBA;EACE,gBChSc;AxNqxyBhB;;AuNn/xBA;EACE,gBClSc;AxNwxyBhB;;AuNp/xBA;EACE,gBCpSe;AxN2xyBjB;;AuNr/xBA;EACE,gBCtSe;AxN8xyBjB;;AuNt/xBA;EACE,gBCxSgB;AxNiyyBlB;;AuNv/xBA;EACE,gBC1SgB;AxNoyyBlB;;AuNx/xBA;EACE,gBC5SgB;AxNuyyBlB;;AuNz/xBA;EACE,gBC9Se;AxN0yyBjB;;AuN1/xBA;EACE,gBChTgB;AxN6yyBlB;;AuN3/xBA;EACE,gBClTe;AxNgzyBjB;;AuN5/xBA;EACE,gBCpTiB;AxNmzyBnB;;AuN7/xBA;EACE,gBCtTc;AxNszyBhB;;AuN9/xBA;EACE,gBCxTgB;AxNyzyBlB;;AuN//xBA;EACE,gBC1Tc;AxN4zyBhB;;AuNhgyBA;EACE,gBC5TgB;AxN+zyBlB;;AuNjgyBA;EACE,gBC9Tc;AxNk0yBhB;;AuNlgyBA;EACE,gBChUiB;AxNq0yBnB;;AuNngyBA;EACE,gBClUiB;AxNw0yBnB;;AuNpgyBA;EACE,gBCpUc;AxN20yBhB;;AuNrgyBA;EACE,gBCtUc;AxN80yBhB;;AuNtgyBA;EACE,gBCxUgB;AxNi1yBlB;;AuNvgyBA;EACE,gBC1UkB;AxNo1yBpB;;AuNxgyBA;EACE,gBC5UkB;AxNu1yBpB;;AuNzgyBA;EACE,gBC9UkB;AxN01yBpB;;AuN1gyBA;EACE,gBChVkB;AxN61yBpB;;AuN3gyBA;EACE,gBClVc;AxNg2yBhB;;AuN5gyBA;EACE,gBCpVa;AxNm2yBf;;AuN7gyBA;EACE,gBCtViB;AxNs2yBnB;;AuN9gyBA;EACE,gBCxVc;AxNy2yBhB;;AuN/gyBA;EACE,gBC1VgB;AxN42yBlB;;AuNhhyBA;EACE,gBC5VmB;AxN+2yBrB;;AuNjhyBA;EACE,gBC9VgB;AxNk3yBlB;;AuNlhyBA;EACE,gBChWiB;AxNq3yBnB;;AuNnhyBA;EACE,gBClWiB;AxNw3yBnB;;AuNphyBA;EACE,gBCpWgB;AxN23yBlB;;AuNrhyBA;EACE,gBCtWe;AxN83yBjB;;AuNthyBA;EACE,gBCxWe;AxNi4yBjB;;AuNvhyBA;EACE,gBC1We;AxNo4yBjB;;AuNxhyBA;EACE,gBC5Wc;AxNu4yBhB;;AuNzhyBA;EACE,gBC9Wc;AxN04yBhB;;AuN1hyBA;EACE,gBChXgB;AxN64yBlB;;AuN3hyBA;EACE,gBClXc;AxNg5yBhB;;AuN5hyBA;EACE,gBCpXoB;AxNm5yBtB;;AuN7hyBA;EACE,gBCtXiB;AxNs5yBnB;;AuN9hyBA;EACE,gBCxXc;AxNy5yBhB;;AuN/hyBA;EACE,gBC1Xc;AxN45yBhB;;AuNhiyBA;EACE,gBC5XmB;AxN+5yBrB;;AuNjiyBA;EACE,gBC9XiB;AxNk6yBnB;;AuNliyBA;EACE,gBChYc;AxNq6yBhB;;AuNniyBA;EACE,gBClYiB;AxNw6yBnB;;AuNpiyBA;EACE,gBCpYc;AxN26yBhB;;AuNriyBA;EACE,gBCtYc;AxN86yBhB;;AuNtiyBA;EACE,gBCxYmB;AxNi7yBrB;;AuNviyBA;EACE,gBC1YgB;AxNo7yBlB;;AuNxiyBA;EACE,gBC5YgB;AxNu7yBlB;;AuNziyBA;EACE,gBC9Ye;AxN07yBjB;;AuN1iyBA;EACE,gBChZiB;AxN67yBnB;;AyN1ozBA;;;EACE,iBAAA;EACA,kBAAA;AzN+ozBF;AyN7ozBE;;;;;EAEE,uBAAA;EACA,kBAAA;EACA,6BAAA;EAEA,SAAA;EACA,UAAA;AzNipzBJ;AyN9ozBE;;;EACE,WAAA;EACA,WAAA;EACA,iBCEwB;EDAxB,UAAA;EACA,4BxNDO;ADkpzBX;;AyN7ozBA;EAGE,MAAA;EACA,gBAAA;AzN8ozBF;AyN5ozBE;EAEE,gBAAA;EACA,yBxNjBI;AD8pzBR;AyN1ozBE;EACE,SAAA;EACA,4BxNnBO;AD+pzBX;;AyNxozBA;;;EAGE,SAAA;EACA,mBAAA;AzN2ozBF;AyNzozBE;;;;;EAEE,mBAAA;EACA,sBAAA;AzN8ozBJ;AyN3ozBE;;;EACE,YAAA;EACA,yBxNrCO;ADorzBX;;A2NpszBA;EACE,cAAA;EACA,WAAA;A3NuszBF;;A2NpszBA;EACE,sB1NOM;E0NNN,c1NaS;E0NZT,yBAAA;EACA,sBvNyW4B;EuNxW5B,qBAAA;EACA,kBAAA;EAEA,kU1NgGmB;ADsmzBrB;;A2NlszBE;EACE,UAAA;A3NqszBJ;A2NlszBE;EACE,cAAA;A3NoszBJ;A2NjszBE;EACE,qBAAA;A3NmszBJ;A2NhszBE;EACE,qBAAA;A3NkszBJ;;A2N9rzBA;EACE,kBAAA;EACA,UAAA;A3NiszBF;;A2N9rzBA;EACE,YAAA;A3NiszBF;A2N/rzBE;EACE,eAAA;A3NiszBJ;A2N1rzBE;EACE,kBAAA;A3N4rzBJ;A2NrrzBE;EACE,gBD3CwB;A1NkuzB5B;A2NrrzBI;EACE,UAAA;EACA,WAAA;A3NurzBN;A2NnrzBE;EACE,iBDpDwB;A1NyuzB5B;A2NnrzBI;EACE,UAAA;EACA,WAAA;A3NqrzBN;;A2NhrzBA;EACE,kBAAA;EACA,sB1NlEM;E0NmEN,gCAAA;EACA,+BvNiS4B;EuNhS5B,gCvNgS4B;EuN/R5B,iBAAA;EACA,kBAAA;A3NmrzBF;A2NjrzBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;A3NmrzBJ;;A2N/qzBA;;;;;;EAME,qBAAA;EACA,aAAA;A3NkrzBF;;A2N/qzBA;;EAEE,aAAA;EACA,c1NrFS;E0NsFT,iBAAA;EACA,mBAAA;A3NkrzBF;;A2N/qzBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;A3NkrzBF;;A2N/qzBA;EACE,gBAAA;EACA,iBD1GsB;EC2GtB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;A3NkrzBF;A2NhrzBE;EACE,UAAA;EACA,2B1NrHO;ADuyzBX;A2NhrzBI;EACE,8DAAA;A3NkrzBN;A2N/qzBI;EAEE,+DDxIkC;ECyIlC,eAAA;A3NgrzBN;A2N5qzBE;EACE,WAAA;EACA,0B1NpIO;ADkzzBX;A2N7qzBI;EACE,WAAA;A3N+qzBN;A2N5qzBI;EACE,6DAAA;A3N8qzBN;A2N3qzBI;EAEE,8DD1JkC;EC2JlC,eAAA;A3N4qzBN;A2NxqzBE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A3N0qzBJ;A2NxqzBI;EACE,QAAA;EACA,yB1N7JK;ADu0zBX;A2NxqzBM;EACE,4DAAA;A3N0qzBR;A2NtqzBI;EACE,SAAA;EACA,4B1NtKK;AD80zBX;A2NtqzBM;EACE,+DAAA;A3NwqzBR;;A2NlqzBA;EACE,WAAA;A3NqqzBF;;A2NlqzBA;EACE,cDvLmB;ECwLnB,kBAAA;A3NqqzBF;;A2NlqzBA;EACE,YAAA;EACA,8BAAA;EACA,YAAA;A3NqqzBF;A2NnqzBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;A3NqqzBJ;A2NlqzBE;EACE,kBAAA;EACA,iBAAA;A3NoqzBJ;A2NlqzBI;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;A3NoqzBN;A2NnqzBM;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;A3NqqzBR;A2NnqzBQ;EACE,iBAAA;A3NqqzBV;A2NpqzBU;EACE,eAAA;EACA,yB1NpIa;AD0yzBzB;A2NpqzBU;EACE,wCD7OiB;EC8OjB,W1NpOJ;E0NqOI,iBAAA;A3NsqzBZ;A2NrqzBY;EACE,wCDjPe;A1Nw5zB7B;A2NpqzBU;EACE,c1NvOD;AD64zBX;A2NpqzBY;EACE,eAAA;EACA,6BAAA;A3NsqzBd;;A2N7pzBA;EACE,c1NrPS;E0NsPT,qBAAA;EACA,WD3PsB;EC4PtB,iBD5PsB;EC6PtB,kBAAA;EACA,gBDjQuB;A1Ni6zBzB;A2N/pzBE;EACE,eAAA;A3NiqzBJ;A2NhqzBI;EACE,sBvNmGwB;EuNlGxB,sB1NnQE;ADq6zBR;;A2N7pzBA;EACE,mB1NxQS;E0NyQT,6BAAA;EACA,gBAAA;A3NgqzBF;;A2N7pzBA;;EAEE,mBAAA;A3NgqzBF;;A2N7pzBA;;;EAGE,c1N/QS;E0NgRT,qBAAA;EACA,WDxRsB;ECyRtB,iBDzRsB;EC0RtB,kBAAA;EACA,gBD9RuB;A1N87zBzB;;A2N7pzBA;EACE,eAAA;ErN5RE,sBAAA;AN67zBJ;A2N9pzBE;EACE,yB1NrQI;E0NsQJ,W1NpSI;ADo8zBR;A2N7pzBE;EACE,iBAAA;A3N+pzBJ;A2N5pzBE;EACE,sBvNyD0B;EuNxD1B,yB1N/QI;E0NgRJ,W1N9SI;AD48zBR;A2N5pzBI;EACE,mEAAA;A3N8pzBN;A2N3pzBI;EACE,c1NhRG;AD66zBT;A2N1pzBI;EACE,c1NzRG;ADq7zBT;A2NxpzBE;EACE,yB1NxRI;E0NyRJ,W1N/TI;ADy9zBR;A2NxpzBI;EACE,yB1N5RE;E0N6RF,W1NnUE;AD69zBR;A2NtpzBE;EAEE,yB1N7OqB;E0N8OrB,4BvNspBgC;AJigyBpC;A2NrpzBI;EACE,yB1NjPmB;E0NkPnB,4BvNkpB8B;AJqgyBpC;A2NlpzBE;EACE,sBvNiB0B;EuNhB1B,kEAAA;EACA,W1NtVI;AD0+zBR;A2NlpzBI;EACE,oEAAA;A3NopzBN;A2NhpzBE;EACE,yB1NlQqB;ADo5zBzB;A2N9ozBI;EACE,yB1N7TE;E0N8TF,W1NpWE;ADo/zBR;A2N5ozBE;EACE,eAAA;EACA,c1NtWO;ADo/zBX;A2N5ozBI;EACE,6BAAA;EACA,c1N1WK;ADw/zBX;;A2NxozBA;;EAEE,oCAAA;EACA,sBAAA;A3N2ozBF;;A2NxozBA;;;EAGE,6BAAA;EACA,sBvNzB4B;AJoqzB9B;A2NzozBE;;;EACE,eAAA;A3N6ozBJ;A2N3ozBI;;;;;;EAEE,4DAAA;A3NipzBN;A2N7ozBE;;;EAEE,yB1NvYO;E0NwYP,YAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBD9Y0B;A1N8h0B9B;;A2N5ozBA;;;EAGE,sB1NvZM;E0NwZN,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sBvNzD4B;EuN0D5B,yBAAA;A3N+ozBF;A2N7ozBE;;;EACE,eAAA;A3NipzBJ;A2N9ozBE;;;EACE,aAAA;EACA,kBAAA;A3NkpzBJ;;A2N9ozBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A3NipzBF;A2N/ozBE;;;EACE,+BvNhF0B;EuNiF1B,gCvNjF0B;AJouzB9B;A2NhpzBE;;;EACE,yBAAA;EAGA,iBAAA;EACA,kCvNzF0B;EuN0F1B,mCvN1F0B;AJ8uzB9B;A2NjpzBE;;;EACE,yB1N/bO;ADol0BX;A2NnpzBI;;;EACE,+DAAA;A3NupzBN;A2NppzBI;;;EACE,4DAAA;A3NwpzBN;A2NppzBE;;;EACE,kBAAA;EACA,UAAA;A3NwpzBJ;;A2NppzBA;EACE,6BAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;A3NupzBF;A2NrpzBE;EACE,wCD5eyB;EC6ezB,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,W1NteI;E0NueJ,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A3NupzBJ;;A2NnpzBA;EACE,gB1NtfM;E0NufN,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;A3NspzBF;;A2NnpzBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,avNyXkC;EuNxXlC,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A3NspzBF;A2NppzBE;;;EAGE,WAAA;EACA,iBAAA;A3NspzBJ;A2NlpzBE;EACE;;;IAGE,WAAA;IACA,iBAAA;E3NopzBJ;AACF;A2NjpzBE;;EAEE,mBAAA;A3NmpzBJ;A2NhpzBE;EACE,iCAAA;EACA,eAAA;A3NkpzBJ;A2N/ozBE;EACE,2B1NzgBI;AD0p0BR;A2N/ozBI;EACE,qEAAA;A3NipzBN;A2N9ozBI;EAEE,+DDtjBkC;ECujBlC,eAAA;A3N+ozBN;A2N3ozBE;EACE,0B1NvhBI;ADoq0BR;A2N3ozBI;EACE,oEAAA;A3N6ozBN;A2N1ozBI;EAEE,8DDpkBkC;ECqkBlC,eAAA;A3N2ozBN;;A2NtozBA;EACE,8BAAA;A3NyozBF;;A2NtozBA;EACE,wBAAA;EACA,yBAAA;A3NyozBF;;A4Nlu0BA;EACE,YAAA;A5Nqu0BF;;A4Nlu0BA;;EAEE,cAAA;A5Nqu0BF;;A4Nlu0BA;;EAEE,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,+DAAA;EACA,4BAAA;A5Nqu0BF;;A4Nlu0BA;EACE,wBAAA;EACA,yBAAA;EACA,8DAAA;EACA,4BAAA;A5Nqu0BF;;A4Nlu0BA;;EAEE,+BAAA;EACA,6BAAA;A5Nqu0BF;;A4Nlu0BA;EACE,gCAAA;EACA,6BAAA;A5Nqu0BF;;A4Nlu0BA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E5Nqu0BF;E4Nnu0BA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E5Nqu0BF;AACF;A4Nlu0BA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E5Nou0BF;E4Nlu0BA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E5Nou0BF;AACF;A4Nju0BA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;A5Nmu0BF;;A4Nhu0BA;EACE,aAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,oBAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,oBAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,oBAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,oBAAA;A5Nmu0BF;;A4Nhu0BA;EACE,kBAAA;EACA,W3NtFM;E2NuFN,gBAAA;EACA,qBAAA;EACA,yB3NjFS;E2NkFT,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;A5Nmu0BF;;A4Nhu0BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,yB3NtGS;ADy00BX;;A4Nhu0BA;EACE,SAAA;A5Nmu0BF;;A4Nhu0BA;EACE,SAAA;A5Nmu0BF;;A4Nhu0BA;EACE,UAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,SAAA;EACA,gBAAA;EACA,2BAAA;EACA,2B3N3HS;AD810BX;;A4Nhu0BA;EACE,QAAA;A5Nmu0BF;;A4Nhu0BA;EACE,QAAA;EACA,aAAA;A5Nmu0BF;;A4Nhu0BA;EACE,WAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,0B3NjJS;ADo30BX;;A4Nhu0BA;EACE,QAAA;A5Nmu0BF;;A4Nhu0BA;EACE,QAAA;EACA,aAAA;A5Nmu0BF;;A4Nhu0BA;EACE,WAAA;A5Nmu0BF;;A4Nhu0BA;;;EAGE,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,4B3NvKS;AD040BX;;A4Nhu0BA;EACE,SAAA;A5Nmu0BF;;A4Nhu0BA;EACE,SAAA;A5Nmu0BF;;A4Nhu0BA;EACE,UAAA;A5Nmu0BF;;A6N560BA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EvNaE,sBAAA;EuNVF,kBAAA;EACA,sBAAA;EACA,6CAAA;A7N+60BF;;A6N560BA;EACE,kBAAA;EACA,WAAA;EACA,yB5NCS;E4NAT,WAAA;EvNCE,sBAAA;AN+60BJ;;A6N560BA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EvNNE,sBAAA;EuNQF,yB5NmBM;AD450BR;;A6N560BA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sB5NzBM;E4N2BN,mBAAA;EACA,4BAAA;A7N+60BF;A6N760BE;EACE,aAAA;A7N+60BJ;A6N560BE;EAGE,+DAAA;EACA,sGAAA;A7N460BJ;A6Nx60BE;EAEE,gBAAA;A7N060BJ;;A6Nt60BA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;A7Ny60BF;;A6Nt60BA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,c5NxDS;ADi+0BX;;A6Nt60BA;EACE,c5N1DS;ADm+0BX;;A6Nt60BA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;A7Ny60BF;;A6Nt60BA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,sB5NnFM;E4NoFN,eAAA;EACA,kBAAA;EACA,sBAAA;A7Ny60BF;;A6Nt60BA;EACE,qB5N5DM;ADq+0BR;;A6Nt60BA;EACE,yB5N5FS;ADqg1BX;;A6Nt60BA;EACE,yB5N9FS;ADug1BX;;A6Nt60BA;;EAEE,qB5NnGS;E4NoGT,gBAAA;EACA,sB5NzGM;E4N0GN,mBAAA;A7Ny60BF;;A6Nt60BA;;EAEE,8BAAA;A7Ny60BF;;A6Nt60BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;A7Ny60BF;;A6Nt60BA;EACE,YAAA;EACA,UAAA;A7Ny60BF;;A6Nt60BA;EACE,SAAA;EACA,SAAA;EACA,UAAA;A7Ny60BF;;A6Nt60BA;EACE,iBAAA;EACA,mBAAA;EAEA,mBAAA;A7Ny60BF;;A6Nt60BA;EACE,MAAA;EACA,UAAA;EACA,YAAA;A7Ny60BF;;A6Nt60BA;EACE,YAAA;EACA,UAAA;A7Ny60BF;;A6Nt60BA;EACE,SAAA;EACA,mBAAA;A7Ny60BF;;A6Nt60BA;EACE,mBAAA;A7Ny60BF;;A6Nt60BA;EACE,mBAAA;A7Ny60BF;;A6Nt60BA;;EAEE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;A7Ny60BF;;A6Nt60BA;EACE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;A7Ny60BF;;A6Nt60BA;;EAEE,yCAAA;EACA,6BAAA;A7Ny60BF;;A6Nt60BA;EACE,0CAAA;EACA,6BAAA;A7Ny60BF;;A6Nt60BA;;EAEE,sBAAA;EACA,yDAAA;A7Ny60BF;;A6Nt60BA;EACE,iEAAA;A7Ny60BF;;A6Nt60BA;EACE;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;E7Ny60BF;E6Nv60BA;IACE,0BAAA;IACA,sBAAA;E7Ny60BF;AACF;A6Nt60BA;EACE;IACE,0BAAA;IACA,sBAAA;E7Nw60BF;E6Nt60BA;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;E7Nw60BF;AACF;A6Nr60BA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,6CAAA;A7Nu60BF;;A6Np60BA;EACE,aAAA;A7Nu60BF;;A6Np60BA;EACE,oBAAA;A7Nu60BF;;A6Np60BA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,W5NpPM;E4NqPN,kBAAA;EACA,qBAAA;EACA,yB5N9OS;EKNP,sBAAA;EuNsPF,kU5NzJmB;E4N0JnB,iBAAA;A7Nu60BF;;A6Np60BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A7Nu60BF;;A6Np60BA;EACE,WAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yB5NjQS;ADwq1BX;;A6Nh60BI;EACE,yB5N7MS;ADgn1Bf;A6Nh60BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADyr1BR;A6Nh60BM;EAGE,+DAAA;EACA,sGAAA;A7Ng60BR;A6N350BI;EACE,qB5N9NS;AD2n1Bf;;A6N/60BI;EACE,yB5N7MS;AD+n1Bf;A6N/60BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADws1BR;A6N/60BM;EAGE,8DAAA;EACA,0GAAA;A7N+60BR;A6N160BI;EACE,qB5N9NS;AD0o1Bf;;A6N970BI;EACE,yB5N7MS;AD8o1Bf;A6N970BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADut1BR;A6N970BM;EAGE,6DAAA;EACA,wGAAA;A7N870BR;A6Nz70BI;EACE,qB5N9NS;ADyp1Bf;;A6N780BI;EACE,yB5N7MS;AD6p1Bf;A6N780BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADsu1BR;A6N780BM;EAGE,0CAAA;EACA,wGAAA;A7N680BR;A6Nx80BI;EACE,qB5N9NS;ADwq1Bf;;A6N590BI;EACE,yB5N7MS;AD4q1Bf;A6N590BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADqv1BR;A6N590BM;EAGE,+DAAA;EACA,wGAAA;A7N490BR;A6Nv90BI;EACE,qB5N9NS;ADur1Bf;;A6N3+0BI;EACE,yB5N7MS;AD2r1Bf;A6N3+0BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADow1BR;A6N3+0BM;EAGE,8DAAA;EACA,sGAAA;A7N2+0BR;A6Nt+0BI;EACE,qB5N9NS;ADss1Bf;;A6N1/0BI;EACE,yB5N7MS;AD0s1Bf;A6N1/0BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADmx1BR;A6N1/0BM;EAGE,yCAAA;EACA,0GAAA;A7N0/0BR;A6Nr/0BI;EACE,qB5N9NS;ADqt1Bf;;A6Nzg1BI;EACE,yB5N7MS;ADyt1Bf;A6Nzg1BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADky1BR;A6Nzg1BM;EAGE,sDAAA;EACA,oGAAA;A7Nyg1BR;A6Npg1BI;EACE,qB5N9NS;ADou1Bf;;A6Nxh1BI;EACE,yB5N7MS;ADwu1Bf;A6Nxh1BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADiz1BR;A6Nxh1BM;EAGE,8DAAA;EACA,oGAAA;A7Nwh1BR;A6Nnh1BI;EACE,qB5N9NS;ADmv1Bf;;A6Nvi1BI;EACE,yB5N7MS;ADuv1Bf;A6Nvi1BI;EACE,qB5NjNS;E4NkNT,sB5NvRE;ADg01BR;A6Nvi1BM;EAGE,6DAAA;EACA,wGAAA;A7Nui1BR;A6Nli1BI;EACE,qB5N9NS;ADkw1Bf;;A6N5h1BE;EvNxSE,gBAAA;EuN0SA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,wCAAA;A7N+h1BJ;;A6N1h1BE;EvNnTE,kBAAA;EuNqTA,iBAAA;A7N6h1BJ;A6N3h1BI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;A7N6h1BN;;A6Nrh1BE;EACE,YAAA;EACA,gBAAA;A7Nwh1BJ;A6Nrh1BE;EACE,WAAA;A7Nuh1BJ;A6Nph1BE;EACE,WAAA;A7Nsh1BJ;A6Nnh1BE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;A7Nqh1BJ;A6Njh1BI;EACE,iBAAA;EACA,WAAA;A7Nmh1BN;A6N7g1BM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;A7N+g1BR;;A6Nvg1BE;EACE,YAAA;EACA,gBAAA;A7N0g1BJ;A6Nvg1BE;EACE,WAAA;A7Nyg1BJ;A6Ntg1BE;EACE,WAAA;A7Nwg1BJ;A6Nrg1BE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;A7Nug1BJ;A6Nng1BI;EACE,iBAAA;EACA,WAAA;A7Nqg1BN;A6N//0BM;EACE,WAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mB5NjZG;ADk51BX;;A8Nv61BA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A9N061BF;;A8Nx61BA;EACE,+BAAA;A9N261BF;;A8Nz61BA;EACE,qCAAA;A9N461BF;;A8N161BA;EACE,qCAAA;A9N661BF;;A8N361BA;EACE,YAAA;EACA,eAAA;A9N861BF;;A8N561BA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;A9N+61BF;;A8N761BA;EACE,aAAA;A9Ng71BF;;A8N961BA;EACE,+BAAA;EACA,yBAAA;A9Ni71BF;;A8N/61BA;EACE,qCAAA;A9Nk71BF;;A8Nh71BA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;A9Nm71BF;;A8Nj71BA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;A9No71BF;;A8Nl71BA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A9Nq71BF;;A8Nn71BA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;A9Ns71BF;;A8Np71BA;EACE,+BAAA;EACA,yBAAA;A9Nu71BF;;A8Nr71BA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;A9Nw71BF;;A8Nt71BA;EACE,mBAAA;A9Ny71BF;;A8Nv71BA;EACE,mBAAA;A9N071BF;;A8Nx71BA;EACE,YAAA;EACA,eAAA;A9N271BF;;A8Nz71BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9N471BF;;A8N171BA;EACE,WAAA;A9N671BF;;A8N371BA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A9N871BF;;A8N571BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9N+71BF;;A8N771BA;EACE,YAAA;A9Ng81BF;;A8N971BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9Ni81BF;;A8N/71BA;EACE,eAAA;A9Nk81BF;;A8Nh81BA;EACE,aAAA;EACA,uBAAA;A9Nm81BF;;A8Nj81BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9No81BF;;A8Nl81BA;EACE,YAAA;A9Nq81BF;;A8Nn81BA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;A9Ns81BF;;A8Np81BA;EACE,YAAA;A9Nu81BF;;A8Nr81BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9Nw81BF;;A8Nt81BA;EACE,WAAA;EACA,WAAA;A9Ny81BF;;A8Nv81BA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A9N081BF;;A8Nx81BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9N281BF;;A8Nz81BA;EACE,WAAA;EACA,WAAA;A9N481BF;;A8N181BA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A9N681BF;;A8N381BA;EACE,iBAAA;A9N881BF;;A8N581BA;EACE,2BAAA;A9N+81BF;;A8N781BA;EACE,6BAAA;A9Ng91BF;;A8N981BA;EACE,8BAAA;A9Ni91BF;;A8N/81BA;EACE,qBAAA;A9Nk91BF;;A8Nh91BA;EACE,qBAAA;A9Nm91BF;;A8Nj91BA;EACE,qBAAA;A9No91BF;;A8Nl91BA;EACE,qBAAA;A9Nq91BF;;A8Nn91BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Ns91BF;;A8Np91BA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A9Nu91BF;;A8Nr91BA;EACE,aAAA;EACA,mBAAA;A9Nw91BF;;A8Nt91BA;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;A9Ny91BF;;A8Nv91BA;EACE,gCAAA;A9N091BF;;A8Nx91BA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;A9N291BF;;A8Nz91BA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;A9N491BF;;A8N191BA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;A9N691BF;;A8N391BA;EACE,+BAAA;A9N891BF;;A8N591BA;EACE,iCAAA;A9N+91BF;;A8N791BA;EACE,mCAAA;A9Ng+1BF;;A8N991BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Ni+1BF;;A8N/91BA;EACE,WAAA;A9Nk+1BF;;A8Nh+1BA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A9Nm+1BF;;A8Nj+1BA;EACE,gBAAA;A9No+1BF;;A8Nl+1BA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A9Nq+1BF;;A8Nn+1BA;EACE,eAAA;A9Ns+1BF;;A8Np+1BA;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A9Nu+1BF;;A8Nr+1BA;EACE,aAAA;A9Nw+1BF;;A8Nt+1BA;EACE,cAAA;A9Ny+1BF;;A8Nv+1BA;EACE,mBAAA;A9N0+1BF;;A8Nx+1BA;EACE,gBAAA;A9N2+1BF;;A8Nz+1BA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A9N4+1BF;;A8N1+1BA;EACE,+BAAA;A9N6+1BF;;A8N3+1BA;EACE,qCAAA;A9N8+1BF;;A8N5+1BA;EACE,wBAAA;A9N++1BF;;A8N7+1BA;EACE,mBAAA;A9Ng/1BF;;A8N9+1BA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A9Ni/1BF;;A8N/+1BA;EACE,WAAA;A9Nk/1BF;;A8Nh/1BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Nm/1BF;;A8Nj/1BA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,+BAAA;A9No/1BF;;A8Nl/1BA;EACE,eAAA;EACA,aAAA;A9Nq/1BF;;A8Nn/1BA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;A9Ns/1BF;;A8Np/1BA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;A9Nu/1BF;;A8Nr/1BA;EACE,aAAA;EACA,sBAAA;A9Nw/1BF;;A8Nt/1BA;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;A9Ny/1BF;;A8Nv/1BA;EACE,aAAA;EACA,mBAAA;A9N0/1BF;;A8Nx/1BA;EACE,aAAA;A9N2/1BF;;A8Nz/1BA;EACE,aAAA;EACA,uBAAA;A9N4/1BF;;A8N1/1BA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A9N6/1BF;;A8N3/1BA;EACE,+BAAA;A9N8/1BF;;A8N5/1BA;EACE,qCAAA;A9N+/1BF;;A8N7/1BA;EACE,wBAAA;A9Ngg2BF;;A8N9/1BA;EACE,mBAAA;A9Nig2BF;;A8N//1BA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;A9Nkg2BF;;A8Nhg2BA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;A9Nmg2BF;;A8Njg2BA;EACE,aAAA;A9Nog2BF;;A8Nlg2BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Nqg2BF;;A8Nng2BA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A9Nsg2BF;;A8Npg2BA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9Nug2BF;;A8Nrg2BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;A9Nwg2BF;;A8Ntg2BA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qBAAA;EAEA,wDAAA;A9Nwg2BF;;A8Ntg2BA;EAEE,uBAAA;A9Nyg2BF;;A8Nvg2BA;EAEE,uBAAA;A9N0g2BF;A8Npg2BA;EACE;IAEE,mBAAA;E9N+g2BF;E8N9g2BE;IAEA,mBAAA;E9Ngh2BF;AACF;A8N9g2BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Ngh2BF;;A8N9g2BA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A9Nih2BF;;A8N/g2BA;EACE,eAAA;EACA,cAAA;EACA,aAAA;A9Nkh2BF;;A8Nhh2BA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;A9Nmh2BF;;A8Njh2BA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;A9Noh2BF;;A8Nlh2BA;EACE,mBAAA;EACA,gCAAA;A9Nqh2BF;;A8Nnh2BA;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;A9Nsh2BF;;A8Nph2BA;EACE,2BAAA;A9Nuh2BF;;A8Nrh2BA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A9Nwh2BF;;A8Nth2BA;EACE,eAAA;A9Nyh2BF;;A8Nvh2BA;EACE,eAAA;EACA,iBAAA;A9N0h2BF;;A8Nxh2BA;EACC,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;A9N2h2BD;;A8Nzh2BA;EACE,aAAA;EACA,mBAAA;A9N4h2BF;;A8N1h2BA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;A9N6h2BF;;A8N3h2BA;EACE,mBAAA;A9N8h2BF;;A8N5h2BA;EACE,aAAA;A9N+h2BF;;A8N7h2BA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A9Ngi2BF;;A8N9h2BA;EACE,+BAAA;A9Nii2BF;;A8N/h2BA;EACE,qCAAA;A9Nki2BF;;A8Nhi2BA;EACE,wBAAA;A9Nmi2BF;;A8Nji2BA;EACE,mBAAA;A9Noi2BF;;A8Nli2BA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A9Nqi2BF;;A8Nni2BA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;A9Nsi2BF;;A8Npi2BA;EACE,aAAA;A9Nui2BF;;A8Nri2BA;EACE,eAAA;A9Nwi2BF;;A8Nti2BA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;A9Nyi2BF;;A8Nvi2BA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;A9N0i2BF;;A8Nxi2BA;EACE,aAAA;A9N2i2BF;;A8Nzi2BA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;A9N4i2BF;;A8N1i2BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9N6i2BF;;A8N3i2BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A9N8i2BF;;A8N5i2BA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A9N+i2BF;;A8N7i2BA;EACE,WAAA;A9Ngj2BF;;A8N9i2BA;EACE,kBAAA;A9Nij2BF;;A8N/i2BA;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,uBAAA;A9Nkj2BF;;A8Nhj2BA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;A9Nmj2BF;;A8Njj2BA;EACE,kBAAA;A9Noj2BF;;A8Nlj2BA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;A9Nqj2BF;;A8Nnj2BA;EACE,gBAAA;EACA,gCAAA;A9Nsj2BF;;A8Npj2BA;EACE,yBAAA;A9Nuj2BF;;A8Nrj2BA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;A9Nwj2BF;;A8Ntj2BA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;A9Nyj2BF;;A8Nvj2BA;EACE,2BAAA;A9N0j2BF;;A8Nxj2BA;EACE,YAAA;EACA,WAAA;EACA,eAAA;A9N2j2BF;;A8Nzj2BA;EACE,kBAAA;A9N4j2BF;;A8N1j2BA;EACE,kBAAA;A9N6j2BF;;A8N3j2BA;EACE,aAAA;EACA,uBAAA;A9N8j2BF;;A8N5j2BA;EACE,aAAA;A9N+j2BF;;A8N7j2BA;EACE,aAAA;EACA,yBAAA;A9Ngk2BF;;A8N9j2BA;EACE,QAAA;A9Nik2BF;;A8N/j2BA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;A9Nkk2BF;;A8Nhk2BA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;A9Nmk2BF;;A8Njk2BA;EACE,aAAA;A9Nok2BF;;A8Nlk2BA;EACE,aAAA;A9Nqk2BF;;A8Nnk2BA;EACE,uBAAA;A9Nsk2BF;;A8Npk2BA;EACE,8BAAA;EACA,iBAAA;A9Nuk2BF;;A8Nrk2BA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;A9Nwk2BF,E8Nvk2BC;;;;;;;;;CAAA;AAUD;EAA2E,eAAA;EAAe,gBAAA;EAAA,mBAAA;A9N0k2B1F;;A8N1k2B6G;EAAkD,8CAAA;A9N8k2B/J;;A8N9k2B6M;EAAkB,kBAAA;A9Nkl2B/N;;A8Nll2BiP;EAA6B,wCAAA;EAAqC,oCAAA;EAAmC,kBAAA;EAAkB,UAAA;A9Nyl2BxW;;A8Nzl2BkX;EAA0B,kBAAA;A9N6l2B5Y;;A8N7l2B8Z;EAAuD,gBAAA;A9Nim2Brd;;A8Njm2Bqe;EAA2D,OAAA;EAAO,gBAAA;A9Nsm2BviB;;A8Ntm2BujB;EAAyD,kBAAA;A9N0m2BhnB;;A8N1m2BkoB;EAA6D,cAAA;EAAc,kBAAA;EAAkB,WAAA;A9Ngn2B/tB;;A8Nhn2B0uB;EAAwD,iBAAA;A9Non2BlyB;;A8Npn2BmzB;EAA4D,QAAA;EAAQ,iBAAA;A9Nyn2Bv3B;;A8Nzn2Bw4B;EAAoC,cAAA;EAAc,kBAAA;EAAkB,UAAA;A9N+n2B58B;;A8N/n2Bs9B;EAAwC,cAAA;A9Nmo2B9/B;;A8Nno2B4gC;EAA+B,aAAA;A9Nuo2B3iC;;A8Nvo2BwjC;EAAgC,kBAAA;EAAkB,qBAAA;A9N4o2B1mC;;A8N5o2B+nC;EAA8B,cAAA;EAAc,gBAAA;A9Nip2B3qC;;A8Njp2B2rC;EAA8B,cAAA;EAAc,iBAAA;A9Nsp2BvuC;;A8Ntp2BwvC;EAAkC,cAAA;A9N0p2B1xC;;A8N1p2BwyC;EAAkC,cAAA;A9N8p2B10C;;A8N9p2Bw1C;EAA0D,cAAA;EAAc,UAAA;A9Nmq2Bh6C;;A8Nnq2B06C;EAAkE,kBAAA;A9Nuq2B5+C;;A8Nvq2B8/C;EAAkE,mBAAA;A9N2q2BhkD;;A8N3q2BmlD;EAAkE,gBAAA;A9N+q2BrpD;;A8N/q2BqqD;EAAkE,iBAAA;A9Nmr2BvuD;;A8Nnr2BwvD;EAAkE,kBAAA;A9Nur2B1zD;;A8Nvr2B40D;EAAkE,mBAAA;A9N2r2B94D;;A8N3r2Bi6D;EAAkE,gBAAA;A9N+r2Bn+D;;A8N/r2Bm/D;EAAkE,iBAAA;A9Nms2BrjE;;A8Nns2BskE;EAAkE,kBAAA;A9Nus2BxoE;;A8Nvs2B0pE;EAAkE,mBAAA;A9N2s2B5tE;;A8N3s2B+uE;EAA4C,uBAAA;EAAuB,kBAAA;A9Ngt2BlzE;;A8Nht2Bo0E;EAA4E,qBAAA;A9Not2Bh5E;;A8Npt2Bq6E;EAA4E,uBAAA;A9Nwt2Bj/E;;A8Nxt2BwgF;EAA0C,qBAAA;EAAqB,kBAAA;A9N6t2BvkF;;A8N7t2BylF;EAAkF,WAAA;EAAW,kBAAA;EAAkB,iBAAA;EAAiB,WAAA;A9Nou2BztF;;A8Npu2BouF;EAAkF,kBAAA;EAAkB,YAAA;EAAY,gBAAA;EAAgB,WAAA;A9N2u2Bp2F;;A8N3u2B+2F;EAAiD,0BAAA;EAA0B,sBAAA;A9Ngv2B17F;;A8Nhv2Bg9F;EAAiF,0BAAA;EAA0B,sBAAA;A9Nqv2B3jG;;A8Nrv2BilG;EAAiF,0BAAA;EAA0B,sBAAA;A9N0v2B5rG;;A8N1v2BktG;EAAiF,0BAAA;EAA0B,sBAAA;A9N+v2B7zG;;A8N/v2Bm1G;EAAiF,0BAAA;EAA0B,sBAAA;A9Now2B97G;;A8Npw2Bo9G;EAAgE,kBAAA;A9Nww2BphH;;A8Nxw2BsiH;EAAgE,kBAAA;A9N4w2BtmH;;A8N5w2BwnH;EAAgE,kBAAA;A9Ngx2BxrH;;A8Nhx2B0sH;EAAgE,kBAAA;A9Nox2B1wH;;A8Npx2B4xH;EAAgE,kBAAA;A9Nwx2B51H;;A8Ntx2BA;EACE,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;A9Nyx2BF;;A+N7m4BA;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;A/Ngn4BF;;A+N7m4BA;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;A/Ngn4BF;;A+N9m4BA;;EAEE,0BAAA;A/Nin4BF;;A+N/m4BA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;A/Nkn4BF;;A+Nhn4BA;EACE,+BAAA;A/Nmn4BF;;A+Njn4BA;EACE,WAAA;A/Non4BF;;A+Njn4BA;EACE,OAAA;A/Non4BF;;A+N3m4BA;EACE,yBAAA;EANA,8BAOwB;EANxB,sFAAA;EACA,0BAAA;EAOA,kEAAA;EACA,eAAA;A/N+m4BF;;A+N7m4BA;EACE,aAAA;A/Ngn4BF;;A+N9m4BA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;A/Nin4BF;;A+N/m4BA;EACE,yB9N5BM;E8N6BN,uCAAA;EACA,4BAAA;EACA,cAAA;A/Nkn4BF;;A+Nhn4BA;EACE,oCAAA;A/Nmn4BF;;A+Njn4BA;EACE,4BAAA;EACA,yB9NtCM;E8NuCN,cAAA;EACA,gBAAA;A/Non4BF;;A+Nln4BA;EACE,oCAAA;A/Nqn4BF;;A+Nln4BA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EAEA,0BAAA;A/Nqn4BF;;A+Nnn4BA;EACE,iBAAA;A/Nsn4BF;;A+Npn4BA;EACE,iBAAA;EACA,WAAA;A/Nun4BF;;A+Nrn4BA;EACE,iBAAA;EACA,WAAA;A/Nwn4BF;;A+Njn4BI;EACE,YAAA;EACA,iBAAA;EACA,UAAA;A/Non4BN;A+Nln4BI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;A/Non4BN;A+Nhn4BM;EACE,iBAAA;A/Nkn4BR;A+N7m4BM;EACE,iBAAA;EACA,WAAA;A/N+m4BR;A+N5m4BM;EACE,iBAAA;EACA,WAAA;A/N8m4BR;;AgO9v4BA;EACE,WAAA;EACA,0BAAA;E1NeE,qBAAA;E0NbF,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AhOiw4BF;AgO/v4BE;EACE,qB/NgCI;ADiu4BR;AgO9v4BE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AhOgw4BJ;AgO7v4BE;EACE,aAAA;AhO+v4BJ;AgO5v4BE;EACE,aAAA;AhO8v4BJ;AgO3v4BE;EACE,WAAA;EACA,YAAA;AhO6v4BJ;AgO1v4BE;EACE,cAAA;EACA,c/NlBO;AD8w4BX;AgOzv4BE;EACE,qB/NzBO;ADox4BX;AgOzv4BI;EACE,c/N3BK;ADsx4BX;;AiOxy4BA;EACE,aAAA;AjO2y4BF;AiOzy4BE;EACE,kBAAA;AjO2y4BJ;AiOzy4BI;EACE,gBAAA;EACA,uBAAA;AjO2y4BN;AiOzy4BM;EACE,aAAA;AjO2y4BR;AiOvy4BI;EACE,kBAAA;AjOyy4BN;AiOpy4BE;EACE,aAAA;AjOsy4BJ;AiOny4BE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AjOqy4BJ;AiOly4BI;EACE,yBAAA;EACA,UAAA;AjOoy4BN;AkOly4BE;EACE,cDCuB;ECAvB,UAAA;AlOoy4BJ;AkOhy4BE;EACE,cDLuB;AjOuy4B3B;AkO9x4BE;EACE,cDVuB;AjO0y4B3B;AiOvy4BI;EACE,eAAA;EACA,gBAAA;AjOyy4BN;AiOty4BI;EACE,YAAA;AjOwy4BN;AiOry4BI;EACE,qBAAA;AjOuy4BN;AiOjy4BQ;EACE,YAAA;AjOmy4BV;AiO9x4BQ;EACE,YAAA;AjOgy4BV;AiO1x4BE;EACE,UAAA;AjO4x4BJ;AiO1x4BI;EACE,eAAA;AjO4x4BN;AiOxx4BE;EACE,yBhO4BqB;EgO3BrB,SAAA;E3N9DA,sBAAA;E2NgEA,chOrCI;EgOsCJ,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AjO0x4BJ;AiOxx4BI;EACE,yBhO1EK;EgO2EL,chOvEK;EgOwEL,oBAAA;AjO0x4BN;AiOvx4BI;EACE,eAAA;EACA,mBAAA;AjOyx4BN;AiOtx4BI;EACE,yBhOxDE;EgOyDF,WhOvFE;EgOwFF,aAAA;EACA,qBAAA;AjOwx4BN;AiOrx4BI;EACE,SAAA;EACA,chOvFK;EgOwFL,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;AjOux4BN;AiOnx4BE;ECvHA,iDDwHqB;EACnB,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AjOux4BJ;AiOrx4BI;EACE,YAAA;EACA,WAAA;AjOux4BN;AiOnx4BE;EClHA,aAAA;EDoHE,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA,EAAA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AjOyx4BJ;AiOvx4BI;EACE,WAAA;AjOyx4BN;AiOtx4BI;EACE,gBAAA;EACA,oBAAA,EAAA,yCAAA;EACA,6BAAA;EACA,YAAA;AjOwx4BN;AiOpx4BE;EACE,mBAAA;AjOsx4BJ;AiOnx4BE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AjOqx4BJ;;AiOjx4BA,iBAAA;AACA;EC9IE,SD+Ic;AjOwx4BhB;AiOtx4BE;ECzJA,aAAA;AlOs74BF;AiOzx4BE;EAEE,UAAA;AjO0x4BJ;AiOvx4BE;EAEE,UAAA;AjOwx4BJ;AiOrx4BE;EACE,yBAAA;EACA,4BAAA;AjOux4BJ;AiOpx4BE;EACE,0BAAA;EACA,6BAAA;AjOsx4BJ;;AiOlx4BA;EACE;IACE,wBAAA;EjOqx4BF;AACF;AiO3w4BE;ECvLA,SDwLgB;EACd,YAAA;AjOsx4BJ;;AiOlx4BA;EACE,6BAAA;EACA,YAAA;AjOqx4BF;;AmOl/4BA,kBAAA;AAKA;EACE;IACE,GAAA;EnOi/4BF;EmO/+4BA;IACE,GAAA;EnOi/4BF;AACF;AmO9+4BA;EACE;IACE,GAAA;EnOg/4BF;EmO9+4BA;IACE,GAAA;EnOg/4BF;AACF;AmO7+4BA;ECiBE,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EDxBA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BEcuB;EFbvB,eAAA;AnOw/4BF;;AmOt/4BE;EACE,aAAA;AnOy/4BJ;;AmOt/4BE;EAKE,eAAA;AnOq/4BJ;;AmOl/4BE;EACE,oBAAA;AnOq/4BJ;;AmO/+4BA;;EAEE,clO9BS;ADgh5BX;;AmOt+4BE;EAEE,yBlOnDO;AD2h5BX;;AmOt+4BE;EAEE,yBlOtDO;AD8h5BX;;AmOr+4BE;EAEE,yBlO5DO;ADmi5BX;;AmOj+4BE;EAEE,8BAAA;AnOm+4BJ;;AmOj+4BI;EACE,+BAAA;EACA,iBAAA;AnOo+4BN;;AmO/94BA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AnOk+4BF;;AmO/94BA;EACE,YAAA;EACA,clOnFS;EkOqFT,cEpFiB;EFqFjB,oBEpFmB;EFqFnB,aAAA;EACA,kBAAA;AnOi+4BF;;AmO/94BE;EAME,sBAAA;AnO694BJ;;AmOz94BA;;;EAGE,mBAAA;AnO494BF;;AmOz94BA;EACE,aAAA;EACA,gBAAA;EACA,yC/N4kBsC;E+N3kBtC,sBlOvHM;EkOwHN,yBAAA;EACA,sB/N4O4B;E+N3O5B,aAAA;EACA,4BAAA;EAEA,WAAA;AnO294BF;;AmOz94BE;EACE,0BAAA;AnO494BJ;;AmOz94BE;EACE,clO7HO;EkO8HP,sBlOrII;EkOsIJ,iElOIuB;EkOHvB,6CE7GsB;EF8GtB,wCAAA;AnO494BJ;;AmO194BI;EAEI,mFAAA;AnO494BR;;AmOt94BA;ECxHE,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EDkHA,kBAAA;AnOi+4BF;;AoO7k5BE;EAIE,UAAA;ApO6k5BJ;;AmOn+4BE;EACE,aAAA;AnOs+4BJ;;AmOn+4BE;EAGE,eAAA;AnOo+4BJ;;AmO994BA;EACE,clO/JS;EkOgKT,sBlOvKM;EkOwKN,gD/NuM4B;E+NtM5B,4BE5IuB;EF6IvB,cAAA;AnOi+4BF;;AmO994BE;EAIE,yBlO/KO;AD6o5BX;;AmOz94BA;;EAEE,clOlLS;AD8o5BX;;AmO194BE;;EACE,WEnH+B;ArOil5BnC;;AmOz94BA;ECtKE,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;ApOmo5BF;;AoO7n5BE;EAIE,UAAA;ApO6n5BJ;;AmOt+4BA;EACE,4CAAA;EACA,0BAAA;AnOy+4BF;;AmOt+4BA;EACE,6CAAA;EACA,0BAAA;AnOy+4BF;;AmOt+4BA;;EAEE,+CAAA;EACA,iCAAA;EACA,8BAAA;AnOy+4BF;;AsO5q5BE;EAEE,cDRe;ECSf,mBAAA;EACA,gBAAA;EACA,kBAjCQ;EAkCR,qBAlCQ;AtOgt5BZ;;AsO5q5BI;EACE,aAAA;AtO+q5BN;;AsO3q5BE;EACE,yBAAA;UAAA,iBAAA;EACA,crOtBO;EqOuBP,eAAA;EACA,6BAAA;EACA,4BDLqB;ArOmr5BzB;;AsO5q5BI;EAEE,yBrOpCK;EqOqCL,qBrOrCK;ADmt5BX;;AsO1q5BI;EACE,yBA9CQ;EA+CR,qBA/CQ;EAgDR,WA9CW;AtO2t5BjB;;AsO1q5BI;EACE,mBAAA;EACA,6BAjDQ;EAkDR,yBAjDkB;EAkDlB,crOlDK;AD+t5BX;;AsOzq5BE;;;;EAGE,qBAAA;EACA,aAAA;AtO6q5BJ;;AsO1q5BE;EACE,kBAAA;EACA,crO9DO;AD2u5BX;;AsO1q5BE;EAEE,iBA1DmB;EA2DnB,gBAAA;AtO4q5BJ;;AsOzq5BE;EAGE,cAAA;EACA,cDrEe;ECsEf,qBAAA;AtO0q5BJ;;AuOvw5BE;EACE,kBFyBmB;EExBnB,sBF0BQ;EEzBR,sBAAA;AvO0w5BJ;;AuOxw5BI;EACE,ctOcK;EsObL,sBtOME;EsOLF,iEtO+IqB;EsO9IrB,mFAAA;EACA,wCAAA;AvO2w5BN;;AuOxw5BI;EAEE,oBAAA;AvO0w5BN;;AuOvw5BI;EACE,eAAA;AvO0w5BN;;AwOjx5BE;EACE,kBAAA;EACA,aANK;EAOL,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AxOox5BJ;;AwOlx5BI;EACE,SAAA;EACA,YAAA;AxOqx5BN;;AwOlx5BI;EACE,aAjBW;AxOsy5BjB;;AwOjx5BE;EAGE,kBA7BgB;AxO+y5BpB;;AwO/w5BI;EACE,gBAAA;EACA,eAlCc;AxOoz5BpB;;AwO9w5BE;EACE,cAAA;EACA,iCAAA;EACA,eA9CY;EA+CZ,kBHpBmB;EGqBnB,4CA1CS;EA2CT,sBAAA;EACA,4BHPqB;EGQrB,gBHtBQ;ArOuy5BZ;;AwO/w5BI;EACE,iBArDO;AxOu05Bb;;AwO/w5BI;EACE,aAAA;EACA,kBA3DU;EA4DV,4CArDU;AxOu05BhB;;AwO9w5BE;EACE,0CAAA;AxOix5BJ;;AwO9w5BE;EACE,gBAAA;AxOix5BJ;;AwO/w5BI;EACE,wBAAA;EACA,UAAA;EACA,oCAAA;AxOkx5BN;;AwO7w5BI;EACE,mCAAA;AxOgx5BN;;AwO5w5BE;;EAEE,gBAAA;AxO+w5BJ;;AwO7w5BI;;EACE,UAAA;EACA,2BAAA;AxOix5BN;;AwO9w5BI;;EACE,UAAA;EACA,0BAAA;AxOkx5BN;;AwO9w5BE;EACE,aAAA;AxOix5BJ;;AyOn35BE;EACE,WAAA;AzOs35BJ;;AyOn35BE;ELkCA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;ApOq15BF;;AoO/05BE;EAIE,UAAA;ApO+05BJ;;AyO735BE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AzOg45BJ;;AyO935BI;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AzOi45BN;;AyO935BI;EACE,sBrO2iBwB;EqO1iBxB,eAAA;AzOi45BN;;A0Oh65BE;EACE,6BAAA;EACA,UAAA;A1Om65BJ;;A2Oj45BE;EPKA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EOXE,qDAAA;EACA,kBAAA;EACA,eAAA;A3O445BJ;;AoO735BE;EAIE,UAAA;ApO635BJ;;A2O945BI;EAGE,eAAA;A3O+45BN;;A2O345BE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;A3O845BJ;;A2O545BI;EACE,eAAA;A3O+45BN;;A2O345BE;EACE,oBAAA;EAEA,8DAxDS;EAyDT,6DAzDS;EA0DT,sDAvDS;EAwDT,kBAvDgB;EAwDhB,yB1OrDO;E0OsDP,yBAAA;EAEA,eAAA;EACA,eAAA;EACA,mBAAA;EAGA,gBAAA;A3O045BJ;;A2Ox45BI;EACE,aAAA;A3O245BN;;A2Ox45BI;EACE,cAAA;EACA,+DA5EO;EA6EP,0BAAA;A3O245BN;;A2Ox45BI;EPnEF,UAAA;EACA,6CCgBwB;EDfxB,wCAAA;ApO+85BF;;A2O145BI;EAEE,aAAA;A3O445BN;;A2Ox45BE;EACE,0BAAA;A3O245BJ;;A2Ox45BE;EPhEA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EOyDE,eAAA;EACA,mBAAA;EAEA,iBAAA;A3Om55BJ;;A2On45BI;EACE,aAAA;A3Os45BN;;A2On45BI;EACE,eAAA;A3Os45BN;;A4Ox95BE;EACE,WAAA;EACA,YAAA;EACA,WAAA;A5O295BJ;;A4Ox95BE;EACE,gBAAA;A5O295BJ;;A4Ox95BE;EACE,kBPjCmB;EOkCnB,sBPhCQ;EOiCR,sBAAA;A5O295BJ;;A4Ox95BE;EACE,iBAAA;A5O295BJ;;A4Oz95BE;EACE,aAAA;EACA,cAAA;A5O495BJ;;A4Oz95BE;;EAEE,4BPhCqB;ArO4/5BzB;;AoO1g6BE;;EANA,UAAA;EACA,6CCgBwB;EDfxB,wCAAA;ApOqh6BF;;AoO9g6BI;;EACE,aAAA;EACA,gBAAA;ApOkh6BN;;A4Op+5BI;;;EAEE,oBAAA;EACA,aAAA;A5Ow+5BN;;A4Op+5BE;EACE,gBAAA;EACA,kBP9DmB;ArOqi6BvB;;A4Op+5BI;EACE,yB3O7EK;ADoj6BX;;A4Or+5BI;EACE,yB3O/EK;ADuj6BX;;A4Op+5BE;;;;EAIE,oBAAA;A5Ou+5BJ;;A4Ol+5BI;;EACE,uBAAA;A5Os+5BN;;A4On+5BE;EACE,iBAAA;A5Os+5BJ;;A4Op+5BI;EACE,eAAA;A5Ou+5BN;;A4Op+5BI;EACE,iBAAA;A5Ou+5BN;;A4Or+5BM;EACE,cAAA;EACA,kBAAA;A5Ow+5BR;;A4On+5BE;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,YPhGiB;EOiGjB,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBP9GQ;ArOol6BZ;;A4Op+5BE;EACE,2BAAA;A5Ou+5BJ;;A4Or+5BE;EACE,wBAAA;A5Ow+5BJ;;A4Or+5BE;EACE,kBAAA;A5Ow+5BJ;;A4Or+5BE;EACE,mBAAA;EACA,kBApIS;EAqIT,gCAAA;EACA,eArIW;A5O6m6Bf;;A4Or+5BE;EACE,mBAAA;EACA,c3O1IO;E2O2IP,sBAAA;EAEA,kBPzImB;EO0InB,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAlJW;EAmJX,aAAA;A5Ou+5BJ;;A4Or+5BI;EACE,yB3O7JK;ADqo6BX;;A4Ot+5BI;EACE,yB3O/JK;ADwo6BX;;A4Ot+5BI;EACE,yBNxKQ;EMyKR,qBNzKQ;EM0KR,WNxKW;AtOip6BjB;;A4Ot+5BI;EACE,kBApKO;A5O6o6Bb;;A4Or+5BE;EACE,c3O7KO;ADqp6BX;;A4Or+5BE;EACE,kBAAA;EACA,gBAAA;A5Ow+5BJ;;A4Or+5BE;EACE,WAAA;EACA,gBAAA;EACA,0CAAA;EAjKF,0BAAA;A5O0o6BF;;A4Oxo6BE;EA4JA;IA3JE,+BAAA;E5O4o6BF;AACF;A4O3+5BE;EACE,mCAAA;EACA,2BAAA;A5O6+5BJ;;A4O3+5BI;EAzKF,8BAAA;A5Owp6BF;;A4Otp6BE;EAuKE;IAtKA,mCAAA;E5O0p6BF;AACF;A4Ol/5BI;EA5KF,6BAAA;A5Oiq6BF;;A4O/p6BE;EA0KE;IAzKA,kCAAA;E5Omq6BF;AACF;A4Ox/5BI;EA/KF,8BAAA;A5O0q6BF;;A4Oxq6BE;EA6KE;IA5KA,mCAAA;E5O4q6BF;AACF;A4O9/5BI;EAlLF,6BAAA;A5Omr6BF;;A4Ojr6BE;EAgLE;IA/KA,kCAAA;E5Oqr6BF;AACF;A4Ong6BI;EAtLF,0BAAA;A5O4r6BF;;A4O1r6BE;EAoLE;IAnLA,+BAAA;E5O8r6BF;AACF;A4Ovg6BE;EACE,mCAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;A5Oyg6BJ;;A4Ovg6BI;EAlMF,6BAAA;A5O6s6BF;;A4O3s6BE;EAgME;IA/LA,kCAAA;E5O+s6BF;AACF;A4O9g6BI;EArMF,8BAAA;A5Ost6BF;;A4Opt6BE;EAmME;IAlMA,mCAAA;E5Owt6BF;AACF;A4Oph6BI;EAxMF,6BAAA;A5O+t6BF;;A4O7t6BE;EAsME;IArMA,kCAAA;E5Oiu6BF;AACF;A4O1h6BI;EA3MF,8BAAA;A5Owu6BF;;A4Otu6BE;EAyME;IAxMA,mCAAA;E5O0u6BF;AACF;A6Oxx6BE;EACE,aAAA;EACA,sBAAA;A7O0x6BJ;;A6Oxx6BI;EACE,kBAAA;EACA,aAAA;A7O2x6BN;;A8O9x6BE;EACE,oBAAA;EACA,yC1O4sBoC;E0O3sBpC,mBAAA;EACA,sB7OQI;E6OPJ,yBAAA;EACA,sB1O2W0B;E0O1W1B,aAAA;EACA,YAAA;A9Oiy6BJ;;A8O9x6BE;EV2BA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EUjCE,gBAAA;A9Oyy6BJ;;AoOlw6BE;EAIE,UAAA;ApOkw6BJ;;A8O1y6BI;EAEE,kBAAA;A9O4y6BN;;A8Oxy6BE;EVcA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EUrBE,gBAAA;EACA,yBAAA;EACA,6BAAA;EAAA,wBAAA;A9Ooz6BJ;;A8Olz6BI;EACE,aAAA;A9Oqz6BN;;A8Ojz6BE;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;A9Ooz6BJ;;A8Olz6BI;EACE,mBAAA;EACA,kBAAA;A9Oqz6BN;;A8Olz6BI;EAEE,UAAA;A9Ooz6BN;;A+Ot26BE;EACE,aAAA;EACA,sBAAA;A/Oy26BJ;;A+Ov26BI;EACE,SAAA;A/O026BN;;AgP126BA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,sUAAA;AhP626BF;AgPx26BE;E1OFE,mBAAA;E0OIA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kU/OgFiB;E+O/EjB,iBAAA;AhP026BJ;AgPx26BI;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AhP026BN;AgPt26BE;EACE,gB/O5BI;E+O6BJ,YAvCkB;EAwClB,aAAA;EACA,UAAA;AhPw26BJ;AgPr26BE;EACE,uBAAA;EACA,QAAA;AhPu26BJ;AgPp26BE;EACE,kBAAA;AhPs26BJ;AgPp26BI;EACE,WAAA;EACA,YAAA;E1OzCF,kBAAA;ANg56BJ;AgPp26BM;EACE,WAAA;AhPs26BR;AgPj26BE;EACE,iB/OsBW;E+OrBX,c/OhDO;E+OiDP,SAAA;EACA,mB/OxDO;E+OyDP,uBAAA;EACA,gCAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AhPm26BJ;AgPj26BI;EACE,aAAA;AhPm26BN;AgP916BI;EACE,c/O1CE;E+O2CF,mB/OIS;E+OHT,yBAAA;EACA,SAAA;EACA,kBAAA;AhPg26BN;;AgP316BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;E1OrFE,mBAAA;ANo76BJ;AgP516BE;EACE,sBAAA;EACA,6BAAA;EACA,UAAA;AhP816BJ;AgP316BE;EACE,UAAA;AhP616BJ;;AgPz16BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AhP416BF;;AiP786BA;EACE,kBAAA;EACA,yBAAA;E3OSE,sBAAA;E2OPF,gBAAA;EACA,YAAA;AjPg96BF;AiP986BE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AjPg96BJ;AiP986BI;EACE,iB7OoawB;AJ4i6B9B;AiP586BE;EACE,mBhPXO;EgPYP,chPiBI;AD676BR;AiP586BI;EACE,chPVK;ADw96BX;AiP186BE;EACE,kBAAA;AjP486BJ;AiPz86BE;EACE,chPpBO;EgPqBP,0BAAA;EACA,eAAA;AjP286BJ;;AiPv86BA;EACE,gBAAA;AjP086BF;;AiPv86BA;EACE,gCAAA;AjP086BF;;AiPr86BA;EACE,aAAA;EACA,qB7O8R4B;AJ0q6B9B;;AiPn86BA;EACE,YAAA;EACA,aAAA;EACA,WAAA;AjPs86BF;;AiPj86BA;EACE,mBhPtDS;EKAP,sBAAA;E2OwDF,chPrDS;EgPsDT,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AjPo86BF;;AiPh86BE;EACE,mBhPnEO;EgPoEP,chPlEO;ADqg7BX;;AiP776BA;EACE,eAAA;AjPg86BF;;AkP5h7BA;EACE;IACE,aAAA;ElP+h7BF;AACF;Aa196BI;EqOhEF;IACE,cAAA;ElP6h7BF;EkPzh7BE;IAEE,aAAA;ElP0h7BJ;EkPth7BA;IACE,0BAAA;IACA,uBAAA;IACA,6BAAA;ElPwh7BF;EkPth7BE;IACE,aAAA;ElPwh7BJ;EkPlh7BE;IAEE,wBAAA;ElPmh7BJ;EkP/g7BM;IACE,cAAA;IAAA,oBAAA;ElPih7BR;EkP/g7BQ;IACE,aAAA;ElPih7BV;EkP7g7BM;IACE,cAAA;IAAA,oBAAA;IACA,wBAAA;ElP+g7BR;EkP5g7BM;IACE,cAAA;IAAA,oBAAA;IACA,SAAA;IACA,cAAA;ElP8g7BR;EkP3g7BM;IACE,mBAAA;ElP6g7BR;EkPzg7BQ;IACE,uBAAA;ElP2g7BV;EkPzg7BU;IACE,aAAA;ElP2g7BZ;EkPtg7BU;IACE,iBAAA;ElPwg7BZ;EkPlg7BI;IACE,sBAAA;ElPog7BN;EkPlg7BM;IACE,sBAAA;IACA,iBAAA;IACA,eAAA;ElPog7BR;EkP//6BE;IACE,YAAA;ElPig7BJ;EkP9/6BE;IACE,cAAA;ElPgg7BJ;EkP1/6BE;IACE,0BAAA;IACA,WAAA;ElP4/6BJ;EkPx/6BA;IACE,8BAAA;ElP0/6BF;EkPx/6BE;IACE,aAAA;IACA,QAAA;IACA,kCAAA;IACA,oBAAA;ElP0/6BJ;EkPv/6BE;IACE,kBAAA;IACA,UAAA;IACA,kUjPVe;IiPWf,kBAAA;IACA,QAAA;IACA,UAAA;IACA,MAAA;IACA,oBAAA;IACA,gBjPhHE;IKGJ,mBAAA;I4O+GE,eAAA;IACA,gBAAA;ElPy/6BJ;EkPv/6BI;IACE,mBAAA;IACA,iBAAA;ElPy/6BN;EkPv/6BM;IACE,eAAA;ElPy/6BR;EkPt/6BM;IACE,aAAA;ElPw/6BR;EkPn/6BM;IACE,aAAA;ElPq/6BR;EkPj/6BI;IACE,mBAAA;IACA,UAAA;IACA,SAAA;ElPm/6BN;EkP/+6BE;IACE,aAAA;IACA,QAAA;ElPi/6BJ;EkP9+6BE;IACE,aAAA;IACA,QAAA;ElPg/6BJ;EkP3+6BM;IAEE,oCAAA;IACA,sCAAA;ElP4+6BR;EkPx+6BI;IACE,mBjP3JG;EDqo7BT;EkPp+6BA;;IAEE,0BAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,qBAAA;IACA,sCAAA;IACA,0BAAA;ElPs+6BF;EkPp+6BE;;IACE,aAAA;ElPu+6BJ;EkPl+6BA;IACE,eAAA;IAAA,kBAAA;ElPo+6BF;EkPl+6BE;IACE,wBAAA;ElPo+6BJ;EkPh+6BA;IACE,kBAAA;ElPk+6BF;EkPh+6BE;;IAEE,cAAA;IACA,cAAA;ElPk+6BJ;EkP/96BE;IACE,sBAAA;ElPi+6BJ;EkP596BI;;;;IAEE,qBAAA;ElPg+6BN;EkPx96BE;IACE,aAAA;ElP096BJ;EkPv96BE;IACE,WAAA;ElPy96BJ;EkPv96BI;IACE,cAAA;ElPy96BN;EkPj96BM;IACE,yBAAA;ElPm96BR;EkP186BE;IACE,iBAAA;IACA,cAAA;ElP486BJ;EkPv86BE;IACE,2BAAA;ElPy86BJ;EkPp86BE;IACE,yBAAA;ElPs86BJ;EkPp86BI;IACE,gCAAA;IACA,4BAAA;ElPs86BN;EkPn86BI;IACE,iBAAA;ElPq86BN;EkP/76BE;IACE,aAAA;ElPi86BJ;EkP976BE;IACE,kBAAA;ElPg86BJ;EkP576BA;IACE,yBAAA;ElP876BF;EkPx76BI;IACE,iBAAA;ElP076BN;EkPr76BA;IACE,cAAA;ElPu76BF;AACF;Aanq7BI;EqOiPF;;IAEE,aAAA;ElPq76BF;EkPj76BE;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,e1KjUY;ExEov7BhB;EkPj76BI;;IAEE,mBAAA;ElPm76BN;EkPj76BM;;IACE,sBAAA;IACA,gBAAA;IACA,oBAAA;ElPo76BR;EkP766BE;IACE,2BAAA;ElP+66BJ;AACF;Aazs7BI;EqOiSA;IACE,2BAAA;ElP266BJ;AACF;Aajs7BI;EqO4RF;IACE,aAAA;ElPw66BF;AACF;Aats7BI;EqOkSF;IACE,oBAAA;ElPu66BF;EkPp66BA;;IAEE,iCAAA;ElPs66BF;EkPn66BA;IACE,gBAAA;IACA,gCAAA;ElPq66BF;EkPl66BA;IACE,qBAAA;IACA,sBAAA;IACA,kBAAA;ElPo66BF;EkPj66BA;IACE,mBAAA;ElPm66BF;EkPh66BA;;IAEE,UAAA;IACA,SAAA;ElPk66BF;EkP/56BA;IACE,YAAA;IACA,cAAA;IACA,uBAAA;IACA,kBAAA;ElPi66BF;EkP/56BE;IACE,oBAAA;ElPi66BJ;EkP956BE;IACE,UAAA;ElPg66BJ;EkP156BI;IACE,+BAAA;IACA,cAAA;ElP456BN;EkPz56BI;IACE,0BAAA;IACA,yBAAA;IACA,WAAA;ElP256BN;EkPz56BM;IACE,mBAAA;ElP256BR;EkPr56BA;IACE,aAAA;ElPu56BF;EkPl56BE;;IACE,cAAA;IACA,kBAAA;ElPq56BJ;EkPn56BI;;IACE,0BAAA;ElPs56BN;EkPn56BI;;IACE,gBAAA;ElPs56BN;EkPj56BA;IACE,aAAA;ElPm56BF;EkPh56BA;IACE,cAAA;ElPk56BF;AACF;AkP/46BA;EAEI;IACE,cAAA;IACA,kBAAA;ElPg56BJ;EkP946BI;IACE,0BAAA;ElPg56BN;EkP746BI;IACE,gBAAA;ElP+46BN;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n.border-primary {\n  border-color: #545cd8;\n}\n\n.border-secondary {\n  border-color: #6c757d;\n}\n\n.border-success {\n  border-color: #3ac47d;\n}\n\n.border-info {\n  border-color: #30b1ff;\n}\n\n.border-warning {\n  border-color: #f7b924;\n}\n\n.border-danger {\n  border-color: #d92550;\n}\n\n.border-light {\n  border-color: #eeeeee;\n}\n\n.border-dark {\n  border-color: #343a40;\n}\n\n.border-focus {\n  border-color: #444054;\n}\n\n.border-alternate {\n  border-color: #83588a;\n}\n\n:root {\n  --bs-blue: #86c6fb;\n  --bs-indigo: #444054;\n  --bs-purple: #83588a;\n  --bs-pink: #f65ca2;\n  --bs-red: #d92550;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #f7b924;\n  --bs-green: #3ac47d;\n  --bs-teal: #16E0BD;\n  --bs-cyan: #30b1ff;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-primary: #545cd8;\n  --bs-secondary: #6c757d;\n  --bs-success: #3ac47d;\n  --bs-info: #30b1ff;\n  --bs-warning: #f7b924;\n  --bs-danger: #d92550;\n  --bs-light: #eeeeee;\n  --bs-dark: #343a40;\n  --bs-focus: #444054;\n  --bs-alternate: #83588a;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-font-sans-serif);\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  background-color: currentColor;\n  border: 0;\n  opacity: 0.25;\n}\n\nhr:not([size]) {\n  height: 1px;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\nh1, .h1 {\n  font-size: calc(1.345rem + 1.14vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.2rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.301rem + 0.612vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.76rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.279rem + 0.348vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.54rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.257rem + 0.084vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.32rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.1rem;\n}\n\nh6, .h6 {\n  font-size: 0.88rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-bs-original-title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #545cd8;\n  text-decoration: underline;\n}\na:hover {\n  color: rgb(67.2, 73.6, 172.8);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n  direction: ltr /* rtl:ignore */;\n  unicode-bidi: bidi-override;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: #f65ca2;\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.875em;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n  font-weight: 700;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: #6c757d;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.1rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: var(--bs-gutter-x, 0.75rem);\n  padding-left: var(--bs-gutter-x, 0.75rem);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 1320px;\n  }\n}\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(var(--bs-gutter-y) * -1);\n  margin-right: calc(var(--bs-gutter-x) * -0.5);\n  margin-left: calc(var(--bs-gutter-x) * -0.5);\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-bg: transparent;\n  --bs-table-accent-bg: rgba(0, 0, 0, 0.03);\n  --bs-table-striped-color: #495057;\n  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n  --bs-table-active-color: #495057;\n  --bs-table-active-bg: #e0f3ff;\n  --bs-table-hover-color: #495057;\n  --bs-table-hover-bg: #e0f3ff;\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #495057;\n  vertical-align: top;\n  border-color: #e9ecef;\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n.table > :not(:last-child) > :last-child > * {\n  border-bottom-color: currentColor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n\n.table-hover > tbody > tr:hover {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n  --bs-table-bg: rgb(220.8, 222.4, 247.2);\n  --bs-table-striped-bg: rgb(209.76, 211.28, 234.84);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(198.72, 200.16, 222.48);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(204.24, 205.72, 228.66);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(198.72, 200.16, 222.48);\n}\n\n.table-secondary {\n  --bs-table-bg: rgb(225.6, 227.4, 229);\n  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(203.04, 204.66, 206.1);\n}\n\n.table-success {\n  --bs-table-bg: rgb(215.6, 243.2, 229);\n  --bs-table-striped-bg: rgb(204.82, 231.04, 217.55);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(194.04, 218.88, 206.1);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(199.43, 224.96, 211.825);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(194.04, 218.88, 206.1);\n}\n\n.table-info {\n  --bs-table-bg: rgb(213.6, 239.4, 255);\n  --bs-table-striped-bg: rgb(202.92, 227.43, 242.25);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(192.24, 215.46, 229.5);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(197.58, 221.445, 235.875);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(192.24, 215.46, 229.5);\n}\n\n.table-warning {\n  --bs-table-bg: rgb(253.4, 241, 211.2);\n  --bs-table-striped-bg: rgb(240.73, 228.95, 200.64);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(228.06, 216.9, 190.08);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(234.395, 222.925, 195.36);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(228.06, 216.9, 190.08);\n}\n\n.table-danger {\n  --bs-table-bg: rgb(247.4, 211.4, 220);\n  --bs-table-striped-bg: rgb(235.03, 200.83, 209);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(222.66, 190.26, 198);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(228.845, 195.545, 203.5);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(222.66, 190.26, 198);\n}\n\n.table-light {\n  --bs-table-bg: #eeeeee;\n  --bs-table-striped-bg: rgb(226.1, 226.1, 226.1);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(214.2, 214.2, 214.2);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(220.15, 220.15, 220.15);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(214.2, 214.2, 214.2);\n}\n\n.table-dark {\n  --bs-table-bg: #343a40;\n  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);\n  --bs-table-hover-color: #fff;\n  color: #fff;\n  border-color: rgb(72.3, 77.7, 83.1);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.1rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.968rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: #495057;\n  background-color: rgb(239.3, 248.9225806452, 255);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: rgb(227.335, 236.4764516129, 242.25);\n}\n.form-control::-webkit-file-upload-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: #495057;\n  background-color: rgb(239.3, 248.9225806452, 255);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::-webkit-file-upload-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: rgb(227.335, 236.4764516129, 242.25);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #495057;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + (0.5rem + 2px));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  border-radius: 0.2rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n.form-control-sm::-webkit-file-upload-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + (1rem + 2px));\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n.form-control-lg::-webkit-file-upload-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + (0.75rem + 2px));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + (0.5rem + 2px));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + (1rem + 2px));\n}\n\n.form-control-color {\n  max-width: 3rem;\n  height: auto;\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n.form-control-color::-webkit-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: #e9ecef;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.968rem;\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.1rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.32rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-input {\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  background-color: #fff;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  appearance: none;\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-check-input:checked {\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.form-check-input:checked[type=checkbox] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #545cd8;\n  border-color: #545cd8;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%28187.8214285714, 190.9642857143, 239.6785714286%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(203.7, 206.1, 243.3);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(203.7, 206.1, 243.3);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-select {\n  height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus {\n  z-index: 3;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 3;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: rgb(239.3, 248.9225806452, 255);\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #3ac47d;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.968rem;\n  color: #000;\n  background-color: rgba(58, 196, 125, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #3ac47d;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%233ac47d' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #3ac47d;\n  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: #3ac47d;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  padding-right: 4.125rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%233ac47d' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: #3ac47d;\n  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: #3ac47d;\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: #3ac47d;\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #3ac47d;\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,\n.was-validated .input-group .form-select:valid,\n.input-group .form-select.is-valid {\n  z-index: 1;\n}\n.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,\n.was-validated .input-group .form-select:valid:focus,\n.input-group .form-select.is-valid:focus {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #d92550;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.968rem;\n  color: #fff;\n  background-color: rgba(217, 37, 80, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #d92550;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23d92550'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23d92550' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #d92550;\n  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: #d92550;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  padding-right: 4.125rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23d92550'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23d92550' stroke='none'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: #d92550;\n  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: #d92550;\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: #d92550;\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #d92550;\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,\n.was-validated .input-group .form-select:invalid,\n.input-group .form-select.is-invalid {\n  z-index: 2;\n}\n.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,\n.was-validated .input-group .form-select:invalid:focus,\n.input-group .form-select.is-invalid:focus {\n  z-index: 3;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  border-radius: 0.25rem;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #495057;\n}\n.btn-check:focus + .btn, .btn:focus {\n  outline: 0;\n  box-shadow: none;\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  pointer-events: none;\n  opacity: 0.65;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n}\n.btn-check:focus + .btn-primary, .btn-primary:focus {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(67.2, 73.6, 172.8);\n  border-color: #3f45a2;\n}\n.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-primary:disabled, .btn-primary.disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n}\n.btn-check:focus + .btn-secondary, .btn-secondary:focus {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(86.4, 93.6, 100);\n  border-color: rgb(81, 87.75, 93.75);\n}\n.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-secondary:disabled, .btn-secondary.disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-success {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:hover {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:focus + .btn-success, .btn-success:focus {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {\n  color: #000;\n  background-color: rgb(97.4, 207.8, 151);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-success:disabled, .btn-success.disabled {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n\n.btn-info {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:hover {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:focus + .btn-info, .btn-info:focus {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {\n  color: #000;\n  background-color: rgb(89.4, 192.6, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-info:disabled, .btn-info.disabled {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n\n.btn-warning {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:hover {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:focus + .btn-warning, .btn-warning:focus {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {\n  color: #000;\n  background-color: rgb(248.6, 199, 79.8);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-warning:disabled, .btn-warning.disabled {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n}\n.btn-check:focus + .btn-danger, .btn-danger:focus {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(173.6, 29.6, 64);\n  border-color: rgb(162.75, 27.75, 60);\n}\n.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-danger:disabled, .btn-danger.disabled {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n\n.btn-light {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:hover {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:focus + .btn-light, .btn-light:focus {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {\n  color: #000;\n  background-color: rgb(241.4, 241.4, 241.4);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-light:disabled, .btn-light.disabled {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n}\n.btn-check:focus + .btn-dark, .btn-dark:focus {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(41.6, 46.4, 51.2);\n  border-color: rgb(39, 43.5, 48);\n}\n.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-dark:disabled, .btn-dark.disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-focus {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:hover {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n}\n.btn-check:focus + .btn-focus, .btn-focus:focus {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(54.4, 51.2, 67.2);\n  border-color: #33303f;\n}\n.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-focus:disabled, .btn-focus.disabled {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n\n.btn-alternate {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:hover {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n}\n.btn-check:focus + .btn-alternate, .btn-alternate:focus {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(104.8, 70.4, 110.4);\n  border-color: rgb(98.25, 66, 103.5);\n}\n.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-alternate:disabled, .btn-alternate.disabled {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n\n.btn-outline-primary {\n  color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary:disabled, .btn-outline-primary.disabled {\n  color: #545cd8;\n  background-color: transparent;\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n\n.btn-outline-success {\n  color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:hover {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success:disabled, .btn-outline-success.disabled {\n  color: #3ac47d;\n  background-color: transparent;\n}\n\n.btn-outline-info {\n  color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:hover {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info:disabled, .btn-outline-info.disabled {\n  color: #30b1ff;\n  background-color: transparent;\n}\n\n.btn-outline-warning {\n  color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:hover {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning:disabled, .btn-outline-warning.disabled {\n  color: #f7b924;\n  background-color: transparent;\n}\n\n.btn-outline-danger {\n  color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger:disabled, .btn-outline-danger.disabled {\n  color: #d92550;\n  background-color: transparent;\n}\n\n.btn-outline-light {\n  color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:hover {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light:disabled, .btn-outline-light.disabled {\n  color: #eeeeee;\n  background-color: transparent;\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark:disabled, .btn-outline-dark.disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n\n.btn-outline-focus {\n  color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:hover {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus:disabled, .btn-outline-focus.disabled {\n  color: #444054;\n  background-color: transparent;\n}\n\n.btn-outline-alternate {\n  color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:hover {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {\n  color: #83588a;\n  background-color: transparent;\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #545cd8;\n  text-decoration: underline;\n}\n.btn-link:hover {\n  color: rgb(67.2, 73.6, 172.8);\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #6c757d;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  border-radius: 0.2rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  z-index: 1000;\n  display: none;\n  min-width: 15rem;\n  padding: 0.65rem 0;\n  margin: 0;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: 0.125rem;\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: rgb(29.7, 33.3, 36.9);\n  background-color: #e0f3ff;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #545cd8;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #adb5bd;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.65rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.968rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.4rem 1rem;\n  color: #212529;\n}\n\n.dropdown-menu-dark {\n  color: #dee2e6;\n  background-color: #343a40;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.dropdown-menu-dark .dropdown-item {\n  color: #dee2e6;\n}\n.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {\n  color: #fff;\n  background-color: #545cd8;\n}\n.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {\n  color: #adb5bd;\n}\n.dropdown-menu-dark .dropdown-divider {\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.dropdown-menu-dark .dropdown-item-text {\n  color: #dee2e6;\n}\n.dropdown-menu-dark .dropdown-header {\n  color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n  color: #545cd8;\n  text-decoration: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: rgb(67.2, 73.6, 172.8);\n}\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-link {\n  margin-bottom: -1px;\n  background: none;\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n  isolation: isolate;\n}\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: 0.25rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #545cd8;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: 0.335rem;\n  padding-bottom: 0.335rem;\n  margin-right: 1rem;\n  font-size: 1.1rem;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.1rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  transition: box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 0;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.55);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-text a,\n.navbar-light .navbar-text a:hover,\n.navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.55);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-text a,\n.navbar-dark .navbar-text a:hover,\n.navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n  border-radius: 0.25rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1rem 1rem;\n}\n\n.card-title {\n  margin-bottom: 0.5rem;\n}\n\n.card-subtitle {\n  margin-top: -0.25rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1rem;\n}\n\n.card-header {\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n}\n.card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 0.5rem 1rem;\n  background-color: #fff;\n  border-top: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n  margin-left: -0.5rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.5rem;\n  margin-left: -0.5rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1rem;\n  border-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-group > .card {\n  margin-bottom: 0.75rem;\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 1.25rem;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  background-color: #fff;\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s, border-radius 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: rgb(75.6, 82.8, 194.4);\n  background-color: rgb(237.9, 238.7, 251.1);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2875.6, 82.8, 194.4%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  transform: rotate(-180deg);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-left: auto;\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23495057'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-size: 1.25rem;\n  transition: transform 0.2s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: none;\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: #fff;\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.accordion-body {\n  padding: 1rem 1.25rem;\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 0;\n  margin-bottom: 1rem;\n  list-style: none;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: #545cd8;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: rgb(67.2, 73.6, 172.8);\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 3;\n  color: rgb(67.2, 73.6, 172.8);\n  background-color: #e9ecef;\n  outline: 0;\n  box-shadow: none;\n}\n\n.page-item:not(:first-child) .page-link, .pagination .page-number:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n.page-item.active .page-link, .pagination .active.page-number .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.page-item.disabled .page-link, .pagination .disabled.page-number .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.page-link {\n  padding: 0.375rem 0.75rem;\n}\n\n.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.1rem;\n}\n.pagination-lg .page-item:first-child .page-link, .pagination-lg .pagination .page-number:first-child .page-link, .pagination .pagination-lg .page-number:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n.pagination-lg .page-item:last-child .page-link, .pagination-lg .pagination .page-number:last-child .page-link, .pagination .pagination-lg .page-number:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n}\n.pagination-sm .page-item:first-child .page-link, .pagination-sm .pagination .page-number:first-child .page-link, .pagination .pagination-sm .page-number:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n.pagination-sm .page-item:last-child .page-link, .pagination-sm .pagination .page-number:last-child .page-link, .pagination .pagination-sm .page-number:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.35em 0.65em;\n  font-size: 0.75em;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  position: relative;\n  padding: 1rem 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  color: rgb(50.4, 55.2, 129.6);\n  background-color: rgb(220.8, 222.4, 247.2);\n  border-color: rgb(203.7, 206.1, 243.3);\n}\n.alert-primary .alert-link {\n  color: rgb(40.32, 44.16, 103.68);\n}\n\n.alert-secondary {\n  color: rgb(64.8, 70.2, 75);\n  background-color: rgb(225.6, 227.4, 229);\n  border-color: rgb(210.9, 213.6, 216);\n}\n.alert-secondary .alert-link {\n  color: rgb(51.84, 56.16, 60);\n}\n\n.alert-success {\n  color: rgb(34.8, 117.6, 75);\n  background-color: rgb(215.6, 243.2, 229);\n  border-color: rgb(195.9, 237.3, 216);\n}\n.alert-success .alert-link {\n  color: rgb(27.84, 94.08, 60);\n}\n\n.alert-info {\n  color: rgb(28.8, 106.2, 153);\n  background-color: rgb(213.6, 239.4, 255);\n  border-color: rgb(192.9, 231.6, 255);\n}\n.alert-info .alert-link {\n  color: rgb(23.04, 84.96, 122.4);\n}\n\n.alert-warning {\n  color: rgb(98.8, 74, 14.4);\n  background-color: rgb(253.4, 241, 211.2);\n  border-color: rgb(252.6, 234, 189.3);\n}\n.alert-warning .alert-link {\n  color: rgb(79.04, 59.2, 11.52);\n}\n\n.alert-danger {\n  color: rgb(130.2, 22.2, 48);\n  background-color: rgb(247.4, 211.4, 220);\n  border-color: rgb(243.6, 189.6, 202.5);\n}\n.alert-danger .alert-link {\n  color: rgb(104.16, 17.76, 38.4);\n}\n\n.alert-light {\n  color: rgb(95.2, 95.2, 95.2);\n  background-color: rgb(251.6, 251.6, 251.6);\n  border-color: rgb(249.9, 249.9, 249.9);\n}\n.alert-light .alert-link {\n  color: rgb(76.16, 76.16, 76.16);\n}\n\n.alert-dark {\n  color: rgb(31.2, 34.8, 38.4);\n  background-color: rgb(214.4, 215.6, 216.8);\n  border-color: rgb(194.1, 195.9, 197.7);\n}\n.alert-dark .alert-link {\n  color: rgb(24.96, 27.84, 30.72);\n}\n\n.alert-focus {\n  color: rgb(40.8, 38.4, 50.4);\n  background-color: rgb(217.6, 216.8, 220.8);\n  border-color: rgb(198.9, 197.7, 203.7);\n}\n.alert-focus .alert-link {\n  color: rgb(32.64, 30.72, 40.32);\n}\n\n.alert-alternate {\n  color: rgb(78.6, 52.8, 82.8);\n  background-color: rgb(230.2, 221.6, 231.6);\n  border-color: rgb(217.8, 204.9, 219.9);\n}\n.alert-alternate .alert-link {\n  color: rgb(62.88, 42.24, 66.24);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.66rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #545cd8;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.25rem;\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > li::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.list-group-item-action:active {\n  color: #495057;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.5rem 1rem;\n  color: #212529;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid rgba(84, 92, 216, 0.08);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: rgb(50.4, 55.2, 129.6);\n  background-color: rgb(220.8, 222.4, 247.2);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(50.4, 55.2, 129.6);\n  background-color: rgb(198.72, 200.16, 222.48);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(50.4, 55.2, 129.6);\n  border-color: rgb(50.4, 55.2, 129.6);\n}\n\n.list-group-item-secondary {\n  color: rgb(64.8, 70.2, 75);\n  background-color: rgb(225.6, 227.4, 229);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(64.8, 70.2, 75);\n  background-color: rgb(203.04, 204.66, 206.1);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(64.8, 70.2, 75);\n  border-color: rgb(64.8, 70.2, 75);\n}\n\n.list-group-item-success {\n  color: rgb(34.8, 117.6, 75);\n  background-color: rgb(215.6, 243.2, 229);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(34.8, 117.6, 75);\n  background-color: rgb(194.04, 218.88, 206.1);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(34.8, 117.6, 75);\n  border-color: rgb(34.8, 117.6, 75);\n}\n\n.list-group-item-info {\n  color: rgb(28.8, 106.2, 153);\n  background-color: rgb(213.6, 239.4, 255);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(28.8, 106.2, 153);\n  background-color: rgb(192.24, 215.46, 229.5);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(28.8, 106.2, 153);\n  border-color: rgb(28.8, 106.2, 153);\n}\n\n.list-group-item-warning {\n  color: rgb(98.8, 74, 14.4);\n  background-color: rgb(253.4, 241, 211.2);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(98.8, 74, 14.4);\n  background-color: rgb(228.06, 216.9, 190.08);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(98.8, 74, 14.4);\n  border-color: rgb(98.8, 74, 14.4);\n}\n\n.list-group-item-danger {\n  color: rgb(130.2, 22.2, 48);\n  background-color: rgb(247.4, 211.4, 220);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(130.2, 22.2, 48);\n  background-color: rgb(222.66, 190.26, 198);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(130.2, 22.2, 48);\n  border-color: rgb(130.2, 22.2, 48);\n}\n\n.list-group-item-light {\n  color: rgb(95.2, 95.2, 95.2);\n  background-color: rgb(251.6, 251.6, 251.6);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(95.2, 95.2, 95.2);\n  background-color: rgb(226.44, 226.44, 226.44);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(95.2, 95.2, 95.2);\n  border-color: rgb(95.2, 95.2, 95.2);\n}\n\n.list-group-item-dark {\n  color: rgb(31.2, 34.8, 38.4);\n  background-color: rgb(214.4, 215.6, 216.8);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(31.2, 34.8, 38.4);\n  background-color: rgb(192.96, 194.04, 195.12);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(31.2, 34.8, 38.4);\n  border-color: rgb(31.2, 34.8, 38.4);\n}\n\n.list-group-item-focus {\n  color: rgb(40.8, 38.4, 50.4);\n  background-color: rgb(217.6, 216.8, 220.8);\n}\n.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {\n  color: rgb(40.8, 38.4, 50.4);\n  background-color: rgb(195.84, 195.12, 198.72);\n}\n.list-group-item-focus.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(40.8, 38.4, 50.4);\n  border-color: rgb(40.8, 38.4, 50.4);\n}\n\n.list-group-item-alternate {\n  color: rgb(78.6, 52.8, 82.8);\n  background-color: rgb(230.2, 221.6, 231.6);\n}\n.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {\n  color: rgb(78.6, 52.8, 82.8);\n  background-color: rgb(207.18, 199.44, 208.44);\n}\n.list-group-item-alternate.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(78.6, 52.8, 82.8);\n  border-color: rgb(78.6, 52.8, 82.8);\n}\n\n.btn-close {\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: 0.5;\n}\n.btn-close:hover {\n  color: #000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n  opacity: 1;\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.btn-close-white {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  width: 350px;\n  max-width: 100%;\n  font-size: 0.875rem;\n  pointer-events: auto;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.toast:not(.showing):not(.show) {\n  opacity: 0;\n}\n.toast.hide {\n  display: none;\n}\n\n.toast-container {\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.toast-header .btn-close {\n  margin-right: -0.375rem;\n  margin-left: 0.75rem;\n}\n\n.toast-body {\n  padding: 0.75rem;\n  word-wrap: break-word;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n.modal-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 1px solid #dee2e6;\n  border-bottom-right-radius: calc(0.3rem - 1px);\n  border-bottom-left-radius: calc(0.3rem - 1px);\n}\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1080;\n  display: block;\n  margin: 0;\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.968rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .tooltip-arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0 /* rtl:ignore */;\n  z-index: 1070;\n  display: block;\n  max-width: 320px;\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.968rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n  border-radius: 0.3rem;\n}\n.popover .popover-arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-0.5rem - 1px);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #fff;\n}\n\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.88rem;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 1rem 1rem;\n  color: #495057;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    animation-duration: 1.5s;\n  }\n}\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  background-clip: padding-box;\n  outline: 0;\n  transition: transform 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n}\n.offcanvas-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin-top: -0.5rem;\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: 1rem 1rem;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: 400px;\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: 400px;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  transform: none;\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.link-primary {\n  color: #545cd8;\n}\n.link-primary:hover, .link-primary:focus {\n  color: rgb(67.2, 73.6, 172.8);\n}\n\n.link-secondary {\n  color: #6c757d;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: rgb(86.4, 93.6, 100);\n}\n\n.link-success {\n  color: #3ac47d;\n}\n.link-success:hover, .link-success:focus {\n  color: rgb(97.4, 207.8, 151);\n}\n\n.link-info {\n  color: #30b1ff;\n}\n.link-info:hover, .link-info:focus {\n  color: rgb(89.4, 192.6, 255);\n}\n\n.link-warning {\n  color: #f7b924;\n}\n.link-warning:hover, .link-warning:focus {\n  color: rgb(248.6, 199, 79.8);\n}\n\n.link-danger {\n  color: #d92550;\n}\n.link-danger:hover, .link-danger:focus {\n  color: rgb(173.6, 29.6, 64);\n}\n\n.link-light {\n  color: #eeeeee;\n}\n.link-light:hover, .link-light:focus {\n  color: rgb(241.4, 241.4, 241.4);\n}\n\n.link-dark {\n  color: #343a40;\n}\n.link-dark:hover, .link-dark:focus {\n  color: rgb(41.6, 46.4, 51.2);\n}\n\n.link-focus {\n  color: #444054;\n}\n.link-focus:hover, .link-focus:focus {\n  color: rgb(54.4, 51.2, 67.2);\n}\n\n.link-alternate {\n  color: #83588a;\n}\n.link-alternate:hover, .link-alternate:focus {\n  color: rgb(104.8, 70.4, 110.4);\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: 1px solid #dee2e6 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: 1px solid #dee2e6 !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #545cd8 !important;\n}\n\n.border-secondary {\n  border-color: #6c757d !important;\n}\n\n.border-success {\n  border-color: #3ac47d !important;\n}\n\n.border-info {\n  border-color: #30b1ff !important;\n}\n\n.border-warning {\n  border-color: #f7b924 !important;\n}\n\n.border-danger {\n  border-color: #d92550 !important;\n}\n\n.border-light {\n  border-color: #eeeeee !important;\n}\n\n.border-dark {\n  border-color: #343a40 !important;\n}\n\n.border-focus {\n  border-color: #444054 !important;\n}\n\n.border-alternate {\n  border-color: #83588a !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.345rem + 1.14vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.301rem + 0.612vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.279rem + 0.348vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.257rem + 0.084vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.1rem !important;\n}\n\n.fs-6 {\n  font-size: 0.88rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  color: #545cd8 !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\n.text-success {\n  color: #3ac47d !important;\n}\n\n.text-info {\n  color: #30b1ff !important;\n}\n\n.text-warning {\n  color: #f7b924 !important;\n}\n\n.text-danger {\n  color: #d92550 !important;\n}\n\n.text-light {\n  color: #eeeeee !important;\n}\n\n.text-dark {\n  color: #343a40 !important;\n}\n\n.text-focus {\n  color: #444054 !important;\n}\n\n.text-alternate {\n  color: #83588a !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-body {\n  color: #495057 !important;\n}\n\n.text-muted, .dispute .chatbot .chat p, .dispute .chatbot__body .date {\n  color: #6c757d !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.bg-primary {\n  background-color: #545cd8 !important;\n}\n\n.bg-secondary {\n  background-color: #6c757d !important;\n}\n\n.bg-success {\n  background-color: #3ac47d !important;\n}\n\n.bg-info {\n  background-color: #30b1ff !important;\n}\n\n.bg-warning {\n  background-color: #f7b924 !important;\n}\n\n.bg-danger {\n  background-color: #d92550 !important;\n}\n\n.bg-light {\n  background-color: #eeeeee !important;\n}\n\n.bg-dark {\n  background-color: #343a40 !important;\n}\n\n.bg-focus {\n  background-color: #444054 !important;\n}\n\n.bg-alternate {\n  background-color: #83588a !important;\n}\n\n.bg-body {\n  background-color: #fff !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.2rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-end {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: 0.25rem !important;\n  border-top-left-radius: 0.25rem !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.2rem !important;\n  }\n  .fs-2 {\n    font-size: 1.76rem !important;\n  }\n  .fs-3 {\n    font-size: 1.54rem !important;\n  }\n  .fs-4 {\n    font-size: 1.32rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\na,\nbutton,\n.btn {\n  outline: none !important;\n}\n\n.app-container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  margin: 0;\n}\n\n.SidebarAnimation-appear {\n  transform: translateX(-30px);\n  opacity: 0;\n}\n.SidebarAnimation-appear.SidebarAnimation-appear-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.4s linear;\n}\n\n.HeaderAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.HeaderAnimation-appear.HeaderAnimation-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s linear;\n}\n\n.MainAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.MainAnimation-appear.MainAnimation-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s linear;\n}\n\n.app-header {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  position: relative;\n  z-index: 10;\n  transition: all 0.2s;\n}\n.app-header.header-shadow {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.app-header .app-header__content {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex: 1;\n  padding: 0 1.5rem;\n  height: 60px;\n}\n.app-header .app-header__content .app-header-left {\n  display: flex;\n  align-items: center;\n}\n.app-header .app-header__content .app-header-right {\n  align-items: center;\n  display: flex;\n  margin-left: auto;\n}\n.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {\n  white-space: nowrap;\n}\n.app-header .header-user-info > .widget-subheading {\n  font-size: 0.8rem;\n}\n\n.app-header__logo {\n  padding: 0 1.5rem;\n  height: 60px;\n  width: 280px;\n  display: flex;\n  align-items: center;\n  transition: width 0.2s;\n}\n.app-header__logo .logo-src {\n  height: 23px;\n  width: 97px;\n  background: url(\"../../../assets/utils/images/logo-inverse.png\");\n}\n\n.app-header__menu,\n.app-header__mobile-menu {\n  display: none;\n  padding: 0 1.5rem;\n  height: 60px;\n  align-items: center;\n}\n\n.fixed-header .app-header {\n  position: fixed;\n  width: 100%;\n  top: 0;\n}\n.fixed-header .app-header .app-header__logo {\n  visibility: visible;\n}\n.fixed-header .app-main {\n  padding-top: 60px;\n}\n.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {\n  visibility: hidden;\n}\n\n.header-dots {\n  margin-left: auto;\n  display: flex;\n}\n.header-dots > .dropdown {\n  display: flex;\n  align-content: center;\n}\n.header-dots .icon-wrapper-alt {\n  margin: 0;\n  height: 44px;\n  width: 44px;\n  text-align: center;\n  overflow: visible;\n}\n.header-dots .icon-wrapper-alt .language-icon {\n  border-radius: 30px;\n  position: relative;\n  z-index: 4;\n  width: 28px;\n  height: 28px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n.header-dots .icon-wrapper-alt .language-icon img {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  margin: -22px 0 0 -20px;\n}\n.header-dots .icon-wrapper-alt .icon-wrapper-bg {\n  opacity: 0.1;\n  transition: opacity 0.2s;\n  border-radius: 40px;\n}\n.header-dots .icon-wrapper-alt svg {\n  margin: 0 auto;\n}\n@-moz-document url-prefix() {\n  .header-dots .icon-wrapper-alt svg {\n    width: 50%;\n  }\n}\n.header-dots .icon-wrapper-alt i {\n  font-size: 1.3rem;\n}\n.header-dots .icon-wrapper-alt:hover {\n  cursor: pointer;\n}\n.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {\n  opacity: 0.2;\n}\n.header-dots .icon-wrapper-alt .badge-dot {\n  top: 1px;\n  right: 1px;\n  border: 0;\n}\n\n.header-megamenu.nav > li > .nav-link {\n  color: #6c757d;\n  padding-left: 0.6666666667rem;\n  padding-right: 0.6666666667rem;\n}\n.header-megamenu.nav > li > .nav-link .rounded-pill {\n  padding: 5px 7px;\n}\n.header-megamenu.nav > li > .nav-link:hover {\n  color: #343a40;\n}\n.header-megamenu.nav > li > .nav-link svg {\n  margin-top: 1px;\n}\n\n.header-btn-lg {\n  padding: 0 0 0 1.5rem;\n  margin-left: 1.5rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n  /*&::before {\n    position: absolute;\n    left: -1px;\n    top: 50%;\n    background: $border-color;\n    width: 1px;\n    height: 30px;\n    margin-top: -15px;\n    content: '';\n  }*/\n}\n.header-btn-lg .hamburger-inner,\n.header-btn-lg .hamburger-inner::before,\n.header-btn-lg .hamburger-inner::after {\n  background: #6c757d;\n}\n\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {\n  color: rgb(255, 255, 255);\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {\n  fill: rgba(255, 255, 255, 0.7);\n  transition: all 0.2s;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {\n  background: rgba(255, 255, 255, 0.1) !important;\n  transition: all 0.2s;\n  opacity: 1;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {\n  fill: rgba(255, 255, 255, 0.95);\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {\n  border-color: transparent;\n}\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n.app-header.header-text-light .search-wrapper.active .input-holder {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-header.header-text-light .search-wrapper.active .input-holder .search-input {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-header.header-text-light .header-btn-lg::before {\n  background: rgba(255, 255, 255, 0.2);\n}\n.app-header.header-text-light .header-btn-lg .hamburger-inner,\n.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,\n.app-header.header-text-light .header-btn-lg .hamburger-inner::before,\n.app-header.header-text-light .header-btn-lg .hamburger-inner::after,\n.app-header.header-text-light .header__pane .hamburger-inner,\n.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,\n.app-header.header-text-light .header__pane .hamburger-inner::before,\n.app-header.header-text-light .header__pane .hamburger-inner::after {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .search-wrapper .close::before,\n.app-header.header-text-light .search-wrapper .close::after,\n.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {\n  background: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header__logo .logo-src {\n  background: url(\"../../../../assets/utils/images/logo.png\");\n}\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {\n  color: rgba(0, 0, 0, 0.7);\n}\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {\n  color: rgb(0, 0, 0);\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {\n  fill: rgba(0, 0, 0, 0.7);\n  transition: all 0.2s;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {\n  background: rgba(0, 0, 0, 0.1) !important;\n  transition: all 0.2s;\n  opacity: 1;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {\n  fill: rgba(0, 0, 0, 0.95);\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {\n  border-color: transparent;\n}\n.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,\n.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,\n.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .header-btn-lg::before {\n  background: rgba(0, 0, 0, 0.2);\n}\n.app-header.header-text-dark .header-btn-lg .hamburger-inner,\n.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,\n.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,\n.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,\n.app-header.header-text-dark .header__pane .hamburger-inner,\n.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,\n.app-header.header-text-dark .header__pane .hamburger-inner::before,\n.app-header.header-text-dark .header__pane .hamburger-inner::after {\n  background-color: rgba(0, 0, 0, 0.8) !important;\n}\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {\n  border-color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper .close::before,\n.app-header.header-text-dark .search-wrapper .close::after,\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {\n  background: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .app-header__logo .logo-src {\n  background: url(\"../../../../assets/utils/images/logo-inverse.png\");\n}\n\n.app-sidebar {\n  width: 280px;\n  display: flex;\n  z-index: 11;\n  overflow: hidden;\n  min-width: 280px;\n  position: relative;\n  flex: 0 0 280px;\n  margin-top: -60px;\n  padding-top: 60px;\n  transition: all 0.2s;\n}\n.app-sidebar .app-sidebar__inner {\n  padding: 2px 1.5rem 1.5rem;\n}\n.app-sidebar .scrollbar-container {\n  z-index: 15;\n  width: 100%;\n}\n.app-sidebar .app-sidebar-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0.05;\n  background-size: cover;\n  z-index: 10;\n}\n.app-sidebar .app-header__logo {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: none;\n  z-index: 11;\n}\n.app-sidebar.sidebar-shadow {\n  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\n}\n\n.app-sidebar__heading {\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  margin: 0.75rem 0;\n  font-weight: bold;\n  color: #545cd8;\n  white-space: nowrap;\n  position: relative;\n}\n\n.sidebar-mobile-overlay {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: #333;\n  opacity: 0.6;\n  left: 0;\n  top: 0;\n  z-index: 12;\n}\n\n.vertical-nav-menu {\n  position: relative;\n}\n.vertical-nav-menu::after {\n  content: \" \";\n  pointer-events: none;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n.vertical-nav-menu .metismenu-container,\n.vertical-nav-menu .metismenu-item {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.vertical-nav-menu .metismenu-container {\n  list-style: none;\n}\n.vertical-nav-menu .metismenu-container:before {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link {\n  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;\n  display: block;\n  line-height: 2.5rem;\n  height: 2.5rem;\n  padding: 0 1.5rem 0 45px;\n  position: relative;\n  border-radius: 0.25rem;\n  color: #343a40;\n  white-space: nowrap;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover {\n  background: #e0f3ff;\n  text-decoration: none;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {\n  opacity: 0.6;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {\n  opacity: 1;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link.active {\n  color: #545cd8;\n  background: #e0f3ff;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {\n  font-weight: bold;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon,\n.vertical-nav-menu .metismenu-container i.metismenu-icon {\n  text-align: center;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  position: absolute;\n  left: 5px;\n  top: 50%;\n  margin-top: -17px;\n  font-size: 1.5rem;\n  opacity: 0.3;\n  transition: color 300ms;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon {\n  transition: transform 300ms;\n  left: auto;\n  right: 0;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {\n  transform: rotate(-180deg);\n}\n.vertical-nav-menu .metismenu-container .metismenu-container {\n  transition: padding 300ms;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible {\n  padding: 0.5em 0 0 2rem;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {\n  content: \"\";\n  height: 100%;\n  opacity: 1;\n  width: 3px;\n  background: #e0f3ff;\n  position: absolute;\n  left: 20px;\n  top: 0;\n  border-radius: 15px;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 2.3em;\n  line-height: 2.3em;\n  color: #6c757d;\n  margin: 0 0 3px;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {\n  color: #545cd8;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {\n  display: none;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {\n  color: #545cd8;\n  background: #e0f3ff;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {\n  height: 0;\n  overflow: hidden;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {\n  padding-left: 1em;\n}\n\n.app-sidebar.sidebar-text-light {\n  border-right: 0 !important;\n}\n.app-sidebar.sidebar-text-light .app-sidebar__heading {\n  color: rgba(255, 255, 255, 0.6);\n}\n.app-sidebar.sidebar-text-light .app-sidebar__heading::before {\n  background: rgba(255, 255, 255, 0.2) !important;\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {\n  color: rgb(255, 255, 255);\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {\n  color: rgba(255, 255, 255, 0.6);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {\n  color: rgb(255, 255, 255);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {\n  background: rgba(255, 255, 255, 0.3);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {\n  opacity: 0.5;\n}\n.app-sidebar.sidebar-text-light .ps__thumb-y {\n  background: rgba(255, 255, 255, 0.3);\n}\n.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {\n  background: rgba(255, 255, 255, 0.2);\n}\n.app-sidebar.sidebar-text-light .app-header__logo .logo-src {\n  background: url(\"../../../../assets/utils/images/logo.png\");\n}\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.app-sidebar.sidebar-text-dark {\n  border-right: 0 !important;\n}\n.app-sidebar.sidebar-text-dark .app-sidebar__heading {\n  color: rgba(0, 0, 0, 0.6);\n}\n.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {\n  background: rgba(0, 0, 0, 0.5) !important;\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {\n  color: rgba(0, 0, 0, 0.7);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {\n  color: rgb(0, 0, 0);\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {\n  color: rgba(0, 0, 0, 0.6);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {\n  opacity: 0.5;\n}\n.app-sidebar.sidebar-text-dark .ps__thumb-y {\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {\n  background: rgba(0, 0, 0, 0.2);\n}\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.fixed-sidebar .app-sidebar {\n  position: fixed;\n  height: 100vh;\n}\n.fixed-sidebar .app-main .app-main__outer {\n  z-index: 9;\n  padding-left: 280px;\n}\n.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {\n  display: none;\n}\n.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {\n  display: flex;\n}\n.fixed-sidebar:not(.fixed-header) .app-header {\n  margin-left: 280px;\n}\n.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {\n  display: none;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {\n  margin-left: 80px;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {\n  width: 80px;\n  padding: 0;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {\n  display: none;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {\n  margin-right: auto;\n}\n\n.closed-sidebar .app-sidebar {\n  transition: all 0.3s ease;\n  width: 80px;\n  min-width: 80px;\n  flex: 0 0 80px;\n  z-index: 13;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {\n  text-indent: -999em;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #e0f3ff;\n  text-indent: 1px;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {\n  text-indent: -99rem;\n  padding: 0;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {\n  text-indent: 0;\n  left: 50%;\n  margin-left: -17px;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {\n  visibility: hidden;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {\n  padding: 0;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 0;\n}\n.closed-sidebar .app-sidebar:hover {\n  flex: 0 0 280px !important;\n  width: 280px !important;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {\n  text-indent: initial;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {\n  display: none;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {\n  text-indent: initial;\n  padding: 0 1.5rem 0 45px;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {\n  text-indent: initial;\n  left: 5px;\n  margin-left: 0;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {\n  visibility: visible;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {\n  padding: 0.5em 0 0 2rem;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 2.3em;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {\n  padding-left: 1em;\n}\n.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {\n  position: static;\n  height: auto;\n  overflow: initial !important;\n}\n.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {\n  position: absolute;\n  height: 100%;\n  overflow: hidden !important;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {\n  width: 80px;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {\n  display: none;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {\n  margin-right: auto;\n}\n.closed-sidebar.fixed-sidebar .app-main__outer {\n  padding-left: 80px;\n}\n.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {\n  visibility: hidden;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,\n.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {\n  width: auto;\n  display: flex;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,\n.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {\n  display: none;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {\n  display: flex;\n  width: 80px;\n  padding: 0 1.5rem !important;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {\n  display: block !important;\n  margin: 0 auto;\n  width: 21px;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {\n  display: none;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {\n  width: 280px;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {\n  width: 97px;\n  margin: 0;\n}\n.closed-sidebar.closed-sidebar-mobile .app-header {\n  margin-left: 0 !important;\n}\n.closed-sidebar.fixed-footer .app-footer__inner {\n  margin-left: 0 !important;\n}\n\n.app-main {\n  z-index: 8;\n  position: relative;\n  display: flex;\n}\n.app-main .app-main__outer {\n  flex: 1;\n  flex-direction: column;\n  display: flex;\n  z-index: 12;\n  width: 1px;\n}\n.app-main .app-main__inner {\n  padding: 1.5rem 1.5rem 0;\n  flex: 1;\n}\n.app-main .app-main__inner > .RRT__container > .RRT__panel {\n  margin-top: 1.5rem;\n}\n.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {\n  margin-top: -0.5rem;\n}\n\n.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {\n  margin-top: 1rem;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {\n  border: 0;\n  background: transparent;\n  position: relative;\n  z-index: 7;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {\n  margin-top: -13px;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {\n  margin-top: 0.5rem;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {\n  color: #fff;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {\n  position: absolute;\n  top: 1.1rem;\n  z-index: 5;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {\n  height: 35px;\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.app-theme-white.app-container {\n  background: #eaedef;\n}\n.app-theme-white .app-sidebar {\n  background: #ffffff;\n}\n.app-theme-white .app-footer .app-footer__inner,\n.app-theme-white .app-header {\n  background: #fafbfc;\n}\n.app-theme-white.fixed-header .app-header__logo {\n  background: rgba(250, 251, 252, 0.1);\n}\n\n.app-theme-gray.app-container {\n  background: #ffffff;\n}\n.app-theme-gray .app-sidebar {\n  background: #ffffff;\n  border-right: #dee2e6 solid 1px;\n}\n.app-theme-gray .app-page-title {\n  background: rgba(0, 0, 0, 0.03);\n}\n.app-theme-gray .app-footer,\n.app-theme-gray .app-header {\n  background: #f8f9fa;\n}\n.app-theme-gray .app-footer {\n  border-top: #dee2e6 solid 1px;\n}\n.app-theme-gray .app-header .app-header__logo {\n  border-right: rgba(0, 0, 0, 0.1) solid 1px;\n}\n.app-theme-gray.fixed-header .app-header__logo {\n  background: rgba(0, 0, 0, 0.03);\n}\n.app-theme-gray .card {\n  border-width: 1px;\n}\n.app-theme-gray .main-card {\n  box-shadow: 0 0 0 0 transparent !important;\n}\n.app-theme-gray .main-card > .card-body > .card-title {\n  text-transform: none;\n  font-size: 1.1rem;\n  font-weight: normal;\n  border-bottom: #dee2e6 solid 1px;\n  position: relative;\n  padding: 0 0 1.5rem;\n  margin: 0 0 1.5rem;\n}\n.app-theme-gray .main-card > .card-body > .card-title::before {\n  position: absolute;\n  width: 40px;\n  background: #545cd8;\n  border-radius: 30px;\n  height: 5px;\n  left: 0;\n  bottom: -2px;\n  content: \"\";\n}\n.app-theme-gray .app-inner-layout__sidebar {\n  border-left: 0 !important;\n}\n\n@media (min-width: 760px) {\n  .trade_icon {\n    position: absolute;\n    top: 60%;\n    left: 45%; /* Move to the center horizontally */\n    transform: translateX(-50%); /* Center the element based on its width */\n  }\n}\n.carousel .thumbs-wrapper {\n  margin: 0 !important;\n}\n\n.carousel .thumbs {\n  padding: 0 !important;\n}\n\n.carousel .thumb.selected,\n.carousel .thumb:hover {\n  border: none !important;\n}\n\n.app-footer {\n  height: 60px;\n}\n.app-footer .app-footer__inner {\n  padding: 0 1.5rem 0 0.75rem;\n  height: 60px;\n  transition: all 0.2s;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.app-footer .app-footer__inner .app-footer-left {\n  display: flex;\n  align-items: center;\n}\n.app-footer .app-footer__inner .app-footer-right {\n  margin-left: auto;\n  display: flex;\n}\n\n.footer-dots {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.footer-dots .dots-separator {\n  height: 40px;\n  margin: 0 0.6rem;\n  width: 1px;\n  background: #e9ecef;\n}\n\n.dot-btn-wrapper {\n  padding: 0.5rem;\n  position: relative;\n  display: flex;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n.dot-btn-wrapper .badge-abs {\n  right: 50%;\n}\n.dot-btn-wrapper .badge-abs.badge-dot-sm {\n  top: -2px;\n  margin-right: -3px;\n}\n.dot-btn-wrapper .dot-btn-icon {\n  font-size: 1.8rem;\n}\n.dot-btn-wrapper:hover {\n  text-decoration: none;\n  opacity: 1;\n}\n\n.fixed-footer .app-footer {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  z-index: 7;\n}\n.fixed-footer .app-footer .app-footer__inner {\n  margin-left: 280px;\n  box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.04), 0.3rem -0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02);\n}\n.fixed-footer .app-main .app-main__outer {\n  padding-bottom: 60px;\n}\n.fixed-footer.closed-sidebar .app-footer .app-footer__inner {\n  margin-left: 80px !important;\n}\n\n.app-page-title {\n  padding: 1.5rem;\n  margin: -1.5rem -1.5rem 1.5rem;\n  position: relative;\n}\n.app-page-title .page-title-wrapper {\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.app-page-title .page-title-heading,\n.app-page-title .page-title-subheading {\n  margin: 0;\n  padding: 0;\n}\n.app-page-title .page-title-heading {\n  font-size: 1.1rem;\n  font-weight: 400;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.app-page-title .page-title-subheading {\n  padding: 3px 0 0;\n  font-size: 0.88rem;\n  opacity: 0.6;\n}\n.app-page-title .page-title-subheading .breadcrumb {\n  padding: 0;\n  margin: 3px 0 0;\n  background: transparent;\n}\n.app-page-title .page-title-actions {\n  margin-left: auto;\n}\n.app-page-title .page-title-actions .breadcrumb {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n}\n.app-page-title .page-title-icon {\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  padding: 0.8333333333rem;\n  margin: 0 1.5rem 0 0;\n  background: #fff;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  border-radius: 0.25rem;\n  width: 60px;\n  height: 60px;\n}\n.app-page-title .page-title-icon i {\n  margin: auto;\n}\n.app-page-title .page-title-icon.rounded-circle {\n  margin: 0 1rem 0 0;\n}\n.app-page-title + .RRT__container {\n  margin-top: -1.1538461538rem;\n}\n.app-page-title + .rc-tabs {\n  max-width: calc(100vw - 322px);\n  margin: -1.5rem -0.75rem 1.95rem;\n}\n@media only screen and (max-width: 812px) and (min-width: 360px) {\n  .app-page-title + .rc-tabs {\n    max-width: calc(100vw - 0px);\n    margin: -1.5rem -0.75rem 1.95rem;\n  }\n}\n.app-page-title.app-page-title-simple {\n  margin: 0;\n  background: none !important;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n}\n.app-page-title .page-title-right {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 15px;\n}\n.app-page-title .page-title-right span {\n  white-space: nowrap;\n  color: #212121;\n}\n\n.page-title-icon-rounded .page-title-icon {\n  border-radius: 50px;\n}\n\n.closed-sidebar .rc-tabs {\n  max-width: calc(100vw - 140px);\n}\n\n@media only screen and (max-width: 812px) and (min-width: 360px) {\n  .closed-sidebar .rc-tabs {\n    max-width: calc(100vw - 0px);\n  }\n}\n.body-tabs.body-tabs-layout {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n  padding: 0 1.5rem;\n  border-top: 0;\n  border-bottom: #dee2e6 solid 1px;\n}\n\n.search-wrapper {\n  position: relative;\n  margin-right: 0.6666666667rem;\n}\n.search-wrapper .input-holder {\n  height: 42px;\n  width: 42px;\n  overflow: hidden;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n}\n.search-wrapper .input-holder .search-input {\n  width: 100%;\n  padding: 0 70px 0 20px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: transparent;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  transform: translate(0, 60px);\n  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transition-delay: 0.3s;\n  font-size: 0.88rem;\n}\n.search-wrapper .input-holder .search-icon {\n  width: 42px;\n  height: 42px;\n  border: none;\n  padding: 0;\n  outline: none;\n  position: relative;\n  z-index: 2;\n  float: right;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 30px;\n}\n.search-wrapper .input-holder .search-icon span {\n  width: 22px;\n  height: 22px;\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  transform: rotate(45deg);\n  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);\n}\n.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {\n  position: absolute;\n  content: \"\";\n}\n.search-wrapper .input-holder .search-icon span::before {\n  width: 4px;\n  height: 11px;\n  left: 9px;\n  top: 13px;\n  border-radius: 2px;\n  background: #545cd8;\n}\n.search-wrapper .input-holder .search-icon span::after {\n  width: 14px;\n  height: 14px;\n  left: 4px;\n  top: 0;\n  border-radius: 16px;\n  border: 2px solid #545cd8;\n}\n.search-wrapper .btn-close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  cursor: pointer;\n  opacity: 0 !important;\n  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);\n  transition-delay: 0.1s;\n}\n.search-wrapper .btn-close::before, .search-wrapper .btn-close::after {\n  position: absolute;\n  background: #545cd8;\n  border-radius: 2px;\n}\n.search-wrapper .btn-close::before {\n  width: 2px;\n  height: 20px;\n  left: 9px;\n  top: 0;\n}\n.search-wrapper .btn-close::after {\n  width: 20px;\n  height: 2px;\n  left: 0;\n  top: 9px;\n}\n.search-wrapper.active {\n  width: 330px;\n}\n.search-wrapper.active .input-holder {\n  width: 290px;\n  border-radius: 50px;\n  background: rgba(0, 0, 0, 0.05);\n  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);\n}\n.search-wrapper.active .input-holder .search-input {\n  opacity: 1;\n  transform: translate(0, 11px);\n}\n.search-wrapper.active .input-holder .search-icon {\n  width: 42px;\n  height: 42px;\n  margin: 0;\n  border-radius: 30px;\n}\n.search-wrapper.active .input-holder .search-icon span {\n  transform: rotate(-45deg);\n}\n.search-wrapper.active .btn-close {\n  left: 300px;\n  opacity: 0.6 !important;\n  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transition-delay: 0.5s;\n}\n.search-wrapper.active .btn-close:hover {\n  opacity: 1 !important;\n}\n.search-wrapper.active + .header-megamenu {\n  opacity: 0;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.bg-gray {\n  background: #f9f9f9 !important;\n}\n.bg-table--green {\n  background: #229e60 !important;\n}\n.bg-table--red {\n  background: #cd3a3d !important;\n}\n\n.text-success {\n  color: #0e9451 !important;\n}\n.text-primary {\n  color: #535bd6 !important;\n}\n.text-base {\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 400;\n  color: inherit;\n}\n.text-muted, .dispute .chatbot .chat p, .dispute .chatbot__body .date {\n  color: #767676 !important;\n}\n.text-table--green {\n  color: #229e60 !important;\n}\n.text-table--red {\n  color: #cd3a3d !important;\n}\n\n.weight-400 {\n  font-weight: 400 !important;\n}\n.weight-500 {\n  font-weight: 500 !important;\n}\n.weight-600 {\n  font-weight: 600 !important;\n}\n.weight-700 {\n  font-weight: 700 !important;\n}\n\n.alert {\n  border-radius: 0.25rem;\n  padding: 0.25rem 0.625rem;\n  border-style: solid;\n  border-width: 1px;\n  text-transform: uppercase;\n  font-size: 11px;\n  line-height: 13px;\n  font-weight: 700;\n  color: inherit;\n  margin: 0;\n}\n.alert-orange {\n  background: #ffefc9;\n  border-color: #f7b924;\n  color: #f7b924;\n}\n.alert-red {\n  background: #ffe2e7;\n  border-color: #fd1a41;\n  color: #fd1a41;\n}\n.alert-green {\n  background: rgba(34, 158, 96, 0.0509803922);\n  border-color: #229e60;\n  color: #229e60;\n}\n\n@media (min-width: 768px) {\n  .h-md-100p {\n    height: 100% !important;\n  }\n}\n\n.p-3\\.5 {\n  padding: 20px !important;\n}\n\n.ps-\\.5 {\n  padding-left: 0px !important;\n}\n\n.pe-\\.5 {\n  padding-right: 20px !important;\n}\n\n.pt-\\.5 {\n  padding-top: 20px !important;\n}\n\n.pb-\\.5 {\n  padding-bottom: 20px !important;\n}\n\n.m-3\\.5 {\n  margin: 20px !important;\n}\n\n.ms-3\\.5 {\n  margin-left: 0px !important;\n}\n\n.me-3\\.5 {\n  margin-right: 20px !important;\n}\n\n.mt-3\\.5 {\n  margin-top: 20px !important;\n}\n\n.mb-3\\.5 {\n  margin-bottom: 20px !important;\n}\n\n@media (min-width: 768px) {\n  .w-md-auto {\n    width: auto !important;\n  }\n}\n\n.badge {\n  white-space: normal;\n}\n\n.app-title {\n  margin-bottom: 1.5rem;\n}\n@media (max-width: 767.98px) {\n  .app-title {\n    margin-bottom: 0.75rem;\n  }\n}\n.app-title .avatar {\n  width: 3rem;\n  height: 3rem;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  border-radius: 0.25rem;\n  background: #ffffff;\n  margin-right: 0.625rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.app-title .avatar i {\n  font-size: 2rem;\n}\n.app-title span:not(.avatar) {\n  font-size: 0.813rem;\n  line-height: 0.938rem;\n  font-weight: 400;\n  color: #767676;\n}\n.app-title [type=date] {\n  background: #ffffff;\n  border-color: #535bd6;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #212121;\n  padding: 0.5rem 0.875rem;\n  background-color: #ffffff;\n  background-image: url(../../images/icon__caret.svg), url(../../images/icon__calendar.svg);\n  background-size: 12px 7px, 16px;\n  background-position: right 0.875rem center, 0.875rem center;\n  background-repeat: no-repeat;\n  border-color: #535bd6;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #212121;\n  padding: 0.5rem 0.875rem;\n  padding-right: calc(1.75rem + 12px);\n  padding-left: calc(1.75rem + 16px);\n  border-radius: 0.25rem !important;\n  width: auto;\n}\n.app-title [type=date]::-webkit-calendar-picker-indicator {\n  background: transparent;\n  bottom: 0;\n  color: transparent;\n  cursor: pointer;\n  height: auto;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: auto;\n}\n.app-title .btn-outline-primary {\n  background: #ffffff;\n  font-weight: 600;\n}\n\n.dashboard-card {\n  padding: 1.25rem;\n  background: #ffffff;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n}\n.dashboard-card > header {\n  min-height: auto;\n  padding: 0;\n}\n.dashboard-card.card {\n  padding: 0;\n}\n\n.card {\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05) !important;\n  border-radius: 0.25rem !important;\n}\n\nbody {\n  font-family: \"Inter\", serif;\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #212121;\n}\n\nh1, .h1,\nh2,\n.h2,\nh3,\n.h3,\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n  font-family: \"Inter\", serif;\n  font-weight: 600;\n}\n\nh3, .h3 {\n  font-size: 19px;\n  line-height: 25px;\n  font-weight: 500;\n  color: #212121;\n}\n\nh5, .h5 {\n  font-size: 15px;\n  line-height: 21px;\n  font-weight: 500;\n  color: #212121;\n}\n\nh6, .h6 {\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 500;\n  color: #212121;\n}\n\n.rdt_Wrapper {\n  border: solid 1px #e6e6e6;\n  border-radius: 6px !important;\n}\n.rdt_Wrapper .rdt_TableHead {\n  background: #f6f6f6;\n  font-size: 13px;\n  line-height: 15px;\n  font-weight: 400;\n  color: #535bd6;\n}\n.rdt_Wrapper .rdt_TableHeadRow {\n  background: none;\n  min-height: auto;\n  border-bottom-color: #e6e6e6;\n}\n.rdt_Wrapper .rdt_TableCol {\n  padding: 10px 20px;\n}\n.rdt_Wrapper .rdt_TableCol_Sortable:hover, .rdt_Wrapper .rdt_TableCol_Sortable:focus {\n  opacity: 1;\n}\n.rdt_Wrapper .rdt_TableCol_Sortable:hover *, .rdt_Wrapper .rdt_TableCol_Sortable:focus * {\n  opacity: 1;\n}\n.rdt_Wrapper .rdt_TableRow {\n  min-height: auto;\n  font-size: 13px;\n  line-height: 15px;\n  font-weight: 400;\n  color: #212121;\n}\n.rdt_Wrapper .rdt_TableCell {\n  padding: 10px 20px;\n}\n.rdt_Pagination {\n  border: none !important;\n  border-radius: 0 0 0.25rem 0.25rem !important;\n  background: none !important;\n  min-height: auto !important;\n}\n.rdt_SubHeader {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n@media (min-width: 1200px) {\n  .rdt_SubHeader {\n    display: flex;\n    align-items: center;\n  }\n}\n.rdt_SubHeader .btn {\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #ffffff;\n  padding: 0.5rem 0.875rem;\n  border-radius: 0.25rem !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.rdt_SubHeader .btn-gray {\n  background: #eaedef;\n  border-color: #eaedef;\n  color: #212121;\n}\n.rdt_SubHeader .btn-gray:hover, .rdt_SubHeader .btn-gray:active {\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.rdt_SubHeader .btn-icon {\n  position: relative;\n  padding-right: 3rem;\n}\n.rdt_SubHeader .btn-icon .icon {\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  right: 0;\n  border-radius: 0 0.25rem 0.25rem 0 !important;\n  width: 2.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #535bd6;\n}\n.rdt_SubHeader .btn-icon .icon img {\n  height: 18px;\n  width: auto;\n}\n.rdt_SubHeader .btn-sort:after {\n  content: \"\";\n  background-size: 100%;\n  margin-left: 0.5rem;\n  background: url(../../images/icon__caret.svg) no-repeat 0 0;\n  width: 12px;\n  height: 7px;\n}\n.rdt_SubHeader .btn-filter:before {\n  content: \"\";\n  background-size: 100%;\n  margin-right: 0.5rem;\n  background: url(../../images/icon__filter.svg) no-repeat 0 0;\n  width: 16px;\n  height: 14px;\n}\n.rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker {\n  background: #ffffff;\n  border-color: #535bd6;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #212121;\n  padding: 0.5rem 0.875rem;\n  border-radius: 0.25rem !important;\n}\n.rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker::placeholder {\n  color: #212121;\n  opacity: 1;\n}\n.rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker:hover {\n  border-color: #535bd6;\n}\n@media (max-width: 767.98px) {\n  .rdt_SubHeader .custom-date-range-picker .date-picker-container .custom-datepicker {\n    width: 100%;\n  }\n}\n.rdt_SubHeader .form-control {\n  background: #ffffff;\n  border-color: #535bd6;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #212121;\n  padding: 0.5rem 0.875rem;\n  border-radius: 0.25rem !important;\n}\n.rdt_SubHeader .form-control::placeholder {\n  color: #212121;\n  opacity: 1;\n}\n.rdt_SubHeader .form-control:focus {\n  z-index: 1 !important;\n}\n.rdt_SubHeader .form-search {\n  background: #ffffff url(../../images/icon__search.svg) no-repeat 0.875rem center;\n  padding-left: 44px;\n}\n.rdt_SubHeader .form-search-reset {\n  position: absolute;\n  right: 0.875rem;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n.rdt_SubHeader .form-select {\n  background-color: #ffffff;\n  background-image: url(../../images/icon__caret.svg);\n  background-position: right 0.875rem center;\n  background-size: 12px 7px;\n  border-color: #535bd6;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #212121;\n  padding: 0.5rem 0.875rem;\n  padding-right: calc(1.75rem + 12px);\n  border-radius: 0.25rem !important;\n  width: auto;\n}\n.rdt_SubHeader .form-select-period {\n  background-image: url(../../images/icon__caret.svg), url(../../images/icon__calendar.svg);\n  background-size: 12px 7px, 16px;\n  background-position: right 0.875rem center, 0.875rem center;\n  padding-left: calc(1.75rem + 16px);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.75rem 2.25rem;\n}\n\n@media (min-width: 768px) {\n  .button-group {\n    display: flex;\n    align-items: center;\n  }\n  .button-group .btn + .btn {\n    margin-left: 1rem;\n  }\n}\n@media (max-width: 767.98px) {\n  .button-group .btn {\n    width: 100%;\n  }\n  .button-group .btn + .btn {\n    margin-top: 0.5rem;\n  }\n}\n\n.form-control {\n  border-color: #e6e6e6;\n  color: #212121;\n  outline: none !important;\n  box-shadow: none !important;\n}\n.form-control::placeholder {\n  opacity: 1;\n  color: #767676;\n}\n.form-control:disabled, .form-control[readonly] {\n  background: #f6f6f6;\n}\n.form-select {\n  border-color: #e6e6e6;\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #767676;\n}\n.form-select-wrapper {\n  position: relative;\n}\n.form-select-wrapper:after {\n  content: \"\";\n  width: 12px;\n  height: 7px;\n  background: url(\"../../images/icon__caret.svg\") no-repeat 0 0;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.form-select-wrapper .form-select {\n  -webkit-appearance: none;\n  appearance: none;\n  background-image: none;\n}\n.form-select.lrg {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.form-textarea {\n  height: 100px;\n  overflow: auto;\n  resize: none;\n}\n\n.dropdown .dropdown-toggle:after {\n  margin-left: 0.5rem;\n  background: url(../../images/icon__caret.svg) no-repeat 0 0;\n  background-size: 100%;\n  width: 12px;\n  height: 7px;\n  opacity: 1;\n  position: static;\n  border: none;\n}\n.dropdown .dropdown-toggle:hover {\n  color: inherit;\n}\n.dropdown .dropdown-menu {\n  min-width: 10rem;\n  background: #ffffff;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  margin: 0;\n  padding: 0.5rem 0;\n}\n.dropdown .dropdown-menu:before, .dropdown .dropdown-menu:after {\n  display: none;\n}\n.dropdown .dropdown-menu .dropdown-item {\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #212121;\n}\n.dropdown.show > .dropdown-toggle {\n  box-shadow: none !important;\n}\n.dropdown.show > .dropdown-toggle.btn-gray {\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n  color: #212121;\n}\n\n.admin-box h2, .admin-box .h2 {\n  font-weight: 500;\n  font-size: 20px;\n  margin-bottom: 0;\n}\n.admin-box p {\n  color: #212121;\n}\n.admin-box .btn {\n  border-radius: 5px;\n}\n.admin-box .coinbox-value {\n  font-size: 32px;\n  color: #535bd6;\n  line-height: 40px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n.admin-box .coinbox p {\n  color: #767676;\n  margin-bottom: 0;\n}\n.admin-box .wallet-box {\n  width: 100%;\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.admin-box .wallet-box-top {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.admin-box .wallet-box-top .btn-box {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n}\n.admin-box .wallet-box-mid {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 5px;\n}\n.admin-box .wallet-box-bottom {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  border-top: 1px solid #767676;\n  padding-top: 15px;\n}\n.admin-box .wallet-box-bottom div {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.admin-box .wallet-box-bottom div p {\n  font-size: 15px;\n  margin-bottom: 0;\n}\n.admin-box .wallet-box-bottom div p:first-child {\n  color: #767676;\n}\n.admin-box .summery-box {\n  width: 100%;\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.admin-box .summery-box-list {\n  width: 100%;\n  display: grid;\n  grid: 100px/auto auto auto auto;\n  grid-gap: 20px;\n}\n.admin-box .summery-box-card {\n  padding: 20px;\n  border-radius: 10px;\n}\n.admin-box .summery-box-card h2, .admin-box .summery-box-card .h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n.admin-box .summery-box-card p {\n  margin-bottom: 0;\n}\n.admin-box .summery-box-card.blue-md {\n  background-color: #f3f4ff;\n}\n.admin-box .summery-box-card.blue-md h2, .admin-box .summery-box-card.blue-md .h2 {\n  color: #535bd6;\n}\n.admin-box .summery-box-card.blue-vi {\n  background-color: #e7f5ff;\n}\n.admin-box .summery-box-card.blue-vi h2, .admin-box .summery-box-card.blue-vi .h2 {\n  color: #1188dd;\n}\n.admin-box .summery-box-card.green {\n  background-color: #e8faf2;\n}\n.admin-box .summery-box-card.green h2, .admin-box .summery-box-card.green .h2 {\n  color: #0e9451;\n}\n.admin-box .summery-box-card.orange {\n  background-color: #fffce8;\n}\n.admin-box .summery-box-card.orange h2, .admin-box .summery-box-card.orange .h2 {\n  color: #f7b924;\n}\n.admin-box .summery-box-card.red {\n  background-color: #fff1f1;\n}\n.admin-box .summery-box-card.red h2, .admin-box .summery-box-card.red .h2 {\n  color: #d8092e;\n}\n.admin-box .summery-box-card.gray {\n  background-color: #f5f5f5;\n}\n.admin-box .summery-box-card.gray h2, .admin-box .summery-box-card.gray .h2 {\n  color: #212121;\n}\n.admin-box .summery-box-card.pink {\n  background-color: #fff0fb;\n}\n.admin-box .summery-box-card.pink h2, .admin-box .summery-box-card.pink .h2 {\n  color: #d423a5;\n}\n.admin-box .summery-box-card.violet {\n  background-color: #f3f4ff;\n}\n.admin-box .summery-box-card.violet h2, .admin-box .summery-box-card.violet .h2 {\n  color: #9953d6;\n}\n.admin-box .table-box {\n  width: 100%;\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 25px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.admin-box .table-box-top {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n}\n.admin-box .table-box-topleft {\n  width: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n.admin-box .table-box-topright {\n  width: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n.admin-box .table-box .saleamt {\n  background-color: #eeefff;\n  padding: 8px 15px;\n  border-radius: 5px;\n}\n.admin-box .table-box .saleamt p {\n  margin-bottom: 0;\n  color: #535bd6;\n  font-size: 13px;\n  font-weight: 600;\n}\n.admin-box .table-box .filtericon {\n  background-color: #535bd6;\n  color: #fff;\n  border-radius: 5px;\n  padding: 5px;\n}\n.admin-box .table-box .datainfo {\n  width: 100%;\n  display: grid;\n  grid: 20px/auto auto auto auto;\n  grid-gap: 10px;\n}\n.admin-box .table-box .datainfo-list {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  align-items: center;\n  justify-content: flex-start;\n}\n.admin-box .table-box .datainfo-list span {\n  width: 8px;\n  height: 8px;\n  border-radius: 100%;\n}\n.admin-box .table-box .datainfo-list.tt span {\n  background-color: #535bd6;\n}\n.admin-box .table-box .datainfo-list.ctu span {\n  background-color: #1188dd;\n}\n.admin-box .table-box .datainfo-list.ts span {\n  background-color: #0e9451;\n}\n.admin-box .table-box .datainfo-list.trd span {\n  background-color: #f7b924;\n}\n.admin-box .table-box .datainfo-list.bpa span {\n  background-color: #d8092e;\n}\n.admin-box .table-box .datainfo-list.te span {\n  background-color: #212121;\n}\n.admin-box .table-box .datainfo-list.tr span {\n  background-color: #d423a5;\n}\n.admin-box .table-box .datainfo-list.tri span {\n  background-color: #9953d6;\n}\n.admin-box .table-box .datainfo p {\n  margin-bottom: 0;\n  font-size: 13px;\n  line-height: 14px;\n}\n.admin-box .table-box-bottom {\n  width: 100%;\n}\n.admin-box .table-box-bottom .table {\n  margin-bottom: 0;\n}\n.admin-box .table-box-bottom .table thead tr {\n  background-color: #f6f6f6;\n}\n.admin-box .table-box-bottom .table thead tr th {\n  color: #535bd6;\n  font-weight: 500 !important;\n  border-bottom: 1px solid #e6e6e6;\n  padding: 10px;\n}\n.admin-box .table-box-bottom .table tbody tr td {\n  padding: 0 10px;\n}\n.admin-box .table-box-bottom .table tbody tr:last-child td {\n  border-bottom: 0px;\n}\n.admin-box .tableinner {\n  overflow: hidden;\n  border-radius: 5px;\n  border: 1px solid #e6e6e6;\n}\n\n.paypal {\n  /* Rectangle 118 */\n  width: 124.92px;\n  height: 62px;\n  background: #FAEACC;\n  border-radius: 8px;\n}\n\n.dispute {\n  color: #212121;\n  font-size: 13px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #212121;\n}\n.dispute__body {\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  border-radius: 0.25rem;\n  background: #ffffff;\n}\n.dispute__body hr {\n  color: #000000;\n  background-color: #000000;\n  opacity: 0.05;\n  margin: 1.5rem 0;\n}\n.dispute__info {\n  overflow: hidden;\n  color: #212121;\n}\n.dispute__info.buy-sell, .dispute__info.trade .bg-gray {\n  background: rgba(228, 230, 232, 0.2);\n}\n.dispute__info.trade > .row > [class*=col-]:last-of-type {\n  border-left: solid 1px rgba(228, 230, 232, 0.4);\n}\n.dispute__info.trade .block {\n  border: solid 1px rgba(228, 230, 232, 0.4);\n  border-radius: 6px;\n}\n.dispute__info span {\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 400;\n  color: inherit;\n  color: #767676;\n  margin-bottom: 0.25rem;\n  display: block;\n}\n@media (min-width: 768px) {\n  .dispute__info .col-custom-5 {\n    width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .dispute__info .col-custom-5 {\n    width: 33.3333333333%;\n  }\n}\n@media (min-width: 1200px) {\n  .dispute__info .col-custom-5 {\n    width: 20%;\n  }\n}\n.dispute__info .alert {\n  border-color: #de9d00;\n  font-size: 10px;\n  line-height: 14px;\n  font-weight: 700;\n  color: #de9d00;\n  padding: 3px 6px;\n  margin: 0;\n  text-transform: uppercase;\n}\n.dispute__info .timeline > div {\n  position: relative;\n  padding-left: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n@media (max-width: 767.98px) {\n  .dispute__info .timeline > div:last-child {\n    margin: 0;\n  }\n}\n.dispute__info .timeline > div:last-child::before {\n  display: none;\n}\n.dispute__info .timeline > div::before, .dispute__info .timeline > div:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n}\n.dispute__info .timeline > div:before {\n  width: 1px;\n  height: calc(100% + 1.5rem);\n  background: rgba(83, 91, 214, 0.4);\n  left: 0;\n}\n.dispute__info .timeline > div:after {\n  border: solid 1px #535bd6;\n  background: #ffffff;\n  width: calc(0.5rem + 1px);\n  height: calc(0.5rem + 1px);\n  border-radius: 50%;\n  left: -0.25rem;\n}\n.dispute__info .timeline > div.completed:after {\n  background: #535bd6;\n}\n.dispute .form-select {\n  min-width: 16vw;\n}\n.dispute .buyer-seller-card {\n  border-radius: 6px;\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 400;\n  color: inherit;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.dispute .buyer-seller-card .counter input {\n  flex-grow: 1;\n  padding: 0 0.25rem;\n  background: none;\n  border: none;\n  text-align: center;\n  font-size: 15px;\n  line-height: 30px;\n  font-weight: 600;\n  color: inherit;\n  max-width: 2.5rem;\n}\n.dispute .buyer-seller-card .counter .btn {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: none;\n  border-radius: 0.25rem;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.2);\n}\n.dispute .buyer-seller-card .counter .btn:hover {\n  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.6);\n}\n.dispute .buyer-seller-card .refund-buyer .block {\n  position: relative;\n}\n.dispute .buyer-seller-card .refund-buyer .block:not(:first-child) {\n  margin-top: 10px;\n}\n.dispute .buyer-seller-card .refund-buyer .block .option {\n  background: #ffffff;\n  border-radius: 6px;\n  border: solid 1px #ffffff;\n  padding: 0.5rem 0.75rem;\n  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.2);\n  transition: all 0.5s ease-in;\n}\n.dispute .buyer-seller-card .refund-buyer .block:hover .option {\n  border-color: #535bd6;\n}\n.dispute .buyer-seller-card .refund-buyer .block [type=radio] {\n  position: absolute;\n  inset: 0;\n  width: auto;\n  height: auto;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n}\n.dispute .buyer-seller-card .refund-buyer .block [type=radio]:checked ~ .option {\n  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.6);\n  border-color: #535bd6;\n  background-color: #535bd6;\n  color: white;\n}\n.dispute .buyer-seller-card .refund-buyer .block .input {\n  position: relative;\n  z-index: 2;\n}\n.dispute .buyer-seller-card .refund-buyer .block .input input {\n  padding-right: 52px;\n}\n.dispute .buyer-seller-card .refund-buyer .block .input:after {\n  content: \"EUR\";\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  text-transform: uppercase;\n  color: #767676;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block {\n  position: relative;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block:not(:first-child) {\n  margin-top: 10px;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block .option {\n  background: #ffffff;\n  border-radius: 6px;\n  border: solid 1px #ffffff;\n  padding: 0.5rem 0.75rem;\n  box-shadow: 0 0.25rem 0.25rem rgba(197, 197, 197, 0.2);\n  transition: all 0.5s ease-in;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block [type=radio] {\n  position: absolute;\n  inset: 0;\n  width: auto;\n  height: auto;\n  z-index: 1;\n  cursor: pointer;\n  opacity: 0;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block .input {\n  position: relative;\n  z-index: 2;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block .input input {\n  padding-right: 52px;\n}\n.dispute .buyer-seller-card .refund-buyer .no-block .input:after {\n  content: \"EUR\";\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  text-transform: uppercase;\n  color: #767676;\n}\n.dispute .buyer-seller-card .footer {\n  border: solid 1px rgba(230, 230, 230, 0.5);\n  background: #ffffff;\n  padding: 0.75rem 1.25rem 1rem;\n  border-radius: 0 0 6px 6px;\n  margin-top: auto;\n}\n.dispute .attachments {\n  height: 4rem;\n  width: 5.5rem;\n  position: relative;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.dispute .attachments:after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(33, 33, 33, 0.7);\n}\n.dispute .attachments img {\n  width: 100%;\n  height: 100%;\n}\n.dispute .attachments > span {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  color: #ffffff;\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dispute .past-comments {\n  border: solid 1px #e6e6e6;\n  border-radius: 6px;\n  padding: 1rem;\n}\n.dispute .past-comments .blocks {\n  overflow-x: hidden;\n  overflow-y: auto;\n  height: 25rem;\n}\n.dispute .past-comments .blocks::-webkit-scrollbar {\n  width: 0.25rem;\n}\n.dispute .past-comments .blocks::-webkit-scrollbar-track {\n  box-shadow: none;\n  border-radius: 0;\n  background: none;\n}\n.dispute .past-comments .blocks::-webkit-scrollbar-thumb {\n  background: #e6e6e6;\n  border-radius: 10px;\n}\n.dispute .past-comments .blocks .block {\n  background: rgba(234, 237, 239, 0.7);\n  border-radius: 8px;\n  padding: 10px 14px;\n}\n.dispute .past-comments .blocks .block:not(:first-child) {\n  margin-top: 0.5rem;\n}\n.dispute .past-comments .blocks .block p {\n  color: #767676;\n  margin-bottom: 0.5rem;\n}\n.dispute .past-comments .blocks .block > span {\n  display: block;\n  font-size: 11px;\n  line-height: 15px;\n  font-weight: 400;\n  color: #535bd6;\n  text-align: right;\n}\n.dispute .past-comments .blocks .block2 {\n  background: rgba(17, 136, 221, 0.7);\n  border-radius: 8px;\n  padding: 10px 14px;\n}\n.dispute .past-comments .blocks .block2:not(:first-child) {\n  margin-top: 0.5rem;\n}\n.dispute .past-comments .blocks .block2 p {\n  color: #212121;\n  margin-bottom: 0.5rem;\n}\n.dispute .past-comments .blocks .block2 > span {\n  display: block;\n  font-size: 11px;\n  line-height: 15px;\n  font-weight: 400;\n  color: #535bd6;\n  text-align: right;\n}\n.dispute .chatbot {\n  border: solid 1px #e6e6e6;\n  border-radius: 6px;\n}\n.dispute .chatbot__header {\n  border-bottom: solid 1px #e6e6e6;\n  border-radius: 6px 6px 0 0;\n  padding: 0.75rem 0.875rem;\n  background: #f5f6fd;\n}\n.dispute .chatbot__body {\n  padding: 0.75rem 1rem 1rem;\n  padding-right: 0;\n}\n.dispute .chatbot__body .date {\n  display: block;\n  text-align: center;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: 400;\n  color: inherit;\n  margin-bottom: 0.75rem;\n}\n.dispute .chatbot__footer {\n  border-top: solid 1px #e6e6e6;\n  border-radius: 0 0 6px 6px;\n  padding: 0.75rem 0.75rem 0.625rem;\n  display: flex;\n  align-items: center;\n}\n.dispute .chatbot__footer input {\n  flex-grow: 1;\n  padding: 0;\n  margin: 0;\n  margin-right: 1rem;\n  height: 34px;\n  line-height: 34px;\n  color: #212121;\n  background: none;\n  border: none;\n  box-shadow: none;\n  outline: none;\n  width: calc(100% - 50px);\n}\n.dispute .chatbot__footer input::placeholder {\n  color: #767676;\n  opacity: 1;\n}\n.dispute .chatbot__footer button {\n  flex-shrink: 0;\n  background: #e7f5ff;\n  border: none;\n  box-shadow: none;\n  outline: none;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n.dispute .chatbot__footer button:hover {\n  background: rgb(205.5, 234.375, 255);\n}\n.dispute .chatbot .chats {\n  height: 300px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  justify-content: flex-end;\n}\n.dispute .chatbot .chats .inner {\n  display: flex;\n  flex-direction: column;\n  padding-right: 1rem;\n}\n.dispute .chatbot .chats::-webkit-scrollbar {\n  width: 0.25rem;\n}\n.dispute .chatbot .chats::-webkit-scrollbar-track {\n  box-shadow: none;\n  border-radius: 0;\n  background: none;\n}\n.dispute .chatbot .chats::-webkit-scrollbar-thumb {\n  background: #e6e6e6;\n  border-radius: 10px;\n}\n.dispute .chatbot .chat {\n  max-width: 75%;\n}\n.dispute .chatbot .chat:not(:first-child) {\n  margin-top: 0.75rem;\n}\n.dispute .chatbot .chat.user {\n  display: flex;\n  align-items: flex-start;\n  max-width: calc(75% + 30px);\n  margin: 5px 0px;\n}\n.dispute .chatbot .chat.user .avatar {\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  font-size: 16px;\n  line-height: 30px;\n  font-weight: 500;\n  color: rgba(33, 33, 33, 0.5);\n  margin-right: 6px;\n  background: #eaedef;\n  flex-shrink: 0;\n  text-align: center;\n  overflow: hidden;\n  padding: 0 0.25rem;\n}\n.dispute .chatbot .chat.user > div {\n  flex-grow: 1;\n  border: solid 1px rgba(234, 237, 239, 0.7);\n  background: rgba(234, 237, 239, 0.7);\n  border-radius: 0.5rem;\n  padding: 10px 14px;\n  border-radius: 0.5rem;\n}\n.dispute .chatbot .chat.self {\n  border: solid 1px rgba(0, 0, 0, 0.14);\n  background: #ffffff;\n  align-self: flex-end;\n  padding: 10px 14px;\n  border-radius: 0.5rem;\n  margin: 5px 0px;\n}\n.dispute .chatbot .chat p {\n  margin-bottom: 3px;\n}\n.dispute .chatbot .chat .time {\n  display: block;\n  font-size: 11px;\n  line-height: 15px;\n  font-weight: 400;\n  color: #535bd6;\n  text-align: right;\n}\n.dispute .chatbot .user + .user,\n.dispute .chatbot .self + .self {\n  margin-top: 0.375rem;\n  margin: 5px 0px;\n}\n.dispute .tooltip--custom {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: calc(100% + 1rem);\n  min-width: 15rem;\n  max-width: calc(100vw - 2rem);\n  background: #ffffff;\n  border: solid 1px #535bd6;\n  border-radius: 0.25rem;\n  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.07));\n  padding: 0.375rem 0.5rem;\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: 400;\n  color: #212121;\n  text-align: center;\n  z-index: 1;\n}\n.dispute .tooltip--custom::before, .dispute .tooltip--custom:after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n}\n.dispute .tooltip--custom::before {\n  bottom: -0.75rem;\n  border-left: 0.75rem solid transparent;\n  border-right: 0.75rem solid transparent;\n  border-top: 0.75rem solid #535bd6;\n}\n.dispute .tooltip--custom::after {\n  bottom: -0.625rem;\n  border-left: 0.625rem solid transparent;\n  border-right: 0.625rem solid transparent;\n  border-top: 0.625rem solid #ffffff;\n  z-index: 1;\n}\n.dispute .tooltip--custom p {\n  margin: 0;\n}\n.dispute .tooltip--custom p > strong {\n  color: #535bd6;\n  font-weight: 600;\n}\n.dispute .tooltip--custom.warning {\n  border-color: #ffd1d1;\n}\n.dispute .tooltip--custom.warning::before {\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-top-color: #ffd1d1;\n}\n.dispute .tooltip--custom.warning::after {\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-top-color: #ffffff;\n}\n.dispute .tooltip--custom.warning p > strong {\n  color: #d35d5f;\n}\n\n/* Base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.voucher-generator {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  color: #333;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n/* Header styles */\n.header {\n  background-color: #fff;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 64px;\n  padding: 0 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-right: 24px;\n}\n\n.nav-menu {\n  display: none;\n}\n\n.nav-link {\n  color: #666;\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 8px 12px;\n  margin: 0 8px;\n  position: relative;\n}\n\n.nav-link:hover {\n  color: #333;\n}\n\n.nav-link.active {\n  color: #2563eb;\n  border-bottom: 2px solid #2563eb;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n}\n\n.notification-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  margin-right: 12px;\n}\n\n.avatar-container {\n  position: relative;\n}\n\n.avatar-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background-color: #e5e5e5;\n}\n\n/* Main content styles */\n.main-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.page-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.page-subtitle {\n  color: #666;\n}\n\n.export-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n  margin-top: 12px;\n}\n\n.export-btn:hover {\n  background-color: #f5f5f5;\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* Stats cards */\n.stats-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.card {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.card-header {\n  padding: 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.card-title {\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n\n.card-content {\n  padding: 16px;\n}\n\n.card-content.no-padding {\n  padding: 0;\n}\n\n.stat-value {\n  font-size: 1.875rem;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.total-vouchers {\n  color: #2563eb;\n}\n\n.active-vouchers {\n  color: #10b981;\n}\n\n.redeemed-value {\n  color: #8b5cf6;\n}\n\n.stat-label {\n  font-size: 0.875rem;\n  color: #666;\n}\n\n/* Main grid layout */\n.main-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 24px;\n}\n\n/* Form styles */\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background-color: #f9fafb;\n  font-size: 0.875rem;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n.form-hint {\n  font-size: 0.75rem;\n  color: #666;\n  margin-top: 4px;\n}\n\n.generate-btn {\n  width: 100%;\n  padding: 10px;\n  background-color: #2563eb;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.generate-btn:hover {\n  background-color: #1d4ed8;\n}\n\n.generate-btn:disabled {\n  background-color: #93c5fd;\n  cursor: not-allowed;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 16px;\n}\n\n.tab-button {\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.tab-button.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n}\n\n/* Table styles */\n.table-container {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.table th {\n  background-color: #f9fafb;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #4b5563;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.table tr:last-child td {\n  border-bottom: none;\n}\n\n.monospace {\n  font-family: \"Courier New\", Courier, monospace;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.badge-active {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.badge-redeemed {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.badge-expired {\n  background-color: #f3f4f6;\n  color: #4b5563;\n}\n\n/* Empty state */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.empty-icon {\n  width: 48px;\n  height: 48px;\n  color: #d1d5db;\n  margin-bottom: 16px;\n}\n\n.empty-title {\n  font-size: 1.125rem;\n  font-weight: 500;\n  color: #111827;\n  margin-bottom: 4px;\n}\n\n.empty-description {\n  font-size: 0.875rem;\n  color: #6b7280;\n  max-width: 20rem;\n  margin: 0 auto;\n}\n\n/* Action buttons */\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n}\n\n.action-btn:hover {\n  background-color: #f5f5f5;\n}\n\n/* Loading spinner */\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #fff;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* Toast notification */\n.toast-container {\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.toast {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  padding: 16px;\n  min-width: 300px;\n  max-width: 400px;\n  animation: slideIn 0.3s ease-out forwards;\n}\n\n.toast-header {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.toast-body {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n/* Responsive styles */\n@media (min-width: 768px) {\n  .nav-menu {\n    display: flex;\n  }\n  .stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .main-grid {\n    grid-template-columns: 1fr 2fr;\n  }\n  .export-btn {\n    margin-top: 0;\n  }\n}\n.listContainer {\n  max-width: 1800px;\n  min-width: 1600px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.listHeader {\n  margin-bottom: 30px;\n}\n\n.listHeader h1, .listHeader .h1 {\n  font-size: 24px;\n  color: #333;\n  margin: 0 0 10px 0;\n}\n\n.listHeader p {\n  color: #666;\n  margin: 0;\n}\n\n.controlsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 15px;\n}\n\n.searchContainer {\n  flex: 1;\n  min-width: 300px;\n}\n\n.searchInput {\n  width: 100%;\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.filtersContainer {\n  display: flex;\n  gap: 15px;\n}\n\n.filterGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filterGroup label {\n  font-size: 14px;\n  color: #555;\n}\n\n.filterGroup select {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n}\n\n.tableContainer {\n  overflow-x: auto;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.usersTable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.usersTable th,\n.usersTable td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.usersTable th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #333;\n  position: sticky;\n  top: 0;\n}\n\n.sortableHeader {\n  cursor: pointer;\n  user-select: none;\n}\n\n.sortableHeader:hover {\n  background-color: #f1f3f5;\n}\n\n.sortIcon {\n  display: inline-block;\n  margin-left: 5px;\n}\n\n.userRow {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.userRow:hover {\n  background-color: #f8f9fa;\n}\n\n.statusBadge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n  min-width: 80px;\n}\n\n.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.typeLabel {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.individualType {\n  background-color: #e2f0fd;\n  color: #0c63e4;\n}\n\n.businessType {\n  background-color: #e6e6fa;\n  color: #6f42c1;\n}\n\n.viewButton {\n  background-color: #2c6ecf;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.viewButton:hover {\n  background-color: #1e5bb0;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  gap: 15px;\n}\n\n.paginationButton {\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #e9ecef;\n}\n\n.paginationButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pageInfo {\n  font-size: 14px;\n  color: #666;\n}\n\n.resultsInfo {\n  text-align: center;\n  font-size: 14px;\n  color: #666;\n  margin-top: 10px;\n}\n\n.noResults {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .controlsContainer {\n    flex-direction: column;\n  }\n  .searchContainer {\n    min-width: 100%;\n  }\n  .filtersContainer {\n    width: 100%;\n    justify-content: space-between;\n  }\n  .usersTable th:nth-child(3),\n  .usersTable td:nth-child(3) {\n    display: none;\n  }\n}\n@media (max-width: 576px) {\n  .usersTable th:nth-child(4),\n  .usersTable td:nth-child(4) {\n    display: none;\n  }\n}\n.reviewPanel {\n  max-width: 1200px;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.panelHeader {\n  background-color: #f8f9fa;\n  padding: 20px 30px;\n  border-bottom: 1px solid #e9ecef;\n  position: relative;\n}\n\n.headerActions {\n  margin-bottom: 15px;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  color: #2c6ecf;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n.backButton:hover {\n  text-decoration: underline;\n}\n\n.panelHeader h1, .panelHeader .h1 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.submissionMeta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 10px;\n  font-size: 14px;\n  color: #666;\n}\n\n.submissionId {\n  font-weight: 600;\n}\n\n.submissionStatus {\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-weight: 600;\n}\n\n.submissionStatus.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.submissionStatus.approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.submissionStatus.rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.reviewContent {\n  padding: 30px;\n}\n\n.infoSection {\n  margin-bottom: 30px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 20px;\n}\n\n.infoSection h2, .infoSection .h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #333;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n}\n\n.infoGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.infoItem {\n  margin-bottom: 15px;\n}\n\n.infoItem label {\n  display: block;\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 5px;\n}\n\n.infoItem div {\n  font-size: 16px;\n  color: #333;\n  padding: 8px 0;\n  overflow-wrap: break-word;\n}\n\n.documentsSection {\n  margin-bottom: 30px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 20px;\n}\n\n.documentsSection h2, .documentsSection .h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #333;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n}\n\n.documentsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.documentItem {\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.documentItem:hover {\n  transform: translateY(-5px);\n}\n\n.documentThumbnail {\n  height: 150px;\n  overflow: hidden;\n  background-color: #eee;\n}\n\n.documentThumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.documentLabel {\n  padding: 10px;\n  text-align: center;\n  font-size: 14px;\n  background-color: #fff;\n  border-top: 1px solid #eee;\n}\n\n.verificationSection {\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 20px;\n}\n\n.verificationSection h2, .verificationSection .h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #333;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n}\n\n.notesTextarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  resize: vertical;\n}\n\n.actionButtons {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n}\n\n.approveButton,\n.rejectButton,\n.confirmRejectButton,\n.cancelButton {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.approveButton {\n  background-color: #28a745;\n  color: white;\n}\n\n.approveButton:hover {\n  background-color: #218838;\n}\n\n.rejectButton {\n  background-color: #dc3545;\n  color: white;\n}\n\n.rejectButton:hover {\n  background-color: #c82333;\n}\n\n.confirmRejectButton {\n  background-color: #dc3545;\n  color: white;\n}\n\n.confirmRejectButton:hover {\n  background-color: #c82333;\n}\n\n.cancelButton {\n  background-color: #6c757d;\n  color: white;\n}\n\n.cancelButton:hover {\n  background-color: #5a6268;\n}\n\n.statusMessage {\n  padding: 15px;\n  border-radius: 4px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.approvedMessage {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.rejectedMessage {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.documentViewer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.documentViewerContent {\n  background-color: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 900px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.documentViewerHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.documentViewerHeader h3, .documentViewerHeader .h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n}\n\n.documentViewerImage {\n  padding: 20px;\n  overflow: auto;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.documentViewerImage img {\n  max-width: 100%;\n  max-height: 70vh;\n  object-fit: contain;\n}\n\n.rejectionModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.rejectionModalContent {\n  background-color: white;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  padding: 25px;\n}\n\n.rejectionModalContent h3, .rejectionModalContent .h3 {\n  margin-top: 0;\n  color: #333;\n}\n\n.rejectionTextarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin: 15px 0;\n  font-size: 14px;\n  resize: vertical;\n}\n\n.rejectionModalButtons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 18px;\n  color: #666;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .panelHeader {\n    padding: 15px 20px;\n  }\n  .reviewContent {\n    padding: 20px;\n  }\n  .infoGrid {\n    grid-template-columns: 1fr;\n  }\n  .documentsGrid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n  .actionButtons {\n    flex-direction: column;\n  }\n  .approveButton,\n  .rejectButton {\n    width: 100%;\n  }\n}\n/* Admin Panel Styles */\n.admin-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.admin-header h1, .admin-header .h1 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.admin-header p {\n  font-size: 14px;\n  color: #666;\n  margin: 4px 0 0 0;\n}\n\n/* Stats Cards */\n.stats-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.stat-card {\n  background-color: white;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.stat-card h2, .stat-card .h2 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  margin: 0 0 8px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.stat-description {\n  font-size: 14px;\n  color: #666;\n}\n\n/* Content Container */\n.content-container {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 24px;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 16px;\n}\n\n.tabs button {\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  font-size: 14px;\n  color: #666;\n  cursor: pointer;\n  position: relative;\n}\n\n.tabs button.tab-active {\n  color: #4f46e5;\n  font-weight: 500;\n}\n\n.tabs button.tab-active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #4f46e5;\n}\n\n/* Bug List */\n.bug-list-container,\n.bug-detail-container {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.bug-list {\n  max-height: 600px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db #f3f4f6;\n}\n\n.bug-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.bug-list::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 4px;\n}\n\n.bug-list::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 4px;\n}\n\n.bug-list-item {\n  padding: 16px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.bug-list-item:hover {\n  background-color: #f9f9f9;\n}\n\n.bug-list-item.selected {\n  background-color: #f0f7ff;\n  border-left: 3px solid #4f46e5;\n}\n\n.bug-list-item-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.bug-type {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.bug-severity {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.bug-severity.critical {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n\n.bug-severity.high {\n  background-color: #ffedd5;\n  color: #c2410c;\n}\n\n.bug-severity.medium {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.bug-severity.low {\n  background-color: #ecfdf5;\n  color: #047857;\n}\n\n.bug-details-preview {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 12px;\n  line-height: 1.4;\n}\n\n.bug-list-item-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n}\n\n.bug-reporter {\n  display: flex;\n  flex-direction: column;\n}\n\n.username {\n  font-weight: 500;\n  color: #333;\n}\n\n.email {\n  color: #666;\n}\n\n.bug-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #666;\n}\n\n.attachment-indicator {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Bug List Empty State */\n.empty-bug-list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: #666;\n  text-align: center;\n}\n\n.empty-bug-list svg {\n  color: #ccc;\n  margin-bottom: 16px;\n}\n\n.empty-bug-list h3, .empty-bug-list .h3 {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 8px 0;\n}\n\n.empty-bug-list p {\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Bug Detail */\n.bug-detail {\n  padding: 24px;\n}\n\n.bug-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.bug-detail-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.bug-detail-title h2, .bug-detail-title .h2 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.status-badge {\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.status-badge.open {\n  background-color: #fee2e2;\n  color: #b91c1c;\n}\n\n.status-badge.resolved {\n  background-color: #ecfdf5;\n  color: #047857;\n}\n\n.bug-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.status-select {\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.action-button {\n  background-color: #4f46e5;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.action-button:hover {\n  background-color: #4338ca;\n}\n\n.bug-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.bug-detail-section {\n  border-bottom: 1px solid #eee;\n  padding-bottom: 24px;\n}\n\n.bug-detail-section:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.bug-detail-section h3, .bug-detail-section .h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n  color: #333;\n}\n\n.detail-row {\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.detail-label {\n  width: 120px;\n  font-weight: 500;\n  color: #666;\n  font-size: 14px;\n}\n\n.detail-value {\n  font-size: 14px;\n  color: #333;\n}\n\n.severity-indicator {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 6px;\n}\n\n.severity-indicator.critical {\n  background-color: #ef4444;\n}\n\n.severity-indicator.high {\n  background-color: #f59e0b;\n}\n\n.severity-indicator.medium {\n  background-color: #f59e0b;\n}\n\n.severity-indicator.low {\n  background-color: #10b981;\n}\n\n.detail-text {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.attachments-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.attachment-item {\n  border: 1px solid #eee;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.attachment-preview {\n  height: 150px;\n  overflow: hidden;\n}\n\n.attachment-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.attachment-info {\n  padding: 8px;\n}\n\n.attachment-name {\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  word-break: break-all;\n}\n\n.download-link {\n  font-size: 12px;\n  color: #4f46e5;\n  text-decoration: none;\n}\n\n.download-link:hover {\n  text-decoration: underline;\n}\n\n/* Empty State */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: #666;\n  text-align: center;\n  height: 100%;\n}\n\n.empty-state svg {\n  color: #ccc;\n  margin-bottom: 16px;\n}\n\n.empty-state h3, .empty-state .h3 {\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 0 8px 0;\n}\n\n.empty-state p {\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Status Colors */\n.bug-list-item.open {\n  border-left: 3px solid #ef4444;\n}\n\n.bug-list-item.resolved {\n  border-left: 3px solid #10b981;\n}\n\n/* Scrollbar Styles */\n[role=dialog] > div {\n  scrollbar-width: thin;\n  scrollbar-color: #4b5563 #1f2937;\n}\n\n[role=dialog] > div::-webkit-scrollbar {\n  width: 8px;\n}\n\n[role=dialog] > div::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\n\n[role=dialog] > div::-webkit-scrollbar-thumb {\n  background-color: #4b5563;\n  border-radius: 4px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .content-container {\n    grid-template-columns: 1fr;\n  }\n  .bug-list {\n    max-height: 300px;\n  }\n}\n/* Responsive adjustments */\n@media (max-height: 700px) {\n  .stats-container {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n  }\n  .stat-card {\n    padding: 12px;\n  }\n  .stat-value {\n    font-size: 28px;\n  }\n  .content-container {\n    gap: 16px;\n  }\n}\n@media (max-height: 600px) {\n  .admin-container {\n    padding: 16px;\n  }\n  .admin-header {\n    margin-bottom: 16px;\n  }\n  .stats-container {\n    margin-bottom: 16px;\n  }\n}\n.opacity-01 {\n  opacity: 0.01 !important;\n}\n\n.opacity-02 {\n  opacity: 0.02 !important;\n}\n\n.opacity-03 {\n  opacity: 0.03 !important;\n}\n\n.opacity-04 {\n  opacity: 0.04 !important;\n}\n\n.opacity-05 {\n  opacity: 0.05 !important;\n}\n\n.opacity-06 {\n  opacity: 0.06 !important;\n}\n\n.opacity-07 {\n  opacity: 0.07 !important;\n}\n\n.opacity-08 {\n  opacity: 0.08 !important;\n}\n\n.opacity-09 {\n  opacity: 0.09 !important;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-9 {\n  opacity: 0.9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.filter-grayscale-5 {\n  filter: grayscale(5%) !important;\n}\n\n.filter-grayscale-10 {\n  filter: grayscale(10%) !important;\n}\n\n.filter-grayscale-20 {\n  filter: grayscale(20%) !important;\n}\n\n.filter-grayscale-30 {\n  filter: grayscale(30%) !important;\n}\n\n.filter-grayscale-40 {\n  filter: grayscale(40%) !important;\n}\n\n.filter-grayscale-50 {\n  filter: grayscale(50%) !important;\n}\n\n.filter-grayscale-80 {\n  filter: grayscale(80%) !important;\n}\n\n.filter-grayscale-100 {\n  filter: grayscale(100%) !important;\n}\n\n.br-tl {\n  border-top-left-radius: 0.25rem !important;\n}\n\n.br-tr {\n  border-top-right-radius: 0.25rem !important;\n}\n\n.br-bl {\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.br-br {\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.b-radius-0 {\n  border-radius: 0 !important;\n}\n\n.rm-border {\n  border-width: 0 !important;\n}\n\n.br-a {\n  border-radius: 0.25rem;\n}\n\n.margin-h-center {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.center-svg {\n  margin: 0 auto;\n}\n.center-svg svg {\n  margin: 0 auto;\n}\n\n.apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-donut {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.alert-dismissible .close {\n  top: 0;\n  right: 5px;\n  padding: 5px;\n}\n\n.icon-gradient {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n}\n\n.font-size-xlg {\n  font-size: 1.3rem !important;\n}\n\n.font-size-md {\n  font-size: 0.9rem !important;\n}\n\n.font-size-lg {\n  font-size: 1.1rem !important;\n}\n\n.no-shadow {\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.h-100 {\n  height: 100vh !important;\n}\n\n.he-auto {\n  height: auto !important;\n}\n\n.he-100 {\n  height: 100%;\n}\n\n.h-sm {\n  height: 150px;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n.fsize-1 {\n  font-size: 0.95rem !important;\n}\n\n.fsize-2 {\n  font-size: 1.3rem !important;\n}\n\n.fsize-3 {\n  font-size: 1.6rem !important;\n}\n\n.fsize-4 {\n  font-size: 2rem !important;\n}\n\n.z-index-6 {\n  z-index: 6;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n.center-elem {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.flex2 {\n  flex: 2;\n}\n\n.divider {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  height: 1px;\n  overflow: hidden;\n  background: #e9ecef;\n}\n\n.list-group-item:hover {\n  z-index: initial;\n}\n\n.no-results {\n  padding: 1.5rem;\n  text-align: center;\n}\n.no-results .results-title {\n  color: #495057;\n  font-size: 1.1rem;\n}\n.no-results .results-subtitle {\n  color: #adb5bd;\n  font-size: 1.1rem;\n}\n\n.bg-animation {\n  animation: bg-pan-left 8s both;\n}\n\n@-webkit-keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n.w-100 {\n  width: 100%;\n}\n\n.mb--2 {\n  margin-bottom: -1.5rem;\n}\n\n.mbg-3 {\n  margin-bottom: 1.5rem;\n}\n\n.loader-container {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  width: 100vw;\n  text-align: center;\n  line-height: 1.6rem;\n}\n.loader-container .loader-container-inner {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0 1.5rem;\n}\n.loader-container small, .loader-container .small {\n  margin: 10px 0 0;\n  display: block;\n  color: #6c757d;\n  font-weight: normal;\n}\n.loader-container h3, .loader-container .h3 {\n  text-align: center;\n  display: block;\n}\n\n.btn-info, .btn-success {\n  color: #fff !important;\n}\n\n.bg-warning {\n  color: #212529;\n}\n\n.list-group-item {\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.btn-link, a {\n  text-decoration: none !important;\n}\n\n.bg-light {\n  color: #212529;\n}\n\n.table {\n  --bs-table-accent-bg: none;\n}\n\n.form-check-input-custom {\n  width: 1rem;\n  height: 1rem;\n}\n\n.bg-warm-flame {\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\n}\n\n.bg-night-fade {\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\n}\n\n.bg-sunny-morning {\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\n}\n\n.bg-tempting-azure {\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\n}\n\n.bg-amy-crisp {\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\n}\n\n.bg-heavy-rain {\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\n}\n\n.bg-mean-fruit {\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\n}\n\n.bg-malibu-beach {\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\n}\n\n.bg-deep-blue {\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\n}\n\n.bg-ripe-malin {\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\n}\n\n.bg-arielle-smile {\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\n}\n\n.bg-plum-plate {\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n.bg-happy-fisher {\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\n}\n\n.bg-happy-itmeo {\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\n}\n\n.bg-mixed-hopes {\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\n}\n\n.bg-strong-bliss {\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\n}\n\n.bg-grow-early {\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\n}\n\n.bg-love-kiss {\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\n}\n\n.bg-premium-dark {\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\n}\n\n.bg-happy-green {\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\n}\n\n.bg-vicious-stance {\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\n}\n\n.bg-midnight-bloom {\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\n}\n\n.bg-night-sky {\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\n}\n\n.bg-slick-carbon {\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;\n  background-blend-mode: multiply;\n}\n\n.bg-royal {\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\n}\n\n.bg-asteroid {\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\n}\n\n.bg-transparent {\n  background: transparent !important;\n}\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\nbody {\n  -webkit-backface-visibility: hidden;\n}\n\n.animated, .TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s);\n  animation-duration: calc(1s);\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n.animated.infinite, .infinite.TabsAnimation-appear {\n  animation-iteration-count: infinite;\n}\n.animated.hinge, .hinge.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 2);\n  animation-duration: calc(1s * 2);\n}\n.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 0.75);\n  animation-duration: calc(1s * 0.75);\n}\n.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 0.75);\n  animation-duration: calc(1s * 0.75);\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.fadeInUp, .TabsAnimation-appear {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: translateX(-20%) skewX(30deg);\n    opacity: 1;\n  }\n  80% {\n    -webkit-transform: translateX(0%) skewX(-15deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n}\n@keyframes lightSpeedIn {\n  0% {\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    transform: translateX(-20%) skewX(30deg);\n    opacity: 1;\n  }\n  80% {\n    transform: translateX(0%) skewX(-15deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n}\n.lightSpeedIn {\n  -webkit-animation-name: lightSpeedIn;\n  animation-name: lightSpeedIn;\n  -webkit-animation-timing-function: ease-out;\n  animation-timing-function: ease-out;\n}\n\n@-webkit-keyframes lightSpeedOut {\n  0% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n}\n@keyframes lightSpeedOut {\n  0% {\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n}\n.lightSpeedOut {\n  -webkit-animation-name: lightSpeedOut;\n  animation-name: lightSpeedOut;\n  -webkit-animation-timing-function: ease-in;\n  animation-timing-function: ease-in;\n}\n\n.dropdown-menu.show {\n  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n.popover.show {\n  display: block;\n  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n.dropdown-menu[data-placement^=top].show {\n  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n  bottom: auto !important;\n  top: auto !important;\n}\n\n@keyframes fade-in2 {\n  0% {\n    margin-top: -50px;\n    visibility: hidden;\n    opacity: 0;\n  }\n  100% {\n    margin-top: 0px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n.form-control {\n  transition: all 0.2s;\n}\n\n.btn-outline-2x {\n  border-width: 2px;\n}\n\n.btn-group .btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n.btn-group .btn-outline-2x + .btn-outline-2x {\n  margin-left: -2px;\n}\n.btn-group .btn-square {\n  border-radius: 0;\n}\n\n.btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n.btn.btn-pill.btn-wide, .btn.btn-pill {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.btn-dashed {\n  border-style: dashed;\n}\n\n.btn-icon {\n  vertical-align: bottom;\n}\n.btn-icon.btn-icon-right .btn-icon-wrapper {\n  margin-left: 0.5rem;\n  margin-right: 0;\n}\n.btn-icon .btn-icon-wrapper {\n  margin-right: 0.5rem;\n  margin-left: 0;\n  margin-top: 0;\n  font-size: 17px;\n  vertical-align: middle;\n  transition: color 0.1s;\n  display: inline-block;\n}\n.btn-icon.btn-link {\n  text-decoration: none;\n}\n.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 25px;\n}\n.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 16px;\n}\n\n.btn-icon-only .btn-icon-wrapper {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.btn-hover-shine {\n  position: relative;\n}\n.btn-hover-shine:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.4);\n  -webkit-transition: none;\n  -moz-transition: none;\n  transition: none;\n}\n.btn-hover-shine:hover:after {\n  width: 120%;\n  background-color: rgba(255, 255, 255, 0);\n  transition: all 0.4s ease-in-out;\n}\n.btn-hover-shine.btn-pill::after {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.btn-icon-vertical {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.btn-icon-vertical .btn-icon-wrapper {\n  display: block;\n  font-size: 200%;\n  margin: 5px 0;\n  opacity: 0.6;\n}\n.btn-icon-vertical.btn-link {\n  text-decoration: none;\n}\n.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 25px;\n}\n.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 16px;\n}\n.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {\n  opacity: 1;\n}\n.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {\n  margin: 0.2rem 0 5px;\n}\n.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {\n  transition: all 0.2s !important;\n}\n.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {\n  transform: scale(1.3);\n}\n.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {\n  color: #fff !important;\n}\n\n.btn-icon-lg {\n  font-size: 2.2rem !important;\n}\n\n.btn-transition {\n  color: #6c757d;\n  border-color: #e9ecef;\n  background-color: none;\n}\n.btn-transition.btn-outline-link {\n  border-color: transparent;\n  background-color: transparent;\n}\n.btn-transition.btn-outline-link:hover {\n  color: #545cd8;\n  background: #f8f9fa;\n}\n.btn-transition.disabled, .btn-transition:disabled {\n  color: #6c757d;\n  border-color: #e9ecef;\n}\n.btn-transition:hover .btn-icon-wrapper {\n  transition: none;\n}\n\n.btn-transition-alt:hover .icon-gradient {\n  -webkit-background-clip: initial;\n  -webkit-text-fill-color: initial;\n  background-clip: initial;\n  text-fill-color: initial;\n  background: none !important;\n  color: #fff;\n}\n\n.btn-square {\n  border-radius: 0 !important;\n}\n\n.active-btn {\n  border: 1px solid rgb(212, 212, 212);\n  border-radius: 1rem;\n  padding: 1em;\n  background-color: rgb(241, 241, 241);\n  box-shadow: 1px solid black;\n}\n\n.inactive-btn {\n  border: 1px solid rgb(212, 212, 212);\n  border-radius: 1rem;\n  padding: 1em;\n  background-color: inherit;\n  box-shadow: 1px solid black;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner {\n  width: 20px;\n  height: 20px;\n  background-color: none;\n  animation: spin 1s linear infinite;\n}\n\n.btn.btn-wide {\n  padding: 0.375rem 1.5rem;\n  font-size: 0.8rem;\n  border-radius: 0.25rem;\n}\n\n.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {\n  padding: 0.5rem 2rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n\n.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {\n  padding: 0.25rem 1rem;\n  font-size: 0.8rem;\n  border-radius: 0.2rem;\n}\n\n.dropdown-toggle::after {\n  position: relative;\n  top: 2px;\n  opacity: 0.8;\n}\n\n.dropright .dropdown-toggle::after {\n  top: 0;\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, 0.1) solid 1px;\n}\n\n.btn-gradient-primary {\n  background-image: linear-gradient(140deg, rgb(41.5071428571, 50.0214285714, 181.9928571429) -30%, #545cd8 90%);\n  background-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));\n}\n.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(38.6657142857, 46.5971428571, 169.5342857143) 0%, rgb(71.5414285714, 80.1242857143, 213.1585714286) 100%);\n  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));\n  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);\n}\n.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {\n  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143)) !important;\n  border-color: rgb(36.7714285714, 44.3142857143, 161.2285714286) !important;\n}\n.btn-gradient-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-gradient-primary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n\n.btn-gradient-secondary {\n  background-image: linear-gradient(140deg, rgb(72.5407725322, 78.5858369099, 83.9592274678) -30%, #6c757d 90%);\n  background-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);\n  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);\n  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));\n}\n.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(65.4489270386, 70.9030042918, 75.7510729614) 0%, rgb(100.9081545064, 109.317167382, 116.7918454936) 100%);\n  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));\n  border-color: rgb(48.9012875536, 52.9763948498, 56.5987124464);\n}\n.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {\n  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464)) !important;\n  border-color: rgb(60.7210300429, 65.7811158798, 70.2789699571) !important;\n}\n.btn-gradient-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-gradient-secondary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n\n.btn-gradient-success {\n  background-image: linear-gradient(140deg, rgb(40.531496063, 136.968503937, 87.3523622047) -30%, #3ac47d 90%);\n  background-color: rgb(40.531496063, 136.968503937, 87.3523622047);\n  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);\n  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));\n}\n.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(37.0377952756, 125.1622047244, 79.8228346457) 0%, rgb(54.5062992126, 184.1937007874, 117.4704724409) 100%);\n  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));\n  border-color: rgb(28.8858267717, 97.6141732283, 62.2539370079);\n}\n.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {\n  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079)) !important;\n  border-color: rgb(34.7086614173, 117.2913385827, 74.8031496063) !important;\n}\n.btn-gradient-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-gradient-success.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n\n.btn-gradient-info {\n  background-image: linear-gradient(140deg, rgb(0, 141.152173913, 226.5) -30%, #30b1ff 90%);\n  background-color: rgb(0, 141.152173913, 226.5);\n  border-color: rgb(0, 141.152173913, 226.5);\n  color: color-yiq(rgb(0, 109.3695652174, 175.5));\n}\n.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(0, 131.6173913043, 211.2) 0%, rgb(32.7, 171.2347826087, 255) 100%);\n  color: color-yiq(rgb(0, 109.3695652174, 175.5));\n  border-color: rgb(0, 109.3695652174, 175.5);\n}\n.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {\n  color: color-yiq(rgb(0, 109.3695652174, 175.5)) !important;\n  border-color: rgb(0, 125.2608695652, 201) !important;\n}\n.btn-gradient-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-gradient-info.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n\n.btn-gradient-warning {\n  background-image: linear-gradient(140deg, rgb(199.2224669604, 142.8215859031, 7.2775330396) -30%, #f7b924 90%);\n  background-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);\n  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);\n  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));\n}\n.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(184.4616740088, 132.2396475771, 6.7383259912) 0%, rgb(246.4607929515, 180.281938326, 21.2392070485) 100%);\n  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));\n  border-color: rgb(150.0198237885, 107.5484581498, 5.4801762115);\n}\n.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {\n  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115)) !important;\n  border-color: rgb(174.6211453744, 125.1850220264, 6.3788546256) !important;\n}\n.btn-gradient-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-gradient-warning.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n\n.btn-gradient-danger {\n  background-image: linear-gradient(140deg, rgb(151.6437007874, 25.8562992126, 55.905511811) -30%, #d92550 90%);\n  background-color: rgb(151.6437007874, 25.8562992126, 55.905511811);\n  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);\n  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));\n}\n.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(138.5724409449, 23.6275590551, 51.0866141732) 0%, rgb(203.9287401575, 34.7712598425, 75.1811023622) 100%);\n  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));\n  border-color: rgb(108.0728346457, 18.4271653543, 39.842519685);\n}\n.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {\n  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685)) !important;\n  border-color: rgb(129.8582677165, 22.1417322835, 47.874015748) !important;\n}\n.btn-gradient-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-gradient-danger.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n\n.btn-gradient-focus {\n  background-image: linear-gradient(140deg, rgb(32.8513513514, 30.9189189189, 40.5810810811) -30%, #444054 90%);\n  background-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);\n  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);\n  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));\n}\n.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(25.8216216216, 24.3027027027, 31.8972972973) 0%, rgb(60.9702702703, 57.3837837838, 75.3162162162) 100%);\n  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));\n  border-color: rgb(9.4189189189, 8.8648648649, 11.6351351351);\n}\n.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {\n  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351)) !important;\n  border-color: rgb(21.1351351351, 19.8918918919, 26.1081081081) !important;\n}\n.btn-gradient-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-gradient-focus.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n\n.btn-gradient-alternate {\n  background-image: linear-gradient(140deg, rgb(86.657079646, 58.2123893805, 91.2876106195) -30%, #83588a 90%);\n  background-color: rgb(86.657079646, 58.2123893805, 91.2876106195);\n  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);\n  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));\n}\n.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(77.7884955752, 52.2548672566, 81.9451327434) 0%, rgb(122.1314159292, 82.0424778761, 128.6575221239) 100%);\n  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));\n  border-color: rgb(57.0951327434, 38.3539823009, 60.1460176991);\n}\n.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {\n  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991)) !important;\n  border-color: rgb(71.8761061947, 48.2831858407, 75.7168141593) !important;\n}\n.btn-gradient-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-gradient-alternate.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n\n.btn-gradient-light {\n  background-image: linear-gradient(140deg, rgb(199.75, 199.75, 199.75) -30%, #eeeeee 90%);\n  background-color: rgb(199.75, 199.75, 199.75);\n  border-color: rgb(199.75, 199.75, 199.75);\n  color: color-yiq(rgb(174.25, 174.25, 174.25));\n}\n.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(192.1, 192.1, 192.1) 0%, rgb(230.35, 230.35, 230.35) 100%);\n  color: color-yiq(rgb(174.25, 174.25, 174.25));\n  border-color: rgb(174.25, 174.25, 174.25);\n}\n.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {\n  color: color-yiq(rgb(174.25, 174.25, 174.25)) !important;\n  border-color: #bbbbbb !important;\n}\n.btn-gradient-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-gradient-light.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n\n.btn-gradient-dark {\n  background-image: linear-gradient(140deg, rgb(17.7068965517, 19.75, 21.7931034483) -30%, #343a40 90%);\n  background-color: rgb(17.7068965517, 19.75, 21.7931034483);\n  border-color: rgb(17.7068965517, 19.75, 21.7931034483);\n  color: color-yiq(black);\n}\n.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(10.8482758621, 12.1, 13.3517241379) 0%, rgb(45.1413793103, 50.35, 55.5586206897) 100%);\n  color: color-yiq(black);\n  border-color: black;\n}\n.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {\n  color: color-yiq(black) !important;\n  border-color: rgb(6.275862069, 7, 7.724137931) !important;\n}\n.btn-gradient-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-gradient-dark.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n\n.btn-shadow.active {\n  box-shadow: 0 0 0 0 transparent !important;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n}\n.btn-check:focus + .btn-primary, .btn-primary:focus {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(67.2, 73.6, 172.8);\n  border-color: #3f45a2;\n}\n.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-primary:disabled, .btn-primary.disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-primary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n}\n.btn-check:focus + .btn-secondary, .btn-secondary:focus {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(86.4, 93.6, 100);\n  border-color: rgb(81, 87.75, 93.75);\n}\n.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-secondary:disabled, .btn-secondary.disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-secondary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n\n.btn-success {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:hover {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:focus + .btn-success, .btn-success:focus {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {\n  color: #000;\n  background-color: rgb(97.4, 207.8, 151);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-success:disabled, .btn-success.disabled {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-success.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n\n.btn-info {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:hover {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:focus + .btn-info, .btn-info:focus {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {\n  color: #000;\n  background-color: rgb(89.4, 192.6, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-info:disabled, .btn-info.disabled {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-info.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n\n.btn-warning {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:hover {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:focus + .btn-warning, .btn-warning:focus {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {\n  color: #000;\n  background-color: rgb(248.6, 199, 79.8);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-warning:disabled, .btn-warning.disabled {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-warning.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n}\n.btn-check:focus + .btn-danger, .btn-danger:focus {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(173.6, 29.6, 64);\n  border-color: rgb(162.75, 27.75, 60);\n}\n.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-danger:disabled, .btn-danger.disabled {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-danger.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n\n.btn-light {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:hover {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:focus + .btn-light, .btn-light:focus {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {\n  color: #000;\n  background-color: rgb(241.4, 241.4, 241.4);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-light:disabled, .btn-light.disabled {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-light.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n}\n.btn-check:focus + .btn-dark, .btn-dark:focus {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(41.6, 46.4, 51.2);\n  border-color: rgb(39, 43.5, 48);\n}\n.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-dark:disabled, .btn-dark.disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-dark.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n\n.btn-focus {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:hover {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n}\n.btn-check:focus + .btn-focus, .btn-focus:focus {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(54.4, 51.2, 67.2);\n  border-color: #33303f;\n}\n.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-focus:disabled, .btn-focus.disabled {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-focus.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n\n.btn-alternate {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:hover {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n}\n.btn-check:focus + .btn-alternate, .btn-alternate:focus {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(104.8, 70.4, 110.4);\n  border-color: rgb(98.25, 66, 103.5);\n}\n.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-alternate:disabled, .btn-alternate.disabled {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-alternate.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n\n.btn-shadow-primary:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n\n.btn-shadow-secondary:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-shadow-success:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n\n.btn-shadow-info:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n\n.btn-shadow-warning:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n\n.btn-shadow-danger:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n\n.btn-shadow-light:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n\n.btn-shadow-dark:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-shadow-focus:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n\n.btn-shadow-alternate:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n\n.btn-outline-primary {\n  color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary:disabled, .btn-outline-primary.disabled {\n  color: #545cd8;\n  background-color: transparent;\n}\n.btn-outline-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n.btn-outline-primary.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n.btn-outline-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n.btn-outline-secondary.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);\n}\n\n.btn-outline-success {\n  color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:hover {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success:disabled, .btn-outline-success.disabled {\n  color: #3ac47d;\n  background-color: transparent;\n}\n.btn-outline-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n.btn-outline-success.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);\n}\n\n.btn-outline-info {\n  color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:hover {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info:disabled, .btn-outline-info.disabled {\n  color: #30b1ff;\n  background-color: transparent;\n}\n.btn-outline-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n.btn-outline-info.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);\n}\n\n.btn-outline-warning {\n  color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:hover {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning:disabled, .btn-outline-warning.disabled {\n  color: #f7b924;\n  background-color: transparent;\n}\n.btn-outline-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n.btn-outline-warning.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);\n}\n\n.btn-outline-danger {\n  color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger:disabled, .btn-outline-danger.disabled {\n  color: #d92550;\n  background-color: transparent;\n}\n.btn-outline-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n.btn-outline-danger.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);\n}\n\n.btn-outline-light {\n  color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:hover {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light:disabled, .btn-outline-light.disabled {\n  color: #eeeeee;\n  background-color: transparent;\n}\n.btn-outline-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n.btn-outline-light.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark:disabled, .btn-outline-dark.disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n.btn-outline-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n.btn-outline-dark.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);\n}\n\n.btn-outline-focus {\n  color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:hover {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus:disabled, .btn-outline-focus.disabled {\n  color: #444054;\n  background-color: transparent;\n}\n.btn-outline-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n.btn-outline-focus.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);\n}\n\n.btn-outline-alternate {\n  color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:hover {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {\n  color: #83588a;\n  background-color: transparent;\n}\n.btn-outline-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n.btn-outline-alternate.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);\n}\n\n.btn {\n  position: relative;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn-light {\n  border-color: rgb(219.5, 219.5, 219.5);\n}\n\n.btn-outline-light {\n  color: #8f8f8f;\n}\n\n.dropdown-menu {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  font-size: 0.88rem;\n  margin: 0.125rem;\n}\n.dropdown-menu.dropdown-menu-right {\n  right: 0 !important;\n}\n.dropdown-menu .dropdown-header {\n  text-transform: uppercase;\n  font-size: 0.7333333333rem;\n  color: #545cd8;\n  font-weight: bold;\n}\n.dropdown-menu .dropdown-item {\n  font-size: 0.88rem;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n  z-index: 6;\n  position: relative;\n}\n.dropdown-menu .dropdown-item .dropdown-icon {\n  font-size: 1rem;\n  margin-right: 0.325rem;\n  width: 30px;\n  text-align: center;\n  opacity: 0.3;\n  margin-left: -10px;\n}\n.dropdown-menu .dropdown-item:hover .dropdown-icon {\n  opacity: 0.7;\n}\n.dropdown-menu.dropdown-menu-shadow {\n  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.dropdown-menu-rounded {\n  border-radius: 10px;\n  padding: 0.65rem;\n}\n.dropdown-menu-rounded .dropdown-item {\n  border-radius: 30px;\n}\n.dropdown-menu-rounded .dropdown-divider {\n  margin-left: -0.65rem;\n  margin-right: -0.65rem;\n}\n.dropdown-menu-rounded .dropdown-menu-header {\n  margin-left: -0.65rem;\n  margin-right: -0.65rem;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.dropdown-menu-rounded .menu-header-image,\n.dropdown-menu-rounded .dropdown-menu-header-inner {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.dropdown-menu-hover-link .dropdown-item:hover {\n  background: none;\n  color: #545cd8;\n}\n\n.dropdown-menu-hover-primary .dropdown-item:hover {\n  background: #545cd8;\n  color: #fff;\n}\n\n.dropdown-menu.dropdown-menu-lg {\n  min-width: 22rem;\n}\n.dropdown-menu.dropdown-menu-xl {\n  min-width: 25rem;\n}\n\n.dropdown-menu .dropdown-menu-header,\n.dropdown-menu .menu-header-image,\n.dropdown-menu .dropdown-menu-header-inner {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.dropdown-menu-header {\n  color: #fff;\n  margin-top: -0.65rem;\n  margin-bottom: 0.65rem;\n  position: relative;\n  z-index: 6;\n}\n.dropdown-menu-header .dropdown-menu-header-inner {\n  margin: -1px -1px 0;\n  padding: 1.5rem 0.5rem;\n  position: relative;\n}\n.dropdown-menu-header .menu-header-image {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 8;\n  opacity: 0.25;\n  filter: grayscale(80%);\n  background-size: cover;\n}\n.dropdown-menu-header .menu-header-content {\n  text-align: center;\n  position: relative;\n  z-index: 10;\n}\n.dropdown-menu-header .menu-header-content.text-start {\n  padding-left: 0.5rem;\n}\n.dropdown-menu-header .menu-header-content.btn-pane-right {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  text-align: left;\n}\n.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n  margin: 0 0 0 auto;\n}\n.dropdown-menu-header .menu-header-content .menu-header-btn-pane {\n  margin-top: 10px;\n  margin-bottom: 3px;\n}\n.dropdown-menu-header + .grid-menu {\n  margin-top: -0.65rem;\n}\n\n.menu-header-title {\n  font-weight: 500;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.menu-header-subtitle {\n  font-size: var(--bs-font-sans-serif);\n  margin: 5px 0 0;\n  opacity: 0.8;\n}\n\n.dropdown-menu .grid-menu {\n  margin-bottom: -0.65rem;\n  padding: 1px;\n}\n.dropdown-menu .grid-menu [class*=col-] {\n  padding: 0.65rem;\n}\n.dropdown-menu .grid-menu-xl {\n  margin-bottom: -0.4814814815rem;\n}\n.dropdown-menu .grid-menu-xl [class*=col-] {\n  padding: 0;\n}\n\n.dropdown-toggle::after {\n  position: relative;\n  top: 2px;\n  opacity: 0.8;\n  margin-left: 5px;\n}\n\n.dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-toggle::after {\n  top: 0;\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, 0.1) solid 2px;\n}\n\n.dropdown-menu::before, .dropdown-menu::after {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  left: 5px;\n  top: -5px;\n  transform: rotate(45deg);\n  border-radius: 4px;\n  content: \"\";\n  display: block;\n  z-index: 5;\n}\n.dropdown-menu::before {\n  background: #fff;\n  z-index: 5;\n}\n.dropdown-menu::after {\n  top: -6px;\n  background: rgba(0, 0, 0, 0.15);\n  z-index: 4;\n}\n.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {\n  top: auto;\n  bottom: -5px;\n}\n.dropdown-menu[data-placement=top-start]::after {\n  bottom: -6px;\n}\n.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {\n  left: auto;\n  right: -5px;\n  top: 5px;\n}\n.dropdown-menu[data-placement=left-start]::after {\n  top: 5px;\n  right: -6px;\n}\n.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {\n  right: auto;\n  left: -5px;\n  top: 5px;\n}\n.dropdown-menu[data-placement=right-start]::after {\n  top: 5px;\n  left: -6px;\n}\n.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {\n  left: auto;\n  right: 6px;\n}\n.dropdown-menu.dropdown-menu-right::after {\n  right: 6px;\n}\n.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {\n  display: none;\n}\n\n.dropdown-mega-menu {\n  width: 56rem;\n  padding: 1rem;\n}\n.dropdown-mega-menu .nav-item.nav-item-header {\n  text-transform: none;\n  font-size: 0.88rem;\n  padding-top: 0;\n  font-weight: normal;\n}\n.dropdown-mega-menu .grid-menu {\n  margin-bottom: 0;\n}\n\n.dropdown-mega-menu-sm {\n  width: 40rem;\n}\n\nbody .dropdown-menu.dropdown-menu-inline {\n  border: 0;\n  position: static !important;\n  box-shadow: 0 0 0 transparent;\n  background: transparent;\n  border-radius: 0;\n  display: inline-block;\n  float: none;\n  left: 0 !important;\n  top: 0 !important;\n  width: 100% !important;\n  transform: translateY(0) !important;\n}\nbody .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {\n  display: none;\n}\n\n.nav-item .nav-link {\n  font-weight: normal;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n}\n.nav-link .nav-link-icon {\n  color: #545cd8;\n  font-size: 1rem;\n  width: 30px;\n  text-align: center;\n  opacity: 0.45;\n  margin-left: -10px;\n}\n.nav-link:hover {\n  color: #495057;\n}\n.nav-link:hover .nav-link-icon {\n  opacity: 0.9;\n  color: #545cd8;\n}\n.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {\n  opacity: 0.3;\n}\n\n.nav-item.nav-item-header {\n  text-transform: uppercase;\n  font-size: 0.7333333333rem;\n  color: #6c757d;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n}\n.nav-item.nav-item-btn {\n  padding: 0.5rem 1rem;\n}\n.nav-item.nav-item-divider {\n  margin: 0.5rem 0;\n  height: 1px;\n  overflow: hidden;\n  background: #dee2e6;\n}\n\n.nav .badge {\n  margin-left: 8px;\n}\n\n.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {\n  color: #fff;\n}\n.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {\n  color: #fff;\n  opacity: 0.8;\n}\n.nav-pills .nav-link:hover {\n  color: #495057 !important;\n}\n\n.grid-menu [class*=col-] {\n  border-right: #dee2e6 solid 0;\n  border-bottom: #dee2e6 solid 1px;\n}\n.grid-menu [class*=col-]:hover {\n  z-index: 5;\n}\n.grid-menu [class*=col-]:nth-last-child(-n+2) {\n  border-bottom-width: 0;\n}\n.grid-menu [class*=col-]:nth-child(1n) {\n  border-right-width: 1px;\n}\n.grid-menu [class*=col-]:nth-child(2n) {\n  border-right-width: 0;\n}\n.grid-menu [class*=col-]:nth-last-child(-n+1) {\n  border-bottom-width: 0;\n}\n.grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {\n  border-bottom-width: 0;\n}\n.grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {\n  border-right-width: 1px;\n}\n.grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {\n  border-right-width: 0;\n}\n.grid-menu .btn {\n  display: block;\n  border: 0;\n  min-width: 100%;\n}\n\n.badge {\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  min-width: 19px;\n}\n\n.badge-light {\n  background: #fff;\n}\n\n.badge-dot {\n  text-indent: -999em;\n  padding: 0;\n  width: 8px;\n  height: 8px;\n  border: transparent solid 1px;\n  border-radius: 30px;\n  min-width: 2px;\n}\n\n.badge-dot-lg {\n  width: 10px;\n  height: 10px;\n}\n\n.badge-dot-xl {\n  width: 18px;\n  height: 18px;\n  position: relative;\n}\n.badge-dot-xl::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 0.25rem;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -5px 0 0 -5px;\n  background: #fff;\n}\n\n.badge-dot-sm {\n  width: 6px;\n  height: 6px;\n}\n\n.btn .badge {\n  margin-left: 8px;\n}\n.btn .badge-dot {\n  position: absolute;\n  border: #fff solid 2px;\n  top: -5px;\n  right: -5px;\n  width: 11px;\n  height: 11px;\n}\n.btn .badge-dot.badge-dot-lg {\n  width: 14px;\n  height: 14px;\n}\n.btn .badge-dot.badge-dot-sm {\n  width: 8px;\n  height: 8px;\n  border-width: 1px;\n}\n.btn .badge-dot-inside {\n  top: 10px;\n  right: 10px;\n}\n\n.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {\n  top: 1px;\n  right: 4px;\n}\n.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {\n  top: 0px;\n  right: 2px;\n}\n.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {\n  top: -3px;\n  right: -2px;\n}\n.btn-sm .rounded-pill, .btn-group-sm > .btn .rounded-pill {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n}\n\n.badge-abs {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n}\n\n.avatar-icon-wrapper {\n  display: inline-block;\n  margin-right: 0.1rem;\n  position: relative;\n}\n.avatar-icon-wrapper .badge {\n  position: absolute;\n  right: -2px;\n  top: -2px;\n}\n.avatar-icon-wrapper .badge:empty {\n  display: block;\n}\n.avatar-icon-wrapper .badge.badge-bottom {\n  top: auto;\n  right: -2px;\n  bottom: -2px;\n}\n.avatar-icon-wrapper .badge-dot {\n  width: 10px;\n  height: 10px;\n  border: #fff solid 2px;\n}\n.avatar-icon-wrapper .badge-dot.badge-dot-lg {\n  width: 14px;\n  height: 14px;\n  border: #fff solid 2px;\n  top: 0;\n  right: 0;\n}\n.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {\n  top: auto;\n  right: 0;\n  bottom: 0;\n}\n\n.avatar-icon-add .avatar-icon {\n  background: #e0f3ff;\n  border: rgb(146.2928571429, 151.3785714286, 230.2071428571) dashed 1px;\n  color: #545cd8;\n  text-align: center;\n  opacity: 0.6;\n}\n.avatar-icon-add .avatar-icon i {\n  font-style: normal;\n  vertical-align: middle;\n  font-size: 1.32rem;\n  display: block;\n  height: 100%;\n}\n.avatar-icon-add:hover {\n  cursor: pointer;\n}\n.avatar-icon-add:hover .avatar-icon {\n  opacity: 1;\n}\n\na.avatar-icon-wrapper:hover .avatar-icon {\n  opacity: 0.8;\n}\n\n.avatar-icon {\n  display: block;\n  width: 44px;\n  height: 44px;\n  transition: all 0.2s;\n  opacity: 1;\n  border-radius: 50px;\n}\n.avatar-icon.rounded {\n  border-radius: 0.39rem !important;\n}\n\n.avatar-icon-xl .avatar-icon {\n  width: 64px;\n  height: 64px;\n}\n.avatar-icon-xl.avatar-icon-add i {\n  font-size: 1.76rem;\n}\n\n.avatar-icon-lg .avatar-icon {\n  width: 54px;\n  height: 54px;\n}\n.avatar-icon-lg.avatar-icon-add i {\n  font-size: 1.54rem;\n}\n\n.avatar-icon-sm .avatar-icon {\n  width: 34px;\n  height: 34px;\n}\n.avatar-icon-sm.avatar-icon-add i {\n  font-size: 1.1rem;\n}\n\n.avatar-icon-xs .avatar-icon {\n  width: 26px;\n  height: 26px;\n  transition: transform 0.2s;\n}\n.avatar-icon-xs.avatar-icon-add i {\n  line-height: 26px;\n  font-size: 0.88rem;\n}\n.avatar-icon-xs:hover .avatar-icon {\n  transform: scale(2);\n}\n\n.avatar-icon {\n  border: #fff solid 3px;\n  overflow: hidden;\n}\n.avatar-icon img {\n  width: 100%;\n  height: 100%;\n}\n\n.avatar-wrapper-overlap .avatar-icon-wrapper {\n  z-index: 5;\n  margin-left: -18px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper:hover {\n  z-index: 7;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {\n  margin-left: -30px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {\n  margin-left: -24px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {\n  margin-left: -14px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {\n  margin-left: -10px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {\n  margin-left: 0 !important;\n}\n\n@-webkit-keyframes sploosh {\n  0% {\n    box-shadow: 0 0 0 0px rgba(51, 51, 51, 0.2);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(51, 51, 51, 0);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  16.5% {\n    -webkit-transform: scale(1.2);\n  }\n  33% {\n    -webkit-transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n.badge-pulse {\n  -webkit-animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  position: relative;\n}\n.badge-pulse::before, .badge-pulse::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n  -webkit-animation-iteration-count: infinite;\n}\n.badge-pulse::after {\n  -webkit-animation-delay: 0.33s;\n  -webkit-animation-duration: 2.2s;\n}\n\n.card {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  border-width: 0;\n  transition: all 0.2s;\n}\n.card > .dropdown-menu-header {\n  margin: 0;\n}\n.card > .dropdown-menu-header .dropdown-menu-header-inner {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.card.text-dark.text-white .card-footer,\n.card.text-dark.text-white .card-header, .card.text-white .card-footer,\n.card.text-white .card-header {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n.card.text-dark.text-white .card-footer,\n.card.text-dark.text-white .card-header {\n  color: rgba(0, 0, 0, 0.9);\n}\n.card .card-footer {\n  display: flex;\n  align-items: center;\n}\n\n.btn-actions-pane-right {\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.btn-actions-pane-left {\n  margin-right: auto;\n}\n\n.actions-icon-btn .btn-icon-only {\n  padding-left: 0;\n  padding-right: 0;\n  color: #495057;\n}\n.actions-icon-btn .btn-icon-only .btn-icon-wrapper {\n  font-size: 1.3rem;\n  width: 30px;\n  text-align: center;\n}\n.actions-icon-btn .btn-icon-only:hover {\n  color: #545cd8;\n}\n\n.card-header,\n.card-title {\n  text-transform: uppercase;\n  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.7);\n  font-weight: bold;\n  font-size: 0.88rem;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom-width: 1px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: 0.5rem;\n  height: 3.5rem;\n}\n.card-header.no-border {\n  border: 0;\n  padding: 0;\n  height: auto;\n}\n.card-header .menu-header-subtitle {\n  display: block;\n}\n.card-header.card-header-tab .nav {\n  width: auto;\n  margin-left: auto;\n}\n.card-header.card-header-tab .card-header-title {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n.card-header .header-icon {\n  font-size: 1.65rem;\n  margin-right: 0.5rem;\n}\n.card-header > .nav {\n  margin-left: -0.5rem;\n  height: 100%;\n  width: 100%;\n}\n.card-header > .nav .nav-item {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.card-header > .nav .nav-link {\n  text-transform: none;\n  width: 100%;\n  display: block;\n  color: #495057;\n}\n.card-header > .nav .nav-link::before {\n  content: \"\";\n  border-radius: 15px;\n  background: #545cd8;\n  transition: all 0.2s;\n  height: 4px;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  opacity: 0;\n}\n.card-header > .nav .nav-link:hover {\n  color: #545cd8;\n}\n.card-header > .nav .nav-link.active {\n  color: #545cd8;\n}\n.card-header > .nav .nav-link.active::before {\n  opacity: 1;\n}\n.card-header.card-header-tab-animation .nav .nav-link::before {\n  transform: scale(0);\n  opacity: 1;\n  width: 90%;\n  left: 5%;\n}\n.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {\n  transform: scale(1);\n}\n\n.card-border {\n  box-shadow: 0 0 0 transparent;\n  border-width: 1px;\n}\n\n.card-hover-shadow:hover {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.card-hover-shadow-2x:hover {\n  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.card-subtitle {\n  margin-bottom: 1rem;\n  font-size: 0.968rem;\n  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.55);\n}\n\n.card-shadow-primary {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);\n}\n\n.card-shadow-secondary {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);\n}\n\n.card-shadow-success {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);\n}\n\n.card-shadow-info {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);\n}\n\n.card-shadow-warning {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);\n}\n\n.card-shadow-danger {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);\n}\n\n.card-shadow-light {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);\n}\n\n.card-shadow-dark {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);\n}\n\n.card-shadow-focus {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);\n}\n\n.card-shadow-alternate {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);\n}\n\n.card-header-lg {\n  padding: 2rem 2rem;\n  height: auto;\n}\n\n.sticky-active-class .sticky-inner-wrapper > div {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.nav-pills,\n.nav-tabs {\n  margin-bottom: 1rem;\n}\n\n.nav-link {\n  font-weight: bold;\n}\n.nav-link:hover {\n  cursor: pointer;\n}\n\n.nav-tabs .nav-link:hover {\n  color: #545cd8 !important;\n}\n.nav-tabs .nav-link.active {\n  color: #545cd8;\n}\n\n.nav-pills .nav-link:hover {\n  color: #545cd8 !important;\n}\n.nav-pills .nav-link.active {\n  background: #545cd8;\n}\n.nav-pills .nav-link.active:hover {\n  color: #fff !important;\n}\n\n.RRT__container {\n  position: relative;\n}\n\n.RRT__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.RRT__accordion {\n  flex-direction: column;\n}\n\n.RRT__tab {\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  padding: 0.5rem 1rem;\n  transition: all 0.2s;\n}\n.RRT__tab:hover {\n  color: #545cd8;\n}\n.RRT__tab:focus {\n  outline: 0;\n}\n\n.RRT__tab--selected {\n  color: #545cd8;\n}\n\n.RRT__tab--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RRT__tab:focus {\n  z-index: 2;\n}\n\n.RRT__tab--selected .RRT__removable {\n  position: relative;\n}\n\n.RRT__tab--selected .RRT__removable-text {\n  margin-right: 10px;\n}\n\n.RRT__tab--selected .RRT__removable-icon {\n  position: absolute;\n  font-size: 18px;\n  right: 0.5em;\n  top: 0.2em;\n}\n\n.body-tabs.body-tabs-layout.body-tabs-big {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  margin: 0 auto;\n  padding: 10px;\n  border-radius: 50px;\n  border: #e9ecef solid 1px;\n  z-index: 7;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 300;\n  padding: 0;\n  height: 50px;\n  line-height: 50px;\n  flex: 1;\n  text-align: center;\n  position: relative;\n  color: #545cd8;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {\n  color: #212529;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {\n  color: #fff;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {\n  color: #fff;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {\n  height: 70px !important;\n  top: -70px !important;\n  margin: 0 auto -3.4rem;\n  position: relative;\n  padding: 0 10px;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {\n  position: absolute;\n  content: \"\";\n  background: #fff;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: -11px;\n  border-radius: 50px;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {\n  height: 50px !important;\n  margin-top: 10px;\n  border-radius: 50px;\n  box-shadow: 0 0 0 transparent;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {\n  margin-top: -1rem;\n}\n\n.RRT__panel {\n  margin-top: 1rem;\n}\n\n.RRT__showmore {\n  border-radius: 0.25rem;\n  background: #545cd8;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  font-weight: bold;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  display: block;\n  margin-left: 15px;\n  position: absolute;\n  right: 1.5rem;\n  top: 50%;\n  margin-top: -18px;\n  font-size: 1.4rem;\n}\n.RRT__showmore:focus {\n  outline: none;\n}\n\n.RRT__showmore-label {\n  position: relative;\n  z-index: 1;\n  color: #fff;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  line-height: 24px;\n}\n\n.RRT__showmore--selected {\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.RRT__showmore-list {\n  position: absolute;\n  right: -1px;\n  top: 100%;\n  display: none;\n  min-width: 15rem;\n  padding: 0.65rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.RRT__showmore-list .RRT__tab {\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n}\n.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {\n  color: rgb(29.7, 33.3, 36.9) !important;\n  text-decoration: none;\n  background: #e0f3ff;\n}\n\n.RRT__showmore-list--opened {\n  display: block;\n}\n.RRT__showmore-list--opened .RRT__tab--selected {\n  color: #545cd8;\n}\n\n.RRT__inkbar-wrapper {\n  width: 100%;\n}\n\n.RRT__inkbar {\n  position: relative;\n  bottom: 0;\n  height: 3px;\n  margin-top: -3px;\n  background-color: #545cd8;\n  border-radius: 15px;\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n  z-index: 2;\n}\n\n.card-tabs .card-header {\n  padding: 0 1.25rem;\n}\n.card-tabs .card-header.RRT__tabs {\n  cursor: pointer;\n  font-weight: normal;\n}\n.card-tabs .card-header.RRT__tabs .RRT__tab {\n  text-transform: none;\n  line-height: 1.3;\n}\n.card-tabs .RRT__inkbar-wrapper {\n  width: calc(100% - 1.5rem) !important;\n  margin-left: 1.25rem;\n}\n.card-tabs .RRT__panel {\n  padding: 1rem;\n  margin: 0;\n}\n.card-tabs.text-white .RRT__tab {\n  color: rgba(255, 255, 255, 0.6);\n}\n.card-tabs.text-white .RRT__tab:hover {\n  color: #fff;\n}\n.card-tabs.text-white .RRT__tab--selected {\n  color: #fff;\n}\n.card-tabs.text-white .RRT__inkbar {\n  background: rgb(250.1142857143, 250.3428571429, 253.8857142857);\n}\n\n.card-tabs-animated .RRT__container > .RRT__tabs {\n  background: transparent;\n  position: relative;\n  z-index: 7;\n}\n.card-tabs-animated .RRT__container > .RRT__tabs.card-header {\n  border-bottom: 0;\n  height: auto;\n  padding: 1.5rem 1.5rem 0.5rem;\n}\n.card-tabs-animated .RRT__inkbar-wrapper {\n  position: absolute;\n  top: 1.5rem;\n  z-index: 5;\n}\n.card-tabs-animated .RRT__tab {\n  padding: 0.5rem 1.2rem;\n}\n.card-tabs-animated .RRT__tab--selected {\n  color: #fff;\n}\n.card-tabs-animated .RRT__inkbar {\n  height: 35px;\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.card-tabs-animated-inner .RRT__tabs {\n  padding: 0 5%;\n}\n.card-tabs-animated-inner .RRT__inkbar-wrapper {\n  left: 5%;\n  width: 90%;\n  height: 36px;\n  top: 14px;\n}\n.card-tabs-animated-inner .RRT__inkbar {\n  height: 36px;\n}\n\n.body-tabs {\n  border-bottom: #dee2e6 solid 2px;\n}\n.body-tabs > .RRT__tab {\n  padding: 1rem 1.25rem;\n  font-weight: normal;\n  font-size: 0.88rem;\n}\n.body-tabs.body-tabs-alt > .RRT__tab {\n  padding: 1.3636363636rem 0.5rem;\n  font-weight: normal;\n  font-size: 0.86rem;\n  width: 33%;\n  text-align: center;\n}\n.body-tabs.body-tabs-alt .RRT__inkbar {\n  height: 2px;\n  margin-top: -2px;\n}\n\n.popover .RRT__panel,\n.dropdown-menu .RRT__panel {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.popover .RRT__panel::after, .popover .RRT__panel::before,\n.dropdown-menu .RRT__panel::after,\n.dropdown-menu .RRT__panel::before {\n  width: 100%;\n  bottom: auto;\n  top: 0;\n  left: 0;\n  height: 20px;\n  position: absolute;\n  z-index: 10;\n  content: \"\";\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\", endColorstr=\"#00ffffff\", GradientType=0);\n}\n.popover .RRT__panel::after,\n.dropdown-menu .RRT__panel::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00ffffff\", endColorstr=\"#ffffff\", GradientType=0);\n}\n\n.tabs-lg-alternate.card-header {\n  padding: 0;\n  height: auto;\n}\n.tabs-lg-alternate.card-header .widget-number {\n  font-size: 1.76rem;\n  font-weight: 300;\n}\n.tabs-lg-alternate.card-header .tab-subheading {\n  padding: 5px 0 0;\n  opacity: 0.6;\n  transition: all 0.2s;\n}\n.tabs-lg-alternate.card-header > .nav {\n  margin: 0;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link {\n  padding: 1.5rem 0;\n  border-right: #e9ecef solid 1px;\n  background: #f8f9fa;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link:hover {\n  background: #fff;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {\n  color: #000;\n  opacity: 0.9;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link::before {\n  background: #fff;\n  border-radius: 0;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link.active {\n  background: #fff;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {\n  color: #000;\n  opacity: 0.9;\n}\n.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {\n  border-right: 0;\n}\n\n.accordion-wrapper {\n  border-radius: 0.25rem;\n  border: #e9ecef solid 1px;\n}\n.accordion-wrapper > .card {\n  box-shadow: 0 0 0 0 transparent;\n}\n.accordion-wrapper > .card > .card-header {\n  padding: 1rem;\n  height: auto;\n}\n.accordion-wrapper > .card > .card-header .btn:active,\n.accordion-wrapper > .card > .card-header .btn:focus,\n.accordion-wrapper > .card > .card-header .btn:hover {\n  text-decoration: none;\n}\n.accordion-wrapper > .card > .card-header .form-heading p {\n  margin: 0;\n}\n.accordion-wrapper > .card .collapse {\n  border-bottom: transparent solid 1px;\n}\n.accordion-wrapper > .card .collapse.show {\n  border-bottom-color: #e9ecef;\n}\n\n.modal-header,\n.modal-footer {\n  background: #f8f9fa;\n}\n\n.modal-footer {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.modal-dialog {\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n  border-radius: 0.25rem;\n}\n\n/**\n * Dots\n */\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ball-pulse > div:nth-child(0) {\n  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(1) {\n  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(2) {\n  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(3) {\n  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY(10px);\n  }\n  66% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.ball-pulse-sync > div:nth-child(0) {\n  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(1) {\n  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(2) {\n  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(3) {\n  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;\n}\n.ball-pulse-sync > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.ball-scale > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  animation: ball-scale 1s 0s ease-in-out infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.ball-rotate {\n  position: relative;\n}\n.ball-rotate > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: relative;\n}\n.ball-rotate > div:first-child {\n  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;\n}\n.ball-rotate > div:before, .ball-rotate > div:after {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  content: \"\";\n  position: absolute;\n  opacity: 0.8;\n}\n.ball-rotate > div:before {\n  top: 0px;\n  left: -28px;\n}\n.ball-rotate > div:after {\n  top: 0px;\n  left: 25px;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n.ball-clip-rotate > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  border: 2px solid #545cd8;\n  border-bottom-color: transparent;\n  height: 25px;\n  width: 25px;\n  background: transparent !important;\n  display: inline-block;\n  animation: rotate 0.75s 0s linear infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n}\n.ball-clip-rotate-pulse > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  border-radius: 100%;\n}\n.ball-clip-rotate-pulse > div:first-child {\n  background: #545cd8;\n  height: 16px;\n  width: 16px;\n  top: 7px;\n  left: -7px;\n  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n.ball-clip-rotate-pulse > div:last-child {\n  position: absolute;\n  border: 2px solid #545cd8;\n  width: 30px;\n  height: 30px;\n  left: -16px;\n  top: -2px;\n  background: transparent;\n  border: 2px solid;\n  border-color: #545cd8 transparent #545cd8 transparent;\n  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n  animation-duration: 1s;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n.ball-clip-rotate-multiple {\n  position: relative;\n}\n.ball-clip-rotate-multiple > div {\n  animation-fill-mode: both;\n  position: absolute;\n  left: -20px;\n  top: -20px;\n  border: 2px solid #545cd8;\n  border-bottom-color: transparent;\n  border-top-color: transparent;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px;\n  animation: rotate 1s 0s ease-in-out infinite;\n}\n.ball-clip-rotate-multiple > div:last-child {\n  display: inline-block;\n  top: -10px;\n  left: -10px;\n  width: 15px;\n  height: 15px;\n  animation-duration: 0.5s;\n  border-color: #545cd8 transparent #545cd8 transparent;\n  animation-direction: reverse;\n}\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ball-scale-ripple > div {\n  animation-fill-mode: both;\n  height: 50px;\n  width: 50px;\n  border-radius: 100%;\n  border: 2px solid #545cd8;\n  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ball-scale-ripple-multiple {\n  position: relative;\n  transform: translateY(-25px);\n}\n.ball-scale-ripple-multiple > div:nth-child(0) {\n  animation-delay: -0.8s;\n}\n.ball-scale-ripple-multiple > div:nth-child(1) {\n  animation-delay: -0.6s;\n}\n.ball-scale-ripple-multiple > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.ball-scale-ripple-multiple > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.ball-scale-ripple-multiple > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: -2px;\n  left: -26px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 2px solid #545cd8;\n  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.ball-beat > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation: ball-beat 0.7s 0s infinite linear;\n}\n.ball-beat > div:nth-child(2n-1) {\n  animation-delay: -0.35s !important;\n}\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.ball-scale-multiple {\n  position: relative;\n  transform: translateY(-30px);\n}\n.ball-scale-multiple > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.ball-scale-multiple > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.ball-scale-multiple > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  left: -30px;\n  top: 0px;\n  opacity: 0;\n  margin: 0;\n  width: 60px;\n  height: 60px;\n  animation: ball-scale-multiple 1s 0s linear infinite;\n}\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate(25px, -50px);\n  }\n  66% {\n    transform: translate(50px, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate(25px, 50px);\n  }\n  66% {\n    transform: translate(-25px, 50px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-50px, 0px);\n  }\n  66% {\n    transform: translate(-25px, -50px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n.ball-triangle-path {\n  position: relative;\n  transform: translate(-29.9940011998px, -37.5093773443px);\n}\n.ball-triangle-path > div:nth-child(1) {\n  animation-name: ball-triangle-path-1;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div:nth-child(2) {\n  animation-name: ball-triangle-path-2;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div:nth-child(3) {\n  animation-name: ball-triangle-path-3;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div {\n  animation-fill-mode: both;\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  border: 1px solid #545cd8;\n}\n.ball-triangle-path > div:nth-of-type(1) {\n  top: 50px;\n}\n.ball-triangle-path > div:nth-of-type(2) {\n  left: 25px;\n}\n.ball-triangle-path > div:nth-of-type(3) {\n  top: 50px;\n  left: 50px;\n}\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-30px);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY(30px);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1);\n  }\n}\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY(30px);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-30px);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n.ball-pulse-rise > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation-duration: 1s;\n  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n.ball-pulse-rise > div:nth-child(2n) {\n  animation-name: ball-pulse-rise-even;\n}\n.ball-pulse-rise > div:nth-child(2n-1) {\n  animation-name: ball-pulse-rise-odd;\n}\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ball-grid-beat {\n  width: 57px;\n}\n.ball-grid-beat > div:nth-child(1) {\n  animation-delay: 0.53s;\n  animation-duration: 0.66s;\n}\n.ball-grid-beat > div:nth-child(2) {\n  animation-delay: 0.69s;\n  animation-duration: 0.91s;\n}\n.ball-grid-beat > div:nth-child(3) {\n  animation-delay: 0.51s;\n  animation-duration: 1.56s;\n}\n.ball-grid-beat > div:nth-child(4) {\n  animation-delay: 0.01s;\n  animation-duration: 0.64s;\n}\n.ball-grid-beat > div:nth-child(5) {\n  animation-delay: 0.59s;\n  animation-duration: 1.54s;\n}\n.ball-grid-beat > div:nth-child(6) {\n  animation-delay: 0.41s;\n  animation-duration: 0.65s;\n}\n.ball-grid-beat > div:nth-child(7) {\n  animation-delay: 0.32s;\n  animation-duration: 1.25s;\n}\n.ball-grid-beat > div:nth-child(8) {\n  animation-delay: -0.15s;\n  animation-duration: 1.37s;\n}\n.ball-grid-beat > div:nth-child(9) {\n  animation-delay: 0.55s;\n  animation-duration: 1.56s;\n}\n.ball-grid-beat > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  float: left;\n  animation-name: ball-grid-beat;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ball-grid-pulse {\n  width: 57px;\n}\n.ball-grid-pulse > div:nth-child(1) {\n  animation-delay: -0.03s;\n  animation-duration: 1.31s;\n}\n.ball-grid-pulse > div:nth-child(2) {\n  animation-delay: 0.66s;\n  animation-duration: 0.93s;\n}\n.ball-grid-pulse > div:nth-child(3) {\n  animation-delay: 0.64s;\n  animation-duration: 1.56s;\n}\n.ball-grid-pulse > div:nth-child(4) {\n  animation-delay: 0.45s;\n  animation-duration: 0.81s;\n}\n.ball-grid-pulse > div:nth-child(5) {\n  animation-delay: 0.57s;\n  animation-duration: 1.55s;\n}\n.ball-grid-pulse > div:nth-child(6) {\n  animation-delay: 0.24s;\n  animation-duration: 1.47s;\n}\n.ball-grid-pulse > div:nth-child(7) {\n  animation-delay: -0.14s;\n  animation-duration: 1.25s;\n}\n.ball-grid-pulse > div:nth-child(8) {\n  animation-delay: 0.54s;\n  animation-duration: 0.84s;\n}\n.ball-grid-pulse > div:nth-child(9) {\n  animation-delay: 0.43s;\n  animation-duration: 1.11s;\n}\n.ball-grid-pulse > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  float: left;\n  animation-name: ball-grid-pulse;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.ball-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -10px;\n}\n.ball-spin-fade-loader > div:nth-child(1) {\n  top: 25px;\n  left: 0;\n  animation: ball-spin-fade-loader 1s -0.96s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(2) {\n  top: 17.0454545455px;\n  left: 17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.84s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(3) {\n  top: 0;\n  left: 25px;\n  animation: ball-spin-fade-loader 1s -0.72s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(4) {\n  top: -17.0454545455px;\n  left: 17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.6s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(5) {\n  top: -25px;\n  left: 0;\n  animation: ball-spin-fade-loader 1s -0.48s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(6) {\n  top: -17.0454545455px;\n  left: -17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.36s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(7) {\n  top: 0;\n  left: -25px;\n  animation: ball-spin-fade-loader 1s -0.24s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(8) {\n  top: 17.0454545455px;\n  left: -17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.12s infinite linear;\n}\n.ball-spin-fade-loader > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n}\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ball-spin-loader {\n  position: relative;\n}\n.ball-spin-loader > span:nth-child(1) {\n  top: 45px;\n  left: 0;\n  animation: ball-spin-loader 2s 0.9s infinite linear;\n}\n.ball-spin-loader > span:nth-child(2) {\n  top: 30.6818181818px;\n  left: 30.6818181818px;\n  animation: ball-spin-loader 2s 1.8s infinite linear;\n}\n.ball-spin-loader > span:nth-child(3) {\n  top: 0;\n  left: 45px;\n  animation: ball-spin-loader 2s 2.7s infinite linear;\n}\n.ball-spin-loader > span:nth-child(4) {\n  top: -30.6818181818px;\n  left: 30.6818181818px;\n  animation: ball-spin-loader 2s 3.6s infinite linear;\n}\n.ball-spin-loader > span:nth-child(5) {\n  top: -45px;\n  left: 0;\n  animation: ball-spin-loader 2s 4.5s infinite linear;\n}\n.ball-spin-loader > span:nth-child(6) {\n  top: -30.6818181818px;\n  left: -30.6818181818px;\n  animation: ball-spin-loader 2s 5.4s infinite linear;\n}\n.ball-spin-loader > span:nth-child(7) {\n  top: 0;\n  left: -45px;\n  animation: ball-spin-loader 2s 6.3s infinite linear;\n}\n.ball-spin-loader > span:nth-child(8) {\n  top: 30.6818181818px;\n  left: -30.6818181818px;\n  animation: ball-spin-loader 2s 7.2s infinite linear;\n}\n.ball-spin-loader > div {\n  animation-fill-mode: both;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  background: green;\n}\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-15px, -30px);\n  }\n  66% {\n    transform: translate(15px, -30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes ball-zag {\n  33% {\n    transform: translate(15px, 30px);\n  }\n  66% {\n    transform: translate(-15px, 30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-15px, -15px);\n}\n.ball-zig-zag > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  margin-left: 15px;\n  top: 4px;\n  left: -7px;\n}\n.ball-zig-zag > div:first-child {\n  animation: ball-zig 0.7s 0s infinite linear;\n}\n.ball-zig-zag > div:last-child {\n  animation: ball-zag 0.7s 0s infinite linear;\n}\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-15px, -30px);\n  }\n  34% {\n    transform: translate(15px, -30px);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(15px, -30px);\n  }\n  84% {\n    transform: translate(-15px, -30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate(15px, 30px);\n  }\n  34% {\n    transform: translate(-15px, 30px);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-15px, 30px);\n  }\n  84% {\n    transform: translate(15px, 30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-15px, -15px);\n}\n.ball-zig-zag-deflect > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  margin-left: 15px;\n  top: 4px;\n  left: -7px;\n}\n.ball-zig-zag-deflect > div:first-child {\n  animation: ball-zig-deflect 1.5s 0s infinite linear;\n}\n.ball-zig-zag-deflect > div:last-child {\n  animation: ball-zag-deflect 1.5s 0s infinite linear;\n}\n\n/**\n * Lines\n */\n@keyframes line-scale {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.line-scale > div:nth-child(1) {\n  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(2) {\n  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(3) {\n  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(4) {\n  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(5) {\n  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.line-scale-party > div:nth-child(1) {\n  animation-delay: 0.48s;\n  animation-duration: 0.38s;\n}\n.line-scale-party > div:nth-child(2) {\n  animation-delay: -0.06s;\n  animation-duration: 0.78s;\n}\n.line-scale-party > div:nth-child(3) {\n  animation-delay: 0.43s;\n  animation-duration: 0.58s;\n}\n.line-scale-party > div:nth-child(4) {\n  animation-delay: 0.12s;\n  animation-duration: 1.01s;\n}\n.line-scale-party > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation-name: line-scale-party;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.line-scale-pulse-out > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);\n}\n.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {\n  animation-delay: -0.4s !important;\n}\n.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {\n  animation-delay: -0.2s !important;\n}\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1);\n  }\n}\n.line-scale-pulse-out-rapid > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  vertical-align: middle;\n  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);\n}\n.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {\n  animation-delay: -0.25s !important;\n}\n.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {\n  animation-delay: 0s !important;\n}\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.line-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -4px;\n}\n.line-spin-fade-loader > div:nth-child(1) {\n  top: 20px;\n  left: 0;\n  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(2) {\n  top: 13.6363636364px;\n  left: 13.6363636364px;\n  transform: rotate(-45deg);\n  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(3) {\n  top: 0;\n  left: 20px;\n  transform: rotate(90deg);\n  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(4) {\n  top: -13.6363636364px;\n  left: 13.6363636364px;\n  transform: rotate(45deg);\n  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(5) {\n  top: -20px;\n  left: 0;\n  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(6) {\n  top: -13.6363636364px;\n  left: -13.6363636364px;\n  transform: rotate(-45deg);\n  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(7) {\n  top: 0;\n  left: -20px;\n  transform: rotate(90deg);\n  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(8) {\n  top: 13.6363636364px;\n  left: -13.6363636364px;\n  transform: rotate(45deg);\n  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;\n}\n.line-spin-fade-loader > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  width: 5px;\n  height: 15px;\n}\n\n/**\n * Misc\n */\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n.triangle-skew-spin > div {\n  animation-fill-mode: both;\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-bottom: 20px solid #545cd8;\n  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n.square-spin > div {\n  animation-fill-mode: both;\n  width: 50px;\n  height: 50px;\n  background: #545cd8;\n  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n\n@keyframes rotate_pacman_half_up {\n  0% {\n    transform: rotate(270deg);\n  }\n  50% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(270deg);\n  }\n}\n@keyframes rotate_pacman_half_down {\n  0% {\n    transform: rotate(90deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(90deg);\n  }\n}\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-100px, -6.25px);\n  }\n}\n.pacman {\n  position: relative;\n}\n.pacman > div:nth-child(2) {\n  animation: pacman-balls 1s -0.99s infinite linear;\n}\n.pacman > div:nth-child(3) {\n  animation: pacman-balls 1s -0.66s infinite linear;\n}\n.pacman > div:nth-child(4) {\n  animation: pacman-balls 1s -0.33s infinite linear;\n}\n.pacman > div:nth-child(5) {\n  animation: pacman-balls 1s 0s infinite linear;\n}\n.pacman > div:first-of-type {\n  width: 0px;\n  height: 0px;\n  border-right: 25px solid transparent;\n  border-top: 25px solid #545cd8;\n  border-left: 25px solid #545cd8;\n  border-bottom: 25px solid #545cd8;\n  border-radius: 25px;\n  animation: rotate_pacman_half_up 0.5s 0s infinite;\n  position: relative;\n  left: -30px;\n}\n.pacman > div:nth-child(2) {\n  width: 0px;\n  height: 0px;\n  border-right: 25px solid transparent;\n  border-top: 25px solid #545cd8;\n  border-left: 25px solid #545cd8;\n  border-bottom: 25px solid #545cd8;\n  border-radius: 25px;\n  animation: rotate_pacman_half_down 0.5s 0s infinite;\n  margin-top: -50px;\n  position: relative;\n  left: -30px;\n}\n.pacman > div:nth-child(3),\n.pacman > div:nth-child(4),\n.pacman > div:nth-child(5),\n.pacman > div:nth-child(6) {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  transform: translate(0, -6.25px);\n  top: 25px;\n  left: 70px;\n}\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX(50px) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate(50px, 50px) rotate(-180deg);\n  }\n  75% {\n    transform: translateY(50px) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n.cube-transition {\n  position: relative;\n  transform: translate(-25px, -25px);\n}\n.cube-transition > div {\n  animation-fill-mode: both;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: -5px;\n  left: -5px;\n  background-color: #545cd8;\n  animation: cube-transition 1.6s 0s infinite ease-in-out;\n}\n.cube-transition > div:last-child {\n  animation-delay: -0.8s;\n}\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.semi-circle-spin {\n  position: relative;\n  width: 35px;\n  height: 35px;\n  overflow: hidden;\n}\n.semi-circle-spin > div {\n  position: absolute;\n  border-width: 0px;\n  border-radius: 100%;\n  animation: spin-rotate 0.6s 0s infinite linear;\n  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);\n  width: 100%;\n  height: 100%;\n}\n\n.progress .progress-bar:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.progress.progress-bar-sm {\n  height: 0.5rem;\n}\n.progress.progress-bar-xs {\n  height: 0.3rem;\n}\n.progress.progress-bar-rounded {\n  border-radius: 30px;\n}\n\n.progress-bar-animated-alt.progress-bar,\n.progress-bar-animated-alt .progress-bar {\n  position: relative;\n}\n.progress-bar-animated-alt.progress-bar::after,\n.progress-bar-animated-alt .progress-bar::after {\n  content: \"\";\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  animation: progress-active 2s ease infinite;\n}\n\n@keyframes progress-active {\n  0% {\n    opacity: 0.4;\n    width: 0;\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n.vertical-timeline {\n  width: 100%;\n  position: relative;\n  padding: 1.5rem 0 1rem;\n}\n.vertical-timeline::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 67px;\n  height: 100%;\n  width: 4px;\n  background: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.vertical-timeline-element {\n  position: relative;\n  margin: 0 0 1rem;\n}\n.vertical-timeline-element:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline-element:last-child {\n  margin-bottom: 0;\n}\n\n.vertical-timeline-element-content {\n  position: relative;\n  margin-left: 90px;\n  font-size: 0.8rem;\n}\n.vertical-timeline-element-content:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline-element-content .timeline-title {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  margin: 0 0 0.5rem;\n  padding: 2px 0 0;\n  font-weight: bold;\n}\n.vertical-timeline-element-content p {\n  color: #6c757d;\n  margin: 0 0 0.5rem;\n}\n.vertical-timeline-element-content .vertical-timeline-element-date {\n  display: block;\n  position: absolute;\n  left: -90px;\n  top: 0;\n  padding-right: 10px;\n  text-align: right;\n  color: #adb5bd;\n  font-size: 0.7619047619rem;\n  white-space: nowrap;\n}\n\n.vertical-timeline-element-icon {\n  position: absolute;\n  top: 0;\n  left: 60px;\n}\n.vertical-timeline-element-icon .badge-dot-xl {\n  box-shadow: 0 0 0 5px #fff;\n}\n\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\n  background: 0 0;\n  box-shadow: none;\n}\n.vertical-timeline-element--no-children .vertical-timeline-element-content::before {\n  display: none;\n}\n\n.vertical-without-time::before {\n  left: 11px;\n}\n.vertical-without-time .vertical-timeline-element-content {\n  margin-left: 36px;\n}\n.vertical-without-time .vertical-timeline-element-icon {\n  left: 4px;\n}\n\n.vertical-time-icons {\n  padding: 2rem 0 0;\n}\n.vertical-time-icons::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 14px;\n  height: 100%;\n  width: 6px;\n  background: #e9ecef;\n  border-radius: 0.25rem;\n}\n.vertical-time-icons .vertical-timeline-element {\n  margin-bottom: 1rem;\n}\n.vertical-time-icons .vertical-timeline-element-content {\n  margin-left: 50px;\n}\n.vertical-time-icons .vertical-timeline-element-icon {\n  width: 34px;\n  height: 34px;\n  left: 0;\n  top: -7px;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {\n  width: 34px;\n  height: 34px;\n  background: #fff;\n  border-radius: 50px;\n  border-width: 2px;\n  border-style: solid;\n  box-shadow: 0 0 0 5px #fff;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {\n  display: block;\n  font-size: 1.1rem;\n  margin: 0 auto;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {\n  margin: 0 auto;\n}\n\n.vertical-time-simple {\n  padding: 0.5rem 0;\n}\n.vertical-time-simple .vertical-timeline-element {\n  margin: 0 0 0.5rem;\n}\n.vertical-time-simple .timeline-title {\n  font-weight: normal;\n  font-size: 0.9166666667rem;\n  padding: 0;\n}\n.vertical-time-simple .vertical-timeline-element-icon {\n  height: 14px;\n  width: 14px;\n  background: #e9ecef;\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  display: block;\n  border-radius: 20px;\n}\n.vertical-time-simple .vertical-timeline-element-icon::after {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  top: 50%;\n  margin: -4px 0 0 -4px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 20px;\n}\n.vertical-time-simple .timeline-title {\n  text-transform: none;\n}\n\n.dot-primary .vertical-timeline-element-icon {\n  background: #545cd8;\n}\n\n.dot-secondary .vertical-timeline-element-icon {\n  background: #6c757d;\n}\n\n.dot-success .vertical-timeline-element-icon {\n  background: #3ac47d;\n}\n\n.dot-info .vertical-timeline-element-icon {\n  background: #30b1ff;\n}\n\n.dot-warning .vertical-timeline-element-icon {\n  background: #f7b924;\n}\n\n.dot-danger .vertical-timeline-element-icon {\n  background: #d92550;\n}\n\n.dot-light .vertical-timeline-element-icon {\n  background: #eeeeee;\n}\n\n.dot-dark .vertical-timeline-element-icon {\n  background: #343a40;\n}\n\n.dot-focus .vertical-timeline-element-icon {\n  background: #444054;\n}\n\n.dot-alternate .vertical-timeline-element-icon {\n  background: #83588a;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\n  visibility: hidden;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\n  visibility: visible;\n  animation: cd-bounce-1 0.8s;\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n@-moz-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -moz-transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: scale(1.2);\n  }\n  100% {\n    -moz-transform: scale(1);\n  }\n}\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n    -moz-transform: scale(0.5);\n    -ms-transform: scale(0.5);\n    -o-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n    -moz-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\n  visibility: hidden;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n  visibility: visible;\n  -webkit-animation: cd-bounce-2 0.6s;\n  -moz-animation: cd-bounce-2 0.6s;\n  animation: cd-bounce-2 0.6s;\n}\n\n@media only screen and (min-width: 1170px) {\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    -moz-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n}\n@media only screen and (max-width: 1169px) {\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    -moz-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n}\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(20px);\n  }\n  100% {\n    -moz-transform: translateX(0);\n  }\n}\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    -moz-transform: translateX(-100px);\n    -ms-transform: translateX(-100px);\n    -o-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    -moz-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    -o-transform: translateX(20px);\n    transform: translateX(20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(-20px);\n  }\n  100% {\n    -moz-transform: translateX(0);\n  }\n}\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    -moz-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    -o-transform: translateX(-20px);\n    transform: translateX(-20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n.todo-list-wrapper .todo-indicator {\n  position: absolute;\n  width: 4px;\n  height: 60%;\n  border-radius: 0.3rem;\n  left: 0.5rem;\n  top: 20%;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n.todo-list-wrapper .list-group-item:hover .todo-indicator {\n  opacity: 0.9;\n}\n.todo-list-wrapper .custom-control,\n.todo-list-wrapper input[checkbox] {\n  margin-left: 0.5rem;\n}\n\n.list-group-flush + .card-footer {\n  border-top: 0;\n}\n\n.rm-list-borders .list-group-item {\n  border: 0;\n  padding: 0.6666666667rem 0;\n}\n\n.rm-list-borders-scroll .list-group-item {\n  border: 0;\n  padding-right: 1.5rem;\n}\n\n.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n.input-group > div:not([class]) {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > div:not([class]) .react-datepicker__input-container .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group .input-group-prepend + div {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > .react-datepicker-wrapper {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\nlegend {\n  font-size: 0.88rem;\n  font-weight: bold;\n}\n\n.form-heading {\n  font-size: 1.1rem;\n  margin: 0;\n  color: #545cd8;\n}\n.form-heading p {\n  color: #6c757d;\n  padding: 0.3rem 0 0;\n  font-size: 0.88rem;\n}\n\n.custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.pagination li a {\n  position: relative;\n  display: block;\n  padding: 0.375rem 0.75rem;\n  margin-left: -1px;\n  color: #545cd8;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.pagination li a:hover {\n  z-index: 2;\n  color: rgb(67.2, 73.6, 172.8);\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.pagination li a:focus {\n  z-index: 2;\n  outline: 0;\n  box-shadow: none;\n}\n.pagination li a:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n.pagination li:first-child a {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.pagination li:last-child a {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.pagination li.active a {\n  z-index: 1;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.pagination li.active a:hover {\n  color: #fff;\n}\n.pagination li.disabled a {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-rounded li a {\n  border-radius: 50px !important;\n  margin: 0 0.3rem;\n}\n\n.chat-box-wrapper {\n  display: flex;\n  clear: both;\n  padding: 0.75rem;\n}\n.chat-box-wrapper + .chat-box-wrapper {\n  padding-top: 0;\n}\n.chat-box-wrapper .chat-box {\n  box-shadow: 0 0 0 transparent;\n  position: relative;\n  opacity: 1;\n  background: #e0f3ff;\n  border: 0;\n  padding: 0.75rem 1.5rem;\n  border-radius: 30px;\n  border-top-left-radius: 0.25rem;\n  flex: 1;\n  display: flex;\n  max-width: 50%;\n  min-width: 100%;\n  text-align: left;\n}\n.chat-box-wrapper .chat-box + small, .chat-box-wrapper .chat-box + .small {\n  text-align: left;\n  padding: 0.5rem 0 0;\n  margin-left: 1.5rem;\n  display: block;\n}\n.chat-box-wrapper.chat-box-wrapper-right {\n  text-align: right;\n}\n.chat-box-wrapper.chat-box-wrapper-right .chat-box {\n  border-radius: 30px;\n  border-top-left-radius: 30px;\n  border-top-right-radius: 0.25rem;\n  margin-left: auto;\n}\n.chat-box-wrapper.chat-box-wrapper-right .chat-box + small, .chat-box-wrapper.chat-box-wrapper-right .chat-box + .small {\n  text-align: right;\n  margin-right: 1.5rem;\n  margin-left: 0;\n}\n\n.forms-wizard {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n  border-radius: 0.25rem;\n}\n.forms-wizard li {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 1rem 0;\n  color: #adb5bd;\n  position: relative;\n}\n.forms-wizard li::after, .forms-wizard li::before {\n  position: absolute;\n  height: 4px;\n  top: 50%;\n  margin-top: -1rem;\n  width: 50%;\n  content: \"\";\n  background: #dee2e6;\n  z-index: 5;\n  transition: all 0.2s;\n}\n.forms-wizard li::after {\n  left: 50%;\n}\n.forms-wizard li::before {\n  left: 0;\n}\n.forms-wizard li:first-child::before {\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n.forms-wizard li:last-child::after {\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n.forms-wizard li em {\n  font-style: normal;\n  font-size: 1.32rem;\n  background: #ced4da;\n  color: #fff;\n  text-align: center;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 50px;\n  display: block;\n  margin: 0 auto 0.5rem;\n  position: relative;\n  z-index: 7;\n  transition: all 0.2s;\n}\n.forms-wizard li.form-wizard-step-doing {\n  color: #495057;\n}\n.forms-wizard li.form-wizard-step-doing em {\n  background: #545cd8;\n}\n.forms-wizard li.form-wizard-step-doing::before {\n  background: #545cd8;\n}\n.forms-wizard li.form-wizard-step-done em {\n  font-family: \"Linearicons-Free\";\n  background: #3ac47d;\n  overflow: hidden;\n}\n.forms-wizard li.form-wizard-step-done em::before {\n  width: 42px;\n  height: 42px;\n  font-size: 1.2rem;\n  line-height: 40px;\n  text-align: center;\n  display: block;\n}\n.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {\n  background: #3ac47d;\n}\n.forms-wizard li:hover {\n  color: #6c757d;\n}\n\n.forms-wizard-alt .forms-wizard li {\n  font-size: 0.88rem;\n}\n.forms-wizard-alt .forms-wizard li em {\n  width: 14px;\n  height: 14px;\n  line-height: 14px;\n  text-indent: -999rem;\n  border: #fff solid 2px;\n  margin: -7px auto 0;\n}\n\n.forms-wizard-vertical .forms-wizard {\n  display: block;\n  width: 30%;\n  float: left;\n  padding: 0 1.5rem 1.5rem 0;\n}\n.forms-wizard-vertical .forms-wizard li {\n  text-align: left;\n  display: flex;\n  align-items: center;\n  align-content: flex-start;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  border-radius: 0.3rem;\n  transition: all 0.2s;\n}\n.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {\n  display: none;\n}\n.forms-wizard-vertical .forms-wizard li em {\n  margin: 0 0.75rem 0 0;\n}\n.forms-wizard-vertical .forms-wizard li:hover {\n  background: #e9ecef;\n}\n.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {\n  background: #545cd8;\n  color: #fff;\n}\n.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {\n  background: rgba(255, 255, 255, 0.2);\n}\n.forms-wizard-vertical .form-wizard-content {\n  width: 70%;\n  overflow: auto;\n}\n\n@media screen and (min-width: 360px) and (max-width: 812px) {\n  .forms-wizard-vertical .forms-wizard {\n    display: block;\n    width: 50%;\n    float: left;\n    padding: 0 1.5rem 1.5rem 0;\n  }\n  .forms-wizard-vertical .forms-wizard li {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    align-content: flex-start;\n    padding: 0.75rem;\n    margin-bottom: 0.5rem;\n    border-radius: 0.3rem;\n    transition: all 0.2s;\n  }\n  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {\n    display: none;\n  }\n  .forms-wizard-vertical .forms-wizard li em {\n    margin: 0 0.75rem 0 0;\n  }\n  .forms-wizard-vertical .forms-wizard li:hover {\n    background: #e9ecef;\n  }\n  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {\n    background: #545cd8;\n    color: #fff;\n  }\n  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {\n    background: rgba(255, 255, 255, 0.2);\n  }\n  .forms-wizard-vertical .form-wizard-content {\n    width: 50%;\n    overflow: auto;\n  }\n}\n.icon-wrapper {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.widget-chart {\n  text-align: center;\n  padding: 1rem;\n  position: relative;\n}\n.widget-chart .progress-sub-label {\n  opacity: 0.8;\n  padding: 5px 0 0;\n}\n.widget-chart .progress-circle-wrapper {\n  min-width: 68px;\n  margin-right: 1rem;\n}\n.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {\n  font-size: 0.8rem;\n}\n.widget-chart .widget-chart-content {\n  position: relative;\n  z-index: 5;\n}\n.widget-chart .widget-chart-content-lg {\n  padding: 2rem 0 1rem 2rem;\n}\n.widget-chart .widget-chart-content-lg .widget-numbers {\n  margin-bottom: 0;\n}\n.widget-chart .widget-chart-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0.25;\n  z-index: 6;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  overflow: hidden;\n}\n.widget-chart .widget-numbers {\n  font-weight: bold;\n  font-size: 2.5rem;\n  display: block;\n  line-height: 1;\n  margin: 1rem auto;\n}\n.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {\n  margin-top: -0.5rem;\n}\n.widget-chart .widget-subheading {\n  margin: -0.5rem 0 0;\n  display: block;\n  opacity: 0.6;\n}\n.widget-chart .widget-subheading:first-child {\n  margin-top: 0;\n}\n.widget-chart .widget-subheading + .widget-numbers {\n  margin-top: 0.5rem;\n}\n.widget-chart .widget-description {\n  margin: 1rem 0 0;\n}\n.widget-chart.widget-chart-hover {\n  transition: all 0.2s;\n}\n.widget-chart.widget-chart-hover:hover {\n  z-index: 15;\n  transform: scale(1.15);\n  box-shadow: 0 0.46875rem 4.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.9375rem 2.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.25rem 1.3125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06), 0 0.125rem 1.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06);\n  cursor: pointer;\n  background: #fff;\n}\n.widget-chart .widget-chart-actions {\n  position: absolute;\n  right: 0.5rem;\n  top: 0.5rem;\n  z-index: 12;\n}\n.widget-chart .widget-chart-actions .btn-link {\n  font-size: 1.1rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0.6;\n}\n.widget-chart .widget-progress-wrapper {\n  margin-top: 1rem;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {\n  margin: 0 -1px -1px;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {\n  border-bottom-left-radius: 0.25rem;\n}\n.widget-chart .widget-chart-flex {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  margin-bottom: 1rem;\n}\n.widget-chart .widget-chart-flex:last-child {\n  margin-bottom: 0;\n}\n.widget-chart .widget-chart-flex .widget-subheading {\n  margin: 0;\n}\n.widget-chart .widget-chart-flex .widget-description {\n  margin-top: 0;\n}\n.widget-chart.text-start {\n  flex-direction: row;\n  align-items: center;\n}\n.widget-chart.text-start .icon-wrapper {\n  min-width: 54px;\n  margin: 0 1rem 0 0;\n}\n.widget-chart.text-start .widget-numbers {\n  margin-left: 0;\n}\n.widget-chart.text-start .widget-chart-content {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  flex: 1;\n  position: relative;\n}\n.widget-chart.text-start .widget-chart-content > .widget-numbers:first-child {\n  margin-top: 0;\n}\n.widget-chart.text-start .widget-chart-content .widget-description {\n  align-self: flex-start;\n}\n.widget-chart.text-start .widget-chart-wrapper {\n  height: 35%;\n}\n.widget-chart.widget-chart-left {\n  padding-bottom: 15%;\n}\n.widget-chart .chart-wrapper-relative {\n  position: relative;\n  opacity: 1;\n  margin-top: 1rem;\n}\n\n.widget-chart-actions {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  z-index: 12;\n}\n.widget-chart-actions .btn-link {\n  font-size: 1.1rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0.6;\n}\n\n.widget-chart:hover .widget-chart-actions .btn-link,\n.widget-content:hover .widget-chart-actions .btn-link {\n  opacity: 1;\n}\n\n.grid-menu .widget-chart.widget-chart-hover:hover {\n  background: #fff;\n  border-radius: 0.25rem;\n}\n\n.icon-wrapper {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n}\n.icon-wrapper[class*=border-] {\n  border-width: 1px;\n  border-style: solid;\n}\n.icon-wrapper .icon-wrapper-bg {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 3;\n  opacity: 0.2;\n}\n.icon-wrapper .icon-wrapper-bg.bg-light {\n  opacity: 0.08;\n}\n.icon-wrapper i {\n  margin: 0 auto;\n  font-size: 1.7rem;\n  position: relative;\n  z-index: 5;\n}\n.icon-wrapper i:before {\n  margin-top: -3px;\n}\n.icon-wrapper .progress-circle-wrapper {\n  width: 100%;\n  margin-right: 0;\n}\n\n.widget-chart2 .widget-chart-flex {\n  display: flex;\n  align-items: baseline;\n  align-content: center;\n  margin-bottom: 0;\n}\n.widget-chart2 .widget-chart-flex .widget-subtitle {\n  margin-left: auto;\n}\n.widget-chart2 .widget-chart-flex .widget-numbers {\n  font-weight: normal;\n}\n.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {\n  margin-bottom: 0;\n}\n.widget-chart2 .widget-chat-wrapper-outer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-width: 100%;\n}\n.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {\n  height: 70px;\n  opacity: 0.8;\n  position: relative;\n  margin: 1rem auto -0.5rem;\n}\n.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {\n  height: 130px;\n}\n\n.card-btm-border {\n  border-bottom: transparent solid 4px;\n}\n\n.progress-box {\n  text-align: center;\n}\n.progress-box h4, .progress-box .h4 {\n  font-size: 0.88rem;\n  font-weight: bold;\n  opacity: 0.6;\n  text-transform: uppercase;\n  padding-bottom: 0.3333333333rem;\n}\n.progress-box svg {\n  margin: 0 auto;\n}\n\n.svg-bg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.1;\n}\n.svg-bg svg {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.widget-numbers-sm {\n  font-size: 1.5rem;\n}\n\n.widget-content {\n  padding: 1rem;\n  flex-direction: row;\n  align-items: center;\n}\n.widget-content .widget-content-wrapper {\n  display: flex;\n  flex: 1;\n  position: relative;\n  align-items: center;\n}\n.widget-content .widget-content-left .widget-heading {\n  opacity: 0.8;\n  font-weight: bold;\n}\n.widget-content .widget-content-left .widget-subheading {\n  opacity: 0.5;\n}\n.widget-content .widget-content-right {\n  margin-left: auto;\n}\n.widget-content .widget-numbers {\n  font-weight: bold;\n  font-size: 1.8rem;\n  display: block;\n}\n.widget-content .widget-content-outer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.widget-content .widget-progress-wrapper {\n  margin-top: 1rem;\n}\n.widget-content .widget-progress-wrapper .progress-sub-label {\n  margin-top: 0.3333333333rem;\n  opacity: 0.5;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {\n  margin-left: auto;\n}\n.widget-content .widget-content-right.widget-content-actions {\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n.widget-content:hover .widget-content-right.widget-content-actions {\n  visibility: visible;\n  opacity: 1;\n}\n\n.profile-block {\n  position: relative;\n  overflow: hidden;\n}\n.profile-block .profile-blur {\n  width: 100%;\n  height: 100%;\n  filter: blur(5px);\n  transform: scale(1.8);\n  position: absolute;\n  left: -25%;\n  top: -25%;\n}\n.profile-block .profile-inner {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  left: 0;\n  top: 0;\n}\n.profile-block .dropdown-menu-header .menu-header-content {\n  padding: 3rem;\n}\n.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {\n  margin: 0.75rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {\n  margin: 0.5rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane {\n  margin: 0.5rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {\n  color: #fff;\n  padding: 0;\n  width: 44px;\n  height: 44px;\n  line-height: 37px;\n  font-size: 1.1rem;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.app-logo {\n  height: 23px;\n  width: 97px;\n  background: url(\"../../assets/utils/images/logo-inverse.png\");\n}\n\n.app-logo-inverse {\n  height: 23px;\n  width: 97px;\n  background: url(\"../../assets/utils/images/logo.png\");\n}\n\n.app-login-box .app-logo {\n  margin-bottom: 3rem;\n}\n.app-login-box h4, .app-login-box .h4 {\n  margin-bottom: 1.5rem;\n  font-weight: normal;\n}\n.app-login-box h4 div, .app-login-box .h4 div {\n  opacity: 0.6;\n}\n.app-login-box h4 span, .app-login-box .h4 span {\n  font-size: 1.1rem;\n}\n\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 10px;\n  height: 50vh;\n  overflow-y: scroll;\n  font-family: \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.message-wrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-message {\n  display: flex;\n  margin: 10px;\n  padding: 10px;\n  max-width: 50%;\n  width: 100%;\n  position: relative;\n}\n\n.left {\n  justify-content: flex-start;\n  align-self: flex-start;\n}\n\n.right {\n  justify-content: flex-end;\n  align-self: flex-end;\n}\n\n.chat-bubble {\n  padding: 10px;\n  border-radius: 15px;\n  position: relative;\n  background-color: white;\n  width: 100%;\n}\n\n.left .chat-bubble {\n  background-color: #f1f0f0;\n}\n\n.right .chat-bubble {\n  background-color: #593196;\n  margin-left: auto;\n}\n\n.chat-user-info {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.chat-profile-img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.chat-user-name {\n  font-weight: bold;\n  color: #333;\n}\n\n.chat-message-content {\n  margin-top: 5px;\n}\n\n.chat-message-content p {\n  margin: 0;\n  padding: 5px;\n  font-size: 16px;\n  word-wrap: break-word;\n}\n\n.chat-message-content small, .chat-message-content .small {\n  display: block;\n  text-align: right;\n  font-size: 12px;\n  color: gray;\n}\n\n.left .chat-bubble::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -8px;\n  width: 20px;\n  height: 20px;\n  background-color: #f1f0f0;\n  border-bottom-right-radius: 15px;\n  transform: rotate(90deg);\n}\n\n.right .chat-bubble::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: -8px;\n  width: 20px;\n  height: 20px;\n  background-color: #593196;\n  border-bottom-left-radius: 15px;\n  transform: rotate(-90deg);\n}\n\n.chat-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-container::-webkit-scrollbar-thumb {\n  background-color: #b0b0b0;\n  border-radius: 3px;\n}\n\n.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {\n  width: auto;\n  float: none;\n}\n.app-inner-layout .app-inner-layout__header {\n  width: 100%;\n  padding: 1.5rem;\n  text-align: left;\n  border-bottom: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__header .app-page-title {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n}\n.app-inner-layout .app-inner-layout__header-boxed {\n  padding: 1.5rem;\n}\n.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {\n  border-radius: 0.3rem;\n}\n.app-inner-layout .app-inner-layout__wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  min-height: 100vh;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {\n  flex: 1;\n  display: flex;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {\n  box-shadow: 0 0 0 0 transparent;\n  border-radius: 0;\n  border: 0;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  text-align: left;\n  padding: 0.75rem 1.5rem;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {\n  display: flex;\n  align-items: center;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {\n  padding: 1.5rem;\n  border-top: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {\n  width: 270px;\n  list-style: none;\n  text-align: left;\n  order: -1;\n  flex: 0 0 270px;\n  display: flex;\n  margin: 0;\n  position: relative;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {\n  white-space: normal;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {\n  box-shadow: 0 0 0 0 transparent;\n  border-radius: 0;\n  background: #f8f9fa;\n  border: 0;\n  border-right: #e9ecef solid 1px;\n  border-left: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {\n  background: #f8f9fa;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {\n  width: 60px;\n}\n.app-inner-layout .app-inner-layout__footer {\n  width: 100%;\n  height: 50px;\n}\n\n.app-wrapper-footer .app-footer {\n  border-top: #e9ecef solid 1px;\n}\n.app-wrapper-footer .app-footer .app-footer__inner {\n  border-left: #e9ecef solid 1px;\n}\n\n.chat-layout.app-inner-layout .app-inner-layout__sidebar {\n  width: 360px;\n  flex: 0 0 360px;\n}\n.chat-layout .app-inner-layout__top-pane h4, .chat-layout .app-inner-layout__top-pane .h4 {\n  font-size: 1.1rem;\n}\n.chat-layout .app-inner-layout__top-pane h4 div, .chat-layout .app-inner-layout__top-pane .h4 div {\n  font-size: 0.88rem;\n}\n.chat-layout .chat-box-wrapper {\n  padding: 1.5rem;\n}\n\n@media (max-width: 991.98px) {\n  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {\n    white-space: normal;\n  }\n}\n.mobile-app-menu-btn {\n  display: none;\n  margin: 3px 1.5rem 0 0;\n}\n\n@media (max-width: 767.98px) {\n  .app-inner-layout__sidebar {\n    display: none !important;\n  }\n  .mobile-app-menu-btn {\n    display: block;\n  }\n  .open-mobile-menu .app-inner-layout__sidebar {\n    display: block !important;\n  }\n}\n/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none !important;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  z-index: 7;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  border-radius: 50px;\n  z-index: 7;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: rgba(0, 0, 0, 0.1);\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  transition: background-color 0.2s linear, height 0.2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  transition: background-color 0.2s linear, width 0.2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  background-color: rgba(0, 0, 0, 0.12);\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  background-color: rgba(0, 0, 0, 0.12);\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n.scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n\n.scroll-area {\n  overflow-x: hidden;\n  height: 400px;\n}\n\n.scroll-area-xs {\n  height: 150px;\n  overflow-x: hidden;\n}\n\n.scroll-area-sm {\n  height: 200px;\n  overflow-x: hidden;\n}\n\n.scroll-area-md {\n  height: 300px;\n  overflow-x: hidden;\n}\n\n.scroll-area-lg {\n  height: 400px;\n  overflow-x: hidden;\n}\n\n.scroll-area-x {\n  overflow-x: auto;\n  width: 100%;\n  max-width: 100%;\n}\n\n.shadow-overflow {\n  position: relative;\n}\n.shadow-overflow::after, .shadow-overflow::before {\n  width: 100%;\n  bottom: auto;\n  top: 0;\n  left: 0;\n  height: 1.5rem;\n  position: absolute;\n  z-index: 10;\n  content: \"\";\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\", endColorstr=\"#00ffffff\", GradientType=0);\n}\n.shadow-overflow::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00ffffff\", endColorstr=\"#ffffff\", GradientType=0);\n}\n\n.rc-tabs {\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.rc-tabs-bar,\n.rc-tabs-nav-container {\n  font-size: 14px;\n  line-height: 1.5;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  outline: none;\n  zoom: 1;\n  transition: padding 0.45s;\n}\n\n.rc-tabs-ink-bar {\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.rc-tabs-ink-bar-animated {\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n}\n\n.rc-tabs-tab-prev,\n.rc-tabs-tab-next {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 1;\n  line-height: 36px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n}\n\n.rc-tabs-tab-prev-icon,\n.rc-tabs-tab-next-icon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  font-smoothing: antialiased;\n  text-stroke-width: 0;\n  font-family: sans-serif;\n}\n\n.rc-tabs-tab-prev-icon:before,\n.rc-tabs-tab-next-icon:before {\n  display: block;\n}\n\n.rc-tabs-tab-btn-disabled {\n  cursor: default;\n  color: #495057;\n}\n\n.rc-tabs-nav-wrap {\n  overflow: hidden;\n}\n\n.rc-tabs-nav {\n  box-sizing: border-box;\n  padding-left: 0;\n  position: relative;\n  margin: 0;\n  float: left;\n  list-style: none;\n  display: inline-block;\n  transform-origin: 0 0;\n}\n.rc-tabs-nav > div:first-child {\n  z-index: 5;\n  position: relative;\n}\n\n.rc-tabs-nav-animated {\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n.rc-tabs-nav:before,\n.rc-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n\n.rc-tabs-nav:after {\n  clear: both;\n}\n\n.rc-tabs-tab {\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  padding: 8px 20px;\n  cursor: pointer;\n}\n\n.rc-tabs-tab:hover {\n  color: #545cd8;\n}\n\n.rc-tabs-tab-active,\n.rc-tabs-tab-active:hover {\n  color: #fff;\n  cursor: default;\n  transform: translateZ(0);\n}\n\n.rc-tabs-tab-disabled {\n  cursor: default;\n  color: #495057;\n}\n\n.rc-tabs-tab-disabled:hover {\n  color: #495057;\n}\n\n.rc-tabs-content {\n  zoom: 1;\n}\n\n.rc-tabs-content .rc-tabs-tabpane {\n  overflow: hidden;\n}\n\n.rc-tabs-content-animated {\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  display: -ms-flexbox;\n  display: flex;\n  will-change: transform;\n}\n\n.rc-tabs-content-animated .rc-tabs-tabpane {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.no-flexbox .rc-tabs-content {\n  transform: none !important;\n  overflow: hidden;\n}\n\n.no-csstransitions .rc-tabs-tabpane-inactive,\n.no-flexbox .rc-tabs-tabpane-inactive,\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\n  display: none;\n}\n\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-content {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.rc-tabs-top .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rc-tabs-top .rc-tabs-nav-wrap {\n  width: 100%;\n  padding: 1.5rem 0.75rem;\n}\n\n.rc-tabs-top .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-tab-next {\n  right: 2px;\n}\n\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev {\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev,\n.rc-tabs-top .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 0;\n  height: 0;\n  top: 0;\n  text-align: center;\n  opacity: 0;\n  transition: width 0.3s, height 0.3s, opacity 0.3s;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 35px;\n  height: 100%;\n}\n\n.rc-tabs-top .rc-tabs-ink-bar {\n  height: 35px;\n  bottom: 0;\n  left: 0;\n  background: #545cd8;\n}\n\n.rc-tabs-top .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  line-height: 1.3;\n  margin-right: 0.75rem;\n}\n\n.rc-tabs-top .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n\n/*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n/*************************************\n * CONFIG\n */\n/*************************************\n * MIXINS\n */\n/*************************************\n * Opacity animation for spin.js\n */\n@keyframes ladda-spinner-line-fade {\n  0%, 100% {\n    opacity: 0.22; /* minimum opacity */\n  }\n  1% {\n    opacity: 1;\n  }\n}\n/*************************************\n * BUTTON BASE\n */\n.ladda-button {\n  position: relative;\n}\n\n/* Spinner animation */\n.ladda-button .ladda-spinner {\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  width: 32px;\n  top: 50%;\n  margin-top: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Button label */\n.ladda-button .ladda-label {\n  position: relative;\n  z-index: 3;\n}\n\n[class*=btn-outline-] .ladda-spinner div div div {\n  background: #000 !important;\n}\n[class*=btn-outline-].ladda-button .ladda-label {\n  transition: none !important;\n}\n\n/* Progress bar */\n.ladda-button .ladda-progress {\n  position: absolute;\n  width: 0;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.2);\n  display: none;\n  transition: 0.1s linear all !important;\n}\n\n.ladda-button[data-loading] .ladda-progress {\n  display: block;\n}\n\n/*************************************\n * EASING\n */\n.ladda-button,\n.ladda-button .ladda-spinner,\n.ladda-button .ladda-label {\n  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n}\n\n.ladda-button[data-style=zoom-in],\n.ladda-button[data-style=zoom-in] .ladda-spinner,\n.ladda-button[data-style=zoom-in] .ladda-label,\n.ladda-button[data-style=zoom-out],\n.ladda-button[data-style=zoom-out] .ladda-spinner,\n.ladda-button[data-style=zoom-out] .ladda-label {\n  transition: 0.3s ease all !important;\n}\n\n/*************************************\n * EXPAND RIGHT\n */\n.ladda-button[data-style=expand-right] .ladda-spinner {\n  right: -6px;\n}\n.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {\n  right: -12px;\n}\n.ladda-button[data-style=expand-right][data-loading] {\n  padding-right: 56px;\n}\n.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {\n  padding-right: 40px;\n}\n\n/*************************************\n * EXPAND LEFT\n */\n.ladda-button[data-style=expand-left] .ladda-spinner {\n  left: 26px;\n}\n.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {\n  left: 4px;\n}\n.ladda-button[data-style=expand-left][data-loading] {\n  padding-left: 56px;\n}\n.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {\n  padding-left: 40px;\n}\n\n/*************************************\n * EXPAND UP\n */\n.ladda-button[data-style=expand-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-up] .ladda-spinner {\n  top: -32px;\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=expand-up][data-loading] {\n  padding-top: 54px;\n}\n.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {\n  opacity: 1;\n  top: 26px;\n  margin-top: 0;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {\n  padding-top: 32px;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {\n  top: 4px;\n}\n\n/*************************************\n * EXPAND DOWN\n */\n.ladda-button[data-style=expand-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-down] .ladda-spinner {\n  top: 52px;\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {\n  top: 40px;\n}\n.ladda-button[data-style=expand-down][data-loading] {\n  padding-bottom: 54px;\n}\n.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {\n  padding-bottom: 32px;\n}\n\n/*************************************\n * SLIDE LEFT\n */\n.ladda-button[data-style=slide-left] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-left] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-left] .ladda-spinner {\n  left: 100%;\n  margin-left: 0;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-label {\n  opacity: 0;\n  left: -100%;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {\n  opacity: 1;\n  left: 50%;\n}\n\n/*************************************\n * SLIDE RIGHT\n */\n.ladda-button[data-style=slide-right] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-right] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-right] .ladda-spinner {\n  right: 100%;\n  margin-left: 0;\n  left: 16px;\n}\n[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {\n  right: auto;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-label {\n  opacity: 0;\n  left: 100%;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {\n  opacity: 1;\n  left: 50%;\n}\n\n/*************************************\n * SLIDE UP\n */\n.ladda-button[data-style=slide-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-up] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-up] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n  margin-top: 1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-label {\n  opacity: 0;\n  top: -1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-top: 0;\n}\n\n/*************************************\n * SLIDE DOWN\n */\n.ladda-button[data-style=slide-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-down] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-down] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n  margin-top: -2em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-label {\n  opacity: 0;\n  top: 1em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-top: 0;\n}\n\n/*************************************\n * ZOOM-OUT\n */\n.ladda-button[data-style=zoom-out] {\n  overflow: hidden;\n}\n\n.ladda-button[data-style=zoom-out] .ladda-spinner {\n  left: 50%;\n  margin-left: 32px;\n  transform: scale(2.5);\n}\n\n.ladda-button[data-style=zoom-out] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\n  opacity: 0;\n  transform: scale(0.5);\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  transform: none;\n}\n\n/*************************************\n * ZOOM-IN\n */\n.ladda-button[data-style=zoom-in] {\n  overflow: hidden;\n}\n\n.ladda-button[data-style=zoom-in] .ladda-spinner {\n  left: 50%;\n  margin-left: -16px;\n  transform: scale(0.2);\n}\n\n.ladda-button[data-style=zoom-in] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\n  opacity: 0;\n  transform: scale(2.2);\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  transform: none;\n}\n\n/*************************************\n * CONTRACT\n */\n.ladda-button[data-style=contract] {\n  overflow: hidden;\n  width: 100px;\n}\n\n.ladda-button[data-style=contract] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n}\n\n.ladda-button[data-style=contract][data-loading] .ladda-label {\n  opacity: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n/*************************************\n * OVERLAY\n */\n.ladda-button[data-style=contract-overlay] {\n  overflow: hidden;\n  width: 100px;\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);\n}\n\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\n  opacity: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n[dir=rtl] .ladda-spinner > div {\n  left: 25% !important;\n}\n\n/*!\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n.hamburger {\n  padding: 0px 0px;\n  display: inline-block;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n.hamburger.is-active:hover {\n  opacity: 0.7;\n}\n.hamburger.is-active .hamburger-inner,\n.hamburger.is-active .hamburger-inner::before,\n.hamburger.is-active .hamburger-inner::after {\n  background-color: #545cd8;\n}\n\n.hamburger-box {\n  width: 24px;\n  height: 14px;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: -1px;\n}\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {\n  width: 24px;\n  height: 2px;\n  background-color: #545cd8;\n  border-radius: 10px;\n  position: absolute;\n  transition-property: transform;\n  transition-duration: 0.15s;\n  transition-timing-function: ease;\n}\n.hamburger-inner::before, .hamburger-inner::after {\n  content: \"\";\n  display: block;\n}\n.hamburger-inner::before {\n  top: -6px;\n}\n.hamburger-inner::after {\n  bottom: -6px;\n}\n\n/*\n * Elastic\n */\n.hamburger--elastic .hamburger-inner {\n  top: 1px;\n  transition-duration: 0.275s;\n  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic .hamburger-inner::before {\n  top: 6px;\n  transition: opacity 0.125s 0.275s ease;\n}\n.hamburger--elastic .hamburger-inner::after {\n  top: 12px;\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic.is-active .hamburger-inner {\n  transform: translate3d(0, 6px, 0) rotate(135deg);\n  transition-delay: 0.075s;\n}\n.hamburger--elastic.is-active .hamburger-inner::before {\n  transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic.is-active .hamburger-inner::after {\n  transform: translate3d(0, -12px, 0) rotate(-270deg);\n  transition-delay: 0.075s;\n}\n\n.drawer-content-wrapper {\n  background: #fff;\n  position: relative;\n  padding: 1.5rem;\n}\n.drawer-content-wrapper .drawer-heading {\n  font-size: 0.968rem;\n  color: #495057;\n  margin: 0;\n  background: #f8f9fa;\n  padding: 0.75rem 1.5rem;\n  border-bottom: #dee2e6 solid 1px;\n  border-top: #dee2e6 solid 1px;\n}\n.drawer-content-wrapper .drawer-heading:first-child {\n  border-top: 0;\n}\n.drawer-content-wrapper .drawer-section {\n  padding: 1.5rem;\n}\n.drawer-content-wrapper > .app-sidebar__heading:first-child {\n  margin-top: 0;\n}\n\n.drawer-nav-btn {\n  border-radius: 30px;\n  background: #fff;\n  position: fixed;\n  right: 0.75rem;\n  top: 0.75rem;\n  padding: 0.5rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  z-index: 20;\n}\n.drawer-nav-btn .hamburger {\n  margin-top: 4px;\n}\n\n.sa-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid #dee2e6;\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  margin: 20px auto;\n  padding: 0;\n  position: relative;\n  box-sizing: content-box;\n}\n.sa-icon.sa-error {\n  border-color: #d92550;\n}\n.sa-icon.sa-error .sa-x-mark {\n  position: relative;\n  display: block;\n}\n.sa-icon.sa-error .sa-line {\n  position: absolute;\n  height: 5px;\n  width: 47px;\n  background-color: #d92550;\n  display: block;\n  top: 37px;\n  border-radius: 2px;\n}\n.sa-icon.sa-error .sa-line.sa-left {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  left: 17px;\n}\n.sa-icon.sa-error .sa-line.sa-right {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  right: 16px;\n}\n.sa-icon.sa-warning {\n  border-color: #f7b924;\n}\n.sa-icon.sa-warning .sa-body {\n  position: absolute;\n  width: 5px;\n  height: 47px;\n  left: 50%;\n  top: 10px;\n  -webkit-border-radius: 2px;\n  border-radius: 2px;\n  margin-left: -2px;\n  background-color: #f7b924;\n}\n.sa-icon.sa-warning .sa-dot {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  margin-left: -3px;\n  left: 50%;\n  bottom: 10px;\n  background-color: #f7b924;\n}\n.sa-icon.sa-info {\n  border-color: #30b1ff;\n}\n.sa-icon.sa-info::before {\n  content: \"\";\n  position: absolute;\n  width: 5px;\n  height: 29px;\n  left: 50%;\n  bottom: 17px;\n  border-radius: 2px;\n  margin-left: -2px;\n  background-color: #30b1ff;\n}\n.sa-icon.sa-info::after {\n  content: \"\";\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-left: -3px;\n  top: 19px;\n  background-color: #30b1ff;\n}\n.sa-icon.sa-success {\n  border-color: #3ac47d;\n}\n.sa-icon.sa-success::before, .sa-icon.sa-success::after {\n  content: \"\";\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  position: absolute;\n  width: 60px;\n  height: 120px;\n  background: #fff;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sa-icon.sa-success::before {\n  -webkit-border-radius: 120px 0 0 120px;\n  border-radius: 120px 0 0 120px;\n  top: -7px;\n  left: -33px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 60px 60px;\n  transform-origin: 60px 60px;\n}\n.sa-icon.sa-success::after {\n  -webkit-border-radius: 0 120px 120px 0;\n  border-radius: 0 120px 120px 0;\n  top: -11px;\n  left: 30px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 0 60px;\n  transform-origin: 0 60px;\n}\n.sa-icon.sa-success .sa-placeholder {\n  width: 80px;\n  height: 80px;\n  border: 4px solid rgba(165, 220, 134, 0.2);\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n  border-radius: 50%;\n  box-sizing: content-box;\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  z-index: 2;\n}\n.sa-icon.sa-success .sa-fix {\n  width: 5px;\n  height: 90px;\n  background-color: #fff;\n  position: absolute;\n  left: 28px;\n  top: 8px;\n  z-index: 1;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sa-icon.sa-success .sa-line {\n  height: 5px;\n  background-color: #3ac47d;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 2;\n}\n.sa-icon.sa-success .sa-line.sa-tip {\n  width: 25px;\n  left: 14px;\n  top: 46px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sa-icon.sa-success .sa-line.sa-long {\n  width: 47px;\n  right: 8px;\n  top: 38px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sa-icon.sa-custom {\n  background-size: contain;\n  border-radius: 0;\n  border: none;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n@-webkit-keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n@keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n@-webkit-keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n@keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n.animateSuccessTip {\n  -webkit-animation: animateSuccessTip 0.75s;\n  animation: animateSuccessTip 0.75s;\n}\n\n.animateSuccessLong {\n  -webkit-animation: animateSuccessLong 0.75s;\n  animation: animateSuccessLong 0.75s;\n}\n\n.sa-icon.sa-success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n/* Success icon */\n.sweet-alert .sa-icon.sa-success {\n  border-color: transparent \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\n  -ms-transform: rotate(45deg) \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {\n  -ms-transform: rotate(-45deg) \\9 ;\n}\n\n.Toastify__toast-container {\n  z-index: 9999;\n  position: fixed;\n  padding: 0;\n  width: 320px;\n  box-sizing: border-box;\n  color: #fff;\n}\n.Toastify__toast-container--top-left {\n  top: 1rem;\n  left: 1rem;\n}\n.Toastify__toast-container--top-center {\n  top: 1rem;\n  left: 50%;\n  margin-left: -160px;\n}\n.Toastify__toast-container--top-right {\n  top: 1rem;\n  right: 1rem;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1rem;\n  left: 1rem;\n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1rem;\n  left: 50%;\n  margin-left: -160px;\n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1rem;\n  right: 1rem;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0;\n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: 54px;\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  display: flex;\n  justify-content: space-between;\n  max-height: 800px;\n  overflow: hidden;\n  font-family: sans-serif;\n  cursor: pointer;\n  direction: ltr;\n}\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n.Toastify__toast--default {\n  background: #fff;\n  color: #495057;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);\n}\n.Toastify__toast--info {\n  background: #30b1ff;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);\n}\n.Toastify__toast--success {\n  background: #3ac47d;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);\n}\n.Toastify__toast--warning {\n  background: #f7b924;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);\n}\n.Toastify__toast--error {\n  background: #d92550;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);\n}\n.Toastify__toast-body {\n  margin: auto 0;\n  padding: 0 0 0.4rem;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    margin-bottom: 0;\n  }\n}\n.Toastify__close-button {\n  color: #fff;\n  font-size: 14px;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  position: absolute;\n  top: 5px;\n  right: 9px;\n}\n.Toastify__close-button--default {\n  color: #000;\n  opacity: 0.3;\n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    width: 96%;\n  }\n  100% {\n    width: 0;\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 9%;\n  left: 2%;\n  width: 0;\n  height: 5px;\n  z-index: 9999;\n  animation: Toastify__trackProgress linear 1;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 0.25rem;\n}\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n}\n.Toastify__progress-bar--default {\n  background: #545cd8;\n}\n@keyframes Toastify__bounceInRight {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n}\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n/* -- container -- */\n.rodal,\n.rodal-mask {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.rodal {\n  position: fixed;\n}\n\n/* -- mask -- */\n.rodal-mask {\n  position: absolute;\n  background-color: #000;\n  opacity: 0.5;\n}\n\n/* -- dialog -- */\n.rodal-dialog {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 101;\n  background: #fff;\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n  border-radius: 0.25rem;\n  height: auto !important;\n}\n\n.rodal-dialog:focus {\n  outline: none;\n}\n\n/* -- close button -- */\n.rodal-close {\n  position: absolute;\n  cursor: pointer;\n  top: 16px;\n  right: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.rodal-close:before,\n.rodal-close:after {\n  position: absolute;\n  content: \"\";\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  background: #adb5bd;\n  border-radius: 100%;\n  transition: background 0.2s;\n}\n\n.rodal-close:before {\n  transform: rotate(45deg);\n}\n\n.rodal-close:after {\n  transform: rotate(-45deg);\n}\n\n.rodal-close:hover:before,\n.rodal-close:hover:after {\n  background: #343a40;\n}\n\n/* -- fade -- */\n@keyframes rodal-fade-enter {\n  from {\n    opacity: 0;\n  }\n}\n.rodal-fade-enter {\n  animation: rodal-fade-enter both ease-in;\n}\n\n@keyframes rodal-fade-leave {\n  to {\n    opacity: 0;\n  }\n}\n.rodal-fade-leave {\n  animation: rodal-fade-leave both ease-out;\n}\n\n@keyframes rodal-zoom-enter {\n  from {\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-zoom-enter {\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-zoom-leave {\n  to {\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-zoom-leave {\n  animation: rodal-zoom-leave both;\n}\n\n@keyframes rodal-slideDown-enter {\n  from {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n.rodal-slideDown-enter {\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideDown-leave {\n  to {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n.rodal-slideDown-leave {\n  animation: rodal-slideDown-leave both;\n}\n\n/* -- slideLeft -- */\n@keyframes rodal-slideLeft-enter {\n  from {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n.rodal-slideLeft-enter {\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideLeft-leave {\n  to {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n.rodal-slideLeft-leave {\n  animation: rodal-slideLeft-leave both;\n}\n\n/* -- slideRight -- */\n@keyframes rodal-slideRight-enter {\n  from {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n.rodal-slideRight-enter {\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideRight-leave {\n  to {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n.rodal-slideRight-leave {\n  animation: rodal-slideRight-leave both;\n}\n\n/* -- slideUp -- */\n@keyframes rodal-slideUp-enter {\n  from {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n.rodal-slideUp-enter {\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideUp-leave {\n  to {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n.rodal-slideUp-leave {\n  animation: rodal-slideUp-leave both;\n}\n\n/* -- flip -- */\n@keyframes rodal-flip-enter {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\n  }\n  70% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.rodal-flip-enter {\n  animation: rodal-flip-enter both ease-in;\n  backface-visibility: visible !important;\n}\n\n@keyframes rodal-flip-leave {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\n  }\n}\n.rodal-flip-leave {\n  animation: rodal-flip-leave both;\n  backface-visibility: visible !important;\n}\n\n/* -- rotate -- */\n@keyframes rodal-rotate-enter {\n  from {\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-rotate-enter {\n  animation: rodal-rotate-enter both;\n  transform-origin: center;\n}\n\n@keyframes rodal-rotate-leave {\n  to {\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-rotate-leave {\n  animation: rodal-rotate-leave both;\n  transform-origin: center;\n}\n\n/* -- door -- */\n@keyframes rodal-door-enter {\n  from {\n    transform: scale3d(0, 1, 1);\n  }\n}\n.rodal-door-enter {\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-door-leave {\n  60% {\n    transform: scale3d(0.01, 1, 1);\n  }\n  to {\n    transform: scale3d(0, 1, 0.1);\n  }\n}\n.rodal-door-leave {\n  animation: rodal-door-leave both;\n}\n\n.react-sweet-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.react-sweet-progress-symbol {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  width: 35px;\n  height: 20px;\n  padding-left: 10px;\n  color: rgba(0, 0, 0, 0.7);\n  font-weight: 200;\n}\n\n.react-sweet-progress-symbol-absolute {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\n  padding: 0;\n  width: 100%;\n}\n\n.react-sweet-progress-circle-outer {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line {\n  width: 100%;\n  border-radius: 100px;\n  background-color: #efefef;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line-inner {\n  position: relative;\n  min-height: 10px;\n  border-radius: 100px;\n  transition: width 0.3s ease;\n}\n\n.react-sweet-progress-line-inner-status-active:before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 10px;\n  background: #fff;\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\n  content: \"\";\n  opacity: 0;\n}\n\n@keyframes active-anim {\n  0% {\n    width: 0;\n    opacity: 0.1;\n  }\n  20% {\n    width: 0;\n    opacity: 0.5;\n  }\n  to {\n    width: 100%;\n    opacity: 0;\n  }\n}\n.react-sweet-progress-circle path {\n  stroke-linecap: round;\n}\n\n/* Slider */\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slick-slider-sm .slick-slider {\n  max-width: 450px;\n}\n.slick-slider-sm .slick-slider .slick-prev {\n  left: -20px;\n}\n.slick-slider-sm .slick-slider .slick-next {\n  right: -20px;\n}\n\n.slick-slider-md .slick-slider {\n  max-width: 650px;\n  margin: 0 auto;\n}\n\n.slick-slider-hover .slick-arrow {\n  opacity: 0;\n  background: #545cd8;\n  color: #fff !important;\n}\n.slick-slider-hover .slick-prev {\n  left: -30px;\n}\n.slick-slider-hover .slick-next {\n  right: -30px;\n}\n.slick-slider-hover:hover .slick-arrow {\n  opacity: 1;\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n.slick-list.dragging {\n  cursor: pointer;\n  cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slick-track:before, .slick-track:after {\n  content: \"\";\n  display: table;\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  display: none;\n}\n[dir=rtl] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n/* Arrows */\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n  color: #6c757d;\n  top: 50%;\n  transform: translate(0, -80%);\n  padding: 0;\n  border: none;\n  outline: none;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  transition: all 0.2s;\n  font-family: \"Pe-icon-7-stroke\";\n  border-radius: 50px;\n  background: #fff;\n  z-index: 6;\n  overflow: hidden;\n}\n.slick-prev::before,\n.slick-next::before {\n  font-size: 35px;\n  height: 40px;\n  line-height: 40px;\n  width: 40px;\n}\n.slick-prev:hover, .slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus {\n  outline: none;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  color: #545cd8;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n\n.slick-prev {\n  left: 0;\n}\n.slick-prev:before {\n  content: \"\\e686\";\n}\n\n.slick-next {\n  right: 0;\n}\n.slick-next:before {\n  content: \"\\e684\";\n}\n\n/* Dots */\n.slick-dots {\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: 0.75rem 0 0;\n  width: 100%;\n}\n.slick-dots li {\n  position: relative;\n  display: inline-block;\n  padding: 0;\n  margin: 0 5px;\n  cursor: pointer;\n  transform: scale(0.8);\n  transition: all 0.2s;\n}\n.slick-dots li button {\n  border: 0;\n  background: transparent;\n  display: block;\n  height: 14px;\n  width: 14px;\n  background: #545cd8;\n  cursor: pointer;\n  position: relative;\n  border-radius: 20px;\n  color: transparent;\n}\n.slick-dots li button::before {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  top: 50%;\n  margin: -4px 0 0 -4px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 20px;\n}\n.slick-dots li.slick-active {\n  transform: scale(1.2);\n}\n\n.slick-center {\n  transform: scale(1.1);\n}\n\n.slick-slider .slide-img-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  opacity: 0.4;\n  z-index: 10;\n}\n.slick-slider .slider-content {\n  position: relative;\n  z-index: 15;\n  text-align: center;\n  margin: 0 6rem;\n}\n.slick-slider .slider-content h3, .slick-slider .slider-content .h3 {\n  font-size: 1.54rem;\n  font-weight: normal;\n  margin-bottom: 1.5rem;\n}\n.slick-slider .slider-content p {\n  font-size: 0.88rem;\n  opacity: 0.7;\n}\n\n.slider-light .slick-dots {\n  position: absolute;\n  bottom: 10px;\n}\n.slider-light .slick-dots li button {\n  background: rgba(255, 255, 255, 0.25);\n}\n.slider-light .slick-prev,\n.slider-light .slick-next {\n  background: transparent;\n  color: #fff;\n  box-shadow: 0 0 0 0 transparent;\n}\n.slider-light .slick-prev:hover,\n.slider-light .slick-next:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n.slider-light .slick-next {\n  right: 15px;\n}\n.slider-light .slick-prev {\n  left: 15px;\n}\n.slider-light .slider-content {\n  color: #fff;\n}\n\n.loading-indicator {\n  text-align: center;\n}\n\n.loading-bullet {\n  display: inline-block;\n  opacity: 0;\n  font-size: 2em;\n  color: #02a17c;\n}\n\n.block-ui {\n  position: relative;\n  min-height: 3em;\n}\n\n.block-ui-container {\n  position: absolute;\n  z-index: 1010;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  min-height: 2em;\n  cursor: wait;\n  overflow: hidden;\n}\n\n.block-ui-container:focus {\n  outline: none;\n}\n\n.block-ui-overlay {\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  background-color: white;\n}\n\n.block-ui-message-container {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  right: 0;\n  text-align: center;\n  transform: translateY(-50%);\n  z-index: 10001;\n}\n\n.block-ui-message {\n  color: #333;\n  background: none;\n  z-index: 1011;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block-overlay-dark .block-ui-overlay {\n  background: rgb(0, 0, 0);\n}\n\n.popover {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.popover .grid-menu {\n  margin-bottom: -1rem;\n  padding: 1px;\n}\n.popover .grid-menu [class*=col-] {\n  padding: 1rem;\n}\n.popover .grid-menu + .nav .nav-item-btn {\n  margin-bottom: 1rem;\n}\n.popover .grid-menu-xl {\n  margin-bottom: -0.7407407407rem;\n}\n.popover .grid-menu-xl [class*=col-] {\n  padding: 0;\n}\n.popover .popover-inner .dropdown-menu-header {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n  margin-top: -1px;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.rm-max-width > .popover {\n  max-width: initial;\n}\n\n.rm-pointers > .popover .arrow {\n  display: none !important;\n}\n\n.popover-primary {\n  background-color: #545cd8 !important;\n}\n\n.popover-secondary {\n  background-color: #6c757d !important;\n}\n\n.popover-success {\n  background-color: #3ac47d !important;\n}\n\n.popover-info {\n  background-color: #30b1ff !important;\n}\n\n.popover-warning {\n  background-color: #f7b924 !important;\n}\n\n.popover-danger {\n  background-color: #d92550 !important;\n}\n\n.popover-light {\n  background-color: #eeeeee !important;\n}\n\n.popover-dark {\n  background-color: #343a40 !important;\n}\n\n.popover-focus {\n  background-color: #444054 !important;\n}\n\n.popover-alternate {\n  background-color: #83588a !important;\n}\n\n.popover-custom .popover-body {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n.popover-custom .popover-body .dropdown-menu-header {\n  margin-top: 0;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n}\n.popover-custom .popover-body .dropdown-menu-header .menu-header-content {\n  padding: 0 1.5rem;\n}\n.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {\n  color: rgba(0, 0, 0, 0.8);\n}\n.popover-custom.popover-custom-lg {\n  min-width: 22rem;\n}\n.popover-custom.popover-custom-xl {\n  min-width: 25rem;\n}\n.popover-custom.popover-custom-sm {\n  min-width: 15rem;\n}\n\n.popover-bg {\n  border: 0;\n}\n.popover-bg .arrow {\n  display: none;\n}\n.popover-bg .popover-header {\n  background: rgba(255, 255, 255, 0.1);\n  border-bottom: 0;\n  color: rgb(255, 255, 255);\n}\n.popover-bg .popover-header::before {\n  display: none;\n}\n.popover-bg .popover-body {\n  color: rgba(255, 255, 255, 0.7);\n}\n.popover-bg.text-dark .popover-header {\n  color: rgba(0, 0, 0, 0.8);\n}\n.popover-bg.text-dark .popover-body {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.tooltip-light > .tooltip .tooltip-inner {\n  background: #fff;\n  color: #343a40;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  border: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125) solid 1px;\n}\n.tooltip-light > .tooltip .arrow {\n  display: none;\n}\n\n.scrollable-block {\n  margin-bottom: 50px;\n  overflow: hidden;\n  position: relative;\n}\n.scrollable-block .sticky {\n  z-index: 2;\n}\n\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1 1;\n  min-height: 580px;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full, .rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: rgb(178.5, 178.5, 178.5);\n}\n\n.rbc-header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  flex: 1 0;\n  flex-basis: auto !important;\n}\n.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  z-index: 4;\n}\n\n.rbc-today {\n  background-color: #e0f3ff;\n}\n\n.rbc-toolbar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  width: 100%;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #fff;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: #545cd8;\n  border: 1px solid #545cd8;\n  padding: 0.375rem 1rem;\n  border-radius: 0.25rem;\n  line-height: normal;\n  white-space: nowrap;\n  font-weight: bold;\n  text-transform: capitalize;\n  font-size: 0.88rem;\n}\n.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);\n}\n.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {\n  color: #fff;\n  background-color: rgb(39.6128571429, 47.7385714286, 173.6871428571);\n  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);\n}\n.rbc-toolbar button:focus {\n  color: #fff;\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);\n}\n.rbc-toolbar button:hover {\n  color: #fff;\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-event {\n  cursor: pointer;\n  padding: 0.125rem;\n  background-color: #545cd8;\n  border-radius: 0.25rem;\n  color: #fff;\n}\n.rbc-event.rbc-selected {\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n}\n\n.rbc-event-label {\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #e9ecef;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n  height: 100%;\n}\n.rbc-month-view .rbc-header {\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-month-view .rbc-header + .rbc-header {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #e9ecef;\n}\n\n.rbc-date-cell {\n  padding-right: 5px;\n  text-align: right;\n  flex: 1 1;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-bg {\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\n  flex: 1 0;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n\n.rbc-off-range-bg {\n  background: #f8f9fa;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table {\n  width: 100%;\n  border: 1px solid #e9ecef;\n}\n.rbc-agenda-view table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table tbody > tr > td + td {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-agenda-view table tbody > tr + tr {\n  border-top: 1px solid #e9ecef;\n}\n.rbc-agenda-view table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-agenda-view table thead > tr > th {\n  text-align: right;\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  flex: 1;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #e9ecef;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-event {\n  border: 1px solid rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  display: flex;\n  max-height: 100%;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  overflow: hidden;\n}\n.rbc-day-slot .rbc-event-label {\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid white;\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-day-slot .rbc-event {\n  position: absolute;\n  z-index: 2;\n}\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  cursor: default;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #white;\n  font-size: 75%;\n  padding: 3px;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #e9ecef;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  min-height: 20px;\n}\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #e9ecef;\n}\n.rbc-time-header > .rbc-row > * + * {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-header > .rbc-row > * + * {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-time-header .rbc-gutter-cell {\n  flex: none;\n}\n.rbc-time-header > .rbc-gutter-cell + * {\n  width: 100%;\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #e9ecef;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  user-select: none;\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  height: 1px;\n  background-color: #3ac47d;\n  pointer-events: none;\n}\n.rbc-current-time-indicator::before {\n  display: block;\n  position: absolute;\n  left: -3px;\n  top: -3px;\n  content: \" \";\n  background-color: #3ac47d;\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n}\n.rbc-rtl .rbc-current-time-indicator::before {\n  left: 0;\n  right: -3px;\n}\n\n.handle-bar {\n  background: transparent !important;\n  border-radius: 30px;\n}\n.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {\n  background-color: #e9ecef !important;\n}\n.handle-bar.resize-not-allowed:hover {\n  background-color: #e9ecef;\n}\n.handle-bar .handle-bar_drag {\n  border-color: #545cd8 !important;\n}\n\n/**\n * Extra class applied to VirtualScroll through className prop\n */\n.rst__virtualScrollOverride {\n  overflow: auto !important;\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n  overflow: visible !important;\n}\n\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\n  direction: rtl;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n.rst__node {\n  min-width: 100%;\n  white-space: nowrap;\n  position: relative;\n  text-align: left;\n}\n\n.rst__node.rst__rtl {\n  text-align: right;\n}\n\n.rst__nodeContent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n/* ==========================================================================\n   Scaffold\n\n    Line-overlaid blocks used for showing the tree structure\n   ========================================================================== */\n.rst__lineBlock,\n.rst__absoluteLineBlock {\n  height: 100%;\n  position: relative;\n  display: inline-block;\n}\n\n.rst__absoluteLineBlock {\n  position: absolute;\n  top: 0;\n}\n\n.rst__lineHalfHorizontalRight::before,\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  position: absolute;\n  content: \"\";\n  background-color: black;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |     |\n * +-----+\n */\n.rst__lineHalfHorizontalRight::before {\n  height: 1px;\n  top: 50%;\n  right: 0;\n  width: 50%;\n}\n\n.rst__rtl.rst__lineHalfHorizontalRight::before {\n  left: 0;\n  right: initial;\n}\n\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  width: 1px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__lineFullVertical::after,\n.rst__rtl.rst__lineHalfVerticalTop::after,\n.rst__rtl.rst__lineHalfVerticalBottom::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__lineHalfVerticalTop::after {\n  height: 50%;\n}\n\n.rst__lineHalfVerticalBottom::after {\n  top: auto;\n  bottom: 0;\n  height: 50%;\n}\n\n/* Highlight line for pointing to dragged row destination\n   ========================================================================== */\n.rst__highlightLineVertical {\n  z-index: 3;\n}\n\n.rst__highlightLineVertical::before {\n  position: absolute;\n  content: \"\";\n  background-color: #545cd8;\n  width: 8px;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__highlightLineVertical::before {\n  margin-left: initial;\n  margin-right: -4px;\n  left: initial;\n  right: 50%;\n}\n\n@keyframes arrow-pulse {\n  0% {\n    transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n.rst__highlightLineVertical::after {\n  content: \"\";\n  position: absolute;\n  height: 0;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid white;\n  animation: arrow-pulse 1s infinite linear both;\n}\n\n.rst__rtl.rst__highlightLineVertical::after {\n  margin-left: initial;\n  margin-right: -4px;\n  right: 50%;\n  left: initial;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |  |  |\n * +--+--+\n */\n.rst__highlightTopLeftCorner::before {\n  z-index: 3;\n  content: \"\";\n  position: absolute;\n  border-top: solid 8px #545cd8;\n  border-left: solid 8px #545cd8;\n  box-sizing: border-box;\n  height: calc(50% + 4px);\n  top: 50%;\n  margin-top: -4px;\n  right: 0;\n  width: calc(50% + 4px);\n}\n\n.rst__rtl.rst__highlightTopLeftCorner::before {\n  border-right: solid 8px #545cd8;\n  border-left: none;\n  left: 0;\n  right: initial;\n}\n\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  +->|\n * +-----+\n */\n.rst__highlightBottomLeftCorner {\n  z-index: 3;\n}\n\n.rst__highlightBottomLeftCorner::before {\n  content: \"\";\n  position: absolute;\n  border-bottom: solid 8px #545cd8;\n  border-left: solid 8px #545cd8;\n  box-sizing: border-box;\n  height: calc(100% + 4px);\n  top: 0;\n  right: 12px;\n  width: calc(50% - 8px);\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::before {\n  border-right: solid 8px #545cd8;\n  border-left: none;\n  left: 12px;\n  right: initial;\n}\n\n.rst__highlightBottomLeftCorner::after {\n  content: \"\";\n  position: absolute;\n  height: 0;\n  right: 0;\n  top: 100%;\n  margin-top: -12px;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid #545cd8;\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::after {\n  left: 0;\n  right: initial;\n  border-right: 12px solid #545cd8;\n  border-left: none;\n}\n\n.rst__rowWrapper {\n  padding: 10px 10px 10px 0;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.rst__rtl.rst__rowWrapper {\n  padding: 10px 0 10px 10px;\n}\n\n.rst__row {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n}\n\n.rst__row > * {\n  box-sizing: border-box;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__rowLandingPad,\n.rst__rowCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rst__rowLandingPad > *,\n.rst__rowCancelPad > * {\n  opacity: 0 !important;\n}\n\n.rst__rowLandingPad::before,\n.rst__rowCancelPad::before {\n  background-color: lightblue;\n  border: 1px dashed #fff;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__rowCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/**\n * Nodes matching the search conditions are highlighted\n */\n.rst__rowSearchMatch {\n  outline: solid 3px #0080ff;\n}\n\n/**\n * The node that matches the search conditions and is currently focused\n */\n.rst__rowSearchFocus {\n  outline: solid 3px #fc6421;\n}\n\n.rst__rowContents,\n.rst__rowLabel,\n.rst__rowToolbar,\n.rst__moveHandle,\n.rst__toolbarButton {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.rst__rowContents {\n  position: relative;\n  height: 100%;\n  border: solid #dee2e6 1px;\n  border-left: none;\n  padding: 0 5px 0 10px;\n  border-radius: 2px;\n  min-width: 230px;\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n}\n\n.rst__rtl.rst__rowContents {\n  border-right: none;\n  border-left: solid #dee2e6 1px;\n  padding: 0 10px 0 5px;\n}\n\n.rst__rowContentsDragDisabled {\n  border-left: solid #dee2e6 1px;\n}\n\n.rst__rtl.rst__rowContentsDragDisabled {\n  border-right: solid #dee2e6 1px;\n  border-left: solid #dee2e6 1px;\n}\n\n.rst__rowLabel {\n  flex: 0 1 auto;\n  padding-right: 20px;\n}\n\n.rst__rtl.rst__rowLabel {\n  padding-left: 20px;\n  padding-right: inherit;\n}\n\n.rst__rowToolbar {\n  flex: 0 1 auto;\n  display: flex;\n}\n\n.rst__moveHandle,\n.rst__loadingHandle {\n  height: 100%;\n  width: 44px;\n  background: #e9ecef url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+\") no-repeat center;\n  border: solid #aaa 1px;\n  cursor: move;\n  border-radius: 1px;\n  z-index: 1;\n}\n\n.rst__loadingHandle {\n  cursor: default;\n  background: #e9ecef;\n}\n\n@keyframes pointFade {\n  0%, 19.999%, 100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n.rst__loadingCircle {\n  width: 80%;\n  height: 80%;\n  margin: 10%;\n  position: relative;\n}\n\n.rst__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rst__rtl.rst__loadingCirclePoint {\n  right: 0;\n  left: initial;\n}\n\n.rst__loadingCirclePoint::before {\n  content: \"\";\n  display: block;\n  margin: 0 auto;\n  width: 11%;\n  height: 30%;\n  background-color: #fff;\n  border-radius: 30%;\n  animation: pointFade 800ms infinite ease-in-out both;\n}\n\n.rst__loadingCirclePoint:nth-of-type(1) {\n  transform: rotate(0deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(1)::before,\n.rst__loadingCirclePoint:nth-of-type(7)::before {\n  animation-delay: -800ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(2) {\n  transform: rotate(30deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(8) {\n  transform: rotate(210deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(2)::before,\n.rst__loadingCirclePoint:nth-of-type(8)::before {\n  animation-delay: -666ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(3) {\n  transform: rotate(60deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(9) {\n  transform: rotate(240deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(3)::before,\n.rst__loadingCirclePoint:nth-of-type(9)::before {\n  animation-delay: -533ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(4) {\n  transform: rotate(90deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(10) {\n  transform: rotate(270deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(4)::before,\n.rst__loadingCirclePoint:nth-of-type(10)::before {\n  animation-delay: -400ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(5) {\n  transform: rotate(120deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(11) {\n  transform: rotate(300deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(5)::before,\n.rst__loadingCirclePoint:nth-of-type(11)::before {\n  animation-delay: -266ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(6) {\n  transform: rotate(150deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(12) {\n  transform: rotate(330deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(6)::before,\n.rst__loadingCirclePoint:nth-of-type(12)::before {\n  animation-delay: -133ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(13) {\n  transform: rotate(360deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(7)::before,\n.rst__loadingCirclePoint:nth-of-type(13)::before {\n  animation-delay: 0ms;\n}\n\n.rst__rowTitle {\n  font-weight: bold;\n}\n\n.rst__rowTitleWithSubtitle {\n  font-size: 85%;\n  display: block;\n  height: 0.8rem;\n}\n\n.rst__rowSubtitle {\n  font-size: 70%;\n  line-height: 1;\n}\n\n.rst__collapseButton,\n.rst__expandButton {\n  appearance: none;\n  border: none;\n  position: absolute;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #000;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n\n.rst__rtl.rst__collapseButton,\n.rst__rtl.rst__expandButton {\n  transform: translate(50%, -50%);\n}\n\n.rst__collapseButton:focus,\n.rst__expandButton:focus {\n  outline: none;\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n}\n\n.rst__collapseButton:hover:not(:active),\n.rst__expandButton:hover:not(:active) {\n  background-size: 24px;\n  height: 20px;\n  width: 20px;\n}\n\n.rst__collapseButton {\n  background: #fff url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==\") no-repeat center;\n}\n\n.rst__expandButton {\n  background: #fff url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+\") no-repeat center;\n}\n\n/**\n * Line for under a node with children\n */\n.rst__lineChildren {\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n}\n\n.rst__lineChildren::after {\n  content: \"\";\n  position: absolute;\n  background-color: black;\n  width: 1px;\n  left: 50%;\n  bottom: 0;\n  height: 10px;\n}\n\n.rst__rtl.rst__lineChildren::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__placeholder {\n  position: relative;\n  height: 68px;\n  max-width: 300px;\n  padding: 10px;\n}\n\n.rst__placeholder,\n.rst__placeholder > * {\n  box-sizing: border-box;\n}\n\n.rst__placeholder::before {\n  border: 3px dashed #e9ecef;\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  z-index: -1;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__placeholderLandingPad,\n.rst__placeholderCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rst__placeholderLandingPad *,\n.rst__placeholderCancelPad * {\n  opacity: 0 !important;\n}\n\n.rst__placeholderLandingPad::before,\n.rst__placeholderCancelPad::before {\n  background-color: lightblue;\n  border-color: white;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__placeholderCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/* Collection default theme */\n/* Grid default theme */\n/* Table default theme */\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 24px;\n  flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n.ReactTable {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.ReactTable .rt-table {\n  flex: auto 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n}\n.ReactTable .-pagination input,\n.ReactTable .-pagination select,\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  display: block;\n  width: 100%;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  height: calc(1.5em + (0.5rem + 2px));\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.2rem;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n.ReactTable .-pagination input::-ms-expand,\n.ReactTable .-pagination select::-ms-expand,\n.ReactTable .rt-thead.-filters input::-ms-expand,\n.ReactTable .rt-thead.-filters select::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.ReactTable .-pagination input::placeholder,\n.ReactTable .-pagination select::placeholder,\n.ReactTable .rt-thead.-filters input::placeholder,\n.ReactTable .rt-thead.-filters select::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],\n.ReactTable .-pagination select:disabled,\n.ReactTable .-pagination select[readonly],\n.ReactTable .rt-thead.-filters input:disabled,\n.ReactTable .rt-thead.-filters input[readonly],\n.ReactTable .rt-thead.-filters select:disabled,\n.ReactTable .rt-thead.-filters select[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.ReactTable .rt-thead {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n}\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid #e9ecef;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th,\n.ReactTable .rt-thead.-headerGroups .rt-td {\n  padding: 0.3rem;\n  color: #6c757d;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th:hover,\n.ReactTable .rt-thead.-headerGroups .rt-td:hover {\n  color: #6c757d;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th:empty,\n.ReactTable .rt-thead.-headerGroups .rt-td:empty {\n  padding: 0;\n}\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n.ReactTable .rt-thead.-filters .rt-th {\n  border-right: 1px solid #e9ecef;\n}\n.ReactTable .rt-thead.-filters.-header {\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  padding: 0.55rem;\n  line-height: normal;\n  position: relative;\n  font-weight: bold;\n  border-right: 1px solid #e9ecef;\n  border-bottom: 1px solid #e9ecef;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n  color: #545cd8;\n}\n.ReactTable .rt-thead .rt-th:hover,\n.ReactTable .rt-thead .rt-td:hover {\n  color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n}\n.ReactTable .rt-thead .rt-th.-sort-asc,\n.ReactTable .rt-thead .rt-td.-sort-asc {\n  box-shadow: inset 0 3px 0 0 #545cd8;\n}\n.ReactTable .rt-thead .rt-th.-sort-desc,\n.ReactTable .rt-thead .rt-td.-sort-desc {\n  box-shadow: inset 0 -3px 0 0 #545cd8;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n.ReactTable .rt-tbody {\n  flex: 99999 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px #e9ecef;\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n.ReactTable .rt-tbody .rt-td {\n  border-right: 1px solid #e9ecef;\n  align-items: center;\n  align-content: center;\n  display: flex;\n}\n.ReactTable .rt-tbody .rt-td [contenteditable=true] {\n  width: 100%;\n  border: 1px solid transparent;\n  background: #fff !important;\n  border-radius: 0.2rem;\n}\n.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {\n  padding: 3px 5px;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: none;\n}\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n  text-overflow: clip;\n}\n.ReactTable .rt-tr-group {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.ReactTable .rt-tr {\n  flex: 1 0 auto;\n  display: inline-flex;\n}\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  flex: 1 0 0;\n  text-overflow: ellipsis;\n  padding: 0.55rem;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n}\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  color: transparent;\n  margin: 0 10px 0 0;\n}\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.ReactTable .rt-expander.-open:after {\n  transform: translate(-50%, -50%) rotate(0);\n}\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n.ReactTable .rt-tfoot {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid #e9ecef;\n}\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n.ReactTable.-fixed .-header {\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\n}\n.ReactTable.-fixed .pagination-bottom {\n  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: #e0f3ff;\n}\n.ReactTable .-pagination {\n  z-index: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  padding: 3px;\n  border-top: 2px solid rgba(0, 0, 0, 0.1);\n}\n.ReactTable .-pagination .-btn {\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 0.25rem;\n  padding: 6px;\n  font-size: 1em;\n  color: #545cd8;\n  background: #f8f9fa;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  outline: none;\n  font-weight: bold;\n}\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: default;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: #545cd8;\n  color: #fff;\n}\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  flex: 1;\n  text-align: center;\n}\n.ReactTable .-pagination .-center {\n  text-align: center;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-around;\n}\n.ReactTable .-pagination .-totalPages {\n  padding-left: 5px;\n  font-weight: bold;\n}\n.ReactTable .-pagination .-pageInfo {\n  display: inherit;\n  margin: 3px 0 3px 10px;\n  white-space: nowrap;\n  height: 30px;\n  line-height: 30px;\n}\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n  margin: 0 5px;\n}\n.ReactTable .-pagination .-pageJump input {\n  width: 70px;\n  text-align: center;\n}\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: #545cd8;\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n.ReactTable .-loading.-active > div {\n  transform: translateY(50%);\n}\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.table thead th,\n.table td {\n  vertical-align: middle;\n}\n\n.table th .filter {\n  margin-top: 0.375rem;\n  height: auto;\n  padding: 0.3rem 0.5rem;\n}\n\n.caret-4-asc,\n.caret-4-desc {\n  font-family: \"Linearicons-Free\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  margin-left: 0.375rem;\n}\n\n.table .sortable:hover .caret-4-asc,\n.table .sortable:hover .caret-4-desc {\n  color: #545cd8;\n}\n\n.table-lg th,\n.table-lg td {\n  padding: 1.1rem 0.825rem;\n}\n\n@font-face {\n  font-family: \"Linearicons-Free\";\n  src: url(\"linearicons/Linearicons-Free.eot?w118d\");\n  src: url(\"linearicons/Linearicons-Free.eot?#iefixw118d\") format(\"embedded-opentype\"), url(\"linearicons/Linearicons-Free.woff2?w118d\") format(\"woff2\"), url(\"linearicons/Linearicons-Free.woff?w118d\") format(\"woff\"), url(\"linearicons/Linearicons-Free.ttf?w118d\") format(\"truetype\"), url(\"linearicons/Linearicons-Free.svg?w118d#Linearicons-Free\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=lnr-],\n[class*=\" lnr-\"] {\n  font-family: \"Linearicons-Free\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.lnr-home:before {\n  content: \"\\e800\";\n}\n\n.lnr-apartment:before {\n  content: \"\\e801\";\n}\n\n.lnr-pencil:before {\n  content: \"\\e802\";\n}\n\n.lnr-magic-wand:before {\n  content: \"\\e803\";\n}\n\n.lnr-drop:before {\n  content: \"\\e804\";\n}\n\n.lnr-lighter:before {\n  content: \"\\e805\";\n}\n\n.lnr-poop:before {\n  content: \"\\e806\";\n}\n\n.lnr-sun:before {\n  content: \"\\e807\";\n}\n\n.lnr-moon:before {\n  content: \"\\e808\";\n}\n\n.lnr-cloud:before {\n  content: \"\\e809\";\n}\n\n.lnr-cloud-upload:before {\n  content: \"\\e80a\";\n}\n\n.lnr-cloud-download:before {\n  content: \"\\e80b\";\n}\n\n.lnr-cloud-sync:before {\n  content: \"\\e80c\";\n}\n\n.lnr-cloud-check:before {\n  content: \"\\e80d\";\n}\n\n.lnr-database:before {\n  content: \"\\e80e\";\n}\n\n.lnr-lock:before {\n  content: \"\\e80f\";\n}\n\n.lnr-cog:before {\n  content: \"\\e810\";\n}\n\n.lnr-trash:before {\n  content: \"\\e811\";\n}\n\n.lnr-dice:before {\n  content: \"\\e812\";\n}\n\n.lnr-heart:before {\n  content: \"\\e813\";\n}\n\n.lnr-star:before {\n  content: \"\\e814\";\n}\n\n.lnr-star-half:before {\n  content: \"\\e815\";\n}\n\n.lnr-star-empty:before {\n  content: \"\\e816\";\n}\n\n.lnr-flag:before {\n  content: \"\\e817\";\n}\n\n.lnr-envelope:before {\n  content: \"\\e818\";\n}\n\n.lnr-paperclip:before {\n  content: \"\\e819\";\n}\n\n.lnr-inbox:before {\n  content: \"\\e81a\";\n}\n\n.lnr-eye:before {\n  content: \"\\e81b\";\n}\n\n.lnr-printer:before {\n  content: \"\\e81c\";\n}\n\n.lnr-file-empty:before {\n  content: \"\\e81d\";\n}\n\n.lnr-file-add:before {\n  content: \"\\e81e\";\n}\n\n.lnr-enter:before {\n  content: \"\\e81f\";\n}\n\n.lnr-exit:before {\n  content: \"\\e820\";\n}\n\n.lnr-graduation-hat:before {\n  content: \"\\e821\";\n}\n\n.lnr-license:before {\n  content: \"\\e822\";\n}\n\n.lnr-music-note:before {\n  content: \"\\e823\";\n}\n\n.lnr-film-play:before {\n  content: \"\\e824\";\n}\n\n.lnr-camera-video:before {\n  content: \"\\e825\";\n}\n\n.lnr-camera:before {\n  content: \"\\e826\";\n}\n\n.lnr-picture:before {\n  content: \"\\e827\";\n}\n\n.lnr-book:before {\n  content: \"\\e828\";\n}\n\n.lnr-bookmark:before {\n  content: \"\\e829\";\n}\n\n.lnr-user:before {\n  content: \"\\e82a\";\n}\n\n.lnr-users:before {\n  content: \"\\e82b\";\n}\n\n.lnr-shirt:before {\n  content: \"\\e82c\";\n}\n\n.lnr-store:before {\n  content: \"\\e82d\";\n}\n\n.lnr-cart:before {\n  content: \"\\e82e\";\n}\n\n.lnr-tag:before {\n  content: \"\\e82f\";\n}\n\n.lnr-phone-handset:before {\n  content: \"\\e830\";\n}\n\n.lnr-phone:before {\n  content: \"\\e831\";\n}\n\n.lnr-pushpin:before {\n  content: \"\\e832\";\n}\n\n.lnr-map-marker:before {\n  content: \"\\e833\";\n}\n\n.lnr-map:before {\n  content: \"\\e834\";\n}\n\n.lnr-location:before {\n  content: \"\\e835\";\n}\n\n.lnr-calendar-full:before {\n  content: \"\\e836\";\n}\n\n.lnr-keyboard:before {\n  content: \"\\e837\";\n}\n\n.lnr-spell-check:before {\n  content: \"\\e838\";\n}\n\n.lnr-screen:before {\n  content: \"\\e839\";\n}\n\n.lnr-smartphone:before {\n  content: \"\\e83a\";\n}\n\n.lnr-tablet:before {\n  content: \"\\e83b\";\n}\n\n.lnr-laptop:before {\n  content: \"\\e83c\";\n}\n\n.lnr-laptop-phone:before {\n  content: \"\\e83d\";\n}\n\n.lnr-power-switch:before {\n  content: \"\\e83e\";\n}\n\n.lnr-bubble:before {\n  content: \"\\e83f\";\n}\n\n.lnr-heart-pulse:before {\n  content: \"\\e840\";\n}\n\n.lnr-construction:before {\n  content: \"\\e841\";\n}\n\n.lnr-pie-chart:before {\n  content: \"\\e842\";\n}\n\n.lnr-chart-bars:before {\n  content: \"\\e843\";\n}\n\n.lnr-gift:before {\n  content: \"\\e844\";\n}\n\n.lnr-diamond:before {\n  content: \"\\e845\";\n}\n\n.lnr-linearicons:before {\n  content: \"\\e846\";\n}\n\n.lnr-dinner:before {\n  content: \"\\e847\";\n}\n\n.lnr-coffee-cup:before {\n  content: \"\\e848\";\n}\n\n.lnr-leaf:before {\n  content: \"\\e849\";\n}\n\n.lnr-paw:before {\n  content: \"\\e84a\";\n}\n\n.lnr-rocket:before {\n  content: \"\\e84b\";\n}\n\n.lnr-briefcase:before {\n  content: \"\\e84c\";\n}\n\n.lnr-bus:before {\n  content: \"\\e84d\";\n}\n\n.lnr-car:before {\n  content: \"\\e84e\";\n}\n\n.lnr-train:before {\n  content: \"\\e84f\";\n}\n\n.lnr-bicycle:before {\n  content: \"\\e850\";\n}\n\n.lnr-wheelchair:before {\n  content: \"\\e851\";\n}\n\n.lnr-select:before {\n  content: \"\\e852\";\n}\n\n.lnr-earth:before {\n  content: \"\\e853\";\n}\n\n.lnr-smile:before {\n  content: \"\\e854\";\n}\n\n.lnr-sad:before {\n  content: \"\\e855\";\n}\n\n.lnr-neutral:before {\n  content: \"\\e856\";\n}\n\n.lnr-mustache:before {\n  content: \"\\e857\";\n}\n\n.lnr-alarm:before {\n  content: \"\\e858\";\n}\n\n.lnr-bullhorn:before {\n  content: \"\\e859\";\n}\n\n.lnr-volume-high:before {\n  content: \"\\e85a\";\n}\n\n.lnr-volume-medium:before {\n  content: \"\\e85b\";\n}\n\n.lnr-volume-low:before {\n  content: \"\\e85c\";\n}\n\n.lnr-volume:before {\n  content: \"\\e85d\";\n}\n\n.lnr-mic:before {\n  content: \"\\e85e\";\n}\n\n.lnr-hourglass:before {\n  content: \"\\e85f\";\n}\n\n.lnr-undo:before {\n  content: \"\\e860\";\n}\n\n.lnr-redo:before {\n  content: \"\\e861\";\n}\n\n.lnr-sync:before {\n  content: \"\\e862\";\n}\n\n.lnr-history:before {\n  content: \"\\e863\";\n}\n\n.lnr-clock:before {\n  content: \"\\e864\";\n}\n\n.lnr-download:before {\n  content: \"\\e865\";\n}\n\n.lnr-upload:before {\n  content: \"\\e866\";\n}\n\n.lnr-enter-down:before {\n  content: \"\\e867\";\n}\n\n.lnr-exit-up:before {\n  content: \"\\e868\";\n}\n\n.lnr-bug:before {\n  content: \"\\e869\";\n}\n\n.lnr-code:before {\n  content: \"\\e86a\";\n}\n\n.lnr-link:before {\n  content: \"\\e86b\";\n}\n\n.lnr-unlink:before {\n  content: \"\\e86c\";\n}\n\n.lnr-thumbs-up:before {\n  content: \"\\e86d\";\n}\n\n.lnr-thumbs-down:before {\n  content: \"\\e86e\";\n}\n\n.lnr-magnifier:before {\n  content: \"\\e86f\";\n}\n\n.lnr-cross:before {\n  content: \"\\e870\";\n}\n\n.lnr-menu:before {\n  content: \"\\e871\";\n}\n\n.lnr-list:before {\n  content: \"\\e872\";\n}\n\n.lnr-chevron-up:before, .caret-4-asc:before {\n  content: \"\\e873\";\n}\n\n.lnr-chevron-down:before, .caret-4-desc:before {\n  content: \"\\e874\";\n}\n\n.lnr-chevron-left:before {\n  content: \"\\e875\";\n}\n\n.lnr-chevron-right:before {\n  content: \"\\e876\";\n}\n\n.lnr-arrow-up:before {\n  content: \"\\e877\";\n}\n\n.lnr-arrow-down:before {\n  content: \"\\e878\";\n}\n\n.lnr-arrow-left:before {\n  content: \"\\e879\";\n}\n\n.lnr-arrow-right:before {\n  content: \"\\e87a\";\n}\n\n.lnr-move:before {\n  content: \"\\e87b\";\n}\n\n.lnr-warning:before {\n  content: \"\\e87c\";\n}\n\n.lnr-question-circle:before {\n  content: \"\\e87d\";\n}\n\n.lnr-menu-circle:before {\n  content: \"\\e87e\";\n}\n\n.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {\n  content: \"\\e87f\";\n}\n\n.lnr-cross-circle:before {\n  content: \"\\e880\";\n}\n\n.lnr-plus-circle:before {\n  content: \"\\e881\";\n}\n\n.lnr-circle-minus:before {\n  content: \"\\e882\";\n}\n\n.lnr-arrow-up-circle:before {\n  content: \"\\e883\";\n}\n\n.lnr-arrow-down-circle:before {\n  content: \"\\e884\";\n}\n\n.lnr-arrow-left-circle:before {\n  content: \"\\e885\";\n}\n\n.lnr-arrow-right-circle:before {\n  content: \"\\e886\";\n}\n\n.lnr-chevron-up-circle:before {\n  content: \"\\e887\";\n}\n\n.lnr-chevron-down-circle:before {\n  content: \"\\e888\";\n}\n\n.lnr-chevron-left-circle:before {\n  content: \"\\e889\";\n}\n\n.lnr-chevron-right-circle:before {\n  content: \"\\e88a\";\n}\n\n.lnr-crop:before {\n  content: \"\\e88b\";\n}\n\n.lnr-frame-expand:before {\n  content: \"\\e88c\";\n}\n\n.lnr-frame-contract:before {\n  content: \"\\e88d\";\n}\n\n.lnr-layers:before {\n  content: \"\\e88e\";\n}\n\n.lnr-funnel:before {\n  content: \"\\e88f\";\n}\n\n.lnr-text-format:before {\n  content: \"\\e890\";\n}\n\n.lnr-text-format-remove:before {\n  content: \"\\e891\";\n}\n\n.lnr-text-size:before {\n  content: \"\\e892\";\n}\n\n.lnr-bold:before {\n  content: \"\\e893\";\n}\n\n.lnr-italic:before {\n  content: \"\\e894\";\n}\n\n.lnr-underline:before {\n  content: \"\\e895\";\n}\n\n.lnr-strikethrough:before {\n  content: \"\\e896\";\n}\n\n.lnr-highlight:before {\n  content: \"\\e897\";\n}\n\n.lnr-text-align-left:before {\n  content: \"\\e898\";\n}\n\n.lnr-text-align-center:before {\n  content: \"\\e899\";\n}\n\n.lnr-text-align-right:before {\n  content: \"\\e89a\";\n}\n\n.lnr-text-align-justify:before {\n  content: \"\\e89b\";\n}\n\n.lnr-line-spacing:before {\n  content: \"\\e89c\";\n}\n\n.lnr-indent-increase:before {\n  content: \"\\e89d\";\n}\n\n.lnr-indent-decrease:before {\n  content: \"\\e89e\";\n}\n\n.lnr-pilcrow:before {\n  content: \"\\e89f\";\n}\n\n.lnr-direction-ltr:before {\n  content: \"\\e8a0\";\n}\n\n.lnr-direction-rtl:before {\n  content: \"\\e8a1\";\n}\n\n.lnr-page-break:before {\n  content: \"\\e8a2\";\n}\n\n.lnr-sort-alpha-asc:before {\n  content: \"\\e8a3\";\n}\n\n.lnr-sort-amount-asc:before {\n  content: \"\\e8a4\";\n}\n\n.lnr-hand:before {\n  content: \"\\e8a5\";\n}\n\n.lnr-pointer-up:before {\n  content: \"\\e8a6\";\n}\n\n.lnr-pointer-right:before {\n  content: \"\\e8a7\";\n}\n\n.lnr-pointer-down:before {\n  content: \"\\e8a8\";\n}\n\n.lnr-pointer-left:before {\n  content: \"\\e8a9\";\n}\n\n/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n@font-face {\n  font-family: \"Pe-icon-7-stroke\";\n  src: url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v\");\n  src: url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?#iefixd7yf1v\") format(\"embedded-opentype\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v\") format(\"woff\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v\") format(\"truetype\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=pe-7s-], [class*=\" pe-7s-\"] {\n  display: inline-block;\n  font-family: \"Pe-icon-7-stroke\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* HELPER CLASS\n * -------------------------- */\n/* FA based classes */\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: 1.1704rem;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 1.76rem;\n}\n\n.pe-3x {\n  font-size: 2.64rem;\n}\n\n.pe-4x {\n  font-size: 3.52rem;\n}\n\n.pe-5x {\n  font-size: 4.4rem;\n}\n\n.pe-fw {\n  width: 1.2857142857em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.pe-ul > li {\n  position: relative;\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  top: 0.1428571429em;\n  text-align: center;\n}\n.pe-li.pe-lg {\n  left: -1.8571428571em;\n}\n\n.pe-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: 0.1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe.pull-left {\n  float: left;\n  margin-right: 0.3em;\n  margin-left: 0.3em;\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n\n.pe-7s-album:before {\n  content: \"\\e6aa\";\n}\n\n.pe-7s-arc:before {\n  content: \"\\e6ab\";\n}\n\n.pe-7s-back-2:before {\n  content: \"\\e6ac\";\n}\n\n.pe-7s-bandaid:before {\n  content: \"\\e6ad\";\n}\n\n.pe-7s-car:before {\n  content: \"\\e6ae\";\n}\n\n.pe-7s-diamond:before {\n  content: \"\\e6af\";\n}\n\n.pe-7s-door-lock:before {\n  content: \"\\e6b0\";\n}\n\n.pe-7s-eyedropper:before {\n  content: \"\\e6b1\";\n}\n\n.pe-7s-female:before {\n  content: \"\\e6b2\";\n}\n\n.pe-7s-gym:before {\n  content: \"\\e6b3\";\n}\n\n.pe-7s-hammer:before {\n  content: \"\\e6b4\";\n}\n\n.pe-7s-headphones:before {\n  content: \"\\e6b5\";\n}\n\n.pe-7s-helm:before {\n  content: \"\\e6b6\";\n}\n\n.pe-7s-hourglass:before {\n  content: \"\\e6b7\";\n}\n\n.pe-7s-leaf:before {\n  content: \"\\e6b8\";\n}\n\n.pe-7s-magic-wand:before {\n  content: \"\\e6b9\";\n}\n\n.pe-7s-male:before {\n  content: \"\\e6ba\";\n}\n\n.pe-7s-map-2:before {\n  content: \"\\e6bb\";\n}\n\n.pe-7s-next-2:before {\n  content: \"\\e6bc\";\n}\n\n.pe-7s-paint-bucket:before {\n  content: \"\\e6bd\";\n}\n\n.pe-7s-pendrive:before {\n  content: \"\\e6be\";\n}\n\n.pe-7s-photo:before {\n  content: \"\\e6bf\";\n}\n\n.pe-7s-piggy:before {\n  content: \"\\e6c0\";\n}\n\n.pe-7s-plugin:before {\n  content: \"\\e6c1\";\n}\n\n.pe-7s-refresh-2:before {\n  content: \"\\e6c2\";\n}\n\n.pe-7s-rocket:before {\n  content: \"\\e6c3\";\n}\n\n.pe-7s-settings:before {\n  content: \"\\e6c4\";\n}\n\n.pe-7s-shield:before {\n  content: \"\\e6c5\";\n}\n\n.pe-7s-smile:before {\n  content: \"\\e6c6\";\n}\n\n.pe-7s-usb:before {\n  content: \"\\e6c7\";\n}\n\n.pe-7s-vector:before {\n  content: \"\\e6c8\";\n}\n\n.pe-7s-wine:before {\n  content: \"\\e6c9\";\n}\n\n.pe-7s-cloud-upload:before {\n  content: \"\\e68a\";\n}\n\n.pe-7s-cash:before {\n  content: \"\\e68c\";\n}\n\n.pe-7s-close:before {\n  content: \"\\e680\";\n}\n\n.pe-7s-bluetooth:before {\n  content: \"\\e68d\";\n}\n\n.pe-7s-cloud-download:before {\n  content: \"\\e68b\";\n}\n\n.pe-7s-way:before {\n  content: \"\\e68e\";\n}\n\n.pe-7s-close-circle:before {\n  content: \"\\e681\";\n}\n\n.pe-7s-id:before {\n  content: \"\\e68f\";\n}\n\n.pe-7s-angle-up:before {\n  content: \"\\e682\";\n}\n\n.pe-7s-wristwatch:before {\n  content: \"\\e690\";\n}\n\n.pe-7s-angle-up-circle:before {\n  content: \"\\e683\";\n}\n\n.pe-7s-world:before {\n  content: \"\\e691\";\n}\n\n.pe-7s-angle-right:before {\n  content: \"\\e684\";\n}\n\n.pe-7s-volume:before {\n  content: \"\\e692\";\n}\n\n.pe-7s-angle-right-circle:before {\n  content: \"\\e685\";\n}\n\n.pe-7s-users:before {\n  content: \"\\e693\";\n}\n\n.pe-7s-angle-left:before {\n  content: \"\\e686\";\n}\n\n.pe-7s-user-female:before {\n  content: \"\\e694\";\n}\n\n.pe-7s-angle-left-circle:before {\n  content: \"\\e687\";\n}\n\n.pe-7s-up-arrow:before {\n  content: \"\\e695\";\n}\n\n.pe-7s-angle-down:before {\n  content: \"\\e688\";\n}\n\n.pe-7s-switch:before {\n  content: \"\\e696\";\n}\n\n.pe-7s-angle-down-circle:before {\n  content: \"\\e689\";\n}\n\n.pe-7s-scissors:before {\n  content: \"\\e697\";\n}\n\n.pe-7s-wallet:before {\n  content: \"\\e600\";\n}\n\n.pe-7s-safe:before {\n  content: \"\\e698\";\n}\n\n.pe-7s-volume2:before {\n  content: \"\\e601\";\n}\n\n.pe-7s-volume1:before {\n  content: \"\\e602\";\n}\n\n.pe-7s-voicemail:before {\n  content: \"\\e603\";\n}\n\n.pe-7s-video:before {\n  content: \"\\e604\";\n}\n\n.pe-7s-user:before {\n  content: \"\\e605\";\n}\n\n.pe-7s-upload:before {\n  content: \"\\e606\";\n}\n\n.pe-7s-unlock:before {\n  content: \"\\e607\";\n}\n\n.pe-7s-umbrella:before {\n  content: \"\\e608\";\n}\n\n.pe-7s-trash:before {\n  content: \"\\e609\";\n}\n\n.pe-7s-tools:before {\n  content: \"\\e60a\";\n}\n\n.pe-7s-timer:before {\n  content: \"\\e60b\";\n}\n\n.pe-7s-ticket:before {\n  content: \"\\e60c\";\n}\n\n.pe-7s-target:before {\n  content: \"\\e60d\";\n}\n\n.pe-7s-sun:before {\n  content: \"\\e60e\";\n}\n\n.pe-7s-study:before {\n  content: \"\\e60f\";\n}\n\n.pe-7s-stopwatch:before {\n  content: \"\\e610\";\n}\n\n.pe-7s-star:before {\n  content: \"\\e611\";\n}\n\n.pe-7s-speaker:before {\n  content: \"\\e612\";\n}\n\n.pe-7s-signal:before {\n  content: \"\\e613\";\n}\n\n.pe-7s-shuffle:before {\n  content: \"\\e614\";\n}\n\n.pe-7s-shopbag:before {\n  content: \"\\e615\";\n}\n\n.pe-7s-share:before {\n  content: \"\\e616\";\n}\n\n.pe-7s-server:before {\n  content: \"\\e617\";\n}\n\n.pe-7s-search:before {\n  content: \"\\e618\";\n}\n\n.pe-7s-film:before {\n  content: \"\\e6a5\";\n}\n\n.pe-7s-science:before {\n  content: \"\\e619\";\n}\n\n.pe-7s-disk:before {\n  content: \"\\e6a6\";\n}\n\n.pe-7s-ribbon:before {\n  content: \"\\e61a\";\n}\n\n.pe-7s-repeat:before {\n  content: \"\\e61b\";\n}\n\n.pe-7s-refresh:before {\n  content: \"\\e61c\";\n}\n\n.pe-7s-add-user:before {\n  content: \"\\e6a9\";\n}\n\n.pe-7s-refresh-cloud:before {\n  content: \"\\e61d\";\n}\n\n.pe-7s-paperclip:before {\n  content: \"\\e69c\";\n}\n\n.pe-7s-radio:before {\n  content: \"\\e61e\";\n}\n\n.pe-7s-note2:before {\n  content: \"\\e69d\";\n}\n\n.pe-7s-print:before {\n  content: \"\\e61f\";\n}\n\n.pe-7s-network:before {\n  content: \"\\e69e\";\n}\n\n.pe-7s-prev:before {\n  content: \"\\e620\";\n}\n\n.pe-7s-mute:before {\n  content: \"\\e69f\";\n}\n\n.pe-7s-power:before {\n  content: \"\\e621\";\n}\n\n.pe-7s-medal:before {\n  content: \"\\e6a0\";\n}\n\n.pe-7s-portfolio:before {\n  content: \"\\e622\";\n}\n\n.pe-7s-like2:before {\n  content: \"\\e6a1\";\n}\n\n.pe-7s-plus:before {\n  content: \"\\e623\";\n}\n\n.pe-7s-left-arrow:before {\n  content: \"\\e6a2\";\n}\n\n.pe-7s-play:before {\n  content: \"\\e624\";\n}\n\n.pe-7s-key:before {\n  content: \"\\e6a3\";\n}\n\n.pe-7s-plane:before {\n  content: \"\\e625\";\n}\n\n.pe-7s-joy:before {\n  content: \"\\e6a4\";\n}\n\n.pe-7s-photo-gallery:before {\n  content: \"\\e626\";\n}\n\n.pe-7s-pin:before {\n  content: \"\\e69b\";\n}\n\n.pe-7s-phone:before {\n  content: \"\\e627\";\n}\n\n.pe-7s-plug:before {\n  content: \"\\e69a\";\n}\n\n.pe-7s-pen:before {\n  content: \"\\e628\";\n}\n\n.pe-7s-right-arrow:before {\n  content: \"\\e699\";\n}\n\n.pe-7s-paper-plane:before {\n  content: \"\\e629\";\n}\n\n.pe-7s-delete-user:before {\n  content: \"\\e6a7\";\n}\n\n.pe-7s-paint:before {\n  content: \"\\e62a\";\n}\n\n.pe-7s-bottom-arrow:before {\n  content: \"\\e6a8\";\n}\n\n.pe-7s-notebook:before {\n  content: \"\\e62b\";\n}\n\n.pe-7s-note:before {\n  content: \"\\e62c\";\n}\n\n.pe-7s-next:before {\n  content: \"\\e62d\";\n}\n\n.pe-7s-news-paper:before {\n  content: \"\\e62e\";\n}\n\n.pe-7s-musiclist:before {\n  content: \"\\e62f\";\n}\n\n.pe-7s-music:before {\n  content: \"\\e630\";\n}\n\n.pe-7s-mouse:before {\n  content: \"\\e631\";\n}\n\n.pe-7s-more:before {\n  content: \"\\e632\";\n}\n\n.pe-7s-moon:before {\n  content: \"\\e633\";\n}\n\n.pe-7s-monitor:before {\n  content: \"\\e634\";\n}\n\n.pe-7s-micro:before {\n  content: \"\\e635\";\n}\n\n.pe-7s-menu:before {\n  content: \"\\e636\";\n}\n\n.pe-7s-map:before {\n  content: \"\\e637\";\n}\n\n.pe-7s-map-marker:before {\n  content: \"\\e638\";\n}\n\n.pe-7s-mail:before {\n  content: \"\\e639\";\n}\n\n.pe-7s-mail-open:before {\n  content: \"\\e63a\";\n}\n\n.pe-7s-mail-open-file:before {\n  content: \"\\e63b\";\n}\n\n.pe-7s-magnet:before {\n  content: \"\\e63c\";\n}\n\n.pe-7s-loop:before {\n  content: \"\\e63d\";\n}\n\n.pe-7s-look:before {\n  content: \"\\e63e\";\n}\n\n.pe-7s-lock:before {\n  content: \"\\e63f\";\n}\n\n.pe-7s-lintern:before {\n  content: \"\\e640\";\n}\n\n.pe-7s-link:before {\n  content: \"\\e641\";\n}\n\n.pe-7s-like:before {\n  content: \"\\e642\";\n}\n\n.pe-7s-light:before {\n  content: \"\\e643\";\n}\n\n.pe-7s-less:before {\n  content: \"\\e644\";\n}\n\n.pe-7s-keypad:before {\n  content: \"\\e645\";\n}\n\n.pe-7s-junk:before {\n  content: \"\\e646\";\n}\n\n.pe-7s-info:before {\n  content: \"\\e647\";\n}\n\n.pe-7s-home:before {\n  content: \"\\e648\";\n}\n\n.pe-7s-help2:before {\n  content: \"\\e649\";\n}\n\n.pe-7s-help1:before {\n  content: \"\\e64a\";\n}\n\n.pe-7s-graph3:before {\n  content: \"\\e64b\";\n}\n\n.pe-7s-graph2:before {\n  content: \"\\e64c\";\n}\n\n.pe-7s-graph1:before {\n  content: \"\\e64d\";\n}\n\n.pe-7s-graph:before {\n  content: \"\\e64e\";\n}\n\n.pe-7s-global:before {\n  content: \"\\e64f\";\n}\n\n.pe-7s-gleam:before {\n  content: \"\\e650\";\n}\n\n.pe-7s-glasses:before {\n  content: \"\\e651\";\n}\n\n.pe-7s-gift:before {\n  content: \"\\e652\";\n}\n\n.pe-7s-folder:before {\n  content: \"\\e653\";\n}\n\n.pe-7s-flag:before {\n  content: \"\\e654\";\n}\n\n.pe-7s-filter:before {\n  content: \"\\e655\";\n}\n\n.pe-7s-file:before {\n  content: \"\\e656\";\n}\n\n.pe-7s-expand1:before {\n  content: \"\\e657\";\n}\n\n.pe-7s-exapnd2:before {\n  content: \"\\e658\";\n}\n\n.pe-7s-edit:before {\n  content: \"\\e659\";\n}\n\n.pe-7s-drop:before {\n  content: \"\\e65a\";\n}\n\n.pe-7s-drawer:before {\n  content: \"\\e65b\";\n}\n\n.pe-7s-download:before {\n  content: \"\\e65c\";\n}\n\n.pe-7s-display2:before {\n  content: \"\\e65d\";\n}\n\n.pe-7s-display1:before {\n  content: \"\\e65e\";\n}\n\n.pe-7s-diskette:before {\n  content: \"\\e65f\";\n}\n\n.pe-7s-date:before {\n  content: \"\\e660\";\n}\n\n.pe-7s-cup:before {\n  content: \"\\e661\";\n}\n\n.pe-7s-culture:before {\n  content: \"\\e662\";\n}\n\n.pe-7s-crop:before {\n  content: \"\\e663\";\n}\n\n.pe-7s-credit:before {\n  content: \"\\e664\";\n}\n\n.pe-7s-copy-file:before {\n  content: \"\\e665\";\n}\n\n.pe-7s-config:before {\n  content: \"\\e666\";\n}\n\n.pe-7s-compass:before {\n  content: \"\\e667\";\n}\n\n.pe-7s-comment:before {\n  content: \"\\e668\";\n}\n\n.pe-7s-coffee:before {\n  content: \"\\e669\";\n}\n\n.pe-7s-cloud:before {\n  content: \"\\e66a\";\n}\n\n.pe-7s-clock:before {\n  content: \"\\e66b\";\n}\n\n.pe-7s-check:before {\n  content: \"\\e66c\";\n}\n\n.pe-7s-chat:before {\n  content: \"\\e66d\";\n}\n\n.pe-7s-cart:before {\n  content: \"\\e66e\";\n}\n\n.pe-7s-camera:before {\n  content: \"\\e66f\";\n}\n\n.pe-7s-call:before {\n  content: \"\\e670\";\n}\n\n.pe-7s-calculator:before {\n  content: \"\\e671\";\n}\n\n.pe-7s-browser:before {\n  content: \"\\e672\";\n}\n\n.pe-7s-box2:before {\n  content: \"\\e673\";\n}\n\n.pe-7s-box1:before {\n  content: \"\\e674\";\n}\n\n.pe-7s-bookmarks:before {\n  content: \"\\e675\";\n}\n\n.pe-7s-bicycle:before {\n  content: \"\\e676\";\n}\n\n.pe-7s-bell:before {\n  content: \"\\e677\";\n}\n\n.pe-7s-battery:before {\n  content: \"\\e678\";\n}\n\n.pe-7s-ball:before {\n  content: \"\\e679\";\n}\n\n.pe-7s-back:before {\n  content: \"\\e67a\";\n}\n\n.pe-7s-attention:before {\n  content: \"\\e67b\";\n}\n\n.pe-7s-anchor:before {\n  content: \"\\e67c\";\n}\n\n.pe-7s-albums:before {\n  content: \"\\e67d\";\n}\n\n.pe-7s-alarm:before {\n  content: \"\\e67e\";\n}\n\n.pe-7s-airplay:before {\n  content: \"\\e67f\";\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -6px;\n  position: absolute;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 6px solid transparent;\n  height: 0;\n  width: 1px;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  content: \"\";\n  z-index: -1;\n  border-width: 6px;\n  left: -6px;\n  border-bottom-color: #dee2e6;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -6px;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #fff;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #dee2e6;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -6px;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: -1px;\n  border-top-color: #dee2e6;\n}\n\n.react-datepicker-wrapper {\n  display: block;\n  z-index: 10;\n}\n\n.react-datepicker {\n  background-color: #fff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  display: inline-block;\n  position: relative;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 102;\n}\n.react-datepicker-popper[data-placement^=bottom] {\n  margin-top: 8px;\n}\n.react-datepicker-popper[data-placement^=top] {\n  margin-bottom: 8px;\n}\n.react-datepicker-popper[data-placement^=right] {\n  margin-left: 6px;\n}\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n.react-datepicker-popper[data-placement^=left] {\n  margin-right: 6px;\n}\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #fff;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n  padding-top: 10px;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n  margin-top: 0;\n  color: #343a40;\n  font-weight: bold;\n  font-size: 0.968rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 2rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 15px;\n  padding: 0;\n  border: 0.35rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ced4da;\n}\n.react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ced4da;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 80px;\n}\n.react-datepicker__navigation--next:hover {\n  border-left-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ced4da;\n}\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ced4da;\n}\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: 0.5rem;\n  text-align: center;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #dee2e6;\n  width: 120px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -122px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 120px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  height: calc(195px + 2rem / 2);\n  overflow-y: scroll;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  padding: 5px 10px;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #e0f3ff;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: theme-color(\"primary\");\n  color: #fff;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: theme-color(\"primary\");\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ced4da;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ced4da;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.25rem;\n  background-color: #fff;\n}\n\n.react-datepicker__day-names {\n  background: #f8f9fa;\n  border-top: #dee2e6 solid 1px;\n  margin-top: 10px;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #495057;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day {\n  cursor: pointer;\n  border-radius: 0.25rem;\n}\n.react-datepicker__day:hover {\n  background-color: #545cd8;\n  color: #fff;\n}\n.react-datepicker__day--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted {\n  border-radius: 0.25rem;\n  background-color: #545cd8;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover {\n  background-color: rgb(63.2357142857, 72.2071428571, 211.2642857143);\n}\n.react-datepicker__day--highlighted-custom-1 {\n  color: #f7b924;\n}\n.react-datepicker__day--highlighted-custom-2 {\n  color: #444054;\n}\n.react-datepicker__day--selected {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {\n  background-color: #e0f3ff;\n  color: rgb(29.7, 33.3, 36.9);\n}\n.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {\n  background-color: #e0f3ff;\n  color: rgb(29.7, 33.3, 36.9);\n}\n.react-datepicker__day--keyboard-selected {\n  border-radius: 0.25rem;\n  background-color: rgb(96.811023622, 208.188976378, 150.8858267717);\n  color: #fff;\n}\n.react-datepicker__day--keyboard-selected:hover {\n  background-color: rgb(52.1771653543, 176.3228346457, 112.4507874016);\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {\n  background-color: #e0f3ff;\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--disabled {\n  cursor: default;\n  color: #ced4da;\n}\n.react-datepicker__day--disabled:hover {\n  background-color: transparent;\n  color: #ced4da;\n}\n\n.react-datepicker__day--selecting-range-start,\n.react-datepicker__day--selecting-range-end {\n  background-color: #3ac47d !important;\n  color: #fff !important;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ced4da;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.35rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #fff;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.25rem;\n  border: 1px solid #dee2e6;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ced4da;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n}\n.react-datepicker__close-icon::after {\n  background-color: theme-color(\"primary\");\n  border-radius: 50%;\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  content: \"×\";\n  cursor: pointer;\n  font-size: 12px;\n  height: 16px;\n  width: 16px;\n  line-height: 1;\n  margin: -8px auto 0;\n  padding: 2px;\n  position: absolute;\n  right: 0px;\n  text-align: center;\n}\n\n.react-datepicker__today-button {\n  background: #fff;\n  border-top: 1px solid #dee2e6;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1040;\n  background-color: rgba(0, 0, 0, 0.5);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.584rem;\n}\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.63rem solid transparent;\n  margin-top: 3px;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #545cd8;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n}\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #545cd8;\n}\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n}\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n\n.rangeButtonSelectedStyle {\n  background: #545cd8 !important;\n}\n\n.rangebuttonstyle {\n  outline: none !important;\n  color: #545cd8 !important;\n}\n\n.rc-slider-tooltip {\n  z-index: 555;\n}\n\n.rc-tooltip.rc-tooltip-zoom-enter,\n.rc-tooltip.rc-tooltip-zoom-leave {\n  display: block;\n}\n\n.rc-tooltip-zoom-enter,\n.rc-tooltip-zoom-appear {\n  opacity: 0;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\n  animation-name: rcToolTipZoomIn;\n  animation-play-state: running;\n}\n\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\n  animation-name: rcToolTipZoomOut;\n  animation-play-state: running;\n}\n\n@keyframes rcToolTipZoomIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcToolTipZoomOut {\n  0% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n}\n.rc-tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.rc-tooltip-hidden {\n  display: none;\n}\n\n.rc-tooltip-placement-top,\n.rc-tooltip-placement-topLeft,\n.rc-tooltip-placement-topRight {\n  padding: 5px 0 9px 0;\n}\n\n.rc-tooltip-placement-right,\n.rc-tooltip-placement-rightTop,\n.rc-tooltip-placement-rightBottom {\n  padding: 0 5px 0 9px;\n}\n\n.rc-tooltip-placement-bottom,\n.rc-tooltip-placement-bottomLeft,\n.rc-tooltip-placement-bottomRight {\n  padding: 9px 0 5px 0;\n}\n\n.rc-tooltip-placement-left,\n.rc-tooltip-placement-leftTop,\n.rc-tooltip-placement-leftBottom {\n  padding: 0 9px 0 5px;\n}\n\n.rc-tooltip-inner {\n  padding: 12px 14px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  background-color: #343a40;\n  border-radius: 6px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\n  min-height: 34px;\n  font-weight: bold;\n}\n\n.rc-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow,\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  bottom: 4px;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #343a40;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow,\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  left: 4px;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #343a40;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow,\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  right: 4px;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #343a40;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  top: 4px;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #343a40;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-slider {\n  position: relative;\n  height: 20px;\n  padding: 8px 0 0;\n  width: 100%;\n  border-radius: 0.25rem;\n  -ms-touch-action: none;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: #e9ecef;\n  height: 4px;\n  border-radius: 0.25rem;\n}\n\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  border-radius: 0.25rem;\n  background-color: #545cd8;\n}\n\n.rc-slider-handle {\n  position: absolute;\n  margin-left: -8px;\n  margin-top: -6px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px #545cd8;\n  background-color: #fff;\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n  transition: box-shadow 200ms;\n}\n.rc-slider-handle:focus {\n  outline: none;\n}\n.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {\n  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);\n}\n.rc-slider-handle:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: #6c757d;\n}\n\n.rc-slider-mark-text-active {\n  color: #343a40;\n}\n\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #dee2e6;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n\n.rc-slider-dot-active {\n  border-color: #545cd8;\n}\n\n.rc-slider-disabled {\n  background-color: #e9ecef;\n}\n\n.rc-slider-disabled .rc-slider-track {\n  background-color: #ced4da;\n}\n\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: #ced4da;\n  box-shadow: none;\n  background-color: #fff;\n  cursor: not-allowed;\n}\n\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -6px;\n  margin-bottom: -7px;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n\n.rc-slider-tooltip-inner {\n  padding: 0 8px;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  color: #fff;\n  text-align: center;\n  text-decoration: none;\n  background-color: #212529;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  font-weight: bold;\n}\n\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #212529;\n}\n\n.rc-slider-primary .rc-slider-track {\n  background-color: #545cd8;\n}\n.rc-slider-primary .rc-slider-handle {\n  border-color: #545cd8;\n  background-color: #fff;\n}\n.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {\n  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);\n}\n.rc-slider-primary .rc-slider-dot-active {\n  border-color: #545cd8;\n}\n\n.rc-slider-secondary .rc-slider-track {\n  background-color: #6c757d;\n}\n.rc-slider-secondary .rc-slider-handle {\n  border-color: #6c757d;\n  background-color: #fff;\n}\n.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {\n  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);\n}\n.rc-slider-secondary .rc-slider-dot-active {\n  border-color: #6c757d;\n}\n\n.rc-slider-success .rc-slider-track {\n  background-color: #3ac47d;\n}\n.rc-slider-success .rc-slider-handle {\n  border-color: #3ac47d;\n  background-color: #fff;\n}\n.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {\n  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);\n}\n.rc-slider-success .rc-slider-dot-active {\n  border-color: #3ac47d;\n}\n\n.rc-slider-info .rc-slider-track {\n  background-color: #30b1ff;\n}\n.rc-slider-info .rc-slider-handle {\n  border-color: #30b1ff;\n  background-color: #fff;\n}\n.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {\n  border-color: rgb(0, 141.152173913, 226.5);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);\n}\n.rc-slider-info .rc-slider-dot-active {\n  border-color: #30b1ff;\n}\n\n.rc-slider-warning .rc-slider-track {\n  background-color: #f7b924;\n}\n.rc-slider-warning .rc-slider-handle {\n  border-color: #f7b924;\n  background-color: #fff;\n}\n.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {\n  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);\n}\n.rc-slider-warning .rc-slider-dot-active {\n  border-color: #f7b924;\n}\n\n.rc-slider-danger .rc-slider-track {\n  background-color: #d92550;\n}\n.rc-slider-danger .rc-slider-handle {\n  border-color: #d92550;\n  background-color: #fff;\n}\n.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {\n  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);\n}\n.rc-slider-danger .rc-slider-dot-active {\n  border-color: #d92550;\n}\n\n.rc-slider-light .rc-slider-track {\n  background-color: #eeeeee;\n}\n.rc-slider-light .rc-slider-handle {\n  border-color: #eeeeee;\n  background-color: #fff;\n}\n.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {\n  border-color: rgb(199.75, 199.75, 199.75);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);\n}\n.rc-slider-light .rc-slider-dot-active {\n  border-color: #eeeeee;\n}\n\n.rc-slider-dark .rc-slider-track {\n  background-color: #343a40;\n}\n.rc-slider-dark .rc-slider-handle {\n  border-color: #343a40;\n  background-color: #fff;\n}\n.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {\n  border-color: rgb(17.7068965517, 19.75, 21.7931034483);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);\n}\n.rc-slider-dark .rc-slider-dot-active {\n  border-color: #343a40;\n}\n\n.rc-slider-focus .rc-slider-track {\n  background-color: #444054;\n}\n.rc-slider-focus .rc-slider-handle {\n  border-color: #444054;\n  background-color: #fff;\n}\n.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {\n  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);\n}\n.rc-slider-focus .rc-slider-dot-active {\n  border-color: #444054;\n}\n\n.rc-slider-alternate .rc-slider-track {\n  background-color: #83588a;\n}\n.rc-slider-alternate .rc-slider-handle {\n  border-color: #83588a;\n  background-color: #fff;\n}\n.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {\n  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);\n}\n.rc-slider-alternate .rc-slider-dot-active {\n  border-color: #83588a;\n}\n\n.rc-slider-line .rc-slider-handle {\n  border-radius: 0;\n  border-width: 0 3px 0 0;\n  margin-left: -8px;\n  width: 10px;\n  background-color: transparent;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.rc-slider-square .rc-slider-handle {\n  border-radius: 3px;\n  border-widtH: 1px;\n}\n.rc-slider-square .rc-slider-handle:before {\n  position: absolute;\n  height: 8px;\n  width: 4px;\n  border: #adb5bd solid 1px;\n  border-width: 0 1px;\n  display: block;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -4px -2px;\n}\n\n.rc-slider-lg.rc-slider {\n  height: 20px;\n  padding: 8px 0 0;\n}\n.rc-slider-lg .rc-slider-rail {\n  height: 4px;\n}\n.rc-slider-lg .rc-slider-track {\n  height: 4px;\n}\n.rc-slider-lg .rc-slider-handle {\n  margin-left: -10px;\n  margin-top: -8px;\n  width: 20px;\n  height: 20px;\n}\n.rc-slider-lg.rc-slider-line .rc-slider-handle {\n  margin-left: -8px;\n  width: 10px;\n}\n.rc-slider-lg.rc-slider-square .rc-slider-handle:before {\n  height: 10px;\n  width: 6px;\n  margin: -5px -3px;\n}\n\n.rc-slider-sm.rc-slider {\n  height: 20px;\n  padding: 8px 0 0;\n}\n.rc-slider-sm .rc-slider-rail {\n  height: 4px;\n}\n.rc-slider-sm .rc-slider-track {\n  height: 4px;\n}\n.rc-slider-sm .rc-slider-handle {\n  margin-left: -6px;\n  margin-top: -4px;\n  width: 12px;\n  height: 12px;\n}\n.rc-slider-sm.rc-slider-line .rc-slider-handle {\n  margin-left: -8px;\n  width: 10px;\n}\n.rc-slider-sm.rc-slider-square .rc-slider-handle:before {\n  height: 6px;\n  margin: -3px 0 0 -1px;\n  border: 0;\n  width: 2px;\n  background: #adb5bd;\n}\n\n.rdw-option-wrapper {\n  border: 1px solid #F1F1F1;\n  padding: 5px;\n  min-width: 25px;\n  height: 20px;\n  border-radius: 2px;\n  margin: 0 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-option-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-option-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-option-active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-option-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.rdw-dropdown-wrapper {\n  height: 30px;\n  background: white;\n  cursor: pointer;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  margin: 0 3px;\n  text-transform: capitalize;\n  background: white;\n}\n\n.rdw-dropdown-wrapper:focus {\n  outline: none;\n}\n\n.rdw-dropdown-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n\n.rdw-dropdown-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-dropdown-carettoopen {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-top: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.rdw-dropdown-carettoclose {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-bottom: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.rdw-dropdown-selectedtext {\n  display: flex;\n  position: relative;\n  height: 100%;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.rdw-dropdown-optionwrapper {\n  z-index: 100;\n  position: relative;\n  border: 1px solid #F1F1F1;\n  width: 98%;\n  background: white;\n  border-radius: 2px;\n  margin: 0;\n  padding: 0;\n  max-height: 250px;\n  overflow-y: scroll;\n}\n\n.rdw-dropdown-optionwrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n\n.rdw-dropdownoption-default {\n  min-height: 25px;\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.rdw-dropdownoption-highlighted {\n  background: #F1F1F1;\n}\n\n.rdw-dropdownoption-active {\n  background: #f5f5f5;\n}\n\n.rdw-dropdownoption-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.rdw-inline-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-inline-dropdown {\n  width: 50px;\n}\n\n.rdw-inline-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-block-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-block-dropdown {\n  width: 110px;\n}\n\n.rdw-fontsize-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-fontsize-dropdown {\n  min-width: 40px;\n}\n\n.rdw-fontsize-option {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-fontfamily-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-fontfamily-dropdown {\n  width: 115px;\n}\n\n.rdw-fontfamily-placeholder {\n  white-space: nowrap;\n  max-width: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rdw-fontfamily-optionwrapper {\n  width: 140px;\n}\n\n.rdw-list-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-list-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n\n.rdw-list-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-text-align-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-text-align-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n\n.rdw-text-align-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-right-aligned-block {\n  text-align: right;\n}\n\n.rdw-left-aligned-block {\n  text-align: left !important;\n}\n\n.rdw-center-aligned-block {\n  text-align: center !important;\n}\n\n.rdw-justify-aligned-block {\n  text-align: justify !important;\n}\n\n.rdw-right-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-left-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-center-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-justify-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-colorpicker-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-colorpicker-modal-header {\n  display: flex;\n  padding-bottom: 5px;\n}\n\n.rdw-colorpicker-modal-style-label {\n  font-size: 15px;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  padding: 0 10px 5px;\n}\n\n.rdw-colorpicker-modal-style-label-active {\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-colorpicker-modal-options {\n  margin: 5px auto;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  overflow: scroll;\n}\n\n.rdw-colorpicker-cube {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #F1F1F1;\n}\n\n.rdw-colorpicker-option {\n  margin: 3px;\n  padding: 0;\n  min-height: 20px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  box-shadow: 1px 2px 1px #BFBDBD inset;\n}\n\n.rdw-colorpicker-option:hover {\n  box-shadow: 1px 2px 1px #BFBDBD;\n}\n\n.rdw-colorpicker-option:active {\n  box-shadow: -1px -2px 1px #BFBDBD;\n}\n\n.rdw-colorpicker-option-active {\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\n}\n\n.rdw-link-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-link-dropdown {\n  width: 50px;\n}\n\n.rdw-link-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-link-dropdownPlaceholder {\n  margin-left: 8px;\n}\n\n.rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 205px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-link-modal-label {\n  font-size: 15px;\n}\n\n.rdw-link-modal-input {\n  margin-top: 5px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  height: 25px;\n  margin-bottom: 15px;\n  padding: 0 5px;\n}\n\n.rdw-link-modal-input:focus {\n  outline: none;\n}\n\n.rdw-link-modal-buttonsection {\n  margin: 0 auto;\n}\n\n.rdw-link-modal-target-option {\n  margin-bottom: 20px;\n}\n\n.rdw-link-modal-target-option > span {\n  margin-left: 5px;\n}\n\n.rdw-link-modal-btn {\n  margin-left: 10px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-link-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-link-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-link-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-link-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-link-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-history-dropdown {\n  width: 50px;\n}\n\n.rdw-embedded-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-embedded-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  justify-content: space-between;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-embedded-modal-header {\n  font-size: 15px;\n  display: flex;\n}\n\n.rdw-embedded-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.rdw-embedded-modal-header-label {\n  width: 95px;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-embedded-modal-link-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.rdw-embedded-modal-link-input {\n  width: 88%;\n  height: 35px;\n  margin: 10px 0;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n\n.rdw-embedded-modal-link-input-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.rdw-embedded-modal-link-input:focus {\n  outline: none;\n}\n\n.rdw-embedded-modal-btn-section {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-embedded-modal-btn {\n  margin: 0 3px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-embedded-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-embedded-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-embedded-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-embedded-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-embedded-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n\n.rdw-embedded-modal-size-input {\n  width: 80%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n\n.rdw-embedded-modal-size-input:focus {\n  outline: none;\n}\n\n.rdw-emoji-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-emoji-modal {\n  overflow: auto;\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-emoji-icon {\n  margin: 2.5px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  font-size: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rdw-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.rdw-spinner > div {\n  width: 12px;\n  height: 12px;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.rdw-spinner .rdw-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.rdw-spinner .rdw-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.rdw-image-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-image-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-image-modal-header {\n  font-size: 15px;\n  margin: 10px 0;\n  display: flex;\n}\n\n.rdw-image-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.rdw-image-modal-header-label {\n  width: 80px;\n  background: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n}\n\n.rdw-image-modal-header-label-highlighted {\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-image-modal-upload-option {\n  width: 100%;\n  color: gray;\n  cursor: pointer;\n  display: flex;\n  border: none;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f1f1f1;\n  outline: 2px dashed gray;\n  outline-offset: -10px;\n  margin: 10px 0;\n  padding: 9px 0;\n}\n\n.rdw-image-modal-upload-option-highlighted {\n  outline: 2px dashed #0a66b7;\n}\n\n.rdw-image-modal-upload-option-label {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n}\n\n.rdw-image-modal-upload-option-label span {\n  padding: 0 20px;\n}\n\n.rdw-image-modal-upload-option-image-preview {\n  max-width: 100%;\n  max-height: 200px;\n}\n\n.rdw-image-modal-upload-option-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.rdw-image-modal-url-section {\n  display: flex;\n  align-items: center;\n}\n\n.rdw-image-modal-url-input {\n  width: 90%;\n  height: 35px;\n  margin: 15px 0 12px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n\n.rdw-image-modal-btn-section {\n  margin: 10px auto 0;\n}\n\n.rdw-image-modal-url-input:focus {\n  outline: none;\n}\n\n.rdw-image-modal-btn {\n  margin: 0 5px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-image-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-image-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-image-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-image-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-image-modal-spinner {\n  position: absolute;\n  top: -3px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n\n.rdw-image-modal-alt-input {\n  width: 70%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n\n.rdw-image-modal-alt-input:focus {\n  outline: none;\n}\n\n.rdw-image-modal-alt-lbl {\n  font-size: 12px;\n}\n\n.rdw-image-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n\n.rdw-image-modal-size-input {\n  width: 40%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n\n.rdw-image-modal-size-input:focus {\n  outline: none;\n}\n\n.rdw-image-mandatory-sign {\n  color: red;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n.rdw-remove-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-history-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-history-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-history-dropdown {\n  width: 50px;\n}\n\n.rdw-link-decorator-wrapper {\n  position: relative;\n}\n\n.rdw-link-decorator-icon {\n  position: absolute;\n  left: 40%;\n  top: 0;\n  cursor: pointer;\n  background-color: white;\n}\n\n.rdw-mention-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.rdw-suggestion-wrapper {\n  position: relative;\n}\n\n.rdw-suggestion-dropdown {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #F1F1F1;\n  min-width: 100px;\n  max-height: 150px;\n  overflow: auto;\n  background: white;\n  z-index: 100;\n}\n\n.rdw-suggestion-option {\n  padding: 7px 5px;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.rdw-suggestion-option-active {\n  background-color: #F1F1F1;\n}\n\n.rdw-hashtag-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.rdw-image-alignment-options-popup {\n  position: absolute;\n  background: white;\n  display: flex;\n  padding: 5px 2px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  width: 105px;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.rdw-alignment-option-left {\n  justify-content: flex-start;\n}\n\n.rdw-image-alignment-option {\n  height: 15px;\n  width: 15px;\n  min-width: 15px;\n}\n\n.rdw-image-alignment {\n  position: relative;\n}\n\n.rdw-image-imagewrapper {\n  position: relative;\n}\n\n.rdw-image-center {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-image-left {\n  display: flex;\n}\n\n.rdw-image-right {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rdw-image-alignment-options-popup-right {\n  right: 0;\n}\n\n.rdw-editor-main {\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n}\n\n.rdw-editor-toolbar {\n  padding: 6px 5px 0;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  display: flex;\n  justify-content: flex-start;\n  background: white;\n  flex-wrap: wrap;\n  font-size: 15px;\n  margin-bottom: 5px;\n  user-select: none;\n}\n\n.public-DraftStyleDefault-block {\n  margin: 1em 0;\n}\n\n.rdw-editor-wrapper:focus {\n  outline: none;\n}\n\n.rdw-editor-wrapper {\n  box-sizing: content-box;\n}\n\n.rdw-editor-main blockquote {\n  border-left: 5px solid #f1f1f1;\n  padding-left: 5px;\n}\n\n.rdw-editor-main pre {\n  background: #f1f1f1;\n  border-radius: 3px;\n  padding: 1px 10px;\n} /**\n* Draft v0.9.1\n*\n* Copyright (c) 2013-present, Facebook, Inc.\n* All rights reserved.\n*\n* This source code is licensed under the BSD-style license found in the\n* LICENSE file in the root directory of this source tree. An additional grant\n* of patent rights can be found in the PATENTS file in the same directory.\n*/\n.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {\n  height: inherit;\n  text-align: initial;\n}\n\n.public-DraftEditor-content[contenteditable=true] {\n  -webkit-user-modify: read-write-plaintext-only;\n}\n\n.DraftEditor-root {\n  position: relative;\n}\n\n.DraftEditor-editorContainer {\n  background-color: rgba(255, 255, 255, 0);\n  border-left: 0.1px solid transparent;\n  position: relative;\n  z-index: 1;\n}\n\n.public-DraftEditor-block {\n  position: relative;\n}\n\n.DraftEditor-alignLeft .public-DraftStyleDefault-block {\n  text-align: left;\n}\n\n.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {\n  left: 0;\n  text-align: left;\n}\n\n.DraftEditor-alignCenter .public-DraftStyleDefault-block {\n  text-align: center;\n}\n\n.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {\n  margin: 0 auto;\n  text-align: center;\n  width: 100%;\n}\n\n.DraftEditor-alignRight .public-DraftStyleDefault-block {\n  text-align: right;\n}\n\n.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {\n  right: 0;\n  text-align: right;\n}\n\n.public-DraftEditorPlaceholder-root {\n  color: #9197a3;\n  position: absolute;\n  z-index: 0;\n}\n\n.public-DraftEditorPlaceholder-hasFocus {\n  color: #bdc1c9;\n}\n\n.DraftEditorPlaceholder-hidden {\n  display: none;\n}\n\n.public-DraftStyleDefault-block {\n  position: relative;\n  white-space: pre-wrap;\n}\n\n.public-DraftStyleDefault-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n.public-DraftStyleDefault-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n.public-DraftStyleDefault-listLTR {\n  direction: ltr;\n}\n\n.public-DraftStyleDefault-listRTL {\n  direction: rtl;\n}\n\n.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {\n  margin: 16px 0;\n  padding: 0;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n  margin-left: 1.5em;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {\n  margin-right: 1.5em;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {\n  margin-left: 3em;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {\n  margin-right: 3em;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {\n  margin-left: 4.5em;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {\n  margin-right: 4.5em;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {\n  margin-left: 6em;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {\n  margin-right: 6em;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {\n  margin-left: 7.5em;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {\n  margin-right: 7.5em;\n}\n\n.public-DraftStyleDefault-unorderedListItem {\n  list-style-type: square;\n  position: relative;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {\n  list-style-type: disc;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {\n  list-style-type: circle;\n}\n\n.public-DraftStyleDefault-orderedListItem {\n  list-style-type: none;\n  position: relative;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {\n  left: -36px;\n  position: absolute;\n  text-align: right;\n  width: 30px;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {\n  position: absolute;\n  right: -36px;\n  text-align: left;\n  width: 30px;\n}\n\n.public-DraftStyleDefault-orderedListItem:before {\n  content: counter(ol0) \". \";\n  counter-increment: ol0;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {\n  content: counter(ol1) \". \";\n  counter-increment: ol1;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {\n  content: counter(ol2) \". \";\n  counter-increment: ol2;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {\n  content: counter(ol3) \". \";\n  counter-increment: ol3;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {\n  content: counter(ol4) \". \";\n  counter-increment: ol4;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {\n  counter-reset: ol0;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {\n  counter-reset: ol1;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {\n  counter-reset: ol2;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {\n  counter-reset: ol3;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {\n  counter-reset: ol4;\n}\n\n.demo-editor {\n  height: 275px !important;\n  border: 1px solid #F1F1F1 !important;\n  padding: 5px !important;\n  border-radius: 2px !important;\n}\n\n.has-switch {\n  border-radius: 30px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.72222;\n  overflow: hidden;\n  position: relative;\n  text-align: left;\n  width: 60px;\n  user-select: none;\n}\n\n.has-switch.deactivate {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.has-switch.deactivate label,\n.has-switch.deactivate span {\n  cursor: default !important;\n}\n\n.has-switch > div {\n  position: relative;\n  top: 0;\n  width: 100px;\n}\n\n.has-switch > div.switch-animate {\n  transition: left 0.25s ease-out;\n}\n\n.has-switch > div.switch-off {\n  left: -35px;\n}\n\n.has-switch > div.switch-on {\n  left: 0;\n}\n\n.has-switch > div label {\n  background-color: #FFFFFF;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);\n  background-size: 150% 150%;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n\n.has-switch input[type=checkbox] {\n  display: none;\n}\n\n.has-switch span {\n  cursor: pointer;\n  float: left;\n  font-size: 11px;\n  font-weight: 400;\n  height: 24px;\n  line-height: 15px;\n  margin: 0;\n  padding-bottom: 6px;\n  padding-top: 5px;\n  position: relative;\n  text-align: center;\n  text-indent: -10px;\n  width: 50%;\n  z-index: 1;\n  transition: 0.25s ease-out;\n}\n\n.has-switch span.switch-left {\n  background-color: #545cd8;\n  border-left: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 30px 0 0 30px;\n  color: #FFFFFF;\n}\n\n.has-switch .switch-off span.switch-left {\n  background-color: #ced4da !important;\n}\n\n.has-switch span.switch-right {\n  border-radius: 0 30px 30px 0;\n  background-color: #545cd8;\n  color: #ffffff;\n  text-indent: 1px;\n}\n\n.has-switch .switch-off span.switch-right {\n  background-color: #ced4da !important;\n}\n\n.has-switch label {\n  border-radius: 12px;\n  float: left;\n  height: 22px;\n  margin: 1px -13px;\n  padding: 0;\n  position: relative;\n  vertical-align: middle;\n  width: 22px;\n  z-index: 10;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n\n.has-switch .switch-on .fa-check:before {\n  margin-left: 10px;\n}\n\n.has-switch:hover .switch-on label {\n  margin: 1px -17px;\n  width: 26px;\n}\n\n.has-switch:hover .switch-off label {\n  margin: 1px -13px;\n  width: 26px;\n}\n\n.has-switch-sm.has-switch span {\n  height: 18px;\n  line-height: 18px;\n  padding: 0;\n}\n.has-switch-sm.has-switch label {\n  height: 16px;\n  width: 16px;\n  margin: 1px -8px;\n}\n.has-switch-sm.has-switch .switch-off label {\n  margin: 1px -13px;\n}\n.has-switch-sm.has-switch:hover .switch-on label {\n  margin: 1px -11px;\n  width: 20px;\n}\n.has-switch-sm.has-switch:hover .switch-off label {\n  margin: 1px -13px;\n  width: 20px;\n}\n\n.dropzone-wrapper {\n  width: 100%;\n  border: #ced4da dashed 2px;\n  border-radius: 0.3rem;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  height: 230px;\n  transition: all 0.2s;\n}\n.dropzone-wrapper:hover {\n  border-color: #545cd8;\n}\n.dropzone-wrapper > div {\n  width: 100%;\n  height: 100%;\n  outline: none !important;\n  display: flex;\n  align-items: center;\n}\n.dropzone-wrapper.dropzone-wrapper-lg {\n  height: 300px;\n}\n.dropzone-wrapper.dropzone-wrapper-sm {\n  height: 150px;\n}\n.dropzone-wrapper input {\n  width: 100%;\n  height: 100%;\n}\n.dropzone-wrapper .dropzone-content {\n  margin: 0 auto;\n  color: #6c757d;\n}\n.dropzone-wrapper[aria-disabled=true] {\n  border-color: #dee2e6;\n}\n.dropzone-wrapper[aria-disabled=true] .dropzone-content {\n  color: #ced4da;\n}\n\n.rbt {\n  outline: none;\n}\n.rbt-menu {\n  margin-bottom: 2px;\n}\n.rbt-menu > li a {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rbt-menu > li a:focus {\n  outline: none;\n}\n.rbt-menu-pagination-option {\n  text-align: center;\n}\n.rbt .rbt-input-main::-ms-clear {\n  display: none;\n}\n.rbt-input-multi {\n  cursor: text;\n  overflow: hidden;\n  position: relative;\n}\n.rbt-input-multi.form-control[disabled] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.rbt-input-multi input::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.rbt-input-multi input:-ms-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi input::-webkit-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi .rbt-input-wrapper {\n  margin-top: 2px;\n  overflow: hidden;\n}\n.rbt-input-multi .rbt-input-main {\n  height: auto;\n}\n.rbt-input-multi .rbt-input-hint-container {\n  display: inline-block;\n}\n.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {\n  height: auto;\n}\n.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {\n  height: auto;\n}\n.rbt-close {\n  z-index: 1;\n}\n.rbt-close-lg {\n  font-size: 24px;\n}\n.rbt-token {\n  background-color: #e0f3ff;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #545cd8;\n  display: inline-block;\n  line-height: 1em;\n  margin: 0 3px 3px 0;\n  padding: 4px 7px;\n  position: relative;\n}\n.rbt-token-disabled {\n  background-color: #f8f9fa;\n  color: #adb5bd;\n  pointer-events: none;\n}\n.rbt-token-removeable {\n  cursor: pointer;\n  padding-right: 21px;\n}\n.rbt-token-active {\n  background-color: #545cd8;\n  color: #fff;\n  outline: none;\n  text-decoration: none;\n}\n.rbt-token .rbt-token-remove-button {\n  bottom: 0;\n  color: #495057;\n  font-size: inherit;\n  font-weight: normal;\n  opacity: 1;\n  outline: none;\n  padding: 3px 7px;\n  position: absolute;\n  right: 0;\n  text-shadow: none;\n  top: -1px;\n}\n.rbt-loader {\n  -webkit-animation: loader-animation 600ms infinite linear;\n  -o-animation: loader-animation 600ms infinite linear;\n  animation: loader-animation 600ms infinite linear;\n  border: 1px solid #e0f3ff;\n  border-radius: 50%;\n  border-top-color: rgb(173, 223.2580645161, 255);\n  display: block;\n  height: 16px;\n  width: 16px;\n}\n.rbt-loader-lg {\n  height: 20px;\n  width: 20px;\n}\n.rbt-aux {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  justify-content: center;\n  pointer-events: none; /* Don't block clicks on the input */\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 34px;\n}\n.rbt-aux-lg {\n  width: 46px;\n}\n.rbt-aux .rbt-close {\n  margin-top: -1px;\n  pointer-events: auto; /* Override pointer-events: none; above */\n  background-color: transparent;\n  border: none;\n}\n.has-aux .rbt-input {\n  padding-right: 34px;\n}\n.rbt-highlight-text {\n  background-color: inherit;\n  color: inherit;\n  font-weight: bold;\n  padding: 0;\n}\n\n/* Input Groups */\n.input-group > .rbt {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.input-group > .rbt .rbt-input-hint-container {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n.input-group > .rbt .rbt-input-hint {\n  z-index: 5;\n}\n.input-group > .rbt .rbt-aux {\n  z-index: 5;\n}\n.input-group > .rbt:not(:first-child) .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rbt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n@keyframes loader-animation {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes loader-animation {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n.input-group > .rbt .rbt-input-hint-container {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  height: 100%;\n}\n\n.rbt-token-remove-button {\n  background-color: transparent;\n  border: none;\n}\n\n/* for debugging */\n@keyframes react-widgets-autofill-start {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n@keyframes react-widgets-autofill-cancel {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n.rw-btn {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-clip: padding-box;\n  cursor: pointer;\n}\n\n.rw-btn:focus {\n  outline: none;\n}\n\n.rw-btn:disabled, fieldset[disabled] .rw-btn, .rw-state-disabled .rw-btn, .rw-state-readonly .rw-btn {\n  cursor: inherit;\n}\n\nfieldset[disabled] .rw-btn {\n  pointer-events: none;\n}\n\n.rw-picker-caret,\n.rw-picker-btn {\n  color: #212529;\n}\n\n.rw-picker-btn:hover {\n  background-color: #e9ecef;\n}\n\n.rw-picker-btn:active {\n  background-color: #dee2e6;\n}\n\n.rw-picker-btn:disabled, fieldset[disabled] .rw-picker-btn {\n  background-color: #e9ecef;\n}\n\n.rw-input-addon, .rw-input-addon.rw-picker-btn {\n  border-left: #ced4da 1px solid;\n}\n\n[dir=rtl] .rw-input-addon, [dir=rtl] .rw-input-addon.rw-picker-btn {\n  border-right: #ced4da 1px solid;\n  border-left: none;\n}\n\n.rw-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.rw-widget {\n  border: none;\n  color: #212529;\n  font-size: 1em;\n  font-family: inherit;\n  outline: none;\n  position: relative;\n}\n\n.rw-widget, .rw-widget *, .rw-widget:after, .rw-widget:before, .rw-widget *:after, .rw-widget *:before {\n  box-sizing: border-box;\n}\n\n.rw-state-readonly,\n.rw-state-disabled,\nfieldset[disabled] .rw-widget {\n  cursor: not-allowed;\n}\n\n.rw-widget-picker {\n  display: grid;\n  overflow: hidden;\n  min-height: calc(1.5em + (0.75rem + 2px));\n  background-color: #fff;\n  border: #ced4da 1px solid;\n  border-radius: 0.25rem;\n  outline: none;\n  grid-template: 1fr/1fr 1.9em;\n  width: 100%;\n}\n\n.rw-widget-picker.rw-hide-caret {\n  grid-template-columns: 1fr;\n}\n\n.rw-state-focus .rw-widget-picker {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-state-focus .rw-widget-picker.rw-widget-input {\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);\n}\n\n.rw-input {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  padding: 0 0.75rem;\n}\n\n.rw-input:disabled {\n  opacity: 1;\n}\n\n.rw-input[type=text]::-ms-clear {\n  display: none;\n}\n\n.rw-input:disabled, .rw-input:read-only {\n  cursor: inherit;\n}\n\n.rw-widget-input {\n  color: #495057;\n  background-color: #fff;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  background-clip: padding-box;\n  width: inherit;\n}\n\n.rw-widget-input.rw-state-disabled, .rw-state-disabled .rw-widget-input, fieldset[disabled] .rw-widget-input {\n  background-color: #e9ecef;\n}\n\n.rw-placeholder,\n.rw-input::placeholder {\n  color: #6c757d;\n}\n\n.rw-state-disabled .rw-placeholder,\n.rw-state-disabled .rw-input::placeholder {\n  color: #999;\n}\n\n.rw-detect-autofill {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n}\n\n.rw-detect-autofill:disabled {\n  opacity: 1;\n}\n\n.rw-detect-autofill:-webkit-autofill {\n  animation-name: react-widgets-autofill-start;\n  animation-duration: 0.01ms;\n}\n\n.rw-detect-autofill:not(:-webkit-autofill) {\n  animation-name: react-widgets-autofill-cancel;\n  animation-duration: 0.01ms;\n}\n\n.rw-webkit-autofill .rw-widget-container,\n.rw-input:-webkit-autofill {\n  background-color: rgb(232, 240, 254) !important;\n  background-image: none !important;\n  color: rgb(0, 0, 0) !important;\n}\n\n.rw-list {\n  font-size: 1em;\n  overflow-x: visible;\n  overflow-y: auto;\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n\n.rw-list:focus {\n  outline: none;\n}\n\n.rw-list-option, .rw-list-option-create {\n  user-select: none;\n  color: #212529;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n.rw-list-option:hover, .rw-list-option-create:hover, [data-intent=keyboard] .rw-list-option.rw-state-focus:not(.rw-state-selected), [data-intent=keyboard] .rw-state-focus.rw-list-option-create:not(.rw-state-selected) {\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n}\n\n.rw-list-option.rw-state-selected, .rw-state-selected.rw-list-option-create {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: #fff;\n}\n\n.rw-list-option.rw-state-disabled, .rw-state-disabled.rw-list-option-create {\n  cursor: not-allowed;\n  background-color: transparent;\n  border-color: transparent;\n  color: #dee2e6;\n}\n\n.rw-list-empty,\n.rw-list-option,\n.rw-list-option-create,\n.rw-list-optgroup {\n  padding: 0.25em 1.5em;\n  outline: none;\n}\n\n.rw-list-empty {\n  text-align: center;\n  color: #ced4da;\n}\n\n.rw-list-optgroup {\n  font-weight: bold;\n  padding-top: 7px;\n}\n\n.rw-list-option-create {\n  display: block;\n  font-size: 1em;\n  padding: 0.25em 1.5em;\n}\n\n.rw-listbox {\n  border-radius: 4px;\n  background-color: #fff;\n  border: #ccc 1px solid;\n}\n\n.rw-listbox.rw-state-focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-listbox.rw-state-disabled > *, fieldset[disabled] .rw-listbox > * {\n  pointer-events: none;\n}\n\n.rw-listbox.rw-state-readonly > * {\n  cursor: inherit;\n}\n\n.rw-popup-container {\n  position: absolute;\n  z-index: 1005;\n  top: 100%;\n  left: -1em;\n  right: -1em;\n  padding: 0 1em;\n}\n\n.rw-popup-container.rw-dropup {\n  top: auto;\n  bottom: 100%;\n}\n\n.rw-state-focus .rw-popup-container {\n  z-index: 1006;\n}\n\n.rw-slide-transition {\n  margin-bottom: 1em;\n}\n\n.rw-dropup > .rw-slide-transition {\n  margin-bottom: 0;\n  margin-top: 1em;\n}\n\n.rw-popup {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-top: 2px;\n  border-radius: 4px;\n  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);\n  border: #ccc 1px solid;\n  background-clip: padding-box;\n  background: #fff;\n}\n\n.rw-popup .rw-list {\n  max-height: 250px;\n}\n\n.rw-dropup .rw-popup {\n  margin-top: 0;\n  margin-bottom: 2px;\n  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);\n}\n\n.rw-slide-transition {\n  transition: transform 130ms, opacity 100ms;\n}\n\n.rw-slide-transition-entering {\n  overflow: hidden;\n}\n\n.rw-slide-transition-entering .rw-slide-transition {\n  transform: translateY(0);\n  opacity: 1;\n  transition-timing-function: ease-out;\n}\n\n.rw-slide-transition-exiting .rw-slide-transition {\n  transition-timing-function: ease-in;\n}\n\n.rw-slide-transition-exiting,\n.rw-slide-transition-exited {\n  overflow: hidden;\n}\n\n.rw-slide-transition-exiting .rw-slide-transition,\n.rw-slide-transition-exited .rw-slide-transition {\n  opacity: 0;\n  transform: translateY(-10%);\n}\n\n.rw-slide-transition-exiting.rw-dropup .rw-slide-transition,\n.rw-slide-transition-exited.rw-dropup .rw-slide-transition {\n  opacity: 0;\n  transform: translateY(10%);\n}\n\n.rw-slide-transition-exited {\n  display: none;\n}\n\n.rw-dropdown-list {\n  width: 100%;\n}\n\n.rw-dropdownlist-search {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n}\n\n.rw-dropdownlist-search:disabled {\n  opacity: 1;\n}\n\n.rw-dropdown-list-input {\n  padding: 0 0.75rem;\n  align-self: center;\n  display: grid;\n  min-width: 0;\n  grid-template: 1fr/1fr;\n}\n\n.rw-dropdown-list-input > * {\n  grid-area: 1/1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n[dir=rtl] .rw-dropdown-list-input {\n  padding-right: 0.75rem;\n  padding-left: 0;\n}\n\n.rw-combobox-input {\n  background-color: transparent;\n  z-index: 1;\n}\n\n.rw-multiselect-input {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  height: calc(calc(1.5em + (0.75rem + 2px)) - 1px * 2);\n  padding: 0 0.75rem;\n  max-width: 100%;\n}\n\n.rw-multiselect-input:disabled {\n  opacity: 1;\n}\n\n.rw-multiselect-input:disabled, .rw-multiselect-input:read-only {\n  cursor: inherit;\n}\n\n.rw-multiselect-taglist {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  width: 100%;\n  outline: none;\n  cursor: text;\n}\n\n.rw-state-disabled .rw-multiselect-taglist {\n  cursor: unset;\n}\n\n.rw-multiselect-tag {\n  display: inline-flex;\n  margin-left: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);\n  margin-top: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);\n  min-height: calc(calc(1.5em + (0.75rem + 2px)) * 0.77);\n  border-radius: 3px;\n  background-color: #dee2e6;\n  border: 1px solid #dee2e6;\n  cursor: default;\n  max-width: 100%;\n  align-items: center;\n  overflow: hidden;\n}\n\n.rw-multiselect-tag:focus {\n  outline: none;\n}\n\n[dir=rtl] .rw-multiselect-tag {\n  margin-left: 0;\n  margin-right: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);\n  padding: 0 0.35em 0 0.35em;\n}\n\n.rw-multiselect-tag.rw-state-focus {\n  z-index: 1;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-multiselect-tag.rw-state-disabled, fieldset[disabled] .rw-multiselect-tag {\n  opacity: 0.65;\n}\n\n.rw-multiselect-tag-label {\n  padding: 0 0.35em 0 0.35em;\n}\n\n.rw-multiselect-tag-btn {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  cursor: pointer;\n  align-self: stretch;\n  padding: 0 0.35em;\n}\n\n.rw-multiselect-tag-btn:focus {\n  outline: none;\n}\n\n.rw-multiselect-tag-btn:disabled {\n  cursor: inherit;\n}\n\n.rw-calendar-popup {\n  right: auto;\n  min-width: 0;\n  width: 22em;\n}\n\n.rw-calendar {\n  overflow: hidden;\n}\n\n.rw-calendar-contained {\n  border-radius: 4px;\n  background-color: #fff;\n  border: #ccc 1px solid;\n}\n\n.rw-calendar-now {\n  font-weight: bold;\n}\n\n.rw-calendar-header {\n  display: flex;\n  padding: 0.8em;\n}\n\n.rw-cell,\n.rw-calendar-btn {\n  background-clip: padding-box;\n}\n\n.rw-cell:focus,\n.rw-calendar-btn:focus {\n  z-index: 1;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n[data-intent=mouse] .rw-cell:focus,\n[data-intent=mouse] .rw-calendar-btn:focus {\n  z-index: auto;\n  box-shadow: none;\n}\n\n.rw-cell:disabled, .rw-cell.rw-state-disabled,\n.rw-calendar-btn:disabled,\n.rw-calendar-btn.rw-state-disabled {\n  pointer-events: none;\n  opacity: 0.35;\n}\n\n.rw-calendar-btn {\n  line-height: 2em;\n  border-radius: 4px;\n}\n\n.rw-calendar-btn:hover {\n  background-color: #e9ecef;\n}\n\n.rw-calendar-btn:active {\n  background-color: #dee2e6;\n}\n\n.rw-calendar-btn-left,\n.rw-calendar-btn-today,\n.rw-calendar-btn-right,\n.rw-calendar-btn-view {\n  padding: 0.3em 0.6em;\n}\n\n[dir=rtl] .rw-calendar-btn-left,\n[dir=rtl] .rw-calendar-btn-right {\n  transform: scale(-1, 1);\n}\n\n.rw-calendar-btn-view {\n  font-weight: bold;\n}\n\n.rw-calendar-btn-view > :last-child {\n  margin: 0 0.5em;\n}\n\n.rw-calendar-btn-view + * {\n  margin-left: auto;\n}\n\n[dir=rtl] .rw-calendar-btn-view + * {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.rw-calendar-grid {\n  display: table;\n  outline: none;\n  height: 14em;\n  padding: 3px;\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  background-color: #fff;\n}\n\n.rw-calendar-head {\n  display: table-header-group;\n}\n\n.rw-calendar-body {\n  display: table-row-group;\n}\n\n.rw-calendar-row {\n  display: table-row;\n}\n\n.rw-head-cell {\n  display: table-cell;\n  text-align: center;\n  border-bottom: 1px solid #ced4da;\n  padding: 0.25em;\n}\n\n.rw-cell {\n  display: table-cell;\n  color: #212529;\n  vertical-align: middle;\n  border-radius: 4px;\n  cursor: pointer;\n  line-height: normal;\n  text-align: center;\n  border: 1px solid transparent;\n  padding: 0.25em;\n  outline: none;\n}\n\n.rw-cell:hover {\n  background-color: #e9ecef;\n}\n\n.rw-cell:active {\n  background-color: #dee2e6;\n}\n\n.rw-cell.rw-state-selected {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: #fff;\n}\n\n.rw-calendar-month .rw-cell {\n  text-align: center;\n}\n\n.rw-cell-off-range {\n  color: #ced4da;\n}\n\n.rw-calendar-transition-group {\n  position: relative;\n  overflow: hidden;\n}\n\n.rw-calendar-transition {\n  width: 100%;\n  overflow: hidden;\n  transition: transform 0.2s ease-in-out 0ms;\n  transform: translate(0, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.rw-calendar-transition-next {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.rw-calendar-transition-top .rw-calendar-transition-next {\n  transform: translate(0, -100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-top .rw-calendar-transition-next {\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.rw-calendar-transition-bottom .rw-calendar-transition-next {\n  transform: translate(0, 100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-bottom .rw-calendar-transition-next {\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.rw-calendar-transition-right .rw-calendar-transition-next {\n  transform: translate(-100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-right .rw-calendar-transition-next {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.rw-calendar-transition-left .rw-calendar-transition-next {\n  transform: translate(100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-left .rw-calendar-transition-next {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.rw-calendar-transition-next.rw-calendar-transition-active {\n  transform: translate(0, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-next.rw-calendar-transition-active {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.rw-calendar-transition-prev {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rw-calendar-transition-top .rw-calendar-transition-prev {\n  transform: translate(0, 100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-top .rw-calendar-transition-prev {\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.rw-calendar-transition-bottom .rw-calendar-transition-prev {\n  transform: translate(0, -100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-bottom .rw-calendar-transition-prev {\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.rw-calendar-transition-right .rw-calendar-transition-prev {\n  transform: translate(100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-right .rw-calendar-transition-prev {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.rw-calendar-transition-left .rw-calendar-transition-prev {\n  transform: translate(-100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-left .rw-calendar-transition-prev {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.rw-popup {\n  display: flex;\n  flex-direction: column;\n}\n\n.rw-popup > .rw-time-input {\n  align-self: center;\n  margin: 1em 0;\n}\n\n.rw-time-input {\n  display: inline-flex;\n  min-height: calc(1.5em + (0.75rem + 2px));\n  align-items: center;\n  background-color: #fff;\n  border: #ced4da 1px solid;\n  border-radius: 0.25rem;\n  outline: none;\n  cursor: text;\n}\n\n.rw-time-part-input {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  padding: 0 0.5em;\n}\n\n.rw-time-part-input:disabled {\n  opacity: 1;\n}\n\n.rw-time-part-input, .rw-time-part-input::placeholder {\n  text-align: center;\n}\n\n.rw-time-part-meridiem {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  padding: 0 0.5em;\n  text-transform: lowercase;\n  font-variant: small-caps;\n}\n\n.rw-time-part-meridiem :focus {\n  outline: none;\n}\n\n.rw-time-input-clear {\n  padding: 0 0.4em;\n  outline: none;\n  opacity: 0;\n  margin-left: auto;\n}\n\n[dir=rtl] .rw-time-input-clear {\n  margin-left: revert;\n  margin-right: auto;\n}\n\n.rw-time-input:hover .rw-time-input-clear.rw-show, .rw-time-input.rw-state-focus .rw-time-input-clear.rw-show {\n  opacity: 1;\n}\n\n.rw-number-picker-spinners {\n  display: flex;\n  flex-direction: column;\n}\n\n.rw-number-picker-spinners .rw-btn {\n  flex: 1 1 0;\n}\n\n.ui-theme-settings {\n  position: fixed;\n  z-index: 155;\n  right: -30px;\n  top: 0;\n  height: 100vh;\n  transform: translate(500px);\n  transition: all 0.2s;\n  box-shadow: -0.46875rem 0 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.9375rem 0 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.25rem 0 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), -0.125rem 0 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.ui-theme-settings .btn-open-options {\n  border-radius: 50px;\n  position: absolute;\n  left: -114px;\n  bottom: 80px;\n  padding: 0;\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n  text-align: center;\n  display: block;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  margin-top: -27px;\n}\n.ui-theme-settings .btn-open-options svg {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  margin: -0.5em 0 0 -0.5em;\n}\n.ui-theme-settings .theme-settings__inner {\n  background: #fff;\n  width: 500px;\n  height: 100vh;\n  padding: 0;\n}\n.ui-theme-settings.settings-open {\n  transform: translate(0);\n  right: 0;\n}\n.ui-theme-settings .theme-settings-swatches {\n  text-align: center;\n}\n.ui-theme-settings .theme-settings-swatches .swatch-holder-img {\n  width: 72px;\n  height: auto;\n  border-radius: 3px;\n}\n.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {\n  width: 100%;\n}\n.ui-theme-settings .themeoptions-heading {\n  font-size: 1.1rem;\n  color: #495057;\n  margin: 0;\n  background: #f8f9fa;\n  padding: 0.75rem 1.5rem;\n  border-bottom: #dee2e6 solid 1px;\n  border-top: #dee2e6 solid 1px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.ui-theme-settings .themeoptions-heading:first-child {\n  border-top: 0;\n}\n.ui-theme-settings .list-group-item h5, .ui-theme-settings .list-group-item .h5 {\n  color: #545cd8;\n  font-size: 0.968rem;\n  text-transform: uppercase;\n  margin: 0;\n  text-align: center;\n}\n\n.swatch-holder {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin: 5px 5px 0;\n  transition: all 0.2s;\n  opacity: 0.7;\n  display: inline-block;\n  border-radius: 30px;\n}\n.swatch-holder.active {\n  border: #fff solid 2px;\n  box-shadow: 0 0 0 5px #545cd8;\n  opacity: 1;\n}\n.swatch-holder:hover {\n  opacity: 1;\n}\n\n.swatch-holder-lg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n}\n\n.font-icon-wrapper {\n  text-align: center;\n  border: #e9ecef solid 1px;\n  border-radius: 0.25rem;\n  margin: 0 0 10px;\n  padding: 5px;\n}\n.font-icon-wrapper.font-icon-lg {\n  float: left;\n  padding: 10px;\n  text-align: center;\n  margin-right: 15px;\n  min-width: 64px;\n}\n.font-icon-wrapper.font-icon-lg i {\n  font-size: 2.2rem;\n}\n.font-icon-wrapper:hover {\n  background: #f8f9fa;\n  color: #545cd8;\n}\n.font-icon-wrapper:hover p {\n  color: #6c757d;\n}\n.font-icon-wrapper i {\n  font-size: 1.65rem;\n}\n.font-icon-wrapper p {\n  color: #adb5bd;\n  font-size: 0.8066666667rem;\n  margin: 5px 0 0;\n}\n\n.btn-icon-vertical {\n  min-width: 100px;\n}\n\n.card.mb-3 {\n  margin-bottom: 1.5rem !important;\n}\n\n.demo-image-bg {\n  height: 350px;\n  margin-bottom: 1.5rem;\n}\n\n.loader-wrapper {\n  width: 150px;\n  height: 100px;\n  float: left;\n}\n\n.slider-item {\n  background: #dee2e6;\n  border-radius: 0.25rem;\n  color: #6c757d;\n  font-size: 36px;\n  padding: 0;\n  position: relative;\n  height: 150px;\n  line-height: 150px;\n  text-align: center;\n  margin: 0 1.5rem;\n  transition: all 0.2s;\n}\n\n.slick-center .slider-item {\n  background: #adb5bd;\n  color: #495057;\n}\n\n.after-img {\n  max-width: 100%;\n}\n\n@media only screen and (max-width: 1320px) {\n  .header-user-info {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-main {\n    display: block;\n  }\n  .dropdown-menu::before, .dropdown-menu::after {\n    display: none;\n  }\n  .app-sidebar {\n    flex: 0 0 280px !important;\n    width: 280px !important;\n    transform: translateX(-280px);\n  }\n  .app-sidebar .app-header__logo {\n    display: none;\n  }\n  .sidebar-mobile-open .app-sidebar {\n    transform: translateX(0);\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {\n    text-indent: initial;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {\n    display: none;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {\n    text-indent: initial;\n    padding: 0 1.5rem 0 45px;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {\n    text-indent: initial;\n    left: 5px;\n    margin-left: 0;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {\n    visibility: visible;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {\n    padding: 0.5em 0 0 2rem;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n    height: 2.3em;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {\n    padding-left: 1em;\n  }\n  .sidebar-mobile-open .app-sidebar .app-header__logo {\n    width: auto !important;\n  }\n  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {\n    width: 97px !important;\n    margin-left: auto;\n    margin-right: 0;\n  }\n  .sidebar-mobile-open .fixed-sidebar .app-sidebar {\n    height: 100%;\n  }\n  .sidebar-mobile-open .sidebar-mobile-overlay {\n    display: block;\n  }\n  .app-main .app-main__outer {\n    padding-left: 0 !important;\n    width: auto;\n  }\n  .app-header {\n    justify-content: space-between;\n  }\n  .app-header .app-header__logo {\n    display: none;\n    order: 2;\n    background: transparent !important;\n    border: 0 !important;\n  }\n  .app-header .app-header__content {\n    visibility: hidden;\n    opacity: 0;\n    box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n    position: absolute;\n    left: 5%;\n    width: 90%;\n    top: 0;\n    transition: all 0.2s;\n    background: #fff;\n    border-radius: 50px;\n    padding: 0 10px;\n    overflow: hidden;\n  }\n  .app-header .app-header__content .header-btn-lg {\n    margin-left: 0.5rem;\n    padding: 0 0.5rem;\n  }\n  .app-header .app-header__content .header-btn-lg .hamburger-box {\n    margin-top: 5px;\n  }\n  .app-header .app-header__content .header-btn-lg + .header-btn-lg {\n    display: none;\n  }\n  .app-header .app-header__content .app-header-left .nav {\n    display: none;\n  }\n  .app-header .app-header__content.header-mobile-open {\n    visibility: visible;\n    opacity: 1;\n    top: 80px;\n  }\n  .app-header .app-header__mobile-menu {\n    display: flex;\n    order: 1;\n  }\n  .app-header .app-header__menu {\n    display: flex;\n    order: 3;\n  }\n  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n  .app-header.header-text-light .header-mobile-open {\n    background: #343a40;\n  }\n  .popover,\n  .dropdown-menu {\n    position: fixed !important;\n    z-index: 50;\n    left: 5% !important;\n    top: 50% !important;\n    width: 90% !important;\n    transform: translateY(-50%) !important;\n    min-width: 10px !important;\n  }\n  .popover .btn-icon-vertical .btn-icon-wrapper,\n  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {\n    display: none;\n  }\n  .popover {\n    max-width: initial;\n  }\n  .popover .arrow {\n    display: none !important;\n  }\n  .app-page-title {\n    text-align: center;\n  }\n  .app-page-title .page-title-heading,\n  .app-page-title .page-title-wrapper {\n    margin: 0 auto;\n    display: block;\n  }\n  .app-page-title .page-title-actions {\n    margin: 0.75rem auto 0;\n  }\n  .app-page-title .page-title-actions .breadcrumb-item,\n  .app-page-title .page-title-actions .breadcrumb,\n  .app-page-title .page-title-subheading .breadcrumb-item,\n  .app-page-title .page-title-subheading .breadcrumb {\n    display: inline-block;\n  }\n  .app-footer .app-footer__inner .app-footer-right {\n    display: none;\n  }\n  .app-footer .app-footer__inner .app-footer-left {\n    width: 100%;\n  }\n  .app-footer .app-footer__inner .app-footer-left .footer-dots {\n    margin: 0 auto;\n  }\n  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {\n    margin-left: 0 !important;\n  }\n  .widget-content .widget-numbers {\n    font-size: 1.6rem;\n    line-height: 1;\n  }\n  .slick-slider-sm .slick-slider {\n    max-width: 650px !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big {\n    display: block !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {\n    display: inline-block !important;\n    padding: 0 1.5rem !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {\n    margin-top: -20px;\n  }\n  .ReactTable .-pagination .-center {\n    display: none;\n  }\n  .ReactTable .-pagination .-previous {\n    padding-right: 3px;\n  }\n  .bg-transparent.list-group-item {\n    border-color: transparent;\n  }\n  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {\n    font-size: 1.5rem;\n  }\n  .page-title-head {\n    display: block;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-page-title .page-title-icon,\n  .ui-theme-settings {\n    display: none;\n  }\n  .card-header.responsive-center {\n    display: block;\n    text-align: center;\n    height: auto;\n    padding: 1.5rem;\n  }\n  .card-header.responsive-center .nav,\n  .card-header.responsive-center .btn-actions-pane-right {\n    margin: 0.75rem 0 0;\n  }\n  .card-header.responsive-center .nav .d-inline-block.ml-2,\n  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {\n    width: 100% !important;\n    text-align: left;\n    margin: 0 !important;\n  }\n  .slick-slider-sm .slick-slider {\n    max-width: 650px !important;\n  }\n}\n@media (min-width: 992px) {\n  .slick-slider-sm .slick-slider {\n    max-width: 850px !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .-hide-paging .-pagination .-center {\n    display: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .app-main .app-main__inner {\n    padding: 15px 15px 0;\n  }\n  .mbg-3,\n  body .card.mb-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .app-page-title {\n    padding: 0.75rem;\n    margin: -0.75rem -0.75rem 1.5rem;\n  }\n  .body-tabs.body-tabs-layout {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n    padding: 0 0.75rem;\n  }\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\n    margin-top: 0.75rem;\n  }\n  .popover,\n  .dropdown-menu {\n    width: 80%;\n    left: 10%;\n  }\n  body .card-header {\n    height: auto;\n    display: block;\n    padding: 0.75rem 1.5rem;\n    text-align: center;\n  }\n  body .card-header .btn-actions-pane-right {\n    padding: 0.75rem 0 0;\n  }\n  body .card-header .actions-icon-btn {\n    padding: 0;\n  }\n  .card-header.card-header-tab .card-header-title {\n    display: inline-flex !important;\n    line-height: 1;\n  }\n  .card-header.card-header-tab > .nav {\n    margin: 0.75rem 0 -0.75rem;\n    display: table !important;\n    width: 100%;\n  }\n  .card-header.card-header-tab > .nav .nav-item {\n    display: table-cell;\n  }\n  .header-icon {\n    display: none;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {\n    display: block;\n    text-align: center;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {\n    margin-right: 0 !important;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n    margin-top: 1rem;\n  }\n  .slick-slider-sm .slick-slider .slick-prev {\n    left: 0.75rem;\n  }\n  .slick-slider-sm .slick-slider .slick-next {\n    right: 0.75rem;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {\n    display: block;\n    text-align: center;\n  }\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {\n    margin-right: 0 !important;\n  }\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n    margin-top: 1rem;\n  }\n}","// GENERIC\r\n\r\n@use \"sass:math\";\r\n\r\n$enable-caret: true;\r\n$enable-rounded: true;\r\n$enable-shadows: false;\r\n$enable-gradients: false;\r\n$enable-transitions: true;\r\n$enable-grid-classes: true;\r\n$enable-print-styles: false;\r\n\r\n$body-bg: #fff;\r\n\r\n// Colors\r\n\r\n$white: #fff;\r\n$gray-100: #f8f9fa;\r\n$gray-200: #e9ecef;\r\n$gray-300: #dee2e6;\r\n$gray-400: #ced4da;\r\n$gray-500: #adb5bd;\r\n$gray-600: #6c757d;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black: #000;\r\n\r\n$grays: ();\r\n\r\n$grays: map-merge(\r\n                (\r\n                        \"100\": $gray-100,\r\n                        \"200\": $gray-200,\r\n                        \"300\": $gray-300,\r\n                        \"400\": $gray-400,\r\n                        \"500\": $gray-500,\r\n                        \"600\": $gray-600,\r\n                        \"700\": $gray-700,\r\n                        \"800\": $gray-800,\r\n                        \"900\": $gray-900\r\n                ),\r\n                $grays\r\n);\r\n\r\n//--#{$color}\r\n$brand: #545cd8;\r\n$blue: #86c6fb;\r\n$indigo: #444054;\r\n$purple: #83588a;\r\n$pink: #f65ca2;\r\n$red: #d92550;\r\n$orange: #fd7e14;\r\n$yellow: #f7b924;\r\n$green: #3ac47d;\r\n$teal: #16E0BD;\r\n$cyan: #30b1ff;\r\n$blue-light: #eeeeee;\r\n\r\n$primary: $brand;\r\n$secondary: $gray-600;\r\n$success: $green;\r\n$info: $cyan;\r\n$warning: $yellow;\r\n$danger: $red;\r\n$light: $blue-light;\r\n$dark: $gray-800;\r\n$focus: $indigo;\r\n$alt: $purple;\r\n\r\n$theme-colors: ();\r\n\r\n$custom-colors: (\r\n  \"primary\": $primary,\r\n  \"secondary\": $secondary,\r\n  \"success\": $success,\r\n  \"info\": $info,\r\n  \"warning\": $warning,\r\n  \"danger\": $danger,\r\n  \"light\": $light,\r\n  \"dark\": $dark,\r\n  \"focus\": $focus,\r\n  \"alternate\": $alt\r\n);\r\n\r\n$theme-colors: map-merge( $theme-colors, $custom-colors);\r\n\r\n// BOOTSTRAP OVERWRITES\r\n\r\n$headings-font-weight: 400;\r\n\r\n$font-size-base: 0.88rem;\r\n$font-size-lg: ($font-size-base * 1.25);\r\n$font-size-sm: ($font-size-base * 1.1);\r\n$font-size-xs: math.div($font-size-base, 1.1);\r\n\r\n$btn-transition: color .15s, background-color .15s, border-color .15s, box-shadow .15s;\r\n$btn-focus-width: 0;\r\n$btn-focus-box-shadow: none;\r\n\r\n$pagination-focus-box-shadow: none;\r\n\r\n$body-color: $gray-700;\r\n\r\n$card-cap-bg: $white;\r\n$card-border-color: rgba(darken($primary, 25%), .125);\r\n\r\n$dropdown-min-width: 15rem;\r\n$dropdown-link-hover-bg: #e0f3ff;\r\n$dropdown-item-padding-y: .4rem;\r\n$dropdown-padding-y: .65rem;\r\n\r\n$box-shadow-default: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03), 0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03), 0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05), 0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\r\n\r\n$box-shadow-default-right: 0.46875rem 0 2.1875rem rgba(darken($primary, 50%), .03),\r\n0.9375rem 0 1.40625rem rgba(darken($primary, 50%), .03),\r\n0.25rem 0 0.53125rem rgba(darken($primary, 50%), .05),\r\n0.125rem 0 0.1875rem rgba(darken($primary, 50%), .03);\r\n\r\n$box-shadow-default-inverse: 0 -0.46875rem 2.1875rem rgba(darken($primary, 50%), .03), 0 -0.9375rem 1.40625rem rgba(darken($primary, 50%), .03), 0 -0.25rem 0.53125rem rgba(darken($primary, 50%), .05), 0 -0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\r\n\r\n$box-shadow-lg-default: 0 0.76875rem 2.4875rem rgba($gray-800, .3), 0 1.3375rem 1.70625rem rgba($gray-800, .3), 0 0.55rem 0.53125rem rgba(darken($gray-800, 50%), .05), 0 0.225rem 0.4375rem rgba($gray-800, .3);\r\n\r\n$form-check-input-margin-y: 0.3rem;\r\n\r\n$input-group-addon-bg: lighten($dropdown-link-hover-bg, 3%);\r\n\r\n// Tables\r\n\r\n$table-accent-bg: rgba($black, .03);\r\n$table-hover-bg: $dropdown-link-hover-bg;\r\n$table-active-bg: $table-hover-bg;\r\n$table-border-color: $gray-200;\r\n$table-head-bg: $gray-100;\r\n$table-head-color: $gray-600;\r\n$table-cell-padding: .55rem;\r\n$table-cell-padding-sm: .3rem;\r\n\r\n// Popovers\r\n\r\n$popover-max-width: 320px;\r\n$popover-box-shadow: $box-shadow-default;\r\n$popover-border-color: $card-border-color;\r\n$popover-header-bg: $white;\r\n\r\n// Color Modifiers\r\n\r\n$link-color: $primary;\r\n$component-active-bg: $primary;\r\n$custom-control-indicator-checked-disabled-bg: rgba($primary, .5);\r\n$form-feedback-valid-color: $success;\r\n$form-feedback-invalid-color: $danger;\r\n$progress-bar-bg: $primary;\r\n$input-btn-focus-color: rgba($component-active-bg, .25);\r\n$input-focus-border-color: lighten($component-active-bg, 25%);\r\n$custom-control-indicator-checked-bg: $component-active-bg;\r\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%);\r\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg;\r\n$custom-range-thumb-bg: $component-active-bg;\r\n$custom-range-thumb-active-bg: lighten($component-active-bg, 35%);\r\n$dropdown-link-active-bg: $component-active-bg;\r\n$nav-pills-link-active-bg: $component-active-bg;\r\n$pagination-active-bg: $component-active-bg;\r\n$list-group-active-bg: $component-active-bg;\r\n\r\n$list-group-border-color: rgba($primary, .08) !default;\r\n\r\n// Mixins\r\n\r\n@mixin box-shadow-architect($shadow) {\r\n  box-shadow: 0 0.66875rem 2.3875rem rgba($shadow, .03), 0 1.1375rem 1.60625rem rgba($shadow, .03), 0 0.45rem 0.73125rem rgba($shadow, .05), 0 0.325rem 0.3875rem rgba($shadow, .03);\r\n}\r\n\r\n// Border\r\n\r\n@each $color, $value in $theme-colors {\r\n  .border-#{$color} {\r\n    border-color: $value;\r\n  }\r\n}\r\n\r\n// List Group\r\n\r\n// @each $color, $value in $theme-colors {\r\n//   @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\r\n// }\r\n\r\n// // Background\r\n\r\n// @each $color, $value in $theme-colors {\r\n//   @include bg-variant(\".bg-#{$color}\", $value);\r\n// }\r\n\r\n@if $enable-gradients {\r\n  @each $color, $value in $theme-colors {\r\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n  }\r\n}",":root {\r\n  // Custom variable values only support SassScript inside `#{}`.\r\n  @each $color, $value in $colors {\r\n    --#{$variable-prefix}#{$color}: #{$value};\r\n  }\r\n\r\n  @each $color, $value in $theme-colors {\r\n    --#{$variable-prefix}#{$color}: #{$value};\r\n  }\r\n\r\n  // Use `inspect` for lists so that quoted items keep the quotes.\r\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\r\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\r\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\r\n  --#{$variable-prefix}gradient: #{$gradient};\r\n}\r\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\r\n\r\n\r\n// Reboot\r\n//\r\n// Normalization of HTML elements, manually forked from Normalize.css to remove\r\n// styles targeting irrelevant browsers while applying new styles.\r\n//\r\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\r\n\r\n\r\n// Document\r\n//\r\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n// Root\r\n//\r\n// Ability to the value of the root font sizes, affecting the value of `rem`.\r\n// null by default, thus nothing is generated.\r\n\r\n:root {\r\n  font-size: $font-size-root;\r\n\r\n  @if $enable-smooth-scroll {\r\n    @media (prefers-reduced-motion: no-preference) {\r\n      scroll-behavior: smooth;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Body\r\n//\r\n// 1. Remove the margin in all browsers.\r\n// 2. As a best practice, apply a default `background-color`.\r\n// 3. Prevent adjustments of font size after orientation changes in iOS.\r\n// 4. Change the default tap highlight to be completely transparent in iOS.\r\n\r\nbody {\r\n  margin: 0; // 1\r\n  font-family: $font-family-base;\r\n  @include font-size($font-size-base);\r\n  font-weight: $font-weight-base;\r\n  line-height: $line-height-base;\r\n  color: $body-color;\r\n  text-align: $body-text-align;\r\n  background-color: $body-bg; // 2\r\n  -webkit-text-size-adjust: 100%; // 3\r\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\r\n}\r\n\r\n\r\n// Content grouping\r\n//\r\n// 1. Reset Firefox's gray color\r\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\r\n\r\nhr {\r\n  margin: $hr-margin-y 0;\r\n  color: $hr-color; // 1\r\n  background-color: currentColor;\r\n  border: 0;\r\n  opacity: $hr-opacity;\r\n}\r\n\r\nhr:not([size]) {\r\n  height: $hr-height; // 2\r\n}\r\n\r\n\r\n// Typography\r\n//\r\n// 1. Remove top margins from headings\r\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\r\n//    margin for easier control within type scales as it avoids margin collapsing.\r\n\r\n%heading {\r\n  margin-top: 0; // 1\r\n  margin-bottom: $headings-margin-bottom;\r\n  font-family: $headings-font-family;\r\n  font-style: $headings-font-style;\r\n  font-weight: $headings-font-weight;\r\n  line-height: $headings-line-height;\r\n  color: $headings-color;\r\n}\r\n\r\nh1 {\r\n  @extend %heading;\r\n  @include font-size($h1-font-size);\r\n}\r\n\r\nh2 {\r\n  @extend %heading;\r\n  @include font-size($h2-font-size);\r\n}\r\n\r\nh3 {\r\n  @extend %heading;\r\n  @include font-size($h3-font-size);\r\n}\r\n\r\nh4 {\r\n  @extend %heading;\r\n  @include font-size($h4-font-size);\r\n}\r\n\r\nh5 {\r\n  @extend %heading;\r\n  @include font-size($h5-font-size);\r\n}\r\n\r\nh6 {\r\n  @extend %heading;\r\n  @include font-size($h6-font-size);\r\n}\r\n\r\n\r\n// Reset margins on paragraphs\r\n//\r\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\r\n// bottom margin to use `rem` units instead of `em`.\r\n\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: $paragraph-margin-bottom;\r\n}\r\n\r\n\r\n// Abbreviations\r\n//\r\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\r\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\r\n// 3. Add explicit cursor to indicate changed behavior.\r\n// 4. Prevent the text-decoration to be skipped.\r\n\r\nabbr[title],\r\nabbr[data-bs-original-title] { // 1\r\n  text-decoration: underline dotted; // 2\r\n  cursor: help; // 3\r\n  text-decoration-skip-ink: none; // 4\r\n}\r\n\r\n\r\n// Address\r\n\r\naddress {\r\n  margin-bottom: 1rem;\r\n  font-style: normal;\r\n  line-height: inherit;\r\n}\r\n\r\n\r\n// Lists\r\n\r\nol,\r\nul {\r\n  padding-left: 2rem;\r\n}\r\n\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nol ol,\r\nul ul,\r\nol ul,\r\nul ol {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndt {\r\n  font-weight: $dt-font-weight;\r\n}\r\n\r\n// 1. Undo browser default\r\n\r\ndd {\r\n  margin-bottom: .5rem;\r\n  margin-left: 0; // 1\r\n}\r\n\r\n\r\n// Blockquote\r\n\r\nblockquote {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n\r\n// Strong\r\n//\r\n// Add the correct font weight in Chrome, Edge, and Safari\r\n\r\nb,\r\nstrong {\r\n  font-weight: $font-weight-bolder;\r\n}\r\n\r\n\r\n// Small\r\n//\r\n// Add the correct font size in all browsers\r\n\r\nsmall {\r\n  @include font-size($small-font-size);\r\n}\r\n\r\n\r\n// Mark\r\n\r\nmark {\r\n  padding: $mark-padding;\r\n  background-color: $mark-bg;\r\n}\r\n\r\n\r\n// Sub and Sup\r\n//\r\n// Prevent `sub` and `sup` elements from affecting the line height in\r\n// all browsers.\r\n\r\nsub,\r\nsup {\r\n  position: relative;\r\n  @include font-size($sub-sup-font-size);\r\n  line-height: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub { bottom: -.25em; }\r\nsup { top: -.5em; }\r\n\r\n\r\n// Links\r\n\r\na {\r\n  color: $link-color;\r\n  text-decoration: $link-decoration;\r\n\r\n  &:hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n  }\r\n}\r\n\r\n// And undo these styles for placeholder links/named anchors (without href).\r\n// It would be more straightforward to just use a[href] in previous block, but that\r\n// causes specificity issues in many other styles that are too complex to fix.\r\n// See https://github.com/twbs/bootstrap/issues/19402\r\n\r\na:not([href]):not([class]) {\r\n  &,\r\n  &:hover {\r\n    color: inherit;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n\r\n// Code\r\n\r\npre,\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: $font-family-code;\r\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\r\n  direction: ltr #{\"/* rtl:ignore */\"};\r\n  unicode-bidi: bidi-override;\r\n}\r\n\r\n// 1. Remove browser default top margin\r\n// 2. Reset browser default of `1em` to use `rem`s\r\n// 3. Don't allow content to break outside\r\n\r\npre {\r\n  display: block;\r\n  margin-top: 0; // 1\r\n  margin-bottom: 1rem; // 2\r\n  overflow: auto; // 3\r\n  @include font-size($code-font-size);\r\n  color: $pre-color;\r\n\r\n  // Account for some code outputs that place code tags in pre tags\r\n  code {\r\n    @include font-size(inherit);\r\n    color: inherit;\r\n    word-break: normal;\r\n  }\r\n}\r\n\r\ncode {\r\n  @include font-size($code-font-size);\r\n  color: $code-color;\r\n  word-wrap: break-word;\r\n\r\n  // Streamline the style when inside anchors to avoid broken underline and more\r\n  a > & {\r\n    color: inherit;\r\n  }\r\n}\r\n\r\nkbd {\r\n  padding: $kbd-padding-y $kbd-padding-x;\r\n  @include font-size($kbd-font-size);\r\n  color: $kbd-color;\r\n  background-color: $kbd-bg;\r\n  @include border-radius($border-radius-sm);\r\n\r\n  kbd {\r\n    padding: 0;\r\n    @include font-size(1em);\r\n    font-weight: $nested-kbd-font-weight;\r\n  }\r\n}\r\n\r\n\r\n// Figures\r\n//\r\n// Apply a consistent margin strategy (matches our type styles).\r\n\r\nfigure {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n\r\n// Images and content\r\n\r\nimg,\r\nsvg {\r\n  vertical-align: middle;\r\n}\r\n\r\n\r\n// Tables\r\n//\r\n// Prevent double borders\r\n\r\ntable {\r\n  caption-side: bottom;\r\n  border-collapse: collapse;\r\n}\r\n\r\ncaption {\r\n  padding-top: $table-cell-padding-y;\r\n  padding-bottom: $table-cell-padding-y;\r\n  color: $table-caption-color;\r\n  text-align: left;\r\n}\r\n\r\n// 1. Removes font-weight bold by inheriting\r\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\r\n// 3. Fix alignment for Safari\r\n\r\nth {\r\n  font-weight: $table-th-font-weight; // 1\r\n  text-align: inherit; // 2\r\n  text-align: -webkit-match-parent; // 3\r\n}\r\n\r\nthead,\r\ntbody,\r\ntfoot,\r\ntr,\r\ntd,\r\nth {\r\n  border-color: inherit;\r\n  border-style: solid;\r\n  border-width: 0;\r\n}\r\n\r\n\r\n// Forms\r\n//\r\n// 1. Allow labels to use `margin` for spacing.\r\n\r\nlabel {\r\n  display: inline-block; // 1\r\n}\r\n\r\n// Remove the default `border-radius` that macOS Chrome adds.\r\n// See https://github.com/twbs/bootstrap/issues/24093\r\n\r\nbutton {\r\n  // stylelint-disable-next-line property-disallowed-list\r\n  border-radius: 0;\r\n}\r\n\r\n// Explicitly remove focus outline in Chromium when it shouldn't be\r\n// visible (e.g. as result of mouse click or touch tap). It already\r\n// should be doing this automatically, but seems to currently be\r\n// confused and applies its very visible two-tone outline anyway.\r\n\r\nbutton:focus:not(:focus-visible) {\r\n  outline: 0;\r\n}\r\n\r\n// 1. Remove the margin in Firefox and Safari\r\n\r\ninput,\r\nbutton,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0; // 1\r\n  font-family: inherit;\r\n  @include font-size(inherit);\r\n  line-height: inherit;\r\n}\r\n\r\n// Remove the inheritance of text transform in Firefox\r\nbutton,\r\nselect {\r\n  text-transform: none;\r\n}\r\n// Set the cursor for non-`<button>` buttons\r\n//\r\n// Details at https://github.com/twbs/bootstrap/pull/30562\r\n[role=\"button\"] {\r\n  cursor: pointer;\r\n}\r\n\r\nselect {\r\n  // Remove the inheritance of word-wrap in Safari.\r\n  // See https://github.com/twbs/bootstrap/issues/24990\r\n  word-wrap: normal;\r\n\r\n  // Undo the opacity change from Chrome\r\n  &:disabled {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\r\n// See https://stackoverflow.com/a/54997118\r\n\r\n[list]::-webkit-calendar-picker-indicator {\r\n  display: none;\r\n}\r\n\r\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\r\n//    controls in Android 4.\r\n// 2. Correct the inability to style clickable types in iOS and Safari.\r\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\r\n\r\nbutton,\r\n[type=\"button\"], // 1\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  -webkit-appearance: button; // 2\r\n\r\n  @if $enable-button-pointers {\r\n    &:not(:disabled) {\r\n      cursor: pointer; // 3\r\n    }\r\n  }\r\n}\r\n\r\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\r\n\r\n::-moz-focus-inner {\r\n  padding: 0;\r\n  border-style: none;\r\n}\r\n\r\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\r\n\r\ntextarea {\r\n  resize: vertical; // 1\r\n}\r\n\r\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\r\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\r\n//    So we reset that to ensure fieldsets behave more like a standard block element.\r\n//    See https://github.com/twbs/bootstrap/issues/12359\r\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\r\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\r\n\r\nfieldset {\r\n  min-width: 0; // 1\r\n  padding: 0; // 2\r\n  margin: 0; // 2\r\n  border: 0; // 2\r\n}\r\n\r\n// 1. By using `float: left`, the legend will behave like a block element.\r\n//    This way the border of a fieldset wraps around the legend if present.\r\n// 2. Fix wrapping bug.\r\n//    See https://github.com/twbs/bootstrap/issues/29712\r\n\r\nlegend {\r\n  float: left; // 1\r\n  width: 100%;\r\n  padding: 0;\r\n  margin-bottom: $legend-margin-bottom;\r\n  @include font-size($legend-font-size);\r\n  font-weight: $legend-font-weight;\r\n  line-height: inherit;\r\n\r\n  + * {\r\n    clear: left; // 2\r\n  }\r\n}\r\n\r\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\r\n// See https://github.com/twbs/bootstrap/issues/18842\r\n\r\n::-webkit-datetime-edit-fields-wrapper,\r\n::-webkit-datetime-edit-text,\r\n::-webkit-datetime-edit-minute,\r\n::-webkit-datetime-edit-hour-field,\r\n::-webkit-datetime-edit-day-field,\r\n::-webkit-datetime-edit-month-field,\r\n::-webkit-datetime-edit-year-field {\r\n  padding: 0;\r\n}\r\n\r\n::-webkit-inner-spin-button {\r\n  height: auto;\r\n}\r\n\r\n// 1. Correct the outline style in Safari.\r\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\r\n//    `.form-control` class can properly style them. Note that this cannot simply\r\n//    be added to `.form-control` as it's not specific enough. For details, see\r\n//    https://github.com/twbs/bootstrap/issues/11586.\r\n\r\n[type=\"search\"] {\r\n  outline-offset: -2px; // 1\r\n  -webkit-appearance: textfield; // 2\r\n}\r\n\r\n// 1. A few input types should stay LTR\r\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\r\n// 2. RTL only output\r\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\r\n\r\n/* rtl:raw:\r\n[type=\"tel\"],\r\n[type=\"url\"],\r\n[type=\"email\"],\r\n[type=\"number\"] {\r\n  direction: ltr;\r\n}\r\n*/\r\n\r\n// Remove the inner padding in Chrome and Safari on macOS.\r\n\r\n::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n// Remove padding around color pickers in webkit browsers\r\n\r\n::-webkit-color-swatch-wrapper {\r\n  padding: 0;\r\n}\r\n\r\n\r\n// Inherit font family and line height for file input buttons\r\n\r\n::file-selector-button {\r\n  font: inherit;\r\n}\r\n\r\n// 1. Change font properties to `inherit`\r\n// 2. Correct the inability to style clickable types in iOS and Safari.\r\n\r\n::-webkit-file-upload-button {\r\n  font: inherit; // 1\r\n  -webkit-appearance: button; // 2\r\n}\r\n\r\n// Correct element displays\r\n\r\noutput {\r\n  display: inline-block;\r\n}\r\n\r\n// Remove border from iframe\r\n\r\niframe {\r\n  border: 0;\r\n}\r\n\r\n// Summary\r\n//\r\n// 1. Add the correct display in all browsers\r\n\r\nsummary {\r\n  display: list-item; // 1\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n// Progress\r\n//\r\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\r\n\r\nprogress {\r\n  vertical-align: baseline;\r\n}\r\n\r\n\r\n// Hidden attribute\r\n//\r\n// Always hide an element with the `hidden` HTML attribute.\r\n\r\n[hidden] {\r\n  display: none !important;\r\n}\r\n","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n// Color system\r\n\r\n// scss-docs-start gray-color-variables\r\n$white:    #fff !default;\r\n$gray-100: #f8f9fa !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #212529 !default;\r\n$black:    #000 !default;\r\n// scss-docs-end gray-color-variables\r\n\r\n// fusv-disable\r\n// scss-docs-start gray-colors-map\r\n$grays: (\r\n  \"100\": $gray-100,\r\n  \"200\": $gray-200,\r\n  \"300\": $gray-300,\r\n  \"400\": $gray-400,\r\n  \"500\": $gray-500,\r\n  \"600\": $gray-600,\r\n  \"700\": $gray-700,\r\n  \"800\": $gray-800,\r\n  \"900\": $gray-900\r\n) !default;\r\n// scss-docs-end gray-colors-map\r\n// fusv-enable\r\n\r\n// scss-docs-start color-variables\r\n$blue:    #0d6efd !default;\r\n$indigo:  #6610f2 !default;\r\n$purple:  #6f42c1 !default;\r\n$pink:    #d63384 !default;\r\n$red:     #dc3545 !default;\r\n$orange:  #fd7e14 !default;\r\n$yellow:  #ffc107 !default;\r\n$green:   #198754 !default;\r\n$teal:    #20c997 !default;\r\n$cyan:    #0dcaf0 !default;\r\n// scss-docs-end color-variables\r\n\r\n// scss-docs-start colors-map\r\n$colors: (\r\n  \"blue\":       $blue,\r\n  \"indigo\":     $indigo,\r\n  \"purple\":     $purple,\r\n  \"pink\":       $pink,\r\n  \"red\":        $red,\r\n  \"orange\":     $orange,\r\n  \"yellow\":     $yellow,\r\n  \"green\":      $green,\r\n  \"teal\":       $teal,\r\n  \"cyan\":       $cyan,\r\n  \"white\":      $white,\r\n  \"gray\":       $gray-600,\r\n  \"gray-dark\":  $gray-800\r\n) !default;\r\n// scss-docs-end colors-map\r\n\r\n// scss-docs-start theme-color-variables\r\n$primary:       $blue !default;\r\n$secondary:     $gray-600 !default;\r\n$success:       $green !default;\r\n$info:          $cyan !default;\r\n$warning:       $yellow !default;\r\n$danger:        $red !default;\r\n$light:         $gray-100 !default;\r\n$dark:          $gray-900 !default;\r\n// scss-docs-end theme-color-variables\r\n\r\n// scss-docs-start theme-colors-map\r\n$theme-colors: (\r\n  \"primary\":    $primary,\r\n  \"secondary\":  $secondary,\r\n  \"success\":    $success,\r\n  \"info\":       $info,\r\n  \"warning\":    $warning,\r\n  \"danger\":     $danger,\r\n  \"light\":      $light,\r\n  \"dark\":       $dark\r\n) !default;\r\n// scss-docs-end theme-colors-map\r\n\r\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\r\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\r\n$min-contrast-ratio:   4.5 !default;\r\n\r\n// Customize the light and dark text colors for use in our color contrast function.\r\n$color-contrast-dark:      $black !default;\r\n$color-contrast-light:     $white !default;\r\n\r\n// fusv-disable\r\n$blue-100: tint-color($blue, 80%) !default;\r\n$blue-200: tint-color($blue, 60%) !default;\r\n$blue-300: tint-color($blue, 40%) !default;\r\n$blue-400: tint-color($blue, 20%) !default;\r\n$blue-500: $blue !default;\r\n$blue-600: shade-color($blue, 20%) !default;\r\n$blue-700: shade-color($blue, 40%) !default;\r\n$blue-800: shade-color($blue, 60%) !default;\r\n$blue-900: shade-color($blue, 80%) !default;\r\n\r\n$indigo-100: tint-color($indigo, 80%) !default;\r\n$indigo-200: tint-color($indigo, 60%) !default;\r\n$indigo-300: tint-color($indigo, 40%) !default;\r\n$indigo-400: tint-color($indigo, 20%) !default;\r\n$indigo-500: $indigo !default;\r\n$indigo-600: shade-color($indigo, 20%) !default;\r\n$indigo-700: shade-color($indigo, 40%) !default;\r\n$indigo-800: shade-color($indigo, 60%) !default;\r\n$indigo-900: shade-color($indigo, 80%) !default;\r\n\r\n$purple-100: tint-color($purple, 80%) !default;\r\n$purple-200: tint-color($purple, 60%) !default;\r\n$purple-300: tint-color($purple, 40%) !default;\r\n$purple-400: tint-color($purple, 20%) !default;\r\n$purple-500: $purple !default;\r\n$purple-600: shade-color($purple, 20%) !default;\r\n$purple-700: shade-color($purple, 40%) !default;\r\n$purple-800: shade-color($purple, 60%) !default;\r\n$purple-900: shade-color($purple, 80%) !default;\r\n\r\n$pink-100: tint-color($pink, 80%) !default;\r\n$pink-200: tint-color($pink, 60%) !default;\r\n$pink-300: tint-color($pink, 40%) !default;\r\n$pink-400: tint-color($pink, 20%) !default;\r\n$pink-500: $pink !default;\r\n$pink-600: shade-color($pink, 20%) !default;\r\n$pink-700: shade-color($pink, 40%) !default;\r\n$pink-800: shade-color($pink, 60%) !default;\r\n$pink-900: shade-color($pink, 80%) !default;\r\n\r\n$red-100: tint-color($red, 80%) !default;\r\n$red-200: tint-color($red, 60%) !default;\r\n$red-300: tint-color($red, 40%) !default;\r\n$red-400: tint-color($red, 20%) !default;\r\n$red-500: $red !default;\r\n$red-600: shade-color($red, 20%) !default;\r\n$red-700: shade-color($red, 40%) !default;\r\n$red-800: shade-color($red, 60%) !default;\r\n$red-900: shade-color($red, 80%) !default;\r\n\r\n$orange-100: tint-color($orange, 80%) !default;\r\n$orange-200: tint-color($orange, 60%) !default;\r\n$orange-300: tint-color($orange, 40%) !default;\r\n$orange-400: tint-color($orange, 20%) !default;\r\n$orange-500: $orange !default;\r\n$orange-600: shade-color($orange, 20%) !default;\r\n$orange-700: shade-color($orange, 40%) !default;\r\n$orange-800: shade-color($orange, 60%) !default;\r\n$orange-900: shade-color($orange, 80%) !default;\r\n\r\n$yellow-100: tint-color($yellow, 80%) !default;\r\n$yellow-200: tint-color($yellow, 60%) !default;\r\n$yellow-300: tint-color($yellow, 40%) !default;\r\n$yellow-400: tint-color($yellow, 20%) !default;\r\n$yellow-500: $yellow !default;\r\n$yellow-600: shade-color($yellow, 20%) !default;\r\n$yellow-700: shade-color($yellow, 40%) !default;\r\n$yellow-800: shade-color($yellow, 60%) !default;\r\n$yellow-900: shade-color($yellow, 80%) !default;\r\n\r\n$green-100: tint-color($green, 80%) !default;\r\n$green-200: tint-color($green, 60%) !default;\r\n$green-300: tint-color($green, 40%) !default;\r\n$green-400: tint-color($green, 20%) !default;\r\n$green-500: $green !default;\r\n$green-600: shade-color($green, 20%) !default;\r\n$green-700: shade-color($green, 40%) !default;\r\n$green-800: shade-color($green, 60%) !default;\r\n$green-900: shade-color($green, 80%) !default;\r\n\r\n$teal-100: tint-color($teal, 80%) !default;\r\n$teal-200: tint-color($teal, 60%) !default;\r\n$teal-300: tint-color($teal, 40%) !default;\r\n$teal-400: tint-color($teal, 20%) !default;\r\n$teal-500: $teal !default;\r\n$teal-600: shade-color($teal, 20%) !default;\r\n$teal-700: shade-color($teal, 40%) !default;\r\n$teal-800: shade-color($teal, 60%) !default;\r\n$teal-900: shade-color($teal, 80%) !default;\r\n\r\n$cyan-100: tint-color($cyan, 80%) !default;\r\n$cyan-200: tint-color($cyan, 60%) !default;\r\n$cyan-300: tint-color($cyan, 40%) !default;\r\n$cyan-400: tint-color($cyan, 20%) !default;\r\n$cyan-500: $cyan !default;\r\n$cyan-600: shade-color($cyan, 20%) !default;\r\n$cyan-700: shade-color($cyan, 40%) !default;\r\n$cyan-800: shade-color($cyan, 60%) !default;\r\n$cyan-900: shade-color($cyan, 80%) !default;\r\n// fusv-enable\r\n\r\n// Characters which are escaped by the escape-svg function\r\n$escaped-characters: (\r\n  (\"<\", \"%3c\"),\r\n  (\">\", \"%3e\"),\r\n  (\"#\", \"%23\"),\r\n  (\"(\", \"%28\"),\r\n  (\")\", \"%29\"),\r\n) !default;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret:                true !default;\r\n$enable-rounded:              true !default;\r\n$enable-shadows:              false !default;\r\n$enable-gradients:            false !default;\r\n$enable-transitions:          true !default;\r\n$enable-reduced-motion:       true !default;\r\n$enable-smooth-scroll:        true !default;\r\n$enable-grid-classes:         true !default;\r\n$enable-button-pointers:      true !default;\r\n$enable-rfs:                  true !default;\r\n$enable-validation-icons:     true !default;\r\n$enable-negative-margins:     false !default;\r\n$enable-deprecation-messages: true !default;\r\n$enable-important-utilities:  true !default;\r\n\r\n// Prefix for :root CSS variables\r\n\r\n$variable-prefix:             bs- !default;\r\n\r\n// Gradient\r\n//\r\n// The gradient which is added to components if `$enable-gradients` is `true`\r\n// This gradient is also added to elements with `.bg-gradient`\r\n// scss-docs-start variable-gradient\r\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\r\n// scss-docs-end variable-gradient\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// scss-docs-start spacer-variables-maps\r\n$spacer: 1rem !default;\r\n$spacers: (\r\n  0: 0,\r\n  1: $spacer * .25,\r\n  2: $spacer * .5,\r\n  3: $spacer,\r\n  4: $spacer * 1.5,\r\n  5: $spacer * 3,\r\n) !default;\r\n\r\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\r\n// scss-docs-end spacer-variables-maps\r\n\r\n// Position\r\n//\r\n// Define the edge positioning anchors of the position utilities.\r\n\r\n// scss-docs-start position-map\r\n$position-values: (\r\n  0: 0,\r\n  50: 50%,\r\n  100: 100%\r\n) !default;\r\n// scss-docs-end position-map\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg:                   $white !default;\r\n$body-color:                $gray-900 !default;\r\n$body-text-align:           null !default;\r\n\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color:                              $primary !default;\r\n$link-decoration:                         underline !default;\r\n$link-shade-percentage:                   20% !default;\r\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\r\n$link-hover-decoration:                   null !default;\r\n\r\n$stretched-link-pseudo-element:           after !default;\r\n$stretched-link-z-index:                  1 !default;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom:   1rem !default;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n// scss-docs-start grid-breakpoints\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px,\r\n  xxl: 1400px\r\n) !default;\r\n// scss-docs-end grid-breakpoints\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\r\n\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n// scss-docs-start container-max-widths\r\n$container-max-widths: (\r\n  sm: 540px,\r\n  md: 720px,\r\n  lg: 960px,\r\n  xl: 1140px,\r\n  xxl: 1320px\r\n) !default;\r\n// scss-docs-end container-max-widths\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns:                12 !default;\r\n$grid-gutter-width:           1.5rem !default;\r\n$grid-row-columns:            6 !default;\r\n\r\n$gutters: $spacers !default;\r\n\r\n// Container padding\r\n\r\n$container-padding-x: $grid-gutter-width * .5 !default;\r\n\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n// scss-docs-start border-variables\r\n$border-width:                1px !default;\r\n$border-widths: (\r\n  1: 1px,\r\n  2: 2px,\r\n  3: 3px,\r\n  4: 4px,\r\n  5: 5px\r\n) !default;\r\n\r\n$border-color:                $gray-300 !default;\r\n// scss-docs-end border-variables\r\n\r\n// scss-docs-start border-radius-variables\r\n$border-radius:               .25rem !default;\r\n$border-radius-sm:            .2rem !default;\r\n$border-radius-lg:            .3rem !default;\r\n$border-radius-pill:          50rem !default;\r\n// scss-docs-end border-radius-variables\r\n\r\n// scss-docs-start box-shadow-variables\r\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\r\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\r\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\r\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\r\n// scss-docs-end box-shadow-variables\r\n\r\n$component-active-color:      $white !default;\r\n$component-active-bg:         $primary !default;\r\n\r\n// scss-docs-start caret-variables\r\n$caret-width:                 .3em !default;\r\n$caret-vertical-align:        $caret-width * .85 !default;\r\n$caret-spacing:               $caret-width * .85 !default;\r\n// scss-docs-end caret-variables\r\n\r\n$transition-base:             all .2s ease-in-out !default;\r\n$transition-fade:             opacity .15s linear !default;\r\n// scss-docs-start collapse-transition\r\n$transition-collapse:         height .35s ease !default;\r\n// scss-docs-end collapse-transition\r\n\r\n// stylelint-disable function-disallowed-list\r\n// scss-docs-start aspect-ratios\r\n$aspect-ratios: (\r\n  \"1x1\": 100%,\r\n  \"4x3\": calc(3 / 4 * 100%),\r\n  \"16x9\": calc(9 / 16 * 100%),\r\n  \"21x9\": calc(9 / 21 * 100%)\r\n) !default;\r\n// scss-docs-end aspect-ratios\r\n// stylelint-enable function-disallowed-list\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// scss-docs-start font-variables\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\r\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\r\n// stylelint-enable value-keyword-case\r\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\r\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\r\n\r\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\r\n// $font-size-base affects the font size of the body text\r\n$font-size-root:              null !default;\r\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-sm:                $font-size-base * .875 !default;\r\n$font-size-lg:                $font-size-base * 1.25 !default;\r\n\r\n$font-weight-lighter:         lighter !default;\r\n$font-weight-light:           300 !default;\r\n$font-weight-normal:          400 !default;\r\n$font-weight-bold:            700 !default;\r\n$font-weight-bolder:          bolder !default;\r\n\r\n$font-weight-base:            $font-weight-normal !default;\r\n\r\n$line-height-base:            1.5 !default;\r\n$line-height-sm:              1.25 !default;\r\n$line-height-lg:              2 !default;\r\n\r\n$h1-font-size:                $font-size-base * 2.5 !default;\r\n$h2-font-size:                $font-size-base * 2 !default;\r\n$h3-font-size:                $font-size-base * 1.75 !default;\r\n$h4-font-size:                $font-size-base * 1.5 !default;\r\n$h5-font-size:                $font-size-base * 1.25 !default;\r\n$h6-font-size:                $font-size-base !default;\r\n// scss-docs-end font-variables\r\n\r\n// scss-docs-start font-sizes\r\n$font-sizes: (\r\n  1: $h1-font-size,\r\n  2: $h2-font-size,\r\n  3: $h3-font-size,\r\n  4: $h4-font-size,\r\n  5: $h5-font-size,\r\n  6: $h6-font-size\r\n) !default;\r\n// scss-docs-end font-sizes\r\n\r\n// scss-docs-start headings-variables\r\n$headings-margin-bottom:      $spacer * .5 !default;\r\n$headings-font-family:        null !default;\r\n$headings-font-style:         null !default;\r\n$headings-font-weight:        500 !default;\r\n$headings-line-height:        1.2 !default;\r\n$headings-color:              null !default;\r\n// scss-docs-end headings-variables\r\n\r\n// scss-docs-start display-headings\r\n$display-font-sizes: (\r\n  1: 5rem,\r\n  2: 4.5rem,\r\n  3: 4rem,\r\n  4: 3.5rem,\r\n  5: 3rem,\r\n  6: 2.5rem\r\n) !default;\r\n\r\n$display-font-weight: 300 !default;\r\n$display-line-height: $headings-line-height !default;\r\n// scss-docs-end display-headings\r\n\r\n// scss-docs-start type-variables\r\n$lead-font-size:              $font-size-base * 1.25 !default;\r\n$lead-font-weight:            300 !default;\r\n\r\n$small-font-size:             .875em !default;\r\n\r\n$sub-sup-font-size:           .75em !default;\r\n\r\n$text-muted:                  $gray-600 !default;\r\n\r\n$initialism-font-size:        $small-font-size !default;\r\n\r\n$blockquote-margin-y:         $spacer !default;\r\n$blockquote-font-size:        $font-size-base * 1.25 !default;\r\n$blockquote-footer-color:     $gray-600 !default;\r\n$blockquote-footer-font-size: $small-font-size !default;\r\n\r\n$hr-margin-y:                 $spacer !default;\r\n$hr-color:                    inherit !default;\r\n$hr-height:                   $border-width !default;\r\n$hr-opacity:                  .25 !default;\r\n\r\n$legend-margin-bottom:        .5rem !default;\r\n$legend-font-size:            1.5rem !default;\r\n$legend-font-weight:          null !default;\r\n\r\n$mark-padding:                .2em !default;\r\n\r\n$dt-font-weight:              $font-weight-bold !default;\r\n\r\n$nested-kbd-font-weight:      $font-weight-bold !default;\r\n\r\n$list-inline-padding:         .5rem !default;\r\n\r\n$mark-bg:                     #fcf8e3 !default;\r\n// scss-docs-end type-variables\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n// scss-docs-start table-variables\r\n$table-cell-padding-y:        .5rem !default;\r\n$table-cell-padding-x:        .5rem !default;\r\n$table-cell-padding-y-sm:     .25rem !default;\r\n$table-cell-padding-x-sm:     .25rem !default;\r\n\r\n$table-cell-vertical-align:   top !default;\r\n\r\n$table-color:                 $body-color !default;\r\n$table-bg:                    transparent !default;\r\n$table-accent-bg:             transparent !default;\r\n\r\n$table-th-font-weight:        null !default;\r\n\r\n$table-striped-color:         $table-color !default;\r\n$table-striped-bg-factor:     .05 !default;\r\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\r\n\r\n$table-active-color:          $table-color !default;\r\n$table-active-bg-factor:      .1 !default;\r\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\r\n\r\n$table-hover-color:           $table-color !default;\r\n$table-hover-bg-factor:       .075 !default;\r\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\r\n\r\n$table-border-factor:         .1 !default;\r\n$table-border-width:          $border-width !default;\r\n$table-border-color:          $border-color !default;\r\n\r\n$table-striped-order:         odd !default;\r\n\r\n$table-group-separator-color: currentColor !default;\r\n\r\n$table-caption-color:         $text-muted !default;\r\n\r\n$table-bg-scale:              -80% !default;\r\n// scss-docs-end table-variables\r\n\r\n// scss-docs-start table-loop\r\n$table-variants: (\r\n  \"primary\":    shift-color($primary, $table-bg-scale),\r\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\r\n  \"success\":    shift-color($success, $table-bg-scale),\r\n  \"info\":       shift-color($info, $table-bg-scale),\r\n  \"warning\":    shift-color($warning, $table-bg-scale),\r\n  \"danger\":     shift-color($danger, $table-bg-scale),\r\n  \"light\":      $light,\r\n  \"dark\":       $dark,\r\n) !default;\r\n// scss-docs-end table-loop\r\n\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n// scss-docs-start input-btn-variables\r\n$input-btn-padding-y:         .375rem !default;\r\n$input-btn-padding-x:         .75rem !default;\r\n$input-btn-font-family:       null !default;\r\n$input-btn-font-size:         $font-size-base !default;\r\n$input-btn-line-height:       $line-height-base !default;\r\n\r\n$input-btn-focus-width:         .25rem !default;\r\n$input-btn-focus-color-opacity: .25 !default;\r\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\r\n$input-btn-focus-blur:          0 !default;\r\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\r\n\r\n$input-btn-padding-y-sm:      .25rem !default;\r\n$input-btn-padding-x-sm:      .5rem !default;\r\n$input-btn-font-size-sm:      $font-size-sm !default;\r\n\r\n$input-btn-padding-y-lg:      .5rem !default;\r\n$input-btn-padding-x-lg:      1rem !default;\r\n$input-btn-font-size-lg:      $font-size-lg !default;\r\n\r\n$input-btn-border-width:      $border-width !default;\r\n// scss-docs-end input-btn-variables\r\n\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n// scss-docs-start btn-variables\r\n$btn-padding-y:               $input-btn-padding-y !default;\r\n$btn-padding-x:               $input-btn-padding-x !default;\r\n$btn-font-family:             $input-btn-font-family !default;\r\n$btn-font-size:               $input-btn-font-size !default;\r\n$btn-line-height:             $input-btn-line-height !default;\r\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\r\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\r\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\r\n\r\n$btn-border-width:            $input-btn-border-width !default;\r\n\r\n$btn-font-weight:             $font-weight-normal !default;\r\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\r\n$btn-focus-width:             $input-btn-focus-width !default;\r\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\r\n$btn-disabled-opacity:        .65 !default;\r\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\r\n\r\n$btn-link-color:              $link-color !default;\r\n$btn-link-hover-color:        $link-hover-color !default;\r\n$btn-link-disabled-color:     $gray-600 !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius:           $border-radius !default;\r\n$btn-border-radius-sm:        $border-radius-sm !default;\r\n$btn-border-radius-lg:        $border-radius-lg !default;\r\n\r\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$btn-hover-bg-shade-amount:       15% !default;\r\n$btn-hover-bg-tint-amount:        15% !default;\r\n$btn-hover-border-shade-amount:   20% !default;\r\n$btn-hover-border-tint-amount:    10% !default;\r\n$btn-active-bg-shade-amount:      20% !default;\r\n$btn-active-bg-tint-amount:       20% !default;\r\n$btn-active-border-shade-amount:  25% !default;\r\n$btn-active-border-tint-amount:   10% !default;\r\n// scss-docs-end btn-variables\r\n\r\n\r\n// Forms\r\n\r\n// scss-docs-start form-text-variables\r\n$form-text-margin-top:                  .25rem !default;\r\n$form-text-font-size:                   $small-font-size !default;\r\n$form-text-font-style:                  null !default;\r\n$form-text-font-weight:                 null !default;\r\n$form-text-color:                       $text-muted !default;\r\n// scss-docs-end form-text-variables\r\n\r\n// scss-docs-start form-label-variables\r\n$form-label-margin-bottom:              .5rem !default;\r\n$form-label-font-size:                  null !default;\r\n$form-label-font-style:                 null !default;\r\n$form-label-font-weight:                null !default;\r\n$form-label-color:                      null !default;\r\n// scss-docs-end form-label-variables\r\n\r\n// scss-docs-start form-input-variables\r\n$input-padding-y:                       $input-btn-padding-y !default;\r\n$input-padding-x:                       $input-btn-padding-x !default;\r\n$input-font-family:                     $input-btn-font-family !default;\r\n$input-font-size:                       $input-btn-font-size !default;\r\n$input-font-weight:                     $font-weight-base !default;\r\n$input-line-height:                     $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\r\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\r\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\r\n\r\n$input-bg:                              $white !default;\r\n$input-disabled-bg:                     $gray-200 !default;\r\n$input-disabled-border-color:           null !default;\r\n\r\n$input-color:                           $body-color !default;\r\n$input-border-color:                    $gray-400 !default;\r\n$input-border-width:                    $input-btn-border-width !default;\r\n$input-box-shadow:                      $box-shadow-inset !default;\r\n\r\n$input-border-radius:                   $border-radius !default;\r\n$input-border-radius-sm:                $border-radius-sm !default;\r\n$input-border-radius-lg:                $border-radius-lg !default;\r\n\r\n$input-focus-bg:                        $input-bg !default;\r\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\r\n$input-focus-color:                     $input-color !default;\r\n$input-focus-width:                     $input-btn-focus-width !default;\r\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\r\n\r\n$input-placeholder-color:               $gray-600 !default;\r\n$input-plaintext-color:                 $body-color !default;\r\n\r\n$input-height-border:                   $input-border-width * 2 !default;\r\n\r\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\r\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\r\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\r\n\r\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\r\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\r\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\r\n\r\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n// scss-docs-end form-input-variables\r\n\r\n// scss-docs-start form-check-variables\r\n$form-check-input-width:                  1em !default;\r\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\r\n$form-check-padding-start:                $form-check-input-width + .5em !default;\r\n$form-check-margin-bottom:                .125rem !default;\r\n$form-check-label-color:                  null !default;\r\n$form-check-label-cursor:                 null !default;\r\n$form-check-transition:                   null !default;\r\n\r\n$form-check-input-active-filter:          brightness(90%) !default;\r\n\r\n$form-check-input-bg:                     $input-bg !default;\r\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\r\n$form-check-input-border-radius:          .25em !default;\r\n$form-check-radio-border-radius:          50% !default;\r\n$form-check-input-focus-border:           $input-focus-border-color !default;\r\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\r\n\r\n$form-check-input-checked-color:          $component-active-color !default;\r\n$form-check-input-checked-bg-color:       $component-active-bg !default;\r\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\r\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\r\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\r\n\r\n$form-check-input-indeterminate-color:          $component-active-color !default;\r\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\r\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\r\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\r\n\r\n$form-check-input-disabled-opacity:        .5 !default;\r\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\r\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\r\n\r\n$form-check-inline-margin-end:    1rem !default;\r\n// scss-docs-end form-check-variables\r\n\r\n// scss-docs-start form-switch-variables\r\n$form-switch-color:               rgba(0, 0, 0, .25) !default;\r\n$form-switch-width:               2em !default;\r\n$form-switch-padding-start:       $form-switch-width + .5em !default;\r\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\r\n$form-switch-border-radius:       $form-switch-width !default;\r\n$form-switch-transition:          background-position .15s ease-in-out !default;\r\n\r\n$form-switch-focus-color:         $input-focus-border-color !default;\r\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\r\n\r\n$form-switch-checked-color:       $component-active-color !default;\r\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\r\n$form-switch-checked-bg-position: right center !default;\r\n// scss-docs-end form-switch-variables\r\n\r\n// scss-docs-start input-group-variables\r\n$input-group-addon-padding-y:           $input-padding-y !default;\r\n$input-group-addon-padding-x:           $input-padding-x !default;\r\n$input-group-addon-font-weight:         $input-font-weight !default;\r\n$input-group-addon-color:               $input-color !default;\r\n$input-group-addon-bg:                  $gray-200 !default;\r\n$input-group-addon-border-color:        $input-border-color !default;\r\n// scss-docs-end input-group-variables\r\n\r\n// scss-docs-start form-select-variables\r\n$form-select-padding-y:             $input-padding-y !default;\r\n$form-select-padding-x:             $input-padding-x !default;\r\n$form-select-font-family:           $input-font-family !default;\r\n$form-select-font-size:             $input-font-size !default;\r\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\r\n$form-select-font-weight:           $input-font-weight !default;\r\n$form-select-line-height:           $input-line-height !default;\r\n$form-select-color:                 $input-color !default;\r\n$form-select-bg:                    $input-bg !default;\r\n$form-select-disabled-color:        null !default;\r\n$form-select-disabled-bg:           $gray-200 !default;\r\n$form-select-disabled-border-color: $input-disabled-border-color !default;\r\n$form-select-bg-position:           right $form-select-padding-x center !default;\r\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\r\n$form-select-indicator-color:       $gray-800 !default;\r\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\r\n\r\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\r\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\r\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\r\n\r\n$form-select-border-width:        $input-border-width !default;\r\n$form-select-border-color:        $input-border-color !default;\r\n$form-select-border-radius:       $border-radius !default;\r\n$form-select-box-shadow:          $box-shadow-inset !default;\r\n\r\n$form-select-focus-border-color:  $input-focus-border-color !default;\r\n$form-select-focus-width:         $input-focus-width !default;\r\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\r\n\r\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\r\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\r\n$form-select-font-size-sm:        $input-font-size-sm !default;\r\n\r\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\r\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\r\n$form-select-font-size-lg:        $input-font-size-lg !default;\r\n\r\n$form-select-transition:          $input-transition !default;\r\n// scss-docs-end form-select-variables\r\n\r\n// scss-docs-start form-range-variables\r\n$form-range-track-width:          100% !default;\r\n$form-range-track-height:         .5rem !default;\r\n$form-range-track-cursor:         pointer !default;\r\n$form-range-track-bg:             $gray-300 !default;\r\n$form-range-track-border-radius:  1rem !default;\r\n$form-range-track-box-shadow:     $box-shadow-inset !default;\r\n\r\n$form-range-thumb-width:                   1rem !default;\r\n$form-range-thumb-height:                  $form-range-thumb-width !default;\r\n$form-range-thumb-bg:                      $component-active-bg !default;\r\n$form-range-thumb-border:                  0 !default;\r\n$form-range-thumb-border-radius:           1rem !default;\r\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\r\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\r\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\r\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\r\n$form-range-thumb-disabled-bg:             $gray-500 !default;\r\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n// scss-docs-end form-range-variables\r\n\r\n// scss-docs-start form-file-variables\r\n$form-file-button-color:          $input-color !default;\r\n$form-file-button-bg:             $input-group-addon-bg !default;\r\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\r\n// scss-docs-end form-file-variables\r\n\r\n// scss-docs-start form-floating-variables\r\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\r\n$form-floating-line-height:       1.25 !default;\r\n$form-floating-padding-x:         $input-padding-x !default;\r\n$form-floating-padding-y:         1rem !default;\r\n$form-floating-input-padding-t:   1.625rem !default;\r\n$form-floating-input-padding-b:   .625rem !default;\r\n$form-floating-label-opacity:     .65 !default;\r\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\r\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\r\n// scss-docs-end form-floating-variables\r\n\r\n// Form validation\r\n\r\n// scss-docs-start form-feedback-variables\r\n$form-feedback-margin-top:          $form-text-margin-top !default;\r\n$form-feedback-font-size:           $form-text-font-size !default;\r\n$form-feedback-font-style:          $form-text-font-style !default;\r\n$form-feedback-valid-color:         $success !default;\r\n$form-feedback-invalid-color:       $danger !default;\r\n\r\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\r\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\r\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\r\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\r\n// scss-docs-end form-feedback-variables\r\n\r\n// scss-docs-start form-validation-states\r\n$form-validation-states: (\r\n  \"valid\": (\r\n    \"color\": $form-feedback-valid-color,\r\n    \"icon\": $form-feedback-icon-valid\r\n  ),\r\n  \"invalid\": (\r\n    \"color\": $form-feedback-invalid-color,\r\n    \"icon\": $form-feedback-icon-invalid\r\n  )\r\n) !default;\r\n// scss-docs-end form-validation-states\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n// scss-docs-start zindex-stack\r\n$zindex-dropdown:                   1000 !default;\r\n$zindex-sticky:                     1020 !default;\r\n$zindex-fixed:                      1030 !default;\r\n$zindex-modal-backdrop:             1040 !default;\r\n$zindex-offcanvas:                  1050 !default;\r\n$zindex-modal:                      1060 !default;\r\n$zindex-popover:                    1070 !default;\r\n$zindex-tooltip:                    1080 !default;\r\n// scss-docs-end zindex-stack\r\n\r\n\r\n// Navs\r\n\r\n// scss-docs-start nav-variables\r\n$nav-link-padding-y:                .5rem !default;\r\n$nav-link-padding-x:                1rem !default;\r\n$nav-link-font-size:                null !default;\r\n$nav-link-font-weight:              null !default;\r\n$nav-link-color:                    $link-color !default;\r\n$nav-link-hover-color:              $link-hover-color !default;\r\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\r\n$nav-link-disabled-color:           $gray-600 !default;\r\n\r\n$nav-tabs-border-color:             $gray-300 !default;\r\n$nav-tabs-border-width:             $border-width !default;\r\n$nav-tabs-border-radius:            $border-radius !default;\r\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-active-color:        $gray-700 !default;\r\n$nav-tabs-link-active-bg:           $body-bg !default;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n\r\n$nav-pills-border-radius:           $border-radius !default;\r\n$nav-pills-link-active-color:       $component-active-color !default;\r\n$nav-pills-link-active-bg:          $component-active-bg !default;\r\n// scss-docs-end nav-variables\r\n\r\n\r\n// Navbar\r\n\r\n// scss-docs-start navbar-variables\r\n$navbar-padding-y:                  $spacer * .5 !default;\r\n$navbar-padding-x:                  null !default;\r\n\r\n$navbar-nav-link-padding-x:         .5rem !default;\r\n\r\n$navbar-brand-font-size:            $font-size-lg !default;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\r\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\r\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\r\n$navbar-brand-margin-end:           1rem !default;\r\n\r\n$navbar-toggler-padding-y:          .25rem !default;\r\n$navbar-toggler-padding-x:          .75rem !default;\r\n$navbar-toggler-font-size:          $font-size-lg !default;\r\n$navbar-toggler-border-radius:      $btn-border-radius !default;\r\n$navbar-toggler-focus-width:        $btn-focus-width !default;\r\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\r\n// scss-docs-end navbar-variables\r\n\r\n// scss-docs-start navbar-theme-variables\r\n$navbar-dark-color:                 rgba($white, .55) !default;\r\n$navbar-dark-hover-color:           rgba($white, .75) !default;\r\n$navbar-dark-active-color:          $white !default;\r\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\r\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\r\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\r\n\r\n$navbar-light-color:                rgba($black, .55) !default;\r\n$navbar-light-hover-color:          rgba($black, .7) !default;\r\n$navbar-light-active-color:         rgba($black, .9) !default;\r\n$navbar-light-disabled-color:       rgba($black, .3) !default;\r\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\r\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\r\n\r\n$navbar-light-brand-color:                $navbar-light-active-color !default;\r\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\r\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\r\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\r\n// scss-docs-end navbar-theme-variables\r\n\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n// scss-docs-start dropdown-variables\r\n$dropdown-min-width:                10rem !default;\r\n$dropdown-padding-x:                0 !default;\r\n$dropdown-padding-y:                .5rem !default;\r\n$dropdown-spacer:                   .125rem !default;\r\n$dropdown-font-size:                $font-size-base !default;\r\n$dropdown-color:                    $body-color !default;\r\n$dropdown-bg:                       $white !default;\r\n$dropdown-border-color:             rgba($black, .15) !default;\r\n$dropdown-border-radius:            $border-radius !default;\r\n$dropdown-border-width:             $border-width !default;\r\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\r\n$dropdown-divider-bg:               $dropdown-border-color !default;\r\n$dropdown-divider-margin-y:         $spacer * .5 !default;\r\n$dropdown-box-shadow:               $box-shadow !default;\r\n\r\n$dropdown-link-color:               $gray-900 !default;\r\n$dropdown-link-hover-color:         shade-color($gray-900, 10%) !default;\r\n$dropdown-link-hover-bg:            $gray-200 !default;\r\n\r\n$dropdown-link-active-color:        $component-active-color !default;\r\n$dropdown-link-active-bg:           $component-active-bg !default;\r\n\r\n$dropdown-link-disabled-color:      $gray-500 !default;\r\n\r\n$dropdown-item-padding-y:           $spacer * .25 !default;\r\n$dropdown-item-padding-x:           $spacer !default;\r\n\r\n$dropdown-header-color:             $gray-600 !default;\r\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\r\n// scss-docs-end dropdown-variables\r\n\r\n// scss-docs-start dropdown-dark-variables\r\n$dropdown-dark-color:               $gray-300 !default;\r\n$dropdown-dark-bg:                  $gray-800 !default;\r\n$dropdown-dark-border-color:        $dropdown-border-color !default;\r\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\r\n$dropdown-dark-box-shadow:          null !default;\r\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\r\n$dropdown-dark-link-hover-color:    $white !default;\r\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\r\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\r\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\r\n$dropdown-dark-link-disabled-color: $gray-500 !default;\r\n$dropdown-dark-header-color:        $gray-500 !default;\r\n// scss-docs-end dropdown-dark-variables\r\n\r\n\r\n// Pagination\r\n\r\n// scss-docs-start pagination-variables\r\n$pagination-padding-y:              .375rem !default;\r\n$pagination-padding-x:              .75rem !default;\r\n$pagination-padding-y-sm:           .25rem !default;\r\n$pagination-padding-x-sm:           .5rem !default;\r\n$pagination-padding-y-lg:           .75rem !default;\r\n$pagination-padding-x-lg:           1.5rem !default;\r\n\r\n$pagination-color:                  $link-color !default;\r\n$pagination-bg:                     $white !default;\r\n$pagination-border-width:           $border-width !default;\r\n$pagination-border-radius:          $border-radius !default;\r\n$pagination-margin-start:           -$pagination-border-width !default;\r\n$pagination-border-color:           $gray-300 !default;\r\n\r\n$pagination-focus-color:            $link-hover-color !default;\r\n$pagination-focus-bg:               $gray-200 !default;\r\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\r\n$pagination-focus-outline:          0 !default;\r\n\r\n$pagination-hover-color:            $link-hover-color !default;\r\n$pagination-hover-bg:               $gray-200 !default;\r\n$pagination-hover-border-color:     $gray-300 !default;\r\n\r\n$pagination-active-color:           $component-active-color !default;\r\n$pagination-active-bg:              $component-active-bg !default;\r\n$pagination-active-border-color:    $pagination-active-bg !default;\r\n\r\n$pagination-disabled-color:         $gray-600 !default;\r\n$pagination-disabled-bg:            $white !default;\r\n$pagination-disabled-border-color:  $gray-300 !default;\r\n\r\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$pagination-border-radius-sm:       $border-radius-sm !default;\r\n$pagination-border-radius-lg:       $border-radius-lg !default;\r\n// scss-docs-end pagination-variables\r\n\r\n\r\n// Cards\r\n\r\n// scss-docs-start card-variables\r\n$card-spacer-y:                     $spacer !default;\r\n$card-spacer-x:                     $spacer !default;\r\n$card-title-spacer-y:               $spacer * .5 !default;\r\n$card-border-width:                 $border-width !default;\r\n$card-border-radius:                $border-radius !default;\r\n$card-border-color:                 rgba($black, .125) !default;\r\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\r\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\r\n$card-cap-padding-x:                $card-spacer-x !default;\r\n$card-cap-bg:                       rgba($black, .03) !default;\r\n$card-cap-color:                    null !default;\r\n$card-height:                       null !default;\r\n$card-color:                        null !default;\r\n$card-bg:                           $white !default;\r\n$card-img-overlay-padding:          $spacer !default;\r\n$card-group-margin:                 $grid-gutter-width * .5 !default;\r\n// scss-docs-end card-variables\r\n\r\n// Accordion\r\n\r\n// scss-docs-start accordion-variables\r\n$accordion-padding-y:                     1rem !default;\r\n$accordion-padding-x:                     1.25rem !default;\r\n$accordion-color:                         $body-color !default;\r\n$accordion-bg:                            $body-bg !default;\r\n$accordion-border-width:                  $border-width !default;\r\n$accordion-border-color:                  rgba($black, .125) !default;\r\n$accordion-border-radius:                 $border-radius !default;\r\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\r\n\r\n$accordion-body-padding-y:                $accordion-padding-y !default;\r\n$accordion-body-padding-x:                $accordion-padding-x !default;\r\n\r\n$accordion-button-padding-y:              $accordion-padding-y !default;\r\n$accordion-button-padding-x:              $accordion-padding-x !default;\r\n$accordion-button-color:                  $accordion-color !default;\r\n$accordion-button-bg:                     $accordion-bg !default;\r\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\r\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\r\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\r\n\r\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\r\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\r\n\r\n$accordion-icon-width:                    1.25rem !default;\r\n$accordion-icon-color:                    $accordion-color !default;\r\n$accordion-icon-active-color:             $accordion-button-active-color !default;\r\n$accordion-icon-transition:               transform .2s ease-in-out !default;\r\n$accordion-icon-transform:                rotate(-180deg) !default;\r\n\r\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n// scss-docs-end accordion-variables\r\n\r\n// Tooltips\r\n\r\n// scss-docs-start tooltip-variables\r\n$tooltip-font-size:                 $font-size-sm !default;\r\n$tooltip-max-width:                 200px !default;\r\n$tooltip-color:                     $white !default;\r\n$tooltip-bg:                        $black !default;\r\n$tooltip-border-radius:             $border-radius !default;\r\n$tooltip-opacity:                   .9 !default;\r\n$tooltip-padding-y:                 $spacer * .25 !default;\r\n$tooltip-padding-x:                 $spacer * .5 !default;\r\n$tooltip-margin:                    0 !default;\r\n\r\n$tooltip-arrow-width:               .8rem !default;\r\n$tooltip-arrow-height:              .4rem !default;\r\n$tooltip-arrow-color:               $tooltip-bg !default;\r\n// scss-docs-end tooltip-variables\r\n\r\n// Form tooltips must come after regular tooltips\r\n// scss-docs-start tooltip-feedback-variables\r\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\r\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\r\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\r\n$form-feedback-tooltip-line-height:   null !default;\r\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\r\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\r\n// scss-docs-end tooltip-feedback-variables\r\n\r\n\r\n// Popovers\r\n\r\n// scss-docs-start popover-variables\r\n$popover-font-size:                 $font-size-sm !default;\r\n$popover-bg:                        $white !default;\r\n$popover-max-width:                 276px !default;\r\n$popover-border-width:              $border-width !default;\r\n$popover-border-color:              rgba($black, .2) !default;\r\n$popover-border-radius:             $border-radius-lg !default;\r\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\r\n$popover-box-shadow:                $box-shadow !default;\r\n\r\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\r\n$popover-header-color:              $headings-color !default;\r\n$popover-header-padding-y:          .5rem !default;\r\n$popover-header-padding-x:          $spacer !default;\r\n\r\n$popover-body-color:                $body-color !default;\r\n$popover-body-padding-y:            $spacer !default;\r\n$popover-body-padding-x:            $spacer !default;\r\n\r\n$popover-arrow-width:               1rem !default;\r\n$popover-arrow-height:              .5rem !default;\r\n$popover-arrow-color:               $popover-bg !default;\r\n\r\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\r\n// scss-docs-end popover-variables\r\n\r\n\r\n// Toasts\r\n\r\n// scss-docs-start toast-variables\r\n$toast-max-width:                   350px !default;\r\n$toast-padding-x:                   .75rem !default;\r\n$toast-padding-y:                   .5rem !default;\r\n$toast-font-size:                   .875rem !default;\r\n$toast-color:                       null !default;\r\n$toast-background-color:            rgba($white, .85) !default;\r\n$toast-border-width:                1px !default;\r\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\r\n$toast-border-radius:               $border-radius !default;\r\n$toast-box-shadow:                  $box-shadow !default;\r\n$toast-spacing:                     $container-padding-x !default;\r\n\r\n$toast-header-color:                $gray-600 !default;\r\n$toast-header-background-color:     rgba($white, .85) !default;\r\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\r\n// scss-docs-end toast-variables\r\n\r\n\r\n// Badges\r\n\r\n// scss-docs-start badge-variables\r\n$badge-font-size:                   .75em !default;\r\n$badge-font-weight:                 $font-weight-bold !default;\r\n$badge-color:                       $white !default;\r\n$badge-padding-y:                   .35em !default;\r\n$badge-padding-x:                   .65em !default;\r\n$badge-border-radius:               $border-radius !default;\r\n// scss-docs-end badge-variables\r\n\r\n\r\n// Modals\r\n\r\n// scss-docs-start modal-variables\r\n$modal-inner-padding:               $spacer !default;\r\n\r\n$modal-footer-margin-between:       .5rem !default;\r\n\r\n$modal-dialog-margin:               .5rem !default;\r\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\r\n\r\n$modal-title-line-height:           $line-height-base !default;\r\n\r\n$modal-content-color:               null !default;\r\n$modal-content-bg:                  $white !default;\r\n$modal-content-border-color:        rgba($black, .2) !default;\r\n$modal-content-border-width:        $border-width !default;\r\n$modal-content-border-radius:       $border-radius-lg !default;\r\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\r\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\r\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\r\n\r\n$modal-backdrop-bg:                 $black !default;\r\n$modal-backdrop-opacity:            .5 !default;\r\n$modal-header-border-color:         $border-color !default;\r\n$modal-footer-border-color:         $modal-header-border-color !default;\r\n$modal-header-border-width:         $modal-content-border-width !default;\r\n$modal-footer-border-width:         $modal-header-border-width !default;\r\n$modal-header-padding-y:            $modal-inner-padding !default;\r\n$modal-header-padding-x:            $modal-inner-padding !default;\r\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\r\n\r\n$modal-sm:                          300px !default;\r\n$modal-md:                          500px !default;\r\n$modal-lg:                          800px !default;\r\n$modal-xl:                          1140px !default;\r\n\r\n$modal-fade-transform:              translate(0, -50px) !default;\r\n$modal-show-transform:              none !default;\r\n$modal-transition:                  transform .3s ease-out !default;\r\n$modal-scale-transform:             scale(1.02) !default;\r\n// scss-docs-end modal-variables\r\n\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n// scss-docs-start alert-variables\r\n$alert-padding-y:               $spacer !default;\r\n$alert-padding-x:               $spacer !default;\r\n$alert-margin-bottom:           1rem !default;\r\n$alert-border-radius:           $border-radius !default;\r\n$alert-link-font-weight:        $font-weight-bold !default;\r\n$alert-border-width:            $border-width !default;\r\n$alert-bg-scale:                -80% !default;\r\n$alert-border-scale:            -70% !default;\r\n$alert-color-scale:             40% !default;\r\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\r\n// scss-docs-end alert-variables\r\n\r\n\r\n// Progress bars\r\n\r\n// scss-docs-start progress-variables\r\n$progress-height:                   1rem !default;\r\n$progress-font-size:                $font-size-base * .75 !default;\r\n$progress-bg:                       $gray-200 !default;\r\n$progress-border-radius:            $border-radius !default;\r\n$progress-box-shadow:               $box-shadow-inset !default;\r\n$progress-bar-color:                $white !default;\r\n$progress-bar-bg:                   $primary !default;\r\n$progress-bar-animation-timing:     1s linear infinite !default;\r\n$progress-bar-transition:           width .6s ease !default;\r\n// scss-docs-end progress-variables\r\n\r\n\r\n// List group\r\n\r\n// scss-docs-start list-group-variables\r\n$list-group-color:                  $gray-900 !default;\r\n$list-group-bg:                     $white !default;\r\n$list-group-border-color:           rgba($black, .125) !default;\r\n$list-group-border-width:           $border-width !default;\r\n$list-group-border-radius:          $border-radius !default;\r\n\r\n$list-group-item-padding-y:         $spacer * .5 !default;\r\n$list-group-item-padding-x:         $spacer !default;\r\n$list-group-item-bg-scale:          -80% !default;\r\n$list-group-item-color-scale:       40% !default;\r\n\r\n$list-group-hover-bg:               $gray-100 !default;\r\n$list-group-active-color:           $component-active-color !default;\r\n$list-group-active-bg:              $component-active-bg !default;\r\n$list-group-active-border-color:    $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color:         $gray-600 !default;\r\n$list-group-disabled-bg:            $list-group-bg !default;\r\n\r\n$list-group-action-color:           $gray-700 !default;\r\n$list-group-action-hover-color:     $list-group-action-color !default;\r\n\r\n$list-group-action-active-color:    $body-color !default;\r\n$list-group-action-active-bg:       $gray-200 !default;\r\n// scss-docs-end list-group-variables\r\n\r\n\r\n// Image thumbnails\r\n\r\n// scss-docs-start thumbnail-variables\r\n$thumbnail-padding:                 .25rem !default;\r\n$thumbnail-bg:                      $body-bg !default;\r\n$thumbnail-border-width:            $border-width !default;\r\n$thumbnail-border-color:            $gray-300 !default;\r\n$thumbnail-border-radius:           $border-radius !default;\r\n$thumbnail-box-shadow:              $box-shadow-sm !default;\r\n// scss-docs-end thumbnail-variables\r\n\r\n\r\n// Figures\r\n\r\n// scss-docs-start figure-variables\r\n$figure-caption-font-size:          $small-font-size !default;\r\n$figure-caption-color:              $gray-600 !default;\r\n// scss-docs-end figure-variables\r\n\r\n\r\n// Breadcrumbs\r\n\r\n// scss-docs-start breadcrumb-variables\r\n$breadcrumb-font-size:              null !default;\r\n$breadcrumb-padding-y:              0 !default;\r\n$breadcrumb-padding-x:              0 !default;\r\n$breadcrumb-item-padding-x:         .5rem !default;\r\n$breadcrumb-margin-bottom:          1rem !default;\r\n$breadcrumb-bg:                     null !default;\r\n$breadcrumb-divider-color:          $gray-600 !default;\r\n$breadcrumb-active-color:           $gray-600 !default;\r\n$breadcrumb-divider:                quote(\"/\") !default;\r\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\r\n$breadcrumb-border-radius:          null !default;\r\n// scss-docs-end breadcrumb-variables\r\n\r\n// Carousel\r\n\r\n// scss-docs-start carousel-variables\r\n$carousel-control-color:             $white !default;\r\n$carousel-control-width:             15% !default;\r\n$carousel-control-opacity:           .5 !default;\r\n$carousel-control-hover-opacity:     .9 !default;\r\n$carousel-control-transition:        opacity .15s ease !default;\r\n\r\n$carousel-indicator-width:           30px !default;\r\n$carousel-indicator-height:          3px !default;\r\n$carousel-indicator-hit-area-height: 10px !default;\r\n$carousel-indicator-spacer:          3px !default;\r\n$carousel-indicator-opacity:         .5 !default;\r\n$carousel-indicator-active-bg:       $white !default;\r\n$carousel-indicator-active-opacity:  1 !default;\r\n$carousel-indicator-transition:      opacity .6s ease !default;\r\n\r\n$carousel-caption-width:             70% !default;\r\n$carousel-caption-color:             $white !default;\r\n$carousel-caption-padding-y:         1.25rem !default;\r\n$carousel-caption-spacer:            1.25rem !default;\r\n\r\n$carousel-control-icon-width:        2rem !default;\r\n\r\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\r\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n\r\n$carousel-transition-duration:       .6s !default;\r\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n$carousel-dark-indicator-active-bg:  $black !default;\r\n$carousel-dark-caption-color:        $black !default;\r\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\r\n// scss-docs-end carousel-variables\r\n\r\n\r\n// Spinners\r\n\r\n// scss-docs-start spinner-variables\r\n$spinner-width:           2rem !default;\r\n$spinner-height:          $spinner-width !default;\r\n$spinner-vertical-align:  -.125em !default;\r\n$spinner-border-width:    .25em !default;\r\n$spinner-animation-speed: .75s !default;\r\n\r\n$spinner-width-sm:        1rem !default;\r\n$spinner-height-sm:       $spinner-width-sm !default;\r\n$spinner-border-width-sm: .2em !default;\r\n// scss-docs-end spinner-variables\r\n\r\n\r\n// Close\r\n\r\n// scss-docs-start close-variables\r\n$btn-close-width:            1em !default;\r\n$btn-close-height:           $btn-close-width !default;\r\n$btn-close-padding-x:        .25em !default;\r\n$btn-close-padding-y:        $btn-close-padding-x !default;\r\n$btn-close-color:            $black !default;\r\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\r\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\r\n$btn-close-opacity:          .5 !default;\r\n$btn-close-hover-opacity:    .75 !default;\r\n$btn-close-focus-opacity:    1 !default;\r\n$btn-close-disabled-opacity: .25 !default;\r\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\r\n// scss-docs-end close-variables\r\n\r\n\r\n// Offcanvas\r\n\r\n// scss-docs-start offcanvas-variables\r\n$offcanvas-padding-y:               $modal-inner-padding !default;\r\n$offcanvas-padding-x:               $modal-inner-padding !default;\r\n$offcanvas-horizontal-width:        400px !default;\r\n$offcanvas-vertical-height:         30vh !default;\r\n$offcanvas-transition-duration:     .3s !default;\r\n$offcanvas-border-color:            $modal-content-border-color !default;\r\n$offcanvas-border-width:            $modal-content-border-width !default;\r\n$offcanvas-title-line-height:       $modal-title-line-height !default;\r\n$offcanvas-bg-color:                $modal-content-bg !default;\r\n$offcanvas-color:                   $modal-content-color !default;\r\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\r\n// scss-docs-end offcanvas-variables\r\n\r\n// Code\r\n\r\n$code-font-size:                    $small-font-size !default;\r\n$code-color:                        $pink !default;\r\n\r\n$kbd-padding-y:                     .2rem !default;\r\n$kbd-padding-x:                     .4rem !default;\r\n$kbd-font-size:                     $code-font-size !default;\r\n$kbd-color:                         $white !default;\r\n$kbd-bg:                            $gray-900 !default;\r\n\r\n$pre-color:                         null !default;\r\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\r\n\r\n// SCSS RFS mixin\r\n//\r\n// Automated responsive values for font sizes, paddings, margins and much more\r\n//\r\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\r\n\r\n// Configuration\r\n\r\n// Base value\r\n$rfs-base-value: 1.25rem !default;\r\n$rfs-unit: rem !default;\r\n\r\n@if $rfs-unit != rem and $rfs-unit != px {\r\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\r\n}\r\n\r\n// Breakpoint at where values start decreasing if screen width is smaller\r\n$rfs-breakpoint: 1200px !default;\r\n$rfs-breakpoint-unit: px !default;\r\n\r\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\r\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\r\n}\r\n\r\n// Resize values based on screen height and width\r\n$rfs-two-dimensional: false !default;\r\n\r\n// Factor of decrease\r\n$rfs-factor: 10 !default;\r\n\r\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\r\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\r\n}\r\n\r\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\r\n$rfs-mode: min-media-query !default;\r\n\r\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\r\n$rfs-class: false !default;\r\n\r\n// 1 rem = $rfs-rem-value px\r\n$rfs-rem-value: 16 !default;\r\n\r\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\r\n$rfs-safari-iframe-resize-bug-fix: false !default;\r\n\r\n// Disable RFS by setting $enable-rfs to false\r\n$enable-rfs: true !default;\r\n\r\n// Cache $rfs-base-value unit\r\n$rfs-base-value-unit: unit($rfs-base-value);\r\n\r\n@function divide($dividend, $divisor, $precision: 10) {\r\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\r\n  $dividend: abs($dividend);\r\n  $divisor: abs($divisor);\r\n  @if $dividend == 0 {\r\n    @return 0;\r\n  }\r\n  @if $divisor == 0 {\r\n    @error \"Cannot divide by 0\";\r\n  }\r\n  $remainder: $dividend;\r\n  $result: 0;\r\n  $factor: 10;\r\n  @while ($remainder > 0 and $precision >= 0) {\r\n    $quotient: 0;\r\n    @while ($remainder >= $divisor) {\r\n      $remainder: $remainder - $divisor;\r\n      $quotient: $quotient + 1;\r\n    }\r\n    $result: $result * 10 + $quotient;\r\n    $factor: $factor * .1;\r\n    $remainder: $remainder * 10;\r\n    $precision: $precision - 1;\r\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\r\n      $result: $result + 1;\r\n    }\r\n  }\r\n  $result: $result * $factor * $sign;\r\n  $dividend-unit: unit($dividend);\r\n  $divisor-unit: unit($divisor);\r\n  $unit-map: (\r\n    \"px\": 1px,\r\n    \"rem\": 1rem,\r\n    \"em\": 1em,\r\n    \"%\": 1%\r\n  );\r\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\r\n    $result: $result * map-get($unit-map, $dividend-unit);\r\n  }\r\n  @return $result;\r\n}\r\n\r\n// Remove px-unit from $rfs-base-value for calculations\r\n@if $rfs-base-value-unit == px {\r\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\r\n}\r\n@else if $rfs-base-value-unit == rem {\r\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\r\n}\r\n\r\n// Cache $rfs-breakpoint unit to prevent multiple calls\r\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\r\n\r\n// Remove unit from $rfs-breakpoint for calculations\r\n@if $rfs-breakpoint-unit-cache == px {\r\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\r\n}\r\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\r\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\r\n}\r\n\r\n// Calculate the media query value\r\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\r\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\r\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\r\n\r\n// Internal mixin used to determine which media query needs to be used\r\n@mixin _rfs-media-query {\r\n  @if $rfs-two-dimensional {\r\n    @if $rfs-mode == max-media-query {\r\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\r\n        @content;\r\n      }\r\n    }\r\n    @else {\r\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\r\n        @content;\r\n      }\r\n    }\r\n  }\r\n  @else {\r\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n// Internal mixin that adds disable classes to the selector if needed.\r\n@mixin _rfs-rule {\r\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\r\n    // Adding an extra class increases specificity, which prevents the media query to override the property\r\n    &,\r\n    .disable-rfs &,\r\n    &.disable-rfs {\r\n      @content;\r\n    }\r\n  }\r\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\r\n    .enable-rfs &,\r\n    &.enable-rfs {\r\n      @content;\r\n    }\r\n  }\r\n  @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Internal mixin that adds enable classes to the selector if needed.\r\n@mixin _rfs-media-query-rule {\r\n\r\n  @if $rfs-class == enable {\r\n    @if $rfs-mode == min-media-query {\r\n      @content;\r\n    }\r\n\r\n    @include _rfs-media-query {\r\n      .enable-rfs &,\r\n      &.enable-rfs {\r\n        @content;\r\n      }\r\n    }\r\n  }\r\n  @else {\r\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\r\n      .disable-rfs &,\r\n      &.disable-rfs {\r\n        @content;\r\n      }\r\n    }\r\n    @include _rfs-media-query {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n// Helper function to get the formatted non-responsive value\r\n@function rfs-value($values) {\r\n  // Convert to list\r\n  $values: if(type-of($values) != list, ($values,), $values);\r\n\r\n  $val: '';\r\n\r\n  // Loop over each value and calculate value\r\n  @each $value in $values {\r\n    @if $value == 0 {\r\n      $val: $val + ' 0';\r\n    }\r\n    @else {\r\n      // Cache $value unit\r\n      $unit: if(type-of($value) == \"number\", unit($value), false);\r\n\r\n      @if $unit == px {\r\n        // Convert to rem if needed\r\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\r\n      }\r\n      @else if $unit == rem {\r\n        // Convert to px if needed\r\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\r\n      }\r\n      @else {\r\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\r\n        $val: $val + ' ' + $value;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Remove first space\r\n  @return unquote(str-slice($val, 2));\r\n}\r\n\r\n// Helper function to get the responsive value calculated by RFS\r\n@function rfs-fluid-value($values) {\r\n  // Convert to list\r\n  $values: if(type-of($values) != list, ($values,), $values);\r\n\r\n  $val: '';\r\n\r\n  // Loop over each value and calculate value\r\n  @each $value in $values {\r\n    @if $value == 0 {\r\n      $val: $val + ' 0';\r\n    }\r\n\r\n    @else {\r\n      // Cache $value unit\r\n      $unit: if(type-of($value) == \"number\", unit($value), false);\r\n\r\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\r\n      @if not $unit or $unit != px and $unit != rem {\r\n        $val: $val + ' ' + $value;\r\n      }\r\n\r\n      @else {\r\n        // Remove unit from $value for calculations\r\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\r\n\r\n        // Only add the media query if the value is greater than the minimum value\r\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\r\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\r\n        }\r\n        @else {\r\n          // Calculate the minimum value\r\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\r\n\r\n          // Calculate difference between $value and the minimum value\r\n          $value-diff: abs($value) - $value-min;\r\n\r\n          // Base value formatting\r\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\r\n\r\n          // Use negative value if needed\r\n          $min-width: if($value < 0, -$min-width, $min-width);\r\n\r\n          // Use `vmin` if two-dimensional is enabled\r\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\r\n\r\n          // Calculate the variable width between 0 and $rfs-breakpoint\r\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\r\n\r\n          // Return the calculated value\r\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Remove first space\r\n  @return unquote(str-slice($val, 2));\r\n}\r\n\r\n// RFS mixin\r\n@mixin rfs($values, $property: font-size) {\r\n  @if $values != null {\r\n    $val: rfs-value($values);\r\n    $fluidVal: rfs-fluid-value($values);\r\n\r\n    // Do not print the media query if responsive & non-responsive values are the same\r\n    @if $val == $fluidVal {\r\n      #{$property}: $val;\r\n    }\r\n    @else {\r\n      @include _rfs-rule {\r\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\r\n\r\n        // Include safari iframe resize fix if needed\r\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\r\n      }\r\n\r\n      @include _rfs-media-query-rule {\r\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Shorthand helper mixins\r\n@mixin font-size($value) {\r\n  @include rfs($value);\r\n}\r\n\r\n@mixin padding($value) {\r\n  @include rfs($value, padding);\r\n}\r\n\r\n@mixin padding-top($value) {\r\n  @include rfs($value, padding-top);\r\n}\r\n\r\n@mixin padding-right($value) {\r\n  @include rfs($value, padding-right);\r\n}\r\n\r\n@mixin padding-bottom($value) {\r\n  @include rfs($value, padding-bottom);\r\n}\r\n\r\n@mixin padding-left($value) {\r\n  @include rfs($value, padding-left);\r\n}\r\n\r\n@mixin margin($value) {\r\n  @include rfs($value, margin);\r\n}\r\n\r\n@mixin margin-top($value) {\r\n  @include rfs($value, margin-top);\r\n}\r\n\r\n@mixin margin-right($value) {\r\n  @include rfs($value, margin-right);\r\n}\r\n\r\n@mixin margin-bottom($value) {\r\n  @include rfs($value, margin-bottom);\r\n}\r\n\r\n@mixin margin-left($value) {\r\n  @include rfs($value, margin-left);\r\n}\r\n","// stylelint-disable property-disallowed-list\r\n// Single side border-radius\r\n\r\n// Helper function to replace negative values with 0\r\n@function valid-radius($radius) {\r\n  $return: ();\r\n  @each $value in $radius {\r\n    @if type-of($value) == number {\r\n      $return: append($return, max($value, 0));\r\n    } @else {\r\n      $return: append($return, $value);\r\n    }\r\n  }\r\n  @return $return;\r\n}\r\n\r\n// scss-docs-start border-radius-mixins\r\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\r\n  @if $enable-rounded {\r\n    border-radius: valid-radius($radius);\r\n  }\r\n  @else if $fallback-border-radius != false {\r\n    border-radius: $fallback-border-radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: valid-radius($radius);\r\n    border-top-right-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-end-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: valid-radius($radius);\r\n    border-bottom-right-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: valid-radius($radius);\r\n    border-bottom-left-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-start-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: valid-radius($radius);\r\n    border-bottom-left-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-top-start-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-top-end-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-bottom-end-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: valid-radius($radius);\r\n  }\r\n}\r\n\r\n@mixin border-bottom-start-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-left-radius: valid-radius($radius);\r\n  }\r\n}\r\n// scss-docs-end border-radius-mixins\r\n","//\r\n// Headings\r\n//\r\n.h1 {\r\n  @extend h1;\r\n}\r\n\r\n.h2 {\r\n  @extend h2;\r\n}\r\n\r\n.h3 {\r\n  @extend h3;\r\n}\r\n\r\n.h4 {\r\n  @extend h4;\r\n}\r\n\r\n.h5 {\r\n  @extend h5;\r\n}\r\n\r\n.h6 {\r\n  @extend h6;\r\n}\r\n\r\n\r\n.lead {\r\n  @include font-size($lead-font-size);\r\n  font-weight: $lead-font-weight;\r\n}\r\n\r\n// Type display classes\r\n@each $display, $font-size in $display-font-sizes {\r\n  .display-#{$display} {\r\n    @include font-size($font-size);\r\n    font-weight: $display-font-weight;\r\n    line-height: $display-line-height;\r\n  }\r\n}\r\n\r\n//\r\n// Emphasis\r\n//\r\n.small {\r\n  @extend small;\r\n}\r\n\r\n.mark {\r\n  @extend mark;\r\n}\r\n\r\n//\r\n// Lists\r\n//\r\n\r\n.list-unstyled {\r\n  @include list-unstyled();\r\n}\r\n\r\n// Inline turns list items into inline-block\r\n.list-inline {\r\n  @include list-unstyled();\r\n}\r\n.list-inline-item {\r\n  display: inline-block;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: $list-inline-padding;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Misc\r\n//\r\n\r\n// Builds on `abbr`\r\n.initialism {\r\n  @include font-size($initialism-font-size);\r\n  text-transform: uppercase;\r\n}\r\n\r\n// Blockquotes\r\n.blockquote {\r\n  margin-bottom: $blockquote-margin-y;\r\n  @include font-size($blockquote-font-size);\r\n\r\n  > :last-child {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.blockquote-footer {\r\n  margin-top: -$blockquote-margin-y;\r\n  margin-bottom: $blockquote-margin-y;\r\n  @include font-size($blockquote-footer-font-size);\r\n  color: $blockquote-footer-color;\r\n\r\n  &::before {\r\n    content: \"\\2014\\00A0\"; // em dash, nbsp\r\n  }\r\n}\r\n","// Lists\r\n\r\n// Unstyled keeps list items block level, just removes default browser padding and list-style\r\n@mixin list-unstyled {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n","// Responsive images (ensure images don't scale beyond their parents)\r\n//\r\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\r\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\r\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\r\n// which weren't expecting the images within themselves to be involuntarily resized.\r\n// See also https://github.com/twbs/bootstrap/issues/18178\r\n.img-fluid {\r\n  @include img-fluid();\r\n}\r\n\r\n\r\n// Image thumbnails\r\n.img-thumbnail {\r\n  padding: $thumbnail-padding;\r\n  background-color: $thumbnail-bg;\r\n  border: $thumbnail-border-width solid $thumbnail-border-color;\r\n  @include border-radius($thumbnail-border-radius);\r\n  @include box-shadow($thumbnail-box-shadow);\r\n\r\n  // Keep them at most 100% wide\r\n  @include img-fluid();\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\n.figure {\r\n  // Ensures the caption's text aligns with the image.\r\n  display: inline-block;\r\n}\r\n\r\n.figure-img {\r\n  margin-bottom: $spacer * .5;\r\n  line-height: 1;\r\n}\r\n\r\n.figure-caption {\r\n  @include font-size($figure-caption-font-size);\r\n  color: $figure-caption-color;\r\n}\r\n","// Image Mixins\r\n// - Responsive image\r\n// - Retina image\r\n\r\n\r\n// Responsive image\r\n//\r\n// Keep images from scaling beyond the width of their parents.\r\n\r\n@mixin img-fluid {\r\n  // Part 1: Set a maximum relative to the parent\r\n  max-width: 100%;\r\n  // Part 2: Override the height to auto, otherwise images will be stretched\r\n  // when setting a width and height attribute on the img element.\r\n  height: auto;\r\n}\r\n","// Container widths\r\n//\r\n// Set the container width, and override it for fixed navbars in media queries.\r\n\r\n@if $enable-grid-classes {\r\n  // Single container class with breakpoint max-widths\r\n  .container,\r\n  // 100% wide container at all breakpoints\r\n  .container-fluid {\r\n    @include make-container();\r\n  }\r\n\r\n  // Responsive containers that are 100% wide until a breakpoint\r\n  @each $breakpoint, $container-max-width in $container-max-widths {\r\n    .container-#{$breakpoint} {\r\n      @extend .container-fluid;\r\n    }\r\n\r\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\r\n      %responsive-container-#{$breakpoint} {\r\n        max-width: $container-max-width;\r\n      }\r\n\r\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\r\n      $extend-breakpoint: true;\r\n\r\n      @each $name, $width in $grid-breakpoints {\r\n        @if ($extend-breakpoint) {\r\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\r\n            @extend %responsive-container-#{$breakpoint};\r\n          }\r\n\r\n          // Once the current breakpoint is reached, stop extending\r\n          @if ($breakpoint == $name) {\r\n            $extend-breakpoint: false;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Container mixins\r\n\r\n@mixin make-container($gutter: $container-padding-x) {\r\n  width: 100%;\r\n  padding-right: var(--#{$variable-prefix}gutter-x, #{$gutter});\r\n  padding-left: var(--#{$variable-prefix}gutter-x, #{$gutter});\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n","// Breakpoint viewport sizes and media queries.\r\n//\r\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\r\n//\r\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\r\n//\r\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\r\n\r\n// Name of the next breakpoint, or null for the last breakpoint.\r\n//\r\n//    >> breakpoint-next(sm)\r\n//    md\r\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    md\r\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\r\n//    md\r\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\r\n  $n: index($breakpoint-names, $name);\r\n  @if not $n {\r\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\r\n  }\r\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\r\n}\r\n\r\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\r\n//\r\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    576px\r\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\r\n  $min: map-get($breakpoints, $name);\r\n  @return if($min != 0, $min, null);\r\n}\r\n\r\n// Maximum breakpoint width.\r\n// The maximum value is reduced by 0.02px to work around the limitations of\r\n// `min-` and `max-` prefixes and viewports with fractional widths.\r\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\r\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\r\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\r\n//\r\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    767.98px\r\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\r\n  $max: map-get($breakpoints, $name);\r\n  @return if($max and $max > 0, $max - .02, null);\r\n}\r\n\r\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\r\n// Useful for making responsive utilities.\r\n//\r\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"\"  (Returns a blank string)\r\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"-sm\"\r\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\r\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\r\n}\r\n\r\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\r\n// Makes the @content apply to the given breakpoint and wider.\r\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  @if $min {\r\n    @media (min-width: $min) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\r\n// Makes the @content apply to the given breakpoint and narrower.\r\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\r\n  $max: breakpoint-max($name, $breakpoints);\r\n  @if $max {\r\n    @media (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media that spans multiple breakpoint widths.\r\n// Makes the @content apply between the min and max breakpoints\r\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($lower, $breakpoints);\r\n  $max: breakpoint-max($upper, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($lower, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($upper, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n// Media between the breakpoint's minimum and maximum widths.\r\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\r\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\r\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\r\n  $min:  breakpoint-min($name, $breakpoints);\r\n  $next: breakpoint-next($name, $breakpoints);\r\n  $max:  breakpoint-max($next);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($next, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n","// Row\r\n//\r\n// Rows contain your columns.\r\n\r\n@if $enable-grid-classes {\r\n  .row {\r\n    @include make-row();\r\n\r\n    > * {\r\n      @include make-col-ready();\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Columns\r\n//\r\n// Common styles for small and large grid columns\r\n\r\n@if $enable-grid-classes {\r\n  @include make-grid-columns();\r\n}\r\n","// Grid system\r\n//\r\n// Generate semantic grid columns with these mixins.\r\n\r\n@mixin make-row($gutter: $grid-gutter-width) {\r\n  --#{$variable-prefix}gutter-x: #{$gutter};\r\n  --#{$variable-prefix}gutter-y: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-top: calc(var(--#{$variable-prefix}gutter-y) * -1); // stylelint-disable-line function-disallowed-list\r\n  margin-right: calc(var(--#{$variable-prefix}gutter-x) * -.5); // stylelint-disable-line function-disallowed-list\r\n  margin-left: calc(var(--#{$variable-prefix}gutter-x) * -.5); // stylelint-disable-line function-disallowed-list\r\n}\r\n\r\n@mixin make-col-ready($gutter: $grid-gutter-width) {\r\n  // Add box sizing if only the grid is loaded\r\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\r\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\r\n  // always setting `width: 100%;`. This works because we set the width\r\n  // later on to override this initial width.\r\n  flex-shrink: 0;\r\n  width: 100%;\r\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\r\n  padding-right: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\r\n  padding-left: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\r\n  margin-top: var(--#{$variable-prefix}gutter-y);\r\n}\r\n\r\n@mixin make-col($size: false, $columns: $grid-columns) {\r\n  @if $size {\r\n    flex: 0 0 auto;\r\n    width: percentage(divide($size, $columns));\r\n\r\n  } @else {\r\n    flex: 1 1 0;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@mixin make-col-auto() {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n}\r\n\r\n@mixin make-col-offset($size, $columns: $grid-columns) {\r\n  $num: divide($size, $columns);\r\n  margin-left: if($num == 0, 0, percentage($num));\r\n}\r\n\r\n// Row columns\r\n//\r\n// Specify on a parent element(e.g., .row) to force immediate children into NN\r\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\r\n// style grid.\r\n@mixin row-cols($count) {\r\n  > * {\r\n    flex: 0 0 auto;\r\n    width: divide(100%, $count);\r\n  }\r\n}\r\n\r\n// Framework grid generation\r\n//\r\n// Used only by Bootstrap to generate the correct number of grid classes given\r\n// any value of `$grid-columns`.\r\n\r\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\r\n  @each $breakpoint in map-keys($breakpoints) {\r\n    // .row-cols defaults must all appear before .col overrides so they can be overridden.\r\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\r\n      .col#{$infix} {\r\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\r\n      }\r\n\r\n      .row-cols#{$infix}-auto > * {\r\n        @include make-col-auto();\r\n      }\r\n\r\n      @if $grid-row-columns > 0 {\r\n        @for $i from 1 through $grid-row-columns {\r\n          .row-cols#{$infix}-#{$i} {\r\n            @include row-cols($i);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @each $breakpoint in map-keys($breakpoints) {\r\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\r\n\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      .col#{$infix}-auto {\r\n        @include make-col-auto();\r\n      }\r\n\r\n      @if $columns > 0 {\r\n        @for $i from 1 through $columns {\r\n          .col#{$infix}-#{$i} {\r\n            @include make-col($i, $columns);\r\n          }\r\n        }\r\n\r\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\r\n        @for $i from 0 through ($columns - 1) {\r\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\r\n            .offset#{$infix}-#{$i} {\r\n              @include make-col-offset($i, $columns);\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      // Gutters\r\n      //\r\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\r\n      @each $key, $value in $gutters {\r\n        .g#{$infix}-#{$key},\r\n        .gx#{$infix}-#{$key} {\r\n          --#{$variable-prefix}gutter-x: #{$value};\r\n        }\r\n\r\n        .g#{$infix}-#{$key},\r\n        .gy#{$infix}-#{$key} {\r\n          --#{$variable-prefix}gutter-y: #{$value};\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Basic Bootstrap table\r\n//\r\n\r\n.table {\r\n  --#{$variable-prefix}table-bg: #{$table-bg};\r\n  --#{$variable-prefix}table-accent-bg: #{$table-accent-bg};\r\n  --#{$variable-prefix}table-striped-color: #{$table-striped-color};\r\n  --#{$variable-prefix}table-striped-bg: #{$table-striped-bg};\r\n  --#{$variable-prefix}table-active-color: #{$table-active-color};\r\n  --#{$variable-prefix}table-active-bg: #{$table-active-bg};\r\n  --#{$variable-prefix}table-hover-color: #{$table-hover-color};\r\n  --#{$variable-prefix}table-hover-bg: #{$table-hover-bg};\r\n\r\n  width: 100%;\r\n  margin-bottom: $spacer;\r\n  color: $table-color;\r\n  vertical-align: $table-cell-vertical-align;\r\n  border-color: $table-border-color;\r\n\r\n  // Target th & td\r\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\r\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\r\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\r\n  // stylelint-disable-next-line selector-max-universal\r\n  > :not(caption) > * > * {\r\n    padding: $table-cell-padding-y $table-cell-padding-x;\r\n    background-color: var(--#{$variable-prefix}table-bg);\r\n    border-bottom-width: $table-border-width;\r\n    box-shadow: inset 0 0 0 9999px var(--#{$variable-prefix}table-accent-bg);\r\n  }\r\n\r\n  > tbody {\r\n    vertical-align: inherit;\r\n  }\r\n\r\n  > thead {\r\n    vertical-align: bottom;\r\n  }\r\n\r\n  // Highlight border color between thead, tbody and tfoot.\r\n  > :not(:last-child) > :last-child > * {\r\n    border-bottom-color: $table-group-separator-color;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Change placement of captions with a class\r\n//\r\n\r\n.caption-top {\r\n  caption-side: top;\r\n}\r\n\r\n\r\n//\r\n// Condensed table w/ half padding\r\n//\r\n\r\n.table-sm {\r\n  // stylelint-disable-next-line selector-max-universal\r\n  > :not(caption) > * > * {\r\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\r\n  }\r\n}\r\n\r\n\r\n// Border versions\r\n//\r\n// Add or remove borders all around the table and between all the columns.\r\n//\r\n// When borders are added on all sides of the cells, the corners can render odd when\r\n// these borders do not have the same color or if they are semi-transparent.\r\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\r\n// to the `td`s or `th`s\r\n\r\n.table-bordered {\r\n  > :not(caption) > * {\r\n    border-width: $table-border-width 0;\r\n\r\n    // stylelint-disable-next-line selector-max-universal\r\n    > * {\r\n      border-width: 0 $table-border-width;\r\n    }\r\n  }\r\n}\r\n\r\n.table-borderless {\r\n  // stylelint-disable-next-line selector-max-universal\r\n  > :not(caption) > * > * {\r\n    border-bottom-width: 0;\r\n  }\r\n}\r\n\r\n// Zebra-striping\r\n//\r\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\r\n\r\n.table-striped {\r\n  > tbody > tr:nth-of-type(#{$table-striped-order}) {\r\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-striped-bg);\r\n    color: var(--#{$variable-prefix}table-striped-color);\r\n  }\r\n}\r\n\r\n// Active table\r\n//\r\n// The `.table-active` class can be added to highlight rows or cells\r\n\r\n.table-active {\r\n  --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-active-bg);\r\n  color: var(--#{$variable-prefix}table-active-color);\r\n}\r\n\r\n// Hover effect\r\n//\r\n// Placed here since it has to come after the potential zebra striping\r\n\r\n.table-hover {\r\n  > tbody > tr:hover {\r\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-hover-bg);\r\n    color: var(--#{$variable-prefix}table-hover-color);\r\n  }\r\n}\r\n\r\n\r\n// Table variants\r\n//\r\n// Table variants set the table cell backgrounds, border colors\r\n// and the colors of the striped, hovered & active tables\r\n\r\n@each $color, $value in $table-variants {\r\n  @include table-variant($color, $value);\r\n}\r\n\r\n// Responsive tables\r\n//\r\n// Generate series of `.table-responsive-*` classes for configuring the screen\r\n// size of where your table will overflow.\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n  @include media-breakpoint-down($breakpoint) {\r\n    .table-responsive#{$infix} {\r\n      overflow-x: auto;\r\n      -webkit-overflow-scrolling: touch;\r\n    }\r\n  }\r\n}\r\n","// scss-docs-start table-variant\r\n@mixin table-variant($state, $background) {\r\n  .table-#{$state} {\r\n    $color: color-contrast(opaque($body-bg, $background));\r\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\r\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\r\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\r\n\r\n    --#{$variable-prefix}table-bg: #{$background};\r\n    --#{$variable-prefix}table-striped-bg: #{$striped-bg};\r\n    --#{$variable-prefix}table-striped-color: #{color-contrast($striped-bg)};\r\n    --#{$variable-prefix}table-active-bg: #{$active-bg};\r\n    --#{$variable-prefix}table-active-color: #{color-contrast($active-bg)};\r\n    --#{$variable-prefix}table-hover-bg: #{$hover-bg};\r\n    --#{$variable-prefix}table-hover-color: #{color-contrast($hover-bg)};\r\n\r\n    color: $color;\r\n    border-color: mix($color, $background, percentage($table-border-factor));\r\n  }\r\n}\r\n// scss-docs-end table-variant\r\n","//\r\n// Labels\r\n//\r\n\r\n.form-label {\r\n  margin-bottom: $form-label-margin-bottom;\r\n  @include font-size($form-label-font-size);\r\n  font-style: $form-label-font-style;\r\n  font-weight: $form-label-font-weight;\r\n  color: $form-label-color;\r\n}\r\n\r\n// For use with horizontal and inline forms, when you need the label (or legend)\r\n// text to align with the form controls.\r\n.col-form-label {\r\n  padding-top: add($input-padding-y, $input-border-width);\r\n  padding-bottom: add($input-padding-y, $input-border-width);\r\n  margin-bottom: 0; // Override the `<legend>` default\r\n  @include font-size(inherit); // Override the `<legend>` default\r\n  font-style: $form-label-font-style;\r\n  font-weight: $form-label-font-weight;\r\n  line-height: $input-line-height;\r\n  color: $form-label-color;\r\n}\r\n\r\n.col-form-label-lg {\r\n  padding-top: add($input-padding-y-lg, $input-border-width);\r\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\r\n  @include font-size($input-font-size-lg);\r\n}\r\n\r\n.col-form-label-sm {\r\n  padding-top: add($input-padding-y-sm, $input-border-width);\r\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\r\n  @include font-size($input-font-size-sm);\r\n}\r\n","//\r\n// Form text\r\n//\r\n\r\n.form-text {\r\n  margin-top: $form-text-margin-top;\r\n  @include font-size($form-text-font-size);\r\n  font-style: $form-text-font-style;\r\n  font-weight: $form-text-font-weight;\r\n  color: $form-text-color;\r\n}\r\n","//\r\n// General form controls (plus a few specific high-level interventions)\r\n//\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-family: $input-font-family;\r\n  @include font-size($input-font-size);\r\n  font-weight: $input-font-weight;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n  appearance: none; // Fix appearance for date inputs in Safari\r\n\r\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\r\n  @include border-radius($input-border-radius, 0);\r\n\r\n  @include box-shadow($input-box-shadow);\r\n  @include transition($input-transition);\r\n\r\n  &[type=\"file\"] {\r\n    overflow: hidden; // prevent pseudo element button overlap\r\n\r\n    &:not(:disabled):not([readonly]) {\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  // Customize the `:focus` state to imitate native WebKit styles.\r\n  &:focus {\r\n    color: $input-focus-color;\r\n    background-color: $input-focus-bg;\r\n    border-color: $input-focus-border-color;\r\n    outline: 0;\r\n    @if $enable-shadows {\r\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\r\n    } @else {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      box-shadow: $input-focus-box-shadow;\r\n    }\r\n  }\r\n\r\n  // Add some height to date inputs on iOS\r\n  // https://github.com/twbs/bootstrap/issues/23307\r\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\r\n  &::-webkit-date-and-time-value {\r\n    // Multiply line-height by 1em if it has no unit\r\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\r\n  }\r\n\r\n  // Placeholder\r\n  &::placeholder {\r\n    color: $input-placeholder-color;\r\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\r\n    opacity: 1;\r\n  }\r\n\r\n  // Disabled and read-only inputs\r\n  //\r\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\r\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\r\n  // don't honor that edge case; we style them as disabled anyway.\r\n  &:disabled,\r\n  &[readonly] {\r\n    background-color: $input-disabled-bg;\r\n    border-color: $input-disabled-border-color;\r\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\r\n    opacity: 1;\r\n  }\r\n\r\n  // File input buttons theming\r\n  &::file-selector-button {\r\n    padding: $input-padding-y $input-padding-x;\r\n    margin: (-$input-padding-y) (-$input-padding-x);\r\n    margin-inline-end: $input-padding-x;\r\n    color: $form-file-button-color;\r\n    @include gradient-bg($form-file-button-bg);\r\n    pointer-events: none;\r\n    border-color: inherit;\r\n    border-style: solid;\r\n    border-width: 0;\r\n    border-inline-end-width: $input-border-width;\r\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\r\n    @include transition($btn-transition);\r\n  }\r\n\r\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\r\n    background-color: $form-file-button-hover-bg;\r\n  }\r\n\r\n  &::-webkit-file-upload-button {\r\n    padding: $input-padding-y $input-padding-x;\r\n    margin: (-$input-padding-y) (-$input-padding-x);\r\n    margin-inline-end: $input-padding-x;\r\n    color: $form-file-button-color;\r\n    @include gradient-bg($form-file-button-bg);\r\n    pointer-events: none;\r\n    border-color: inherit;\r\n    border-style: solid;\r\n    border-width: 0;\r\n    border-inline-end-width: $input-border-width;\r\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\r\n    @include transition($btn-transition);\r\n  }\r\n\r\n  &:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\r\n    background-color: $form-file-button-hover-bg;\r\n  }\r\n}\r\n\r\n// Readonly controls as plain text\r\n//\r\n// Apply class to a readonly input to make it appear like regular plain\r\n// text (without any border, background color, focus indicator)\r\n\r\n.form-control-plaintext {\r\n  display: block;\r\n  width: 100%;\r\n  padding: $input-padding-y 0;\r\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\r\n  line-height: $input-line-height;\r\n  color: $input-plaintext-color;\r\n  background-color: transparent;\r\n  border: solid transparent;\r\n  border-width: $input-border-width 0;\r\n\r\n  &.form-control-sm,\r\n  &.form-control-lg {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n// Form control sizing\r\n//\r\n// Build on `.form-control` with modifier classes to decrease or increase the\r\n// height and font-size of form controls.\r\n//\r\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\r\n\r\n.form-control-sm {\r\n  min-height: $input-height-sm;\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  @include font-size($input-font-size-sm);\r\n  @include border-radius($input-border-radius-sm);\r\n\r\n  &::file-selector-button {\r\n    padding: $input-padding-y-sm $input-padding-x-sm;\r\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\r\n    margin-inline-end: $input-padding-x-sm;\r\n  }\r\n\r\n  &::-webkit-file-upload-button {\r\n    padding: $input-padding-y-sm $input-padding-x-sm;\r\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\r\n    margin-inline-end: $input-padding-x-sm;\r\n  }\r\n}\r\n\r\n.form-control-lg {\r\n  min-height: $input-height-lg;\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  @include font-size($input-font-size-lg);\r\n  @include border-radius($input-border-radius-lg);\r\n\r\n  &::file-selector-button {\r\n    padding: $input-padding-y-lg $input-padding-x-lg;\r\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\r\n    margin-inline-end: $input-padding-x-lg;\r\n  }\r\n\r\n  &::-webkit-file-upload-button {\r\n    padding: $input-padding-y-lg $input-padding-x-lg;\r\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\r\n    margin-inline-end: $input-padding-x-lg;\r\n  }\r\n}\r\n\r\n// Make sure textareas don't shrink too much when resized\r\n// https://github.com/twbs/bootstrap/pull/29124\r\n// stylelint-disable selector-no-qualifying-type\r\ntextarea {\r\n  &.form-control {\r\n    min-height: $input-height;\r\n  }\r\n\r\n  &.form-control-sm {\r\n    min-height: $input-height-sm;\r\n  }\r\n\r\n  &.form-control-lg {\r\n    min-height: $input-height-lg;\r\n  }\r\n}\r\n// stylelint-enable selector-no-qualifying-type\r\n\r\n.form-control-color {\r\n  max-width: 3rem;\r\n  height: auto; // Override fixed browser height\r\n  padding: $input-padding-y;\r\n\r\n  &:not(:disabled):not([readonly]) {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &::-moz-color-swatch {\r\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\r\n    @include border-radius($input-border-radius);\r\n  }\r\n\r\n  &::-webkit-color-swatch {\r\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\r\n    @include border-radius($input-border-radius);\r\n  }\r\n}\r\n","// stylelint-disable property-disallowed-list\r\n@mixin transition($transition...) {\r\n  @if length($transition) == 0 {\r\n    $transition: $transition-base;\r\n  }\r\n\r\n  @if length($transition) > 1 {\r\n    @each $value in $transition {\r\n      @if $value == null or $value == none {\r\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\r\n      }\r\n    }\r\n  }\r\n\r\n  @if $enable-transitions {\r\n    @if nth($transition, 1) != null {\r\n      transition: $transition;\r\n    }\r\n\r\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\r\n      @media (prefers-reduced-motion: reduce) {\r\n        transition: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Gradients\r\n\r\n// scss-docs-start gradient-bg-mixin\r\n@mixin gradient-bg($color: null) {\r\n  background-color: $color;\r\n\r\n  @if $enable-gradients {\r\n    background-image: var(--#{$variable-prefix}gradient);\r\n  }\r\n}\r\n// scss-docs-end gradient-bg-mixin\r\n\r\n// scss-docs-start gradient-mixins\r\n// Horizontal gradient, from left to right\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\r\n}\r\n\r\n// Vertical gradient, from top to bottom\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\r\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\r\n}\r\n\r\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\r\n  background-image: linear-gradient($deg, $start-color, $end-color);\r\n}\r\n\r\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\r\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\r\n}\r\n\r\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\r\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\r\n}\r\n\r\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\r\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\r\n}\r\n\r\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\r\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\r\n}\r\n// scss-docs-end gradient-mixins\r\n","// Select\r\n//\r\n// Replaces the browser default select with a custom one, mostly pulled from\r\n// https://primer.github.io/.\r\n\r\n.form-select {\r\n  display: block;\r\n  width: 100%;\r\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\r\n  // stylelint-disable-next-line property-no-vendor-prefix\r\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\r\n  font-family: $form-select-font-family;\r\n  @include font-size($form-select-font-size);\r\n  font-weight: $form-select-font-weight;\r\n  line-height: $form-select-line-height;\r\n  color: $form-select-color;\r\n  background-color: $form-select-bg;\r\n  background-image: escape-svg($form-select-indicator);\r\n  background-repeat: no-repeat;\r\n  background-position: $form-select-bg-position;\r\n  background-size: $form-select-bg-size;\r\n  border: $form-select-border-width solid $form-select-border-color;\r\n  @include border-radius($form-select-border-radius, 0);\r\n  @include box-shadow($form-select-box-shadow);\r\n  @include transition($form-select-transition);\r\n  appearance: none;\r\n\r\n  &:focus {\r\n    border-color: $form-select-focus-border-color;\r\n    outline: 0;\r\n    @if $enable-shadows {\r\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\r\n    } @else {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      box-shadow: $form-select-focus-box-shadow;\r\n    }\r\n  }\r\n\r\n  &[multiple],\r\n  &[size]:not([size=\"1\"]) {\r\n    padding-right: $form-select-padding-x;\r\n    background-image: none;\r\n  }\r\n\r\n  &:disabled {\r\n    color: $form-select-disabled-color;\r\n    background-color: $form-select-disabled-bg;\r\n    border-color: $form-select-disabled-border-color;\r\n  }\r\n\r\n  // Remove outline from select box in FF\r\n  &:-moz-focusring {\r\n    color: transparent;\r\n    text-shadow: 0 0 0 $form-select-color;\r\n  }\r\n}\r\n\r\n.form-select-sm {\r\n  padding-top: $form-select-padding-y-sm;\r\n  padding-bottom: $form-select-padding-y-sm;\r\n  padding-left: $form-select-padding-x-sm;\r\n  @include font-size($form-select-font-size-sm);\r\n}\r\n\r\n.form-select-lg {\r\n  padding-top: $form-select-padding-y-lg;\r\n  padding-bottom: $form-select-padding-y-lg;\r\n  padding-left: $form-select-padding-x-lg;\r\n  @include font-size($form-select-font-size-lg);\r\n}\r\n","//\r\n// Check/radio\r\n//\r\n\r\n.form-check {\r\n  display: block;\r\n  min-height: $form-check-min-height;\r\n  padding-left: $form-check-padding-start;\r\n  margin-bottom: $form-check-margin-bottom;\r\n\r\n  .form-check-input {\r\n    float: left;\r\n    margin-left: $form-check-padding-start * -1;\r\n  }\r\n}\r\n\r\n.form-check-input {\r\n  width: $form-check-input-width;\r\n  height: $form-check-input-width;\r\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\r\n  vertical-align: top;\r\n  background-color: $form-check-input-bg;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: contain;\r\n  border: $form-check-input-border;\r\n  appearance: none;\r\n  print-color-adjust: exact; // Keep themed appearance for print\r\n  @include transition($form-check-transition);\r\n\r\n  &[type=\"checkbox\"] {\r\n    @include border-radius($form-check-input-border-radius);\r\n  }\r\n\r\n  &[type=\"radio\"] {\r\n    // stylelint-disable-next-line property-disallowed-list\r\n    border-radius: $form-check-radio-border-radius;\r\n  }\r\n\r\n  &:active {\r\n    filter: $form-check-input-active-filter;\r\n  }\r\n\r\n  &:focus {\r\n    border-color: $form-check-input-focus-border;\r\n    outline: 0;\r\n    box-shadow: $form-check-input-focus-box-shadow;\r\n  }\r\n\r\n  &:checked {\r\n    background-color: $form-check-input-checked-bg-color;\r\n    border-color: $form-check-input-checked-border-color;\r\n\r\n    &[type=\"checkbox\"] {\r\n      @if $enable-gradients {\r\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$variable-prefix}gradient);\r\n      } @else {\r\n        background-image: escape-svg($form-check-input-checked-bg-image);\r\n      }\r\n    }\r\n\r\n    &[type=\"radio\"] {\r\n      @if $enable-gradients {\r\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$variable-prefix}gradient);\r\n      } @else {\r\n        background-image: escape-svg($form-check-radio-checked-bg-image);\r\n      }\r\n    }\r\n  }\r\n\r\n  &[type=\"checkbox\"]:indeterminate {\r\n    background-color: $form-check-input-indeterminate-bg-color;\r\n    border-color: $form-check-input-indeterminate-border-color;\r\n\r\n    @if $enable-gradients {\r\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$variable-prefix}gradient);\r\n    } @else {\r\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\r\n    }\r\n  }\r\n\r\n  &:disabled {\r\n    pointer-events: none;\r\n    filter: none;\r\n    opacity: $form-check-input-disabled-opacity;\r\n  }\r\n\r\n  // Use disabled attribute in addition of :disabled pseudo-class\r\n  // See: https://github.com/twbs/bootstrap/issues/28247\r\n  &[disabled],\r\n  &:disabled {\r\n    ~ .form-check-label {\r\n      opacity: $form-check-label-disabled-opacity;\r\n    }\r\n  }\r\n}\r\n\r\n.form-check-label {\r\n  color: $form-check-label-color;\r\n  cursor: $form-check-label-cursor;\r\n}\r\n\r\n//\r\n// Switch\r\n//\r\n\r\n.form-switch {\r\n  padding-left: $form-switch-padding-start;\r\n\r\n  .form-check-input {\r\n    width: $form-switch-width;\r\n    margin-left: $form-switch-padding-start * -1;\r\n    background-image: escape-svg($form-switch-bg-image);\r\n    background-position: left center;\r\n    @include border-radius($form-switch-border-radius);\r\n    @include transition($form-switch-transition);\r\n\r\n    &:focus {\r\n      background-image: escape-svg($form-switch-focus-bg-image);\r\n    }\r\n\r\n    &:checked {\r\n      background-position: $form-switch-checked-bg-position;\r\n\r\n      @if $enable-gradients {\r\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$variable-prefix}gradient);\r\n      } @else {\r\n        background-image: escape-svg($form-switch-checked-bg-image);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.form-check-inline {\r\n  display: inline-block;\r\n  margin-right: $form-check-inline-margin-end;\r\n}\r\n\r\n.btn-check {\r\n  position: absolute;\r\n  clip: rect(0, 0, 0, 0);\r\n  pointer-events: none;\r\n\r\n  &[disabled],\r\n  &:disabled {\r\n    + .btn {\r\n      pointer-events: none;\r\n      filter: none;\r\n      opacity: $form-check-btn-check-disabled-opacity;\r\n    }\r\n  }\r\n}\r\n","// Range\r\n//\r\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\r\n// elements cannot be mixed. As such, there are no shared styles for focus or\r\n// active states on prefixed selectors.\r\n\r\n.form-range {\r\n  width: 100%;\r\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\r\n  padding: 0; // Need to reset padding\r\n  background-color: transparent;\r\n  appearance: none;\r\n\r\n  &:focus {\r\n    outline: 0;\r\n\r\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\r\n    // No box-shadow() mixin for focus accessibility.\r\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\r\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\r\n  }\r\n\r\n  &::-moz-focus-outer {\r\n    border: 0;\r\n  }\r\n\r\n  &::-webkit-slider-thumb {\r\n    width: $form-range-thumb-width;\r\n    height: $form-range-thumb-height;\r\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\r\n    @include gradient-bg($form-range-thumb-bg);\r\n    border: $form-range-thumb-border;\r\n    @include border-radius($form-range-thumb-border-radius);\r\n    @include box-shadow($form-range-thumb-box-shadow);\r\n    @include transition($form-range-thumb-transition);\r\n    appearance: none;\r\n\r\n    &:active {\r\n      @include gradient-bg($form-range-thumb-active-bg);\r\n    }\r\n  }\r\n\r\n  &::-webkit-slider-runnable-track {\r\n    width: $form-range-track-width;\r\n    height: $form-range-track-height;\r\n    color: transparent; // Why?\r\n    cursor: $form-range-track-cursor;\r\n    background-color: $form-range-track-bg;\r\n    border-color: transparent;\r\n    @include border-radius($form-range-track-border-radius);\r\n    @include box-shadow($form-range-track-box-shadow);\r\n  }\r\n\r\n  &::-moz-range-thumb {\r\n    width: $form-range-thumb-width;\r\n    height: $form-range-thumb-height;\r\n    @include gradient-bg($form-range-thumb-bg);\r\n    border: $form-range-thumb-border;\r\n    @include border-radius($form-range-thumb-border-radius);\r\n    @include box-shadow($form-range-thumb-box-shadow);\r\n    @include transition($form-range-thumb-transition);\r\n    appearance: none;\r\n\r\n    &:active {\r\n      @include gradient-bg($form-range-thumb-active-bg);\r\n    }\r\n  }\r\n\r\n  &::-moz-range-track {\r\n    width: $form-range-track-width;\r\n    height: $form-range-track-height;\r\n    color: transparent;\r\n    cursor: $form-range-track-cursor;\r\n    background-color: $form-range-track-bg;\r\n    border-color: transparent; // Firefox specific?\r\n    @include border-radius($form-range-track-border-radius);\r\n    @include box-shadow($form-range-track-box-shadow);\r\n  }\r\n\r\n  &:disabled {\r\n    pointer-events: none;\r\n\r\n    &::-webkit-slider-thumb {\r\n      background-color: $form-range-thumb-disabled-bg;\r\n    }\r\n\r\n    &::-moz-range-thumb {\r\n      background-color: $form-range-thumb-disabled-bg;\r\n    }\r\n  }\r\n}\r\n",".form-floating {\r\n  position: relative;\r\n\r\n  > .form-control,\r\n  > .form-select {\r\n    height: $form-floating-height;\r\n    line-height: $form-floating-line-height;\r\n  }\r\n\r\n  > label {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%; // allow textareas\r\n    padding: $form-floating-padding-y $form-floating-padding-x;\r\n    pointer-events: none;\r\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\r\n    transform-origin: 0 0;\r\n    @include transition($form-floating-transition);\r\n  }\r\n\r\n  // stylelint-disable no-duplicate-selectors\r\n  > .form-control {\r\n    padding: $form-floating-padding-y $form-floating-padding-x;\r\n\r\n    &::placeholder {\r\n      color: transparent;\r\n    }\r\n\r\n    &:focus,\r\n    &:not(:placeholder-shown) {\r\n      padding-top: $form-floating-input-padding-t;\r\n      padding-bottom: $form-floating-input-padding-b;\r\n    }\r\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\r\n    &:-webkit-autofill {\r\n      padding-top: $form-floating-input-padding-t;\r\n      padding-bottom: $form-floating-input-padding-b;\r\n    }\r\n  }\r\n\r\n  > .form-select {\r\n    padding-top: $form-floating-input-padding-t;\r\n    padding-bottom: $form-floating-input-padding-b;\r\n  }\r\n\r\n  > .form-control:focus,\r\n  > .form-control:not(:placeholder-shown),\r\n  > .form-select {\r\n    ~ label {\r\n      opacity: $form-floating-label-opacity;\r\n      transform: $form-floating-label-transform;\r\n    }\r\n  }\r\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\r\n  > .form-control:-webkit-autofill {\r\n    ~ label {\r\n      opacity: $form-floating-label-opacity;\r\n      transform: $form-floating-label-transform;\r\n    }\r\n  }\r\n  // stylelint-enable no-duplicate-selectors\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // For form validation feedback\r\n  align-items: stretch;\r\n  width: 100%;\r\n\r\n  > .form-control,\r\n  > .form-select {\r\n    position: relative; // For focus state's z-index\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\r\n  }\r\n\r\n  // Bring the \"active\" form control to the top of surrounding elements\r\n  > .form-control:focus,\r\n  > .form-select:focus {\r\n    z-index: 3;\r\n  }\r\n\r\n  // Ensure buttons are always above inputs for more visually pleasing borders.\r\n  // This isn't needed for `.input-group-text` since it shares the same border-color\r\n  // as our inputs.\r\n  .btn {\r\n    position: relative;\r\n    z-index: 2;\r\n\r\n    &:focus {\r\n      z-index: 3;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Textual addons\r\n//\r\n// Serves as a catch-all element for any text or radio/checkbox input you wish\r\n// to prepend or append to an input.\r\n\r\n.input-group-text {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\r\n  @include font-size($input-font-size); // Match inputs\r\n  font-weight: $input-group-addon-font-weight;\r\n  line-height: $input-line-height;\r\n  color: $input-group-addon-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: $input-group-addon-bg;\r\n  border: $input-border-width solid $input-group-addon-border-color;\r\n  @include border-radius($input-border-radius);\r\n}\r\n\r\n\r\n// Sizing\r\n//\r\n// Remix the default form control sizing classes into new ones for easier\r\n// manipulation.\r\n\r\n.input-group-lg > .form-control,\r\n.input-group-lg > .form-select,\r\n.input-group-lg > .input-group-text,\r\n.input-group-lg > .btn {\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  @include font-size($input-font-size-lg);\r\n  @include border-radius($input-border-radius-lg);\r\n}\r\n\r\n.input-group-sm > .form-control,\r\n.input-group-sm > .form-select,\r\n.input-group-sm > .input-group-text,\r\n.input-group-sm > .btn {\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  @include font-size($input-font-size-sm);\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\n.input-group-lg > .form-select,\r\n.input-group-sm > .form-select {\r\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\r\n}\r\n\r\n\r\n// Rounded corners\r\n//\r\n// These rulesets must come after the sizing ones to properly override sm and lg\r\n// border-radius values when extending. They're more specific than we'd like\r\n// with the `.input-group >` part, but without it, we cannot override the sizing.\r\n\r\n// stylelint-disable-next-line no-duplicate-selectors\r\n.input-group {\r\n  &:not(.has-validation) {\r\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\r\n    > .dropdown-toggle:nth-last-child(n + 3) {\r\n      @include border-end-radius(0);\r\n    }\r\n  }\r\n\r\n  &.has-validation {\r\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),\r\n    > .dropdown-toggle:nth-last-child(n + 4) {\r\n      @include border-end-radius(0);\r\n    }\r\n  }\r\n\r\n  $validation-messages: \"\";\r\n  @each $state in map-keys($form-validation-states) {\r\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\r\n  }\r\n\r\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\r\n    margin-left: -$input-border-width;\r\n    @include border-start-radius(0);\r\n  }\r\n}\r\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\r\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\r\n\r\n// scss-docs-start form-validation-mixins\r\n@mixin form-validation-state-selector($state) {\r\n  @if ($state == \"valid\" or $state == \"invalid\") {\r\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\r\n    #{if(&, \"&\", \"\")}.is-#{$state} {\r\n      @content;\r\n    }\r\n  } @else {\r\n    #{if(&, \"&\", \"\")}.is-#{$state} {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin form-validation-state(\r\n  $state,\r\n  $color,\r\n  $icon,\r\n  $tooltip-color: color-contrast($color),\r\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\r\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\r\n) {\r\n  .#{$state}-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: $form-feedback-margin-top;\r\n    @include font-size($form-feedback-font-size);\r\n    font-style: $form-feedback-font-style;\r\n    color: $color;\r\n  }\r\n\r\n  .#{$state}-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%; // Contain to parent when possible\r\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\r\n    margin-top: .1rem;\r\n    @include font-size($form-feedback-tooltip-font-size);\r\n    line-height: $form-feedback-tooltip-line-height;\r\n    color: $tooltip-color;\r\n    background-color: $tooltip-bg-color;\r\n    @include border-radius($form-feedback-tooltip-border-radius);\r\n  }\r\n\r\n  @include form-validation-state-selector($state) {\r\n    ~ .#{$state}-feedback,\r\n    ~ .#{$state}-tooltip {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .form-control {\r\n    @include form-validation-state-selector($state) {\r\n      border-color: $color;\r\n\r\n      @if $enable-validation-icons {\r\n        padding-right: $input-height-inner;\r\n        background-image: escape-svg($icon);\r\n        background-repeat: no-repeat;\r\n        background-position: right $input-height-inner-quarter center;\r\n        background-size: $input-height-inner-half $input-height-inner-half;\r\n      }\r\n\r\n      &:focus {\r\n        border-color: $color;\r\n        box-shadow: $focus-box-shadow;\r\n      }\r\n    }\r\n  }\r\n\r\n  // stylelint-disable-next-line selector-no-qualifying-type\r\n  textarea.form-control {\r\n    @include form-validation-state-selector($state) {\r\n      @if $enable-validation-icons {\r\n        padding-right: $input-height-inner;\r\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-select {\r\n    @include form-validation-state-selector($state) {\r\n      border-color: $color;\r\n\r\n      @if $enable-validation-icons {\r\n        &:not([multiple]):not([size]),\r\n        &:not([multiple])[size=\"1\"] {\r\n          padding-right: $form-select-feedback-icon-padding-end;\r\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\r\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\r\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        border-color: $color;\r\n        box-shadow: $focus-box-shadow;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-check-input {\r\n    @include form-validation-state-selector($state) {\r\n      border-color: $color;\r\n\r\n      &:checked {\r\n        background-color: $color;\r\n      }\r\n\r\n      &:focus {\r\n        box-shadow: $focus-box-shadow;\r\n      }\r\n\r\n      ~ .form-check-label {\r\n        color: $color;\r\n      }\r\n    }\r\n  }\r\n  .form-check-inline .form-check-input {\r\n    ~ .#{$state}-feedback {\r\n      margin-left: .5em;\r\n    }\r\n  }\r\n\r\n  .input-group .form-control,\r\n  .input-group .form-select {\r\n    @include form-validation-state-selector($state) {\r\n      @if $state == \"valid\" {\r\n        z-index: 1;\r\n      } @else if $state == \"invalid\" {\r\n        z-index: 2;\r\n      }\r\n      &:focus {\r\n        z-index: 3;\r\n      }\r\n    }\r\n  }\r\n}\r\n// scss-docs-end form-validation-mixins\r\n","//\r\n// Base styles\r\n//\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-family: $btn-font-family;\r\n  font-weight: $btn-font-weight;\r\n  line-height: $btn-line-height;\r\n  color: $body-color;\r\n  text-align: center;\r\n  text-decoration: if($link-decoration == none, null, none);\r\n  white-space: $btn-white-space;\r\n  vertical-align: middle;\r\n  cursor: if($enable-button-pointers, pointer, null);\r\n  user-select: none;\r\n  background-color: transparent;\r\n  border: $btn-border-width solid transparent;\r\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-border-radius);\r\n  @include transition($btn-transition);\r\n\r\n  &:hover {\r\n    color: $body-color;\r\n    text-decoration: if($link-hover-decoration == underline, none, null);\r\n  }\r\n\r\n  .btn-check:focus + &,\r\n  &:focus {\r\n    outline: 0;\r\n    box-shadow: $btn-focus-box-shadow;\r\n  }\r\n\r\n  .btn-check:checked + &,\r\n  .btn-check:active + &,\r\n  &:active,\r\n  &.active {\r\n    @include box-shadow($btn-active-box-shadow);\r\n\r\n    &:focus {\r\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\r\n    }\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled,\r\n  fieldset:disabled & {\r\n    pointer-events: none;\r\n    opacity: $btn-disabled-opacity;\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Alternate buttons\r\n//\r\n\r\n// scss-docs-start btn-variant-loops\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color} {\r\n    @include button-variant($value, $value);\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-outline-#{$color} {\r\n    @include button-outline-variant($value);\r\n  }\r\n}\r\n// scss-docs-end btn-variant-loops\r\n\r\n\r\n//\r\n// Link buttons\r\n//\r\n\r\n// Make a button look and behave like a link\r\n.btn-link {\r\n  font-weight: $font-weight-normal;\r\n  color: $btn-link-color;\r\n  text-decoration: $link-decoration;\r\n\r\n  &:hover {\r\n    color: $btn-link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n  }\r\n\r\n  &:focus {\r\n    text-decoration: $link-hover-decoration;\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    color: $btn-link-disabled-color;\r\n  }\r\n\r\n  // No need for an active state here\r\n}\r\n\r\n\r\n//\r\n// Button Sizes\r\n//\r\n\r\n.btn-lg {\r\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\r\n}\r\n\r\n.btn-sm {\r\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\r\n}\r\n","// Button variants\r\n//\r\n// Easily pump out default styles, as well as :hover, :focus, :active,\r\n// and disabled options for all buttons\r\n\r\n// scss-docs-start btn-variant-mixin\r\n@mixin button-variant(\r\n  $background,\r\n  $border,\r\n  $color: color-contrast($background),\r\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\r\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\r\n  $hover-color: color-contrast($hover-background),\r\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\r\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\r\n  $active-color: color-contrast($active-background),\r\n  $disabled-background: $background,\r\n  $disabled-border: $border,\r\n  $disabled-color: color-contrast($disabled-background)\r\n) {\r\n  color: $color;\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n  @include box-shadow($btn-box-shadow);\r\n\r\n  &:hover {\r\n    color: $hover-color;\r\n    @include gradient-bg($hover-background);\r\n    border-color: $hover-border;\r\n  }\r\n\r\n  .btn-check:focus + &,\r\n  &:focus {\r\n    color: $hover-color;\r\n    @include gradient-bg($hover-background);\r\n    border-color: $hover-border;\r\n    @if $enable-shadows {\r\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\r\n    } @else {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\r\n    }\r\n  }\r\n\r\n  .btn-check:checked + &,\r\n  .btn-check:active + &,\r\n  &:active,\r\n  &.active,\r\n  .show > &.dropdown-toggle {\r\n    color: $active-color;\r\n    background-color: $active-background;\r\n    // Remove CSS gradients if they're enabled\r\n    background-image: if($enable-gradients, none, null);\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      @if $enable-shadows {\r\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\r\n      } @else {\r\n        // Avoid using mixin so we can pass custom focus shadow properly\r\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\r\n      }\r\n    }\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    color: $disabled-color;\r\n    background-color: $disabled-background;\r\n    // Remove CSS gradients if they're enabled\r\n    background-image: if($enable-gradients, none, null);\r\n    border-color: $disabled-border;\r\n  }\r\n}\r\n// scss-docs-end btn-variant-mixin\r\n\r\n// scss-docs-start btn-outline-variant-mixin\r\n@mixin button-outline-variant(\r\n  $color,\r\n  $color-hover: color-contrast($color),\r\n  $active-background: $color,\r\n  $active-border: $color,\r\n  $active-color: color-contrast($active-background)\r\n) {\r\n  color: $color;\r\n  border-color: $color;\r\n\r\n  &:hover {\r\n    color: $color-hover;\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n  }\r\n\r\n  .btn-check:focus + &,\r\n  &:focus {\r\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n  }\r\n\r\n  .btn-check:checked + &,\r\n  .btn-check:active + &,\r\n  &:active,\r\n  &.active,\r\n  &.dropdown-toggle.show {\r\n    color: $active-color;\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      @if $enable-shadows {\r\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\r\n      } @else {\r\n        // Avoid using mixin so we can pass custom focus shadow properly\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n      }\r\n    }\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    color: $color;\r\n    background-color: transparent;\r\n  }\r\n}\r\n// scss-docs-end btn-outline-variant-mixin\r\n\r\n// scss-docs-start btn-size-mixin\r\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\r\n  padding: $padding-y $padding-x;\r\n  @include font-size($font-size);\r\n  // Manually declare to provide an override to the browser default\r\n  @include border-radius($border-radius, 0);\r\n}\r\n// scss-docs-end btn-size-mixin\r\n",".fade {\r\n  @include transition($transition-fade);\r\n\r\n  &:not(.show) {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n// scss-docs-start collapse-classes\r\n.collapse {\r\n  &:not(.show) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.collapsing {\r\n  height: 0;\r\n  overflow: hidden;\r\n  @include transition($transition-collapse);\r\n}\r\n// scss-docs-end collapse-classes\r\n","// The dropdown wrapper (`<div>`)\r\n.dropup,\r\n.dropend,\r\n.dropdown,\r\n.dropstart {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  white-space: nowrap;\r\n\r\n  // Generate the caret automatically\r\n  @include caret();\r\n}\r\n\r\n// The dropdown menu\r\n.dropdown-menu {\r\n  position: absolute;\r\n  z-index: $zindex-dropdown;\r\n  display: none; // none by default, but block on \"open\" of the menu\r\n  min-width: $dropdown-min-width;\r\n  padding: $dropdown-padding-y $dropdown-padding-x;\r\n  margin: 0; // Override default margin of ul\r\n  @include font-size($dropdown-font-size);\r\n  color: $dropdown-color;\r\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\r\n  list-style: none;\r\n  background-color: $dropdown-bg;\r\n  background-clip: padding-box;\r\n  border: $dropdown-border-width solid $dropdown-border-color;\r\n  @include border-radius($dropdown-border-radius);\r\n  @include box-shadow($dropdown-box-shadow);\r\n\r\n  &[data-bs-popper] {\r\n    top: 100%;\r\n    left: 0;\r\n    margin-top: $dropdown-spacer;\r\n  }\r\n}\r\n\r\n// scss-docs-start responsive-breakpoints\r\n// We deliberately hardcode the `bs-` prefix because we check\r\n// this custom property in JS to determine Popper's positioning\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .dropdown-menu#{$infix}-start {\r\n      --bs-position: start;\r\n\r\n      &[data-bs-popper] {\r\n        right: auto;\r\n        left: 0;\r\n      }\r\n    }\r\n\r\n    .dropdown-menu#{$infix}-end {\r\n      --bs-position: end;\r\n\r\n      &[data-bs-popper] {\r\n        right: 0;\r\n        left: auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n// scss-docs-end responsive-breakpoints\r\n\r\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\r\n// Just add .dropup after the standard .dropdown class and you're set.\r\n.dropup {\r\n  .dropdown-menu[data-bs-popper] {\r\n    top: auto;\r\n    bottom: 100%;\r\n    margin-top: 0;\r\n    margin-bottom: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(up);\r\n  }\r\n}\r\n\r\n.dropend {\r\n  .dropdown-menu[data-bs-popper] {\r\n    top: 0;\r\n    right: auto;\r\n    left: 100%;\r\n    margin-top: 0;\r\n    margin-left: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(end);\r\n    &::after {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropstart {\r\n  .dropdown-menu[data-bs-popper] {\r\n    top: 0;\r\n    right: 100%;\r\n    left: auto;\r\n    margin-top: 0;\r\n    margin-right: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(start);\r\n    &::before {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Dividers (basically an `<hr>`) within the dropdown\r\n.dropdown-divider {\r\n  height: 0;\r\n  margin: $dropdown-divider-margin-y 0;\r\n  overflow: hidden;\r\n  border-top: 1px solid $dropdown-divider-bg;\r\n}\r\n\r\n// Links, buttons, and more within the dropdown menu\r\n//\r\n// `<button>`-specific styles are denoted with `// For <button>s`\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%; // For `<button>`s\r\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n  clear: both;\r\n  font-weight: $font-weight-normal;\r\n  color: $dropdown-link-color;\r\n  text-align: inherit; // For `<button>`s\r\n  text-decoration: if($link-decoration == none, null, none);\r\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\r\n  background-color: transparent; // For `<button>`s\r\n  border: 0; // For `<button>`s\r\n\r\n  // Prevent dropdown overflow if there's no padding\r\n  // See https://github.com/twbs/bootstrap/pull/27703\r\n  @if $dropdown-padding-y == 0 {\r\n    &:first-child {\r\n      @include border-top-radius($dropdown-inner-border-radius);\r\n    }\r\n\r\n    &:last-child {\r\n      @include border-bottom-radius($dropdown-inner-border-radius);\r\n    }\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $dropdown-link-hover-color;\r\n    text-decoration: if($link-hover-decoration == underline, none, null);\r\n    @include gradient-bg($dropdown-link-hover-bg);\r\n  }\r\n\r\n  &.active,\r\n  &:active {\r\n    color: $dropdown-link-active-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-active-bg);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $dropdown-link-disabled-color;\r\n    pointer-events: none;\r\n    background-color: transparent;\r\n    // Remove CSS gradients if they're enabled\r\n    background-image: if($enable-gradients, none, null);\r\n  }\r\n}\r\n\r\n.dropdown-menu.show {\r\n  display: block;\r\n}\r\n\r\n// Dropdown section headers\r\n.dropdown-header {\r\n  display: block;\r\n  padding: $dropdown-header-padding;\r\n  margin-bottom: 0; // for use with heading elements\r\n  @include font-size($font-size-sm);\r\n  color: $dropdown-header-color;\r\n  white-space: nowrap; // as with > li > a\r\n}\r\n\r\n// Dropdown text\r\n.dropdown-item-text {\r\n  display: block;\r\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n  color: $dropdown-link-color;\r\n}\r\n\r\n// Dark dropdowns\r\n.dropdown-menu-dark {\r\n  color: $dropdown-dark-color;\r\n  background-color: $dropdown-dark-bg;\r\n  border-color: $dropdown-dark-border-color;\r\n  @include box-shadow($dropdown-dark-box-shadow);\r\n\r\n  .dropdown-item {\r\n    color: $dropdown-dark-link-color;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $dropdown-dark-link-hover-color;\r\n      @include gradient-bg($dropdown-dark-link-hover-bg);\r\n    }\r\n\r\n    &.active,\r\n    &:active {\r\n      color: $dropdown-dark-link-active-color;\r\n      @include gradient-bg($dropdown-dark-link-active-bg);\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled {\r\n      color: $dropdown-dark-link-disabled-color;\r\n    }\r\n  }\r\n\r\n  .dropdown-divider {\r\n    border-color: $dropdown-dark-divider-bg;\r\n  }\r\n\r\n  .dropdown-item-text {\r\n    color: $dropdown-dark-link-color;\r\n  }\r\n\r\n  .dropdown-header {\r\n    color: $dropdown-dark-header-color;\r\n  }\r\n}\r\n","// scss-docs-start caret-mixins\r\n@mixin caret-down {\r\n  border-top: $caret-width solid;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: 0;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-up {\r\n  border-top: 0;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: $caret-width solid;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-end {\r\n  border-top: $caret-width solid transparent;\r\n  border-right: 0;\r\n  border-bottom: $caret-width solid transparent;\r\n  border-left: $caret-width solid;\r\n}\r\n\r\n@mixin caret-start {\r\n  border-top: $caret-width solid transparent;\r\n  border-right: $caret-width solid;\r\n  border-bottom: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret($direction: down) {\r\n  @if $enable-caret {\r\n    &::after {\r\n      display: inline-block;\r\n      margin-left: $caret-spacing;\r\n      vertical-align: $caret-vertical-align;\r\n      content: \"\";\r\n      @if $direction == down {\r\n        @include caret-down();\r\n      } @else if $direction == up {\r\n        @include caret-up();\r\n      } @else if $direction == end {\r\n        @include caret-end();\r\n      }\r\n    }\r\n\r\n    @if $direction == start {\r\n      &::after {\r\n        display: none;\r\n      }\r\n\r\n      &::before {\r\n        display: inline-block;\r\n        margin-right: $caret-spacing;\r\n        vertical-align: $caret-vertical-align;\r\n        content: \"\";\r\n        @include caret-start();\r\n      }\r\n    }\r\n\r\n    &:empty::after {\r\n      margin-left: 0;\r\n    }\r\n  }\r\n}\r\n// scss-docs-end caret-mixins\r\n","// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .btn {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n  }\r\n\r\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n  // the borders properly\r\n  > .btn-check:checked + .btn,\r\n  > .btn-check:focus + .btn,\r\n  > .btn:hover,\r\n  > .btn:focus,\r\n  > .btn:active,\r\n  > .btn.active {\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group {\r\n  // Prevent double borders when buttons are next to each other\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) {\r\n    margin-left: -$btn-border-width;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-end-radius(0);\r\n  }\r\n\r\n  // The left radius should be 0 if the button is:\r\n  // - the \"third or more\" child\r\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\r\n  // - part of a btn-group which isn't the first child\r\n  > .btn:nth-child(n + 3),\r\n  > :not(.btn-check) + .btn,\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-start-radius(0);\r\n  }\r\n}\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .btn { @extend .btn-sm; }\r\n.btn-group-lg > .btn { @extend .btn-lg; }\r\n\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: $btn-padding-x * .75;\r\n  padding-left: $btn-padding-x * .75;\r\n\r\n  &::after,\r\n  .dropup &::after,\r\n  .dropend &::after {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .dropstart &::before {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.btn-sm + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-sm * .75;\r\n  padding-left: $btn-padding-x-sm * .75;\r\n}\r\n\r\n.btn-lg + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-lg * .75;\r\n  padding-left: $btn-padding-x-lg * .75;\r\n}\r\n\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  > .btn,\r\n  > .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) {\r\n    margin-top: -$btn-border-width;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-bottom-radius(0);\r\n  }\r\n\r\n  > .btn ~ .btn,\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Kickstart any navigation component with a set of style resets. Works with\r\n// `<nav>`s, `<ul>`s or `<ol>`s.\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: $nav-link-padding-y $nav-link-padding-x;\r\n  @include font-size($nav-link-font-size);\r\n  font-weight: $nav-link-font-weight;\r\n  color: $nav-link-color;\r\n  text-decoration: if($link-decoration == none, null, none);\r\n  @include transition($nav-link-transition);\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $nav-link-hover-color;\r\n    text-decoration: if($link-hover-decoration == underline, none, null);\r\n  }\r\n\r\n  // Disabled state lightens text\r\n  &.disabled {\r\n    color: $nav-link-disabled-color;\r\n    pointer-events: none;\r\n    cursor: default;\r\n  }\r\n}\r\n\r\n//\r\n// Tabs\r\n//\r\n\r\n.nav-tabs {\r\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\r\n\r\n  .nav-link {\r\n    margin-bottom: -$nav-tabs-border-width;\r\n    background: none;\r\n    border: $nav-tabs-border-width solid transparent;\r\n    @include border-top-radius($nav-tabs-border-radius);\r\n\r\n    &:hover,\r\n    &:focus {\r\n      border-color: $nav-tabs-link-hover-border-color;\r\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\r\n      isolation: isolate;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $nav-link-disabled-color;\r\n      background-color: transparent;\r\n      border-color: transparent;\r\n    }\r\n  }\r\n\r\n  .nav-link.active,\r\n  .nav-item.show .nav-link {\r\n    color: $nav-tabs-link-active-color;\r\n    background-color: $nav-tabs-link-active-bg;\r\n    border-color: $nav-tabs-link-active-border-color;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    // Make dropdown border overlap tab border\r\n    margin-top: -$nav-tabs-border-width;\r\n    // Remove the top rounded corners here since there is a hard edge above the menu\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Pills\r\n//\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n    background: none;\r\n    border: 0;\r\n    @include border-radius($nav-pills-border-radius);\r\n  }\r\n\r\n  .nav-link.active,\r\n  .show > .nav-link {\r\n    color: $nav-pills-link-active-color;\r\n    @include gradient-bg($nav-pills-link-active-bg);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Justified variants\r\n//\r\n\r\n.nav-fill {\r\n  > .nav-link,\r\n  .nav-item {\r\n    flex: 1 1 auto;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.nav-justified {\r\n  > .nav-link,\r\n  .nav-item {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.nav-fill,\r\n.nav-justified {\r\n  .nav-item .nav-link {\r\n    width: 100%; // Make sure button will grow\r\n  }\r\n}\r\n\r\n\r\n// Tabbable tabs\r\n//\r\n// Hide tabbable panes to start, show them when `.active`\r\n\r\n.tab-content {\r\n  > .tab-pane {\r\n    display: none;\r\n  }\r\n  > .active {\r\n    display: block;\r\n  }\r\n}\r\n","// Contents\r\n//\r\n// Navbar\r\n// Navbar brand\r\n// Navbar nav\r\n// Navbar text\r\n// Responsive navbar\r\n// Navbar position\r\n// Navbar themes\r\n\r\n\r\n// Navbar\r\n//\r\n// Provide a static navbar from which we expand to create full-width, fixed, and\r\n// other navbar variations.\r\n\r\n.navbar {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\r\n  align-items: center;\r\n  justify-content: space-between; // space out brand from logo\r\n  padding-top: $navbar-padding-y;\r\n  padding-right: $navbar-padding-x; // default: null\r\n  padding-bottom: $navbar-padding-y;\r\n  padding-left: $navbar-padding-x; // default: null\r\n  @include gradient-bg();\r\n\r\n  // Because flex properties aren't inherited, we need to redeclare these first\r\n  // few properties so that content nested within behave properly.\r\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\r\n  %container-flex-properties {\r\n    display: flex;\r\n    flex-wrap: inherit;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  > .container,\r\n  > .container-fluid {\r\n    @extend %container-flex-properties;\r\n  }\r\n\r\n  @each $breakpoint, $container-max-width in $container-max-widths {\r\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\r\n      @extend %container-flex-properties;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Navbar brand\r\n//\r\n// Used for brand, project, or site names.\r\n\r\n.navbar-brand {\r\n  padding-top: $navbar-brand-padding-y;\r\n  padding-bottom: $navbar-brand-padding-y;\r\n  margin-right: $navbar-brand-margin-end;\r\n  @include font-size($navbar-brand-font-size);\r\n  text-decoration: if($link-decoration == none, null, none);\r\n  white-space: nowrap;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    text-decoration: if($link-hover-decoration == underline, none, null);\r\n  }\r\n}\r\n\r\n\r\n// Navbar nav\r\n//\r\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n\r\n  .nav-link {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    position: static;\r\n  }\r\n}\r\n\r\n\r\n// Navbar text\r\n//\r\n//\r\n\r\n.navbar-text {\r\n  padding-top: $nav-link-padding-y;\r\n  padding-bottom: $nav-link-padding-y;\r\n}\r\n\r\n\r\n// Responsive navbar\r\n//\r\n// Custom styles for responsive collapsing and toggling of navbar contents.\r\n// Powered by the collapse Bootstrap JavaScript plugin.\r\n\r\n// When collapsed, prevent the toggleable navbar contents from appearing in\r\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\r\n// on the `.navbar` parent.\r\n.navbar-collapse {\r\n  flex-basis: 100%;\r\n  flex-grow: 1;\r\n  // For always expanded or extra full navbars, ensure content aligns itself\r\n  // properly vertically. Can be easily overridden with flex utilities.\r\n  align-items: center;\r\n}\r\n\r\n// Button for toggling the navbar when in its collapsed state\r\n.navbar-toggler {\r\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\r\n  @include font-size($navbar-toggler-font-size);\r\n  line-height: 1;\r\n  background-color: transparent; // remove default button style\r\n  border: $border-width solid transparent; // remove default button style\r\n  @include border-radius($navbar-toggler-border-radius);\r\n  @include transition($navbar-toggler-transition);\r\n\r\n  &:hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    text-decoration: none;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 $navbar-toggler-focus-width;\r\n  }\r\n}\r\n\r\n// Keep as a separate element so folks can easily override it with another icon\r\n// or image file as needed.\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: 100%;\r\n}\r\n\r\n.navbar-nav-scroll {\r\n  max-height: var(--#{$variable-prefix}scroll-height, 75vh);\r\n  overflow-y: auto;\r\n}\r\n\r\n// scss-docs-start navbar-expand-loop\r\n// Generate series of `.navbar-expand-*` responsive classes for configuring\r\n// where your navbar collapses.\r\n.navbar-expand {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    // stylelint-disable-next-line scss/selector-no-union-class-name\r\n    &#{$infix} {\r\n      @include media-breakpoint-up($next) {\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start;\r\n\r\n        .navbar-nav {\r\n          flex-direction: row;\r\n\r\n          .dropdown-menu {\r\n            position: absolute;\r\n          }\r\n\r\n          .nav-link {\r\n            padding-right: $navbar-nav-link-padding-x;\r\n            padding-left: $navbar-nav-link-padding-x;\r\n          }\r\n        }\r\n\r\n        .navbar-nav-scroll {\r\n          overflow: visible;\r\n        }\r\n\r\n        .navbar-collapse {\r\n          display: flex !important; // stylelint-disable-line declaration-no-important\r\n          flex-basis: auto;\r\n        }\r\n\r\n        .navbar-toggler {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n// scss-docs-end navbar-expand-loop\r\n\r\n\r\n// Navbar themes\r\n//\r\n// Styles for switching between navbars with light or dark background.\r\n\r\n// Dark links against a light background\r\n.navbar-light {\r\n  .navbar-brand {\r\n    color: $navbar-light-brand-color;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $navbar-light-brand-hover-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-light-color;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $navbar-light-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-light-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .nav-link.active {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-light-color;\r\n    border-color: $navbar-light-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-light-color;\r\n\r\n    a,\r\n    a:hover,\r\n    a:focus  {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n}\r\n\r\n// White links against a dark background\r\n.navbar-dark {\r\n  .navbar-brand {\r\n    color: $navbar-dark-brand-color;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $navbar-dark-brand-hover-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-dark-color;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $navbar-dark-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-dark-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .nav-link.active {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-dark-color;\r\n    border-color: $navbar-dark-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-dark-color;\r\n    a,\r\n    a:hover,\r\n    a:focus {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\r\n  height: $card-height;\r\n  word-wrap: break-word;\r\n  background-color: $card-bg;\r\n  background-clip: border-box;\r\n  border: $card-border-width solid $card-border-color;\r\n  @include border-radius($card-border-radius);\r\n\r\n  > hr {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .list-group {\r\n    border-top: inherit;\r\n    border-bottom: inherit;\r\n\r\n    &:first-child {\r\n      border-top-width: 0;\r\n      @include border-top-radius($card-inner-border-radius);\r\n    }\r\n\r\n    &:last-child  {\r\n      border-bottom-width: 0;\r\n      @include border-bottom-radius($card-inner-border-radius);\r\n    }\r\n  }\r\n\r\n  // Due to specificity of the above selector (`.card > .list-group`), we must\r\n  // use a child selector here to prevent double borders.\r\n  > .card-header + .list-group,\r\n  > .list-group + .card-footer {\r\n    border-top: 0;\r\n  }\r\n}\r\n\r\n.card-body {\r\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\r\n  // as much space as possible, ensuring footers are aligned to the bottom.\r\n  flex: 1 1 auto;\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  color: $card-color;\r\n}\r\n\r\n.card-title {\r\n  margin-bottom: $card-title-spacer-y;\r\n}\r\n\r\n.card-subtitle {\r\n  margin-top: -$card-title-spacer-y * .5;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-text:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-link {\r\n  &:hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  + .card-link {\r\n    margin-left: $card-spacer-x;\r\n  }\r\n}\r\n\r\n//\r\n// Optional textual caps\r\n//\r\n\r\n.card-header {\r\n  padding: $card-cap-padding-y $card-cap-padding-x;\r\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\r\n  color: $card-cap-color;\r\n  background-color: $card-cap-bg;\r\n  border-bottom: $card-border-width solid $card-border-color;\r\n\r\n  &:first-child {\r\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\r\n  }\r\n}\r\n\r\n.card-footer {\r\n  padding: $card-cap-padding-y $card-cap-padding-x;\r\n  color: $card-cap-color;\r\n  background-color: $card-cap-bg;\r\n  border-top: $card-border-width solid $card-border-color;\r\n\r\n  &:last-child {\r\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Header navs\r\n//\r\n\r\n.card-header-tabs {\r\n  margin-right: -$card-cap-padding-x * .5;\r\n  margin-bottom: -$card-cap-padding-y;\r\n  margin-left: -$card-cap-padding-x * .5;\r\n  border-bottom: 0;\r\n\r\n  @if $nav-tabs-link-active-bg != $card-bg {\r\n    .nav-link.active {\r\n      background-color: $card-bg;\r\n      border-bottom-color: $card-bg;\r\n    }\r\n  }\r\n}\r\n\r\n.card-header-pills {\r\n  margin-right: -$card-cap-padding-x * .5;\r\n  margin-left: -$card-cap-padding-x * .5;\r\n}\r\n\r\n// Card image\r\n.card-img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: $card-img-overlay-padding;\r\n  @include border-radius($card-inner-border-radius);\r\n}\r\n\r\n.card-img,\r\n.card-img-top,\r\n.card-img-bottom {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n}\r\n\r\n.card-img,\r\n.card-img-top {\r\n  @include border-top-radius($card-inner-border-radius);\r\n}\r\n\r\n.card-img,\r\n.card-img-bottom {\r\n  @include border-bottom-radius($card-inner-border-radius);\r\n}\r\n\r\n\r\n//\r\n// Card groups\r\n//\r\n\r\n.card-group {\r\n  // The child selector allows nested `.card` within `.card-group`\r\n  // to display properly.\r\n  > .card {\r\n    margin-bottom: $card-group-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    // The child selector allows nested `.card` within `.card-group`\r\n    // to display properly.\r\n    > .card {\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\r\n      flex: 1 0 0%;\r\n      margin-bottom: 0;\r\n\r\n      + .card {\r\n        margin-left: 0;\r\n        border-left: 0;\r\n      }\r\n\r\n      // Handle rounded corners\r\n      @if $enable-rounded {\r\n        &:not(:last-child) {\r\n          @include border-end-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            // stylelint-disable-next-line property-disallowed-list\r\n            border-top-right-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            // stylelint-disable-next-line property-disallowed-list\r\n            border-bottom-right-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:not(:first-child) {\r\n          @include border-start-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            // stylelint-disable-next-line property-disallowed-list\r\n            border-top-left-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            // stylelint-disable-next-line property-disallowed-list\r\n            border-bottom-left-radius: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.accordion-button {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: $accordion-button-padding-y $accordion-button-padding-x;\r\n  @include font-size($font-size-base);\r\n  color: $accordion-button-color;\r\n  text-align: left; // Reset button style\r\n  background-color: $accordion-button-bg;\r\n  border: 0;\r\n  @include border-radius(0);\r\n  overflow-anchor: none;\r\n  @include transition($accordion-transition);\r\n\r\n  &:not(.collapsed) {\r\n    color: $accordion-button-active-color;\r\n    background-color: $accordion-button-active-bg;\r\n    box-shadow: inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\r\n\r\n    &::after {\r\n      background-image: escape-svg($accordion-button-active-icon);\r\n      transform: $accordion-icon-transform;\r\n    }\r\n  }\r\n\r\n  // Accordion icon\r\n  &::after {\r\n    flex-shrink: 0;\r\n    width: $accordion-icon-width;\r\n    height: $accordion-icon-width;\r\n    margin-left: auto;\r\n    content: \"\";\r\n    background-image: escape-svg($accordion-button-icon);\r\n    background-repeat: no-repeat;\r\n    background-size: $accordion-icon-width;\r\n    @include transition($accordion-icon-transition);\r\n  }\r\n\r\n  &:hover {\r\n    z-index: 2;\r\n  }\r\n\r\n  &:focus {\r\n    z-index: 3;\r\n    border-color: $accordion-button-focus-border-color;\r\n    outline: 0;\r\n    box-shadow: $accordion-button-focus-box-shadow;\r\n  }\r\n}\r\n\r\n.accordion-header {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.accordion-item {\r\n  background-color: $accordion-bg;\r\n  // border: $accordion-border-width solid $accordion-border-color;\r\n\r\n  &:first-of-type {\r\n    @include border-top-radius($accordion-border-radius);\r\n\r\n    .accordion-button {\r\n      @include border-top-radius($accordion-inner-border-radius);\r\n    }\r\n  }\r\n\r\n  &:not(:first-of-type) {\r\n    border-top: 0;\r\n  }\r\n\r\n  // Only set a border-radius on the last item if the accordion is collapsed\r\n  &:last-of-type {\r\n    @include border-bottom-radius($accordion-border-radius);\r\n\r\n    .accordion-button {\r\n      &.collapsed {\r\n        @include border-bottom-radius($accordion-inner-border-radius);\r\n      }\r\n    }\r\n\r\n    .accordion-collapse {\r\n      @include border-bottom-radius($accordion-border-radius);\r\n    }\r\n  }\r\n}\r\n\r\n.accordion-body {\r\n  padding: $accordion-body-padding-y $accordion-body-padding-x;\r\n}\r\n\r\n\r\n// Flush accordion items\r\n//\r\n// Remove borders and border-radius to keep accordion items edge-to-edge.\r\n\r\n.accordion-flush {\r\n  .accordion-collapse {\r\n    border-width: 0;\r\n  }\r\n\r\n  .accordion-item {\r\n    border-right: 0;\r\n    border-left: 0;\r\n    @include border-radius(0);\r\n\r\n    &:first-child { border-top: 0; }\r\n    &:last-child { border-bottom: 0; }\r\n\r\n    .accordion-button {\r\n      @include border-radius(0);\r\n    }\r\n  }\r\n}\r\n",".breadcrumb {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\r\n  margin-bottom: $breadcrumb-margin-bottom;\r\n  @include font-size($breadcrumb-font-size);\r\n  list-style: none;\r\n  background-color: $breadcrumb-bg;\r\n  @include border-radius($breadcrumb-border-radius);\r\n}\r\n\r\n.breadcrumb-item {\r\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\r\n  + .breadcrumb-item {\r\n    padding-left: $breadcrumb-item-padding-x;\r\n\r\n    &::before {\r\n      float: left; // Suppress inline spacings and underlining of the separator\r\n      padding-right: $breadcrumb-item-padding-x;\r\n      color: $breadcrumb-divider-color;\r\n      content: var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\r\n    }\r\n  }\r\n\r\n  &.active {\r\n    color: $breadcrumb-active-color;\r\n  }\r\n}\r\n",".pagination {\r\n  display: flex;\r\n  @include list-unstyled();\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  color: $pagination-color;\r\n  text-decoration: if($link-decoration == none, null, none);\r\n  background-color: $pagination-bg;\r\n  border: $pagination-border-width solid $pagination-border-color;\r\n  @include transition($pagination-transition);\r\n\r\n  &:hover {\r\n    z-index: 2;\r\n    color: $pagination-hover-color;\r\n    text-decoration: if($link-hover-decoration == underline, none, null);\r\n    background-color: $pagination-hover-bg;\r\n    border-color: $pagination-hover-border-color;\r\n  }\r\n\r\n  &:focus {\r\n    z-index: 3;\r\n    color: $pagination-focus-color;\r\n    background-color: $pagination-focus-bg;\r\n    outline: $pagination-focus-outline;\r\n    box-shadow: $pagination-focus-box-shadow;\r\n  }\r\n}\r\n\r\n.page-item {\r\n  &:not(:first-child) .page-link {\r\n    margin-left: $pagination-margin-start;\r\n  }\r\n\r\n  &.active .page-link {\r\n    z-index: 3;\r\n    color: $pagination-active-color;\r\n    @include gradient-bg($pagination-active-bg);\r\n    border-color: $pagination-active-border-color;\r\n  }\r\n\r\n  &.disabled .page-link {\r\n    color: $pagination-disabled-color;\r\n    pointer-events: none;\r\n    background-color: $pagination-disabled-bg;\r\n    border-color: $pagination-disabled-border-color;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Sizing\r\n//\r\n@include pagination-size($pagination-padding-y, $pagination-padding-x, null, $pagination-border-radius);\r\n\r\n.pagination-lg {\r\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\r\n}\r\n\r\n.pagination-sm {\r\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\r\n}\r\n","// Pagination\r\n\r\n// scss-docs-start pagination-mixin\r\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\r\n  .page-link {\r\n    padding: $padding-y $padding-x;\r\n    @include font-size($font-size);\r\n  }\r\n\r\n  .page-item {\r\n    @if $pagination-margin-start == (-$pagination-border-width) {\r\n      &:first-child {\r\n        .page-link {\r\n          @include border-start-radius($border-radius);\r\n        }\r\n      }\r\n\r\n      &:last-child {\r\n        .page-link {\r\n          @include border-end-radius($border-radius);\r\n        }\r\n      }\r\n    } @else {\r\n      //Add border-radius to all pageLinks in case they have left margin\r\n      .page-link {\r\n        @include border-radius($border-radius);\r\n      }\r\n    }\r\n  }\r\n}\r\n// scss-docs-end pagination-mixin\r\n","// Base class\r\n//\r\n// Requires one of the contextual, color modifier classes for `color` and\r\n// `background-color`.\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: $badge-padding-y $badge-padding-x;\r\n  @include font-size($badge-font-size);\r\n  font-weight: $badge-font-weight;\r\n  line-height: 1;\r\n  color: $badge-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  @include border-radius($badge-border-radius);\r\n  @include gradient-bg();\r\n\r\n  // Empty badges collapse automatically\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// Quick fix for badges in buttons\r\n.btn .badge {\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.alert {\r\n  position: relative;\r\n  padding: $alert-padding-y $alert-padding-x;\r\n  margin-bottom: $alert-margin-bottom;\r\n  border: $alert-border-width solid transparent;\r\n  @include border-radius($alert-border-radius);\r\n}\r\n\r\n// Headings for larger alerts\r\n.alert-heading {\r\n  // Specified to prevent conflicts of changing $headings-color\r\n  color: inherit;\r\n}\r\n\r\n// Provide class for links that match alerts\r\n.alert-link {\r\n  font-weight: $alert-link-font-weight;\r\n}\r\n\r\n\r\n// Dismissible alerts\r\n//\r\n// Expand the right padding and account for the close button's positioning.\r\n\r\n.alert-dismissible {\r\n  padding-right: $alert-dismissible-padding-r;\r\n\r\n  // Adjust close link position\r\n  .btn-close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: $stretched-link-z-index + 1;\r\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\r\n  }\r\n}\r\n\r\n\r\n// scss-docs-start alert-modifiers\r\n// Generate contextual modifier classes for colorizing the alert.\r\n\r\n@each $state, $value in $theme-colors {\r\n  $alert-background: shift-color($value, $alert-bg-scale);\r\n  $alert-border: shift-color($value, $alert-border-scale);\r\n  $alert-color: shift-color($value, $alert-color-scale);\r\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\r\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\r\n  }\r\n  .alert-#{$state} {\r\n    @include alert-variant($alert-background, $alert-border, $alert-color);\r\n  }\r\n}\r\n// scss-docs-end alert-modifiers\r\n","// scss-docs-start alert-variant-mixin\r\n@mixin alert-variant($background, $border, $color) {\r\n  color: $color;\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n\r\n  .alert-link {\r\n    color: shade-color($color, 20%);\r\n  }\r\n}\r\n// scss-docs-end alert-variant-mixin\r\n","// Disable animation if transitions are disabled\r\n\r\n// scss-docs-start progress-keyframes\r\n@if $enable-transitions {\r\n  @keyframes progress-bar-stripes {\r\n    0% { background-position-x: $progress-height; }\r\n  }\r\n}\r\n// scss-docs-end progress-keyframes\r\n\r\n.progress {\r\n  display: flex;\r\n  height: $progress-height;\r\n  overflow: hidden; // force rounded corners by cropping it\r\n  @include font-size($progress-font-size);\r\n  background-color: $progress-bg;\r\n  @include border-radius($progress-border-radius);\r\n  @include box-shadow($progress-box-shadow);\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  color: $progress-bar-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: $progress-bar-bg;\r\n  @include transition($progress-bar-transition);\r\n}\r\n\r\n.progress-bar-striped {\r\n  @include gradient-striped();\r\n  background-size: $progress-height $progress-height;\r\n}\r\n\r\n@if $enable-transitions {\r\n  .progress-bar-animated {\r\n    animation: $progress-bar-animation-timing progress-bar-stripes;\r\n\r\n    @if $enable-reduced-motion {\r\n      @media (prefers-reduced-motion: reduce) {\r\n        animation: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Easily usable on <ul>, <ol>, or <div>.\r\n\r\n.list-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // No need to set list-style: none; since .list-group-item is block level\r\n  padding-left: 0; // reset padding because ul and ol\r\n  margin-bottom: 0;\r\n  @include border-radius($list-group-border-radius);\r\n}\r\n\r\n.list-group-numbered {\r\n  list-style-type: none;\r\n  counter-reset: section;\r\n\r\n  > li::before {\r\n    // Increments only this instance of the section counter\r\n    content: counters(section, \".\") \". \";\r\n    counter-increment: section;\r\n  }\r\n}\r\n\r\n\r\n// Interactive list items\r\n//\r\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\r\n// list items. Includes an extra `.active` modifier class for selected items.\r\n\r\n.list-group-item-action {\r\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\r\n  color: $list-group-action-color;\r\n  text-align: inherit; // For `<button>`s (anchors inherit)\r\n\r\n  // Hover state\r\n  &:hover,\r\n  &:focus {\r\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\r\n    color: $list-group-action-hover-color;\r\n    text-decoration: none;\r\n    background-color: $list-group-hover-bg;\r\n  }\r\n\r\n  &:active {\r\n    color: $list-group-action-active-color;\r\n    background-color: $list-group-action-active-bg;\r\n  }\r\n}\r\n\r\n\r\n// Individual list items\r\n//\r\n// Use on `li`s or `div`s within the `.list-group` parent.\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\r\n  color: $list-group-color;\r\n  text-decoration: if($link-decoration == none, null, none);\r\n  background-color: $list-group-bg;\r\n  border: $list-group-border-width solid $list-group-border-color;\r\n\r\n  &:first-child {\r\n    @include border-top-radius(inherit);\r\n  }\r\n\r\n  &:last-child {\r\n    @include border-bottom-radius(inherit);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $list-group-disabled-color;\r\n    pointer-events: none;\r\n    background-color: $list-group-disabled-bg;\r\n  }\r\n\r\n  // Include both here for `<a>`s and `<button>`s\r\n  &.active {\r\n    z-index: 2; // Place active items above their siblings for proper border styling\r\n    color: $list-group-active-color;\r\n    background-color: $list-group-active-bg;\r\n    border-color: $list-group-active-border-color;\r\n  }\r\n\r\n  & + & {\r\n    border-top-width: 0;\r\n\r\n    &.active {\r\n      margin-top: -$list-group-border-width;\r\n      border-top-width: $list-group-border-width;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Horizontal\r\n//\r\n// Change the layout of list group items from vertical (default) to horizontal.\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .list-group-horizontal#{$infix} {\r\n      flex-direction: row;\r\n\r\n      > .list-group-item {\r\n        &:first-child {\r\n          @include border-bottom-start-radius($list-group-border-radius);\r\n          @include border-top-end-radius(0);\r\n        }\r\n\r\n        &:last-child {\r\n          @include border-top-end-radius($list-group-border-radius);\r\n          @include border-bottom-start-radius(0);\r\n        }\r\n\r\n        &.active {\r\n          margin-top: 0;\r\n        }\r\n\r\n        + .list-group-item {\r\n          border-top-width: $list-group-border-width;\r\n          border-left-width: 0;\r\n\r\n          &.active {\r\n            margin-left: -$list-group-border-width;\r\n            border-left-width: $list-group-border-width;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Flush list items\r\n//\r\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\r\n// useful within other components (e.g., cards).\r\n\r\n.list-group-flush {\r\n  @include border-radius(0);\r\n\r\n  > .list-group-item {\r\n    border-width: 0 0 $list-group-border-width;\r\n\r\n    &:last-child {\r\n      border-bottom-width: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// scss-docs-start list-group-modifiers\r\n// List group contextual variants\r\n//\r\n// Add modifier classes to change text and background color on individual items.\r\n// Organizationally, this must come after the `:hover` states.\r\n\r\n@each $state, $value in $theme-colors {\r\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\r\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\r\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\r\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\r\n  }\r\n\r\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\r\n}\r\n// scss-docs-end list-group-modifiers\r\n","// List Groups\r\n\r\n// scss-docs-start list-group-mixin\r\n@mixin list-group-item-variant($state, $background, $color) {\r\n  .list-group-item-#{$state} {\r\n    color: $color;\r\n    background-color: $background;\r\n\r\n    &.list-group-item-action {\r\n      &:hover,\r\n      &:focus {\r\n        color: $color;\r\n        background-color: shade-color($background, 10%);\r\n      }\r\n\r\n      &.active {\r\n        color: $white;\r\n        background-color: $color;\r\n        border-color: $color;\r\n      }\r\n    }\r\n  }\r\n}\r\n// scss-docs-end list-group-mixin\r\n","// transparent background and border properties included for button version.\r\n// iOS requires the button element instead of an anchor tag.\r\n// If you want the anchor version, it requires `href=\"#\"`.\r\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\r\n\r\n.btn-close {\r\n  box-sizing: content-box;\r\n  width: $btn-close-width;\r\n  height: $btn-close-height;\r\n  padding: $btn-close-padding-y $btn-close-padding-x;\r\n  color: $btn-close-color;\r\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\r\n  border: 0; // for button elements\r\n  @include border-radius();\r\n  opacity: $btn-close-opacity;\r\n\r\n  // Override <a>'s hover style\r\n  &:hover {\r\n    color: $btn-close-color;\r\n    text-decoration: none;\r\n    opacity: $btn-close-hover-opacity;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 0;\r\n    box-shadow: $btn-close-focus-shadow;\r\n    opacity: $btn-close-focus-opacity;\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    pointer-events: none;\r\n    user-select: none;\r\n    opacity: $btn-close-disabled-opacity;\r\n  }\r\n}\r\n\r\n.btn-close-white {\r\n  filter: $btn-close-white-filter;\r\n}\r\n",".toast {\r\n  width: $toast-max-width;\r\n  max-width: 100%;\r\n  @include font-size($toast-font-size);\r\n  color: $toast-color;\r\n  pointer-events: auto;\r\n  background-color: $toast-background-color;\r\n  background-clip: padding-box;\r\n  border: $toast-border-width solid $toast-border-color;\r\n  box-shadow: $toast-box-shadow;\r\n  @include border-radius($toast-border-radius);\r\n\r\n  &:not(.showing):not(.show) {\r\n    opacity: 0;\r\n  }\r\n\r\n  &.hide {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.toast-container {\r\n  width: max-content;\r\n  max-width: 100%;\r\n  pointer-events: none;\r\n\r\n  > :not(:last-child) {\r\n    margin-bottom: $toast-spacing;\r\n  }\r\n}\r\n\r\n.toast-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: $toast-padding-y $toast-padding-x;\r\n  color: $toast-header-color;\r\n  background-color: $toast-header-background-color;\r\n  background-clip: padding-box;\r\n  border-bottom: $toast-border-width solid $toast-header-border-color;\r\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\r\n\r\n  .btn-close {\r\n    margin-right: $toast-padding-x * -.5;\r\n    margin-left: $toast-padding-x;\r\n  }\r\n}\r\n\r\n.toast-body {\r\n  padding: $toast-padding-x; // apply to both vertical and horizontal\r\n  word-wrap: break-word;\r\n}\r\n","// .modal-open      - body class for killing the scroll\r\n// .modal           - container to scroll within\r\n// .modal-dialog    - positioning shell for the actual modal\r\n// .modal-content   - actual modal w/ bg and corners and stuff\r\n\r\n\r\n// Container that the modal scrolls within\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal;\r\n  display: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\r\n  // https://github.com/twbs/bootstrap/pull/10951.\r\n  outline: 0;\r\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\r\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\r\n  // See also https://github.com/twbs/bootstrap/issues/17695\r\n}\r\n\r\n// Shell div to position the modal with bottom padding\r\n.modal-dialog {\r\n  position: relative;\r\n  width: auto;\r\n  margin: $modal-dialog-margin;\r\n  // allow clicks to pass through for custom click handling to close modal\r\n  pointer-events: none;\r\n\r\n  // When fading in the modal, animate it to slide down\r\n  .modal.fade & {\r\n    @include transition($modal-transition);\r\n    transform: $modal-fade-transform;\r\n  }\r\n  .modal.show & {\r\n    transform: $modal-show-transform;\r\n  }\r\n\r\n  // When trying to close, animate focus to scale\r\n  .modal.modal-static & {\r\n    transform: $modal-scale-transform;\r\n  }\r\n}\r\n\r\n.modal-dialog-scrollable {\r\n  height: subtract(100%, $modal-dialog-margin * 2);\r\n\r\n  .modal-content {\r\n    max-height: 100%;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .modal-body {\r\n    overflow-y: auto;\r\n  }\r\n}\r\n\r\n.modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: subtract(100%, $modal-dialog-margin * 2);\r\n}\r\n\r\n// Actual modal\r\n.modal-content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\r\n  // counteract the pointer-events: none; in the .modal-dialog\r\n  color: $modal-content-color;\r\n  pointer-events: auto;\r\n  background-color: $modal-content-bg;\r\n  background-clip: padding-box;\r\n  border: $modal-content-border-width solid $modal-content-border-color;\r\n  @include border-radius($modal-content-border-radius);\r\n  @include box-shadow($modal-content-box-shadow-xs);\r\n  // Remove focus outline from opened modal\r\n  outline: 0;\r\n}\r\n\r\n// Modal background\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal-backdrop;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: $modal-backdrop-bg;\r\n\r\n  // Fade for backdrop\r\n  &.fade { opacity: 0; }\r\n  &.show { opacity: $modal-backdrop-opacity; }\r\n}\r\n\r\n// Modal header\r\n// Top section of the modal w/ title and dismiss\r\n.modal-header {\r\n  display: flex;\r\n  flex-shrink: 0;\r\n  align-items: center;\r\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\r\n  padding: $modal-header-padding;\r\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\r\n  @include border-top-radius($modal-content-inner-border-radius);\r\n\r\n  .btn-close {\r\n    padding: ($modal-header-padding-y * .5) ($modal-header-padding-x * .5);\r\n    margin: ($modal-header-padding-y * -.5) ($modal-header-padding-x * -.5) ($modal-header-padding-y * -.5) auto;\r\n  }\r\n}\r\n\r\n// Title text within header\r\n.modal-title {\r\n  margin-bottom: 0;\r\n  line-height: $modal-title-line-height;\r\n}\r\n\r\n// Modal body\r\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\r\n.modal-body {\r\n  position: relative;\r\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\r\n  // when there should be a fixed height on `.modal-dialog`.\r\n  flex: 1 1 auto;\r\n  padding: $modal-inner-padding;\r\n}\r\n\r\n// Footer (for actions)\r\n.modal-footer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n  align-items: center; // vertically center\r\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\r\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\r\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\r\n  @include border-bottom-radius($modal-content-inner-border-radius);\r\n\r\n  // Place margin between footer elements\r\n  // This solution is far from ideal because of the universal selector usage,\r\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\r\n  > * {\r\n    margin: $modal-footer-margin-between * .5;\r\n  }\r\n}\r\n\r\n// Scale up the modal\r\n@include media-breakpoint-up(sm) {\r\n  // Automatically set modal's width for larger viewports\r\n  .modal-dialog {\r\n    max-width: $modal-md;\r\n    margin: $modal-dialog-margin-y-sm-up auto;\r\n  }\r\n\r\n  .modal-dialog-scrollable {\r\n    height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\r\n  }\r\n\r\n  .modal-dialog-centered {\r\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\r\n  }\r\n\r\n  .modal-content {\r\n    @include box-shadow($modal-content-box-shadow-sm-up);\r\n  }\r\n\r\n  .modal-sm { max-width: $modal-sm; }\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n  .modal-lg,\r\n  .modal-xl {\r\n    max-width: $modal-lg;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-up(xl) {\r\n  .modal-xl { max-width: $modal-xl; }\r\n}\r\n\r\n// scss-docs-start modal-fullscreen-loop\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\r\n\r\n  @include media-breakpoint-down($breakpoint) {\r\n    .modal-fullscreen#{$postfix} {\r\n      width: 100vw;\r\n      max-width: none;\r\n      height: 100%;\r\n      margin: 0;\r\n\r\n      .modal-content {\r\n        height: 100%;\r\n        border: 0;\r\n        @include border-radius(0);\r\n      }\r\n\r\n      .modal-header {\r\n        @include border-radius(0);\r\n      }\r\n\r\n      .modal-body {\r\n        overflow-y: auto;\r\n      }\r\n\r\n      .modal-footer {\r\n        @include border-radius(0);\r\n      }\r\n    }\r\n  }\r\n}\r\n// scss-docs-end modal-fullscreen-loop\r\n","// Base class\r\n.tooltip {\r\n  position: absolute;\r\n  z-index: $zindex-tooltip;\r\n  display: block;\r\n  margin: $tooltip-margin;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  @include font-size($tooltip-font-size);\r\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\r\n  word-wrap: break-word;\r\n  opacity: 0;\r\n\r\n  &.show { opacity: $tooltip-opacity; }\r\n\r\n  .tooltip-arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $tooltip-arrow-width;\r\n    height: $tooltip-arrow-height;\r\n\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-top {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .tooltip-arrow {\r\n    bottom: 0;\r\n\r\n    &::before {\r\n      top: -1px;\r\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\r\n      border-top-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-end {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .tooltip-arrow {\r\n    left: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      right: -1px;\r\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\r\n      border-right-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-bottom {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .tooltip-arrow {\r\n    top: 0;\r\n\r\n    &::before {\r\n      bottom: -1px;\r\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\r\n      border-bottom-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-start {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .tooltip-arrow {\r\n    right: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      left: -1px;\r\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\r\n      border-left-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-auto {\r\n  &[data-popper-placement^=\"top\"] {\r\n    @extend .bs-tooltip-top;\r\n  }\r\n  &[data-popper-placement^=\"right\"] {\r\n    @extend .bs-tooltip-end;\r\n  }\r\n  &[data-popper-placement^=\"bottom\"] {\r\n    @extend .bs-tooltip-bottom;\r\n  }\r\n  &[data-popper-placement^=\"left\"] {\r\n    @extend .bs-tooltip-start;\r\n  }\r\n}\r\n\r\n// Wrapper for the tooltip content\r\n.tooltip-inner {\r\n  max-width: $tooltip-max-width;\r\n  padding: $tooltip-padding-y $tooltip-padding-x;\r\n  color: $tooltip-color;\r\n  text-align: center;\r\n  background-color: $tooltip-bg;\r\n  @include border-radius($tooltip-border-radius);\r\n}\r\n","@mixin reset-text {\r\n  font-family: $font-family-base;\r\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\r\n  font-style: normal;\r\n  font-weight: $font-weight-normal;\r\n  line-height: $line-height-base;\r\n  text-align: left; // Fallback for where `start` is not supported\r\n  text-align: start;\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n}\r\n",".popover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0 #{\"/* rtl:ignore */\"};\r\n  z-index: $zindex-popover;\r\n  display: block;\r\n  max-width: $popover-max-width;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  @include font-size($popover-font-size);\r\n  // Allow breaking very long words so they don't overflow the popover's bounds\r\n  word-wrap: break-word;\r\n  background-color: $popover-bg;\r\n  background-clip: padding-box;\r\n  border: $popover-border-width solid $popover-border-color;\r\n  @include border-radius($popover-border-radius);\r\n  @include box-shadow($popover-box-shadow);\r\n\r\n  .popover-arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    height: $popover-arrow-height;\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      display: block;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-top {\r\n  > .popover-arrow {\r\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\r\n\r\n    &::before {\r\n      bottom: 0;\r\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\r\n      border-top-color: $popover-arrow-outer-color;\r\n    }\r\n\r\n    &::after {\r\n      bottom: $popover-border-width;\r\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\r\n      border-top-color: $popover-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-end {\r\n  > .popover-arrow {\r\n    left: subtract(-$popover-arrow-height, $popover-border-width);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n\r\n    &::before {\r\n      left: 0;\r\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\r\n      border-right-color: $popover-arrow-outer-color;\r\n    }\r\n\r\n    &::after {\r\n      left: $popover-border-width;\r\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\r\n      border-right-color: $popover-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-bottom {\r\n  > .popover-arrow {\r\n    top: subtract(-$popover-arrow-height, $popover-border-width);\r\n\r\n    &::before {\r\n      top: 0;\r\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\r\n      border-bottom-color: $popover-arrow-outer-color;\r\n    }\r\n\r\n    &::after {\r\n      top: $popover-border-width;\r\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\r\n      border-bottom-color: $popover-arrow-color;\r\n    }\r\n  }\r\n\r\n  // This will remove the popover-header's border just below the arrow\r\n  .popover-header::before {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    margin-left: -$popover-arrow-width * .5;\r\n    content: \"\";\r\n    border-bottom: $popover-border-width solid $popover-header-bg;\r\n  }\r\n}\r\n\r\n.bs-popover-start {\r\n  > .popover-arrow {\r\n    right: subtract(-$popover-arrow-height, $popover-border-width);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n\r\n    &::before {\r\n      right: 0;\r\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\r\n      border-left-color: $popover-arrow-outer-color;\r\n    }\r\n\r\n    &::after {\r\n      right: $popover-border-width;\r\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\r\n      border-left-color: $popover-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-auto {\r\n  &[data-popper-placement^=\"top\"] {\r\n    @extend .bs-popover-top;\r\n  }\r\n  &[data-popper-placement^=\"right\"] {\r\n    @extend .bs-popover-end;\r\n  }\r\n  &[data-popper-placement^=\"bottom\"] {\r\n    @extend .bs-popover-bottom;\r\n  }\r\n  &[data-popper-placement^=\"left\"] {\r\n    @extend .bs-popover-start;\r\n  }\r\n}\r\n\r\n// Offset the popover to account for the popover arrow\r\n.popover-header {\r\n  padding: $popover-header-padding-y $popover-header-padding-x;\r\n  margin-bottom: 0; // Reset the default from Reboot\r\n  @include font-size($font-size-base);\r\n  color: $popover-header-color;\r\n  background-color: $popover-header-bg;\r\n  border-bottom: $popover-border-width solid $popover-border-color;\r\n  @include border-top-radius($popover-inner-border-radius);\r\n\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.popover-body {\r\n  padding: $popover-body-padding-y $popover-body-padding-x;\r\n  color: $popover-body-color;\r\n}\r\n","// Notes on the classes:\r\n//\r\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\r\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\r\n//    we're preventing all actions instead\r\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\r\n//    the active slide is heading.\r\n// 3. .active.carousel-item is the current slide.\r\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\r\n//    slide in its in-transition state. Only one of these occurs at a time.\r\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\r\n//    is the upcoming slide in transition.\r\n\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel.pointer-event {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  @include clearfix();\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  float: left;\r\n  width: 100%;\r\n  margin-right: -100%;\r\n  backface-visibility: hidden;\r\n  @include transition($carousel-transition);\r\n}\r\n\r\n.carousel-item.active,\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  display: block;\r\n}\r\n\r\n/* rtl:begin:ignore */\r\n.carousel-item-next:not(.carousel-item-start),\r\n.active.carousel-item-end {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.carousel-item-prev:not(.carousel-item-end),\r\n.active.carousel-item-start {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n/* rtl:end:ignore */\r\n\r\n\r\n//\r\n// Alternate transitions\r\n//\r\n\r\n.carousel-fade {\r\n  .carousel-item {\r\n    opacity: 0;\r\n    transition-property: opacity;\r\n    transform: none;\r\n  }\r\n\r\n  .carousel-item.active,\r\n  .carousel-item-next.carousel-item-start,\r\n  .carousel-item-prev.carousel-item-end {\r\n    z-index: 1;\r\n    opacity: 1;\r\n  }\r\n\r\n  .active.carousel-item-start,\r\n  .active.carousel-item-end {\r\n    z-index: 0;\r\n    opacity: 0;\r\n    @include transition(opacity 0s $carousel-transition-duration);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Left/right controls for nav\r\n//\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  // Use flex for alignment (1-3)\r\n  display: flex; // 1. allow flex styles\r\n  align-items: center; // 2. vertically center contents\r\n  justify-content: center; // 3. horizontally center contents\r\n  width: $carousel-control-width;\r\n  padding: 0;\r\n  color: $carousel-control-color;\r\n  text-align: center;\r\n  background: none;\r\n  border: 0;\r\n  opacity: $carousel-control-opacity;\r\n  @include transition($carousel-control-transition);\r\n\r\n  // Hover/focus state\r\n  &:hover,\r\n  &:focus {\r\n    color: $carousel-control-color;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    opacity: $carousel-control-hover-opacity;\r\n  }\r\n}\r\n.carousel-control-prev {\r\n  left: 0;\r\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\r\n}\r\n.carousel-control-next {\r\n  right: 0;\r\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\r\n}\r\n\r\n// Icons for within\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: $carousel-control-icon-width;\r\n  height: $carousel-control-icon-width;\r\n  background-repeat: no-repeat;\r\n  background-position: 50%;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n/* rtl:options: {\r\n  \"autoRename\": true,\r\n  \"stringMap\":[ {\r\n    \"name\"    : \"prev-next\",\r\n    \"search\"  : \"prev\",\r\n    \"replace\" : \"next\"\r\n  } ]\r\n} */\r\n.carousel-control-prev-icon {\r\n  background-image: escape-svg($carousel-control-prev-icon-bg);\r\n}\r\n.carousel-control-next-icon {\r\n  background-image: escape-svg($carousel-control-next-icon-bg);\r\n}\r\n\r\n// Optional indicator pips/controls\r\n//\r\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\r\n// like a button) with data-bs-target for each slide your carousel holds.\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 2;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 0;\r\n  // Use the .carousel-control's width as margin so we don't overlay those\r\n  margin-right: $carousel-control-width;\r\n  margin-bottom: 1rem;\r\n  margin-left: $carousel-control-width;\r\n  list-style: none;\r\n\r\n  [data-bs-target] {\r\n    box-sizing: content-box;\r\n    flex: 0 1 auto;\r\n    width: $carousel-indicator-width;\r\n    height: $carousel-indicator-height;\r\n    padding: 0;\r\n    margin-right: $carousel-indicator-spacer;\r\n    margin-left: $carousel-indicator-spacer;\r\n    text-indent: -999px;\r\n    cursor: pointer;\r\n    background-color: $carousel-indicator-active-bg;\r\n    background-clip: padding-box;\r\n    border: 0;\r\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\r\n    border-top: $carousel-indicator-hit-area-height solid transparent;\r\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\r\n    opacity: $carousel-indicator-opacity;\r\n    @include transition($carousel-indicator-transition);\r\n  }\r\n\r\n  .active {\r\n    opacity: $carousel-indicator-active-opacity;\r\n  }\r\n}\r\n\r\n\r\n// Optional captions\r\n//\r\n//\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: (100% - $carousel-caption-width) * .5;\r\n  bottom: $carousel-caption-spacer;\r\n  left: (100% - $carousel-caption-width) * .5;\r\n  padding-top: $carousel-caption-padding-y;\r\n  padding-bottom: $carousel-caption-padding-y;\r\n  color: $carousel-caption-color;\r\n  text-align: center;\r\n}\r\n\r\n// Dark mode carousel\r\n\r\n.carousel-dark {\r\n  .carousel-control-prev-icon,\r\n  .carousel-control-next-icon {\r\n    filter: $carousel-dark-control-icon-filter;\r\n  }\r\n\r\n  .carousel-indicators [data-bs-target] {\r\n    background-color: $carousel-dark-indicator-active-bg;\r\n  }\r\n\r\n  .carousel-caption {\r\n    color: $carousel-dark-caption-color;\r\n  }\r\n}\r\n","// scss-docs-start clearfix\r\n@mixin clearfix() {\r\n  &::after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\";\r\n  }\r\n}\r\n// scss-docs-end clearfix\r\n","//\r\n// Rotating border\r\n//\r\n\r\n// scss-docs-start spinner-border-keyframes\r\n@keyframes spinner-border {\r\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\r\n}\r\n// scss-docs-end spinner-border-keyframes\r\n\r\n.spinner-border {\r\n  display: inline-block;\r\n  width: $spinner-width;\r\n  height: $spinner-height;\r\n  vertical-align: $spinner-vertical-align;\r\n  border: $spinner-border-width solid currentColor;\r\n  border-right-color: transparent;\r\n  // stylelint-disable-next-line property-disallowed-list\r\n  border-radius: 50%;\r\n  animation: $spinner-animation-speed linear infinite spinner-border;\r\n}\r\n\r\n.spinner-border-sm {\r\n  width: $spinner-width-sm;\r\n  height: $spinner-height-sm;\r\n  border-width: $spinner-border-width-sm;\r\n}\r\n\r\n//\r\n// Growing circle\r\n//\r\n\r\n// scss-docs-start spinner-grow-keyframes\r\n@keyframes spinner-grow {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n// scss-docs-end spinner-grow-keyframes\r\n\r\n.spinner-grow {\r\n  display: inline-block;\r\n  width: $spinner-width;\r\n  height: $spinner-height;\r\n  vertical-align: $spinner-vertical-align;\r\n  background-color: currentColor;\r\n  // stylelint-disable-next-line property-disallowed-list\r\n  border-radius: 50%;\r\n  opacity: 0;\r\n  animation: $spinner-animation-speed linear infinite spinner-grow;\r\n}\r\n\r\n.spinner-grow-sm {\r\n  width: $spinner-width-sm;\r\n  height: $spinner-height-sm;\r\n}\r\n\r\n@if $enable-reduced-motion {\r\n  @media (prefers-reduced-motion: reduce) {\r\n    .spinner-border,\r\n    .spinner-grow {\r\n      animation-duration: $spinner-animation-speed * 2;\r\n    }\r\n  }\r\n}\r\n",".offcanvas {\r\n  position: fixed;\r\n  bottom: 0;\r\n  z-index: $zindex-offcanvas;\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 100%;\r\n  color: $offcanvas-color;\r\n  visibility: hidden;\r\n  background-color: $offcanvas-bg-color;\r\n  background-clip: padding-box;\r\n  outline: 0;\r\n  @include box-shadow($offcanvas-box-shadow);\r\n  @include transition(transform $offcanvas-transition-duration ease-in-out);\r\n}\r\n\r\n.offcanvas-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\r\n\r\n  .btn-close {\r\n    padding: ($offcanvas-padding-y * .5) ($offcanvas-padding-x * .5);\r\n    margin-top: $offcanvas-padding-y * -.5;\r\n    margin-right: $offcanvas-padding-x * -.5;\r\n    margin-bottom: $offcanvas-padding-y * -.5;\r\n  }\r\n}\r\n\r\n.offcanvas-title {\r\n  margin-bottom: 0;\r\n  line-height: $offcanvas-title-line-height;\r\n}\r\n\r\n.offcanvas-body {\r\n  flex-grow: 1;\r\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\r\n  overflow-y: auto;\r\n}\r\n\r\n.offcanvas-start {\r\n  top: 0;\r\n  left: 0;\r\n  width: $offcanvas-horizontal-width;\r\n  border-right: $offcanvas-border-width solid $offcanvas-border-color;\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.offcanvas-end {\r\n  top: 0;\r\n  right: 0;\r\n  width: $offcanvas-horizontal-width;\r\n  border-left: $offcanvas-border-width solid $offcanvas-border-color;\r\n  transform: translateX(100%);\r\n}\r\n\r\n.offcanvas-top {\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  height: $offcanvas-vertical-height;\r\n  max-height: 100%;\r\n  border-bottom: $offcanvas-border-width solid $offcanvas-border-color;\r\n  transform: translateY(-100%);\r\n}\r\n\r\n.offcanvas-bottom {\r\n  right: 0;\r\n  left: 0;\r\n  height: $offcanvas-vertical-height;\r\n  max-height: 100%;\r\n  border-top: $offcanvas-border-width solid $offcanvas-border-color;\r\n  transform: translateY(100%);\r\n}\r\n\r\n.offcanvas.show {\r\n  transform: none;\r\n}\r\n","$gray-200: #e9ecef !default;\r\n$jumbotron-padding:                 2rem !default;\r\n$jumbotron-bg:                      $gray-200 !default;\r\n\r\n.jumbotron {\r\n  padding: $jumbotron-padding ($jumbotron-padding * 0.5);\r\n  margin-bottom: $jumbotron-padding;\r\n  background-color: $jumbotron-bg;\r\n  @include border-radius($border-radius-lg);\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\r\n  }\r\n}\r\n\r\n.jumbotron-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n  @include border-radius(0);\r\n}\r\n","@each $color, $value in $theme-colors {\r\n  .link-#{$color} {\r\n    color: $value;\r\n\r\n    @if $link-shade-percentage != 0 {\r\n      &:hover,\r\n      &:focus {\r\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Credit: Nicolas Gallagher and SUIT CSS.\r\n\r\n.ratio {\r\n  position: relative;\r\n  width: 100%;\r\n\r\n  &::before {\r\n    display: block;\r\n    padding-top: var(--#{$variable-prefix}aspect-ratio);\r\n    content: \"\";\r\n  }\r\n\r\n  > * {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n@each $key, $ratio in $aspect-ratios {\r\n  .ratio-#{$key} {\r\n    --#{$variable-prefix}aspect-ratio: #{$ratio};\r\n  }\r\n}\r\n","// Shorthand\r\n\r\n.fixed-top {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.fixed-bottom {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n// Responsive sticky top\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .sticky#{$infix}-top {\r\n      position: sticky;\r\n      top: 0;\r\n      z-index: $zindex-sticky;\r\n    }\r\n  }\r\n}\r\n","//\r\n// Visually hidden\r\n//\r\n\r\n.visually-hidden,\r\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\r\n  @include visually-hidden();\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Hide content visually while keeping it accessible to assistive technologies\r\n//\r\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\r\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\r\n\r\n@mixin visually-hidden() {\r\n  position: absolute !important;\r\n  width: 1px !important;\r\n  height: 1px !important;\r\n  padding: 0 !important;\r\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\r\n  overflow: hidden !important;\r\n  clip: rect(0, 0, 0, 0) !important;\r\n  white-space: nowrap !important;\r\n  border: 0 !important;\r\n}\r\n\r\n// Use to only display content when it's focused, or one of its child elements is focused\r\n// (i.e. when focus is within the element/container that the class was applied to)\r\n//\r\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\r\n\r\n@mixin visually-hidden-focusable() {\r\n  &:not(:focus):not(:focus-within) {\r\n    @include visually-hidden();\r\n  }\r\n}\r\n","//\r\n// Stretched link\r\n//\r\n\r\n.stretched-link {\r\n  &::#{$stretched-link-pseudo-element} {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: $stretched-link-z-index;\r\n    content: \"\";\r\n  }\r\n}\r\n","//\r\n// Text truncation\r\n//\r\n\r\n.text-truncate {\r\n  @include text-truncate();\r\n}\r\n","// Text truncate\r\n// Requires inline-block or block for proper styling\r\n\r\n@mixin text-truncate() {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n","// Utility generator\r\n// Used to generate utilities & print utilities\r\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\r\n  $values: map-get($utility, values);\r\n\r\n  // If the values are a list or string, convert it into a map\r\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\r\n    $values: zip($values, $values);\r\n  }\r\n\r\n  @each $key, $value in $values {\r\n    $properties: map-get($utility, property);\r\n\r\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\r\n    @if type-of($properties) == \"string\" {\r\n      $properties: append((), $properties);\r\n    }\r\n\r\n    // Use custom class if present\r\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\r\n    $property-class: if($property-class == null, \"\", $property-class);\r\n\r\n    // State params to generate pseudo-classes\r\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\r\n\r\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\r\n\r\n    // Don't prefix if value key is null (eg. with shadow class)\r\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\r\n\r\n    @if map-get($utility, rfs) {\r\n      // Inside the media query\r\n      @if $is-rfs-media-query {\r\n        $val: rfs-value($value);\r\n\r\n        // Do not render anything if fluid and non fluid values are the same\r\n        $value: if($val == rfs-fluid-value($value), null, $val);\r\n      }\r\n      @else {\r\n        $value: rfs-fluid-value($value);\r\n      }\r\n    }\r\n\r\n    $is-rtl: map-get($utility, rtl);\r\n\r\n    @if $value != null {\r\n      @if $is-rtl == false {\r\n        /* rtl:begin:remove */\r\n      }\r\n      .#{$property-class + $infix + $property-class-modifier} {\r\n        @each $property in $properties {\r\n          #{$property}: $value if($enable-important-utilities, !important, null);\r\n        }\r\n      }\r\n\r\n      @each $pseudo in $state {\r\n        .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\r\n          @each $property in $properties {\r\n            #{$property}: $value if($enable-important-utilities, !important, null);\r\n          }\r\n        }\r\n      }\r\n      @if $is-rtl == false {\r\n        /* rtl:end:remove */\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Loop over each breakpoint\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n\r\n  // Generate media query if needed\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    // Loop over each utility property\r\n    @each $key, $utility in $utilities {\r\n      // The utility can be disabled with `false`, thus check if the utility is a map first\r\n      // Only proceed if responsive media queries are enabled or if it's the base media query\r\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\r\n        @include generate-utility($utility, $infix);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// RFS rescaling\r\n@media (min-width: $rfs-mq-value) {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\r\n      // Loop over each utility property\r\n      @each $key, $utility in $utilities {\r\n        // The utility can be disabled with `false`, thus check if the utility is a map first\r\n        // Only proceed if responsive media queries are enabled or if it's the base media query\r\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\r\n          @include generate-utility($utility, $infix, true);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Print utilities\r\n@media print {\r\n  @each $key, $utility in $utilities {\r\n    // The utility can be disabled with `false`, thus check if the utility is a map first\r\n    // Then check if the utility needs print styles\r\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\r\n      @include generate-utility($utility, \"-print\");\r\n    }\r\n  }\r\n}\r\n","// General\r\n\r\na,\r\nbutton,\r\n.btn {\r\n  outline: none !important;\r\n}\r\n\r\n.app-container {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  flex-direction: column;\r\n  margin: 0;\r\n}","// Sidebar Animation\r\n\r\n.SidebarAnimation-appear {\r\n  transform: translateX(-30px);\r\n  opacity: 0;\r\n\r\n  &.SidebarAnimation-appear-active {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n    transition: all .4s linear;\r\n  }\r\n}\r\n\r\n// Tabs Animation\r\n\r\n.TabsAnimation-appear {\r\n  @extend .animated;\r\n  @extend .fadeInUp;\r\n}\r\n\r\n// Header Animation\r\n\r\n.HeaderAnimation-appear {\r\n  transform: translateY(-30px);\r\n  opacity: 0;\r\n\r\n  &.HeaderAnimation-appear-active {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition: all .4s linear;\r\n  }\r\n}\r\n\r\n// Main Animation\r\n\r\n.MainAnimation-appear {\r\n  transform: translateY(-30px);\r\n  opacity: 0;\r\n\r\n  &.MainAnimation-appear-active {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition: all .4s linear;\r\n  }\r\n}","// Header Base\r\n\r\n.app-header {\r\n  height: $app-header-height;\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  position: relative;\r\n  z-index: 10;\r\n  transition: all .2s;\r\n\r\n  &.header-shadow {\r\n    box-shadow: $box-shadow-default;\r\n  }\r\n\r\n  .app-header__content {\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n    flex: 1;\r\n    padding: 0 $layout-spacer-x;\r\n    height: $app-header-height;\r\n\r\n    .app-header-left {\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n\r\n    .app-header-right {\r\n      align-items: center;\r\n      display: flex;\r\n      margin-left: auto;\r\n    }\r\n  }\r\n\r\n  .header-user-info {\r\n    & > .widget-heading,\r\n    & > .widget-subheading {\r\n      white-space: nowrap;\r\n    }\r\n\r\n    & > .widget-subheading {\r\n      font-size: $font-size-xs;\r\n    }\r\n  }\r\n}\r\n\r\n.app-header__logo {\r\n  padding: 0 $layout-spacer-x;\r\n  height: $app-header-height;\r\n  width: $app-sidebar-width;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: width .2s;\r\n\r\n  .logo-src {\r\n    height: $logo-height;\r\n    width: $logo-width;\r\n    background: url('../../../assets/utils/images/logo-inverse.png');\r\n  }\r\n}\r\n\r\n.app-header__menu,\r\n.app-header__mobile-menu {\r\n  display: none;\r\n  padding: 0 $layout-spacer-x;\r\n  height: $app-header-height;\r\n  align-items: center;\r\n}\r\n\r\n// Header Modifiers\r\n\r\n@import \"modifiers/fixed-header\";\r\n@import \"modifiers/header-dots\";\r\n@import \"modifiers/header-megamenu\";\r\n@import \"modifiers/header-buttons\";\r\n//@import \"modifiers/header-horizontal\";\r\n\r\n// Header Themes\r\n\r\n@import \"themes/header-light\";\r\n@import \"themes/header-dark\";\r\n//@import \"themes/header-inverted\";","// Variables\r\n\r\n$spacer-lg: 3rem;\r\n$spacer-sm: 1.5rem;\r\n\r\n$layout-spacer-lg: 3rem;\r\n$layout-spacer-x: 1.5rem;\r\n\r\n$app-sidebar-width: 280px;\r\n$app-sidebar-width-collapsed: 80px;\r\n\r\n$logo-height: 23px;\r\n$logo-width: 97px;\r\n\r\n$app-header-height: 60px;\r\n","// Fixed Header\r\n\r\n.fixed-header {\r\n  .app-header {\r\n    position: fixed;\r\n    width: 100%;\r\n    top: 0;\r\n\r\n    .app-header__logo {\r\n      visibility: visible;\r\n    }\r\n  }\r\n\r\n  .app-main {\r\n    padding-top: $app-header-height;\r\n  }\r\n\r\n  &:not(.fixed-sidebar):not(.closed-sidebar) {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        visibility: hidden;\r\n      }\r\n    }\r\n  }\r\n}","// Header Dots\r\n\r\n.header-dots {\r\n  margin-left: auto;\r\n  display: flex;\r\n\r\n  & > .dropdown {\r\n    display: flex;\r\n    align-content: center;\r\n  }\r\n\r\n  .icon-wrapper-alt {\r\n    margin: 0;\r\n    height: 44px;\r\n    width: 44px;\r\n    text-align: center;\r\n    overflow: visible;\r\n\r\n    .language-icon {\r\n      @include border-radius(30px);\r\n      position: relative;\r\n      z-index: 4;\r\n      width: 28px;\r\n      height: 28px;\r\n      overflow: hidden;\r\n      margin: 0 auto;\r\n\r\n      img {\r\n        position: relative;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin: -22px 0 0 -20px;\r\n      }\r\n\r\n    }\r\n\r\n    .icon-wrapper-bg {\r\n      opacity: .1;\r\n      transition: opacity .2s;\r\n      @include border-radius(40px);\r\n    }\r\n\r\n    svg {\r\n      margin: 0 auto;\r\n    }\r\n\r\n    @-moz-document url-prefix() {\r\n      svg {\r\n        width: 50%;\r\n      }\r\n    }\r\n\r\n    i {\r\n      font-size: 1.3rem;\r\n    }\r\n\r\n    &:hover {\r\n      cursor: pointer;\r\n\r\n      .icon-wrapper-bg {\r\n        opacity: .2;\r\n      }\r\n    }\r\n\r\n    .badge-dot {\r\n      top: 1px;\r\n      right: 1px;\r\n      border: 0;\r\n    }\r\n  }\r\n}","// Header Mega Menu\r\n\r\n@use \"sass:math\";\r\n\r\n.header-megamenu {\r\n  &.nav {\r\n    & > li > .nav-link {\r\n      color: $gray-600;\r\n      padding-left: math.div($nav-link-padding-x, 1.5);\r\n      padding-right: math.div($nav-link-padding-x, 1.5);\r\n\r\n      .rounded-pill {\r\n        padding: 5px 7px;\r\n      }\r\n\r\n      &:hover {\r\n        color: $gray-800;\r\n      }\r\n\r\n      svg {\r\n        margin-top: 1px;\r\n      }\r\n    }\r\n  }\r\n}","\r\n// Header Buttons\r\n\r\n.header-btn-lg {\r\n  padding: 0 0 0 ($layout-spacer-x);\r\n  margin-left: ($layout-spacer-x);\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n\r\n  /*&::before {\r\n    position: absolute;\r\n    left: -1px;\r\n    top: 50%;\r\n    background: $border-color;\r\n    width: 1px;\r\n    height: 30px;\r\n    margin-top: -15px;\r\n    content: '';\r\n  }*/\r\n\r\n  .hamburger-inner,\r\n  .hamburger-inner::before,\r\n  .hamburger-inner::after {\r\n    background: $gray-600;\r\n  }\r\n\r\n}","// Header Light\r\n\r\n.app-header {\r\n  &.header-text-light {\r\n    .app-header-left > .nav > li > .nav-link {\r\n      color: rgba(255, 255, 255, .7);\r\n\r\n      .nav-link-icon {\r\n        color: rgba(255, 255, 255, .8);\r\n      }\r\n\r\n      &:hover {\r\n        color: rgba(255, 255, 255, 1);\r\n      }\r\n    }\r\n\r\n    .app-header-right {\r\n      .icon-wrapper-alt {\r\n\r\n        svg {\r\n          fill: rgba(255, 255, 255, .7);\r\n          transition: all .2s;\r\n        }\r\n\r\n        .icon-wrapper-bg {\r\n          background: rgba(255, 255, 255, .1) !important;\r\n          transition: all .2s;\r\n          opacity: 1;\r\n        }\r\n\r\n        &:hover {\r\n          svg {\r\n            fill: rgba(255, 255, 255, .95);\r\n          }\r\n\r\n          .icon-wrapper-bg {\r\n            background: rgba(255, 255, 255, .15) !important;\r\n          }\r\n        }\r\n\r\n        .badge-dot {\r\n          border-color: transparent;\r\n        }\r\n      }\r\n\r\n      & > .header-btn-lg {\r\n\r\n        & .widget-content-left .btn-group > .btn-link,\r\n        .widget-heading,\r\n        .widget-subheading {\r\n          color: rgba(255, 255, 255, .8);\r\n        }\r\n\r\n        .header-user-info {\r\n          & > .btn-shadow {\r\n            box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, .1), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .search-wrapper {\r\n      .input-holder {\r\n        .search-icon {\r\n          background: rgba(0, 0, 0, .1);\r\n        }\r\n\r\n        .search-input {\r\n          &::placeholder,\r\n          &::-webkit-input-placeholder,\r\n          &:-ms-input-placeholder,\r\n          &:-moz-placeholder,\r\n          &::-moz-placeholder {\r\n            color: rgba(255, 255, 255, .5) !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        .input-holder {\r\n          background: rgba(255, 255, 255, .1);\r\n\r\n          .search-input {\r\n            color: rgba(255, 255, 255, .8);\r\n          }\r\n\r\n          .search-icon {\r\n            background: rgba(255, 255, 255, .1);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .header-btn-lg {\r\n      &::before {\r\n        background: rgba(255, 255, 255, .2);\r\n      }\r\n    }\r\n\r\n    .header-btn-lg,\r\n    .header__pane {\r\n      .hamburger-inner,\r\n      .hamburger.is-active .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(255, 255, 255, .8) !important;\r\n      }\r\n    }\r\n\r\n    .search-wrapper .input-holder .search-icon span::after {\r\n      border-color: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    .search-wrapper .close::before,\r\n    .search-wrapper .close::after,\r\n    .search-wrapper .input-holder .search-icon span::before {\r\n      background: rgba(255, 255, 255, .8);\r\n    }\r\n\r\n    .app-header__logo {\r\n      .logo-src {\r\n        background: url('../../../../assets/utils/images/logo.png');\r\n      }\r\n    }\r\n\r\n    .app-header__mobile-menu {\r\n      .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background: rgba(255, 255, 255, .9);\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n}","// Header Dark\r\n\r\n.app-header {\r\n  &.header-text-dark {\r\n    .app-header-left > .nav > li > .nav-link {\r\n      color: rgba(0,0,0,.7);\r\n\r\n      .nav-link-icon {\r\n        color: rgba(0, 0, 0, .8);\r\n      }\r\n\r\n      &:hover {\r\n        color: rgba(0,0,0,1);\r\n      }\r\n    }\r\n\r\n    .app-header-right {\r\n      .icon-wrapper-alt {\r\n\r\n        svg {\r\n          fill: rgba(0,0,0,.7);\r\n          transition: all .2s;\r\n        }\r\n\r\n        .icon-wrapper-bg {\r\n          background: rgba(0,0,0,.1) !important;\r\n          transition: all .2s;\r\n          opacity: 1;\r\n        }\r\n\r\n        &:hover {\r\n          svg {\r\n            fill: rgba(0,0,0,.95);\r\n          }\r\n\r\n          .icon-wrapper-bg {\r\n            background: rgba(0,0,0,.15) !important;\r\n          }\r\n        }\r\n\r\n        .badge-dot {\r\n          border-color: transparent;\r\n        }\r\n      }\r\n\r\n      .widget-content-left {\r\n\r\n        & > .btn-group > .btn-link,\r\n        .widget-heading,\r\n        .widget-subheading {\r\n          color: rgba(0,0,0,.8);\r\n        }\r\n      }\r\n    }\r\n\r\n    .search-wrapper {\r\n      .input-holder {\r\n        .search-icon {\r\n          background: rgba(0,0,0,.1);\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        .input-holder {\r\n          background: rgba(0,0,0,.1);\r\n\r\n          .search-input {\r\n            color: rgba(0,0,0,.8);\r\n          }\r\n\r\n          .search-icon {\r\n            background: rgba(0,0,0,.1);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .header-btn-lg {\r\n      &::before {\r\n        background: rgba(0,0,0,.2);\r\n      }\r\n    }\r\n\r\n    .header-btn-lg,\r\n    .header__pane {\r\n      .hamburger-inner,\r\n      .hamburger.is-active .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(0, 0, 0, .8) !important;\r\n      }\r\n    }\r\n\r\n    .search-wrapper .input-holder .search-icon span::after {\r\n      border-color: rgba(0, 0, 0, .8);\r\n    }\r\n\r\n    .search-wrapper .close::before,\r\n    .search-wrapper .close::after,\r\n    .search-wrapper .input-holder .search-icon span::before {\r\n      background: rgba(0, 0, 0, .8);\r\n    }\r\n\r\n    .app-header__logo {\r\n      .logo-src {\r\n        background: url('../../../../assets/utils/images/logo-inverse.png');\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n\r\n}","// Sidebar Base\r\n\r\n@use \"sass:math\";\r\n\r\n.app-sidebar {\r\n  width: $app-sidebar-width;\r\n  display: flex;\r\n  z-index: 11;\r\n  overflow: hidden;\r\n  min-width: $app-sidebar-width;\r\n  position: relative;\r\n  flex: 0 0 $app-sidebar-width;\r\n  margin-top: -$app-header-height;\r\n  padding-top: $app-header-height;\r\n  transition: all .2s;\r\n\r\n  .app-sidebar__inner {\r\n    padding: 2px ($layout-spacer-x) $layout-spacer-x;\r\n  }\r\n\r\n  .scrollbar-container {\r\n    z-index: 15;\r\n    width: 100%;\r\n  }\r\n\r\n  .app-sidebar-bg {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    opacity: 0.05;\r\n    background-size: cover;\r\n    z-index: 10;\r\n  }\r\n\r\n  .app-header__logo {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    display: none;\r\n    z-index: 11;\r\n  }\r\n\r\n  &.sidebar-shadow {\r\n    box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\r\n  }\r\n}\r\n\r\n.app-sidebar__heading {\r\n  text-transform: uppercase;\r\n  font-size: $font-size-xs;\r\n  margin: math.div($layout-spacer-x, 2) 0;\r\n  font-weight: bold;\r\n  color: $primary;\r\n  white-space: nowrap;\r\n  position: relative;\r\n}\r\n\r\n.sidebar-mobile-overlay {\r\n  display: none;\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #333;\r\n  opacity: .6;\r\n  left: 0;\r\n  top: 0;\r\n  z-index: 12;\r\n}\r\n\r\n// Sidebar Components\r\n\r\n@import \"modifiers/navmenu-vertical\";\r\n\r\n// Sidebar Modifiers\r\n\r\n@import \"themes/sidebar-light\";\r\n@import \"themes/sidebar-dark\";\r\n//@import \"themes/sidebar-inverted\";\r\n\r\n\r\n@import \"modifiers/fixed-sidebar\";\r\n@import \"modifiers/closed-sidebar\";\r\n","// Navigation Menu Vertical\r\n\r\n.vertical-nav-menu {\r\n  position: relative;\r\n\r\n  &::after {\r\n    content: \" \";\r\n    pointer-events: none;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .metismenu-container,\r\n  .metismenu-item {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative;\r\n  }\r\n  .metismenu-container {\r\n    list-style: none;\r\n\r\n    &:before {\r\n      opacity: 0;\r\n      transition: opacity 300ms;\r\n    }\r\n\r\n    .metismenu-link {\r\n      transition: transform .2s, height 300ms, color 300ms, background-color 300ms;\r\n      display: block;\r\n      line-height: 2.5rem;\r\n      height: 2.5rem;\r\n      padding: 0 $layout-spacer-x 0 45px;\r\n      position: relative;\r\n      @include border-radius($border-radius);\r\n      color: $gray-800;\r\n      white-space: nowrap;\r\n\r\n      &:hover {\r\n        background: $dropdown-link-hover-bg;\r\n        text-decoration: none;\r\n        //transform: scale(1.02);\r\n\r\n        i.metismenu-icon {\r\n          opacity: .6;\r\n        }\r\n\r\n        i.metismenu-state-icon {\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      &.active {\r\n        color: $primary;\r\n        background: $dropdown-link-hover-bg;\r\n      }\r\n\r\n      &.has-active-child,\r\n      &.active {\r\n        font-weight: bold;\r\n      }\r\n    }\r\n\r\n    i.metismenu-state-icon,\r\n    i.metismenu-icon {\r\n      text-align: center;\r\n      width: 34px;\r\n      height: 34px;\r\n      line-height: 34px;\r\n      position: absolute;\r\n      left: 5px;\r\n      top: 50%;\r\n      margin-top: -17px;\r\n      font-size: 1.5rem;\r\n      opacity: .3;\r\n      transition: color 300ms;\r\n    }\r\n\r\n    i.metismenu-state-icon {\r\n      transition: transform 300ms;\r\n      left: auto;\r\n      right: 0;\r\n\r\n      &.rotate-minus-90 {\r\n        transform: rotate(-180deg);\r\n      }\r\n    }\r\n\r\n    .metismenu-container {\r\n      transition: padding 300ms;\r\n\r\n      &.visible {\r\n        padding: .5em 0 0 2rem;\r\n\r\n        &:before {\r\n          content: '';\r\n          height: 100%;\r\n          opacity: 1;\r\n          width: 3px;\r\n          background: $dropdown-link-hover-bg;\r\n          position: absolute;\r\n          left: 20px;\r\n          top: 0;\r\n          @include border-radius(15px);\r\n        }\r\n\r\n        & > .metismenu-item > .metismenu-link {\r\n          height: 2.3em;\r\n          line-height: 2.3em;\r\n          color: $gray-600;\r\n          margin: 0 0 3px;\r\n\r\n          &:hover {\r\n            color: $primary;\r\n          }\r\n\r\n          .metismenu-icon {\r\n            display: none;\r\n          }\r\n\r\n          &.active {\r\n            color: $primary;\r\n            background: $dropdown-link-hover-bg;\r\n          }\r\n        }\r\n      }\r\n\r\n      .metismenu-item > .metismenu-link {\r\n        height: 0;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .metismenu-link {\r\n        padding-left: 1em;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Sidebar Light\r\n\r\n.app-sidebar {\r\n  &.sidebar-text-light {\r\n    border-right: 0 !important;\r\n\r\n    .app-sidebar__heading {\r\n      color: rgba(255, 255, 255, .6);\r\n\r\n      &::before {\r\n        background: rgba(255, 255, 255, 0.2) !important;\r\n      }\r\n    }\r\n\r\n    .metismenu {\r\n      .metismenu-container {\r\n        .metismenu-link {\r\n          color: rgba(255, 255, 255, .7);\r\n\r\n          &:hover {\r\n            color: rgba(255, 255, 255, 1);\r\n            background: rgba(255, 255, 255, .1);\r\n          }\r\n\r\n          &.active {\r\n            background: rgba(255, 255, 255, .1);\r\n          }\r\n        }\r\n\r\n        &.metismenu-container {\r\n          &.visible {\r\n            .metismenu-item > .metismenu-link {\r\n              color: rgba(255, 255, 255, .6);\r\n\r\n              &.active {\r\n                background: rgba(255, 255, 255, .1);\r\n                color: rgba(255, 255, 255, .8);\r\n              }\r\n\r\n              &:hover {\r\n                color: rgba(255, 255, 255, 1);\r\n              }\r\n\r\n            }\r\n\r\n            &::before {\r\n              background: rgba(255, 255, 255, .3);\r\n            }\r\n          }\r\n        }\r\n\r\n        i.metismenu-state-icon,\r\n        i.metismenu-icon {\r\n          opacity: .5;\r\n        }\r\n      }\r\n    }\r\n\r\n    .ps__thumb-y {\r\n      background: rgba(255, 255, 255, .3);\r\n    }\r\n\r\n    .ps__rail-y:hover {\r\n      .ps__thumb-y {\r\n        background: rgba(255, 255, 255, .2);\r\n      }\r\n    }\r\n\r\n    .app-header__logo {\r\n      .logo-src {\r\n        background: url('../../../../assets/utils/images/logo.png');\r\n      }\r\n\r\n      .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(255, 255, 255, .8);\r\n      }\r\n    }\r\n  }\r\n}","// Sidebar Light\r\n\r\n.app-sidebar {\r\n  &.sidebar-text-dark {\r\n    border-right: 0 !important;\r\n\r\n    .app-sidebar__heading {\r\n      color: rgba(0, 0, 0, .6);\r\n\r\n      &::before {\r\n        background: rgba(0, 0, 0, 0.5) !important;\r\n      }\r\n    }\r\n\r\n    .metismenu {\r\n      .metismenu-container {\r\n        .metismenu-link {\r\n          color: rgba(0, 0, 0, .7);\r\n\r\n          &:hover {\r\n            color: rgba(0, 0, 0, 1);\r\n            background: rgba(0, 0, 0, .1);\r\n          }\r\n\r\n          &.active {\r\n            background: rgba(0, 0, 0, .1);\r\n          }\r\n        }\r\n\r\n        &.metismenu-container {\r\n          &.visible {\r\n            .metismenu-item > .metismenu-link {\r\n              color: rgba(0, 0, 0, .6);\r\n\r\n              &.active {\r\n                background: rgba(0, 0, 0, .1);\r\n              }\r\n            }\r\n\r\n            &::before {\r\n              background: rgba(0, 0, 0, .3);\r\n            }\r\n          }\r\n\r\n          i.metismenu-state-icon,\r\n          i.metismenu-icon {\r\n            opacity: .5;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .ps__thumb-y {\r\n      background: rgba(0, 0, 0, .3);\r\n    }\r\n\r\n    .ps__rail-y:hover {\r\n      .ps__thumb-y {\r\n        background: rgba(0, 0, 0, .2);\r\n      }\r\n    }\r\n\r\n    .app-header__logo {\r\n\r\n      .hamburger-inner,\r\n      .hamburger-inner::before,\r\n      .hamburger-inner::after {\r\n        background-color: rgba(0, 0, 0, .8);\r\n      }\r\n    }\r\n  }\r\n}","// Fixed Sidebar\r\n\r\n.fixed-sidebar {\r\n  .app-sidebar {\r\n    position: fixed;\r\n    height: 100vh;\r\n  }\r\n\r\n  .app-main {\r\n\r\n    .app-main__outer {\r\n      z-index: 9;\r\n      padding-left: $app-sidebar-width;\r\n    }\r\n\r\n  }\r\n\r\n  &.fixed-header {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  &:not(.fixed-header) {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        display: flex;\r\n      }\r\n    }\r\n\r\n    .app-header {\r\n\r\n      margin-left: $app-sidebar-width;\r\n\r\n      .app-header__logo {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    .app-main {\r\n      //z-index: 12;\r\n    }\r\n  }\r\n\r\n  &.closed-sidebar {\r\n    &:not(.fixed-header) {\r\n\r\n      .app-header {\r\n        margin-left: $app-sidebar-width-collapsed;\r\n      }\r\n\r\n      .app-sidebar {\r\n\r\n        .app-header__logo {\r\n          width: $app-sidebar-width-collapsed;\r\n          padding: 0;\r\n\r\n          .logo-src {\r\n            display: none;\r\n          }\r\n\r\n          .header__pane {\r\n            margin-right: auto;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","// Closed Sidebar\r\n\r\n// Sidebar Menu Hover\r\n\r\n.closed-sidebar {\r\n  .app-sidebar {\r\n    transition: all .3s ease;\r\n    width: $app-sidebar-width-collapsed;\r\n    min-width: $app-sidebar-width-collapsed;\r\n    flex: 0 0 $app-sidebar-width-collapsed;\r\n    z-index: 13;\r\n\r\n    .app-sidebar__inner {\r\n\r\n      .app-sidebar__heading {\r\n        text-indent: -999em;\r\n\r\n        &::before {\r\n          content: '';\r\n          position: absolute;\r\n          top: 50%;\r\n          left: 0;\r\n          width: 100%;\r\n          height: 1px;\r\n          background: $dropdown-link-hover-bg;\r\n          text-indent: 1px;\r\n        }\r\n      }\r\n\r\n      .metismenu-link {\r\n        text-indent: -99rem;\r\n        padding: 0;\r\n      }\r\n\r\n      .metismenu-icon {\r\n        text-indent: 0;\r\n        left: 50%;\r\n        margin-left: -17px;\r\n      }\r\n\r\n      .metismenu-state-icon {\r\n        visibility: hidden;\r\n      }\r\n\r\n      .metismenu-container {\r\n        &.visible {\r\n          padding: 0;\r\n\r\n          & > .metismenu-item > .metismenu-link {\r\n            height: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      flex: 0 0 $app-sidebar-width !important;\r\n      width: $app-sidebar-width !important;\r\n\r\n      .app-sidebar__inner {\r\n\r\n        .app-sidebar__heading {\r\n          text-indent: initial;\r\n          &::before {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        .metismenu-link {\r\n          text-indent: initial;\r\n          padding: 0 $layout-spacer-x 0 45px;\r\n        }\r\n\r\n        .metismenu-icon {\r\n          text-indent: initial;\r\n          left: 5px;\r\n          margin-left: 0;\r\n        }\r\n\r\n        .metismenu-state-icon {\r\n          visibility: visible;\r\n        }\r\n\r\n        .metismenu-container {\r\n          &.visible {\r\n            padding: .5em 0 0 2rem;\r\n\r\n            & > .metismenu-item > .metismenu-link {\r\n              height: 2.3em;\r\n            }\r\n          }\r\n\r\n          .metismenu-container {\r\n            .metismenu-link {\r\n              padding-left: 1em;\r\n            }\r\n          }\r\n\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &:not(.sidebar-mobile-open) {\r\n\r\n    .app-sidebar {\r\n      .scrollbar-container {\r\n        position: static;\r\n        height: auto;\r\n        overflow: initial !important;\r\n      }\r\n\r\n      &:hover {\r\n        .scrollbar-container {\r\n          position: absolute;\r\n          height: 100%;\r\n          overflow: hidden !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &:not(.closed-sidebar-mobile) {\r\n    .app-header {\r\n      .app-header__logo {\r\n        width: $app-sidebar-width-collapsed;\r\n\r\n        .logo-src {\r\n          display: none;\r\n        }\r\n\r\n        .header__pane {\r\n          margin-right: auto;\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  &.fixed-sidebar {\r\n    .app-main__outer {\r\n      padding-left: $app-sidebar-width-collapsed;\r\n    }\r\n  }\r\n\r\n  &.fixed-header:not(.fixed-sidebar) {\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        visibility: hidden;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.closed-sidebar-mobile {\r\n    .app-sidebar,\r\n    .app-header {\r\n      .app-header__logo {\r\n        width: auto;\r\n        display: flex;\r\n\r\n        .header__pane {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .app-sidebar {\r\n      .app-header__logo {\r\n        display: flex;\r\n        width: $app-sidebar-width-collapsed;\r\n        padding: 0 $layout-spacer-x !important;\r\n\r\n        .logo-src {\r\n          display: block !important;\r\n          margin: 0 auto;\r\n          width: $logo-width - 76;\r\n        }\r\n\r\n        .header__pane {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        .app-header__logo {\r\n          width: $app-sidebar-width;\r\n\r\n          .logo-src {\r\n            width: $logo-width;\r\n            margin: 0;\r\n\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .app-header {\r\n      margin-left: 0 !important;\r\n    }\r\n  }\r\n\r\n  &.fixed-footer {\r\n    .app-footer__inner {\r\n      margin-left: 0 !important;\r\n    }\r\n  }\r\n}","// Main Base\r\n\r\n@use \"sass:math\";\r\n\r\n.app-main {\r\n  z-index: 8;\r\n  position: relative;\r\n  display: flex;\r\n\r\n  .app-main__outer {\r\n    flex: 1;\r\n    flex-direction: column;\r\n    display: flex;\r\n    z-index: 12;\r\n    width: 1px;\r\n  }\r\n\r\n  .app-main__inner {\r\n    padding: $grid-gutter-width $grid-gutter-width 0;\r\n    flex: 1;\r\n\r\n    & > .RRT__container {\r\n      & > .RRT__panel {\r\n        margin-top: $grid-gutter-width;\r\n      }\r\n\r\n      & > .body-tabs-layout {\r\n        .RRT__tab {\r\n          margin-top: (-(math.div($layout-spacer-x, 3)));\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Alternate Section Tabs\r\n\r\n.body-tabs-shadow-btn {\r\n  .app-main__inner {\r\n    & > .RRT__container {\r\n      & > .RRT__panel {\r\n        margin-top: math.div($grid-gutter-width, 1.5);\r\n      }\r\n\r\n      .body-tabs-layout {\r\n        border: 0;\r\n        background: transparent;\r\n        position: relative;\r\n        z-index: 7;\r\n\r\n        .RRT__showmore {\r\n          margin-top: -13px;\r\n        }\r\n\r\n        .RRT__tab {\r\n          margin-top: $nav-link-padding-y;\r\n        }\r\n\r\n        .RRT__tab--selected {\r\n          color: $white;\r\n        }\r\n\r\n        & + .RRT__inkbar-wrapper {\r\n          position: absolute;\r\n          top: ($nav-link-padding-y * 2.2);\r\n          z-index: 5;\r\n\r\n          .RRT__inkbar {\r\n            height: 35px;\r\n            margin-top: 0;\r\n            @include border-radius($border-radius);\r\n            box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\r\n              0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n              0 8px 10px -5px rgba($primary, 0.2);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Themes\r\n\r\n@import \"themes/main-white\";\r\n@import \"themes/main-gray\";\r\n//@import \"themes/main-inverted-blue\";\r\n//@import \"themes/main-inverted-black\";\r\n\r\n@media (min-width: 760px) {\r\n  .trade_icon {\r\n    position: absolute;\r\n    top: 60%;\r\n    left: 45%; /* Move to the center horizontally */\r\n    transform: translateX(-50%); /* Center the element based on its width */\r\n  }\r\n}\r\n\r\n.carousel .thumbs-wrapper {\r\n  margin: 0 !important;\r\n}\r\n.carousel .thumbs {\r\n  padding: 0 !important;\r\n}\r\n\r\n.carousel .thumb.selected,\r\n.carousel .thumb:hover {\r\n  border: none !important;\r\n}\r\n","// Theme White\r\n\r\n// Variables\r\n\r\n$app-container-bg: #eaedef;\r\n$app-sidebar-bg: #ffffff;\r\n$app-header-bg: #fafbfc;\r\n$app-header-logo-bg: rgba(255, 255, 255, 0.9);\r\n\r\n// Content\r\n\r\n.app-theme-white {\r\n  &.app-container {\r\n    background: $app-container-bg;\r\n  }\r\n\r\n  .app-sidebar {\r\n    background: $app-sidebar-bg;\r\n  }\r\n\r\n  .app-page-title {\r\n    // background: rgba(255, 255, 255, 0.55);\r\n  }\r\n\r\n  .app-footer .app-footer__inner,\r\n  .app-header {\r\n    background: $app-header-bg;\r\n  }\r\n\r\n  &.fixed-header {\r\n    .app-header__logo {\r\n      background: rgba($app-header-bg, 0.1);\r\n    }\r\n  }\r\n}\r\n","// Theme Gray\r\n\r\n// Variables\r\n\r\n$app-container-bg: #ffffff;\r\n$app-sidebar-bg: #ffffff;\r\n$app-header-bg: #f8f9fa;\r\n$app-header-logo-bg: rgba(0, 0, 0, .03);\r\n\r\n// Content\r\n\r\n.app-theme-gray {\r\n\r\n  &.app-container {\r\n    background: $app-container-bg;\r\n  }\r\n\r\n  .app-sidebar {\r\n    background: $app-sidebar-bg;\r\n    border-right: $gray-300 solid 1px;\r\n  }\r\n\r\n  .app-page-title {\r\n    background: rgba(0, 0, 0, .03);\r\n  }\r\n\r\n  .app-footer,\r\n  .app-header {\r\n    background: $app-header-bg;\r\n  }\r\n\r\n  .app-footer {\r\n    border-top: $gray-300 solid 1px;\r\n  }\r\n\r\n  .app-header {\r\n    .app-header__logo {\r\n      border-right: rgba(0, 0, 0, .1) solid 1px;\r\n    }\r\n  }\r\n\r\n  &.fixed-header {\r\n    .app-header__logo {\r\n      background: $app-header-logo-bg;\r\n    }\r\n  }\r\n\r\n  .card {\r\n    border-width: 1px;\r\n  }\r\n\r\n  .main-card {\r\n    box-shadow: 0 0 0 0 transparent !important;\r\n\r\n    & > .card-body {\r\n\r\n      & > .card-title {\r\n        text-transform: none;\r\n        font-size: $font-size-lg;\r\n        font-weight: normal;\r\n        border-bottom: $gray-300 solid 1px;\r\n        position: relative;\r\n        padding: 0 0 ($card-spacer-y * 1.5);\r\n        margin: 0 0 ($card-spacer-y * 1.5);\r\n\r\n        &::before {\r\n          position: absolute;\r\n          width: 40px;\r\n          background: $primary;\r\n          @include border-radius(30px);\r\n          height: 5px;\r\n          left: 0;\r\n          bottom: -2px;\r\n          content: \"\";\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__sidebar {\r\n    border-left: 0 !important;\r\n  }\r\n\r\n  \r\n\r\n}\r\n","// Footer base\r\n\r\n@use \"sass:math\";\r\n\r\n.app-footer {\r\n  height: $app-header-height;\r\n\r\n  .app-footer__inner {\r\n    padding: 0 $layout-spacer-x 0 math.div($layout-spacer-x, 2);\r\n    height: $app-header-height;\r\n    transition: all .2s;\r\n\r\n    display: flex;\r\n    align-content: center;\r\n    align-items: center;\r\n\r\n    .app-footer-left {\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n\r\n    .app-footer-right {\r\n      margin-left: auto;\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n\r\n// Footer Dots Section\r\n\r\n.footer-dots {\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n\r\n  .dots-separator {\r\n    height: 40px;\r\n    margin: 0 math.div($layout-spacer-x, 2.5);\r\n    width: 1px;\r\n    background: $gray-200;\r\n  }\r\n}\r\n\r\n.dot-btn-wrapper {\r\n  padding: .5rem;\r\n  position: relative;\r\n  display: flex;\r\n  opacity: .7;\r\n  transition: opacity .2s;\r\n\r\n  .badge-abs {\r\n    right: 50%;\r\n\r\n    &.badge-dot-sm {\r\n      top: -2px;\r\n      margin-right: -3px;\r\n    }\r\n  }\r\n\r\n  .dot-btn-icon {\r\n    font-size: 1.8rem;\r\n  }\r\n\r\n  &:hover {\r\n    text-decoration: none;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// Footer Modifiers\r\n\r\n@import \"fixed-footer\";\r\n","// Fixed Header\r\n\r\n.fixed-footer {\r\n  .app-footer {\r\n    position: fixed;\r\n    width: 100%;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 7;\r\n\r\n    .app-footer__inner {\r\n      margin-left: $app-sidebar-width;\r\n      box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(darken($primary, 50%), .02),\r\n      0.3rem -0.9375rem 1.40625rem rgba(darken($primary, 50%), .02),\r\n      0.3rem -0.25rem 0.53125rem rgba(darken($primary, 50%), .04),\r\n      0.3rem -0.125rem 0.1875rem rgba(darken($primary, 50%), .02);\r\n\r\n    }\r\n  }\r\n\r\n  .app-main .app-main__outer {\r\n    padding-bottom: $app-header-height;\r\n  }\r\n\r\n  &.closed-sidebar {\r\n    .app-footer {\r\n      .app-footer__inner {\r\n        margin-left: $app-sidebar-width-collapsed !important;\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n","// Page title\r\n\r\n@use \"sass:math\";\r\n\r\n.app-page-title {\r\n  padding: $grid-gutter-width;\r\n  margin: (-$grid-gutter-width) (-$grid-gutter-width) ($grid-gutter-width);\r\n  position: relative;\r\n\r\n  .page-title-wrapper {\r\n    width: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .page-title-heading,\r\n  .page-title-subheading {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .page-title-heading {\r\n    font-size: $h5-font-size;\r\n    font-weight: 400;\r\n    display: flex;\r\n    align-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .page-title-subheading {\r\n    padding: 3px 0 0;\r\n    font-size: $font-size-base;\r\n    opacity: 0.6;\r\n\r\n    .breadcrumb {\r\n      padding: 0;\r\n      margin: 3px 0 0;\r\n      background: transparent;\r\n    }\r\n  }\r\n\r\n  .page-title-actions {\r\n    margin-left: auto;\r\n\r\n    .breadcrumb {\r\n      margin: 0;\r\n      padding: 0;\r\n      background: transparent;\r\n    }\r\n  }\r\n\r\n  .page-title-icon {\r\n    font-size: 2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n    text-align: center;\r\n    padding: math.div($layout-spacer-x, 1.8);\r\n    margin: 0 ($grid-gutter-width) 0 0;\r\n    background: $white;\r\n    box-shadow: $box-shadow-default;\r\n    @include border-radius($border-radius);\r\n    width: 60px;\r\n    height: 60px;\r\n\r\n    i {\r\n      margin: auto;\r\n    }\r\n\r\n    &.rounded-circle {\r\n      margin: 0 math.div($grid-gutter-width, 1.5) 0 0;\r\n    }\r\n  }\r\n\r\n  & + .RRT__container {\r\n    margin-top: -(math.div($grid-gutter-width, 1.3));\r\n  }\r\n\r\n  & + .rc-tabs {\r\n    // to fix width issue in firefox\r\n    max-width: calc(100vw - 322px);\r\n    margin: (-($grid-gutter-width)) (-(math.div($grid-gutter-width, 2)))\r\n      (($grid-gutter-width * 1.3));\r\n  }\r\n  @media only screen and (max-width: 812px) and (min-width: 360px) {\r\n    & + .rc-tabs {\r\n      // to fix width issue in firefox\r\n      max-width: calc(100vw - 0px);\r\n      margin: (-($grid-gutter-width)) (-(math.div($grid-gutter-width, 2)))\r\n        (($grid-gutter-width * 1.3));\r\n    }\r\n  }\r\n\r\n  &.app-page-title-simple {\r\n    margin: 0;\r\n    background: none !important;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .page-title-right {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    gap: 15px;\r\n\r\n    span {\r\n      white-space: nowrap;\r\n      color: #212121;\r\n    }\r\n  }\r\n}\r\n\r\n.page-title-icon-rounded {\r\n  .page-title-icon {\r\n    @include border-radius(50px);\r\n  }\r\n}\r\n\r\n.closed-sidebar .rc-tabs {\r\n  max-width: calc(100vw - 140px);\r\n}\r\n@media only screen and (max-width: 812px) and (min-width: 360px) {\r\n  .closed-sidebar .rc-tabs {\r\n    max-width: calc(100vw - 0px);\r\n  }\r\n}\r\n\r\n// Body Tabs\r\n\r\n.body-tabs {\r\n  &.body-tabs-layout {\r\n    margin-left: -($grid-gutter-width);\r\n    margin-right: -($grid-gutter-width);\r\n    padding: 0 $grid-gutter-width;\r\n    border-top: 0;\r\n    border-bottom: $gray-300 solid 1px;\r\n  }\r\n}\r\n","// Search Box\r\n\r\n@use \"sass:math\";\r\n\r\n$search-box-size:     42px;\r\n\r\n.search-wrapper {\r\n  position: relative;\r\n  margin-right: math.div($nav-link-padding-x, 1.5);\r\n\r\n  .input-holder {\r\n    height: $search-box-size;\r\n    width: $search-box-size;\r\n    overflow: hidden;\r\n    position: relative;\r\n    transition: all 0.3s ease-in-out;\r\n\r\n    .search-input {\r\n      width: 100%;\r\n      padding: 0 70px 0 20px;\r\n      opacity: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      background: transparent;\r\n      box-sizing: border-box;\r\n      border: none;\r\n      outline: none;\r\n      transform: translate(0, 60px);\r\n      transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n      transition-delay: 0.3s;\r\n      font-size: $font-size-base;\r\n    }\r\n\r\n    .search-icon {\r\n      width: $search-box-size;\r\n      height: $search-box-size;\r\n      border: none;\r\n      padding: 0;\r\n      outline: none;\r\n      position: relative;\r\n      z-index: 2;\r\n      float: right;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease-in-out;\r\n      background: rgba(0,0,0,.06);\r\n      @include border-radius(30px);\r\n\r\n      span {\r\n        width: 22px;\r\n        height: 22px;\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        position: relative;\r\n        transform: rotate(45deg);\r\n        transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);\r\n\r\n        &::before,\r\n        &::after {\r\n          position: absolute;\r\n          content: '';\r\n        }\r\n\r\n        &::before {\r\n          width: 4px;\r\n          height: 11px;\r\n          left: 9px;\r\n          top: 13px;\r\n          border-radius: 2px;\r\n          background: $primary;\r\n        }\r\n\r\n        &::after {\r\n          width: 14px;\r\n          height: 14px;\r\n          left: 4px;\r\n          top: 0;\r\n          border-radius: 16px;\r\n          border: 2px solid $primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .btn-close {\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 50%;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-top: -10px;\r\n    cursor: pointer;\r\n    opacity: 0 !important;\r\n    // transform: rotate(-180deg);\r\n    transition: all .2s cubic-bezier(0.285, -0.450, 0.935, 0.110);\r\n    transition-delay: 0.1s;\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      background: $primary;\r\n      border-radius: 2px;\r\n    }\r\n\r\n    &::before {\r\n      width: 2px;\r\n      height: 20px;\r\n      left: 9px;\r\n      top: 0;\r\n    }\r\n\r\n    &::after {\r\n      width: 20px;\r\n      height: 2px;\r\n      left: 0;\r\n      top: 9px;\r\n    }\r\n  }\r\n\r\n  &.active {\r\n    width: 330px;\r\n\r\n    .input-holder {\r\n      width: 290px;\r\n      border-radius: 50px;\r\n      background: rgba(0, 0, 0, 0.05);\r\n      transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n\r\n      .search-input {\r\n        opacity: 1;\r\n        transform: translate(0, 11px);\r\n      }\r\n\r\n      .search-icon {\r\n        width: $search-box-size;\r\n        height: $search-box-size;\r\n        margin: 0;\r\n        border-radius: 30px;\r\n\r\n        span {\r\n          transform: rotate(-45deg);\r\n        }\r\n      }\r\n    }\r\n\r\n    .btn-close {\r\n      left: 300px;\r\n      opacity: .6 !important;\r\n      // transform: rotate(45deg);\r\n      transition: all .6s cubic-bezier(0.000, 0.105, 0.035, 1.570);\r\n      transition-delay: 0.5s;\r\n\r\n      &:hover {\r\n        opacity: 1 !important;\r\n      }\r\n    }\r\n\r\n    & + .header-megamenu {\r\n      opacity: 0;\r\n    }\r\n\r\n  }\r\n}","// #########################\n// Reset\n// #########################\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n// input[type=\"date\"]::-webkit-calendar-picker-indicator {\n//   display: none;\n//   -webkit-appearance: none;\n// }\n","// #########################\n// Global\n// #########################\n\n.bg {\n  &-gray {\n    background: $white-gray-dark !important;\n  }\n\n  &-table {\n    &--green {\n      background: $table-green !important;\n    }\n\n    &--red {\n      background: $table-red !important;\n    }\n  }\n}\n\n.text {\n  &-success {\n    color: $dark-green !important;\n  }\n\n  &-primary {\n    color: $moderate-blue !important;\n  }\n\n  &-base {\n    @include font(13px, 19px);\n  }\n\n  &-muted {\n    color: $dark-gray-mid !important;\n  }\n\n  &-table {\n    &--green {\n      color: $table-green !important;\n    }\n\n    &--red {\n      color: $table-red !important;\n    }\n  }\n}\n\n.weight {\n  &-400 {\n    font-weight: 400 !important;\n  }\n\n  &-500 {\n    font-weight: 500 !important;\n  }\n\n  &-600 {\n    font-weight: 600 !important;\n  }\n\n  &-700 {\n    font-weight: 700 !important;\n  }\n}\n\n.alert {\n  border-radius: 0.25rem;\n  padding: 0.25rem 0.625rem;\n  border-style: solid;\n  border-width: 1px;\n  text-transform: uppercase;\n  @include font(11px, 13px, 700);\n  margin: 0;\n\n  &-orange {\n    background: $alert-orange-light;\n    border-color: $alert-orange;\n    color: $alert-orange;\n  }\n\n  &-red {\n    background: $alert-red-light;\n    border-color: $alert-red;\n    color: $alert-red;\n  }\n\n  &-green {\n    background: $alert-green-light;\n    border-color: $alert-green;\n    color: $alert-green;\n  }\n}\n\n.h-md-100p {\n  @include media-breakpoint-up(md) {\n    & {\n      height: 100% !important;\n    }\n  }\n}\n\n.p-3\\.5 {\n  padding: 20px !important;\n}\n\n.ps-\\.5 {\n  padding-left: 0px !important;\n}\n\n.pe-\\.5 {\n  padding-right: 20px !important;\n}\n\n.pt-\\.5 {\n  padding-top: 20px !important;\n}\n\n.pb-\\.5 {\n  padding-bottom: 20px !important;\n}\n\n.m-3\\.5 {\n  margin: 20px !important;\n}\n\n.ms-3\\.5 {\n  margin-left: 0px !important;\n}\n\n.me-3\\.5 {\n  margin-right: 20px !important;\n}\n\n.mt-3\\.5 {\n  margin-top: 20px !important;\n}\n\n.mb-3\\.5 {\n  margin-bottom: 20px !important;\n}\n\n.w-md-auto {\n  @include media-breakpoint-up(md) {\n    & {\n      width: auto !important;\n    }\n  }\n}\n\n.badge {\n  white-space: normal;\n}\n\n// Dashboard\n\n.app-title {\n  margin-bottom: 1.5rem;\n\n  @include media-breakpoint-down(md) {\n    & {\n      margin-bottom: 0.75rem;\n    }\n  }\n\n  .avatar {\n    width: 3rem;\n    height: 3rem;\n    box-shadow: 0 0.25rem 0.5rem rgba($color-black, 0.05);\n    border-radius: 0.25rem;\n    background: $color-white;\n    margin-right: 0.625rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    i {\n      font-size: 2rem;\n    }\n  }\n\n  span {\n    &:not(.avatar) {\n      @include font(0.813rem, 0.938rem, 400, $dark-gray-mid);\n    }\n  }\n\n  [type=\"date\"] {\n    background: $color-white;\n    border-color: $moderate-blue;\n    @include font(13px, 18px, 400, $dark-gray);\n    padding: 0.5rem 0.875rem;\n    background-color: $color-white;\n    background-image: url(../../images/icon__caret.svg),\n      url(../../images/icon__calendar.svg);\n    background-size: 12px 7px, 16px;\n    background-position: right 0.875rem center, 0.875rem center;\n    background-repeat: no-repeat;\n    border-color: $moderate-blue;\n    @include font(13px, 18px, 400, $dark-gray);\n    padding: 0.5rem 0.875rem;\n    padding-right: calc((0.875rem * 2) + 12px);\n    padding-left: calc((0.875rem * 2) + 16px);\n    border-radius: 0.25rem !important;\n    width: auto;\n\n    &::-webkit-calendar-picker-indicator {\n      background: transparent;\n      bottom: 0;\n      color: transparent;\n      cursor: pointer;\n      height: auto;\n      left: 0;\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: auto;\n    }\n  }\n\n  .btn {\n    &-outline-primary {\n      background: $color-white;\n      font-weight: 600;\n    }\n  }\n}\n\n.dashboard-card {\n  padding: 1.25rem;\n  background: $color-white;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.25rem 0.5rem rgba($color-black, 0.05);\n\n  & > header {\n    min-height: auto;\n    padding: 0;\n  }\n\n  &.card {\n    padding: 0;\n  }\n}\n\n.card {\n  box-shadow: 0 0.25rem 0.5rem rgba($color-black, 0.05) !important;\n  border-radius: 0.25rem !important;\n}\n","// #########################\n// Mixins\n// #########################\n\n@mixin font($fontSize, $lineHeight, $weight: 400, $color: inherit) {\n  font-size: $fontSize;\n  line-height: $lineHeight;\n  font-weight: $weight;\n  color: $color;\n}\n","// #########################\n// Variables\n// #########################\n\n$moderate-violet: #9953d6;\n$moderate-blue: #535bd6;\n$white-blue: #f3f4ff;\n$white-blue-two: #f1f2ff;\n\n$vivid-blue: #1188dd;\n$white-blue-two: #e7f5ff;\n$white-blue-three: #eeefff;\n$white-blue-four: #f5f6fd;\n\n$dark-gray-lighter: #eaedef;\n$dark-gray-light: #e4e6e8;\n$dark-gray-mid: #767676;\n$dark-gray: #212121;\n$white-gray: #f5f5f5;\n$white-gray-dark: #f9f9f9;\n$light-gray: #f6f6f6;\n$light-gray-two: #e6e6e6;\n\n$strong-red: #d8092e;\n$white-red: #fff1f1;\n\n$dark-green: #0e9451;\n$white-green: #e8faf2;\n\n$strong-pink: #d423a5;\n$light-pink: #ffd1d1;\n$dark-pink: #d35d5f;\n$white-pink: #fff0fb;\n\n$vivid-orange: #f7b924;\n$white-yellow: #fffce8;\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n$color-warning-text: #de9d00;\n\n// ### Table\n$table-border: #e6e6e6;\n$table-header: #f6f6f6;\n$table-header-text: #535bd6;\n$table-body-text: #212121;\n$table-red: #cd3a3d;\n$table-green: #229e60;\n\n$alert-orange: #f7b924;\n$alert-orange-light: #ffefc9;\n\n$alert-red: #fd1a41;\n$alert-red-light: #ffe2e7;\n\n$alert-green: #229e60;\n$alert-green-light: #229e600d;\n","// #########################\n// Typography\n// #########################\n\nbody {\n  font-family: \"Inter\", serif;\n  @include font(13px, 19px, 400, $dark-gray);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Inter\", serif;\n  font-weight: 600;\n}\n\nh3 {\n  @include font(19px, 25px, 500, $dark-gray);\n}\n\nh5 {\n  @include font(15px, 21px, 500, $dark-gray);\n}\n\nh6 {\n  @include font(13px, 19px, 500, $dark-gray);\n}\n","// #########################\n// Table\n// #########################\n\n.rdt {\n  &_Wrapper {\n    border: solid 1px $table-border;\n    border-radius: 6px !important;\n\n    .rdt {\n      &_TableHead {\n        background: $table-header;\n        @include font(13px, 15px, 400, $table-header-text);\n      }\n\n      &_TableHeadRow {\n        background: none;\n        min-height: auto;\n        border-bottom-color: $table-border;\n      }\n\n      &_TableCol {\n        padding: 10px 20px;\n\n        &_Sortable {\n          &:hover,\n          &:focus {\n            opacity: 1;\n\n            & * {\n              opacity: 1;\n            }\n          }\n        }\n      }\n\n      &_TableRow {\n        min-height: auto;\n        @include font(13px, 15px, 400, $table-body-text);\n      }\n\n      &_TableCell {\n        padding: 10px 20px;\n      }\n    }\n  }\n\n  &_Pagination {\n    border: none !important;\n    border-radius: 0 0 0.25rem 0.25rem !important;\n    background: none !important;\n    min-height: auto !important;\n  }\n\n  &_SubHeader {\n    width: 100%;\n    margin-bottom: 1rem;\n\n    @include media-breakpoint-up(xl) {\n      & {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .btn {\n      @include font(13px, 18px, 400, $color-white);\n      padding: 0.5rem 0.875rem;\n      border-radius: 0.25rem !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &-gray {\n        background: $dark-gray-lighter;\n        border-color: $dark-gray-lighter;\n        color: $dark-gray;\n\n        &:hover,\n        &:active {\n          background: $table-border;\n          border-color: $table-border;\n        }\n      }\n\n      &-icon {\n        position: relative;\n        padding-right: 3rem;\n\n        .icon {\n          position: absolute;\n          top: -1px;\n          bottom: -1px;\n          right: 0;\n\n          border-radius: 0 0.25rem 0.25rem 0 !important;\n          width: 2.25rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: $moderate-blue;\n\n          img {\n            height: 18px;\n            width: auto;\n          }\n        }\n      }\n\n      &-sort {\n        &:after {\n          content: \"\";\n          background-size: 100%;\n          margin-left: 0.5rem;\n          background: url(../../images/icon__caret.svg) no-repeat 0 0;\n          width: 12px;\n          height: 7px;\n        }\n      }\n\n      &-filter {\n        &:before {\n          content: \"\";\n          background-size: 100%;\n          margin-right: 0.5rem;\n          background: url(../../images/icon__filter.svg) no-repeat 0 0;\n          width: 16px;\n          height: 14px;\n        }\n      }\n    }\n\n    .custom-date-range-picker {\n      .date-picker-container {\n        .custom-datepicker {\n          background: $color-white;\n          border-color: $moderate-blue;\n          @include font(13px, 18px, 400, $dark-gray);\n          padding: 0.5rem 0.875rem;\n          border-radius: 0.25rem !important;\n\n          &::placeholder {\n            color: $dark-gray;\n            opacity: 1;\n          }\n\n          &:hover {\n            border-color: $moderate-blue;\n          }\n\n          @include media-breakpoint-down(md) {\n            & {\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n\n    // .react-datepicker__tab-loop {\n    //   position: relative;\n    //   z-index: 2;\n    // }\n\n    .form {\n      &-control {\n        background: $color-white;\n        border-color: $moderate-blue;\n        @include font(13px, 18px, 400, $dark-gray);\n        padding: 0.5rem 0.875rem;\n        border-radius: 0.25rem !important;\n\n        &::placeholder {\n          color: $dark-gray;\n          opacity: 1;\n        }\n\n        &:focus {\n          z-index: 1 !important;\n        }\n      }\n\n      &-search {\n        background: $color-white url(../../images/icon__search.svg) no-repeat\n          0.875rem center;\n        padding-left: 44px;\n\n        &-reset {\n          position: absolute;\n          right: 0.875rem;\n          top: 50%;\n          transform: translateY(-50%);\n          z-index: 1;\n        }\n      }\n\n      &-select {\n        background-color: $color-white;\n        background-image: url(../../images/icon__caret.svg);\n        background-position: right 0.875rem center;\n        background-size: 12px 7px;\n        border-color: $moderate-blue;\n        @include font(13px, 18px, 400, $dark-gray);\n        padding: 0.5rem 0.875rem;\n        padding-right: calc((0.875rem * 2) + 12px);\n        border-radius: 0.25rem !important;\n        width: auto;\n\n        &-period {\n          background-image: url(../../images/icon__caret.svg),\n            url(../../images/icon__calendar.svg);\n          background-size: 12px 7px, 16px;\n          background-position: right 0.875rem center, 0.875rem center;\n          padding-left: calc((0.875rem * 2) + 16px);\n        }\n      }\n    }\n  }\n}\n","// #########################\n// Buttons\n// #########################\n\n.btn {\n  &-lg {\n    padding: 0.75rem 2.25rem;\n  }\n}\n\n.button-group {\n  @include media-breakpoint-up(md) {\n    & {\n      display: flex;\n      align-items: center;\n\n      .btn {\n        & + .btn {\n          margin-left: 1rem;\n        }\n      }\n    }\n  }\n  @include media-breakpoint-down(md) {\n    & {\n      .btn {\n        width: 100%;\n        & + .btn {\n          margin-top: 0.5rem;\n        }\n      }\n    }\n  }\n}\n","// #########################\n// Form ELements\n// #########################\n\n.form {\n  &-control {\n    border-color: $light-gray-two;\n    color: $dark-gray;\n    outline: none !important;\n    box-shadow: none !important;\n\n    &::placeholder {\n      opacity: 1;\n      color: $dark-gray-mid;\n    }\n\n    &:disabled,\n    &[readonly] {\n      background: $light-gray;\n    }\n  }\n\n  &-select {\n    border-color: $light-gray-two;\n    @include font(13px, 19px, 400, $dark-gray-mid);\n\n    &-wrapper {\n      position: relative;\n\n      &:after {\n        content: \"\";\n        width: 12px;\n        height: 7px;\n        background: url(\"../../images/icon__caret.svg\") no-repeat 0 0;\n        position: absolute;\n        right: 16px;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n\n      .form-select {\n        -webkit-appearance: none;\n        appearance: none;\n        background-image: none;\n      }\n    }\n\n    &.lrg {\n      padding-top: 10px;\n      padding-bottom: 10px;\n    }\n  }\n\n  &-textarea {\n    height: 100px;\n    overflow: auto;\n    resize: none;\n  }\n}\n\n.dashboard-card {\n  & > header {\n    .form {\n    }\n  }\n}\n","// #########################\n// Dropdown\n// #########################\n\n// React Bootstrap Dropdown\n\n.dropdown {\n  .dropdown {\n    &-toggle {\n      &:after {\n        margin-left: 0.5rem;\n        background: url(../../images/icon__caret.svg) no-repeat 0 0;\n        background-size: 100%;\n        width: 12px;\n        height: 7px;\n        opacity: 1;\n        position: static;\n        border: none;\n      }\n\n      &:hover {\n        color: inherit;\n      }\n    }\n    &-menu {\n      min-width: 10rem;\n      background: $color-white;\n      border-radius: 0.25rem;\n      box-shadow: 0 0.25rem 0.5rem rgba($color-black, 0.05);\n      margin: 0;\n      padding: 0.5rem 0;\n\n      &:before,\n      &:after {\n        display: none;\n      }\n\n      .dropdown {\n        &-item {\n          @include font(13px, 19px, 400, $dark-gray);\n        }\n      }\n    }\n  }\n\n  &.show {\n    & > .dropdown-toggle {\n      box-shadow: none !important;\n\n      &.btn-gray {\n        background: $table-border;\n        border-color: $table-border;\n        color: $dark-gray;\n      }\n    }\n  }\n}\n",".admin-box {\n  h2 {\n    font-weight: 500;\n    font-size: 20px;\n    margin-bottom: 0;\n  }\n\n  p {\n    color: $dark-gray;\n  }\n\n  .btn {\n    border-radius: 5px;\n  }\n\n  .coinbox {\n    &-value {\n      font-size: 32px;\n      color: $moderate-blue;\n      line-height: 40px;\n      font-weight: 700;\n      margin-bottom: 10px;\n    }\n\n    p {\n      color: $dark-gray-mid;\n      margin-bottom: 0;\n    }\n  }\n\n  .wallet-box {\n    width: 100%;\n    background-color: $white;\n    padding: 20px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n    &-top {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      .btn-box {\n        display: flex;\n        flex-direction: row;\n        gap: 10px;\n        align-items: center;\n\n        .btn {\n        }\n      }\n    }\n\n    &-mid {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      padding-bottom: 5px;\n    }\n\n    &-bottom {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: center;\n      gap: 10px;\n      border-top: 1px solid $dark-gray-mid;\n      padding-top: 15px;\n\n      div {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n\n        p {\n          font-size: 15px;\n          margin-bottom: 0;\n\n          &:first-child {\n            color: $dark-gray-mid;\n          }\n        }\n      }\n    }\n  }\n\n  .summery-box {\n    width: 100%;\n    background-color: $white;\n    padding: 20px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n    &-list {\n      width: 100%;\n      display: grid;\n      grid: 100px / auto auto auto auto;\n      grid-gap: 20px;\n    }\n\n    &-card {\n      padding: 20px;\n      border-radius: 10px;\n\n      h2 {\n        font-size: 20px;\n        font-weight: 600;\n        margin-bottom: 10px;\n      }\n\n      p {\n        margin-bottom: 0;\n      }\n\n      &.blue-md {\n        background-color: $white-blue;\n        h2 {\n          color: $moderate-blue;\n        }\n      }\n      &.blue-vi {\n        background-color: $white-blue-two;\n        h2 {\n          color: $vivid-blue;\n        }\n      }\n      &.green {\n        background-color: $white-green;\n        h2 {\n          color: $dark-green;\n        }\n      }\n      &.orange {\n        background-color: $white-yellow;\n        h2 {\n          color: $vivid-orange;\n        }\n      }\n\n      &.red {\n        background-color: $white-red;\n        h2 {\n          color: $strong-red;\n        }\n      }\n      &.gray {\n        background-color: $white-gray;\n        h2 {\n          color: $dark-gray;\n        }\n      }\n      &.pink {\n        background-color: $white-pink;\n        h2 {\n          color: $strong-pink;\n        }\n      }\n\n      &.violet {\n        background-color: $white-blue;\n        h2 {\n          color: $moderate-violet;\n        }\n      }\n    }\n  }\n\n  .table-box {\n    width: 100%;\n    background-color: $white;\n    padding: 20px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 25px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n    &-top {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 10px;\n      justify-content: space-between;\n    }\n\n    &-topleft {\n      width: auto;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 10px;\n    }\n\n    &-topright {\n      width: auto;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 10px;\n    }\n\n    &-filter {\n    }\n\n    .saleamt {\n      background-color: $white-blue-three;\n      padding: 8px 15px;\n      border-radius: 5px;\n      p {\n        margin-bottom: 0;\n        color: $moderate-blue;\n        font-size: 13px;\n        font-weight: 600;\n      }\n    }\n\n    .filtericon {\n      background-color: $moderate-blue;\n      color: $white;\n      border-radius: 5px;\n      padding: 5px;\n    }\n\n    .datainfo {\n      width: 100%;\n      display: grid;\n      grid: 20px / auto auto auto auto;\n      grid-gap: 10px;\n\n      &-list {\n        display: flex;\n        flex-direction: row;\n        gap: 5px;\n        align-items: center;\n        justify-content: flex-start;\n\n        span {\n          width: 8px;\n          height: 8px;\n          border-radius: 100%;\n        }\n\n        &.tt {\n          span {\n            background-color: $moderate-blue;\n          }\n        }\n        &.ctu {\n          span {\n            background-color: $vivid-blue;\n          }\n        }\n        &.ts {\n          span {\n            background-color: $dark-green;\n          }\n        }\n\n        &.trd {\n          span {\n            background-color: $vivid-orange;\n          }\n        }\n        &.bpa {\n          span {\n            background-color: $strong-red;\n          }\n        }\n        &.te {\n          span {\n            background-color: $dark-gray;\n          }\n        }\n        &.tr {\n          span {\n            background-color: $strong-pink;\n          }\n        }\n        &.tri {\n          span {\n            background-color: $moderate-violet;\n          }\n        }\n      }\n\n      p {\n        margin-bottom: 0;\n        font-size: 13px;\n        line-height: 14px;\n      }\n    }\n\n    &-bottom {\n      width: 100%;\n\n      .table {\n        margin-bottom: 0;\n\n        thead {\n          tr {\n            background-color: $light-gray;\n\n            th {\n              color: $moderate-blue;\n              font-weight: 500 !important;\n              border-bottom: 1px solid $light-gray-two;\n              padding: 10px;\n            }\n          }\n        }\n\n        tbody {\n          tr {\n            td {\n              padding: 0 10px;\n              .graphimg {\n              }\n            }\n            &:last-child {\n              td {\n                border-bottom: 0px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .tableinner {\n    overflow: hidden;\n    border-radius: 5px;\n    border: 1px solid $light-gray-two;\n  }\n}\n.paypal{\n  /* Rectangle 118 */\nwidth: 124.92px;\nheight: 62px;\nbackground: #FAEACC;\nborder-radius: 8px;\n\n}","  // #########################\n  // Admin :: Dispute Page\n  // #########################\n\n  @use \"sass:math\";\n\n  $shadow: 0 0.25rem 0.25rem rgba(#c5c5c5, 0.2);\n  $shadow-hover: 0 0.25rem 0.25rem rgba(#c5c5c5, 0.6);\n\n  .dispute {\n    color: $dark-gray;\n    @include font(13px, 19px, 400, $dark-gray);\n\n    // Components\n\n    &__body {\n      box-shadow: 0 0.25rem 0.5rem rgba($color-black, 0.05);\n      border-radius: 0.25rem;\n      background: $color-white;\n\n      hr {\n        color: $color-black;\n        background-color: $color-black;\n        opacity: 0.05;\n        margin: 1.5rem 0;\n      }\n    }\n\n    &__info {\n      overflow: hidden;\n      color: $dark-gray;\n\n      &.buy-sell,\n      &.trade .bg-gray {\n        background: rgba($dark-gray-light, 0.2);\n      }\n\n      &.trade {\n        & > .row {\n          & > [class*=\"col-\"]:last-of-type {\n            border-left: solid 1px rgba($dark-gray-light, 0.4);\n          }\n        }\n\n        .block {\n          border: solid 1px rgba($dark-gray-light, 0.4);\n          border-radius: 6px;\n        }\n      }\n\n      span {\n        @include font(12px, 18px);\n        color: $dark-gray-mid;\n        margin-bottom: 0.25rem;\n        display: block;\n      }\n\n      .col-custom-5 {\n        @include media-breakpoint-up(md) {\n          & {\n            width: math.div(100%, 2);\n          }\n        }\n        @include media-breakpoint-up(lg) {\n          & {\n            width: math.div(100%, 3);\n          }\n        }\n        @include media-breakpoint-up(xl) {\n          & {\n            width: math.div(100%, 5);\n          }\n        }\n      }\n\n      .alert {\n        border-color: $color-warning-text;\n        @include font(10px, 14px, 700, $color-warning-text);\n        padding: 3px 6px;\n        margin: 0;\n        text-transform: uppercase;\n      }\n\n      .timeline {\n        & > div {\n          position: relative;\n          padding-left: 0.75rem;\n          margin-bottom: 1.5rem;\n\n          &:last-child {\n            @include media-breakpoint-down(md) {\n              & {\n                margin: 0;\n              }\n            }\n            &::before {\n              display: none;\n            }\n          }\n\n          &::before,\n          &:after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n          }\n\n          &:before {\n            width: 1px;\n            height: calc(100% + 1.5rem);\n            background: rgba($moderate-blue, 0.4);\n            left: 0;\n          }\n\n          &:after {\n            border: solid 1px $moderate-blue;\n            background: $color-white;\n            width: calc(0.5rem + 1px);\n            height: calc(0.5rem + 1px);\n            border-radius: 50%;\n            left: -0.25rem;\n          }\n\n          &.completed {\n            &:after {\n              background: $moderate-blue;\n            }\n          }\n        }\n      }\n    }\n\n    // Global\n\n    .form-select {\n      min-width: 16vw;\n    }\n\n    .buyer-seller-card {\n      border-radius: 6px;\n      @include font(12px, 18px);\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n\n      .counter {\n        input {\n          flex-grow: 1;\n          padding: 0 0.25rem;\n          background: none;\n          border: none;\n          text-align: center;\n          @include font(15px, 30px, 600);\n          max-width: 2.5rem;\n        }\n\n        .btn {\n          width: 30px;\n          height: 30px;\n          padding: 0;\n          border: none;\n          border-radius: 0.25rem;\n          background: $color-white;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          box-shadow: $shadow;\n\n          &:hover {\n            box-shadow: $shadow-hover;\n          }\n        }\n      }\n\n      .refund-buyer {\n        .block {\n          position: relative;\n\n          &:not(:first-child) {\n            margin-top: 10px;\n          }\n\n          .option {\n            background: $color-white;\n            border-radius: 6px;\n            border: solid 1px $color-white;\n            padding: 0.5rem 0.75rem;\n            box-shadow: $shadow;\n            transition: all 0.5s ease-in;\n          }\n\n          &:hover {\n            .option {\n              border-color: $moderate-blue;\n            }\n          }\n\n          [type=\"radio\"] {\n            position: absolute;\n            inset: 0;\n            width: auto;\n            height: auto;\n            z-index: 1;\n            cursor: pointer;\n            opacity: 0;\n          }\n\n          [type=\"radio\"]:checked ~ .option {\n            box-shadow: $shadow-hover;\n            border-color: $moderate-blue;\n            background-color: $moderate-blue;\n            color: white;\n          }\n\n          .input {\n            position: relative;\n            z-index: 2;\n\n            input {\n              padding-right: 52px;\n            }\n\n            &:after {\n              content: \"EUR\";\n              position: absolute;\n              right: 0.75rem;\n              top: 50%;\n              transform: translateY(-50%);\n              text-transform: uppercase;\n              color: $dark-gray-mid;\n            }\n          }\n        }\n        .no-block {\n          position: relative;\n\n          &:not(:first-child) {\n            margin-top: 10px;\n          }\n\n          .option {\n            background: $color-white;\n            border-radius: 6px;\n            border: solid 1px $color-white;\n            padding: 0.5rem 0.75rem;\n            box-shadow: $shadow;\n            transition: all 0.5s ease-in;\n          }\n\n          // &:hover {\n          //   .option {\n          //     border-color: $moderate-blue;\n          //   }\n          // }\n\n          [type=\"radio\"] {\n            position: absolute;\n            inset: 0;\n            width: auto;\n            height: auto;\n            z-index: 1;\n            cursor: pointer;\n            opacity: 0;\n          }\n\n          // [type=\"radio\"]:checked ~ .option {\n          //   // box-shadow: $shadow-hover;\n          //   // border-color: $moderate-blue;\n          // }\n\n          .input {\n            position: relative;\n            z-index: 2;\n\n            input {\n              padding-right: 52px;\n            }\n\n            &:after {\n              content: \"EUR\";\n              position: absolute;\n              right: 0.75rem;\n              top: 50%;\n              transform: translateY(-50%);\n              text-transform: uppercase;\n              color: $dark-gray-mid;\n            }\n          }\n        }\n      }\n\n      .footer {\n        border: solid 1px rgba($light-gray-two, 0.5);\n        background: $color-white;\n        padding: 0.75rem 1.25rem 1rem;\n        border-radius: 0 0 6px 6px;\n        margin-top: auto;\n      }\n    }\n\n    .attachments {\n      height: 4rem;\n      width: 5.5rem;\n      position: relative;\n      border-radius: 6px;\n      overflow: hidden;\n\n      &:after {\n        content: \"\";\n        position: absolute;\n        inset: 0;\n        background: rgba($dark-gray, 0.7);\n      }\n\n      img {\n        width: 100%;\n        height: 100%;\n      }\n\n      & > span {\n        @include font(14px, 20px, 500, $color-white);\n        position: absolute;\n        inset: 0;\n        z-index: 1;\n        padding: 0.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n\n    .past-comments {\n      border: solid 1px $light-gray-two;\n      border-radius: 6px;\n      padding: 1rem;\n\n      .blocks {\n        overflow-x: hidden;\n        overflow-y: auto;\n        height: 25rem;\n\n        &::-webkit-scrollbar {\n          width: 0.25rem;\n        }\n\n        &::-webkit-scrollbar-track {\n          box-shadow: none;\n          border-radius: 0;\n          background: none;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: $light-gray-two;\n          border-radius: 10px;\n        }\n\n        .block{\n          background: rgba($dark-gray-lighter, 0.7);\n          border-radius: 8px;\n          padding: 10px 14px;\n\n          &:not(:first-child) {\n            margin-top: 0.5rem;\n          }\n\n          p {\n            color: $dark-gray-mid;\n            margin-bottom: 0.5rem;\n          }\n\n          & > span {\n            display: block;\n            @include font(11px, 15px, 400, $moderate-blue);\n            text-align: right;\n          }\n        }\n        .block2{\n          background: rgba(rgba($vivid-blue, 0.4), 0.7);\n          border-radius: 8px;\n          padding: 10px 14px;\n\n          &:not(:first-child) {\n            margin-top: 0.5rem;\n          }\n\n          p {\n            color: $dark-gray;\n            margin-bottom: 0.5rem;\n          }\n\n          & > span {\n            display: block;\n            @include font(11px, 15px, 400, $moderate-blue);\n            text-align: right;\n          }\n        }\n      }\n    }\n\n    // Chatbot\n\n    .chatbot {\n      border: solid 1px $light-gray-two;\n      border-radius: 6px;\n\n      &__header {\n        border-bottom: solid 1px $light-gray-two;\n        border-radius: 6px 6px 0 0;\n        padding: 0.75rem 0.875rem;\n        background: $white-blue-four;\n      }\n\n      &__body {\n        padding: 0.75rem 1rem 1rem;\n        padding-right: 0;\n\n        .date {\n          display: block;\n          text-align: center;\n          @include font(12px, 14px);\n          @extend .text-muted;\n          margin-bottom: 0.75rem;\n        }\n      }\n\n      &__footer {\n        border-top: solid 1px $light-gray-two;\n        border-radius: 0 0 6px 6px;\n        padding: 0.75rem 0.75rem 0.625rem;\n        display: flex;\n        align-items: center;\n\n        input {\n          flex-grow: 1;\n          padding: 0;\n          margin: 0;\n          margin-right: 1rem;\n          height: 34px;\n          line-height: 34px;\n          color: $dark-gray;\n          background: none;\n          border: none;\n          box-shadow: none;\n          outline: none;\n          width: calc(100% - 50px);\n\n          &::placeholder {\n            color: $dark-gray-mid;\n            opacity: 1;\n          }\n        }\n\n        button {\n          flex-shrink: 0;\n          background: $white-blue-two;\n          border: none;\n          box-shadow: none;\n          outline: none;\n          width: 34px;\n          height: 34px;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: all 0.3s ease;\n\n          &:hover {\n            background: darken($white-blue-two, 5%);\n          }\n        }\n      }\n\n      .chats {\n        height: 300px;\n        overflow-x: hidden;\n        overflow-y: auto;\n        justify-content: flex-end;\n\n        .inner {\n          display: flex;\n          flex-direction: column;\n          padding-right: 1rem;\n        }\n\n        &::-webkit-scrollbar {\n          width: 0.25rem;\n        }\n\n        &::-webkit-scrollbar-track {\n          box-shadow: none;\n          border-radius: 0;\n          background: none;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: $light-gray-two;\n          border-radius: 10px;\n        }\n      }\n\n      .chat {\n        max-width: 75%;\n\n        &:not(:first-child) {\n          margin-top: 0.75rem;\n        }\n\n        &.user {\n          display: flex;\n          align-items: flex-start;\n          max-width: calc(75% + 30px);\n          margin: 5px 0px;\n\n          .avatar {\n            height: 30px;\n            width: 30px;\n            border-radius: 50%;\n            @include font(16px, 30px, 500, rgba($dark-gray, 0.5));\n            margin-right: 6px;\n            background: $dark-gray-lighter;\n            flex-shrink: 0;\n            text-align: center;\n            overflow: hidden;\n            padding: 0 0.25rem;\n          }\n\n          & > div {\n            flex-grow: 1;\n            border: solid 1px rgba($dark-gray-lighter, 0.7);\n            background: rgba($dark-gray-lighter, 0.7);\n            border-radius: 0.5rem;\n            padding: 10px 14px;\n            border-radius: 0.5rem;\n          }\n        }\n\n        &.self {\n          border: solid 1px rgba($color-black, 0.14);\n          background: $color-white;\n          align-self: flex-end;\n          padding: 10px 14px;\n          border-radius: 0.5rem;\n          margin: 5px 0px;\n        }\n\n        p {\n          margin-bottom: 3px;\n          @extend .text-muted;\n        }\n\n        .time {\n          display: block;\n          @include font(11px, 15px, 400, $moderate-blue);\n          text-align: right;\n        }\n      }\n\n      .user + .user,\n      .self + .self {\n        margin-top: 0.375rem;\n        margin: 5px 0px;\n      }\n    }\n\n    // Tooltip\n\n    .tooltip--custom {\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      bottom: calc(100% + 1rem);\n      min-width: 15rem;\n      max-width: calc(100vw - 2rem);\n      background: $color-white;\n      border: solid 1px $moderate-blue;\n      border-radius: 0.25rem;\n      filter: drop-shadow(0 4px 10px rgba($color-black, 0.07));\n      padding: 0.375rem 0.5rem;\n      @include font(12px, 18px, 400, $dark-gray);\n      text-align: center;\n      z-index: 1;\n\n      &::before,\n      &:after {\n        content: \"\";\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 0;\n        height: 0;\n      }\n\n      &::before {\n        bottom: -0.75rem;\n        border-left: 0.75rem solid transparent;\n        border-right: 0.75rem solid transparent;\n        border-top: 0.75rem solid $moderate-blue;\n      }\n\n      &::after {\n        bottom: -0.625rem;\n        border-left: 0.625rem solid transparent;\n        border-right: 0.625rem solid transparent;\n        border-top: 0.625rem solid $color-white;\n        z-index: 1;\n      }\n\n      p {\n        margin: 0;\n\n        & > strong {\n          color: $moderate-blue;\n          font-weight: 600;\n        }\n      }\n\n      &.warning {\n        border-color: $light-pink;\n\n        &::before {\n          border-left-color: transparent;\n          border-right-color: transparent;\n          border-top-color: $light-pink;\n        }\n\n        &::after {\n          border-left-color: transparent;\n          border-right-color: transparent;\n          border-top-color: $color-white;\n        }\n\n        p {\n          & > strong {\n            color: $dark-pink;\n          }\n        }\n      }\n    }\n  }\n","/* Base styles */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  \n  .voucher-generator {\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\",\n      \"Helvetica Neue\", sans-serif;\n    color: #333;\n    background-color: #f5f5f5;\n    min-height: 100vh;\n  }\n  \n  .sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n  \n  /* Header styles */\n  .header {\n    background-color: #fff;\n    border-bottom: 1px solid #e5e5e5;\n  }\n  \n  .header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 64px;\n    padding: 0 24px;\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n  \n  .header-left {\n    display: flex;\n    align-items: center;\n  }\n  \n  .logo {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin-right: 24px;\n  }\n  \n  .nav-menu {\n    display: none;\n  }\n  \n  .nav-link {\n    color: #666;\n    text-decoration: none;\n    font-size: 0.875rem;\n    font-weight: 500;\n    padding: 8px 12px;\n    margin: 0 8px;\n    position: relative;\n  }\n  \n  .nav-link:hover {\n    color: #333;\n  }\n  \n  .nav-link.active {\n    color: #2563eb;\n    border-bottom: 2px solid #2563eb;\n  }\n  \n  .header-right {\n    display: flex;\n    align-items: center;\n  }\n  \n  .notification-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #666;\n    margin-right: 12px;\n  }\n  \n  .avatar-container {\n    position: relative;\n  }\n  \n  .avatar-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n  }\n  \n  .avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: #e5e5e5;\n  }\n  \n  /* Main content styles */\n  .main-content {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 24px;\n  }\n  \n  .page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n  }\n  \n  .page-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 4px;\n  }\n  \n  .page-subtitle {\n    color: #666;\n  }\n  \n  .export-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    background-color: #fff;\n    border: 1px solid #e5e5e5;\n    border-radius: 6px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #333;\n    cursor: pointer;\n    margin-top: 12px;\n  }\n  \n  .export-btn:hover {\n    background-color: #f5f5f5;\n  }\n  \n  .icon {\n    width: 16px;\n    height: 16px;\n  }\n  \n  /* Stats cards */\n  .stats-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n  \n  .card {\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n  }\n  \n  .card-header {\n    padding: 16px;\n    border-bottom: 1px solid #f0f0f0;\n  }\n  \n  .card-title {\n    font-size: 1.125rem;\n    font-weight: 500;\n  }\n  \n  .card-content {\n    padding: 16px;\n  }\n  \n  .card-content.no-padding {\n    padding: 0;\n  }\n  \n  .stat-value {\n    font-size: 1.875rem;\n    font-weight: 700;\n    margin-bottom: 4px;\n  }\n  \n  .total-vouchers {\n    color: #2563eb;\n  }\n  \n  .active-vouchers {\n    color: #10b981;\n  }\n  \n  .redeemed-value {\n    color: #8b5cf6;\n  }\n  \n  .stat-label {\n    font-size: 0.875rem;\n    color: #666;\n  }\n  \n  /* Main grid layout */\n  .main-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n  \n  /* Form styles */\n  .form-group {\n    margin-bottom: 16px;\n  }\n  \n  .form-label {\n    display: block;\n    font-size: 0.875rem;\n    font-weight: 500;\n    margin-bottom: 8px;\n  }\n  \n  .form-input {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    background-color: #f9fafb;\n    font-size: 0.875rem;\n  }\n  \n  .form-input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n  }\n  \n  .form-hint {\n    font-size: 0.75rem;\n    color: #666;\n    margin-top: 4px;\n  }\n  \n  .generate-btn {\n    width: 100%;\n    padding: 10px;\n    background-color: #2563eb;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 16px;\n  }\n  \n  .generate-btn:hover {\n    background-color: #1d4ed8;\n  }\n  \n  .generate-btn:disabled {\n    background-color: #93c5fd;\n    cursor: not-allowed;\n  }\n  \n  /* Tabs */\n  .tabs {\n    display: flex;\n    border-bottom: 1px solid #e5e5e5;\n    margin-bottom: 16px;\n  }\n  \n  .tab-button {\n    padding: 12px 16px;\n    background: none;\n    border: none;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: #666;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n  }\n  \n  .tab-button.active {\n    color: #2563eb;\n    border-bottom-color: #2563eb;\n  }\n  \n  /* Table styles */\n  .table-container {\n    overflow-x: auto;\n  }\n  \n  .table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .table th,\n  .table td {\n    padding: 12px 16px;\n    text-align: left;\n    border-bottom: 1px solid #e5e5e5;\n  }\n  \n  .table th {\n    background-color: #f9fafb;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #4b5563;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  .table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .monospace {\n    font-family: \"Courier New\", Courier, monospace;\n  }\n  \n  .badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 9999px;\n    font-size: 0.75rem;\n    font-weight: 500;\n  }\n  \n  .badge-active {\n    background-color: #d1fae5;\n    color: #065f46;\n  }\n  \n  .badge-redeemed {\n    background-color: #dbeafe;\n    color: #1e40af;\n  }\n  \n  .badge-expired {\n    background-color: #f3f4f6;\n    color: #4b5563;\n  }\n  \n  /* Empty state */\n  .empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 48px 24px;\n    text-align: center;\n  }\n  \n  .empty-icon {\n    width: 48px;\n    height: 48px;\n    color: #d1d5db;\n    margin-bottom: 16px;\n  }\n  \n  .empty-title {\n    font-size: 1.125rem;\n    font-weight: 500;\n    color: #111827;\n    margin-bottom: 4px;\n  }\n  \n  .empty-description {\n    font-size: 0.875rem;\n    color: #6b7280;\n    max-width: 20rem;\n    margin: 0 auto;\n  }\n  \n  /* Action buttons */\n  .action-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n  \n  .action-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px;\n    background-color: #fff;\n    border: 1px solid #e5e5e5;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: #333;\n    cursor: pointer;\n  }\n  \n  .action-btn:hover {\n    background-color: #f5f5f5;\n  }\n  \n  /* Loading spinner */\n  .spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid #fff;\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  /* Toast notification */\n  .toast-container {\n    position: fixed;\n    bottom: 16px;\n    right: 16px;\n    z-index: 50;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .toast {\n    background-color: #fff;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n    padding: 16px;\n    min-width: 300px;\n    max-width: 400px;\n    animation: slideIn 0.3s ease-out forwards;\n  }\n  \n  .toast-header {\n    font-weight: 600;\n    margin-bottom: 4px;\n  }\n  \n  .toast-body {\n    font-size: 0.875rem;\n    color: #6b7280;\n  }\n  \n  @keyframes slideIn {\n    from {\n      transform: translateX(100%);\n      opacity: 0;\n    }\n    to {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  \n  /* Responsive styles */\n  @media (min-width: 768px) {\n    .nav-menu {\n      display: flex;\n    }\n  \n    .stats-grid {\n      grid-template-columns: repeat(3, 1fr);\n    }\n  \n    .main-grid {\n      grid-template-columns: 1fr 2fr;\n    }\n  \n    .export-btn {\n      margin-top: 0;\n    }\n  }\n  ","  .listContainer {\n      max-width: 1800px;\n      min-width: 1600px;\n      margin: 0 auto;\n      padding: 20px;\n    }\n    \n    .listHeader {\n      margin-bottom: 30px;\n    }\n    \n    .listHeader h1 {\n      font-size: 24px;\n      color: #333;\n      margin: 0 0 10px 0;\n    }\n    \n    .listHeader p {\n      color: #666;\n      margin: 0;\n    }\n    \n    .controlsContainer {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      margin-bottom: 20px;\n      gap: 15px;\n    }\n    \n    .searchContainer {\n      flex: 1;\n      min-width: 300px;\n    }\n    \n    .searchInput {\n      width: 100%;\n      padding: 10px 15px;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      font-size: 14px;\n    }\n    \n    .filtersContainer {\n      display: flex;\n      gap: 15px;\n    }\n    \n    .filterGroup {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n    \n    .filterGroup label {\n      font-size: 14px;\n      color: #555;\n    }\n    \n    .filterGroup select {\n      padding: 8px 10px;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      background-color: white;\n      font-size: 14px;\n    }\n    \n    .tableContainer {\n      overflow-x: auto;\n      background-color: white;\n      border-radius: 8px;\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n      margin-bottom: 20px;\n    }\n    \n    .usersTable {\n      width: 100%;\n      border-collapse: collapse;\n    }\n    \n    .usersTable th,\n    .usersTable td {\n      padding: 12px 15px;\n      text-align: left;\n      border-bottom: 1px solid #eee;\n    }\n    \n    .usersTable th {\n      background-color: #f8f9fa;\n      font-weight: 600;\n      color: #333;\n      position: sticky;\n      top: 0;\n    }\n    \n    .sortableHeader {\n      cursor: pointer;\n      user-select: none;\n    }\n    \n    .sortableHeader:hover {\n      background-color: #f1f3f5;\n    }\n    \n    .sortIcon {\n      display: inline-block;\n      margin-left: 5px;\n    }\n    \n    .userRow {\n      cursor: pointer;\n      transition: background-color 0.2s ease;\n    }\n    \n    .userRow:hover {\n      background-color: #f8f9fa;\n    }\n    \n    .statusBadge {\n      display: inline-block;\n      padding: 4px 8px;\n      border-radius: 12px;\n      font-size: 12px;\n      font-weight: 500;\n      text-align: center;\n      min-width: 80px;\n    }\n    \n    .pending {\n      background-color: #fff3cd;\n      color: #856404;\n    }\n    \n    .approved {\n      background-color: #d4edda;\n      color: #155724;\n    }\n    \n    .rejected {\n      background-color: #f8d7da;\n      color: #721c24;\n    }\n    \n    .typeLabel {\n      display: inline-block;\n      padding: 4px 8px;\n      border-radius: 12px;\n      font-size: 12px;\n      font-weight: 500;\n      text-align: center;\n    }\n    \n    .individualType {\n      background-color: #e2f0fd;\n      color: #0c63e4;\n    }\n    \n    .businessType {\n      background-color: #e6e6fa;\n      color: #6f42c1;\n    }\n    \n    .viewButton {\n      background-color: #2c6ecf;\n      color: white;\n      border: none;\n      border-radius: 4px;\n      padding: 6px 12px;\n      font-size: 13px;\n      cursor: pointer;\n      transition: background-color 0.2s ease;\n    }\n    \n    .viewButton:hover {\n      background-color: #1e5bb0;\n    }\n    \n    .pagination {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: 20px;\n      gap: 15px;\n    }\n    \n    .paginationButton {\n      background-color: #f8f9fa;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      padding: 8px 15px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n    }\n    \n    .paginationButton:hover:not(:disabled) {\n      background-color: #e9ecef;\n    }\n    \n    .paginationButton:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n    \n    .pageInfo {\n      font-size: 14px;\n      color: #666;\n    }\n    \n    .resultsInfo {\n      text-align: center;\n      font-size: 14px;\n      color: #666;\n      margin-top: 10px;\n    }\n    \n    .noResults {\n      text-align: center;\n      padding: 30px;\n      color: #666;\n    }\n    \n    /* Responsive styles */\n    @media (max-width: 768px) {\n      .controlsContainer {\n        flex-direction: column;\n      }\n    \n      .searchContainer {\n        min-width: 100%;\n      }\n    \n      .filtersContainer {\n        width: 100%;\n        justify-content: space-between;\n      }\n    \n      .usersTable th:nth-child(3),\n      .usersTable td:nth-child(3) {\n        display: none;\n      }\n    }\n    \n    @media (max-width: 576px) {\n      .usersTable th:nth-child(4),\n      .usersTable td:nth-child(4) {\n        display: none;\n      }\n    }\n    ",".reviewPanel {\n    max-width: 1200px;\n    margin: 0 auto;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n  }\n  \n  .panelHeader {\n    background-color: #f8f9fa;\n    padding: 20px 30px;\n    border-bottom: 1px solid #e9ecef;\n    position: relative;\n  }\n  \n  .headerActions {\n    margin-bottom: 15px;\n  }\n  \n  .backButton {\n    background: none;\n    border: none;\n    color: #2c6ecf;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 0;\n    display: flex;\n    align-items: center;\n  }\n  \n  .backButton:hover {\n    text-decoration: underline;\n  }\n  \n  .panelHeader h1 {\n    margin: 0;\n    font-size: 24px;\n    color: #333;\n  }\n  \n  .submissionMeta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin-top: 10px;\n    font-size: 14px;\n    color: #666;\n  }\n  \n  .submissionId {\n    font-weight: 600;\n  }\n  \n  .submissionStatus {\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-weight: 600;\n  }\n  \n  .submissionStatus.pending {\n    background-color: #fff3cd;\n    color: #856404;\n  }\n  \n  .submissionStatus.approved {\n    background-color: #d4edda;\n    color: #155724;\n  }\n  \n  .submissionStatus.rejected {\n    background-color: #f8d7da;\n    color: #721c24;\n  }\n  \n  .reviewContent {\n    padding: 30px;\n  }\n  \n  .infoSection {\n    margin-bottom: 30px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    padding: 20px;\n  }\n  \n  .infoSection h2 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 18px;\n    color: #333;\n    border-bottom: 1px solid #e9ecef;\n    padding-bottom: 10px;\n  }\n  \n  .infoGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n  }\n  \n  .infoItem {\n    margin-bottom: 15px;\n  } \n  \n  .infoItem label {\n    display: block;\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 5px;\n  }\n  \n  .infoItem div {\n    font-size: 16px;\n    color: #333;\n    padding: 8px 0;\n    overflow-wrap: break-word;\n  }\n  \n  .documentsSection {\n    margin-bottom: 30px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    padding: 20px;\n  }\n  \n  .documentsSection h2 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 18px;\n    color: #333;\n    border-bottom: 1px solid #e9ecef;\n    padding-bottom: 10px;\n  }\n  \n  .documentsGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 20px;\n  }\n  \n  .documentItem {\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    border-radius: 6px;\n    overflow: hidden;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .documentItem:hover {\n    transform: translateY(-5px);\n  }\n  \n  .documentThumbnail {\n    height: 150px;\n    overflow: hidden;\n    background-color: #eee;\n  }\n  \n  .documentThumbnail img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .documentLabel {\n    padding: 10px;\n    text-align: center;\n    font-size: 14px;\n    background-color: #fff;\n    border-top: 1px solid #eee;\n  }\n  \n  .verificationSection {\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    padding: 20px;\n  }\n  \n  .verificationSection h2 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 18px;\n    color: #333;\n    border-bottom: 1px solid #e9ecef;\n    padding-bottom: 10px;\n  }\n  \n  .notesTextarea {\n    width: 100%;\n    min-height: 120px;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 20px;\n    font-size: 14px;\n    resize: vertical;\n  }\n  \n  .actionButtons {\n    display: flex;\n    gap: 15px;\n    justify-content: flex-end;\n  }\n  \n  .approveButton,\n  .rejectButton,\n  .confirmRejectButton,\n  .cancelButton {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .approveButton {\n    background-color: #28a745;\n    color: white;\n  }\n  \n  .approveButton:hover {\n    background-color: #218838;\n  }\n  \n  .rejectButton {\n    background-color: #dc3545;\n    color: white;\n  }\n  \n  .rejectButton:hover {\n    background-color: #c82333;\n  }\n  \n  .confirmRejectButton {\n    background-color: #dc3545;\n    color: white;\n  }\n  \n  .confirmRejectButton:hover {\n    background-color: #c82333;\n  }\n  \n  .cancelButton {\n    background-color: #6c757d;\n    color: white;\n  }\n  \n  .cancelButton:hover {\n    background-color: #5a6268;\n  }\n  \n  .statusMessage {\n    padding: 15px;\n    border-radius: 4px;\n    font-weight: 500;\n    text-align: center;\n  }\n  \n  .approvedMessage {\n    background-color: #d4edda;\n    color: #155724;\n    padding: 10px;\n    border-radius: 4px;\n  }\n  \n  .rejectedMessage {\n    background-color: #f8d7da;\n    color: #721c24;\n    padding: 10px;\n    border-radius: 4px;\n  }\n  \n  .documentViewer {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n  }\n  \n  .documentViewerContent {\n    background-color: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 900px;\n    max-height: 90vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .documentViewerHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 20px;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .documentViewerHeader h3 {\n    margin: 0;\n    font-size: 18px;\n  }\n  \n  .closeButton {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #666;\n  }\n  \n  .documentViewerImage {\n    padding: 20px;\n    overflow: auto;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .documentViewerImage img {\n    max-width: 100%;\n    max-height: 70vh;\n    object-fit: contain;\n  }\n  \n  .rejectionModal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n  }\n  \n  .rejectionModalContent {\n    background-color: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n    padding: 25px;\n  }\n  \n  .rejectionModalContent h3 {\n    margin-top: 0;\n    color: #333;\n  }\n  \n  .rejectionTextarea {\n    width: 100%;\n    min-height: 120px;\n    padding: 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin: 15px 0;\n    font-size: 14px;\n    resize: vertical;\n  }\n  \n  .rejectionModalButtons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 20px;\n  }\n  \n  .loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 300px;\n    font-size: 18px;\n    color: #666;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    .panelHeader {\n      padding: 15px 20px;\n    }\n  \n    .reviewContent {\n      padding: 20px;\n    }\n  \n    .infoGrid {\n      grid-template-columns: 1fr;\n    }\n  \n    .documentsGrid {\n      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    }\n  \n    .actionButtons {\n      flex-direction: column;\n    }\n  \n    .approveButton,\n    .rejectButton {\n      width: 100%;\n    }\n  }\n  ","/* Admin Panel Styles */\n.admin-container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 24px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\",\n      \"Helvetica Neue\", sans-serif;\n  }\n  \n  .admin-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n  }\n  \n  .admin-header h1 {\n    font-size: 24px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n  }\n  \n  .admin-header p {\n    font-size: 14px;\n    color: #666;\n    margin: 4px 0 0 0;\n  }\n  \n  /* Stats Cards */\n  .stats-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n  \n  .stat-card {\n    background-color: white;\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n  \n  .stat-card h2 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #666;\n    margin: 0 0 8px 0;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .stat-value {\n    font-size: 32px;\n    font-weight: 700;\n    margin-bottom: 4px;\n  }\n  \n  .stat-description {\n    font-size: 14px;\n    color: #666;\n  }\n  \n  /* Content Container */\n  .content-container {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr;\n    gap: 24px;\n  }\n  \n  /* Tabs */\n  .tabs {\n    display: flex;\n    border-bottom: 1px solid #ddd;\n    margin-bottom: 16px;\n  }\n  \n  .tabs button {\n    padding: 12px 16px;\n    background: none;\n    border: none;\n    font-size: 14px;\n    color: #666;\n    cursor: pointer;\n    position: relative;\n  }\n  \n  .tabs button.tab-active {\n    color: #4f46e5;\n    font-weight: 500;\n  }\n  \n  .tabs button.tab-active::after {\n    content: \"\";\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background-color: #4f46e5;\n  }\n  \n  /* Bug List */\n  .bug-list-container,\n  .bug-detail-container {\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n  }\n  \n  .bug-list {\n    max-height: 600px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #d1d5db #f3f4f6;\n  }\n  \n  .bug-list::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  .bug-list::-webkit-scrollbar-track {\n    background: #f3f4f6;\n    border-radius: 4px;\n  }\n  \n  .bug-list::-webkit-scrollbar-thumb {\n    background-color: #d1d5db;\n    border-radius: 4px;\n  }\n  \n  .bug-list-item {\n    padding: 16px;\n    border-bottom: 1px solid #eee;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .bug-list-item:hover {\n    background-color: #f9f9f9;\n  }\n  \n  .bug-list-item.selected {\n    background-color: #f0f7ff;\n    border-left: 3px solid #4f46e5;\n  }\n  \n  .bug-list-item-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n  \n  .bug-type {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .bug-severity {\n    font-size: 12px;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-weight: 500;\n  }\n  \n  .bug-severity.critical {\n    background-color: #fee2e2;\n    color: #b91c1c;\n  }\n  \n  .bug-severity.high {\n    background-color: #ffedd5;\n    color: #c2410c;\n  }\n  \n  .bug-severity.medium {\n    background-color: #fef3c7;\n    color: #92400e;\n  }\n  \n  .bug-severity.low {\n    background-color: #ecfdf5;\n    color: #047857;\n  }\n  \n  .bug-details-preview {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 12px;\n    line-height: 1.4;\n  }\n  \n  .bug-list-item-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n  }\n  \n  .bug-reporter {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .username {\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .email {\n    color: #666;\n  }\n  \n  .bug-meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #666;\n  }\n  \n  .attachment-indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n  \n  /* Bug List Empty State */\n  .empty-bug-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 48px 24px;\n    color: #666;\n    text-align: center;\n  }\n  \n  .empty-bug-list svg {\n    color: #ccc;\n    margin-bottom: 16px;\n  }\n  \n  .empty-bug-list h3 {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 8px 0;\n  }\n  \n  .empty-bug-list p {\n    font-size: 14px;\n    margin: 0;\n  }\n  \n  /* Bug Detail */\n  .bug-detail {\n    padding: 24px;\n  }\n  \n  .bug-detail-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n  }\n  \n  .bug-detail-title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .bug-detail-title h2 {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n  }\n  \n  .status-badge {\n    font-size: 12px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-weight: 500;\n  }\n  \n  .status-badge.open {\n    background-color: #fee2e2;\n    color: #b91c1c;\n  }\n  \n  .status-badge.resolved {\n    background-color: #ecfdf5;\n    color: #047857;\n  }\n  \n  .bug-actions {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .status-select {\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n  }\n  \n  .action-button {\n    background-color: #4f46e5;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 16px;\n    font-size: 14px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .action-button:hover {\n    background-color: #4338ca;\n  }\n  \n  .bug-detail-content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n  \n  .bug-detail-section {\n    border-bottom: 1px solid #eee;\n    padding-bottom: 24px;\n  }\n  \n  .bug-detail-section:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n  \n  .bug-detail-section h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 16px 0;\n    color: #333;\n  }\n  \n  .detail-row {\n    display: flex;\n    margin-bottom: 8px;\n  }\n  \n  .detail-label {\n    width: 120px;\n    font-weight: 500;\n    color: #666;\n    font-size: 14px;\n  }\n  \n  .detail-value {\n    font-size: 14px;\n    color: #333;\n  }\n  \n  .severity-indicator {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 6px;\n  }\n  \n  .severity-indicator.critical {\n    background-color: #ef4444;\n  }\n  \n  .severity-indicator.high {\n    background-color: #f59e0b;\n  }\n  \n  .severity-indicator.medium {\n    background-color: #f59e0b;\n  }\n  \n  .severity-indicator.low {\n    background-color: #10b981;\n  }\n  \n  .detail-text {\n    font-size: 14px;\n    line-height: 1.6;\n    color: #333;\n  }\n  \n  .attachments-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 16px;\n  }\n  \n  .attachment-item {\n    border: 1px solid #eee;\n    border-radius: 4px;\n    overflow: hidden;\n  }\n  \n  .attachment-preview {\n    height: 150px;\n    overflow: hidden;\n  }\n  \n  .attachment-preview img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .attachment-info {\n    padding: 8px;\n  }\n  \n  .attachment-name {\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 4px;\n    word-break: break-all;\n  }\n  \n  .download-link {\n    font-size: 12px;\n    color: #4f46e5;\n    text-decoration: none;\n  }\n  \n  .download-link:hover {\n    text-decoration: underline;\n  }\n  \n  /* Empty State */\n  .empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 48px 24px;\n    color: #666;\n    text-align: center;\n    height: 100%;\n  }\n  \n  .empty-state svg {\n    color: #ccc;\n    margin-bottom: 16px;\n  }\n  \n  .empty-state h3 {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 8px 0;\n  }\n  \n  .empty-state p {\n    font-size: 14px;\n    margin: 0;\n  }\n  \n  /* Status Colors */\n  .bug-list-item.open {\n    border-left: 3px solid #ef4444;\n  }\n  \n  .bug-list-item.resolved {\n    border-left: 3px solid #10b981;\n  }\n  \n  /* Scrollbar Styles */\n  [role=\"dialog\"] > div {\n    scrollbar-width: thin;\n    scrollbar-color: #4b5563 #1f2937;\n  }\n  \n  [role=\"dialog\"] > div::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  [role=\"dialog\"] > div::-webkit-scrollbar-track {\n    background: #1f2937;\n    border-radius: 4px;\n  }\n  \n  [role=\"dialog\"] > div::-webkit-scrollbar-thumb {\n    background-color: #4b5563;\n    border-radius: 4px;\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n    .content-container {\n      grid-template-columns: 1fr;\n    }\n  \n    .bug-list {\n      max-height: 300px;\n    }\n  }\n  \n  /* Responsive adjustments */\n  @media (max-height: 700px) {\n    .stats-container {\n      grid-template-columns: repeat(3, 1fr);\n      gap: 12px;\n    }\n  \n    .stat-card {\n      padding: 12px;\n    }\n  \n    .stat-value {\n      font-size: 28px;\n    }\n  \n    .content-container {\n      gap: 16px;\n    }\n  }\n  \n  @media (max-height: 600px) {\n    .admin-container {\n      padding: 16px;\n    }\n  \n    .admin-header {\n      margin-bottom: 16px;\n    }\n  \n    .stats-container {\n      margin-bottom: 16px;\n    }\n  }\n  ","\r\n// Opacity\r\n\r\n.opacity-01 {\r\n  opacity: .01 !important;\r\n}\r\n\r\n.opacity-02 {\r\n  opacity: .02 !important;\r\n}\r\n\r\n.opacity-03 {\r\n  opacity: .03 !important;\r\n}\r\n\r\n.opacity-04 {\r\n  opacity: .04 !important;\r\n}\r\n\r\n.opacity-05 {\r\n  opacity: .05 !important;\r\n}\r\n\r\n.opacity-06 {\r\n  opacity: .06 !important;\r\n}\r\n\r\n.opacity-07 {\r\n  opacity: .07 !important;\r\n}\r\n\r\n.opacity-08 {\r\n  opacity: .08 !important;\r\n}\r\n\r\n.opacity-09 {\r\n  opacity: .09 !important;\r\n}\r\n\r\n.opacity-1 {\r\n  opacity: .1 !important;\r\n}\r\n\r\n.opacity-15 {\r\n  opacity: .15 !important;\r\n}\r\n\r\n.opacity-2 {\r\n  opacity: .2 !important;\r\n}\r\n\r\n.opacity-3 {\r\n  opacity: .3 !important;\r\n}\r\n\r\n.opacity-4 {\r\n  opacity: .4 !important;\r\n}\r\n\r\n.opacity-5 {\r\n  opacity: .5 !important;\r\n}\r\n\r\n.opacity-6 {\r\n  opacity: .6 !important;\r\n}\r\n\r\n.opacity-7 {\r\n  opacity: .7 !important;\r\n}\r\n\r\n.opacity-8 {\r\n  opacity: .8 !important;\r\n}\r\n\r\n.opacity-9 {\r\n  opacity: .9 !important;\r\n}\r\n\r\n.opacity-10 {\r\n  opacity: 1 !important;\r\n}","// Grayscale Filter\r\n\r\n.filter-grayscale-5 {\r\n  filter: grayscale(5%) !important;\r\n}\r\n\r\n.filter-grayscale-10 {\r\n  filter: grayscale(10%) !important;\r\n}\r\n\r\n.filter-grayscale-20 {\r\n  filter: grayscale(20%) !important;\r\n}\r\n\r\n.filter-grayscale-30 {\r\n  filter: grayscale(30%) !important;\r\n}\r\n\r\n.filter-grayscale-40 {\r\n  filter: grayscale(40%) !important;\r\n}\r\n\r\n.filter-grayscale-50 {\r\n  filter: grayscale(50%) !important;\r\n}\r\n\r\n.filter-grayscale-80 {\r\n  filter: grayscale(80%) !important;\r\n}\r\n\r\n.filter-grayscale-100 {\r\n  filter: grayscale(100%) !important;\r\n}","// Helpers imports\r\n@import \"helpers/opacity\";\r\n@import \"helpers/grayscale\";\r\n\r\n// Resets\r\n\r\n.br-tl {\r\n  border-top-left-radius: $border-radius !important;\r\n}\r\n\r\n.br-tr {\r\n  border-top-right-radius: $border-radius !important;\r\n}\r\n\r\n.br-bl {\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.br-br {\r\n  border-bottom-right-radius: $border-radius !important;\r\n}\r\n\r\n.b-radius-0 {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.rm-border {\r\n  border-width: 0 !important;\r\n}\r\n\r\n.br-a {\r\n  @include border-radius($border-radius);\r\n}\r\n\r\n// Center Elements\r\n\r\n.margin-h-center {\r\n  margin-left: auto !important;\r\n  margin-right: auto !important;\r\n}\r\n\r\n.center-svg {\r\n  margin: 0 auto;\r\n\r\n  svg {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.apexcharts-canvas {\r\n  margin: 0 auto;\r\n}\r\n\r\n.apexcharts-donut {\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n\r\n.alert-dismissible {\r\n  .close {\r\n    top: 0;\r\n    right: 5px;\r\n    padding: 5px;\r\n  }\r\n}\r\n\r\n// Gradient Icons\r\n\r\n.icon-gradient {\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  text-fill-color: transparent;\r\n}\r\n\r\n// Font sizes\r\n\r\n.font-size-xlg {\r\n  font-size: 1.3rem !important;\r\n}\r\n\r\n.font-size-md {\r\n  font-size: .9rem !important;\r\n}\r\n\r\n.font-size-lg {\r\n  font-size: 1.1rem !important;\r\n}\r\n\r\n// No Shadow\r\n\r\n.no-shadow {\r\n  box-shadow: 0 0 0 transparent !important;\r\n}\r\n\r\n// Layout\r\n\r\n.h-100 {\r\n  height: 100vh !important;\r\n}\r\n\r\n.he-auto {\r\n  height: auto !important;\r\n}\r\n\r\n.he-100 {\r\n  height: 100%;\r\n}\r\n\r\n.h-sm {\r\n  height: 150px;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap;\r\n}\r\n\r\n// Font size\r\n\r\n.fsize-1 {\r\n  font-size: .95rem !important;\r\n}\r\n\r\n.fsize-2 {\r\n  font-size: 1.3rem !important;\r\n}\r\n\r\n.fsize-3 {\r\n  font-size: 1.6rem !important;\r\n}\r\n\r\n.fsize-4 {\r\n  font-size: 2rem !important;\r\n}\r\n\r\n.z-index-6 {\r\n  z-index: 6;\r\n}\r\n\r\n.line-height-1 {\r\n  line-height: 1;\r\n}\r\n\r\n// Center element\r\n\r\n.center-elem {\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n\r\n.flex2 {\r\n  flex: 2;\r\n}\r\n\r\n// Divider\r\n\r\n.divider {\r\n  margin-top: $spacer;\r\n  margin-bottom: $spacer;\r\n  height: 1px;\r\n  overflow: hidden;\r\n  background: $gray-200;\r\n}\r\n\r\n.list-group-item:hover {\r\n  z-index: initial;\r\n}\r\n\r\n// No Results\r\n\r\n.no-results {\r\n  padding: ($spacer * 1.5);\r\n  text-align: center;\r\n\r\n  .results-title {\r\n    color: $gray-700;\r\n    font-size: $h5-font-size;\r\n  }\r\n\r\n  .results-subtitle {\r\n    color: $gray-500;\r\n    font-size: $font-size-lg;\r\n  }\r\n}\r\n\r\n// Background Color Animation\r\n\r\n.bg-animation {\r\n  animation: bg-pan-left 8s both;\r\n}\r\n\r\n@-webkit-keyframes bg-pan-left {\r\n  0% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n@keyframes bg-pan-left {\r\n  0% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n// Width 100%\r\n\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n\r\n.mb--2 {\r\n  margin-bottom: -1.5rem;\r\n}\r\n\r\n// Margins\r\n\r\n.mbg-3 {\r\n  margin-bottom: $grid-gutter-width;\r\n}\r\n\r\n// Loader\r\n\r\n.loader-container {\r\n  align-items: center;\r\n  display: flex;\r\n  height: 100vh;\r\n  justify-content: center;\r\n  width: 100vw;\r\n  text-align: center;\r\n  line-height: 1.6rem;\r\n\r\n  .loader-container-inner {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    padding: 0 $layout-spacer-x;\r\n  }\r\n\r\n  small {\r\n    margin: 10px 0 0;\r\n    display: block;\r\n    color: $gray-600;\r\n    font-weight: normal;\r\n  }\r\n\r\n  h3 {\r\n    text-align: center;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.btn-info, .btn-success {\r\n  color:#fff !important;\r\n}\r\n\r\n.bg-warning {\r\n  color: #212529;\r\n}\r\n\r\n.list-group-item {\r\n  border: 1px solid rgba(0,0,0,0.125);\r\n}\r\n\r\n.btn-link, a {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.bg-light {\r\n  color: #212529;\r\n  // background: #fff;\r\n}\r\n\r\n.table {\r\n  --bs-table-accent-bg: none;\r\n}\r\n\r\n.form-check-input-custom {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}","// Gradients\r\n\r\n.bg-warm-flame {\r\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\r\n}\r\n\r\n.bg-night-fade {\r\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\r\n}\r\n\r\n.bg-sunny-morning {\r\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\r\n}\r\n\r\n.bg-tempting-azure {\r\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\r\n}\r\n\r\n.bg-amy-crisp {\r\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\r\n}\r\n\r\n.bg-heavy-rain {\r\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\r\n}\r\n\r\n.bg-mean-fruit {\r\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\r\n}\r\n\r\n.bg-malibu-beach {\r\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\r\n}\r\n\r\n.bg-deep-blue {\r\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\r\n}\r\n\r\n.bg-ripe-malin {\r\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\r\n}\r\n\r\n.bg-arielle-smile {\r\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\r\n}\r\n\r\n.bg-plum-plate {\r\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\r\n}\r\n\r\n.bg-happy-fisher {\r\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\r\n}\r\n\r\n.bg-happy-itmeo {\r\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\r\n}\r\n\r\n.bg-mixed-hopes {\r\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\r\n}\r\n\r\n.bg-strong-bliss {\r\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\r\n}\r\n\r\n.bg-grow-early {\r\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\r\n}\r\n\r\n.bg-love-kiss {\r\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\r\n}\r\n\r\n.bg-premium-dark {\r\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\r\n}\r\n\r\n.bg-happy-green {\r\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\r\n}\r\n\r\n.bg-vicious-stance {\r\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\r\n}\r\n\r\n.bg-midnight-bloom {\r\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\r\n}\r\n\r\n.bg-night-sky {\r\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\r\n}\r\n\r\n.bg-slick-carbon {\r\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.25) 200%) !important;\r\n  background-blend-mode: multiply;\r\n}\r\n\r\n.bg-royal {\r\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\r\n}\r\n\r\n.bg-asteroid {\r\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background: transparent !important;\r\n}","@charset \"UTF-8\";\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\n\nbody {\n\t-webkit-backface-visibility: hidden; // Addresses a small issue in webkit: https://css-tricks.com/almanac/properties/b/backface-visibility/\n}\n\n.animated {\n  \t@include animate-prefixer(animation-duration, calc( #{$base-duration} ) );\n  \t@include animate-prefixer(animation-fill-mode, $base-fill-mode);\n\n\t&.infinite {\n\t  animation-iteration-count: $base-iteration-count;\n\t}\n\n\t&.hinge {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 2 ) );\n\t}\n\n\t&.bounceIn,\n\t&.bounceOut {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n\n\t&.flipOutX,\n\t&.flipOutY {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n}","///////////////////////////////////////////////////////////////////\n// Sass Mixins which will be used by the modules                 //\n///////////////////////////////////////////////////////////////////\n\n//===============================================================//\n//          Automatically add vendor prefixes in one hit         //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, 'fadeIn');        //\n//      }                                                        //\n//===============================================================//\n//                                                               //\n//===============================================================//\n@mixin animate-prefixer($property, $value...) {\n    -webkit-#{$property}: unquote('#{$value}');\n    #{$property}: unquote('#{$value}');\n}\n//===============================================================//\n// Generate keyframes animations with vendor prefixes in one hit //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, fadeIn);        //\n//      }                                                        //\n//      @include animate-keyframe(fadeIn) {                      //\n//          0% {opacity: 0;}                                     //\n//          100% {opacity: 1;}                                   //\n//      }                                                        //\n//===============================================================//\n// Courtesy of @integralist: (twitter.com)                       //\n//===============================================================//\n\n@mixin animate-keyframe($animation-name) {\n    @-webkit-keyframes #{$animation-name} {\n        @content;\n    }\n\n    @keyframes #{$animation-name} {\n        @content;\n    }\n}\n","/////////////////////////////////////////////////////////\n// Animation Default Settings                          //\n/////////////////////////////////////////////////////////\n\n\n// Base module settings\n$base-duration\t\t\t\t\t: 1s !default;           // used in 1-base module\n$base-origin \t\t\t\t\t: top center !default;\n$base-degrees \t\t\t\t\t: 30deg !default;        // used in lightspeed & special modules\n$base-fill-mode\t\t\t\t\t: both !default;\n$base-iteration-count\t\t\t: infinite !default;\n\n$base-timing-function-in\t\t: ease-in !default;\n$base-timing-function-out\t\t: ease-out !default;\n$base-timing-function-in-out\t: ease-in-out !default;\n\n$base-distance\t\t\t\t\t: 10px !default; \t\t// used in fade, shake and bounce modules\n$base-distance-big\t\t\t\t: 1000px !default;       // used in fadeBig and bounce modules\n\n\n// Rotate module settings\n$rotate-degrees \t\t\t\t: 90deg !default;\n$rotate-degrees-max \t\t\t: 200deg !default;\n$rotate-origin \t\t\t\t\t: center center !default;\n\n// Flipper module settings\n$flipper-perspective\t\t\t: 400px !default;\n$flipper-translate \t\t\t\t: 150px !default;\n$flipper-degrees \t\t\t\t: 10deg !default;\n$flipper-degrees-max \t\t\t: 90deg !default;\n\n\n// Hinge module settings\n$hinge-origin \t\t\t\t\t: top left !default;\n$hinge-degrees-max \t\t\t\t: 80deg !default;\n$hinge-translate \t\t\t\t: 700px !default;\n\n\n//==================================================================================================//\n// Module loading                                                                                   //\n//==================================================================================================//\n// To include an animation module in the compiled css file, simply set it's attribute below to true //\n// (all modules set to false will not be included)                                                  //\n// The idea here is to only load the animations you want to use on a per project basis              //\n// This helps keep the compiled css file at its leanest                                             //\n//==================================================================================================//\n// Hugely influenced and inspired by @csswizardry's inuit.css _vars.scss file                       //\n//==================================================================================================//\n\n$use-all                    :   false !default; // all animations status\n$use-fade               :   $use-all !default; // all fades\n$use-bounce             :   $use-all !default; // all bounces\n$use-rotate             :   $use-all !default; // all rotates\n$use-slide              :   $use-all !default; // all slide animations\n$use-flipers            :   $use-all !default; // all flip animations\n$use-light-speed        :   $use-all !default; // all light speed animations\n$use-attention-seekers  :   $use-all !default; // all attention seeker animations\n$use-special            :   $use-all !default; // all special animations\n$use-zoom               :   $use-all !default; // all zoom animations\n// Fade Enter\n$use-fade-in            :   $use-fade !default;\n$use-fadeIn \t\t\t:\t$use-fade-in !default;\n$use-fadeInUp \t\t\t:\t$use-fade-in !default;\n$use-fadeInUpBig \t\t:\t$use-fade-in !default;\n$use-fadeInDown \t\t:\t$use-fade-in !default;\n$use-fadeInDownBig \t\t:\t$use-fade-in !default;\n$use-fadeInLeft \t\t:\t$use-fade-in !default;\n$use-fadeInLeftBig \t\t:\t$use-fade-in !default;\n$use-fadeInRight \t\t:\t$use-fade-in !default;\n$use-fadeInRightBig \t:\t$use-fade-in !default;\n\n\n// Fade Exit\n$use-fade-out           :   $use-fade !default;\n$use-fadeOut\t\t\t:   $use-fade-out !default;\n$use-fadeOutUp\t\t\t:\t$use-fade-out !default;\n$use-fadeOutUpBig   \t:\t$use-fade-out !default;\n$use-fadeOutDown\t\t:\t$use-fade-out !default;\n$use-fadeOutDownBig \t:\t$use-fade-out !default;\n$use-fadeOutLeft\t\t:\t$use-fade-out !default;\n$use-fadeOutLeftBig \t:\t$use-fade-out !default;\n$use-fadeOutRight\t\t:\t$use-fade-out !default;\n$use-fadeOutRightBig\t:\t$use-fade-out !default;\n\n\n// Bounce Enter\n$use-bounce-in          :   $use-bounce !default;\n$use-bounceIn\t\t\t:\t$use-bounce-in !default;\n$use-bounceInUp\t\t\t: \t$use-bounce-in !default;\n$use-bounceInDown \t\t: \t$use-bounce-in !default;\n$use-bounceInLeft \t\t: \t$use-bounce-in !default;\n$use-bounceInRight \t\t: \t$use-bounce-in !default;\n\n\n// Bounce Exit\n$use-bounce-out         :   $use-bounce !default;\n$use-bounceOut\t\t\t:\t$use-bounce-out !default;\n$use-bounceOutUp\t\t: \t$use-bounce-out !default;\n$use-bounceOutDown \t\t: \t$use-bounce-out !default;\n$use-bounceOutLeft \t\t: \t$use-bounce-out !default;\n$use-bounceOutRight \t: \t$use-bounce-out !default;\n\n\n\n// Rotate Enter\n$use-rotate-in          :   $use-rotate !default;\n$use-rotateIn \t\t\t:\t$use-rotate-in !default;\n$use-rotateInUpLeft \t: \t$use-rotate-in !default;\n$use-rotateInUpRight \t: \t$use-rotate-in !default;\n$use-rotateInDownLeft \t: \t$use-rotate-in !default;\n$use-rotateInDownRight \t: \t$use-rotate-in !default;\n\n\n// Rotate Exit\n$use-rotate-out         :   $use-rotate !default;\n$use-rotateOut \t\t\t:\t$use-rotate-out !default;\n$use-rotateOutUpLeft \t: \t$use-rotate-out !default;\n$use-rotateOutUpRight \t: \t$use-rotate-out !default;\n$use-rotateOutDownLeft \t: \t$use-rotate-out !default;\n$use-rotateOutDownRight : \t$use-rotate-out !default;\n\n\n// Slide Enter\n$use-slide-in           :   $use-slide !default;\n$use-slideIn\t\t\t:   $use-slide-in !default;\n$use-slideInUp\t\t\t:   $use-slide-in !default;\n$use-slideInDown\t\t:   $use-slide-in !default;\n$use-slideInLeft\t\t:   $use-slide-in !default;\n$use-slideInRight\t\t:   $use-slide-in !default;\n\n// Slide Exit\n$use-slide-out          :   $use-slide !default;\n$use-slideOut\t\t\t:   $use-slide-out !default;\n$use-slideOutUp\t\t\t:   $use-slide-out !default;\n$use-slideOutDown\t\t:   $use-slide-out !default;\n$use-slideOutLeft\t\t:   $use-slide-out !default;\n$use-slideOutRight\t\t:   $use-slide-out !default;\n\n// Flippers\n$use-flip\t\t\t\t:\t$use-flipers !default;\n$use-flipInX\t\t\t:\t$use-flipers !default;\n$use-flipInY\t\t\t:\t$use-flipers !default;\n$use-flipOutX\t\t\t:\t$use-flipers !default;\n$use-flipOutY\t\t\t:\t$use-flipers !default;\n\n\n// Lightspeed\n$use-lightSpeedIn \t\t:\t$use-light-speed !default;\n$use-lightSpeedOut \t\t:\t$use-light-speed !default;\n\n\n// Attention Seekers\n$use-bounce\t\t\t\t:\t$use-attention-seekers !default;\n$use-flash\t\t\t\t:\t$use-attention-seekers !default;\n$use-pulse\t\t\t\t:\t$use-attention-seekers !default;\n$use-wiggle\t\t\t\t:\t$use-attention-seekers !default;\n$use-swing\t\t\t\t:\t$use-attention-seekers !default;\n$use-shake\t\t\t\t:\t$use-attention-seekers !default;\n$use-tada\t\t\t\t:\t$use-attention-seekers !default;\n$use-wobble\t\t\t\t:\t$use-attention-seekers !default;\n\n\n// Special\n$use-hinge\t\t\t\t:\t$use-special !default;\n$use-rollIn\t\t\t\t: \t$use-special !default;\n$use-rollOut \t\t\t:\t$use-special !default;\n\n\n// Zoom In\n$use-zoom-in            :   $use-zoom !default;\n$use-zoomIn \t\t\t:\t$use-zoom-in !default;\n$use-zoomInDown \t\t:\t$use-zoom-in !default;\n$use-zoomInLeft \t\t:\t$use-zoom-in !default;\n$use-zoomInRight \t\t:\t$use-zoom-in !default;\n$use-zoomInUp \t\t\t:\t$use-zoom-in !default;\n\n\n// Zoom Out\n$use-zoom-out           :   $use-zoom !default;\n$use-zoomOut\t\t\t:\t$use-zoom-out !default;\n$use-zoomOutDown\t\t:\t$use-zoom-out !default;\n$use-zoomOutLeft\t\t:\t$use-zoom-out !default;\n$use-zoomOutRight\t\t:\t$use-zoom-out !default;\n$use-zoomOutUp\t\t\t:\t$use-zoom-out !default;\n","@if $use-fadeIn == true {\n\n\t@include animate-keyframe(fadeIn) {\n\t\t0% {opacity: 0;}\n\t\t100% {opacity: 1;}\n\t}\n\n\t.fadeIn {\n\t\t@include animate-prefixer(animation-name, fadeIn);\n\t}\n\n}\n","@if $use-fadeInDown == true {\n\n\t@-webkit-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInDown {\n\t\t@include animate-prefixer(animation-name, fadeInDown);\n\t}\n\n}\n","@if $use-fadeInUp == true {\n\n\t@-webkit-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInUp {\n\t\t@include animate-prefixer(animation-name, fadeInUp);\n\t}\n\n}\n","@if $use-fadeOut == true {\n\n\t@include animate-keyframe(fadeOut) {\n\t\t0% {opacity: 1;}\n\t\t100% {opacity: 0;}\n\t}\n\n\t.fadeOut {\n\t\t@include animate-prefixer(animation-name, fadeOut);\n\t}\n\n}\n","@if $use-lightSpeedIn == true {\n\n\t@-webkit-keyframes lightSpeedIn {\n\t\t0% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { -webkit-transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { -webkit-transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t@keyframes lightSpeedIn {\n\t\t0% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t.lightSpeedIn {\n\t\t@include animate-prefixer(animation-name, lightSpeedIn);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-out);\n\t}\n\n}\n","@if $use-lightSpeedOut == true {\n\n\t@-webkit-keyframes lightSpeedOut {\n\t\t0% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t@keyframes lightSpeedOut {\n\t\t0% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t.lightSpeedOut {\n\t\t@include animate-prefixer(animation-name, lightSpeedOut);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-in);\n\t}\n}\n","// Common Comps Animations\r\n\r\n\r\n$base-duration\t\t\t\t\t: .2s;\r\n$base-distance                  : 10px;\r\n$base-fill-mode\t\t\t\t\t: both;\r\n\r\n// Dropdown Animation\r\n\r\n.dropdown-menu {\r\n  &.show {\r\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\r\n  }\r\n}\r\n\r\n.popover {\r\n  &.show {\r\n    display: block;\r\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  &[data-placement^=\"top\"].show {\r\n    animation: fade-in3 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\r\n    bottom: auto !important;\r\n    top: auto !important;\r\n  }\r\n}\r\n\r\n@keyframes fade-in2 {\r\n  0% {\r\n    margin-top: -50px;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    margin-top: 0px;\r\n    visibility: visible;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.form-control {\r\n  transition: all .2s;\r\n}\r\n","// Buttons\r\n\r\n// 2x Outline Border\r\n$btn-block-spacing-y:         .5rem !default;\r\n\r\n@use \"sass:math\";\r\n\r\n.btn-outline-2x {\r\n  border-width: 2px;\r\n}\r\n\r\n.btn-group {\r\n  .btn {\r\n    font-size: 0.8rem;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .btn-outline-2x + .btn-outline-2x {\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .btn-square {\r\n    @include border-radius(0);\r\n  }\r\n}\r\n\r\n.btn {\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n\r\n  // Pills Buttons\r\n\r\n  &.btn-pill.btn-wide,\r\n  &.btn-pill {\r\n    @include border-start-radius(50px);\r\n    @include border-end-radius(50px);\r\n  }\r\n\r\n}\r\n\r\n// Dashed Border\r\n\r\n.btn-dashed {\r\n  border-style: dashed;\r\n}\r\n\r\n// Icon Buttons\r\n\r\n.btn-icon {\r\n  vertical-align: bottom;\r\n\r\n  &.btn-icon-right {\r\n    .btn-icon-wrapper {\r\n      margin-left: math.div($spacer, 2);\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  .btn-icon-wrapper {\r\n    margin-right: math.div($spacer, 2);\r\n    margin-left: 0;\r\n    margin-top: 0;\r\n    font-size: 17px;\r\n    vertical-align: middle;\r\n    transition: color .1s;\r\n    display: inline-block;\r\n  }\r\n\r\n  &.btn-link {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.btn-lg:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 25px;\r\n    }\r\n  }\r\n\r\n  &.btn-sm:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n.btn-icon-only {\r\n  .btn-icon-wrapper {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n// Hover Shine {\r\n\r\n.btn-hover-shine {\r\n  position: relative;\r\n\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 0;\r\n    height: 100%;\r\n    background-color: rgba(255, 255, 255, 0.4);\r\n    -webkit-transition: none;\r\n    -moz-transition: none;\r\n    transition: none;\r\n  }\r\n\r\n  &:hover:after {\r\n    width: 120%;\r\n    background-color: rgba(255, 255, 255, 0);\r\n    transition: all 0.4s ease-in-out;\r\n  }\r\n\r\n  &.btn-pill {\r\n    &::after {\r\n      @include border-start-radius(50px);\r\n      @include border-end-radius(50px);\r\n    }\r\n  }\r\n}\r\n\r\n// Vertical Icons {\r\n\r\n.btn-icon-vertical {\r\n  padding-top: ($btn-block-spacing-y * 2);\r\n  padding-bottom: ($btn-block-spacing-y * 2);\r\n\r\n  .btn-icon-wrapper {\r\n    display: block;\r\n    font-size: 200%;\r\n    margin: 5px 0;\r\n    opacity: .6;\r\n  }\r\n\r\n  &.btn-link {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.btn-lg:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 25px;\r\n    }\r\n  }\r\n\r\n  &.btn-sm:not(.btn-block) {\r\n    .btn-icon-wrapper {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n\r\n  &:active,\r\n  &.active,\r\n  &:hover {\r\n    .btn-icon-wrapper {\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  &.btn-icon-bottom {\r\n    .btn-icon-wrapper {\r\n      margin: math.div($spacer, 5) 0 5px;\r\n    }\r\n  }\r\n\r\n  &.btn-transition-text {\r\n    .btn-icon-wrapper {\r\n      transition: all .2s !important;\r\n    }\r\n\r\n    &:hover {\r\n      .btn-icon-wrapper {\r\n        transform: scale(1.3);\r\n      }\r\n    }\r\n\r\n    &.btn-transition-alt {\r\n\r\n      &:hover {\r\n        .btn-icon-wrapper {\r\n          color: $white !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btn-icon-lg {\r\n  font-size: $h1-font-size !important;\r\n}\r\n\r\n// Buttons Transitions\r\n\r\n.btn-transition {\r\n  color: $gray-600;\r\n  border-color: $gray-200;\r\n  background-color: none;\r\n\r\n  &.btn-outline-link {\r\n    border-color: transparent;\r\n    background-color: transparent;\r\n\r\n    &:hover {\r\n      color: $primary;\r\n      background: $gray-100;\r\n    }\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $gray-600;\r\n    border-color: $gray-200;\r\n  }\r\n\r\n  &:hover {\r\n    .btn-icon-wrapper {\r\n      transition: none;\r\n    }\r\n  }\r\n}\r\n\r\n.btn-transition-alt {\r\n  &:hover {\r\n    .icon-gradient {\r\n      -webkit-background-clip: initial;\r\n      -webkit-text-fill-color: initial;\r\n      background-clip: initial;\r\n      text-fill-color: initial;\r\n      background: none !important;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n// Square Buttons\r\n\r\n.btn-square {\r\n  @include border-radius(0 !important);\r\n}\r\n.active-btn{\r\n  border: 1px solid rgb(212, 212, 212);\r\n    border-radius: 1rem;\r\n    padding: 1em;\r\n    background-color: rgb(241, 241, 241);\r\n    box-shadow: 1px solid black;\r\n}\r\n.inactive-btn{\r\n  border: 1px solid rgb(212, 212, 212);\r\n    border-radius: 1rem;\r\n    padding: 1em;\r\n    background-color: inherit;\r\n    box-shadow: 1px solid black;\r\n}\r\n// Wide buttons\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.spinner {\r\n  width: 20px;\r\n  height: 20px;\r\n  // border: 5px solid rgba(0, 0, 0, 0.1);\r\n  // border-top-color: #3498db;\r\n  // border-radius: 50%;\r\n  background-color: none;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.btn {\r\n  &.btn-wide {\r\n    @include button-size($btn-padding-y, ($btn-padding-x * 2), $font-size-xs, $btn-border-radius);\r\n  }\r\n}\r\n\r\n.btn-lg {\r\n  &.btn-wide {\r\n    @include button-size($btn-padding-y-lg, ($btn-padding-x-lg * 2), $font-size-lg,  $btn-border-radius-lg);\r\n  }\r\n}\r\n\r\n.btn-sm {\r\n  &.btn-wide {\r\n    @include button-size($btn-padding-y-sm, ($btn-padding-x-sm * 2), $font-size-xs, $btn-border-radius-sm);\r\n  }\r\n}\r\n\r\n// Dropdown toggle\r\n\r\n.dropdown-toggle {\r\n  &::after {\r\n    position: relative;\r\n    top: 2px;\r\n    opacity: .8;\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-toggle {\r\n    &::after {\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  border-left: rgba(255, 255, 255, .1) solid 1px;\r\n}\r\n\r\n// Buttons Gradients\r\n\r\n$btn-gradients: ();\r\n\r\n$gradient-primary: $brand;\r\n$gradient-secondary: $gray-600;\r\n$gradient-success: $green;\r\n$gradient-info: $cyan;\r\n$gradient-warning: $yellow;\r\n$gradient-danger: $red;\r\n$gradient-light: $blue-light;\r\n$gradient-dark: $gray-800;\r\n$gradient-focus: $indigo;\r\n$gradient-alt: $purple;\r\n\r\n$gradinet-percent: 15%;\r\n\r\n$btn-gradients: map_merge(\r\n                (\r\n                        \"primary\": (\r\n                                darken($gradient-primary, $gradinet-percent), // color-start\r\n                                $gradient-primary, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"secondary\": (\r\n                                darken($gradient-secondary, $gradinet-percent), // color-start\r\n                                $gradient-secondary, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"success\": (\r\n                                darken($gradient-success, $gradinet-percent), // color-start\r\n                                $gradient-success, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"info\": (\r\n                                darken($gradient-info, $gradinet-percent), // color-start\r\n                                $gradient-info, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"warning\": (\r\n                                darken($gradient-warning, $gradinet-percent), // color-start\r\n                                $gradient-warning, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"danger\": (\r\n                                darken($gradient-danger, $gradinet-percent), // color-start\r\n                                $gradient-danger, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"focus\": (\r\n                                darken($gradient-focus, $gradinet-percent), // color-start\r\n                                $gradient-focus, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"alternate\": (\r\n                                darken($gradient-alt, $gradinet-percent), // color-start\r\n                                $gradient-alt, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"light\": (\r\n                                darken($gradient-light, $gradinet-percent), // color-start\r\n                                $gradient-light, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                        \"dark\": (\r\n                                darken($gradient-dark, $gradinet-percent), // color-start\r\n                                $gradient-dark, // color-end\r\n                                0%, // gr-start\r\n                        ),\r\n                ),\r\n                $btn-gradients\r\n);\r\n\r\n@mixin btn-grad-variant($color-start, $color-end, $gr-start) {\r\n  background-image: linear-gradient(140deg, $color-start -30%, $color-end 90%);\r\n  background-color: $color-start;\r\n  border-color: $color-start;\r\n  color: color-yiq(darken($color-start, 10%));\r\n\r\n  &.active,\r\n  &:active,\r\n  &:not(:disabled):not(.disabled):hover {\r\n    background-image: linear-gradient(120deg, darken($color-start, 3%) 0%, darken($color-end, 3%) 100%);\r\n    color: color-yiq(darken($color-start, 10%));\r\n    border-color: darken($color-start, 10%);\r\n  }\r\n\r\n  &:focus,\r\n  &.focus,\r\n  &:active,\r\n  &.active {\r\n    color: color-yiq(darken($color-start, 10%)) !important;\r\n    border-color: darken($color-end, 20%) !important;\r\n  }\r\n\r\n}\r\n\r\n@each $grad, $colors in $btn-gradients {\r\n  $color: nth($colors, 1);\r\n  $color1: nth($colors, 2);\r\n  $color2: nth($colors, 3);\r\n\r\n  .btn-gradient-#{$grad} {\r\n    @include btn-grad-variant($color, $color1, $color2);\r\n\r\n    &.btn-shadow {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($color1, .4), 0 0.0625rem 0.125rem rgba($color1, .5);\r\n\r\n      &:hover {\r\n        box-shadow: 0 0.125rem 0.625rem rgba($color1, .5), 0 0.0625rem 0.125rem rgba($color1, .6);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btn-shadow {\r\n  &.active {\r\n    box-shadow: 0 0 0 0 transparent !important;\r\n  }\r\n}\r\n\r\n// Links\r\n\r\n$link-color: $primary;\r\n$link-hover-color: darken($link-color, 15%);\r\n\r\n// Generate Buttons\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color} {\r\n    @include button-variant($value, $value);\r\n\r\n    &.btn-shadow {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\r\n\r\n      &:hover {\r\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-shadow-#{$color} {\r\n    &:hover {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-outline-#{$color} {\r\n    @include button-outline-variant($value);\r\n\r\n    &.btn-shadow {\r\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\r\n\r\n      &.active:hover,\r\n      &.disabled:hover,\r\n      &:active:hover,\r\n      &:disabled:hover {\r\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\r\n      }\r\n\r\n      &:hover {\r\n        box-shadow: (0px 5px 15px 2px rgba($value, 0.19));\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.btn {\r\n  position: relative;\r\n  @include transition($btn-transition);\r\n}\r\n\r\n.btn-light {\r\n  border-color: darken(#f5f5f5, 10%);\r\n}\r\n\r\n.btn-outline-light {\r\n  color: darken(#f5f5f5, 40%);\r\n}","// Dropdown\r\n\r\n@use \"sass:math\";\r\n\r\n.dropdown-menu {\r\n  box-shadow: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03),\r\n  0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03),\r\n  0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05),\r\n  0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\r\n  font-size: $font-size-base;\r\n\r\n  margin: $dropdown-spacer;\r\n\r\n  &.dropdown-menu-right {\r\n    right: 0 !important;\r\n  }\r\n\r\n  .dropdown-header {\r\n    text-transform: uppercase;\r\n    font-size: math.div($font-size-base, 1.2);\r\n    color: $primary;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .dropdown-item {\r\n    font-size: $font-size-base;\r\n    display: flex;\r\n    align-items: center;\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n    cursor: pointer;\r\n    z-index: 6;\r\n    position: relative;\r\n\r\n    .dropdown-icon {\r\n      font-size: 1rem;\r\n      margin-right: math.div($dropdown-padding-y, 2);\r\n      width: 30px;\r\n      text-align: center;\r\n      opacity: .3;\r\n      margin-left: -10px;\r\n    }\r\n\r\n    &:hover {\r\n      .dropdown-icon {\r\n        opacity: .7;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.dropdown-menu-shadow {\r\n    box-shadow: 0 0.66875rem 2.3875rem rgba(darken($primary, 50%), .03),\r\n    0 1.1375rem 1.60625rem rgba(darken($primary, 50%), .03),\r\n    0 0.45rem 0.73125rem rgba(darken($primary, 50%), .05),\r\n    0 0.325rem 0.3875rem rgba(darken($primary, 50%), .03);\r\n  }\r\n}\r\n\r\n.dropdown-menu-rounded {\r\n  @include border-radius(10px);\r\n  padding: $dropdown-padding-y;\r\n\r\n  .dropdown-item {\r\n    @include border-radius(30px);\r\n  }\r\n\r\n  .dropdown-divider {\r\n    margin-left: -$dropdown-padding-y;\r\n    margin-right: -$dropdown-padding-y;\r\n  }\r\n\r\n  .dropdown-menu-header {\r\n    margin-left: -$dropdown-padding-y;\r\n    margin-right: -$dropdown-padding-y;\r\n    @include border-top-radius(10px);\r\n  }\r\n\r\n  .menu-header-image,\r\n  .dropdown-menu-header-inner {\r\n    @include border-top-radius(10px);\r\n  }\r\n}\r\n\r\n.dropdown-menu-hover-link {\r\n  .dropdown-item {\r\n    &:hover {\r\n      background: none;\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu-hover-primary {\r\n  .dropdown-item {\r\n    &:hover {\r\n      background: $primary;\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  &.dropdown-menu-lg {\r\n    min-width: 22rem;\r\n  }\r\n\r\n  &.dropdown-menu-xl {\r\n    min-width: 25rem;\r\n  }\r\n}\r\n\r\n// Dropdown header\r\n\r\n.dropdown-menu {\r\n  .dropdown-menu-header,\r\n  .menu-header-image,\r\n  .dropdown-menu-header-inner {\r\n    @include border-top-radius($dropdown-border-radius);\r\n  }\r\n}\r\n\r\n.dropdown-menu-header {\r\n  color: $white;\r\n  margin-top: -$dropdown-padding-y;\r\n  margin-bottom: $dropdown-padding-y;\r\n  position: relative;\r\n  z-index: 6;\r\n\r\n  .dropdown-menu-header-inner {\r\n    margin: -1px -1px 0;\r\n    padding: ($spacer * 1.5) math.div($spacer, 2);\r\n    position: relative;\r\n  }\r\n\r\n  .menu-header-image {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 8;\r\n    opacity: .25;\r\n    filter: grayscale(80%);\r\n    background-size: cover;\r\n  }\r\n\r\n  .menu-header-content {\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 10;\r\n\r\n    &.text-start {\r\n      padding-left: math.div($spacer, 2);\r\n    }\r\n\r\n    &.btn-pane-right {\r\n      padding-left: math.div($spacer, 2);\r\n      padding-right: math.div($spacer, 2);\r\n      display: flex;\r\n      align-content: center;\r\n      align-items: center;\r\n      text-align: left;\r\n\r\n      .menu-header-btn-pane {\r\n        margin: 0 0 0 auto;\r\n      }\r\n    }\r\n\r\n    .menu-header-btn-pane {\r\n      margin-top: 10px;\r\n      margin-bottom: 3px;\r\n    }\r\n  }\r\n\r\n  & + .grid-menu {\r\n    margin-top: -$dropdown-padding-y;\r\n  }\r\n}\r\n\r\n.menu-header-title {\r\n  font-weight: 500;\r\n  font-size: $h5-font-size;\r\n  margin: 0;\r\n}\r\n\r\n.menu-header-subtitle {\r\n  font-size: $font-family-base;\r\n  margin: 5px 0 0;\r\n  opacity: .8;\r\n}\r\n\r\n.dropdown-menu {\r\n  .grid-menu {\r\n    margin-bottom: -$dropdown-padding-y;\r\n    padding: 1px;\r\n\r\n    [class*=\"col-\"] {\r\n      padding: $dropdown-padding-y;\r\n    }\r\n  }\r\n\r\n  .grid-menu-xl {\r\n    margin-bottom: -(math.div($dropdown-padding-y, 1.35));\r\n\r\n    [class*=\"col-\"] {\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Dropdown toggle\r\n\r\n.dropdown-toggle {\r\n  &::after {\r\n    position: relative;\r\n    top: 2px;\r\n    opacity: .8;\r\n    margin-left: 5px;\r\n  }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-toggle {\r\n    &::after {\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  border-left: rgba(255, 255, 255, .1) solid 2px;\r\n}\r\n\r\n// Dropdown Indicators\r\n\r\n.dropdown-menu {\r\n\r\n  &::before,\r\n  &::after {\r\n    position: absolute;\r\n    width: 14px;\r\n    height: 14px;\r\n    left: 5px;\r\n    top: -5px;\r\n    transform: rotate(45deg);\r\n    border-radius: 4px;\r\n    content: '';\r\n    display: block;\r\n    z-index: 5;\r\n  }\r\n\r\n  &::before {\r\n    background: $dropdown-bg;\r\n    z-index: 5;\r\n  }\r\n\r\n  &::after {\r\n    top: -6px;\r\n    background: $dropdown-border-color;\r\n    z-index: 4;\r\n  }\r\n\r\n  &[data-placement=\"top-start\"] {\r\n    &::before,\r\n    &::after {\r\n      top: auto;\r\n      bottom: -5px;\r\n    }\r\n\r\n    &::after {\r\n      bottom: -6px;\r\n    }\r\n  }\r\n\r\n  &[data-placement=\"left-start\"] {\r\n    &::before,\r\n    &::after {\r\n      left: auto;\r\n      right: -5px;\r\n      top: 5px;\r\n    }\r\n\r\n    &::after {\r\n      top: 5px;\r\n      right: -6px;\r\n    }\r\n  }\r\n\r\n  &[data-placement=\"right-start\"] {\r\n    &::before,\r\n    &::after {\r\n      right: auto;\r\n      left: -5px;\r\n      top: 5px;\r\n    }\r\n\r\n    &::after {\r\n      top: 5px;\r\n      left: -6px;\r\n    }\r\n  }\r\n\r\n  &.dropdown-menu-right {\r\n    &::before,\r\n    &::after {\r\n      left: auto;\r\n      right: 6px;\r\n    }\r\n\r\n    &::after {\r\n      right: 6px;\r\n    }\r\n  }\r\n\r\n  &.rm-pointers {\r\n    &::before,\r\n    &::after {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Dropdown Mega Menu\r\n\r\n.dropdown-mega-menu {\r\n  width: 56rem;\r\n  padding: $spacer;\r\n\r\n  .nav-item.nav-item-header {\r\n    text-transform: none;\r\n    font-size: $h6-font-size;\r\n    padding-top: 0;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .grid-menu {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.dropdown-mega-menu-sm {\r\n  width: 40rem;\r\n}\r\n\r\n// Dropdown Inline\r\n\r\nbody .dropdown-menu.dropdown-menu-inline {\r\n  border: 0;\r\n  position: static !important;\r\n  box-shadow: 0 0 0 transparent;\r\n  background: transparent;\r\n  @include border-radius(0);\r\n  display: inline-block;\r\n  float: none;\r\n  left: 0 !important;\r\n  top: 0 !important;\r\n  width: 100% !important;\r\n  transform: translateY(0) !important;\r\n\r\n  &::before,\r\n  &::after {\r\n    display: none;\r\n  }\r\n}\r\n","// NAVS\r\n\r\n@use \"sass:math\";\r\n\r\n.nav-item {\r\n  .nav-link {\r\n    font-weight: normal;\r\n  }\r\n}\r\n\r\n.nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n  cursor: pointer;\r\n\r\n  .nav-link-icon {\r\n    color: $primary;\r\n    font-size: 1rem;\r\n    width: 30px;\r\n    text-align: center;\r\n    opacity: .45;\r\n    margin-left: -10px;\r\n  }\r\n\r\n  &:hover {\r\n    color: $gray-700;\r\n\r\n    .nav-link-icon {\r\n      opacity: .9;\r\n      color: $primary;\r\n    }\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    .nav-link-icon {\r\n      opacity: .3;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-item {\r\n  &.nav-item-header {\r\n    text-transform: uppercase;\r\n    font-size: math.div($font-size-base, 1.2);\r\n    color: $gray-600;\r\n    font-weight: bold;\r\n    padding: $nav-link-padding-y $nav-link-padding-x;\r\n  }\r\n\r\n  &.nav-item-btn {\r\n    padding: $nav-link-padding-y $nav-link-padding-x;\r\n  }\r\n\r\n  &.nav-item-divider {\r\n    margin: $nav-link-padding-y 0;\r\n    height: 1px;\r\n    overflow: hidden;\r\n    background: $gray-300;\r\n  }\r\n}\r\n\r\n.nav {\r\n  .badge {\r\n    margin-left: 8px;\r\n  }\r\n}\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n\r\n    &.active,\r\n    &.active:hover {\r\n      color: $white;\r\n\r\n      .nav-link-icon {\r\n        color: $white;\r\n        opacity: .8;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      color: $gray-700 !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Grid Menus\r\n\r\n.grid-menu {\r\n\r\n  [class*=\"col-\"] {\r\n    border-right: $border-color solid 0;\r\n    border-bottom: $border-color solid 1px;\r\n\r\n    &:hover {\r\n      z-index: 5;\r\n    }\r\n  }\r\n\r\n  // @include media-breakpoint-between(sm, xl) {\r\n\r\n    [class*=\"col-\"]:nth-last-child(-n+2) {\r\n      border-bottom-width: 0;\r\n    }\r\n\r\n    [class*=\"col-\"]:nth-child(1n) {\r\n      border-right-width: 1px;\r\n    }\r\n\r\n    [class*=\"col-\"]:nth-child(2n) {\r\n      border-right-width: 0;\r\n    }\r\n  // }\r\n\r\n  [class*=\"col-\"]:nth-last-child(-n+1) {\r\n    border-bottom-width: 0;\r\n  }\r\n\r\n  &.grid-menu-3col {\r\n\r\n    // @include media-breakpoint-up(xl) {\r\n\r\n      [class*=\"col-\"]:nth-last-child(-n+3) {\r\n        border-bottom-width: 0;\r\n      }\r\n\r\n      [class*=\"col-\"]:nth-child(2n) {\r\n        border-right-width: 1px;\r\n      }\r\n\r\n      [class*=\"col-\"]:nth-child(3n) {\r\n        border-right-width: 0;\r\n      }\r\n    // }\r\n  }\r\n\r\n  .btn {\r\n    display: block;\r\n    border: 0;\r\n    min-width: 100%;\r\n  }\r\n}\r\n\r\n","// Badges\r\n\r\n// @each $color, $value in $theme-colors {\r\n//   .badge-#{$color} {\r\n//     @include badge-variant($value);\r\n//   }\r\n// }\r\n\r\n.badge {\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  padding: 5px 10px;\r\n  min-width: 19px;\r\n}\r\n\r\n.badge-light {\r\n  background: $white;\r\n}\r\n\r\n.badge-dot {\r\n  text-indent: -999em;\r\n  padding: 0;\r\n  width: 8px;\r\n  height: 8px;\r\n  border: transparent solid 1px;\r\n  @include border-radius(30px);\r\n  min-width: 2px;\r\n}\r\n\r\n.badge-dot-lg {\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n.badge-dot-xl {\r\n  width: 18px;\r\n  height: 18px;\r\n  position: relative;\r\n\r\n  &::before {\r\n    content: '';\r\n    width: 10px;\r\n    height: 10px;\r\n    @include border-radius($border-radius);\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: -5px 0 0 -5px;\r\n    background: $white;\r\n  }\r\n}\r\n\r\n.badge-dot-sm {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n.btn {\r\n  .badge {\r\n    margin-left: 8px;\r\n  }\r\n\r\n  .badge-dot {\r\n    position: absolute;\r\n    border: $white solid 2px;\r\n    top: -5px;\r\n    right: -5px;\r\n    width: 11px;\r\n    height: 11px;\r\n\r\n    &.badge-dot-lg {\r\n      width: 14px;\r\n      height: 14px;\r\n    }\r\n\r\n    &.badge-dot-sm {\r\n      width: 8px;\r\n      height: 8px;\r\n      border-width: 1px;\r\n    }\r\n  }\r\n\r\n  .badge-dot-inside {\r\n    top: 10px;\r\n    right: 10px;\r\n  }\r\n}\r\n\r\n.btn-sm {\r\n  .badge-dot-sm {\r\n    top: 1px;\r\n    right: 4px;\r\n  }\r\n\r\n  .badge-dot {\r\n    top: 0px;\r\n    right: 2px;\r\n  }\r\n\r\n  .badge-dot-lg {\r\n    top: -3px;\r\n    right: -2px;\r\n  }\r\n\r\n  .rounded-pill {\r\n    position: absolute;\r\n    top: -4px;\r\n    right: -4px;\r\n  }\r\n}\r\n\r\n.badge-abs {\r\n  position: absolute;\r\n  right: -3px;\r\n  top: -3px;\r\n}\r\n\r\n// Avatars\r\n\r\n.avatar-icon-wrapper {\r\n  display: inline-block;\r\n  margin-right: .1rem;\r\n  position: relative;\r\n\r\n  .badge {\r\n    position: absolute;\r\n    right: -2px;\r\n    top: -2px;\r\n\r\n    &:empty {\r\n      display: block;\r\n    }\r\n\r\n    &.badge-bottom {\r\n      top: auto;\r\n      right: -2px;\r\n      bottom: -2px;\r\n    }\r\n  }\r\n\r\n  .badge-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border: $white solid 2px;\r\n\r\n    &.badge-dot-lg {\r\n      width: 14px;\r\n      height: 14px;\r\n      border: $white solid 2px;\r\n      top: 0;\r\n      right: 0;\r\n\r\n      &.badge-bottom {\r\n        top: auto;\r\n        right: 0;\r\n        bottom: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-add {\r\n\r\n  .avatar-icon {\r\n    background: $dropdown-link-hover-bg;\r\n    border: lighten($primary, 15%) dashed 1px;\r\n    color: $primary;\r\n    text-align: center;\r\n    opacity: .6;\r\n\r\n    i {\r\n      font-style: normal;\r\n      vertical-align: middle;\r\n      font-size: $h4-font-size;\r\n      display: block;\r\n      height: 100%;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n\r\n    .avatar-icon {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n\r\na.avatar-icon-wrapper {\r\n  &:hover {\r\n\r\n    .avatar-icon {\r\n      opacity: .8;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon {\r\n  display: block;\r\n  width: 44px;\r\n  height: 44px;\r\n  transition: all .2s;\r\n  opacity: 1;\r\n  @include border-radius(50px);\r\n\r\n  &.rounded {\r\n    @include border-radius(($border-radius-lg * 1.3) !important);\r\n  }\r\n}\r\n\r\n.avatar-icon-xl {\r\n  .avatar-icon {\r\n    width: 64px;\r\n    height: 64px;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      font-size: $h2-font-size;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-lg {\r\n  .avatar-icon {\r\n    width: 54px;\r\n    height: 54px;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      font-size: $h3-font-size;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-sm {\r\n  .avatar-icon {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      font-size: $font-size-lg;\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon-xs {\r\n  .avatar-icon {\r\n    width: 26px;\r\n    height: 26px;\r\n    transition: transform .2s;\r\n  }\r\n\r\n  &.avatar-icon-add {\r\n    i {\r\n      line-height: 26px;\r\n      font-size: $font-size-base;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    .avatar-icon {\r\n      transform: scale(2);\r\n    }\r\n  }\r\n}\r\n\r\n.avatar-icon {\r\n  border: $white solid 3px;\r\n  overflow: hidden;\r\n\r\n  img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.avatar-wrapper-overlap {\r\n  .avatar-icon-wrapper {\r\n    z-index: 5;\r\n    margin-left: -18px;\r\n\r\n    &:hover {\r\n      z-index: 7;\r\n    }\r\n\r\n    &.avatar-icon-xl {\r\n      margin-left: -30px;\r\n    }\r\n    &.avatar-icon-lg {\r\n      margin-left: -24px;\r\n    }\r\n    &.avatar-icon-sm {\r\n      margin-left: -14px;\r\n    }\r\n    &.avatar-icon-xs {\r\n      margin-left: -10px;\r\n    }\r\n\r\n    &.avatar-icon-add,\r\n    &:first-child {\r\n      margin-left: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Badge Pulse\r\n\r\n@-webkit-keyframes sploosh {\r\n  0% {\r\n    box-shadow: 0 0 0 0px rgba(#333, .2);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 8px rgba(#333, 0);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes pulse {\r\n  0% {\r\n    -webkit-transform: scale(1);\r\n  }\r\n  16.5% {\r\n    -webkit-transform: scale(1.2);\r\n  }\r\n  33% {\r\n    -webkit-transform: scale(1.1);\r\n  }\r\n  100% {\r\n    -webkit-transform: scale(1);\r\n  }\r\n}\r\n\r\n.badge-pulse {\r\n  -webkit-animation: pulse 2s ease-out;\r\n  -webkit-animation-iteration-count: infinite;\r\n  position: relative;\r\n\r\n  &::before,\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border: 0;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n\r\n    -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\r\n    -webkit-animation-iteration-count: infinite;\r\n  }\r\n\r\n  &::after {\r\n    -webkit-animation-delay: .33s;\r\n    -webkit-animation-duration: 2.2s;\r\n  }\r\n}","// CARDS\r\n\r\n@use \"sass:math\";\r\n\r\n.card {\r\n  box-shadow: $box-shadow-default;\r\n  border-width: 0;\r\n  transition: all .2s;\r\n\r\n  & > .dropdown-menu-header {\r\n    margin: 0;\r\n\r\n    .dropdown-menu-header-inner {\r\n      @include border-top-radius($card-border-radius);\r\n    }\r\n  }\r\n\r\n  &.text-dark.text-white,\r\n  &.text-white {\r\n    .card-footer,\r\n    .card-header {\r\n      background: rgba(255, 255, 255, .1);\r\n      color: rgba(255, 255, 255, .9);\r\n    }\r\n  }\r\n\r\n  &.text-dark.text-white {\r\n    .card-footer,\r\n    .card-header {\r\n      color: rgba(0, 0, 0, .9);\r\n    }\r\n  }\r\n\r\n  .card-footer {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.btn-actions-pane-right {\r\n  margin-left: auto;\r\n  white-space: nowrap;\r\n}\r\n\r\n.btn-actions-pane-left {\r\n  margin-right: auto;\r\n}\r\n\r\n.actions-icon-btn {\r\n  .btn-icon-only {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n\r\n    .btn-icon-wrapper {\r\n      font-size: 1.3rem;\r\n      width: 30px;\r\n      text-align: center;\r\n    }\r\n\r\n    color: $gray-700;\r\n\r\n    &:hover {\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.card-header,\r\n.card-title {\r\n  text-transform: uppercase;\r\n  color: rgba(darken($primary, 40%), .7);\r\n  font-weight: bold;\r\n  font-size: $font-size-base;\r\n}\r\n\r\n.card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  border-bottom-width: 1px;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  padding-right: math.div($card-spacer-x, 2);\r\n  height: 3.5rem;\r\n\r\n  &.no-border {\r\n    border: 0;\r\n    padding: 0;\r\n    height: auto;\r\n  }\r\n\r\n  .menu-header-subtitle {\r\n    display: block;\r\n  }\r\n\r\n  &.card-header-tab {\r\n    .nav {\r\n      width: auto;\r\n      margin-left: auto;\r\n    }\r\n\r\n    .card-header-title {\r\n      display: flex;\r\n      align-items: center;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n\r\n  .header-icon {\r\n    font-size: ($font-size-lg * 1.5);\r\n    margin-right: math.div($card-spacer-x, 2);\r\n  }\r\n\r\n  & > .nav {\r\n    margin-left: -(math.div($card-spacer-x, 2));\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    .nav-item {\r\n      position: relative;\r\n      height: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n\r\n    .nav-link {\r\n      text-transform: none;\r\n      width: 100%;\r\n      display: block;\r\n      color: $gray-700;\r\n\r\n      &::before {\r\n        content: '';\r\n        @include border-radius(15px);\r\n        background: $primary;\r\n        transition: all .2s;\r\n        height: 4px;\r\n        width: 100%;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -2px;\r\n        opacity: 0;\r\n      }\r\n\r\n      &:hover {\r\n        color: $primary;\r\n      }\r\n\r\n      &.active {\r\n        color: $primary;\r\n\r\n        &::before {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.card-header-tab-animation {\r\n    .nav .nav-link {\r\n      &::before {\r\n        transform: scale(0);\r\n        opacity: 1;\r\n        width: 90%;\r\n        left: 5%;\r\n      }\r\n\r\n      &.active,\r\n      &:hover {\r\n        &::before {\r\n          transform: scale(1);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.card-border {\r\n  box-shadow: 0 0 0 transparent;\r\n  border-width: 1px;\r\n}\r\n\r\n.card-hover-shadow {\r\n  &:hover {\r\n    box-shadow: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03),\r\n    0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03),\r\n    0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05),\r\n    0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\r\n  }\r\n}\r\n\r\n.card-hover-shadow-2x {\r\n  &:hover {\r\n    box-shadow: 0 0.66875rem 2.3875rem rgba(darken($primary, 50%), .03),\r\n    0 1.1375rem 1.60625rem rgba(darken($primary, 50%), .03),\r\n    0 0.45rem 0.73125rem rgba(darken($primary, 50%), .05),\r\n    0 0.325rem 0.3875rem rgba(darken($primary, 50%), .03);\r\n  }\r\n}\r\n\r\n.card-subtitle {\r\n  margin-bottom: $card-spacer-y;\r\n  font-size: $font-size-sm;\r\n  color: rgba(darken($primary, 40%), .55);\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .card-shadow-#{$color} {\r\n    box-shadow: 0 0.46875rem 2.1875rem rgba($value, .03),\r\n    0 0.9375rem 1.40625rem rgba($value, .03),\r\n    0 0.25rem 0.53125rem rgba($value, .05),\r\n    0 0.125rem 0.1875rem rgba($value, .03);\r\n  }\r\n}\r\n\r\n// Large Card Header\r\n\r\n.card-header-lg {\r\n  padding: ($card-spacer-y * 2) ($card-spacer-x * 2);\r\n  height: auto;\r\n}\r\n\r\n.sticky-active-class {\r\n  .sticky-inner-wrapper {\r\n    & > div {\r\n      box-shadow: $box-shadow-default;\r\n    }\r\n  }\r\n}","// TABS\r\n\r\n@use \"sass:math\";\r\n\r\n.nav-pills,\r\n.nav-tabs {\r\n  margin-bottom: $spacer;\r\n}\r\n\r\n.nav-link {\r\n  font-weight: bold;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.nav-tabs {\r\n  .nav-link {\r\n\r\n    &:hover {\r\n      color: $primary !important;\r\n    }\r\n\r\n    &.active {\r\n      color: $primary;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n\r\n    &:hover {\r\n      color: $primary !important;\r\n    }\r\n\r\n    &.active {\r\n      background: $primary;\r\n\r\n      &:hover {\r\n        color: $white !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Fancy Tabs\r\n\r\n.RRT__container {\r\n  position: relative;\r\n}\r\n\r\n.RRT__tabs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  position: relative;\r\n}\r\n\r\n.RRT__accordion {\r\n  flex-direction: column;\r\n}\r\n\r\n.RRT__tab {\r\n  cursor: pointer;\r\n  z-index: 1;\r\n  white-space: nowrap;\r\n  padding: $nav-link-padding-y $nav-link-padding-x;\r\n  transition: all .2s;\r\n\r\n  &:hover {\r\n    color: $primary;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n.RRT__tab--selected {\r\n  color: $primary;\r\n}\r\n\r\n.RRT__tab--disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.RRT__tab:focus {\r\n  z-index: 2;\r\n}\r\n\r\n.RRT__tab--selected .RRT__removable {\r\n  position: relative;\r\n}\r\n\r\n.RRT__tab--selected .RRT__removable-text {\r\n  margin-right: 10px;\r\n}\r\n\r\n.RRT__tab--selected .RRT__removable-icon {\r\n  position: absolute;\r\n  font-size: 18px;\r\n  right: 0.5em;\r\n  top: 0.2em;\r\n}\r\n\r\n// Alternate Style\r\n\r\n.body-tabs.body-tabs-layout {\r\n  &.body-tabs-big {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: stretch;\r\n    @extend .container;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n    @include border-radius(50px);\r\n    border: $gray-200 solid 1px;\r\n    z-index: 7;\r\n\r\n    .RRT__tab {\r\n      margin: 0;\r\n      font-size: 1rem;\r\n      font-weight: 300;\r\n      padding: 0;\r\n      height: 50px;\r\n      line-height: 50px;\r\n      flex: 1;\r\n      text-align: center;\r\n      position: relative;\r\n      color: $primary;\r\n\r\n      &:hover {\r\n        color: $gray-900;\r\n      }\r\n\r\n      &.RRT__tab--selected {\r\n        color: $white;\r\n\r\n        &:hover {\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n\r\n    & + .RRT__inkbar-wrapper {\r\n      height: 70px !important;\r\n      top: -70px !important;\r\n      @extend .container;\r\n      margin: 0 auto -3.4rem;\r\n      position: relative;\r\n      padding: 0 10px;\r\n\r\n      &::before {\r\n        position: absolute;\r\n        content: '';\r\n        background: $white;\r\n        width: 100%;\r\n        height: 100%;\r\n        left: 0;\r\n        top: -11px;\r\n        @include border-radius(50px);\r\n      }\r\n\r\n      .RRT__inkbar {\r\n        height: 50px !important;\r\n        margin-top: 10px;\r\n        @include border-radius(50px);\r\n        box-shadow: 0 0 0 transparent;\r\n      }\r\n\r\n      & + .RRT__panel {\r\n        margin-top: -1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Panels\r\n\r\n.RRT__panel {\r\n  margin-top: $spacer;\r\n}\r\n\r\n.RRT__accordion .RRT__panel {\r\n}\r\n\r\n// Show More\r\n\r\n.RRT__showmore {\r\n  @include border-radius($border-radius);\r\n  background: $primary;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n  white-space: nowrap;\r\n  font-weight: bold;\r\n  width: 36px;\r\n  text-align: center;\r\n  height: 36px;\r\n  display: block;\r\n  margin-left: 15px;\r\n  position: absolute;\r\n  right: $grid-gutter-width;\r\n  top: 50%;\r\n  margin-top: -18px;\r\n  font-size: 1.4rem;\r\n\r\n  &:focus {\r\n    outline: none;\r\n\r\n  }\r\n}\r\n\r\n.RRT__showmore-label {\r\n  position: relative;\r\n  z-index: 1;\r\n  color: $white;\r\n  width: 36px;\r\n  text-align: center;\r\n  height: 36px;\r\n  line-height: 24px;\r\n}\r\n\r\n.RRT__showmore--selected {\r\n  box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\r\n  0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n  0 8px 10px -5px rgba($primary, 0.2);\r\n}\r\n\r\n.RRT__showmore-list {\r\n  position: absolute;\r\n  right: -1px;\r\n  top: 100%;\r\n  display: none;\r\n  min-width: $dropdown-min-width;\r\n  padding: $dropdown-padding-y 0;\r\n  margin: $dropdown-spacer 0 0; // override default ul\r\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\r\n  color: $body-color;\r\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\r\n  list-style: none;\r\n  background-color: $dropdown-bg;\r\n  background-clip: padding-box;\r\n  border: $dropdown-border-width solid $dropdown-border-color;\r\n  @include border-radius($dropdown-border-radius);\r\n  box-shadow: $box-shadow-default;\r\n\r\n  .RRT__tab {\r\n    display: block;\r\n    width: 100%; // For `<button>`s\r\n    padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n    clear: both;\r\n    font-weight: $font-weight-normal;\r\n    color: $dropdown-link-color;\r\n    text-align: inherit; // For `<button>`s\r\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\r\n    background-color: transparent; // For `<button>`s\r\n    border: 0; // For `<button>`s\r\n    margin: 0;\r\n\r\n    &:hover,\r\n    &.RRT__tab--selected {\r\n      color: $dropdown-link-hover-color !important;\r\n      text-decoration: none;\r\n      background: $dropdown-link-hover-bg;\r\n    }\r\n  }\r\n}\r\n\r\n.RRT__showmore-list--opened {\r\n  display: block;\r\n\r\n  .RRT__tab--selected {\r\n    color: $primary;\r\n  }\r\n}\r\n\r\n// Inkbar\r\n\r\n.RRT__inkbar-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.RRT__inkbar {\r\n  position: relative;\r\n  bottom: 0;\r\n  height: 3px;\r\n  margin-top: -3px;\r\n  background-color: $primary;\r\n  @include border-radius(15px);\r\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\r\n  z-index: 2;\r\n}\r\n\r\n.card-tabs {\r\n  .card-header {\r\n    padding: 0 1.25rem;\r\n\r\n    &.RRT__tabs {\r\n      cursor: pointer;\r\n      font-weight: normal;\r\n\r\n      .RRT__tab {\r\n        text-transform: none;\r\n        line-height: 1.3;\r\n      }\r\n    }\r\n  }\r\n\r\n  .RRT__inkbar-wrapper {\r\n    width: calc(100% - 1.5rem) !important;\r\n    margin-left: 1.25rem;\r\n  }\r\n\r\n  .RRT__panel {\r\n    padding: $spacer;\r\n    margin: 0;\r\n  }\r\n\r\n  &.text-white {\r\n\r\n    .RRT__tab {\r\n      color: rgba(255, 255, 255, .6);\r\n\r\n      &:hover {\r\n        color: $white;\r\n      }\r\n    }\r\n\r\n    .RRT__tab--selected {\r\n      color: $white;\r\n    }\r\n\r\n    .RRT__inkbar {\r\n      background: lighten($primary, 40%);\r\n    }\r\n  }\r\n}\r\n\r\n.card-tabs-animated {\r\n  .RRT__container > .RRT__tabs {\r\n    background: transparent;\r\n    position: relative;\r\n    z-index: 7;\r\n\r\n    &.card-header {\r\n      border-bottom: 0;\r\n      height: auto;\r\n      padding: $layout-spacer-x $layout-spacer-x math.div($layout-spacer-x, 3);\r\n    }\r\n  }\r\n\r\n  .RRT__inkbar-wrapper {\r\n    position: absolute;\r\n    top: $layout-spacer-x;\r\n    z-index: 5;\r\n  }\r\n\r\n  .RRT__tab {\r\n    padding: $nav-link-padding-y ($nav-link-padding-x * 1.2);\r\n  }\r\n\r\n  .RRT__tab--selected {\r\n    color: $white;\r\n  }\r\n\r\n  .RRT__inkbar {\r\n    height: 35px;\r\n    margin-top: 0;\r\n    @include border-radius($border-radius);\r\n    box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\r\n    0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n    0 8px 10px -5px rgba($primary, 0.2);\r\n  }\r\n}\r\n\r\n.card-tabs-animated-inner {\r\n  .RRT__tabs {\r\n    padding: 0 5%;\r\n  }\r\n\r\n  .RRT__inkbar-wrapper {\r\n    left: 5%;\r\n    width: 90%;\r\n    height: 36px;\r\n    top: 14px;\r\n  }\r\n\r\n  .RRT__inkbar {\r\n    height: 36px;\r\n  }\r\n}\r\n\r\n.body-tabs {\r\n  border-bottom: $gray-300 solid 2px;\r\n\r\n  & > .RRT__tab {\r\n    padding: math.div($layout-spacer-x, 1.5) math.div($layout-spacer-x, 1.2);\r\n    font-weight: normal;\r\n    font-size: $font-size-base;\r\n  }\r\n\r\n  &.body-tabs-alt {\r\n    & > .RRT__tab {\r\n      padding: math.div($layout-spacer-x, 1.1) math.div($layout-spacer-x, 3);\r\n      font-weight: normal;\r\n      font-size: 0.86rem;\r\n      width: 33%;\r\n      text-align: center;\r\n    }\r\n\r\n    .RRT__inkbar {\r\n      height: 2px;\r\n      margin-top: -2px;\r\n    }\r\n  }\r\n}\r\n\r\n.popover,\r\n.dropdown-menu {\r\n  .RRT__panel {\r\n    margin: 0;\r\n    padding: 0;\r\n    position: relative;\r\n\r\n    &::after,\r\n    &::before {\r\n      width: 100%;\r\n      bottom: auto;\r\n      top: 0;\r\n      left: 0;\r\n      height: 20px;\r\n      position: absolute;\r\n      z-index: 10;\r\n      content: '';\r\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\r\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\r\n    }\r\n\r\n    &::after {\r\n      bottom: 0;\r\n      top: auto;\r\n\r\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\r\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\r\n    }\r\n  }\r\n}\r\n\r\n// Tabs alternate\r\n\r\n.tabs-lg-alternate {\r\n  &.card-header {\r\n    padding: 0;\r\n    height: auto;\r\n\r\n    .widget-number {\r\n      font-size: $h2-font-size;\r\n      font-weight: 300;\r\n    }\r\n\r\n    .tab-subheading {\r\n      padding: 5px 0 0;\r\n      opacity: .6;\r\n      transition: all .2s;\r\n    }\r\n\r\n    & > .nav {\r\n      margin: 0;\r\n\r\n      .nav-link {\r\n        padding: $layout-spacer-x 0;\r\n        border-right: $gray-200 solid 1px;\r\n        background: $gray-100;\r\n\r\n        &:hover {\r\n          background: $white;\r\n          .tab-subheading {\r\n            color: $black;\r\n            opacity: .9;\r\n          }\r\n        }\r\n\r\n        &::before {\r\n          background: $white;\r\n          border-radius: 0;\r\n        }\r\n\r\n        &.active {\r\n          background: $white;\r\n\r\n          .tab-subheading {\r\n            color: $black;\r\n            opacity: .9;\r\n          }\r\n        }\r\n      }\r\n\r\n      .nav-item:last-child {\r\n        .nav-link {\r\n          border-right: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Accordions\r\n\r\n.accordion-wrapper {\r\n  @include border-radius($border-radius);\r\n  border: $gray-200 solid 1px;\r\n\r\n  & > .card {\r\n    box-shadow: 0 0 0 0 transparent;\r\n\r\n    & > .card-header {\r\n      padding: 1rem;\r\n      height: auto;\r\n\r\n      .btn:active,\r\n      .btn:focus,\r\n      .btn:hover {\r\n        text-decoration: none;\r\n      }\r\n\r\n      .form-heading {\r\n        p {\r\n          margin: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .collapse {\r\n      border-bottom: transparent solid 1px;\r\n\r\n      &.show {\r\n        border-bottom-color: $gray-200;\r\n      }\r\n    }\r\n  }\r\n}","// Modals\r\n\r\n.modal-header,\r\n.modal-footer {\r\n  background: $gray-100;\r\n}\r\n\r\n.modal-footer {\r\n  @include border-bottom-radius($border-radius);\r\n}\r\n\r\n.modal-dialog {\r\n  box-shadow: $box-shadow-lg-default;\r\n  @include border-radius($border-radius);\r\n}","$primary-color: $primary !default;\r\n$ball-size: 15px !default;\r\n$margin: 2px !default;\r\n$line-height: 35px !default;\r\n$line-width: 4px !default;\r\n\r\n\r\n@mixin global-bg() {\r\n  background-color: $primary-color;\r\n}\r\n\r\n@mixin global-animation() {\r\n  animation-fill-mode: both;\r\n}\r\n\r\n@mixin balls() {\r\n  @include global-bg();\r\n\r\n  width: $ball-size;\r\n  height: $ball-size;\r\n  border-radius: 100%;\r\n  margin: $margin;\r\n}\r\n\r\n@mixin lines() {\r\n  @include global-bg();\r\n\r\n  width: $line-width;\r\n  height: $line-height;\r\n  border-radius: 2px;\r\n  margin: $margin;\r\n}\r\n\r\n\r\n/**\r\n * Dots\r\n */\r\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse-sync';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-scale';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-rotate';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate-pulse';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate-multiple';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-ripple';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-ripple-multiple';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-beat';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-multiple';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-triangle-trace';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse-rise';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-grid-beat';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-grid-pulse';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-spin-fade-loader';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-spin-loader';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-zig-zag';\r\n@import '../../../node_modules/loaders.css/src/animations/ball-zig-zag-deflect';\r\n\r\n/**\r\n * Lines\r\n */\r\n@import '../../../node_modules/loaders.css/src/animations/line-scale';\r\n@import '../../../node_modules/loaders.css/src/animations/line-scale-random';\r\n@import '../../../node_modules/loaders.css/src/animations/line-scale-pulse-out';\r\n@import '../../../node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid';\r\n@import '../../../node_modules/loaders.css/src/animations/line-spin-fade-loader';\r\n\r\n/**\r\n * Misc\r\n */\r\n@import '../../../node_modules/loaders.css/src/animations/triangle-skew-spin';\r\n@import '../../../node_modules/loaders.css/src/animations/square-spin';\r\n@import '../../../node_modules/loaders.css/src/animations/pacman';\r\n@import '../../../node_modules/loaders.css/src/animations/cube-transition';\r\n@import '../../../node_modules/loaders.css/src/animations/semi-circle-spin';\r\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n// mixins should be separated out\n@mixin ball-pulse($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: scale 0.75s delay(0.12s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.ball-pulse {\n  @include ball-pulse();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$amount: 10px;\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY($amount);\n  }\n  66% {\n    transform: translateY(-$amount);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@mixin ball-pulse-sync($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: ball-pulse-sync 0.6s delay(0.07s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.ball-pulse-sync {\n  @include ball-pulse-sync();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0.0);\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n.ball-scale {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    height: 60px;\n    width: 60px;\n    animation: ball-scale 1s 0s ease-in-out infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.ball-rotate {\n  position: relative;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: relative;\n\n    &:first-child {\n      animation: rotate 1s 0s cubic-bezier(.7,-.13,.22,.86) infinite;\n    }\n\n    &:before, &:after {\n      @include balls();\n\n      content: \"\";\n      position: absolute;\n      opacity: 0.8;\n    }\n\n    &:before {\n      top: 0px;\n      left: -28px;\n    }\n\n    &:after {\n      top: 0px;\n      left: 25px;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    height: 25px;\n    width: 25px;\n    background: transparent !important;\n    display: inline-block;\n    animation: rotate 0.75s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 100%;\n\n    &:first-child {\n      background: $primary-color;\n      height: 16px;\n      width: 16px;\n      top: 7px;\n      left: -7px;\n      animation: scale 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n    }\n\n    &:last-child {\n      position: absolute;\n      border: 2px solid $primary-color;\n      width: 30px;\n      height: 30px;  \n      left: -16px;\n      top: -2px;\n      background: transparent;\n      border: 2px solid;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation: rotate 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n      animation-duration: 1s;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate-multiple {\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    left: -20px;\n    top: -20px;\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    border-top-color: transparent;\n    border-radius: 100%;\n    height: 35px;\n    width: 35px;\n    animation: rotate 1s 0s ease-in-out infinite;\n\n    &:last-child {\n      display: inline-block;\n      top: -10px;\n      left: -10px;\n      width: 15px;\n      height: 15px;\n      animation-duration: 0.5s;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation-direction: reverse;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n.ball-scale-ripple {\n\n  > div {\n    @include global-animation();\n\n    height: 50px;\n    width: 50px;\n    border-radius: 100%;\n    border: 2px solid $primary-color;;\n    animation: ball-scale-ripple 1s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 50px;\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n@mixin ball-scale-ripple-multiple ($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-ripple-multiple {\n  @include ball-scale-ripple-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: $size;\n    height: $size;\n    border-radius: 100%;\n    border: 2px solid $primary-color;\n    animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.ball-beat {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation: ball-beat 0.7s 0s infinite linear;\n\n    &:nth-child(2n-1) {\n      animation-delay: -0.35s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 60px;\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0.0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n@mixin ball-scale-multiple ($n:3, $start:0) {\n  @for $i from 2 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-multiple {\n  @include ball-scale-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    left: -30px;\n    top: 0px;\n    opacity: 0;\n    margin: 0;\n    width: $size;\n    height: $size;\n    animation: ball-scale-multiple 1s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate($amount / 2, -$amount);\n  }\n  66% {\n    transform: translate($amount, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate($amount / 2, $amount);\n  }\n  66% {\n    transform: translate(- $amount / 2, $amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-$amount, 0px);\n  }\n  66% {\n    transform: translate(- $amount / 2, -$amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@mixin ball-triangle-path($n:3) {\n  $animations: ball-triangle-path-1 ball-triangle-path-2 ball-triangle-path-3;\n\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-name: nth($animations, $i);\n      animation-delay: 0;\n      animation-duration: 2s;\n      animation-timing-function: ease-in-out;\n      animation-iteration-count: infinite;\n    }\n  }\n}\n\n.ball-triangle-path {\n  position: relative;\n  @include ball-triangle-path();\n  transform: translate(-$amount / 1.667, -$amount / 1.333);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    border: 1px solid $primary-color;\n\n    &:nth-of-type(1) {\n      top: $amount;\n    }\n\n    &:nth-of-type(2) {\n      left: $amount / 2;\n    }\n\n    &:nth-of-type(3) {\n      top: $amount;\n      left: $amount;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$rise-amount: 30px;\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-$rise-amount);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY($rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1.0);\n  }\n}\n\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY($rise-amount);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-$rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n\n.ball-pulse-rise {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation-duration: 1s;\n    animation-timing-function: cubic-bezier(.15,.46,.9,.6);\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n\n    &:nth-child(2n) {\n      animation-name: ball-pulse-rise-even;\n    }\n\n    &:nth-child(2n-1) {\n      animation-name: ball-pulse-rise-odd;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-beat($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-beat {\n  @include ball-grid-beat();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-beat;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-pulse($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-pulse {\n  @include ball-grid-pulse();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-pulse;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 25px;\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin ball-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-fade-loader 1s delay(0.12s, $n, $i - 1) infinite linear;\n    }\n  }\n}\n\n.ball-spin-fade-loader {\n  @include ball-spin-fade-loader();\n\n  position: relative;\n  top: -10px;\n  left: -10px;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$radius: 45px;\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-spin-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > span:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-loader 2s ($i * 0.9s) infinite linear;\n    }\n  }\n}\n\n.ball-spin-loader {\n  @include ball-spin-loader();\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    background: green;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  66% {\n    transform: translate($amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag {\n  33% {\n    transform: translate($amount/2, $amount);\n  }\n  66% {\n    transform: translate(-$amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig 0.7s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag 0.7s 0s infinite linear;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  34% {\n    transform: translate($amount/2, -$amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate($amount/2, -$amount);\n  }\n  84% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate($amount/2, $amount);\n  }\n  34% {\n    transform: translate(-$amount/2, $amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-$amount/2, $amount);\n  }\n  84% {\n    transform: translate($amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig-deflect 1.5s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag-deflect 1.5s 0s infinite linear;\n    }\n  }\n}\n\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n@mixin line-scale($n:5) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation: line-scale 1s delay(0.1s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.line-scale {\n  @include line-scale();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    $random: 0.5;\n    transform: scale($random);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@mixin line-scale-party($n:4) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.3) + s;\n    }\n  }\n}\n\n.line-scale-party {\n  @include line-scale-party();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation-name: line-scale-party;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation: line-scale-pulse-out 0.9s delay(0.2s, 3, 0) infinite cubic-bezier(.85,.25,.37,.85);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: delay(0.2s, 3, 1) !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: delay(0.2s, 3, 2) !important;\n    }\n\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1.0);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out-rapid {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    vertical-align: middle;\n    animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(.11,.49,.38,.78);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: -0.25s !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: 0s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 20px;\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin line-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n        transform: rotate(90deg);\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n        transform: rotate(45deg);\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n        transform: rotate(90deg);\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n        transform: rotate(45deg);\n      }\n\n      animation: line-spin-fade-loader 1.2s delay(0.12s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.line-spin-fade-loader {\n  @include line-spin-fade-loader();\n  position: relative;\n  top: -10px;\n  left: -4px;\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    position: absolute;\n    width: 5px;\n    height: 15px;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 20px;\n\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.triangle-skew-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 0;\n    height: 0;\n    border-left: $size solid transparent;\n    border-right: $size solid transparent;\n    border-bottom: $size solid $primary-color;\n    animation: triangle-skew-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.square-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 50px;\n    height: 50px;\n    background: $primary-color;\n    animation: square-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 25px;\n\n@keyframes rotate_pacman_half_up  {\n    0% {\n         transform:rotate(270deg);\n    }\n    50% {\n         transform:rotate(360deg);\n    }\n    100% {\n         transform:rotate(270deg);\n    }\n}\n\n@keyframes rotate_pacman_half_down  {\n    0% {\n         transform:rotate(90deg);\n    }\n    50% {\n         transform:rotate(0deg);\n    }\n    100% {\n         transform:rotate(90deg);\n    }\n}\n\n@mixin pacman_design(){\n    width: 0px;\n    height: 0px;\n    border-right: $size solid transparent;\n    border-top: $size solid $primary-color;\n    border-left: $size solid $primary-color;\n    border-bottom: $size solid $primary-color;\n    border-radius: $size;\n}\n\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-4 * $size, -$size / 4);\n  }\n}\n\n@mixin ball-placement($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i + 2}) {\n      animation: pacman-balls 1s delay(.33s, $n, $i) infinite linear;\n    }\n  }\n}\n\n.pacman {\n  @include ball-placement();\n\n  position: relative;\n\n  > div:first-of-type {\n    @include pacman_design();\n    animation: rotate_pacman_half_up 0.5s 0s infinite;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(2) {\n    @include pacman_design();\n    animation: rotate_pacman_half_down 0.5s 0s infinite;\n    margin-top: -2 * $size;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(3),\n  > div:nth-child(4),\n  > div:nth-child(5),\n  > div:nth-child(6) {\n    @include balls();\n\n    width: 10px;\n    height: 10px;\n\n    position: absolute;\n    transform: translate(0, -$size / 4);\n    top: 25px;\n    left: 70px;\n  }\n}","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n$size: 10px;\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX($amount) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate($amount, $amount) rotate(-180deg);\n  }\n  75% {\n    transform: translateY($amount) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n.cube-transition {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include global-animation();\n\n    width: $size;\n    height: $size;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n    background-color: $primary-color;\n    animation: cube-transition 1.6s 0s infinite ease-in-out;\n\n    &:last-child {\n      animation-delay: -0.8s\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 35px;\n$pos: 30%;\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.semi-circle-spin {\n  position: relative;\n  width: $size;\n  height: $size;\n  overflow: hidden;\n\n  > div {\n    position: absolute;\n    border-width: 0px;\n    border-radius: 100%;\n    animation: spin-rotate 0.6s 0s infinite linear;\n    background-image: linear-gradient(transparent 0%, transparent (100% - $pos), $primary-color $pos, $primary-color 100%);\n    width: 100%;\n    height: 100%;\n  }\n}","// Progress Bar\r\n\r\n.progress {\r\n\r\n  .progress-bar {\r\n    &:last-child {\r\n      @include border-end-radius($progress-border-radius);\r\n    }\r\n  }\r\n\r\n  &.progress-bar-sm {\r\n    height: .5rem;\r\n  }\r\n\r\n  &.progress-bar-xs {\r\n    height: .3rem;\r\n  }\r\n\r\n  &.progress-bar-rounded {\r\n    @include border-radius(30px);\r\n  }\r\n\r\n}\r\n\r\n.progress-bar-animated-alt {\r\n  &.progress-bar,\r\n  .progress-bar {\r\n    position: relative;\r\n\r\n    &::after {\r\n      content: '';\r\n      opacity: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      background: $white;\r\n      animation: progress-active 2s ease infinite;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes progress-active {\r\n  0% {\r\n    opacity: .4;\r\n    width: 0\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    width: 100%\r\n  }\r\n}","@use \"sass:math\";\r\n\r\n.vertical-timeline {\r\n  width: 100%;\r\n  position: relative;\r\n  padding: ($spacer * 1.5) 0 ($spacer);\r\n\r\n  &::after {\r\n    content: '';\r\n    display: table;\r\n    clear: both\r\n  }\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 67px;\r\n    height: 100%;\r\n    width: 4px;\r\n    background: $gray-200;\r\n    @include border-radius($border-radius);\r\n  }\r\n}\r\n\r\n.vertical-timeline-element {\r\n  position: relative;\r\n  margin: 0 0 ($spacer);\r\n\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both\r\n  }\r\n\r\n  &:last-child {\r\n    margin-bottom: 0\r\n  }\r\n}\r\n\r\n.vertical-timeline-element-content {\r\n  position: relative;\r\n  margin-left: 90px;\r\n  font-size: $font-size-xs;\r\n\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both\r\n  }\r\n\r\n  .timeline-title {\r\n    font-size: $font-size-xs;\r\n    text-transform: uppercase;\r\n    margin: 0 0 math.div($spacer, 2);\r\n    padding: 2px 0 0;\r\n    font-weight: bold;\r\n  }\r\n\r\n  p {\r\n    color: $gray-600;\r\n    margin: 0 0 math.div($spacer, 2);\r\n  }\r\n\r\n  .vertical-timeline-element-date {\r\n    display: block;\r\n    position: absolute;\r\n    left: -90px;\r\n    top: 0;\r\n    padding-right: 10px;\r\n    text-align: right;\r\n    color: $gray-500;\r\n    font-size: math.div($font-size-xs, 1.05);\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n.vertical-timeline-element-icon {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 60px;\r\n\r\n  .badge-dot-xl {\r\n    box-shadow: 0 0 0 5px $white;\r\n  }\r\n}\r\n\r\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\r\n  background: 0 0;\r\n  box-shadow: none;\r\n\r\n  &::before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.vertical-without-time {\r\n  &::before {\r\n    left: 11px;\r\n  }\r\n\r\n  .vertical-timeline-element-content {\r\n    margin-left: 36px;\r\n  }\r\n\r\n  .vertical-timeline-element-icon {\r\n    left: 4px;\r\n  }\r\n}\r\n\r\n.vertical-time-icons {\r\n  padding: ($spacer * 2) 0 0;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 14px;\r\n    height: 100%;\r\n    width: 6px;\r\n    background: $gray-200;\r\n    @include border-radius($border-radius);\r\n  }\r\n\r\n  .vertical-timeline-element {\r\n    margin-bottom: $spacer;\r\n  }\r\n\r\n  .vertical-timeline-element-content {\r\n    margin-left: 50px;\r\n  }\r\n\r\n  .vertical-timeline-element-icon {\r\n    width: 34px;\r\n    height: 34px;\r\n    left: 0;\r\n    top: -7px;\r\n\r\n    .timeline-icon {\r\n      width: 34px;\r\n      height: 34px;\r\n      background: $white;\r\n      @include border-radius(50px);\r\n      border-width: 2px;\r\n      border-style: solid;\r\n      box-shadow: 0 0 0 5px $white;\r\n      text-align: center;\r\n      display: flex;\r\n      align-items: center;\r\n      align-content: center;\r\n\r\n      i {\r\n        display: block;\r\n        font-size: 1.1rem;\r\n        margin: 0 auto;\r\n      }\r\n\r\n      svg {\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Simple Dots Timeline\r\n\r\n.vertical-time-simple {\r\n  padding: math.div($spacer, 2) 0;\r\n\r\n  .vertical-timeline-element {\r\n    margin: 0 0 math.div($spacer, 2);\r\n  }\r\n\r\n  .timeline-title {\r\n    font-weight: normal;\r\n    font-size: math.div($font-size-lg, 1.2);\r\n    padding: 0;\r\n  }\r\n\r\n  .vertical-timeline-element-icon {\r\n    height: 14px;\r\n    width: 14px;\r\n    background: $gray-200;\r\n    position: absolute;\r\n    left: 6px;\r\n    top: 2px;\r\n    display: block;\r\n    @include border-radius(20px);\r\n\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      background: $white;\r\n      left: 50%;\r\n      top: 50%;\r\n      margin: -4px 0 0 -4px;\r\n      display: block;\r\n      width: 8px;\r\n      height: 8px;\r\n      @include border-radius(20px);\r\n    }\r\n  }\r\n\r\n  .timeline-title {\r\n    text-transform: none;\r\n  }\r\n}\r\n\r\n@mixin timeline-variant($parent, $color) {\r\n  #{$parent} {\r\n    .vertical-timeline-element-icon {\r\n      background: $color;\r\n    }\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include timeline-variant(\".dot-#{$color}\", $value);\r\n}\r\n\r\n\r\n// Animations\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\r\n  visibility: hidden\r\n}\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\r\n  visibility: visible;\r\n  animation: cd-bounce-1 .8s\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(.5)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1.2)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: scale(1)\r\n  }\r\n\r\n}\r\n\r\n@-moz-keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -moz-transform: scale(.5)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -moz-transform: scale(1.2)\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: scale(1)\r\n  }\r\n\r\n}\r\n\r\n@keyframes cd-bounce-1 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(.5);\r\n    -moz-transform: scale(.5);\r\n    -ms-transform: scale(.5);\r\n    -o-transform: scale(.5);\r\n    transform: scale(.5)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1.2);\r\n    -moz-transform: scale(1.2);\r\n    -ms-transform: scale(1.2);\r\n    -o-transform: scale(1.2);\r\n    transform: scale(1.2)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: scale(1);\r\n    -moz-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -o-transform: scale(1);\r\n    transform: scale(1)\r\n  }\r\n\r\n}\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\r\n  visibility: hidden\r\n}\r\n\r\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\r\n  visibility: visible;\r\n  -webkit-animation: cd-bounce-2 .6s;\r\n  -moz-animation: cd-bounce-2 .6s;\r\n  animation: cd-bounce-2 .6s\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\r\n    -webkit-animation: cd-bounce-2-inverse .6s;\r\n    -moz-animation: cd-bounce-2-inverse .6s;\r\n    animation: cd-bounce-2-inverse .6s\r\n  }\r\n\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\r\n    visibility: visible;\r\n    -webkit-animation: cd-bounce-2-inverse .6s;\r\n    -moz-animation: cd-bounce-2-inverse .6s;\r\n    animation: cd-bounce-2-inverse .6s\r\n  }\r\n\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(-100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@-moz-keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -moz-transform: translateX(-100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -moz-transform: translateX(20px)\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@keyframes cd-bounce-2 {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(-100px);\r\n    -moz-transform: translateX(-100px);\r\n    -ms-transform: translateX(-100px);\r\n    -o-transform: translateX(-100px);\r\n    transform: translateX(-100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(20px);\r\n    -moz-transform: translateX(20px);\r\n    -ms-transform: translateX(20px);\r\n    -o-transform: translateX(20px);\r\n    transform: translateX(20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    -moz-transform: translateX(0);\r\n    -ms-transform: translateX(0);\r\n    -o-transform: translateX(0);\r\n    transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@-webkit-keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(-20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@-moz-keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -moz-transform: translateX(100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -moz-transform: translateX(-20px)\r\n  }\r\n\r\n  100% {\r\n    -moz-transform: translateX(0)\r\n  }\r\n\r\n}\r\n\r\n@keyframes cd-bounce-2-inverse {\r\n  0% {\r\n    opacity: 0;\r\n    -webkit-transform: translateX(100px);\r\n    -moz-transform: translateX(100px);\r\n    -ms-transform: translateX(100px);\r\n    -o-transform: translateX(100px);\r\n    transform: translateX(100px)\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translateX(-20px);\r\n    -moz-transform: translateX(-20px);\r\n    -ms-transform: translateX(-20px);\r\n    -o-transform: translateX(-20px);\r\n    transform: translateX(-20px)\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateX(0);\r\n    -moz-transform: translateX(0);\r\n    -ms-transform: translateX(0);\r\n    -o-transform: translateX(0);\r\n    transform: translateX(0)\r\n  }\r\n\r\n}","// List Group\r\n\r\n@use \"sass:math\";\r\n\r\n.todo-list-wrapper {\r\n  .todo-indicator {\r\n    position: absolute;\r\n    width: 4px;\r\n    height: 60%;\r\n    @include border-radius($border-radius-lg);\r\n    left: math.div($card-spacer-x, 2);\r\n    top: 20%;\r\n    opacity: .6;\r\n    transition: opacity .2s;\r\n  }\r\n\r\n  .list-group-item {\r\n    &:hover {\r\n      .todo-indicator {\r\n        opacity: .9;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custom-control,\r\n  input[checkbox] {\r\n    margin-left: math.div($card-spacer-x, 2);\r\n  }\r\n}\r\n\r\n.list-group-flush + .card-footer {\r\n  border-top: 0;\r\n}\r\n\r\n.rm-list-borders {\r\n  .list-group-item {\r\n    border: 0;\r\n    padding: math.div($card-spacer-y, 1.5) 0;\r\n  }\r\n}\r\n\r\n.rm-list-borders-scroll {\r\n  .list-group-item {\r\n    border: 0;\r\n    padding-right: ($card-spacer-y * 1.5);\r\n  }\r\n}","// Input groups\r\n\r\n.input-group {\r\n  .input-group-prepend {\r\n    div:not([class]) .react-datepicker__input-container,\r\n    & + div .react-datepicker__input-container {\r\n      .form-control {\r\n        @include border-start-radius(0);\r\n        @include border-end-radius($input-border-radius !important);\r\n      }\r\n    }\r\n  }\r\n\r\n  & > div:not([class]) {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n\r\n    & .react-datepicker__input-container {\r\n      .form-control {\r\n        @include border-end-radius(0);\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n.input-group {\r\n  .input-group-prepend {\r\n    & + div {\r\n      position: relative;\r\n      flex: 1 1 auto;\r\n      width: 1%;\r\n    }\r\n  }\r\n\r\n  & > .react-datepicker-wrapper {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n\r\n    & > .react-datepicker__input-container > .form-control {\r\n      @include border-start-radius(0);\r\n    }\r\n  }\r\n}\r\n\r\n// Forms Legend\r\n\r\nlegend {\r\n  font-size: $font-size-base;\r\n  font-weight: bold;\r\n}\r\n\r\n// Headings\r\n\r\n.form-heading {\r\n  font-size: $font-size-lg;\r\n  margin: 0;\r\n  color: $primary;\r\n\r\n  p {\r\n    color: $gray-600;\r\n    padding: 0.3rem 0 0;\r\n    font-size: $font-size-base;\r\n  }\r\n}\r\n\r\n.custom-select {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n}","// Pagination\r\n\r\n@use \"sass:math\";\r\n\r\n.pagination {\r\n  .page-number {\r\n    @extend .page-item;\r\n  }\r\n\r\n  li {\r\n    a {\r\n      position: relative;\r\n      display: block;\r\n      padding: $pagination-padding-y $pagination-padding-x;\r\n      margin-left: -$pagination-border-width;\r\n      // line-height: $pagination-line-height;\r\n      color: $pagination-color;\r\n      background-color: $pagination-bg;\r\n      border: $pagination-border-width solid $pagination-border-color;\r\n\r\n      &:hover {\r\n        z-index: 2;\r\n        color: $pagination-hover-color;\r\n        text-decoration: none;\r\n        background-color: $pagination-hover-bg;\r\n        border-color: $pagination-hover-border-color;\r\n      }\r\n\r\n      &:focus {\r\n        z-index: 2;\r\n        outline: $pagination-focus-outline;\r\n        box-shadow: $pagination-focus-box-shadow;\r\n      }\r\n\r\n      // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\r\n      &:not(:disabled):not(.disabled) {\r\n        cursor: pointer;\r\n      }\r\n    }\r\n\r\n    &:first-child {\r\n      a {\r\n        margin-left: 0;\r\n        @include border-start-radius($border-radius);\r\n      }\r\n    }\r\n    &:last-child {\r\n      a {\r\n        @include border-end-radius($border-radius);\r\n      }\r\n    }\r\n\r\n    &.active a {\r\n      z-index: 1;\r\n      color: $pagination-active-color;\r\n      background-color: $pagination-active-bg;\r\n      border-color: $pagination-active-border-color;\r\n\r\n      &:hover {\r\n        color: $pagination-active-color;\r\n      }\r\n    }\r\n\r\n    &.disabled a {\r\n      color: $pagination-disabled-color;\r\n      pointer-events: none;\r\n      // Opinionated: remove the \"hand\" cursor set previously for .page-link\r\n      cursor: auto;\r\n      background-color: $pagination-disabled-bg;\r\n      border-color: $pagination-disabled-border-color;\r\n    }\r\n  }\r\n}\r\n\r\n// Pagination Rounded\r\n\r\n.pagination-rounded {\r\n  li a {\r\n    @include border-radius(50px !important);\r\n    margin: 0 math.div($layout-spacer-x, 5);\r\n  }\r\n}","// Chat\r\n\r\n@use \"sass:math\";\r\n\r\n.chat-box-wrapper {\r\n  display: flex;\r\n  clear: both;\r\n  padding: math.div($layout-spacer-x, 2);\r\n\r\n  & + .chat-box-wrapper {\r\n    padding-top: 0;\r\n  }\r\n\r\n  .chat-box {\r\n    box-shadow: 0 0 0 transparent;\r\n    position: relative;\r\n    opacity: 1;\r\n    background: $dropdown-link-hover-bg;\r\n    border: 0;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    @include border-radius(30px);\r\n    border-top-left-radius: $border-radius;\r\n    flex: 1;\r\n    display: flex;\r\n    max-width: 50%;\r\n    min-width: 100%;\r\n    text-align: left;\r\n\r\n    & + small {\r\n      text-align: left;\r\n      padding: math.div($layout-spacer-x, 3) 0 0;\r\n      margin-left: $layout-spacer-x;\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  &.chat-box-wrapper-right {\r\n    text-align: right;\r\n\r\n    .chat-box {\r\n      @include border-radius(30px);\r\n      border-top-left-radius: 30px;\r\n      border-top-right-radius: $border-radius;\r\n      margin-left: auto;\r\n\r\n      & + small {\r\n        text-align: right;\r\n        margin-right: $layout-spacer-x;\r\n        margin-left: 0;\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n","// Wizard Multi Step\r\n\r\n@use \"sass:math\";\r\n\r\n.forms-wizard {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style-type: none;\r\n  width: 100%;\r\n  display: table;\r\n  table-layout: fixed;\r\n  @include border-radius($border-radius);\r\n\r\n  li {\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-size: math.div($font-size-lg, 1.1);\r\n    padding: math.div($layout-spacer-x, 1.5) 0;\r\n    color: $gray-500;\r\n    position: relative;\r\n\r\n    &::after,\r\n    &::before {\r\n      position: absolute;\r\n      height: 4px;\r\n      top: 50%;\r\n      margin-top: -(math.div($layout-spacer-x, 1.5));\r\n      width: 50%;\r\n      content: '';\r\n      background: $gray-300;\r\n      z-index: 5;\r\n      transition: all .2s;\r\n    }\r\n\r\n    &::after {\r\n      left: 50%;\r\n    }\r\n\r\n    &::before {\r\n      left: 0;\r\n    }\r\n\r\n    &:first-child {\r\n      &::before {\r\n        @include border-start-radius(20px);\r\n      }\r\n    }\r\n\r\n    &:last-child {\r\n      &::after {\r\n        @include border-end-radius(20px);\r\n      }\r\n    }\r\n\r\n    em {\r\n      font-style: normal;\r\n      font-size: $h4-font-size;\r\n      background: $gray-400;\r\n      color: $white;\r\n      text-align: center;\r\n      padding: 0;\r\n      width: 40px;\r\n      height: 40px;\r\n      line-height: 40px;\r\n      @include border-radius(50px);\r\n      display: block;\r\n      margin: 0 auto 0.5rem;\r\n      position: relative;\r\n      z-index: 7;\r\n      transition: all .2s;\r\n    }\r\n\r\n    &.form-wizard-step-doing {\r\n      color: $gray-700;\r\n      em {\r\n        background: $primary;\r\n      }\r\n\r\n      &::before {\r\n        background: $primary;\r\n      }\r\n    }\r\n\r\n    &.form-wizard-step-done {\r\n      em {\r\n        font-family: 'Linearicons-Free';\r\n        @extend .lnr-checkmark-circle !optional;\r\n        background: $success;\r\n        overflow: hidden;\r\n        &::before {\r\n          width: 42px;\r\n          height: 42px;\r\n          font-size: 1.2rem;\r\n          line-height: 40px;\r\n          text-align: center;\r\n          display: block;\r\n        }\r\n      }\r\n\r\n      &::after,\r\n      &::before {\r\n        background: $success;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      color: $gray-600;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Form Wizard Alternate\r\n\r\n.forms-wizard-alt {\r\n  .forms-wizard {\r\n    li {\r\n      font-size: $font-size-base;\r\n\r\n      em {\r\n        width: 14px;\r\n        height: 14px;\r\n        line-height: 14px;\r\n        text-indent: -999rem;\r\n        border: $white solid 2px;\r\n        margin: -7px auto 0;\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.forms-wizard-vertical {\r\n  .forms-wizard {\r\n    display: block;\r\n    width: 30%;\r\n    float: left;\r\n    padding: 0 $layout-spacer-x $layout-spacer-x 0;\r\n\r\n    li {\r\n      text-align: left;\r\n      display: flex;\r\n      align-items: center;\r\n      align-content: flex-start;\r\n      padding: math.div($layout-spacer-x, 2);\r\n      margin-bottom: math.div($layout-spacer-x, 3);\r\n      @include border-radius($border-radius-lg);\r\n      transition: all .2s;\r\n\r\n      &::before,\r\n      &::after {\r\n        display: none;\r\n      }\r\n\r\n      em {\r\n        margin: 0 math.div($layout-spacer-x, 2) 0 0;\r\n      }\r\n\r\n      &:hover {\r\n        background: $gray-200;\r\n      }\r\n\r\n      &.form-wizard-step-doing {\r\n        background: $primary;\r\n        color: $white;\r\n\r\n        em {\r\n          background: rgba(255,255,255,.2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-wizard-content {\r\n    width: 70%;\r\n    overflow: auto;\r\n  }\r\n}\r\n@media screen and (min-width: 360px) and (max-width: 812px) {\r\n  .forms-wizard-vertical {\r\n    .forms-wizard {\r\n      display: block;\r\n      width: 50%;\r\n      float: left;\r\n      padding: 0 $layout-spacer-x $layout-spacer-x 0;\r\n  \r\n      li {\r\n        text-align: left;\r\n        display: flex;\r\n        align-items: center;\r\n        align-content: flex-start;\r\n        padding: math.div($layout-spacer-x, 2);\r\n        margin-bottom: math.div($layout-spacer-x, 3);\r\n        @include border-radius($border-radius-lg);\r\n        transition: all .2s;\r\n  \r\n        &::before,\r\n        &::after {\r\n          display: none;\r\n        }\r\n  \r\n        em {\r\n          margin: 0 math.div($layout-spacer-x, 2) 0 0;\r\n        }\r\n  \r\n        &:hover {\r\n          background: $gray-200;\r\n        }\r\n  \r\n        &.form-wizard-step-doing {\r\n          background: $primary;\r\n          color: $white;\r\n  \r\n          em {\r\n            background: rgba(255,255,255,.2);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    .form-wizard-content {\r\n      width: 50%;\r\n      overflow: auto;\r\n    }\r\n  }\r\n}","// Chart boxes\r\n\r\n// Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$widget-spacer: $spacer;\r\n\r\n%center-elem {\r\n  display: flex;\r\n  align-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.widget-chart {\r\n  text-align: center;\r\n  padding: $widget-spacer;\r\n  position: relative;\r\n\r\n  .progress-sub-label {\r\n    opacity: .8;\r\n    padding: 5px 0 0;\r\n  }\r\n\r\n  .progress-circle-wrapper {\r\n    min-width: 68px;\r\n    margin-right: $widget-spacer;\r\n\r\n    .react-sweet-progress-symbol {\r\n      font-size: $font-size-xs;\r\n    }\r\n  }\r\n\r\n  .widget-chart-content {\r\n    position: relative;\r\n    z-index: 5;\r\n  }\r\n\r\n  .widget-chart-content-lg {\r\n    padding: ($widget-spacer * 2) 0 $widget-spacer  ($widget-spacer * 2);\r\n\r\n    .widget-numbers {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .widget-chart-wrapper {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    opacity: .25;\r\n    z-index: 6;\r\n    @include border-bottom-radius($card-border-radius);\r\n    overflow: hidden;\r\n  }\r\n\r\n  .widget-numbers {\r\n    font-weight: bold;\r\n    font-size: 2.5rem;\r\n    display: block;\r\n    line-height: 1;\r\n    margin: $widget-spacer auto;\r\n\r\n    & + .widget-chart-flex,\r\n    & + .widget-description,\r\n    & + .widget-subheading {\r\n      margin-top: -(math.div($widget-spacer, 2));\r\n    }\r\n  }\r\n\r\n  .widget-subheading {\r\n    margin: -0.5rem 0 0;\r\n    display: block;\r\n    opacity: .6;\r\n\r\n    &:first-child {\r\n      margin-top: 0;\r\n    }\r\n\r\n    & + .widget-numbers {\r\n      margin-top: math.div($widget-spacer, 2);\r\n    }\r\n  }\r\n\r\n  .widget-description {\r\n    margin: $widget-spacer 0 0;\r\n  }\r\n\r\n  &.widget-chart-hover {\r\n    transition: all .2s;\r\n\r\n    &:hover {\r\n      z-index: 15;\r\n      transform: scale(1.15);\r\n      box-shadow: 0 0.46875rem 4.1875rem rgba(darken($primary, 50%), .05),\r\n      0 0.9375rem 2.40625rem rgba(darken($primary, 50%), .05),\r\n      0 0.25rem 1.3125rem rgba(darken($primary, 50%), .06),\r\n      0 0.125rem 1.1875rem rgba(darken($primary, 50%), .06);\r\n      cursor: pointer;\r\n      background: $white;\r\n    }\r\n  }\r\n\r\n  .widget-chart-actions {\r\n    position: absolute;\r\n    right: math.div($widget-spacer, 2);\r\n    top: math.div($widget-spacer, 2);\r\n    z-index: 12;\r\n\r\n    .btn-link {\r\n      font-size: 1.1rem;\r\n      padding-top: 0;\r\n      padding-bottom: 0;\r\n      opacity: .6;\r\n    }\r\n  }\r\n\r\n  .widget-progress-wrapper {\r\n    margin-top: $widget-spacer;\r\n\r\n    &.progress-wrapper-bottom {\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      width: 100%;\r\n\r\n      .progress {\r\n        margin: 0 -1px -1px;\r\n      }\r\n\r\n      .progress {\r\n        @include border-top-radius(0);\r\n        @include border-bottom-radius($card-border-radius);\r\n\r\n        .progress-bar {\r\n          border-bottom-left-radius: $card-border-radius;\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n\r\n  .widget-chart-flex {\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n    margin-bottom: $widget-spacer;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    .widget-subheading {\r\n      margin: 0;\r\n    }\r\n\r\n    .widget-description {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n\r\n  &.text-start {\r\n    flex-direction: row;\r\n    align-items: center;\r\n\r\n    .icon-wrapper {\r\n      min-width: 54px;\r\n      margin: 0 ($widget-spacer) 0 0;\r\n    }\r\n\r\n    .widget-numbers {\r\n      margin-left: 0;\r\n    }\r\n\r\n    .widget-chart-content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-content: center;\r\n      flex: 1;\r\n      position: relative;\r\n\r\n      & > .widget-numbers:first-child {\r\n        margin-top: 0;\r\n      }\r\n\r\n      .widget-description {\r\n        align-self: flex-start;\r\n      }\r\n    }\r\n\r\n    .widget-chart-wrapper {\r\n      height: 35%;\r\n    }\r\n  }\r\n\r\n  &.widget-chart-left {\r\n    padding-bottom: 15%;\r\n  }\r\n\r\n  .chart-wrapper-relative {\r\n    position: relative;\r\n    opacity: 1;\r\n    margin-top: ($widget-spacer);\r\n  }\r\n}\r\n\r\n.widget-chart-actions {\r\n  position: absolute;\r\n  right: $widget-spacer;\r\n  top: $widget-spacer;\r\n  z-index: 12;\r\n\r\n  .btn-link {\r\n    font-size: 1.1rem;\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    opacity: .6;\r\n  }\r\n}\r\n\r\n.widget-chart,\r\n.widget-content {\r\n  &:hover {\r\n    .widget-chart-actions {\r\n      .btn-link {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.grid-menu {\r\n  .widget-chart {\r\n    &.widget-chart-hover {\r\n      &:hover {\r\n        background: $card-bg;\r\n        @include border-radius($border-radius);\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.icon-wrapper {\r\n  width: 54px;\r\n  height: 54px;\r\n  margin: 0 auto;\r\n  @extend %center-elem;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  &[class*=\"border-\"] {\r\n    border-width: 1px;\r\n    border-style: solid;\r\n  }\r\n\r\n  .icon-wrapper-bg {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 3;\r\n    opacity: .2;\r\n\r\n    &.bg-light {\r\n      opacity: .08;\r\n    }\r\n\r\n  }\r\n\r\n  i {\r\n    margin: 0 auto;\r\n    font-size: 1.7rem;\r\n    position: relative;\r\n    z-index: 5;\r\n\r\n    &:before {\r\n      margin-top: -3px;\r\n    }\r\n  }\r\n\r\n  .progress-circle-wrapper {\r\n    width: 100%;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.widget-chart2 {\r\n  .widget-chart-flex {\r\n    display: flex;\r\n    align-items: baseline;\r\n    align-content: center;\r\n    margin-bottom: 0;\r\n\r\n    .widget-subtitle,\r\n    .widget-title {\r\n    }\r\n\r\n    .widget-subtitle {\r\n      margin-left: auto;\r\n    }\r\n\r\n    .widget-numbers {\r\n      font-weight: normal;\r\n    }\r\n\r\n    & + .widget-chart-flex {\r\n      .widget-numbers {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .widget-chat-wrapper-outer {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n    max-width: 100%;\r\n\r\n    .widget-chart-wrapper {\r\n      height: 70px;\r\n      opacity: .8;\r\n      position: relative;\r\n      margin: $widget-spacer auto (-(math.div($widget-spacer, 2)));\r\n    }\r\n\r\n    .widget-chart-wrapper-lg {\r\n      height: 130px;\r\n    }\r\n  }\r\n}\r\n\r\n// Widgets with bottom border\r\n\r\n.card-btm-border {\r\n  border-bottom: transparent solid 4px;\r\n}\r\n\r\n// Progress Box\r\n\r\n.progress-box {\r\n  text-align: center;\r\n\r\n  h4 {\r\n    font-size: $font-size-base;\r\n    font-weight: bold;\r\n    opacity: .6;\r\n    text-transform: uppercase;\r\n    padding-bottom: math.div($widget-spacer, 3)\r\n  }\r\n\r\n  svg {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.svg-bg {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: .1;\r\n\r\n  svg {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.widget-numbers-sm {\r\n  font-size: 1.5rem;\r\n}","// Content Boxes\r\n\r\n// Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$widget-spacer: $spacer;\r\n\r\n.widget-content {\r\n  padding: $widget-spacer;\r\n  flex-direction: row;\r\n  align-items: center;\r\n\r\n  .widget-content-wrapper {\r\n    display: flex;\r\n    flex: 1;\r\n    position: relative;\r\n    align-items: center;\r\n  }\r\n\r\n  .widget-content-left {\r\n\r\n    .widget-heading {\r\n      opacity: .8;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .widget-subheading {\r\n      opacity: .5;\r\n    }\r\n  }\r\n\r\n  .widget-content-right {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .widget-numbers {\r\n    font-weight: bold;\r\n    font-size: 1.8rem;\r\n    display: block;\r\n  }\r\n\r\n  .widget-content-outer {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .widget-progress-wrapper {\r\n    margin-top: $widget-spacer;\r\n\r\n    .progress-sub-label {\r\n      margin-top: math.div($widget-spacer, 3);\r\n      opacity: .5;\r\n      display: flex;\r\n      align-content: center;\r\n      align-items: center;\r\n\r\n      .sub-label-left {\r\n\r\n      }\r\n\r\n      .sub-label-right {\r\n        margin-left: auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  .widget-content-right {\r\n    &.widget-content-actions {\r\n      visibility: hidden;\r\n      opacity: 0;\r\n      transition: opacity .2s;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    .widget-content-right {\r\n      &.widget-content-actions {\r\n        visibility: visible;\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Profile Boxes\r\n\r\n@use \"sass:math\";\r\n\r\n.profile-block {\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  .profile-blur {\r\n    width: 100%;\r\n    height: 100%;\r\n    filter: blur(5px);\r\n    transform: scale(1.8);\r\n    position: absolute;\r\n    left: -25%;\r\n    top: -25%;\r\n  }\r\n\r\n  .profile-inner {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: .5;\r\n    left: 0;\r\n    top: 0;\r\n  }\r\n\r\n  .dropdown-menu-header {\r\n\r\n    .menu-header-content {\r\n      padding: $layout-spacer-lg;\r\n\r\n      .menu-header-title {\r\n        margin: math.div($layout-spacer-x, 2) 0 0;\r\n      }\r\n\r\n      .menu-header-subtitle {\r\n        margin: math.div($layout-spacer-x, 3) 0 0;\r\n      }\r\n    }\r\n\r\n    .menu-header-btn-pane {\r\n      margin: math.div($layout-spacer-x, 3) 0 0;\r\n\r\n      .btn-icon {\r\n        color: $white;\r\n        padding: 0;\r\n        width: 44px;\r\n        height: 44px;\r\n        line-height: 37px;\r\n        font-size: $font-size-lg;\r\n\r\n        &:hover {\r\n          background: rgba(255, 255, 255, .2);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n}","// User Pages\r\n\r\n.app-logo {\r\n  height: $logo-height;\r\n  width: $logo-width;\r\n  background: url('../../assets/utils/images/logo-inverse.png');\r\n}\r\n\r\n.app-logo-inverse {\r\n  height: $logo-height;\r\n  width: $logo-width;\r\n  background: url('../../assets/utils/images/logo.png');\r\n}\r\n\r\n.app-login-box {\r\n  .app-logo {\r\n    margin-bottom: $layout-spacer-lg;\r\n  }\r\n\r\n  h4 {\r\n    margin-bottom: $layout-spacer-x;\r\n    font-weight: normal;\r\n\r\n    div {\r\n      opacity: .6;\r\n    }\r\n\r\n    span {\r\n      font-size: $font-size-lg;\r\n    }\r\n  }\r\n}\r\n.chat-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n  padding: 10px;\r\n  height: 50vh;\r\n  overflow-y: scroll;\r\n  font-family: 'Helvetica Neue', Arial, sans-serif;\r\n}\r\n\r\n.message-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.chat-message {\r\n  display: flex;\r\n  margin: 10px;\r\n  padding: 10px;\r\n  max-width: 50%;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.left {\r\n  justify-content: flex-start;\r\n  align-self: flex-start;\r\n}\r\n\r\n.right {\r\n  justify-content: flex-end;\r\n  align-self: flex-end;\r\n}\r\n\r\n.chat-bubble {\r\n  padding: 10px;\r\n  border-radius: 15px;\r\n  position: relative;\r\n  background-color: white;\r\n  width: 100%;\r\n}\r\n\r\n.left .chat-bubble {\r\n  background-color: #f1f0f0;\r\n}\r\n\r\n.right .chat-bubble {\r\n  background-color: #593196;\r\n  margin-left: auto;\r\n}\r\n\r\n.chat-user-info {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.chat-profile-img {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  margin-right: 10px;\r\n}\r\n\r\n.chat-user-name {\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n.chat-message-content {\r\n  margin-top: 5px;\r\n}\r\n\r\n.chat-message-content p {\r\n  margin: 0;\r\n  padding: 5px;\r\n  font-size: 16px;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.chat-message-content small {\r\n  display: block;\r\n  text-align: right;\r\n  font-size: 12px;\r\n  color: gray;\r\n}\r\n\r\n.left .chat-bubble::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: -8px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background-color: #f1f0f0;\r\n  border-bottom-right-radius: 15px;\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.right .chat-bubble::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  right: -8px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background-color: #593196;\r\n  border-bottom-left-radius: 15px;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\n.chat-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.chat-container::-webkit-scrollbar-thumb {\r\n  background-color: #b0b0b0;\r\n  border-radius: 3px;\r\n}\r\n","// Applications\r\n\r\n@use \"sass:math\";\r\n\r\n$app-layout-sidebar-width         : 270px;\r\n$app-layout-aside-width           : 60px;\r\n$app-layout-header-height         : 50px;\r\n\r\n\r\n\r\n.app-inner-layout {\r\n\r\n  &.rm-sidebar {\r\n    .app-inner-layout__wrapper {\r\n      .app-inner-layout__content {\r\n        width: auto;\r\n        float: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__header {\r\n    width: 100%;\r\n    padding: $layout-spacer-x;\r\n    text-align: left;\r\n\r\n    .app-page-title {\r\n      margin: 0;\r\n      padding: 0;\r\n      background: transparent;\r\n    }\r\n\r\n    border-bottom: $gray-200 solid 1px;\r\n  }\r\n\r\n  .app-inner-layout__header-boxed {\r\n    padding: $layout-spacer-x;\r\n\r\n    .app-inner-layout__header {\r\n      @include border-radius($border-radius-lg);\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: row;\r\n    min-height: 100vh;\r\n\r\n    .app-inner-layout__content {\r\n      flex: 1;\r\n      display: flex;\r\n\r\n      &.card {\r\n        box-shadow: 0 0 0 0 transparent;\r\n        border-radius: 0;\r\n        border: 0;\r\n      }\r\n\r\n      .app-inner-layout__top-pane {\r\n        display: flex;\r\n        align-content: center;\r\n        align-items: center;\r\n        text-align: left;\r\n        padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n      }\r\n\r\n      .pane-left {\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n\r\n      .pane-right {\r\n        display: flex;\r\n        align-items: center;\r\n        margin-left: auto;\r\n      }\r\n\r\n      .app-inner-layout__bottom-pane {\r\n        padding: $layout-spacer-x;\r\n        border-top: $gray-200 solid 1px;\r\n      }\r\n    }\r\n\r\n    .app-inner-layout__sidebar {\r\n      width: $app-layout-sidebar-width;\r\n      list-style: none;\r\n      text-align: left;\r\n      order: -1;\r\n      flex: 0 0 $app-layout-sidebar-width;\r\n      display: flex;\r\n      margin: 0;\r\n      position: relative;\r\n\r\n      .dropdown-item {\r\n        white-space: normal;\r\n      }\r\n\r\n      &.card {\r\n        box-shadow: 0 0 0 0 transparent;\r\n        border-radius: 0;\r\n        background: $gray-100;\r\n        border: 0;\r\n        border-right: $gray-200 solid 1px;\r\n        border-left: $gray-200 solid 1px;\r\n      }\r\n\r\n      .app-inner-layout__sidebar-footer,\r\n      .app-inner-layout__sidebar-header {\r\n        background: $gray-100;\r\n      }\r\n    }\r\n\r\n    .app-inner-layout__aside {\r\n      width: $app-layout-aside-width;\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__footer {\r\n    width: 100%;\r\n    height: $app-layout-header-height;\r\n  }\r\n}\r\n\r\n.app-wrapper-footer {\r\n  .app-footer {\r\n    border-top: $gray-200 solid 1px;\r\n\r\n    .app-footer__inner {\r\n      border-left: $gray-200 solid 1px;\r\n    }\r\n  }\r\n}\r\n\r\n// Components\r\n\r\n@import \"chat\";\r\n\r\n// Responsive\r\n\r\n.mobile-app-menu-btn {\r\n  display: none;\r\n  margin: 3px $layout-spacer-x 0 0;\r\n}\r\n\r\n@import \"responsive\";","// Chat\r\n$app-layout-chat-sidebar-width: 360px;\r\n\r\n.chat-layout {\r\n  &.app-inner-layout {\r\n    .app-inner-layout__sidebar {\r\n      width: $app-layout-chat-sidebar-width;\r\n      flex: 0 0 $app-layout-chat-sidebar-width;\r\n    }\r\n  }\r\n\r\n  .app-inner-layout__top-pane h4 {\r\n    font-size: $h5-font-size;\r\n\r\n    div {\r\n      font-size: $font-size-base;\r\n    }\r\n  }\r\n\r\n  .chat-box-wrapper {\r\n    padding: $layout-spacer-x;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(lg) {\r\n  .chat-layout {\r\n    &.app-inner-layout {\r\n      .app-inner-layout__sidebar {\r\n        .widget-content .widget-content-left .widget-subheading {\r\n          white-space: normal;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","// Responsive Applications\r\n\r\n@include media-breakpoint-down(md) {\r\n  .app-inner-layout__sidebar {\r\n    display: none !important;\r\n  }\r\n\r\n  .mobile-app-menu-btn {\r\n    display: block;\r\n  }\r\n\r\n  .open-mobile-menu {\r\n\r\n    .app-inner-layout__sidebar {\r\n      display: block !important;\r\n    }\r\n  }\r\n}","/*\r\n * Container style\r\n */\r\n.ps {\r\n  overflow: hidden !important;\r\n  overflow-anchor: none;\r\n  touch-action: auto;\r\n}\r\n\r\n/*\r\n * Scrollbar rail styles\r\n */\r\n.ps__rail-x {\r\n  display: none !important;\r\n  opacity: 0;\r\n  transition: background-color .2s linear, opacity .2s linear;\r\n  height: 15px;\r\n  /* there must be 'bottom' or 'top' for ps__rail-x */\r\n  bottom: 0;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n  z-index: 7;\r\n}\r\n\r\n.ps__rail-y {\r\n  display: none;\r\n  opacity: 0;\r\n  transition: background-color .2s linear, opacity .2s linear;\r\n  width: 15px;\r\n  /* there must be 'right' or 'left' for ps__rail-y */\r\n  right: 0;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n  @include border-radius(50px);\r\n  z-index: 7;\r\n}\r\n\r\n.ps--active-x > .ps__rail-x,\r\n.ps--active-y > .ps__rail-y {\r\n  display: block;\r\n  background-color: transparent;\r\n}\r\n\r\n.ps:hover > .ps__rail-x,\r\n.ps:hover > .ps__rail-y,\r\n.ps--focus > .ps__rail-x,\r\n.ps--focus > .ps__rail-y,\r\n.ps--scrolling-x > .ps__rail-x,\r\n.ps--scrolling-y > .ps__rail-y {\r\n  opacity: 0.6;\r\n}\r\n\r\n.ps__rail-x:hover,\r\n.ps__rail-y:hover,\r\n.ps__rail-x:focus,\r\n.ps__rail-y:focus {\r\n  background-color: rgba(0, 0, 0, .1);\r\n  opacity: 0.9;\r\n}\r\n\r\n/*\r\n * Scrollbar thumb styles\r\n */\r\n.ps__thumb-x {\r\n  background-color: rgba(0, 0, 0, .1);\r\n  border-radius: 6px;\r\n  transition: background-color .2s linear, height .2s ease-in-out;\r\n  height: 6px;\r\n  /* there must be 'bottom' for ps__thumb-x */\r\n  bottom: 2px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__thumb-y {\r\n  background-color: rgba(0, 0, 0, .1);\r\n  border-radius: 6px;\r\n  transition: background-color .2s linear, width .2s ease-in-out;\r\n  width: 6px;\r\n  /* there must be 'right' for ps__thumb-y */\r\n  right: 2px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__rail-x:hover > .ps__thumb-x,\r\n.ps__rail-x:focus > .ps__thumb-x {\r\n  background-color: rgba(0, 0, 0, .12);\r\n  height: 11px;\r\n}\r\n\r\n.ps__rail-y:hover > .ps__thumb-y,\r\n.ps__rail-y:focus > .ps__thumb-y {\r\n  background-color: rgba(0, 0, 0, .12);\r\n  width: 11px;\r\n}\r\n\r\n/* MS supports */\r\n@supports (-ms-overflow-style: none) {\r\n  .ps {\r\n    overflow: auto !important;\r\n  }\r\n}\r\n\r\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\r\n  .ps {\r\n    overflow: auto !important;\r\n  }\r\n}\r\n\r\n.scrollbar-container {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n// Scroll Areas\r\n\r\n.scroll-area {\r\n  overflow-x: hidden;\r\n  height: 400px;\r\n}\r\n\r\n.scroll-area-xs {\r\n  height: 150px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-sm {\r\n  height: 200px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-md {\r\n  height: 300px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-lg {\r\n  height: 400px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.scroll-area-x {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.shadow-overflow {\r\n  position: relative;\r\n\r\n  &::after,\r\n  &::before {\r\n    width: 100%;\r\n    bottom: auto;\r\n    top: 0;\r\n    left: 0;\r\n    height: $layout-spacer-x;\r\n    position: absolute;\r\n    z-index: 10;\r\n    content: '';\r\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\r\n  }\r\n\r\n  &::after {\r\n    bottom: 0;\r\n    top: auto;\r\n\r\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\r\n  }\r\n\r\n}","\r\n@use \"sass:math\";\r\n\r\n.rc-tabs {\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.rc-tabs-bar,\r\n.rc-tabs-nav-container {\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  position: relative;\r\n  white-space: nowrap;\r\n  outline: none;\r\n  zoom: 1;\r\n  transition: padding .45s;\r\n}\r\n\r\n.rc-tabs-ink-bar {\r\n  margin-top: 0;\r\n  @include border-radius($border-radius);\r\n  box-shadow:\r\n          0 16px 26px -10px rgba($primary, 0.56),\r\n          0 4px 25px 0px rgba(0, 0, 0, 0.12),\r\n          0 8px 10px -5px rgba($primary, 0.2);\r\n}\r\n\r\n.rc-tabs-ink-bar-animated {\r\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\r\n}\r\n\r\n.rc-tabs-tab-prev,\r\n.rc-tabs-tab-next {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  z-index: 1;\r\n  line-height: 36px;\r\n  cursor: pointer;\r\n  border: none;\r\n  background-color: transparent;\r\n  position: absolute;\r\n}\r\n\r\n.rc-tabs-tab-prev-icon,\r\n.rc-tabs-tab-next-icon {\r\n  position: relative;\r\n  display: inline-block;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  line-height: inherit;\r\n  vertical-align: baseline;\r\n  text-align: center;\r\n  text-transform: none;\r\n  font-smoothing: antialiased;\r\n  text-stroke-width: 0;\r\n  font-family: sans-serif;\r\n}\r\n\r\n.rc-tabs-tab-prev-icon:before,\r\n.rc-tabs-tab-next-icon:before {\r\n  display: block;\r\n}\r\n\r\n.rc-tabs-tab-btn-disabled {\r\n  cursor: default;\r\n  color: $gray-700;\r\n}\r\n\r\n.rc-tabs-nav-wrap {\r\n  overflow: hidden;\r\n}\r\n\r\n.rc-tabs-nav {\r\n  box-sizing: border-box;\r\n  padding-left: 0;\r\n  position: relative;\r\n  margin: 0;\r\n  float: left;\r\n  list-style: none;\r\n  display: inline-block;\r\n  transform-origin: 0 0;\r\n\r\n  & > div:first-child {\r\n    z-index: 5;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.rc-tabs-nav-animated {\r\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\r\n}\r\n\r\n.rc-tabs-nav:before,\r\n.rc-tabs-nav:after {\r\n  display: table;\r\n  content: \" \";\r\n}\r\n\r\n.rc-tabs-nav:after {\r\n  clear: both;\r\n}\r\n\r\n.rc-tabs-tab {\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  display: block;\r\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\r\n  padding: 8px 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.rc-tabs-tab:hover {\r\n  color: $primary;\r\n}\r\n\r\n.rc-tabs-tab-active,\r\n.rc-tabs-tab-active:hover {\r\n  color: $white;\r\n  cursor: default;\r\n  transform: translateZ(0);\r\n}\r\n\r\n.rc-tabs-tab-disabled {\r\n  cursor: default;\r\n  color: $gray-700;\r\n}\r\n\r\n.rc-tabs-tab-disabled:hover {\r\n  color: $gray-700;\r\n}\r\n\r\n.rc-tabs-content {\r\n  zoom: 1;\r\n}\r\n\r\n.rc-tabs-content .rc-tabs-tabpane {\r\n  overflow: hidden;\r\n}\r\n\r\n.rc-tabs-content-animated {\r\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  will-change: transform;\r\n}\r\n\r\n.rc-tabs-content-animated .rc-tabs-tabpane {\r\n  -ms-flex-negative: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.no-flexbox .rc-tabs-content {\r\n  transform: none !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.no-csstransitions .rc-tabs-tabpane-inactive,\r\n.no-flexbox .rc-tabs-tabpane-inactive,\r\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\r\n  display: none;\r\n}\r\n\r\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\r\n  opacity: 1;\r\n  width: 100%;\r\n  height: 35px;\r\n}\r\n\r\n\r\n.rc-tabs-top .rc-tabs-tab-arrow-show {\r\n  opacity: 1;\r\n  width: 100%;\r\n  height: 35px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-content {\r\n  width: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\r\n  padding-left: 35px;\r\n  padding-right: 35px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-scroll {\r\n  width: 99999px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-swipe {\r\n  position: relative;\r\n  left: 0;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex: 1;\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-negative: 0;\r\n  flex-shrink: 0;\r\n  margin-right: 0;\r\n  padding: 8px 0;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-nav-wrap {\r\n  width: 100%;\r\n  padding: $layout-spacer-x math.div($grid-gutter-width, 2);\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-content-animated {\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\r\n  width: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-next {\r\n  right: 2px;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\r\n  content: \">\";\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-prev {\r\n  left: 0;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\r\n  content: \"<\";\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-prev,\r\n.rc-tabs-top .rc-tabs-tab-next {\r\n  margin-right: -2px;\r\n  width: 0;\r\n  height: 0;\r\n  top: 0;\r\n  text-align: center;\r\n  opacity: 0;\r\n  transition: width .3s, height .3s, opacity .3s;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab-arrow-show {\r\n  opacity: 1;\r\n  width: 35px;\r\n  height: 100%;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-ink-bar {\r\n  height: 35px;\r\n  bottom: 0;\r\n  left: 0;\r\n  background: $primary;\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tab {\r\n  float: left;\r\n  height: 100%;\r\n  line-height: 1.3;\r\n  margin-right: math.div($layout-spacer-x, 2);\r\n}\r\n\r\n.rc-tabs-top .rc-tabs-tabpane-inactive {\r\n  height: 0;\r\n  overflow: visible;\r\n}\r\n","/*!\r\n * Ladda\r\n * http://lab.hakim.se/ladda\r\n * MIT licensed\r\n *\r\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\r\n */\r\n\r\n\r\n/*************************************\r\n * CONFIG\r\n */\r\n\r\n@use \"sass:math\";\r\n\r\n$spinnerSize: 32px !default;\r\n\r\n\r\n/*************************************\r\n * MIXINS\r\n */\r\n\r\n@mixin transition( $value ) {\r\n  transition: $value !important;\r\n}\r\n\r\n@mixin transform( $value ) {\r\n  transform: $value;\r\n}\r\n\r\n/*************************************\r\n * Opacity animation for spin.js\r\n */\r\n\r\n@keyframes ladda-spinner-line-fade {\r\n  0%, 100% {\r\n    opacity: 0.22; /* minimum opacity */\r\n  }\r\n  1% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * BUTTON BASE\r\n */\r\n\r\n.ladda-button {\r\n  position: relative;\r\n}\r\n\r\n\r\n/* Spinner animation */\r\n.ladda-button .ladda-spinner {\r\n  position: absolute;\r\n  z-index: 2;\r\n  display: inline-block;\r\n  width: $spinnerSize;\r\n  top: 50%;\r\n  margin-top: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Button label */\r\n.ladda-button .ladda-label {\r\n  position: relative;\r\n  z-index: 3;\r\n}\r\n\r\n[class*=\"btn-outline-\"] {\r\n  .ladda-spinner div div div {\r\n    background: $black !important;\r\n  }\r\n\r\n  &.ladda-button .ladda-label {\r\n    transition: none !important;\r\n  }\r\n}\r\n\r\n/* Progress bar */\r\n.ladda-button .ladda-progress {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  background: rgba( 0, 0, 0, 0.2 );\r\n  display: none;\r\n\r\n  @include transition( 0.1s linear all );\r\n}\r\n.ladda-button[data-loading] .ladda-progress {\r\n  display: block;\r\n}\r\n\r\n\r\n/*************************************\r\n * EASING\r\n */\r\n\r\n.ladda-button,\r\n.ladda-button .ladda-spinner,\r\n.ladda-button .ladda-label {\r\n  @include transition( 0.3s cubic-bezier(0.175, 0.885, 0.320, 1.275) all );\r\n}\r\n\r\n.ladda-button[data-style=zoom-in],\r\n.ladda-button[data-style=zoom-in] .ladda-spinner,\r\n.ladda-button[data-style=zoom-in] .ladda-label,\r\n.ladda-button[data-style=zoom-out],\r\n.ladda-button[data-style=zoom-out] .ladda-spinner,\r\n.ladda-button[data-style=zoom-out] .ladda-label {\r\n  @include transition( 0.3s ease all );\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND RIGHT\r\n */\r\n\r\n.ladda-button[data-style=expand-right] {\r\n  .ladda-spinner {\r\n    right: math.div($spinnerSize, -2) + 10;\r\n  }\r\n\r\n  &[data-size=\"s\"] .ladda-spinner,\r\n  &[data-size=\"xs\"] .ladda-spinner {\r\n    right: math.div($spinnerSize, -2) + 4;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-right: 56px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-right: 40px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND LEFT\r\n */\r\n\r\n.ladda-button[data-style=expand-left] {\r\n  .ladda-spinner {\r\n    left: math.div($spinnerSize, 2) + 10;\r\n  }\r\n\r\n  &[data-size=\"s\"] .ladda-spinner,\r\n  &[data-size=\"xs\"] .ladda-spinner {\r\n    left: 4px;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-left: 56px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-left: 40px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND UP\r\n */\r\n\r\n.ladda-button[data-style=expand-up] {\r\n  overflow: hidden;\r\n\r\n  .ladda-spinner {\r\n    top: -$spinnerSize;\r\n    left: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-top: 54px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      top: math.div($spinnerSize, 2) + 10;\r\n      margin-top: 0;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-top: 32px;\r\n\r\n      .ladda-spinner {\r\n        top: 4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * EXPAND DOWN\r\n */\r\n\r\n.ladda-button[data-style=expand-down] {\r\n  overflow: hidden;\r\n\r\n  .ladda-spinner {\r\n    top: 52px;\r\n    left: 50%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  &[data-size=\"s\"] .ladda-spinner,\r\n  &[data-size=\"xs\"] .ladda-spinner {\r\n    top: 40px;\r\n  }\r\n\r\n  &[data-loading] {\r\n    padding-bottom: 54px;\r\n\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n    }\r\n\r\n    &[data-size=\"s\"],\r\n    &[data-size=\"xs\"] {\r\n      padding-bottom: 32px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE LEFT\r\n */\r\n.ladda-button[data-style=slide-left] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    left: 100%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      left: -100%;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      left: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE RIGHT\r\n */\r\n.ladda-button[data-style=slide-right] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    right: 100%;\r\n    margin-left: 0;\r\n    left: math.div($spinnerSize, 2);\r\n\r\n    [dir=\"rtl\"] & {\r\n      right: auto;\r\n    }\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      left: 100%;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      left: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE UP\r\n */\r\n.ladda-button[data-style=slide-up] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    left: 50%;\r\n    margin-left: 0;\r\n    margin-top: 1em;\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      top: -1em;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * SLIDE DOWN\r\n */\r\n.ladda-button[data-style=slide-down] {\r\n  overflow: hidden;\r\n\r\n  .ladda-label {\r\n    position: relative;\r\n  }\r\n  .ladda-spinner {\r\n    left: 50%;\r\n    margin-left: 0;\r\n    margin-top: -2em;\r\n  }\r\n\r\n  &[data-loading] {\r\n    .ladda-label {\r\n      opacity: 0;\r\n      top: 1em;\r\n    }\r\n    .ladda-spinner {\r\n      opacity: 1;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/*************************************\r\n * ZOOM-OUT\r\n */\r\n\r\n.ladda-button[data-style=zoom-out] {\r\n  overflow: hidden;\r\n}\r\n.ladda-button[data-style=zoom-out] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: $spinnerSize;\r\n\r\n  @include transform( scale( 2.5 ) );\r\n}\r\n.ladda-button[data-style=zoom-out] .ladda-label {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\r\n  opacity: 0;\r\n\r\n  @include transform( scale( 0.5 ) );\r\n}\r\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n  margin-left: 0;\r\n\r\n  @include transform( none );\r\n}\r\n\r\n\r\n/*************************************\r\n * ZOOM-IN\r\n */\r\n\r\n.ladda-button[data-style=zoom-in] {\r\n  overflow: hidden;\r\n}\r\n.ladda-button[data-style=zoom-in] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: math.div($spinnerSize, -2);\r\n\r\n  @include transform( scale( 0.2 ) );\r\n}\r\n.ladda-button[data-style=zoom-in] .ladda-label {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\r\n  opacity: 0;\r\n\r\n  @include transform( scale( 2.2 ) );\r\n}\r\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n  margin-left: 0;\r\n\r\n  @include transform( none );\r\n}\r\n\r\n\r\n/*************************************\r\n * CONTRACT\r\n */\r\n\r\n.ladda-button[data-style=contract] {\r\n  overflow: hidden;\r\n  width: 100px;\r\n}\r\n.ladda-button[data-style=contract] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: 0;\r\n}\r\n\r\n.ladda-button[data-style=contract][data-loading] {\r\n  border-radius: 50%;\r\n  width: 52px;\r\n}\r\n.ladda-button[data-style=contract][data-loading] .ladda-label {\r\n  opacity: 0;\r\n}\r\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n}\r\n\r\n\r\n\r\n/*************************************\r\n * OVERLAY\r\n */\r\n\r\n.ladda-button[data-style=contract-overlay] {\r\n  overflow: hidden;\r\n  width: 100px;\r\n\r\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0);\r\n}\r\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\r\n  left: 50%;\r\n  margin-left: 0;\r\n}\r\n\r\n.ladda-button[data-style=contract-overlay][data-loading] {\r\n  border-radius: 50%;\r\n  width: 52px;\r\n\r\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\r\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0.8);\r\n}\r\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\r\n  opacity: 0;\r\n}\r\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\r\n  opacity: 1;\r\n}\r\n\r\n\r\n[dir=\"rtl\"] .ladda-spinner > div {\r\n  left: 25% !important;\r\n}","@charset \"UTF-8\";\r\n/*!\r\n * Hamburgers\r\n * @description Tasty CSS-animated hamburgers\r\n * @author Jonathan Suh @jonsuh\r\n * @site https://jonsuh.com/hamburgers\r\n * @link https://github.com/jonsuh/hamburgers\r\n */\r\n\r\n// Settings\r\n// ==================================================\r\n$hamburger-padding-x           : 0px !default;\r\n$hamburger-padding-y           : 0px !default;\r\n$hamburger-layer-width         : 24px !default;\r\n$hamburger-layer-height        : 2px !default;\r\n$hamburger-layer-spacing       : 4px !default;\r\n$hamburger-layer-color         : $primary !default;\r\n$hamburger-layer-border-radius : 10px !default;\r\n$hamburger-hover-opacity       : 0.7 !default;\r\n$hamburger-active-layer-color  : $hamburger-layer-color !default;\r\n$hamburger-active-hover-opacity: $hamburger-hover-opacity !default;\r\n\r\n// To use CSS filters as the hover effect instead of opacity,\r\n// set $hamburger-hover-use-filter as true and\r\n// change the value of $hamburger-hover-filter accordingly.\r\n$hamburger-hover-use-filter   : false !default;\r\n$hamburger-hover-filter       : opacity(50%) !default;\r\n$hamburger-active-hover-filter: $hamburger-hover-filter !default;\r\n\r\n// Types (Remove or comment out what you don’t need)\r\n// ==================================================\r\n$hamburger-types: (\r\n  //3dx,\r\n  //3dx-r,\r\n  //3dy,\r\n  //3dy-r,\r\n  //3dxy,\r\n  //3dxy-r,\r\n  //arrow,\r\n  //arrow-r,\r\n  //arrowalt,\r\n  //arrowalt-r,\r\n  //arrowturn,\r\n  //arrowturn-r,\r\n  //boring,\r\n  //collapse,\r\n  //collapse-r,\r\n  elastic,\r\n  //elastic-r,\r\n  //emphatic,\r\n  //emphatic-r,\r\n  //minus,\r\n  //slider,\r\n  //slider-r,\r\n  //spin,\r\n  //spin-r,\r\n  //spring,\r\n  //spring-r,\r\n  //stand,\r\n  //stand-r,\r\n  //squeeze,\r\n  //vortex,\r\n  //vortex-r\r\n) !default;\r\n\r\n// Base Hamburger (We need this)\r\n// ==================================================\r\n@import \"base\";\r\n\r\n// Hamburger types\r\n// ==================================================\r\n@import \"types/3dx\";\r\n@import \"types/3dx-r\";\r\n@import \"types/3dy\";\r\n@import \"types/3dy-r\";\r\n@import \"types/3dxy\";\r\n@import \"types/3dxy-r\";\r\n@import \"types/arrow\";\r\n@import \"types/arrow-r\";\r\n@import \"types/arrowalt\";\r\n@import \"types/arrowalt-r\";\r\n@import \"types/arrowturn\";\r\n@import \"types/arrowturn-r\";\r\n@import \"types/boring\";\r\n@import \"types/collapse\";\r\n@import \"types/collapse-r\";\r\n@import \"types/elastic\";\r\n@import \"types/elastic-r\";\r\n@import \"types/emphatic\";\r\n@import \"types/emphatic-r\";\r\n@import \"types/minus\";\r\n@import \"types/slider\";\r\n@import \"types/slider-r\";\r\n@import \"types/spin\";\r\n@import \"types/spin-r\";\r\n@import \"types/spring\";\r\n@import \"types/spring-r\";\r\n@import \"types/stand\";\r\n@import \"types/stand-r\";\r\n@import \"types/squeeze\";\r\n@import \"types/vortex\";\r\n@import \"types/vortex-r\";\r\n\r\n// ==================================================\r\n// Cooking up additional types:\r\n//\r\n// The Sass for each hamburger type should be nested\r\n// inside an @if directive to check whether or not\r\n// it exists in $hamburger-types so only the CSS for\r\n// included types are generated.\r\n//\r\n// e.g. hamburgers/types/_new-type.scss\r\n//\r\n// @if index($hamburger-types, new-type) {\r\n//   .hamburger--new-type {\r\n//     ...\r\n//   }\r\n// }\r\n","// Hamburger\r\n// ==================================================\r\n@use \"sass:math\";\r\n\r\n.hamburger {\r\n  padding: $hamburger-padding-y $hamburger-padding-x;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n\r\n  transition-property: opacity, filter;\r\n  transition-duration: 0.15s;\r\n  transition-timing-function: linear;\r\n\r\n  // Normalize (<button>)\r\n  font: inherit;\r\n  color: inherit;\r\n  text-transform: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n  margin: 0;\r\n  overflow: visible;\r\n\r\n  &:hover {\r\n    @if $hamburger-hover-use-filter == true {\r\n      filter: $hamburger-hover-filter;\r\n    }\r\n    @else {\r\n      opacity: $hamburger-hover-opacity;\r\n    }\r\n  }\r\n\r\n  &.is-active {\r\n    &:hover {\r\n      @if $hamburger-hover-use-filter == true {\r\n        filter: $hamburger-active-hover-filter;\r\n      }\r\n      @else {\r\n        opacity: $hamburger-active-hover-opacity;\r\n      }\r\n    }\r\n\r\n    .hamburger-inner,\r\n    .hamburger-inner::before,\r\n    .hamburger-inner::after {\r\n      background-color: $hamburger-active-layer-color;\r\n    }\r\n  }\r\n}\r\n\r\n.hamburger-box {\r\n  width: $hamburger-layer-width;\r\n  height: $hamburger-layer-height * 3 + $hamburger-layer-spacing * 2;\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.hamburger-inner {\r\n  display: block;\r\n  top: 50%;\r\n  margin-top: math.div($hamburger-layer-height, -2);\r\n\r\n  &,\r\n  &::before,\r\n  &::after {\r\n    width: $hamburger-layer-width;\r\n    height: $hamburger-layer-height;\r\n    background-color: $hamburger-layer-color;\r\n    border-radius: $hamburger-layer-border-radius;\r\n    position: absolute;\r\n    transition-property: transform;\r\n    transition-duration: 0.15s;\r\n    transition-timing-function: ease;\r\n  }\r\n\r\n  &::before,\r\n  &::after {\r\n    content: \"\";\r\n    display: block;\r\n  }\r\n\r\n  &::before {\r\n    top: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\r\n  }\r\n\r\n  &::after {\r\n    bottom: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\r\n  }\r\n}\r\n","@use \"sass:math\";\r\n\r\n@if index($hamburger-types, elastic) {\r\n  /*\r\n   * Elastic\r\n   */\r\n  .hamburger--elastic {\r\n    .hamburger-inner {\r\n      top: math.div($hamburger-layer-height, 2);\r\n      transition-duration: 0.275s;\r\n      transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n\r\n      &::before {\r\n        top: $hamburger-layer-height + $hamburger-layer-spacing;\r\n        transition: opacity 0.125s 0.275s ease;\r\n      }\r\n\r\n      &::after {\r\n        top: ($hamburger-layer-height * 2) + ($hamburger-layer-spacing * 2);\r\n        transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n      }\r\n    }\r\n\r\n    &.is-active {\r\n      .hamburger-inner {\r\n        $y-offset: $hamburger-layer-spacing + $hamburger-layer-height;\r\n\r\n        transform: translate3d(0, $y-offset, 0) rotate(135deg);\r\n        transition-delay: 0.075s;\r\n\r\n        &::before {\r\n          transition-delay: 0s;\r\n          opacity: 0;\r\n        }\r\n\r\n        &::after {\r\n          transform: translate3d(0, $y-offset * -2, 0) rotate(-270deg);\r\n          transition-delay: 0.075s;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Drawers\r\n\r\n@use \"sass:math\";\r\n\r\n.drawer-content-wrapper {\r\n  background: $white;\r\n  position: relative;\r\n  padding: $layout-spacer-x;\r\n\r\n  .drawer-heading {\r\n    font-size: $font-size-sm;\r\n    color: $body-color;\r\n    margin: 0;\r\n    background: $gray-100;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    border-bottom: $gray-300 solid 1px;\r\n    border-top: $gray-300 solid 1px;\r\n\r\n    &:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  .drawer-section {\r\n    padding: $layout-spacer-x;\r\n  }\r\n\r\n  & > .app-sidebar__heading:first-child {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n.drawer-nav-btn {\r\n  @include border-radius(30px);\r\n  background: $white;\r\n  position: fixed;\r\n  right: math.div($layout-spacer-x, 2);\r\n  top: math.div($layout-spacer-x, 2);\r\n  padding: math.div($layout-spacer-x, 3);\r\n  box-shadow: $box-shadow-sm;\r\n  z-index: 20;\r\n\r\n  .hamburger {\r\n    margin-top: 4px;\r\n  }\r\n}","// @use \"sass:math\";\r\n\r\n// body.stop-scrolling {\r\n//   height: 100%;\r\n//   overflow: hidden;\r\n// }\r\n\r\n// .sweet-overlay {\r\n//   position: fixed;\r\n//   top: 0;\r\n//   right: 0;\r\n//   bottom: 0;\r\n//   left: 0;\r\n//   z-index: $zindex-modal-backdrop;\r\n//   background-color: $modal-backdrop-bg;\r\n//   opacity: $modal-backdrop-opacity !important;\r\n// }\r\n\r\n// .sweet-alert {\r\n//   background-color: $white;\r\n//   width: 30%;\r\n//   padding: $spacer;\r\n//   @include border-radius($border-radius);\r\n//   text-align: center;\r\n//   position: fixed;\r\n//   left: 50%;\r\n//   top: 50%;\r\n//   margin-left: -15%;\r\n//   margin-top: -15%;\r\n//   overflow: hidden;\r\n//   display: none;\r\n//   z-index: 99999;\r\n//   box-shadow: $box-shadow-lg-default;\r\n\r\n//   h2 {\r\n//     color: $gray-700;\r\n//     text-align: center;\r\n//     text-transform: none;\r\n//     position: relative;\r\n//     margin: math.div($spacer-sm, 2) 0;\r\n//     padding: 0;\r\n//     display: block;\r\n//   }\r\n\r\n//   p {\r\n//     color: $gray-500;\r\n//     text-align: center;\r\n//     position: relative;\r\n//     float: none;\r\n//     margin: 0;\r\n//     padding: 0;\r\n//   }\r\n\r\n//   fieldset {\r\n//     border: none;\r\n//     position: relative;\r\n//   }\r\n\r\n//   .sa-error-container {\r\n//     background-color: $gray-100;\r\n//     margin-left: -17px;\r\n//     margin-right: -17px;\r\n//     overflow: hidden;\r\n//     padding: 0 10px;\r\n//     max-height: 0;\r\n//     transition: padding 0.15s, max-height 0.15s;\r\n\r\n//     &.show {\r\n//       padding: 10px 0;\r\n//       max-height: 100px;\r\n//       transition: padding 0.25s, max-height 0.25s;\r\n//     }\r\n\r\n//     .icon {\r\n//       display: inline-block;\r\n//       width: 24px;\r\n//       height: 24px;\r\n//       border-radius: 50%;\r\n//       background-color: $danger;\r\n//       color: $white;\r\n//       line-height: 24px;\r\n//       text-align: center;\r\n//       margin-right: 3px;\r\n//     }\r\n\r\n//     p {\r\n//       display: inline-block;\r\n//     }\r\n//   }\r\n\r\n//   .sa-input-error {\r\n//     position: absolute;\r\n//     top: 29px;\r\n//     right: 26px;\r\n//     width: 20px;\r\n//     height: 20px;\r\n//     opacity: 0;\r\n//     -webkit-transform: scale(0.5);\r\n//     transform: scale(0.5);\r\n//     -webkit-transform-origin: 50% 50%;\r\n//     transform-origin: 50% 50%;\r\n//     -webkit-transition: all 0.1s;\r\n//     transition: all 0.1s;\r\n\r\n//     &::before, &::after {\r\n//       content: \"\";\r\n//       width: 20px;\r\n//       height: 6px;\r\n//       background-color: $danger;\r\n//       border-radius: 3px;\r\n//       position: absolute;\r\n//       top: 50%;\r\n//       margin-top: -4px;\r\n//       left: 50%;\r\n//       margin-left: -9px;\r\n//     }\r\n\r\n//     &::before {\r\n//       -webkit-transform: rotate(-45deg);\r\n//       transform: rotate(-45deg);\r\n//     }\r\n\r\n//     &::after {\r\n//       -webkit-transform: rotate(45deg);\r\n//       transform: rotate(45deg);\r\n//     }\r\n\r\n//     &.show {\r\n//       opacity: 1;\r\n//       -webkit-transform: scale(1);\r\n//       transform: scale(1);\r\n//     }\r\n//   }\r\n\r\n//   input {\r\n//     width: 100%;\r\n//     box-sizing: border-box;\r\n//     border-radius: 3px;\r\n//     border: 1px solid #d7d7d7;\r\n//     height: 43px;\r\n//     margin-top: 10px;\r\n//     margin-bottom: 17px;\r\n//     font-size: 18px;\r\n//     box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\r\n//     padding: 0 12px;\r\n//     display: none;\r\n//     -webkit-transition: all 0.3s;\r\n//     transition: all 0.3s;\r\n//   }\r\n\r\n//   input:focus {\r\n//     outline: none;\r\n//     box-shadow: 0 0 3px #c4e6f5;\r\n//     border: 1px solid #b4dbed;\r\n//   }\r\n\r\n//   .sweet-alert.show-input input {\r\n//     display: block;\r\n//   }\r\n\r\n//   .sa-confirm-button-container {\r\n//     display: inline-block;\r\n//     position: relative;\r\n//   }\r\n\r\n//   .la-ball-fall {\r\n//     position: absolute;\r\n//     left: 50%;\r\n//     top: 50%;\r\n//     margin-left: -27px;\r\n//     margin-top: 4px;\r\n//     opacity: 0;\r\n//     visibility: hidden;\r\n//   }\r\n\r\n//   button {\r\n//     display: inline-block;\r\n//     font-weight: $btn-font-weight;\r\n//     text-align: center;\r\n//     white-space: nowrap;\r\n//     font-size: $font-size-base;\r\n//     vertical-align: middle;\r\n//     user-select: none;\r\n//     border: $btn-border-width solid transparent;\r\n//     @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-border-radius);\r\n//     @include transition($btn-transition);\r\n//     @include button-variant($primary, $primary);\r\n\r\n//     // Share hover and focus styles\r\n//     // @include hover-focus {\r\n//     //   text-decoration: none;\r\n//     // }\r\n\r\n//     &:focus,\r\n//     &.focus {\r\n//       outline: 0;\r\n//       box-shadow: $btn-focus-box-shadow;\r\n//     }\r\n\r\n//     // Disabled comes first so active can properly restyle\r\n//     &.disabled,\r\n//     &:disabled {\r\n//       opacity: $btn-disabled-opacity;\r\n//       @include box-shadow(none);\r\n//     }\r\n//   }\r\n\r\n//   button.cancel {\r\n//     font-weight: $font-weight-normal;\r\n//     color: $link-color;\r\n//     background-color: transparent;\r\n//     border-color: transparent;\r\n//     margin-right: 0.5rem;\r\n\r\n//     // @include hover {\r\n//     //   color: $link-hover-color;\r\n//     //   text-decoration: $link-hover-decoration;\r\n//     //   background-color: transparent;\r\n//     //   border-color: transparent;\r\n//     // }\r\n\r\n//     &:active,\r\n//     &.active,\r\n//     &:focus,\r\n//     &.focus {\r\n//       text-decoration: none;\r\n//       border-color: transparent;\r\n//       box-shadow: none;\r\n//       background-color: transparent;\r\n//     }\r\n\r\n//     &:disabled,\r\n//     &.disabled {\r\n//       color: $btn-link-disabled-color;\r\n//       pointer-events: none;\r\n//     }\r\n//   }\r\n\r\n//   button.confirm[disabled] ~ .la-ball-fall {\r\n//     opacity: 1;\r\n//     visibility: visible;\r\n//     transition-delay: 0s;\r\n//   }\r\n\r\n//   &[data-has-cancel-button=false] button {\r\n//     box-shadow: none !important;\r\n//   }\r\n\r\n//   &[data-has-confirm-button=false][data-has-cancel-button=false] {\r\n//     padding-bottom: 40px;\r\n//   }\r\n\r\n//   .sa-button-container {\r\n//     padding: $spacer 0 0;\r\n//   }\r\n\r\n// }\r\n\r\n.sa-icon {\r\n  width: 80px;\r\n  height: 80px;\r\n  border: 4px solid $gray-300;\r\n  -webkit-border-radius: 40px;\r\n  border-radius: 50%;\r\n  margin: 20px auto;\r\n  padding: 0;\r\n  position: relative;\r\n  box-sizing: content-box;\r\n\r\n  &.sa-error {\r\n    border-color: $danger;\r\n\r\n    .sa-x-mark {\r\n      position: relative;\r\n      display: block;\r\n    }\r\n\r\n    .sa-line {\r\n      position: absolute;\r\n      height: 5px;\r\n      width: 47px;\r\n      background-color: $danger;\r\n      display: block;\r\n      top: 37px;\r\n      border-radius: 2px;\r\n\r\n      &.sa-left {\r\n        -webkit-transform: rotate(45deg);\r\n        transform: rotate(45deg);\r\n        left: 17px;\r\n      }\r\n\r\n      &.sa-right {\r\n        -webkit-transform: rotate(-45deg);\r\n        transform: rotate(-45deg);\r\n        right: 16px;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.sa-warning {\r\n    border-color: $warning;\r\n\r\n    .sa-body {\r\n      position: absolute;\r\n      width: 5px;\r\n      height: 47px;\r\n      left: 50%;\r\n      top: 10px;\r\n      -webkit-border-radius: 2px;\r\n      border-radius: 2px;\r\n      margin-left: -2px;\r\n      background-color: $warning;\r\n    }\r\n\r\n    .sa-dot {\r\n      position: absolute;\r\n      width: 7px;\r\n      height: 7px;\r\n      -webkit-border-radius: 50%;\r\n      border-radius: 50%;\r\n      margin-left: -3px;\r\n      left: 50%;\r\n      bottom: 10px;\r\n      background-color: $warning;\r\n    }\r\n  }\r\n\r\n  &.sa-info {\r\n    border-color: $info;\r\n\r\n    &::before {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 5px;\r\n      height: 29px;\r\n      left: 50%;\r\n      bottom: 17px;\r\n      border-radius: 2px;\r\n      margin-left: -2px;\r\n      background-color: $info;\r\n    }\r\n\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 7px;\r\n      height: 7px;\r\n      border-radius: 50%;\r\n      margin-left: -3px;\r\n      top: 19px;\r\n      background-color: $info;\r\n    }\r\n  }\r\n\r\n  &.sa-success {\r\n    border-color: $success;\r\n\r\n    &::before,\r\n    &::after {\r\n      content: '';\r\n      -webkit-border-radius: 40px;\r\n      border-radius: 50%;\r\n      position: absolute;\r\n      width: 60px;\r\n      height: 120px;\r\n      background: $white;\r\n      -webkit-transform: rotate(45deg);\r\n      transform: rotate(45deg);\r\n    }\r\n\r\n    &::before {\r\n      -webkit-border-radius: 120px 0 0 120px;\r\n      border-radius: 120px 0 0 120px;\r\n      top: -7px;\r\n      left: -33px;\r\n      -webkit-transform: rotate(-45deg);\r\n      transform: rotate(-45deg);\r\n      -webkit-transform-origin: 60px 60px;\r\n      transform-origin: 60px 60px;\r\n    }\r\n\r\n    &::after {\r\n      -webkit-border-radius: 0 120px 120px 0;\r\n      border-radius: 0 120px 120px 0;\r\n      top: -11px;\r\n      left: 30px;\r\n      -webkit-transform: rotate(-45deg);\r\n      transform: rotate(-45deg);\r\n      -webkit-transform-origin: 0 60px;\r\n      transform-origin: 0 60px;\r\n    }\r\n\r\n    .sa-placeholder {\r\n      width: 80px;\r\n      height: 80px;\r\n      border: 4px solid rgba(165, 220, 134, 0.2);\r\n      -webkit-border-radius: 40px;\r\n      border-radius: 40px;\r\n      border-radius: 50%;\r\n      box-sizing: content-box;\r\n      position: absolute;\r\n      left: -4px;\r\n      top: -4px;\r\n      z-index: 2;\r\n    }\r\n\r\n    .sa-fix {\r\n      width: 5px;\r\n      height: 90px;\r\n      background-color: $white;\r\n      position: absolute;\r\n      left: 28px;\r\n      top: 8px;\r\n      z-index: 1;\r\n      -webkit-transform: rotate(-45deg);\r\n      transform: rotate(-45deg);\r\n    }\r\n\r\n    .sa-line {\r\n      height: 5px;\r\n      background-color: $success;\r\n      display: block;\r\n      border-radius: 2px;\r\n      position: absolute;\r\n      z-index: 2;\r\n\r\n      &.sa-tip {\r\n        width: 25px;\r\n        left: 14px;\r\n        top: 46px;\r\n        -webkit-transform: rotate(45deg);\r\n        transform: rotate(45deg);\r\n      }\r\n\r\n      &.sa-long {\r\n        width: 47px;\r\n        right: 8px;\r\n        top: 38px;\r\n        -webkit-transform: rotate(-45deg);\r\n        transform: rotate(-45deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  &.sa-custom {\r\n    background-size: contain;\r\n    border-radius: 0;\r\n    border: none;\r\n    background-position: center center;\r\n    background-repeat: no-repeat;\r\n  }\r\n}\r\n\r\n// @media all and (max-width: 540px) {\r\n//   .sweet-alert {\r\n//     width: auto;\r\n//     margin-left: 0;\r\n//     margin-right: 0;\r\n//     left: 15px;\r\n//     right: 15px;\r\n//   }\r\n// }\r\n\r\n// /*\r\n//  * Animations\r\n//  */\r\n// @-webkit-keyframes showSweetAlert {\r\n//   0% {\r\n//     transform: scale(0.7);\r\n//     -webkit-transform: scale(0.7);\r\n//   }\r\n//   45% {\r\n//     transform: scale(1.05);\r\n//     -webkit-transform: scale(1.05);\r\n//   }\r\n//   80% {\r\n//     transform: scale(0.95);\r\n//     -webkit-transform: scale(0.95);\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n// }\r\n\r\n// @keyframes showSweetAlert {\r\n//   0% {\r\n//     transform: scale(0.7);\r\n//     -webkit-transform: scale(0.7);\r\n//   }\r\n//   45% {\r\n//     transform: scale(1.05);\r\n//     -webkit-transform: scale(1.05);\r\n//   }\r\n//   80% {\r\n//     transform: scale(0.95);\r\n//     -webkit-transform: scale(0.95);\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes hideSweetAlert {\r\n//   0% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n//   100% {\r\n//     transform: scale(0.5);\r\n//     -webkit-transform: scale(0.5);\r\n//   }\r\n// }\r\n\r\n// @keyframes hideSweetAlert {\r\n//   0% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//   }\r\n//   100% {\r\n//     transform: scale(0.5);\r\n//     -webkit-transform: scale(0.5);\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideFromTop {\r\n//   0% {\r\n//     top: 0%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideFromTop {\r\n//   0% {\r\n//     top: 0%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideToTop {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 0%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideToTop {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 0%;\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideFromBottom {\r\n//   0% {\r\n//     top: 70%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideFromBottom {\r\n//   0% {\r\n//     top: 70%;\r\n//   }\r\n//   100% {\r\n//     top: 50%;\r\n//   }\r\n// }\r\n\r\n// @-webkit-keyframes slideToBottom {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 70%;\r\n//   }\r\n// }\r\n\r\n// @keyframes slideToBottom {\r\n//   0% {\r\n//     top: 50%;\r\n//   }\r\n//   100% {\r\n//     top: 70%;\r\n//   }\r\n// }\r\n\r\n// .showSweetAlert[data-animation=pop] {\r\n//   -webkit-animation: showSweetAlert 0.3s;\r\n//   animation: showSweetAlert 0.3s;\r\n// }\r\n\r\n// .showSweetAlert[data-animation=none] {\r\n//   -webkit-animation: none;\r\n//   animation: none;\r\n// }\r\n\r\n// .showSweetAlert[data-animation=slide-from-top] {\r\n//   -webkit-animation: slideFromTop 0.3s;\r\n//   animation: slideFromTop 0.3s;\r\n// }\r\n\r\n// .showSweetAlert[data-animation=slide-from-bottom] {\r\n//   -webkit-animation: slideFromBottom 0.3s;\r\n//   animation: slideFromBottom 0.3s;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=pop] {\r\n//   -webkit-animation: hideSweetAlert 0.2s;\r\n//   animation: hideSweetAlert 0.2s;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=none] {\r\n//   -webkit-animation: none;\r\n//   animation: none;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=slide-from-top] {\r\n//   -webkit-animation: slideToTop 0.4s;\r\n//   animation: slideToTop 0.4s;\r\n// }\r\n\r\n// .hideSweetAlert[data-animation=slide-from-bottom] {\r\n//   -webkit-animation: slideToBottom 0.3s;\r\n//   animation: slideToBottom 0.3s;\r\n// }\r\n\r\n@-webkit-keyframes animateSuccessTip {\r\n  0% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  54% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  70% {\r\n    width: 50px;\r\n    left: -8px;\r\n    top: 37px;\r\n  }\r\n  84% {\r\n    width: 17px;\r\n    left: 21px;\r\n    top: 48px;\r\n  }\r\n  100% {\r\n    width: 25px;\r\n    left: 14px;\r\n    top: 45px;\r\n  }\r\n}\r\n\r\n@keyframes animateSuccessTip {\r\n  0% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  54% {\r\n    width: 0;\r\n    left: 1px;\r\n    top: 19px;\r\n  }\r\n  70% {\r\n    width: 50px;\r\n    left: -8px;\r\n    top: 37px;\r\n  }\r\n  84% {\r\n    width: 17px;\r\n    left: 21px;\r\n    top: 48px;\r\n  }\r\n  100% {\r\n    width: 25px;\r\n    left: 14px;\r\n    top: 45px;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes animateSuccessLong {\r\n  0% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  65% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  84% {\r\n    width: 55px;\r\n    right: 0;\r\n    top: 35px;\r\n  }\r\n  100% {\r\n    width: 47px;\r\n    right: 8px;\r\n    top: 38px;\r\n  }\r\n}\r\n\r\n@keyframes animateSuccessLong {\r\n  0% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  65% {\r\n    width: 0;\r\n    right: 46px;\r\n    top: 54px;\r\n  }\r\n  84% {\r\n    width: 55px;\r\n    right: 0;\r\n    top: 35px;\r\n  }\r\n  100% {\r\n    width: 47px;\r\n    right: 8px;\r\n    top: 38px;\r\n  }\r\n}\r\n\r\n// @-webkit-keyframes rotatePlaceholder {\r\n//   0% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   5% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   12% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n// }\r\n\r\n// @keyframes rotatePlaceholder {\r\n//   0% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   5% {\r\n//     transform: rotate(-45deg);\r\n//     -webkit-transform: rotate(-45deg);\r\n//   }\r\n//   12% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(-405deg);\r\n//     -webkit-transform: rotate(-405deg);\r\n//   }\r\n// }\r\n\r\n.animateSuccessTip {\r\n  -webkit-animation: animateSuccessTip 0.75s;\r\n  animation: animateSuccessTip 0.75s;\r\n}\r\n\r\n.animateSuccessLong {\r\n  -webkit-animation: animateSuccessLong 0.75s;\r\n  animation: animateSuccessLong 0.75s;\r\n}\r\n\r\n.sa-icon.sa-success.animate::after {\r\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\r\n  animation: rotatePlaceholder 4.25s ease-in;\r\n}\r\n\r\n// @-webkit-keyframes animateErrorIcon {\r\n//   0% {\r\n//     transform: rotateX(100deg);\r\n//     -webkit-transform: rotateX(100deg);\r\n//     opacity: 0;\r\n//   }\r\n//   100% {\r\n//     transform: rotateX(0deg);\r\n//     -webkit-transform: rotateX(0deg);\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// @keyframes animateErrorIcon {\r\n//   0% {\r\n//     transform: rotateX(100deg);\r\n//     -webkit-transform: rotateX(100deg);\r\n//     opacity: 0;\r\n//   }\r\n//   100% {\r\n//     transform: rotateX(0deg);\r\n//     -webkit-transform: rotateX(0deg);\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// .animateErrorIcon {\r\n//   -webkit-animation: animateErrorIcon 0.5s;\r\n//   animation: animateErrorIcon 0.5s;\r\n// }\r\n\r\n// @-webkit-keyframes animateXMark {\r\n//   0% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   50% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   80% {\r\n//     transform: scale(1.15);\r\n//     -webkit-transform: scale(1.15);\r\n//     margin-top: -6px;\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//     margin-top: 0;\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// @keyframes animateXMark {\r\n//   0% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   50% {\r\n//     transform: scale(0.4);\r\n//     -webkit-transform: scale(0.4);\r\n//     margin-top: 26px;\r\n//     opacity: 0;\r\n//   }\r\n//   80% {\r\n//     transform: scale(1.15);\r\n//     -webkit-transform: scale(1.15);\r\n//     margin-top: -6px;\r\n//   }\r\n//   100% {\r\n//     transform: scale(1);\r\n//     -webkit-transform: scale(1);\r\n//     margin-top: 0;\r\n//     opacity: 1;\r\n//   }\r\n// }\r\n\r\n// .animateXMark {\r\n//   -webkit-animation: animateXMark 0.5s;\r\n//   animation: animateXMark 0.5s;\r\n// }\r\n\r\n// @-webkit-keyframes pulseWarning {\r\n//   0% {\r\n//     border-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     border-color: $warning;\r\n//   }\r\n// }\r\n\r\n// @keyframes pulseWarning {\r\n//   0% {\r\n//     border-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     border-color: $warning;\r\n//   }\r\n// }\r\n\r\n// .pulseWarning {\r\n//   -webkit-animation: pulseWarning 0.75s infinite alternate;\r\n//   animation: pulseWarning 0.75s infinite alternate;\r\n// }\r\n\r\n// @-webkit-keyframes pulseWarningIns {\r\n//   0% {\r\n//     background-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     background-color: $warning;\r\n//   }\r\n// }\r\n\r\n// @keyframes pulseWarningIns {\r\n//   0% {\r\n//     background-color: #F8D486;\r\n//   }\r\n//   100% {\r\n//     background-color: $warning;\r\n//   }\r\n// }\r\n\r\n// .pulseWarningIns {\r\n//   -webkit-animation: pulseWarningIns 0.75s infinite alternate;\r\n//   animation: pulseWarningIns 0.75s infinite alternate;\r\n// }\r\n\r\n// @-webkit-keyframes rotate-loading {\r\n//   0% {\r\n//     transform: rotate(0deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(360deg);\r\n//   }\r\n// }\r\n\r\n// @keyframes rotate-loading {\r\n//   0% {\r\n//     transform: rotate(0deg);\r\n//   }\r\n//   100% {\r\n//     transform: rotate(360deg);\r\n//   }\r\n// }\r\n\r\n// /* Internet Explorer 9 has some special quirks that are fixed here */\r\n// /* The icons are not animated. */\r\n// /* This file is automatically merged into sweet-alert.min.js through Gulp */\r\n// /* Error icon */\r\n// .sweet-alert .sa-icon.sa-error .sa-line.sa-left {\r\n//   -ms-transform: rotate(45deg) \\9\r\n// ;\r\n// }\r\n\r\n// .sweet-alert .sa-icon.sa-error .sa-line.sa-right {\r\n//   -ms-transform: rotate(-45deg) \\9\r\n// ;\r\n// }\r\n\r\n/* Success icon */\r\n.sweet-alert .sa-icon.sa-success {\r\n  border-color: transparent \\9\r\n;\r\n}\r\n\r\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\r\n  -ms-transform: rotate(45deg) \\9\r\n;\r\n}\r\n\r\n.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {\r\n  -ms-transform: rotate(-45deg) \\9\r\n;\r\n}\r\n\r\n// /*!\r\n//  * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)\r\n//  * Copyright 2015 Daniel Cardoso <@DanielCardoso>\r\n//  * Licensed under MIT\r\n//  */\r\n// .la-ball-fall,\r\n// .la-ball-fall > div {\r\n//   position: relative;\r\n//   -webkit-box-sizing: border-box;\r\n//   -moz-box-sizing: border-box;\r\n//   box-sizing: border-box;\r\n// }\r\n\r\n// .la-ball-fall {\r\n//   display: block;\r\n//   font-size: 0;\r\n//   color: #fff;\r\n// }\r\n\r\n// .la-ball-fall.la-dark {\r\n//   color: #333;\r\n// }\r\n\r\n// .la-ball-fall > div {\r\n//   display: inline-block;\r\n//   float: none;\r\n//   background-color: currentColor;\r\n//   border: 0 solid currentColor;\r\n// }\r\n\r\n// .la-ball-fall {\r\n//   width: 54px;\r\n//   height: 18px;\r\n// }\r\n\r\n// .la-ball-fall > div {\r\n//   width: 10px;\r\n//   height: 10px;\r\n//   margin: 4px;\r\n//   border-radius: 100%;\r\n//   opacity: 0;\r\n//   -webkit-animation: ball-fall 1s ease-in-out infinite;\r\n//   -moz-animation: ball-fall 1s ease-in-out infinite;\r\n//   -o-animation: ball-fall 1s ease-in-out infinite;\r\n//   animation: ball-fall 1s ease-in-out infinite;\r\n// }\r\n\r\n// .la-ball-fall > div:nth-child(1) {\r\n//   -webkit-animation-delay: -200ms;\r\n//   -moz-animation-delay: -200ms;\r\n//   -o-animation-delay: -200ms;\r\n//   animation-delay: -200ms;\r\n// }\r\n\r\n// .la-ball-fall > div:nth-child(2) {\r\n//   -webkit-animation-delay: -100ms;\r\n//   -moz-animation-delay: -100ms;\r\n//   -o-animation-delay: -100ms;\r\n//   animation-delay: -100ms;\r\n// }\r\n\r\n// .la-ball-fall > div:nth-child(3) {\r\n//   -webkit-animation-delay: 0ms;\r\n//   -moz-animation-delay: 0ms;\r\n//   -o-animation-delay: 0ms;\r\n//   animation-delay: 0ms;\r\n// }\r\n\r\n// .la-ball-fall.la-sm {\r\n//   width: 26px;\r\n//   height: 8px;\r\n// }\r\n\r\n// .la-ball-fall.la-sm > div {\r\n//   width: 4px;\r\n//   height: 4px;\r\n//   margin: 2px;\r\n// }\r\n\r\n// .la-ball-fall.la-2x {\r\n//   width: 108px;\r\n//   height: 36px;\r\n// }\r\n\r\n// .la-ball-fall.la-2x > div {\r\n//   width: 20px;\r\n//   height: 20px;\r\n//   margin: 8px;\r\n// }\r\n\r\n// .la-ball-fall.la-3x {\r\n//   width: 162px;\r\n//   height: 54px;\r\n// }\r\n\r\n// .la-ball-fall.la-3x > div {\r\n//   width: 30px;\r\n//   height: 30px;\r\n//   margin: 12px;\r\n// }\r\n\r\n// /*\r\n//  * Animation\r\n//  */\r\n// @-webkit-keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n\r\n// @-moz-keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -moz-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -moz-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -moz-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -moz-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n\r\n// @-o-keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -o-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -o-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n\r\n// @keyframes ball-fall {\r\n//   0% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(-145%);\r\n//     -moz-transform: translateY(-145%);\r\n//     -o-transform: translateY(-145%);\r\n//     transform: translateY(-145%);\r\n//   }\r\n//   10% {\r\n//     opacity: .5;\r\n//   }\r\n//   20% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     -moz-transform: translateY(0);\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   80% {\r\n//     opacity: 1;\r\n//     -webkit-transform: translateY(0);\r\n//     -moz-transform: translateY(0);\r\n//     -o-transform: translateY(0);\r\n//     transform: translateY(0);\r\n//   }\r\n//   90% {\r\n//     opacity: .5;\r\n//   }\r\n//   100% {\r\n//     opacity: 0;\r\n//     -webkit-transform: translateY(145%);\r\n//     -moz-transform: translateY(145%);\r\n//     -o-transform: translateY(145%);\r\n//     transform: translateY(145%);\r\n//   }\r\n// }\r\n","@use \"sass:math\";\r\n\r\n.#{$rt-namespace}__toast-container {\r\n    z-index: $rt-z-index;\r\n    position: fixed;\r\n    padding: 0;\r\n    width: $rt-toast-width;\r\n    box-sizing: border-box;\r\n    color: $white;\r\n    &--top-left {\r\n        top: $spacer;\r\n        left: $spacer;\r\n    }\r\n    &--top-center {\r\n        top: $spacer;\r\n        left: 50%;\r\n        margin-left: -(math.div($rt-toast-width, 2));\r\n    }\r\n    &--top-right {\r\n        top: $spacer;\r\n        right: $spacer;\r\n    }\r\n    &--bottom-left {\r\n        bottom: $spacer;\r\n        left: $spacer;\r\n    }\r\n    &--bottom-center {\r\n        bottom: $spacer;\r\n        left: 50%;\r\n        margin-left: -(math.div($rt-toast-width, 2));\r\n    }\r\n    &--bottom-right {\r\n        bottom: $spacer;\r\n        right: $spacer;\r\n    }\r\n}\r\n\r\n@media #{$rt-mobile} {\r\n    .#{$rt-namespace}__toast-container {\r\n        width: 100vw;\r\n        padding: 0;\r\n        left: 0;\r\n        margin: 0;\r\n        &--top-left,\r\n        &--top-center,\r\n        &--top-right {\r\n            top: 0;\r\n        }\r\n        &--bottom-left,\r\n        &--bottom-center,\r\n        &--bottom-right {\r\n            bottom: 0;\r\n        }\r\n        &--rtl{\r\n          right: 0;\r\n          left: initial;\r\n        }\r\n    }\r\n}\r\n","$rt-namespace: 'Toastify';\r\n$rt-toast-width: 320px !default;\r\n$rt-toast-background: #ffffff !default;\r\n$rt-toast-min-height: 54px !default;\r\n$rt-toast-max-height: 800px !default;\r\n\r\n\r\n$rt-color-default: #fff !default;\r\n$rt-color-info: $info !default;\r\n$rt-color-success: $success !default;\r\n$rt-color-warning: $warning !default;\r\n$rt-color-error: $danger !default;\r\n\r\n$rt-color-progress-default: $primary !default;\r\n\r\n$rt-mobile: \"only screen and (max-width : 480px)\" !default;\r\n$rt-font-family: sans-serif !default;\r\n$rt-z-index: 9999 !default;\r\n\r\n","@use \"sass:math\";\r\n\r\n.#{$rt-namespace}__toast {\r\n    position: relative;\r\n    min-height: $rt-toast-min-height;\r\n    box-sizing: border-box;\r\n    margin-bottom: 1rem;\r\n    padding: $spacer;\r\n    @include border-radius($border-radius);\r\n    box-shadow: $box-shadow-default;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    max-height: $rt-toast-max-height;\r\n    overflow: hidden;\r\n    font-family: $rt-font-family;\r\n    cursor: pointer;\r\n    direction: ltr;\r\n    &--rtl {\r\n        direction: rtl;\r\n    }\r\n    &--default {\r\n        background: $rt-color-default;\r\n        color: $gray-700;\r\n        @include box-shadow-architect($primary);\r\n    }\r\n    &--info {\r\n        background: $rt-color-info;\r\n        @include box-shadow-architect($info);\r\n    }\r\n    &--success {\r\n        background: $rt-color-success;\r\n        @include box-shadow-architect($success);\r\n    }\r\n    &--warning {\r\n        background: $rt-color-warning;\r\n        @include box-shadow-architect($warning);\r\n    }\r\n    &--error {\r\n        background: $rt-color-error;\r\n        @include box-shadow-architect($danger);\r\n    }\r\n    &-body {\r\n        margin: auto 0;\r\n        padding: 0 0 math.div($spacer, 2.5);\r\n    }\r\n}\r\n\r\n@media #{$rt-mobile} {\r\n  .#{$rt-namespace}__toast{\r\n    margin-bottom: 0;  \r\n  }\r\n}",".#{$rt-namespace}__close-button {\r\n  color: $white;\r\n  font-size: 14px;\r\n  background: transparent;\r\n  outline: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  opacity: 0.7;\r\n  transition: 0.3s ease;\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 9px;\r\n  &--default {\r\n    color: #000;\r\n    opacity: 0.3;\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    opacity: 1;\r\n  }\r\n}\r\n","@keyframes #{$rt-namespace}__trackProgress {\r\n  0%{\r\n    width: 96%;\r\n  }\r\n  100%{\r\n    width: 0;\r\n  }\r\n}\r\n\r\n.#{$rt-namespace}__progress-bar {\r\n  position: absolute;\r\n  bottom: 9%;\r\n  left: 2%;\r\n  width: 0;\r\n  height: 5px;\r\n  z-index: $rt-z-index;\r\n  animation: #{$rt-namespace}__trackProgress linear 1;\r\n  background-color: rgba(255,255,255,.3);\r\n  @include border-radius($border-radius);\r\n\r\n  &--rtl {\r\n    right: 0;\r\n    left: initial;\r\n  }\r\n  &--default{\r\n    background: $rt-color-progress-default;\r\n  }\r\n\r\n  &--info{}\r\n  &--success{}\r\n  &--warning{}\r\n  &--error{}\r\n}\r\n","@mixin timing-function {\r\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInRight {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    from {\r\n        opacity: 0;\r\n        transform: translate3d(3000px, 0, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(-25px, 0, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(10px, 0, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(-5px, 0, 0);\r\n    }\r\n    to {\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutRight {\r\n    20% {\r\n        opacity: 1;\r\n        transform: translate3d(-20px, 0, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInLeft {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate3d(-3000px, 0, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(25px, 0, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(-10px, 0, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(5px, 0, 0);\r\n    }\r\n    to {\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutLeft {\r\n    20% {\r\n        opacity: 1;\r\n        transform: translate3d(20px, 0, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(-2000px, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInUp {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    from {\r\n        opacity: 0;\r\n        transform: translate3d(0, 3000px, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(0, -20px, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(0, 10px, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(0, -5px, 0);\r\n    }\r\n    to {\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutUp {\r\n    20% {\r\n        transform: translate3d(0, -10px, 0);\r\n    }\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        transform: translate3d(0, 20px, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(0, -2000px, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceInDown {\r\n    from,\r\n    60%,\r\n    75%,\r\n    90%,\r\n    to {\r\n        @include timing-function;\r\n    }\r\n    0% {\r\n        opacity: 0;\r\n        transform: translate3d(0, -3000px, 0);\r\n    }\r\n    60% {\r\n        opacity: 1;\r\n        transform: translate3d(0, 25px, 0);\r\n    }\r\n    75% {\r\n        transform: translate3d(0, -10px, 0);\r\n    }\r\n    90% {\r\n        transform: translate3d(0, 5px, 0);\r\n    }\r\n    to {\r\n        transform: none;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__bounceOutDown {\r\n    20% {\r\n        transform: translate3d(0, 10px, 0);\r\n    }\r\n    40%,\r\n    45% {\r\n        opacity: 1;\r\n        transform: translate3d(0, -20px, 0);\r\n    }\r\n    to {\r\n        opacity: 0;\r\n        transform: translate3d(0, 2000px, 0);\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__bounce-enter {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__bounceInLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__bounceInRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__bounceInDown;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__bounceInUp;\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__bounce-exit {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__bounceOutLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__bounceOutRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__bounceOutUp;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__bounceOutDown;\r\n    }\r\n}","@keyframes #{$rt-namespace}__zoomIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__zoomOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n    50% {\r\n        opacity: 0;\r\n        transform: scale3d(0.3, 0.3, 0.3);\r\n    }\r\n    to {\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__zoom-enter {\r\n    animation-name: #{$rt-namespace}__zoomIn;\r\n}\r\n\r\n.#{$rt-namespace}__zoom-exit {\r\n    animation-name: #{$rt-namespace}__zoomOut;\r\n}\r\n","@keyframes #{$rt-namespace}__flipIn {\r\n    from {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        animation-timing-function: ease-in;\r\n        opacity: 0;\r\n    }\r\n    40% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        animation-timing-function: ease-in;\r\n    }\r\n    60% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\r\n        opacity: 1\r\n    }\r\n    80% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\r\n    }\r\n    to {\r\n        transform: perspective(400px);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__flipOut {\r\n    from {\r\n        transform: perspective(400px);\r\n    }\r\n    30% {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\r\n        opacity: 1\r\n    }\r\n    to {\r\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__flip-enter {\r\n    animation-name: #{$rt-namespace}__flipIn;\r\n}\r\n\r\n.#{$rt-namespace}__flip-exit {\r\n    animation-name: #{$rt-namespace}__flipOut;\r\n}\r\n","@mixin transform {\r\n    transform: translate3d(0, 0, 0);\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInRight {\r\n    from {\r\n        transform: translate3d(110%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInLeft {\r\n    from {\r\n        transform: translate3d(-110%, 0, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInUp {\r\n    from {\r\n        transform: translate3d(0, 110%, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideInDown {\r\n    from {\r\n        transform: translate3d(0, -110%, 0);\r\n        visibility: visible;\r\n    }\r\n    to {\r\n        @include transform;\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutRight {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(110%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutLeft {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(-110%, 0, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutDown {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(0, 500px, 0);\r\n    }\r\n}\r\n\r\n@keyframes #{$rt-namespace}__slideOutUp {\r\n    from {\r\n        @include transform;\r\n    }\r\n    to {\r\n        visibility: hidden;\r\n        transform: translate3d(0, -500px, 0);\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__slide-enter {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__slideInLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__slideInRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__slideInDown;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__slideInUp;\r\n    }\r\n}\r\n\r\n.#{$rt-namespace}__slide-exit {\r\n    &--top-left,\r\n    &--bottom-left {\r\n        animation-name: #{$rt-namespace}__slideOutLeft;\r\n    }\r\n    &--top-right,\r\n    &--bottom-right {\r\n        animation-name: #{$rt-namespace}__slideOutRight;\r\n    }\r\n    &--top-center {\r\n        animation-name: #{$rt-namespace}__slideOutUp;\r\n    }\r\n    &--bottom-center {\r\n        animation-name: #{$rt-namespace}__slideOutDown;\r\n    }\r\n}","/* -- container -- */\r\n.rodal,\r\n.rodal-mask {\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100;\r\n}\r\n\r\n.rodal {\r\n  position: fixed;\r\n}\r\n\r\n/* -- mask -- */\r\n.rodal-mask {\r\n  position: absolute;\r\n  background-color: $modal-backdrop-bg;\r\n  opacity: $modal-backdrop-opacity;\r\n}\r\n\r\n/* -- dialog -- */\r\n.rodal-dialog {\r\n  position: absolute;\r\n  top: 10%;\r\n  left: 0;\r\n  right: 0;\r\n  margin: auto;\r\n  z-index: 101;\r\n  background: $white;\r\n  box-shadow: $box-shadow-lg-default;\r\n  @include border-radius($border-radius);\r\n  height: auto !important;\r\n}\r\n\r\n.rodal-dialog:focus {\r\n  outline: none;\r\n}\r\n\r\n/* -- close button -- */\r\n.rodal-close {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 16px;\r\n  right: 16px;\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.rodal-close:before,\r\n.rodal-close:after {\r\n  position: absolute;\r\n  content: '';\r\n  height: 2px;\r\n  width: 100%;\r\n  top: 50%;\r\n  left: 0;\r\n  margin-top: -1px;\r\n  background: $gray-500;\r\n  border-radius: 100%;\r\n  transition: background .2s;\r\n}\r\n\r\n.rodal-close:before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.rodal-close:after {\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.rodal-close:hover:before,\r\n.rodal-close:hover:after {\r\n  background: $gray-800;\r\n}\r\n\r\n/* -- fade -- */\r\n\r\n@keyframes rodal-fade-enter {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.rodal-fade-enter {\r\n  animation: rodal-fade-enter both ease-in;\r\n}\r\n\r\n@keyframes rodal-fade-leave {\r\n  to {\r\n    opacity: 0\r\n  }\r\n}\r\n\r\n.rodal-fade-leave {\r\n  animation: rodal-fade-leave both ease-out;\r\n}\r\n\r\n@keyframes rodal-zoom-enter {\r\n  from {\r\n    transform: scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-zoom-enter {\r\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-zoom-leave {\r\n  to {\r\n    transform: scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-zoom-leave {\r\n  animation: rodal-zoom-leave both;\r\n}\r\n\r\n@keyframes rodal-slideDown-enter {\r\n  from {\r\n    transform: translate3d(0, -100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideDown-enter {\r\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideDown-leave {\r\n  to {\r\n    transform: translate3d(0, -100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideDown-leave {\r\n  animation: rodal-slideDown-leave both;\r\n}\r\n\r\n/* -- slideLeft -- */\r\n\r\n@keyframes rodal-slideLeft-enter {\r\n  from {\r\n    transform: translate3d(-150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideLeft-enter {\r\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideLeft-leave {\r\n  to {\r\n    transform: translate3d(-150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideLeft-leave {\r\n  animation: rodal-slideLeft-leave both;\r\n}\r\n\r\n/* -- slideRight -- */\r\n\r\n@keyframes rodal-slideRight-enter {\r\n  from {\r\n    transform: translate3d(150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideRight-enter {\r\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideRight-leave {\r\n  to {\r\n    transform: translate3d(150px, 0, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideRight-leave {\r\n  animation: rodal-slideRight-leave both;\r\n}\r\n\r\n/* -- slideUp -- */\r\n\r\n@keyframes rodal-slideUp-enter {\r\n  from {\r\n    transform: translate3d(0, 100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideUp-enter {\r\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-slideUp-leave {\r\n  to {\r\n    transform: translate3d(0, 100px, 0);\r\n  }\r\n}\r\n\r\n.rodal-slideUp-leave {\r\n  animation: rodal-slideUp-leave both;\r\n}\r\n\r\n/* -- flip -- */\r\n\r\n@keyframes rodal-flip-enter {\r\n  from {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\r\n  }\r\n  70% {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\r\n  }\r\n  to {\r\n    transform: perspective(400px);\r\n  }\r\n}\r\n\r\n.rodal-flip-enter {\r\n  animation: rodal-flip-enter both ease-in;\r\n  backface-visibility: visible !important;\r\n}\r\n\r\n@keyframes rodal-flip-leave {\r\n  from {\r\n    transform: perspective(400px);\r\n  }\r\n  30% {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\r\n  }\r\n  to {\r\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\r\n  }\r\n}\r\n\r\n.rodal-flip-leave {\r\n  animation: rodal-flip-leave both;\r\n  backface-visibility: visible !important;\r\n}\r\n\r\n/* -- rotate -- */\r\n\r\n@keyframes rodal-rotate-enter {\r\n  from {\r\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-rotate-enter {\r\n  animation: rodal-rotate-enter both;\r\n  transform-origin: center;\r\n}\r\n\r\n@keyframes rodal-rotate-leave {\r\n  to {\r\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(.3, .3, .3);\r\n  }\r\n}\r\n\r\n.rodal-rotate-leave {\r\n  animation: rodal-rotate-leave both;\r\n  transform-origin: center;\r\n}\r\n\r\n/* -- door -- */\r\n\r\n@keyframes rodal-door-enter {\r\n  from {\r\n    transform: scale3d(0, 1, 1);\r\n  }\r\n}\r\n\r\n.rodal-door-enter {\r\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\r\n}\r\n\r\n@keyframes rodal-door-leave {\r\n  60% {\r\n    transform: scale3d(.01, 1, 1);\r\n  }\r\n  to {\r\n    transform: scale3d(0, 1, .1);\r\n  }\r\n}\r\n\r\n.rodal-door-leave {\r\n  animation: rodal-door-leave both;\r\n}",".react-sweet-progress {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.react-sweet-progress-symbol {\r\n  display: flex;\r\n  align-items: center;\r\n  -ms-flex-pack: start;\r\n  justify-content: flex-start;\r\n  width: 35px;\r\n  height: 20px;\r\n  padding-left: 10px;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  font-weight: 200;\r\n}\r\n\r\n.react-sweet-progress-symbol-absolute {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -ms-flex-pack: center;\r\n  justify-content: center;\r\n  transform: translate3d(-50%, -50%, 0);\r\n}\r\n\r\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n.react-sweet-progress-circle-outer {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.react-sweet-progress-line {\r\n  width: 100%;\r\n  border-radius: 100px;\r\n  background-color: #efefef;\r\n  vertical-align: middle;\r\n}\r\n\r\n.react-sweet-progress-line-inner {\r\n  position: relative;\r\n  min-height: 10px;\r\n  border-radius: 100px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.react-sweet-progress-line-inner-status-active:before {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\r\n  content: \"\";\r\n  opacity: 0;\r\n}\r\n\r\n@keyframes active-anim {\r\n  0% {\r\n    width: 0;\r\n    opacity: .1;\r\n  }\r\n  20% {\r\n    width: 0;\r\n    opacity: .5;\r\n  }\r\n  to {\r\n    width: 100%;\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.react-sweet-progress-circle path {\r\n  stroke-linecap: round;\r\n}\r\n","/* Slider */\r\n\r\n.slick-slider {\r\n  position: relative;\r\n  display: block;\r\n  box-sizing: border-box;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -ms-touch-action: pan-y;\r\n  touch-action: pan-y;\r\n  -webkit-tap-highlight-color: transparent;\r\n  max-width: 1400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.slick-slider-sm {\r\n  .slick-slider {\r\n    max-width: 450px;\r\n\r\n    .slick-prev {\r\n      left: -20px;\r\n    }\r\n\r\n    .slick-next {\r\n      right: -20px;\r\n    }\r\n  }\r\n}\r\n\r\n.slick-slider-md {\r\n  .slick-slider {\r\n    max-width: 650px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.slick-slider-hover {\r\n  .slick-arrow {\r\n    opacity: 0;\r\n    background: $primary-color;\r\n    color: $white !important;\r\n  }\r\n\r\n  .slick-prev {\r\n    left: -30px;\r\n\r\n  }\r\n\r\n  .slick-next {\r\n    right: -30px;\r\n  }\r\n\r\n\r\n  &:hover {\r\n    .slick-arrow {\r\n      opacity: 1;\r\n    }\r\n  }\r\n}\r\n\r\n.slick-list {\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: block;\r\n  margin: 0;\r\n  padding: 0;\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n\r\n  &.dragging {\r\n    cursor: pointer;\r\n    cursor: hand;\r\n  }\r\n}\r\n\r\n.slick-slider .slick-track,\r\n.slick-slider .slick-list {\r\n  -webkit-transform: translate3d(0, 0, 0);\r\n  -moz-transform: translate3d(0, 0, 0);\r\n  -ms-transform: translate3d(0, 0, 0);\r\n  -o-transform: translate3d(0, 0, 0);\r\n  transform: translate3d(0, 0, 0);\r\n}\r\n\r\n.slick-track {\r\n  position: relative;\r\n  left: 0;\r\n  top: 0;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  &:before,\r\n  &:after {\r\n    content: \"\";\r\n    display: table;\r\n  }\r\n\r\n  &:after {\r\n    clear: both;\r\n  }\r\n\r\n  .slick-loading & {\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n.slick-slide {\r\n  float: left;\r\n  height: 100%;\r\n  min-height: 1px;\r\n  [dir=\"rtl\"] & {\r\n    float: right;\r\n  }\r\n  img {\r\n    display: block;\r\n  }\r\n  &.slick-loading img {\r\n    display: none;\r\n  }\r\n\r\n  display: none;\r\n\r\n  &.dragging img {\r\n    pointer-events: none;\r\n  }\r\n\r\n  .slick-initialized & {\r\n    display: block;\r\n  }\r\n\r\n  .slick-loading & {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .slick-vertical & {\r\n    display: block;\r\n    height: auto;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n\r\n.slick-arrow.slick-hidden {\r\n  display: none;\r\n}\r\n\r\n@import \"slick-theme\";","// Default Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$slick-font-path: \"./fonts/\" !default;\r\n$slick-font-family: \"slick\" !default;\r\n$slick-loader-path: \"./\" !default;\r\n$slick-arrow-color: $primary !default;\r\n$slick-next-character: \"\\E684\" !default;\r\n$slick-prev-character: \"\\E686\" !default;\r\n$slick-dot-size: 6px !default;\r\n$slick-opacity-default: 0.75 !default;\r\n$slick-opacity-on-hover: 1 !default;\r\n$slick-opacity-not-active: 0.25 !default;\r\n\r\n/* Arrows */\r\n\r\n.slick-prev,\r\n.slick-next {\r\n  position: absolute;\r\n  display: block;\r\n  height: 40px;\r\n  width: 40px;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n  top: 50%;\r\n  transform: translate(0, -80%);\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: $box-shadow-default;\r\n  transition: all .2s;\r\n  font-family: 'Pe-icon-7-stroke';\r\n  @include border-radius(50px);\r\n  background: $white;\r\n  z-index: 6;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    font-size: 35px;\r\n    height: 40px;\r\n    line-height: 40px;\r\n    width: 40px;\r\n  }\r\n\r\n  &:hover, &:focus {\r\n    outline: none;\r\n    box-shadow: $box-shadow-lg;\r\n    color: $primary;\r\n  }\r\n\r\n  &.slick-disabled:before {\r\n    opacity: $slick-opacity-not-active;\r\n  }\r\n}\r\n\r\n.slick-prev {\r\n  left: 0;\r\n  &:before {\r\n    content: $slick-prev-character;\r\n\r\n  }\r\n}\r\n\r\n.slick-next {\r\n  right: 0;\r\n  &:before {\r\n    content: $slick-next-character;\r\n  }\r\n}\r\n\r\n/* Dots */\r\n\r\n.slick-dots {\r\n  list-style: none;\r\n  display: block;\r\n  text-align: center;\r\n  padding: 0;\r\n  margin: math.div($layout-spacer-x, 2) 0 0;\r\n  width: 100%;\r\n  li {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: 0;\r\n    margin: 0 5px;\r\n    cursor: pointer;\r\n    transform: scale(.8);\r\n    transition: all .2s;\r\n\r\n    button {\r\n      border: 0;\r\n      background: transparent;\r\n      display: block;\r\n      height: 14px;\r\n      width: 14px;\r\n      background: $primary;\r\n      cursor: pointer;\r\n      position: relative;\r\n      @include border-radius(20px);\r\n      color: transparent;\r\n\r\n      &::before {\r\n        content: '';\r\n        position: absolute;\r\n        background: $white;\r\n        left: 50%;\r\n        top: 50%;\r\n        margin: -4px 0 0 -4px;\r\n        display: block;\r\n        width: 8px;\r\n        height: 8px;\r\n        @include border-radius(20px);\r\n      }\r\n\r\n    }\r\n    &.slick-active {\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n}\r\n\r\n.slick-center {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.slick-slider {\r\n  .slide-img-bg {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-size: cover;\r\n    opacity: .4;\r\n    z-index: 10;\r\n  }\r\n\r\n  .slider-content {\r\n    position: relative;\r\n    z-index: 15;\r\n    text-align: center;\r\n    margin: 0 ($spacer-lg * 2);\r\n\r\n    h3 {\r\n      font-size: $h3-font-size;\r\n      font-weight: normal;\r\n      margin-bottom: $spacer-sm;\r\n    }\r\n\r\n    p {\r\n      font-size: $h6-font-size;\r\n      opacity: .7;\r\n    }\r\n  }\r\n}\r\n\r\n// slider-light\r\n\r\n.slider-light {\r\n  .slick-dots {\r\n    position: absolute;\r\n    bottom: 10px;\r\n\r\n    li button {\r\n      background: rgba(255, 255, 255, 0.25);\r\n    }\r\n  }\r\n\r\n  .slick-prev,\r\n  .slick-next {\r\n    background: transparent;\r\n    color: $white;\r\n    box-shadow: 0 0 0 0 transparent;\r\n\r\n    &:hover {\r\n      background: rgba(255,255,255,.15);\r\n    }\r\n  }\r\n\r\n  .slick-next {\r\n    right: 15px;\r\n  }\r\n\r\n  .slick-prev {\r\n    left: 15px;\r\n  }\r\n\r\n  .slider-content {\r\n    color: $white;\r\n  }\r\n}\r\n",".loading-indicator {\r\n  text-align: center;\r\n}\r\n\r\n.loading-bullet {\r\n  display: inline-block;\r\n  opacity: 0;\r\n  font-size: 2em;\r\n  color: #02a17c;\r\n}\r\n\r\n.block-ui {\r\n  position: relative;\r\n  min-height: 3em;\r\n}\r\n\r\n.block-ui-container {\r\n  position: absolute;\r\n  z-index: 1010;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  min-height: 2em;\r\n  cursor: wait;\r\n  overflow: hidden;\r\n}\r\n\r\n.block-ui-container:focus {\r\n  outline: none;\r\n}\r\n\r\n.block-ui-overlay {\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  background-color: white;\r\n}\r\n\r\n.block-ui-message-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  width: 100%;\r\n  right: 0;\r\n  text-align: center;\r\n  transform: translateY(-50%);\r\n  z-index: 10001;\r\n}\r\n\r\n.block-ui-message {\r\n  color: #333;\r\n  background: none;\r\n  z-index: 1011;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.block-overlay-dark {\r\n  .block-ui-overlay {\r\n    background: rgba(0,0,0,1);\r\n  }\r\n}","// Tooltips & Popovers\r\n\r\n// Popover\r\n\r\n@use \"sass:math\";\r\n\r\n.popover {\r\n  box-shadow: $box-shadow-default;\r\n\r\n  .grid-menu {\r\n    margin-bottom: -$popover-body-padding-y;\r\n    padding: 1px;\r\n\r\n    [class*=\"col-\"] {\r\n      padding: $popover-body-padding-y;\r\n    }\r\n\r\n    & + .nav {\r\n      .nav-item-btn {\r\n        margin-bottom: $popover-body-padding-y;\r\n      }\r\n    }\r\n  }\r\n\r\n  .grid-menu-xl {\r\n    margin-bottom: -(math.div($popover-body-padding-y, 1.35));\r\n\r\n    [class*=\"col-\"] {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .popover-inner {\r\n    .dropdown-menu-header {\r\n      @include border-top-radius($popover-border-radius);\r\n      overflow: hidden;\r\n      margin-top: -1px;\r\n      margin-left: -1px;\r\n      margin-right: -1px;\r\n    }\r\n  }\r\n}\r\n\r\n.rm-max-width {\r\n  & > .popover {\r\n    max-width: initial;\r\n  }\r\n}\r\n\r\n.rm-pointers {\r\n  & > .popover {\r\n    .arrow {\r\n      display: none !important;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin bg-popover($parent, $color) {\r\n  #{$parent} {\r\n    background-color: $color !important;\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include bg-popover(\".popover-#{$color}\", $value);\r\n}\r\n\r\n.popover-custom {\r\n  .popover-body {\r\n    padding-top: 0;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n\r\n    .dropdown-menu-header {\r\n      margin-top: 0;\r\n      @include border-top-radius($popover-border-radius);\r\n      overflow: hidden;\r\n\r\n      .menu-header-content {\r\n        padding: 0 $layout-spacer-x;\r\n      }\r\n\r\n      .dropdown-menu-header-inner.bg-light {\r\n        color: rgba(0, 0, 0, .8);\r\n      }\r\n    }\r\n  }\r\n\r\n  &.popover-custom-lg {\r\n    min-width: 22rem;\r\n  }\r\n\r\n  &.popover-custom-xl {\r\n    min-width: 25rem;\r\n  }\r\n\r\n  &.popover-custom-sm {\r\n    min-width: 15rem;\r\n  }\r\n}\r\n\r\n.popover-bg {\r\n  border: 0;\r\n\r\n  .arrow {\r\n    display: none;\r\n  }\r\n\r\n  .popover-header {\r\n    background: rgba(255, 255, 255, .1);\r\n    border-bottom: 0;\r\n    color: rgba(255, 255, 255, 1);\r\n\r\n    &::before {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .popover-body {\r\n    color: rgba(255, 255, 255, .7);\r\n  }\r\n\r\n  &.text-dark {\r\n    .popover-header {\r\n      color: rgba(0, 0, 0, .8);\r\n    }\r\n\r\n    .popover-body {\r\n      color: rgba(0, 0, 0, .7);\r\n    }\r\n  }\r\n}\r\n\r\n// Tooltip\r\n\r\n.tooltip-light {\r\n  & > .tooltip {\r\n    .tooltip-inner {\r\n      background: $white;\r\n      color: $gray-800;\r\n      box-shadow: $box-shadow-default;\r\n      border: $popover-border-color solid 1px;\r\n    }\r\n\r\n    .arrow {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n","// Sticky Elements\r\n\r\n.scrollable-block {\r\n  margin-bottom: 50px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  .sticky {\r\n    z-index: 2;\r\n  }\r\n}",".rbc-btn {\r\n  color: inherit;\r\n  font: inherit;\r\n  margin: 0;\r\n}\r\n\r\nbutton.rbc-btn {\r\n  overflow: visible;\r\n  text-transform: none;\r\n  -webkit-appearance: button;\r\n  cursor: pointer;\r\n}\r\n\r\nbutton[disabled].rbc-btn {\r\n  cursor: not-allowed;\r\n}\r\n\r\nbutton.rbc-input::-moz-focus-inner {\r\n  border: 0;\r\n  padding: 0;\r\n}\r\n","@import 'scss/variables';\r\n@import 'scss/reset';\r\n\r\n\r\n.rbc-calendar {\r\n  box-sizing: border-box;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n    flex: 1 1;\r\n    min-height: 580px;\r\n}\r\n\r\n.rbc-calendar *,\r\n.rbc-calendar *:before,\r\n.rbc-calendar *:after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n.rbc-abs-full {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.rbc-ellipsis {\r\n  display: block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rbc-rtl {\r\n  direction: rtl;\r\n}\r\n\r\n.rbc-off-range {\r\n  color: $out-of-range-color;\r\n}\r\n\r\n.rbc-header {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  padding: 0 3px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  font-weight: bold;\r\n  font-size: 90%;\r\n  min-height: 0;\r\n  flex: 1 0;\r\n  flex-basis: auto !important;\r\n\r\n  > a {\r\n    &, &:active, &:visited {\r\n      color: inherit;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-row-content {\r\n  position: relative;\r\n  user-select: none;\r\n  z-index: 4;\r\n}\r\n\r\n.rbc-today {\r\n  background-color: $today-highlight-bg;\r\n}\r\n\r\n\r\n@import 'scss/toolbar';\r\n@import 'scss/event';\r\n@import 'scss/month';\r\n@import 'scss/agenda';\r\n@import 'scss/time-grid';\r\n","\r\n@use \"sass:math\";\r\n\r\n$out-of-range-color: lighten(#333, 50%);\r\n\r\n$calendar-border: $gray-200;\r\n$cell-border: $gray-200;\r\n\r\n$border-color: $gray-300;\r\n\r\n$segment-width: percentage(math.div(1, 7));\r\n\r\n$time-selection-color: #white;\r\n$time-selection-bg-color: rgba(0,0,0, .50);\r\n$date-selection-bg-color: rgba(0,0,0, .10);\r\n\r\n\r\n$event-bg: $primary;\r\n$event-border: darken($event-bg, 10%);\r\n$event-color: $white;\r\n$event-border-radius: $border-radius;\r\n$event-padding: $dropdown-spacer;\r\n$event-zindex: 4;\r\n\r\n$btn-color: $white;\r\n$btn-bg: $primary;\r\n$btn-border: $primary;\r\n\r\n$current-time-color: $success;\r\n\r\n$rbc-css-prefix: rbc-i;\r\n\r\n$today-highlight-bg: $dropdown-link-hover-bg;\r\n","@use \"sass:math\";\r\n\r\n@import 'variables';\r\n\r\n$active-background: darken($btn-bg, 10%);\r\n$active-border: darken($btn-border, 12%);\r\n\r\n.rbc-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n\r\n  .rbc-toolbar-label {\r\n    width: 100%;\r\n    padding: 0 10px;\r\n    text-align: center;\r\n  }\r\n\r\n  & button {\r\n    color: $btn-color;\r\n    display: inline-block;\r\n    margin: 0;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    background: $primary;\r\n    border: 1px solid $btn-border;\r\n    padding: .375rem 1rem;\r\n    border-radius: $border-radius;\r\n    line-height: normal;\r\n    white-space: nowrap;\r\n    font-weight: bold;\r\n    text-transform: capitalize;\r\n    font-size: math.div($font-size-sm, 1.1);\r\n\r\n    &:active,\r\n    &.rbc-active {\r\n      background-image: none;\r\n      box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\r\n      background-color: $active-background;\r\n      border-color: $active-border;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $btn-color;\r\n        background-color: darken($btn-bg, 17%);\r\n        border-color: darken($btn-border, 25%);\r\n      }\r\n    }\r\n\r\n    &:focus {\r\n      color: $btn-color;\r\n      background-color: $active-background;\r\n      border-color: $active-border;\r\n    }\r\n\r\n    &:hover {\r\n      color: $btn-color;\r\n      background-color: $active-background;\r\n      border-color: $active-border;\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-btn-group {\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n\r\n  > button:first-child:not(:last-child) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  > button:last-child:not(:first-child) {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .rbc-rtl & > button:first-child:not(:last-child) {\r\n    border-radius: 4px;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .rbc-rtl & > button:last-child:not(:first-child) {\r\n    border-radius: 4px;\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n\r\n  > button:not(:first-child):not(:last-child) {\r\n    border-radius: 0;\r\n  }\r\n\r\n  button + button {\r\n    margin-left: -1px;\r\n  }\r\n\r\n  .rbc-rtl & button + button {\r\n    margin-left: 0;\r\n    margin-right: -1px;\r\n  }\r\n\r\n  & + &,\r\n  & + button {\r\n    margin-left: 10px;\r\n  }\r\n}\r\n","@import 'variables';\r\n\r\n.rbc-event {\r\n  cursor: pointer;\r\n  padding: $event-padding;\r\n  background-color: $event-bg;\r\n  border-radius: $event-border-radius;\r\n  color: $event-color;\r\n\r\n  &.rbc-selected {\r\n    background-color: darken($event-bg, 10%);\r\n  }\r\n}\r\n\r\n.rbc-event-label {\r\n  @extend .rbc-ellipsis;\r\n  font-size: 80%;\r\n}\r\n\r\n.rbc-event-overlaps {\r\n  box-shadow: -1px 1px 5px 0px rgba(51,51,51,.5);\r\n}\r\n\r\n.rbc-event-continues-prior {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n.rbc-event-continues-after {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n\r\n.rbc-event-continues-earlier {\r\n  border-top-left-radius: 0;\r\n  border-top-right-radius: 0;\r\n}\r\n.rbc-event-continues-later {\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n","@import 'variables';\r\n\r\n\r\n.rbc-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.rbc-row-segment {\r\n  padding: 0 1px 1px 1px;\r\n\r\n  .rbc-event-content {\r\n    @extend .rbc-ellipsis;\r\n  }\r\n}\r\n\r\n.rbc-selected-cell {\r\n  background-color: $date-selection-bg-color;\r\n}\r\n\r\n\r\n.rbc-show-more {\r\n  @extend .rbc-ellipsis;\r\n  background-color: rgba(255, 255, 255, 0.3);\r\n  z-index: $event-zindex;\r\n  font-weight: bold;\r\n  font-size: 85%;\r\n  height: auto;\r\n  line-height: normal;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rbc-month-view {\r\n  position: relative;\r\n  border: 1px solid $calendar-border;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 0 0;\r\n  width: 100%;\r\n  user-select: none;\r\n\r\n  height: 100%; // ie-fix\r\n\r\n  .rbc-header {\r\n    border-bottom: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-header + .rbc-header {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & .rbc-header + .rbc-header {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n}\r\n\r\n.rbc-month-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.rbc-month-row {\r\n  display: flex;\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex: 1 0 0;\r\n  overflow: hidden;\r\n\r\n  height: 100%; // ie-fix\r\n\r\n  & + & {\r\n    border-top: 1px solid $cell-border;\r\n  }\r\n}\r\n\r\n.rbc-date-cell {\r\n  padding-right: 5px;\r\n  text-align: right;\r\n  flex: 1 1;\r\n\r\n  &.rbc-now {\r\n    font-weight: bold;\r\n  }\r\n\r\n  > a {\r\n    &, &:active, &:visited {\r\n      color: inherit;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-row-bg {\r\n  @extend .rbc-abs-full;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 1 0 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.rbc-day-bg {\r\nflex: 1 0;\r\n  & + & {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & + & {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n}\r\n\r\n.rbc-off-range-bg {\r\n    background: $gray-100;\r\n}\r\n\r\n.rbc-overlay {\r\n  position: absolute;\r\n  z-index: $event-zindex + 1;\r\n  border: 1px solid #e5e5e5;\r\n  background-color: #fff;\r\n  box-shadow: 0 5px 15px rgba(0,0,0,.25);\r\n  padding: 10px;\r\n\r\n  > * + * {\r\n    margin-top: 1px;\r\n  }\r\n}\r\n\r\n.rbc-overlay-header {\r\n  border-bottom: 1px solid #e5e5e5;\r\n  margin: -10px -10px 5px -10px ;\r\n  padding: 2px 10px;\r\n}\r\n","\r\n.rbc-agenda-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1 0 0;\r\n  overflow: auto;\r\n\r\n  table {\r\n    width: 100%;\r\n    border: 1px solid $cell-border;\r\n\r\n    tbody > tr > td {\r\n      padding: 5px 10px;\r\n      vertical-align: top;\r\n\r\n    }\r\n\r\n    .rbc-agenda-time-cell {\r\n      padding-left: 15px;\r\n      padding-right: 15px;\r\n      text-transform: lowercase;\r\n    }\r\n\r\n    tbody > tr > td + td {\r\n      border-left: 1px solid $cell-border;\r\n    }\r\n\r\n    .rbc-rtl & {\r\n      tbody > tr > td + td {\r\n        border-left-width: 0;\r\n        border-right: 1px solid $cell-border;\r\n      }\r\n    }\r\n\r\n    tbody > tr + tr {\r\n      border-top: 1px solid $cell-border;\r\n    }\r\n\r\n    thead > tr > th {\r\n      padding: 3px 5px;\r\n      text-align: left;\r\n      border-bottom: 1px solid $cell-border;\r\n\r\n      .rbc-rtl & {\r\n        text-align: right;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.rbc-agenda-time-cell {\r\n  text-transform: lowercase;\r\n\r\n  .rbc-continues-after:after {\r\n    content: ' »'\r\n  }\r\n  .rbc-continues-prior:before {\r\n    content: '« '\r\n  }\r\n}\r\n\r\n.rbc-agenda-date-cell,\r\n.rbc-agenda-time-cell {\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n.rbc-agenda-event-cell {\r\n  width: 100%\r\n}\r\n","@import 'variables';\r\n\r\n\r\n.rbc-time-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100%;\r\n\r\n  .rbc-timeslot-group {\r\n    flex: 1;\r\n  }\r\n}\r\n\r\n\r\n.rbc-timeslot-group {\r\n  border-bottom: 1px solid $cell-border;\r\n  min-height: 40px;\r\n  display: flex;\r\n  flex-flow: column nowrap;\r\n}\r\n\r\n.rbc-time-gutter,\r\n.rbc-header-gutter {\r\n  flex: none;\r\n}\r\n\r\n.rbc-label {\r\n  padding: 0 5px;\r\n}\r\n\r\n.rbc-day-slot {\r\n  position: relative;\r\n\r\n  .rbc-event {\r\n    border: 1px solid $event-border;\r\n    display: flex;\r\n    max-height: 100%;\r\n    flex-flow: column wrap;\r\n    align-items: flex-start;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .rbc-event-label {\r\n    flex: none;\r\n    padding-right: 5px;\r\n    width: auto;\r\n  }\r\n\r\n  .rbc-event-content {\r\n    width: 100%;\r\n    flex: 1 1 0;\r\n    word-wrap: break-word;\r\n    line-height: 1;\r\n    height: 100%;\r\n    min-height: 1em;\r\n  }\r\n\r\n  .rbc-time-slot {\r\n    border-top: 1px solid lighten($cell-border, 10%);\r\n  }\r\n}\r\n\r\n.rbc-time-slot {\r\n  flex: 1 0 0;\r\n\r\n  &.rbc-now {\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n.rbc-day-header {\r\n  text-align: center;\r\n}\r\n\r\n.rbc-day-slot .rbc-event {\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n","@import 'variables';\r\n@import 'time-column';\r\n\r\n.rbc-slot-selection {\r\n  z-index: 10;\r\n  position: absolute;\r\n  cursor: default;\r\n  background-color: $time-selection-bg-color;\r\n  color: $time-selection-color;\r\n  font-size: 75%;\r\n  padding: 3px;\r\n}\r\n\r\n.rbc-time-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  width: 100%;\r\n  border: 1px solid $calendar-border;\r\n  min-height: 0;\r\n\r\n  .rbc-time-gutter {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .rbc-allday-cell {\r\n    width: 100%;\r\n    position: relative;\r\n  }\r\n\r\n  .rbc-allday-events {\r\n    position: relative;\r\n    z-index: 4;\r\n  }\r\n\r\n  .rbc-row {\r\n    min-height: 20px;\r\n  }\r\n}\r\n\r\n\r\n.rbc-time-header {\r\n  display: flex;\r\n  flex: 0 0 auto; // should not shrink below height\r\n  flex-direction: column;\r\n\r\n  &.rbc-overflowing {\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl &.rbc-overflowing {\r\n    border-right-width: 0;\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  > .rbc-row > * + * {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & > .rbc-row > * + * {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n\r\n  > .rbc-row:first-child {\r\n    border-bottom: 1px solid  $cell-border;\r\n  }\r\n\r\n  .rbc-gutter-cell {\r\n    flex: none;\r\n  }\r\n\r\n  > .rbc-gutter-cell + * {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.rbc-time-content {\r\n  display: flex;\r\n  flex: 1 0 0%;\r\n  align-items: flex-start;\r\n  width: 100%;\r\n  border-top: 2px solid $calendar-border;\r\n  overflow-y: auto;\r\n  position: relative;\r\n\r\n  > .rbc-time-gutter {\r\n    flex: none;\r\n  }\r\n\r\n  > * + * > * {\r\n    border-left: 1px solid $cell-border;\r\n  }\r\n\r\n  .rbc-rtl & > * + * > * {\r\n    border-left-width: 0;\r\n    border-right: 1px solid $cell-border;\r\n  }\r\n\r\n  > .rbc-day-slot {\r\n    width: 100%;\r\n    user-select: none;\r\n  }\r\n}\r\n\r\n.rbc-current-time-indicator {\r\n  position: absolute;\r\n  z-index: 1;\r\n  left: 0;\r\n  height: 1px;\r\n\r\n  background-color: $current-time-color;\r\n  pointer-events: none;\r\n\r\n  &::before {\r\n    display: block;\r\n\r\n    position: absolute;\r\n    left: -3px;\r\n    top: -3px;\r\n\r\n    content: ' ';\r\n    background-color: $current-time-color;\r\n\r\n    border-radius: 50%;\r\n    width: 8px;\r\n    height: 8px;\r\n  }\r\n\r\n  .rbc-rtl &::before {\r\n    left: 0;\r\n    right: -3px;\r\n  }\r\n}\r\n","// Layout Splitter\r\n\r\n.handle-bar {\r\n  background: transparent !important;\r\n  @include border-radius(30px);\r\n\r\n  &:active,\r\n  &:hover,\r\n  &.handle-bar_clone {\r\n    background-color: $gray-200 !important;\r\n  }\r\n\r\n  &.resize-not-allowed:hover {\r\n    background-color: $gray-200;\r\n  }\r\n\r\n  .handle-bar_drag {\r\n    border-color: $primary !important;\r\n  }\r\n}","/**\r\n * Extra class applied to VirtualScroll through className prop\r\n */\r\n.rst__virtualScrollOverride {\r\n  overflow: auto !important;\r\n}\r\n\r\n.ReactVirtualized__Grid__innerScrollContainer {\r\n  overflow: visible !important;\r\n}\r\n\r\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\r\n  direction: rtl;\r\n}\r\n\r\n.ReactVirtualized__Grid {\r\n  outline: none;\r\n}\r\n\r\n.rst__node {\r\n  min-width: 100%;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  text-align: left;\r\n}\r\n\r\n.rst__node.rst__rtl {\r\n  text-align: right;\r\n}\r\n\r\n.rst__nodeContent {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n}\r\n\r\n/* ==========================================================================\r\n   Scaffold\r\n\r\n    Line-overlaid blocks used for showing the tree structure\r\n   ========================================================================== */\r\n.rst__lineBlock,\r\n.rst__absoluteLineBlock {\r\n  height: 100%;\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.rst__absoluteLineBlock {\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n.rst__lineHalfHorizontalRight::before,\r\n.rst__lineFullVertical::after,\r\n.rst__lineHalfVerticalTop::after,\r\n.rst__lineHalfVerticalBottom::after {\r\n  position: absolute;\r\n  content: '';\r\n  background-color: black;\r\n}\r\n\r\n/**\r\n * +-----+\r\n * |     |\r\n * |  +--+\r\n * |     |\r\n * +-----+\r\n */\r\n.rst__lineHalfHorizontalRight::before {\r\n  height: 1px;\r\n  top: 50%;\r\n  right: 0;\r\n  width: 50%;\r\n}\r\n\r\n.rst__rtl.rst__lineHalfHorizontalRight::before {\r\n  left: 0;\r\n  right: initial;\r\n}\r\n\r\n.rst__lineFullVertical::after,\r\n.rst__lineHalfVerticalTop::after,\r\n.rst__lineHalfVerticalBottom::after {\r\n  width: 1px;\r\n  left: 50%;\r\n  top: 0;\r\n  height: 100%;\r\n}\r\n\r\n.rst__rtl.rst__lineFullVertical::after,\r\n.rst__rtl.rst__lineHalfVerticalTop::after,\r\n.rst__rtl.rst__lineHalfVerticalBottom::after {\r\n  right: 50%;\r\n  left: initial;\r\n}\r\n\r\n.rst__lineHalfVerticalTop::after {\r\n  height: 50%;\r\n}\r\n\r\n.rst__lineHalfVerticalBottom::after {\r\n  top: auto;\r\n  bottom: 0;\r\n  height: 50%;\r\n}\r\n\r\n/* Highlight line for pointing to dragged row destination\r\n   ========================================================================== */\r\n.rst__highlightLineVertical {\r\n  z-index: 3;\r\n}\r\n.rst__highlightLineVertical::before {\r\n  position: absolute;\r\n  content: '';\r\n  background-color: $primary;\r\n  width: 8px;\r\n  margin-left: -4px;\r\n  left: 50%;\r\n  top: 0;\r\n  height: 100%;\r\n}\r\n\r\n.rst__rtl.rst__highlightLineVertical::before {\r\n  margin-left: initial;\r\n  margin-right: -4px;\r\n  left: initial;\r\n  right: 50%;\r\n}\r\n\r\n@keyframes arrow-pulse {\r\n  0% {\r\n    transform: translate(0, 0);\r\n    opacity: 0;\r\n  }\r\n  30% {\r\n    transform: translate(0, 300%);\r\n    opacity: 1;\r\n  }\r\n  70% {\r\n    transform: translate(0, 700%);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: translate(0, 1000%);\r\n    opacity: 0;\r\n  }\r\n}\r\n.rst__highlightLineVertical::after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 0;\r\n  margin-left: -4px;\r\n  left: 50%;\r\n  top: 0;\r\n  border-left: 4px solid transparent;\r\n  border-right: 4px solid transparent;\r\n  border-top: 4px solid white;\r\n  animation: arrow-pulse 1s infinite linear both;\r\n}\r\n\r\n.rst__rtl.rst__highlightLineVertical::after {\r\n  margin-left: initial;\r\n  margin-right: -4px;\r\n  right: 50%;\r\n  left: initial;\r\n}\r\n\r\n/**\r\n * +-----+\r\n * |     |\r\n * |  +--+\r\n * |  |  |\r\n * +--+--+\r\n */\r\n.rst__highlightTopLeftCorner::before {\r\n  z-index: 3;\r\n  content: '';\r\n  position: absolute;\r\n  border-top: solid 8px $primary;\r\n  border-left: solid 8px $primary;\r\n  box-sizing: border-box;\r\n  height: calc(50% + 4px);\r\n  top: 50%;\r\n  margin-top: -4px;\r\n  right: 0;\r\n  width: calc(50% + 4px);\r\n}\r\n\r\n.rst__rtl.rst__highlightTopLeftCorner::before {\r\n  border-right: solid 8px $primary;\r\n  border-left: none;\r\n  left: 0;\r\n  right: initial;\r\n}\r\n\r\n/**\r\n * +--+--+\r\n * |  |  |\r\n * |  |  |\r\n * |  +->|\r\n * +-----+\r\n */\r\n.rst__highlightBottomLeftCorner {\r\n  z-index: 3;\r\n}\r\n.rst__highlightBottomLeftCorner::before {\r\n  content: '';\r\n  position: absolute;\r\n  border-bottom: solid 8px $primary;\r\n  border-left: solid 8px $primary;\r\n  box-sizing: border-box;\r\n  height: calc(100% + 4px);\r\n  top: 0;\r\n  right: 12px;\r\n  width: calc(50% - 8px);\r\n}\r\n\r\n.rst__rtl.rst__highlightBottomLeftCorner::before {\r\n  border-right: solid 8px $primary;\r\n  border-left: none;\r\n  left: 12px;\r\n  right: initial;\r\n}\r\n\r\n.rst__highlightBottomLeftCorner::after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 0;\r\n  right: 0;\r\n  top: 100%;\r\n  margin-top: -12px;\r\n  border-top: 12px solid transparent;\r\n  border-bottom: 12px solid transparent;\r\n  border-left: 12px solid $primary;\r\n}\r\n\r\n.rst__rtl.rst__highlightBottomLeftCorner::after {\r\n  left: 0;\r\n  right: initial;\r\n  border-right: 12px solid $primary;\r\n  border-left: none;\r\n}\r\n\r\n.rst__rowWrapper {\r\n  padding: 10px 10px 10px 0;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.rst__rtl.rst__rowWrapper {\r\n  padding: 10px 0 10px 10px;\r\n}\r\n\r\n.rst__row {\r\n  height: 100%;\r\n  white-space: nowrap;\r\n  display: flex;\r\n}\r\n.rst__row > * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/**\r\n * The outline of where the element will go if dropped, displayed while dragging\r\n */\r\n.rst__rowLandingPad,\r\n.rst__rowCancelPad {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n}\r\n.rst__rowLandingPad > *,\r\n.rst__rowCancelPad > * {\r\n  opacity: 0 !important;\r\n}\r\n.rst__rowLandingPad::before,\r\n.rst__rowCancelPad::before {\r\n  background-color: lightblue;\r\n  border: 1px dashed $white;\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n}\r\n\r\n/**\r\n * Alternate appearance of the landing pad when the dragged location is invalid\r\n */\r\n.rst__rowCancelPad::before {\r\n  background-color: #e6a8ad;\r\n}\r\n\r\n/**\r\n * Nodes matching the search conditions are highlighted\r\n */\r\n.rst__rowSearchMatch {\r\n  outline: solid 3px #0080ff;\r\n}\r\n\r\n/**\r\n * The node that matches the search conditions and is currently focused\r\n */\r\n.rst__rowSearchFocus {\r\n  outline: solid 3px #fc6421;\r\n}\r\n\r\n.rst__rowContents,\r\n.rst__rowLabel,\r\n.rst__rowToolbar,\r\n.rst__moveHandle,\r\n.rst__toolbarButton {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.rst__rowContents {\r\n  position: relative;\r\n  height: 100%;\r\n  border: solid $gray-300 1px;\r\n  border-left: none;\r\n  padding: 0 5px 0 10px;\r\n  border-radius: 2px;\r\n  min-width: 230px;\r\n  flex: 1 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: white;\r\n}\r\n\r\n.rst__rtl.rst__rowContents {\r\n  border-right: none;\r\n  border-left: solid $gray-300 1px;\r\n  padding: 0 10px 0 5px;\r\n}\r\n\r\n.rst__rowContentsDragDisabled {\r\n  border-left: solid $gray-300 1px;\r\n}\r\n\r\n.rst__rtl.rst__rowContentsDragDisabled {\r\n  border-right: solid $gray-300 1px;\r\n  border-left: solid $gray-300 1px;\r\n}\r\n\r\n.rst__rowLabel {\r\n  flex: 0 1 auto;\r\n  padding-right: 20px;\r\n}\r\n.rst__rtl.rst__rowLabel {\r\n  padding-left: 20px;\r\n  padding-right: inherit;\r\n}\r\n\r\n.rst__rowToolbar {\r\n  flex: 0 1 auto;\r\n  display: flex;\r\n}\r\n\r\n.rst__moveHandle,\r\n.rst__loadingHandle {\r\n  height: 100%;\r\n  width: 44px;\r\n  background: $gray-200\r\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+')\r\n  no-repeat center;\r\n  border: solid #aaa 1px;\r\n  cursor: move;\r\n  border-radius: 1px;\r\n  z-index: 1;\r\n}\r\n\r\n.rst__loadingHandle {\r\n  cursor: default;\r\n  background: $gray-200;\r\n}\r\n\r\n@keyframes pointFade {\r\n  0%,\r\n  19.999%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n  20% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.rst__loadingCircle {\r\n  width: 80%;\r\n  height: 80%;\r\n  margin: 10%;\r\n  position: relative;\r\n}\r\n\r\n.rst__loadingCirclePoint {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.rst__rtl.rst__loadingCirclePoint {\r\n  right: 0;\r\n  left: initial;\r\n}\r\n\r\n.rst__loadingCirclePoint::before {\r\n  content: '';\r\n  display: block;\r\n  margin: 0 auto;\r\n  width: 11%;\r\n  height: 30%;\r\n  background-color: $white;\r\n  border-radius: 30%;\r\n  animation: pointFade 800ms infinite ease-in-out both;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(1) {\r\n  transform: rotate(0deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(7) {\r\n  transform: rotate(180deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(1)::before,\r\n.rst__loadingCirclePoint:nth-of-type(7)::before {\r\n  animation-delay: -800ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(2) {\r\n  transform: rotate(30deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(8) {\r\n  transform: rotate(210deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(2)::before,\r\n.rst__loadingCirclePoint:nth-of-type(8)::before {\r\n  animation-delay: -666ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(3) {\r\n  transform: rotate(60deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(9) {\r\n  transform: rotate(240deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(3)::before,\r\n.rst__loadingCirclePoint:nth-of-type(9)::before {\r\n  animation-delay: -533ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(4) {\r\n  transform: rotate(90deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(10) {\r\n  transform: rotate(270deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(4)::before,\r\n.rst__loadingCirclePoint:nth-of-type(10)::before {\r\n  animation-delay: -400ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(5) {\r\n  transform: rotate(120deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(11) {\r\n  transform: rotate(300deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(5)::before,\r\n.rst__loadingCirclePoint:nth-of-type(11)::before {\r\n  animation-delay: -266ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(6) {\r\n  transform: rotate(150deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(12) {\r\n  transform: rotate(330deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(6)::before,\r\n.rst__loadingCirclePoint:nth-of-type(12)::before {\r\n  animation-delay: -133ms;\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(7) {\r\n  transform: rotate(180deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(13) {\r\n  transform: rotate(360deg);\r\n}\r\n.rst__loadingCirclePoint:nth-of-type(7)::before,\r\n.rst__loadingCirclePoint:nth-of-type(13)::before {\r\n  animation-delay: 0ms;\r\n}\r\n\r\n.rst__rowTitle {\r\n  font-weight: bold;\r\n}\r\n\r\n.rst__rowTitleWithSubtitle {\r\n  font-size: 85%;\r\n  display: block;\r\n  height: 0.8rem;\r\n}\r\n\r\n.rst__rowSubtitle {\r\n  font-size: 70%;\r\n  line-height: 1;\r\n}\r\n\r\n.rst__collapseButton,\r\n.rst__expandButton {\r\n  appearance: none;\r\n  border: none;\r\n  position: absolute;\r\n  border-radius: 100%;\r\n  box-shadow: 0 0 0 1px #000;\r\n  width: 16px;\r\n  height: 16px;\r\n  padding: 0;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  cursor: pointer;\r\n}\r\n.rst__rtl.rst__collapseButton,\r\n.rst__rtl.rst__expandButton {\r\n  transform: translate(50%, -50%);\r\n}\r\n.rst__collapseButton:focus,\r\n.rst__expandButton:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\r\n}\r\n.rst__collapseButton:hover:not(:active),\r\n.rst__expandButton:hover:not(:active) {\r\n  background-size: 24px;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.rst__collapseButton {\r\n  background: $white\r\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==')\r\n  no-repeat center;\r\n}\r\n\r\n.rst__expandButton {\r\n  background: $white\r\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+')\r\n  no-repeat center;\r\n}\r\n\r\n/**\r\n * Line for under a node with children\r\n */\r\n.rst__lineChildren {\r\n  height: 100%;\r\n  display: inline-block;\r\n  position: absolute;\r\n}\r\n.rst__lineChildren::after {\r\n  content: '';\r\n  position: absolute;\r\n  background-color: black;\r\n  width: 1px;\r\n  left: 50%;\r\n  bottom: 0;\r\n  height: 10px;\r\n}\r\n\r\n.rst__rtl.rst__lineChildren::after {\r\n  right: 50%;\r\n  left: initial;\r\n}\r\n\r\n.rst__placeholder {\r\n  position: relative;\r\n  height: 68px;\r\n  max-width: 300px;\r\n  padding: 10px;\r\n}\r\n.rst__placeholder,\r\n.rst__placeholder > * {\r\n  box-sizing: border-box;\r\n}\r\n.rst__placeholder::before {\r\n  border: 3px dashed $gray-200;\r\n  content: '';\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  bottom: 5px;\r\n  left: 5px;\r\n  z-index: -1;\r\n}\r\n\r\n/**\r\n * The outline of where the element will go if dropped, displayed while dragging\r\n */\r\n.rst__placeholderLandingPad,\r\n.rst__placeholderCancelPad {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n}\r\n.rst__placeholderLandingPad *,\r\n.rst__placeholderCancelPad * {\r\n  opacity: 0 !important;\r\n}\r\n.rst__placeholderLandingPad::before,\r\n.rst__placeholderCancelPad::before {\r\n  background-color: lightblue;\r\n  border-color: white;\r\n}\r\n\r\n/**\r\n * Alternate appearance of the landing pad when the dragged location is invalid\r\n */\r\n.rst__placeholderCancelPad::before {\r\n  background-color: #e6a8ad;\r\n}\r\n\r\n/* Collection default theme */\r\n\r\n.ReactVirtualized__Collection {\r\n}\r\n\r\n.ReactVirtualized__Collection__innerScrollContainer {\r\n}\r\n\r\n/* Grid default theme */\r\n\r\n.ReactVirtualized__Grid {\r\n}\r\n\r\n.ReactVirtualized__Grid__innerScrollContainer {\r\n}\r\n\r\n/* Table default theme */\r\n\r\n.ReactVirtualized__Table {\r\n}\r\n\r\n.ReactVirtualized__Table__Grid {\r\n}\r\n\r\n.ReactVirtualized__Table__headerRow {\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n.ReactVirtualized__Table__row {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.ReactVirtualized__Table__headerTruncatedText {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn,\r\n.ReactVirtualized__Table__rowColumn {\r\n  margin-right: 10px;\r\n  min-width: 0px;\r\n}\r\n.ReactVirtualized__Table__rowColumn {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ReactVirtualized__Table__headerColumn:first-of-type,\r\n.ReactVirtualized__Table__rowColumn:first-of-type {\r\n  margin-left: 10px;\r\n}\r\n.ReactVirtualized__Table__sortableHeaderColumn {\r\n  cursor: pointer;\r\n}\r\n\r\n.ReactVirtualized__Table__sortableHeaderIconContainer {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n}\r\n.ReactVirtualized__Table__sortableHeaderIcon {\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 24px;\r\n  flex: 0 0 24px;\r\n  height: 1em;\r\n  width: 1em;\r\n  fill: currentColor;\r\n}\r\n\r\n/* List default theme */\r\n\r\n.ReactVirtualized__List {\r\n}","@use \"sass:math\";\r\n\r\n.ReactTable {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n\r\n  .rt-table {\r\n    flex: auto 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    overflow: auto;\r\n  }\r\n\r\n  .-pagination input,\r\n  .-pagination select,\r\n  .rt-thead.-filters input,\r\n  .rt-thead.-filters select {\r\n    display: block;\r\n    width: 100%;\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n    background-clip: padding-box;\r\n    border: $input-border-width solid $input-border-color;\r\n\r\n    height: $input-height-sm;\r\n    padding: $input-padding-y-sm $input-padding-x-sm;\r\n    // line-height: $input-line-height-sm;\r\n    @include border-radius($input-border-radius-sm);\r\n\r\n    @if $enable-rounded {\r\n      border-radius: $input-border-radius;\r\n    } @else {\r\n      border-radius: 0;\r\n    }\r\n\r\n    @include box-shadow($input-box-shadow);\r\n    @include transition($input-transition);\r\n\r\n    &::-ms-expand {\r\n      background-color: transparent;\r\n      border: 0;\r\n    }\r\n\r\n    // @include form-control-focus();\r\n\r\n    // Placeholder\r\n    &::placeholder {\r\n      color: $input-placeholder-color;\r\n      opacity: 1;\r\n    }\r\n\r\n    &:disabled,\r\n    &[readonly] {\r\n      background-color: $input-disabled-bg;\r\n      opacity: 1;\r\n    }\r\n  }\r\n\r\n  .rt-thead {\r\n    flex: 1 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    user-select: none;\r\n\r\n    &.-headerGroups {\r\n      background: rgba(0, 0, 0, 0.03);\r\n      border-bottom: 1px solid $table-border-color;\r\n\r\n      .rt-th,\r\n      .rt-td {\r\n        padding: $table-cell-padding-sm;\r\n        color: $table-head-color;\r\n\r\n        &:hover {\r\n          color: $table-head-color;\r\n        }\r\n\r\n        &:empty {\r\n          padding: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.-filters {\r\n      border-bottom: 1px solid $table-border-color;\r\n      background: $gray-100;\r\n\r\n      .rt-th {\r\n        border-right: 1px solid $table-border-color;\r\n      }\r\n\r\n      &.-header {\r\n        box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\r\n      }\r\n    }\r\n\r\n    .rt-tr {\r\n      text-align: center;\r\n    }\r\n\r\n    .rt-th,\r\n    .rt-td {\r\n      padding: $table-cell-padding;\r\n      line-height: normal;\r\n      position: relative;\r\n      font-weight: bold;\r\n      border-right: 1px solid $table-border-color;\r\n      border-bottom: 1px solid $table-border-color;\r\n      transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n      box-shadow: inset 0 0 0 0 transparent;\r\n      color: $primary;\r\n\r\n      &:hover {\r\n        color: darken($primary, 15%);\r\n      }\r\n    }\r\n\r\n    .rt-th.-sort-asc,\r\n    .rt-td.-sort-asc {\r\n      box-shadow: inset 0 3px 0 0 $primary;\r\n    }\r\n\r\n    .rt-th.-sort-desc,\r\n    .rt-td.-sort-desc {\r\n      box-shadow: inset 0 -3px 0 0 $primary;\r\n    }\r\n\r\n    .rt-th.-cursor-pointer,\r\n    .rt-td.-cursor-pointer {\r\n      cursor: pointer;\r\n    }\r\n\r\n    .rt-th:last-child,\r\n    .rt-td:last-child {\r\n      border-right: 0;\r\n    }\r\n\r\n    .rt-resizable-header {\r\n      overflow: visible;\r\n    }\r\n\r\n    .rt-resizable-header:last-child {\r\n      overflow: hidden;\r\n    }\r\n\r\n    .rt-resizable-header-content {\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n    }\r\n\r\n    .rt-header-pivot {\r\n      border-right-color: #f7f7f7;\r\n    }\r\n\r\n    .rt-header-pivot:after,\r\n    .rt-header-pivot:before {\r\n      left: 100%;\r\n      top: 50%;\r\n      border: solid transparent;\r\n      content: \" \";\r\n      height: 0;\r\n      width: 0;\r\n      position: absolute;\r\n      pointer-events: none;\r\n    }\r\n\r\n    .rt-header-pivot:after {\r\n      border-color: rgba(255, 255, 255, 0);\r\n      border-left-color: $white;\r\n      border-width: 8px;\r\n      margin-top: -8px;\r\n    }\r\n\r\n    .rt-header-pivot:before {\r\n      border-color: rgba(102, 102, 102, 0);\r\n      border-left-color: #f7f7f7;\r\n      border-width: 10px;\r\n      margin-top: -10px;\r\n    }\r\n  }\r\n\r\n  .rt-tbody {\r\n    flex: 99999 1 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n\r\n    .rt-tr-group {\r\n      border-bottom: solid 1px $table-border-color;\r\n    }\r\n\r\n    .rt-tr-group:last-child {\r\n      border-bottom: 0;\r\n    }\r\n\r\n    .rt-td {\r\n      border-right: 1px solid $table-border-color;\r\n      align-items: center;\r\n      align-content: center;\r\n      display: flex;\r\n\r\n      [contenteditable=\"true\"] {\r\n        width: 100%;\r\n        border: 1px solid transparent;\r\n        background: $white !important;\r\n        @include border-radius($input-border-radius-sm);\r\n\r\n        &:focus {\r\n          padding: 3px 5px;\r\n          border-color: $input-focus-border-color;\r\n          outline: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .rt-td:last-child {\r\n      border-right: 0;\r\n    }\r\n\r\n    .rt-expandable {\r\n      cursor: pointer;\r\n      text-overflow: clip;\r\n    }\r\n  }\r\n\r\n  .rt-tr-group {\r\n    flex: 1 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .rt-tr {\r\n    flex: 1 0 auto;\r\n    display: inline-flex;\r\n  }\r\n\r\n  .rt-th,\r\n  .rt-td {\r\n    flex: 1 0 0;\r\n    text-overflow: ellipsis;\r\n    padding: $table-cell-padding;\r\n    //overflow: hidden;\r\n    transition: 0.3s ease;\r\n    transition-property: width, min-width, padding, opacity;\r\n\r\n    &.-hidden {\r\n      width: 0 !important;\r\n      min-width: 0 !important;\r\n      padding: 0 !important;\r\n      border: 0 !important;\r\n      opacity: 0 !important;\r\n    }\r\n  }\r\n\r\n  .rt-expander {\r\n    display: inline-block;\r\n    position: relative;\r\n    color: transparent;\r\n    margin: 0 10px 0 0;\r\n    &:after {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%) rotate(-90deg);\r\n      border-left: 5.04px solid transparent;\r\n      border-right: 5.04px solid transparent;\r\n      border-top: 7px solid rgba(0, 0, 0, 0.8);\r\n      transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n      cursor: pointer;\r\n    }\r\n    &.-open:after {\r\n      transform: translate(-50%, -50%) rotate(0);\r\n    }\r\n  }\r\n\r\n  .rt-resizer {\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 36px;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: -18px;\r\n    cursor: col-resize;\r\n    z-index: 10;\r\n  }\r\n\r\n  .rt-tfoot {\r\n    flex: 1 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\r\n\r\n    .rt-td {\r\n      border-right: 1px solid $table-border-color;\r\n      &:last-child {\r\n        border-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.-striped .rt-tr.-odd {\r\n    background: rgba(0, 0, 0, 0.03);\r\n  }\r\n\r\n  &.-fixed {\r\n    .-header {\r\n      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\r\n    }\r\n\r\n    .pagination-bottom {\r\n      box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\r\n    }\r\n  }\r\n\r\n  &.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\r\n    background: $dropdown-link-hover-bg;\r\n  }\r\n\r\n  .-pagination {\r\n    z-index: 1;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: stretch;\r\n    flex-wrap: wrap;\r\n    padding: 3px;\r\n    border-top: 2px solid rgba(0, 0, 0, 0.1);\r\n\r\n    .-btn {\r\n      appearance: none;\r\n      display: block;\r\n      width: 100%;\r\n      height: 100%;\r\n      border: 0;\r\n      border-radius: $border-radius;\r\n      padding: 6px;\r\n      font-size: 1em;\r\n      color: $primary;\r\n      background: $gray-100;\r\n      transition: all 0.2s ease;\r\n      cursor: pointer;\r\n      outline: none;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .-btn[disabled] {\r\n      opacity: 0.5;\r\n      cursor: default;\r\n    }\r\n\r\n    .-btn:not([disabled]):hover {\r\n      background: $primary;\r\n      color: $white;\r\n    }\r\n\r\n    .-previous,\r\n    .-next {\r\n      flex: 1;\r\n      text-align: center;\r\n    }\r\n\r\n    .-center {\r\n      text-align: center;\r\n      margin-bottom: 0;\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      align-items: center;\r\n      justify-content: space-around;\r\n    }\r\n\r\n    .-totalPages {\r\n      padding-left: 5px;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .-pageInfo {\r\n      display: inherit;\r\n      margin: 3px 0 3px 10px;\r\n      white-space: nowrap;\r\n      height: 30px;\r\n      line-height: 30px;\r\n    }\r\n\r\n    .-pageJump {\r\n      display: inline-block;\r\n      margin: 0 5px;\r\n    }\r\n\r\n    .-pageJump input {\r\n      width: 70px;\r\n      text-align: center;\r\n    }\r\n\r\n    .-pageSizeOptions {\r\n      margin: 3px 10px;\r\n    }\r\n  }\r\n\r\n  .rt-noData {\r\n    display: block;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: rgba(255, 255, 255, 0.8);\r\n    transition: all 0.3s ease;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n    padding: 20px;\r\n    color: rgba(0, 0, 0, 0.5);\r\n  }\r\n\r\n  .-loading {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    transition: all 0.3s ease;\r\n    z-index: -1;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .-loading > div {\r\n    position: absolute;\r\n    display: block;\r\n    text-align: center;\r\n    width: 100%;\r\n    top: 50%;\r\n    left: 0;\r\n    font-size: 15px;\r\n    color: $primary;\r\n    transform: translateY(-52%);\r\n    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n  }\r\n\r\n  .-loading.-active {\r\n    opacity: 1;\r\n    z-index: 2;\r\n    pointer-events: all;\r\n  }\r\n\r\n  .-loading.-active > div {\r\n    transform: translateY(50%);\r\n  }\r\n\r\n  .rt-resizing .rt-th,\r\n  .rt-resizing .rt-td {\r\n    transition: none !important;\r\n    cursor: col-resize;\r\n    user-select: none;\r\n  }\r\n}\r\n\r\n.table thead th,\r\n.table td {\r\n  vertical-align: middle;\r\n}\r\n\r\n.table {\r\n  th .filter {\r\n    margin-top: math.div($layout-spacer-x, 4);\r\n    height: auto;\r\n    padding: 0.3rem 0.5rem;\r\n  }\r\n}\r\n\r\n.caret-4-asc,\r\n.caret-4-desc {\r\n  font-family: \"Linearicons-Free\";\r\n  speak: none;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  text-transform: none;\r\n  line-height: 1;\r\n  margin-left: math.div($layout-spacer-x, 4);\r\n}\r\n\r\n.table .sortable:hover {\r\n  .caret-4-asc,\r\n  .caret-4-desc {\r\n    color: $primary;\r\n  }\r\n}\r\n\r\n.caret-4-asc {\r\n  @extend .lnr-chevron-up !optional;\r\n}\r\n\r\n.caret-4-desc {\r\n  @extend .lnr-chevron-down !optional;\r\n}\r\n\r\n// Table sizing\r\n\r\n.table-lg {\r\n  th,\r\n  td {\r\n    padding: ($table-cell-padding * 2) ($table-cell-padding * 1.5);\r\n  }\r\n}\r\n\r\n//react-data-table-component  css\r\n\r\n// .rdt_Table {\r\n//   border: 1px solid rgba(0,0,0,.1);\r\n// }\r\n\r\n// .rdt_TableCol {\r\n//   padding: 0.55rem;\r\n//   line-height: normal;\r\n//   position: relative;\r\n//   font-weight: 700;\r\n//   border-right: 1px solid #e9ecef;\r\n//   border-bottom: 1px solid #e9ecef;\r\n//   transition: box-shadow .3s cubic-bezier(.175,.885,.32,1.275);\r\n//   box-shadow: inset 0 0 0 0 transparent;\r\n//   color: #545cd8;\r\n// }\r\n\r\n// .rdt_TableCell {\r\n//   border-right: 1px solid #e9ecef;\r\n// }\r\n\r\n// .rdt_TableRow:nth-child(odd) {\r\n//   background-color: #FFFFFF;\r\n// }\r\n// .rdt_TableRow:nth-child(even) {\r\n//   background-color: #f7f7f7;\r\n// }\r\n\r\n// .rdt_TableRow:hover {\r\n//   background-color: $dropdown-link-hover-bg;\r\n// }\r\n","// Linear Icons\r\n$linearicons-font-path: \"linearicons\";\r\n\r\n\r\n@font-face {\r\n  font-family: 'Linearicons-Free';\r\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?w118d');\r\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?#iefixw118d') format('embedded-opentype'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.woff2?w118d') format('woff2'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.woff?w118d') format('woff'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.ttf?w118d') format('truetype'),\r\n  url('#{$linearicons-font-path}/Linearicons-Free.svg?w118d#Linearicons-Free') format('svg');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n[class^=\"lnr-\"],\r\n[class*=\" lnr-\"] {\r\n  font-family: 'Linearicons-Free';\r\n  speak: none;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  text-transform: none;\r\n  line-height: 1;\r\n\r\n  /* Better Font Rendering =========== */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.lnr-home:before {\r\n  content: \"\\e800\";\r\n}\r\n.lnr-apartment:before {\r\n  content: \"\\e801\";\r\n}\r\n.lnr-pencil:before {\r\n  content: \"\\e802\";\r\n}\r\n.lnr-magic-wand:before {\r\n  content: \"\\e803\";\r\n}\r\n.lnr-drop:before {\r\n  content: \"\\e804\";\r\n}\r\n.lnr-lighter:before {\r\n  content: \"\\e805\";\r\n}\r\n.lnr-poop:before {\r\n  content: \"\\e806\";\r\n}\r\n.lnr-sun:before {\r\n  content: \"\\e807\";\r\n}\r\n.lnr-moon:before {\r\n  content: \"\\e808\";\r\n}\r\n.lnr-cloud:before {\r\n  content: \"\\e809\";\r\n}\r\n.lnr-cloud-upload:before {\r\n  content: \"\\e80a\";\r\n}\r\n.lnr-cloud-download:before {\r\n  content: \"\\e80b\";\r\n}\r\n.lnr-cloud-sync:before {\r\n  content: \"\\e80c\";\r\n}\r\n.lnr-cloud-check:before {\r\n  content: \"\\e80d\";\r\n}\r\n.lnr-database:before {\r\n  content: \"\\e80e\";\r\n}\r\n.lnr-lock:before {\r\n  content: \"\\e80f\";\r\n}\r\n.lnr-cog:before {\r\n  content: \"\\e810\";\r\n}\r\n.lnr-trash:before {\r\n  content: \"\\e811\";\r\n}\r\n.lnr-dice:before {\r\n  content: \"\\e812\";\r\n}\r\n.lnr-heart:before {\r\n  content: \"\\e813\";\r\n}\r\n.lnr-star:before {\r\n  content: \"\\e814\";\r\n}\r\n.lnr-star-half:before {\r\n  content: \"\\e815\";\r\n}\r\n.lnr-star-empty:before {\r\n  content: \"\\e816\";\r\n}\r\n.lnr-flag:before {\r\n  content: \"\\e817\";\r\n}\r\n.lnr-envelope:before {\r\n  content: \"\\e818\";\r\n}\r\n.lnr-paperclip:before {\r\n  content: \"\\e819\";\r\n}\r\n.lnr-inbox:before {\r\n  content: \"\\e81a\";\r\n}\r\n.lnr-eye:before {\r\n  content: \"\\e81b\";\r\n}\r\n.lnr-printer:before {\r\n  content: \"\\e81c\";\r\n}\r\n.lnr-file-empty:before {\r\n  content: \"\\e81d\";\r\n}\r\n.lnr-file-add:before {\r\n  content: \"\\e81e\";\r\n}\r\n.lnr-enter:before {\r\n  content: \"\\e81f\";\r\n}\r\n.lnr-exit:before {\r\n  content: \"\\e820\";\r\n}\r\n.lnr-graduation-hat:before {\r\n  content: \"\\e821\";\r\n}\r\n.lnr-license:before {\r\n  content: \"\\e822\";\r\n}\r\n.lnr-music-note:before {\r\n  content: \"\\e823\";\r\n}\r\n.lnr-film-play:before {\r\n  content: \"\\e824\";\r\n}\r\n.lnr-camera-video:before {\r\n  content: \"\\e825\";\r\n}\r\n.lnr-camera:before {\r\n  content: \"\\e826\";\r\n}\r\n.lnr-picture:before {\r\n  content: \"\\e827\";\r\n}\r\n.lnr-book:before {\r\n  content: \"\\e828\";\r\n}\r\n.lnr-bookmark:before {\r\n  content: \"\\e829\";\r\n}\r\n.lnr-user:before {\r\n  content: \"\\e82a\";\r\n}\r\n.lnr-users:before {\r\n  content: \"\\e82b\";\r\n}\r\n.lnr-shirt:before {\r\n  content: \"\\e82c\";\r\n}\r\n.lnr-store:before {\r\n  content: \"\\e82d\";\r\n}\r\n.lnr-cart:before {\r\n  content: \"\\e82e\";\r\n}\r\n.lnr-tag:before {\r\n  content: \"\\e82f\";\r\n}\r\n.lnr-phone-handset:before {\r\n  content: \"\\e830\";\r\n}\r\n.lnr-phone:before {\r\n  content: \"\\e831\";\r\n}\r\n.lnr-pushpin:before {\r\n  content: \"\\e832\";\r\n}\r\n.lnr-map-marker:before {\r\n  content: \"\\e833\";\r\n}\r\n.lnr-map:before {\r\n  content: \"\\e834\";\r\n}\r\n.lnr-location:before {\r\n  content: \"\\e835\";\r\n}\r\n.lnr-calendar-full:before {\r\n  content: \"\\e836\";\r\n}\r\n.lnr-keyboard:before {\r\n  content: \"\\e837\";\r\n}\r\n.lnr-spell-check:before {\r\n  content: \"\\e838\";\r\n}\r\n.lnr-screen:before {\r\n  content: \"\\e839\";\r\n}\r\n.lnr-smartphone:before {\r\n  content: \"\\e83a\";\r\n}\r\n.lnr-tablet:before {\r\n  content: \"\\e83b\";\r\n}\r\n.lnr-laptop:before {\r\n  content: \"\\e83c\";\r\n}\r\n.lnr-laptop-phone:before {\r\n  content: \"\\e83d\";\r\n}\r\n.lnr-power-switch:before {\r\n  content: \"\\e83e\";\r\n}\r\n.lnr-bubble:before {\r\n  content: \"\\e83f\";\r\n}\r\n.lnr-heart-pulse:before {\r\n  content: \"\\e840\";\r\n}\r\n.lnr-construction:before {\r\n  content: \"\\e841\";\r\n}\r\n.lnr-pie-chart:before {\r\n  content: \"\\e842\";\r\n}\r\n.lnr-chart-bars:before {\r\n  content: \"\\e843\";\r\n}\r\n.lnr-gift:before {\r\n  content: \"\\e844\";\r\n}\r\n.lnr-diamond:before {\r\n  content: \"\\e845\";\r\n}\r\n.lnr-linearicons:before {\r\n  content: \"\\e846\";\r\n}\r\n.lnr-dinner:before {\r\n  content: \"\\e847\";\r\n}\r\n.lnr-coffee-cup:before {\r\n  content: \"\\e848\";\r\n}\r\n.lnr-leaf:before {\r\n  content: \"\\e849\";\r\n}\r\n.lnr-paw:before {\r\n  content: \"\\e84a\";\r\n}\r\n.lnr-rocket:before {\r\n  content: \"\\e84b\";\r\n}\r\n.lnr-briefcase:before {\r\n  content: \"\\e84c\";\r\n}\r\n.lnr-bus:before {\r\n  content: \"\\e84d\";\r\n}\r\n.lnr-car:before {\r\n  content: \"\\e84e\";\r\n}\r\n.lnr-train:before {\r\n  content: \"\\e84f\";\r\n}\r\n.lnr-bicycle:before {\r\n  content: \"\\e850\";\r\n}\r\n.lnr-wheelchair:before {\r\n  content: \"\\e851\";\r\n}\r\n.lnr-select:before {\r\n  content: \"\\e852\";\r\n}\r\n.lnr-earth:before {\r\n  content: \"\\e853\";\r\n}\r\n.lnr-smile:before {\r\n  content: \"\\e854\";\r\n}\r\n.lnr-sad:before {\r\n  content: \"\\e855\";\r\n}\r\n.lnr-neutral:before {\r\n  content: \"\\e856\";\r\n}\r\n.lnr-mustache:before {\r\n  content: \"\\e857\";\r\n}\r\n.lnr-alarm:before {\r\n  content: \"\\e858\";\r\n}\r\n.lnr-bullhorn:before {\r\n  content: \"\\e859\";\r\n}\r\n.lnr-volume-high:before {\r\n  content: \"\\e85a\";\r\n}\r\n.lnr-volume-medium:before {\r\n  content: \"\\e85b\";\r\n}\r\n.lnr-volume-low:before {\r\n  content: \"\\e85c\";\r\n}\r\n.lnr-volume:before {\r\n  content: \"\\e85d\";\r\n}\r\n.lnr-mic:before {\r\n  content: \"\\e85e\";\r\n}\r\n.lnr-hourglass:before {\r\n  content: \"\\e85f\";\r\n}\r\n.lnr-undo:before {\r\n  content: \"\\e860\";\r\n}\r\n.lnr-redo:before {\r\n  content: \"\\e861\";\r\n}\r\n.lnr-sync:before {\r\n  content: \"\\e862\";\r\n}\r\n.lnr-history:before {\r\n  content: \"\\e863\";\r\n}\r\n.lnr-clock:before {\r\n  content: \"\\e864\";\r\n}\r\n.lnr-download:before {\r\n  content: \"\\e865\";\r\n}\r\n.lnr-upload:before {\r\n  content: \"\\e866\";\r\n}\r\n.lnr-enter-down:before {\r\n  content: \"\\e867\";\r\n}\r\n.lnr-exit-up:before {\r\n  content: \"\\e868\";\r\n}\r\n.lnr-bug:before {\r\n  content: \"\\e869\";\r\n}\r\n.lnr-code:before {\r\n  content: \"\\e86a\";\r\n}\r\n.lnr-link:before {\r\n  content: \"\\e86b\";\r\n}\r\n.lnr-unlink:before {\r\n  content: \"\\e86c\";\r\n}\r\n.lnr-thumbs-up:before {\r\n  content: \"\\e86d\";\r\n}\r\n.lnr-thumbs-down:before {\r\n  content: \"\\e86e\";\r\n}\r\n.lnr-magnifier:before {\r\n  content: \"\\e86f\";\r\n}\r\n.lnr-cross:before {\r\n  content: \"\\e870\";\r\n}\r\n.lnr-menu:before {\r\n  content: \"\\e871\";\r\n}\r\n.lnr-list:before {\r\n  content: \"\\e872\";\r\n}\r\n.lnr-chevron-up:before {\r\n  content: \"\\e873\";\r\n}\r\n.lnr-chevron-down:before {\r\n  content: \"\\e874\";\r\n}\r\n.lnr-chevron-left:before {\r\n  content: \"\\e875\";\r\n}\r\n.lnr-chevron-right:before {\r\n  content: \"\\e876\";\r\n}\r\n.lnr-arrow-up:before {\r\n  content: \"\\e877\";\r\n}\r\n.lnr-arrow-down:before {\r\n  content: \"\\e878\";\r\n}\r\n.lnr-arrow-left:before {\r\n  content: \"\\e879\";\r\n}\r\n.lnr-arrow-right:before {\r\n  content: \"\\e87a\";\r\n}\r\n.lnr-move:before {\r\n  content: \"\\e87b\";\r\n}\r\n.lnr-warning:before {\r\n  content: \"\\e87c\";\r\n}\r\n.lnr-question-circle:before {\r\n  content: \"\\e87d\";\r\n}\r\n.lnr-menu-circle:before {\r\n  content: \"\\e87e\";\r\n}\r\n.lnr-checkmark-circle:before {\r\n  content: \"\\e87f\";\r\n}\r\n.lnr-cross-circle:before {\r\n  content: \"\\e880\";\r\n}\r\n.lnr-plus-circle:before {\r\n  content: \"\\e881\";\r\n}\r\n.lnr-circle-minus:before {\r\n  content: \"\\e882\";\r\n}\r\n.lnr-arrow-up-circle:before {\r\n  content: \"\\e883\";\r\n}\r\n.lnr-arrow-down-circle:before {\r\n  content: \"\\e884\";\r\n}\r\n.lnr-arrow-left-circle:before {\r\n  content: \"\\e885\";\r\n}\r\n.lnr-arrow-right-circle:before {\r\n  content: \"\\e886\";\r\n}\r\n.lnr-chevron-up-circle:before {\r\n  content: \"\\e887\";\r\n}\r\n.lnr-chevron-down-circle:before {\r\n  content: \"\\e888\";\r\n}\r\n.lnr-chevron-left-circle:before {\r\n  content: \"\\e889\";\r\n}\r\n.lnr-chevron-right-circle:before {\r\n  content: \"\\e88a\";\r\n}\r\n.lnr-crop:before {\r\n  content: \"\\e88b\";\r\n}\r\n.lnr-frame-expand:before {\r\n  content: \"\\e88c\";\r\n}\r\n.lnr-frame-contract:before {\r\n  content: \"\\e88d\";\r\n}\r\n.lnr-layers:before {\r\n  content: \"\\e88e\";\r\n}\r\n.lnr-funnel:before {\r\n  content: \"\\e88f\";\r\n}\r\n.lnr-text-format:before {\r\n  content: \"\\e890\";\r\n}\r\n.lnr-text-format-remove:before {\r\n  content: \"\\e891\";\r\n}\r\n.lnr-text-size:before {\r\n  content: \"\\e892\";\r\n}\r\n.lnr-bold:before {\r\n  content: \"\\e893\";\r\n}\r\n.lnr-italic:before {\r\n  content: \"\\e894\";\r\n}\r\n.lnr-underline:before {\r\n  content: \"\\e895\";\r\n}\r\n.lnr-strikethrough:before {\r\n  content: \"\\e896\";\r\n}\r\n.lnr-highlight:before {\r\n  content: \"\\e897\";\r\n}\r\n.lnr-text-align-left:before {\r\n  content: \"\\e898\";\r\n}\r\n.lnr-text-align-center:before {\r\n  content: \"\\e899\";\r\n}\r\n.lnr-text-align-right:before {\r\n  content: \"\\e89a\";\r\n}\r\n.lnr-text-align-justify:before {\r\n  content: \"\\e89b\";\r\n}\r\n.lnr-line-spacing:before {\r\n  content: \"\\e89c\";\r\n}\r\n.lnr-indent-increase:before {\r\n  content: \"\\e89d\";\r\n}\r\n.lnr-indent-decrease:before {\r\n  content: \"\\e89e\";\r\n}\r\n.lnr-pilcrow:before {\r\n  content: \"\\e89f\";\r\n}\r\n.lnr-direction-ltr:before {\r\n  content: \"\\e8a0\";\r\n}\r\n.lnr-direction-rtl:before {\r\n  content: \"\\e8a1\";\r\n}\r\n.lnr-page-break:before {\r\n  content: \"\\e8a2\";\r\n}\r\n.lnr-sort-alpha-asc:before {\r\n  content: \"\\e8a3\";\r\n}\r\n.lnr-sort-amount-asc:before {\r\n  content: \"\\e8a4\";\r\n}\r\n.lnr-hand:before {\r\n  content: \"\\e8a5\";\r\n}\r\n.lnr-pointer-up:before {\r\n  content: \"\\e8a6\";\r\n}\r\n.lnr-pointer-right:before {\r\n  content: \"\\e8a7\";\r\n}\r\n.lnr-pointer-down:before {\r\n  content: \"\\e8a8\";\r\n}\r\n.lnr-pointer-left:before {\r\n  content: \"\\e8a9\";\r\n}\r\n","/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n\n@import \"variables\";\n@import \"path\";\n@import \"core\";\n@import \"helper\";\n@import \"icons\";\n","@font-face {\n\tfont-family: 'Pe-icon-7-stroke';\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?d7yf1v');\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?#iefixd7yf1v') format('embedded-opentype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.woff?d7yf1v') format('woff'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.ttf?d7yf1v') format('truetype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke') format('svg');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n","[class^=\"#{$font-prefix}-\"], [class*=\" #{$font-prefix}-\"] {\n\tdisplay: inline-block;\n\tfont-family: 'Pe-icon-7-stroke';\n\tspeak: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\n\t/* Better Font Rendering =========== */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n","\n/* HELPER CLASS\n * -------------------------- */\n\n/* FA based classes */\n\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: $font-size-base * 1.33;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 2 * $font-size-base;\n}\n\n.pe-3x {\n  font-size: 3 * $font-size-base;\n}\n\n.pe-4x {\n  font-size: 4 * $font-size-base;\n}\n\n.pe-5x {\n  font-size: 5 * $font-size-base;\n}\n\n.pe-fw {\n  width: 1.2857142857142858em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.142857142857143em;\n  list-style-type: none;\n  \n  & > li {\n    position: relative;\n  }\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.142857142857143em;\n  width: 2.142857142857143em;\n  top: 0.14285714285714285em;\n  text-align: center;\n\n  &.pe-lg {\n    left: -1.8571428571428572em;\n  }\n}\n\n.pe-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: .1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe {\n  &.pull-left {\n    float: left;\n    margin-right: .3em;\n    margin-left: .3em;\n  }\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n",".#{$font-prefix}-album:before {\n  content: $font-var-album;\n}\n\n.#{$font-prefix}-arc:before {\n  content: $font-var-arc;\n}\n.#{$font-prefix}-back-2:before {\n  content: $font-var-back-2;\n}\n.#{$font-prefix}-bandaid:before {\n  content: $font-var-bandaid;\n}\n.#{$font-prefix}-car:before {\n  content: $font-var-car;\n}\n.#{$font-prefix}-diamond:before {\n  content: $font-var-diamond;\n}\n.#{$font-prefix}-door-lock:before {\n  content: $font-var-door-lock;\n}\n.#{$font-prefix}-eyedropper:before {\n  content: $font-var-eyedropper;\n}\n.#{$font-prefix}-female:before {\n  content: $font-var-female;\n}\n.#{$font-prefix}-gym:before {\n  content: $font-var-gym;\n}\n.#{$font-prefix}-hammer:before {\n  content: $font-var-hammer;\n}\n.#{$font-prefix}-headphones:before {\n  content: $font-var-headphones;\n}\n.#{$font-prefix}-helm:before {\n  content: $font-var-helm;\n}\n.#{$font-prefix}-hourglass:before {\n  content: $font-var-hourglass;\n}\n.#{$font-prefix}-leaf:before {\n  content: $font-var-leaf;\n}\n.#{$font-prefix}-magic-wand:before {\n  content: $font-var-magic-wand;\n}\n.#{$font-prefix}-male:before {\n  content: $font-var-male;\n}\n.#{$font-prefix}-map-2:before {\n  content: $font-var-map-2;\n}\n.#{$font-prefix}-next-2:before {\n  content: $font-var-next-2;\n}\n.#{$font-prefix}-paint-bucket:before {\n  content: $font-var-paint-bucket;\n}\n.#{$font-prefix}-pendrive:before {\n  content: $font-var-pendrive;\n}\n.#{$font-prefix}-photo:before {\n  content: $font-var-photo;\n}\n.#{$font-prefix}-piggy:before {\n  content: $font-var-piggy;\n}\n.#{$font-prefix}-plugin:before {\n  content: $font-var-plugin;\n}\n.#{$font-prefix}-refresh-2:before {\n  content: $font-var-refresh-2;\n}\n.#{$font-prefix}-rocket:before {\n  content: $font-var-rocket;\n}\n.#{$font-prefix}-settings:before {\n  content: $font-var-settings;\n}\n.#{$font-prefix}-shield:before {\n  content: $font-var-shield;\n}\n.#{$font-prefix}-smile:before {\n  content: $font-var-smile;\n}\n.#{$font-prefix}-usb:before {\n  content: $font-var-usb;\n}\n.#{$font-prefix}-vector:before {\n  content: $font-var-vector;\n}\n.#{$font-prefix}-wine:before {\n  content: $font-var-wine;\n}\n.#{$font-prefix}-cloud-upload:before {\n  content: $font-var-cloud-upload;\n}\n.#{$font-prefix}-cash:before {\n  content: $font-var-cash;\n}\n.#{$font-prefix}-close:before {\n  content: $font-var-close;\n}\n.#{$font-prefix}-bluetooth:before {\n  content: $font-var-bluetooth;\n}\n.#{$font-prefix}-cloud-download:before {\n  content: $font-var-cloud-download;\n}\n.#{$font-prefix}-way:before {\n  content: $font-var-way;\n}\n.#{$font-prefix}-close-circle:before {\n  content: $font-var-close-circle;\n}\n.#{$font-prefix}-id:before {\n  content: $font-var-id;\n}\n.#{$font-prefix}-angle-up:before {\n  content: $font-var-angle-up;\n}\n.#{$font-prefix}-wristwatch:before {\n  content: $font-var-wristwatch;\n}\n.#{$font-prefix}-angle-up-circle:before {\n  content: $font-var-angle-up-circle;\n}\n.#{$font-prefix}-world:before {\n  content: $font-var-world;\n}\n.#{$font-prefix}-angle-right:before {\n  content: $font-var-angle-right;\n}\n.#{$font-prefix}-volume:before {\n  content: $font-var-volume;\n}\n.#{$font-prefix}-angle-right-circle:before {\n  content: $font-var-angle-right-circle;\n}\n.#{$font-prefix}-users:before {\n  content: $font-var-users;\n}\n.#{$font-prefix}-angle-left:before {\n  content: $font-var-angle-left;\n}\n.#{$font-prefix}-user-female:before {\n  content: $font-var-user-female;\n}\n.#{$font-prefix}-angle-left-circle:before {\n  content: $font-var-angle-left-circle;\n}\n.#{$font-prefix}-up-arrow:before {\n  content: $font-var-up-arrow;\n}\n.#{$font-prefix}-angle-down:before {\n  content: $font-var-angle-down;\n}\n.#{$font-prefix}-switch:before {\n  content: $font-var-switch;\n}\n.#{$font-prefix}-angle-down-circle:before {\n  content: $font-var-angle-down-circle;\n}\n.#{$font-prefix}-scissors:before {\n  content: $font-var-scissors;\n}\n.#{$font-prefix}-wallet:before {\n  content: $font-var-wallet;\n}\n.#{$font-prefix}-safe:before {\n  content: $font-var-safe;\n}\n.#{$font-prefix}-volume2:before {\n  content: $font-var-volume2;\n}\n.#{$font-prefix}-volume1:before {\n  content: $font-var-volume1;\n}\n.#{$font-prefix}-voicemail:before {\n  content: $font-var-voicemail;\n}\n.#{$font-prefix}-video:before {\n  content: $font-var-video;\n}\n.#{$font-prefix}-user:before {\n  content: $font-var-user;\n}\n.#{$font-prefix}-upload:before {\n  content: $font-var-upload;\n}\n.#{$font-prefix}-unlock:before {\n  content: $font-var-unlock;\n}\n.#{$font-prefix}-umbrella:before {\n  content: $font-var-umbrella;\n}\n.#{$font-prefix}-trash:before {\n  content: $font-var-trash;\n}\n.#{$font-prefix}-tools:before {\n  content: $font-var-tools;\n}\n.#{$font-prefix}-timer:before {\n  content: $font-var-timer;\n}\n.#{$font-prefix}-ticket:before {\n  content: $font-var-ticket;\n}\n.#{$font-prefix}-target:before {\n  content: $font-var-target;\n}\n.#{$font-prefix}-sun:before {\n  content: $font-var-sun;\n}\n.#{$font-prefix}-study:before {\n  content: $font-var-study;\n}\n.#{$font-prefix}-stopwatch:before {\n  content: $font-var-stopwatch;\n}\n.#{$font-prefix}-star:before {\n  content: $font-var-star;\n}\n.#{$font-prefix}-speaker:before {\n  content: $font-var-speaker;\n}\n.#{$font-prefix}-signal:before {\n  content: $font-var-signal;\n}\n.#{$font-prefix}-shuffle:before {\n  content: $font-var-shuffle;\n}\n.#{$font-prefix}-shopbag:before {\n  content: $font-var-shopbag;\n}\n.#{$font-prefix}-share:before {\n  content: $font-var-share;\n}\n.#{$font-prefix}-server:before {\n  content: $font-var-server;\n}\n.#{$font-prefix}-search:before {\n  content: $font-var-search;\n}\n.#{$font-prefix}-film:before {\n  content: $font-var-film;\n}\n.#{$font-prefix}-science:before {\n  content: $font-var-science;\n}\n.#{$font-prefix}-disk:before {\n  content: $font-var-disk;\n}\n.#{$font-prefix}-ribbon:before {\n  content: $font-var-ribbon;\n}\n.#{$font-prefix}-repeat:before {\n  content: $font-var-repeat;\n}\n.#{$font-prefix}-refresh:before {\n  content: $font-var-refresh;\n}\n.#{$font-prefix}-add-user:before {\n  content: $font-var-add-user;\n}\n.#{$font-prefix}-refresh-cloud:before {\n  content: $font-var-refresh-cloud;\n}\n.#{$font-prefix}-paperclip:before {\n  content: $font-var-paperclip;\n}\n.#{$font-prefix}-radio:before {\n  content: $font-var-radio;\n}\n.#{$font-prefix}-note2:before {\n  content: $font-var-note2;\n}\n.#{$font-prefix}-print:before {\n  content: $font-var-print;\n}\n.#{$font-prefix}-network:before {\n  content: $font-var-network;\n}\n.#{$font-prefix}-prev:before {\n  content: $font-var-prev;\n}\n.#{$font-prefix}-mute:before {\n  content: $font-var-mute;\n}\n.#{$font-prefix}-power:before {\n  content: $font-var-power;\n}\n.#{$font-prefix}-medal:before {\n  content: $font-var-medal;\n}\n.#{$font-prefix}-portfolio:before {\n  content: $font-var-portfolio;\n}\n.#{$font-prefix}-like2:before {\n  content: $font-var-like2;\n}\n.#{$font-prefix}-plus:before {\n  content: $font-var-plus;\n}\n.#{$font-prefix}-left-arrow:before {\n  content: $font-var-left-arrow;\n}\n.#{$font-prefix}-play:before {\n  content: $font-var-play;\n}\n.#{$font-prefix}-key:before {\n  content: $font-var-key;\n}\n.#{$font-prefix}-plane:before {\n  content: $font-var-plane;\n}\n.#{$font-prefix}-joy:before {\n  content: $font-var-joy;\n}\n.#{$font-prefix}-photo-gallery:before {\n  content: $font-var-photo-gallery;\n}\n.#{$font-prefix}-pin:before {\n  content: $font-var-pin;\n}\n.#{$font-prefix}-phone:before {\n  content: $font-var-phone;\n}\n.#{$font-prefix}-plug:before {\n  content: $font-var-plug;\n}\n.#{$font-prefix}-pen:before {\n  content: $font-var-pen;\n}\n.#{$font-prefix}-right-arrow:before {\n  content: $font-var-right-arrow;\n}\n.#{$font-prefix}-paper-plane:before {\n  content: $font-var-paper-plane;\n}\n.#{$font-prefix}-delete-user:before {\n  content: $font-var-delete-user;\n}\n.#{$font-prefix}-paint:before {\n  content: $font-var-paint;\n}\n.#{$font-prefix}-bottom-arrow:before {\n  content: $font-var-bottom-arrow;\n}\n.#{$font-prefix}-notebook:before {\n  content: $font-var-notebook;\n}\n.#{$font-prefix}-note:before {\n  content: $font-var-note;\n}\n.#{$font-prefix}-next:before {\n  content: $font-var-next;\n}\n.#{$font-prefix}-news-paper:before {\n  content: $font-var-news-paper;\n}\n.#{$font-prefix}-musiclist:before {\n  content: $font-var-musiclist;\n}\n.#{$font-prefix}-music:before {\n  content: $font-var-music;\n}\n.#{$font-prefix}-mouse:before {\n  content: $font-var-mouse;\n}\n.#{$font-prefix}-more:before {\n  content: $font-var-more;\n}\n.#{$font-prefix}-moon:before {\n  content: $font-var-moon;\n}\n.#{$font-prefix}-monitor:before {\n  content: $font-var-monitor;\n}\n.#{$font-prefix}-micro:before {\n  content: $font-var-micro;\n}\n.#{$font-prefix}-menu:before {\n  content: $font-var-menu;\n}\n.#{$font-prefix}-map:before {\n  content: $font-var-map;\n}\n.#{$font-prefix}-map-marker:before {\n  content: $font-var-map-marker;\n}\n.#{$font-prefix}-mail:before {\n  content: $font-var-mail;\n}\n.#{$font-prefix}-mail-open:before {\n  content: $font-var-mail-open;\n}\n.#{$font-prefix}-mail-open-file:before {\n  content: $font-var-mail-open-file;\n}\n.#{$font-prefix}-magnet:before {\n  content: $font-var-magnet;\n}\n.#{$font-prefix}-loop:before {\n  content: $font-var-loop;\n}\n.#{$font-prefix}-look:before {\n  content: $font-var-look;\n}\n.#{$font-prefix}-lock:before {\n  content: $font-var-lock;\n}\n.#{$font-prefix}-lintern:before {\n  content: $font-var-lintern;\n}\n.#{$font-prefix}-link:before {\n  content: $font-var-link;\n}\n.#{$font-prefix}-like:before {\n  content: $font-var-like;\n}\n.#{$font-prefix}-light:before {\n  content: $font-var-light;\n}\n.#{$font-prefix}-less:before {\n  content: $font-var-less;\n}\n.#{$font-prefix}-keypad:before {\n  content: $font-var-keypad;\n}\n.#{$font-prefix}-junk:before {\n  content: $font-var-junk;\n}\n.#{$font-prefix}-info:before {\n  content: $font-var-info;\n}\n.#{$font-prefix}-home:before {\n  content: $font-var-home;\n}\n.#{$font-prefix}-help2:before {\n  content: $font-var-help2;\n}\n.#{$font-prefix}-help1:before {\n  content: $font-var-help1;\n}\n.#{$font-prefix}-graph3:before {\n  content: $font-var-graph3;\n}\n.#{$font-prefix}-graph2:before {\n  content: $font-var-graph2;\n}\n.#{$font-prefix}-graph1:before {\n  content: $font-var-graph1;\n}\n.#{$font-prefix}-graph:before {\n  content: $font-var-graph;\n}\n.#{$font-prefix}-global:before {\n  content: $font-var-global;\n}\n.#{$font-prefix}-gleam:before {\n  content: $font-var-gleam;\n}\n.#{$font-prefix}-glasses:before {\n  content: $font-var-glasses;\n}\n.#{$font-prefix}-gift:before {\n  content: $font-var-gift;\n}\n.#{$font-prefix}-folder:before {\n  content: $font-var-folder;\n}\n.#{$font-prefix}-flag:before {\n  content: $font-var-flag;\n}\n.#{$font-prefix}-filter:before {\n  content: $font-var-filter;\n}\n.#{$font-prefix}-file:before {\n  content: $font-var-file;\n}\n.#{$font-prefix}-expand1:before {\n  content: $font-var-expand1;\n}\n.#{$font-prefix}-exapnd2:before {\n  content: $font-var-exapnd2;\n}\n.#{$font-prefix}-edit:before {\n  content: $font-var-edit;\n}\n.#{$font-prefix}-drop:before {\n  content: $font-var-drop;\n}\n.#{$font-prefix}-drawer:before {\n  content: $font-var-drawer;\n}\n.#{$font-prefix}-download:before {\n  content: $font-var-download;\n}\n.#{$font-prefix}-display2:before {\n  content: $font-var-display2;\n}\n.#{$font-prefix}-display1:before {\n  content: $font-var-display1;\n}\n.#{$font-prefix}-diskette:before {\n  content: $font-var-diskette;\n}\n.#{$font-prefix}-date:before {\n  content: $font-var-date;\n}\n.#{$font-prefix}-cup:before {\n  content: $font-var-cup;\n}\n.#{$font-prefix}-culture:before {\n  content: $font-var-culture;\n}\n.#{$font-prefix}-crop:before {\n  content: $font-var-crop;\n}\n.#{$font-prefix}-credit:before {\n  content: $font-var-credit;\n}\n.#{$font-prefix}-copy-file:before {\n  content: $font-var-copy-file;\n}\n.#{$font-prefix}-config:before {\n  content: $font-var-config;\n}\n.#{$font-prefix}-compass:before {\n  content: $font-var-compass;\n}\n.#{$font-prefix}-comment:before {\n  content: $font-var-comment;\n}\n.#{$font-prefix}-coffee:before {\n  content: $font-var-coffee;\n}\n.#{$font-prefix}-cloud:before {\n  content: $font-var-cloud;\n}\n.#{$font-prefix}-clock:before {\n  content: $font-var-clock;\n}\n.#{$font-prefix}-check:before {\n  content: $font-var-check;\n}\n.#{$font-prefix}-chat:before {\n  content: $font-var-chat;\n}\n.#{$font-prefix}-cart:before {\n  content: $font-var-cart;\n}\n.#{$font-prefix}-camera:before {\n  content: $font-var-camera;\n}\n.#{$font-prefix}-call:before {\n  content: $font-var-call;\n}\n.#{$font-prefix}-calculator:before {\n  content: $font-var-calculator;\n}\n.#{$font-prefix}-browser:before {\n  content: $font-var-browser;\n}\n.#{$font-prefix}-box2:before {\n  content: $font-var-box2;\n}\n.#{$font-prefix}-box1:before {\n  content: $font-var-box1;\n}\n.#{$font-prefix}-bookmarks:before {\n  content: $font-var-bookmarks;\n}\n.#{$font-prefix}-bicycle:before {\n  content: $font-var-bicycle;\n}\n.#{$font-prefix}-bell:before {\n  content: $font-var-bell;\n}\n.#{$font-prefix}-battery:before {\n  content: $font-var-battery;\n}\n.#{$font-prefix}-ball:before {\n  content: $font-var-ball;\n}\n.#{$font-prefix}-back:before {\n  content: $font-var-back;\n}\n.#{$font-prefix}-attention:before {\n  content: $font-var-attention;\n}\n.#{$font-prefix}-anchor:before {\n  content: $font-var-anchor;\n}\n.#{$font-prefix}-albums:before {\n  content: $font-var-albums;\n}\n.#{$font-prefix}-alarm:before {\n  content: $font-var-alarm;\n}\n.#{$font-prefix}-airplay:before {\n  content: $font-var-airplay;\n}\n","$pe-7s-font-path: \"../fonts\" !default;\n$font-size-base: 1em !default;\n$font-prefix: \"pe-7s\" !default;\n\n$font-var-album: \"\\e6aa\";\n$font-var-arc: \"\\e6ab\";\n$font-var-back-2: \"\\e6ac\";\n$font-var-bandaid: \"\\e6ad\";\n$font-var-car: \"\\e6ae\";\n$font-var-diamond: \"\\e6af\";\n$font-var-door-lock: \"\\e6b0\";\n$font-var-eyedropper: \"\\e6b1\";\n$font-var-female: \"\\e6b2\";\n$font-var-gym: \"\\e6b3\";\n$font-var-hammer: \"\\e6b4\";\n$font-var-headphones: \"\\e6b5\";\n$font-var-helm: \"\\e6b6\";\n$font-var-hourglass: \"\\e6b7\";\n$font-var-leaf: \"\\e6b8\";\n$font-var-magic-wand: \"\\e6b9\";\n$font-var-male: \"\\e6ba\";\n$font-var-map-2: \"\\e6bb\";\n$font-var-next-2: \"\\e6bc\";\n$font-var-paint-bucket: \"\\e6bd\";\n$font-var-pendrive: \"\\e6be\";\n$font-var-photo: \"\\e6bf\";\n$font-var-piggy: \"\\e6c0\";\n$font-var-plugin: \"\\e6c1\";\n$font-var-refresh-2: \"\\e6c2\";\n$font-var-rocket: \"\\e6c3\";\n$font-var-settings: \"\\e6c4\";\n$font-var-shield: \"\\e6c5\";\n$font-var-smile: \"\\e6c6\";\n$font-var-usb: \"\\e6c7\";\n$font-var-vector: \"\\e6c8\";\n$font-var-wine: \"\\e6c9\";\n$font-var-cloud-upload: \"\\e68a\";\n$font-var-cash: \"\\e68c\";\n$font-var-close: \"\\e680\";\n$font-var-bluetooth: \"\\e68d\";\n$font-var-cloud-download: \"\\e68b\";\n$font-var-way: \"\\e68e\";\n$font-var-close-circle: \"\\e681\";\n$font-var-id: \"\\e68f\";\n$font-var-angle-up: \"\\e682\";\n$font-var-wristwatch: \"\\e690\";\n$font-var-angle-up-circle: \"\\e683\";\n$font-var-world: \"\\e691\";\n$font-var-angle-right: \"\\e684\";\n$font-var-volume: \"\\e692\";\n$font-var-angle-right-circle: \"\\e685\";\n$font-var-users: \"\\e693\";\n$font-var-angle-left: \"\\e686\";\n$font-var-user-female: \"\\e694\";\n$font-var-angle-left-circle: \"\\e687\";\n$font-var-up-arrow: \"\\e695\";\n$font-var-angle-down: \"\\e688\";\n$font-var-switch: \"\\e696\";\n$font-var-angle-down-circle: \"\\e689\";\n$font-var-scissors: \"\\e697\";\n$font-var-wallet: \"\\e600\";\n$font-var-safe: \"\\e698\";\n$font-var-volume2: \"\\e601\";\n$font-var-volume1: \"\\e602\";\n$font-var-voicemail: \"\\e603\";\n$font-var-video: \"\\e604\";\n$font-var-user: \"\\e605\";\n$font-var-upload: \"\\e606\";\n$font-var-unlock: \"\\e607\";\n$font-var-umbrella: \"\\e608\";\n$font-var-trash: \"\\e609\";\n$font-var-tools: \"\\e60a\";\n$font-var-timer: \"\\e60b\";\n$font-var-ticket: \"\\e60c\";\n$font-var-target: \"\\e60d\";\n$font-var-sun: \"\\e60e\";\n$font-var-study: \"\\e60f\";\n$font-var-stopwatch: \"\\e610\";\n$font-var-star: \"\\e611\";\n$font-var-speaker: \"\\e612\";\n$font-var-signal: \"\\e613\";\n$font-var-shuffle: \"\\e614\";\n$font-var-shopbag: \"\\e615\";\n$font-var-share: \"\\e616\";\n$font-var-server: \"\\e617\";\n$font-var-search: \"\\e618\";\n$font-var-film: \"\\e6a5\";\n$font-var-science: \"\\e619\";\n$font-var-disk: \"\\e6a6\";\n$font-var-ribbon: \"\\e61a\";\n$font-var-repeat: \"\\e61b\";\n$font-var-refresh: \"\\e61c\";\n$font-var-add-user: \"\\e6a9\";\n$font-var-refresh-cloud: \"\\e61d\";\n$font-var-paperclip: \"\\e69c\";\n$font-var-radio: \"\\e61e\";\n$font-var-note2: \"\\e69d\";\n$font-var-print: \"\\e61f\";\n$font-var-network: \"\\e69e\";\n$font-var-prev: \"\\e620\";\n$font-var-mute: \"\\e69f\";\n$font-var-power: \"\\e621\";\n$font-var-medal: \"\\e6a0\";\n$font-var-portfolio: \"\\e622\";\n$font-var-like2: \"\\e6a1\";\n$font-var-plus: \"\\e623\";\n$font-var-left-arrow: \"\\e6a2\";\n$font-var-play: \"\\e624\";\n$font-var-key: \"\\e6a3\";\n$font-var-plane: \"\\e625\";\n$font-var-joy: \"\\e6a4\";\n$font-var-photo-gallery: \"\\e626\";\n$font-var-pin: \"\\e69b\";\n$font-var-phone: \"\\e627\";\n$font-var-plug: \"\\e69a\";\n$font-var-pen: \"\\e628\";\n$font-var-right-arrow: \"\\e699\";\n$font-var-paper-plane: \"\\e629\";\n$font-var-delete-user: \"\\e6a7\";\n$font-var-paint: \"\\e62a\";\n$font-var-bottom-arrow: \"\\e6a8\";\n$font-var-notebook: \"\\e62b\";\n$font-var-note: \"\\e62c\";\n$font-var-next: \"\\e62d\";\n$font-var-news-paper: \"\\e62e\";\n$font-var-musiclist: \"\\e62f\";\n$font-var-music: \"\\e630\";\n$font-var-mouse: \"\\e631\";\n$font-var-more: \"\\e632\";\n$font-var-moon: \"\\e633\";\n$font-var-monitor: \"\\e634\";\n$font-var-micro: \"\\e635\";\n$font-var-menu: \"\\e636\";\n$font-var-map: \"\\e637\";\n$font-var-map-marker: \"\\e638\";\n$font-var-mail: \"\\e639\";\n$font-var-mail-open: \"\\e63a\";\n$font-var-mail-open-file: \"\\e63b\";\n$font-var-magnet: \"\\e63c\";\n$font-var-loop: \"\\e63d\";\n$font-var-look: \"\\e63e\";\n$font-var-lock: \"\\e63f\";\n$font-var-lintern: \"\\e640\";\n$font-var-link: \"\\e641\";\n$font-var-like: \"\\e642\";\n$font-var-light: \"\\e643\";\n$font-var-less: \"\\e644\";\n$font-var-keypad: \"\\e645\";\n$font-var-junk: \"\\e646\";\n$font-var-info: \"\\e647\";\n$font-var-home: \"\\e648\";\n$font-var-help2: \"\\e649\";\n$font-var-help1: \"\\e64a\";\n$font-var-graph3: \"\\e64b\";\n$font-var-graph2: \"\\e64c\";\n$font-var-graph1: \"\\e64d\";\n$font-var-graph: \"\\e64e\";\n$font-var-global: \"\\e64f\";\n$font-var-gleam: \"\\e650\";\n$font-var-glasses: \"\\e651\";\n$font-var-gift: \"\\e652\";\n$font-var-folder: \"\\e653\";\n$font-var-flag: \"\\e654\";\n$font-var-filter: \"\\e655\";\n$font-var-file: \"\\e656\";\n$font-var-expand1: \"\\e657\";\n$font-var-exapnd2: \"\\e658\";\n$font-var-edit: \"\\e659\";\n$font-var-drop: \"\\e65a\";\n$font-var-drawer: \"\\e65b\";\n$font-var-download: \"\\e65c\";\n$font-var-display2: \"\\e65d\";\n$font-var-display1: \"\\e65e\";\n$font-var-diskette: \"\\e65f\";\n$font-var-date: \"\\e660\";\n$font-var-cup: \"\\e661\";\n$font-var-culture: \"\\e662\";\n$font-var-crop: \"\\e663\";\n$font-var-credit: \"\\e664\";\n$font-var-copy-file: \"\\e665\";\n$font-var-config: \"\\e666\";\n$font-var-compass: \"\\e667\";\n$font-var-comment: \"\\e668\";\n$font-var-coffee: \"\\e669\";\n$font-var-cloud: \"\\e66a\";\n$font-var-clock: \"\\e66b\";\n$font-var-check: \"\\e66c\";\n$font-var-chat: \"\\e66d\";\n$font-var-cart: \"\\e66e\";\n$font-var-camera: \"\\e66f\";\n$font-var-call: \"\\e670\";\n$font-var-calculator: \"\\e671\";\n$font-var-browser: \"\\e672\";\n$font-var-box2: \"\\e673\";\n$font-var-box1: \"\\e674\";\n$font-var-bookmarks: \"\\e675\";\n$font-var-bicycle: \"\\e676\";\n$font-var-bell: \"\\e677\";\n$font-var-battery: \"\\e678\";\n$font-var-ball: \"\\e679\";\n$font-var-back: \"\\e67a\";\n$font-var-attention: \"\\e67b\";\n$font-var-anchor: \"\\e67c\";\n$font-var-albums: \"\\e67d\";\n$font-var-alarm: \"\\e67e\";\n$font-var-airplay: \"\\e67f\";\n","%triangle-arrow {\r\n  margin-left: -$datepicker__triangle-size;\r\n  position: absolute;\r\n\r\n  &,\r\n  &::before {\r\n    box-sizing: content-box;\r\n    position: absolute;\r\n    border: $datepicker__triangle-size solid transparent;\r\n\r\n    height: 0;\r\n    width: 1px;\r\n  }\r\n\r\n  &::before {\r\n    content: \"\";\r\n    z-index: -1;\r\n    border-width: $datepicker__triangle-size;\r\n\r\n    left: -$datepicker__triangle-size;\r\n    border-bottom-color: $datepicker__border-color;\r\n  }\r\n}\r\n\r\n%triangle-arrow-up {\r\n  @extend %triangle-arrow;\r\n\r\n  top: 0;\r\n  margin-top: -$datepicker__triangle-size;\r\n\r\n  &,\r\n  &::before {\r\n    border-top: none;\r\n    border-bottom-color: $datepicker__background-color;\r\n  }\r\n\r\n  &::before {\r\n    top: -1px;\r\n    border-bottom-color: $datepicker__border-color;\r\n  }\r\n}\r\n\r\n%triangle-arrow-down {\r\n  @extend %triangle-arrow;\r\n\r\n  bottom: 0;\r\n  margin-bottom: -$datepicker__triangle-size;\r\n\r\n  &,\r\n  &::before {\r\n    border-bottom: none;\r\n    border-top-color: #fff;\r\n  }\r\n\r\n  &::before {\r\n    bottom: -1px;\r\n    border-top-color: $datepicker__border-color;\r\n  }\r\n}\r\n","// Datepicker\r\n\r\n$datepicker__background-color: $white;\r\n$datepicker__border-color: $gray-300;\r\n$datepicker__highlighted-color: $primary;\r\n$datepicker__muted-color: $gray-400;\r\n$datepicker__selected-color: theme-color(\"primary\");\r\n$datepicker__text-color: $gray-700;\r\n$datepicker__header-color: $gray-800;\r\n$datepicker__navigation-disabled-color: darken($datepicker__muted-color, 5%)\r\n;\r\n\r\n$datepicker__border-radius: $border-radius;\r\n$datepicker__day-margin: 0.166rem;\r\n$datepicker__font-size: $font-size-base;\r\n$datepicker__font-family: $font-size-base;\r\n$datepicker__item-size: 2rem;\r\n$datepicker__margin: 0.5rem;\r\n$datepicker__navigation-size: 0.35rem;\r\n$datepicker__triangle-size: 6px;","@import \"variables\";\r\n@import \"mixins\";\r\n\r\n.react-datepicker-wrapper {\r\n  display: block;\r\n  z-index: 10;\r\n}\r\n\r\n.react-datepicker {\r\n  background-color: $white;\r\n  color: $datepicker__text-color;\r\n  border: 1px solid $datepicker__border-color;\r\n  border-radius: $datepicker__border-radius;\r\n  display: inline-block;\r\n  position: relative;\r\n\r\n  box-shadow: $box-shadow-default;\r\n}\r\n\r\n.react-datepicker--time-only {\r\n  .react-datepicker__triangle {\r\n    left: 35px;\r\n  }\r\n\r\n  .react-datepicker__time-container {\r\n    border-left: 0;\r\n  }\r\n\r\n  .react-datepicker__time {\r\n    border-radius: 0.3rem;\r\n  }\r\n\r\n  .react-datepicker__time-box {\r\n    border-radius: 0.3rem;\r\n  }\r\n}\r\n\r\n.react-datepicker__triangle {\r\n  position: absolute;\r\n  left: 50px;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 102;\r\n\r\n  &[data-placement^=\"bottom\"] {\r\n    margin-top: $datepicker__triangle-size + 2px;\r\n\r\n    .react-datepicker__triangle {\r\n      @extend %triangle-arrow-up;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"top\"] {\r\n    margin-bottom: $datepicker__triangle-size + 2px;\r\n\r\n    .react-datepicker__triangle {\r\n      @extend %triangle-arrow-down;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"right\"] {\r\n    margin-left: $datepicker__triangle-size;\r\n\r\n    .react-datepicker__triangle {\r\n      left: auto;\r\n      right: 42px;\r\n    }\r\n  }\r\n\r\n  &[data-placement^=\"left\"] {\r\n    margin-right: $datepicker__triangle-size;\r\n\r\n    .react-datepicker__triangle {\r\n      left: 42px;\r\n      right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__header {\r\n  text-align: center;\r\n  background-color: $datepicker__background-color;\r\n  border-bottom: 1px solid $datepicker__border-color;\r\n  border-top-left-radius: $datepicker__border-radius;\r\n  border-top-right-radius: $datepicker__border-radius;\r\n  padding-top: 10px;\r\n  position: relative;\r\n\r\n  &--time {\r\n    padding-bottom: 8px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-dropdown-container--select,\r\n.react-datepicker__month-dropdown-container--select,\r\n.react-datepicker__month-year-dropdown-container--select,\r\n.react-datepicker__year-dropdown-container--scroll,\r\n.react-datepicker__month-dropdown-container--scroll,\r\n.react-datepicker__month-year-dropdown-container--scroll {\r\n  display: inline-block;\r\n  margin: 0 2px;\r\n}\r\n\r\n.react-datepicker__current-month,\r\n.react-datepicker-time__header {\r\n  margin-top: 0;\r\n  color: $datepicker__header-color;\r\n  font-weight: bold;\r\n  font-size: $datepicker__font-size * 1.1;\r\n}\r\n\r\n.react-datepicker-time__header {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.react-datepicker__navigation {\r\n  background: none;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 15px;\r\n  padding: 0;\r\n  border: $datepicker__navigation-size solid transparent;\r\n  z-index: 1;\r\n  height: 10px;\r\n  width: 10px;\r\n  text-indent: -999em;\r\n  overflow: hidden;\r\n\r\n  &--previous {\r\n    left: 10px;\r\n    border-right-color: $datepicker__muted-color;\r\n\r\n    &:hover {\r\n      border-right-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-right-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  &--next {\r\n    right: 10px;\r\n    border-left-color: $datepicker__muted-color;\r\n    &--with-time:not(&--with-today-button) {\r\n      right: 80px;\r\n    }\r\n\r\n    &:hover {\r\n      border-left-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-left-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  &--years {\r\n    position: relative;\r\n    top: 0;\r\n    display: block;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n\r\n    &-previous {\r\n      top: 4px;\r\n      border-top-color: $datepicker__muted-color;\r\n\r\n      &:hover {\r\n        border-top-color: darken($datepicker__muted-color, 10%);\r\n      }\r\n    }\r\n\r\n    &-upcoming {\r\n      top: -4px;\r\n      border-bottom-color: $datepicker__muted-color;\r\n\r\n      &:hover {\r\n        border-bottom-color: darken($datepicker__muted-color, 10%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__month-container {\r\n  float: left;\r\n}\r\n\r\n.react-datepicker__month {\r\n  margin: $datepicker__margin;\r\n  text-align: center;\r\n}\r\n\r\n.react-datepicker__time-container {\r\n  float: right;\r\n  border-left: 1px solid $datepicker__border-color;\r\n  width: 120px;\r\n\r\n  &--with-today-button {\r\n    display: inline;\r\n    border: 1px solid #aeaeae;\r\n    border-radius: 0.3rem;\r\n    position: absolute;\r\n    right: -122px;\r\n    top: 0;\r\n  }\r\n\r\n  .react-datepicker__time {\r\n    position: relative;\r\n    background: white;\r\n\r\n    .react-datepicker__time-box {\r\n      width: 120px;\r\n      overflow-x: hidden;\r\n      margin: 0 auto;\r\n      text-align: center;\r\n      ul.react-datepicker__time-list {\r\n        list-style: none;\r\n        margin: 0;\r\n        padding: 0;\r\n        height: calc(195px + (#{$datepicker__item-size} / 2));\r\n        overflow-y: scroll;\r\n        width: 100%;\r\n        box-sizing: content-box;\r\n\r\n        li.react-datepicker__time-list-item {\r\n          padding: 5px 10px;\r\n          &:hover {\r\n            cursor: pointer;\r\n            background-color: $dropdown-link-hover-bg;\r\n          }\r\n          &--selected {\r\n            background-color: $datepicker__selected-color;\r\n            color: $white;\r\n            font-weight: bold;\r\n            &:hover {\r\n              background-color: $datepicker__selected-color;\r\n            }\r\n          }\r\n          &--disabled {\r\n            color: $datepicker__muted-color;\r\n\r\n            &:hover {\r\n              cursor: default;\r\n              background-color: transparent;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__week-number {\r\n  color: $datepicker__muted-color;\r\n  display: inline-block;\r\n  width: $datepicker__item-size;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  margin: $datepicker__day-margin;\r\n  &.react-datepicker__week-number--clickable {\r\n    cursor: pointer;\r\n    &:hover {\r\n      border-radius: $datepicker__border-radius;\r\n      background-color: $datepicker__background-color;\r\n    }\r\n  }\r\n}\r\n\r\n.react-datepicker__day-names {\r\n  background: $gray-100;\r\n  border-top: $gray-300 solid 1px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.react-datepicker__day-names,\r\n.react-datepicker__week {\r\n  white-space: nowrap;\r\n}\r\n\r\n.react-datepicker__day-name,\r\n.react-datepicker__day,\r\n.react-datepicker__time-name {\r\n  color: $datepicker__text-color;\r\n  display: inline-block;\r\n  width: $datepicker__item-size;\r\n  line-height: $datepicker__item-size;\r\n  text-align: center;\r\n  margin: $datepicker__day-margin;\r\n}\r\n\r\n.react-datepicker__day {\r\n  cursor: pointer;\r\n  @include border-radius($datepicker__border-radius);\r\n\r\n  &:hover {\r\n    background-color: $primary;\r\n    color: $white;\r\n  }\r\n\r\n  &--today {\r\n    font-weight: bold;\r\n  }\r\n\r\n  &--highlighted {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: $datepicker__highlighted-color;\r\n    color: $white;\r\n\r\n    &:hover {\r\n      background-color: darken($datepicker__highlighted-color, 5%);\r\n    }\r\n\r\n    &-custom-1 {\r\n      color: $warning;\r\n    }\r\n\r\n    &-custom-2 {\r\n      color: $focus;\r\n    }\r\n  }\r\n\r\n  &--selected {\r\n    background-color: $success;\r\n    color: $white;\r\n\r\n    &:hover {\r\n      background-color: $success;\r\n      color: $white;\r\n    }\r\n  }\r\n\r\n  &--in-selecting-range,\r\n  &--in-range {\r\n    background-color: $dropdown-link-hover-bg;\r\n    color: $dropdown-link-hover-color;\r\n\r\n    &:hover {\r\n      background-color: $dropdown-link-hover-bg;\r\n      color: $dropdown-link-hover-color;\r\n    }\r\n\r\n  }\r\n\r\n  &--keyboard-selected {\r\n    border-radius: $datepicker__border-radius;\r\n    background-color: lighten($success, 10%);\r\n    color: $white;\r\n\r\n    &:hover {\r\n      background-color: darken($success, 5%);\r\n    }\r\n  }\r\n\r\n  &--in-selecting-range:not(&--in-range) {\r\n    background-color: $dropdown-link-hover-bg;\r\n  }\r\n\r\n  &--in-range:not(&--in-selecting-range) {\r\n    .react-datepicker__month--selecting-range & {\r\n      background-color: $success;\r\n      color: $white;\r\n    }\r\n  }\r\n\r\n  &--disabled {\r\n    cursor: default;\r\n    color: $datepicker__muted-color;\r\n\r\n    &:hover {\r\n      background-color: transparent;\r\n      color: $datepicker__muted-color;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.react-datepicker__day--selecting-range-start,\r\n.react-datepicker__day--selecting-range-end {\r\n  background-color: $success  !important;\r\n  color: $white !important;\r\n}\r\n\r\n.react-datepicker__year-read-view,\r\n.react-datepicker__month-read-view,\r\n.react-datepicker__month-year-read-view {\r\n  border: 1px solid transparent;\r\n  border-radius: $datepicker__border-radius;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n\r\n    .react-datepicker__year-read-view--down-arrow,\r\n    .react-datepicker__month-read-view--down-arrow {\r\n      border-top-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n  }\r\n\r\n  &--down-arrow {\r\n    @extend %triangle-arrow-down;\r\n    border-top-color: $datepicker__muted-color;\r\n    float: right;\r\n    margin-left: 20px;\r\n    top: 8px;\r\n    position: relative;\r\n    border-width: $datepicker__navigation-size;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-dropdown,\r\n.react-datepicker__month-dropdown,\r\n.react-datepicker__month-year-dropdown {\r\n  background-color: $datepicker__background-color;\r\n  position: absolute;\r\n  width: 50%;\r\n  left: 25%;\r\n  top: 30px;\r\n  z-index: 1;\r\n  text-align: center;\r\n  border-radius: $datepicker__border-radius;\r\n  border: 1px solid $datepicker__border-color;\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &--scrollable {\r\n    height: 150px;\r\n    overflow-y: scroll;\r\n  }\r\n}\r\n\r\n.react-datepicker__year-option,\r\n.react-datepicker__month-option,\r\n.react-datepicker__month-year-option {\r\n  line-height: 20px;\r\n  width: 100%;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  &:first-of-type {\r\n    border-top-left-radius: $datepicker__border-radius;\r\n    border-top-right-radius: $datepicker__border-radius;\r\n  }\r\n\r\n  &:last-of-type {\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    border-bottom-left-radius: $datepicker__border-radius;\r\n    border-bottom-right-radius: $datepicker__border-radius;\r\n  }\r\n\r\n  &:hover {\r\n    background-color: $datepicker__muted-color;\r\n\r\n    .react-datepicker__navigation--years-upcoming {\r\n      border-bottom-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n\r\n    .react-datepicker__navigation--years-previous {\r\n      border-top-color: darken($datepicker__muted-color, 10%);\r\n    }\r\n  }\r\n\r\n  &--selected {\r\n    position: absolute;\r\n    left: 15px;\r\n  }\r\n}\r\n\r\n.react-datepicker__close-icon {\r\n  background-color: transparent;\r\n  border: 0;\r\n  cursor: pointer;\r\n  outline: 0;\r\n  padding: 0;\r\n  vertical-align: middle;\r\n  position: absolute;\r\n  height: 16px;\r\n  width: 16px;\r\n  top: 25%;\r\n  right: 7px;\r\n\r\n  &::after {\r\n    background-color: $datepicker__selected-color;\r\n    border-radius: 50%;\r\n    bottom: 0;\r\n    box-sizing: border-box;\r\n    color: $white;\r\n    content: \"\\00d7\";\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    height: 16px;\r\n    width: 16px;\r\n    line-height: 1;\r\n    margin: -8px auto 0;\r\n    padding: 2px;\r\n    position: absolute;\r\n    right: 0px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.react-datepicker__today-button {\r\n  background: $datepicker__background-color;\r\n  border-top: 1px solid $datepicker__border-color;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  padding: 5px 0;\r\n  clear: left;\r\n}\r\n\r\n.react-datepicker__portal {\r\n  position: fixed;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: $zindex-modal-backdrop;\r\n  background-color: rgba($modal-backdrop-bg, $modal-backdrop-opacity);\r\n  left: 0;\r\n  top: 0;\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n\r\n  .react-datepicker__day-name,\r\n  .react-datepicker__day,\r\n  .react-datepicker__time-name {\r\n    width: 3rem;\r\n    line-height: 3rem;\r\n  }\r\n\r\n  // Resize for small screens\r\n  @media (max-width: 400px), (max-height: 550px) {\r\n    .react-datepicker__day-name,\r\n    .react-datepicker__day,\r\n    .react-datepicker__time-name {\r\n      width: 2rem;\r\n      line-height: 2rem;\r\n    }\r\n  }\r\n\r\n  .react-datepicker__current-month,\r\n  .react-datepicker-time__header {\r\n    font-size: $datepicker__font-size * 1.8;\r\n  }\r\n\r\n  .react-datepicker__navigation {\r\n    border: 1.8 * $datepicker__navigation-size solid transparent;\r\n    margin-top: 3px;\r\n  }\r\n\r\n  .react-datepicker__navigation--previous {\r\n    border-right-color: $primary;\r\n\r\n    &:hover {\r\n      border-right-color: darken($primary, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-right-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n\r\n  .react-datepicker__navigation--next {\r\n    border-left-color: $primary;\r\n\r\n    &:hover {\r\n      border-left-color: darken($primary, 10%);\r\n    }\r\n\r\n    &--disabled,\r\n    &--disabled:hover {\r\n      border-left-color: $datepicker__navigation-disabled-color;\r\n      cursor: default;\r\n    }\r\n  }\r\n}\r\n\r\n.rangeButtonSelectedStyle {\r\n  background: $primary !important;\r\n}\r\n\r\n.rangebuttonstyle {\r\n  outline: none !important;\r\n  color: $primary !important;\r\n}",".rc-slider-tooltip {\r\n  z-index: 555;\r\n}\r\n\r\n.rc-tooltip.rc-tooltip-zoom-enter,\r\n.rc-tooltip.rc-tooltip-zoom-leave {\r\n  display: block;\r\n}\r\n\r\n.rc-tooltip-zoom-enter,\r\n.rc-tooltip-zoom-appear {\r\n  opacity: 0;\r\n  animation-duration: 0.3s;\r\n  animation-fill-mode: both;\r\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-tooltip-zoom-leave {\r\n  animation-duration: 0.3s;\r\n  animation-fill-mode: both;\r\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\r\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\r\n  animation-name: rcToolTipZoomIn;\r\n  animation-play-state: running;\r\n}\r\n\r\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\r\n  animation-name: rcToolTipZoomOut;\r\n  animation-play-state: running;\r\n}\r\n\r\n@keyframes rcToolTipZoomIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(0, 0);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n@keyframes rcToolTipZoomOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform-origin: 50% 50%;\r\n    transform: scale(0, 0);\r\n  }\r\n}\r\n\r\n.rc-tooltip {\r\n  position: absolute;\r\n  z-index: 1070;\r\n  display: block;\r\n  visibility: visible;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  opacity: 0.9;\r\n}\r\n\r\n.rc-tooltip-hidden {\r\n  display: none;\r\n}\r\n\r\n.rc-tooltip-placement-top,\r\n.rc-tooltip-placement-topLeft,\r\n.rc-tooltip-placement-topRight {\r\n  padding: 5px 0 9px 0;\r\n}\r\n\r\n.rc-tooltip-placement-right,\r\n.rc-tooltip-placement-rightTop,\r\n.rc-tooltip-placement-rightBottom {\r\n  padding: 0 5px 0 9px;\r\n}\r\n\r\n.rc-tooltip-placement-bottom,\r\n.rc-tooltip-placement-bottomLeft,\r\n.rc-tooltip-placement-bottomRight {\r\n  padding: 9px 0 5px 0;\r\n}\r\n\r\n.rc-tooltip-placement-left,\r\n.rc-tooltip-placement-leftTop,\r\n.rc-tooltip-placement-leftBottom {\r\n  padding: 0 9px 0 5px;\r\n}\r\n\r\n.rc-tooltip-inner {\r\n  padding: 12px 14px;\r\n  color: $white;\r\n  text-align: left;\r\n  text-decoration: none;\r\n  background-color: $gray-800;\r\n  border-radius: 6px;\r\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\r\n  min-height: 34px;\r\n  font-weight: bold;\r\n}\r\n\r\n.rc-tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.rc-tooltip-placement-top .rc-tooltip-arrow,\r\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\r\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\r\n  bottom: 4px;\r\n  margin-left: -5px;\r\n  border-width: 5px 5px 0;\r\n  border-top-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-top .rc-tooltip-arrow {\r\n  left: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\r\n  left: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\r\n  right: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-right .rc-tooltip-arrow,\r\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\r\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\r\n  left: 4px;\r\n  margin-top: -5px;\r\n  border-width: 5px 5px 5px 0;\r\n  border-right-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-right .rc-tooltip-arrow {\r\n  top: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\r\n  top: 15%;\r\n  margin-top: 0;\r\n}\r\n\r\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\r\n  bottom: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-left .rc-tooltip-arrow,\r\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\r\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\r\n  right: 4px;\r\n  margin-top: -5px;\r\n  border-width: 5px 0 5px 5px;\r\n  border-left-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-left .rc-tooltip-arrow {\r\n  top: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\r\n  top: 15%;\r\n  margin-top: 0;\r\n}\r\n\r\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\r\n  bottom: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\r\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\r\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\r\n  top: 4px;\r\n  margin-left: -5px;\r\n  border-width: 0 5px 5px;\r\n  border-bottom-color: $gray-800;\r\n}\r\n\r\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\r\n  left: 50%;\r\n}\r\n\r\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\r\n  left: 15%;\r\n}\r\n\r\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\r\n  right: 15%;\r\n}\r\n","@import 'tooltip';\r\n\r\n.rc-slider {\r\n  position: relative;\r\n  height: 20px;\r\n  padding: 8px 0 0;\r\n  width: 100%;\r\n  @include border-radius($border-radius);\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.rc-slider-rail {\r\n  position: absolute;\r\n  width: 100%;\r\n  background-color: $gray-200;\r\n  height: 4px;\r\n  @include border-radius($border-radius);\r\n}\r\n\r\n.rc-slider-track {\r\n  position: absolute;\r\n  left: 0;\r\n  height: 4px;\r\n  @include border-radius($border-radius);\r\n  background-color: $primary;\r\n}\r\n\r\n.rc-slider-handle {\r\n  position: absolute;\r\n  margin-left: -8px;\r\n  margin-top: -6px;\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n  cursor: -webkit-grab;\r\n  cursor: grab;\r\n  border-radius: 50%;\r\n  border: solid 2px $primary;\r\n  background-color: $white;\r\n  -ms-touch-action: pan-x;\r\n  touch-action: pan-x;\r\n  transition: box-shadow 200ms;\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n\r\n  &:focus,\r\n  &:active,\r\n  &:hover {\r\n    border-color: darken($primary, 15%);\r\n    box-shadow: 0 0.46875rem 2.1875rem rgba($primary, .8),\r\n    0 0.125rem 0.5875rem rgba($primary, .9);\r\n  }\r\n\r\n  &:active {\r\n    cursor: -webkit-grabbing;\r\n    cursor: grabbing;\r\n  }\r\n}\r\n\r\n.rc-slider-mark {\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 0;\r\n  width: 100%;\r\n  font-size: 12px;\r\n}\r\n\r\n.rc-slider-mark-text {\r\n  position: absolute;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n}\r\n\r\n.rc-slider-mark-text-active {\r\n  color: $gray-800;\r\n}\r\n\r\n.rc-slider-step {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 4px;\r\n  background: transparent;\r\n}\r\n\r\n.rc-slider-dot {\r\n  position: absolute;\r\n  bottom: -2px;\r\n  margin-left: -4px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border: 2px solid $gray-300;\r\n  background-color: $white;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  vertical-align: middle;\r\n}\r\n\r\n.rc-slider-dot-active {\r\n  border-color: $primary;\r\n}\r\n\r\n.rc-slider-disabled {\r\n  background-color: $gray-200;\r\n}\r\n\r\n.rc-slider-disabled .rc-slider-track {\r\n  background-color: $gray-400;\r\n}\r\n\r\n.rc-slider-disabled .rc-slider-handle,\r\n.rc-slider-disabled .rc-slider-dot {\r\n  border-color: $gray-400;\r\n  box-shadow: none;\r\n  background-color: $white;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rc-slider-disabled .rc-slider-mark-text,\r\n.rc-slider-disabled .rc-slider-dot {\r\n  cursor: not-allowed !important;\r\n}\r\n\r\n.rc-slider-vertical {\r\n  width: 14px;\r\n  height: 100%;\r\n  padding: 0 5px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-rail {\r\n  height: 100%;\r\n  width: 4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-track {\r\n  left: 5px;\r\n  bottom: 0;\r\n  width: 4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-handle {\r\n  margin-left: -6px;\r\n  margin-bottom: -7px;\r\n  -ms-touch-action: pan-y;\r\n  touch-action: pan-y;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-mark {\r\n  top: 0;\r\n  left: 18px;\r\n  height: 100%;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-step {\r\n  height: 100%;\r\n  width: 4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-dot {\r\n  left: 2px;\r\n  margin-bottom: -4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-dot:first-child {\r\n  margin-bottom: -4px;\r\n}\r\n\r\n.rc-slider-vertical .rc-slider-dot:last-child {\r\n  margin-bottom: -4px;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-enter,\r\n.rc-slider-tooltip-zoom-down-appear {\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  display: block !important;\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-leave {\r\n  animation-duration: .3s;\r\n  animation-fill-mode: both;\r\n  display: block !important;\r\n  animation-play-state: paused;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\r\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\r\n  animation-name: rcSliderTooltipZoomDownIn;\r\n  animation-play-state: running;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\r\n  animation-name: rcSliderTooltipZoomDownOut;\r\n  animation-play-state: running;\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-enter,\r\n.rc-slider-tooltip-zoom-down-appear {\r\n  transform: scale(0, 0);\r\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\r\n}\r\n\r\n.rc-slider-tooltip-zoom-down-leave {\r\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n}\r\n\r\n@keyframes rcSliderTooltipZoomDownIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform-origin: 50% 100%;\r\n    transform: scale(0, 0);\r\n  }\r\n  100% {\r\n    transform-origin: 50% 100%;\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\n\r\n@keyframes rcSliderTooltipZoomDownOut {\r\n  0% {\r\n    transform-origin: 50% 100%;\r\n    transform: scale(1, 1);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform-origin: 50% 100%;\r\n    transform: scale(0, 0);\r\n  }\r\n}\r\n\r\n.rc-slider-tooltip {\r\n  position: absolute;\r\n  left: -9999px;\r\n  top: -9999px;\r\n  visibility: visible;\r\n  box-sizing: border-box;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.rc-slider-tooltip-hidden {\r\n  display: none;\r\n}\r\n\r\n.rc-slider-tooltip-placement-top {\r\n  padding: 4px 0 8px 0;\r\n}\r\n\r\n.rc-slider-tooltip-inner {\r\n  padding: 0 8px;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  line-height: 28px;\r\n  color: $white;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  background-color: $gray-900;\r\n  @include border-radius($border-radius);\r\n  box-shadow: $box-shadow-default;\r\n  font-weight: bold;\r\n}\r\n\r\n.rc-slider-tooltip-arrow {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\r\n  bottom: 4px;\r\n  left: 50%;\r\n  margin-left: -4px;\r\n  border-width: 4px 4px 0;\r\n  border-top-color: $gray-900;\r\n}\r\n\r\n// Colors\r\n\r\n@each $color, $value in $theme-colors {\r\n  .rc-slider-#{$color} {\r\n    .rc-slider-track {\r\n      background-color: $value;\r\n    }\r\n\r\n    .rc-slider-handle {\r\n      border-color: $value;\r\n      background-color: $white;\r\n\r\n      &:focus,\r\n      &:active,\r\n      &:hover {\r\n        border-color: darken($value, 15%);\r\n        box-shadow: 0 0.46875rem 2.1875rem rgba($value, .8),\r\n        0 0.125rem 0.5875rem rgba($value, .9);\r\n      }\r\n    }\r\n\r\n    .rc-slider-dot-active {\r\n      border-color: $value;\r\n    }\r\n  }\r\n}\r\n\r\n// Alternate Styles\r\n\r\n.rc-slider-line {\r\n  .rc-slider-handle {\r\n    @include border-radius(0);\r\n    border-width: 0 3px 0 0;\r\n    margin-left: -8px;\r\n    width: 10px;\r\n    background-color: transparent;\r\n    box-shadow: 0 0 0 transparent !important;\r\n  }\r\n}\r\n\r\n.rc-slider-square {\r\n  .rc-slider-handle {\r\n    @include border-radius(3px);\r\n    border-widtH: 1px;\r\n\r\n    &:before {\r\n      position: absolute;\r\n      height: 8px;\r\n      width: 4px;\r\n      border: $gray-500 solid 1px;\r\n      border-width: 0 1px;\r\n      display: block;\r\n      content: '';\r\n      top: 50%;\r\n      left: 50%;\r\n      margin: -4px -2px;\r\n    }\r\n  }\r\n}\r\n\r\n// Sizing\r\n\r\n.rc-slider-lg {\r\n  &.rc-slider {\r\n    height: 20px;\r\n    padding: 8px 0 0;\r\n  }\r\n\r\n  .rc-slider-rail {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-track {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-handle {\r\n    margin-left: -10px;\r\n    margin-top: -8px;\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  &.rc-slider-line {\r\n    .rc-slider-handle {\r\n      margin-left: -8px;\r\n      width: 10px;\r\n    }\r\n  }\r\n\r\n  &.rc-slider-square {\r\n    .rc-slider-handle {\r\n      &:before {\r\n        height: 10px;\r\n        width: 6px;\r\n        margin: -5px -3px;\r\n      }\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.rc-slider-sm {\r\n  &.rc-slider {\r\n    height: 20px;\r\n    padding: 8px 0 0;\r\n  }\r\n\r\n  .rc-slider-rail {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-track {\r\n    height: 4px;\r\n  }\r\n\r\n  .rc-slider-handle {\r\n    margin-left: -6px;\r\n    margin-top: -4px;\r\n    width: 12px;\r\n    height: 12px;\r\n  }\r\n\r\n  &.rc-slider-line {\r\n    .rc-slider-handle {\r\n      margin-left: -8px;\r\n      width: 10px;\r\n    }\r\n  }\r\n\r\n  &.rc-slider-square {\r\n    .rc-slider-handle {\r\n      &:before {\r\n        height: 6px;\r\n        margin: -3px 0 0 -1px;\r\n        border: 0;\r\n        width: 2px;\r\n        background: $gray-500;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n",".rdw-option-wrapper {\r\n  border: 1px solid #F1F1F1;\r\n  padding: 5px;\r\n  min-width: 25px;\r\n  height: 20px;\r\n  border-radius: 2px;\r\n  margin: 0 4px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-option-wrapper:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-option-wrapper:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-option-active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-option-disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n.rdw-dropdown-wrapper {\r\n  height: 30px;\r\n  background: white;\r\n  cursor: pointer;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  margin: 0 3px;\r\n  text-transform: capitalize;\r\n  background: white;\r\n}\r\n.rdw-dropdown-wrapper:focus {\r\n  outline: none;\r\n}\r\n.rdw-dropdown-wrapper:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n  background-color: #FFFFFF;\r\n}\r\n.rdw-dropdown-wrapper:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-dropdown-carettoopen {\r\n  height: 0px;\r\n  width: 0px;\r\n  position: absolute;\r\n  top: 35%;\r\n  right: 10%;\r\n  border-top: 6px solid black;\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n}\r\n.rdw-dropdown-carettoclose {\r\n  height: 0px;\r\n  width: 0px;\r\n  position: absolute;\r\n  top: 35%;\r\n  right: 10%;\r\n  border-bottom: 6px solid black;\r\n  border-left: 5px solid transparent;\r\n  border-right: 5px solid transparent;\r\n}\r\n.rdw-dropdown-selectedtext {\r\n  display: flex;\r\n  position: relative;\r\n  height: 100%;\r\n  align-items: center;\r\n  padding: 0 5px;\r\n}\r\n.rdw-dropdown-optionwrapper {\r\n  z-index: 100;\r\n  position: relative;\r\n  border: 1px solid #F1F1F1;\r\n  width: 98%;\r\n  background: white;\r\n  border-radius: 2px;\r\n  margin: 0;\r\n  padding: 0;\r\n  max-height: 250px;\r\n  overflow-y: scroll;\r\n}\r\n.rdw-dropdown-optionwrapper:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n  background-color: #FFFFFF;\r\n}\r\n.rdw-dropdownoption-default {\r\n  min-height: 25px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 5px;\r\n}\r\n.rdw-dropdownoption-highlighted {\r\n  background: #F1F1F1;\r\n}\r\n.rdw-dropdownoption-active {\r\n  background: #f5f5f5;\r\n}\r\n.rdw-dropdownoption-disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n.rdw-inline-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-inline-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-inline-dropdownoption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-block-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-block-dropdown {\r\n  width: 110px;\r\n}\r\n.rdw-fontsize-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-fontsize-dropdown {\r\n  min-width: 40px;\r\n}\r\n.rdw-fontsize-option {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-fontfamily-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-fontfamily-dropdown {\r\n  width: 115px;\r\n}\r\n.rdw-fontfamily-placeholder {\r\n  white-space: nowrap;\r\n  max-width: 90px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.rdw-fontfamily-optionwrapper {\r\n  width: 140px;\r\n}\r\n.rdw-list-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-list-dropdown {\r\n  width: 50px;\r\n  z-index: 90;\r\n}\r\n.rdw-list-dropdownOption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-text-align-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-text-align-dropdown {\r\n  width: 50px;\r\n  z-index: 90;\r\n}\r\n.rdw-text-align-dropdownOption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-right-aligned-block {\r\n  text-align: right;\r\n}\r\n.rdw-left-aligned-block {\r\n  text-align: left !important;\r\n}\r\n.rdw-center-aligned-block {\r\n  text-align: center !important;\r\n}\r\n.rdw-justify-aligned-block {\r\n  text-align: justify !important;\r\n}\r\n.rdw-right-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-left-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-center-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-justify-aligned-block > div {\r\n  display: inline-block;\r\n}\r\n.rdw-colorpicker-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-colorpicker-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 175px;\r\n  height: 175px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-colorpicker-modal-header {\r\n  display: flex;\r\n  padding-bottom: 5px;\r\n}\r\n.rdw-colorpicker-modal-style-label {\r\n  font-size: 15px;\r\n  width: 50%;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  padding: 0 10px 5px;\r\n}\r\n.rdw-colorpicker-modal-style-label-active {\r\n  border-bottom: 2px solid #0a66b7;\r\n}\r\n.rdw-colorpicker-modal-options {\r\n  margin: 5px auto;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  flex-wrap: wrap;\r\n  overflow: scroll;\r\n}\r\n.rdw-colorpicker-cube {\r\n  width: 22px;\r\n  height: 22px;\r\n  border: 1px solid #F1F1F1;\r\n}\r\n.rdw-colorpicker-option {\r\n  margin: 3px;\r\n  padding: 0;\r\n  min-height: 20px;\r\n  border: none;\r\n  width: 22px;\r\n  height: 22px;\r\n  min-width: 22px;\r\n  box-shadow: 1px 2px 1px #BFBDBD inset;\r\n}\r\n.rdw-colorpicker-option:hover {\r\n  box-shadow: 1px 2px 1px #BFBDBD;\r\n}\r\n.rdw-colorpicker-option:active {\r\n  box-shadow: -1px -2px 1px #BFBDBD;\r\n}\r\n.rdw-colorpicker-option-active {\r\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\r\n}\r\n.rdw-link-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-link-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-link-dropdownOption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-link-dropdownPlaceholder {\r\n  margin-left: 8px;\r\n}\r\n.rdw-link-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 235px;\r\n  height: 205px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-link-modal-label {\r\n  font-size: 15px;\r\n}\r\n.rdw-link-modal-input {\r\n  margin-top: 5px;\r\n  border-radius: 2px;\r\n  border: 1px solid #F1F1F1;\r\n  height: 25px;\r\n  margin-bottom: 15px;\r\n  padding: 0 5px;\r\n}\r\n.rdw-link-modal-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-link-modal-buttonsection {\r\n  margin: 0 auto;\r\n}\r\n.rdw-link-modal-target-option {\r\n  margin-bottom: 20px;\r\n}\r\n.rdw-link-modal-target-option > span {\r\n  margin-left: 5px;\r\n}\r\n.rdw-link-modal-btn {\r\n  margin-left: 10px;\r\n  width: 75px;\r\n  height: 30px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-link-modal-btn:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-link-modal-btn:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-link-modal-btn:focus {\r\n  outline: none !important;\r\n}\r\n.rdw-link-modal-btn:disabled {\r\n  background: #ece9e9;\r\n}\r\n.rdw-link-dropdownoption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-history-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-embedded-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-embedded-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 235px;\r\n  height: 180px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  justify-content: space-between;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-embedded-modal-header {\r\n  font-size: 15px;\r\n  display: flex;\r\n}\r\n.rdw-embedded-modal-header-option {\r\n  width: 50%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n.rdw-embedded-modal-header-label {\r\n  width: 95px;\r\n  border: 1px solid #f1f1f1;\r\n  margin-top: 5px;\r\n  background: #6EB8D4;\r\n  border-bottom: 2px solid #0a66b7;\r\n}\r\n.rdw-embedded-modal-link-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.rdw-embedded-modal-link-input {\r\n  width: 88%;\r\n  height: 35px;\r\n  margin: 10px 0;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 15px;\r\n  padding: 0 5px;\r\n}\r\n.rdw-embedded-modal-link-input-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.rdw-embedded-modal-link-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-embedded-modal-btn-section {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-embedded-modal-btn {\r\n  margin: 0 3px;\r\n  width: 75px;\r\n  height: 30px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-embedded-modal-btn:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-embedded-modal-btn:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-embedded-modal-btn:focus {\r\n  outline: none !important;\r\n}\r\n.rdw-embedded-modal-btn:disabled {\r\n  background: #ece9e9;\r\n}\r\n.rdw-embedded-modal-size {\r\n  align-items: center;\r\n  display: flex;\r\n  margin: 8px 0;\r\n  justify-content: space-between;\r\n}\r\n.rdw-embedded-modal-size-input {\r\n  width: 80%;\r\n  height: 20px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 12px;\r\n}\r\n.rdw-embedded-modal-size-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-emoji-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-emoji-modal {\r\n  overflow: auto;\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 235px;\r\n  height: 180px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-emoji-icon {\r\n  margin: 2.5px;\r\n  height: 24px;\r\n  width: 24px;\r\n  cursor: pointer;\r\n  font-size: 22px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.rdw-spinner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.rdw-spinner > div {\r\n  width: 12px;\r\n  height: 12px;\r\n  background-color: #333;\r\n\r\n  border-radius: 100%;\r\n  display: inline-block;\r\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\r\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\r\n}\r\n.rdw-spinner .rdw-bounce1 {\r\n  -webkit-animation-delay: -0.32s;\r\n  animation-delay: -0.32s;\r\n}\r\n.rdw-spinner .rdw-bounce2 {\r\n  -webkit-animation-delay: -0.16s;\r\n  animation-delay: -0.16s;\r\n}\r\n@-webkit-keyframes sk-bouncedelay {\r\n  0%, 80%, 100% { -webkit-transform: scale(0) }\r\n  40% { -webkit-transform: scale(1.0) }\r\n}\r\n@keyframes sk-bouncedelay {\r\n  0%, 80%, 100% {\r\n    -webkit-transform: scale(0);\r\n    transform: scale(0);\r\n  } 40% {\r\n    -webkit-transform: scale(1.0);\r\n    transform: scale(1.0);\r\n  }\r\n}\r\n.rdw-image-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-image-modal {\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 235px;\r\n  border: 1px solid #F1F1F1;\r\n  padding: 15px;\r\n  border-radius: 2px;\r\n  z-index: 100;\r\n  background: white;\r\n  box-shadow: 3px 3px 5px #BFBDBD;\r\n}\r\n.rdw-image-modal-header {\r\n  font-size: 15px;\r\n  margin: 10px 0;\r\n  display: flex;\r\n}\r\n.rdw-image-modal-header-option {\r\n  width: 50%;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n.rdw-image-modal-header-label {\r\n  width: 80px;\r\n  background: #f1f1f1;\r\n  border: 1px solid #f1f1f1;\r\n  margin-top: 5px;\r\n}\r\n.rdw-image-modal-header-label-highlighted {\r\n  background: #6EB8D4;\r\n  border-bottom: 2px solid #0a66b7;\r\n}\r\n.rdw-image-modal-upload-option {\r\n  width: 100%;\r\n  color: gray;\r\n  cursor: pointer;\r\n  display: flex;\r\n  border: none;\r\n  font-size: 15px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #f1f1f1;\r\n  outline: 2px dashed gray;\r\n  outline-offset: -10px;\r\n  margin: 10px 0;\r\n  padding: 9px 0;\r\n}\r\n.rdw-image-modal-upload-option-highlighted {\r\n  outline: 2px dashed #0a66b7;\r\n}\r\n.rdw-image-modal-upload-option-label {\r\n  cursor: pointer;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 15px;\r\n}\r\n.rdw-image-modal-upload-option-label span{\r\n  padding: 0 20px;\r\n}\r\n.rdw-image-modal-upload-option-image-preview {\r\n  max-width: 100%;\r\n  max-height: 200px;\r\n}\r\n.rdw-image-modal-upload-option-input {\r\n\twidth: 0.1px;\r\n\theight: 0.1px;\r\n\topacity: 0;\r\n\toverflow: hidden;\r\n\tposition: absolute;\r\n\tz-index: -1;\r\n}\r\n.rdw-image-modal-url-section {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.rdw-image-modal-url-input {\r\n  width: 90%;\r\n  height: 35px;\r\n  margin: 15px 0 12px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 15px;\r\n  padding: 0 5px;\r\n}\r\n.rdw-image-modal-btn-section {\r\n  margin: 10px auto 0;\r\n}\r\n.rdw-image-modal-url-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-image-modal-btn {\r\n  margin: 0 5px;\r\n  width: 75px;\r\n  height: 30px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  background: white;\r\n  text-transform: capitalize;\r\n}\r\n.rdw-image-modal-btn:hover {\r\n  box-shadow: 1px 1px 0px #BFBDBD;\r\n}\r\n.rdw-image-modal-btn:active {\r\n  box-shadow: 1px 1px 0px #BFBDBD inset;\r\n}\r\n.rdw-image-modal-btn:focus {\r\n  outline: none !important;\r\n}\r\n.rdw-image-modal-btn:disabled {\r\n  background: #ece9e9;\r\n}\r\n.rdw-image-modal-spinner {\r\n  position: absolute;\r\n  top: -3px;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.5;\r\n}\r\n.rdw-image-modal-alt-input {\r\n  width: 70%;\r\n  height: 20px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 12px;\r\n  margin-left: 5px;\r\n}\r\n.rdw-image-modal-alt-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-image-modal-alt-lbl {\r\n  font-size: 12px;\r\n}\r\n.rdw-image-modal-size {\r\n  align-items: center;\r\n  display: flex;\r\n  margin: 8px 0;\r\n  justify-content: space-between;\r\n}\r\n.rdw-image-modal-size-input {\r\n  width: 40%;\r\n  height: 20px;\r\n  border: 1px solid #F1F1F1;\r\n  border-radius: 2px;\r\n  font-size: 12px;\r\n}\r\n.rdw-image-modal-size-input:focus {\r\n  outline: none;\r\n}\r\n.rdw-image-mandatory-sign {\r\n  color: red;\r\n  margin-left: 3px;\r\n  margin-right: 3px;\r\n}\r\n.rdw-remove-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n}\r\n.rdw-history-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.rdw-history-dropdownoption {\r\n  height: 40px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-history-dropdown {\r\n  width: 50px;\r\n}\r\n.rdw-link-decorator-wrapper {\r\n  position: relative;\r\n}\r\n.rdw-link-decorator-icon {\r\n  position: absolute;\r\n  left: 40%;\r\n  top: 0;\r\n  cursor: pointer;\r\n  background-color: white;\r\n}\r\n.rdw-mention-link {\r\n  text-decoration: none;\r\n  color: #1236ff;\r\n  background-color: #f0fbff;\r\n  padding: 1px 2px;\r\n  border-radius: 2px;\r\n}\r\n.rdw-suggestion-wrapper {\r\n  position: relative;\r\n}\r\n.rdw-suggestion-dropdown {\r\n  position: absolute;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #F1F1F1;\r\n  min-width: 100px;\r\n  max-height: 150px;\r\n  overflow: auto;\r\n  background: white;\r\n  z-index: 100;\r\n}\r\n.rdw-suggestion-option {\r\n  padding: 7px 5px;\r\n  border-bottom: 1px solid #f1f1f1;\r\n}\r\n.rdw-suggestion-option-active {\r\n  background-color: #F1F1F1;\r\n}\r\n.rdw-hashtag-link {\r\n  text-decoration: none;\r\n  color: #1236ff;\r\n  background-color: #f0fbff;\r\n  padding: 1px 2px;\r\n  border-radius: 2px;\r\n}\r\n.rdw-image-alignment-options-popup {\r\n  position: absolute;;\r\n  background: white;\r\n  display: flex;\r\n  padding: 5px 2px;\r\n  border-radius: 2px;\r\n  border: 1px solid #F1F1F1;\r\n  width: 105px;\r\n  cursor: pointer;\r\n  z-index: 100;\r\n}\r\n.rdw-alignment-option-left {\r\n  justify-content: flex-start;\r\n}\r\n.rdw-image-alignment-option {\r\n  height: 15px;\r\n  width: 15px;\r\n  min-width: 15px;\r\n}\r\n.rdw-image-alignment {\r\n  position: relative;\r\n}\r\n.rdw-image-imagewrapper {\r\n  position: relative;\r\n}\r\n.rdw-image-center {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.rdw-image-left {\r\n  display: flex;\r\n}\r\n.rdw-image-right {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n.rdw-image-alignment-options-popup-right {\r\n  right: 0;\r\n}\r\n.rdw-editor-main {\r\n  height: 100%;\r\n  overflow: auto;\r\n  box-sizing: border-box;\r\n}\r\n.rdw-editor-toolbar {\r\n  padding: 6px 5px 0;\r\n  border-radius: 2px;\r\n  border: 1px solid #F1F1F1;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  background: white;\r\n  flex-wrap: wrap;\r\n  font-size: 15px;\r\n  margin-bottom: 5px;\r\n  user-select: none;\r\n}\r\n.public-DraftStyleDefault-block {\r\n  margin: 1em 0;\r\n}\r\n.rdw-editor-wrapper:focus {\r\n  outline: none;\r\n}\r\n.rdw-editor-wrapper {\r\n  box-sizing: content-box;\r\n}\r\n.rdw-editor-main blockquote {\r\n  border-left: 5px solid #f1f1f1;\r\n  padding-left: 5px;\r\n}\r\n.rdw-editor-main pre {\r\n  background: #f1f1f1;\r\n  border-radius: 3px;\r\n  padding: 1px 10px;\r\n}/**\r\n * Draft v0.9.1\r\n *\r\n * Copyright (c) 2013-present, Facebook, Inc.\r\n * All rights reserved.\r\n *\r\n * This source code is licensed under the BSD-style license found in the\r\n * LICENSE file in the root directory of this source tree. An additional grant\r\n * of patent rights can be found in the PATENTS file in the same directory.\r\n */\r\n.DraftEditor-editorContainer,.DraftEditor-root,.public-DraftEditor-content{height:inherit;text-align:initial}.public-DraftEditor-content[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.DraftEditor-root{position:relative}.DraftEditor-editorContainer{background-color:rgba(255,255,255,0);border-left:.1px solid transparent;position:relative;z-index:1}.public-DraftEditor-block{position:relative}.DraftEditor-alignLeft .public-DraftStyleDefault-block{text-align:left}.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root{left:0;text-align:left}.DraftEditor-alignCenter .public-DraftStyleDefault-block{text-align:center}.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root{margin:0 auto;text-align:center;width:100%}.DraftEditor-alignRight .public-DraftStyleDefault-block{text-align:right}.DraftEditor-alignRight .public-DraftEditorPlaceholder-root{right:0;text-align:right}.public-DraftEditorPlaceholder-root{color:#9197a3;position:absolute;z-index:0}.public-DraftEditorPlaceholder-hasFocus{color:#bdc1c9}.DraftEditorPlaceholder-hidden{display:none}.public-DraftStyleDefault-block{position:relative;white-space:pre-wrap}.public-DraftStyleDefault-ltr{direction:ltr;text-align:left}.public-DraftStyleDefault-rtl{direction:rtl;text-align:right}.public-DraftStyleDefault-listLTR{direction:ltr}.public-DraftStyleDefault-listRTL{direction:rtl}.public-DraftStyleDefault-ol,.public-DraftStyleDefault-ul{margin:16px 0;padding:0}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) \". \";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) \". \";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) \". \";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) \". \";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) \". \";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}\r\n\r\n.demo-editor {\r\n  height: 275px !important;\r\n  border: 1px solid #F1F1F1 !important;\r\n  padding: 5px !important;\r\n  border-radius: 2px !important;\r\n}","\r\n/// switch\r\n\r\n.has-switch {\r\n  border-radius: 30px;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  line-height: 1.72222;\r\n  overflow: hidden;\r\n  position: relative;\r\n  text-align: left;\r\n  width: 60px;\r\n  user-select: none;\r\n\r\n}\r\n.has-switch.deactivate {\r\n  opacity: 0.5;\r\n  filter: alpha(opacity=50);\r\n  cursor: default !important;\r\n}\r\n.has-switch.deactivate label,\r\n.has-switch.deactivate span {\r\n  cursor: default !important;\r\n}\r\n.has-switch > div {\r\n  position: relative;\r\n  top: 0;\r\n  width: 100px;\r\n}\r\n.has-switch > div.switch-animate {\r\n  transition: left 0.25s ease-out;\r\n}\r\n.has-switch > div.switch-off {\r\n  left: -35px;\r\n}\r\n\r\n.has-switch > div.switch-on {\r\n  left: 0;\r\n}\r\n\r\n@mixin icon-gradient ($top-color, $bottom-color){\r\n  background: $top-color;\r\n  background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\r\n  background-size: 150% 150%;\r\n}\r\n\r\n.has-switch > div label {\r\n  background-color: #FFFFFF;\r\n  @include icon-gradient (rgba(255,255,255,1), rgba(241,241,242,1));\r\n\r\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\r\n  cursor: pointer;\r\n}\r\n.has-switch input[type=checkbox] {\r\n  display: none;\r\n}\r\n.has-switch span {\r\n  cursor: pointer;\r\n  float: left;\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n  height: 24px;\r\n  line-height: 15px;\r\n  margin: 0;\r\n  padding-bottom: 6px;\r\n  padding-top: 5px;\r\n  position: relative;\r\n  text-align: center;\r\n  text-indent: -10px;\r\n  width: 50%;\r\n  z-index: 1;\r\n  transition: 0.25s ease-out;\r\n}\r\n.has-switch span.switch-left {\r\n  background-color: $primary;\r\n  border-left: 1px solid rgba(0, 0, 0, 0);\r\n  border-radius: 30px 0 0 30px;\r\n  color: #FFFFFF;\r\n}\r\n.has-switch .switch-off span.switch-left{\r\n  background-color: $gray-400 !important;\r\n}\r\n.has-switch span.switch-right {\r\n  border-radius: 0 30px 30px 0;\r\n  background-color: $primary;\r\n  color: #ffffff;\r\n  text-indent: 1px;\r\n}\r\n.has-switch .switch-off span.switch-right{\r\n  background-color: $gray-400 !important;\r\n}\r\n\r\n.has-switch label {\r\n  border-radius: 12px;\r\n  float: left;\r\n  height: 22px;\r\n  margin: 1px -13px;\r\n  padding: 0;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  width: 22px;\r\n  z-index: 10;\r\n  -webkit-transition: 0.25s ease-out;\r\n  transition: 0.25s ease-out;\r\n}\r\n.has-switch .switch-on .fa-check:before{\r\n  margin-left: 10px;\r\n}\r\n.has-switch:hover .switch-on label{\r\n  margin: 1px -17px;\r\n  width: 26px;\r\n}\r\n.has-switch:hover .switch-off label{\r\n  margin: 1px -13px;\r\n  width: 26px;\r\n}\r\n\r\n// Sizing\r\n\r\n.has-switch-sm {\r\n  &.has-switch {\r\n    span {\r\n      height: 18px;\r\n      line-height: 18px;\r\n      padding: 0;\r\n    }\r\n    label {\r\n      height: 16px;\r\n      width: 16px;\r\n      margin: 1px -8px;\r\n    }\r\n\r\n    .switch-off {\r\n      label {\r\n        margin: 1px -13px;\r\n      }\r\n    }\r\n\r\n    &:hover {\r\n      .switch-on label {\r\n        margin: 1px -11px;\r\n        width: 20px;\r\n      }\r\n\r\n      .switch-off label {\r\n        margin: 1px -13px;\r\n        width: 20px;\r\n      }\r\n    }\r\n  }\r\n}","// Dropzone\r\n\r\n.dropzone-wrapper {\r\n  width: 100%;\r\n  border: $gray-400 dashed 2px;\r\n  @include border-radius($border-radius-lg);\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  text-align: center;\r\n  height: 230px;\r\n  transition: all .2s;\r\n\r\n  &:hover {\r\n    border-color: $primary;\r\n  }\r\n\r\n  & > div {\r\n    width: 100%;\r\n    height: 100%;\r\n    outline: none !important;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  &.dropzone-wrapper-lg {\r\n    height: 300px;\r\n  }\r\n\r\n  &.dropzone-wrapper-sm {\r\n    height: 150px;\r\n  }\r\n\r\n  input {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  .dropzone-content {\r\n    margin: 0 auto;\r\n    color: $gray-600;\r\n  }\r\n\r\n  &[aria-disabled=\"true\"] {\r\n    border-color: $gray-300;\r\n\r\n    .dropzone-content {\r\n      color: $gray-400;\r\n    }\r\n  }\r\n}","@import '_mixins';\r\n\r\n.rbt {\r\n  outline: none;\r\n\r\n  &-menu {\r\n    margin-bottom: 2px;\r\n\r\n    & > li a {\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n    }\r\n\r\n    &-pagination-option {\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  // Hide IE's native \"clear\" button\r\n  & .rbt-input-main::-ms-clear {\r\n    display: none;\r\n  }\r\n\r\n  &-input-multi {\r\n    cursor: text;\r\n    overflow: hidden;\r\n    position: relative;\r\n\r\n    // BS4 uses the :disabled pseudo-class, which doesn't work with non-inputs.\r\n    &.form-control[disabled] {\r\n      background-color: #e9ecef;\r\n      opacity: 1;\r\n    }\r\n\r\n    input {\r\n      @include placeholder(#6c757d);\r\n    }\r\n\r\n    .rbt-input-wrapper {\r\n      margin-top: 2px;\r\n      overflow: hidden;\r\n    }\r\n\r\n    .rbt-input-main {\r\n      height: auto;\r\n    }\r\n\r\n    .rbt-input-hint-container {\r\n      display: inline-block;\r\n    }\r\n\r\n    &.input,\r\n    &.form-control {\r\n      &-lg {\r\n        .rbt-input-main {\r\n          height: auto;\r\n        }\r\n      }\r\n\r\n      &-sm {\r\n        .rbt-input-main {\r\n          height: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &-close {\r\n    z-index: 1;\r\n\r\n    &-lg {\r\n      font-size: 24px;\r\n    }\r\n  }\r\n\r\n  &-token {\r\n    background-color: $dropdown-link-hover-bg;\r\n    border: 0;\r\n    @include border-radius($border-radius);\r\n    color: $primary;\r\n    display: inline-block;\r\n    line-height: 1em;\r\n    margin: 0 3px 3px 0;\r\n    padding: 4px 7px;\r\n    position: relative;\r\n\r\n    &-disabled {\r\n      background-color: $gray-100;\r\n      color: $gray-500;\r\n      pointer-events: none;\r\n    }\r\n\r\n    &-removeable {\r\n      cursor: pointer;\r\n      padding-right: 21px;\r\n    }\r\n\r\n    &-active {\r\n      background-color: $primary;\r\n      color: $white;\r\n      outline: none;\r\n      text-decoration: none;\r\n    }\r\n\r\n    & &-remove-button {\r\n      bottom: 0;\r\n      color: $gray-700;\r\n      font-size: inherit;\r\n      font-weight: normal;\r\n      opacity: 1;\r\n      outline: none;\r\n      padding: 3px 7px;\r\n      position: absolute;\r\n      right: 0;\r\n      text-shadow: none;\r\n      top: -1px;\r\n    }\r\n  }\r\n\r\n  &-loader {\r\n    @include animation(loader-animation 600ms infinite linear);\r\n    border: 1px solid $dropdown-link-hover-bg;\r\n    border-radius: 50%;\r\n    border-top-color: darken($dropdown-link-hover-bg, 10%);\r\n    display: block;\r\n    height: 16px;\r\n    width: 16px;\r\n\r\n    &-lg {\r\n      height: 20px;\r\n      width: 20px;\r\n    }\r\n  }\r\n\r\n  &-aux {\r\n    @include display-flex();\r\n    align-items: center;\r\n    bottom: 0;\r\n    justify-content: center;\r\n    pointer-events: none; /* Don't block clicks on the input */\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: 34px;\r\n\r\n    &-lg {\r\n      width: 46px;\r\n    }\r\n\r\n    & .rbt-close {\r\n      margin-top: -1px;\r\n      pointer-events: auto; /* Override pointer-events: none; above */\r\n      background-color: transparent;\r\n      border: none;\r\n    }\r\n  }\r\n\r\n  .has-aux &-input {\r\n    padding-right: 34px;\r\n  }\r\n\r\n  &-highlight-text {\r\n    background-color: inherit;\r\n    color: inherit;\r\n    font-weight: bold;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n/* Input Groups */\r\n.input-group > .rbt {\r\n  @include flex(1);\r\n\r\n  & .rbt-input-hint-container {\r\n    @include display-flex();\r\n  }\r\n\r\n  & .rbt-input-hint {\r\n    // Form-controls within input-groups have a higher z-index.\r\n    z-index: 5;\r\n  }\r\n\r\n  & .rbt-aux {\r\n    // Form-controls within input-groups have a higher z-index.\r\n    z-index: 5;\r\n  }\r\n\r\n  &:not(:first-child) .form-control {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  &:not(:last-child) .form-control {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n  }\r\n}\r\n\r\n@keyframes loader-animation {\r\n  to {\r\n    transform: rotate(1turn);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes loader-animation {\r\n  to {\r\n    -webkit-transform: rotate(1turn);\r\n  }\r\n}\r\n\r\n.input-group > .rbt {\r\n  & .rbt-input-hint-container {\r\n    @include flex(1);\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.rbt-token-remove-button {\r\n  background-color: transparent;\r\n  border: none;\r\n}","\r\n@mixin animation($animation) {\r\n  -webkit-animation: $animation;\r\n  -o-animation: $animation;\r\n  animation: $animation;\r\n}\r\n\r\n@mixin box-shadow($shadow, $inset: false) {\r\n  @if $inset {\r\n    -webkit-box-shadow: $inset, $shadow;\r\n    -moz-box-shadow: $inset, $shadow;\r\n    box-shadow: $inset, $shadow;\r\n  } @else {\r\n    -webkit-box-shadow: $shadow;\r\n    -moz-box-shadow: $shadow;\r\n    box-shadow: $shadow;\r\n  }\r\n}\r\n\r\n@mixin display-flex()  {\r\n  display: -webkit-box;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n}\r\n\r\n@mixin flex($value) {\r\n  -webkit-box-flex: $value;\r\n  -moz-box-flex: $value;\r\n  -webkit-flex: $value;\r\n  -ms-flex: $value;\r\n  flex: $value;\r\n}\r\n\r\n@mixin placeholder($placeholder-color) {\r\n  // Firefox\r\n  &::-moz-placeholder {\r\n    color: $placeholder-color;\r\n    opacity: 1;\r\n  }\r\n\r\n  // Internet Explorer 10+\r\n  &:-ms-input-placeholder {\r\n    color: $placeholder-color;\r\n  }\r\n\r\n  // Safari and Chrome\r\n  &::-webkit-input-placeholder  {\r\n    color: $placeholder-color;\r\n  }\r\n}","@use './variables.scss' as *;\n@use './mixins.scss';\n/* for debugging */\n// *:focus {\n//   outline: 1px red solid !important;\n// }\n\n@keyframes react-widgets-autofill-start {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n\n@keyframes react-widgets-autofill-cancel {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n\n.rw-btn {\n  @include mixins.btn-input-reset;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-clip: $widget-background-clip;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:disabled,\n  fieldset[disabled] &,\n  // for picker-caret\n  .rw-state-disabled &,\n  .rw-state-readonly & {\n    cursor: inherit;\n  }\n  // easier to disable this way then check in each event handler\n  fieldset[disabled] & {\n    pointer-events: none;\n  }\n}\n\n// The Psuedo button on DropdownList and Multiselect\n// also composes rw-btn\n.rw-picker-caret,\n.rw-picker-btn {\n  color: $picker-btn-color;\n  align-items: $picker-btn-align-items;\n  justify-content: $picker-btn-justify-content;\n  padding-left: $picker-btn-padding-left;\n  padding-right: $picker-btn-padding-right;\n}\n\n.rw-picker-btn {\n  background-color: $picker-btn-bg;\n  // border color doesn't make sense here\n  // since it's surrounded by the input border\n\n  &:hover {\n    color: $picker-btn-hover-color;\n    background-color: $picker-btn-hover-bg;\n  }\n  &:active {\n    color: $picker-btn-active-color;\n    background-color: $picker-btn-active-bg;\n  }\n\n  &:disabled,\n  fieldset[disabled] & {\n    background-color: $picker-btn-disabled-bg;\n  }\n}\n\n.rw-input-addon {\n  // The input border should be more important here\n  &,\n  &.rw-picker-btn {\n    border-left: $input-addon-border-color 1px solid;\n\n    [dir='rtl'] & {\n      border-right: $input-addon-border-color 1px solid;\n      border-left: none;\n    }\n  }\n}\n\n.rw-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.rw-widget {\n  border: none;\n  color: $widget-color;\n  font-weight: $widget-font-weight;\n  font-size: $widget-font-size;\n  font-family: $widget-font-family;\n  outline: none;\n  position: relative;\n\n  &,\n  & *,\n  &:after,\n  &:before,\n  & *:after,\n  & *:before {\n    box-sizing: border-box;\n  }\n}\n\n.rw-state-readonly,\n.rw-state-disabled,\nfieldset[disabled] .rw-widget {\n  cursor: not-allowed;\n}\n\n.rw-widget-picker {\n  display: grid;\n  overflow: hidden;\n  min-height: $input-height;\n  background-color: $input-bg;\n  border: $input-border-color $input-border-width solid;\n  border-radius: $input-border-radius;\n  outline: none;\n  grid-template: 1fr / 1fr $input-addon-width;\n  // ensure that the \"chrome\" is the same width as the actual container\n  width: 100%;\n\n  &.rw-hide-caret {\n    grid-template-columns: 1fr;\n  }\n\n  .rw-state-focus & {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    box-shadow: $widget-focus-box-shadow;\n    transition: if($widget-focus-box-shadow, $widget-focus-transition, null);\n\n    &.rw-widget-input {\n      @if ($input-box-shadow) {\n        box-shadow: #{$widget-focus-box-shadow}, #{$input-box-shadow};\n      }\n    }\n  }\n}\n\n.rw-input {\n  @include mixins.btn-input-reset;\n  @include mixins.input-base;\n\n  padding: 0 $input-padding-x;\n\n  &[type='text']::-ms-clear {\n    display: none;\n  }\n\n  &:disabled,\n  &:read-only {\n    // use parent style\n    cursor: inherit;\n  }\n}\n\n// This class represents the abstract container that is the \"input\" of any\n// given widget\n.rw-widget-input {\n  color: $input-color;\n  background-color: $input-bg;\n  box-shadow: $input-box-shadow;\n  background-clip: $widget-background-clip;\n  width: inherit;\n\n  // Listbox is also the rw-widget\n  &.rw-state-disabled,\n  .rw-state-disabled &,\n  fieldset[disabled] & {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n  }\n}\n\n.rw-placeholder,\n.rw-input::placeholder {\n  color: $input-placeholder-color;\n\n  .rw-state-disabled & {\n    color: $input-disabled-placeholder-color;\n  }\n}\n\n// https://github.com/klarna/ui/blob/master/Field/styles.scss\n.rw-detect-autofill {\n  @include mixins.btn-input-reset;\n  @include mixins.input-base;\n}\n\n.rw-detect-autofill:-webkit-autofill {\n  animation-name: react-widgets-autofill-start;\n  animation-duration: 0.01ms;\n}\n\n.rw-detect-autofill:not(:-webkit-autofill) {\n  animation-name: react-widgets-autofill-cancel;\n  animation-duration: 0.01ms;\n}\n\n.rw-webkit-autofill .rw-widget-container,\n.rw-input:-webkit-autofill {\n  background-color: $input-autofill-bg !important;\n  background-image: none !important;\n  color: $input-autofill-color !important;\n}\n","@use './variables.scss' as *;\n\n@mixin border-box() {\n  background-clip: border-box;\n\n  &,\n  & * {\n    box-sizing: border-box;\n  }\n\n  &:before,\n  & *:before,\n  &:after,\n  & *:after {\n    box-sizing: border-box;\n  }\n}\n\n@mixin unstyled-list() {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n@mixin focus-ring() {\n  z-index: 1;\n  box-shadow: $widget-focus-box-shadow;\n  transition: if($widget-focus-box-shadow, $widget-focus-transition, null);\n}\n\n@mixin focus() {\n  &:focus {\n    @include focus-ring();\n\n    [data-intent='mouse'] & {\n      z-index: auto;\n      box-shadow: none;\n    }\n  }\n}\n\n@mixin btn-input-reset {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n}\n\n@mixin input-base {\n  caret-color: $input-caret-color;\n\n  &:disabled {\n    // For safari, which seems to ignore color on disabled inputs\n    // opacity for IOS\n    -webkit-text-fill-color: $input-disabled-color;\n    opacity: 1;\n  }\n}\n","$components: (\n  'Listbox',\n  'DropdownList',\n  'Combobox',\n  'Autocomplete',\n  'Multiselect',\n  'DatePicker',\n  'Calendar',\n  'TimeInput',\n  'NumberPicker'\n) !default;\n\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n\n//\n// Widget States\n//\n$widget-font-weight: null !default; // TODO\n$widget-font-size: 1em !default;\n$widget-font-family: inherit !default;\n\n$widget-border-radius: 4px !default;\n\n$widget-bg: #fff !default;\n$widget-color: $gray-900;\n$widget-border-color: #ccc !default;\n$widget-disabled-bg: $gray-200 !default;\n\n$widget-hover-bg: $gray-200 !default;\n$widget-hover-border-color: $widget-hover-bg !default;\n$widget-hover-color: null !default;\n\n$widget-focus-width: 3px !default;\n$widget-focus-color: rgba(0, 123, 255, 0.25) !default;\n$widget-focus-box-shadow: 0 0 0 $widget-focus-width $widget-focus-color !default;\n$widget-focus-transition: box-shadow 0.15s ease-in-out !default;\n\n$widget-background-clip: padding-box !default;\n\n//\n// Buttons\n//\n$picker-btn-align-items: null !default; // TD\n$picker-btn-justify-content: null !default; // TD\n\n$picker-btn-padding-left: null !default;\n$picker-btn-padding-right: null !default;\n$picker-btn-color: $widget-color !default;\n$picker-btn-border-color: null !default;\n$picker-btn-bg: null !default;\n$picker-btn-disabled-bg: $widget-disabled-bg !default;\n\n$picker-btn-hover-color: null !default;\n$picker-btn-hover-border-color: null !default;\n$picker-btn-hover-bg: $widget-hover-bg !default;\n\n$picker-btn-active-color: null !default;\n$picker-btn-active-border-color: null !default;\n$picker-btn-active-bg: $gray-300 !default;\n\n//\n// Picker inputs\n//\n\n$input-height: 38px !default; // 2.5em is good for 16px roots\n$input-color: $gray-700 !default;\n$input-caret-color: null !default;\n$input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !default;\n$input-padding-x: 0.857em !default;\n\n$input-bg: $widget-bg !default;\n$input-placeholder-color: #999 !default;\n\n$input-border-color: $widget-border-color !default;\n$input-border-width: 1px !default;\n$input-border-radius: $widget-border-radius !default;\n\n$input-disabled-bg: $widget-disabled-bg !default;\n$input-disabled-border-color: null !default;\n$input-disabled-color: null !default;\n$input-disabled-placeholder-color: #999 !default;\n\n$input-focus-bg: null !default;\n$input-focus-border-color: #80bdff !default; // 25% lighter active-bg\n$input-focus-color: null !default;\n\n$input-autofill-bg: rgb(232, 240, 254) !default;\n$input-autofill-color: rgb(0, 0, 0) !default;\n\n$input-addon-width: 1.9em !default;\n$input-addon-border-color: $input-border-color !default;\n","@use './variables.scss' as *;\n\n$color: $widget-color !default;\n$font-size: $widget-font-size !default;\n$padding-y: 0.5em !default;\n\n$_hover-bg: $widget-hover-bg;\n$_hover-border-color: $widget-hover-border-color;\n$_hover-color: $widget-hover-color;\n\n$focus-bg: $_hover-bg !default;\n$focus-border-color: $_hover-border-color !default;\n$focus-color: $_hover-color !default;\n\n$selected-bg: #007bff !default;\n$selected-border-color: $selected-bg !default;\n$selected-color: #fff !default;\n\n$disabled-bg: transparent !default;\n$disabled-border-color: transparent !default;\n$disabled-color: $gray-300 !default;\n\n$option-padding-y: 0.25em !default;\n$option-padding-x: 1.5em !default;\n$option-muted-color: $gray-400 !default;\n\n$option-create-bg: $widget-bg !default;\n\n$optgroup-color: null !default;\n$optgroup-font-weight: bold !default;\n\n@mixin List() {\n  .rw-list {\n    // outline: 0;\n    font-size: $font-size;\n    overflow-x: visible;\n    overflow-y: auto;\n    padding-top: $padding-y;\n    padding-bottom: $padding-y;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .rw-list-option {\n    user-select: none;\n    color: $color;\n    cursor: pointer;\n    border: 1px solid transparent;\n    background-clip: $widget-background-clip;\n\n    &:hover,\n    [data-intent='keyboard'] &.rw-state-focus:not(.rw-state-selected) {\n      background-color: $focus-bg;\n      border-color: $focus-border-color;\n      color: $focus-color;\n    }\n\n    &.rw-state-selected {\n      background-color: $selected-bg;\n      border-color: $selected-border-color;\n      color: $selected-color;\n    }\n\n    &.rw-state-disabled {\n      cursor: not-allowed; // required to override the cursor above\n      background-color: $disabled-bg;\n      border-color: $disabled-border-color;\n      color: $disabled-color;\n    }\n  }\n\n  .rw-list-empty,\n  .rw-list-option,\n  .rw-list-optgroup {\n    padding: $option-padding-y $option-padding-x;\n    outline: none;\n  }\n\n  .rw-list-empty {\n    text-align: center;\n    color: $option-muted-color;\n  }\n\n  .rw-list-optgroup {\n    color: $optgroup-color;\n    font-weight: $optgroup-font-weight;\n    padding-top: 7px;\n  }\n\n  .rw-list-option-create {\n    @extend .rw-list-option;\n\n    display: block;\n    font-size: $font-size;\n    padding: $option-padding-y $option-padding-x;\n  }\n}\n","@use './variables.scss' as *;\n\n@mixin Listbox() {\n  .rw-listbox {\n    border-radius: $widget-border-radius;\n    background-color: $widget-bg;\n    border: $widget-border-color 1px solid;\n\n    &.rw-state-focus {\n      color: $input-focus-color;\n      background-color: $input-focus-bg;\n      border-color: $input-focus-border-color;\n      box-shadow: #{$widget-focus-box-shadow}, #{$input-box-shadow};\n      transition: if($widget-focus-box-shadow, $widget-focus-transition, null);\n    }\n\n    &.rw-state-disabled > *,\n    fieldset[disabled] & > * {\n      pointer-events: none;\n    }\n\n    &.rw-state-readonly > * {\n      cursor: inherit;\n    }\n  }\n}\n","@use './variables.scss' as *;\n\n$widget-offset: 2px !default;\n$max-height: 250px;\n$bg: $widget-bg !default;\n$border: $widget-border-color !default;\n$border-radius: $widget-border-radius !default;\n$box-shadow-offset: 1em !default;\n$box-shadow: 0 0.5em 1em rgba(#000, 0.175) !default;\n$box-shadow-up: 0 0.5em 1em rgba(#000, 0.175) !default;\n\n$zindex: 1005 !default;\n$zindex-focused: $zindex + 1 !default;\n\n@mixin Popup() {\n  .rw-popup-container {\n    position: absolute;\n    z-index: $zindex;\n    top: 100%;\n    left: -$box-shadow-offset;\n    right: -$box-shadow-offset;\n    padding: 0 $box-shadow-offset;\n\n    &.rw-dropup {\n      top: auto;\n      bottom: 100%;\n    }\n\n    .rw-state-focus & {\n      z-index: $zindex-focused;\n    }\n  }\n\n  .rw-slide-transition {\n    // the offsets allows for drop shadow to not be clipped by the container\n    // width: 100%;\n    margin-bottom: $box-shadow-offset;\n    // margin: 0 $box-shadow-offset;\n\n    .rw-dropup > & {\n      margin-bottom: 0;\n      margin-top: $box-shadow-offset;\n    }\n  }\n\n  .rw-popup {\n    overflow: auto; // this is needed for some reason to clip scrollbar corners\n    -webkit-overflow-scrolling: touch;\n    margin-top: $widget-offset;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow;\n    border: $border 1px solid;\n    background-clip: $widget-background-clip;\n    background: $bg;\n\n    & .rw-list {\n      max-height: $max-height;\n    }\n\n    .rw-dropup & {\n      margin-top: 0;\n      margin-bottom: $widget-offset;\n      box-shadow: $box-shadow-up;\n    }\n  }\n\n  .rw-slide-transition {\n    transition: transform 130ms, opacity 100ms;\n  }\n\n  .rw-slide-transition-entering {\n    overflow: hidden;\n\n    & .rw-slide-transition {\n      transform: translateY(0);\n      opacity: 1;\n      transition-timing-function: ease-out;\n    }\n  }\n\n  .rw-slide-transition-exiting {\n    & .rw-slide-transition {\n      transition-timing-function: ease-in;\n    }\n  }\n\n  .rw-slide-transition-exiting,\n  .rw-slide-transition-exited {\n    overflow: hidden;\n\n    & .rw-slide-transition {\n      opacity: 0;\n      transform: translateY(-10%);\n    }\n\n    &.rw-dropup .rw-slide-transition {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n  }\n\n  .rw-slide-transition-exited {\n    display: none;\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n\n@mixin DropdownList() {\n  .rw-dropdown-list {\n    width: 100%;\n  }\n\n  .rw-dropdownlist-search {\n    @include mixins.btn-input-reset;\n    @include mixins.input-base;\n  }\n\n  .rw-dropdown-list-value {\n  }\n\n  .rw-dropdown-list-input {\n    padding: 0 $input-padding-x;\n    align-self: center;\n    display: grid;\n    min-width: 0;\n    grid-template: 1fr / 1fr;\n\n    & > * {\n      grid-area: 1/1;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    [dir='rtl'] & {\n      padding-right: $input-padding-x;\n      padding-left: 0;\n    }\n  }\n}\n","@mixin Combobox() {\n  .rw-combobox-input {\n    background-color: transparent;\n    z-index: 1;\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n\n$gutter-pt: 0.115 !default;\n$tag-padding-left: 0.35em !default;\n$tag-padding-right: 0.35em !default;\n\n$tag-color: null !default;\n$tag-border-color: $gray-300 !default;\n$tag-bg: $gray-300 !default;\n\n$tag-height-pt: 1 - ($gutter-pt * 2) !default;\n$tag-gutter: calc(\n  #{$input-height} * #{$gutter-pt} - #{$input-border-width}\n) !default;\n$tag-height: calc(#{$input-height} * #{$tag-height-pt}) !default;\n$tag-border-radius: 3px !default;\n\n$tag-btn-padding-y: 0 !default;\n$tag-btn-padding-x: 0.35em !default;\n\n$tag-btn-bg: null !default;\n$tag-btn-border-color: null !default;\n$tag-btn-color: null !default;\n\n$tag-btn-hover-bg: null !default;\n$tag-btn-hover-border-color: null !default;\n$tag-btn-hover-color: null !default;\n\n$tag-btn-active-bg: null !default;\n$tag-btn-active-border-color: null !default;\n$tag-btn-active-color: null !default;\n\n@mixin Multiselect() {\n  .rw-multiselect {\n  }\n\n  .rw-multiselect-input {\n    @include mixins.btn-input-reset;\n    @include mixins.input-base;\n\n    height: calc(#{$input-height} - #{$input-border-width} * 2);\n    padding: 0 $input-padding-x;\n    max-width: 100%; // breaks to a new line but doesn't stop growing\n\n    &:disabled,\n    &:read-only {\n      // use parent style\n      cursor: inherit;\n    }\n  }\n\n  .rw-multiselect-taglist {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    width: 100%;\n    outline: none;\n    cursor: text;\n\n    .rw-state-disabled & {\n      cursor: unset;\n    }\n  }\n\n  .rw-multiselect-tag {\n    display: inline-flex;\n    color: $tag-color;\n    margin-left: $tag-gutter;\n    margin-top: $tag-gutter;\n    min-height: $tag-height;\n    border-radius: $tag-border-radius;\n    background-color: $tag-bg;\n    border: if($tag-border-color, 1px solid $tag-border-color, null);\n    // reset the text selection cursor on the parent\n    cursor: default;\n    max-width: 100%;\n    align-items: center;\n    // border radius clipping when there are background colors, e.g. hover/active\n    // easier than rtl border radius'in\n    overflow: hidden;\n\n    &:focus {\n      outline: none;\n    }\n\n    [dir='rtl'] & {\n      margin-left: 0;\n      margin-right: $tag-gutter;\n      padding: 0 $tag-padding-left 0 $tag-padding-right;\n    }\n\n    &.rw-state-focus {\n      @include mixins.focus-ring();\n    }\n\n    &.rw-state-disabled,\n    fieldset[disabled] & {\n      opacity: 0.65;\n    }\n  }\n\n  .rw-multiselect-tag-label {\n    padding: 0 $tag-padding-right 0 $tag-padding-left;\n  }\n\n  .rw-multiselect-tag-btn {\n    @include mixins.btn-input-reset;\n\n    cursor: pointer;\n    align-self: stretch;\n\n    padding: $tag-btn-padding-y $tag-btn-padding-x;\n    color: $tag-btn-color;\n    border-color: $tag-btn-border-color;\n    background-color: $tag-btn-bg;\n\n    &:hover {\n      color: $tag-btn-hover-color;\n      border-color: $tag-btn-hover-border-color;\n      background-color: $tag-btn-hover-bg;\n    }\n    &:active {\n      color: $tag-btn-active-color;\n      background-color: $tag-btn-active-bg;\n      border-color: $tag-btn-active-border-color;\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:disabled {\n      cursor: inherit;\n    }\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n@use './list.scss' as list;\n\n$bg: $widget-bg !default;\n\n$btn-bg: #fff !default;\n$btn-color: $widget-color !default;\n$btn-border-color: null !default;\n$btn-muted-color: $gray-400;\n$btn-border-radius: $widget-border-radius !default;\n\n$btn-hover-bg: $widget-hover-bg !default;\n$btn-hover-border-color: $widget-hover-border-color !default;\n$btn-hover-color: $widget-hover-color !default;\n\n$btn-active-color: null !default;\n$btn-active-border-color: null !default;\n$btn-active-bg: $gray-300 !default;\n\n$btn-focus-color: null !default;\n$btn-focus-border-color: null !default;\n$btn-focus-bg: null !default;\n\n$cell-align: center !default;\n$cell-padding: 0.25em !default;\n$cell-color: $btn-color !default;\n$cell-border-color: null !default;\n$cell-border-radius: $btn-border-radius !default;\n\n$cell-hover-bg: $btn-hover-bg !default;\n$cell-hover-border-color: $btn-hover-border-color !default;\n$cell-hover-color: $btn-hover-color !default;\n\n$cell-active-bg: $btn-active-bg !default;\n$cell-active-border-color: $btn-active-border-color !default;\n$cell-active-color: $btn-active-color !default;\n\n$cell-select-color: list.$selected-color !default;\n$cell-select-border-color: list.$selected-border-color !default;\n$cell-select-bg: list.$selected-bg !default;\n\n@mixin _translate($x, $y) {\n  transform: translate(#{$x}, #{$y});\n\n  @supports (transform-style: preserve-3d) {\n    transform: translate3d(#{$x}, #{$y}, 0);\n  }\n}\n\n@mixin Calendar() {\n  .rw-calendar-popup {\n    right: auto;\n    min-width: 0;\n    width: 22em;\n  }\n\n  .rw-calendar {\n    overflow: hidden;\n  }\n\n  .rw-calendar-contained {\n    border-radius: $widget-border-radius;\n    background-color: $bg;\n    border: $widget-border-color 1px solid;\n  }\n\n  .rw-calendar-now {\n    font-weight: bold;\n  }\n  .rw-calendar-header {\n    display: flex;\n    padding: 0.8em;\n  }\n\n  .rw-cell,\n  .rw-calendar-btn {\n    background-clip: $widget-background-clip;\n\n    @include mixins.focus();\n\n    // TODO: normal button disabled\n    &:disabled,\n    &.rw-state-disabled {\n      pointer-events: none;\n      opacity: 0.35;\n    }\n  }\n\n  .rw-calendar-btn {\n    line-height: 2em;\n    border-radius: $btn-border-radius;\n    border-color: $btn-border-color;\n\n    &:hover {\n      background-color: $btn-hover-bg;\n    }\n    &:active {\n      background-color: $btn-active-bg;\n    }\n  }\n\n  .rw-calendar-btn-left,\n  .rw-calendar-btn-today,\n  .rw-calendar-btn-right,\n  .rw-calendar-btn-view {\n    padding: 0.3em 0.6em;\n  }\n\n  .rw-calendar-btn-left,\n  .rw-calendar-btn-right {\n    [dir='rtl'] & {\n      transform: scale(-1, 1);\n    }\n  }\n  .rw-calendar-btn-view {\n    font-weight: bold;\n\n    & > :last-child {\n      margin: 0 0.5em;\n    }\n\n    & + * {\n      margin-left: auto;\n\n      [dir='rtl'] & {\n        margin-left: 0;\n        margin-right: auto;\n      }\n    }\n  }\n\n  .rw-calendar-grid {\n    display: table;\n    outline: none;\n    height: 14em;\n    padding: $widget-focus-width;\n    table-layout: fixed;\n    border-collapse: separate;\n    border-spacing: 0;\n    width: 100%;\n    background-color: $bg;\n  }\n  .rw-calendar-head {\n    display: table-header-group;\n  }\n  .rw-calendar-body {\n    display: table-row-group;\n  }\n\n  .rw-calendar-row {\n    display: table-row;\n  }\n\n  .rw-head-cell {\n    display: table-cell;\n    text-align: $cell-align;\n    border-bottom: 1px solid $input-border-color;\n    padding: $cell-padding;\n  }\n\n  .rw-cell {\n    display: table-cell;\n    color: $cell-color;\n    vertical-align: middle;\n    border-color: $cell-border-color;\n    border-radius: $cell-border-radius;\n    cursor: pointer;\n    line-height: normal;\n    text-align: center;\n    border: 1px solid transparent;\n    padding: $cell-padding;\n    outline: none;\n\n    &:hover {\n      background-color: $cell-hover-bg;\n    }\n    &:active {\n      background-color: $cell-active-bg;\n    }\n\n    &.rw-state-selected {\n      background-color: $cell-select-bg;\n      border-color: $cell-select-border-color;\n      color: $cell-select-color;\n    }\n\n    .rw-calendar-month & {\n      text-align: $cell-align;\n    }\n  }\n\n  .rw-cell-off-range {\n    color: $btn-muted-color;\n  }\n\n  .rw-calendar-transition-group {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .rw-calendar-transition {\n    width: 100%;\n    overflow: hidden;\n    transition: transform 0.2s ease-in-out 0ms;\n    @include _translate(0, 0);\n  }\n\n  .rw-calendar-transition-next {\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n\n    .rw-calendar-transition-top & {\n      @include _translate(0, -100%);\n    }\n    .rw-calendar-transition-bottom & {\n      @include _translate(0, 100%);\n    }\n    .rw-calendar-transition-right & {\n      @include _translate(-100%, 0);\n    }\n    .rw-calendar-transition-left & {\n      @include _translate(100%, 0);\n    }\n\n    &.rw-calendar-transition-active {\n      @include _translate(0, 0);\n    }\n  }\n\n  .rw-calendar-transition-prev {\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    .rw-calendar-transition-top & {\n      @include _translate(0, 100%);\n    }\n    .rw-calendar-transition-bottom & {\n      @include _translate(0, -100%);\n    }\n    .rw-calendar-transition-right & {\n      @include _translate(100%, 0);\n    }\n    .rw-calendar-transition-left & {\n      @include _translate(-100%, 0);\n    }\n  }\n}\n","@mixin DateTimePicker() {\n  .rw-popup {\n    display: flex;\n    flex-direction: column;\n\n    & > .rw-time-input {\n      align-self: center;\n      margin: 1em 0;\n    }\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n\n@mixin TimeInput() {\n  .rw-time-input {\n    display: inline-flex;\n    min-height: $input-height;\n    align-items: center;\n    background-color: $input-bg;\n    border: $input-border-color $input-border-width solid;\n    border-radius: $input-border-radius;\n    outline: none;\n    cursor: text;\n  }\n\n  .rw-time-part-input {\n    @include mixins.btn-input-reset;\n    @include mixins.input-base;\n\n    padding: 0 0.5em;\n    // min-height: $input-height;\n\n    &,\n    &::placeholder {\n      text-align: center;\n    }\n  }\n\n  .rw-time-part-meridiem {\n    @include mixins.btn-input-reset;\n\n    padding: 0 0.5em;\n    text-transform: lowercase;\n    font-variant: small-caps;\n\n    & :focus {\n      outline: none;\n    }\n  }\n\n  .rw-time-input-clear {\n    padding: 0 0.4em;\n    outline: none;\n    opacity: 0;\n    margin-left: auto;\n\n    [dir='rtl'] & {\n      margin-left: revert;\n      margin-right: auto;\n    }\n\n    .rw-time-input:hover &.rw-show,\n    .rw-time-input.rw-state-focus &.rw-show {\n      opacity: 1;\n    }\n  }\n}\n","@use './variables.scss' as *;\n\n@mixin NumberPicker() {\n  .rw-number-picker-spinners {\n    display: flex;\n    flex-direction: column;\n\n    .rw-btn {\n      flex: 1 1 0;\n    }\n  }\n}\n","// Theme Options\r\n\r\n// Variables\r\n\r\n@use \"sass:math\";\r\n\r\n$theme-options-width: 500px;\r\n\r\n.ui-theme-settings {\r\n  position: fixed;\r\n  z-index: 155;\r\n  right: -30px;\r\n  top: 0;\r\n  height: 100vh;\r\n  transform: translate($theme-options-width);\r\n  transition: all .2s;\r\n  box-shadow: -0.46875rem 0 2.1875rem rgba(darken($primary, 50%), .03),\r\n  -0.9375rem 0 1.40625rem rgba(darken($primary, 50%), .03),\r\n  -0.25rem 0 0.53125rem rgba(darken($primary, 50%), .05),\r\n  -0.125rem 0 0.1875rem rgba(darken($primary, 50%), .03);\r\n\r\n  .btn-open-options {\r\n    @include border-radius(50px);\r\n    position: absolute;\r\n    left: -114px;\r\n    bottom: 80px;\r\n    padding: 0;\r\n    height: 54px;\r\n    line-height: 54px;\r\n    width: 54px;\r\n    text-align: center;\r\n    display: block;\r\n    box-shadow: $box-shadow-default;\r\n    margin-top: -27px;\r\n\r\n    svg {\r\n      top: 50%;\r\n      left: 50%;\r\n      position: absolute;\r\n      margin: -0.5em 0 0 -0.5em;\r\n    }\r\n  }\r\n\r\n  .theme-settings__inner {\r\n    background: $white;\r\n    width: $theme-options-width;\r\n    height: 100vh;\r\n    padding: 0;\r\n  }\r\n\r\n  &.settings-open {\r\n    transform: translate(0);\r\n    right: 0;\r\n  }\r\n\r\n  .theme-settings-swatches {\r\n    text-align: center;\r\n\r\n    .swatch-holder-img {\r\n      width: 72px;\r\n      height: auto;\r\n      @include border-radius(3px);\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  .themeoptions-heading {\r\n    font-size: $font-size-lg;\r\n    color: $body-color;\r\n    margin: 0;\r\n    background: $gray-100;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    border-bottom: $gray-300 solid 1px;\r\n    border-top: $gray-300 solid 1px;\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: center;\r\n\r\n    &:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  .list-group-item {\r\n    h5 {\r\n      color: $primary;\r\n      font-size: $font-size-sm;\r\n      text-transform: uppercase;\r\n      margin: 0;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n\r\n.swatch-holder {\r\n  width: 24px;\r\n  height: 24px;\r\n  line-height: 24px;\r\n  margin: 5px 5px 0;\r\n  transition: all .2s;\r\n  opacity: .7;\r\n  display: inline-block;\r\n  @include border-radius(30px);\r\n\r\n  &.active {\r\n    border: $white solid 2px;\r\n    box-shadow: 0 0 0 5px $primary;\r\n    opacity: 1;\r\n  }\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.swatch-holder-lg {\r\n  width: 48px;\r\n  height: 48px;\r\n  line-height: 48px;\r\n}","// DEMO\r\n\r\n@use \"sass:math\";\r\n\r\n@import \"elements/theme-options\";\r\n\r\n// Icons demo\r\n\r\n.font-icon-wrapper {\r\n  text-align: center;\r\n  border: $gray-200 solid 1px;\r\n  @include border-radius($border-radius);\r\n  margin: 0 0 10px;\r\n  padding: 5px;\r\n\r\n  &.font-icon-lg {\r\n    float: left;\r\n    padding: 10px;\r\n    text-align: center;\r\n    margin-right: 15px;\r\n    min-width: 64px;\r\n\r\n    i {\r\n      font-size: $h1-font-size;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    background: $gray-100;\r\n    color: $primary;\r\n\r\n    p {\r\n      color: $gray-600;\r\n    }\r\n  }\r\n\r\n  i {\r\n    font-size: ($font-size-lg * 1.5);\r\n  }\r\n\r\n  p {\r\n    color: $gray-500;\r\n    font-size: math.div($font-size-sm, 1.2);\r\n    margin: 5px 0 0;\r\n  }\r\n}\r\n\r\n.btn-icon-vertical {\r\n  min-width: 100px;\r\n}\r\n\r\n.card.mb-3 {\r\n  margin-bottom: $grid-gutter-width !important;\r\n}\r\n\r\n// Image BG\r\n\r\n.demo-image-bg {\r\n  height: 350px;\r\n  margin-bottom: $grid-gutter-width;\r\n}\r\n\r\n// Loaders wrapper\r\n\r\n.loader-wrapper {\r\n  width: 150px;\r\n  height: 100px;\r\n  float: left;\r\n}\r\n\r\n// Slick slider\r\n\r\n.slider-item {\r\n  background: $gray-300;\r\n  @include border-radius($border-radius);\r\n  color: $gray-600;\r\n  font-size: 36px;\r\n  padding: 0;\r\n  position: relative;\r\n  height: 150px;\r\n  line-height: 150px;\r\n  text-align: center;\r\n  margin: 0 $layout-spacer-x;\r\n  transition: all .2s;\r\n}\r\n\r\n.slick-center {\r\n  .slider-item {\r\n    background: $gray-500;\r\n    color: $gray-700;\r\n  }\r\n}\r\n\r\n// Image Crop\r\n\r\n.after-img {\r\n  max-width: 100%;\r\n}\r\n","// Responsive\r\n\r\n@use \"sass:math\";\r\n\r\n@media only screen and (max-width: 1320px) {\r\n  .header-user-info {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(md) {\r\n\r\n  .app-main {\r\n    display: block;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    &::before,\r\n    &::after {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .app-sidebar {\r\n    flex: 0 0 $app-sidebar-width !important;\r\n    width: $app-sidebar-width !important;\r\n    transform: translateX(-$app-sidebar-width);\r\n\r\n    .app-header__logo {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .sidebar-mobile-open {\r\n\r\n    .app-sidebar {\r\n\r\n      transform: translateX(0);\r\n\r\n      .app-sidebar__inner {\r\n\r\n        .app-sidebar__heading {\r\n          text-indent: initial;\r\n\r\n          &::before {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        .metismenu-link {\r\n          text-indent: initial;\r\n          padding: 0 $layout-spacer-x 0 45px;\r\n        }\r\n\r\n        .metismenu-icon {\r\n          text-indent: initial;\r\n          left: 5px;\r\n          margin-left: 0;\r\n        }\r\n\r\n        .metismenu-state-icon {\r\n          visibility: visible;\r\n        }\r\n\r\n        .metismenu-container {\r\n          &.visible {\r\n            padding: .5em 0 0 2rem;\r\n\r\n            & > .metismenu-item > .metismenu-link {\r\n              height: 2.3em;\r\n            }\r\n          }\r\n\r\n          .metismenu-container {\r\n            .metismenu-link {\r\n              padding-left: 1em;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .app-header__logo {\r\n        width: auto !important;\r\n\r\n        .logo-src {\r\n          width: $logo-width !important;\r\n          margin-left: auto;\r\n          margin-right: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .fixed-sidebar .app-sidebar {\r\n      height: 100%;\r\n    }\r\n\r\n    .sidebar-mobile-overlay {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .app-main {\r\n\r\n    .app-main__outer {\r\n      padding-left: 0 !important;\r\n      width: auto;\r\n    }\r\n  }\r\n\r\n  .app-header {\r\n    justify-content: space-between;\r\n\r\n    .app-header__logo {\r\n      display: none;\r\n      order: 2;\r\n      background: transparent !important;\r\n      border: 0 !important;\r\n    }\r\n\r\n    .app-header__content {\r\n      visibility: hidden;\r\n      opacity: 0;\r\n      box-shadow: $box-shadow-default;\r\n      position: absolute;\r\n      left: 5%;\r\n      width: 90%;\r\n      top: 0;\r\n      transition: all .2s;\r\n      background: $white;\r\n      @include border-radius(50px);\r\n      padding: 0 10px;\r\n      overflow: hidden;\r\n\r\n      .header-btn-lg {\r\n        margin-left: .5rem;\r\n        padding: 0 .5rem;\r\n\r\n        .hamburger-box {\r\n          margin-top: 5px;\r\n        }\r\n\r\n        & + .header-btn-lg {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      .app-header-left {\r\n        .nav {\r\n          display: none;\r\n        }\r\n      }\r\n\r\n      &.header-mobile-open {\r\n        visibility: visible;\r\n        opacity: 1;\r\n        top: $app-header-height + 20;\r\n      }\r\n    }\r\n\r\n    .app-header__mobile-menu {\r\n      display: flex;\r\n      order: 1;\r\n    }\r\n\r\n    .app-header__menu {\r\n      display: flex;\r\n      order: 3;\r\n    }\r\n\r\n    &.header-text-light {\r\n      .app-header__menu {\r\n        & > span .btn,\r\n        & > .btn {\r\n          background: rgba(255, 255, 255, .1);\r\n          border-color: rgba(255, 255, 255, .1);\r\n        }\r\n      }\r\n\r\n      .header-mobile-open {\r\n        background: $gray-800;\r\n      }\r\n\r\n    }\r\n  }\r\n\r\n  .popover,\r\n  .dropdown-menu {\r\n    position: fixed !important;\r\n    z-index: 50;\r\n    left: 5% !important;\r\n    top: 50% !important;\r\n    width: 90% !important;\r\n    transform: translateY(-50%) !important;\r\n    min-width: 10px !important;\r\n\r\n    .btn-icon-vertical .btn-icon-wrapper {\r\n      display: none;\r\n    }\r\n\r\n  }\r\n\r\n  .popover {\r\n    max-width: initial;\r\n\r\n    .arrow {\r\n      display: none !important;\r\n    }\r\n  }\r\n\r\n  .app-page-title {\r\n    text-align: center;\r\n\r\n    .page-title-heading,\r\n    .page-title-wrapper {\r\n      margin: 0 auto;\r\n      display: block;\r\n    }\r\n\r\n    .page-title-actions {\r\n      margin: math.div($grid-gutter-width, 2) auto 0;\r\n    }\r\n\r\n    .page-title-actions,\r\n    .page-title-subheading {\r\n      .breadcrumb-item,\r\n      .breadcrumb {\r\n        display: inline-block;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Footer\r\n\r\n  .app-footer .app-footer__inner {\r\n    .app-footer-right {\r\n      display: none;\r\n    }\r\n\r\n    .app-footer-left {\r\n      width: 100%;\r\n\r\n      .footer-dots {\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n  }\r\n\r\n  .fixed-footer {\r\n    &.closed-sidebar {\r\n      .app-footer {\r\n        .app-footer__inner {\r\n          margin-left: 0 !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Components\r\n\r\n  .widget-content {\r\n    .widget-numbers {\r\n      font-size: 1.6rem;\r\n      line-height: 1;\r\n    }\r\n  }\r\n\r\n  .slick-slider-sm {\r\n    .slick-slider {\r\n      max-width: 650px !important;\r\n    }\r\n  }\r\n\r\n  .body-tabs.body-tabs-layout {\r\n    &.body-tabs-big {\r\n      display: block !important;\r\n\r\n      .RRT__tab {\r\n        display: inline-block !important;\r\n        padding: 0 $layout-spacer-x !important;\r\n      }\r\n\r\n      .RRT__showmore {\r\n        margin-top: -20px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ReactTable .-pagination {\r\n    .-center {\r\n      display: none;\r\n    }\r\n\r\n    .-previous {\r\n      padding-right: 3px;\r\n    }\r\n  }\r\n\r\n  .bg-transparent.list-group-item {\r\n    border-color: transparent;\r\n  }\r\n\r\n  .tabs-lg-alternate.card-header {\r\n\r\n    & > .nav .nav-item {\r\n      .widget-number {\r\n        font-size: 1.5rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .page-title-head {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-between(xs, md) {\r\n\r\n  .app-page-title .page-title-icon,\r\n  .ui-theme-settings {\r\n    display: none;\r\n  }\r\n\r\n  .card-header {\r\n    &.responsive-center {\r\n      display: block;\r\n      text-align: center;\r\n      height: auto;\r\n      padding: $layout-spacer-x;\r\n\r\n      .nav,\r\n      .btn-actions-pane-right {\r\n        margin: math.div($layout-spacer-x, 2) 0 0;\r\n\r\n        .d-inline-block.ml-2 {\r\n          width: 100% !important;\r\n          text-align: left;\r\n          margin: 0 !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .slick-slider-sm {\r\n    .slick-slider {\r\n      max-width: 650px !important;\r\n    }\r\n  }\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n\r\n  .slick-slider-sm {\r\n    .slick-slider {\r\n      max-width: 850px !important;\r\n    }\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(lg) {\r\n\r\n  .-hide-paging .-pagination .-center {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n  .app-main .app-main__inner {\r\n    padding: 15px 15px 0;\r\n  }\r\n\r\n  .mbg-3,\r\n  body .card.mb-3 {\r\n    margin-bottom: math.div($grid-gutter-width, 2) !important;\r\n  }\r\n\r\n  .app-page-title {\r\n    padding: math.div($grid-gutter-width, 2);\r\n    margin: (-(math.div($grid-gutter-width, 2))) (-(math.div($grid-gutter-width, 2))) $grid-gutter-width;\r\n  }\r\n\r\n  .body-tabs.body-tabs-layout {\r\n    margin-left: (-(math.div($grid-gutter-width, 2)));\r\n    margin-right: (-(math.div($grid-gutter-width, 2)));\r\n    padding: 0 math.div($grid-gutter-width, 2);\r\n  }\r\n\r\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\r\n    margin-top: math.div($grid-gutter-width, 2);\r\n  }\r\n\r\n  .popover,\r\n  .dropdown-menu {\r\n    width: 80%;\r\n    left: 10%;\r\n  }\r\n\r\n  body .card-header {\r\n    height: auto;\r\n    display: block;\r\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\r\n    text-align: center;\r\n\r\n    .btn-actions-pane-right {\r\n      padding: math.div($layout-spacer-x, 2) 0 0;\r\n    }\r\n\r\n    .actions-icon-btn {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .card-header {\r\n    &.card-header-tab {\r\n      .card-header-title {\r\n        display: inline-flex !important;\r\n        line-height: 1;\r\n      }\r\n\r\n      & > .nav {\r\n        margin: math.div($layout-spacer-x, 2) 0 (-(math.div($layout-spacer-x, 2)));\r\n        display: table !important;\r\n        width: 100%;\r\n\r\n        .nav-item {\r\n          display: table-cell;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .header-icon {\r\n    display: none;\r\n  }\r\n\r\n  .profile-responsive-sm,\r\n  .profile-responsive {\r\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\r\n      display: block;\r\n      text-align: center;\r\n\r\n      .avatar-icon-wrapper {\r\n        margin-right: 0 !important;\r\n      }\r\n\r\n      .menu-header-btn-pane {\r\n        margin-top: 1rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .slick-slider-sm .slick-slider .slick-prev {\r\n    left: math.div($grid-gutter-width, 2);\r\n  }\r\n\r\n  .slick-slider-sm .slick-slider .slick-next {\r\n    right: math.div($grid-gutter-width, 2);\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\r\n  .profile-responsive {\r\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\r\n      display: block;\r\n      text-align: center;\r\n\r\n      .avatar-icon-wrapper {\r\n        margin-right: 0 !important;\r\n      }\r\n\r\n      .menu-header-btn-pane {\r\n        margin-top: 1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
